
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireba46"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireba46"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b8reE", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $81b591678b09dda1$export$ffb0004e005737fa, (v) => $81b591678b09dda1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $81b591678b09dda1$export$34b9dba7ce09269b, (v) => $81b591678b09dda1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $81b591678b09dda1$export$25062201e9e25d76, (v) => $81b591678b09dda1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81b591678b09dda1$export$ffb0004e005737fa;
var $81b591678b09dda1$export$34b9dba7ce09269b;
var $81b591678b09dda1$export$25062201e9e25d76;
'use strict';

var $8tsvq = parcelRequire("8tsvq");
var $81b591678b09dda1$var$k = Symbol.for("react.element"), $81b591678b09dda1$var$l = Symbol.for("react.fragment"), $81b591678b09dda1$var$m = Object.prototype.hasOwnProperty, $81b591678b09dda1$var$n = $8tsvq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $81b591678b09dda1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $81b591678b09dda1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$81b591678b09dda1$var$m.call(a, b) && !$81b591678b09dda1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $81b591678b09dda1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $81b591678b09dda1$var$n.current
    };
}
$81b591678b09dda1$export$ffb0004e005737fa = $81b591678b09dda1$var$l;
$81b591678b09dda1$export$34b9dba7ce09269b = $81b591678b09dda1$var$q;
$81b591678b09dda1$export$25062201e9e25d76 = $81b591678b09dda1$var$q;

});
parcelRegister("8tsvq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4rIOO"));

});
parcelRegister("4rIOO", function(module, exports) {

$parcel$export(module.exports, "Children", () => $33cc730c2de4ccfb$export$dca3b0875bd9a954, (v) => $33cc730c2de4ccfb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $33cc730c2de4ccfb$export$16fa2f45be04daa8, (v) => $33cc730c2de4ccfb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $33cc730c2de4ccfb$export$ffb0004e005737fa, (v) => $33cc730c2de4ccfb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $33cc730c2de4ccfb$export$e2c29f18771995cb, (v) => $33cc730c2de4ccfb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $33cc730c2de4ccfb$export$221d75b3f55bb0bd, (v) => $33cc730c2de4ccfb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $33cc730c2de4ccfb$export$5f8d39834fd61797, (v) => $33cc730c2de4ccfb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $33cc730c2de4ccfb$export$74bf444e3cd11ea5, (v) => $33cc730c2de4ccfb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $33cc730c2de4ccfb$export$ae55be85d98224ed, (v) => $33cc730c2de4ccfb$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $33cc730c2de4ccfb$export$e530037191fcd5d7, (v) => $33cc730c2de4ccfb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $33cc730c2de4ccfb$export$fd42f52fd3ae1109, (v) => $33cc730c2de4ccfb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $33cc730c2de4ccfb$export$c8a8987d4410bf2d, (v) => $33cc730c2de4ccfb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $33cc730c2de4ccfb$export$d38cd72104c1f0e9, (v) => $33cc730c2de4ccfb$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $33cc730c2de4ccfb$export$7d1e3a5e95ceca43, (v) => $33cc730c2de4ccfb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $33cc730c2de4ccfb$export$257a8862b851cb5b, (v) => $33cc730c2de4ccfb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $33cc730c2de4ccfb$export$a8257692ac88316c, (v) => $33cc730c2de4ccfb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $33cc730c2de4ccfb$export$488013bae63b21da, (v) => $33cc730c2de4ccfb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $33cc730c2de4ccfb$export$7c73462e0d25e514, (v) => $33cc730c2de4ccfb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $33cc730c2de4ccfb$export$7568632d0d33d16d, (v) => $33cc730c2de4ccfb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $33cc730c2de4ccfb$export$88948ce120ea2619, (v) => $33cc730c2de4ccfb$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $33cc730c2de4ccfb$export$35808ee640e87ca7, (v) => $33cc730c2de4ccfb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $33cc730c2de4ccfb$export$fae74005e78b1a27, (v) => $33cc730c2de4ccfb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e, (v) => $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $33cc730c2de4ccfb$export$6a7bc4e911dc01cf, (v) => $33cc730c2de4ccfb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $33cc730c2de4ccfb$export$6d9c69b0de29b591, (v) => $33cc730c2de4ccfb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $33cc730c2de4ccfb$export$f680877a34711e37, (v) => $33cc730c2de4ccfb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $33cc730c2de4ccfb$export$d5a552a76deda3c2, (v) => $33cc730c2de4ccfb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $33cc730c2de4ccfb$export$aaabe4eda9ed9969, (v) => $33cc730c2de4ccfb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $33cc730c2de4ccfb$export$e5c5a5f917a5871c, (v) => $33cc730c2de4ccfb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $33cc730c2de4ccfb$export$1538c33de8887b59, (v) => $33cc730c2de4ccfb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $33cc730c2de4ccfb$export$13e3392192263954, (v) => $33cc730c2de4ccfb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $33cc730c2de4ccfb$export$b8f5890fc79d6aca, (v) => $33cc730c2de4ccfb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $33cc730c2de4ccfb$export$60241385465d0a34, (v) => $33cc730c2de4ccfb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $33cc730c2de4ccfb$export$306c0aa65ff9ec16, (v) => $33cc730c2de4ccfb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $33cc730c2de4ccfb$export$7b286972b8d8ccbf, (v) => $33cc730c2de4ccfb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $33cc730c2de4ccfb$export$83d89fbfd8236492, (v) => $33cc730c2de4ccfb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $33cc730c2de4ccfb$export$dca3b0875bd9a954;
var $33cc730c2de4ccfb$export$16fa2f45be04daa8;
var $33cc730c2de4ccfb$export$ffb0004e005737fa;
var $33cc730c2de4ccfb$export$e2c29f18771995cb;
var $33cc730c2de4ccfb$export$221d75b3f55bb0bd;
var $33cc730c2de4ccfb$export$5f8d39834fd61797;
var $33cc730c2de4ccfb$export$74bf444e3cd11ea5;
var $33cc730c2de4ccfb$export$ae55be85d98224ed;
var $33cc730c2de4ccfb$export$e530037191fcd5d7;
var $33cc730c2de4ccfb$export$fd42f52fd3ae1109;
var $33cc730c2de4ccfb$export$c8a8987d4410bf2d;
var $33cc730c2de4ccfb$export$d38cd72104c1f0e9;
var $33cc730c2de4ccfb$export$7d1e3a5e95ceca43;
var $33cc730c2de4ccfb$export$257a8862b851cb5b;
var $33cc730c2de4ccfb$export$a8257692ac88316c;
var $33cc730c2de4ccfb$export$488013bae63b21da;
var $33cc730c2de4ccfb$export$7c73462e0d25e514;
var $33cc730c2de4ccfb$export$7568632d0d33d16d;
var $33cc730c2de4ccfb$export$88948ce120ea2619;
var $33cc730c2de4ccfb$export$35808ee640e87ca7;
var $33cc730c2de4ccfb$export$fae74005e78b1a27;
var $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e;
var $33cc730c2de4ccfb$export$6a7bc4e911dc01cf;
var $33cc730c2de4ccfb$export$6d9c69b0de29b591;
var $33cc730c2de4ccfb$export$f680877a34711e37;
var $33cc730c2de4ccfb$export$d5a552a76deda3c2;
var $33cc730c2de4ccfb$export$aaabe4eda9ed9969;
var $33cc730c2de4ccfb$export$e5c5a5f917a5871c;
var $33cc730c2de4ccfb$export$1538c33de8887b59;
var $33cc730c2de4ccfb$export$13e3392192263954;
var $33cc730c2de4ccfb$export$b8f5890fc79d6aca;
var $33cc730c2de4ccfb$export$60241385465d0a34;
var $33cc730c2de4ccfb$export$306c0aa65ff9ec16;
var $33cc730c2de4ccfb$export$7b286972b8d8ccbf;
var $33cc730c2de4ccfb$export$83d89fbfd8236492;
'use strict';
var $33cc730c2de4ccfb$var$l = Symbol.for("react.element"), $33cc730c2de4ccfb$var$n = Symbol.for("react.portal"), $33cc730c2de4ccfb$var$p = Symbol.for("react.fragment"), $33cc730c2de4ccfb$var$q = Symbol.for("react.strict_mode"), $33cc730c2de4ccfb$var$r = Symbol.for("react.profiler"), $33cc730c2de4ccfb$var$t = Symbol.for("react.provider"), $33cc730c2de4ccfb$var$u = Symbol.for("react.context"), $33cc730c2de4ccfb$var$v = Symbol.for("react.forward_ref"), $33cc730c2de4ccfb$var$w = Symbol.for("react.suspense"), $33cc730c2de4ccfb$var$x = Symbol.for("react.memo"), $33cc730c2de4ccfb$var$y = Symbol.for("react.lazy"), $33cc730c2de4ccfb$var$z = Symbol.iterator;
function $33cc730c2de4ccfb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $33cc730c2de4ccfb$var$z && a[$33cc730c2de4ccfb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $33cc730c2de4ccfb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $33cc730c2de4ccfb$var$C = Object.assign, $33cc730c2de4ccfb$var$D = {};
function $33cc730c2de4ccfb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33cc730c2de4ccfb$var$D;
    this.updater = e || $33cc730c2de4ccfb$var$B;
}
$33cc730c2de4ccfb$var$E.prototype.isReactComponent = {};
$33cc730c2de4ccfb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$33cc730c2de4ccfb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $33cc730c2de4ccfb$var$F() {}
$33cc730c2de4ccfb$var$F.prototype = $33cc730c2de4ccfb$var$E.prototype;
function $33cc730c2de4ccfb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33cc730c2de4ccfb$var$D;
    this.updater = e || $33cc730c2de4ccfb$var$B;
}
var $33cc730c2de4ccfb$var$H = $33cc730c2de4ccfb$var$G.prototype = new $33cc730c2de4ccfb$var$F;
$33cc730c2de4ccfb$var$H.constructor = $33cc730c2de4ccfb$var$G;
$33cc730c2de4ccfb$var$C($33cc730c2de4ccfb$var$H, $33cc730c2de4ccfb$var$E.prototype);
$33cc730c2de4ccfb$var$H.isPureReactComponent = !0;
var $33cc730c2de4ccfb$var$I = Array.isArray, $33cc730c2de4ccfb$var$J = Object.prototype.hasOwnProperty, $33cc730c2de4ccfb$var$K = {
    current: null
}, $33cc730c2de4ccfb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $33cc730c2de4ccfb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$33cc730c2de4ccfb$var$J.call(b, d) && !$33cc730c2de4ccfb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $33cc730c2de4ccfb$var$K.current
    };
}
function $33cc730c2de4ccfb$var$N(a, b) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $33cc730c2de4ccfb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $33cc730c2de4ccfb$var$l;
}
function $33cc730c2de4ccfb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $33cc730c2de4ccfb$var$P = /\/+/g;
function $33cc730c2de4ccfb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $33cc730c2de4ccfb$var$escape("" + a.key) : b.toString(36);
}
function $33cc730c2de4ccfb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $33cc730c2de4ccfb$var$l:
                case $33cc730c2de4ccfb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $33cc730c2de4ccfb$var$Q(h, 0) : d, $33cc730c2de4ccfb$var$I(c) ? (e = "", null != a && (e = a.replace($33cc730c2de4ccfb$var$P, "$&/") + "/"), $33cc730c2de4ccfb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($33cc730c2de4ccfb$var$O(c) && (c = $33cc730c2de4ccfb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($33cc730c2de4ccfb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($33cc730c2de4ccfb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $33cc730c2de4ccfb$var$Q(k, g);
        h += $33cc730c2de4ccfb$var$R(k, b, e, f, c);
    }
    else if (f = $33cc730c2de4ccfb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $33cc730c2de4ccfb$var$Q(k, g++), h += $33cc730c2de4ccfb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $33cc730c2de4ccfb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $33cc730c2de4ccfb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $33cc730c2de4ccfb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $33cc730c2de4ccfb$var$U = {
    current: null
}, $33cc730c2de4ccfb$var$V = {
    transition: null
}, $33cc730c2de4ccfb$var$W = {
    ReactCurrentDispatcher: $33cc730c2de4ccfb$var$U,
    ReactCurrentBatchConfig: $33cc730c2de4ccfb$var$V,
    ReactCurrentOwner: $33cc730c2de4ccfb$var$K
};
$33cc730c2de4ccfb$export$dca3b0875bd9a954 = {
    map: $33cc730c2de4ccfb$var$S,
    forEach: function(a, b, e) {
        $33cc730c2de4ccfb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $33cc730c2de4ccfb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $33cc730c2de4ccfb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$33cc730c2de4ccfb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$33cc730c2de4ccfb$export$16fa2f45be04daa8 = $33cc730c2de4ccfb$var$E;
$33cc730c2de4ccfb$export$ffb0004e005737fa = $33cc730c2de4ccfb$var$p;
$33cc730c2de4ccfb$export$e2c29f18771995cb = $33cc730c2de4ccfb$var$r;
$33cc730c2de4ccfb$export$221d75b3f55bb0bd = $33cc730c2de4ccfb$var$G;
$33cc730c2de4ccfb$export$5f8d39834fd61797 = $33cc730c2de4ccfb$var$q;
$33cc730c2de4ccfb$export$74bf444e3cd11ea5 = $33cc730c2de4ccfb$var$w;
$33cc730c2de4ccfb$export$ae55be85d98224ed = $33cc730c2de4ccfb$var$W;
$33cc730c2de4ccfb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $33cc730c2de4ccfb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $33cc730c2de4ccfb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$33cc730c2de4ccfb$var$J.call(b, f) && !$33cc730c2de4ccfb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$33cc730c2de4ccfb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $33cc730c2de4ccfb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $33cc730c2de4ccfb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$33cc730c2de4ccfb$export$c8a8987d4410bf2d = $33cc730c2de4ccfb$var$M;
$33cc730c2de4ccfb$export$d38cd72104c1f0e9 = function(a) {
    var b = $33cc730c2de4ccfb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$33cc730c2de4ccfb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$33cc730c2de4ccfb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$v,
        render: a
    };
};
$33cc730c2de4ccfb$export$a8257692ac88316c = $33cc730c2de4ccfb$var$O;
$33cc730c2de4ccfb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $33cc730c2de4ccfb$var$T
    };
};
$33cc730c2de4ccfb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$33cc730c2de4ccfb$export$7568632d0d33d16d = function(a) {
    var b = $33cc730c2de4ccfb$var$V.transition;
    $33cc730c2de4ccfb$var$V.transition = {};
    try {
        a();
    } finally{
        $33cc730c2de4ccfb$var$V.transition = b;
    }
};
$33cc730c2de4ccfb$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$33cc730c2de4ccfb$export$35808ee640e87ca7 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useCallback(a, b);
};
$33cc730c2de4ccfb$export$fae74005e78b1a27 = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useContext(a);
};
$33cc730c2de4ccfb$export$dc8fbce3eb94dc1e = function() {};
$33cc730c2de4ccfb$export$6a7bc4e911dc01cf = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useDeferredValue(a);
};
$33cc730c2de4ccfb$export$6d9c69b0de29b591 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useEffect(a, b);
};
$33cc730c2de4ccfb$export$f680877a34711e37 = function() {
    return $33cc730c2de4ccfb$var$U.current.useId();
};
$33cc730c2de4ccfb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useImperativeHandle(a, b, e);
};
$33cc730c2de4ccfb$export$aaabe4eda9ed9969 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useInsertionEffect(a, b);
};
$33cc730c2de4ccfb$export$e5c5a5f917a5871c = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useLayoutEffect(a, b);
};
$33cc730c2de4ccfb$export$1538c33de8887b59 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useMemo(a, b);
};
$33cc730c2de4ccfb$export$13e3392192263954 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useReducer(a, b, e);
};
$33cc730c2de4ccfb$export$b8f5890fc79d6aca = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useRef(a);
};
$33cc730c2de4ccfb$export$60241385465d0a34 = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useState(a);
};
$33cc730c2de4ccfb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useSyncExternalStore(a, b, e);
};
$33cc730c2de4ccfb$export$7b286972b8d8ccbf = function() {
    return $33cc730c2de4ccfb$var$U.current.useTransition();
};
$33cc730c2de4ccfb$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("jhxbP", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e09959a092a7608b$export$ae55be85d98224ed, (v) => $e09959a092a7608b$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $e09959a092a7608b$export$d39a5bbd09211389, (v) => $e09959a092a7608b$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $e09959a092a7608b$export$882461b6382ed46c, (v) => $e09959a092a7608b$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $e09959a092a7608b$export$466bfc07425424d5, (v) => $e09959a092a7608b$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $e09959a092a7608b$export$cd75ccfd720a3cd4, (v) => $e09959a092a7608b$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $e09959a092a7608b$export$fa8d919ba61d84db, (v) => $e09959a092a7608b$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $e09959a092a7608b$export$757ceba2d55c277e, (v) => $e09959a092a7608b$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $e09959a092a7608b$export$b3890eb0ae9dca99, (v) => $e09959a092a7608b$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $e09959a092a7608b$export$502457920280e6be, (v) => $e09959a092a7608b$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e09959a092a7608b$export$c78a37762a8d58e1, (v) => $e09959a092a7608b$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $e09959a092a7608b$export$dc54d992c10e8a18, (v) => $e09959a092a7608b$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $e09959a092a7608b$export$83d89fbfd8236492, (v) => $e09959a092a7608b$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e09959a092a7608b$export$ae55be85d98224ed;
var $e09959a092a7608b$export$d39a5bbd09211389;
var $e09959a092a7608b$export$882461b6382ed46c;
var $e09959a092a7608b$export$466bfc07425424d5;
var $e09959a092a7608b$export$cd75ccfd720a3cd4;
var $e09959a092a7608b$export$fa8d919ba61d84db;
var $e09959a092a7608b$export$757ceba2d55c277e;
var $e09959a092a7608b$export$b3890eb0ae9dca99;
var $e09959a092a7608b$export$502457920280e6be;
var $e09959a092a7608b$export$c78a37762a8d58e1;
var $e09959a092a7608b$export$dc54d992c10e8a18;
var $e09959a092a7608b$export$83d89fbfd8236492;
'use strict';

var $8tsvq = parcelRequire("8tsvq");

var $7DCtq = parcelRequire("7DCtq");
function $e09959a092a7608b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e09959a092a7608b$var$da = new Set, $e09959a092a7608b$var$ea = {};
function $e09959a092a7608b$var$fa(a, b) {
    $e09959a092a7608b$var$ha(a, b);
    $e09959a092a7608b$var$ha(a + "Capture", b);
}
function $e09959a092a7608b$var$ha(a, b) {
    $e09959a092a7608b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e09959a092a7608b$var$da.add(b[a]);
}
var $e09959a092a7608b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e09959a092a7608b$var$ja = Object.prototype.hasOwnProperty, $e09959a092a7608b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e09959a092a7608b$var$la = {}, $e09959a092a7608b$var$ma = {};
function $e09959a092a7608b$var$oa(a) {
    if ($e09959a092a7608b$var$ja.call($e09959a092a7608b$var$ma, a)) return !0;
    if ($e09959a092a7608b$var$ja.call($e09959a092a7608b$var$la, a)) return !1;
    if ($e09959a092a7608b$var$ka.test(a)) return $e09959a092a7608b$var$ma[a] = !0;
    $e09959a092a7608b$var$la[a] = !0;
    return !1;
}
function $e09959a092a7608b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e09959a092a7608b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e09959a092a7608b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e09959a092a7608b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e09959a092a7608b$var$ra = /[\-:]([a-z])/g;
function $e09959a092a7608b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e09959a092a7608b$var$z.xlinkHref = new $e09959a092a7608b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e09959a092a7608b$var$ta(a, b, c, d) {
    var e = $e09959a092a7608b$var$z.hasOwnProperty(b) ? $e09959a092a7608b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e09959a092a7608b$var$qa(b, c, e, d) && (c = null), d || null === e ? $e09959a092a7608b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e09959a092a7608b$var$ua = $8tsvq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e09959a092a7608b$var$va = Symbol.for("react.element"), $e09959a092a7608b$var$wa = Symbol.for("react.portal"), $e09959a092a7608b$var$ya = Symbol.for("react.fragment"), $e09959a092a7608b$var$za = Symbol.for("react.strict_mode"), $e09959a092a7608b$var$Aa = Symbol.for("react.profiler"), $e09959a092a7608b$var$Ba = Symbol.for("react.provider"), $e09959a092a7608b$var$Ca = Symbol.for("react.context"), $e09959a092a7608b$var$Da = Symbol.for("react.forward_ref"), $e09959a092a7608b$var$Ea = Symbol.for("react.suspense"), $e09959a092a7608b$var$Fa = Symbol.for("react.suspense_list"), $e09959a092a7608b$var$Ga = Symbol.for("react.memo"), $e09959a092a7608b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e09959a092a7608b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e09959a092a7608b$var$Ja = Symbol.iterator;
function $e09959a092a7608b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e09959a092a7608b$var$Ja && a[$e09959a092a7608b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e09959a092a7608b$var$A = Object.assign, $e09959a092a7608b$var$La;
function $e09959a092a7608b$var$Ma(a) {
    if (void 0 === $e09959a092a7608b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e09959a092a7608b$var$La = b && b[1] || "";
    }
    return "\n" + $e09959a092a7608b$var$La + a;
}
var $e09959a092a7608b$var$Na = !1;
function $e09959a092a7608b$var$Oa(a, b) {
    if (!a || $e09959a092a7608b$var$Na) return "";
    $e09959a092a7608b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e09959a092a7608b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e09959a092a7608b$var$Ma(a) : "";
}
function $e09959a092a7608b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e09959a092a7608b$var$Ma(a.type);
        case 16:
            return $e09959a092a7608b$var$Ma("Lazy");
        case 13:
            return $e09959a092a7608b$var$Ma("Suspense");
        case 19:
            return $e09959a092a7608b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e09959a092a7608b$var$Oa(a.type, !1), a;
        case 11:
            return a = $e09959a092a7608b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e09959a092a7608b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e09959a092a7608b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e09959a092a7608b$var$ya:
            return "Fragment";
        case $e09959a092a7608b$var$wa:
            return "Portal";
        case $e09959a092a7608b$var$Aa:
            return "Profiler";
        case $e09959a092a7608b$var$za:
            return "StrictMode";
        case $e09959a092a7608b$var$Ea:
            return "Suspense";
        case $e09959a092a7608b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e09959a092a7608b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e09959a092a7608b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e09959a092a7608b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e09959a092a7608b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e09959a092a7608b$var$Qa(a.type) || "Memo";
        case $e09959a092a7608b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e09959a092a7608b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e09959a092a7608b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e09959a092a7608b$var$Qa(b);
        case 8:
            return b === $e09959a092a7608b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e09959a092a7608b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e09959a092a7608b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e09959a092a7608b$var$Ua(a) {
    var b = $e09959a092a7608b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e09959a092a7608b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e09959a092a7608b$var$Ua(a));
}
function $e09959a092a7608b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e09959a092a7608b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e09959a092a7608b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e09959a092a7608b$var$Ya(a, b) {
    var c = b.checked;
    return $e09959a092a7608b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e09959a092a7608b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e09959a092a7608b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e09959a092a7608b$var$ab(a, b) {
    b = b.checked;
    null != b && $e09959a092a7608b$var$ta(a, "checked", b, !1);
}
function $e09959a092a7608b$var$bb(a, b) {
    $e09959a092a7608b$var$ab(a, b);
    var c = $e09959a092a7608b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e09959a092a7608b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e09959a092a7608b$var$cb(a, b.type, $e09959a092a7608b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e09959a092a7608b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e09959a092a7608b$var$cb(a, b, c) {
    if ("number" !== b || $e09959a092a7608b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e09959a092a7608b$var$eb = Array.isArray;
function $e09959a092a7608b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e09959a092a7608b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e09959a092a7608b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e09959a092a7608b$var$p(91));
    return $e09959a092a7608b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e09959a092a7608b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e09959a092a7608b$var$p(92));
            if ($e09959a092a7608b$var$eb(c)) {
                if (1 < c.length) throw Error($e09959a092a7608b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e09959a092a7608b$var$Sa(c)
    };
}
function $e09959a092a7608b$var$ib(a, b) {
    var c = $e09959a092a7608b$var$Sa(b.value), d = $e09959a092a7608b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e09959a092a7608b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e09959a092a7608b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e09959a092a7608b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e09959a092a7608b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e09959a092a7608b$var$mb, $e09959a092a7608b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e09959a092a7608b$var$mb = $e09959a092a7608b$var$mb || document.createElement("div");
        $e09959a092a7608b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e09959a092a7608b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e09959a092a7608b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e09959a092a7608b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e09959a092a7608b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e09959a092a7608b$var$pb).forEach(function(a) {
    $e09959a092a7608b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e09959a092a7608b$var$pb[b] = $e09959a092a7608b$var$pb[a];
    });
});
function $e09959a092a7608b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e09959a092a7608b$var$pb.hasOwnProperty(a) && $e09959a092a7608b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e09959a092a7608b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e09959a092a7608b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e09959a092a7608b$var$tb = $e09959a092a7608b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e09959a092a7608b$var$ub(a, b) {
    if (b) {
        if ($e09959a092a7608b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e09959a092a7608b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e09959a092a7608b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e09959a092a7608b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e09959a092a7608b$var$p(62));
    }
}
function $e09959a092a7608b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e09959a092a7608b$var$wb = null;
function $e09959a092a7608b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e09959a092a7608b$var$yb = null, $e09959a092a7608b$var$zb = null, $e09959a092a7608b$var$Ab = null;
function $e09959a092a7608b$var$Bb(a) {
    if (a = $e09959a092a7608b$var$Cb(a)) {
        if ("function" !== typeof $e09959a092a7608b$var$yb) throw Error($e09959a092a7608b$var$p(280));
        var b = a.stateNode;
        b && (b = $e09959a092a7608b$var$Db(b), $e09959a092a7608b$var$yb(a.stateNode, a.type, b));
    }
}
function $e09959a092a7608b$var$Eb(a) {
    $e09959a092a7608b$var$zb ? $e09959a092a7608b$var$Ab ? $e09959a092a7608b$var$Ab.push(a) : $e09959a092a7608b$var$Ab = [
        a
    ] : $e09959a092a7608b$var$zb = a;
}
function $e09959a092a7608b$var$Fb() {
    if ($e09959a092a7608b$var$zb) {
        var a = $e09959a092a7608b$var$zb, b = $e09959a092a7608b$var$Ab;
        $e09959a092a7608b$var$Ab = $e09959a092a7608b$var$zb = null;
        $e09959a092a7608b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e09959a092a7608b$var$Bb(b[a]);
    }
}
function $e09959a092a7608b$var$Gb(a, b) {
    return a(b);
}
function $e09959a092a7608b$var$Hb() {}
var $e09959a092a7608b$var$Ib = !1;
function $e09959a092a7608b$var$Jb(a, b, c) {
    if ($e09959a092a7608b$var$Ib) return a(b, c);
    $e09959a092a7608b$var$Ib = !0;
    try {
        return $e09959a092a7608b$var$Gb(a, b, c);
    } finally{
        if ($e09959a092a7608b$var$Ib = !1, null !== $e09959a092a7608b$var$zb || null !== $e09959a092a7608b$var$Ab) $e09959a092a7608b$var$Hb(), $e09959a092a7608b$var$Fb();
    }
}
function $e09959a092a7608b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e09959a092a7608b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e09959a092a7608b$var$p(231, b, typeof c));
    return c;
}
var $e09959a092a7608b$var$Lb = !1;
if ($e09959a092a7608b$var$ia) try {
    var $e09959a092a7608b$var$Mb = {};
    Object.defineProperty($e09959a092a7608b$var$Mb, "passive", {
        get: function() {
            $e09959a092a7608b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e09959a092a7608b$var$Mb, $e09959a092a7608b$var$Mb);
    window.removeEventListener("test", $e09959a092a7608b$var$Mb, $e09959a092a7608b$var$Mb);
} catch (a) {
    $e09959a092a7608b$var$Lb = !1;
}
function $e09959a092a7608b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e09959a092a7608b$var$Ob = !1, $e09959a092a7608b$var$Pb = null, $e09959a092a7608b$var$Qb = !1, $e09959a092a7608b$var$Rb = null, $e09959a092a7608b$var$Sb = {
    onError: function(a) {
        $e09959a092a7608b$var$Ob = !0;
        $e09959a092a7608b$var$Pb = a;
    }
};
function $e09959a092a7608b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e09959a092a7608b$var$Ob = !1;
    $e09959a092a7608b$var$Pb = null;
    $e09959a092a7608b$var$Nb.apply($e09959a092a7608b$var$Sb, arguments);
}
function $e09959a092a7608b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e09959a092a7608b$var$Tb.apply(this, arguments);
    if ($e09959a092a7608b$var$Ob) {
        if ($e09959a092a7608b$var$Ob) {
            var l = $e09959a092a7608b$var$Pb;
            $e09959a092a7608b$var$Ob = !1;
            $e09959a092a7608b$var$Pb = null;
        } else throw Error($e09959a092a7608b$var$p(198));
        $e09959a092a7608b$var$Qb || ($e09959a092a7608b$var$Qb = !0, $e09959a092a7608b$var$Rb = l);
    }
}
function $e09959a092a7608b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e09959a092a7608b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e09959a092a7608b$var$Xb(a) {
    if ($e09959a092a7608b$var$Vb(a) !== a) throw Error($e09959a092a7608b$var$p(188));
}
function $e09959a092a7608b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e09959a092a7608b$var$Vb(a);
        if (null === b) throw Error($e09959a092a7608b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e09959a092a7608b$var$Xb(e), a;
                if (f === d) return $e09959a092a7608b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e09959a092a7608b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e09959a092a7608b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e09959a092a7608b$var$p(190));
    }
    if (3 !== c.tag) throw Error($e09959a092a7608b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e09959a092a7608b$var$Zb(a) {
    a = $e09959a092a7608b$var$Yb(a);
    return null !== a ? $e09959a092a7608b$var$$b(a) : null;
}
function $e09959a092a7608b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e09959a092a7608b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e09959a092a7608b$var$ac = $7DCtq.unstable_scheduleCallback, $e09959a092a7608b$var$bc = $7DCtq.unstable_cancelCallback, $e09959a092a7608b$var$cc = $7DCtq.unstable_shouldYield, $e09959a092a7608b$var$dc = $7DCtq.unstable_requestPaint, $e09959a092a7608b$var$B = $7DCtq.unstable_now, $e09959a092a7608b$var$ec = $7DCtq.unstable_getCurrentPriorityLevel, $e09959a092a7608b$var$fc = $7DCtq.unstable_ImmediatePriority, $e09959a092a7608b$var$gc = $7DCtq.unstable_UserBlockingPriority, $e09959a092a7608b$var$hc = $7DCtq.unstable_NormalPriority, $e09959a092a7608b$var$ic = $7DCtq.unstable_LowPriority, $e09959a092a7608b$var$jc = $7DCtq.unstable_IdlePriority, $e09959a092a7608b$var$kc = null, $e09959a092a7608b$var$lc = null;
function $e09959a092a7608b$var$mc(a) {
    if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onCommitFiberRoot) try {
        $e09959a092a7608b$var$lc.onCommitFiberRoot($e09959a092a7608b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e09959a092a7608b$var$oc = Math.clz32 ? Math.clz32 : $e09959a092a7608b$var$nc, $e09959a092a7608b$var$pc = Math.log, $e09959a092a7608b$var$qc = Math.LN2;
function $e09959a092a7608b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e09959a092a7608b$var$pc(a) / $e09959a092a7608b$var$qc | 0) | 0;
}
var $e09959a092a7608b$var$rc = 64, $e09959a092a7608b$var$sc = 4194304;
function $e09959a092a7608b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e09959a092a7608b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e09959a092a7608b$var$tc(h) : (f &= g, 0 !== f && (d = $e09959a092a7608b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e09959a092a7608b$var$tc(g) : 0 !== f && (d = $e09959a092a7608b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e09959a092a7608b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e09959a092a7608b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e09959a092a7608b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e09959a092a7608b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e09959a092a7608b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e09959a092a7608b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e09959a092a7608b$var$yc() {
    var a = $e09959a092a7608b$var$rc;
    $e09959a092a7608b$var$rc <<= 1;
    0 === ($e09959a092a7608b$var$rc & 4194240) && ($e09959a092a7608b$var$rc = 64);
    return a;
}
function $e09959a092a7608b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e09959a092a7608b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e09959a092a7608b$var$oc(b);
    a[b] = c;
}
function $e09959a092a7608b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e09959a092a7608b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e09959a092a7608b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e09959a092a7608b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e09959a092a7608b$var$C = 0;
function $e09959a092a7608b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e09959a092a7608b$var$Ec, $e09959a092a7608b$var$Fc, $e09959a092a7608b$var$Gc, $e09959a092a7608b$var$Hc, $e09959a092a7608b$var$Ic, $e09959a092a7608b$var$Jc = !1, $e09959a092a7608b$var$Kc = [], $e09959a092a7608b$var$Lc = null, $e09959a092a7608b$var$Mc = null, $e09959a092a7608b$var$Nc = null, $e09959a092a7608b$var$Oc = new Map, $e09959a092a7608b$var$Pc = new Map, $e09959a092a7608b$var$Qc = [], $e09959a092a7608b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e09959a092a7608b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e09959a092a7608b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e09959a092a7608b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e09959a092a7608b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e09959a092a7608b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e09959a092a7608b$var$Pc.delete(b.pointerId);
    }
}
function $e09959a092a7608b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e09959a092a7608b$var$Cb(b), null !== b && $e09959a092a7608b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e09959a092a7608b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e09959a092a7608b$var$Lc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e09959a092a7608b$var$Mc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e09959a092a7608b$var$Nc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e09959a092a7608b$var$Oc.set(f, $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e09959a092a7608b$var$Pc.set(f, $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e09959a092a7608b$var$Vc(a) {
    var b = $e09959a092a7608b$var$Wc(a.target);
    if (null !== b) {
        var c = $e09959a092a7608b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e09959a092a7608b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e09959a092a7608b$var$Ic(a.priority, function() {
                        $e09959a092a7608b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e09959a092a7608b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e09959a092a7608b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e09959a092a7608b$var$wb = d;
            c.target.dispatchEvent(d);
            $e09959a092a7608b$var$wb = null;
        } else return b = $e09959a092a7608b$var$Cb(c), null !== b && $e09959a092a7608b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e09959a092a7608b$var$Zc(a, b, c) {
    $e09959a092a7608b$var$Xc(a) && c.delete(b);
}
function $e09959a092a7608b$var$$c() {
    $e09959a092a7608b$var$Jc = !1;
    null !== $e09959a092a7608b$var$Lc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Lc) && ($e09959a092a7608b$var$Lc = null);
    null !== $e09959a092a7608b$var$Mc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Mc) && ($e09959a092a7608b$var$Mc = null);
    null !== $e09959a092a7608b$var$Nc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Nc) && ($e09959a092a7608b$var$Nc = null);
    $e09959a092a7608b$var$Oc.forEach($e09959a092a7608b$var$Zc);
    $e09959a092a7608b$var$Pc.forEach($e09959a092a7608b$var$Zc);
}
function $e09959a092a7608b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e09959a092a7608b$var$Jc || ($e09959a092a7608b$var$Jc = !0, $7DCtq.unstable_scheduleCallback($7DCtq.unstable_NormalPriority, $e09959a092a7608b$var$$c)));
}
function $e09959a092a7608b$var$bd(a) {
    function b(b) {
        return $e09959a092a7608b$var$ad(b, a);
    }
    if (0 < $e09959a092a7608b$var$Kc.length) {
        $e09959a092a7608b$var$ad($e09959a092a7608b$var$Kc[0], a);
        for(var c = 1; c < $e09959a092a7608b$var$Kc.length; c++){
            var d = $e09959a092a7608b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e09959a092a7608b$var$Lc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Lc, a);
    null !== $e09959a092a7608b$var$Mc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Mc, a);
    null !== $e09959a092a7608b$var$Nc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Nc, a);
    $e09959a092a7608b$var$Oc.forEach(b);
    $e09959a092a7608b$var$Pc.forEach(b);
    for(c = 0; c < $e09959a092a7608b$var$Qc.length; c++)d = $e09959a092a7608b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e09959a092a7608b$var$Qc.length && (c = $e09959a092a7608b$var$Qc[0], null === c.blockedOn);)$e09959a092a7608b$var$Vc(c), null === c.blockedOn && $e09959a092a7608b$var$Qc.shift();
}
var $e09959a092a7608b$var$cd = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$dd = !0;
function $e09959a092a7608b$var$ed(a, b, c, d) {
    var e = $e09959a092a7608b$var$C, f = $e09959a092a7608b$var$cd.transition;
    $e09959a092a7608b$var$cd.transition = null;
    try {
        $e09959a092a7608b$var$C = 1, $e09959a092a7608b$var$fd(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$C = e, $e09959a092a7608b$var$cd.transition = f;
    }
}
function $e09959a092a7608b$var$gd(a, b, c, d) {
    var e = $e09959a092a7608b$var$C, f = $e09959a092a7608b$var$cd.transition;
    $e09959a092a7608b$var$cd.transition = null;
    try {
        $e09959a092a7608b$var$C = 4, $e09959a092a7608b$var$fd(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$C = e, $e09959a092a7608b$var$cd.transition = f;
    }
}
function $e09959a092a7608b$var$fd(a, b, c, d) {
    if ($e09959a092a7608b$var$dd) {
        var e = $e09959a092a7608b$var$Yc(a, b, c, d);
        if (null === e) $e09959a092a7608b$var$hd(a, b, d, $e09959a092a7608b$var$id, c), $e09959a092a7608b$var$Sc(a, d);
        else if ($e09959a092a7608b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e09959a092a7608b$var$Sc(a, d), b & 4 && -1 < $e09959a092a7608b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e09959a092a7608b$var$Cb(e);
                null !== f && $e09959a092a7608b$var$Ec(f);
                f = $e09959a092a7608b$var$Yc(a, b, c, d);
                null === f && $e09959a092a7608b$var$hd(a, b, d, $e09959a092a7608b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e09959a092a7608b$var$hd(a, b, d, null, c);
    }
}
var $e09959a092a7608b$var$id = null;
function $e09959a092a7608b$var$Yc(a, b, c, d) {
    $e09959a092a7608b$var$id = null;
    a = $e09959a092a7608b$var$xb(d);
    a = $e09959a092a7608b$var$Wc(a);
    if (null !== a) {
        if (b = $e09959a092a7608b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e09959a092a7608b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e09959a092a7608b$var$id = a;
    return null;
}
function $e09959a092a7608b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e09959a092a7608b$var$ec()){
                case $e09959a092a7608b$var$fc:
                    return 1;
                case $e09959a092a7608b$var$gc:
                    return 4;
                case $e09959a092a7608b$var$hc:
                case $e09959a092a7608b$var$ic:
                    return 16;
                case $e09959a092a7608b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e09959a092a7608b$var$kd = null, $e09959a092a7608b$var$ld = null, $e09959a092a7608b$var$md = null;
function $e09959a092a7608b$var$nd() {
    if ($e09959a092a7608b$var$md) return $e09959a092a7608b$var$md;
    var a, b = $e09959a092a7608b$var$ld, c = b.length, d, e = "value" in $e09959a092a7608b$var$kd ? $e09959a092a7608b$var$kd.value : $e09959a092a7608b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e09959a092a7608b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e09959a092a7608b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e09959a092a7608b$var$pd() {
    return !0;
}
function $e09959a092a7608b$var$qd() {
    return !1;
}
function $e09959a092a7608b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e09959a092a7608b$var$pd : $e09959a092a7608b$var$qd;
        this.isPropagationStopped = $e09959a092a7608b$var$qd;
        return this;
    }
    $e09959a092a7608b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e09959a092a7608b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e09959a092a7608b$var$pd);
        },
        persist: function() {},
        isPersistent: $e09959a092a7608b$var$pd
    });
    return b;
}
var $e09959a092a7608b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e09959a092a7608b$var$td = $e09959a092a7608b$var$rd($e09959a092a7608b$var$sd), $e09959a092a7608b$var$ud = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    view: 0,
    detail: 0
}), $e09959a092a7608b$var$vd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$ud), $e09959a092a7608b$var$wd, $e09959a092a7608b$var$xd, $e09959a092a7608b$var$yd, $e09959a092a7608b$var$Ad = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e09959a092a7608b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e09959a092a7608b$var$yd && ($e09959a092a7608b$var$yd && "mousemove" === a.type ? ($e09959a092a7608b$var$wd = a.screenX - $e09959a092a7608b$var$yd.screenX, $e09959a092a7608b$var$xd = a.screenY - $e09959a092a7608b$var$yd.screenY) : $e09959a092a7608b$var$xd = $e09959a092a7608b$var$wd = 0, $e09959a092a7608b$var$yd = a);
        return $e09959a092a7608b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e09959a092a7608b$var$xd;
    }
}), $e09959a092a7608b$var$Bd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ad), $e09959a092a7608b$var$Cd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    dataTransfer: 0
}), $e09959a092a7608b$var$Dd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Cd), $e09959a092a7608b$var$Ed = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    relatedTarget: 0
}), $e09959a092a7608b$var$Fd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ed), $e09959a092a7608b$var$Gd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e09959a092a7608b$var$Hd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Gd), $e09959a092a7608b$var$Id = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e09959a092a7608b$var$Jd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Id), $e09959a092a7608b$var$Kd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    data: 0
}), $e09959a092a7608b$var$Ld = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Kd), $e09959a092a7608b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e09959a092a7608b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e09959a092a7608b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e09959a092a7608b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e09959a092a7608b$var$Od[a]) ? !!b[a] : !1;
}
function $e09959a092a7608b$var$zd() {
    return $e09959a092a7608b$var$Pd;
}
var $e09959a092a7608b$var$Qd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e09959a092a7608b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e09959a092a7608b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e09959a092a7608b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e09959a092a7608b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e09959a092a7608b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e09959a092a7608b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e09959a092a7608b$var$Rd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Qd), $e09959a092a7608b$var$Sd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e09959a092a7608b$var$Td = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Sd), $e09959a092a7608b$var$Ud = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e09959a092a7608b$var$zd
}), $e09959a092a7608b$var$Vd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ud), $e09959a092a7608b$var$Wd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e09959a092a7608b$var$Xd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Wd), $e09959a092a7608b$var$Yd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e09959a092a7608b$var$Zd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Yd), $e09959a092a7608b$var$$d = [
    9,
    13,
    27,
    32
], $e09959a092a7608b$var$ae = $e09959a092a7608b$var$ia && "CompositionEvent" in window, $e09959a092a7608b$var$be = null;
$e09959a092a7608b$var$ia && "documentMode" in document && ($e09959a092a7608b$var$be = document.documentMode);
var $e09959a092a7608b$var$ce = $e09959a092a7608b$var$ia && "TextEvent" in window && !$e09959a092a7608b$var$be, $e09959a092a7608b$var$de = $e09959a092a7608b$var$ia && (!$e09959a092a7608b$var$ae || $e09959a092a7608b$var$be && 8 < $e09959a092a7608b$var$be && 11 >= $e09959a092a7608b$var$be), $e09959a092a7608b$var$ee = String.fromCharCode(32), $e09959a092a7608b$var$fe = !1;
function $e09959a092a7608b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e09959a092a7608b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e09959a092a7608b$var$ie = !1;
function $e09959a092a7608b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e09959a092a7608b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e09959a092a7608b$var$fe = !0;
            return $e09959a092a7608b$var$ee;
        case "textInput":
            return a = b.data, a === $e09959a092a7608b$var$ee && $e09959a092a7608b$var$fe ? null : a;
        default:
            return null;
    }
}
function $e09959a092a7608b$var$ke(a, b) {
    if ($e09959a092a7608b$var$ie) return "compositionend" === a || !$e09959a092a7608b$var$ae && $e09959a092a7608b$var$ge(a, b) ? (a = $e09959a092a7608b$var$nd(), $e09959a092a7608b$var$md = $e09959a092a7608b$var$ld = $e09959a092a7608b$var$kd = null, $e09959a092a7608b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e09959a092a7608b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e09959a092a7608b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e09959a092a7608b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e09959a092a7608b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e09959a092a7608b$var$ne(a, b, c, d) {
    $e09959a092a7608b$var$Eb(d);
    b = $e09959a092a7608b$var$oe(b, "onChange");
    0 < b.length && (c = new $e09959a092a7608b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e09959a092a7608b$var$pe = null, $e09959a092a7608b$var$qe = null;
function $e09959a092a7608b$var$re(a) {
    $e09959a092a7608b$var$se(a, 0);
}
function $e09959a092a7608b$var$te(a) {
    var b = $e09959a092a7608b$var$ue(a);
    if ($e09959a092a7608b$var$Wa(b)) return a;
}
function $e09959a092a7608b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e09959a092a7608b$var$we = !1;
if ($e09959a092a7608b$var$ia) {
    var $e09959a092a7608b$var$xe;
    if ($e09959a092a7608b$var$ia) {
        var $e09959a092a7608b$var$ye = "oninput" in document;
        if (!$e09959a092a7608b$var$ye) {
            var $e09959a092a7608b$var$ze = document.createElement("div");
            $e09959a092a7608b$var$ze.setAttribute("oninput", "return;");
            $e09959a092a7608b$var$ye = "function" === typeof $e09959a092a7608b$var$ze.oninput;
        }
        $e09959a092a7608b$var$xe = $e09959a092a7608b$var$ye;
    } else $e09959a092a7608b$var$xe = !1;
    $e09959a092a7608b$var$we = $e09959a092a7608b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e09959a092a7608b$var$Ae() {
    $e09959a092a7608b$var$pe && ($e09959a092a7608b$var$pe.detachEvent("onpropertychange", $e09959a092a7608b$var$Be), $e09959a092a7608b$var$qe = $e09959a092a7608b$var$pe = null);
}
function $e09959a092a7608b$var$Be(a) {
    if ("value" === a.propertyName && $e09959a092a7608b$var$te($e09959a092a7608b$var$qe)) {
        var b = [];
        $e09959a092a7608b$var$ne(b, $e09959a092a7608b$var$qe, a, $e09959a092a7608b$var$xb(a));
        $e09959a092a7608b$var$Jb($e09959a092a7608b$var$re, b);
    }
}
function $e09959a092a7608b$var$Ce(a, b, c) {
    "focusin" === a ? ($e09959a092a7608b$var$Ae(), $e09959a092a7608b$var$pe = b, $e09959a092a7608b$var$qe = c, $e09959a092a7608b$var$pe.attachEvent("onpropertychange", $e09959a092a7608b$var$Be)) : "focusout" === a && $e09959a092a7608b$var$Ae();
}
function $e09959a092a7608b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e09959a092a7608b$var$te($e09959a092a7608b$var$qe);
}
function $e09959a092a7608b$var$Ee(a, b) {
    if ("click" === a) return $e09959a092a7608b$var$te(b);
}
function $e09959a092a7608b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e09959a092a7608b$var$te(b);
}
function $e09959a092a7608b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e09959a092a7608b$var$He = "function" === typeof Object.is ? Object.is : $e09959a092a7608b$var$Ge;
function $e09959a092a7608b$var$Ie(a, b) {
    if ($e09959a092a7608b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e09959a092a7608b$var$ja.call(b, e) || !$e09959a092a7608b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e09959a092a7608b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e09959a092a7608b$var$Ke(a, b) {
    var c = $e09959a092a7608b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e09959a092a7608b$var$Je(c);
    }
}
function $e09959a092a7608b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e09959a092a7608b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e09959a092a7608b$var$Me() {
    for(var a = window, b = $e09959a092a7608b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e09959a092a7608b$var$Xa(a.document);
    }
    return b;
}
function $e09959a092a7608b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e09959a092a7608b$var$Oe(a) {
    var b = $e09959a092a7608b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e09959a092a7608b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e09959a092a7608b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e09959a092a7608b$var$Ke(c, f);
                var g = $e09959a092a7608b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e09959a092a7608b$var$Pe = $e09959a092a7608b$var$ia && "documentMode" in document && 11 >= document.documentMode, $e09959a092a7608b$var$Qe = null, $e09959a092a7608b$var$Re = null, $e09959a092a7608b$var$Se = null, $e09959a092a7608b$var$Te = !1;
function $e09959a092a7608b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e09959a092a7608b$var$Te || null == $e09959a092a7608b$var$Qe || $e09959a092a7608b$var$Qe !== $e09959a092a7608b$var$Xa(d) || (d = $e09959a092a7608b$var$Qe, "selectionStart" in d && $e09959a092a7608b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e09959a092a7608b$var$Se && $e09959a092a7608b$var$Ie($e09959a092a7608b$var$Se, d) || ($e09959a092a7608b$var$Se = d, d = $e09959a092a7608b$var$oe($e09959a092a7608b$var$Re, "onSelect"), 0 < d.length && (b = new $e09959a092a7608b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e09959a092a7608b$var$Qe)));
}
function $e09959a092a7608b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e09959a092a7608b$var$We = {
    animationend: $e09959a092a7608b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e09959a092a7608b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e09959a092a7608b$var$Ve("Animation", "AnimationStart"),
    transitionend: $e09959a092a7608b$var$Ve("Transition", "TransitionEnd")
}, $e09959a092a7608b$var$Xe = {}, $e09959a092a7608b$var$Ye = {};
$e09959a092a7608b$var$ia && ($e09959a092a7608b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e09959a092a7608b$var$We.animationend.animation, delete $e09959a092a7608b$var$We.animationiteration.animation, delete $e09959a092a7608b$var$We.animationstart.animation), "TransitionEvent" in window || delete $e09959a092a7608b$var$We.transitionend.transition);
function $e09959a092a7608b$var$Ze(a) {
    if ($e09959a092a7608b$var$Xe[a]) return $e09959a092a7608b$var$Xe[a];
    if (!$e09959a092a7608b$var$We[a]) return a;
    var b = $e09959a092a7608b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e09959a092a7608b$var$Ye) return $e09959a092a7608b$var$Xe[a] = b[c];
    return a;
}
var $e09959a092a7608b$var$$e = $e09959a092a7608b$var$Ze("animationend"), $e09959a092a7608b$var$af = $e09959a092a7608b$var$Ze("animationiteration"), $e09959a092a7608b$var$bf = $e09959a092a7608b$var$Ze("animationstart"), $e09959a092a7608b$var$cf = $e09959a092a7608b$var$Ze("transitionend"), $e09959a092a7608b$var$df = new Map, $e09959a092a7608b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e09959a092a7608b$var$ff(a, b) {
    $e09959a092a7608b$var$df.set(a, b);
    $e09959a092a7608b$var$fa(b, [
        a
    ]);
}
for(var $e09959a092a7608b$var$gf = 0; $e09959a092a7608b$var$gf < $e09959a092a7608b$var$ef.length; $e09959a092a7608b$var$gf++){
    var $e09959a092a7608b$var$hf = $e09959a092a7608b$var$ef[$e09959a092a7608b$var$gf], $e09959a092a7608b$var$jf = $e09959a092a7608b$var$hf.toLowerCase(), $e09959a092a7608b$var$kf = $e09959a092a7608b$var$hf[0].toUpperCase() + $e09959a092a7608b$var$hf.slice(1);
    $e09959a092a7608b$var$ff($e09959a092a7608b$var$jf, "on" + $e09959a092a7608b$var$kf);
}
$e09959a092a7608b$var$ff($e09959a092a7608b$var$$e, "onAnimationEnd");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$af, "onAnimationIteration");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$bf, "onAnimationStart");
$e09959a092a7608b$var$ff("dblclick", "onDoubleClick");
$e09959a092a7608b$var$ff("focusin", "onFocus");
$e09959a092a7608b$var$ff("focusout", "onBlur");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$cf, "onTransitionEnd");
$e09959a092a7608b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e09959a092a7608b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e09959a092a7608b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e09959a092a7608b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e09959a092a7608b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e09959a092a7608b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e09959a092a7608b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e09959a092a7608b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e09959a092a7608b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e09959a092a7608b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e09959a092a7608b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e09959a092a7608b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e09959a092a7608b$var$lf));
function $e09959a092a7608b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e09959a092a7608b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e09959a092a7608b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e09959a092a7608b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e09959a092a7608b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e09959a092a7608b$var$Qb) throw a = $e09959a092a7608b$var$Rb, $e09959a092a7608b$var$Qb = !1, $e09959a092a7608b$var$Rb = null, a;
}
function $e09959a092a7608b$var$D(a, b) {
    var c = b[$e09959a092a7608b$var$of];
    void 0 === c && (c = b[$e09959a092a7608b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e09959a092a7608b$var$pf(b, a, 2, !1), c.add(d));
}
function $e09959a092a7608b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e09959a092a7608b$var$pf(c, a, d, b);
}
var $e09959a092a7608b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e09959a092a7608b$var$sf(a) {
    if (!a[$e09959a092a7608b$var$rf]) {
        a[$e09959a092a7608b$var$rf] = !0;
        $e09959a092a7608b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e09959a092a7608b$var$mf.has(b) || $e09959a092a7608b$var$qf(b, !1, a), $e09959a092a7608b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e09959a092a7608b$var$rf] || (b[$e09959a092a7608b$var$rf] = !0, $e09959a092a7608b$var$qf("selectionchange", !1, b));
    }
}
function $e09959a092a7608b$var$pf(a, b, c, d) {
    switch($e09959a092a7608b$var$jd(b)){
        case 1:
            var e = $e09959a092a7608b$var$ed;
            break;
        case 4:
            e = $e09959a092a7608b$var$gd;
            break;
        default:
            e = $e09959a092a7608b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e09959a092a7608b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e09959a092a7608b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e09959a092a7608b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e09959a092a7608b$var$Jb(function() {
        var d = f, e = $e09959a092a7608b$var$xb(c), g = [];
        a: {
            var h = $e09959a092a7608b$var$df.get(a);
            if (void 0 !== h) {
                var k = $e09959a092a7608b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e09959a092a7608b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e09959a092a7608b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e09959a092a7608b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e09959a092a7608b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e09959a092a7608b$var$Vd;
                        break;
                    case $e09959a092a7608b$var$$e:
                    case $e09959a092a7608b$var$af:
                    case $e09959a092a7608b$var$bf:
                        k = $e09959a092a7608b$var$Hd;
                        break;
                    case $e09959a092a7608b$var$cf:
                        k = $e09959a092a7608b$var$Xd;
                        break;
                    case "scroll":
                        k = $e09959a092a7608b$var$vd;
                        break;
                    case "wheel":
                        k = $e09959a092a7608b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e09959a092a7608b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e09959a092a7608b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e09959a092a7608b$var$Kb(w, x), null != F && t.push($e09959a092a7608b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e09959a092a7608b$var$wb && (n = c.relatedTarget || c.fromElement) && ($e09959a092a7608b$var$Wc(n) || n[$e09959a092a7608b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e09959a092a7608b$var$Wc(n) : null, null !== n && (J = $e09959a092a7608b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e09959a092a7608b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e09959a092a7608b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e09959a092a7608b$var$ue(k);
                        u = null == n ? h : $e09959a092a7608b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e09959a092a7608b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e09959a092a7608b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e09959a092a7608b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e09959a092a7608b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e09959a092a7608b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e09959a092a7608b$var$vf(t);
                                x = $e09959a092a7608b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e09959a092a7608b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e09959a092a7608b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e09959a092a7608b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e09959a092a7608b$var$ve;
                else if ($e09959a092a7608b$var$me(h)) {
                    if ($e09959a092a7608b$var$we) na = $e09959a092a7608b$var$Fe;
                    else {
                        na = $e09959a092a7608b$var$De;
                        var xa = $e09959a092a7608b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e09959a092a7608b$var$Ee);
                if (na && (na = na(a, d))) {
                    $e09959a092a7608b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e09959a092a7608b$var$cb(h, "number", h.value);
            }
            xa = d ? $e09959a092a7608b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e09959a092a7608b$var$me(xa) || "true" === xa.contentEditable) $e09959a092a7608b$var$Qe = xa, $e09959a092a7608b$var$Re = d, $e09959a092a7608b$var$Se = null;
                    break;
                case "focusout":
                    $e09959a092a7608b$var$Se = $e09959a092a7608b$var$Re = $e09959a092a7608b$var$Qe = null;
                    break;
                case "mousedown":
                    $e09959a092a7608b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e09959a092a7608b$var$Te = !1;
                    $e09959a092a7608b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e09959a092a7608b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e09959a092a7608b$var$Ue(g, c, e);
            }
            var $a;
            if ($e09959a092a7608b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e09959a092a7608b$var$ie ? $e09959a092a7608b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e09959a092a7608b$var$de && "ko" !== c.locale && ($e09959a092a7608b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e09959a092a7608b$var$ie && ($a = $e09959a092a7608b$var$nd()) : ($e09959a092a7608b$var$kd = e, $e09959a092a7608b$var$ld = "value" in $e09959a092a7608b$var$kd ? $e09959a092a7608b$var$kd.value : $e09959a092a7608b$var$kd.textContent, $e09959a092a7608b$var$ie = !0)), xa = $e09959a092a7608b$var$oe(d, ba), 0 < xa.length && (ba = new $e09959a092a7608b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e09959a092a7608b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e09959a092a7608b$var$ce ? $e09959a092a7608b$var$je(a, c) : $e09959a092a7608b$var$ke(a, c)) d = $e09959a092a7608b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e09959a092a7608b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e09959a092a7608b$var$se(g, b);
    });
}
function $e09959a092a7608b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e09959a092a7608b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e09959a092a7608b$var$Kb(a, c), null != f && d.unshift($e09959a092a7608b$var$tf(a, f, e)), f = $e09959a092a7608b$var$Kb(a, b), null != f && d.push($e09959a092a7608b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e09959a092a7608b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e09959a092a7608b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e09959a092a7608b$var$Kb(c, f), null != k && g.unshift($e09959a092a7608b$var$tf(c, k, h))) : e || (k = $e09959a092a7608b$var$Kb(c, f), null != k && g.push($e09959a092a7608b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e09959a092a7608b$var$xf = /\r\n?/g, $e09959a092a7608b$var$yf = /\u0000|\uFFFD/g;
function $e09959a092a7608b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e09959a092a7608b$var$xf, "\n").replace($e09959a092a7608b$var$yf, "");
}
function $e09959a092a7608b$var$Af(a, b, c) {
    b = $e09959a092a7608b$var$zf(b);
    if ($e09959a092a7608b$var$zf(a) !== b && c) throw Error($e09959a092a7608b$var$p(425));
}
function $e09959a092a7608b$var$Bf() {}
var $e09959a092a7608b$var$Cf = null, $e09959a092a7608b$var$Df = null;
function $e09959a092a7608b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e09959a092a7608b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e09959a092a7608b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e09959a092a7608b$var$Hf = "function" === typeof Promise ? Promise : void 0, $e09959a092a7608b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e09959a092a7608b$var$Hf ? function(a) {
    return $e09959a092a7608b$var$Hf.resolve(null).then(a).catch($e09959a092a7608b$var$If);
} : $e09959a092a7608b$var$Ff;
function $e09959a092a7608b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e09959a092a7608b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e09959a092a7608b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e09959a092a7608b$var$bd(b);
}
function $e09959a092a7608b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e09959a092a7608b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e09959a092a7608b$var$Nf = Math.random().toString(36).slice(2), $e09959a092a7608b$var$Of = "__reactFiber$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Pf = "__reactProps$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$uf = "__reactContainer$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$of = "__reactEvents$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Qf = "__reactListeners$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Rf = "__reactHandles$" + $e09959a092a7608b$var$Nf;
function $e09959a092a7608b$var$Wc(a) {
    var b = a[$e09959a092a7608b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e09959a092a7608b$var$uf] || c[$e09959a092a7608b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e09959a092a7608b$var$Mf(a); null !== a;){
                if (c = a[$e09959a092a7608b$var$Of]) return c;
                a = $e09959a092a7608b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e09959a092a7608b$var$Cb(a) {
    a = a[$e09959a092a7608b$var$Of] || a[$e09959a092a7608b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e09959a092a7608b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e09959a092a7608b$var$p(33));
}
function $e09959a092a7608b$var$Db(a) {
    return a[$e09959a092a7608b$var$Pf] || null;
}
var $e09959a092a7608b$var$Sf = [], $e09959a092a7608b$var$Tf = -1;
function $e09959a092a7608b$var$Uf(a) {
    return {
        current: a
    };
}
function $e09959a092a7608b$var$E(a) {
    0 > $e09959a092a7608b$var$Tf || (a.current = $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf], $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf] = null, $e09959a092a7608b$var$Tf--);
}
function $e09959a092a7608b$var$G(a, b) {
    $e09959a092a7608b$var$Tf++;
    $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf] = a.current;
    a.current = b;
}
var $e09959a092a7608b$var$Vf = {}, $e09959a092a7608b$var$H = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$Vf), $e09959a092a7608b$var$Wf = $e09959a092a7608b$var$Uf(!1), $e09959a092a7608b$var$Xf = $e09959a092a7608b$var$Vf;
function $e09959a092a7608b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e09959a092a7608b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e09959a092a7608b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e09959a092a7608b$var$$f() {
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
}
function $e09959a092a7608b$var$ag(a, b, c) {
    if ($e09959a092a7608b$var$H.current !== $e09959a092a7608b$var$Vf) throw Error($e09959a092a7608b$var$p(168));
    $e09959a092a7608b$var$G($e09959a092a7608b$var$H, b);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, c);
}
function $e09959a092a7608b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e09959a092a7608b$var$p(108, $e09959a092a7608b$var$Ra(a) || "Unknown", e));
    return $e09959a092a7608b$var$A({}, c, d);
}
function $e09959a092a7608b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e09959a092a7608b$var$Vf;
    $e09959a092a7608b$var$Xf = $e09959a092a7608b$var$H.current;
    $e09959a092a7608b$var$G($e09959a092a7608b$var$H, a);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, $e09959a092a7608b$var$Wf.current);
    return !0;
}
function $e09959a092a7608b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e09959a092a7608b$var$p(169));
    c ? (a = $e09959a092a7608b$var$bg(a, b, $e09959a092a7608b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf), $e09959a092a7608b$var$E($e09959a092a7608b$var$H), $e09959a092a7608b$var$G($e09959a092a7608b$var$H, a)) : $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, c);
}
var $e09959a092a7608b$var$eg = null, $e09959a092a7608b$var$fg = !1, $e09959a092a7608b$var$gg = !1;
function $e09959a092a7608b$var$hg(a) {
    null === $e09959a092a7608b$var$eg ? $e09959a092a7608b$var$eg = [
        a
    ] : $e09959a092a7608b$var$eg.push(a);
}
function $e09959a092a7608b$var$ig(a) {
    $e09959a092a7608b$var$fg = !0;
    $e09959a092a7608b$var$hg(a);
}
function $e09959a092a7608b$var$jg() {
    if (!$e09959a092a7608b$var$gg && null !== $e09959a092a7608b$var$eg) {
        $e09959a092a7608b$var$gg = !0;
        var a = 0, b = $e09959a092a7608b$var$C;
        try {
            var c = $e09959a092a7608b$var$eg;
            for($e09959a092a7608b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e09959a092a7608b$var$eg = null;
            $e09959a092a7608b$var$fg = !1;
        } catch (e) {
            throw null !== $e09959a092a7608b$var$eg && ($e09959a092a7608b$var$eg = $e09959a092a7608b$var$eg.slice(a + 1)), $e09959a092a7608b$var$ac($e09959a092a7608b$var$fc, $e09959a092a7608b$var$jg), e;
        } finally{
            $e09959a092a7608b$var$C = b, $e09959a092a7608b$var$gg = !1;
        }
    }
    return null;
}
var $e09959a092a7608b$var$kg = [], $e09959a092a7608b$var$lg = 0, $e09959a092a7608b$var$mg = null, $e09959a092a7608b$var$ng = 0, $e09959a092a7608b$var$og = [], $e09959a092a7608b$var$pg = 0, $e09959a092a7608b$var$qg = null, $e09959a092a7608b$var$rg = 1, $e09959a092a7608b$var$sg = "";
function $e09959a092a7608b$var$tg(a, b) {
    $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg++] = $e09959a092a7608b$var$ng;
    $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg++] = $e09959a092a7608b$var$mg;
    $e09959a092a7608b$var$mg = a;
    $e09959a092a7608b$var$ng = b;
}
function $e09959a092a7608b$var$ug(a, b, c) {
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$rg;
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$sg;
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$qg;
    $e09959a092a7608b$var$qg = a;
    var d = $e09959a092a7608b$var$rg;
    a = $e09959a092a7608b$var$sg;
    var e = 32 - $e09959a092a7608b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e09959a092a7608b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e09959a092a7608b$var$rg = 1 << 32 - $e09959a092a7608b$var$oc(b) + e | c << e | d;
        $e09959a092a7608b$var$sg = f + a;
    } else $e09959a092a7608b$var$rg = 1 << f | c << e | d, $e09959a092a7608b$var$sg = a;
}
function $e09959a092a7608b$var$vg(a) {
    null !== a.return && ($e09959a092a7608b$var$tg(a, 1), $e09959a092a7608b$var$ug(a, 1, 0));
}
function $e09959a092a7608b$var$wg(a) {
    for(; a === $e09959a092a7608b$var$mg;)$e09959a092a7608b$var$mg = $e09959a092a7608b$var$kg[--$e09959a092a7608b$var$lg], $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg] = null, $e09959a092a7608b$var$ng = $e09959a092a7608b$var$kg[--$e09959a092a7608b$var$lg], $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg] = null;
    for(; a === $e09959a092a7608b$var$qg;)$e09959a092a7608b$var$qg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null, $e09959a092a7608b$var$sg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null, $e09959a092a7608b$var$rg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null;
}
var $e09959a092a7608b$var$xg = null, $e09959a092a7608b$var$yg = null, $e09959a092a7608b$var$I = !1, $e09959a092a7608b$var$zg = null;
function $e09959a092a7608b$var$Ag(a, b) {
    var c = $e09959a092a7608b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e09959a092a7608b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e09959a092a7608b$var$qg ? {
                id: $e09959a092a7608b$var$rg,
                overflow: $e09959a092a7608b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e09959a092a7608b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e09959a092a7608b$var$Eg(a) {
    if ($e09959a092a7608b$var$I) {
        var b = $e09959a092a7608b$var$yg;
        if (b) {
            var c = b;
            if (!$e09959a092a7608b$var$Cg(a, b)) {
                if ($e09959a092a7608b$var$Dg(a)) throw Error($e09959a092a7608b$var$p(418));
                b = $e09959a092a7608b$var$Lf(c.nextSibling);
                var d = $e09959a092a7608b$var$xg;
                b && $e09959a092a7608b$var$Cg(a, b) ? $e09959a092a7608b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e09959a092a7608b$var$I = !1, $e09959a092a7608b$var$xg = a);
            }
        } else {
            if ($e09959a092a7608b$var$Dg(a)) throw Error($e09959a092a7608b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e09959a092a7608b$var$I = !1;
            $e09959a092a7608b$var$xg = a;
        }
    }
}
function $e09959a092a7608b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e09959a092a7608b$var$xg = a;
}
function $e09959a092a7608b$var$Gg(a) {
    if (a !== $e09959a092a7608b$var$xg) return !1;
    if (!$e09959a092a7608b$var$I) return $e09959a092a7608b$var$Fg(a), $e09959a092a7608b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e09959a092a7608b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e09959a092a7608b$var$yg)) {
        if ($e09959a092a7608b$var$Dg(a)) throw $e09959a092a7608b$var$Hg(), Error($e09959a092a7608b$var$p(418));
        for(; b;)$e09959a092a7608b$var$Ag(a, b), b = $e09959a092a7608b$var$Lf(b.nextSibling);
    }
    $e09959a092a7608b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e09959a092a7608b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e09959a092a7608b$var$yg = null;
        }
    } else $e09959a092a7608b$var$yg = $e09959a092a7608b$var$xg ? $e09959a092a7608b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e09959a092a7608b$var$Hg() {
    for(var a = $e09959a092a7608b$var$yg; a;)a = $e09959a092a7608b$var$Lf(a.nextSibling);
}
function $e09959a092a7608b$var$Ig() {
    $e09959a092a7608b$var$yg = $e09959a092a7608b$var$xg = null;
    $e09959a092a7608b$var$I = !1;
}
function $e09959a092a7608b$var$Jg(a) {
    null === $e09959a092a7608b$var$zg ? $e09959a092a7608b$var$zg = [
        a
    ] : $e09959a092a7608b$var$zg.push(a);
}
var $e09959a092a7608b$var$Kg = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig;
function $e09959a092a7608b$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e09959a092a7608b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e09959a092a7608b$var$Mg = $e09959a092a7608b$var$Uf(null), $e09959a092a7608b$var$Ng = null, $e09959a092a7608b$var$Og = null, $e09959a092a7608b$var$Pg = null;
function $e09959a092a7608b$var$Qg() {
    $e09959a092a7608b$var$Pg = $e09959a092a7608b$var$Og = $e09959a092a7608b$var$Ng = null;
}
function $e09959a092a7608b$var$Rg(a) {
    var b = $e09959a092a7608b$var$Mg.current;
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Mg);
    a._currentValue = b;
}
function $e09959a092a7608b$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e09959a092a7608b$var$Tg(a, b) {
    $e09959a092a7608b$var$Ng = a;
    $e09959a092a7608b$var$Pg = $e09959a092a7608b$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e09959a092a7608b$var$Ug = !0), a.firstContext = null);
}
function $e09959a092a7608b$var$Vg(a) {
    var b = a._currentValue;
    if ($e09959a092a7608b$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e09959a092a7608b$var$Og) {
            if (null === $e09959a092a7608b$var$Ng) throw Error($e09959a092a7608b$var$p(308));
            $e09959a092a7608b$var$Og = a;
            $e09959a092a7608b$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e09959a092a7608b$var$Og = $e09959a092a7608b$var$Og.next = a;
    }
    return b;
}
var $e09959a092a7608b$var$Wg = null;
function $e09959a092a7608b$var$Xg(a) {
    null === $e09959a092a7608b$var$Wg ? $e09959a092a7608b$var$Wg = [
        a
    ] : $e09959a092a7608b$var$Wg.push(a);
}
function $e09959a092a7608b$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e09959a092a7608b$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e09959a092a7608b$var$Zg(a, d);
}
function $e09959a092a7608b$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e09959a092a7608b$var$$g = !1;
function $e09959a092a7608b$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e09959a092a7608b$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e09959a092a7608b$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e09959a092a7608b$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e09959a092a7608b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e09959a092a7608b$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e09959a092a7608b$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e09959a092a7608b$var$Zg(a, c);
}
function $e09959a092a7608b$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e09959a092a7608b$var$Cc(a, c);
    }
}
function $e09959a092a7608b$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e09959a092a7608b$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e09959a092a7608b$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e09959a092a7608b$var$A({}, q, r);
                            break a;
                        case 2:
                            $e09959a092a7608b$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e09959a092a7608b$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e09959a092a7608b$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e09959a092a7608b$var$p(191, e));
            e.call(d);
        }
    }
}
var $e09959a092a7608b$var$jh = (new $8tsvq.Component).refs;
function $e09959a092a7608b$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e09959a092a7608b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e09959a092a7608b$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e09959a092a7608b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e09959a092a7608b$var$L(), e = $e09959a092a7608b$var$lh(a), f = $e09959a092a7608b$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e09959a092a7608b$var$dh(a, f, e);
        null !== b && ($e09959a092a7608b$var$mh(b, a, e, d), $e09959a092a7608b$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e09959a092a7608b$var$L(), e = $e09959a092a7608b$var$lh(a), f = $e09959a092a7608b$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e09959a092a7608b$var$dh(a, f, e);
        null !== b && ($e09959a092a7608b$var$mh(b, a, e, d), $e09959a092a7608b$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e09959a092a7608b$var$L(), d = $e09959a092a7608b$var$lh(a), e = $e09959a092a7608b$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e09959a092a7608b$var$dh(a, e, d);
        null !== b && ($e09959a092a7608b$var$mh(b, a, d, c), $e09959a092a7608b$var$eh(b, a, d));
    }
};
function $e09959a092a7608b$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e09959a092a7608b$var$Ie(c, d) || !$e09959a092a7608b$var$Ie(e, f) : !0;
}
function $e09959a092a7608b$var$ph(a, b, c) {
    var d = !1, e = $e09959a092a7608b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e09959a092a7608b$var$Vg(f) : (e = $e09959a092a7608b$var$Zf(b) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e09959a092a7608b$var$Yf(a, e) : $e09959a092a7608b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e09959a092a7608b$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e09959a092a7608b$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e09959a092a7608b$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e09959a092a7608b$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e09959a092a7608b$var$jh;
    $e09959a092a7608b$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e09959a092a7608b$var$Vg(f) : (f = $e09959a092a7608b$var$Zf(b) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, e.context = $e09959a092a7608b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e09959a092a7608b$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e09959a092a7608b$var$nh.enqueueReplaceState(e, e.state, null), $e09959a092a7608b$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e09959a092a7608b$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e09959a092a7608b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e09959a092a7608b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e09959a092a7608b$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e09959a092a7608b$var$p(284));
        if (!c._owner) throw Error($e09959a092a7608b$var$p(290, a));
    }
    return a;
}
function $e09959a092a7608b$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e09959a092a7608b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e09959a092a7608b$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e09959a092a7608b$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e09959a092a7608b$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e09959a092a7608b$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e09959a092a7608b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e09959a092a7608b$var$Ha && $e09959a092a7608b$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e09959a092a7608b$var$sh(a, b, c), d.return = a, d;
        d = $e09959a092a7608b$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e09959a092a7608b$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e09959a092a7608b$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e09959a092a7608b$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e09959a092a7608b$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e09959a092a7608b$var$va:
                    return c = $e09959a092a7608b$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e09959a092a7608b$var$sh(a, null, b), c.return = a, c;
                case $e09959a092a7608b$var$wa:
                    return b = $e09959a092a7608b$var$zh(b, a.mode, c), b.return = a, b;
                case $e09959a092a7608b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e09959a092a7608b$var$eb(b) || $e09959a092a7608b$var$Ka(b)) return b = $e09959a092a7608b$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e09959a092a7608b$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e09959a092a7608b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e09959a092a7608b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e09959a092a7608b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e09959a092a7608b$var$eb(c) || $e09959a092a7608b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e09959a092a7608b$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e09959a092a7608b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e09959a092a7608b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e09959a092a7608b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e09959a092a7608b$var$eb(d) || $e09959a092a7608b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e09959a092a7608b$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e09959a092a7608b$var$Ka(h);
        if ("function" !== typeof l) throw Error($e09959a092a7608b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e09959a092a7608b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e09959a092a7608b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e09959a092a7608b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e09959a092a7608b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e09959a092a7608b$var$Ha && $e09959a092a7608b$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e09959a092a7608b$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e09959a092a7608b$var$ya ? (d = $e09959a092a7608b$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e09959a092a7608b$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e09959a092a7608b$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e09959a092a7608b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e09959a092a7608b$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e09959a092a7608b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e09959a092a7608b$var$eb(f)) return n(a, d, f, h);
            if ($e09959a092a7608b$var$Ka(f)) return t(a, d, f, h);
            $e09959a092a7608b$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e09959a092a7608b$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e09959a092a7608b$var$Bh = $e09959a092a7608b$var$vh(!0), $e09959a092a7608b$var$Ch = $e09959a092a7608b$var$vh(!1), $e09959a092a7608b$var$Dh = {}, $e09959a092a7608b$var$Eh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$Dh), $e09959a092a7608b$var$Fh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$Dh), $e09959a092a7608b$var$Gh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$Dh);
function $e09959a092a7608b$var$Hh(a) {
    if (a === $e09959a092a7608b$var$Dh) throw Error($e09959a092a7608b$var$p(174));
    return a;
}
function $e09959a092a7608b$var$Ih(a, b) {
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Gh, b);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Fh, a);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Eh, $e09959a092a7608b$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e09959a092a7608b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e09959a092a7608b$var$lb(b, a);
    }
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Eh);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Eh, b);
}
function $e09959a092a7608b$var$Jh() {
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Eh);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Fh);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Gh);
}
function $e09959a092a7608b$var$Kh(a) {
    $e09959a092a7608b$var$Hh($e09959a092a7608b$var$Gh.current);
    var b = $e09959a092a7608b$var$Hh($e09959a092a7608b$var$Eh.current);
    var c = $e09959a092a7608b$var$lb(b, a.type);
    b !== c && ($e09959a092a7608b$var$G($e09959a092a7608b$var$Fh, a), $e09959a092a7608b$var$G($e09959a092a7608b$var$Eh, c));
}
function $e09959a092a7608b$var$Lh(a) {
    $e09959a092a7608b$var$Fh.current === a && ($e09959a092a7608b$var$E($e09959a092a7608b$var$Eh), $e09959a092a7608b$var$E($e09959a092a7608b$var$Fh));
}
var $e09959a092a7608b$var$M = $e09959a092a7608b$var$Uf(0);
function $e09959a092a7608b$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e09959a092a7608b$var$Nh = [];
function $e09959a092a7608b$var$Oh() {
    for(var a = 0; a < $e09959a092a7608b$var$Nh.length; a++)$e09959a092a7608b$var$Nh[a]._workInProgressVersionPrimary = null;
    $e09959a092a7608b$var$Nh.length = 0;
}
var $e09959a092a7608b$var$Ph = $e09959a092a7608b$var$ua.ReactCurrentDispatcher, $e09959a092a7608b$var$Qh = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$Rh = 0, $e09959a092a7608b$var$N = null, $e09959a092a7608b$var$O = null, $e09959a092a7608b$var$P = null, $e09959a092a7608b$var$Sh = !1, $e09959a092a7608b$var$Th = !1, $e09959a092a7608b$var$Uh = 0, $e09959a092a7608b$var$Vh = 0;
function $e09959a092a7608b$var$Q() {
    throw Error($e09959a092a7608b$var$p(321));
}
function $e09959a092a7608b$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e09959a092a7608b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e09959a092a7608b$var$Xh(a, b, c, d, e, f) {
    $e09959a092a7608b$var$Rh = f;
    $e09959a092a7608b$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e09959a092a7608b$var$Ph.current = null === a || null === a.memoizedState ? $e09959a092a7608b$var$Yh : $e09959a092a7608b$var$Zh;
    a = c(d, e);
    if ($e09959a092a7608b$var$Th) {
        f = 0;
        do {
            $e09959a092a7608b$var$Th = !1;
            $e09959a092a7608b$var$Uh = 0;
            if (25 <= f) throw Error($e09959a092a7608b$var$p(301));
            f += 1;
            $e09959a092a7608b$var$P = $e09959a092a7608b$var$O = null;
            b.updateQueue = null;
            $e09959a092a7608b$var$Ph.current = $e09959a092a7608b$var$$h;
            a = c(d, e);
        }while ($e09959a092a7608b$var$Th);
    }
    $e09959a092a7608b$var$Ph.current = $e09959a092a7608b$var$ai;
    b = null !== $e09959a092a7608b$var$O && null !== $e09959a092a7608b$var$O.next;
    $e09959a092a7608b$var$Rh = 0;
    $e09959a092a7608b$var$P = $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = null;
    $e09959a092a7608b$var$Sh = !1;
    if (b) throw Error($e09959a092a7608b$var$p(300));
    return a;
}
function $e09959a092a7608b$var$bi() {
    var a = 0 !== $e09959a092a7608b$var$Uh;
    $e09959a092a7608b$var$Uh = 0;
    return a;
}
function $e09959a092a7608b$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e09959a092a7608b$var$P ? $e09959a092a7608b$var$N.memoizedState = $e09959a092a7608b$var$P = a : $e09959a092a7608b$var$P = $e09959a092a7608b$var$P.next = a;
    return $e09959a092a7608b$var$P;
}
function $e09959a092a7608b$var$di() {
    if (null === $e09959a092a7608b$var$O) {
        var a = $e09959a092a7608b$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e09959a092a7608b$var$O.next;
    var b = null === $e09959a092a7608b$var$P ? $e09959a092a7608b$var$N.memoizedState : $e09959a092a7608b$var$P.next;
    if (null !== b) $e09959a092a7608b$var$P = b, $e09959a092a7608b$var$O = a;
    else {
        if (null === a) throw Error($e09959a092a7608b$var$p(310));
        $e09959a092a7608b$var$O = a;
        a = {
            memoizedState: $e09959a092a7608b$var$O.memoizedState,
            baseState: $e09959a092a7608b$var$O.baseState,
            baseQueue: $e09959a092a7608b$var$O.baseQueue,
            queue: $e09959a092a7608b$var$O.queue,
            next: null
        };
        null === $e09959a092a7608b$var$P ? $e09959a092a7608b$var$N.memoizedState = $e09959a092a7608b$var$P = a : $e09959a092a7608b$var$P = $e09959a092a7608b$var$P.next = a;
    }
    return $e09959a092a7608b$var$P;
}
function $e09959a092a7608b$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e09959a092a7608b$var$fi(a) {
    var b = $e09959a092a7608b$var$di(), c = b.queue;
    if (null === c) throw Error($e09959a092a7608b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e09959a092a7608b$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e09959a092a7608b$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e09959a092a7608b$var$N.lanes |= m;
                $e09959a092a7608b$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e09959a092a7608b$var$He(d, b.memoizedState) || ($e09959a092a7608b$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e09959a092a7608b$var$N.lanes |= f, $e09959a092a7608b$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e09959a092a7608b$var$gi(a) {
    var b = $e09959a092a7608b$var$di(), c = b.queue;
    if (null === c) throw Error($e09959a092a7608b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e09959a092a7608b$var$He(f, b.memoizedState) || ($e09959a092a7608b$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e09959a092a7608b$var$hi() {}
function $e09959a092a7608b$var$ii(a, b) {
    var c = $e09959a092a7608b$var$N, d = $e09959a092a7608b$var$di(), e = b(), f = !$e09959a092a7608b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e09959a092a7608b$var$Ug = !0);
    d = d.queue;
    $e09959a092a7608b$var$ji($e09959a092a7608b$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e09959a092a7608b$var$P && $e09959a092a7608b$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e09959a092a7608b$var$li(9, $e09959a092a7608b$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e09959a092a7608b$var$R) throw Error($e09959a092a7608b$var$p(349));
        0 !== ($e09959a092a7608b$var$Rh & 30) || $e09959a092a7608b$var$ni(c, b, e);
    }
    return e;
}
function $e09959a092a7608b$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e09959a092a7608b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e09959a092a7608b$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e09959a092a7608b$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e09959a092a7608b$var$oi(b) && $e09959a092a7608b$var$pi(a);
}
function $e09959a092a7608b$var$ki(a, b, c) {
    return c(function() {
        $e09959a092a7608b$var$oi(b) && $e09959a092a7608b$var$pi(a);
    });
}
function $e09959a092a7608b$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e09959a092a7608b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e09959a092a7608b$var$pi(a) {
    var b = $e09959a092a7608b$var$Zg(a, 1);
    null !== b && $e09959a092a7608b$var$mh(b, a, 1, -1);
}
function $e09959a092a7608b$var$qi(a) {
    var b = $e09959a092a7608b$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e09959a092a7608b$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e09959a092a7608b$var$ri.bind(null, $e09959a092a7608b$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e09959a092a7608b$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e09959a092a7608b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e09959a092a7608b$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e09959a092a7608b$var$si() {
    return $e09959a092a7608b$var$di().memoizedState;
}
function $e09959a092a7608b$var$ti(a, b, c, d) {
    var e = $e09959a092a7608b$var$ci();
    $e09959a092a7608b$var$N.flags |= a;
    e.memoizedState = $e09959a092a7608b$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e09959a092a7608b$var$ui(a, b, c, d) {
    var e = $e09959a092a7608b$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e09959a092a7608b$var$O) {
        var g = $e09959a092a7608b$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e09959a092a7608b$var$Wh(d, g.deps)) {
            e.memoizedState = $e09959a092a7608b$var$li(b, c, f, d);
            return;
        }
    }
    $e09959a092a7608b$var$N.flags |= a;
    e.memoizedState = $e09959a092a7608b$var$li(1 | b, c, f, d);
}
function $e09959a092a7608b$var$vi(a, b) {
    return $e09959a092a7608b$var$ti(8390656, 8, a, b);
}
function $e09959a092a7608b$var$ji(a, b) {
    return $e09959a092a7608b$var$ui(2048, 8, a, b);
}
function $e09959a092a7608b$var$wi(a, b) {
    return $e09959a092a7608b$var$ui(4, 2, a, b);
}
function $e09959a092a7608b$var$xi(a, b) {
    return $e09959a092a7608b$var$ui(4, 4, a, b);
}
function $e09959a092a7608b$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e09959a092a7608b$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e09959a092a7608b$var$ui(4, 4, $e09959a092a7608b$var$yi.bind(null, b, a), c);
}
function $e09959a092a7608b$var$Ai() {}
function $e09959a092a7608b$var$Bi(a, b) {
    var c = $e09959a092a7608b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e09959a092a7608b$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e09959a092a7608b$var$Ci(a, b) {
    var c = $e09959a092a7608b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e09959a092a7608b$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e09959a092a7608b$var$Di(a, b, c) {
    if (0 === ($e09959a092a7608b$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e09959a092a7608b$var$Ug = !0), a.memoizedState = c;
    $e09959a092a7608b$var$He(c, b) || (c = $e09959a092a7608b$var$yc(), $e09959a092a7608b$var$N.lanes |= c, $e09959a092a7608b$var$hh |= c, a.baseState = !0);
    return b;
}
function $e09959a092a7608b$var$Ei(a, b) {
    var c = $e09959a092a7608b$var$C;
    $e09959a092a7608b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e09959a092a7608b$var$Qh.transition;
    $e09959a092a7608b$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e09959a092a7608b$var$C = c, $e09959a092a7608b$var$Qh.transition = d;
    }
}
function $e09959a092a7608b$var$Fi() {
    return $e09959a092a7608b$var$di().memoizedState;
}
function $e09959a092a7608b$var$Gi(a, b, c) {
    var d = $e09959a092a7608b$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e09959a092a7608b$var$Hi(a)) $e09959a092a7608b$var$Ii(b, c);
    else if (c = $e09959a092a7608b$var$Yg(a, b, c, d), null !== c) {
        var e = $e09959a092a7608b$var$L();
        $e09959a092a7608b$var$mh(c, a, d, e);
        $e09959a092a7608b$var$Ji(c, b, d);
    }
}
function $e09959a092a7608b$var$ri(a, b, c) {
    var d = $e09959a092a7608b$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e09959a092a7608b$var$Hi(a)) $e09959a092a7608b$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e09959a092a7608b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e09959a092a7608b$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e09959a092a7608b$var$Yg(a, b, e, d);
        null !== c && (e = $e09959a092a7608b$var$L(), $e09959a092a7608b$var$mh(c, a, d, e), $e09959a092a7608b$var$Ji(c, b, d));
    }
}
function $e09959a092a7608b$var$Hi(a) {
    var b = a.alternate;
    return a === $e09959a092a7608b$var$N || null !== b && b === $e09959a092a7608b$var$N;
}
function $e09959a092a7608b$var$Ii(a, b) {
    $e09959a092a7608b$var$Th = $e09959a092a7608b$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e09959a092a7608b$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e09959a092a7608b$var$Cc(a, c);
    }
}
var $e09959a092a7608b$var$ai = {
    readContext: $e09959a092a7608b$var$Vg,
    useCallback: $e09959a092a7608b$var$Q,
    useContext: $e09959a092a7608b$var$Q,
    useEffect: $e09959a092a7608b$var$Q,
    useImperativeHandle: $e09959a092a7608b$var$Q,
    useInsertionEffect: $e09959a092a7608b$var$Q,
    useLayoutEffect: $e09959a092a7608b$var$Q,
    useMemo: $e09959a092a7608b$var$Q,
    useReducer: $e09959a092a7608b$var$Q,
    useRef: $e09959a092a7608b$var$Q,
    useState: $e09959a092a7608b$var$Q,
    useDebugValue: $e09959a092a7608b$var$Q,
    useDeferredValue: $e09959a092a7608b$var$Q,
    useTransition: $e09959a092a7608b$var$Q,
    useMutableSource: $e09959a092a7608b$var$Q,
    useSyncExternalStore: $e09959a092a7608b$var$Q,
    useId: $e09959a092a7608b$var$Q,
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Yh = {
    readContext: $e09959a092a7608b$var$Vg,
    useCallback: function(a, b) {
        $e09959a092a7608b$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e09959a092a7608b$var$Vg,
    useEffect: $e09959a092a7608b$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e09959a092a7608b$var$ti(4194308, 4, $e09959a092a7608b$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e09959a092a7608b$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e09959a092a7608b$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e09959a092a7608b$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e09959a092a7608b$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e09959a092a7608b$var$Gi.bind(null, $e09959a092a7608b$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e09959a092a7608b$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e09959a092a7608b$var$qi,
    useDebugValue: $e09959a092a7608b$var$Ai,
    useDeferredValue: function(a) {
        return $e09959a092a7608b$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$qi(!1), b = a[0];
        a = $e09959a092a7608b$var$Ei.bind(null, a[1]);
        $e09959a092a7608b$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e09959a092a7608b$var$N, e = $e09959a092a7608b$var$ci();
        if ($e09959a092a7608b$var$I) {
            if (void 0 === c) throw Error($e09959a092a7608b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e09959a092a7608b$var$R) throw Error($e09959a092a7608b$var$p(349));
            0 !== ($e09959a092a7608b$var$Rh & 30) || $e09959a092a7608b$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e09959a092a7608b$var$vi($e09959a092a7608b$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e09959a092a7608b$var$li(9, $e09959a092a7608b$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e09959a092a7608b$var$ci(), b = $e09959a092a7608b$var$R.identifierPrefix;
        if ($e09959a092a7608b$var$I) {
            var c = $e09959a092a7608b$var$sg;
            var d = $e09959a092a7608b$var$rg;
            c = (d & ~(1 << 32 - $e09959a092a7608b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e09959a092a7608b$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e09959a092a7608b$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Zh = {
    readContext: $e09959a092a7608b$var$Vg,
    useCallback: $e09959a092a7608b$var$Bi,
    useContext: $e09959a092a7608b$var$Vg,
    useEffect: $e09959a092a7608b$var$ji,
    useImperativeHandle: $e09959a092a7608b$var$zi,
    useInsertionEffect: $e09959a092a7608b$var$wi,
    useLayoutEffect: $e09959a092a7608b$var$xi,
    useMemo: $e09959a092a7608b$var$Ci,
    useReducer: $e09959a092a7608b$var$fi,
    useRef: $e09959a092a7608b$var$si,
    useState: function() {
        return $e09959a092a7608b$var$fi($e09959a092a7608b$var$ei);
    },
    useDebugValue: $e09959a092a7608b$var$Ai,
    useDeferredValue: function(a) {
        var b = $e09959a092a7608b$var$di();
        return $e09959a092a7608b$var$Di(b, $e09959a092a7608b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$fi($e09959a092a7608b$var$ei)[0], b = $e09959a092a7608b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e09959a092a7608b$var$hi,
    useSyncExternalStore: $e09959a092a7608b$var$ii,
    useId: $e09959a092a7608b$var$Fi,
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$$h = {
    readContext: $e09959a092a7608b$var$Vg,
    useCallback: $e09959a092a7608b$var$Bi,
    useContext: $e09959a092a7608b$var$Vg,
    useEffect: $e09959a092a7608b$var$ji,
    useImperativeHandle: $e09959a092a7608b$var$zi,
    useInsertionEffect: $e09959a092a7608b$var$wi,
    useLayoutEffect: $e09959a092a7608b$var$xi,
    useMemo: $e09959a092a7608b$var$Ci,
    useReducer: $e09959a092a7608b$var$gi,
    useRef: $e09959a092a7608b$var$si,
    useState: function() {
        return $e09959a092a7608b$var$gi($e09959a092a7608b$var$ei);
    },
    useDebugValue: $e09959a092a7608b$var$Ai,
    useDeferredValue: function(a) {
        var b = $e09959a092a7608b$var$di();
        return null === $e09959a092a7608b$var$O ? b.memoizedState = a : $e09959a092a7608b$var$Di(b, $e09959a092a7608b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$gi($e09959a092a7608b$var$ei)[0], b = $e09959a092a7608b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e09959a092a7608b$var$hi,
    useSyncExternalStore: $e09959a092a7608b$var$ii,
    useId: $e09959a092a7608b$var$Fi,
    unstable_isNewReconciler: !1
};
function $e09959a092a7608b$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e09959a092a7608b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e09959a092a7608b$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e09959a092a7608b$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e09959a092a7608b$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e09959a092a7608b$var$Oi(a, b, c) {
    c = $e09959a092a7608b$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e09959a092a7608b$var$Pi || ($e09959a092a7608b$var$Pi = !0, $e09959a092a7608b$var$Qi = d);
        $e09959a092a7608b$var$Mi(a, b);
    };
    return c;
}
function $e09959a092a7608b$var$Ri(a, b, c) {
    c = $e09959a092a7608b$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e09959a092a7608b$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e09959a092a7608b$var$Mi(a, b);
        "function" !== typeof d && (null === $e09959a092a7608b$var$Si ? $e09959a092a7608b$var$Si = new Set([
            this
        ]) : $e09959a092a7608b$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e09959a092a7608b$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e09959a092a7608b$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e09959a092a7608b$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e09959a092a7608b$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e09959a092a7608b$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e09959a092a7608b$var$ch(-1, 1), b.tag = 2, $e09959a092a7608b$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e09959a092a7608b$var$Xi = $e09959a092a7608b$var$ua.ReactCurrentOwner, $e09959a092a7608b$var$Ug = !1;
function $e09959a092a7608b$var$Yi(a, b, c, d) {
    b.child = null === a ? $e09959a092a7608b$var$Ch(b, null, c, d) : $e09959a092a7608b$var$Bh(b, a.child, c, d);
}
function $e09959a092a7608b$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e09959a092a7608b$var$Tg(b, e);
    d = $e09959a092a7608b$var$Xh(a, b, c, d, f, e);
    c = $e09959a092a7608b$var$bi();
    if (null !== a && !$e09959a092a7608b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e09959a092a7608b$var$$i(a, b, e);
    $e09959a092a7608b$var$I && c && $e09959a092a7608b$var$vg(b);
    b.flags |= 1;
    $e09959a092a7608b$var$Yi(a, b, d, e);
    return b.child;
}
function $e09959a092a7608b$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e09959a092a7608b$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e09959a092a7608b$var$cj(a, b, f, d, e);
        a = $e09959a092a7608b$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e09959a092a7608b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e09959a092a7608b$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e09959a092a7608b$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e09959a092a7608b$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e09959a092a7608b$var$Ie(f, d) && a.ref === b.ref) {
            if ($e09959a092a7608b$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e09959a092a7608b$var$Ug = !0);
            else return b.lanes = a.lanes, $e09959a092a7608b$var$$i(a, b, e);
        }
    }
    return $e09959a092a7608b$var$dj(a, b, c, d, e);
}
function $e09959a092a7608b$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e09959a092a7608b$var$G($e09959a092a7608b$var$fj, $e09959a092a7608b$var$gj), $e09959a092a7608b$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e09959a092a7608b$var$G($e09959a092a7608b$var$fj, $e09959a092a7608b$var$gj), $e09959a092a7608b$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e09959a092a7608b$var$G($e09959a092a7608b$var$fj, $e09959a092a7608b$var$gj);
            $e09959a092a7608b$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e09959a092a7608b$var$G($e09959a092a7608b$var$fj, $e09959a092a7608b$var$gj), $e09959a092a7608b$var$gj |= d;
    $e09959a092a7608b$var$Yi(a, b, e, c);
    return b.child;
}
function $e09959a092a7608b$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e09959a092a7608b$var$dj(a, b, c, d, e) {
    var f = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current;
    f = $e09959a092a7608b$var$Yf(b, f);
    $e09959a092a7608b$var$Tg(b, e);
    c = $e09959a092a7608b$var$Xh(a, b, c, d, f, e);
    d = $e09959a092a7608b$var$bi();
    if (null !== a && !$e09959a092a7608b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e09959a092a7608b$var$$i(a, b, e);
    $e09959a092a7608b$var$I && d && $e09959a092a7608b$var$vg(b);
    b.flags |= 1;
    $e09959a092a7608b$var$Yi(a, b, c, e);
    return b.child;
}
function $e09959a092a7608b$var$ij(a, b, c, d, e) {
    if ($e09959a092a7608b$var$Zf(c)) {
        var f = !0;
        $e09959a092a7608b$var$cg(b);
    } else f = !1;
    $e09959a092a7608b$var$Tg(b, e);
    if (null === b.stateNode) $e09959a092a7608b$var$jj(a, b), $e09959a092a7608b$var$ph(b, c, d), $e09959a092a7608b$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e09959a092a7608b$var$Vg(l) : (l = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, l = $e09959a092a7608b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e09959a092a7608b$var$qh(b, g, d, l);
        $e09959a092a7608b$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e09959a092a7608b$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e09959a092a7608b$var$Wf.current || $e09959a092a7608b$var$$g ? ("function" === typeof m && ($e09959a092a7608b$var$kh(b, c, m, d), k = b.memoizedState), (h = $e09959a092a7608b$var$$g || $e09959a092a7608b$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e09959a092a7608b$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e09959a092a7608b$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e09959a092a7608b$var$Vg(k) : (k = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, k = $e09959a092a7608b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e09959a092a7608b$var$qh(b, g, d, k);
        $e09959a092a7608b$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e09959a092a7608b$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e09959a092a7608b$var$Wf.current || $e09959a092a7608b$var$$g ? ("function" === typeof y && ($e09959a092a7608b$var$kh(b, c, y, d), n = b.memoizedState), (l = $e09959a092a7608b$var$$g || $e09959a092a7608b$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e09959a092a7608b$var$kj(a, b, c, d, f, e);
}
function $e09959a092a7608b$var$kj(a, b, c, d, e, f) {
    $e09959a092a7608b$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e09959a092a7608b$var$dg(b, c, !1), $e09959a092a7608b$var$$i(a, b, f);
    d = b.stateNode;
    $e09959a092a7608b$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e09959a092a7608b$var$Bh(b, a.child, null, f), b.child = $e09959a092a7608b$var$Bh(b, null, h, f)) : $e09959a092a7608b$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e09959a092a7608b$var$dg(b, c, !0);
    return b.child;
}
function $e09959a092a7608b$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e09959a092a7608b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e09959a092a7608b$var$ag(a, b.context, !1);
    $e09959a092a7608b$var$Ih(a, b.containerInfo);
}
function $e09959a092a7608b$var$mj(a, b, c, d, e) {
    $e09959a092a7608b$var$Ig();
    $e09959a092a7608b$var$Jg(e);
    b.flags |= 256;
    $e09959a092a7608b$var$Yi(a, b, c, d);
    return b.child;
}
var $e09959a092a7608b$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e09959a092a7608b$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e09959a092a7608b$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e09959a092a7608b$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e09959a092a7608b$var$G($e09959a092a7608b$var$M, e & 1);
    if (null === a) {
        $e09959a092a7608b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e09959a092a7608b$var$qj(g, d, 0, null), a = $e09959a092a7608b$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e09959a092a7608b$var$oj(c), b.memoizedState = $e09959a092a7608b$var$nj, a) : $e09959a092a7608b$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e09959a092a7608b$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e09959a092a7608b$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e09959a092a7608b$var$wh(h, f) : (f = $e09959a092a7608b$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e09959a092a7608b$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e09959a092a7608b$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e09959a092a7608b$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e09959a092a7608b$var$rj(a, b) {
    b = $e09959a092a7608b$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e09959a092a7608b$var$tj(a, b, c, d) {
    null !== d && $e09959a092a7608b$var$Jg(d);
    $e09959a092a7608b$var$Bh(b, a.child, null, c);
    a = $e09959a092a7608b$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e09959a092a7608b$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e09959a092a7608b$var$Li(Error($e09959a092a7608b$var$p(422))), $e09959a092a7608b$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e09959a092a7608b$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e09959a092a7608b$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e09959a092a7608b$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e09959a092a7608b$var$oj(g);
        b.memoizedState = $e09959a092a7608b$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e09959a092a7608b$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e09959a092a7608b$var$p(419));
        d = $e09959a092a7608b$var$Li(f, d, void 0);
        return $e09959a092a7608b$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e09959a092a7608b$var$Ug || h) {
        d = $e09959a092a7608b$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e09959a092a7608b$var$Zg(a, e), $e09959a092a7608b$var$mh(d, a, e, -1));
        }
        $e09959a092a7608b$var$uj();
        d = $e09959a092a7608b$var$Li(Error($e09959a092a7608b$var$p(421)));
        return $e09959a092a7608b$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e09959a092a7608b$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(e.nextSibling);
    $e09959a092a7608b$var$xg = b;
    $e09959a092a7608b$var$I = !0;
    $e09959a092a7608b$var$zg = null;
    null !== a && ($e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$rg, $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$sg, $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$qg, $e09959a092a7608b$var$rg = a.id, $e09959a092a7608b$var$sg = a.overflow, $e09959a092a7608b$var$qg = b);
    b = $e09959a092a7608b$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e09959a092a7608b$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e09959a092a7608b$var$Sg(a.return, b, c);
}
function $e09959a092a7608b$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e09959a092a7608b$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e09959a092a7608b$var$Yi(a, b, d.children, c);
    d = $e09959a092a7608b$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e09959a092a7608b$var$wj(a, c, b);
            else if (19 === a.tag) $e09959a092a7608b$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e09959a092a7608b$var$G($e09959a092a7608b$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e09959a092a7608b$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e09959a092a7608b$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e09959a092a7608b$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e09959a092a7608b$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e09959a092a7608b$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e09959a092a7608b$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e09959a092a7608b$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e09959a092a7608b$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e09959a092a7608b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e09959a092a7608b$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e09959a092a7608b$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e09959a092a7608b$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e09959a092a7608b$var$lj(b);
            $e09959a092a7608b$var$Ig();
            break;
        case 5:
            $e09959a092a7608b$var$Kh(b);
            break;
        case 1:
            $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$cg(b);
            break;
        case 4:
            $e09959a092a7608b$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e09959a092a7608b$var$G($e09959a092a7608b$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e09959a092a7608b$var$G($e09959a092a7608b$var$M, $e09959a092a7608b$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e09959a092a7608b$var$pj(a, b, c);
                $e09959a092a7608b$var$G($e09959a092a7608b$var$M, $e09959a092a7608b$var$M.current & 1);
                a = $e09959a092a7608b$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e09959a092a7608b$var$G($e09959a092a7608b$var$M, $e09959a092a7608b$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e09959a092a7608b$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e09959a092a7608b$var$G($e09959a092a7608b$var$M, $e09959a092a7608b$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e09959a092a7608b$var$ej(a, b, c);
    }
    return $e09959a092a7608b$var$$i(a, b, c);
}
var $e09959a092a7608b$var$Aj, $e09959a092a7608b$var$Bj, $e09959a092a7608b$var$Cj, $e09959a092a7608b$var$Dj;
$e09959a092a7608b$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e09959a092a7608b$var$Bj = function() {};
$e09959a092a7608b$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e09959a092a7608b$var$Hh($e09959a092a7608b$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e09959a092a7608b$var$Ya(a, e);
                d = $e09959a092a7608b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e09959a092a7608b$var$A({}, e, {
                    value: void 0
                });
                d = $e09959a092a7608b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e09959a092a7608b$var$gb(a, e);
                d = $e09959a092a7608b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e09959a092a7608b$var$Bf);
        }
        $e09959a092a7608b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e09959a092a7608b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e09959a092a7608b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e09959a092a7608b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e09959a092a7608b$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e09959a092a7608b$var$Ej(a, b) {
    if (!$e09959a092a7608b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e09959a092a7608b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e09959a092a7608b$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e09959a092a7608b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e09959a092a7608b$var$S(b), null;
        case 1:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), $e09959a092a7608b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e09959a092a7608b$var$Jh();
            $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
            $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
            $e09959a092a7608b$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e09959a092a7608b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e09959a092a7608b$var$zg && ($e09959a092a7608b$var$Gj($e09959a092a7608b$var$zg), $e09959a092a7608b$var$zg = null));
            $e09959a092a7608b$var$Bj(a, b);
            $e09959a092a7608b$var$S(b);
            return null;
        case 5:
            $e09959a092a7608b$var$Lh(b);
            var e = $e09959a092a7608b$var$Hh($e09959a092a7608b$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e09959a092a7608b$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e09959a092a7608b$var$p(166));
                    $e09959a092a7608b$var$S(b);
                    return null;
                }
                a = $e09959a092a7608b$var$Hh($e09959a092a7608b$var$Eh.current);
                if ($e09959a092a7608b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e09959a092a7608b$var$Of] = b;
                    d[$e09959a092a7608b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e09959a092a7608b$var$D("cancel", d);
                            $e09959a092a7608b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e09959a092a7608b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e09959a092a7608b$var$lf.length; e++)$e09959a092a7608b$var$D($e09959a092a7608b$var$lf[e], d);
                            break;
                        case "source":
                            $e09959a092a7608b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e09959a092a7608b$var$D("error", d);
                            $e09959a092a7608b$var$D("load", d);
                            break;
                        case "details":
                            $e09959a092a7608b$var$D("toggle", d);
                            break;
                        case "input":
                            $e09959a092a7608b$var$Za(d, f);
                            $e09959a092a7608b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e09959a092a7608b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$hb(d, f), $e09959a092a7608b$var$D("invalid", d);
                    }
                    $e09959a092a7608b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e09959a092a7608b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e09959a092a7608b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e09959a092a7608b$var$Va(d);
                            $e09959a092a7608b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$Va(d);
                            $e09959a092a7608b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e09959a092a7608b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e09959a092a7608b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e09959a092a7608b$var$Of] = b;
                    a[$e09959a092a7608b$var$Pf] = d;
                    $e09959a092a7608b$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e09959a092a7608b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e09959a092a7608b$var$D("cancel", a);
                                $e09959a092a7608b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e09959a092a7608b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e09959a092a7608b$var$lf.length; e++)$e09959a092a7608b$var$D($e09959a092a7608b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e09959a092a7608b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e09959a092a7608b$var$D("error", a);
                                $e09959a092a7608b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e09959a092a7608b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e09959a092a7608b$var$Za(a, d);
                                e = $e09959a092a7608b$var$Ya(a, d);
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e09959a092a7608b$var$A({}, d, {
                                    value: void 0
                                });
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e09959a092a7608b$var$hb(a, d);
                                e = $e09959a092a7608b$var$gb(a, d);
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e09959a092a7608b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e09959a092a7608b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e09959a092a7608b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e09959a092a7608b$var$ob(a, k) : "number" === typeof k && $e09959a092a7608b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e09959a092a7608b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e09959a092a7608b$var$D("scroll", a) : null != k && $e09959a092a7608b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e09959a092a7608b$var$Va(a);
                                $e09959a092a7608b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e09959a092a7608b$var$Va(a);
                                $e09959a092a7608b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e09959a092a7608b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e09959a092a7608b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e09959a092a7608b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e09959a092a7608b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e09959a092a7608b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e09959a092a7608b$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e09959a092a7608b$var$p(166));
                c = $e09959a092a7608b$var$Hh($e09959a092a7608b$var$Gh.current);
                $e09959a092a7608b$var$Hh($e09959a092a7608b$var$Eh.current);
                if ($e09959a092a7608b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e09959a092a7608b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e09959a092a7608b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e09959a092a7608b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e09959a092a7608b$var$Of] = b, b.stateNode = d;
            }
            $e09959a092a7608b$var$S(b);
            return null;
        case 13:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e09959a092a7608b$var$I && null !== $e09959a092a7608b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e09959a092a7608b$var$Hg(), $e09959a092a7608b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e09959a092a7608b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e09959a092a7608b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e09959a092a7608b$var$p(317));
                        f[$e09959a092a7608b$var$Of] = b;
                    } else $e09959a092a7608b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e09959a092a7608b$var$S(b);
                    f = !1;
                } else null !== $e09959a092a7608b$var$zg && ($e09959a092a7608b$var$Gj($e09959a092a7608b$var$zg), $e09959a092a7608b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e09959a092a7608b$var$M.current & 1) ? 0 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 3) : $e09959a092a7608b$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e09959a092a7608b$var$S(b);
            return null;
        case 4:
            return $e09959a092a7608b$var$Jh(), $e09959a092a7608b$var$Bj(a, b), null === a && $e09959a092a7608b$var$sf(b.stateNode.containerInfo), $e09959a092a7608b$var$S(b), null;
        case 10:
            return $e09959a092a7608b$var$Rg(b.type._context), $e09959a092a7608b$var$S(b), null;
        case 17:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), $e09959a092a7608b$var$S(b), null;
        case 19:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$M);
            f = b.memoizedState;
            if (null === f) return $e09959a092a7608b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e09959a092a7608b$var$Ej(f, !1);
                else {
                    if (0 !== $e09959a092a7608b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e09959a092a7608b$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e09959a092a7608b$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e09959a092a7608b$var$G($e09959a092a7608b$var$M, $e09959a092a7608b$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e09959a092a7608b$var$B() > $e09959a092a7608b$var$Hj && (b.flags |= 128, d = !0, $e09959a092a7608b$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e09959a092a7608b$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e09959a092a7608b$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e09959a092a7608b$var$I) return $e09959a092a7608b$var$S(b), null;
                    } else 2 * $e09959a092a7608b$var$B() - f.renderingStartTime > $e09959a092a7608b$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e09959a092a7608b$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e09959a092a7608b$var$B(), b.sibling = null, c = $e09959a092a7608b$var$M.current, $e09959a092a7608b$var$G($e09959a092a7608b$var$M, d ? c & 1 | 2 : c & 1), b;
            $e09959a092a7608b$var$S(b);
            return null;
        case 22:
        case 23:
            return $e09959a092a7608b$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e09959a092a7608b$var$gj & 1073741824) && ($e09959a092a7608b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e09959a092a7608b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e09959a092a7608b$var$p(156, b.tag));
}
function $e09959a092a7608b$var$Jj(a, b) {
    $e09959a092a7608b$var$wg(b);
    switch(b.tag){
        case 1:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e09959a092a7608b$var$Jh(), $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf), $e09959a092a7608b$var$E($e09959a092a7608b$var$H), $e09959a092a7608b$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e09959a092a7608b$var$Lh(b), null;
        case 13:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e09959a092a7608b$var$p(340));
                $e09959a092a7608b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e09959a092a7608b$var$E($e09959a092a7608b$var$M), null;
        case 4:
            return $e09959a092a7608b$var$Jh(), null;
        case 10:
            return $e09959a092a7608b$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e09959a092a7608b$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e09959a092a7608b$var$Kj = !1, $e09959a092a7608b$var$U = !1, $e09959a092a7608b$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e09959a092a7608b$var$V = null;
function $e09959a092a7608b$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e09959a092a7608b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e09959a092a7608b$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e09959a092a7608b$var$W(a, b, d);
    }
}
var $e09959a092a7608b$var$Oj = !1;
function $e09959a092a7608b$var$Pj(a, b) {
    $e09959a092a7608b$var$Cf = $e09959a092a7608b$var$dd;
    a = $e09959a092a7608b$var$Me();
    if ($e09959a092a7608b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e09959a092a7608b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e09959a092a7608b$var$dd = !1;
    for($e09959a092a7608b$var$V = b; null !== $e09959a092a7608b$var$V;)if (b = $e09959a092a7608b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e09959a092a7608b$var$V = a;
    else for(; null !== $e09959a092a7608b$var$V;){
        b = $e09959a092a7608b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e09959a092a7608b$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(163));
            }
        } catch (F) {
            $e09959a092a7608b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e09959a092a7608b$var$V = a;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
    n = $e09959a092a7608b$var$Oj;
    $e09959a092a7608b$var$Oj = !1;
    return n;
}
function $e09959a092a7608b$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e09959a092a7608b$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e09959a092a7608b$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e09959a092a7608b$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e09959a092a7608b$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e09959a092a7608b$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e09959a092a7608b$var$Of], delete b[$e09959a092a7608b$var$Pf], delete b[$e09959a092a7608b$var$of], delete b[$e09959a092a7608b$var$Qf], delete b[$e09959a092a7608b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e09959a092a7608b$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e09959a092a7608b$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e09959a092a7608b$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e09959a092a7608b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e09959a092a7608b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e09959a092a7608b$var$Wj(a, b, c), a = a.sibling; null !== a;)$e09959a092a7608b$var$Wj(a, b, c), a = a.sibling;
}
function $e09959a092a7608b$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e09959a092a7608b$var$Xj(a, b, c), a = a.sibling; null !== a;)$e09959a092a7608b$var$Xj(a, b, c), a = a.sibling;
}
var $e09959a092a7608b$var$X = null, $e09959a092a7608b$var$Yj = !1;
function $e09959a092a7608b$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e09959a092a7608b$var$ak(a, b, c), c = c.sibling;
}
function $e09959a092a7608b$var$ak(a, b, c) {
    if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onCommitFiberUnmount) try {
        $e09959a092a7608b$var$lc.onCommitFiberUnmount($e09959a092a7608b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e09959a092a7608b$var$U || $e09959a092a7608b$var$Mj(c, b);
        case 6:
            var d = $e09959a092a7608b$var$X, e = $e09959a092a7608b$var$Yj;
            $e09959a092a7608b$var$X = null;
            $e09959a092a7608b$var$Zj(a, b, c);
            $e09959a092a7608b$var$X = d;
            $e09959a092a7608b$var$Yj = e;
            null !== $e09959a092a7608b$var$X && ($e09959a092a7608b$var$Yj ? (a = $e09959a092a7608b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e09959a092a7608b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e09959a092a7608b$var$X && ($e09959a092a7608b$var$Yj ? (a = $e09959a092a7608b$var$X, c = c.stateNode, 8 === a.nodeType ? $e09959a092a7608b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e09959a092a7608b$var$Kf(a, c), $e09959a092a7608b$var$bd(a)) : $e09959a092a7608b$var$Kf($e09959a092a7608b$var$X, c.stateNode));
            break;
        case 4:
            d = $e09959a092a7608b$var$X;
            e = $e09959a092a7608b$var$Yj;
            $e09959a092a7608b$var$X = c.stateNode.containerInfo;
            $e09959a092a7608b$var$Yj = !0;
            $e09959a092a7608b$var$Zj(a, b, c);
            $e09959a092a7608b$var$X = d;
            $e09959a092a7608b$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e09959a092a7608b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e09959a092a7608b$var$Nj(c, b, g) : 0 !== (f & 4) && $e09959a092a7608b$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e09959a092a7608b$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e09959a092a7608b$var$U && ($e09959a092a7608b$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e09959a092a7608b$var$W(c, b, h);
            }
            $e09959a092a7608b$var$Zj(a, b, c);
            break;
        case 21:
            $e09959a092a7608b$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e09959a092a7608b$var$U = (d = $e09959a092a7608b$var$U) || null !== c.memoizedState, $e09959a092a7608b$var$Zj(a, b, c), $e09959a092a7608b$var$U = d) : $e09959a092a7608b$var$Zj(a, b, c);
            break;
        default:
            $e09959a092a7608b$var$Zj(a, b, c);
    }
}
function $e09959a092a7608b$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e09959a092a7608b$var$Lj);
        b.forEach(function(b) {
            var d = $e09959a092a7608b$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e09959a092a7608b$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e09959a092a7608b$var$X = h.stateNode;
                        $e09959a092a7608b$var$Yj = !1;
                        break a;
                    case 3:
                        $e09959a092a7608b$var$X = h.stateNode.containerInfo;
                        $e09959a092a7608b$var$Yj = !0;
                        break a;
                    case 4:
                        $e09959a092a7608b$var$X = h.stateNode.containerInfo;
                        $e09959a092a7608b$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e09959a092a7608b$var$X) throw Error($e09959a092a7608b$var$p(160));
            $e09959a092a7608b$var$ak(f, g, e);
            $e09959a092a7608b$var$X = null;
            $e09959a092a7608b$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e09959a092a7608b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e09959a092a7608b$var$ek(b, a), b = b.sibling;
}
function $e09959a092a7608b$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            if (d & 4) {
                try {
                    $e09959a092a7608b$var$Qj(3, a, a.return), $e09959a092a7608b$var$Rj(3, a);
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
                try {
                    $e09959a092a7608b$var$Qj(5, a, a.return);
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            d & 512 && null !== c && $e09959a092a7608b$var$Mj(c, c.return);
            break;
        case 5:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            d & 512 && null !== c && $e09959a092a7608b$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e09959a092a7608b$var$ob(e, "");
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e09959a092a7608b$var$ab(e, f);
                    $e09959a092a7608b$var$vb(h, g);
                    var l = $e09959a092a7608b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e09959a092a7608b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e09959a092a7608b$var$nb(e, q) : "children" === m ? $e09959a092a7608b$var$ob(e, q) : $e09959a092a7608b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e09959a092a7608b$var$bb(e, f);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e09959a092a7608b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e09959a092a7608b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e09959a092a7608b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e09959a092a7608b$var$Pf] = f;
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e09959a092a7608b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e09959a092a7608b$var$bd(b.containerInfo);
            } catch (t) {
                $e09959a092a7608b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            break;
        case 13:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e09959a092a7608b$var$gk = $e09959a092a7608b$var$B()));
            d & 4 && $e09959a092a7608b$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e09959a092a7608b$var$U = (l = $e09959a092a7608b$var$U) || m, $e09959a092a7608b$var$dk(b, a), $e09959a092a7608b$var$U = l) : $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e09959a092a7608b$var$V = a, m = a.child; null !== m;){
                    for(q = $e09959a092a7608b$var$V = m; null !== $e09959a092a7608b$var$V;){
                        r = $e09959a092a7608b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e09959a092a7608b$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e09959a092a7608b$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e09959a092a7608b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e09959a092a7608b$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e09959a092a7608b$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e09959a092a7608b$var$V = y) : $e09959a092a7608b$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e09959a092a7608b$var$rb("display", g));
                            } catch (t) {
                                $e09959a092a7608b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e09959a092a7608b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e09959a092a7608b$var$dk(b, a);
            $e09959a092a7608b$var$fk(a);
            d & 4 && $e09959a092a7608b$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e09959a092a7608b$var$dk(b, a), $e09959a092a7608b$var$fk(a);
    }
}
function $e09959a092a7608b$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e09959a092a7608b$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e09959a092a7608b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e09959a092a7608b$var$ob(e, ""), d.flags &= -33);
                    var f = $e09959a092a7608b$var$Vj(a);
                    $e09959a092a7608b$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e09959a092a7608b$var$Vj(a);
                    $e09959a092a7608b$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(161));
            }
        } catch (k) {
            $e09959a092a7608b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e09959a092a7608b$var$ik(a, b, c) {
    $e09959a092a7608b$var$V = a;
    $e09959a092a7608b$var$jk(a, b, c);
}
function $e09959a092a7608b$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e09959a092a7608b$var$V;){
        var e = $e09959a092a7608b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e09959a092a7608b$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e09959a092a7608b$var$U;
                h = $e09959a092a7608b$var$Kj;
                var l = $e09959a092a7608b$var$U;
                $e09959a092a7608b$var$Kj = g;
                if (($e09959a092a7608b$var$U = k) && !l) for($e09959a092a7608b$var$V = e; null !== $e09959a092a7608b$var$V;)g = $e09959a092a7608b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e09959a092a7608b$var$kk(e) : null !== k ? (k.return = g, $e09959a092a7608b$var$V = k) : $e09959a092a7608b$var$kk(e);
                for(; null !== f;)$e09959a092a7608b$var$V = f, $e09959a092a7608b$var$jk(f, b, c), f = f.sibling;
                $e09959a092a7608b$var$V = e;
                $e09959a092a7608b$var$Kj = h;
                $e09959a092a7608b$var$U = l;
            }
            $e09959a092a7608b$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e09959a092a7608b$var$V = f) : $e09959a092a7608b$var$lk(a, b, c);
    }
}
function $e09959a092a7608b$var$lk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e09959a092a7608b$var$U || $e09959a092a7608b$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e09959a092a7608b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e09959a092a7608b$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e09959a092a7608b$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e09959a092a7608b$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e09959a092a7608b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e09959a092a7608b$var$p(163));
                }
                $e09959a092a7608b$var$U || b.flags & 512 && $e09959a092a7608b$var$Sj(b);
            } catch (r) {
                $e09959a092a7608b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e09959a092a7608b$var$V = c;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
function $e09959a092a7608b$var$hk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e09959a092a7608b$var$V = c;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
function $e09959a092a7608b$var$kk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e09959a092a7608b$var$Rj(4, b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e09959a092a7608b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e09959a092a7608b$var$Sj(b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e09959a092a7608b$var$Sj(b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e09959a092a7608b$var$W(b, b.return, k);
        }
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e09959a092a7608b$var$V = h;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
var $e09959a092a7608b$var$mk = Math.ceil, $e09959a092a7608b$var$nk = $e09959a092a7608b$var$ua.ReactCurrentDispatcher, $e09959a092a7608b$var$ok = $e09959a092a7608b$var$ua.ReactCurrentOwner, $e09959a092a7608b$var$pk = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$K = 0, $e09959a092a7608b$var$R = null, $e09959a092a7608b$var$Y = null, $e09959a092a7608b$var$Z = 0, $e09959a092a7608b$var$gj = 0, $e09959a092a7608b$var$fj = $e09959a092a7608b$var$Uf(0), $e09959a092a7608b$var$T = 0, $e09959a092a7608b$var$qk = null, $e09959a092a7608b$var$hh = 0, $e09959a092a7608b$var$rk = 0, $e09959a092a7608b$var$sk = 0, $e09959a092a7608b$var$tk = null, $e09959a092a7608b$var$uk = null, $e09959a092a7608b$var$gk = 0, $e09959a092a7608b$var$Hj = Infinity, $e09959a092a7608b$var$vk = null, $e09959a092a7608b$var$Pi = !1, $e09959a092a7608b$var$Qi = null, $e09959a092a7608b$var$Si = null, $e09959a092a7608b$var$wk = !1, $e09959a092a7608b$var$xk = null, $e09959a092a7608b$var$yk = 0, $e09959a092a7608b$var$zk = 0, $e09959a092a7608b$var$Ak = null, $e09959a092a7608b$var$Bk = -1, $e09959a092a7608b$var$Ck = 0;
function $e09959a092a7608b$var$L() {
    return 0 !== ($e09959a092a7608b$var$K & 6) ? $e09959a092a7608b$var$B() : -1 !== $e09959a092a7608b$var$Bk ? $e09959a092a7608b$var$Bk : $e09959a092a7608b$var$Bk = $e09959a092a7608b$var$B();
}
function $e09959a092a7608b$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e09959a092a7608b$var$K & 2) && 0 !== $e09959a092a7608b$var$Z) return $e09959a092a7608b$var$Z & -$e09959a092a7608b$var$Z;
    if (null !== $e09959a092a7608b$var$Kg.transition) return 0 === $e09959a092a7608b$var$Ck && ($e09959a092a7608b$var$Ck = $e09959a092a7608b$var$yc()), $e09959a092a7608b$var$Ck;
    a = $e09959a092a7608b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e09959a092a7608b$var$jd(a.type);
    return a;
}
function $e09959a092a7608b$var$mh(a, b, c, d) {
    if (50 < $e09959a092a7608b$var$zk) throw $e09959a092a7608b$var$zk = 0, $e09959a092a7608b$var$Ak = null, Error($e09959a092a7608b$var$p(185));
    $e09959a092a7608b$var$Ac(a, c, d);
    if (0 === ($e09959a092a7608b$var$K & 2) || a !== $e09959a092a7608b$var$R) a === $e09959a092a7608b$var$R && (0 === ($e09959a092a7608b$var$K & 2) && ($e09959a092a7608b$var$rk |= c), 4 === $e09959a092a7608b$var$T && $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$Z)), $e09959a092a7608b$var$Ek(a, d), 1 === c && 0 === $e09959a092a7608b$var$K && 0 === (b.mode & 1) && ($e09959a092a7608b$var$Hj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$fg && $e09959a092a7608b$var$jg());
}
function $e09959a092a7608b$var$Ek(a, b) {
    var c = a.callbackNode;
    $e09959a092a7608b$var$wc(a, b);
    var d = $e09959a092a7608b$var$uc(a, a === $e09959a092a7608b$var$R ? $e09959a092a7608b$var$Z : 0);
    if (0 === d) null !== c && $e09959a092a7608b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e09959a092a7608b$var$bc(c);
        if (1 === b) 0 === a.tag ? $e09959a092a7608b$var$ig($e09959a092a7608b$var$Fk.bind(null, a)) : $e09959a092a7608b$var$hg($e09959a092a7608b$var$Fk.bind(null, a)), $e09959a092a7608b$var$Jf(function() {
            0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$jg();
        }), c = null;
        else {
            switch($e09959a092a7608b$var$Dc(d)){
                case 1:
                    c = $e09959a092a7608b$var$fc;
                    break;
                case 4:
                    c = $e09959a092a7608b$var$gc;
                    break;
                case 16:
                    c = $e09959a092a7608b$var$hc;
                    break;
                case 536870912:
                    c = $e09959a092a7608b$var$jc;
                    break;
                default:
                    c = $e09959a092a7608b$var$hc;
            }
            c = $e09959a092a7608b$var$Gk(c, $e09959a092a7608b$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e09959a092a7608b$var$Hk(a, b) {
    $e09959a092a7608b$var$Bk = -1;
    $e09959a092a7608b$var$Ck = 0;
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    var c = a.callbackNode;
    if ($e09959a092a7608b$var$Ik() && a.callbackNode !== c) return null;
    var d = $e09959a092a7608b$var$uc(a, a === $e09959a092a7608b$var$R ? $e09959a092a7608b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e09959a092a7608b$var$Jk(a, d);
    else {
        b = d;
        var e = $e09959a092a7608b$var$K;
        $e09959a092a7608b$var$K |= 2;
        var f = $e09959a092a7608b$var$Kk();
        if ($e09959a092a7608b$var$R !== a || $e09959a092a7608b$var$Z !== b) $e09959a092a7608b$var$vk = null, $e09959a092a7608b$var$Hj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$Lk(a, b);
        for(;;)try {
            $e09959a092a7608b$var$Mk();
            break;
        } catch (h) {
            $e09959a092a7608b$var$Nk(a, h);
        }
        $e09959a092a7608b$var$Qg();
        $e09959a092a7608b$var$nk.current = f;
        $e09959a092a7608b$var$K = e;
        null !== $e09959a092a7608b$var$Y ? b = 0 : ($e09959a092a7608b$var$R = null, $e09959a092a7608b$var$Z = 0, b = $e09959a092a7608b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e09959a092a7608b$var$xc(a), 0 !== e && (d = e, b = $e09959a092a7608b$var$Ok(a, e)));
        if (1 === b) throw c = $e09959a092a7608b$var$qk, $e09959a092a7608b$var$Lk(a, 0), $e09959a092a7608b$var$Dk(a, d), $e09959a092a7608b$var$Ek(a, $e09959a092a7608b$var$B()), c;
        if (6 === b) $e09959a092a7608b$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e09959a092a7608b$var$Pk(e) && (b = $e09959a092a7608b$var$Jk(a, d), 2 === b && (f = $e09959a092a7608b$var$xc(a), 0 !== f && (d = f, b = $e09959a092a7608b$var$Ok(a, f))), 1 === b)) throw c = $e09959a092a7608b$var$qk, $e09959a092a7608b$var$Lk(a, 0), $e09959a092a7608b$var$Dk(a, d), $e09959a092a7608b$var$Ek(a, $e09959a092a7608b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e09959a092a7608b$var$p(345));
                case 2:
                    $e09959a092a7608b$var$Qk(a, $e09959a092a7608b$var$uk, $e09959a092a7608b$var$vk);
                    break;
                case 3:
                    $e09959a092a7608b$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e09959a092a7608b$var$gk + 500 - $e09959a092a7608b$var$B(), 10 < b)) {
                        if (0 !== $e09959a092a7608b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e09959a092a7608b$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e09959a092a7608b$var$Ff($e09959a092a7608b$var$Qk.bind(null, a, $e09959a092a7608b$var$uk, $e09959a092a7608b$var$vk), b);
                        break;
                    }
                    $e09959a092a7608b$var$Qk(a, $e09959a092a7608b$var$uk, $e09959a092a7608b$var$vk);
                    break;
                case 4:
                    $e09959a092a7608b$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e09959a092a7608b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e09959a092a7608b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e09959a092a7608b$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e09959a092a7608b$var$Ff($e09959a092a7608b$var$Qk.bind(null, a, $e09959a092a7608b$var$uk, $e09959a092a7608b$var$vk), d);
                        break;
                    }
                    $e09959a092a7608b$var$Qk(a, $e09959a092a7608b$var$uk, $e09959a092a7608b$var$vk);
                    break;
                case 5:
                    $e09959a092a7608b$var$Qk(a, $e09959a092a7608b$var$uk, $e09959a092a7608b$var$vk);
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(329));
            }
        }
    }
    $e09959a092a7608b$var$Ek(a, $e09959a092a7608b$var$B());
    return a.callbackNode === c ? $e09959a092a7608b$var$Hk.bind(null, a) : null;
}
function $e09959a092a7608b$var$Ok(a, b) {
    var c = $e09959a092a7608b$var$tk;
    a.current.memoizedState.isDehydrated && ($e09959a092a7608b$var$Lk(a, b).flags |= 256);
    a = $e09959a092a7608b$var$Jk(a, b);
    2 !== a && (b = $e09959a092a7608b$var$uk, $e09959a092a7608b$var$uk = c, null !== b && $e09959a092a7608b$var$Gj(b));
    return a;
}
function $e09959a092a7608b$var$Gj(a) {
    null === $e09959a092a7608b$var$uk ? $e09959a092a7608b$var$uk = a : $e09959a092a7608b$var$uk.push.apply($e09959a092a7608b$var$uk, a);
}
function $e09959a092a7608b$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e09959a092a7608b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e09959a092a7608b$var$Dk(a, b) {
    b &= ~$e09959a092a7608b$var$sk;
    b &= ~$e09959a092a7608b$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e09959a092a7608b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e09959a092a7608b$var$Fk(a) {
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    $e09959a092a7608b$var$Ik();
    var b = $e09959a092a7608b$var$uc(a, 0);
    if (0 === (b & 1)) return $e09959a092a7608b$var$Ek(a, $e09959a092a7608b$var$B()), null;
    var c = $e09959a092a7608b$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e09959a092a7608b$var$xc(a);
        0 !== d && (b = d, c = $e09959a092a7608b$var$Ok(a, d));
    }
    if (1 === c) throw c = $e09959a092a7608b$var$qk, $e09959a092a7608b$var$Lk(a, 0), $e09959a092a7608b$var$Dk(a, b), $e09959a092a7608b$var$Ek(a, $e09959a092a7608b$var$B()), c;
    if (6 === c) throw Error($e09959a092a7608b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e09959a092a7608b$var$Qk(a, $e09959a092a7608b$var$uk, $e09959a092a7608b$var$vk);
    $e09959a092a7608b$var$Ek(a, $e09959a092a7608b$var$B());
    return null;
}
function $e09959a092a7608b$var$Rk(a, b) {
    var c = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e09959a092a7608b$var$K = c, 0 === $e09959a092a7608b$var$K && ($e09959a092a7608b$var$Hj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$fg && $e09959a092a7608b$var$jg());
    }
}
function $e09959a092a7608b$var$Sk(a) {
    null !== $e09959a092a7608b$var$xk && 0 === $e09959a092a7608b$var$xk.tag && 0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$Ik();
    var b = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 1;
    var c = $e09959a092a7608b$var$pk.transition, d = $e09959a092a7608b$var$C;
    try {
        if ($e09959a092a7608b$var$pk.transition = null, $e09959a092a7608b$var$C = 1, a) return a();
    } finally{
        $e09959a092a7608b$var$C = d, $e09959a092a7608b$var$pk.transition = c, $e09959a092a7608b$var$K = b, 0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$jg();
    }
}
function $e09959a092a7608b$var$Ij() {
    $e09959a092a7608b$var$gj = $e09959a092a7608b$var$fj.current;
    $e09959a092a7608b$var$E($e09959a092a7608b$var$fj);
}
function $e09959a092a7608b$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e09959a092a7608b$var$Gf(c));
    if (null !== $e09959a092a7608b$var$Y) for(c = $e09959a092a7608b$var$Y.return; null !== c;){
        var d = c;
        $e09959a092a7608b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e09959a092a7608b$var$$f();
                break;
            case 3:
                $e09959a092a7608b$var$Jh();
                $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
                $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
                $e09959a092a7608b$var$Oh();
                break;
            case 5:
                $e09959a092a7608b$var$Lh(d);
                break;
            case 4:
                $e09959a092a7608b$var$Jh();
                break;
            case 13:
                $e09959a092a7608b$var$E($e09959a092a7608b$var$M);
                break;
            case 19:
                $e09959a092a7608b$var$E($e09959a092a7608b$var$M);
                break;
            case 10:
                $e09959a092a7608b$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e09959a092a7608b$var$Ij();
        }
        c = c.return;
    }
    $e09959a092a7608b$var$R = a;
    $e09959a092a7608b$var$Y = a = $e09959a092a7608b$var$wh(a.current, null);
    $e09959a092a7608b$var$Z = $e09959a092a7608b$var$gj = b;
    $e09959a092a7608b$var$T = 0;
    $e09959a092a7608b$var$qk = null;
    $e09959a092a7608b$var$sk = $e09959a092a7608b$var$rk = $e09959a092a7608b$var$hh = 0;
    $e09959a092a7608b$var$uk = $e09959a092a7608b$var$tk = null;
    if (null !== $e09959a092a7608b$var$Wg) {
        for(b = 0; b < $e09959a092a7608b$var$Wg.length; b++)if (c = $e09959a092a7608b$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e09959a092a7608b$var$Wg = null;
    }
    return a;
}
function $e09959a092a7608b$var$Nk(a, b) {
    do {
        var c = $e09959a092a7608b$var$Y;
        try {
            $e09959a092a7608b$var$Qg();
            $e09959a092a7608b$var$Ph.current = $e09959a092a7608b$var$ai;
            if ($e09959a092a7608b$var$Sh) {
                for(var d = $e09959a092a7608b$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e09959a092a7608b$var$Sh = !1;
            }
            $e09959a092a7608b$var$Rh = 0;
            $e09959a092a7608b$var$P = $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = null;
            $e09959a092a7608b$var$Th = !1;
            $e09959a092a7608b$var$Uh = 0;
            $e09959a092a7608b$var$ok.current = null;
            if (null === c || null === c.return) {
                $e09959a092a7608b$var$T = 1;
                $e09959a092a7608b$var$qk = b;
                $e09959a092a7608b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e09959a092a7608b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e09959a092a7608b$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e09959a092a7608b$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e09959a092a7608b$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e09959a092a7608b$var$Ti(f, l, b);
                            $e09959a092a7608b$var$uj();
                            break a;
                        }
                        k = Error($e09959a092a7608b$var$p(426));
                    }
                } else if ($e09959a092a7608b$var$I && h.mode & 1) {
                    var J = $e09959a092a7608b$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e09959a092a7608b$var$Wi(J, g, h, f, b);
                        $e09959a092a7608b$var$Jg($e09959a092a7608b$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e09959a092a7608b$var$Ki(k, h);
                4 !== $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 2);
                null === $e09959a092a7608b$var$tk ? $e09959a092a7608b$var$tk = [
                    f
                ] : $e09959a092a7608b$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e09959a092a7608b$var$Oi(f, k, b);
                            $e09959a092a7608b$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e09959a092a7608b$var$Si || !$e09959a092a7608b$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e09959a092a7608b$var$Ri(f, h, b);
                                $e09959a092a7608b$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e09959a092a7608b$var$Tk(c);
        } catch (na) {
            b = na;
            $e09959a092a7608b$var$Y === c && null !== c && ($e09959a092a7608b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e09959a092a7608b$var$Kk() {
    var a = $e09959a092a7608b$var$nk.current;
    $e09959a092a7608b$var$nk.current = $e09959a092a7608b$var$ai;
    return null === a ? $e09959a092a7608b$var$ai : a;
}
function $e09959a092a7608b$var$uj() {
    if (0 === $e09959a092a7608b$var$T || 3 === $e09959a092a7608b$var$T || 2 === $e09959a092a7608b$var$T) $e09959a092a7608b$var$T = 4;
    null === $e09959a092a7608b$var$R || 0 === ($e09959a092a7608b$var$hh & 268435455) && 0 === ($e09959a092a7608b$var$rk & 268435455) || $e09959a092a7608b$var$Dk($e09959a092a7608b$var$R, $e09959a092a7608b$var$Z);
}
function $e09959a092a7608b$var$Jk(a, b) {
    var c = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 2;
    var d = $e09959a092a7608b$var$Kk();
    if ($e09959a092a7608b$var$R !== a || $e09959a092a7608b$var$Z !== b) $e09959a092a7608b$var$vk = null, $e09959a092a7608b$var$Lk(a, b);
    for(;;)try {
        $e09959a092a7608b$var$Uk();
        break;
    } catch (e) {
        $e09959a092a7608b$var$Nk(a, e);
    }
    $e09959a092a7608b$var$Qg();
    $e09959a092a7608b$var$K = c;
    $e09959a092a7608b$var$nk.current = d;
    if (null !== $e09959a092a7608b$var$Y) throw Error($e09959a092a7608b$var$p(261));
    $e09959a092a7608b$var$R = null;
    $e09959a092a7608b$var$Z = 0;
    return $e09959a092a7608b$var$T;
}
function $e09959a092a7608b$var$Uk() {
    for(; null !== $e09959a092a7608b$var$Y;)$e09959a092a7608b$var$Vk($e09959a092a7608b$var$Y);
}
function $e09959a092a7608b$var$Mk() {
    for(; null !== $e09959a092a7608b$var$Y && !$e09959a092a7608b$var$cc();)$e09959a092a7608b$var$Vk($e09959a092a7608b$var$Y);
}
function $e09959a092a7608b$var$Vk(a) {
    var b = $e09959a092a7608b$var$Wk(a.alternate, a, $e09959a092a7608b$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e09959a092a7608b$var$Tk(a) : $e09959a092a7608b$var$Y = b;
    $e09959a092a7608b$var$ok.current = null;
}
function $e09959a092a7608b$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e09959a092a7608b$var$Fj(c, b, $e09959a092a7608b$var$gj), null !== c) {
                $e09959a092a7608b$var$Y = c;
                return;
            }
        } else {
            c = $e09959a092a7608b$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e09959a092a7608b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e09959a092a7608b$var$T = 6;
                $e09959a092a7608b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e09959a092a7608b$var$Y = b;
            return;
        }
        $e09959a092a7608b$var$Y = b = a;
    }while (null !== b);
    0 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 5);
}
function $e09959a092a7608b$var$Qk(a, b, c) {
    var d = $e09959a092a7608b$var$C, e = $e09959a092a7608b$var$pk.transition;
    try {
        $e09959a092a7608b$var$pk.transition = null, $e09959a092a7608b$var$C = 1, $e09959a092a7608b$var$Xk(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$pk.transition = e, $e09959a092a7608b$var$C = d;
    }
    return null;
}
function $e09959a092a7608b$var$Xk(a, b, c, d) {
    do $e09959a092a7608b$var$Ik();
    while (null !== $e09959a092a7608b$var$xk);
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e09959a092a7608b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e09959a092a7608b$var$Bc(a, f);
    a === $e09959a092a7608b$var$R && ($e09959a092a7608b$var$Y = $e09959a092a7608b$var$R = null, $e09959a092a7608b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e09959a092a7608b$var$wk || ($e09959a092a7608b$var$wk = !0, $e09959a092a7608b$var$Gk($e09959a092a7608b$var$hc, function() {
        $e09959a092a7608b$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e09959a092a7608b$var$pk.transition;
        $e09959a092a7608b$var$pk.transition = null;
        var g = $e09959a092a7608b$var$C;
        $e09959a092a7608b$var$C = 1;
        var h = $e09959a092a7608b$var$K;
        $e09959a092a7608b$var$K |= 4;
        $e09959a092a7608b$var$ok.current = null;
        $e09959a092a7608b$var$Pj(a, c);
        $e09959a092a7608b$var$ek(c, a);
        $e09959a092a7608b$var$Oe($e09959a092a7608b$var$Df);
        $e09959a092a7608b$var$dd = !!$e09959a092a7608b$var$Cf;
        $e09959a092a7608b$var$Df = $e09959a092a7608b$var$Cf = null;
        a.current = c;
        $e09959a092a7608b$var$ik(c, a, e);
        $e09959a092a7608b$var$dc();
        $e09959a092a7608b$var$K = h;
        $e09959a092a7608b$var$C = g;
        $e09959a092a7608b$var$pk.transition = f;
    } else a.current = c;
    $e09959a092a7608b$var$wk && ($e09959a092a7608b$var$wk = !1, $e09959a092a7608b$var$xk = a, $e09959a092a7608b$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e09959a092a7608b$var$Si = null);
    $e09959a092a7608b$var$mc(c.stateNode, d);
    $e09959a092a7608b$var$Ek(a, $e09959a092a7608b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e09959a092a7608b$var$Pi) throw $e09959a092a7608b$var$Pi = !1, a = $e09959a092a7608b$var$Qi, $e09959a092a7608b$var$Qi = null, a;
    0 !== ($e09959a092a7608b$var$yk & 1) && 0 !== a.tag && $e09959a092a7608b$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e09959a092a7608b$var$Ak ? $e09959a092a7608b$var$zk++ : ($e09959a092a7608b$var$zk = 0, $e09959a092a7608b$var$Ak = a) : $e09959a092a7608b$var$zk = 0;
    $e09959a092a7608b$var$jg();
    return null;
}
function $e09959a092a7608b$var$Ik() {
    if (null !== $e09959a092a7608b$var$xk) {
        var a = $e09959a092a7608b$var$Dc($e09959a092a7608b$var$yk), b = $e09959a092a7608b$var$pk.transition, c = $e09959a092a7608b$var$C;
        try {
            $e09959a092a7608b$var$pk.transition = null;
            $e09959a092a7608b$var$C = 16 > a ? 16 : a;
            if (null === $e09959a092a7608b$var$xk) var d = !1;
            else {
                a = $e09959a092a7608b$var$xk;
                $e09959a092a7608b$var$xk = null;
                $e09959a092a7608b$var$yk = 0;
                if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(331));
                var e = $e09959a092a7608b$var$K;
                $e09959a092a7608b$var$K |= 4;
                for($e09959a092a7608b$var$V = a.current; null !== $e09959a092a7608b$var$V;){
                    var f = $e09959a092a7608b$var$V, g = f.child;
                    if (0 !== ($e09959a092a7608b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e09959a092a7608b$var$V = l; null !== $e09959a092a7608b$var$V;){
                                    var m = $e09959a092a7608b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e09959a092a7608b$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e09959a092a7608b$var$V = q;
                                    else for(; null !== $e09959a092a7608b$var$V;){
                                        m = $e09959a092a7608b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e09959a092a7608b$var$Tj(m);
                                        if (m === l) {
                                            $e09959a092a7608b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e09959a092a7608b$var$V = r;
                                            break;
                                        }
                                        $e09959a092a7608b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e09959a092a7608b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e09959a092a7608b$var$V = g;
                    else b: for(; null !== $e09959a092a7608b$var$V;){
                        f = $e09959a092a7608b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e09959a092a7608b$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e09959a092a7608b$var$V = x;
                            break b;
                        }
                        $e09959a092a7608b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e09959a092a7608b$var$V = w; null !== $e09959a092a7608b$var$V;){
                    g = $e09959a092a7608b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e09959a092a7608b$var$V = u;
                    else b: for(g = w; null !== $e09959a092a7608b$var$V;){
                        h = $e09959a092a7608b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e09959a092a7608b$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e09959a092a7608b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e09959a092a7608b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e09959a092a7608b$var$V = F;
                            break b;
                        }
                        $e09959a092a7608b$var$V = h.return;
                    }
                }
                $e09959a092a7608b$var$K = e;
                $e09959a092a7608b$var$jg();
                if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onPostCommitFiberRoot) try {
                    $e09959a092a7608b$var$lc.onPostCommitFiberRoot($e09959a092a7608b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e09959a092a7608b$var$C = c, $e09959a092a7608b$var$pk.transition = b;
        }
    }
    return !1;
}
function $e09959a092a7608b$var$Yk(a, b, c) {
    b = $e09959a092a7608b$var$Ki(c, b);
    b = $e09959a092a7608b$var$Oi(a, b, 1);
    a = $e09959a092a7608b$var$dh(a, b, 1);
    b = $e09959a092a7608b$var$L();
    null !== a && ($e09959a092a7608b$var$Ac(a, 1, b), $e09959a092a7608b$var$Ek(a, b));
}
function $e09959a092a7608b$var$W(a, b, c) {
    if (3 === a.tag) $e09959a092a7608b$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e09959a092a7608b$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e09959a092a7608b$var$Si || !$e09959a092a7608b$var$Si.has(d))) {
                a = $e09959a092a7608b$var$Ki(c, a);
                a = $e09959a092a7608b$var$Ri(b, a, 1);
                b = $e09959a092a7608b$var$dh(b, a, 1);
                a = $e09959a092a7608b$var$L();
                null !== b && ($e09959a092a7608b$var$Ac(b, 1, a), $e09959a092a7608b$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e09959a092a7608b$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e09959a092a7608b$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e09959a092a7608b$var$R === a && ($e09959a092a7608b$var$Z & c) === c && (4 === $e09959a092a7608b$var$T || 3 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$Z & 130023424) === $e09959a092a7608b$var$Z && 500 > $e09959a092a7608b$var$B() - $e09959a092a7608b$var$gk ? $e09959a092a7608b$var$Lk(a, 0) : $e09959a092a7608b$var$sk |= c);
    $e09959a092a7608b$var$Ek(a, b);
}
function $e09959a092a7608b$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e09959a092a7608b$var$sc, $e09959a092a7608b$var$sc <<= 1, 0 === ($e09959a092a7608b$var$sc & 130023424) && ($e09959a092a7608b$var$sc = 4194304)));
    var c = $e09959a092a7608b$var$L();
    a = $e09959a092a7608b$var$Zg(a, b);
    null !== a && ($e09959a092a7608b$var$Ac(a, b, c), $e09959a092a7608b$var$Ek(a, c));
}
function $e09959a092a7608b$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e09959a092a7608b$var$Zk(a, c);
}
function $e09959a092a7608b$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e09959a092a7608b$var$p(314));
    }
    null !== d && d.delete(b);
    $e09959a092a7608b$var$Zk(a, c);
}
var $e09959a092a7608b$var$Wk;
$e09959a092a7608b$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e09959a092a7608b$var$Wf.current) $e09959a092a7608b$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e09959a092a7608b$var$Ug = !1, $e09959a092a7608b$var$zj(a, b, c);
            $e09959a092a7608b$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e09959a092a7608b$var$Ug = !1, $e09959a092a7608b$var$I && 0 !== (b.flags & 1048576) && $e09959a092a7608b$var$ug(b, $e09959a092a7608b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e09959a092a7608b$var$jj(a, b);
            a = b.pendingProps;
            var e = $e09959a092a7608b$var$Yf(b, $e09959a092a7608b$var$H.current);
            $e09959a092a7608b$var$Tg(b, c);
            e = $e09959a092a7608b$var$Xh(null, b, d, a, e, c);
            var f = $e09959a092a7608b$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e09959a092a7608b$var$Zf(d) ? (f = !0, $e09959a092a7608b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e09959a092a7608b$var$ah(b), e.updater = $e09959a092a7608b$var$nh, b.stateNode = e, e._reactInternals = b, $e09959a092a7608b$var$rh(b, d, a, c), b = $e09959a092a7608b$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e09959a092a7608b$var$I && f && $e09959a092a7608b$var$vg(b), $e09959a092a7608b$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e09959a092a7608b$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e09959a092a7608b$var$$k(d);
                a = $e09959a092a7608b$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e09959a092a7608b$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e09959a092a7608b$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e09959a092a7608b$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e09959a092a7608b$var$aj(null, b, d, $e09959a092a7608b$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e09959a092a7608b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Lg(d, e), $e09959a092a7608b$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Lg(d, e), $e09959a092a7608b$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e09959a092a7608b$var$lj(b);
                if (null === a) throw Error($e09959a092a7608b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e09959a092a7608b$var$bh(a, b);
                $e09959a092a7608b$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e09959a092a7608b$var$Ki(Error($e09959a092a7608b$var$p(423)), b);
                        b = $e09959a092a7608b$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e09959a092a7608b$var$Ki(Error($e09959a092a7608b$var$p(424)), b);
                        b = $e09959a092a7608b$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(b.stateNode.containerInfo.firstChild), $e09959a092a7608b$var$xg = b, $e09959a092a7608b$var$I = !0, $e09959a092a7608b$var$zg = null, c = $e09959a092a7608b$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e09959a092a7608b$var$Ig();
                    if (d === e) {
                        b = $e09959a092a7608b$var$$i(a, b, c);
                        break a;
                    }
                    $e09959a092a7608b$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e09959a092a7608b$var$Kh(b), null === a && $e09959a092a7608b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e09959a092a7608b$var$Ef(d, e) ? g = null : null !== f && $e09959a092a7608b$var$Ef(d, f) && (b.flags |= 32), $e09959a092a7608b$var$hj(a, b), $e09959a092a7608b$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e09959a092a7608b$var$Eg(b), null;
        case 13:
            return $e09959a092a7608b$var$pj(a, b, c);
        case 4:
            return $e09959a092a7608b$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e09959a092a7608b$var$Bh(b, null, d, c) : $e09959a092a7608b$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Lg(d, e), $e09959a092a7608b$var$Zi(a, b, d, e, c);
        case 7:
            return $e09959a092a7608b$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e09959a092a7608b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e09959a092a7608b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e09959a092a7608b$var$G($e09959a092a7608b$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e09959a092a7608b$var$He(f.value, g)) {
                        if (f.children === e.children && !$e09959a092a7608b$var$Wf.current) {
                            b = $e09959a092a7608b$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e09959a092a7608b$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e09959a092a7608b$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e09959a092a7608b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e09959a092a7608b$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e09959a092a7608b$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e09959a092a7608b$var$Tg(b, c), e = $e09959a092a7608b$var$Vg(e), d = d(e), b.flags |= 1, $e09959a092a7608b$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e09959a092a7608b$var$Lg(d, b.pendingProps), e = $e09959a092a7608b$var$Lg(d.type, e), $e09959a092a7608b$var$aj(a, b, d, e, c);
        case 15:
            return $e09959a092a7608b$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Lg(d, e), $e09959a092a7608b$var$jj(a, b), b.tag = 1, $e09959a092a7608b$var$Zf(d) ? (a = !0, $e09959a092a7608b$var$cg(b)) : a = !1, $e09959a092a7608b$var$Tg(b, c), $e09959a092a7608b$var$ph(b, d, e), $e09959a092a7608b$var$rh(b, d, e, c), $e09959a092a7608b$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e09959a092a7608b$var$yj(a, b, c);
        case 22:
            return $e09959a092a7608b$var$ej(a, b, c);
    }
    throw Error($e09959a092a7608b$var$p(156, b.tag));
};
function $e09959a092a7608b$var$Gk(a, b) {
    return $e09959a092a7608b$var$ac(a, b);
}
function $e09959a092a7608b$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e09959a092a7608b$var$Bg(a, b, c, d) {
    return new $e09959a092a7608b$var$al(a, b, c, d);
}
function $e09959a092a7608b$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e09959a092a7608b$var$$k(a) {
    if ("function" === typeof a) return $e09959a092a7608b$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e09959a092a7608b$var$Da) return 11;
        if (a === $e09959a092a7608b$var$Ga) return 14;
    }
    return 2;
}
function $e09959a092a7608b$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e09959a092a7608b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e09959a092a7608b$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e09959a092a7608b$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e09959a092a7608b$var$ya:
            return $e09959a092a7608b$var$Ah(c.children, e, f, b);
        case $e09959a092a7608b$var$za:
            g = 8;
            e |= 8;
            break;
        case $e09959a092a7608b$var$Aa:
            return a = $e09959a092a7608b$var$Bg(12, c, b, e | 2), a.elementType = $e09959a092a7608b$var$Aa, a.lanes = f, a;
        case $e09959a092a7608b$var$Ea:
            return a = $e09959a092a7608b$var$Bg(13, c, b, e), a.elementType = $e09959a092a7608b$var$Ea, a.lanes = f, a;
        case $e09959a092a7608b$var$Fa:
            return a = $e09959a092a7608b$var$Bg(19, c, b, e), a.elementType = $e09959a092a7608b$var$Fa, a.lanes = f, a;
        case $e09959a092a7608b$var$Ia:
            return $e09959a092a7608b$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e09959a092a7608b$var$Ba:
                    g = 10;
                    break a;
                case $e09959a092a7608b$var$Ca:
                    g = 9;
                    break a;
                case $e09959a092a7608b$var$Da:
                    g = 11;
                    break a;
                case $e09959a092a7608b$var$Ga:
                    g = 14;
                    break a;
                case $e09959a092a7608b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e09959a092a7608b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e09959a092a7608b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e09959a092a7608b$var$Ah(a, b, c, d) {
    a = $e09959a092a7608b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e09959a092a7608b$var$qj(a, b, c, d) {
    a = $e09959a092a7608b$var$Bg(22, a, d, b);
    a.elementType = $e09959a092a7608b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e09959a092a7608b$var$xh(a, b, c) {
    a = $e09959a092a7608b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e09959a092a7608b$var$zh(a, b, c) {
    b = $e09959a092a7608b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e09959a092a7608b$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e09959a092a7608b$var$zc(0);
    this.expirationTimes = $e09959a092a7608b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e09959a092a7608b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e09959a092a7608b$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e09959a092a7608b$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e09959a092a7608b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e09959a092a7608b$var$ah(f);
    return a;
}
function $e09959a092a7608b$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e09959a092a7608b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e09959a092a7608b$var$el(a) {
    if (!a) return $e09959a092a7608b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e09959a092a7608b$var$Vb(a) !== a || 1 !== a.tag) throw Error($e09959a092a7608b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e09959a092a7608b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e09959a092a7608b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e09959a092a7608b$var$Zf(c)) return $e09959a092a7608b$var$bg(a, c, b);
    }
    return b;
}
function $e09959a092a7608b$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e09959a092a7608b$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e09959a092a7608b$var$el(null);
    c = a.current;
    d = $e09959a092a7608b$var$L();
    e = $e09959a092a7608b$var$lh(c);
    f = $e09959a092a7608b$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e09959a092a7608b$var$dh(c, f, e);
    a.current.lanes = e;
    $e09959a092a7608b$var$Ac(a, e, d);
    $e09959a092a7608b$var$Ek(a, d);
    return a;
}
function $e09959a092a7608b$var$gl(a, b, c, d) {
    var e = b.current, f = $e09959a092a7608b$var$L(), g = $e09959a092a7608b$var$lh(e);
    c = $e09959a092a7608b$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e09959a092a7608b$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e09959a092a7608b$var$dh(e, b, g);
    null !== a && ($e09959a092a7608b$var$mh(a, e, g, f), $e09959a092a7608b$var$eh(a, e, g));
    return g;
}
function $e09959a092a7608b$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e09959a092a7608b$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e09959a092a7608b$var$jl(a, b) {
    $e09959a092a7608b$var$il(a, b);
    (a = a.alternate) && $e09959a092a7608b$var$il(a, b);
}
function $e09959a092a7608b$var$kl() {
    return null;
}
var $e09959a092a7608b$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e09959a092a7608b$var$ml(a) {
    this._internalRoot = a;
}
$e09959a092a7608b$var$nl.prototype.render = $e09959a092a7608b$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e09959a092a7608b$var$p(409));
    $e09959a092a7608b$var$gl(a, b, null, null);
};
$e09959a092a7608b$var$nl.prototype.unmount = $e09959a092a7608b$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e09959a092a7608b$var$Sk(function() {
            $e09959a092a7608b$var$gl(null, a, null, null);
        });
        b[$e09959a092a7608b$var$uf] = null;
    }
};
function $e09959a092a7608b$var$nl(a) {
    this._internalRoot = a;
}
$e09959a092a7608b$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e09959a092a7608b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e09959a092a7608b$var$Qc.length && 0 !== b && b < $e09959a092a7608b$var$Qc[c].priority; c++);
        $e09959a092a7608b$var$Qc.splice(c, 0, a);
        0 === c && $e09959a092a7608b$var$Vc(a);
    }
};
function $e09959a092a7608b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e09959a092a7608b$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e09959a092a7608b$var$ql() {}
function $e09959a092a7608b$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e09959a092a7608b$var$hl(g);
                f.call(a);
            };
        }
        var g = $e09959a092a7608b$var$fl(b, d, a, 0, null, !1, !1, "", $e09959a092a7608b$var$ql);
        a._reactRootContainer = g;
        a[$e09959a092a7608b$var$uf] = g.current;
        $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e09959a092a7608b$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e09959a092a7608b$var$hl(k);
            h.call(a);
        };
    }
    var k = $e09959a092a7608b$var$cl(a, 0, !1, null, null, !1, !1, "", $e09959a092a7608b$var$ql);
    a._reactRootContainer = k;
    a[$e09959a092a7608b$var$uf] = k.current;
    $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e09959a092a7608b$var$Sk(function() {
        $e09959a092a7608b$var$gl(b, k, c, d);
    });
    return k;
}
function $e09959a092a7608b$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e09959a092a7608b$var$hl(g);
                h.call(a);
            };
        }
        $e09959a092a7608b$var$gl(b, g, a, e);
    } else g = $e09959a092a7608b$var$rl(c, b, a, e, d);
    return $e09959a092a7608b$var$hl(g);
}
$e09959a092a7608b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e09959a092a7608b$var$tc(b.pendingLanes);
                0 !== c && ($e09959a092a7608b$var$Cc(b, c | 1), $e09959a092a7608b$var$Ek(b, $e09959a092a7608b$var$B()), 0 === ($e09959a092a7608b$var$K & 6) && ($e09959a092a7608b$var$Hj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$jg()));
            }
            break;
        case 13:
            $e09959a092a7608b$var$Sk(function() {
                var b = $e09959a092a7608b$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e09959a092a7608b$var$L();
                    $e09959a092a7608b$var$mh(b, a, 1, c);
                }
            }), $e09959a092a7608b$var$jl(a, 1);
    }
};
$e09959a092a7608b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e09959a092a7608b$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e09959a092a7608b$var$L();
            $e09959a092a7608b$var$mh(b, a, 134217728, c);
        }
        $e09959a092a7608b$var$jl(a, 134217728);
    }
};
$e09959a092a7608b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e09959a092a7608b$var$lh(a), c = $e09959a092a7608b$var$Zg(a, b);
        if (null !== c) {
            var d = $e09959a092a7608b$var$L();
            $e09959a092a7608b$var$mh(c, a, b, d);
        }
        $e09959a092a7608b$var$jl(a, b);
    }
};
$e09959a092a7608b$var$Hc = function() {
    return $e09959a092a7608b$var$C;
};
$e09959a092a7608b$var$Ic = function(a, b) {
    var c = $e09959a092a7608b$var$C;
    try {
        return $e09959a092a7608b$var$C = a, b();
    } finally{
        $e09959a092a7608b$var$C = c;
    }
};
$e09959a092a7608b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e09959a092a7608b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e09959a092a7608b$var$Db(d);
                        if (!e) throw Error($e09959a092a7608b$var$p(90));
                        $e09959a092a7608b$var$Wa(d);
                        $e09959a092a7608b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e09959a092a7608b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e09959a092a7608b$var$fb(a, !!c.multiple, b, !1);
    }
};
$e09959a092a7608b$var$Gb = $e09959a092a7608b$var$Rk;
$e09959a092a7608b$var$Hb = $e09959a092a7608b$var$Sk;
var $e09959a092a7608b$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e09959a092a7608b$var$Cb,
        $e09959a092a7608b$var$ue,
        $e09959a092a7608b$var$Db,
        $e09959a092a7608b$var$Eb,
        $e09959a092a7608b$var$Fb,
        $e09959a092a7608b$var$Rk
    ]
}, $e09959a092a7608b$var$ul = {
    findFiberByHostInstance: $e09959a092a7608b$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e09959a092a7608b$var$vl = {
    bundleType: $e09959a092a7608b$var$ul.bundleType,
    version: $e09959a092a7608b$var$ul.version,
    rendererPackageName: $e09959a092a7608b$var$ul.rendererPackageName,
    rendererConfig: $e09959a092a7608b$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e09959a092a7608b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e09959a092a7608b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e09959a092a7608b$var$ul.findFiberByHostInstance || $e09959a092a7608b$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e09959a092a7608b$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e09959a092a7608b$var$wl.isDisabled && $e09959a092a7608b$var$wl.supportsFiber) try {
        $e09959a092a7608b$var$kc = $e09959a092a7608b$var$wl.inject($e09959a092a7608b$var$vl), $e09959a092a7608b$var$lc = $e09959a092a7608b$var$wl;
    } catch (a) {}
}
$e09959a092a7608b$export$ae55be85d98224ed = $e09959a092a7608b$var$tl;
$e09959a092a7608b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e09959a092a7608b$var$ol(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$dl(a, b, null, c);
};
$e09959a092a7608b$export$882461b6382ed46c = function(a, b) {
    if (!$e09959a092a7608b$var$ol(a)) throw Error($e09959a092a7608b$var$p(299));
    var c = !1, d = "", e = $e09959a092a7608b$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e09959a092a7608b$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e09959a092a7608b$var$uf] = b.current;
    $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e09959a092a7608b$var$ml(b);
};
$e09959a092a7608b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e09959a092a7608b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e09959a092a7608b$var$p(268, a));
    }
    a = $e09959a092a7608b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e09959a092a7608b$export$cd75ccfd720a3cd4 = function(a) {
    return $e09959a092a7608b$var$Sk(a);
};
$e09959a092a7608b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e09959a092a7608b$var$pl(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$sl(null, a, b, !0, c);
};
$e09959a092a7608b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e09959a092a7608b$var$ol(a)) throw Error($e09959a092a7608b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e09959a092a7608b$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e09959a092a7608b$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e09959a092a7608b$var$uf] = b.current;
    $e09959a092a7608b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e09959a092a7608b$var$nl(b);
};
$e09959a092a7608b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e09959a092a7608b$var$pl(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$sl(null, a, b, !1, c);
};
$e09959a092a7608b$export$502457920280e6be = function(a) {
    if (!$e09959a092a7608b$var$pl(a)) throw Error($e09959a092a7608b$var$p(40));
    return a._reactRootContainer ? ($e09959a092a7608b$var$Sk(function() {
        $e09959a092a7608b$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e09959a092a7608b$var$uf] = null;
        });
    }), !0) : !1;
};
$e09959a092a7608b$export$c78a37762a8d58e1 = $e09959a092a7608b$var$Rk;
$e09959a092a7608b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e09959a092a7608b$var$pl(c)) throw Error($e09959a092a7608b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e09959a092a7608b$var$p(38));
    return $e09959a092a7608b$var$sl(a, b, c, !1, d);
};
$e09959a092a7608b$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("7DCtq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fcjP7"));

});
parcelRegister("fcjP7", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $b1075a8380758f91$export$c4744153514ff05d, (v) => $b1075a8380758f91$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $b1075a8380758f91$export$3e506c1ccc9cc1a7, (v) => $b1075a8380758f91$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $b1075a8380758f91$export$e26fe2ed2fa76875, (v) => $b1075a8380758f91$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $b1075a8380758f91$export$502329bbf4b505b1, (v) => $b1075a8380758f91$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $b1075a8380758f91$export$6e3807111c4874c4, (v) => $b1075a8380758f91$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $b1075a8380758f91$export$c27134553091fb3a, (v) => $b1075a8380758f91$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $b1075a8380758f91$export$33ee1acdc04fd2a2, (v) => $b1075a8380758f91$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $b1075a8380758f91$export$b00a404bbd5edef2, (v) => $b1075a8380758f91$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $b1075a8380758f91$export$8352ce38b91d0c62, (v) => $b1075a8380758f91$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $b1075a8380758f91$export$d66a1c1c77bd778b, (v) => $b1075a8380758f91$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $b1075a8380758f91$export$d3dfb8e4810cb555, (v) => $b1075a8380758f91$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $b1075a8380758f91$export$839f9183b0465a69, (v) => $b1075a8380758f91$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $b1075a8380758f91$export$72fdf0e06517287b, (v) => $b1075a8380758f91$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $b1075a8380758f91$export$4b844e58a3e414b4, (v) => $b1075a8380758f91$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $b1075a8380758f91$export$816d2913ae6b83b1, (v) => $b1075a8380758f91$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $b1075a8380758f91$export$61bcfe829111a1d0, (v) => $b1075a8380758f91$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $b1075a8380758f91$export$7ee8c9beb337bc3f, (v) => $b1075a8380758f91$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $b1075a8380758f91$export$b5836b71941fa3ed, (v) => $b1075a8380758f91$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $b1075a8380758f91$export$cf845f2c119da08a, (v) => $b1075a8380758f91$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1075a8380758f91$export$c4744153514ff05d;
var $b1075a8380758f91$export$3e506c1ccc9cc1a7;
var $b1075a8380758f91$export$e26fe2ed2fa76875;
var $b1075a8380758f91$export$502329bbf4b505b1;
var $b1075a8380758f91$export$6e3807111c4874c4;
var $b1075a8380758f91$export$c27134553091fb3a;
var $b1075a8380758f91$export$33ee1acdc04fd2a2;
var $b1075a8380758f91$export$b00a404bbd5edef2;
var $b1075a8380758f91$export$8352ce38b91d0c62;
var $b1075a8380758f91$export$d66a1c1c77bd778b;
var $b1075a8380758f91$export$d3dfb8e4810cb555;
var $b1075a8380758f91$export$839f9183b0465a69;
var $b1075a8380758f91$export$72fdf0e06517287b;
var $b1075a8380758f91$export$4b844e58a3e414b4;
var $b1075a8380758f91$export$816d2913ae6b83b1;
var $b1075a8380758f91$export$61bcfe829111a1d0;
var $b1075a8380758f91$export$7ee8c9beb337bc3f;
var $b1075a8380758f91$export$b5836b71941fa3ed;
var $b1075a8380758f91$export$cf845f2c119da08a;
'use strict';
function $b1075a8380758f91$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b1075a8380758f91$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b1075a8380758f91$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b1075a8380758f91$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b1075a8380758f91$var$g(C, c)) n < e && 0 > $b1075a8380758f91$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b1075a8380758f91$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b1075a8380758f91$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b1075a8380758f91$var$l = performance;
    $b1075a8380758f91$export$c4744153514ff05d = function() {
        return $b1075a8380758f91$var$l.now();
    };
} else {
    var $b1075a8380758f91$var$p = Date, $b1075a8380758f91$var$q = $b1075a8380758f91$var$p.now();
    $b1075a8380758f91$export$c4744153514ff05d = function() {
        return $b1075a8380758f91$var$p.now() - $b1075a8380758f91$var$q;
    };
}
var $b1075a8380758f91$var$r = [], $b1075a8380758f91$var$t = [], $b1075a8380758f91$var$u = 1, $b1075a8380758f91$var$v = null, $b1075a8380758f91$var$y = 3, $b1075a8380758f91$var$z = !1, $b1075a8380758f91$var$A = !1, $b1075a8380758f91$var$B = !1, $b1075a8380758f91$var$D = "function" === typeof setTimeout ? setTimeout : null, $b1075a8380758f91$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b1075a8380758f91$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b1075a8380758f91$var$G(a) {
    for(var b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t); null !== b;){
        if (null === b.callback) $b1075a8380758f91$var$k($b1075a8380758f91$var$t);
        else if (b.startTime <= a) $b1075a8380758f91$var$k($b1075a8380758f91$var$t), b.sortIndex = b.expirationTime, $b1075a8380758f91$var$f($b1075a8380758f91$var$r, b);
        else break;
        b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
    }
}
function $b1075a8380758f91$var$H(a) {
    $b1075a8380758f91$var$B = !1;
    $b1075a8380758f91$var$G(a);
    if (!$b1075a8380758f91$var$A) {
        if (null !== $b1075a8380758f91$var$h($b1075a8380758f91$var$r)) $b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J);
        else {
            var b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
            null !== b && $b1075a8380758f91$var$K($b1075a8380758f91$var$H, b.startTime - a);
        }
    }
}
function $b1075a8380758f91$var$J(a, b) {
    $b1075a8380758f91$var$A = !1;
    $b1075a8380758f91$var$B && ($b1075a8380758f91$var$B = !1, $b1075a8380758f91$var$E($b1075a8380758f91$var$L), $b1075a8380758f91$var$L = -1);
    $b1075a8380758f91$var$z = !0;
    var c = $b1075a8380758f91$var$y;
    try {
        $b1075a8380758f91$var$G(b);
        for($b1075a8380758f91$var$v = $b1075a8380758f91$var$h($b1075a8380758f91$var$r); null !== $b1075a8380758f91$var$v && (!($b1075a8380758f91$var$v.expirationTime > b) || a && !$b1075a8380758f91$var$M());){
            var d = $b1075a8380758f91$var$v.callback;
            if ("function" === typeof d) {
                $b1075a8380758f91$var$v.callback = null;
                $b1075a8380758f91$var$y = $b1075a8380758f91$var$v.priorityLevel;
                var e = d($b1075a8380758f91$var$v.expirationTime <= b);
                b = $b1075a8380758f91$export$c4744153514ff05d();
                "function" === typeof e ? $b1075a8380758f91$var$v.callback = e : $b1075a8380758f91$var$v === $b1075a8380758f91$var$h($b1075a8380758f91$var$r) && $b1075a8380758f91$var$k($b1075a8380758f91$var$r);
                $b1075a8380758f91$var$G(b);
            } else $b1075a8380758f91$var$k($b1075a8380758f91$var$r);
            $b1075a8380758f91$var$v = $b1075a8380758f91$var$h($b1075a8380758f91$var$r);
        }
        if (null !== $b1075a8380758f91$var$v) var w = !0;
        else {
            var m = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
            null !== m && $b1075a8380758f91$var$K($b1075a8380758f91$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b1075a8380758f91$var$v = null, $b1075a8380758f91$var$y = c, $b1075a8380758f91$var$z = !1;
    }
}
var $b1075a8380758f91$var$N = !1, $b1075a8380758f91$var$O = null, $b1075a8380758f91$var$L = -1, $b1075a8380758f91$var$P = 5, $b1075a8380758f91$var$Q = -1;
function $b1075a8380758f91$var$M() {
    return $b1075a8380758f91$export$c4744153514ff05d() - $b1075a8380758f91$var$Q < $b1075a8380758f91$var$P ? !1 : !0;
}
function $b1075a8380758f91$var$R() {
    if (null !== $b1075a8380758f91$var$O) {
        var a = $b1075a8380758f91$export$c4744153514ff05d();
        $b1075a8380758f91$var$Q = a;
        var b = !0;
        try {
            b = $b1075a8380758f91$var$O(!0, a);
        } finally{
            b ? $b1075a8380758f91$var$S() : ($b1075a8380758f91$var$N = !1, $b1075a8380758f91$var$O = null);
        }
    } else $b1075a8380758f91$var$N = !1;
}
var $b1075a8380758f91$var$S;
if ("function" === typeof $b1075a8380758f91$var$F) $b1075a8380758f91$var$S = function() {
    $b1075a8380758f91$var$F($b1075a8380758f91$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b1075a8380758f91$var$T = new MessageChannel, $b1075a8380758f91$var$U = $b1075a8380758f91$var$T.port2;
    $b1075a8380758f91$var$T.port1.onmessage = $b1075a8380758f91$var$R;
    $b1075a8380758f91$var$S = function() {
        $b1075a8380758f91$var$U.postMessage(null);
    };
} else $b1075a8380758f91$var$S = function() {
    $b1075a8380758f91$var$D($b1075a8380758f91$var$R, 0);
};
function $b1075a8380758f91$var$I(a) {
    $b1075a8380758f91$var$O = a;
    $b1075a8380758f91$var$N || ($b1075a8380758f91$var$N = !0, $b1075a8380758f91$var$S());
}
function $b1075a8380758f91$var$K(a, b) {
    $b1075a8380758f91$var$L = $b1075a8380758f91$var$D(function() {
        a($b1075a8380758f91$export$c4744153514ff05d());
    }, b);
}
$b1075a8380758f91$export$3e506c1ccc9cc1a7 = 5;
$b1075a8380758f91$export$e26fe2ed2fa76875 = 1;
$b1075a8380758f91$export$502329bbf4b505b1 = 4;
$b1075a8380758f91$export$6e3807111c4874c4 = 3;
$b1075a8380758f91$export$c27134553091fb3a = null;
$b1075a8380758f91$export$33ee1acdc04fd2a2 = 2;
$b1075a8380758f91$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b1075a8380758f91$export$8352ce38b91d0c62 = function() {
    $b1075a8380758f91$var$A || $b1075a8380758f91$var$z || ($b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J));
};
$b1075a8380758f91$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b1075a8380758f91$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b1075a8380758f91$export$d3dfb8e4810cb555 = function() {
    return $b1075a8380758f91$var$y;
};
$b1075a8380758f91$export$839f9183b0465a69 = function() {
    return $b1075a8380758f91$var$h($b1075a8380758f91$var$r);
};
$b1075a8380758f91$export$72fdf0e06517287b = function(a) {
    switch($b1075a8380758f91$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b1075a8380758f91$var$y;
    }
    var c = $b1075a8380758f91$var$y;
    $b1075a8380758f91$var$y = b;
    try {
        return a();
    } finally{
        $b1075a8380758f91$var$y = c;
    }
};
$b1075a8380758f91$export$4b844e58a3e414b4 = function() {};
$b1075a8380758f91$export$816d2913ae6b83b1 = function() {};
$b1075a8380758f91$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b1075a8380758f91$var$y;
    $b1075a8380758f91$var$y = a;
    try {
        return b();
    } finally{
        $b1075a8380758f91$var$y = c;
    }
};
$b1075a8380758f91$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b1075a8380758f91$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b1075a8380758f91$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b1075a8380758f91$var$f($b1075a8380758f91$var$t, a), null === $b1075a8380758f91$var$h($b1075a8380758f91$var$r) && a === $b1075a8380758f91$var$h($b1075a8380758f91$var$t) && ($b1075a8380758f91$var$B ? ($b1075a8380758f91$var$E($b1075a8380758f91$var$L), $b1075a8380758f91$var$L = -1) : $b1075a8380758f91$var$B = !0, $b1075a8380758f91$var$K($b1075a8380758f91$var$H, c - d))) : (a.sortIndex = e, $b1075a8380758f91$var$f($b1075a8380758f91$var$r, a), $b1075a8380758f91$var$A || $b1075a8380758f91$var$z || ($b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J)));
    return a;
};
$b1075a8380758f91$export$b5836b71941fa3ed = $b1075a8380758f91$var$M;
$b1075a8380758f91$export$cf845f2c119da08a = function(a) {
    var b = $b1075a8380758f91$var$y;
    return function() {
        var c = $b1075a8380758f91$var$y;
        $b1075a8380758f91$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b1075a8380758f91$var$y = c;
        }
    };
};

});



parcelRegister("zJjdF", function(module, exports) {
'use strict';
var $06b66a6bcbc06882$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $kGFoU = parcelRequire("kGFoU");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $06b66a6bcbc06882$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $06b66a6bcbc06882$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $kGFoU();
};

});
parcelRegister("kGFoU", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("kR54n", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});

var $d00e5d22a0b5e103$exports = {};
'use strict';

$d00e5d22a0b5e103$exports = (parcelRequire("b8reE"));



var $8tsvq = parcelRequire("8tsvq");
var $416246511aeb39de$exports = {};

$parcel$export($416246511aeb39de$exports, "createRoot", () => $416246511aeb39de$export$882461b6382ed46c, (v) => $416246511aeb39de$export$882461b6382ed46c = v);
$parcel$export($416246511aeb39de$exports, "hydrateRoot", () => $416246511aeb39de$export$757ceba2d55c277e, (v) => $416246511aeb39de$export$757ceba2d55c277e = v);
var $416246511aeb39de$export$882461b6382ed46c;
var $416246511aeb39de$export$757ceba2d55c277e;
'use strict';
var $a2d184922ae7f92f$exports = {};
'use strict';
function $a2d184922ae7f92f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a2d184922ae7f92f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a2d184922ae7f92f$var$checkDCE();

$a2d184922ae7f92f$exports = (parcelRequire("jhxbP"));


var $416246511aeb39de$var$i;
$416246511aeb39de$export$882461b6382ed46c = $a2d184922ae7f92f$exports.createRoot;
$416246511aeb39de$export$757ceba2d55c277e = $a2d184922ae7f92f$exports.hydrateRoot;





var $8tsvq = parcelRequire("8tsvq");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a60a332f9bf049ee$var$extendStatics = function(d, b) {
    $a60a332f9bf049ee$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a60a332f9bf049ee$var$extendStatics(d, b);
};
function $a60a332f9bf049ee$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a60a332f9bf049ee$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a60a332f9bf049ee$var$__assign = function() {
    $a60a332f9bf049ee$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a60a332f9bf049ee$var$__assign.apply(this, arguments);
};
function $a60a332f9bf049ee$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a60a332f9bf049ee$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a60a332f9bf049ee$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function $a60a332f9bf049ee$var$e(e, t) {
    var i = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
    }
    return i;
}
"function" == typeof SuppressedError && SuppressedError;
var $a60a332f9bf049ee$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $a60a332f9bf049ee$var$i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $a60a332f9bf049ee$var$o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $a60a332f9bf049ee$var$n = $a60a332f9bf049ee$var$o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, i) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [
                    i
                ]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(i, o) {
                    e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
                });
            }, this.unlock = function(t) {
                var i = e.locked.get(t);
                if (void 0 !== i && 0 !== i.length) {
                    var o = i.pop();
                    e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return i.getInstance();
    };
});
$a60a332f9bf049ee$var$i($a60a332f9bf049ee$var$n);
var $a60a332f9bf049ee$var$a = $a60a332f9bf049ee$var$i($a60a332f9bf049ee$var$o(function(e, i) {
    var o = $a60a332f9bf049ee$var$t && $a60a332f9bf049ee$var$t.__awaiter || function(e, t, i, o) {
        return new (i || (i = Promise))(function(n, a) {
            function r(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    a(e);
                }
            }
            function s(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    a(e);
                }
            }
            function c(e) {
                e.done ? n(e.value) : new i(function(t) {
                    t(e.value);
                }).then(r, s);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, a = $a60a332f9bf049ee$var$t && $a60a332f9bf049ee$var$t.__generator || function(e, t) {
        var i, o, n, a, r = {
            label: 0,
            sent: function() {
                if (1 & n[0]) throw n[1];
                return n[1];
            },
            trys: [],
            ops: []
        };
        return a = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this;
        }), a;
        function s(a) {
            return function(s) {
                return function(a) {
                    if (i) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                        switch(o = 0, n && (a = [
                            2 & a[0],
                            n.value
                        ]), a[0]){
                            case 0:
                            case 1:
                                n = a;
                                break;
                            case 4:
                                return r.label++, {
                                    value: a[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, o = a[1], a = [
                                    0
                                ];
                                continue;
                            case 7:
                                a = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                    r.label = a[1];
                                    break;
                                }
                                if (6 === a[0] && r.label < n[1]) {
                                    r.label = n[1], n = a;
                                    break;
                                }
                                if (n && r.label < n[2]) {
                                    r.label = n[2], r.ops.push(a);
                                    break;
                                }
                                n[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        a = t.call(e, r);
                    } catch (e) {
                        a = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        i = n = 0;
                    }
                    if (5 & a[0]) throw a[1];
                    return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                    };
                }([
                    a,
                    s
                ]);
            };
        }
    }, r = $a60a332f9bf049ee$var$t;
    Object.defineProperty(i, "__esModule", {
        value: !0
    });
    var s = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function d(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function u(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++)i += t[Math.floor(Math.random() * t.length)];
        return i;
    }
    var l = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, i) {
            return void 0 === i && (i = 5e3), o(this, void 0, void 0, function() {
                var o, n, r, l, h, p, m;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
                        case 1:
                            return Date.now() < n ? [
                                4,
                                d(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return a.sent(), null !== l.getItemSync(r) ? [
                                3,
                                5
                            ] : (h = this.id + "-" + t + "-" + o, [
                                4,
                                d(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return a.sent(), l.setItemSync(r, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: h,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                d(30)
                            ];
                        case 4:
                            return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(n)
                            ];
                        case 6:
                            a.sent(), a.label = 7;
                        case 7:
                            return o = Date.now() + u(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var i = this;
                return a(this, function(r) {
                    return setTimeout(function() {
                        return o(i, void 0, void 0, function() {
                            var i, o, r;
                            return a(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return [
                                            4,
                                            $a60a332f9bf049ee$var$n.default().lock(t)
                                        ];
                                    case 1:
                                        return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? ($a60a332f9bf049ee$var$n.default().unlock(t), [
                                            2
                                        ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), $a60a332f9bf049ee$var$n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($a60a332f9bf049ee$var$n.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return a(this, function(i) {
                    switch(i.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(i) {
                                    var o = !1, n = Date.now(), a = !1;
                                    function r() {
                                        if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - n);
                                            t > 0 ? setTimeout(i, t) : i(null);
                                        }
                                    }
                                    window.addEventListener("storage", r), e.addToWaiting(r);
                                    var s = setTimeout(r, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return i.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return a(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var i, o, r, d;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [
                                2
                            ] : (d = JSON.parse(r)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $a60a332f9bf049ee$var$n.default().lock(d.iat)
                            ];
                        case 1:
                            a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), $a60a332f9bf049ee$var$n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var i = Date.now() - 5e3, o = t, n = [], a = 0;;){
                var r = o.keySync(a);
                if (null === r) break;
                n.push(r), a++;
            }
            for(var c = !1, d = 0; d < n.length; d++){
                var u = n[d];
                if (u.includes(s)) {
                    var l = o.getItemSync(u);
                    if (null !== l) {
                        var h = JSON.parse(l);
                        (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    i.default = l;
}));
const $a60a332f9bf049ee$var$r = {
    timeoutInSeconds: 60
}, $a60a332f9bf049ee$var$s = {
    name: "auth0-spa-js",
    version: "2.1.3"
}, $a60a332f9bf049ee$var$c = ()=>Date.now();
class $a60a332f9bf049ee$export$7d465be8efa67280 extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $a60a332f9bf049ee$export$7d465be8efa67280.prototype);
    }
    static fromPayload({ error: e, error_description: t }) {
        return new $a60a332f9bf049ee$export$7d465be8efa67280(e, t);
    }
}
class $a60a332f9bf049ee$export$cf0c46b07324e9c5 extends $a60a332f9bf049ee$export$7d465be8efa67280 {
    constructor(e, t, i, o = null){
        super(e, t), this.state = i, this.appState = o, Object.setPrototypeOf(this, $a60a332f9bf049ee$export$cf0c46b07324e9c5.prototype);
    }
}
class $a60a332f9bf049ee$export$66d311bf29d5c89c extends $a60a332f9bf049ee$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $a60a332f9bf049ee$export$66d311bf29d5c89c.prototype);
    }
}
class $a60a332f9bf049ee$export$ebbb83fe03f719a4 extends $a60a332f9bf049ee$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $a60a332f9bf049ee$export$ebbb83fe03f719a4.prototype);
    }
}
class $a60a332f9bf049ee$export$f1f681f0fb26bb55 extends $a60a332f9bf049ee$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $a60a332f9bf049ee$export$f1f681f0fb26bb55.prototype);
    }
}
class $a60a332f9bf049ee$export$c59494f4dae44ada extends $a60a332f9bf049ee$export$7d465be8efa67280 {
    constructor(e, t, i){
        super(e, t), this.mfa_token = i, Object.setPrototypeOf(this, $a60a332f9bf049ee$export$c59494f4dae44ada.prototype);
    }
}
class $a60a332f9bf049ee$export$ac1d2a00f8e0a046 extends $a60a332f9bf049ee$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${$a60a332f9bf049ee$var$g(e, [
            "default"
        ])}', scope: '${$a60a332f9bf049ee$var$g(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $a60a332f9bf049ee$export$ac1d2a00f8e0a046.prototype);
    }
}
function $a60a332f9bf049ee$var$g(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const $a60a332f9bf049ee$var$w = ()=>window.crypto, $a60a332f9bf049ee$var$y = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($a60a332f9bf049ee$var$w().getRandomValues(new Uint8Array(43))).forEach((i)=>t += e[i % e.length]), t;
}, $a60a332f9bf049ee$var$k = (e)=>btoa(e), $a60a332f9bf049ee$var$v = (t)=>{
    var { clientId: i } = t, o = $a60a332f9bf049ee$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, i)=>Object.assign(Object.assign({}, t), {
                [i]: e[i]
            }), {}))(Object.assign({
        client_id: i
    }, o))).toString();
}, $a60a332f9bf049ee$var$b = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $a60a332f9bf049ee$var$_ = async (e, t)=>{
    const i = await fetch(e, t);
    return {
        ok: i.ok,
        json: await i.json()
    };
}, $a60a332f9bf049ee$var$I = async (e, t, i)=>{
    const o = new AbortController;
    let n;
    return t.signal = o.signal, Promise.race([
        $a60a332f9bf049ee$var$_(e, t),
        new Promise((e, t)=>{
            n = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, i);
        })
    ]).finally(()=>{
        clearTimeout(n);
    });
}, $a60a332f9bf049ee$var$S = async (e, t, i, o, n, a, r)=>{
    var s, c;
    return s = {
        auth: {
            audience: t,
            scope: i
        },
        timeout: n,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: r
    }, c = a, new Promise(function(e, t) {
        const i = new MessageChannel;
        i.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
        }, c.postMessage(s, [
            i.port2
        ]);
    });
}, $a60a332f9bf049ee$var$O = async (e, t, i, o, n, a, r = 1e4)=>n ? $a60a332f9bf049ee$var$S(e, t, i, o, r, n, a) : $a60a332f9bf049ee$var$I(e, o, r);
async function $a60a332f9bf049ee$var$T(t, i) {
    var { baseUrl: o, timeout: n, audience: a, scope: r, auth0Client: c, useFormData: u } = t, l = $a60a332f9bf049ee$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    const h = u ? $a60a332f9bf049ee$var$v(l) : JSON.stringify(l);
    return await async function(t, i, o, n, a, r, s) {
        let c, u = null;
        for(let e = 0; e < 3; e++)try {
            c = await $a60a332f9bf049ee$var$O(t, o, n, a, r, s, i), u = null;
            break;
        } catch (e) {
            u = e;
        }
        if (u) throw u;
        const l = c.json, { error: h, error_description: p } = l, g = $a60a332f9bf049ee$var$e(l, [
            "error",
            "error_description"
        ]), { ok: w } = c;
        if (!w) {
            const e = p || `HTTP error. Unable to fetch ${t}`;
            if ("mfa_required" === h) throw new $a60a332f9bf049ee$export$c59494f4dae44ada(h, e, g.mfa_token);
            if ("missing_refresh_token" === h) throw new $a60a332f9bf049ee$export$ac1d2a00f8e0a046(o, n);
            throw new $a60a332f9bf049ee$export$7d465be8efa67280(h || "request_error", e);
        }
        return g;
    }(`${o}/oauth/token`, n, a || "default", r, {
        method: "POST",
        body: h,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || $a60a332f9bf049ee$var$s))
        }
    }, i, u);
}
const $a60a332f9bf049ee$var$j = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class $a60a332f9bf049ee$var$C {
    constructor(e, t = "@@auth0spajs@@", i){
        this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, i, o, n] = e.split("::");
        return new $a60a332f9bf049ee$var$C({
            clientId: i,
            scope: n,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: i, client_id: o } = e;
        return new $a60a332f9bf049ee$var$C({
            scope: t,
            audience: i,
            clientId: o
        });
    }
}
class $a60a332f9bf049ee$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $a60a332f9bf049ee$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, i) {
                    e[t] = i;
                },
                get (t) {
                    const i = e[t];
                    if (i) return i;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $a60a332f9bf049ee$var$x {
    constructor(e, t, i){
        this.cache = e, this.keyManifest = t, this.nowProvider = i || $a60a332f9bf049ee$var$c;
    }
    async setIdToken(e, t, i) {
        var o;
        const n = this.getIdTokenCacheKey(e);
        await this.cache.set(n, {
            id_token: t,
            decodedToken: i
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0) {
        var i;
        let o = await this.cache.get(e.toKey());
        if (!o) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            i && (o = await this.cache.get(i));
        }
        if (!o) return;
        const n = await this.nowProvider(), a = Math.floor(n / 1e3);
        return o.expiresAt - t < a ? o.body.refresh_token ? (o.body = {
            refresh_token: o.body.refresh_token
        }, await this.cache.set(e.toKey(), o), o.body) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : o.body;
    }
    async set(e) {
        var t;
        const i = new $a60a332f9bf049ee$var$C({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(i.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey()));
    }
    async clear(e) {
        var t;
        const i = await this.getCacheKeys();
        i && (await i.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $a60a332f9bf049ee$var$C({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var i;
            const o = $a60a332f9bf049ee$var$C.fromKey(t), n = new Set(o.scope && o.scope.split(" ")), a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [], r = o.scope && a.reduce((e, t)=>e && n.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
        })[0];
    }
}
class $a60a332f9bf049ee$var$Z {
    constructor(e, t, i){
        this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const $a60a332f9bf049ee$var$K = (e)=>"number" == typeof e, $a60a332f9bf049ee$var$W = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $a60a332f9bf049ee$var$E = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [i, o, n] = t;
        if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
        const a = JSON.parse($a60a332f9bf049ee$var$b(o)), r = {
            __raw: e
        }, s = {};
        return Object.keys(a).forEach((e)=>{
            r[e] = a[e], $a60a332f9bf049ee$var$W.includes(e) || (s[e] = a[e]);
        }), {
            encoded: {
                header: i,
                payload: o,
                signature: n
            },
            header: JSON.parse($a60a332f9bf049ee$var$b(i)),
            claims: r,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !$a60a332f9bf049ee$var$K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$a60a332f9bf049ee$var$K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$a60a332f9bf049ee$var$K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const i = e.leeway || 60, o = new Date(e.now || Date.now()), n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);
    if (null != t.claims.nbf && $a60a332f9bf049ee$var$K(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - i), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && $a60a332f9bf049ee$var$K(t.claims.auth_time)) {
        const n = new Date(0);
        if (n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > n) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`);
    }
    if (e.organization) {
        const i = e.organization.trim();
        if (i.startsWith("org_")) {
            const e = i;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = i.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var $a60a332f9bf049ee$var$R = $a60a332f9bf049ee$var$o(function(e, i) {
    var o = $a60a332f9bf049ee$var$t && $a60a332f9bf049ee$var$t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, i = 1, o = arguments.length; i < o; i++)for(var n in t = arguments[i])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
        }, o.apply(this, arguments);
    };
    function n(e, t) {
        if (!t) return "";
        var i = "; " + e;
        return !0 === t ? i : i + "=" + t;
    }
    function a(e, t, i) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
        }(i);
    }
    function r(e) {
        for(var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++){
            var a = i[n].split("="), r = a.slice(1).join("=");
            '"' === r.charAt(0) && (r = r.slice(1, -1));
            try {
                t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function s() {
        return r(document.cookie);
    }
    function c(e, t, i) {
        document.cookie = a(e, t, o({
            path: "/"
        }, i));
    }
    i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function(e) {
        return s()[e];
    }, i.set = c, i.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
$a60a332f9bf049ee$var$i($a60a332f9bf049ee$var$R), $a60a332f9bf049ee$var$R.encode, $a60a332f9bf049ee$var$R.parse, $a60a332f9bf049ee$var$R.getAll;
var $a60a332f9bf049ee$var$U = $a60a332f9bf049ee$var$R.get, $a60a332f9bf049ee$var$L = $a60a332f9bf049ee$var$R.set, $a60a332f9bf049ee$var$D = $a60a332f9bf049ee$var$R.remove;
const $a60a332f9bf049ee$var$X = {
    get (e) {
        const t = $a60a332f9bf049ee$var$U(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $a60a332f9bf049ee$var$L(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $a60a332f9bf049ee$var$D(e, i);
    }
}, $a60a332f9bf049ee$var$N = {
    get (e) {
        const t = $a60a332f9bf049ee$var$X.get(e);
        return t || $a60a332f9bf049ee$var$X.get(`_legacy_${e}`);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $a60a332f9bf049ee$var$L(`_legacy_${e}`, JSON.stringify(t), o), $a60a332f9bf049ee$var$X.save(e, t, i);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $a60a332f9bf049ee$var$D(e, i), $a60a332f9bf049ee$var$X.remove(e, t), $a60a332f9bf049ee$var$X.remove(`_legacy_${e}`, t);
    }
}, $a60a332f9bf049ee$var$J = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function $a60a332f9bf049ee$var$F(e, t, i) {
    var o = void 0 === t ? null : t, n = function(e, t) {
        var i = atob(e);
        if (t) {
            for(var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n)o[n] = i.charCodeAt(n);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return i;
    }(e, void 0 !== i && i), a = n.indexOf("\n", 10) + 1, r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        r
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $a60a332f9bf049ee$var$H, $a60a332f9bf049ee$var$Y, $a60a332f9bf049ee$var$G, $a60a332f9bf049ee$var$V, $a60a332f9bf049ee$var$M = ($a60a332f9bf049ee$var$H = "Lyogcm9sbHVwLXBsdWdpbi13ZWItd29ya2VyLWxvYWRlciAqLwohZnVuY3Rpb24oKXsidXNlIHN0cmljdCI7Y2xhc3MgZSBleHRlbmRzIEVycm9ye2NvbnN0cnVjdG9yKHQscil7c3VwZXIociksdGhpcy5lcnJvcj10LHRoaXMuZXJyb3JfZGVzY3JpcHRpb249cixPYmplY3Quc2V0UHJvdG90eXBlT2YodGhpcyxlLnByb3RvdHlwZSl9c3RhdGljIGZyb21QYXlsb2FkKHtlcnJvcjp0LGVycm9yX2Rlc2NyaXB0aW9uOnJ9KXtyZXR1cm4gbmV3IGUodCxyKX19Y2xhc3MgdCBleHRlbmRzIGV7Y29uc3RydWN0b3IoZSxzKXtzdXBlcigibWlzc2luZ19yZWZyZXNoX3Rva2VuIixgTWlzc2luZyBSZWZyZXNoIFRva2VuIChhdWRpZW5jZTogJyR7cihlLFsiZGVmYXVsdCJdKX0nLCBzY29wZTogJyR7cihzKX0nKWApLHRoaXMuYXVkaWVuY2U9ZSx0aGlzLnNjb3BlPXMsT2JqZWN0LnNldFByb3RvdHlwZU9mKHRoaXMsdC5wcm90b3R5cGUpfX1mdW5jdGlvbiByKGUsdD1bXSl7cmV0dXJuIGUmJiF0LmluY2x1ZGVzKGUpP2U6IiJ9ImZ1bmN0aW9uIj09dHlwZW9mIFN1cHByZXNzZWRFcnJvciYmU3VwcHJlc3NlZEVycm9yO2NvbnN0IHM9ZT0+e3ZhcntjbGllbnRJZDp0fT1lLHI9ZnVuY3Rpb24oZSx0KXt2YXIgcj17fTtmb3IodmFyIHMgaW4gZSlPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwoZSxzKSYmdC5pbmRleE9mKHMpPDAmJihyW3NdPWVbc10pO2lmKG51bGwhPWUmJiJmdW5jdGlvbiI9PXR5cGVvZiBPYmplY3QuZ2V0T3duUHJvcGVydHlTeW1ib2xzKXt2YXIgbz0wO2ZvcihzPU9iamVjdC5nZXRPd25Qcm9wZXJ0eVN5bWJvbHMoZSk7bzxzLmxlbmd0aDtvKyspdC5pbmRleE9mKHNbb10pPDAmJk9iamVjdC5wcm90b3R5cGUucHJvcGVydHlJc0VudW1lcmFibGUuY2FsbChlLHNbb10pJiYocltzW29dXT1lW3Nbb11dKX1yZXR1cm4gcn0oZSxbImNsaWVudElkIl0pO3JldHVybiBuZXcgVVJMU2VhcmNoUGFyYW1zKChlPT5PYmplY3Qua2V5cyhlKS5maWx0ZXIoKHQ9PnZvaWQgMCE9PWVbdF0pKS5yZWR1Y2UoKCh0LHIpPT5PYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30sdCkse1tyXTplW3JdfSkpLHt9KSkoT2JqZWN0LmFzc2lnbih7Y2xpZW50X2lkOnR9LHIpKSkudG9TdHJpbmcoKX07bGV0IG89e307Y29uc3Qgbj0oZSx0KT0+YCR7ZX18JHt0fWA7YWRkRXZlbnRMaXN0ZW5lcigibWVzc2FnZSIsKGFzeW5jKHtkYXRhOnt0aW1lb3V0OmUsYXV0aDpyLGZldGNoVXJsOmksZmV0Y2hPcHRpb25zOmMsdXNlRm9ybURhdGE6YX0scG9ydHM6W3BdfSk9PntsZXQgZjtjb25zdHthdWRpZW5jZTp1LHNjb3BlOmx9PXJ8fHt9O3RyeXtjb25zdCByPWE/KGU9Pntjb25zdCB0PW5ldyBVUkxTZWFyY2hQYXJhbXMoZSkscj17fTtyZXR1cm4gdC5mb3JFYWNoKCgoZSx0KT0+e3JbdF09ZX0pKSxyfSkoYy5ib2R5KTpKU09OLnBhcnNlKGMuYm9keSk7aWYoIXIucmVmcmVzaF90b2tlbiYmInJlZnJlc2hfdG9rZW4iPT09ci5ncmFudF90eXBlKXtjb25zdCBlPSgoZSx0KT0+b1tuKGUsdCldKSh1LGwpO2lmKCFlKXRocm93IG5ldyB0KHUsbCk7Yy5ib2R5PWE/cyhPYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30scikse3JlZnJlc2hfdG9rZW46ZX0pKTpKU09OLnN0cmluZ2lmeShPYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30scikse3JlZnJlc2hfdG9rZW46ZX0pKX1sZXQgaCxnOyJmdW5jdGlvbiI9PXR5cGVvZiBBYm9ydENvbnRyb2xsZXImJihoPW5ldyBBYm9ydENvbnRyb2xsZXIsYy5zaWduYWw9aC5zaWduYWwpO3RyeXtnPWF3YWl0IFByb21pc2UucmFjZShbKGQ9ZSxuZXcgUHJvbWlzZSgoZT0+c2V0VGltZW91dChlLGQpKSkpLGZldGNoKGksT2JqZWN0LmFzc2lnbih7fSxjKSldKX1jYXRjaChlKXtyZXR1cm4gdm9pZCBwLnBvc3RNZXNzYWdlKHtlcnJvcjplLm1lc3NhZ2V9KX1pZighZylyZXR1cm4gaCYmaC5hYm9ydCgpLHZvaWQgcC5wb3N0TWVzc2FnZSh7ZXJyb3I6IlRpbWVvdXQgd2hlbiBleGVjdXRpbmcgJ2ZldGNoJyJ9KTtmPWF3YWl0IGcuanNvbigpLGYucmVmcmVzaF90b2tlbj8oKChlLHQscik9PntvW24odCxyKV09ZX0pKGYucmVmcmVzaF90b2tlbix1LGwpLGRlbGV0ZSBmLnJlZnJlc2hfdG9rZW4pOigoZSx0KT0+e2RlbGV0ZSBvW24oZSx0KV19KSh1LGwpLHAucG9zdE1lc3NhZ2Uoe29rOmcub2ssanNvbjpmfSl9Y2F0Y2goZSl7cC5wb3N0TWVzc2FnZSh7b2s6ITEsanNvbjp7ZXJyb3I6ZS5lcnJvcixlcnJvcl9kZXNjcmlwdGlvbjplLm1lc3NhZ2V9fSl9dmFyIGR9KSl9KCk7Cgo=", $a60a332f9bf049ee$var$Y = null, $a60a332f9bf049ee$var$G = !1, function(e) {
    return $a60a332f9bf049ee$var$V = $a60a332f9bf049ee$var$V || $a60a332f9bf049ee$var$F($a60a332f9bf049ee$var$H, $a60a332f9bf049ee$var$Y, $a60a332f9bf049ee$var$G), new Worker($a60a332f9bf049ee$var$V, e);
});
const $a60a332f9bf049ee$var$A = {};
class $a60a332f9bf049ee$var$B {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const i = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        i.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...i
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const i = new Set(t.keys);
            return i.delete(e), i.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...i
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
}
const $a60a332f9bf049ee$var$$ = {
    memory: ()=>(new $a60a332f9bf049ee$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $a60a332f9bf049ee$export$40ef2cb682e70737
}, $a60a332f9bf049ee$var$q = (e)=>$a60a332f9bf049ee$var$$[e], $a60a332f9bf049ee$var$Q = (t)=>{
    const { openUrl: i, onRedirect: o } = t, n = $a60a332f9bf049ee$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, n), {
        openUrl: !1 === i || i ? i : o
    });
}, $a60a332f9bf049ee$var$ee = new $a60a332f9bf049ee$var$a;
class $a60a332f9bf049ee$var$te {
    constructor(e){
        let t, i;
        if (this.userCache = (new $a60a332f9bf049ee$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await $a60a332f9bf049ee$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$a60a332f9bf049ee$var$w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $a60a332f9bf049ee$var$w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$a60a332f9bf049ee$var$q(t)) throw new Error(`Invalid cache location "${t}"`);
            i = $a60a332f9bf049ee$var$q(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $a60a332f9bf049ee$var$X : $a60a332f9bf049ee$var$N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : $a60a332f9bf049ee$var$J;
        var n;
        this.scope = $a60a332f9bf049ee$var$j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $a60a332f9bf049ee$var$Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $a60a332f9bf049ee$var$c, this.cacheManager = new $a60a332f9bf049ee$var$x(i, i.allKeys ? void 0 : new $a60a332f9bf049ee$var$B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : `https://${n}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $a60a332f9bf049ee$var$M);
    }
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $a60a332f9bf049ee$var$s)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${$a60a332f9bf049ee$var$v(e)}`);
    }
    async _verifyIdToken(e, t, i) {
        const o = await this.nowProvider();
        var n;
        return $a60a332f9bf049ee$var$E({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: i,
            leeway: this.options.leeway,
            max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, i) {
        const o = $a60a332f9bf049ee$var$k($a60a332f9bf049ee$var$y()), n = $a60a332f9bf049ee$var$k($a60a332f9bf049ee$var$y()), a = $a60a332f9bf049ee$var$y(), r = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = $a60a332f9bf049ee$var$w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(a)), s = ((e, t, i, o, n, a, r, s)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), i), {
                scope: $a60a332f9bf049ee$var$j(t, i.scope),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: n,
                redirect_uri: r || e.authorizationParams.redirect_uri,
                code_challenge: a,
                code_challenge_method: "S256"
            }))(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode), c = this._authorizeUrl(s);
        return {
            nonce: n,
            code_verifier: a,
            scope: s.scope,
            audience: s.audience || "default",
            redirect_uri: s.redirect_uri,
            state: o,
            url: c
        };
    }
    async loginWithPopup(e, t) {
        var i;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, i = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const n = await ((e)=>new Promise((t, i)=>{
                let o;
                const n = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", o, !1), i(new $a60a332f9bf049ee$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(n), i(new $a60a332f9bf049ee$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                        if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", o, !1), e.popup.close(), r.data.response.error) return i($a60a332f9bf049ee$export$7d465be8efa67280.fromPayload(r.data.response));
                        t(r.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== n.state) throw new $a60a332f9bf049ee$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: n.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var i;
        const o = $a60a332f9bf049ee$var$Q(t), { openUrl: n, fragment: a, appState: r } = o, s = $a60a332f9bf049ee$var$e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, l = $a60a332f9bf049ee$var$e(d, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: r
        }), c && {
            organization: c
        }));
        const h = a ? `${u}#${a}` : u;
        n ? await n(h) : window.location.assign(h);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: i, code: o, error: n, error_description: a } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), r = this.transactionManager.get();
        if (!r) throw new $a60a332f9bf049ee$export$7d465be8efa67280("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), n) throw new $a60a332f9bf049ee$export$cf0c46b07324e9c5(n, a || n, i, r.appState);
        if (!r.code_verifier || r.state && r.state !== i) throw new $a60a332f9bf049ee$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const s = r.organization, c = r.nonce, l = r.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: r.audience,
            scope: r.scope,
            code_verifier: r.code_verifier,
            grant_type: "authorization_code",
            code: o
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: c,
            organization: s
        }), {
            appState: r.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const i = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $a60a332f9bf049ee$var$j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), o = await ((e, t)=>{
            let i = $a60a332f9bf049ee$var$A[t];
            return i || (i = e().finally(()=>{
                delete $a60a332f9bf049ee$var$A[t], i = null;
            }), $a60a332f9bf049ee$var$A[t] = i), i;
        })(()=>this._getTokenSilently(i), `${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);
        return e.detailedResponse ? o : null == o ? void 0 : o.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: i } = t, o = $a60a332f9bf049ee$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== i) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (e) return e;
        }
        if ("cache-only" !== i) {
            if (!await (async (e, t = 3)=>{
                for(let i = 0; i < t; i++)if (await e()) return !0;
                return !1;
            })(()=>$a60a332f9bf049ee$var$ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new $a60a332f9bf049ee$export$66d311bf29d5c89c;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, access_token: n, oauthTokenScope: a, expires_in: r } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    access_token: n
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: r
                });
            } finally{
                await $a60a332f9bf049ee$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var i;
        const o = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $a60a332f9bf049ee$var$j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
            })
        });
        t = Object.assign(Object.assign({}, $a60a332f9bf049ee$var$r), t), await this.loginWithPopup(o, t);
        return (await this.cacheManager.get(new $a60a332f9bf049ee$var$C({
            scope: o.authorizationParams.scope,
            audience: o.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }))).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const i = t.logoutParams || {}, { federated: o } = i, n = $a60a332f9bf049ee$var$e(i, [
            "federated"
        ]), a = o ? "&federated" : "";
        return this._url(`/v2/logout?${$a60a332f9bf049ee$var$v(Object.assign({
            clientId: t.clientId
        }, n))}`) + a;
    }
    async logout(t = {}) {
        const i = $a60a332f9bf049ee$var$Q(t), { openUrl: o } = i, n = $a60a332f9bf049ee$var$e(i, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@");
        const a = this._buildLogoutUrl(n);
        o ? await o(a) : !1 !== o && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), i = this.cookieStorage.get(this.orgHintCookieName);
        i && !t.organization && (t.organization = i);
        const { url: o, state: n, nonce: a, code_verifier: r, redirect_uri: s, scope: c, audience: u } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new $a60a332f9bf049ee$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const i = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((e, t, i = 60)=>new Promise((o, n)=>{
                    const a = window.document.createElement("iframe");
                    a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                    const r = ()=>{
                        window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        n(new $a60a332f9bf049ee$export$66d311bf29d5c89c), r();
                    }, 1e3 * i);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const i = e.source;
                        i && i.close(), e.data.response.error ? n($a60a332f9bf049ee$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                }))(o, this.domainUrl, i);
            if (n !== h.state) throw new $a60a332f9bf049ee$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const p = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, p), {
                scope: c,
                oauthTokenScope: p.scope,
                audience: u
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $a60a332f9bf049ee$var$C({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }));
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $a60a332f9bf049ee$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
        try {
            const n = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
            }), o && {
                timeout: o
            }));
            return Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
    }
    async _saveEntryInCache(t) {
        const { id_token: i, decodedToken: o } = t, n = $a60a332f9bf049ee$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: i,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(n);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new $a60a332f9bf049ee$var$C({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), i = this.userCache.get("@@user@@");
        return t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: i }) {
        const o = await this.cacheManager.get(new $a60a332f9bf049ee$var$C({
            scope: e,
            audience: t,
            clientId: i
        }), 60);
        if (o && o.access_token) {
            const { access_token: e, oauthTokenScope: t, expires_in: i } = o, n = await this._getIdTokenFromCache();
            return n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: e
            }, t ? {
                scope: t
            } : null), {
                expires_in: i
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: i, organization: o } = t || {}, n = await $a60a332f9bf049ee$var$T(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs
        }, e), this.worker), a = await this._verifyIdToken(n.id_token, i, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
            decodedToken: a,
            scope: e.scope,
            audience: e.audience || "default"
        }), n.scope ? {
            oauthTokenScope: n.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || a.claims.org_id), Object.assign(Object.assign({}, n), {
            decodedToken: a
        });
    }
}
class $a60a332f9bf049ee$export$1f44aaf2ec115b54 {
}
/**
 * The initial auth state.
 */ var $a60a332f9bf049ee$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
/**
 * @ignore
 */ var $a60a332f9bf049ee$var$stub = function() {
    throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */ var $a60a332f9bf049ee$export$1b5d8f0c33515521 = $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, $a60a332f9bf049ee$var$initialAuthState), {
    buildAuthorizeUrl: $a60a332f9bf049ee$var$stub,
    buildLogoutUrl: $a60a332f9bf049ee$var$stub,
    getAccessTokenSilently: $a60a332f9bf049ee$var$stub,
    getAccessTokenWithPopup: $a60a332f9bf049ee$var$stub,
    getIdTokenClaims: $a60a332f9bf049ee$var$stub,
    loginWithRedirect: $a60a332f9bf049ee$var$stub,
    loginWithPopup: $a60a332f9bf049ee$var$stub,
    logout: $a60a332f9bf049ee$var$stub,
    handleRedirectCallback: $a60a332f9bf049ee$var$stub
});
/**
 * The Auth0 Context
 */ var $a60a332f9bf049ee$export$419e9d660c2a6030 = (0, $8tsvq.createContext)($a60a332f9bf049ee$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $a60a332f9bf049ee$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $a60a332f9bf049ee$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $a60a332f9bf049ee$var$CODE_RE = /[?&]code=[^&]+/;
var $a60a332f9bf049ee$var$STATE_RE = /[?&]state=[^&]+/;
var $a60a332f9bf049ee$var$ERROR_RE = /[?&]error=[^&]+/;
var $a60a332f9bf049ee$var$hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($a60a332f9bf049ee$var$CODE_RE.test(searchParams) || $a60a332f9bf049ee$var$ERROR_RE.test(searchParams)) && $a60a332f9bf049ee$var$STATE_RE.test(searchParams);
};
var $a60a332f9bf049ee$var$normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === 'object' && 'error' in error && typeof error.error === 'string') {
            if ('error_description' in error && typeof error.error_description === 'string') return new $a60a332f9bf049ee$export$bdc0f363b754b88f(error.error, error.error_description);
            return new $a60a332f9bf049ee$export$bdc0f363b754b88f(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var $a60a332f9bf049ee$var$loginError = $a60a332f9bf049ee$var$normalizeErrorFn('Login failed');
var $a60a332f9bf049ee$var$tokenError = $a60a332f9bf049ee$var$normalizeErrorFn('Get access token failed');
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $a60a332f9bf049ee$var$deprecateRedirectUri = function(options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn('Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version');
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn('Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version');
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $a60a332f9bf049ee$var$reducer = function(state, action) {
    switch(action.type){
        case 'LOGIN_POPUP_STARTED':
            return $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, state), {
                isLoading: true
            });
        case 'LOGIN_POPUP_COMPLETE':
        case 'INITIALISED':
            return $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case 'HANDLE_REDIRECT_COMPLETE':
        case 'GET_ACCESS_TOKEN_COMPLETE':
            if (state.user === action.user) return state;
            return $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case 'LOGOUT':
            return $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case 'ERROR':
            return $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $a60a332f9bf049ee$var$toAuth0ClientOptions = function(opts) {
    $a60a332f9bf049ee$var$deprecateRedirectUri(opts);
    return $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, opts), {
        auth0Client: {
            name: 'auth0-react',
            version: '2.2.4'
        }
    });
};
/**
 * @ignore
 */ var $a60a332f9bf049ee$var$defaultOnRedirectCallback = function(appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var $a60a332f9bf049ee$export$6aefaad9cc4faf3c = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? $a60a332f9bf049ee$var$defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? $a60a332f9bf049ee$export$419e9d660c2a6030 : _b, clientOpts = $a60a332f9bf049ee$var$__rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, $8tsvq.useState)(function() {
        return new $a60a332f9bf049ee$var$te($a60a332f9bf049ee$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, $8tsvq.useReducer)($a60a332f9bf049ee$var$reducer, $a60a332f9bf049ee$var$initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, $8tsvq.useRef)(false);
    (0, $8tsvq.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return $a60a332f9bf049ee$var$__awaiter(void 0, void 0, void 0, function() {
                var user, appState, error_1;
                return $a60a332f9bf049ee$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!($a60a332f9bf049ee$var$hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            appState = _a.sent().appState;
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _a.sent();
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _a.sent();
                            _a.label = 6;
                        case 6:
                            dispatch({
                                type: 'INITIALISED',
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _a.sent();
                            dispatch({
                                type: 'ERROR',
                                error: $a60a332f9bf049ee$var$loginError(error_1)
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback
    ]);
    var loginWithRedirect = (0, $8tsvq.useCallback)(function(opts) {
        $a60a332f9bf049ee$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $8tsvq.useCallback)(function(options, config) {
        return $a60a332f9bf049ee$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $a60a332f9bf049ee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: 'LOGIN_POPUP_STARTED'
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({
                            type: 'ERROR',
                            error: $a60a332f9bf049ee$var$loginError(error_2)
                        });
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: 'LOGIN_POPUP_COMPLETE',
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var logout = (0, $8tsvq.useCallback)(function(opts) {
        if (opts === void 0) opts = {};
        return $a60a332f9bf049ee$var$__awaiter(void 0, void 0, void 0, function() {
            return $a60a332f9bf049ee$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: 'LOGOUT'
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $8tsvq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $a60a332f9bf049ee$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $a60a332f9bf049ee$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $a60a332f9bf049ee$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $8tsvq.useCallback)(function(opts, config) {
        return $a60a332f9bf049ee$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $a60a332f9bf049ee$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $a60a332f9bf049ee$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'GET_ACCESS_TOKEN_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $8tsvq.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, $8tsvq.useCallback)(function(url) {
        return $a60a332f9bf049ee$var$__awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return $a60a332f9bf049ee$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $a60a332f9bf049ee$var$tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: 'HANDLE_REDIRECT_COMPLETE'
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var contextValue = (0, $8tsvq.useMemo)(function() {
        return $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $a60a332f9bf049ee$export$f2b63d3ca66bb884 = function(context) {
    if (context === void 0) context = $a60a332f9bf049ee$export$419e9d660c2a6030;
    return (0, $8tsvq.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $a60a332f9bf049ee$export$bf0b363fae22b33f = function(Component, context) {
    if (context === void 0) context = $a60a332f9bf049ee$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement(Component, $a60a332f9bf049ee$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $a60a332f9bf049ee$var$defaultOnRedirecting = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).Fragment, null);
};
/**
* @ignore
*/ var $a60a332f9bf049ee$var$defaultOnBeforeAuthentication = function() {
    return $a60a332f9bf049ee$var$__awaiter(void 0, void 0, void 0, function() {
        return $a60a332f9bf049ee$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $a60a332f9bf049ee$var$defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $a60a332f9bf049ee$export$2cfd0b285ff12c70 = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $a60a332f9bf049ee$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $a60a332f9bf049ee$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $a60a332f9bf049ee$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $a60a332f9bf049ee$export$419e9d660c2a6030 : _d;
        var _e = $a60a332f9bf049ee$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $8tsvq.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, loginOptions), {
                appState: $a60a332f9bf049ee$var$__assign($a60a332f9bf049ee$var$__assign({}, loginOptions && loginOptions.appState), {
                    returnTo: typeof returnTo === 'function' ? returnTo() : returnTo
                })
            });
            (function() {
                return $a60a332f9bf049ee$var$__awaiter(_this, void 0, void 0, function() {
                    return $a60a332f9bf049ee$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement(Component, $a60a332f9bf049ee$var$__assign({}, props)) : onRedirecting();
    };
};



'use strict';
function $5d219f656b13ee51$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $3b0e765f17086bfd$var$toString } = Object.prototype;
const { getPrototypeOf: $3b0e765f17086bfd$var$getPrototypeOf } = Object;
const { iterator: $3b0e765f17086bfd$var$iterator, toStringTag: $3b0e765f17086bfd$var$toStringTag } = Symbol;
const $3b0e765f17086bfd$var$kindOf = ((cache)=>(thing)=>{
        const str = $3b0e765f17086bfd$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $3b0e765f17086bfd$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$3b0e765f17086bfd$var$kindOf(thing) === type;
};
const $3b0e765f17086bfd$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $3b0e765f17086bfd$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $3b0e765f17086bfd$var$isUndefined = $3b0e765f17086bfd$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $3b0e765f17086bfd$var$isBuffer(val) {
    return val !== null && !$3b0e765f17086bfd$var$isUndefined(val) && val.constructor !== null && !$3b0e765f17086bfd$var$isUndefined(val.constructor) && $3b0e765f17086bfd$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $3b0e765f17086bfd$var$isArrayBuffer = $3b0e765f17086bfd$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $3b0e765f17086bfd$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $3b0e765f17086bfd$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $3b0e765f17086bfd$var$isString = $3b0e765f17086bfd$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $3b0e765f17086bfd$var$isFunction = $3b0e765f17086bfd$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $3b0e765f17086bfd$var$isNumber = $3b0e765f17086bfd$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $3b0e765f17086bfd$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $3b0e765f17086bfd$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $3b0e765f17086bfd$var$isPlainObject = (val)=>{
    if ($3b0e765f17086bfd$var$kindOf(val) !== 'object') return false;
    const prototype = $3b0e765f17086bfd$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($3b0e765f17086bfd$var$toStringTag in val) && !($3b0e765f17086bfd$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $3b0e765f17086bfd$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$3b0e765f17086bfd$var$isObject(val) || $3b0e765f17086bfd$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $3b0e765f17086bfd$var$isDate = $3b0e765f17086bfd$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $3b0e765f17086bfd$var$isFile = $3b0e765f17086bfd$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $3b0e765f17086bfd$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $3b0e765f17086bfd$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $3b0e765f17086bfd$var$isBlob = $3b0e765f17086bfd$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $3b0e765f17086bfd$var$isFileList = $3b0e765f17086bfd$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $3b0e765f17086bfd$var$isStream = (val)=>$3b0e765f17086bfd$var$isObject(val) && $3b0e765f17086bfd$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $3b0e765f17086bfd$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $3b0e765f17086bfd$var$G = $3b0e765f17086bfd$var$getGlobal();
const $3b0e765f17086bfd$var$FormDataCtor = typeof $3b0e765f17086bfd$var$G.FormData !== 'undefined' ? $3b0e765f17086bfd$var$G.FormData : undefined;
const $3b0e765f17086bfd$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($3b0e765f17086bfd$var$FormDataCtor && thing instanceof $3b0e765f17086bfd$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $3b0e765f17086bfd$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$3b0e765f17086bfd$var$isFunction(thing.append)) return false;
    const kind = $3b0e765f17086bfd$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $3b0e765f17086bfd$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $3b0e765f17086bfd$var$isURLSearchParams = $3b0e765f17086bfd$var$kindOfTest('URLSearchParams');
const [$3b0e765f17086bfd$var$isReadableStream, $3b0e765f17086bfd$var$isRequest, $3b0e765f17086bfd$var$isResponse, $3b0e765f17086bfd$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($3b0e765f17086bfd$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $3b0e765f17086bfd$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $3b0e765f17086bfd$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($3b0e765f17086bfd$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($3b0e765f17086bfd$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $3b0e765f17086bfd$var$findKey(obj, key) {
    if ($3b0e765f17086bfd$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $3b0e765f17086bfd$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $3b0e765f17086bfd$var$isContextDefined = (context)=>!$3b0e765f17086bfd$var$isUndefined(context) && context !== $3b0e765f17086bfd$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $3b0e765f17086bfd$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $3b0e765f17086bfd$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $3b0e765f17086bfd$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $3b0e765f17086bfd$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($3b0e765f17086bfd$var$isPlainObject(existing) && $3b0e765f17086bfd$var$isPlainObject(val)) result[targetKey] = $3b0e765f17086bfd$var$merge(existing, val);
        else if ($3b0e765f17086bfd$var$isPlainObject(val)) result[targetKey] = $3b0e765f17086bfd$var$merge({}, val);
        else if ($3b0e765f17086bfd$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$3b0e765f17086bfd$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++)objs[i] && $3b0e765f17086bfd$var$forEach(objs[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $3b0e765f17086bfd$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $3b0e765f17086bfd$var$forEach(b, (val, key)=>{
        if (thisArg && $3b0e765f17086bfd$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $5d219f656b13ee51$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $3b0e765f17086bfd$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $3b0e765f17086bfd$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $3b0e765f17086bfd$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $3b0e765f17086bfd$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $3b0e765f17086bfd$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $3b0e765f17086bfd$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($3b0e765f17086bfd$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$3b0e765f17086bfd$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $3b0e765f17086bfd$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $3b0e765f17086bfd$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $3b0e765f17086bfd$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$3b0e765f17086bfd$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $3b0e765f17086bfd$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $3b0e765f17086bfd$var$isHTMLForm = $3b0e765f17086bfd$var$kindOfTest('HTMLFormElement');
const $3b0e765f17086bfd$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $3b0e765f17086bfd$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $3b0e765f17086bfd$var$isRegExp = $3b0e765f17086bfd$var$kindOfTest('RegExp');
const $3b0e765f17086bfd$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $3b0e765f17086bfd$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $3b0e765f17086bfd$var$freezeMethods = (obj)=>{
    $3b0e765f17086bfd$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($3b0e765f17086bfd$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$3b0e765f17086bfd$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $3b0e765f17086bfd$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $3b0e765f17086bfd$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $3b0e765f17086bfd$var$noop = ()=>{};
const $3b0e765f17086bfd$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $3b0e765f17086bfd$var$isSpecCompliantForm(thing) {
    return !!(thing && $3b0e765f17086bfd$var$isFunction(thing.append) && thing[$3b0e765f17086bfd$var$toStringTag] === 'FormData' && thing[$3b0e765f17086bfd$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $3b0e765f17086bfd$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($3b0e765f17086bfd$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($3b0e765f17086bfd$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $3b0e765f17086bfd$var$isArray(source) ? [] : {};
                $3b0e765f17086bfd$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$3b0e765f17086bfd$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $3b0e765f17086bfd$var$isAsyncFn = $3b0e765f17086bfd$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $3b0e765f17086bfd$var$isThenable = (thing)=>thing && ($3b0e765f17086bfd$var$isObject(thing) || $3b0e765f17086bfd$var$isFunction(thing)) && $3b0e765f17086bfd$var$isFunction(thing.then) && $3b0e765f17086bfd$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $3b0e765f17086bfd$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $3b0e765f17086bfd$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $3b0e765f17086bfd$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $3b0e765f17086bfd$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $3b0e765f17086bfd$var$isFunction($3b0e765f17086bfd$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $3b0e765f17086bfd$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($3b0e765f17086bfd$var$_global) : $3b0e765f17086bfd$var$_setImmediate;
// *********************
const $3b0e765f17086bfd$var$isIterable = (thing)=>thing != null && $3b0e765f17086bfd$var$isFunction(thing[$3b0e765f17086bfd$var$iterator]);
var $3b0e765f17086bfd$export$2e2bcd8739ae039 = {
    isArray: $3b0e765f17086bfd$var$isArray,
    isArrayBuffer: $3b0e765f17086bfd$var$isArrayBuffer,
    isBuffer: $3b0e765f17086bfd$var$isBuffer,
    isFormData: $3b0e765f17086bfd$var$isFormData,
    isArrayBufferView: $3b0e765f17086bfd$var$isArrayBufferView,
    isString: $3b0e765f17086bfd$var$isString,
    isNumber: $3b0e765f17086bfd$var$isNumber,
    isBoolean: $3b0e765f17086bfd$var$isBoolean,
    isObject: $3b0e765f17086bfd$var$isObject,
    isPlainObject: $3b0e765f17086bfd$var$isPlainObject,
    isEmptyObject: $3b0e765f17086bfd$var$isEmptyObject,
    isReadableStream: $3b0e765f17086bfd$var$isReadableStream,
    isRequest: $3b0e765f17086bfd$var$isRequest,
    isResponse: $3b0e765f17086bfd$var$isResponse,
    isHeaders: $3b0e765f17086bfd$var$isHeaders,
    isUndefined: $3b0e765f17086bfd$var$isUndefined,
    isDate: $3b0e765f17086bfd$var$isDate,
    isFile: $3b0e765f17086bfd$var$isFile,
    isReactNativeBlob: $3b0e765f17086bfd$var$isReactNativeBlob,
    isReactNative: $3b0e765f17086bfd$var$isReactNative,
    isBlob: $3b0e765f17086bfd$var$isBlob,
    isRegExp: $3b0e765f17086bfd$var$isRegExp,
    isFunction: $3b0e765f17086bfd$var$isFunction,
    isStream: $3b0e765f17086bfd$var$isStream,
    isURLSearchParams: $3b0e765f17086bfd$var$isURLSearchParams,
    isTypedArray: $3b0e765f17086bfd$var$isTypedArray,
    isFileList: $3b0e765f17086bfd$var$isFileList,
    forEach: $3b0e765f17086bfd$var$forEach,
    merge: $3b0e765f17086bfd$var$merge,
    extend: $3b0e765f17086bfd$var$extend,
    trim: $3b0e765f17086bfd$var$trim,
    stripBOM: $3b0e765f17086bfd$var$stripBOM,
    inherits: $3b0e765f17086bfd$var$inherits,
    toFlatObject: $3b0e765f17086bfd$var$toFlatObject,
    kindOf: $3b0e765f17086bfd$var$kindOf,
    kindOfTest: $3b0e765f17086bfd$var$kindOfTest,
    endsWith: $3b0e765f17086bfd$var$endsWith,
    toArray: $3b0e765f17086bfd$var$toArray,
    forEachEntry: $3b0e765f17086bfd$var$forEachEntry,
    matchAll: $3b0e765f17086bfd$var$matchAll,
    isHTMLForm: $3b0e765f17086bfd$var$isHTMLForm,
    hasOwnProperty: $3b0e765f17086bfd$var$hasOwnProperty,
    hasOwnProp: $3b0e765f17086bfd$var$hasOwnProperty,
    reduceDescriptors: $3b0e765f17086bfd$var$reduceDescriptors,
    freezeMethods: $3b0e765f17086bfd$var$freezeMethods,
    toObjectSet: $3b0e765f17086bfd$var$toObjectSet,
    toCamelCase: $3b0e765f17086bfd$var$toCamelCase,
    noop: $3b0e765f17086bfd$var$noop,
    toFiniteNumber: $3b0e765f17086bfd$var$toFiniteNumber,
    findKey: $3b0e765f17086bfd$var$findKey,
    global: $3b0e765f17086bfd$var$_global,
    isContextDefined: $3b0e765f17086bfd$var$isContextDefined,
    isSpecCompliantForm: $3b0e765f17086bfd$var$isSpecCompliantForm,
    toJSONObject: $3b0e765f17086bfd$var$toJSONObject,
    isAsyncFn: $3b0e765f17086bfd$var$isAsyncFn,
    isThenable: $3b0e765f17086bfd$var$isThenable,
    setImmediate: $3b0e765f17086bfd$var$_setImmediate,
    asap: $3b0e765f17086bfd$var$asap,
    isIterable: $3b0e765f17086bfd$var$isIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $00ff3ca42995cecb$var$ignoreDuplicateOf = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $00ff3ca42995cecb$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $00ff3ca42995cecb$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $c017eadf116fe6ac$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $c017eadf116fe6ac$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $c017eadf116fe6ac$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $c017eadf116fe6ac$var$sanitizeValue(value, invalidChars) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$c017eadf116fe6ac$var$sanitizeValue(item, invalidChars));
    return $c017eadf116fe6ac$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $c017eadf116fe6ac$export$9e344cffce061a22 = (value)=>$c017eadf116fe6ac$var$sanitizeValue(value, $c017eadf116fe6ac$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $c017eadf116fe6ac$export$59dd66c2a12d8f62 = (value)=>$c017eadf116fe6ac$var$sanitizeValue(value, $c017eadf116fe6ac$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $c017eadf116fe6ac$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $c017eadf116fe6ac$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $2b4c00835bd82ca3$var$$internals = Symbol('internals');
function $2b4c00835bd82ca3$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $2b4c00835bd82ca3$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) ? value.map($2b4c00835bd82ca3$var$normalizeValue) : (0, $c017eadf116fe6ac$export$9e344cffce061a22)(String(value));
}
function $2b4c00835bd82ca3$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $2b4c00835bd82ca3$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $2b4c00835bd82ca3$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $2b4c00835bd82ca3$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $2b4c00835bd82ca3$var$buildAccessors(obj, header) {
    const accessorName = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $2b4c00835bd82ca3$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $2b4c00835bd82ca3$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$2b4c00835bd82ca3$var$isValidHeaderName(header)) setHeaders((0, $00ff3ca42995cecb$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(header) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $2b4c00835bd82ca3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $2b4c00835bd82ca3$var$parseTokens(value);
                if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $2b4c00835bd82ca3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $2b4c00835bd82ca3$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $2b4c00835bd82ca3$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $2b4c00835bd82ca3$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $2b4c00835bd82ca3$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$2b4c00835bd82ca3$var$$internals] = this[$2b4c00835bd82ca3$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $2b4c00835bd82ca3$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $2b4c00835bd82ca3$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$2b4c00835bd82ca3$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).reduceDescriptors($2b4c00835bd82ca3$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).freezeMethods($2b4c00835bd82ca3$var$AxiosHeaders);
var $2b4c00835bd82ca3$export$2e2bcd8739ae039 = $2b4c00835bd82ca3$var$AxiosHeaders;


'use strict';
const $1802f87332a7475d$var$REDACTED = '[REDACTED ****]';
function $1802f87332a7475d$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $1802f87332a7475d$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(source) && $1802f87332a7475d$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $1802f87332a7475d$var$REDACTED : visit(value);
                if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $1802f87332a7475d$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $1802f87332a7475d$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $1802f87332a7475d$var$redactConfig(config, redactKeys) : (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$1802f87332a7475d$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$1802f87332a7475d$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$1802f87332a7475d$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$1802f87332a7475d$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$1802f87332a7475d$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$1802f87332a7475d$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$1802f87332a7475d$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$1802f87332a7475d$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$1802f87332a7475d$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$1802f87332a7475d$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$1802f87332a7475d$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$1802f87332a7475d$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$1802f87332a7475d$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$1802f87332a7475d$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $1802f87332a7475d$export$2e2bcd8739ae039 = $1802f87332a7475d$var$AxiosError;


// eslint-disable-next-line strict
var $a161484968d4e2d6$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $de29dcc6a077369b$export$a143d493d941bafc;
var $de29dcc6a077369b$export$e4cf37d7f6fb9e0a;
var $de29dcc6a077369b$export$f99ded8fe4b79145;
var $de29dcc6a077369b$export$599f31c3813fae4d;
'use strict';
var $8cf1f36cb432a705$export$a48f0734ac7c2329;
var $8cf1f36cb432a705$export$d622b2ad8d90c771;
var $8cf1f36cb432a705$export$6100ba28696e12de;
'use strict';
$8cf1f36cb432a705$export$a48f0734ac7c2329 = $8cf1f36cb432a705$var$byteLength;
$8cf1f36cb432a705$export$d622b2ad8d90c771 = $8cf1f36cb432a705$var$toByteArray;
$8cf1f36cb432a705$export$6100ba28696e12de = $8cf1f36cb432a705$var$fromByteArray;
var $8cf1f36cb432a705$var$lookup = [];
var $8cf1f36cb432a705$var$revLookup = [];
var $8cf1f36cb432a705$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8cf1f36cb432a705$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8cf1f36cb432a705$var$i = 0, $8cf1f36cb432a705$var$len = $8cf1f36cb432a705$var$code.length; $8cf1f36cb432a705$var$i < $8cf1f36cb432a705$var$len; ++$8cf1f36cb432a705$var$i){
    $8cf1f36cb432a705$var$lookup[$8cf1f36cb432a705$var$i] = $8cf1f36cb432a705$var$code[$8cf1f36cb432a705$var$i];
    $8cf1f36cb432a705$var$revLookup[$8cf1f36cb432a705$var$code.charCodeAt($8cf1f36cb432a705$var$i)] = $8cf1f36cb432a705$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8cf1f36cb432a705$var$revLookup['-'.charCodeAt(0)] = 62;
$8cf1f36cb432a705$var$revLookup['_'.charCodeAt(0)] = 63;
function $8cf1f36cb432a705$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8cf1f36cb432a705$var$byteLength(b64) {
    var lens = $8cf1f36cb432a705$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8cf1f36cb432a705$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8cf1f36cb432a705$var$toByteArray(b64) {
    var tmp;
    var lens = $8cf1f36cb432a705$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8cf1f36cb432a705$var$Arr($8cf1f36cb432a705$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 18 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 2 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i)] << 10 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8cf1f36cb432a705$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8cf1f36cb432a705$var$tripletToBase64(num) {
    return $8cf1f36cb432a705$var$lookup[num >> 18 & 0x3F] + $8cf1f36cb432a705$var$lookup[num >> 12 & 0x3F] + $8cf1f36cb432a705$var$lookup[num >> 6 & 0x3F] + $8cf1f36cb432a705$var$lookup[num & 0x3F];
}
function $8cf1f36cb432a705$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8cf1f36cb432a705$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8cf1f36cb432a705$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8cf1f36cb432a705$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8cf1f36cb432a705$var$lookup[tmp >> 2] + $8cf1f36cb432a705$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8cf1f36cb432a705$var$lookup[tmp >> 10] + $8cf1f36cb432a705$var$lookup[tmp >> 4 & 0x3F] + $8cf1f36cb432a705$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $44ef5096b7191751$export$aafa59e2e03f2942;
var $44ef5096b7191751$export$68d8715fc104d294;
$44ef5096b7191751$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$44ef5096b7191751$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $de29dcc6a077369b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$de29dcc6a077369b$export$a143d493d941bafc = $de29dcc6a077369b$var$Buffer;
$de29dcc6a077369b$export$e4cf37d7f6fb9e0a = $de29dcc6a077369b$var$SlowBuffer;
$de29dcc6a077369b$export$f99ded8fe4b79145 = 50;
var $de29dcc6a077369b$var$K_MAX_LENGTH = 0x7fffffff;
$de29dcc6a077369b$export$599f31c3813fae4d = $de29dcc6a077369b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $de29dcc6a077369b$var$Buffer.TYPED_ARRAY_SUPPORT = $de29dcc6a077369b$var$typedArraySupport();
if (!$de29dcc6a077369b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $de29dcc6a077369b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($de29dcc6a077369b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$de29dcc6a077369b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($de29dcc6a077369b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$de29dcc6a077369b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $de29dcc6a077369b$var$createBuffer(length) {
    if (length > $de29dcc6a077369b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $de29dcc6a077369b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $de29dcc6a077369b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $de29dcc6a077369b$var$allocUnsafe(arg);
    }
    return $de29dcc6a077369b$var$from(arg, encodingOrOffset, length);
}
$de29dcc6a077369b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $de29dcc6a077369b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $de29dcc6a077369b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $de29dcc6a077369b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($de29dcc6a077369b$var$isInstance(value, ArrayBuffer) || value && $de29dcc6a077369b$var$isInstance(value.buffer, ArrayBuffer)) return $de29dcc6a077369b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($de29dcc6a077369b$var$isInstance(value, SharedArrayBuffer) || value && $de29dcc6a077369b$var$isInstance(value.buffer, SharedArrayBuffer))) return $de29dcc6a077369b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $de29dcc6a077369b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $de29dcc6a077369b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $de29dcc6a077369b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $de29dcc6a077369b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $de29dcc6a077369b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($de29dcc6a077369b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($de29dcc6a077369b$var$Buffer, Uint8Array);
function $de29dcc6a077369b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $de29dcc6a077369b$var$alloc(size, fill, encoding) {
    $de29dcc6a077369b$var$assertSize(size);
    if (size <= 0) return $de29dcc6a077369b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $de29dcc6a077369b$var$createBuffer(size).fill(fill, encoding) : $de29dcc6a077369b$var$createBuffer(size).fill(fill);
    return $de29dcc6a077369b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $de29dcc6a077369b$var$Buffer.alloc = function(size, fill, encoding) {
    return $de29dcc6a077369b$var$alloc(size, fill, encoding);
};
function $de29dcc6a077369b$var$allocUnsafe(size) {
    $de29dcc6a077369b$var$assertSize(size);
    return $de29dcc6a077369b$var$createBuffer(size < 0 ? 0 : $de29dcc6a077369b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $de29dcc6a077369b$var$Buffer.allocUnsafe = function(size) {
    return $de29dcc6a077369b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $de29dcc6a077369b$var$Buffer.allocUnsafeSlow = function(size) {
    return $de29dcc6a077369b$var$allocUnsafe(size);
};
function $de29dcc6a077369b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$de29dcc6a077369b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $de29dcc6a077369b$var$byteLength(string, encoding) | 0;
    var buf = $de29dcc6a077369b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $de29dcc6a077369b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $de29dcc6a077369b$var$checked(array.length) | 0;
    var buf = $de29dcc6a077369b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $de29dcc6a077369b$var$fromArrayView(arrayView) {
    if ($de29dcc6a077369b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $de29dcc6a077369b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $de29dcc6a077369b$var$fromArrayLike(arrayView);
}
function $de29dcc6a077369b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $de29dcc6a077369b$var$Buffer.prototype);
    return buf;
}
function $de29dcc6a077369b$var$fromObject(obj) {
    if ($de29dcc6a077369b$var$Buffer.isBuffer(obj)) {
        var len = $de29dcc6a077369b$var$checked(obj.length) | 0;
        var buf = $de29dcc6a077369b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $de29dcc6a077369b$var$numberIsNaN(obj.length)) return $de29dcc6a077369b$var$createBuffer(0);
        return $de29dcc6a077369b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $de29dcc6a077369b$var$fromArrayLike(obj.data);
}
function $de29dcc6a077369b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $de29dcc6a077369b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $de29dcc6a077369b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $de29dcc6a077369b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $de29dcc6a077369b$var$Buffer.alloc(+length);
}
$de29dcc6a077369b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $de29dcc6a077369b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$de29dcc6a077369b$var$Buffer.compare = function compare(a, b) {
    if ($de29dcc6a077369b$var$isInstance(a, Uint8Array)) a = $de29dcc6a077369b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($de29dcc6a077369b$var$isInstance(b, Uint8Array)) b = $de29dcc6a077369b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(a) || !$de29dcc6a077369b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$de29dcc6a077369b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$de29dcc6a077369b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $de29dcc6a077369b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $de29dcc6a077369b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($de29dcc6a077369b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $de29dcc6a077369b$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$de29dcc6a077369b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $de29dcc6a077369b$var$byteLength(string, encoding) {
    if ($de29dcc6a077369b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $de29dcc6a077369b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $de29dcc6a077369b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $de29dcc6a077369b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $de29dcc6a077369b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$de29dcc6a077369b$var$Buffer.byteLength = $de29dcc6a077369b$var$byteLength;
function $de29dcc6a077369b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $de29dcc6a077369b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $de29dcc6a077369b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $de29dcc6a077369b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $de29dcc6a077369b$var$latin1Slice(this, start, end);
        case 'base64':
            return $de29dcc6a077369b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de29dcc6a077369b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$de29dcc6a077369b$var$Buffer.prototype._isBuffer = true;
function $de29dcc6a077369b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$de29dcc6a077369b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$de29dcc6a077369b$var$swap(this, i, i + 1);
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $de29dcc6a077369b$var$swap(this, i, i + 3);
        $de29dcc6a077369b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $de29dcc6a077369b$var$swap(this, i, i + 7);
        $de29dcc6a077369b$var$swap(this, i + 1, i + 6);
        $de29dcc6a077369b$var$swap(this, i + 2, i + 5);
        $de29dcc6a077369b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$de29dcc6a077369b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $de29dcc6a077369b$var$utf8Slice(this, 0, length);
    return $de29dcc6a077369b$var$slowToString.apply(this, arguments);
};
$de29dcc6a077369b$var$Buffer.prototype.toLocaleString = $de29dcc6a077369b$var$Buffer.prototype.toString;
$de29dcc6a077369b$var$Buffer.prototype.equals = function equals(b) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $de29dcc6a077369b$var$Buffer.compare(this, b) === 0;
};
$de29dcc6a077369b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $de29dcc6a077369b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($de29dcc6a077369b$var$customInspectSymbol) $de29dcc6a077369b$var$Buffer.prototype[$de29dcc6a077369b$var$customInspectSymbol] = $de29dcc6a077369b$var$Buffer.prototype.inspect;
$de29dcc6a077369b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($de29dcc6a077369b$var$isInstance(target, Uint8Array)) target = $de29dcc6a077369b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $de29dcc6a077369b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($de29dcc6a077369b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $de29dcc6a077369b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($de29dcc6a077369b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $de29dcc6a077369b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $de29dcc6a077369b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $de29dcc6a077369b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$de29dcc6a077369b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$de29dcc6a077369b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $de29dcc6a077369b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$de29dcc6a077369b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $de29dcc6a077369b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $de29dcc6a077369b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($de29dcc6a077369b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $de29dcc6a077369b$var$utf8Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $de29dcc6a077369b$var$asciiWrite(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$asciiToBytes(string), buf, offset, length);
}
function $de29dcc6a077369b$var$base64Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$base64ToBytes(string), buf, offset, length);
}
function $de29dcc6a077369b$var$ucs2Write(buf, string, offset, length) {
    return $de29dcc6a077369b$var$blitBuffer($de29dcc6a077369b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$de29dcc6a077369b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $de29dcc6a077369b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $de29dcc6a077369b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $de29dcc6a077369b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $de29dcc6a077369b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de29dcc6a077369b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$de29dcc6a077369b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $de29dcc6a077369b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8cf1f36cb432a705$export$6100ba28696e12de(buf);
    else return $8cf1f36cb432a705$export$6100ba28696e12de(buf.slice(start, end));
}
function $de29dcc6a077369b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $de29dcc6a077369b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $de29dcc6a077369b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $de29dcc6a077369b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $de29dcc6a077369b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $de29dcc6a077369b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $de29dcc6a077369b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $de29dcc6a077369b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $de29dcc6a077369b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$de29dcc6a077369b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $de29dcc6a077369b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $de29dcc6a077369b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$de29dcc6a077369b$var$Buffer.prototype.readUintLE = $de29dcc6a077369b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readUintBE = $de29dcc6a077369b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint8 = $de29dcc6a077369b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$de29dcc6a077369b$var$Buffer.prototype.readUint16LE = $de29dcc6a077369b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint16BE = $de29dcc6a077369b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$de29dcc6a077369b$var$Buffer.prototype.readUint32LE = $de29dcc6a077369b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$de29dcc6a077369b$var$Buffer.prototype.readUint32BE = $de29dcc6a077369b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$de29dcc6a077369b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$de29dcc6a077369b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$de29dcc6a077369b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$de29dcc6a077369b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 4, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$de29dcc6a077369b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 8, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$de29dcc6a077369b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkOffset(offset, 8, this.length);
    return $44ef5096b7191751$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $de29dcc6a077369b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$de29dcc6a077369b$var$Buffer.prototype.writeUintLE = $de29dcc6a077369b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUintBE = $de29dcc6a077369b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint8 = $de29dcc6a077369b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint16LE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint16BE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint32LE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeUint32BE = $de29dcc6a077369b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $de29dcc6a077369b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$de29dcc6a077369b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $de29dcc6a077369b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $44ef5096b7191751$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$de29dcc6a077369b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeFloat(this, value, offset, true, noAssert);
};
$de29dcc6a077369b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeFloat(this, value, offset, false, noAssert);
};
function $de29dcc6a077369b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de29dcc6a077369b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $44ef5096b7191751$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$de29dcc6a077369b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeDouble(this, value, offset, true, noAssert);
};
$de29dcc6a077369b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $de29dcc6a077369b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$de29dcc6a077369b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$de29dcc6a077369b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$de29dcc6a077369b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$de29dcc6a077369b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $de29dcc6a077369b$var$Buffer.isBuffer(val) ? val : $de29dcc6a077369b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $de29dcc6a077369b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $de29dcc6a077369b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($de29dcc6a077369b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $de29dcc6a077369b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $de29dcc6a077369b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $de29dcc6a077369b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $de29dcc6a077369b$var$base64ToBytes(str) {
    return $8cf1f36cb432a705$export$d622b2ad8d90c771($de29dcc6a077369b$var$base64clean(str));
}
function $de29dcc6a077369b$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $de29dcc6a077369b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $de29dcc6a077369b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $de29dcc6a077369b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $987194e734735588$require$Buffer = $de29dcc6a077369b$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $987194e734735588$var$isVisitable(thing) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $987194e734735588$var$removeBrackets(key) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $987194e734735588$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $987194e734735588$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $987194e734735588$var$isFlatArray(arr) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(arr) && !arr.some($987194e734735588$var$isVisitable);
}
const $987194e734735588$var$predicates = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject((0, $3b0e765f17086bfd$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $987194e734735588$var$toFormData(obj, formData, options) {
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $a161484968d4e2d6$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $987194e734735588$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReactNative(formData) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($987194e734735588$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(value) && $987194e734735588$var$isFlatArray(value) || ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFileList(value) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $987194e734735588$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $987194e734735588$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($987194e734735588$var$isVisitable(value)) return true;
        formData.append($987194e734735588$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($987194e734735588$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $987194e734735588$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $987194e734735588$export$2e2bcd8739ae039 = $987194e734735588$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $2d62ebc7b44b3614$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $2d62ebc7b44b3614$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $987194e734735588$export$2e2bcd8739ae039)(params, this, options);
}
const $2d62ebc7b44b3614$var$prototype = $2d62ebc7b44b3614$var$AxiosURLSearchParams.prototype;
$2d62ebc7b44b3614$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$2d62ebc7b44b3614$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $2d62ebc7b44b3614$var$encode);
    } : $2d62ebc7b44b3614$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $2d62ebc7b44b3614$export$2e2bcd8739ae039 = $2d62ebc7b44b3614$var$AxiosURLSearchParams;


'use strict';
function $cc1325dddfd5d959$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $cc1325dddfd5d959$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $cc1325dddfd5d959$export$c564cdbbe6da493;
    const _options = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $2d62ebc7b44b3614$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $a420fff59be7902c$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $a420fff59be7902c$export$2e2bcd8739ae039 = $a420fff59be7902c$var$InterceptorManager;





'use strict';
var $9db4fba95d842126$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $34729f01ce81b7d2$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $2d62ebc7b44b3614$export$2e2bcd8739ae039);


'use strict';
var $19ab5cefba3b154c$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $8356c2adc32eacfe$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $f2ec196bcb20148e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $34729f01ce81b7d2$export$2e2bcd8739ae039,
        FormData: $19ab5cefba3b154c$export$2e2bcd8739ae039,
        Blob: $8356c2adc32eacfe$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $8ea2ef8349325b95$exports = {};

$parcel$export($8ea2ef8349325b95$exports, "hasBrowserEnv", () => $8ea2ef8349325b95$export$c4996c4b7b93b0bf);
$parcel$export($8ea2ef8349325b95$exports, "navigator", () => $8ea2ef8349325b95$export$ec7c8efa7f5790ae);
$parcel$export($8ea2ef8349325b95$exports, "hasStandardBrowserEnv", () => $8ea2ef8349325b95$export$c0bcc9250309d66);
$parcel$export($8ea2ef8349325b95$exports, "hasStandardBrowserWebWorkerEnv", () => $8ea2ef8349325b95$export$c81692cf5af97dac);
$parcel$export($8ea2ef8349325b95$exports, "origin", () => $8ea2ef8349325b95$export$f710a83a91838a36);
const $8ea2ef8349325b95$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $8ea2ef8349325b95$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $8ea2ef8349325b95$export$c0bcc9250309d66 = $8ea2ef8349325b95$export$c4996c4b7b93b0bf && (!$8ea2ef8349325b95$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($8ea2ef8349325b95$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $8ea2ef8349325b95$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $8ea2ef8349325b95$export$f710a83a91838a36 = $8ea2ef8349325b95$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $5d16336510b0e3a5$export$2e2bcd8739ae039 = {
    ...$8ea2ef8349325b95$exports,
    ...(0, $f2ec196bcb20148e$export$2e2bcd8739ae039)
};


'use strict';
function $54c9a72f9f4172e8$export$2e2bcd8739ae039(data, options) {
    return (0, $987194e734735588$export$2e2bcd8739ae039)(data, new (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).isNode && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $9d923ad61888379b$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $9d923ad61888379b$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $9d923ad61888379b$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $9d923ad61888379b$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(formData) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($9d923ad61888379b$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $9d923ad61888379b$export$2e2bcd8739ae039 = $9d923ad61888379b$var$formDataToJSON;


'use strict';
const $5d85921ddf900d80$var$own = (obj, key)=>obj != null && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $5d85921ddf900d80$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $5d85921ddf900d80$var$defaults = {
    transitional: (0, $9db4fba95d842126$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $9d923ad61888379b$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBuffer(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isStream(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFile(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $5d85921ddf900d80$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $54c9a72f9f4172e8$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $5d85921ddf900d80$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $987194e734735588$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $5d85921ddf900d80$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $5d85921ddf900d80$var$own(this, 'transitional') || $5d85921ddf900d80$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $5d85921ddf900d80$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isResponse(data) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $5d85921ddf900d80$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $1802f87332a7475d$export$2e2bcd8739ae039).from(e, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $5d85921ddf900d80$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $5d85921ddf900d80$var$defaults.headers[method] = {};
});
var $5d85921ddf900d80$export$2e2bcd8739ae039 = $5d85921ddf900d80$var$defaults;



'use strict';
function $cf865322512f7c70$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $5d85921ddf900d80$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $96fd7b558634ab1c$var$CanceledError extends (0, $1802f87332a7475d$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $96fd7b558634ab1c$export$2e2bcd8739ae039 = $96fd7b558634ab1c$var$CanceledError;







'use strict';
function $b50ed5d1058a3519$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $c0626b65ee4f58ad$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $86b5300eb8c2d89a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $86b5300eb8c2d89a$export$2e2bcd8739ae039 = $86b5300eb8c2d89a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $1e06ddf250092091$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $1e06ddf250092091$export$2e2bcd8739ae039 = $1e06ddf250092091$var$throttle;



const $08491b187ed7125f$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $86b5300eb8c2d89a$export$2e2bcd8739ae039)(50, 250);
    return (0, $1e06ddf250092091$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $08491b187ed7125f$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $08491b187ed7125f$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $654ad96f5dc2640f$export$2e2bcd8739ae039 = (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin), (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $7e458861153e1793$export$2e2bcd8739ae039 = (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $b3c557b1375283cb$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $26a5e67631084dd7$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $209a10c5f4d85343$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $b3c557b1375283cb$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $26a5e67631084dd7$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $3714d3e24358701c$var$headersToObject = (thing)=>thing instanceof (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $3714d3e24358701c$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(target) && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3714d3e24358701c$var$headersToObject(a), $3714d3e24358701c$var$headersToObject(b), prop, true)
    };
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




const $e73b2be4d36acc11$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $e73b2be4d36acc11$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($e73b2be4d36acc11$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e73b2be4d36acc11$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
var $e73b2be4d36acc11$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $3714d3e24358701c$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $cc1325dddfd5d959$export$2e2bcd8739ae039)((0, $209a10c5f4d85343$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $e73b2be4d36acc11$var$encodeUTF8(auth.password) : '')));
    if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $e73b2be4d36acc11$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $654ad96f5dc2640f$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $7e458861153e1793$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};



const $665ff90d985d53de$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $665ff90d985d53de$export$2e2bcd8739ae039 = $665ff90d985d53de$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $e73b2be4d36acc11$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b50ed5d1058a3519$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Request aborted', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(msg, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $9db4fba95d842126$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $1802f87332a7475d$export$2e2bcd8739ae039).ETIMEDOUT : (0, $1802f87332a7475d$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach((0, $c017eadf116fe6ac$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $08491b187ed7125f$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $08491b187ed7125f$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $c0626b65ee4f58ad$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $5d16336510b0e3a5$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $08a9a6bf5f67a1dd$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $1802f87332a7475d$export$2e2bcd8739ae039) ? err : new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $08a9a6bf5f67a1dd$export$2e2bcd8739ae039 = $08a9a6bf5f67a1dd$var$composeSignals;


const $5bfc0d8311c377d7$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $5bfc0d8311c377d7$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $5bfc0d8311c377d7$var$readStream(iterable))yield* $5bfc0d8311c377d7$export$71b051935044bd5d(chunk, chunkSize);
};
const $5bfc0d8311c377d7$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $5bfc0d8311c377d7$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $5bfc0d8311c377d7$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $8659296f9dc2c430$require$Buffer = $de29dcc6a077369b$export$a143d493d941bafc;
function $8659296f9dc2c430$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $8659296f9dc2c430$require$Buffer !== 'undefined' && typeof $8659296f9dc2c430$require$Buffer.byteLength === 'function') return $8659296f9dc2c430$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $73d2af2398262305$export$a4ad2735b021c132 = "1.16.1";



const $db39780280fa948e$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $db39780280fa948e$var$isFunction } = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039);
const $db39780280fa948e$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $db39780280fa948e$var$factory = (env)=>{
    const globalObject = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).global !== undefined && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).global !== null ? (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $db39780280fa948e$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $db39780280fa948e$var$isFunction(Request);
    const isResponseSupported = $db39780280fa948e$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $db39780280fa948e$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $db39780280fa948e$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $db39780280fa948e$var$test(()=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $5d16336510b0e3a5$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $e73b2be4d36acc11$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $08a9a6bf5f67a1dd$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $8659296f9dc2c430$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $08491b187ed7125f$export$d9fadd12586c18d6)(requestContentLength, (0, $08491b187ed7125f$export$c1b28109d46c3592)((0, $08491b187ed7125f$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $5bfc0d8311c377d7$export$b0119225647bd83)(_request.body, $db39780280fa948e$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $73d2af2398262305$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $c017eadf116fe6ac$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $08491b187ed7125f$export$d9fadd12586c18d6)(responseContentLength, (0, $08491b187ed7125f$export$c1b28109d46c3592)((0, $08491b187ed7125f$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $5bfc0d8311c377d7$export$b0119225647bd83)(response.body, $db39780280fa948e$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $b50ed5d1058a3519$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $1802f87332a7475d$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Network Error', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $1802f87332a7475d$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $db39780280fa948e$var$seedCache = new Map();
const $db39780280fa948e$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $db39780280fa948e$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $db39780280fa948e$var$factory(env));
        map = target;
    }
    return target;
};
const $db39780280fa948e$var$adapter = $db39780280fa948e$export$3105c6651375d4fa();
var $db39780280fa948e$export$2e2bcd8739ae039 = $db39780280fa948e$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $2945414447657243$var$knownAdapters = {
    http: (0, $a161484968d4e2d6$export$2e2bcd8739ae039),
    xhr: (0, $665ff90d985d53de$export$2e2bcd8739ae039),
    fetch: {
        get: $db39780280fa948e$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach($2945414447657243$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $2945414447657243$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $2945414447657243$var$isResolvedHandle = (adapter)=>(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $2945414447657243$var$getAdapter(adapters, config) {
    adapters = (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$2945414447657243$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $2945414447657243$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($2945414447657243$var$renderReason).join('\n') : ' ' + $2945414447657243$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $2945414447657243$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $2945414447657243$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $2945414447657243$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f06f8d6e3348094a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(null, config);
}
function $f06f8d6e3348094a$export$2e2bcd8739ae039(config) {
    $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
    config.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $2945414447657243$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $5d85921ddf900d80$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039)(reason)) {
            $f06f8d6e3348094a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $cf865322512f7c70$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $97dffca93d4e7f32$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $97dffca93d4e7f32$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $97dffca93d4e7f32$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $97dffca93d4e7f32$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $73d2af2398262305$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$97dffca93d4e7f32$var$deprecatedWarnings[opt]) {
            $97dffca93d4e7f32$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$97dffca93d4e7f32$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $97dffca93d4e7f32$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('options must be an object', (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $1802f87332a7475d$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $1802f87332a7475d$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $97dffca93d4e7f32$export$2e2bcd8739ae039 = {
    assertOptions: $97dffca93d4e7f32$var$assertOptions,
    validators: $97dffca93d4e7f32$var$validators
};




'use strict';
const $0979936342606ee7$var$validators = (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $0979936342606ee7$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $a420fff59be7902c$export$2e2bcd8739ae039)(),
            response: new (0, $a420fff59be7902c$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $3714d3e24358701c$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean),
            forcedJSONParsing: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean),
            clarifyTimeoutError: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean),
            legacyInterceptorReqResOrdering: $0979936342606ee7$var$validators.transitional($0979936342606ee7$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $0979936342606ee7$var$validators.function,
                serialize: $0979936342606ee7$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $97dffca93d4e7f32$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $0979936342606ee7$var$validators.spelling('baseURL'),
            withXsrfToken: $0979936342606ee7$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $9db4fba95d842126$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f06f8d6e3348094a$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f06f8d6e3348094a$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $3714d3e24358701c$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $209a10c5f4d85343$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $cc1325dddfd5d959$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0979936342606ee7$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $3714d3e24358701c$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $3b0e765f17086bfd$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $3714d3e24358701c$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $0979936342606ee7$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $0979936342606ee7$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $0979936342606ee7$export$2e2bcd8739ae039 = $0979936342606ee7$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $edb97a8a31a981a0$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $96fd7b558634ab1c$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $edb97a8a31a981a0$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $edb97a8a31a981a0$export$2e2bcd8739ae039 = $edb97a8a31a981a0$var$CancelToken;






'use strict';
function $b9d9bbe99a0c13e8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $c7eac602bd26f638$export$2e2bcd8739ae039(payload) {
    return (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $7f625779f2088931$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($7f625779f2088931$var$HttpStatusCode).forEach(([key, value])=>{
    $7f625779f2088931$var$HttpStatusCode[value] = key;
});
var $7f625779f2088931$export$2e2bcd8739ae039 = $7f625779f2088931$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $4caf0f2bcd8b9e34$var$createInstance(defaultConfig) {
    const context = new (0, $0979936342606ee7$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $5d219f656b13ee51$export$2e2bcd8739ae039)((0, $0979936342606ee7$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).extend(instance, (0, $0979936342606ee7$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $3b0e765f17086bfd$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $4caf0f2bcd8b9e34$var$createInstance((0, $3714d3e24358701c$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $4caf0f2bcd8b9e34$var$axios = $4caf0f2bcd8b9e34$var$createInstance((0, $5d85921ddf900d80$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$4caf0f2bcd8b9e34$var$axios.Axios = (0, $0979936342606ee7$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$4caf0f2bcd8b9e34$var$axios.CanceledError = (0, $96fd7b558634ab1c$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.CancelToken = (0, $edb97a8a31a981a0$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.isCancel = (0, $7cd3b9ae9fdfe84a$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.VERSION = (0, $73d2af2398262305$export$a4ad2735b021c132);
$4caf0f2bcd8b9e34$var$axios.toFormData = (0, $987194e734735588$export$2e2bcd8739ae039);
// Expose AxiosError class
$4caf0f2bcd8b9e34$var$axios.AxiosError = (0, $1802f87332a7475d$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$4caf0f2bcd8b9e34$var$axios.Cancel = $4caf0f2bcd8b9e34$var$axios.CanceledError;
// Expose all/spread
$4caf0f2bcd8b9e34$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$4caf0f2bcd8b9e34$var$axios.spread = (0, $b9d9bbe99a0c13e8$export$2e2bcd8739ae039);
// Expose isAxiosError
$4caf0f2bcd8b9e34$var$axios.isAxiosError = (0, $c7eac602bd26f638$export$2e2bcd8739ae039);
// Expose mergeConfig
$4caf0f2bcd8b9e34$var$axios.mergeConfig = (0, $3714d3e24358701c$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.AxiosHeaders = (0, $2b4c00835bd82ca3$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.formToJSON = (thing)=>(0, $9d923ad61888379b$export$2e2bcd8739ae039)((0, $3b0e765f17086bfd$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$4caf0f2bcd8b9e34$var$axios.getAdapter = (0, $2945414447657243$export$2e2bcd8739ae039).getAdapter;
$4caf0f2bcd8b9e34$var$axios.HttpStatusCode = (0, $7f625779f2088931$export$2e2bcd8739ae039);
$4caf0f2bcd8b9e34$var$axios.default = $4caf0f2bcd8b9e34$var$axios;
var // this module should only have a default export
$4caf0f2bcd8b9e34$export$2e2bcd8739ae039 = $4caf0f2bcd8b9e34$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b0959eebdd834785$export$1c00760e9e5a4e95, AxiosError: $b0959eebdd834785$export$c1fbed17c2f6a328, CanceledError: $b0959eebdd834785$export$1ab0c6b20d94fa14, isCancel: $b0959eebdd834785$export$3b22524397b493c6, CancelToken: $b0959eebdd834785$export$fd08e3cb425f0d61, VERSION: $b0959eebdd834785$export$a4ad2735b021c132, all: $b0959eebdd834785$export$84bf76cd7afc7469, Cancel: $b0959eebdd834785$export$848c9b7ead0df967, isAxiosError: $b0959eebdd834785$export$fbafdbe06a5b5a9a, spread: $b0959eebdd834785$export$3ae0fd4797ed47c8, toFormData: $b0959eebdd834785$export$10ae0d317ea97f8b, AxiosHeaders: $b0959eebdd834785$export$4e7d6ff0f3e6520, HttpStatusCode: $b0959eebdd834785$export$a972f69c851492b3, formToJSON: $b0959eebdd834785$export$86d7c59254d6a2c9, getAdapter: $b0959eebdd834785$export$17ddc20a97d669e2, mergeConfig: $b0959eebdd834785$export$7ec1ebcfa9d8bd6a, create: $b0959eebdd834785$export$185802fd694ee1f5 } = (0, $4caf0f2bcd8b9e34$export$2e2bcd8739ae039);


var $41c099b1976cc56f$exports = {};
(function(global1, factory) {
    $41c099b1976cc56f$exports = factory();
})($41c099b1976cc56f$exports, function() {
    'use strict';
    var toStringFunction = Function.prototype.toString;
    var create = Object.create, defineProperty = Object.defineProperty, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getPrototypeOf$1 = Object.getPrototypeOf;
    var _a = Object.prototype, hasOwnProperty = _a.hasOwnProperty, propertyIsEnumerable = _a.propertyIsEnumerable;
    var SYMBOL_PROPERTIES = typeof getOwnPropertySymbols === 'function';
    var WEAK_MAP = typeof WeakMap === 'function';
    /**
     * @function createCache
     *
     * @description
     * get a new cache object to prevent circular references
     *
     * @returns the new cache object
     */ var createCache = function() {
        if (WEAK_MAP) return function() {
            return new WeakMap();
        };
        var Cache = /** @class */ function() {
            function Cache() {
                this._keys = [];
                this._values = [];
            }
            Cache.prototype.has = function(key) {
                return !!~this._keys.indexOf(key);
            };
            Cache.prototype.get = function(key) {
                return this._values[this._keys.indexOf(key)];
            };
            Cache.prototype.set = function(key, value) {
                this._keys.push(key);
                this._values.push(value);
            };
            return Cache;
        }();
        return function() {
            return new Cache();
        };
    }();
    /**
     * @function getCleanClone
     *
     * @description
     * get an empty version of the object with the same prototype it has
     *
     * @param object the object to build a clean clone from
     * @param realm the realm the object resides in
     * @returns the empty cloned object
     */ var getCleanClone = function(object, realm) {
        var prototype = object.__proto__ || getPrototypeOf$1(object);
        if (!prototype) return create(null);
        var Constructor = prototype.constructor;
        if (Constructor === realm.Object) return prototype === realm.Object.prototype ? {} : create(prototype);
        if (~toStringFunction.call(Constructor).indexOf('[native code]')) try {
            return new Constructor();
        } catch (_a) {}
        return create(prototype);
    };
    /**
     * @function getObjectCloneLoose
     *
     * @description
     * get a copy of the object based on loose rules, meaning all enumerable keys
     * and symbols are copied, but property descriptors are not considered
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneLoose = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        for(var key in object)if (hasOwnProperty.call(object, key)) clone[key] = handleCopy(object[key], cache);
        if (SYMBOL_PROPERTIES) {
            var symbols = getOwnPropertySymbols(object);
            for(var index = 0, length_1 = symbols.length, symbol = void 0; index < length_1; ++index){
                symbol = symbols[index];
                if (propertyIsEnumerable.call(object, symbol)) clone[symbol] = handleCopy(object[symbol], cache);
            }
        }
        return clone;
    };
    /**
     * @function getObjectCloneStrict
     *
     * @description
     * get a copy of the object based on strict rules, meaning all keys and symbols
     * are copied based on the original property descriptors
     *
     * @param object the object to clone
     * @param realm the realm the object resides in
     * @param handleCopy the function that handles copying the object
     * @returns the copied object
     */ var getObjectCloneStrict = function(object, realm, handleCopy, cache) {
        var clone = getCleanClone(object, realm);
        // set in the cache immediately to be able to reuse the object recursively
        cache.set(object, clone);
        var properties = SYMBOL_PROPERTIES ? getOwnPropertyNames(object).concat(getOwnPropertySymbols(object)) : getOwnPropertyNames(object);
        for(var index = 0, length_2 = properties.length, property = void 0, descriptor = void 0; index < length_2; ++index){
            property = properties[index];
            if (property !== 'callee' && property !== 'caller') {
                descriptor = getOwnPropertyDescriptor(object, property);
                if (descriptor) {
                    // Only clone the value if actually a value, not a getter / setter.
                    if (!descriptor.get && !descriptor.set) descriptor.value = handleCopy(object[property], cache);
                    try {
                        defineProperty(clone, property, descriptor);
                    } catch (error) {
                        // Tee above can fail on node in edge cases, so fall back to the loose assignment.
                        clone[property] = descriptor.value;
                    }
                } else // In extra edge cases where the property descriptor cannot be retrived, fall back to
                // the loose assignment.
                clone[property] = handleCopy(object[property], cache);
            }
        }
        return clone;
    };
    /**
     * @function getRegExpFlags
     *
     * @description
     * get the flags to apply to the copied regexp
     *
     * @param regExp the regexp to get the flags of
     * @returns the flags for the regexp
     */ var getRegExpFlags = function(regExp) {
        var flags = '';
        if (regExp.global) flags += 'g';
        if (regExp.ignoreCase) flags += 'i';
        if (regExp.multiline) flags += 'm';
        if (regExp.unicode) flags += 'u';
        if (regExp.sticky) flags += 'y';
        return flags;
    };
    // utils
    var isArray = Array.isArray;
    var getPrototypeOf = Object.getPrototypeOf;
    var GLOBAL_THIS = function() {
        if (typeof globalThis !== 'undefined') return globalThis;
        if (typeof self !== 'undefined') return self;
        if (typeof window !== 'undefined') return window;
        if (typeof $parcel$global !== 'undefined') return $parcel$global;
        if (console && console.error) console.error('Unable to locate global object, returning "this".');
        return this;
    }();
    /**
     * @function copy
     *
     * @description
     * copy an value deeply as much as possible
     *
     * If `strict` is applied, then all properties (including non-enumerable ones)
     * are copied with their original property descriptors on both objects and arrays.
     *
     * The value is compared to the global constructors in the `realm` provided,
     * and the native constructor is always used to ensure that extensions of native
     * objects (allows in ES2015+) are maintained.
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.isStrict] should the copy be strict
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ function copy(value, options) {
        // manually coalesced instead of default parameters for performance
        var isStrict = !!(options && options.isStrict);
        var realm = options && options.realm || GLOBAL_THIS;
        var getObjectClone = isStrict ? getObjectCloneStrict : getObjectCloneLoose;
        /**
         * @function handleCopy
         *
         * @description
         * copy the value recursively based on its type
         *
         * @param value the value to copy
         * @returns the copied value
         */ var handleCopy = function(value, cache) {
            if (!value || typeof value !== 'object') return value;
            if (cache.has(value)) return cache.get(value);
            var prototype = value.__proto__ || getPrototypeOf(value);
            var Constructor = prototype && prototype.constructor;
            // plain objects
            if (!Constructor || Constructor === realm.Object) return getObjectClone(value, realm, handleCopy, cache);
            var clone;
            // arrays
            if (isArray(value)) {
                // if strict, include non-standard properties
                if (isStrict) return getObjectCloneStrict(value, realm, handleCopy, cache);
                clone = new Constructor();
                cache.set(value, clone);
                for(var index = 0, length_1 = value.length; index < length_1; ++index)clone[index] = handleCopy(value[index], cache);
                return clone;
            }
            // dates
            if (value instanceof realm.Date) return new Constructor(value.getTime());
            // regexps
            if (value instanceof realm.RegExp) {
                clone = new Constructor(value.source, value.flags || getRegExpFlags(value));
                clone.lastIndex = value.lastIndex;
                return clone;
            }
            // maps
            if (realm.Map && value instanceof realm.Map) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value, key) {
                    clone.set(key, handleCopy(value, cache));
                });
                return clone;
            }
            // sets
            if (realm.Set && value instanceof realm.Set) {
                clone = new Constructor();
                cache.set(value, clone);
                value.forEach(function(value) {
                    clone.add(handleCopy(value, cache));
                });
                return clone;
            }
            // blobs
            if (realm.Blob && value instanceof realm.Blob) return value.slice(0, value.size, value.type);
            // buffers (node-only)
            if (realm.Buffer && realm.Buffer.isBuffer(value)) {
                clone = realm.Buffer.allocUnsafe ? realm.Buffer.allocUnsafe(value.length) : new Constructor(value.length);
                cache.set(value, clone);
                value.copy(clone);
                return clone;
            }
            // arraybuffers / dataviews
            if (realm.ArrayBuffer) {
                // dataviews
                if (realm.ArrayBuffer.isView(value)) {
                    clone = new Constructor(value.buffer.slice(0));
                    cache.set(value, clone);
                    return clone;
                }
                // arraybuffers
                if (value instanceof realm.ArrayBuffer) {
                    clone = value.slice(0);
                    cache.set(value, clone);
                    return clone;
                }
            }
            // if the value cannot / should not be cloned, don't
            if (// promise-like
            typeof value.then === 'function' || // errors
            value instanceof Error || // weakmaps
            realm.WeakMap && value instanceof realm.WeakMap || // weaksets
            realm.WeakSet && value instanceof realm.WeakSet) return value;
            // assume anything left is a custom constructor
            return getObjectClone(value, realm, handleCopy, cache);
        };
        return handleCopy(value, createCache());
    }
    // Adding reference to allow usage in CommonJS libraries compiled using TSC, which
    // expects there to be a default property on the exported value. See
    // [#37](https://github.com/planttheidea/fast-copy/issues/37) for details.
    copy.default = copy;
    /**
     * @function strictCopy
     *
     * @description
     * copy the value with `strict` option pre-applied
     *
     * @param value the value to copy
     * @param [options] the options for copying with
     * @param [options.realm] the realm (this) value the value is copied from
     * @returns the copied value
     */ copy.strict = function strictCopy(value, options) {
        return copy(value, {
            isStrict: true,
            realm: options ? options.realm : void 0
        });
    };
    return copy;
});


var $6e19be61753cbc35$exports = {};
'use strict';
var $79acdf0dd8ee88cb$exports = {};
'use strict';
var $41979e9c210b0e24$exports = {};
'use strict';
var $6e764c828aee0516$exports = {};
'use strict';
/** @type {import('./type')} */ $6e764c828aee0516$exports = TypeError;


var $5a5c8f99294101b7$exports = {};
var $5a5c8f99294101b7$var$hasMap = typeof Map === 'function' && Map.prototype;
var $5a5c8f99294101b7$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $5a5c8f99294101b7$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $5a5c8f99294101b7$var$mapSize = $5a5c8f99294101b7$var$hasMap && $5a5c8f99294101b7$var$mapSizeDescriptor && typeof $5a5c8f99294101b7$var$mapSizeDescriptor.get === 'function' ? $5a5c8f99294101b7$var$mapSizeDescriptor.get : null;
var $5a5c8f99294101b7$var$mapForEach = $5a5c8f99294101b7$var$hasMap && Map.prototype.forEach;
var $5a5c8f99294101b7$var$hasSet = typeof Set === 'function' && Set.prototype;
var $5a5c8f99294101b7$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $5a5c8f99294101b7$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $5a5c8f99294101b7$var$setSize = $5a5c8f99294101b7$var$hasSet && $5a5c8f99294101b7$var$setSizeDescriptor && typeof $5a5c8f99294101b7$var$setSizeDescriptor.get === 'function' ? $5a5c8f99294101b7$var$setSizeDescriptor.get : null;
var $5a5c8f99294101b7$var$setForEach = $5a5c8f99294101b7$var$hasSet && Set.prototype.forEach;
var $5a5c8f99294101b7$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $5a5c8f99294101b7$var$weakMapHas = $5a5c8f99294101b7$var$hasWeakMap ? WeakMap.prototype.has : null;
var $5a5c8f99294101b7$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $5a5c8f99294101b7$var$weakSetHas = $5a5c8f99294101b7$var$hasWeakSet ? WeakSet.prototype.has : null;
var $5a5c8f99294101b7$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $5a5c8f99294101b7$var$weakRefDeref = $5a5c8f99294101b7$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $5a5c8f99294101b7$var$booleanValueOf = Boolean.prototype.valueOf;
var $5a5c8f99294101b7$var$objectToString = Object.prototype.toString;
var $5a5c8f99294101b7$var$functionToString = Function.prototype.toString;
var $5a5c8f99294101b7$var$$match = String.prototype.match;
var $5a5c8f99294101b7$var$$slice = String.prototype.slice;
var $5a5c8f99294101b7$var$$replace = String.prototype.replace;
var $5a5c8f99294101b7$var$$toUpperCase = String.prototype.toUpperCase;
var $5a5c8f99294101b7$var$$toLowerCase = String.prototype.toLowerCase;
var $5a5c8f99294101b7$var$$test = RegExp.prototype.test;
var $5a5c8f99294101b7$var$$concat = Array.prototype.concat;
var $5a5c8f99294101b7$var$$join = Array.prototype.join;
var $5a5c8f99294101b7$var$$arrSlice = Array.prototype.slice;
var $5a5c8f99294101b7$var$$floor = Math.floor;
var $5a5c8f99294101b7$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $5a5c8f99294101b7$var$gOPS = Object.getOwnPropertySymbols;
var $5a5c8f99294101b7$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $5a5c8f99294101b7$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $5a5c8f99294101b7$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $5a5c8f99294101b7$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $5a5c8f99294101b7$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $5a5c8f99294101b7$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $5a5c8f99294101b7$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $5a5c8f99294101b7$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$5a5c8f99294101b7$var$$floor(-num) : $5a5c8f99294101b7$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $5a5c8f99294101b7$var$$slice.call(str, intStr.length + 1);
            return $5a5c8f99294101b7$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $5a5c8f99294101b7$var$$replace.call($5a5c8f99294101b7$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $5a5c8f99294101b7$var$$replace.call(str, sepRegex, '$&_');
}
var $7b3c9bafdaa6f1e6$exports = {};
"use strict";


var $5a5c8f99294101b7$var$inspectCustom = $7b3c9bafdaa6f1e6$exports.custom;
var $5a5c8f99294101b7$var$inspectSymbol = $5a5c8f99294101b7$var$isSymbol($5a5c8f99294101b7$var$inspectCustom) ? $5a5c8f99294101b7$var$inspectCustom : null;
var $5a5c8f99294101b7$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $5a5c8f99294101b7$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
$5a5c8f99294101b7$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($5a5c8f99294101b7$var$has(opts, 'quoteStyle') && !$5a5c8f99294101b7$var$has($5a5c8f99294101b7$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($5a5c8f99294101b7$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $5a5c8f99294101b7$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($5a5c8f99294101b7$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($5a5c8f99294101b7$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $5a5c8f99294101b7$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $5a5c8f99294101b7$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $5a5c8f99294101b7$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $5a5c8f99294101b7$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $5a5c8f99294101b7$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($5a5c8f99294101b7$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $5a5c8f99294101b7$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($5a5c8f99294101b7$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$5a5c8f99294101b7$var$isRegExp(obj)) {
        var name = $5a5c8f99294101b7$var$nameOf(obj);
        var keys = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $5a5c8f99294101b7$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($5a5c8f99294101b7$var$isSymbol(obj)) {
        var symString = $5a5c8f99294101b7$var$hasShammedSymbols ? $5a5c8f99294101b7$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $5a5c8f99294101b7$var$symToString.call(obj);
        return typeof obj === 'object' && !$5a5c8f99294101b7$var$hasShammedSymbols ? $5a5c8f99294101b7$var$markBoxed(symString) : symString;
    }
    if ($5a5c8f99294101b7$var$isElement(obj)) {
        var s = '<' + $5a5c8f99294101b7$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $5a5c8f99294101b7$var$wrapQuotes($5a5c8f99294101b7$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $5a5c8f99294101b7$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($5a5c8f99294101b7$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        if (indent && !$5a5c8f99294101b7$var$singleLineValues(xs)) return '[' + $5a5c8f99294101b7$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $5a5c8f99294101b7$var$$join.call(xs, ', ') + ' ]';
    }
    if ($5a5c8f99294101b7$var$isError(obj)) {
        var parts = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$5a5c8f99294101b7$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $5a5c8f99294101b7$var$$join.call($5a5c8f99294101b7$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $5a5c8f99294101b7$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($5a5c8f99294101b7$var$inspectSymbol && typeof obj[$5a5c8f99294101b7$var$inspectSymbol] === 'function' && $7b3c9bafdaa6f1e6$exports) return $7b3c9bafdaa6f1e6$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($5a5c8f99294101b7$var$isMap(obj)) {
        var mapParts = [];
        if ($5a5c8f99294101b7$var$mapForEach) $5a5c8f99294101b7$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $5a5c8f99294101b7$var$collectionOf('Map', $5a5c8f99294101b7$var$mapSize.call(obj), mapParts, indent);
    }
    if ($5a5c8f99294101b7$var$isSet(obj)) {
        var setParts = [];
        if ($5a5c8f99294101b7$var$setForEach) $5a5c8f99294101b7$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $5a5c8f99294101b7$var$collectionOf('Set', $5a5c8f99294101b7$var$setSize.call(obj), setParts, indent);
    }
    if ($5a5c8f99294101b7$var$isWeakMap(obj)) return $5a5c8f99294101b7$var$weakCollectionOf('WeakMap');
    if ($5a5c8f99294101b7$var$isWeakSet(obj)) return $5a5c8f99294101b7$var$weakCollectionOf('WeakSet');
    if ($5a5c8f99294101b7$var$isWeakRef(obj)) return $5a5c8f99294101b7$var$weakCollectionOf('WeakRef');
    if ($5a5c8f99294101b7$var$isNumber(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect(Number(obj)));
    if ($5a5c8f99294101b7$var$isBigInt(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect($5a5c8f99294101b7$var$bigIntValueOf.call(obj)));
    if ($5a5c8f99294101b7$var$isBoolean(obj)) return $5a5c8f99294101b7$var$markBoxed($5a5c8f99294101b7$var$booleanValueOf.call(obj));
    if ($5a5c8f99294101b7$var$isString(obj)) return $5a5c8f99294101b7$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$5a5c8f99294101b7$var$isDate(obj) && !$5a5c8f99294101b7$var$isRegExp(obj)) {
        var ys = $5a5c8f99294101b7$var$arrObjKeys(obj, inspect);
        var isPlainObject = $5a5c8f99294101b7$var$gPO ? $5a5c8f99294101b7$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $5a5c8f99294101b7$var$toStringTag && Object(obj) === obj && $5a5c8f99294101b7$var$toStringTag in obj ? $5a5c8f99294101b7$var$$slice.call($5a5c8f99294101b7$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $5a5c8f99294101b7$var$$join.call($5a5c8f99294101b7$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $5a5c8f99294101b7$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $5a5c8f99294101b7$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $5a5c8f99294101b7$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $5a5c8f99294101b7$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $5a5c8f99294101b7$var$quote(s) {
    return $5a5c8f99294101b7$var$$replace.call(String(s), /"/g, '&quot;');
}
function $5a5c8f99294101b7$var$canTrustToString(obj) {
    return !$5a5c8f99294101b7$var$toStringTag || !(typeof obj === 'object' && ($5a5c8f99294101b7$var$toStringTag in obj || typeof obj[$5a5c8f99294101b7$var$toStringTag] !== 'undefined'));
}
function $5a5c8f99294101b7$var$isArray(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Array]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isDate(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Date]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isRegExp(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object RegExp]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isError(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Error]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isString(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object String]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isNumber(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Number]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
function $5a5c8f99294101b7$var$isBoolean(obj) {
    return $5a5c8f99294101b7$var$toStr(obj) === '[object Boolean]' && $5a5c8f99294101b7$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $5a5c8f99294101b7$var$isSymbol(obj) {
    if ($5a5c8f99294101b7$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$5a5c8f99294101b7$var$symToString) return false;
    try {
        $5a5c8f99294101b7$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$5a5c8f99294101b7$var$bigIntValueOf) return false;
    try {
        $5a5c8f99294101b7$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $5a5c8f99294101b7$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $5a5c8f99294101b7$var$has(obj, key) {
    return $5a5c8f99294101b7$var$hasOwn.call(obj, key);
}
function $5a5c8f99294101b7$var$toStr(obj) {
    return $5a5c8f99294101b7$var$objectToString.call(obj);
}
function $5a5c8f99294101b7$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $5a5c8f99294101b7$var$$match.call($5a5c8f99294101b7$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $5a5c8f99294101b7$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $5a5c8f99294101b7$var$isMap(x) {
    if (!$5a5c8f99294101b7$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$mapSize.call(x);
        try {
            $5a5c8f99294101b7$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakMap(x) {
    if (!$5a5c8f99294101b7$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$weakMapHas.call(x, $5a5c8f99294101b7$var$weakMapHas);
        try {
            $5a5c8f99294101b7$var$weakSetHas.call(x, $5a5c8f99294101b7$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakRef(x) {
    if (!$5a5c8f99294101b7$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isSet(x) {
    if (!$5a5c8f99294101b7$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$setSize.call(x);
        try {
            $5a5c8f99294101b7$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isWeakSet(x) {
    if (!$5a5c8f99294101b7$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $5a5c8f99294101b7$var$weakSetHas.call(x, $5a5c8f99294101b7$var$weakSetHas);
        try {
            $5a5c8f99294101b7$var$weakMapHas.call(x, $5a5c8f99294101b7$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5a5c8f99294101b7$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $5a5c8f99294101b7$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $5a5c8f99294101b7$var$inspectString($5a5c8f99294101b7$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $5a5c8f99294101b7$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $5a5c8f99294101b7$var$$replace.call($5a5c8f99294101b7$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $5a5c8f99294101b7$var$lowbyte);
    return $5a5c8f99294101b7$var$wrapQuotes(s, 'single', opts);
}
function $5a5c8f99294101b7$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $5a5c8f99294101b7$var$$toUpperCase.call(n.toString(16));
}
function $5a5c8f99294101b7$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $5a5c8f99294101b7$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $5a5c8f99294101b7$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $5a5c8f99294101b7$var$indentedJoin(entries, indent) : $5a5c8f99294101b7$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $5a5c8f99294101b7$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($5a5c8f99294101b7$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $5a5c8f99294101b7$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $5a5c8f99294101b7$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $5a5c8f99294101b7$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $5a5c8f99294101b7$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $5a5c8f99294101b7$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $5a5c8f99294101b7$var$arrObjKeys(obj, inspect) {
    var isArr = $5a5c8f99294101b7$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $5a5c8f99294101b7$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $5a5c8f99294101b7$var$gOPS === 'function' ? $5a5c8f99294101b7$var$gOPS(obj) : [];
    var symMap;
    if ($5a5c8f99294101b7$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$5a5c8f99294101b7$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($5a5c8f99294101b7$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($5a5c8f99294101b7$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $5a5c8f99294101b7$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($5a5c8f99294101b7$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $b2e3b2b87fe02ae2$exports = {};
'use strict';


/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $b2e3b2b87fe02ae2$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $b2e3b2b87fe02ae2$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $b2e3b2b87fe02ae2$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $b2e3b2b87fe02ae2$var$listSet = function(objects, key, value) {
    var node = $b2e3b2b87fe02ae2$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $b2e3b2b87fe02ae2$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$b2e3b2b87fe02ae2$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $b2e3b2b87fe02ae2$var$listDelete = function(objects, key) {
    if (objects) return $b2e3b2b87fe02ae2$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ $b2e3b2b87fe02ae2$exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $b2e3b2b87fe02ae2$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $b2e3b2b87fe02ae2$var$listGet($o, key);
        },
        has: function(key) {
            return $b2e3b2b87fe02ae2$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $b2e3b2b87fe02ae2$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $922130af2738a625$exports = {};
'use strict';
var $0b745c80c77d8e6b$exports = {};
'use strict';
var $0b745c80c77d8e6b$var$undefined1;
var $ac5b0a5601f4c0cd$exports = {};
'use strict';
/** @type {import('.')} */ $ac5b0a5601f4c0cd$exports = Object;


var $0debf84a8674c2b5$exports = {};
'use strict';
/** @type {import('.')} */ $0debf84a8674c2b5$exports = Error;


var $d9bcd1a4482ed329$exports = {};
'use strict';
/** @type {import('./eval')} */ $d9bcd1a4482ed329$exports = EvalError;


var $887f1160f223563d$exports = {};
'use strict';
/** @type {import('./range')} */ $887f1160f223563d$exports = RangeError;


var $f64d5910103eef78$exports = {};
'use strict';
/** @type {import('./ref')} */ $f64d5910103eef78$exports = ReferenceError;


var $a54d1f36caabb804$exports = {};
'use strict';
/** @type {import('./syntax')} */ $a54d1f36caabb804$exports = SyntaxError;



var $a45c49983ff6c180$exports = {};
'use strict';
/** @type {import('./uri')} */ $a45c49983ff6c180$exports = URIError;


var $ad19e3ed054e8a02$exports = {};
'use strict';
/** @type {import('./abs')} */ $ad19e3ed054e8a02$exports = Math.abs;


var $f0008ae10e682802$exports = {};
'use strict';
/** @type {import('./floor')} */ $f0008ae10e682802$exports = Math.floor;


var $034dfa09ee158379$exports = {};
'use strict';
/** @type {import('./max')} */ $034dfa09ee158379$exports = Math.max;


var $e153ab56521b305a$exports = {};
'use strict';
/** @type {import('./min')} */ $e153ab56521b305a$exports = Math.min;


var $60f095b063f4bba1$exports = {};
'use strict';
/** @type {import('./pow')} */ $60f095b063f4bba1$exports = Math.pow;


var $eb90eb06fbfc2f13$exports = {};
'use strict';
/** @type {import('./round')} */ $eb90eb06fbfc2f13$exports = Math.round;


var $7a151147b84c6e6f$exports = {};
'use strict';
var $c82891fcd82c7915$exports = {};
'use strict';
/** @type {import('./isNaN')} */ $c82891fcd82c7915$exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};


/** @type {import('./sign')} */ $7a151147b84c6e6f$exports = function sign(number) {
    if ($c82891fcd82c7915$exports(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};


var $0b745c80c77d8e6b$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $0b745c80c77d8e6b$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $0b745c80c77d8e6b$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $2e199f77a4ceed31$exports = {};
'use strict';
var $c120240b3d2ae687$exports = {};
'use strict';
/** @type {import('./gOPD')} */ $c120240b3d2ae687$exports = Object.getOwnPropertyDescriptor;


var $2e199f77a4ceed31$require$$gOPD = $c120240b3d2ae687$exports;
if ($2e199f77a4ceed31$require$$gOPD) try {
    $2e199f77a4ceed31$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $2e199f77a4ceed31$require$$gOPD = null;
}
$2e199f77a4ceed31$exports = $2e199f77a4ceed31$require$$gOPD;


var $ac5fdaf5b4392c78$exports = {};
'use strict';
/** @type {import('.')} */ var $ac5fdaf5b4392c78$var$$defineProperty = Object.defineProperty || false;
if ($ac5fdaf5b4392c78$var$$defineProperty) try {
    $ac5fdaf5b4392c78$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $ac5fdaf5b4392c78$var$$defineProperty = false;
}
$ac5fdaf5b4392c78$exports = $ac5fdaf5b4392c78$var$$defineProperty;


var $0b745c80c77d8e6b$var$throwTypeError = function() {
    throw new $6e764c828aee0516$exports();
};
var $0b745c80c77d8e6b$var$ThrowTypeError = $2e199f77a4ceed31$exports ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $0b745c80c77d8e6b$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $2e199f77a4ceed31$exports(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $0b745c80c77d8e6b$var$throwTypeError;
        }
    }
}() : $0b745c80c77d8e6b$var$throwTypeError;

var $0b745c80c77d8e6b$var$hasSymbols = (parcelRequire("zJjdF"))();
var $969672b68895c563$exports = {};
'use strict';
var $e6e904cbcb179c37$exports = {};
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ $e6e904cbcb179c37$exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;


var $639d49df9cf20e24$exports = {};
'use strict';

/** @type {import('./Object.getPrototypeOf')} */ $639d49df9cf20e24$exports = $ac5b0a5601f4c0cd$exports.getPrototypeOf || null;


var $7aaa8f03afc71c5f$exports = {};
'use strict';
var $a96fc22b83cedf2c$exports = {};
'use strict';
var $b12e07b877244af1$exports = {};
'use strict';
var $26b45d95c3de106a$exports = {};
'use strict';
/* eslint no-invalid-this: 1 */ var $26b45d95c3de106a$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $26b45d95c3de106a$var$toStr = Object.prototype.toString;
var $26b45d95c3de106a$var$max = Math.max;
var $26b45d95c3de106a$var$funcType = '[object Function]';
var $26b45d95c3de106a$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $26b45d95c3de106a$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $26b45d95c3de106a$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
$26b45d95c3de106a$exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $26b45d95c3de106a$var$toStr.apply(target) !== $26b45d95c3de106a$var$funcType) throw new TypeError($26b45d95c3de106a$var$ERROR_MESSAGE + target);
    var args = $26b45d95c3de106a$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $26b45d95c3de106a$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $26b45d95c3de106a$var$concatty(args, arguments));
    };
    var boundLength = $26b45d95c3de106a$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $26b45d95c3de106a$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$b12e07b877244af1$exports = Function.prototype.bind || $26b45d95c3de106a$exports;



var $2d03435b98fc89d8$exports = {};
'use strict';
/** @type {import('./functionCall')} */ $2d03435b98fc89d8$exports = Function.prototype.call;


var $b535588daec7a79a$exports = {};
'use strict';

var $89e36fd9aff82ddc$exports = {};
'use strict';
/** @type {import('./functionApply')} */ $89e36fd9aff82ddc$exports = Function.prototype.apply;



var $5abdc7423a63813e$exports = {};
'use strict';
/** @type {import('./reflectApply')} */ $5abdc7423a63813e$exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/** @type {import('./actualApply')} */ $b535588daec7a79a$exports = $5abdc7423a63813e$exports || $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, $89e36fd9aff82ddc$exports);


/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ $a96fc22b83cedf2c$exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $6e764c828aee0516$exports('a function is required');
    return $b535588daec7a79a$exports($b12e07b877244af1$exports, $2d03435b98fc89d8$exports, args);
};



var $7aaa8f03afc71c5f$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $7aaa8f03afc71c5f$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $7aaa8f03afc71c5f$var$desc = !!$7aaa8f03afc71c5f$var$hasProtoAccessor && $2e199f77a4ceed31$exports && $2e199f77a4ceed31$exports(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $7aaa8f03afc71c5f$var$$Object = Object;
var $7aaa8f03afc71c5f$var$$getPrototypeOf = $7aaa8f03afc71c5f$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ $7aaa8f03afc71c5f$exports = $7aaa8f03afc71c5f$var$desc && typeof $7aaa8f03afc71c5f$var$desc.get === 'function' ? $a96fc22b83cedf2c$exports([
    $7aaa8f03afc71c5f$var$desc.get
]) : typeof $7aaa8f03afc71c5f$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $7aaa8f03afc71c5f$var$$getPrototypeOf(value == null ? value : $7aaa8f03afc71c5f$var$$Object(value));
} : false;


/** @type {import('.')} */ $969672b68895c563$exports = $e6e904cbcb179c37$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $e6e904cbcb179c37$exports(O);
} : $639d49df9cf20e24$exports ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $639d49df9cf20e24$exports(O);
} : $7aaa8f03afc71c5f$exports ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7aaa8f03afc71c5f$exports(O);
} : null;






var $0b745c80c77d8e6b$var$needsEval = {};
var $0b745c80c77d8e6b$var$TypedArray = typeof Uint8Array === 'undefined' || !$969672b68895c563$exports ? undefined : $969672b68895c563$exports(Uint8Array);
var $0b745c80c77d8e6b$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $0b745c80c77d8e6b$var$hasSymbols && $969672b68895c563$exports ? $969672b68895c563$exports([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $0b745c80c77d8e6b$var$needsEval,
    '%AsyncGenerator%': $0b745c80c77d8e6b$var$needsEval,
    '%AsyncGeneratorFunction%': $0b745c80c77d8e6b$var$needsEval,
    '%AsyncIteratorPrototype%': $0b745c80c77d8e6b$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $0debf84a8674c2b5$exports,
    '%eval%': eval,
    '%EvalError%': $d9bcd1a4482ed329$exports,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $0b745c80c77d8e6b$var$$Function,
    '%GeneratorFunction%': $0b745c80c77d8e6b$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $0b745c80c77d8e6b$var$hasSymbols && $969672b68895c563$exports ? $969672b68895c563$exports($969672b68895c563$exports([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$0b745c80c77d8e6b$var$hasSymbols || !$969672b68895c563$exports ? undefined : $969672b68895c563$exports(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $ac5b0a5601f4c0cd$exports,
    '%Object.getOwnPropertyDescriptor%': $2e199f77a4ceed31$exports,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $887f1160f223563d$exports,
    '%ReferenceError%': $f64d5910103eef78$exports,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$0b745c80c77d8e6b$var$hasSymbols || !$969672b68895c563$exports ? undefined : $969672b68895c563$exports(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $0b745c80c77d8e6b$var$hasSymbols && $969672b68895c563$exports ? $969672b68895c563$exports(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $0b745c80c77d8e6b$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $a54d1f36caabb804$exports,
    '%ThrowTypeError%': $0b745c80c77d8e6b$var$ThrowTypeError,
    '%TypedArray%': $0b745c80c77d8e6b$var$TypedArray,
    '%TypeError%': $6e764c828aee0516$exports,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $a45c49983ff6c180$exports,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $2d03435b98fc89d8$exports,
    '%Function.prototype.apply%': $89e36fd9aff82ddc$exports,
    '%Object.defineProperty%': $ac5fdaf5b4392c78$exports,
    '%Object.getPrototypeOf%': $639d49df9cf20e24$exports,
    '%Math.abs%': $ad19e3ed054e8a02$exports,
    '%Math.floor%': $f0008ae10e682802$exports,
    '%Math.max%': $034dfa09ee158379$exports,
    '%Math.min%': $e153ab56521b305a$exports,
    '%Math.pow%': $60f095b063f4bba1$exports,
    '%Math.round%': $eb90eb06fbfc2f13$exports,
    '%Math.sign%': $7a151147b84c6e6f$exports,
    '%Reflect.getPrototypeOf%': $e6e904cbcb179c37$exports
};
if ($969672b68895c563$exports) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $0b745c80c77d8e6b$var$errorProto = $969672b68895c563$exports($969672b68895c563$exports(e));
    $0b745c80c77d8e6b$var$INTRINSICS['%Error.prototype%'] = $0b745c80c77d8e6b$var$errorProto;
}
var $0b745c80c77d8e6b$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $0b745c80c77d8e6b$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $0b745c80c77d8e6b$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $0b745c80c77d8e6b$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $969672b68895c563$exports) value = $969672b68895c563$exports(gen.prototype);
    }
    $0b745c80c77d8e6b$var$INTRINSICS[name] = value;
    return value;
};
var $0b745c80c77d8e6b$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $97681721aaad2266$exports = {};
'use strict';
var $97681721aaad2266$var$call = Function.prototype.call;
var $97681721aaad2266$var$$hasOwn = Object.prototype.hasOwnProperty;

/** @type {import('.')} */ $97681721aaad2266$exports = $b12e07b877244af1$exports.call($97681721aaad2266$var$call, $97681721aaad2266$var$$hasOwn);


var $0b745c80c77d8e6b$var$$concat = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, Array.prototype.concat);
var $0b745c80c77d8e6b$var$$spliceApply = $b12e07b877244af1$exports.call($89e36fd9aff82ddc$exports, Array.prototype.splice);
var $0b745c80c77d8e6b$var$$replace = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, String.prototype.replace);
var $0b745c80c77d8e6b$var$$strSlice = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, String.prototype.slice);
var $0b745c80c77d8e6b$var$$exec = $b12e07b877244af1$exports.call($2d03435b98fc89d8$exports, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $0b745c80c77d8e6b$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $0b745c80c77d8e6b$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $0b745c80c77d8e6b$var$stringToPath = function stringToPath(string) {
    var first = $0b745c80c77d8e6b$var$$strSlice(string, 0, 1);
    var last = $0b745c80c77d8e6b$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $a54d1f36caabb804$exports('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $a54d1f36caabb804$exports('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $0b745c80c77d8e6b$var$$replace(string, $0b745c80c77d8e6b$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $0b745c80c77d8e6b$var$$replace(subString, $0b745c80c77d8e6b$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $0b745c80c77d8e6b$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($97681721aaad2266$exports($0b745c80c77d8e6b$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $0b745c80c77d8e6b$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($97681721aaad2266$exports($0b745c80c77d8e6b$var$INTRINSICS, intrinsicName)) {
        var value = $0b745c80c77d8e6b$var$INTRINSICS[intrinsicName];
        if (value === $0b745c80c77d8e6b$var$needsEval) value = $0b745c80c77d8e6b$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $6e764c828aee0516$exports('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $a54d1f36caabb804$exports('intrinsic ' + name + ' does not exist!');
};
$0b745c80c77d8e6b$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $6e764c828aee0516$exports('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $6e764c828aee0516$exports('"allowMissing" argument must be a boolean');
    if ($0b745c80c77d8e6b$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $a54d1f36caabb804$exports('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $0b745c80c77d8e6b$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $0b745c80c77d8e6b$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $0b745c80c77d8e6b$var$$spliceApply(parts, $0b745c80c77d8e6b$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $0b745c80c77d8e6b$var$$strSlice(part, 0, 1);
        var last = $0b745c80c77d8e6b$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $a54d1f36caabb804$exports('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($97681721aaad2266$exports($0b745c80c77d8e6b$var$INTRINSICS, intrinsicRealName)) value = $0b745c80c77d8e6b$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $6e764c828aee0516$exports('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($2e199f77a4ceed31$exports && i + 1 >= parts.length) {
                var desc = $2e199f77a4ceed31$exports(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $97681721aaad2266$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $0b745c80c77d8e6b$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $ef2ba1ff0782643c$exports = {};
'use strict';


/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $ef2ba1ff0782643c$var$$indexOf = $a96fc22b83cedf2c$exports([
    $0b745c80c77d8e6b$exports('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ $ef2ba1ff0782643c$exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $0b745c80c77d8e6b$exports(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $ef2ba1ff0782643c$var$$indexOf(name, '.prototype.') > -1) return $a96fc22b83cedf2c$exports(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};




var $922130af2738a625$var$$Map = $0b745c80c77d8e6b$exports('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $922130af2738a625$var$$mapGet = $ef2ba1ff0782643c$exports('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $922130af2738a625$var$$mapSet = $ef2ba1ff0782643c$exports('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $922130af2738a625$var$$mapHas = $ef2ba1ff0782643c$exports('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $922130af2738a625$var$$mapDelete = $ef2ba1ff0782643c$exports('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $922130af2738a625$var$$mapSize = $ef2ba1ff0782643c$exports('Map.prototype.size', true);
/** @type {import('.')} */ $922130af2738a625$exports = !!$922130af2738a625$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $922130af2738a625$var$$mapDelete($m, key);
                if ($922130af2738a625$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $922130af2738a625$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $922130af2738a625$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $922130af2738a625$var$$Map();
            $922130af2738a625$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};


var $01e06040bfaa583d$exports = {};
'use strict';





var $01e06040bfaa583d$var$$WeakMap = $0b745c80c77d8e6b$exports('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $01e06040bfaa583d$var$$weakMapGet = $ef2ba1ff0782643c$exports('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $01e06040bfaa583d$var$$weakMapSet = $ef2ba1ff0782643c$exports('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $01e06040bfaa583d$var$$weakMapHas = $ef2ba1ff0782643c$exports('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $01e06040bfaa583d$var$$weakMapDelete = $ef2ba1ff0782643c$exports('WeakMap.prototype.delete', true);
/** @type {import('.')} */ $01e06040bfaa583d$exports = $01e06040bfaa583d$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $01e06040bfaa583d$var$$weakMapDelete($wm, key);
            } else if ($922130af2738a625$exports) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $01e06040bfaa583d$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $01e06040bfaa583d$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($01e06040bfaa583d$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $01e06040bfaa583d$var$$WeakMap();
                $01e06040bfaa583d$var$$weakMapSet($wm, key, value);
            } else if ($922130af2738a625$exports) {
                if (!$m) $m = $922130af2738a625$exports();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $922130af2738a625$exports;


var $41979e9c210b0e24$var$makeChannel = $01e06040bfaa583d$exports || $922130af2738a625$exports || $b2e3b2b87fe02ae2$exports;
/** @type {import('.')} */ $41979e9c210b0e24$exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $6e764c828aee0516$exports('Side channel does not contain ' + $5a5c8f99294101b7$exports(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $41979e9c210b0e24$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};


var $e2d71df10770edb6$exports = {};
'use strict';
var $0895067d86be0ed7$exports = {};
'use strict';
var $0895067d86be0ed7$var$replace = String.prototype.replace;
var $0895067d86be0ed7$var$percentTwenties = /%20/g;
var $0895067d86be0ed7$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
$0895067d86be0ed7$exports = {
    'default': $0895067d86be0ed7$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $0895067d86be0ed7$var$replace.call(value, $0895067d86be0ed7$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $0895067d86be0ed7$var$Format.RFC1738,
    RFC3986: $0895067d86be0ed7$var$Format.RFC3986
};



var $e2d71df10770edb6$var$has = Object.prototype.hasOwnProperty;
var $e2d71df10770edb6$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $e2d71df10770edb6$var$overflowChannel = $41979e9c210b0e24$exports();
var $e2d71df10770edb6$var$markOverflow = function markOverflow(obj, maxIndex) {
    $e2d71df10770edb6$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $e2d71df10770edb6$var$isOverflow = function isOverflow(obj) {
    return $e2d71df10770edb6$var$overflowChannel.has(obj);
};
var $e2d71df10770edb6$var$getMaxIndex = function getMaxIndex(obj) {
    return $e2d71df10770edb6$var$overflowChannel.get(obj);
};
var $e2d71df10770edb6$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $e2d71df10770edb6$var$overflowChannel.set(obj, maxIndex);
};
var $e2d71df10770edb6$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $e2d71df10770edb6$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($e2d71df10770edb6$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $e2d71df10770edb6$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $e2d71df10770edb6$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($e2d71df10770edb6$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) return $e2d71df10770edb6$var$markOverflow($e2d71df10770edb6$var$arrayToObject(target.concat(source), options), nextIndex);
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($e2d71df10770edb6$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $e2d71df10770edb6$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $e2d71df10770edb6$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$e2d71df10770edb6$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($e2d71df10770edb6$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $e2d71df10770edb6$var$markOverflow(result, $e2d71df10770edb6$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) return $e2d71df10770edb6$var$markOverflow($e2d71df10770edb6$var$arrayToObject(combined, options), combined.length - 1);
        return combined;
    }
    var mergeTarget = target;
    if ($e2d71df10770edb6$var$isArray(target) && !$e2d71df10770edb6$var$isArray(source)) mergeTarget = $e2d71df10770edb6$var$arrayToObject(target, options);
    if ($e2d71df10770edb6$var$isArray(target) && $e2d71df10770edb6$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($e2d71df10770edb6$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($e2d71df10770edb6$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        if ($e2d71df10770edb6$var$isOverflow(source) && !$e2d71df10770edb6$var$isOverflow(acc)) $e2d71df10770edb6$var$markOverflow(acc, $e2d71df10770edb6$var$getMaxIndex(source));
        if ($e2d71df10770edb6$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $e2d71df10770edb6$var$getMaxIndex(acc)) $e2d71df10770edb6$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $e2d71df10770edb6$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $e2d71df10770edb6$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $e2d71df10770edb6$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $e2d71df10770edb6$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $e2d71df10770edb6$var$limit){
        var segment = string.length >= $e2d71df10770edb6$var$limit ? string.slice(j, j + $e2d71df10770edb6$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $0895067d86be0ed7$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xC0 | c >> 6] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xE0 | c >> 12] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 6 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $e2d71df10770edb6$var$hexTable[0xF0 | c >> 18] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 12 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c >> 6 & 0x3F] + $e2d71df10770edb6$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $e2d71df10770edb6$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs[refs.length] = val;
            }
        }
    }
    $e2d71df10770edb6$var$compactQueue(queue);
    return value;
};
var $e2d71df10770edb6$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $e2d71df10770edb6$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $e2d71df10770edb6$var$combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if ($e2d71df10770edb6$var$isOverflow(a)) {
        var newIndex = $e2d71df10770edb6$var$getMaxIndex(a) + 1;
        a[newIndex] = b;
        $e2d71df10770edb6$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) return $e2d71df10770edb6$var$markOverflow($e2d71df10770edb6$var$arrayToObject(result, {
        plainObjects: plainObjects
    }), result.length - 1);
    return result;
};
var $e2d71df10770edb6$var$maybeMap = function maybeMap(val, fn) {
    if ($e2d71df10770edb6$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
$e2d71df10770edb6$exports = {
    arrayToObject: $e2d71df10770edb6$var$arrayToObject,
    assign: $e2d71df10770edb6$var$assign,
    combine: $e2d71df10770edb6$var$combine,
    compact: $e2d71df10770edb6$var$compact,
    decode: $e2d71df10770edb6$var$decode,
    encode: $e2d71df10770edb6$var$encode,
    isBuffer: $e2d71df10770edb6$var$isBuffer,
    isOverflow: $e2d71df10770edb6$var$isOverflow,
    isRegExp: $e2d71df10770edb6$var$isRegExp,
    markOverflow: $e2d71df10770edb6$var$markOverflow,
    maybeMap: $e2d71df10770edb6$var$maybeMap,
    merge: $e2d71df10770edb6$var$merge
};



var $79acdf0dd8ee88cb$var$has = Object.prototype.hasOwnProperty;
var $79acdf0dd8ee88cb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $79acdf0dd8ee88cb$var$isArray = Array.isArray;
var $79acdf0dd8ee88cb$var$push = Array.prototype.push;
var $79acdf0dd8ee88cb$var$pushToArray = function(arr, valueOrArray) {
    $79acdf0dd8ee88cb$var$push.apply(arr, $79acdf0dd8ee88cb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $79acdf0dd8ee88cb$var$toISO = Date.prototype.toISOString;
var $79acdf0dd8ee88cb$var$defaultFormat = $0895067d86be0ed7$exports.default;
var $79acdf0dd8ee88cb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $e2d71df10770edb6$exports.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $79acdf0dd8ee88cb$var$defaultFormat,
    formatter: $0895067d86be0ed7$exports.formatters[$79acdf0dd8ee88cb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $79acdf0dd8ee88cb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $79acdf0dd8ee88cb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $79acdf0dd8ee88cb$var$sentinel = {};
var $79acdf0dd8ee88cb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($79acdf0dd8ee88cb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($79acdf0dd8ee88cb$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $79acdf0dd8ee88cb$var$isArray(obj)) obj = $e2d71df10770edb6$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $79acdf0dd8ee88cb$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($79acdf0dd8ee88cb$var$isNonNullishPrimitive(obj) || $e2d71df10770edb6$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $79acdf0dd8ee88cb$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $79acdf0dd8ee88cb$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $79acdf0dd8ee88cb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $e2d71df10770edb6$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($79acdf0dd8ee88cb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $79acdf0dd8ee88cb$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $79acdf0dd8ee88cb$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $79acdf0dd8ee88cb$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $41979e9c210b0e24$exports();
        valueSideChannel.set($79acdf0dd8ee88cb$var$sentinel, sideChannel);
        $79acdf0dd8ee88cb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $79acdf0dd8ee88cb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $79acdf0dd8ee88cb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $79acdf0dd8ee88cb$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $79acdf0dd8ee88cb$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $0895067d86be0ed7$exports.default;
    if (typeof opts.format !== 'undefined') {
        if (!$79acdf0dd8ee88cb$var$has.call($0895067d86be0ed7$exports.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $0895067d86be0ed7$exports.formatters[format];
    var filter = $79acdf0dd8ee88cb$var$defaults.filter;
    if (typeof opts.filter === 'function' || $79acdf0dd8ee88cb$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $79acdf0dd8ee88cb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $79acdf0dd8ee88cb$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $79acdf0dd8ee88cb$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $79acdf0dd8ee88cb$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $79acdf0dd8ee88cb$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $79acdf0dd8ee88cb$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $79acdf0dd8ee88cb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $79acdf0dd8ee88cb$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $79acdf0dd8ee88cb$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $79acdf0dd8ee88cb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $79acdf0dd8ee88cb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $79acdf0dd8ee88cb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $79acdf0dd8ee88cb$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $79acdf0dd8ee88cb$var$defaults.strictNullHandling
    };
};
$79acdf0dd8ee88cb$exports = function(object, opts) {
    var obj = object;
    var options = $79acdf0dd8ee88cb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($79acdf0dd8ee88cb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $79acdf0dd8ee88cb$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $41979e9c210b0e24$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $79acdf0dd8ee88cb$var$pushToArray(keys, $79acdf0dd8ee88cb$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};


var $bad802c248311354$exports = {};
'use strict';

var $bad802c248311354$var$has = Object.prototype.hasOwnProperty;
var $bad802c248311354$var$isArray = Array.isArray;
var $bad802c248311354$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $e2d71df10770edb6$exports.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $bad802c248311354$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $bad802c248311354$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $bad802c248311354$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $bad802c248311354$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $bad802c248311354$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $bad802c248311354$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $bad802c248311354$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $bad802c248311354$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $bad802c248311354$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $e2d71df10770edb6$exports.maybeMap($bad802c248311354$var$parseArrayValue(part.slice(pos + 1), options, $bad802c248311354$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $bad802c248311354$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $bad802c248311354$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $bad802c248311354$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $bad802c248311354$var$isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            val = $e2d71df10770edb6$exports.combine([], val, options.arrayLimit, options.plainObjects);
        }
        if (key !== null) {
            var existing = $bad802c248311354$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $e2d71df10770edb6$exports.combine(obj[key], val, options.arrayLimit, options.plainObjects);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $bad802c248311354$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $bad802c248311354$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($e2d71df10770edb6$exports.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $e2d71df10770edb6$exports.combine([], leaf, options.arrayLimit, options.plainObjects);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $e2d71df10770edb6$exports.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $bad802c248311354$var$splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    if (options.depth <= 0) {
        if (!options.plainObjects && $bad802c248311354$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    var keys = [];
    if (parent) {
        if (!options.plainObjects && $bad802c248311354$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = parent;
    }
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && $bad802c248311354$var$has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) return;
        }
        keys[keys.length] = segment[1];
    }
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }
    return keys;
};
var $bad802c248311354$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $bad802c248311354$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $bad802c248311354$var$parseObject(keys, val, options, valuesParsed);
};
var $bad802c248311354$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $bad802c248311354$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $bad802c248311354$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $bad802c248311354$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $bad802c248311354$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $bad802c248311354$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $bad802c248311354$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $bad802c248311354$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $bad802c248311354$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $bad802c248311354$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $bad802c248311354$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $bad802c248311354$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $bad802c248311354$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $e2d71df10770edb6$exports.isRegExp(opts.delimiter) ? opts.delimiter : $bad802c248311354$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $bad802c248311354$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $bad802c248311354$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $bad802c248311354$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $bad802c248311354$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $bad802c248311354$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $bad802c248311354$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $bad802c248311354$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
$bad802c248311354$exports = function(str, opts) {
    var options = $bad802c248311354$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $bad802c248311354$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $bad802c248311354$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $e2d71df10770edb6$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $e2d71df10770edb6$exports.compact(obj);
};



$6e19be61753cbc35$exports = {
    formats: $0895067d86be0ed7$exports,
    parse: $bad802c248311354$exports,
    stringify: $79acdf0dd8ee88cb$exports
};


var $cf72726b0112c451$exports = {};
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $cf72726b0112c451$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $cf72726b0112c451$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cf72726b0112c451$var$objectToString = $cf72726b0112c451$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $cf72726b0112c451$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cf72726b0112c451$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $cf72726b0112c451$var$isString(value) {
    return typeof value == 'string' || !$cf72726b0112c451$var$isArray(value) && $cf72726b0112c451$var$isObjectLike(value) && $cf72726b0112c451$var$objectToString.call(value) == $cf72726b0112c451$var$stringTag;
}
$cf72726b0112c451$exports = $cf72726b0112c451$var$isString;


var $e7d72dade9aebf3b$exports = {};
'use strict';
class $e7d72dade9aebf3b$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $e7d72dade9aebf3b$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $e7d72dade9aebf3b$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
$e7d72dade9aebf3b$exports = $e7d72dade9aebf3b$var$pThrottle;
$e7d72dade9aebf3b$exports.AbortError = $e7d72dade9aebf3b$var$AbortError;


var $3bdddaf3abddf785$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $3bdddaf3abddf785$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $3bdddaf3abddf785$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $3bdddaf3abddf785$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $3bdddaf3abddf785$var$funcProto = Function.prototype, $3bdddaf3abddf785$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $3bdddaf3abddf785$var$funcToString = $3bdddaf3abddf785$var$funcProto.toString;
/** Used to check objects for own properties. */ var $3bdddaf3abddf785$var$hasOwnProperty = $3bdddaf3abddf785$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $3bdddaf3abddf785$var$objectCtorString = $3bdddaf3abddf785$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3bdddaf3abddf785$var$objectToString = $3bdddaf3abddf785$var$objectProto.toString;
/** Built-in value references. */ var $3bdddaf3abddf785$var$getPrototype = $3bdddaf3abddf785$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3bdddaf3abddf785$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $3bdddaf3abddf785$var$isPlainObject(value) {
    if (!$3bdddaf3abddf785$var$isObjectLike(value) || $3bdddaf3abddf785$var$objectToString.call(value) != $3bdddaf3abddf785$var$objectTag || $3bdddaf3abddf785$var$isHostObject(value)) return false;
    var proto = $3bdddaf3abddf785$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $3bdddaf3abddf785$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $3bdddaf3abddf785$var$funcToString.call(Ctor) == $3bdddaf3abddf785$var$objectCtorString;
}
$3bdddaf3abddf785$exports = $3bdddaf3abddf785$var$isPlainObject;


var $3267bbb6db0678de$exports = {};
// shim for using process in browser
var $3267bbb6db0678de$var$process = $3267bbb6db0678de$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3267bbb6db0678de$var$cachedSetTimeout;
var $3267bbb6db0678de$var$cachedClearTimeout;
function $3267bbb6db0678de$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3267bbb6db0678de$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3267bbb6db0678de$var$cachedSetTimeout = setTimeout;
        else $3267bbb6db0678de$var$cachedSetTimeout = $3267bbb6db0678de$var$defaultSetTimout;
    } catch (e) {
        $3267bbb6db0678de$var$cachedSetTimeout = $3267bbb6db0678de$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3267bbb6db0678de$var$cachedClearTimeout = clearTimeout;
        else $3267bbb6db0678de$var$cachedClearTimeout = $3267bbb6db0678de$var$defaultClearTimeout;
    } catch (e) {
        $3267bbb6db0678de$var$cachedClearTimeout = $3267bbb6db0678de$var$defaultClearTimeout;
    }
})();
function $3267bbb6db0678de$var$runTimeout(fun) {
    if ($3267bbb6db0678de$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3267bbb6db0678de$var$cachedSetTimeout === $3267bbb6db0678de$var$defaultSetTimout || !$3267bbb6db0678de$var$cachedSetTimeout) && setTimeout) {
        $3267bbb6db0678de$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3267bbb6db0678de$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3267bbb6db0678de$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3267bbb6db0678de$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3267bbb6db0678de$var$runClearTimeout(marker) {
    if ($3267bbb6db0678de$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3267bbb6db0678de$var$cachedClearTimeout === $3267bbb6db0678de$var$defaultClearTimeout || !$3267bbb6db0678de$var$cachedClearTimeout) && clearTimeout) {
        $3267bbb6db0678de$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3267bbb6db0678de$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3267bbb6db0678de$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3267bbb6db0678de$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3267bbb6db0678de$var$queue = [];
var $3267bbb6db0678de$var$draining = false;
var $3267bbb6db0678de$var$currentQueue;
var $3267bbb6db0678de$var$queueIndex = -1;
function $3267bbb6db0678de$var$cleanUpNextTick() {
    if (!$3267bbb6db0678de$var$draining || !$3267bbb6db0678de$var$currentQueue) return;
    $3267bbb6db0678de$var$draining = false;
    if ($3267bbb6db0678de$var$currentQueue.length) $3267bbb6db0678de$var$queue = $3267bbb6db0678de$var$currentQueue.concat($3267bbb6db0678de$var$queue);
    else $3267bbb6db0678de$var$queueIndex = -1;
    if ($3267bbb6db0678de$var$queue.length) $3267bbb6db0678de$var$drainQueue();
}
function $3267bbb6db0678de$var$drainQueue() {
    if ($3267bbb6db0678de$var$draining) return;
    var timeout = $3267bbb6db0678de$var$runTimeout($3267bbb6db0678de$var$cleanUpNextTick);
    $3267bbb6db0678de$var$draining = true;
    var len = $3267bbb6db0678de$var$queue.length;
    while(len){
        $3267bbb6db0678de$var$currentQueue = $3267bbb6db0678de$var$queue;
        $3267bbb6db0678de$var$queue = [];
        while(++$3267bbb6db0678de$var$queueIndex < len)if ($3267bbb6db0678de$var$currentQueue) $3267bbb6db0678de$var$currentQueue[$3267bbb6db0678de$var$queueIndex].run();
        $3267bbb6db0678de$var$queueIndex = -1;
        len = $3267bbb6db0678de$var$queue.length;
    }
    $3267bbb6db0678de$var$currentQueue = null;
    $3267bbb6db0678de$var$draining = false;
    $3267bbb6db0678de$var$runClearTimeout(timeout);
}
$3267bbb6db0678de$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3267bbb6db0678de$var$queue.push(new $3267bbb6db0678de$var$Item(fun, args));
    if ($3267bbb6db0678de$var$queue.length === 1 && !$3267bbb6db0678de$var$draining) $3267bbb6db0678de$var$runTimeout($3267bbb6db0678de$var$drainQueue);
};
// v8 likes predictible objects
function $3267bbb6db0678de$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3267bbb6db0678de$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3267bbb6db0678de$var$process.title = 'browser';
$3267bbb6db0678de$var$process.browser = true;
$3267bbb6db0678de$var$process.env = {};
$3267bbb6db0678de$var$process.argv = [];
$3267bbb6db0678de$var$process.version = ''; // empty string to avoid regexp issues
$3267bbb6db0678de$var$process.versions = {};
function $3267bbb6db0678de$var$noop() {}
$3267bbb6db0678de$var$process.on = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.addListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.once = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.off = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.removeListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.removeAllListeners = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.emit = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.prependListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.prependOnceListener = $3267bbb6db0678de$var$noop;
$3267bbb6db0678de$var$process.listeners = function(name) {
    return [];
};
$3267bbb6db0678de$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3267bbb6db0678de$var$process.cwd = function() {
    return '/';
};
$3267bbb6db0678de$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3267bbb6db0678de$var$process.umask = function() {
    return 0;
};


function $24b323c95a04241b$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $24b323c95a04241b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $24b323c95a04241b$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $24b323c95a04241b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $24b323c95a04241b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $24b323c95a04241b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $24b323c95a04241b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $24b323c95a04241b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $24b323c95a04241b$var$_typeof(obj);
}
function $24b323c95a04241b$var$_wrapRegExp() {
    $24b323c95a04241b$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $24b323c95a04241b$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            var i = g[name];
            if ("number" == typeof i) groups[name] = result[i];
            else {
                for(var k = 0; void 0 === result[i[k]] && k + 1 < i.length;)k++;
                groups[name] = result[i[k]];
            }
            return groups;
        }, Object.create(null));
    }
    return $24b323c95a04241b$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        if (result) {
            result.groups = buildGroups(result, this);
            var indices = result.indices;
            indices && (indices.groups = buildGroups(indices, this));
        }
        return result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                var group = groups[name];
                return "$" + (Array.isArray(group) ? group.join("$") : group);
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $24b323c95a04241b$var$_wrapRegExp.apply(this, arguments);
}
function $24b323c95a04241b$var$_defineProperty(obj, key, value) {
    key = $24b323c95a04241b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $24b323c95a04241b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $24b323c95a04241b$var$_setPrototypeOf(subClass, superClass);
}
function $24b323c95a04241b$var$_setPrototypeOf(o, p) {
    $24b323c95a04241b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $24b323c95a04241b$var$_setPrototypeOf(o, p);
}
function $24b323c95a04241b$var$_slicedToArray(arr, i) {
    return $24b323c95a04241b$var$_arrayWithHoles(arr) || $24b323c95a04241b$var$_iterableToArrayLimit(arr, i) || $24b323c95a04241b$var$_unsupportedIterableToArray(arr, i) || $24b323c95a04241b$var$_nonIterableRest();
}
function $24b323c95a04241b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $24b323c95a04241b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $24b323c95a04241b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $24b323c95a04241b$var$_arrayLikeToArray(o, minLen);
}
function $24b323c95a04241b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $24b323c95a04241b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $24b323c95a04241b$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $24b323c95a04241b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $24b323c95a04241b$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $24b323c95a04241b$var$_toPropertyKey(arg) {
    var key = $24b323c95a04241b$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $24b323c95a04241b$var$isNode() {
    /**
   * Save way to check for the global scope which should confirm if an environment is node
   * For reference: https://stackoverflow.com/a/31090240
   */ var isNodeFunc = new Function('try {return this===global;}catch(e){return false;}');
    return isNodeFunc();
}
function $24b323c95a04241b$var$isReactNative() {
    return typeof window !== 'undefined' && 'navigator' in window && 'product' in window.navigator && window.navigator.product === 'ReactNative';
}
function $24b323c95a04241b$var$getNodeVersion() {
    return $3267bbb6db0678de$exports.versions && $3267bbb6db0678de$exports.versions.node ? "v".concat($3267bbb6db0678de$exports.versions.node) : $3267bbb6db0678de$exports.version;
}
function $24b323c95a04241b$var$getWindow() {
    return window;
}
function $24b323c95a04241b$var$noop() {
    return undefined;
}
var $24b323c95a04241b$var$PERCENTAGE_REGEX = /*#__PURE__*/ $24b323c95a04241b$var$_wrapRegExp(/(\d+)(%)/, {
    value: 1
});
function $24b323c95a04241b$var$calculateLimit(type) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
    var limit = max;
    if ($24b323c95a04241b$var$PERCENTAGE_REGEX.test(type)) {
        var _type$match;
        var groups = (_type$match = type.match($24b323c95a04241b$var$PERCENTAGE_REGEX)) === null || _type$match === void 0 ? void 0 : _type$match.groups;
        if (groups && groups.value) {
            var percentage = parseInt(groups.value) / 100;
            limit = Math.round(max * percentage);
        }
    }
    return Math.min(30, Math.max(1, limit));
}
function $24b323c95a04241b$var$createThrottle(limit, logger) {
    logger('info', "Throttle request to ".concat(limit, "/s"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($e7d72dade9aebf3b$exports)))({
        limit: limit,
        interval: 1000,
        strict: false
    });
}
var $24b323c95a04241b$var$rateLimitThrottle = function(axiosInstance) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
    var _axiosInstance$defaul = axiosInstance.defaults.logHandler, logHandler = _axiosInstance$defaul === void 0 ? $24b323c95a04241b$var$noop : _axiosInstance$defaul;
    var limit = (0, (/*@__PURE__*/$parcel$interopDefault($cf72726b0112c451$exports)))(type) ? $24b323c95a04241b$var$calculateLimit(type) : $24b323c95a04241b$var$calculateLimit('auto', type);
    var throttle = $24b323c95a04241b$var$createThrottle(limit, logHandler);
    var isCalculated = false;
    var requestInterceptorId = axiosInstance.interceptors.request.use(function(config) {
        return throttle(function() {
            return config;
        })();
    }, function(error) {
        return Promise.reject(error);
    });
    var responseInterceptorId = axiosInstance.interceptors.response.use(function(response) {
        if (!isCalculated && (0, (/*@__PURE__*/$parcel$interopDefault($cf72726b0112c451$exports)))(type) && (type === 'auto' || $24b323c95a04241b$var$PERCENTAGE_REGEX.test(type)) && response.headers && response.headers['x-contentful-ratelimit-second-limit']) {
            var rawLimit = parseInt(response.headers['x-contentful-ratelimit-second-limit']);
            var nextLimit = $24b323c95a04241b$var$calculateLimit(type, rawLimit);
            if (nextLimit !== limit) {
                if (requestInterceptorId) axiosInstance.interceptors.request.eject(requestInterceptorId);
                limit = nextLimit;
                throttle = $24b323c95a04241b$var$createThrottle(nextLimit, logHandler);
                requestInterceptorId = axiosInstance.interceptors.request.use(function(config) {
                    return throttle(function() {
                        return config;
                    })();
                }, function(error) {
                    return Promise.reject(error);
                });
            }
            isCalculated = true;
        }
        return response;
    }, function(error) {
        return Promise.reject(error);
    });
    return function() {
        axiosInstance.interceptors.request.eject(requestInterceptorId);
        axiosInstance.interceptors.response.eject(responseInterceptorId);
    };
};
var $24b323c95a04241b$var$delay = function delay(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $24b323c95a04241b$var$defaultWait = function defaultWait(attempts) {
    return Math.pow(Math.SQRT2, attempts);
};
function $24b323c95a04241b$var$rateLimit(instance) {
    var maxRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    var _instance$defaults = instance.defaults, _instance$defaults$re = _instance$defaults.responseLogger, responseLogger = _instance$defaults$re === void 0 ? $24b323c95a04241b$var$noop : _instance$defaults$re, _instance$defaults$re2 = _instance$defaults.requestLogger, requestLogger = _instance$defaults$re2 === void 0 ? $24b323c95a04241b$var$noop : _instance$defaults$re2;
    instance.interceptors.request.use(function(config) {
        requestLogger(config);
        return config;
    }, function(error) {
        requestLogger(error);
        return Promise.reject(error);
    });
    instance.interceptors.response.use(function(response) {
        // we don't need to do anything here
        responseLogger(response);
        return response;
    }, function(error) {
        var response = error.response;
        var config = error.config;
        responseLogger(error);
        // Do not retry if it is disabled or no request config exists (not an axios error)
        if (!config || !instance.defaults.retryOnError) return Promise.reject(error);
        // Retried already for max attempts
        var doneAttempts = config.attempts || 1;
        if (doneAttempts > maxRetry) {
            error.attempts = config.attempts;
            return Promise.reject(error);
        }
        var retryErrorType = null;
        var wait = $24b323c95a04241b$var$defaultWait(doneAttempts);
        // Errors without response did not receive anything from the server
        if (!response) retryErrorType = 'Connection';
        else if (response.status >= 500 && response.status < 600) // 5** errors are server related
        retryErrorType = "Server ".concat(response.status);
        else if (response.status === 429) {
            // 429 errors are exceeded rate limit exceptions
            retryErrorType = 'Rate limit';
            // all headers are lowercased by axios https://github.com/mzabriskie/axios/issues/413
            if (response.headers && error.response.headers['x-contentful-ratelimit-reset']) wait = response.headers['x-contentful-ratelimit-reset'];
        }
        if (retryErrorType) {
            // convert to ms and add jitter
            wait = Math.floor(wait * 1000 + Math.random() * 200 + 500);
            instance.defaults.logHandler('warning', "".concat(retryErrorType, " error occurred. Waiting for ").concat(wait, " ms before retrying..."));
            // increase attempts counter
            config.attempts = doneAttempts + 1;
            /* Somehow between the interceptor and retrying the request the httpAgent/httpsAgent gets transformed from an Agent-like object
       to a regular object, causing failures on retries after rate limits. Removing these properties here fixes the error, but retry
       requests still use the original http/httpsAgent property */ delete config.httpAgent;
            delete config.httpsAgent;
            return $24b323c95a04241b$var$delay(wait).then(function() {
                return instance(config);
            });
        }
        return Promise.reject(error);
    });
}
function $24b323c95a04241b$var$asyncToken(instance, getToken) {
    instance.interceptors.request.use(function(config) {
        return getToken().then(function(accessToken) {
            config.headers = $24b323c95a04241b$var$_objectSpread2($24b323c95a04241b$var$_objectSpread2({}, config.headers), {}, {
                Authorization: "Bearer ".concat(accessToken)
            });
            return config;
        });
    });
}
// Matches 'sub.host:port' or 'host:port' and extracts hostname and port
// Also enforces toplevel domain specified, no spaces and no protocol
var $24b323c95a04241b$var$HOST_REGEX = /^(?!\w+:\/\/)([^\s:]+\.?[^\s:]+)(?::(\d+))?(?!:)$/;
/**
 * Create pre configured axios instance
 * @private
 * @param {AxiosStatic} axios - Axios library
 * @param {CreateHttpClientParams} options - Initialization parameters for the HTTP client
 * @return {ContentfulAxiosInstance} Initialized axios instance
 */ function $24b323c95a04241b$export$5ff1805767bd358a(axios, options) {
    var defaultConfig = {
        insecure: false,
        retryOnError: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logHandler: function logHandler(level, data) {
            if (level === 'error' && data) {
                var title = [
                    data.name,
                    data.message
                ].filter(function(a) {
                    return a;
                }).join(' - ');
                console.error("[error] ".concat(title));
                console.error(data);
                return;
            }
            console.log("[".concat(level, "] ").concat(data));
        },
        // Passed to axios
        headers: {},
        httpAgent: false,
        httpsAgent: false,
        timeout: 30000,
        throttle: 0,
        proxy: false,
        basePath: '',
        adapter: undefined,
        maxContentLength: 1073741824,
        // 1GB
        maxBodyLength: 1073741824 // 1GB
    };
    var config = $24b323c95a04241b$var$_objectSpread2($24b323c95a04241b$var$_objectSpread2({}, defaultConfig), options);
    if (!config.accessToken) {
        var missingAccessTokenError = new TypeError('Expected parameter accessToken');
        config.logHandler('error', missingAccessTokenError);
        throw missingAccessTokenError;
    }
    // Construct axios baseURL option
    var protocol = config.insecure ? 'http' : 'https';
    var space = config.space ? "".concat(config.space, "/") : '';
    var hostname = config.defaultHostname;
    var port = config.insecure ? 80 : 443;
    if (config.host && $24b323c95a04241b$var$HOST_REGEX.test(config.host)) {
        var parsed = config.host.split(':');
        if (parsed.length === 2) {
            var _parsed = $24b323c95a04241b$var$_slicedToArray(parsed, 2);
            hostname = _parsed[0];
            port = _parsed[1];
        } else hostname = parsed[0];
    }
    // Ensure that basePath does start but not end with a slash
    if (config.basePath) config.basePath = "/".concat(config.basePath.split('/').filter(Boolean).join('/'));
    var baseURL = options.baseURL || "".concat(protocol, "://").concat(hostname, ":").concat(port).concat(config.basePath, "/spaces/").concat(space);
    if (!config.headers.Authorization && typeof config.accessToken !== 'function') config.headers.Authorization = 'Bearer ' + config.accessToken;
    var axiosOptions = {
        // Axios
        baseURL: baseURL,
        headers: config.headers,
        httpAgent: config.httpAgent,
        httpsAgent: config.httpsAgent,
        paramsSerializer: (0, (/*@__PURE__*/$parcel$interopDefault($6e19be61753cbc35$exports))).stringify,
        proxy: config.proxy,
        timeout: config.timeout,
        adapter: config.adapter,
        maxContentLength: config.maxContentLength,
        maxBodyLength: config.maxBodyLength,
        // Contentful
        logHandler: config.logHandler,
        responseLogger: config.responseLogger,
        requestLogger: config.requestLogger,
        retryOnError: config.retryOnError
    };
    var instance = axios.create(axiosOptions);
    instance.httpClientParams = options;
    /**
   * Creates a new axios instance with the same default base parameters as the
   * current one, and with any overrides passed to the newParams object
   * This is useful as the SDKs use dependency injection to get the axios library
   * and the version of the library comes from different places depending
   * on whether it's a browser build or a node.js build.
   * @private
   * @param {CreateHttpClientParams} httpClientParams - Initialization parameters for the HTTP client
   * @return {ContentfulAxiosInstance} Initialized axios instance
   */ instance.cloneWithNewParams = function(newParams) {
        return $24b323c95a04241b$export$5ff1805767bd358a(axios, $24b323c95a04241b$var$_objectSpread2($24b323c95a04241b$var$_objectSpread2({}, (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(options)), newParams));
    };
    /**
   * Apply interceptors.
   * Please note that the order of interceptors is important
   */ if (config.onBeforeRequest) instance.interceptors.request.use(config.onBeforeRequest);
    if (typeof config.accessToken === 'function') $24b323c95a04241b$var$asyncToken(instance, config.accessToken);
    if (config.throttle) $24b323c95a04241b$var$rateLimitThrottle(instance, config.throttle);
    $24b323c95a04241b$var$rateLimit(instance, config.retryLimit);
    if (config.onError) instance.interceptors.response.use(function(response) {
        return response;
    }, config.onError);
    return instance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Creates request parameters configuration by parsing an existing query object
 * @private
 * @param {Object} query
 * @return {Object} Config object with `params` property, ready to be used in axios
 */ function $24b323c95a04241b$export$b9eda6f1d11bafa2(_ref) {
    var query = _ref.query;
    var config = {};
    delete query.resolveLinks;
    config.params = (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(query);
    return config;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $24b323c95a04241b$export$2d463bb1e491631d(obj, path) {
    if (!(path in obj)) {
        var err = new Error();
        err.name = 'PropertyMissing';
        err.message = "Required property ".concat(path, " missing from:\n\n").concat(JSON.stringify(obj), "\n\n");
        throw err;
    }
    return true;
}
// copied from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
function $24b323c95a04241b$var$deepFreeze(object) {
    var propNames = Object.getOwnPropertyNames(object);
    var _iterator = $24b323c95a04241b$var$_createForOfIteratorHelper(propNames), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var name = _step.value;
            var value = object[name];
            if (value && $24b323c95a04241b$var$_typeof(value) === 'object') $24b323c95a04241b$var$deepFreeze(value);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return Object.freeze(object);
}
function $24b323c95a04241b$export$5f59ea1ba3499740(obj) {
    $24b323c95a04241b$var$deepFreeze(obj.sys || {});
    return obj;
}
function $24b323c95a04241b$var$getBrowserOS() {
    var win = $24b323c95a04241b$var$getWindow();
    if (!win) return null;
    var userAgent = win.navigator.userAgent;
    // TODO: platform is deprecated.
    var platform = win.navigator.platform;
    var macosPlatforms = [
        'Macintosh',
        'MacIntel',
        'MacPPC',
        'Mac68K'
    ];
    var windowsPlatforms = [
        'Win32',
        'Win64',
        'Windows',
        'WinCE'
    ];
    var iosPlatforms = [
        'iPhone',
        'iPad',
        'iPod'
    ];
    if (macosPlatforms.indexOf(platform) !== -1) return 'macOS';
    else if (iosPlatforms.indexOf(platform) !== -1) return 'iOS';
    else if (windowsPlatforms.indexOf(platform) !== -1) return 'Windows';
    else if (/Android/.test(userAgent)) return 'Android';
    else if (/Linux/.test(platform)) return 'Linux';
    return null;
}
function $24b323c95a04241b$var$getNodeOS() {
    var platform = $3267bbb6db0678de$exports.platform || 'linux';
    var version = $3267bbb6db0678de$exports.version || '0.0.0';
    var platformMap = {
        android: 'Android',
        aix: 'Linux',
        darwin: 'macOS',
        freebsd: 'Linux',
        linux: 'Linux',
        openbsd: 'Linux',
        sunos: 'Linux',
        win32: 'Windows'
    };
    if (platform in platformMap) return "".concat(platformMap[platform] || 'Linux', "/").concat(version);
    return null;
}
function $24b323c95a04241b$export$56c7340f89ca57c5(sdk, application, integration, feature) {
    var headerParts = [];
    if (application) headerParts.push("app ".concat(application));
    if (integration) headerParts.push("integration ".concat(integration));
    if (feature) headerParts.push('feature ' + feature);
    headerParts.push("sdk ".concat(sdk));
    var platform = null;
    try {
        if ($24b323c95a04241b$var$isReactNative()) {
            platform = $24b323c95a04241b$var$getBrowserOS();
            headerParts.push('platform ReactNative');
        } else if ($24b323c95a04241b$var$isNode()) {
            platform = $24b323c95a04241b$var$getNodeOS();
            headerParts.push("platform node.js/".concat($24b323c95a04241b$var$getNodeVersion()));
        } else {
            platform = $24b323c95a04241b$var$getBrowserOS();
            headerParts.push('platform browser');
        }
    } catch (e) {
        platform = null;
    }
    if (platform) headerParts.push("os ".concat(platform));
    return "".concat(headerParts.filter(function(item) {
        return item !== '';
    }).join('; '), ";");
}
/**
 * Mixes in a method to return just a plain object with no additional methods
 * @private
 * @param data - Any plain JSON response returned from the API
 * @return Enhanced object with toPlainObject method
 */ function $24b323c95a04241b$export$8530f7b85295aab2(data) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    return Object.defineProperty(data, 'toPlainObject', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function value() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(this);
        }
    });
}
/**
 * Handles errors received from the server. Parses the error into a more useful
 * format, places it in an exception and throws it.
 * See https://www.contentful.com/developers/docs/references/errors/
 * for more details on the data received on the errorResponse.data property
 * and the expected error codes.
 * @private
 */ function $24b323c95a04241b$export$cc3fdd528b56c4a9(errorResponse) {
    var config = errorResponse.config, response = errorResponse.response;
    var errorName;
    // Obscure the Management token
    if (config && config.headers && config.headers['Authorization']) {
        var token = "...".concat(config.headers['Authorization'].toString().substr(-5));
        config.headers['Authorization'] = "Bearer ".concat(token);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3bdddaf3abddf785$exports)))(response) || !(0, (/*@__PURE__*/$parcel$interopDefault($3bdddaf3abddf785$exports)))(config)) throw errorResponse;
    var data = response === null || response === void 0 ? void 0 : response.data;
    var errorData = {
        status: response === null || response === void 0 ? void 0 : response.status,
        statusText: response === null || response === void 0 ? void 0 : response.statusText,
        message: '',
        details: {}
    };
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3bdddaf3abddf785$exports)))(config)) errorData.request = {
        url: config.url,
        headers: config.headers,
        method: config.method,
        payloadData: config.data
    };
    if (data && (0, (/*@__PURE__*/$parcel$interopDefault($3bdddaf3abddf785$exports)))(data)) {
        if ('requestId' in data) errorData.requestId = data.requestId || 'UNKNOWN';
        if ('message' in data) errorData.message = data.message || '';
        if ('details' in data) errorData.details = data.details || {};
        if ('sys' in data) {
            if ('id' in data.sys) errorName = data.sys.id;
        }
    }
    var error = new Error();
    error.name = errorName && errorName !== 'Unknown' ? errorName : "".concat(response === null || response === void 0 ? void 0 : response.status, " ").concat(response === null || response === void 0 ? void 0 : response.statusText);
    try {
        error.message = JSON.stringify(errorData, null, '  ');
    } catch (_unused) {
        var _errorData$message;
        error.message = (_errorData$message = errorData === null || errorData === void 0 ? void 0 : errorData.message) !== null && _errorData$message !== void 0 ? _errorData$message : '';
    }
    throw error;
}



var $a15838d6adce0ad4$exports = {};

$parcel$export($a15838d6adce0ad4$exports, "wrapSpace", () => $a15838d6adce0ad4$export$cb5ff1eae4996863);

function $a15838d6adce0ad4$export$cb5ff1eae4996863(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)(data));
}


var $206a6a54e62df523$exports = {};

$parcel$export($206a6a54e62df523$exports, "wrapEntry", () => $206a6a54e62df523$export$3c25ec50ddfd858c);
$parcel$export($206a6a54e62df523$exports, "wrapEntryCollection", () => $206a6a54e62df523$export$d5eecd09c78a1741);



var $kR54n = parcelRequire("kR54n");
function $89639679f16b8887$export$2e2bcd8739ae039(data) {
    return Object.defineProperty(data, 'stringifySafe', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function() {
            let serializer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            let indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            return (0, (/*@__PURE__*/$parcel$interopDefault($kR54n)))(this, serializer, indent, (key, value)=>{
                return {
                    sys: {
                        type: 'Link',
                        linkType: 'Entry',
                        id: value.sys.id,
                        circular: true
                    }
                };
            });
        }
    });
}



var $ca1cd7dc0760fd40$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $ca1cd7dc0760fd40$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $ca1cd7dc0760fd40$var$UNRESOLVED_LINK = {}; // unique object to avoid polyfill bloat using Symbol()
/**
 * isLink Function
 * Checks if the object has sys.type "Link"
 * @param object
 */ var $ca1cd7dc0760fd40$var$isLink = function isLink(object) {
    return object && object.sys && object.sys.type === 'Link';
};
/**
 * isResourceLink Function
 * Checks if the object has sys.type "ResourceLink"
 * @param object
 */ var $ca1cd7dc0760fd40$var$isResourceLink = function isResourceLink(object) {
    return object && object.sys && object.sys.type === 'ResourceLink';
};
/**
 * Creates a key with spaceId and a key without for entityMap
 *
 * @param {*} sys
 * @param {String} sys.type
 * @param {String} sys.id
 * @param {*} sys.space
 * @param {*} sys.space.sys
 * @param {String} sys.space.id
 * @return {string[]}
 */ var $ca1cd7dc0760fd40$var$makeEntityMapKeys = function makeEntityMapKeys(sys) {
    return sys.space ? [
        sys.type + '!' + sys.id,
        sys.space.sys.id + '!' + sys.type + '!' + sys.id
    ] : [
        sys.type + '!' + sys.id
    ];
};
/**
 * Looks up in entityMap
 *
 * @param entityMap
 * @param {*} linkData
 * @param {String} linkData.type
 * @param {String} linkData.linkType
 * @param {String} linkData.id
 * @param {String} linkData.urn
 * @return {String}
 */ var $ca1cd7dc0760fd40$var$lookupInEntityMap = function lookupInEntityMap(entityMap, linkData) {
    var entryId = linkData.entryId, linkType = linkData.linkType, spaceId = linkData.spaceId;
    if (spaceId) return entityMap.get(spaceId + '!' + linkType + '!' + entryId);
    return entityMap.get(linkType + '!' + entryId);
};
/**
 * getResolvedLink Function
 *
 * @param entityMap
 * @param link
 * @return {undefined}
 */ var $ca1cd7dc0760fd40$var$getResolvedLink = function getResolvedLink(entityMap, link) {
    var _link$sys = link.sys, type = _link$sys.type, linkType = _link$sys.linkType;
    if (type === 'ResourceLink') {
        var urn = link.sys.urn;
        var regExp = /.*:spaces\/(?<spaceId>[A-Za-z0-9]*)\/entries\/(?<entryId>[A-Za-z0-9]*)/;
        if (!regExp.test(urn)) return $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
        var _urn$match$groups = urn.match(regExp).groups, spaceId = _urn$match$groups.spaceId, _entryId = _urn$match$groups.entryId;
        var extractedLinkType = linkType.split(':')[1];
        return $ca1cd7dc0760fd40$var$lookupInEntityMap(entityMap, {
            linkType: extractedLinkType,
            entryId: _entryId,
            spaceId: spaceId
        }) || $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
    }
    var entryId = link.sys.id;
    return $ca1cd7dc0760fd40$var$lookupInEntityMap(entityMap, {
        linkType: linkType,
        entryId: entryId
    }) || $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
};
/**
 * cleanUpLinks Function
 * - Removes unresolvable links from Arrays and Objects
 *
 * @param {Object[]|Object} input
 */ var $ca1cd7dc0760fd40$var$cleanUpLinks = function cleanUpLinks(input) {
    if (Array.isArray(input)) return input.filter(function(val) {
        return val !== $ca1cd7dc0760fd40$var$UNRESOLVED_LINK;
    });
    for(var key in input)if (input[key] === $ca1cd7dc0760fd40$var$UNRESOLVED_LINK) delete input[key];
    return input;
};
/**
 * walkMutate Function
 * @param input
 * @param predicate
 * @param mutator
 * @param removeUnresolved
 * @return {*}
 */ var $ca1cd7dc0760fd40$var$walkMutate = function walkMutate(input, predicate, mutator, removeUnresolved) {
    if (predicate(input)) return mutator(input);
    if (input && (typeof input === 'undefined' ? 'undefined' : $ca1cd7dc0760fd40$var$_typeof(input)) === 'object') {
        for(var key in input)// eslint-disable-next-line no-prototype-builtins
        if (input.hasOwnProperty(key)) input[key] = walkMutate(input[key], predicate, mutator, removeUnresolved);
        if (removeUnresolved) input = $ca1cd7dc0760fd40$var$cleanUpLinks(input);
    }
    return input;
};
var $ca1cd7dc0760fd40$var$normalizeLink = function normalizeLink(entityMap, link, removeUnresolved) {
    var resolvedLink = $ca1cd7dc0760fd40$var$getResolvedLink(entityMap, link);
    if (resolvedLink === $ca1cd7dc0760fd40$var$UNRESOLVED_LINK) return removeUnresolved ? resolvedLink : link;
    return resolvedLink;
};
var $ca1cd7dc0760fd40$var$makeEntryObject = function makeEntryObject(item, itemEntryPoints) {
    if (!Array.isArray(itemEntryPoints)) return item;
    var entryPoints = Object.keys(item).filter(function(ownKey) {
        return itemEntryPoints.indexOf(ownKey) !== -1;
    });
    return entryPoints.reduce(function(entryObj, entryPoint) {
        entryObj[entryPoint] = item[entryPoint];
        return entryObj;
    }, {});
};
/**
 * resolveResponse Function
 * Resolves contentful response to normalized form.
 * @param {Object} response Contentful response
 * @param {{removeUnresolved: Boolean, itemEntryPoints: Array<String>}|{}} options
 * @param {Boolean} options.removeUnresolved - Remove unresolved links default:false
 * @param {Array<String>} options.itemEntryPoints - Resolve links only in those item properties
 * @return {Object}
 */ var $ca1cd7dc0760fd40$var$resolveResponse = function resolveResponse(response, options) {
    options = options || {};
    if (!response.items) return [];
    var responseClone = (0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(response);
    var allIncludes = Object.keys(responseClone.includes || {}).reduce(function(all, type) {
        return [].concat($ca1cd7dc0760fd40$var$_toConsumableArray(all), $ca1cd7dc0760fd40$var$_toConsumableArray(response.includes[type]));
    }, []);
    var allEntries = [].concat($ca1cd7dc0760fd40$var$_toConsumableArray(responseClone.items), $ca1cd7dc0760fd40$var$_toConsumableArray(allIncludes));
    var entityMap = new Map(allEntries.reduce(function(acc, entity) {
        var entries = $ca1cd7dc0760fd40$var$makeEntityMapKeys(entity.sys).map(function(key) {
            return [
                key,
                entity
            ];
        });
        acc.push.apply(acc, $ca1cd7dc0760fd40$var$_toConsumableArray(entries));
        return acc;
    }, []));
    allEntries.forEach(function(item) {
        var entryObject = $ca1cd7dc0760fd40$var$makeEntryObject(item, options.itemEntryPoints);
        Object.assign(item, $ca1cd7dc0760fd40$var$walkMutate(entryObject, function(x) {
            return $ca1cd7dc0760fd40$var$isLink(x) || $ca1cd7dc0760fd40$var$isResourceLink(x);
        }, function(link) {
            return $ca1cd7dc0760fd40$var$normalizeLink(entityMap, link, options.removeUnresolved);
        }, options.removeUnresolved));
    });
    return responseClone.items;
};
var $ca1cd7dc0760fd40$export$2e2bcd8739ae039 = $ca1cd7dc0760fd40$var$resolveResponse;


function $206a6a54e62df523$export$3c25ec50ddfd858c(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $206a6a54e62df523$export$d5eecd09c78a1741(data, _ref) {
    let { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = _ref;
    const wrappedData = (0, $89639679f16b8887$export$2e2bcd8739ae039)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
    if (resolveLinks) wrappedData.items = (0, $ca1cd7dc0760fd40$export$2e2bcd8739ae039)(wrappedData, {
        removeUnresolved: removeUnresolved,
        itemEntryPoints: [
            'fields'
        ]
    });
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)(wrappedData);
}


var $11cd1c5d46f60b03$exports = {};

$parcel$export($11cd1c5d46f60b03$exports, "wrapAsset", () => $11cd1c5d46f60b03$export$a0be037962933a64);
$parcel$export($11cd1c5d46f60b03$exports, "wrapAssetCollection", () => $11cd1c5d46f60b03$export$703c04942b452817);


function $11cd1c5d46f60b03$export$a0be037962933a64(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $11cd1c5d46f60b03$export$703c04942b452817(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $06fe4c90f1058af1$exports = {};

$parcel$export($06fe4c90f1058af1$exports, "wrapAssetKey", () => $06fe4c90f1058af1$export$c3716da8516cbd37);


function $06fe4c90f1058af1$export$c3716da8516cbd37(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $aa045771e14ce9f6$exports = {};

$parcel$export($aa045771e14ce9f6$exports, "wrapContentType", () => $aa045771e14ce9f6$export$8ffdd5df20b16d17);
$parcel$export($aa045771e14ce9f6$exports, "wrapContentTypeCollection", () => $aa045771e14ce9f6$export$3d2cfb0ebcba8025);


function $aa045771e14ce9f6$export$8ffdd5df20b16d17(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $aa045771e14ce9f6$export$3d2cfb0ebcba8025(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $57fa5d94a906c611$exports = {};

$parcel$export($57fa5d94a906c611$exports, "wrapLocale", () => $57fa5d94a906c611$export$8dc16501d170823d);
$parcel$export($57fa5d94a906c611$exports, "wrapLocaleCollection", () => $57fa5d94a906c611$export$7e4340f6ba44035a);


function $57fa5d94a906c611$export$8dc16501d170823d(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $57fa5d94a906c611$export$7e4340f6ba44035a(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $8efe14b02c001f44$exports = {};

$parcel$export($8efe14b02c001f44$exports, "wrapTag", () => $8efe14b02c001f44$export$e1decaf6a8504f95);
$parcel$export($8efe14b02c001f44$exports, "wrapTagCollection", () => $8efe14b02c001f44$export$6dec601a1a726211);


function $8efe14b02c001f44$export$e1decaf6a8504f95(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}
function $8efe14b02c001f44$export$6dec601a1a726211(data) {
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $24b323c95a04241b$export$8530f7b85295aab2)((0, (/*@__PURE__*/$parcel$interopDefault($41c099b1976cc56f$exports)))(data)));
}


var $e41a6e5d48dcbf50$export$2e2bcd8739ae039 = {
    space: $a15838d6adce0ad4$exports,
    entry: $206a6a54e62df523$exports,
    asset: $11cd1c5d46f60b03$exports,
    assetKey: $06fe4c90f1058af1$exports,
    contentType: $aa045771e14ce9f6$exports,
    locale: $57fa5d94a906c611$exports,
    tag: $8efe14b02c001f44$exports
};





function $a70d67d792b25bfa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a70d67d792b25bfa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a70d67d792b25bfa$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a70d67d792b25bfa$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a70d67d792b25bfa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a70d67d792b25bfa$var$_defineProperty(obj, key, value) {
    key = $a70d67d792b25bfa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a70d67d792b25bfa$var$_toPropertyKey(arg) {
    var key = $a70d67d792b25bfa$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a70d67d792b25bfa$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
async function $a70d67d792b25bfa$export$2e2bcd8739ae039(http, query) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!query || !query.initial && !query.nextSyncToken && !query.nextPageToken) throw new Error('Please provide one of `initial`, `nextSyncToken` or `nextPageToken` parameters for syncing');
    if (query && query.content_type && !query.type) query.type = 'Entry';
    else if (query && query.content_type && query.type && query.type !== 'Entry') throw new Error('When using the `content_type` filter your `type` parameter cannot be different from `Entry`.');
    const defaultOptions = {
        resolveLinks: true,
        removeUnresolved: false,
        paginate: true
    };
    const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved, paginate: paginate } = $a70d67d792b25bfa$var$_objectSpread($a70d67d792b25bfa$var$_objectSpread({}, defaultOptions), options);
    const syncOptions = {
        paginate: paginate
    };
    const response = await $a70d67d792b25bfa$var$getSyncPage(http, [], query, syncOptions);
    // clones response.items used in includes because we don't want these to be mutated
    if (resolveLinks) response.items = (0, $ca1cd7dc0760fd40$export$2e2bcd8739ae039)(response, {
        removeUnresolved: removeUnresolved,
        itemEntryPoints: [
            'fields'
        ]
    });
    // maps response items again after getters are attached
    const mappedResponseItems = $a70d67d792b25bfa$var$mapResponseItems(response.items);
    if (response.nextSyncToken) mappedResponseItems.nextSyncToken = response.nextSyncToken;
    if (response.nextPageToken) mappedResponseItems.nextPageToken = response.nextPageToken;
    return (0, $24b323c95a04241b$export$5f59ea1ba3499740)((0, $89639679f16b8887$export$2e2bcd8739ae039)((0, $24b323c95a04241b$export$8530f7b85295aab2)(mappedResponseItems)));
}
/**
 * @private
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @return {Object} Entities mapped to an object for each entity type
 */ function $a70d67d792b25bfa$var$mapResponseItems(items) {
    const reducer = (type)=>{
        return (accumulated, item)=>{
            if (item.sys.type === type) accumulated.push((0, $24b323c95a04241b$export$8530f7b85295aab2)(item));
            return accumulated;
        };
    };
    return {
        entries: items.reduce(reducer('Entry'), []),
        assets: items.reduce(reducer('Asset'), []),
        deletedEntries: items.reduce(reducer('DeletedEntry'), []),
        deletedAssets: items.reduce(reducer('DeletedAsset'), [])
    };
}
/**
 * If the response contains a nextPageUrl, extracts the sync token to get the
 * next page and calls itself again with that token.
 * Otherwise, if the response contains a nextSyncUrl, extracts the sync token
 * and returns it.
 * On each call of this function, any retrieved items are collected in the
 * supplied items array, which gets returned in the end
 * @private
 * @param {Object} http
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @param {Object} query
 * @param {Object} options - Sync page options object
 * @param {boolean} [options.paginate = true] - If further sync pages should automatically be crawled
 * @return {Promise<{items: Array, nextSyncToken: string}>}
 */ async function $a70d67d792b25bfa$var$getSyncPage(http, items, query, _ref) {
    let { paginate: paginate } = _ref;
    if (query.nextSyncToken) {
        query.sync_token = query.nextSyncToken;
        delete query.nextSyncToken;
    }
    if (query.nextPageToken) {
        query.sync_token = query.nextPageToken;
        delete query.nextPageToken;
    }
    if (query.sync_token) {
        delete query.initial;
        delete query.type;
        delete query.content_type;
        delete query.limit;
    }
    const response = await http.get('sync', (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
        query: query
    }));
    const data = response.data || {};
    items = items.concat(data.items || []);
    if (data.nextPageUrl) {
        if (paginate) {
            delete query.initial;
            query.sync_token = $a70d67d792b25bfa$var$getToken(data.nextPageUrl);
            return $a70d67d792b25bfa$var$getSyncPage(http, items, query, {
                paginate: paginate
            });
        }
        return {
            items: items,
            nextPageToken: $a70d67d792b25bfa$var$getToken(data.nextPageUrl)
        };
    } else if (data.nextSyncUrl) return {
        items: items,
        nextSyncToken: $a70d67d792b25bfa$var$getToken(data.nextSyncUrl)
    };
    else return {
        items: []
    };
}
/**
 * Extracts token out of an url
 * @private
 */ function $a70d67d792b25bfa$var$getToken(url) {
    const urlParts = url.split('?');
    return urlParts.length > 0 ? urlParts[1].replace('sync_token=', '') : '';
}


function $acfacf05f6be6c47$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $acfacf05f6be6c47$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $acfacf05f6be6c47$var$ownKeys(Object(source), !0).forEach(function(key) {
            $acfacf05f6be6c47$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $acfacf05f6be6c47$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $acfacf05f6be6c47$var$_defineProperty(obj, key, value) {
    key = $acfacf05f6be6c47$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $acfacf05f6be6c47$var$_toPropertyKey(arg) {
    var key = $acfacf05f6be6c47$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $acfacf05f6be6c47$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $acfacf05f6be6c47$export$2e2bcd8739ae039(query) {
    if (!query.select) return query;
    // The selection of fields for the query is limited
    // Get the different parts that are listed for selection
    const allSelects = Array.isArray(query.select) ? query.select : query.select.split(',').map((q)=>q.trim());
    // Move the parts into a set for easy access and deduplication
    const selectedSet = new Set(allSelects);
    // If we already select all of `sys` we can just return
    // since we're anyway fetching everything that is needed
    if (selectedSet.has('sys')) return query;
    // We don't select `sys` so we need to ensure the minimum set
    selectedSet.add('sys.id');
    selectedSet.add('sys.type');
    // Reassign the normalized sys properties
    return $acfacf05f6be6c47$var$_objectSpread($acfacf05f6be6c47$var$_objectSpread({}, query), {}, {
        select: [
            ...selectedSet
        ].join(',')
    });
}


class $a7e32c1f31f2bcbf$export$2191b9da168c6cf0 extends Error {
    constructor(name, message){
        super(`Invalid "${name}" provided, ` + message);
        this.name = 'ValidationError';
    }
}
function $a7e32c1f31f2bcbf$export$2e2bcd8739ae039(name, timestamp, options) {
    options = options || {};
    if (typeof timestamp !== 'number') throw new $a7e32c1f31f2bcbf$export$2191b9da168c6cf0(name, `only numeric values are allowed for timestamps, provided type was "${typeof timestamp}"`);
    if (options.maximum && timestamp > options.maximum) throw new $a7e32c1f31f2bcbf$export$2191b9da168c6cf0(name, `value (${timestamp}) cannot be further in the future than expected maximum (${options.maximum})`);
    if (options.now && timestamp < options.now) throw new $a7e32c1f31f2bcbf$export$2191b9da168c6cf0(name, `value (${timestamp}) cannot be in the past, current time was ${options.now}`);
}


function $160dd87da30dde6a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $160dd87da30dde6a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $160dd87da30dde6a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $160dd87da30dde6a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $160dd87da30dde6a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $160dd87da30dde6a$var$_defineProperty(obj, key, value) {
    key = $160dd87da30dde6a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $160dd87da30dde6a$var$_toPropertyKey(arg) {
    var key = $160dd87da30dde6a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $160dd87da30dde6a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $160dd87da30dde6a$var$ASSET_KEY_MAX_LIFETIME = 172800;
function $160dd87da30dde6a$export$2e2bcd8739ae039(_ref) {
    let { http: http, getGlobalOptions: getGlobalOptions } = _ref;
    const { wrapSpace: wrapSpace } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).space;
    const { wrapContentType: wrapContentType, wrapContentTypeCollection: wrapContentTypeCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).contentType;
    const { wrapEntry: wrapEntry, wrapEntryCollection: wrapEntryCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).entry;
    const { wrapAsset: wrapAsset, wrapAssetCollection: wrapAssetCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).asset;
    const { wrapTag: wrapTag, wrapTagCollection: wrapTagCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).tag;
    const { wrapAssetKey: wrapAssetKey } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).assetKey;
    const { wrapLocaleCollection: wrapLocaleCollection } = (0, $e41a6e5d48dcbf50$export$2e2bcd8739ae039).locale;
    const notFoundError = (id)=>{
        const error = new Error('The resource could not be found.');
        error.sys = {
            type: 'Error',
            id: 'NotFound'
        };
        error.details = {
            type: 'Entry',
            id: id,
            environment: getGlobalOptions().environment,
            space: getGlobalOptions().space
        };
        return error;
    };
    /**
   * Gets the Space which the client is currently configured to use
   * @memberof ContentfulClientAPI
   * @return {Promise<Entities.Space>} Promise for a Space
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   * // returns the space object with the above <space-id>
   * const space = await client.getSpace()
   * console.log(space)
   */ async function getSpace() {
        switchToSpace(http);
        try {
            const response = await http.get('/');
            return wrapSpace(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a Content Type
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.ContentType>} Promise for a Content Type
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const contentType = await client.getContentType('<content_type_id>')
   * console.log(contentType)
   */ async function getContentType(id) {
        switchToEnvironment(http);
        try {
            const response = await http.get(`content_types/${id}`);
            return wrapContentType(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Content Types
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.ContentTypeCollection>} Promise for a collection of Content Types
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getContentTypes()
   * console.log(response.items)
   */ async function getContentTypes() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        try {
            const response = await http.get('content_types', (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapContentTypeCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets an Entry
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Entry>} Promise for an Entry
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const entry = await client.getEntry('<entry_id>')
   * console.log(entry)
   */ async function getEntry(id) {
        let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!id) throw notFoundError(id);
        try {
            const response = await this.getEntries($160dd87da30dde6a$var$_objectSpread({
                'sys.id': id
            }, query));
            if (response.items.length > 0) return wrapEntry(response.items[0]);
            else throw notFoundError(id);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Entries
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.EntryCollection>} Promise for a collection of Entries
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getEntries()
   * console.log(response.items)
   */ async function getEntries() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions(query);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get('entries', (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapEntryCollection(response.data, {
                resolveLinks: resolveLinks,
                removeUnresolved: removeUnresolved
            });
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets an Asset
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Asset>} Promise for an Asset
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const asset = await client.getAsset('<asset_id>')
   * console.log(asset)
   */ async function getAsset(id) {
        let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        switchToEnvironment(http);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get(`assets/${id}`, (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapAsset(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Assets
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.AssetCollection>} Promise for a collection of Assets
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getAssets()
   * console.log(response.items)
   */ async function getAssets() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get('assets', (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapAssetCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a Tag
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.Tag>} Promise for a Tag
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const tag = await client.getTag('<asset_id>')
   * console.log(tag)
   */ async function getTag(id) {
        switchToEnvironment(http);
        try {
            const response = await http.get(`tags/${id}`);
            return wrapTag(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Tags
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters.
   * @return {Promise<Entities.TagCollection>} Promise for a collection of Tags
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getTags()
   * console.log(response.items)
   */ async function getTags() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        query = (0, $acfacf05f6be6c47$export$2e2bcd8739ae039)(query);
        try {
            const response = await http.get('tags', (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapTagCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Creates an asset key for signing asset URLs (Embargoed Assets)
   * @memberof ContentfulClientAPI
   * @param {number} expiresAt - UNIX timestamp in the future, maximum of 48h from now
   * @return {Promise<Entities.AssetKey>} Promise for an AssetKey
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const assetKey = await client.getAssetKey(<UNIX timestamp>)
   * console.log(assetKey)
   */ async function createAssetKey(expiresAt) {
        switchToEnvironment(http);
        try {
            const now = Math.floor(Date.now() / 1000);
            const currentMaxLifetime = now + $160dd87da30dde6a$var$ASSET_KEY_MAX_LIFETIME;
            (0, $a7e32c1f31f2bcbf$export$2e2bcd8739ae039)('expiresAt', expiresAt, {
                maximum: currentMaxLifetime,
                now: now
            });
            const params = {
                expiresAt: expiresAt
            };
            const response = await http.post('asset_keys', params);
            return wrapAssetKey(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Gets a collection of Locale
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.LocaleCollection>} Promise for a collection of Locale
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.getLocales()
   * console.log(response.items)
   */ async function getLocales() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        switchToEnvironment(http);
        try {
            const response = await http.get('locales', (0, $24b323c95a04241b$export$b9eda6f1d11bafa2)({
                query: query
            }));
            return wrapLocaleCollection(response.data);
        } catch (error) {
            (0, $24b323c95a04241b$export$cc3fdd528b56c4a9)(error);
        }
    }
    /**
   * Synchronizes either all the content or only new content since last sync
   * See <a href="https://www.contentful.com/developers/docs/concepts/sync/">Synchronization</a> for more information.
   * <strong> Important note: </strong> The the sync api endpoint does not support include or link resolution.
   * However contentful.js is doing link resolution client side if you only make an initial sync.
   * For the delta sync (using nextSyncToken) it is not possible since the sdk wont have access to all the data to make such an operation.
   * @memberof ContentfulClientAPI
   * @param  {Object} query - Query object for the sync call. One of initial or nextSyncToken always needs to be specified, but not both.
   * @param  {boolean?} query.initial - Indicates if this is the first sync. Use it if you don't have a sync token.
   * @param  {string?} query.nextSyncToken - The token you got the last time you used this method. Ensures you only get changed content.
   * @param  {string=} query.type - Filter by this type (all (default), Entry, Asset, Deletion, DeletedAsset or DeletedEntry)
   * @param  {string=} query.content_type - Filter by this content type id
   * @param  {boolean=} query.resolveLinks - When true, links to other Entries or Assets are resolved. Default: true.
   * @param  {Object} options
   * @param  {boolean=} [options.paginate = true] - Set to false to disable pagination
   * @return {Promise<Sync.SyncCollection>} Promise for the collection resulting of a sync operation
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * const response = await client.sync({
   *   initial: true
   * })
   * console.log({
   *   entries: response.entries,
   *   assets: response.assets,
   *   nextSyncToken: response.nextSyncToken
   * })
   */ async function sync() {
        let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            paginate: true
        };
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions(query);
        switchToEnvironment(http);
        return (0, $a70d67d792b25bfa$export$2e2bcd8739ae039)(http, query, $160dd87da30dde6a$var$_objectSpread({
            resolveLinks: resolveLinks,
            removeUnresolved: removeUnresolved
        }, options));
    }
    /**
  * Parse raw json data into collection of entry objects.Links will be resolved also
  * @memberof ContentfulClientAPI
  * @param {Object} raw json data
  * @example
  * let data = {items: [
  *    {
  *    sys: {type: 'Entry', locale: 'en-US'},
  *    fields: {
  *      animal: {sys: {type: 'Link', linkType: 'Animal', id: 'oink'}},
  *      anotheranimal: {sys: {type: 'Link', linkType: 'Animal', id: 'middle-parrot'}}
  *    }
  *  }
  * ],
  * includes: {
  *  Animal: [
  *    {
  *      sys: {type: 'Animal', id: 'oink', locale: 'en-US'},
  *      fields: {
  *        name: 'Pig',
  *        friend: {sys: {type: 'Link', linkType: 'Animal', id: 'groundhog'}}
  *      }
  *    }
  *   ]
  *  }
  * }
  * console.log( data.items[0].fields.foo ); // undefined
  * let parsedData = client.parseEntries(data);
  * console.log( parsedData.items[0].fields.foo ); // foo
  */ function parseEntries(data) {
        const { resolveLinks: resolveLinks, removeUnresolved: removeUnresolved } = getGlobalOptions({});
        return wrapEntryCollection(data, {
            resolveLinks: resolveLinks,
            removeUnresolved: removeUnresolved
        });
    }
    /*
   * Switches BaseURL to use /environments path
   * */ function switchToEnvironment(http) {
        http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
    }
    /*
   * Switches BaseURL to use /spaces path
   * */ function switchToSpace(http) {
        http.defaults.baseURL = getGlobalOptions().spaceBaseUrl;
    }
    return {
        getSpace: getSpace,
        getContentType: getContentType,
        getContentTypes: getContentTypes,
        getEntry: getEntry,
        getEntries: getEntries,
        getAsset: getAsset,
        getAssets: getAssets,
        getTag: getTag,
        getTags: getTags,
        createAssetKey: createAssetKey,
        getLocales: getLocales,
        parseEntries: parseEntries,
        sync: sync
    };
}


/**
 * Link resolution can be set globally, or it can be turned off for the methods
 * which make use of it. The local setting always overrides the global setting.
 * @private
 * @param {boolean} globalSetting - Global library setting for link resolution
 * @returns {function} Link resolver method preconfigured with global setting
 */ function $d7bfcc00e4073776$export$2e2bcd8739ae039(globalSettings) {
    /**
   * Link resolver method
   * @param {Object} query - regular query object used for collection endpoints
   */ return function getGlobalOptions(query) {
        return Object.assign({}, globalSettings, query);
    };
}


function $27e65424bfb9f508$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $27e65424bfb9f508$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $27e65424bfb9f508$var$ownKeys(Object(source), !0).forEach(function(key) {
            $27e65424bfb9f508$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $27e65424bfb9f508$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $27e65424bfb9f508$var$_defineProperty(obj, key, value) {
    key = $27e65424bfb9f508$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27e65424bfb9f508$var$_toPropertyKey(arg) {
    var key = $27e65424bfb9f508$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $27e65424bfb9f508$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $27e65424bfb9f508$export$5d730b7aed1a3eb0(params) {
    if (!params.accessToken) throw new TypeError('Expected parameter accessToken');
    if (!params.space) throw new TypeError('Expected parameter space');
    const defaultConfig = {
        resolveLinks: true,
        removeUnresolved: false,
        defaultHostname: 'cdn.contentful.com',
        environment: 'master'
    };
    const config = $27e65424bfb9f508$var$_objectSpread($27e65424bfb9f508$var$_objectSpread({}, defaultConfig), params);
    const userAgentHeader = (0, $24b323c95a04241b$export$56c7340f89ca57c5)(`contentful.js/${"9.2.19"}`, config.application, config.integration);
    config.headers = $27e65424bfb9f508$var$_objectSpread($27e65424bfb9f508$var$_objectSpread({}, config.headers), {}, {
        'Content-Type': 'application/vnd.contentful.delivery.v1+json',
        'X-Contentful-User-Agent': userAgentHeader
    });
    const http = (0, $24b323c95a04241b$export$5ff1805767bd358a)((0, $4caf0f2bcd8b9e34$export$2e2bcd8739ae039), config);
    const getGlobalOptions = (0, $d7bfcc00e4073776$export$2e2bcd8739ae039)({
        resolveLinks: config.resolveLinks,
        environment: config.environment,
        removeUnresolved: config.removeUnresolved,
        spaceBaseUrl: http.defaults.baseURL,
        environmentBaseUrl: `${http.defaults.baseURL}environments/${config.environment}`
    });
    // Append environment to baseURL
    http.defaults.baseURL = getGlobalOptions().environmentBaseUrl;
    return (0, $160dd87da30dde6a$export$2e2bcd8739ae039)({
        http: http,
        getGlobalOptions: getGlobalOptions
    });
}




var $8tsvq = parcelRequire("8tsvq");

/**
 * React Router DOM v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8tsvq = parcelRequire("8tsvq");

/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $cec6b334748d9a6c$var$_extends() {
    $cec6b334748d9a6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cec6b334748d9a6c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $cec6b334748d9a6c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($cec6b334748d9a6c$export$e19cd5f9376f8cee || ($cec6b334748d9a6c$export$e19cd5f9376f8cee = {}));
const $cec6b334748d9a6c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $cec6b334748d9a6c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $cec6b334748d9a6c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $cec6b334748d9a6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $cec6b334748d9a6c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $cec6b334748d9a6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
    }
    return $cec6b334748d9a6c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $cec6b334748d9a6c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $cec6b334748d9a6c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $cec6b334748d9a6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $cec6b334748d9a6c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $cec6b334748d9a6c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $cec6b334748d9a6c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $cec6b334748d9a6c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $cec6b334748d9a6c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $cec6b334748d9a6c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $cec6b334748d9a6c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $cec6b334748d9a6c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $cec6b334748d9a6c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $cec6b334748d9a6c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $cec6b334748d9a6c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($cec6b334748d9a6c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        let location = $cec6b334748d9a6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $cec6b334748d9a6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        let location = $cec6b334748d9a6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $cec6b334748d9a6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $cec6b334748d9a6c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($cec6b334748d9a6c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($cec6b334748d9a6c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $cec6b334748d9a6c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($cec6b334748d9a6c$var$ResultType || ($cec6b334748d9a6c$var$ResultType = {}));
const $cec6b334748d9a6c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $cec6b334748d9a6c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $cec6b334748d9a6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $cec6b334748d9a6c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $cec6b334748d9a6c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($cec6b334748d9a6c$var$isIndexRoute(route)) {
            let indexRoute = $cec6b334748d9a6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $cec6b334748d9a6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $cec6b334748d9a6c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $cec6b334748d9a6c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $cec6b334748d9a6c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $cec6b334748d9a6c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $cec6b334748d9a6c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $cec6b334748d9a6c$var$flattenRoutes(routes);
    $cec6b334748d9a6c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $cec6b334748d9a6c$export$30d21fd6d7295f52(pathname);
        matches = $cec6b334748d9a6c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $cec6b334748d9a6c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $cec6b334748d9a6c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $cec6b334748d9a6c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $cec6b334748d9a6c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $cec6b334748d9a6c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $cec6b334748d9a6c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $cec6b334748d9a6c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $cec6b334748d9a6c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $cec6b334748d9a6c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $cec6b334748d9a6c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $cec6b334748d9a6c$var$paramRe = /^:[\w-]+$/;
const $cec6b334748d9a6c$var$dynamicSegmentValue = 3;
const $cec6b334748d9a6c$var$indexRouteValue = 2;
const $cec6b334748d9a6c$var$emptySegmentValue = 1;
const $cec6b334748d9a6c$var$staticSegmentValue = 10;
const $cec6b334748d9a6c$var$splatPenalty = -2;
const $cec6b334748d9a6c$var$isSplat = (s)=>s === "*";
function $cec6b334748d9a6c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($cec6b334748d9a6c$var$isSplat)) initialScore += $cec6b334748d9a6c$var$splatPenalty;
    if (index) initialScore += $cec6b334748d9a6c$var$indexRouteValue;
    return segments.filter((s)=>!$cec6b334748d9a6c$var$isSplat(s)).reduce((score, segment)=>score + ($cec6b334748d9a6c$var$paramRe.test(segment) ? $cec6b334748d9a6c$var$dynamicSegmentValue : segment === "" ? $cec6b334748d9a6c$var$emptySegmentValue : $cec6b334748d9a6c$var$staticSegmentValue), initialScore);
}
function $cec6b334748d9a6c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $cec6b334748d9a6c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $cec6b334748d9a6c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $cec6b334748d9a6c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $cec6b334748d9a6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $cec6b334748d9a6c$export$a5c6d149b50c1d86($cec6b334748d9a6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $cec6b334748d9a6c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $cec6b334748d9a6c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $cec6b334748d9a6c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $cec6b334748d9a6c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $cec6b334748d9a6c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $cec6b334748d9a6c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $cec6b334748d9a6c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $cec6b334748d9a6c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $cec6b334748d9a6c$var$isAbsoluteUrl = (url)=>$cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $cec6b334748d9a6c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($cec6b334748d9a6c$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $cec6b334748d9a6c$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $cec6b334748d9a6c$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $cec6b334748d9a6c$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $cec6b334748d9a6c$var$normalizeSearch(search),
        hash: $cec6b334748d9a6c$var$normalizeHash(hash)
    };
}
function $cec6b334748d9a6c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $cec6b334748d9a6c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $cec6b334748d9a6c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $cec6b334748d9a6c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $cec6b334748d9a6c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $cec6b334748d9a6c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $cec6b334748d9a6c$var$_extends({}, toArg);
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $cec6b334748d9a6c$var$getInvalidPathError("?", "pathname", "search", to));
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $cec6b334748d9a6c$var$getInvalidPathError("#", "pathname", "hash", to));
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $cec6b334748d9a6c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $cec6b334748d9a6c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $cec6b334748d9a6c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $cec6b334748d9a6c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $cec6b334748d9a6c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $cec6b334748d9a6c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $cec6b334748d9a6c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $cec6b334748d9a6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $cec6b334748d9a6c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $cec6b334748d9a6c$export$4051a07651545597(data, init) {
    return new $cec6b334748d9a6c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $cec6b334748d9a6c$export$42a99a7a4bc0e76a extends Error {
}
class $cec6b334748d9a6c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $cec6b334748d9a6c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $cec6b334748d9a6c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $cec6b334748d9a6c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $cec6b334748d9a6c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $cec6b334748d9a6c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $cec6b334748d9a6c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $cec6b334748d9a6c$var$unwrapTrackedPromise(value) {
    if (!$cec6b334748d9a6c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $cec6b334748d9a6c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $cec6b334748d9a6c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $cec6b334748d9a6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $cec6b334748d9a6c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $cec6b334748d9a6c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $cec6b334748d9a6c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $cec6b334748d9a6c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $cec6b334748d9a6c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $cec6b334748d9a6c$var$validMutationMethods = new Set($cec6b334748d9a6c$var$validMutationMethodsArr);
const $cec6b334748d9a6c$var$validRequestMethodsArr = [
    "get",
    ...$cec6b334748d9a6c$var$validMutationMethodsArr
];
const $cec6b334748d9a6c$var$validRequestMethods = new Set($cec6b334748d9a6c$var$validRequestMethodsArr);
const $cec6b334748d9a6c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $cec6b334748d9a6c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $cec6b334748d9a6c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cec6b334748d9a6c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cec6b334748d9a6c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $cec6b334748d9a6c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $cec6b334748d9a6c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $cec6b334748d9a6c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cec6b334748d9a6c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $cec6b334748d9a6c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $cec6b334748d9a6c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$cec6b334748d9a6c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$cec6b334748d9a6c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $cec6b334748d9a6c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $cec6b334748d9a6c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $cec6b334748d9a6c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $cec6b334748d9a6c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$cec6b334748d9a6c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $cec6b334748d9a6c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $cec6b334748d9a6c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $cec6b334748d9a6c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $cec6b334748d9a6c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $cec6b334748d9a6c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($cec6b334748d9a6c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $cec6b334748d9a6c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $cec6b334748d9a6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $cec6b334748d9a6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $cec6b334748d9a6c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $cec6b334748d9a6c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $cec6b334748d9a6c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $cec6b334748d9a6c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $cec6b334748d9a6c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $cec6b334748d9a6c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $cec6b334748d9a6c$var$findNearestBoundary(matches).route.id,
            {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $cec6b334748d9a6c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($cec6b334748d9a6c$var$isErrorResult(result) && $cec6b334748d9a6c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $cec6b334748d9a6c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $cec6b334748d9a6c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $cec6b334748d9a6c$var$_extends({
            matches: updatedMatches || matches
        }, $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $cec6b334748d9a6c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $cec6b334748d9a6c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $cec6b334748d9a6c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $cec6b334748d9a6c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $cec6b334748d9a6c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $cec6b334748d9a6c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $cec6b334748d9a6c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $cec6b334748d9a6c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($cec6b334748d9a6c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $cec6b334748d9a6c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $cec6b334748d9a6c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $cec6b334748d9a6c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $cec6b334748d9a6c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $cec6b334748d9a6c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $cec6b334748d9a6c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $cec6b334748d9a6c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $cec6b334748d9a6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $cec6b334748d9a6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $cec6b334748d9a6c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cec6b334748d9a6c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $cec6b334748d9a6c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($cec6b334748d9a6c$var$isRedirectResult(actionResult) || $cec6b334748d9a6c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($cec6b334748d9a6c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $cec6b334748d9a6c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($cec6b334748d9a6c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($cec6b334748d9a6c$var$isDeferredResult(actionResult)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $cec6b334748d9a6c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $cec6b334748d9a6c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $cec6b334748d9a6c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $cec6b334748d9a6c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $cec6b334748d9a6c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cec6b334748d9a6c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $cec6b334748d9a6c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) result = await $cec6b334748d9a6c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $cec6b334748d9a6c$export$3e9cee6b33872309(!$cec6b334748d9a6c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $cec6b334748d9a6c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $cec6b334748d9a6c$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $cec6b334748d9a6c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $cec6b334748d9a6c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace : $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $cec6b334748d9a6c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($cec6b334748d9a6c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $cec6b334748d9a6c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $cec6b334748d9a6c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $cec6b334748d9a6c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $cec6b334748d9a6c$var$ResultType.redirect,
                response: $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $cec6b334748d9a6c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: $cec6b334748d9a6c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $cec6b334748d9a6c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $cec6b334748d9a6c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $cec6b334748d9a6c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $cec6b334748d9a6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $cec6b334748d9a6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $cec6b334748d9a6c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $cec6b334748d9a6c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $cec6b334748d9a6c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $cec6b334748d9a6c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $cec6b334748d9a6c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$cec6b334748d9a6c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $cec6b334748d9a6c$export$4d0306f8f6a4585b = Symbol("deferred");
function $cec6b334748d9a6c$export$3336b097a6fbc59a(routes, opts) {
    $cec6b334748d9a6c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cec6b334748d9a6c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $cec6b334748d9a6c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cec6b334748d9a6c$var$createLocation("", $cec6b334748d9a6c$export$fe53371bee54353d(url), null, "default");
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cec6b334748d9a6c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($cec6b334748d9a6c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $cec6b334748d9a6c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cec6b334748d9a6c$var$createLocation("", $cec6b334748d9a6c$export$fe53371bee54353d(url), null, "default");
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cec6b334748d9a6c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $cec6b334748d9a6c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $cec6b334748d9a6c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $cec6b334748d9a6c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($cec6b334748d9a6c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$cec6b334748d9a6c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $cec6b334748d9a6c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($cec6b334748d9a6c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $cec6b334748d9a6c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $cec6b334748d9a6c$var$isResponse(result) ? result : $cec6b334748d9a6c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($cec6b334748d9a6c$var$isDataStrategyResult(e) && $cec6b334748d9a6c$var$isResponse(e.result)) {
                if (e.type === $cec6b334748d9a6c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($cec6b334748d9a6c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($cec6b334748d9a6c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $cec6b334748d9a6c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $cec6b334748d9a6c$var$_extends({}, context, {
                statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $cec6b334748d9a6c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $cec6b334748d9a6c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $cec6b334748d9a6c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategy || $cec6b334748d9a6c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($cec6b334748d9a6c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $cec6b334748d9a6c$export$fec11da027c70692(routes, context, error) {
    let newContext = $cec6b334748d9a6c$var$_extends({}, context, {
        statusCode: $cec6b334748d9a6c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $cec6b334748d9a6c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $cec6b334748d9a6c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $cec6b334748d9a6c$export$cae722b0cc860f13(to ? to : ".", $cec6b334748d9a6c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $cec6b334748d9a6c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $cec6b334748d9a6c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $cec6b334748d9a6c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $cec6b334748d9a6c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $cec6b334748d9a6c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$cec6b334748d9a6c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$cec6b334748d9a6c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $cec6b334748d9a6c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $cec6b334748d9a6c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $cec6b334748d9a6c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$cec6b334748d9a6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$cec6b334748d9a6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $cec6b334748d9a6c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $cec6b334748d9a6c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $cec6b334748d9a6c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $cec6b334748d9a6c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $cec6b334748d9a6c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $cec6b334748d9a6c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $cec6b334748d9a6c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $cec6b334748d9a6c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($cec6b334748d9a6c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $cec6b334748d9a6c$var$shouldRevalidateLoader(match, $cec6b334748d9a6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $cec6b334748d9a6c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $cec6b334748d9a6c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $cec6b334748d9a6c$var$shouldRevalidateLoader(fetcherMatch, $cec6b334748d9a6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $cec6b334748d9a6c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $cec6b334748d9a6c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $cec6b334748d9a6c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $cec6b334748d9a6c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $cec6b334748d9a6c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$cec6b334748d9a6c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $cec6b334748d9a6c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$cec6b334748d9a6c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $cec6b334748d9a6c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $cec6b334748d9a6c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $cec6b334748d9a6c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$cec6b334748d9a6c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $cec6b334748d9a6c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $cec6b334748d9a6c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $cec6b334748d9a6c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $cec6b334748d9a6c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $cec6b334748d9a6c$var$ResultType.data,
                result: undefined
            });
        };
        return $cec6b334748d9a6c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $cec6b334748d9a6c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $cec6b334748d9a6c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $cec6b334748d9a6c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $cec6b334748d9a6c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($cec6b334748d9a6c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: e
            };
        }
        if (type === $cec6b334748d9a6c$var$ResultType.error) return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: new $cec6b334748d9a6c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $cec6b334748d9a6c$var$ResultType.error) {
        if ($cec6b334748d9a6c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: new $cec6b334748d9a6c$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: result,
            statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($cec6b334748d9a6c$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $cec6b334748d9a6c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($cec6b334748d9a6c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $cec6b334748d9a6c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $cec6b334748d9a6c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $cec6b334748d9a6c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $cec6b334748d9a6c$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $cec6b334748d9a6c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $cec6b334748d9a6c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($cec6b334748d9a6c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $cec6b334748d9a6c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $cec6b334748d9a6c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $cec6b334748d9a6c$export$3e9cee6b33872309(!$cec6b334748d9a6c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $cec6b334748d9a6c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $cec6b334748d9a6c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $cec6b334748d9a6c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $cec6b334748d9a6c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($cec6b334748d9a6c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $cec6b334748d9a6c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($cec6b334748d9a6c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $cec6b334748d9a6c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $cec6b334748d9a6c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $cec6b334748d9a6c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $cec6b334748d9a6c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $cec6b334748d9a6c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $cec6b334748d9a6c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $cec6b334748d9a6c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $cec6b334748d9a6c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $cec6b334748d9a6c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(path) : path;
    return $cec6b334748d9a6c$export$fe53371bee54353d($cec6b334748d9a6c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $cec6b334748d9a6c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $cec6b334748d9a6c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $cec6b334748d9a6c$var$ResultType.data || result.type === $cec6b334748d9a6c$var$ResultType.error);
}
function $cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result) {
    return $cec6b334748d9a6c$var$isResponse(result.result) && $cec6b334748d9a6c$var$redirectStatusCodes.has(result.result.status);
}
function $cec6b334748d9a6c$var$isDeferredResult(result) {
    return result.type === $cec6b334748d9a6c$var$ResultType.deferred;
}
function $cec6b334748d9a6c$var$isErrorResult(result) {
    return result.type === $cec6b334748d9a6c$var$ResultType.error;
}
function $cec6b334748d9a6c$var$isRedirectResult(result) {
    return (result && result.type) === $cec6b334748d9a6c$var$ResultType.redirect;
}
function $cec6b334748d9a6c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $cec6b334748d9a6c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $cec6b334748d9a6c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $cec6b334748d9a6c$var$isRedirectResponse(result) {
    if (!$cec6b334748d9a6c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $cec6b334748d9a6c$var$isValidMethod(method) {
    return $cec6b334748d9a6c$var$validRequestMethods.has(method.toLowerCase());
}
function $cec6b334748d9a6c$var$isMutationMethod(method) {
    return $cec6b334748d9a6c$var$validMutationMethods.has(method.toLowerCase());
}
async function $cec6b334748d9a6c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$cec6b334748d9a6c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($cec6b334748d9a6c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $cec6b334748d9a6c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $cec6b334748d9a6c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $cec6b334748d9a6c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $cec6b334748d9a6c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $cec6b334748d9a6c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $cec6b334748d9a6c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $cec6b334748d9a6c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $cec6b334748d9a6c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $cec6b334748d9a6c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $cec6b334748d9a6c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $cec6b334748d9a6c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $cec6b334748d9a6c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $cec6b334748d9a6c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $cec6b334748d9a6c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $cec6b334748d9a6c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $cec6b334748d9a6c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $cec6b334748d9a6c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $cec6b334748d9a6c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $cec6b334748d9a6c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8tsvq = parcelRequire("8tsvq");

function $5bc57f835864eb51$var$_extends() {
    $5bc57f835864eb51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5bc57f835864eb51$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $5bc57f835864eb51$export$3add0d5dce533e2e = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$145dfa71566a64dc = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$var$AwaitContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $5bc57f835864eb51$export$26749e8557646306 = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$c7914228fb69b0f5 = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$9072aa6dd1f93057 = /*#__PURE__*/ $8tsvq.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $5bc57f835864eb51$var$RouteErrorContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $5bc57f835864eb51$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5bc57f835864eb51$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $5bc57f835864eb51$export$9c954a9d03d32f4a() {
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $5bc57f835864eb51$export$45d76561a5302f2b() {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $5bc57f835864eb51$export$1b3f31771c5d07c() {
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $5bc57f835864eb51$export$6c330e8992e8a295(pattern) {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    return $8tsvq.useMemo(()=>(0, $cec6b334748d9a6c$export$81336c211d5ff295)(pattern, (0, $cec6b334748d9a6c$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $5bc57f835864eb51$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $5bc57f835864eb51$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8tsvq.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $5bc57f835864eb51$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $5bc57f835864eb51$var$useNavigateStable() : $5bc57f835864eb51$var$useNavigateUnstable();
}
function $5bc57f835864eb51$var$useNavigateUnstable() {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8tsvq.useRef(false);
    $5bc57f835864eb51$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8tsvq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $5bc57f835864eb51$var$OutletContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $5bc57f835864eb51$export$4138103a3ae699cc() {
    return $8tsvq.useContext($5bc57f835864eb51$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $5bc57f835864eb51$export$a3be3530d8e40d0b(context) {
    let outlet = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $5bc57f835864eb51$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $5bc57f835864eb51$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8tsvq.useMemo(()=>(0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $5bc57f835864eb51$export$5d3fca4a98652595(routes, locationArg) {
    return $5bc57f835864eb51$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $5bc57f835864eb51$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: parentMatches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $5bc57f835864eb51$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $cec6b334748d9a6c$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $cec6b334748d9a6c$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $5bc57f835864eb51$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5bc57f835864eb51$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $cec6b334748d9a6c$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5bc57f835864eb51$var$DefaultErrorComponent() {
    let error = $5bc57f835864eb51$export$ed527bf60f6e05f2();
    let message = (0, $cec6b334748d9a6c$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8tsvq.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8tsvq.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $5bc57f835864eb51$var$defaultErrorElement = /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$DefaultErrorComponent, null);
class $5bc57f835864eb51$var$RenderErrorBoundary extends $8tsvq.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $5bc57f835864eb51$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5bc57f835864eb51$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $5bc57f835864eb51$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5bc57f835864eb51$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8tsvq.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $5bc57f835864eb51$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($5bc57f835864eb51$var$DataRouterHook || {});
var $5bc57f835864eb51$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($5bc57f835864eb51$var$DataRouterStateHook || {});
function $5bc57f835864eb51$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $5bc57f835864eb51$var$useDataRouterContext(hookName) {
    let ctx = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    !ctx && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $5bc57f835864eb51$var$useDataRouterState(hookName) {
    let state = $8tsvq.useContext($5bc57f835864eb51$export$145dfa71566a64dc);
    !state && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return state;
}
function $5bc57f835864eb51$var$useRouteContext(hookName) {
    let route = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    !route && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $5bc57f835864eb51$var$useCurrentRouteId(hookName) {
    let route = $5bc57f835864eb51$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $5bc57f835864eb51$export$5fc8298006ad9e58() {
    return $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5bc57f835864eb51$export$d0fd4b7106de2769() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5bc57f835864eb51$export$600dc272ed516c15() {
    let dataRouterContext = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseRevalidator);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRevalidator);
    return $8tsvq.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5bc57f835864eb51$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseMatches);
    return $8tsvq.useMemo(()=>matches.map((m)=>(0, $cec6b334748d9a6c$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5bc57f835864eb51$export$1448a5050d252c4d() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5bc57f835864eb51$export$fd5d37484eab868d(routeId) {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5bc57f835864eb51$export$fdc00f3f26066d5e() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseActionData);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $5bc57f835864eb51$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8tsvq.useContext($5bc57f835864eb51$var$RouteErrorContext);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRouteError);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $5bc57f835864eb51$export$78a72ddb39bdd145() {
    let value = $8tsvq.useContext($5bc57f835864eb51$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $5bc57f835864eb51$export$17f53340677d5831() {
    let value = $8tsvq.useContext($5bc57f835864eb51$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $5bc57f835864eb51$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $5bc57f835864eb51$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseBlocker);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8tsvq.useState("");
    let blockerFunction = $8tsvq.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $5bc57f835864eb51$var$_extends({}, currentLocation, {
                pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $5bc57f835864eb51$var$_extends({}, nextLocation, {
                pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8tsvq.useEffect(()=>{
        let key = String(++$5bc57f835864eb51$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8tsvq.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $cec6b334748d9a6c$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $5bc57f835864eb51$var$useNavigateStable() {
    let { router: router } = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseNavigateStable);
    let id = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8tsvq.useRef(false);
    $5bc57f835864eb51$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8tsvq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $5bc57f835864eb51$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $5bc57f835864eb51$var$alreadyWarned$1 = {};
function $5bc57f835864eb51$var$warningOnce(key, cond, message) {
    if (!cond && !$5bc57f835864eb51$var$alreadyWarned$1[key]) $5bc57f835864eb51$var$alreadyWarned$1[key] = true;
}
const $5bc57f835864eb51$var$alreadyWarned = {};
function $5bc57f835864eb51$var$warnOnce(key, message) {}
const $5bc57f835864eb51$var$logDeprecation = (flag, msg, link)=>$5bc57f835864eb51$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $5bc57f835864eb51$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $5bc57f835864eb51$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $5bc57f835864eb51$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $5bc57f835864eb51$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $5bc57f835864eb51$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $5bc57f835864eb51$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $5bc57f835864eb51$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5bc57f835864eb51$var$START_TRANSITION = "startTransition";
const $5bc57f835864eb51$var$startTransitionImpl = $8tsvq[$5bc57f835864eb51$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5bc57f835864eb51$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8tsvq.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        if (v7_startTransition && $5bc57f835864eb51$var$startTransitionImpl) $5bc57f835864eb51$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8tsvq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8tsvq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8tsvq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8tsvq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8tsvq.useEffect(()=>$5bc57f835864eb51$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $5bc57f835864eb51$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $5bc57f835864eb51$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $5bc57f835864eb51$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $5bc57f835864eb51$var$startTransitionImpl ? $5bc57f835864eb51$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>$5bc57f835864eb51$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $5bc57f835864eb51$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let navigate = $5bc57f835864eb51$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, (0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8tsvq.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $5bc57f835864eb51$export$910ae8079b2c2852(props) {
    return $5bc57f835864eb51$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $5bc57f835864eb51$export$e7b0ac011bb776c6(_props) {
    (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $5bc57f835864eb51$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $cec6b334748d9a6c$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8tsvq.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $5bc57f835864eb51$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $cec6b334748d9a6c$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8tsvq.useMemo(()=>{
        let trailingPathname = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $5bc57f835864eb51$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $5bc57f835864eb51$export$5d3fca4a98652595($5bc57f835864eb51$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5bc57f835864eb51$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$ResolveAwait, null, children));
}
var $5bc57f835864eb51$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($5bc57f835864eb51$var$AwaitRenderStatus || {});
const $5bc57f835864eb51$var$neverSettledPromise = new Promise(()=>{});
class $5bc57f835864eb51$var$AwaitErrorBoundary extends $8tsvq.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5bc57f835864eb51$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5bc57f835864eb51$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5bc57f835864eb51$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $5bc57f835864eb51$var$AwaitRenderStatus.error : "_data" in promise ? $5bc57f835864eb51$var$AwaitRenderStatus.success : $5bc57f835864eb51$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5bc57f835864eb51$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error && promise._error instanceof (0, $cec6b334748d9a6c$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $5bc57f835864eb51$var$neverSettledPromise;
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $5bc57f835864eb51$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $5bc57f835864eb51$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $5bc57f835864eb51$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8tsvq.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8tsvq.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8tsvq.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5bc57f835864eb51$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $5bc57f835864eb51$export$e7b0ac011bb776c6) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5bc57f835864eb51$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5bc57f835864eb51$export$daf73786167a7f72(matches) {
    return $5bc57f835864eb51$var$_renderMatches(matches);
}
function $5bc57f835864eb51$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8tsvq.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8tsvq.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8tsvq.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $5bc57f835864eb51$export$f30f7e456d254e83(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5bc57f835864eb51$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $5bc57f835864eb51$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $63c245eaedba316b$var$_extends() {
    $63c245eaedba316b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63c245eaedba316b$var$_extends.apply(this, arguments);
}
function $63c245eaedba316b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $63c245eaedba316b$var$defaultMethod = "get";
const $63c245eaedba316b$var$defaultEncType = "application/x-www-form-urlencoded";
function $63c245eaedba316b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $63c245eaedba316b$var$isButtonElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $63c245eaedba316b$var$isFormElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $63c245eaedba316b$var$isInputElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $63c245eaedba316b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $63c245eaedba316b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$63c245eaedba316b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $63c245eaedba316b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $63c245eaedba316b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $63c245eaedba316b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $63c245eaedba316b$var$_formDataSupportsSubmitter = null;
function $63c245eaedba316b$var$isFormDataSubmitterSupported() {
    if ($63c245eaedba316b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $63c245eaedba316b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $63c245eaedba316b$var$_formDataSupportsSubmitter = true;
    }
    return $63c245eaedba316b$var$_formDataSupportsSubmitter;
}
const $63c245eaedba316b$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $63c245eaedba316b$var$getFormEncType(encType) {
    if (encType != null && !$63c245eaedba316b$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $63c245eaedba316b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($63c245eaedba316b$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $63c245eaedba316b$var$defaultMethod;
        encType = $63c245eaedba316b$var$getFormEncType(target.getAttribute("enctype")) || $63c245eaedba316b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($63c245eaedba316b$var$isButtonElement(target) || $63c245eaedba316b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $63c245eaedba316b$var$defaultMethod;
        encType = $63c245eaedba316b$var$getFormEncType(target.getAttribute("formenctype")) || $63c245eaedba316b$var$getFormEncType(form.getAttribute("enctype")) || $63c245eaedba316b$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$63c245eaedba316b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($63c245eaedba316b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $63c245eaedba316b$var$defaultMethod;
        action = null;
        encType = $63c245eaedba316b$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $63c245eaedba316b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $63c245eaedba316b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $63c245eaedba316b$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $63c245eaedba316b$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $63c245eaedba316b$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $63c245eaedba316b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $63c245eaedba316b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $63c245eaedba316b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5bc57f835864eb51$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $63c245eaedba316b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $63c245eaedba316b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $63c245eaedba316b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5bc57f835864eb51$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $63c245eaedba316b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $63c245eaedba316b$var$_extends({}, state, {
        errors: $63c245eaedba316b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $63c245eaedba316b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $cec6b334748d9a6c$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $63c245eaedba316b$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8tsvq.createContext({
    isTransitioning: false
});
const $63c245eaedba316b$export$148fd98d095596d4 = /*#__PURE__*/ $8tsvq.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $63c245eaedba316b$var$START_TRANSITION = "startTransition";
const $63c245eaedba316b$var$startTransitionImpl = $8tsvq[$63c245eaedba316b$var$START_TRANSITION];
const $63c245eaedba316b$var$FLUSH_SYNC = "flushSync";
const $63c245eaedba316b$var$flushSyncImpl = $a2d184922ae7f92f$exports[$63c245eaedba316b$var$FLUSH_SYNC];
const $63c245eaedba316b$var$USE_ID = "useId";
const $63c245eaedba316b$var$useIdImpl = $8tsvq[$63c245eaedba316b$var$USE_ID];
function $63c245eaedba316b$var$startTransitionSafe(cb) {
    if ($63c245eaedba316b$var$startTransitionImpl) $63c245eaedba316b$var$startTransitionImpl(cb);
    else cb();
}
function $63c245eaedba316b$var$flushSyncSafe(cb) {
    if ($63c245eaedba316b$var$flushSyncImpl) $63c245eaedba316b$var$flushSyncImpl(cb);
    else cb();
}
class $63c245eaedba316b$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $63c245eaedba316b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8tsvq.useState(router.state);
    let [pendingState, setPendingState] = $8tsvq.useState();
    let [vtContext, setVtContext] = $8tsvq.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8tsvq.useState();
    let [transition, setTransition] = $8tsvq.useState();
    let [interruption, setInterruption] = $8tsvq.useState();
    let fetcherData = $8tsvq.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8tsvq.useCallback((cb)=>{
        if (v7_startTransition) $63c245eaedba316b$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8tsvq.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $63c245eaedba316b$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $63c245eaedba316b$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $63c245eaedba316b$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $63c245eaedba316b$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $63c245eaedba316b$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8tsvq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8tsvq.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $63c245eaedba316b$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8tsvq.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8tsvq.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8tsvq.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8tsvq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8tsvq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8tsvq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8tsvq.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $63c245eaedba316b$var$MemoizedDataRoutes = /*#__PURE__*/ $8tsvq.memo($63c245eaedba316b$var$DataRoutes);
function $63c245eaedba316b$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5bc57f835864eb51$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $63c245eaedba316b$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $63c245eaedba316b$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $63c245eaedba316b$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $63c245eaedba316b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $63c245eaedba316b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $63c245eaedba316b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8tsvq.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref7, $63c245eaedba316b$var$_excluded);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $63c245eaedba316b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($63c245eaedba316b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5bc57f835864eb51$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $63c245eaedba316b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8tsvq.createElement("a", $63c245eaedba316b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $63c245eaedba316b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8tsvq.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref8, $63c245eaedba316b$var$_excluded2);
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let routerState = $8tsvq.useContext((0, $5bc57f835864eb51$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $63c245eaedba316b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$a6c7ac8248d6e38a, $63c245eaedba316b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $63c245eaedba316b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8tsvq.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $63c245eaedba316b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref9, $63c245eaedba316b$var$_excluded3);
    let submit = $63c245eaedba316b$export$47c85c6e3a081d3();
    let formAction = $63c245eaedba316b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8tsvq.createElement("form", $63c245eaedba316b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $63c245eaedba316b$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $63c245eaedba316b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $63c245eaedba316b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($63c245eaedba316b$var$DataRouterHook || ($63c245eaedba316b$var$DataRouterHook = {}));
var $63c245eaedba316b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($63c245eaedba316b$var$DataRouterStateHook || ($63c245eaedba316b$var$DataRouterStateHook = {}));
// Internal hooks
function $63c245eaedba316b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $63c245eaedba316b$var$useDataRouterContext(hookName) {
    let ctx = $8tsvq.useContext((0, $5bc57f835864eb51$export$3add0d5dce533e2e));
    !ctx && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $63c245eaedba316b$var$useDataRouterState(hookName) {
    let state = $8tsvq.useContext((0, $5bc57f835864eb51$export$145dfa71566a64dc));
    !state && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $63c245eaedba316b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8tsvq.useCallback((event)=>{
        if ($63c245eaedba316b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $cec6b334748d9a6c$export$fe53371bee54353d)(location) === (0, $cec6b334748d9a6c$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $63c245eaedba316b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8tsvq.useRef($63c245eaedba316b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8tsvq.useRef(false);
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let searchParams = $8tsvq.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $63c245eaedba316b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    let setSearchParams = $8tsvq.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $63c245eaedba316b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $63c245eaedba316b$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $63c245eaedba316b$var$fetcherId = 0;
let $63c245eaedba316b$var$getUniqueFetcherId = ()=>"__" + String(++$63c245eaedba316b$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $63c245eaedba316b$export$47c85c6e3a081d3() {
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let currentRouteId = (0, $5bc57f835864eb51$export$5fc8298006ad9e58)();
    return $8tsvq.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $63c245eaedba316b$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $63c245eaedba316b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $63c245eaedba316b$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $63c245eaedba316b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let routeContext = $8tsvq.useContext((0, $5bc57f835864eb51$export$9072aa6dd1f93057));
    !routeContext && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $63c245eaedba316b$var$_extends({}, (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $cec6b334748d9a6c$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $63c245eaedba316b$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseFetcher);
    let state = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8tsvq.useContext($63c245eaedba316b$export$148fd98d095596d4);
    let route = $8tsvq.useContext((0, $5bc57f835864eb51$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    !route && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $63c245eaedba316b$var$useIdImpl ? $63c245eaedba316b$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8tsvq.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($63c245eaedba316b$var$getUniqueFetcherId());
    // Registration/cleanup
    $8tsvq.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8tsvq.useCallback((href, opts)=>{
        !routeId && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $63c245eaedba316b$export$47c85c6e3a081d3();
    let submit = $8tsvq.useCallback((target, opts)=>{
        submitImpl(target, $63c245eaedba316b$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8tsvq.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8tsvq.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$a7fed597f4b8afd8, $63c245eaedba316b$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $cec6b334748d9a6c$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8tsvq.useMemo(()=>$63c245eaedba316b$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $63c245eaedba316b$export$fa996778a3a31087() {
    let state = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $63c245eaedba316b$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $63c245eaedba316b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $63c245eaedba316b$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let matches = (0, $5bc57f835864eb51$export$2378eb7f5ff86053)();
    let navigation = (0, $5bc57f835864eb51$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8tsvq.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $63c245eaedba316b$var$usePageHide($8tsvq.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $63c245eaedba316b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($63c245eaedba316b$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $63c245eaedba316b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($63c245eaedba316b$var$_extends({}, location, {
                    pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($63c245eaedba316b$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $63c245eaedba316b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8tsvq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $63c245eaedba316b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8tsvq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $63c245eaedba316b$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5bc57f835864eb51$export$b273b3273281a049)(when);
    $8tsvq.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8tsvq.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $63c245eaedba316b$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8tsvq.useContext($63c245eaedba316b$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { basename: basename } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $cec6b334748d9a6c$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $cec6b334748d9a6c$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


const $98476e90da6dd9c8$var$AccordionItem = ({ data: data })=>{
    const { children: children, name: name, isOpen: isOpen } = data;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            children ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("svg", {
                className: `arrow_icon ${isOpen ? 'open' : ''}`,
                fill: "#1E293B",
                xmlns: "http://www.w3.org/2000/svg",
                xmlSpace: "preserve",
                width: "512",
                height: "298",
                shapeRendering: "geometricPrecision",
                textRendering: "geometricPrecision",
                imageRendering: "optimizeQuality",
                fillRule: "evenodd",
                clipRule: "evenodd",
                viewBox: "0 0 512 298.04",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                    fillRule: "nonzero",
                    d: "M12.08 70.78c-16.17-16.24-16.09-42.54.15-58.7 16.25-16.17 42.54-16.09 58.71.15L256 197.76 441.06 12.23c16.17-16.24 42.46-16.32 58.71-.15 16.24 16.16 16.32 42.46.15 58.7L285.27 285.96c-16.24 16.17-42.54 16.09-58.7-.15L12.08 70.78z"
                })
            }) : null,
            name
        ]
    });
};
const $98476e90da6dd9c8$var$Accordion = ({ children: children, name: name, slug: slug, open: open })=>{
    const [isOpen, setOpen] = (0, $8tsvq.useState)(false);
    (0, $8tsvq.useEffect)(()=>{
        setOpen(open);
    }, [
        open
    ]);
    const { pathname: pathname } = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    const isActiveSlug = pathname === '/' + slug;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "accordion",
        children: [
            !slug ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                className: "accordion_title",
                onClick: ()=>setOpen(!isOpen),
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($98476e90da6dd9c8$var$AccordionItem, {
                    data: {
                        children: children,
                        name: name,
                        slug: slug,
                        isOpen: isOpen
                    }
                })
            }) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                className: `accordion_title ${isActiveSlug ? 'accordion_title_active' : ''}`,
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                    to: slug,
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($98476e90da6dd9c8$var$AccordionItem, {
                        data: {
                            children: children,
                            name: name,
                            isOpen: isOpen
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: `accordion_content ${isOpen ? 'open' : ''}`,
                children: children
            })
        ]
    });
};
var $98476e90da6dd9c8$export$2e2bcd8739ae039 = $98476e90da6dd9c8$var$Accordion;



/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $f018542cedf583c1$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $f018542cedf583c1$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $f018542cedf583c1$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $f018542cedf583c1$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $f018542cedf583c1$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


function $289faae71d0b9c7d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $289faae71d0b9c7d$export$2e2bcd8739ae039 = $289faae71d0b9c7d$var$stylis_min;


var $1e1e1b885f6c348f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $1e1e1b885f6c348f$export$2e2bcd8739ae039 = $1e1e1b885f6c348f$var$weakMemoize;


// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $a276211492fd575f$var$delimiter = '/*|*/';
var $a276211492fd575f$var$needle = $a276211492fd575f$var$delimiter + '}';
function $a276211492fd575f$var$toSheet(block) {
    if (block) $a276211492fd575f$var$Sheet.current.insert(block + '}');
}
var $a276211492fd575f$var$Sheet = {
    current: null
};
var $a276211492fd575f$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $a276211492fd575f$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $a276211492fd575f$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $a276211492fd575f$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $a276211492fd575f$var$delimiter : '');
            }
        case -2:
            content.split($a276211492fd575f$var$needle).forEach($a276211492fd575f$var$toSheet);
    }
};
var $a276211492fd575f$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $289faae71d0b9c7d$export$2e2bcd8739ae039)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($a276211492fd575f$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $a276211492fd575f$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $f018542cedf583c1$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $a276211492fd575f$export$2e2bcd8739ae039 = $a276211492fd575f$var$createCache;


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $fd60843e7f34d2f0$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $fd60843e7f34d2f0$export$2e2bcd8739ae039 = $fd60843e7f34d2f0$var$murmur2;


var $42b8ea70a8bab97a$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $42b8ea70a8bab97a$export$2e2bcd8739ae039 = $42b8ea70a8bab97a$var$unitlessKeys;


function $26c34b7a9787700e$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $26c34b7a9787700e$export$2e2bcd8739ae039 = $26c34b7a9787700e$var$memoize;


var $f967aabe7c900f32$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $f967aabe7c900f32$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $f967aabe7c900f32$var$hyphenateRegex = /[A-Z]|^ms/g;
var $f967aabe7c900f32$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $f967aabe7c900f32$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $f967aabe7c900f32$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $f967aabe7c900f32$var$processStyleName = (0, $26c34b7a9787700e$export$2e2bcd8739ae039)(function(styleName) {
    return $f967aabe7c900f32$var$isCustomProperty(styleName) ? styleName : styleName.replace($f967aabe7c900f32$var$hyphenateRegex, '-$&').toLowerCase();
});
var $f967aabe7c900f32$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($f967aabe7c900f32$var$animationRegex, function(match, p1, p2) {
                $f967aabe7c900f32$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $f967aabe7c900f32$var$cursor
                };
                return p1;
            });
    }
    if ((0, $42b8ea70a8bab97a$export$2e2bcd8739ae039)[key] !== 1 && !$f967aabe7c900f32$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $f967aabe7c900f32$var$contentValuePattern, $f967aabe7c900f32$var$contentValues, $f967aabe7c900f32$var$oldProcessStyleValue, $f967aabe7c900f32$var$msPattern, $f967aabe7c900f32$var$hyphenPattern, $f967aabe7c900f32$var$hyphenatedCache;
var $f967aabe7c900f32$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $f967aabe7c900f32$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $f967aabe7c900f32$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $f967aabe7c900f32$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $f967aabe7c900f32$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $f967aabe7c900f32$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $f967aabe7c900f32$var$cursor;
                var result = interpolation(mergedProps);
                $f967aabe7c900f32$var$cursor = previousCursor;
                return $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $f967aabe7c900f32$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($f967aabe7c900f32$var$isProcessableValue(value)) string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + $f967aabe7c900f32$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($f967aabe7c900f32$var$isProcessableValue(value[_i])) string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + $f967aabe7c900f32$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $f967aabe7c900f32$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $f967aabe7c900f32$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $f967aabe7c900f32$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $f967aabe7c900f32$var$cursor;
var $f967aabe7c900f32$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $f967aabe7c900f32$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $f967aabe7c900f32$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $f967aabe7c900f32$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $f967aabe7c900f32$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $fd60843e7f34d2f0$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $f967aabe7c900f32$var$cursor
    };
};


var $f97744e9554218f8$var$isBrowser = true;
function $f97744e9554218f8$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $f97744e9554218f8$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $f97744e9554218f8$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $3502267f5140feae$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $3502267f5140feae$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $f97744e9554218f8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3502267f5140feae$var$createEmotion = function createEmotion(options) {
    var cache = (0, $a276211492fd575f$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $f97744e9554218f8$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $3502267f5140feae$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, cache.registered);
        $3502267f5140feae$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $3502267f5140feae$var$merge(cache.registered, css, $3502267f5140feae$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $f97744e9554218f8$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $3502267f5140feae$var$merge.bind(null, cache.registered, css)
    };
};
var $3502267f5140feae$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
var $3502267f5140feae$export$2e2bcd8739ae039 = $3502267f5140feae$var$createEmotion;


var $ee90a39a48e5fa92$var$_createEmotion = (0, $3502267f5140feae$export$2e2bcd8739ae039)(), $ee90a39a48e5fa92$export$4909b86c8034bf73 = $ee90a39a48e5fa92$var$_createEmotion.flush, $ee90a39a48e5fa92$export$fa8d919ba61d84db = $ee90a39a48e5fa92$var$_createEmotion.hydrate, $ee90a39a48e5fa92$export$a274e22fb40f762e = $ee90a39a48e5fa92$var$_createEmotion.cx, $ee90a39a48e5fa92$export$4950aa0f605343fb = $ee90a39a48e5fa92$var$_createEmotion.merge, $ee90a39a48e5fa92$export$95d99596f328fd52 = $ee90a39a48e5fa92$var$_createEmotion.getRegisteredStyles, $ee90a39a48e5fa92$export$efb9f5caaa2ca0c7 = $ee90a39a48e5fa92$var$_createEmotion.injectGlobal, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e = $ee90a39a48e5fa92$var$_createEmotion.keyframes, $ee90a39a48e5fa92$export$dbf350e5966cf602 = $ee90a39a48e5fa92$var$_createEmotion.css, $ee90a39a48e5fa92$export$995990c5c04c46f0 = $ee90a39a48e5fa92$var$_createEmotion.sheet, $ee90a39a48e5fa92$export$69a3209f1a06c04d = $ee90a39a48e5fa92$var$_createEmotion.cache;



var $8tsvq = parcelRequire("8tsvq");
var $3a460728537dec08$exports = {};
Object.defineProperty($3a460728537dec08$exports, "__esModule", {
    value: true
});
$3a460728537dec08$exports = {
    "contentWidthDefault": "1280px",
    "contentWidthText": "768px",
    "contentWidthFull": "100%",
    "spacing2Xs": "0.25rem",
    "spacingXs": "0.5rem",
    "spacingS": "0.75rem",
    "spacingM": "1rem",
    "spacingL": "1.5rem",
    "spacingXl": "2rem",
    "spacing2Xl": "3rem",
    "spacing3Xl": "4rem",
    "spacing4Xl": "5rem",
    "zIndexNegative": -1,
    "zIndexWorkbench": 0,
    "zIndexDefault": 1,
    "zIndexWorkbenchHeader": 10,
    "zIndexModal": 100,
    "zIndexModalContent": 101,
    "zIndexDropdown": 1000,
    "zIndexTooltip": 10000,
    "zIndexNotification": 100000,
    "borderRadiusSmall": "4px",
    "borderRadiusMedium": "6px",
    "boxShadowPositive": "0px 1px 0px rgb(25, 37, 50, 0.1)",
    "boxShadowDefault": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px 3px 7px -3px rgba(25, 37, 50, 0.1), 0px 6px 12px -2px rgba(25, 37, 50, 0.1);",
    "boxShadowHeavy": "0px 0px 0px 1px rgba(25, 37, 50, 0.1), 0px -6px 16px -6px rgba(25, 37, 50, 0.03), 0px 8px 16px -8px rgba(25, 37, 50, 0.2), 0px 13px 27px -5px rgba(25, 37, 50, 0.15);",
    "insetBoxShadowDefault": "inset 0px 2px 0px rgba(225, 228, 232, 0.2);",
    "glowPrimary": "0px 0px 0px 3px #98CBFF",
    "glowNegative": "0px 0px 0px 3px #FFB1B2",
    "glowPositive": "0px 0px 0px 3px #9ED696",
    "glowWarning": "0px 0px 0px 3px #FDE5C0",
    "glowMuted": "0px 0px 0px 3px #E7EBEE",
    "colorBlack": "#0C141C",
    "colorBlueLightest": "#E8F5FF",
    "colorBlueLight": "#98CBFF",
    "colorBlueMid": "#036FE3",
    "colorBlueBase": "#0059C8",
    "colorBlueDark": "#0041AB",
    "blue100": "#E8F5FF",
    "blue200": "#CEECFF",
    "blue300": "#98CBFF",
    "blue400": "#40A0FF",
    "blue500": "#036FE3",
    "blue600": "#0059C8",
    "blue700": "#0041AB",
    "blue800": "#003298",
    "blue900": "#002A8E",
    "colorContrastDark": "#0C141C",
    "colorContrastMid": "#111B2B",
    "colorContrastLight": "#1B273A",
    "colorCoralDark": "#FFE0E0",
    "colorCoralMid": "#FFF2F2",
    "colorElementDarkest": "#67728A",
    "colorElementDark": "#AEC1CC",
    "colorElementMid": "#CFD9E0",
    "colorElementLight": "#E7EBEE",
    "colorElementLightest": "#F7F9FA",
    "gray100": "#F7F9FA",
    "gray200": "#E7EBEE",
    "gray300": "#CFD9E0",
    "gray400": "#AEC1CC",
    "gray500": "#67728A",
    "gray600": "#5A657C",
    "gray700": "#414D63",
    "gray800": "#1B273A",
    "gray900": "#111B2B",
    "colorGreenDark": "#00550C",
    "colorGreenBase": "#006D23",
    "colorGreenMid": "#008539",
    "colorGreenLight": "#9ED696",
    "colorGreenLightest": "#EAF9E8",
    "green100": "#EAF9E8",
    "green200": "#CDF3C6",
    "green300": "#9ED696",
    "green400": "#5DB057",
    "green500": "#008539",
    "green600": "#006D23",
    "green700": "#00550C",
    "green800": "#004700",
    "green900": "#003F00",
    "colorIceDark": "#CEECFF",
    "colorIceMid": "#E8F5FF",
    "colorMintDark": "#CDF3C6",
    "colorMintMid": "#EAF9E8",
    "colorOrangeDark": "#B12D00",
    "colorOrangeBase": "#CC4500",
    "colorOrangeMid": "#F07F23",
    "colorOrangeLight": "#FDE5C0",
    "colorOrangeLightest": "#FFF2E4",
    "orange100": "#FFF2E4",
    "orange200": "#FDE5C0",
    "orange300": "#FDB882",
    "orange400": "#F07F23",
    "orange500": "#CC4500",
    "orange600": "#B12D00",
    "orange700": "#892300",
    "orange800": "#731A00",
    "orange900": "#631C00",
    "colorPeachDark": "#FDE5C0",
    "colorPeachMid": "#FFF2E4",
    "colorPurpleDark": "#5127B5",
    "colorPurpleBase": "#6C3ECF",
    "colorPurpleMid": "#8553E7",
    "colorPurpleLight": "#D1BBFF",
    "colorPurpleLightest": "#F7F2FF",
    "purple100": "#F7F2FF",
    "purple200": "#EDE3FF",
    "purple300": "#D1BBFF",
    "purple400": "#AE89FF",
    "purple500": "#8553E7",
    "purple600": "#6C3ECF",
    "purple700": "#5127B5",
    "purple800": "#3E16A4",
    "purple900": "#340E9C",
    "colorRedDark": "#990017",
    "colorRedBase": "#BD002A",
    "colorRedMid": "#DA294A",
    "colorRedLight": "#FFB1B2",
    "colorRedLightest": "#FFF2F2",
    "red100": "#FFF2F2",
    "red200": "#FFE0E0",
    "red300": "#FFB1B2",
    "red400": "#FF707D",
    "red500": "#DA294A",
    "red600": "#BD002A",
    "red700": "#990017",
    "red800": "#7F0010",
    "red900": "#72000E",
    "colorPrimary": "#036FE3",
    "colorPositive": "#008539",
    "colorNegative": "#DA294A",
    "colorWarning": "#F07F23",
    "colorTextDark": "#111B2B",
    "colorTextBase": "#1B273A",
    "colorTextMid": "#414D63",
    "colorTextLight": "#5A657C",
    "colorTextLightest": "#67728A",
    "colorWhite": "#ffffff",
    "colorYellowDark": "#956300",
    "colorYellowBase": "#EAAF09",
    "colorYellowMid": "#FFC835",
    "colorYellowLight": "#FFD960",
    "colorYellowLightest": "#FFF6CC",
    "yellow100": "#FEF9DF",
    "yellow200": "#FFF6CC",
    "yellow300": "#FFE993",
    "yellow400": "#FFD960",
    "yellow500": "#FFC835",
    "yellow600": "#EAAF09",
    "yellow700": "#B78300",
    "yellow800": "#956300",
    "yellow900": "#7F5200",
    "transitionDurationShort": "0.1s",
    "transitionDurationDefault": "0.2s",
    "transitionDurationLong": "0.3s",
    "transitionEasingDefault": "ease-in-out",
    "transitionEasingCubicBezier": "cubic-bezier(0.13, 0.62, 0.11, 0.99)",
    "fontBaseDefault": "16",
    "fontSize4Xl": "3rem",
    "fontSize3Xl": "2.25rem",
    "fontSize2Xl": "1.75rem",
    "fontSizeXl": "1.25rem",
    "fontSizeL": "1rem",
    "fontSizeM": "0.875rem",
    "fontSizeS": "0.75rem",
    "fontStackPrimary": "-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
    "fontStackMonospace": "SFMono-Regular, Consolas, Liberation Mono, Menlo,monospace",
    "fontWeightNormal": 400,
    "fontWeightMedium": 500,
    "fontWeightDemiBold": 600,
    "letterSpacingWide": "0.1rem",
    "lineHeightDefault": "1.5",
    "lineHeightCondensed": "1.25",
    "lineHeight4Xl": "3.5rem",
    "lineHeight3Xl": "3rem",
    "lineHeight2Xl": "2.25rem",
    "lineHeightXl": "2rem",
    "lineHeightL": "1.5rem",
    "lineHeightM": "1.25rem",
    "lineHeightS": "1rem"
};



var $8tsvq = parcelRequire("8tsvq");
function $0a621ebff2a8df04$export$2e2bcd8739ae039(t, e) {
    return $0a621ebff2a8df04$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0a621ebff2a8df04$export$2e2bcd8739ae039(t, e);
}


function $c96d5d7e938979f8$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0a621ebff2a8df04$export$2e2bcd8739ae039)(t, o);
}



var $8tsvq = parcelRequire("8tsvq");



var $8tsvq = parcelRequire("8tsvq");



var $4e21f7e4fe8f58d3$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $4e21f7e4fe8f58d3$var$EmotionCacheContext = /*#__PURE__*/ (0, $8tsvq.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $a276211492fd575f$export$2e2bcd8739ae039)() : null);
var $4e21f7e4fe8f58d3$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $8tsvq.createContext)({});
var $4e21f7e4fe8f58d3$export$e7094788287c5e9b = $4e21f7e4fe8f58d3$var$EmotionCacheContext.Provider;
var $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $8tsvq.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $4e21f7e4fe8f58d3$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $4e21f7e4fe8f58d3$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4e21f7e4fe8f58d3$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $4e21f7e4fe8f58d3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4e21f7e4fe8f58d3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4e21f7e4fe8f58d3$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $4e21f7e4fe8f58d3$var$Noop = function Noop() {
    return null;
};
var $4e21f7e4fe8f58d3$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$4e21f7e4fe8f58d3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $f97744e9554218f8$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(registeredStyles);
    var labelFromStack;
    var rules = (0, $f97744e9554218f8$export$6f077d94b33a01aa)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4e21f7e4fe8f58d3$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $4e21f7e4fe8f58d3$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $8tsvq.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$var$Noop, null);
    return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $8tsvq.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $4e21f7e4fe8f58d3$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $8tsvq.createElement)($4e21f7e4fe8f58d3$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $4e21f7e4fe8f58d3$var$render(cache, props, theme, ref);
    });
    return $4e21f7e4fe8f58d3$var$render(cache, props, null, ref);
});






function $7c908f8c65e1ea2a$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $f967aabe7c900f32$export$6321afa313b251b5)(args);
}
var $7c908f8c65e1ea2a$export$2e2bcd8739ae039 = $7c908f8c65e1ea2a$var$css;


var $b7d8f67c6c41081e$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $4e21f7e4fe8f58d3$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return (0, $8tsvq.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4e21f7e4fe8f58d3$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4e21f7e4fe8f58d3$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $8tsvq.createElement).apply(null, createElementArgArray);
};
var $b7d8f67c6c41081e$var$warnedAboutCssPropForGlobal = false;
var $b7d8f67c6c41081e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $4e21f7e4fe8f58d3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)([
        styles
    ]);
    return /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $b7d8f67c6c41081e$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $c96d5d7e938979f8$export$2e2bcd8739ae039)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $f018542cedf583c1$export$9d753cd7ae895cce)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $f97744e9554218f8$export$6f077d94b33a01aa)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $8tsvq.Component));
var $b7d8f67c6c41081e$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $b7d8f67c6c41081e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $b7d8f67c6c41081e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $f97744e9554218f8$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $b7d8f67c6c41081e$var$Noop = function Noop() {
    return null;
};
var $b7d8f67c6c41081e$export$9b9c0f9d9f3552b8 = (0, $4e21f7e4fe8f58d3$export$efccba1c4a2ef57b)(function(props, context) {
    return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $4e21f7e4fe8f58d3$export$971d5caa766a69d7).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $f967aabe7c900f32$export$6321afa313b251b5)(args, context.registered);
            (0, $f97744e9554218f8$export$6f077d94b33a01aa)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $b7d8f67c6c41081e$var$merge(context.registered, css, $b7d8f67c6c41081e$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $8tsvq.createElement)($b7d8f67c6c41081e$var$Noop, null);
        return /*#__PURE__*/ (0, $8tsvq.createElement)((0, $8tsvq.Fragment), null, possiblyStyleElement, ele);
    });
});




var $7c1d3a8c755aa15d$var$le = Object.defineProperty, $7c1d3a8c755aa15d$var$me = Object.defineProperties;
var $7c1d3a8c755aa15d$var$ce = Object.getOwnPropertyDescriptors;
var $7c1d3a8c755aa15d$var$A = Object.getOwnPropertySymbols;
var $7c1d3a8c755aa15d$var$v = Object.prototype.hasOwnProperty, $7c1d3a8c755aa15d$var$j = Object.prototype.propertyIsEnumerable;
var $7c1d3a8c755aa15d$var$X = (e, t, o)=>t in e ? $7c1d3a8c755aa15d$var$le(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }) : e[t] = o, $7c1d3a8c755aa15d$var$i = (e, t)=>{
    for(var o in t || (t = {}))$7c1d3a8c755aa15d$var$v.call(t, o) && $7c1d3a8c755aa15d$var$X(e, o, t[o]);
    if ($7c1d3a8c755aa15d$var$A) for (var o of $7c1d3a8c755aa15d$var$A(t))$7c1d3a8c755aa15d$var$j.call(t, o) && $7c1d3a8c755aa15d$var$X(e, o, t[o]);
    return e;
}, $7c1d3a8c755aa15d$var$a = (e, t)=>$7c1d3a8c755aa15d$var$me(e, $7c1d3a8c755aa15d$var$ce(t));
var $7c1d3a8c755aa15d$var$c = (e, t)=>{
    var o = {};
    for(var r in e)$7c1d3a8c755aa15d$var$v.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
    if (e != null && $7c1d3a8c755aa15d$var$A) for (var r of $7c1d3a8c755aa15d$var$A(e))t.indexOf(r) < 0 && $7c1d3a8c755aa15d$var$j.call(e, r) && (o[r] = e[r]);
    return o;
};
var $7c1d3a8c755aa15d$var$fe = (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039)`
  /* Remove default margin */
  /* Button has default margin in some browsers, like safari */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd,
  button {
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  ul[role='list'],
  ol[role='list'] {
    list-style: none;
  }

  /* Set core root defaults */
  html:focus-within {
    scroll-behavior: smooth;
  }

  /* Set core body defaults */
  body {
    text-rendering: optimizeSpeed;
    line-height: 1.5;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`, $7c1d3a8c755aa15d$export$c507fb1c2e1ac13a = ({ withNormalize: e = !0, styles: t })=>$8tsvq.createElement((0, $b7d8f67c6c41081e$export$98f03c5d19621d70), {
        styles: (0, $7c908f8c65e1ea2a$export$2e2bcd8739ae039)`
        ${e ? $7c1d3a8c755aa15d$var$fe : void 0};
        html {
          border: 0;
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        body {
          color: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray800};
          font-family: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontStackPrimary};
          font-size: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontSizeM};
          line-height: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).lineHeightM};
        }

        code {
          font-family: ${(0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).fontStackMonospace};
        }

        fieldset {
          border: 0;
          margin: 0;
          padding: 0;
        }

        *,
        *::after,
        *::before {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
          box-sizing: inherit;
        }

        ${t};
      `
    });
var $7c1d3a8c755aa15d$var$ye = {
    none: 0,
    spacing2Xs: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing2Xs,
    spacingXs: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingXs,
    spacingS: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingS,
    spacingM: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingM,
    spacingL: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingL,
    spacingXl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacingXl,
    spacing2Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing2Xl,
    spacing3Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing3Xl,
    spacing4Xl: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).spacing4Xl
};
function $7c1d3a8c755aa15d$var$m(e) {
    return $7c1d3a8c755aa15d$var$ye[e];
}
function $7c1d3a8c755aa15d$var$J(e) {
    return Object.assign({}, e.margin ? {
        margin: $7c1d3a8c755aa15d$var$m(e.margin)
    } : null, e.marginLeft ? {
        marginLeft: $7c1d3a8c755aa15d$var$m(e.marginLeft)
    } : null, e.marginRight ? {
        marginRight: $7c1d3a8c755aa15d$var$m(e.marginRight)
    } : null, e.marginTop ? {
        marginTop: $7c1d3a8c755aa15d$var$m(e.marginTop)
    } : null, e.marginBottom ? {
        marginBottom: $7c1d3a8c755aa15d$var$m(e.marginBottom)
    } : null, e.padding ? {
        padding: $7c1d3a8c755aa15d$var$m(e.padding)
    } : null, e.paddingLeft ? {
        paddingLeft: $7c1d3a8c755aa15d$var$m(e.paddingLeft)
    } : null, e.paddingRight ? {
        paddingRight: $7c1d3a8c755aa15d$var$m(e.paddingRight)
    } : null, e.paddingTop ? {
        paddingTop: $7c1d3a8c755aa15d$var$m(e.paddingTop)
    } : null, e.paddingBottom ? {
        paddingBottom: $7c1d3a8c755aa15d$var$m(e.paddingBottom)
    } : null);
}
var $7c1d3a8c755aa15d$var$xe = "div";
function $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(e) {
    let E = e, { display: t, className: o, margin: r, marginBottom: s, marginLeft: p, marginRight: n, marginTop: l, padding: d, paddingBottom: f, paddingLeft: y, paddingRight: x, paddingTop: S, testId: R, as: h = $7c1d3a8c755aa15d$var$xe } = E, T = $7c1d3a8c755aa15d$var$c(E, [
        "display",
        "className",
        "margin",
        "marginBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "padding",
        "paddingBottom",
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "testId",
        "as"
    ]);
    return {
        boxProps: $7c1d3a8c755aa15d$var$i({
            className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
                display: t
            }), (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)($7c1d3a8c755aa15d$var$i({}, $7c1d3a8c755aa15d$var$J({
                margin: r,
                marginBottom: s,
                marginLeft: p,
                marginRight: n,
                marginTop: l,
                padding: d,
                paddingBottom: f,
                paddingLeft: y,
                paddingRight: x,
                paddingTop: S
            }))), o),
            ["data-test-id"]: R
        }, T),
        Element: h
    };
}
function $7c1d3a8c755aa15d$var$H(e, t) {
    let { boxProps: o, Element: r } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(e);
    return $8tsvq.createElement(r, $7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, o), {
        ref: t
    }), e.children);
}
$7c1d3a8c755aa15d$var$H.displayName = "Box";
var $7c1d3a8c755aa15d$export$e71c4d32a2263218 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$H);
var $7c1d3a8c755aa15d$var$Re = "div";
function $7c1d3a8c755aa15d$var$V(we, pe) {
    var O = we, { isInline: e, alignItems: t, alignSelf: o, alignContent: r, flex: s, flexBasis: p, flexShrink: n, flexDirection: l, flexGrow: d, flexWrap: f, fullHeight: y, fullWidth: x, gap: S, justifyContent: R, justifyItems: h, justifySelf: T, order: b, children: E, as: I } = O, G = $7c1d3a8c755aa15d$var$c(O, [
        "isInline",
        "alignItems",
        "alignSelf",
        "alignContent",
        "flex",
        "flexBasis",
        "flexShrink",
        "flexDirection",
        "flexGrow",
        "flexWrap",
        "fullHeight",
        "fullWidth",
        "gap",
        "justifyContent",
        "justifyItems",
        "justifySelf",
        "order",
        "children",
        "as"
    ]);
    var N;
    let { boxProps: U, Element: se } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, G), {
        as: I || $7c1d3a8c755aa15d$var$Re
    }));
    return $8tsvq.createElement(se, $7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, U), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: e ? "inline-flex" : "flex",
            width: x ? "100%" : void 0,
            height: y ? "100%" : void 0,
            flex: s,
            flexBasis: p,
            flexShrink: n,
            flexDirection: l,
            gap: (N = (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports)))[S]) != null ? N : S,
            justifyContent: R,
            justifyItems: h,
            justifySelf: T,
            alignItems: t,
            alignSelf: o,
            alignContent: r,
            order: b,
            flexWrap: f,
            flexGrow: d
        }), U.className),
        ref: pe
    }), E);
}
$7c1d3a8c755aa15d$var$V.displayName = "Flex";
var $7c1d3a8c755aa15d$export$f51f4c4ede09e011 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$V);
var $7c1d3a8c755aa15d$var$Te = "div";
function $7c1d3a8c755aa15d$var$Q(S, x) {
    var R = S, { alignContent: e, children: t, columnGap: o = "spacingM", columns: r = "auto", flow: s, isInline: p, justifyContent: n, rowGap: l = "none", rows: d = "auto", as: f } = R, y = $7c1d3a8c755aa15d$var$c(R, [
        "alignContent",
        "children",
        "columnGap",
        "columns",
        "flow",
        "isInline",
        "justifyContent",
        "rowGap",
        "rows",
        "as"
    ]);
    var E, I;
    let h = (G)=>typeof G == "number" ? `repeat(${G}, minmax(0, 1fr))` : G, { boxProps: T, Element: b } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, y), {
        as: f || $7c1d3a8c755aa15d$var$Te
    }));
    return $8tsvq.createElement(b, $7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, T), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: p ? "inline-grid" : "grid",
            gridTemplateColumns: h(r),
            gridTemplateRows: h(d),
            flow: s,
            justifyContent: n,
            alignContent: e,
            columnGap: (E = $7c1d3a8c755aa15d$var$m(o)) != null ? E : 0,
            rowGap: (I = $7c1d3a8c755aa15d$var$m(l)) != null ? I : 0
        }), T.className),
        ref: x
    }), t);
}
$7c1d3a8c755aa15d$var$Q.displayName = "Grid";
var $7c1d3a8c755aa15d$var$Y = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$Q);
function $7c1d3a8c755aa15d$var$Z(f, d) {
    var y = f, { children: e, columnStart: t, columnEnd: o, rowStart: r, rowEnd: s, area: p, order: n } = y, l = $7c1d3a8c755aa15d$var$c(y, [
        "children",
        "columnStart",
        "columnEnd",
        "rowStart",
        "rowEnd",
        "area",
        "order"
    ]);
    let x = p || [
        r || "auto",
        t || "auto",
        s || "auto",
        o || "auto"
    ].join(" / "), { boxProps: S, Element: R } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22(l);
    return $8tsvq.createElement(R, $7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, S), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)((0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            gridArea: x,
            order: n
        }), S.className),
        ref: d
    }), e);
}
$7c1d3a8c755aa15d$var$Z.displayName = "GridItem";
var $7c1d3a8c755aa15d$export$9eb849b9b922d396 = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$Z);
var $7c1d3a8c755aa15d$export$ef2184bd89960b14 = $7c1d3a8c755aa15d$var$Y;
$7c1d3a8c755aa15d$export$ef2184bd89960b14.Item = $7c1d3a8c755aa15d$export$9eb849b9b922d396;
var $7c1d3a8c755aa15d$var$be = "div";
function $7c1d3a8c755aa15d$var$ee(d, l) {
    var f = d, { flexDirection: e = "row", alignItems: t = "center", isInline: o = !1, spacing: r = "spacingM", children: s, as: p } = f, n = $7c1d3a8c755aa15d$var$c(f, [
        "flexDirection",
        "alignItems",
        "isInline",
        "spacing",
        "children",
        "as"
    ]);
    let { boxProps: y, Element: x } = $7c1d3a8c755aa15d$export$3c8fe9c3d6a8ef22($7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, n), {
        as: p || $7c1d3a8c755aa15d$var$be
    }));
    return $8tsvq.createElement($7c1d3a8c755aa15d$export$f51f4c4ede09e011, $7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, y), {
        as: x,
        flexDirection: e,
        alignItems: t,
        isInline: o,
        className: y.className,
        gap: r,
        ref: l
    }), s);
}
$7c1d3a8c755aa15d$var$ee.displayName = "Stack";
var $7c1d3a8c755aa15d$export$694e0d28c7ffc90c = $8tsvq.forwardRef($7c1d3a8c755aa15d$var$ee);
function $7c1d3a8c755aa15d$var$oe() {
    return {
        screenReaderOnly: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            margin: "-1px",
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            border: 0
        })
    };
}
var $7c1d3a8c755aa15d$export$518e781dade4a416 = (p)=>{
    var n = p, { children: e, className: t, testId: o = "cf-ui-ScreenReaderOnly", as: r = "div" } = n, s = $7c1d3a8c755aa15d$var$c(n, [
        "children",
        "className",
        "testId",
        "as"
    ]);
    let l = $7c1d3a8c755aa15d$var$oe();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement(r, $7c1d3a8c755aa15d$var$a($7c1d3a8c755aa15d$var$i({}, s), {
        "data-test-id": o,
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)(l.screenReaderOnly, t)
    }), e);
};
function $7c1d3a8c755aa15d$export$f680877a34711e37(e, t) {
    return (0, $8tsvq.useMemo)(()=>e || [
            t || "id",
            Math.round(Math.random() * 1e4)
        ].join("_"), []);
}
function $7c1d3a8c755aa15d$export$6f32135080cb4c3({ isOpen: e, defaultIsOpen: t, onOpen: o, onClose: r }) {
    let [s, p] = (0, $8tsvq.useState)(t || !1), n = e !== void 0, l = n ? e : s, d = (0, $8tsvq.useCallback)(()=>{
        n || p(!1), r == null || r();
    }, [
        n,
        r
    ]), f = (0, $8tsvq.useCallback)(()=>{
        n || p(!0), o == null || o();
    }, [
        n,
        o
    ]);
    return {
        isOpen: l,
        isControlled: n,
        handleClose: d,
        handleOpen: f
    };
}
function $7c1d3a8c755aa15d$export$c9058316764c140e(...e) {
    return (t)=>{
        e.forEach((o)=>{
            typeof o == "function" ? o(t) : o != null && (o.current = t);
        });
    };
}
var $7c1d3a8c755aa15d$export$125b56fdc77c3731 = ({ status: e })=>{
    switch(e){
        case "published":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorGreenBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorGreenLightest
            };
        case "changed":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorBlueBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorBlueLightest
            };
        case "deleted":
        case "archived":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorRedBase,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorRedLightest
            };
        case "draft":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorOrangeDark,
                backgroundColor: "#ffefd5"
            };
        case "new":
            return {
                color: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorWhite,
                backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorPrimary
            };
        default:
            return console.warn(`Unknown EntityStatus: ${e}`), {};
    }
};


var $6e6b089c3d63766c$var$N = Object.defineProperty, $6e6b089c3d63766c$var$T = Object.defineProperties;
var $6e6b089c3d63766c$var$v = Object.getOwnPropertyDescriptors;
var $6e6b089c3d63766c$var$m = Object.getOwnPropertySymbols;
var $6e6b089c3d63766c$var$c = Object.prototype.hasOwnProperty, $6e6b089c3d63766c$var$x = Object.prototype.propertyIsEnumerable;
var $6e6b089c3d63766c$var$f = (r, a, t)=>a in r ? $6e6b089c3d63766c$var$N(r, a, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : r[a] = t, $6e6b089c3d63766c$var$S = (r, a)=>{
    for(var t in a || (a = {}))$6e6b089c3d63766c$var$c.call(a, t) && $6e6b089c3d63766c$var$f(r, t, a[t]);
    if ($6e6b089c3d63766c$var$m) for (var t of $6e6b089c3d63766c$var$m(a))$6e6b089c3d63766c$var$x.call(a, t) && $6e6b089c3d63766c$var$f(r, t, a[t]);
    return r;
}, $6e6b089c3d63766c$var$d = (r, a)=>$6e6b089c3d63766c$var$T(r, $6e6b089c3d63766c$var$v(a));
var $6e6b089c3d63766c$var$g = (r, a)=>{
    var t = {};
    for(var n in r)$6e6b089c3d63766c$var$c.call(r, n) && a.indexOf(n) < 0 && (t[n] = r[n]);
    if (r != null && $6e6b089c3d63766c$var$m) for (var n of $6e6b089c3d63766c$var$m(r))a.indexOf(n) < 0 && $6e6b089c3d63766c$var$x.call(r, n) && (t[n] = r[n]);
    return t;
};
var $6e6b089c3d63766c$var$h = {
    large: "36px",
    medium: "20px",
    small: "14px"
}, $6e6b089c3d63766c$var$y = ()=>{
    let r = {
        scale1: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    6.666667% {
      transform: scale(1.5, 0.5);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1.5, 0.5);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        scale2: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    13.333333% {
      transform: scale(1, 1);
    }
    20% {
      transform: scale(1.5, 0.5);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(1, 1);
    }
    46.666667% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    73.333333% {
      transform: scale(1.5, 0.5);
    }
    80% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        scale3: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: scale(1, 1);
    }
    26.666667% {
      transform: scale(1, 1);
    }
    33.333333% {
      transform: scale(1.5, 0.5);
    }
    40% {
      transform: scale(1, 1);
    }
    53.333333% {
      transform: scale(1, 1);
    }
    60% {
      transform: scale(1, 1);
    }
    66.666667% {
      transform: scale(1, 1);
    }
    80% {
      transform: scale(1, 1);
    }
    86.666667% {
      transform: scale(1.5, 0.5);
    }
    93.333333% {
      transform: scale(1, 1);
    }
    100% {
      transform: scale(1, 1);
    }
  `,
        translate1: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(10px, 33.528168px);
    }
    6.666667% {
      transform: translate(10px, 41.764084px);
    }
    13.333333% {
      transform: translate(10px, 33.528168px);
    }
    26.666667% {
      transform: translate(10px, -2.651608px);
    }
    33.333333% {
      transform: translate(10px, -4.471832px);
    }
    40% {
      transform: translate(10px, -2.651608px);
    }
    53.333333% {
      transform: translate(10px, 33.528168px);
    }
    60% {
      transform: translate(10px, 41.764084px);
    }
    66.666667% {
      transform: translate(10px, 33.528168px);
    }
    100% {
      transform: translate(10px, 33.528168px);
    }
  `,
        translate2: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(30px, 33.528168px);
    }
    13.333333% {
      transform: translate(30px, 33.528168px);
    }
    20% {
      transform: translate(30px, 41.764084px);
    }
    26.666667% {
      transform: translate(30px, 33.528168px);
    }
    40% {
      transform: translate(30px, -2.651608px);
    }
    46.666667% {
      transform: translate(30px, -4.471832px);
    }
    53.333333% {
      transform: translate(30px, -2.651608px);
    }
    66.666667% {
      transform: translate(30px, 33.528168px);
    }
    73.333333% {
      transform: translate(30px, 41.764084px);
    }
    80% {
      transform: translate(30px, 33.528168px);
    }
    100% {
      transform: translate(30px, 33.528168px);
    }
  `,
        translate3: (0, $ee90a39a48e5fa92$export$d25ddfdf17c3ad3e)`
    0% {
      transform: translate(50px, 33.528168px);
    }
    26.666667% {
      transform: translate(50px, 33.528168px);
    }
    33.333333% {
      transform: translate(50px, 41.764084px);
    }
    40% {
      transform: translate(50px, 33.528168px);
    }
    53.333333% {
      transform: translate(50px, -2.651608px);
    }
    60% {
      transform: translate(50px, -4.471832px);
    }
    66.666667% {
      transform: translate(50px, -2.651608px);
    }
    80% {
      transform: translate(50px, 33.528168px);
    }
    86.666667% {
      transform: translate(50px, 41.764084px);
    }
    93.333333% {
      transform: translate(50px, 33.528168px);
    }
    100% {
      transform: translate(50px, 33.528168px);
    }
  `
    };
    return {
        root: (a)=>(0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
                height: a.customSize ? `${a.customSize}px` : void 0,
                verticalAlign: "middle",
                width: a.customSize ? `${a.customSize}px` : $6e6b089c3d63766c$var$h[a.size]
            }),
        circle1Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale1} 1s linear infinite normal forwards;`
        }),
        circle2Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale2} 1s linear infinite normal forwards;`
        }),
        circle3Scale: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.scale3} 1s linear infinite normal forwards;`
        }),
        circle1Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate1} 1s linear infinite normal forwards;`
        }),
        circle2Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate2} 1s linear infinite normal forwards;`
        }),
        circle3Translate: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            animation: `${r.translate3} 1s linear infinite normal forwards;`
        })
    };
};
var $6e6b089c3d63766c$var$b = "div", $6e6b089c3d63766c$var$I = {
    default: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).gray700,
    primary: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorPrimary,
    white: (0, (/*@__PURE__*/$parcel$interopDefault($3a460728537dec08$exports))).colorWhite
}, $6e6b089c3d63766c$export$7f7cbe89f1eacd2 = (0, $8tsvq.forwardRef)((A, P)=>{
    var p = A, { className: r, customSize: a, size: t = "medium", variant: n = "default", testId: z = "cf-ui-spinner" } = p, w = $6e6b089c3d63766c$var$g(p, [
        "className",
        "customSize",
        "size",
        "variant",
        "testId"
    ]);
    let e = $6e6b089c3d63766c$var$y();
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement((0, $7c1d3a8c755aa15d$export$e71c4d32a2263218), $6e6b089c3d63766c$var$d($6e6b089c3d63766c$var$S({
        as: $6e6b089c3d63766c$var$b,
        display: "inline-block"
    }, w), {
        className: (0, $ee90a39a48e5fa92$export$a274e22fb40f762e)(e.root({
            size: t,
            customSize: a
        }), r),
        ref: P,
        testId: z
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("svg", {
        className: (0, $ee90a39a48e5fa92$export$dbf350e5966cf602)({
            display: "block",
            fill: $6e6b089c3d63766c$var$I[n]
        }),
        viewBox: "0 0 60 51",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("title", null, "Loading\u2026"), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle1Translate,
        transform: "translate(10,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle1Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle2Translate,
        transform: "translate(30,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle2Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle3Translate,
        transform: "translate(50,33.528168)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("g", {
        className: e.circle3Scale
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("circle", {
        r: "6",
        transform: "translate(0,10.471832)"
    })))));
});
$6e6b089c3d63766c$export$7f7cbe89f1eacd2.displayName = "Spinner";




const $37b4dc016acd2660$var$AnchorMenuItem = ({ el: el, activeAnchor: activeAnchor, setActiveAnchor: setActiveAnchor })=>{
    const activeClass = activeAnchor === el.id ? 'anchor_menu_item_active' : '';
    const hasSub = el.subSections && el.subSections.length;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
        className: `anchor_menu_item ${activeClass} ${hasSub ? 'anchor_menu_item_sub' : ''}`,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                onClick: setActiveAnchor ? ()=>setActiveAnchor(el.id) : undefined,
                href: `${el.slug || ''}#${el.id}`,
                children: el.name
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                className: "anchor_menu_list",
                children: hasSub ? el.subSections.map((subEl, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($37b4dc016acd2660$var$AnchorMenuItem, {
                        el: subEl,
                        activeAnchor: activeAnchor,
                        setActiveAnchor: setActiveAnchor
                    }, i)) : null
            })
        ]
    }, el.name);
};
const $37b4dc016acd2660$var$AnchorMenu = ({ data: data, activeAnchor: activeAnchor, setActiveAnchor: setActiveAnchor })=>{
    const skip = [
        'Code',
        'Slug',
        'Name',
        'Extension Page Link',
        'Deviations',
        'Itinerary Free Text',
        'Trip Highlights',
        'People Places Things',
        'Extension Operating Dates Text'
    ];
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("nav", {
        className: "anchor_menu",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                className: "anchor_menu_title",
                children: "On this page"
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                className: "anchor_menu_list",
                children: data.map((el, i)=>{
                    if (!skip.includes(el.name)) {
                        if (el.name.includes('Embed')) el.name = el.name.replace(/Embed$/, '');
                        if (el.name === 'Extension Details') {
                            el.name = 'Extension Itinerary';
                            el.id = 'extensionItinerary';
                        }
                        return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($37b4dc016acd2660$var$AnchorMenuItem, {
                            el: el,
                            activeAnchor: activeAnchor,
                            setActiveAnchor: setActiveAnchor
                        }, i);
                    }
                })
            })
        ]
    });
};
var $37b4dc016acd2660$export$2e2bcd8739ae039 = $37b4dc016acd2660$var$AnchorMenu;






var $8tsvq = parcelRequire("8tsvq");

var $e2137a36f845690e$export$16c55c8c145e9dad;
'use strict';
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $dad3209a3a2cdfa7$export$4473561af957c5c7;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd;
/**
 * Map of all Contentful marks.
 */ var $dad3209a3a2cdfa7$export$c85f128c9305332e;
var $dad3209a3a2cdfa7$export$f31e81340f60ac4f;
var $dad3209a3a2cdfa7$export$e5cde5f1d56fabad;
var $dad3209a3a2cdfa7$export$7b02abc60d9af577;
var $dad3209a3a2cdfa7$export$f164f8df1f226ed8;
var $dad3209a3a2cdfa7$export$61dc594370225b3;
var $dad3209a3a2cdfa7$export$33c1f54ccb4cc9b7;
var $dad3209a3a2cdfa7$export$ba32543429ed7e1c;
var $dad3209a3a2cdfa7$export$d8b073923a26e49d;
var $dad3209a3a2cdfa7$export$f8a6793e9df3d55d;
var $dad3209a3a2cdfa7$export$85f9856e66f16aa5;
var $dad3209a3a2cdfa7$export$cbfd4c4104bf5a27;
var $dad3209a3a2cdfa7$export$1ee7d3855fc41eb3;
'use strict';
var $2fc0c0fa00f9c834$exports = {};
'use strict';
$2fc0c0fa00f9c834$exports = (value)=>{
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};


$dad3209a3a2cdfa7$export$4473561af957c5c7 = void 0;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($dad3209a3a2cdfa7$export$4473561af957c5c7 || ($dad3209a3a2cdfa7$export$4473561af957c5c7 = {}));
$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd = void 0;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd || ($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd = {}));
$dad3209a3a2cdfa7$export$c85f128c9305332e = void 0;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($dad3209a3a2cdfa7$export$c85f128c9305332e || ($dad3209a3a2cdfa7$export$c85f128c9305332e = {}));
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $dad3209a3a2cdfa7$var$extendStatics = function(d, b) {
    $dad3209a3a2cdfa7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $dad3209a3a2cdfa7$var$extendStatics(d, b);
};
function $dad3209a3a2cdfa7$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $dad3209a3a2cdfa7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $dad3209a3a2cdfa7$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $dad3209a3a2cdfa7$var$_a$1;
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */ var $dad3209a3a2cdfa7$var$TOP_LEVEL_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE
];
/**
 * Array of all allowed block types inside list items
 */ var $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE
];
var $dad3209a3a2cdfa7$var$TABLE_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL
];
/**
 * Array of all void block types
 */ var $dad3209a3a2cdfa7$var$VOID_BLOCKS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE
];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */ var $dad3209a3a2cdfa7$var$CONTAINERS = ($dad3209a3a2cdfa7$var$_a$1 = {}, $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM] = $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS, $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST
], $dad3209a3a2cdfa7$var$_a$1[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL] = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
], $dad3209a3a2cdfa7$var$_a$1);
/**
 * Array of all heading levels
 */ var $dad3209a3a2cdfa7$var$HEADINGS = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6
];
/**
 * Array of all block types that may contain text and inline nodes.
 */ var $dad3209a3a2cdfa7$var$TEXT_CONTAINERS = $dad3209a3a2cdfa7$var$__spreadArray([
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
], $dad3209a3a2cdfa7$var$HEADINGS, true);
/**
 * Node types before `tables` release.
 */ var $dad3209a3a2cdfa7$var$V1_NODE_TYPES = [
    $dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.HR,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY,
    $dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.HYPERLINK,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK,
    $dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY,
    'text'
];
/**
 * Marks before `superscript` & `subscript` release.
 */ var $dad3209a3a2cdfa7$var$V1_MARKS = [
    $dad3209a3a2cdfa7$export$c85f128c9305332e.BOLD,
    $dad3209a3a2cdfa7$export$c85f128c9305332e.CODE,
    $dad3209a3a2cdfa7$export$c85f128c9305332e.ITALIC,
    $dad3209a3a2cdfa7$export$c85f128c9305332e.UNDERLINE
];
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ var $dad3209a3a2cdfa7$var$EMPTY_DOCUMENT = {
    nodeType: $dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $dad3209a3a2cdfa7$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $dad3209a3a2cdfa7$var$isInline(node) {
    return $dad3209a3a2cdfa7$var$hasValue($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $dad3209a3a2cdfa7$var$isBlock(node) {
    return $dad3209a3a2cdfa7$var$hasValue($dad3209a3a2cdfa7$export$4473561af957c5c7, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $dad3209a3a2cdfa7$var$isText(node) {
    return node.nodeType === 'text';
}
var $dad3209a3a2cdfa7$var$helpers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    isBlock: $dad3209a3a2cdfa7$var$isBlock,
    isInline: $dad3209a3a2cdfa7$var$isInline,
    isText: $dad3209a3a2cdfa7$var$isText
});
var $dad3209a3a2cdfa7$var$typeMismatchError = function(_a) {
    var path = _a.path, property = _a.property, typeName = _a.typeName, value = _a.value;
    return {
        details: "The type of \"".concat(property, "\" is incorrect, expected type: ").concat(typeName),
        name: 'type',
        path: path.toArray(),
        type: typeName,
        value: value
    };
};
var $dad3209a3a2cdfa7$var$minSizeError = function(_a) {
    var min = _a.min, value = _a.value, path = _a.path;
    return {
        name: 'size',
        min: min,
        path: path.toArray(),
        details: "Size must be at least ".concat(min),
        value: value
    };
};
var $dad3209a3a2cdfa7$var$maxSizeError = function(_a) {
    var max = _a.max, value = _a.value, path = _a.path;
    return {
        name: 'size',
        max: max,
        path: path.toArray(),
        details: "Size must be at most ".concat(max),
        value: value
    };
};
var $dad3209a3a2cdfa7$var$enumError = function(_a) {
    var expected = _a.expected, value = _a.value, path = _a.path;
    return {
        details: "Value must be one of expected values",
        name: 'in',
        expected: $dad3209a3a2cdfa7$var$__spreadArray([], expected, true).sort(),
        path: path.toArray(),
        value: value
    };
};
var $dad3209a3a2cdfa7$var$unknownPropertyError = function(_a) {
    var property = _a.property, path = _a.path;
    return {
        details: "The property \"".concat(property, "\" is not expected"),
        name: 'unexpected',
        path: path.toArray()
    };
};
var $dad3209a3a2cdfa7$var$requiredPropertyError = function(_a) {
    var property = _a.property, path = _a.path;
    return {
        details: "The property \"".concat(property, "\" is required here"),
        name: 'required',
        path: path.toArray()
    };
};
var $dad3209a3a2cdfa7$var$ObjectAssertion = /** @class */ function() {
    function ObjectAssertion(obj, path) {
        var _this = this;
        this.obj = obj;
        this.path = path;
        this._errors = [];
        this.catch = function() {
            var _a;
            var errors = [];
            for(var _i = 0; _i < arguments.length; _i++)errors[_i] = arguments[_i];
            (_a = _this._errors).push.apply(_a, errors);
        };
        /**
         * Asserts the key exists in the object. You probably shouldn't call this
         * function directly. Instead, use `$.object`, `$.number`, `$.string`, etc.
         */ this.exists = function(key) {
            if (key in _this.obj) return true;
            _this.catch($dad3209a3a2cdfa7$var$requiredPropertyError({
                property: key,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is a plain object. if
         * no key is provided, it asserts the object itself.
         */ this.object = function(key) {
            var _a;
            var value = key ? _this.obj[key] : _this.obj;
            if (key) {
                if (!_this.exists(key)) return false;
            }
            if ($2fc0c0fa00f9c834$exports(value)) return true;
            var path = key ? _this.path.of(key) : _this.path;
            var property = (_a = key !== null && key !== void 0 ? key : _this.path.last()) !== null && _a !== void 0 ? _a : 'value';
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'Object',
                property: property,
                path: path,
                value: value
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is a string.
         */ this.string = function(key) {
            var value = _this.obj[key];
            if (key && !_this.exists(key)) return false;
            if (typeof value === 'string') return true;
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'String',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is a number.
         */ this.number = function(key, optional) {
            var value = _this.obj[key];
            if (optional && !(key in _this.obj)) return true;
            if (!_this.exists(key)) return false;
            if (typeof value === 'number' && !Number.isNaN(value)) return true;
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'Number',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        /**
         * Asserts the key exists in the object and its value is an array. You don't
         * need to manually call this function before `$.each` or `$.maxLength`.
         */ this.array = function(key) {
            var value = _this.obj[key];
            if (key && !_this.exists(key)) return false;
            if (Array.isArray(value)) return true;
            _this.catch($dad3209a3a2cdfa7$var$typeMismatchError({
                typeName: 'Array',
                property: key,
                path: _this.path.of(key),
                value: value
            }));
            return false;
        };
        /**
         * Asserts the value of the key is one of the expected values.
         */ this.enum = function(key, expected) {
            var value = _this.obj[key];
            if (typeof value === 'string' && expected.includes(value)) return true;
            _this.catch($dad3209a3a2cdfa7$var$enumError({
                expected: expected,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the array value of the object key is empty. If the value isn't an
         * array, the function captures a type error and returns false.
         */ this.empty = function(key) {
            if (!_this.array(key)) return false;
            var value = _this.obj[key];
            if (value.length === 0) return true;
            _this.catch($dad3209a3a2cdfa7$var$maxSizeError({
                max: 0,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the length of the value of the object key is at least `min`. If the
         * value isn't an array, the function captures a type error and returns false.
         */ this.minLength = function(key, min) {
            if (!_this.array(key)) return false;
            var value = _this.obj[key];
            if (value.length >= min) return true;
            _this.catch($dad3209a3a2cdfa7$var$minSizeError({
                min: min,
                value: value,
                path: _this.path.of(key)
            }));
            return false;
        };
        /**
         * Asserts the object has no additional properties other than the ones
         * specified
         */ this.noAdditionalProperties = function(properties) {
            var unknowns = Object.keys(_this.obj).sort().filter(function(key) {
                return !properties.includes(key);
            });
            unknowns.forEach(function(property) {
                return _this.catch($dad3209a3a2cdfa7$var$unknownPropertyError({
                    property: property,
                    path: _this.path.of(property)
                }));
            });
            return unknowns.length === 0;
        };
        /**
         * Iterates over the value of the key and assert each item. If the value isn't
         * an array, the function captures a type error and safely exits.
         *
         * To maintain compatibility with previous implementation, we stop early if we
         * find any errors.
         */ this.each = function(key, assert) {
            if (!_this.array(key)) return;
            var value = _this.obj[key];
            var foundErrors = false;
            value.forEach(function(item, index) {
                if (foundErrors) return;
                var errors = assert(item, _this.path.of(key).of(index));
                if (errors.length > 0) foundErrors = true;
                _this.catch.apply(_this, errors);
            });
        };
    }
    Object.defineProperty(ObjectAssertion.prototype, "errors", {
        get: function() {
            var _this = this;
            var serializeError = function(error) {
                return JSON.stringify({
                    details: error.details,
                    path: error.path
                });
            };
            return this._errors.filter(function(error, index) {
                return _this._errors.findIndex(function(step) {
                    return serializeError(error) === serializeError(step);
                }) === index;
            });
        },
        enumerable: false,
        configurable: true
    });
    return ObjectAssertion;
}();
var $dad3209a3a2cdfa7$var$VOID_CONTENT = [];
var $dad3209a3a2cdfa7$var$NodeAssertion = /** @class */ function() {
    function NodeAssertion(contentRule, validateData) {
        this.contentRule = contentRule;
        this.validateData = validateData;
    }
    NodeAssertion.prototype.assert = function(node, path) {
        var _a, _b;
        var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(node, path);
        if (!$.object()) return $.errors;
        $.noAdditionalProperties([
            'nodeType',
            'data',
            'content'
        ]);
        var _c = Array.isArray(this.contentRule) ? {
            nodeTypes: this.contentRule
        } : this.contentRule(node, path), nodeTypes = _c.nodeTypes, _d = _c.min, min = _d === void 0 ? 0 : _d;
        if (nodeTypes.length === 0 && min > 0) throw new Error("Invalid content rule. Cannot have enforce a 'min' of ".concat(min, " with no nodeTypes"));
        $.minLength('content', min);
        // Is void
        if (nodeTypes.length === 0) $.empty('content');
        else $.each('content', function(item, path) {
            var item$ = new $dad3209a3a2cdfa7$var$ObjectAssertion(item, path);
            if (!item$.object()) return item$.errors;
            item$.enum('nodeType', nodeTypes);
            return item$.errors;
        });
        if ($.object('data')) {
            var dataErrors = (_b = (_a = this.validateData) === null || _a === void 0 ? void 0 : _a.call(this, node.data, path.of('data'))) !== null && _b !== void 0 ? _b : [];
            $.catch.apply($, dataErrors);
        }
        return $.errors;
    };
    return NodeAssertion;
}();
var $dad3209a3a2cdfa7$var$EntityLinkAssertion = /** @class */ function(_super) {
    $dad3209a3a2cdfa7$var$__extends(EntityLinkAssertion, _super);
    function EntityLinkAssertion(linkType, contentNodeTypes) {
        var _this = _super.call(this, contentNodeTypes, function(data, path) {
            return _this.assertLink(data, path);
        }) || this;
        _this.linkType = linkType;
        _this.assertLink = function(data, path) {
            var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data, path);
            if ($.object('target')) {
                var sys$ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data.target.sys, path.of('target').of('sys'));
                if (sys$.object()) {
                    sys$.enum('type', [
                        _this.type
                    ]);
                    sys$.enum('linkType', [
                        _this.linkType
                    ]);
                    if (_this.type === 'Link') {
                        sys$.string('id');
                        sys$.noAdditionalProperties([
                            'type',
                            'linkType',
                            'id'
                        ]);
                    } else if (_this.type === 'ResourceLink') {
                        sys$.string('urn');
                        sys$.noAdditionalProperties([
                            'type',
                            'linkType',
                            'urn'
                        ]);
                    }
                }
                $.catch.apply($, sys$.errors);
            }
            $.noAdditionalProperties([
                'target'
            ]);
            return $.errors;
        };
        _this.type = _this.linkType.startsWith('Contentful:') ? 'ResourceLink' : 'Link';
        return _this;
    }
    return EntityLinkAssertion;
}($dad3209a3a2cdfa7$var$NodeAssertion);
var $dad3209a3a2cdfa7$var$HyperLinkAssertion = /** @class */ function(_super) {
    $dad3209a3a2cdfa7$var$__extends(HyperLinkAssertion, _super);
    function HyperLinkAssertion() {
        var _this = _super.call(this, [
            'text'
        ], function(data, path) {
            return _this.assertLink(data, path);
        }) || this;
        _this.assertLink = function(data, path) {
            var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data, path);
            $.string('uri');
            $.noAdditionalProperties([
                'uri'
            ]);
            return $.errors;
        };
        return _this;
    }
    return HyperLinkAssertion;
}($dad3209a3a2cdfa7$var$NodeAssertion);
var $dad3209a3a2cdfa7$var$assert = function(contentRule, validateData) {
    return new $dad3209a3a2cdfa7$var$NodeAssertion(contentRule, validateData);
};
var $dad3209a3a2cdfa7$var$assertLink = function(linkType, contentRule) {
    return new $dad3209a3a2cdfa7$var$EntityLinkAssertion(linkType, contentRule);
};
var $dad3209a3a2cdfa7$var$Path = /** @class */ function() {
    function Path(path) {
        if (path === void 0) path = [];
        var _this = this;
        this.path = path;
        this.of = function(element) {
            return new Path($dad3209a3a2cdfa7$var$__spreadArray($dad3209a3a2cdfa7$var$__spreadArray([], _this.path, true), [
                element
            ], false));
        };
        this.isRoot = function() {
            return _this.path.length === 0;
        };
        this.last = function() {
            return _this.path[_this.path.length - 1];
        };
        this.toArray = function() {
            return _this.path;
        };
    }
    return Path;
}();
function $dad3209a3a2cdfa7$var$assertText(text, path) {
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(text, path);
    if (!$.object()) return $.errors;
    $.noAdditionalProperties([
        'nodeType',
        'data',
        'value',
        'marks'
    ]);
    $.object('data');
    $.each('marks', function(mark, path) {
        var mark$ = new $dad3209a3a2cdfa7$var$ObjectAssertion(mark, path);
        if (!mark$.object()) return mark$.errors;
        // For historical reasons, we don't explicitly check for supported marks
        // e.g. bold, italic ..etc. This makes it possible for a customer to add
        // custom marks
        mark$.string('type');
        return mark$.errors;
    });
    $.string('value');
    return $.errors;
}
var $dad3209a3a2cdfa7$var$_a;
var $dad3209a3a2cdfa7$var$assertInlineOrText = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$__spreadArray($dad3209a3a2cdfa7$var$__spreadArray([], Object.values($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd), true), [
    'text'
], false).sort());
var $dad3209a3a2cdfa7$var$assertList = $dad3209a3a2cdfa7$var$assert([
    $dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM
]);
var $dad3209a3a2cdfa7$var$assertVoidEntryLink = $dad3209a3a2cdfa7$var$assertLink('Entry', $dad3209a3a2cdfa7$var$VOID_CONTENT);
var $dad3209a3a2cdfa7$var$assertTableCell = $dad3209a3a2cdfa7$var$assert(function() {
    return {
        nodeTypes: [
            $dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH
        ],
        min: 1
    };
}, function(data, path) {
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(data, path);
    $.noAdditionalProperties([
        'colspan',
        'rowspan'
    ]);
    $.number('colspan', true);
    $.number('rowspan', true);
    return $.errors;
});
var $dad3209a3a2cdfa7$var$nodeValidator = ($dad3209a3a2cdfa7$var$_a = {}, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$TOP_LEVEL_BLOCKS), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6] = $dad3209a3a2cdfa7$var$assertInlineOrText, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$CONTAINERS[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE]), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY] = $dad3209a3a2cdfa7$var$assertVoidEntryLink, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ASSET] = $dad3209a3a2cdfa7$var$assertLink('Asset', $dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE] = $dad3209a3a2cdfa7$var$assertLink('Contentful:Entry', $dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HR] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST] = $dad3209a3a2cdfa7$var$assertList, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST] = $dad3209a3a2cdfa7$var$assertList, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM] = $dad3209a3a2cdfa7$var$assert($dad3209a3a2cdfa7$var$__spreadArray([], $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS, true).sort()), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE] = $dad3209a3a2cdfa7$var$assert(function() {
    return {
        nodeTypes: [
            $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW
        ],
        min: 1
    };
}), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW] = $dad3209a3a2cdfa7$var$assert(function() {
    return {
        nodeTypes: [
            $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL,
            $dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL
        ],
        min: 1
    };
}), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL] = $dad3209a3a2cdfa7$var$assertTableCell, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL] = $dad3209a3a2cdfa7$var$assertTableCell, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.HYPERLINK] = new $dad3209a3a2cdfa7$var$HyperLinkAssertion(), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY] = $dad3209a3a2cdfa7$var$assertVoidEntryLink, $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_RESOURCE] = $dad3209a3a2cdfa7$var$assertLink('Contentful:Entry', $dad3209a3a2cdfa7$var$VOID_CONTENT), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK] = $dad3209a3a2cdfa7$var$assertLink('Entry', [
    'text'
]), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK] = $dad3209a3a2cdfa7$var$assertLink('Asset', [
    'text'
]), $dad3209a3a2cdfa7$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.RESOURCE_HYPERLINK] = $dad3209a3a2cdfa7$var$assertLink('Contentful:Entry', [
    'text'
]), $dad3209a3a2cdfa7$var$_a);
function $dad3209a3a2cdfa7$var$validateNode(node, path) {
    if (node.nodeType === 'text') return $dad3209a3a2cdfa7$var$assertText(node, path);
    var errors = $dad3209a3a2cdfa7$var$nodeValidator[node.nodeType].assert(node, path);
    if (errors.length > 0) return errors;
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(node, path);
    $.each('content', function(item, path) {
        // We already know those are valid nodes thanks to the assertion done in
        // the NodeAssertion class
        return $dad3209a3a2cdfa7$var$validateNode(item, path);
    });
    return $.errors;
}
var $dad3209a3a2cdfa7$var$validateRichTextDocument = function(document) {
    var path = new $dad3209a3a2cdfa7$var$Path();
    var $ = new $dad3209a3a2cdfa7$var$ObjectAssertion(document, path);
    if ($.object()) $.enum('nodeType', [
        $dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT
    ]);
    if ($.errors.length > 0) return $.errors;
    return $dad3209a3a2cdfa7$var$validateNode(document, path);
};
$dad3209a3a2cdfa7$export$f31e81340f60ac4f = $dad3209a3a2cdfa7$var$CONTAINERS;
$dad3209a3a2cdfa7$export$e5cde5f1d56fabad = $dad3209a3a2cdfa7$var$EMPTY_DOCUMENT;
$dad3209a3a2cdfa7$export$7b02abc60d9af577 = $dad3209a3a2cdfa7$var$HEADINGS;
$dad3209a3a2cdfa7$export$f164f8df1f226ed8 = $dad3209a3a2cdfa7$var$LIST_ITEM_BLOCKS;
$dad3209a3a2cdfa7$export$61dc594370225b3 = $dad3209a3a2cdfa7$var$TABLE_BLOCKS;
$dad3209a3a2cdfa7$export$33c1f54ccb4cc9b7 = $dad3209a3a2cdfa7$var$TEXT_CONTAINERS;
$dad3209a3a2cdfa7$export$ba32543429ed7e1c = $dad3209a3a2cdfa7$var$TOP_LEVEL_BLOCKS;
$dad3209a3a2cdfa7$export$d8b073923a26e49d = $dad3209a3a2cdfa7$var$V1_MARKS;
$dad3209a3a2cdfa7$export$f8a6793e9df3d55d = $dad3209a3a2cdfa7$var$V1_NODE_TYPES;
$dad3209a3a2cdfa7$export$85f9856e66f16aa5 = $dad3209a3a2cdfa7$var$VOID_BLOCKS;
$dad3209a3a2cdfa7$export$cbfd4c4104bf5a27 = $dad3209a3a2cdfa7$var$helpers;
$dad3209a3a2cdfa7$export$1ee7d3855fc41eb3 = $dad3209a3a2cdfa7$var$validateRichTextDocument;


/**
 * Returns the text value of a rich text document.
 *
 * NB: This can be applied to non text node of a structured text document,
 * hence the flexible typing.
 */ function $e2137a36f845690e$var$documentToPlainTextString(rootNode, blockDivisor) {
    if (blockDivisor === void 0) blockDivisor = ' ';
    if (!rootNode || !rootNode.content || !Array.isArray(rootNode.content)) /**
         * Handles edge cases, such as when the value is not set in the CMA or the
         * field has not been properly validated, e.g. because of a user extension.
         * Note that we are nevertheless strictly type-casting `rootNode` as
         * Block | Inline. Valid rich text documents (and their branch block nodes)
         * should never lack a Node[] `content` property.
         */ return '';
    /**
     * Algorithm notes: We only want to apply spacing when a node is part of a
     * sequence. This is tricky because nodes can often be deeply nested within
     * non-semantic content arrays. For example, to get the text value of an
     * unordered list, we have to traverse like so:
     *
     * {
     *   nodeType: BLOCKS.UL_LIST,
     *   data: {},
     *   content: [
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'List ', marks: [] },
     *           { nodeType: 'text', data: {}, value: 'item', marks: [{ type: 'bold' }] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.HR,
     *         data: {},
     *         content: [],
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data:
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Yet another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *   }]
     * }
     *
     * We want there to be a space between 'List item' and 'Another list item' (to
     * denote a visual line break, which conventionally appears between non-text
     * node sequences) but not a redundant space between 'List ' and 'item'.
     * Moreover, we want just a _singular_ space between 'Another list item' and
     * 'Yet another list item' - the non-semantic HR between the two nodes should
     * not denote an additional space.
     */ return rootNode.content.reduce(function(acc, node, i) {
        var nodeTextValue;
        if ($dad3209a3a2cdfa7$export$cbfd4c4104bf5a27.isText(node)) nodeTextValue = node.value;
        else if ($dad3209a3a2cdfa7$export$cbfd4c4104bf5a27.isBlock(node) || $dad3209a3a2cdfa7$export$cbfd4c4104bf5a27.isInline(node)) {
            nodeTextValue = $e2137a36f845690e$var$documentToPlainTextString(node, blockDivisor);
            if (!nodeTextValue.length) return acc;
        }
        var nextNode = rootNode.content[i + 1];
        var isNextNodeBlock = nextNode && $dad3209a3a2cdfa7$export$cbfd4c4104bf5a27.isBlock(nextNode);
        var divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}
$e2137a36f845690e$export$16c55c8c145e9dad = $e2137a36f845690e$var$documentToPlainTextString;


const $d75ce639c2332d78$export$c383cdd2a518017a = (str)=>{
    if (!str) return;
    return String(str).normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
};
const $d75ce639c2332d78$export$280746aa23b168d4 = (str)=>{
    const text = str.split(new RegExp('src="', 'i'));
    if (!text || !text[1]) return;
    return text[1].split('"')[0];
};
const $d75ce639c2332d78$export$aebd617640818cda = (str)=>{
    return /^[A-Z]*$/.test(str);
};
const $d75ce639c2332d78$export$161d051f5dd25de7 = (str)=>{
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return "";
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
};
const $d75ce639c2332d78$export$3b34af866c706a7c = (text)=>{
    if ($d75ce639c2332d78$export$aebd617640818cda(text)) return text;
    if (text.length < 3) return text;
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const $d75ce639c2332d78$export$b5336631ae1d96d0 = (updatedAt)=>{
    const options = {
        year: '2-digit',
        month: 'short',
        day: 'numeric',
        hour12: false,
        hour: 'numeric',
        minute: 'numeric'
    };
    const updatedAtDate = new Date(updatedAt);
    if (updatedAtDate == 'Invalid Date') return;
    const date1 = new Date(updatedAtDate.getTime() + updatedAtDate.getTimezoneOffset() * 60000).toLocaleDateString('en-US', options);
    const date2 = date1.split(' ');
    return `${date2[1].replace(/,$/, '-')}${date2[0]}-${date2[2].replace(/,$/, '')}, ${date2[3]} (UTC)`;
};
const $d75ce639c2332d78$export$820fb7fb68841687 = (updatedAt, items)=>{
    if (!updatedAt && !items) return;
    const latest = updatedAt && !items ? updatedAt : items.reduce((max, item)=>max.sys.updatedAt > item.sys.updatedAt ? max : item);
    return $d75ce639c2332d78$export$b5336631ae1d96d0(latest.sys.updatedAt);
};
const $d75ce639c2332d78$export$bda897526085869f = async (key, contentType)=>{
    const url = `https://cdn.contentful.com/spaces/${"b4bpxrz16gb9"}/environments/master/entries?access_token=${"C5LWRE7HouchR5aDcuOD6NU4uXaC3SKjiZw7bPN2X44"}&content_type=${contentType}&sys.id=${key}&include=1`;
    try {
        const json = await fetch(url);
        const data = await json.json();
        return data;
    } catch (error) {
        console.error(error);
    }
};
const $d75ce639c2332d78$export$eac196a2107442 = (item)=>{
    const hits = [];
    const highlightMetadata = item._highlightResult.metadata || {
        tags: []
    };
    highlightMetadata.tags.forEach((m)=>{
        const mached = m.name.matchedWords;
        if (mached && mached.length) hits.push({
            name: m.name,
            _highlightResult: {
                name: m.name
            },
            breadcrumbs: [
                item.fields.name
            ]
        });
    });
    if (item._highlightResult.fields) for (const [key, value] of Object.entries(item._highlightResult.fields)){
        if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
            const mached = value.matchedWords;
            if (mached && mached.length && mached[0].length > 2) hits.push({
                name: value,
                _highlightResult: {
                    name: value
                },
                ...key !== 'name' && {
                    anchor: key
                },
                breadcrumbs: key !== 'name' ? [
                    item.fields.name,
                    $d75ce639c2332d78$export$3b34af866c706a7c(key)
                ] : [
                    item.fields.name
                ],
                tags: highlightMetadata.tags
            });
            if (value.metadata) {
                const metadataMatch = value.metadata.fieldName;
                if (metadataMatch.matchedWords && metadataMatch.matchedWords.length) hits.push({
                    name: value.metadata.fieldName,
                    _highlightResult: {
                        name: value.metadata.fieldName
                    },
                    breadcrumbs: [
                        item.fields.name,
                        $d75ce639c2332d78$export$3b34af866c706a7c(key)
                    ],
                    anchor: key,
                    tags: highlightMetadata.tags
                });
            }
            if (value.fields) for (const [nKey, nValue] of Object.entries(value.fields)){
                const nMached = nValue.matchedWords;
                if (nMached && nMached.length && nMached[0].length > 2) //if (nValue.matchLevel === 'full') {
                hits.push({
                    name: nValue,
                    _highlightResult: {
                        name: nValue
                    },
                    anchor: key,
                    breadcrumbs: [
                        item.fields.name,
                        $d75ce639c2332d78$export$3b34af866c706a7c(key)
                    ],
                    tags: highlightMetadata.tags
                });
                if (nValue.fields) for (const [nNKey, nNValue] of Object.entries(nValue.fields)){
                    const nNmached = nNValue.matchedWords;
                    if (nNmached && nNmached.length && nNmached[0].length > 2) //if (nValue.matchLevel === 'full') {
                    hits.push({
                        name: nNValue,
                        _highlightResult: {
                            name: nNValue
                        },
                        anchor: key,
                        breadcrumbs: [
                            item.fields.name,
                            $d75ce639c2332d78$export$3b34af866c706a7c(key)
                        ],
                        tags: highlightMetadata.tags
                    });
                }
                if (Array.isArray(nValue)) nValue.forEach((nv)=>{
                    if (nv.value) {
                        const nVVMmached = nv.matchedWords;
                        if (nVVMmached && nVVMmached.length && nVVMmached[0].length > 2) hits.push({
                            name: nv,
                            _highlightResult: {
                                name: nv
                            },
                            anchor: key,
                            breadcrumbs: [
                                item.fields.name,
                                $d75ce639c2332d78$export$3b34af866c706a7c(key)
                            ],
                            tags: highlightMetadata.tags
                        });
                    } else for (const [nVkey, nVvalue] of Object.entries(nv.fields)){
                        const nVMmached = nVvalue.matchedWords;
                        if (nVMmached && nVMmached.length && nVMmached[0].length > 2) hits.push({
                            name: nVvalue,
                            _highlightResult: {
                                name: nVvalue
                            },
                            anchor: key,
                            breadcrumbs: [
                                item.fields.name,
                                $d75ce639c2332d78$export$3b34af866c706a7c(key)
                            ],
                            tags: highlightMetadata.tags
                        });
                        else if (nVvalue.content) {
                            const nvRichValue = nVvalue.content[0].content[0].value;
                            if (nvRichValue.matchLevel === 'full') hits.push({
                                name: nvRichValue,
                                _highlightResult: {
                                    name: nvRichValue
                                },
                                anchor: key,
                                breadcrumbs: [
                                    item.fields.name,
                                    $d75ce639c2332d78$export$3b34af866c706a7c(key)
                                ],
                                tags: highlightMetadata.tags
                            });
                        }
                    }
                });
            }
        } else if (Array.isArray(value)) value.forEach((v)=>{
            const mached = v.matchedWords;
            if (v.metadata) {
                const metadataMatch = v.metadata.fieldName;
                if (metadataMatch.matchedWords && metadataMatch.matchedWords.length) {
                    const isArrDuplicate = hits.find((hit)=>hit.name.value === v.metadata.fieldName.value);
                    if (!isArrDuplicate) hits.push({
                        name: v.metadata.fieldName,
                        _highlightResult: {
                            name: v.metadata.fieldName
                        },
                        anchor: key,
                        breadcrumbs: [
                            item.fields.name,
                            $d75ce639c2332d78$export$3b34af866c706a7c(key)
                        ],
                        tags: highlightMetadata.tags
                    });
                }
            }
            if (mached && mached.length && mached[0].length > 2) //if (v.matchLevel === 'full') {
            hits.push({
                name: v,
                _highlightResult: {
                    name: v
                },
                anchor: key,
                breadcrumbs: [
                    item.fields.name,
                    $d75ce639c2332d78$export$3b34af866c706a7c(key)
                ],
                tags: highlightMetadata.tags
            });
            if (v.fields) for (const [nArrKey, nArrValue] of Object.entries(v.fields)){
                if (Array.isArray(nArrValue)) nArrValue.forEach((nArrArrValue, i)=>{
                    if (nArrArrValue.metadata) {
                        const metadataMatch = nArrArrValue.metadata.fieldName;
                        const nestedAnchor = nArrKey + `${i !== 0 ? i : ''}`;
                        if (metadataMatch.matchedWords && metadataMatch.matchedWords.length) {
                            const isArrDuplicate = hits.find((hit)=>hit.name.value === nArrArrValue.metadata.fieldName.value);
                            if (!isArrDuplicate) hits.push({
                                name: nArrArrValue.metadata.fieldName,
                                _highlightResult: {
                                    name: nArrArrValue.metadata.fieldName
                                },
                                anchor: nestedAnchor,
                                breadcrumbs: [
                                    item.fields.name,
                                    $d75ce639c2332d78$export$3b34af866c706a7c(key)
                                ],
                                tags: highlightMetadata.tags
                            });
                        }
                    }
                    if (nArrArrValue.value && nArrArrValue.matchedWords && nArrArrValue.matchedWords.length > 1) // recheck later#1 console.log(nArrArrValue, 'nArrArrValue')
                    hits.push({
                        name: nArrArrValue,
                        _highlightResult: {
                            name: nArrArrValue
                        },
                        anchor: key,
                        breadcrumbs: [
                            item.fields.name,
                            $d75ce639c2332d78$export$3b34af866c706a7c(key)
                        ],
                        tags: highlightMetadata.tags
                    });
                    if (nArrArrValue.fields) for (const [nNArrArrKey, nNArrArrValue] of Object.entries(nArrArrValue.fields)){
                        if (Array.isArray(nNArrArrValue)) nNArrArrValue.forEach((nNArrArrArrValue)=>{
                            const matched = nNArrArrArrValue;
                            if (matched.value && matched.matchedWords && matched.matchedWords.length) hits.push({
                                name: matched,
                                _highlightResult: {
                                    name: matched
                                },
                                anchor: key,
                                breadcrumbs: [
                                    item.fields.name,
                                    $d75ce639c2332d78$export$3b34af866c706a7c(key)
                                ],
                                tags: highlightMetadata.tags
                            });
                            if (nNArrArrArrValue.fields) for (const [nNNArrArrKey, nNNArrArrArrValue] of Object.entries(nNArrArrArrValue.fields)){
                                if (Array.isArray(nNNArrArrArrValue)) ;
                                else {
                                    const matched = nNNArrArrArrValue;
                                    if (matched.value && matched.matchedWords && matched.matchedWords.length > 1) hits.push({
                                        name: matched,
                                        _highlightResult: {
                                            name: matched
                                        },
                                        anchor: key,
                                        breadcrumbs: [
                                            item.fields.name,
                                            $d75ce639c2332d78$export$3b34af866c706a7c(key)
                                        ],
                                        tags: highlightMetadata.tags
                                    });
                                }
                            }
                        });
                        if (nNArrArrValue.matchedWords && nNArrArrValue.matchLevel === 'full' && nNArrArrValue.matchedWords.length && nNArrArrValue.matchedWords[0].length > 2) hits.push({
                            name: nNArrArrValue,
                            _highlightResult: {
                                name: nNArrArrValue
                            },
                            anchor: key,
                            breadcrumbs: [
                                item.fields.name,
                                $d75ce639c2332d78$export$3b34af866c706a7c(key)
                            ],
                            tags: highlightMetadata.tags
                        });
                    }
                });
                const nArrMached = nArrValue.matchedWords;
                if (nArrValue && nArrMached && nArrMached.length && nArrMached[0].length > 2) {
                    if (nArrValue.matchLevel === 'full') hits.push({
                        name: nArrValue,
                        _highlightResult: {
                            name: nArrValue
                        },
                        anchor: key,
                        breadcrumbs: [
                            item.fields.name,
                            $d75ce639c2332d78$export$3b34af866c706a7c(key)
                        ],
                        tags: highlightMetadata.tags
                    });
                } else if (nArrValue.content) {
                    const nArrRichValue = nArrValue.content[0].content[0].value;
                    if (nArrRichValue.matchLevel === 'full') hits.push({
                        name: nArrRichValue,
                        _highlightResult: {
                            name: nArrRichValue
                        },
                        anchor: key,
                        breadcrumbs: [
                            item.fields.name,
                            $d75ce639c2332d78$export$3b34af866c706a7c(key)
                        ],
                        tags: highlightMetadata.tags
                    });
                }
            }
        });
    }
    return hits;
};



const $2bb2818d562d5134$var$EditDate = ({ date: date })=>{
    if (!date) return null;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "edit-date",
        children: [
            "Last updated: ",
            date
        ]
    });
};
var $2bb2818d562d5134$export$2e2bcd8739ae039 = $2bb2818d562d5134$var$EditDate;


const $b404e00b0f12a8df$var$productOwners = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((person, i)=>{
                if (!person || !person.fields) return;
                const { name: name } = person.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: "block-style",
                    children: name && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        style: {
                            marginBottom: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                children: "Name:"
                            }),
                            " ",
                            name
                        ]
                    })
                }, i);
            })
        ]
    });
};
var $b404e00b0f12a8df$export$2e2bcd8739ae039 = $b404e00b0f12a8df$var$productOwners;



var $96d12809385be3c5$export$4a295a2b4ab66da6;
'use strict';

var $8tsvq = parcelRequire("8tsvq");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $96d12809385be3c5$var$__assign = function() {
    $96d12809385be3c5$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $96d12809385be3c5$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
function $96d12809385be3c5$var$appendKeyToValidElement(element, key) {
    if ($8tsvq.isValidElement(element) && element.key === null) return $8tsvq.cloneElement(element, {
        key: key
    });
    return element;
}
function $96d12809385be3c5$var$nodeListToReactComponents(nodes, options) {
    return nodes.map(function(node, index) {
        return $96d12809385be3c5$var$appendKeyToValidElement($96d12809385be3c5$var$nodeToReactComponent(node, options), index);
    });
}
function $96d12809385be3c5$var$nodeToReactComponent(node, options) {
    var renderNode = options.renderNode, renderMark = options.renderMark, renderText = options.renderText, preserveWhitespace = options.preserveWhitespace;
    if ($dad3209a3a2cdfa7$export$cbfd4c4104bf5a27.isText(node)) {
        var nodeValue = renderText ? renderText(node.value) : node.value;
        // Preserving whitespace is only supported with the default transformations.
        if (preserveWhitespace && !renderText) {
            // Preserve multiple spaces.
            nodeValue = nodeValue.replace(/ {2,}/g, function(match) {
                return '\u00A0'.repeat(match.length);
            });
            // Preserve line breaks.
            var lines_1 = nodeValue.split('\n');
            var jsxLines_1 = [];
            lines_1.forEach(function(line, index) {
                jsxLines_1.push(line);
                if (index !== lines_1.length - 1) jsxLines_1.push($8tsvq.createElement("br", null));
            });
            nodeValue = jsxLines_1;
        }
        return node.marks.reduce(function(value, mark) {
            if (!renderMark[mark.type]) return value;
            return renderMark[mark.type](value);
        }, nodeValue);
    } else {
        var children = $96d12809385be3c5$var$nodeListToReactComponents(node.content, options);
        if (!node.nodeType || !renderNode[node.nodeType]) return $8tsvq.createElement($8tsvq.Fragment, null, children);
        return renderNode[node.nodeType](node, children);
    }
}
var $96d12809385be3c5$var$_a, $96d12809385be3c5$var$_b;
var $96d12809385be3c5$var$defaultNodeRenderers = ($96d12809385be3c5$var$_a = {}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.DOCUMENT] = function(node, children) {
    return children;
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.PARAGRAPH] = function(node, children) {
    return $8tsvq.createElement("p", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_1] = function(node, children) {
    return $8tsvq.createElement("h1", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_2] = function(node, children) {
    return $8tsvq.createElement("h2", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_3] = function(node, children) {
    return $8tsvq.createElement("h3", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_4] = function(node, children) {
    return $8tsvq.createElement("h4", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_5] = function(node, children) {
    return $8tsvq.createElement("h5", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HEADING_6] = function(node, children) {
    return $8tsvq.createElement("h6", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_ENTRY] = function(node, children) {
    return $8tsvq.createElement("div", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.EMBEDDED_RESOURCE] = function(node, children) {
    return $8tsvq.createElement("div", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.UL_LIST] = function(node, children) {
    return $8tsvq.createElement("ul", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.OL_LIST] = function(node, children) {
    return $8tsvq.createElement("ol", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.LIST_ITEM] = function(node, children) {
    return $8tsvq.createElement("li", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.QUOTE] = function(node, children) {
    return $8tsvq.createElement("blockquote", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.HR] = function() {
    return $8tsvq.createElement("hr", null);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE] = function(node, children) {
    return $8tsvq.createElement("table", null, $8tsvq.createElement("tbody", null, children));
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_ROW] = function(node, children) {
    return $8tsvq.createElement("tr", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_HEADER_CELL] = function(node, children) {
    return $8tsvq.createElement("th", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$4473561af957c5c7.TABLE_CELL] = function(node, children) {
    return $8tsvq.createElement("td", null, children);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK] = function(node) {
    return $96d12809385be3c5$var$defaultInline($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ASSET_HYPERLINK, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK] = function(node) {
    return $96d12809385be3c5$var$defaultInline($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.ENTRY_HYPERLINK, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.RESOURCE_HYPERLINK] = function(node) {
    return $96d12809385be3c5$var$defaultInlineResource($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.RESOURCE_HYPERLINK, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY] = function(node) {
    return $96d12809385be3c5$var$defaultInline($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_ENTRY, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_RESOURCE] = function(node, _children) {
    return $96d12809385be3c5$var$defaultInlineResource($dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.EMBEDDED_RESOURCE, node);
}, $96d12809385be3c5$var$_a[$dad3209a3a2cdfa7$export$6dca1cbf5d592fbd.HYPERLINK] = function(node, children) {
    return $8tsvq.createElement("a", {
        href: node.data.uri
    }, children);
}, $96d12809385be3c5$var$_a);
var $96d12809385be3c5$var$defaultMarkRenderers = ($96d12809385be3c5$var$_b = {}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.BOLD] = function(text) {
    return $8tsvq.createElement("b", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.ITALIC] = function(text) {
    return $8tsvq.createElement("i", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.UNDERLINE] = function(text) {
    return $8tsvq.createElement("u", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.CODE] = function(text) {
    return $8tsvq.createElement("code", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.SUPERSCRIPT] = function(text) {
    return $8tsvq.createElement("sup", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.SUBSCRIPT] = function(text) {
    return $8tsvq.createElement("sub", null, text);
}, $96d12809385be3c5$var$_b[$dad3209a3a2cdfa7$export$c85f128c9305332e.STRIKETHROUGH] = function(text) {
    return $8tsvq.createElement("s", null, text);
}, $96d12809385be3c5$var$_b);
function $96d12809385be3c5$var$defaultInline(type, node) {
    return $8tsvq.createElement("span", {
        key: node.data.target.sys.id
    }, "type: ", node.nodeType, " id: ", node.data.target.sys.id);
}
function $96d12809385be3c5$var$defaultInlineResource(type, node) {
    return $8tsvq.createElement("span", {
        key: node.data.target.sys.urn
    }, "type: ", node.nodeType, " urn: ", node.data.target.sys.urn);
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */ function $96d12809385be3c5$var$documentToReactComponents(richTextDocument, options) {
    if (options === void 0) options = {};
    if (!richTextDocument) return null;
    return $96d12809385be3c5$var$nodeToReactComponent(richTextDocument, {
        renderNode: $96d12809385be3c5$var$__assign($96d12809385be3c5$var$__assign({}, $96d12809385be3c5$var$defaultNodeRenderers), options.renderNode),
        renderMark: $96d12809385be3c5$var$__assign($96d12809385be3c5$var$__assign({}, $96d12809385be3c5$var$defaultMarkRenderers), options.renderMark),
        renderText: options.renderText,
        preserveWhitespace: options.preserveWhitespace
    });
}
$96d12809385be3c5$export$4a295a2b4ab66da6 = $96d12809385be3c5$var$documentToReactComponents;




const $32fd15a4dc46ab2b$var$Faq = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((f, i)=>{
                if (!f || !f.fields) return;
                const { questionEntryTitle: questionEntryTitle, answer: answer } = f.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    style: {
                        marginBottom: 15
                    },
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            children: questionEntryTitle
                        }),
                        answer && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            style: {
                                marginTop: 10
                            },
                            children: (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(answer)
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $32fd15a4dc46ab2b$export$2e2bcd8739ae039 = $32fd15a4dc46ab2b$var$Faq;










const $316027d593e708f6$var$DefaultAsset = ({ data: data, fullWidth: fullWidth = false })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        className: "assets-container",
        children: data.map((img, i)=>{
            if (!img || !img.fields) return null;
            const { file: file, title: title } = img.fields;
            return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: `asset-wrap ${fullWidth ? 'max-w-none' : ''}`,
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                    src: file.url,
                    alt: title
                })
            }, i);
        })
    });
};
var $316027d593e708f6$export$2e2bcd8739ae039 = $316027d593e708f6$var$DefaultAsset;




const $f7747c0090244a4f$var$RichTextRenderer = ({ richTextDocument: richTextDocument })=>{
    const renderOptions = {
        renderNode: {
            [(0, $dad3209a3a2cdfa7$export$4473561af957c5c7).EMBEDDED_ASSET]: (node)=>{
                const fields = node.data.target.fields;
                if (!fields) return null;
                const { url: url, title: title, description: description } = fields.file;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "embedded-asset",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                            src: url,
                            alt: description || title
                        }),
                        description && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: description
                        })
                    ]
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(richTextDocument, renderOptions)
    });
};
const $f7747c0090244a4f$var$FreeText = ({ data: data, slug: slug, title: title })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    if (!data) return null;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        className: "content_h3",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(title || slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((text, i)=>{
                if (!text || !text.fields) return;
                const { internalName: internalName, additionalNotes: additionalNotes, image: image } = text.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        internalName && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                            style: {
                                marginTop: 10,
                                marginBottom: 30
                            },
                            className: "content_h3",
                            children: internalName
                        }),
                        additionalNotes && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($f7747c0090244a4f$var$RichTextRenderer, {
                            richTextDocument: additionalNotes
                        }),
                        image && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $316027d593e708f6$export$2e2bcd8739ae039), {
                            data: [
                                image
                            ],
                            fullWidth: true
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $f7747c0090244a4f$export$2e2bcd8739ae039 = $f7747c0090244a4f$var$FreeText;


const $5fb78378baf79c9f$var$NewExtensions = ({ data: data, slug: slug, disclaimer: disclaimer, freeText: freeText })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: (0, $d75ce639c2332d78$export$c383cdd2a518017a)(slug),
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: slug
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            disclaimer && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("i", {
                style: {
                    display: 'block',
                    marginBottom: 7
                },
                children: disclaimer
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                children: data && data.map((product, i)=>{
                    if (!product || !product.fields) return;
                    const { name: name, slug: slug } = product.fields;
                    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "block-style",
                        children: name && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h4", {
                            className: "content_h4",
                            style: {
                                marginBottom: 0
                            },
                            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: `/extensions/${slug}`,
                                children: name
                            })
                        })
                    }, i);
                })
            }),
            freeText && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                data: freeText,
                slug: "additionalInfo"
            })
        ]
    });
};
var $5fb78378baf79c9f$export$2e2bcd8739ae039 = $5fb78378baf79c9f$var$NewExtensions;





const $8b892f412b4b5fd2$var$Ship = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                className: "content_h2",
                children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                date: date
            }),
            data.map((ship, i)=>{
                if (!ship || !ship.fields) return;
                const { name: name, Overview: link } = ship.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h4", {
                            className: "content_h4",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                            className: "mb-0",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Ship info:"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    target: "_blank",
                                    href: link,
                                    children: link
                                })
                            ]
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $8b892f412b4b5fd2$export$2e2bcd8739ae039 = $8b892f412b4b5fd2$var$Ship;








const $8d6dcb7409593925$var$VaccineTable = ({ requiredVaccines: requiredVaccines = [], recommendedVaccines: recommendedVaccines = [] })=>{
    const allVaccines = [
        "COVID-19 Vaccine",
        "DTP Vaccine (Diptheria, Tetanus, Pertussis)",
        "Malaria Vaccine",
        "MMR Vaccine (Measles, Mumps, Rubella)",
        "Polio Vaccine",
        "Yellow Fever Vaccine"
    ];
    const cellStyle = {
        padding: '8px',
        textAlign: 'left'
    };
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse'
        },
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("th", {
                            style: cellStyle,
                            children: "Required"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("th", {
                            style: cellStyle,
                            children: "Recommended"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("th", {
                            style: cellStyle,
                            children: "Vaccine"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("tbody", {
                children: allVaccines.map((vaccine)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("td", {
                                style: cellStyle,
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                    style: {
                                        width: '20px',
                                        height: '20px',
                                        border: '1px solid #000',
                                        display: 'inline-block',
                                        textAlign: 'center',
                                        lineHeight: '20px'
                                    },
                                    children: requiredVaccines.includes(vaccine) ? "\u2714" : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("td", {
                                style: cellStyle,
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                    style: {
                                        width: '20px',
                                        height: '20px',
                                        border: '1px solid #000',
                                        display: 'inline-block',
                                        textAlign: 'center',
                                        lineHeight: '20px'
                                    },
                                    children: recommendedVaccines.includes(vaccine) ? "\u2714" : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("td", {
                                style: cellStyle,
                                children: vaccine
                            })
                        ]
                    }, vaccine))
            })
        ]
    });
};
var $8d6dcb7409593925$export$2e2bcd8739ae039 = $8d6dcb7409593925$var$VaccineTable;




const $57d6a9b3d6b7082b$var$MedicalInformation = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        className: "content_h3",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((el, i)=>{
                if (!el || !el.fields) return;
                const { internalName: internalName, mandatoryRequirements: mandatoryRequirements, vaxDisclaimer: vaxDisclaimer, vaccines: vaccines, recommendedVaccines: recommendedVaccines, mobilityMedical: mobilityMedical, generalLexMedicalForm: generalLexMedicalForm, additionalInfo: additionalInfo } = el.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        internalName && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                            style: {
                                marginTop: 10,
                                marginBottom: 30
                            },
                            className: "content_h3",
                            children: internalName
                        }),
                        mandatoryRequirements && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Mandatory Requirements"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: mandatoryRequirements.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        vaxDisclaimer && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Vaccine Disclaimer"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: vaxDisclaimer
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8d6dcb7409593925$export$2e2bcd8739ae039), {
                            requiredVaccines: vaccines,
                            recommendedVaccines: recommendedVaccines
                        }),
                        mobilityMedical && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Mobility / Medical"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: mobilityMedical.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        generalLexMedicalForm && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "d-flex-align-center",
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Medical Form:"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "link-wrap",
                                    href: generalLexMedicalForm,
                                    target: "_blank",
                                    children: generalLexMedicalForm
                                })
                            ]
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $57d6a9b3d6b7082b$export$2e2bcd8739ae039 = $57d6a9b3d6b7082b$var$MedicalInformation;




var $e2ae5481ea3ab6f0$export$7baf571c7f59ce7c;
'use strict';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $e2ae5481ea3ab6f0$var$__assign = function() {
    $e2ae5481ea3ab6f0$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e2ae5481ea3ab6f0$var$__assign.apply(this, arguments);
};
typeof SuppressedError === "function" && SuppressedError;
var $e2ae5481ea3ab6f0$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $e2ae5481ea3ab6f0$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $e2ae5481ea3ab6f0$var$dist = {};
var $e2ae5481ea3ab6f0$var$blocks = {};
Object.defineProperty($e2ae5481ea3ab6f0$var$blocks, "__esModule", {
    value: true
});
$e2ae5481ea3ab6f0$var$blocks.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */ var $e2ae5481ea3ab6f0$var$BLOCKS;
(function(BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})($e2ae5481ea3ab6f0$var$BLOCKS || ($e2ae5481ea3ab6f0$var$blocks.BLOCKS = $e2ae5481ea3ab6f0$var$BLOCKS = {}));
var $e2ae5481ea3ab6f0$var$inlines = {};
Object.defineProperty($e2ae5481ea3ab6f0$var$inlines, "__esModule", {
    value: true
});
$e2ae5481ea3ab6f0$var$inlines.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 *
 * @note This should be kept in alphabetical order since the
 * [validation package](https://github.com/contentful/content-stack/tree/master/packages/validation)
 *  relies on the values being in a predictable order.
 */ var $e2ae5481ea3ab6f0$var$INLINES;
(function(INLINES) {
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
})($e2ae5481ea3ab6f0$var$INLINES || ($e2ae5481ea3ab6f0$var$inlines.INLINES = $e2ae5481ea3ab6f0$var$INLINES = {}));
var $e2ae5481ea3ab6f0$var$marks = {};
Object.defineProperty($e2ae5481ea3ab6f0$var$marks, "__esModule", {
    value: true
});
$e2ae5481ea3ab6f0$var$marks.MARKS = void 0;
/**
 * Map of all Contentful marks.
 */ var $e2ae5481ea3ab6f0$var$MARKS;
(function(MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
    MARKS["STRIKETHROUGH"] = "strikethrough";
})($e2ae5481ea3ab6f0$var$MARKS || ($e2ae5481ea3ab6f0$var$marks.MARKS = $e2ae5481ea3ab6f0$var$MARKS = {}));
var $e2ae5481ea3ab6f0$var$schemaConstraints = {};
(function(exports1) {
    var __spreadArray = $e2ae5481ea3ab6f0$var$commonjsGlobal && $e2ae5481ea3ab6f0$var$commonjsGlobal.__spreadArray || function(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };
    var _a;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.V1_MARKS = exports1.V1_NODE_TYPES = exports1.TEXT_CONTAINERS = exports1.HEADINGS = exports1.CONTAINERS = exports1.VOID_BLOCKS = exports1.TABLE_BLOCKS = exports1.LIST_ITEM_BLOCKS = exports1.TOP_LEVEL_BLOCKS = void 0;
    var blocks_1 = $e2ae5481ea3ab6f0$var$blocks;
    var inlines_1 = $e2ae5481ea3ab6f0$var$inlines;
    var marks_1 = $e2ae5481ea3ab6f0$var$marks;
    /**
	 * Array of all top level block types.
	 * Only these block types can be the direct children of the document.
	 */ exports1.TOP_LEVEL_BLOCKS = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE,
        blocks_1.BLOCKS.TABLE
    ];
    /**
	 * Array of all allowed block types inside list items
	 */ exports1.LIST_ITEM_BLOCKS = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE
    ];
    exports1.TABLE_BLOCKS = [
        blocks_1.BLOCKS.TABLE,
        blocks_1.BLOCKS.TABLE_ROW,
        blocks_1.BLOCKS.TABLE_CELL,
        blocks_1.BLOCKS.TABLE_HEADER_CELL
    ];
    /**
	 * Array of all void block types
	 */ exports1.VOID_BLOCKS = [
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        blocks_1.BLOCKS.EMBEDDED_RESOURCE
    ];
    /**
	 * Dictionary of all container block types, and the set block types they accept as children.
	 *
	 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
	 */ exports1.CONTAINERS = (_a = {}, _a[blocks_1.BLOCKS.OL_LIST] = [
        blocks_1.BLOCKS.LIST_ITEM
    ], _a[blocks_1.BLOCKS.UL_LIST] = [
        blocks_1.BLOCKS.LIST_ITEM
    ], _a[blocks_1.BLOCKS.LIST_ITEM] = exports1.LIST_ITEM_BLOCKS, _a[blocks_1.BLOCKS.QUOTE] = [
        blocks_1.BLOCKS.PARAGRAPH
    ], _a[blocks_1.BLOCKS.TABLE] = [
        blocks_1.BLOCKS.TABLE_ROW
    ], _a[blocks_1.BLOCKS.TABLE_ROW] = [
        blocks_1.BLOCKS.TABLE_CELL,
        blocks_1.BLOCKS.TABLE_HEADER_CELL
    ], _a[blocks_1.BLOCKS.TABLE_CELL] = [
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.OL_LIST
    ], _a[blocks_1.BLOCKS.TABLE_HEADER_CELL] = [
        blocks_1.BLOCKS.PARAGRAPH
    ], _a);
    /**
	 * Array of all heading levels
	 */ exports1.HEADINGS = [
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6
    ];
    /**
	 * Array of all block types that may contain text and inline nodes.
	 */ exports1.TEXT_CONTAINERS = __spreadArray([
        blocks_1.BLOCKS.PARAGRAPH
    ], exports1.HEADINGS, true);
    /**
	 * Node types before `tables` release.
	 */ exports1.V1_NODE_TYPES = [
        blocks_1.BLOCKS.DOCUMENT,
        blocks_1.BLOCKS.PARAGRAPH,
        blocks_1.BLOCKS.HEADING_1,
        blocks_1.BLOCKS.HEADING_2,
        blocks_1.BLOCKS.HEADING_3,
        blocks_1.BLOCKS.HEADING_4,
        blocks_1.BLOCKS.HEADING_5,
        blocks_1.BLOCKS.HEADING_6,
        blocks_1.BLOCKS.OL_LIST,
        blocks_1.BLOCKS.UL_LIST,
        blocks_1.BLOCKS.LIST_ITEM,
        blocks_1.BLOCKS.HR,
        blocks_1.BLOCKS.QUOTE,
        blocks_1.BLOCKS.EMBEDDED_ENTRY,
        blocks_1.BLOCKS.EMBEDDED_ASSET,
        inlines_1.INLINES.HYPERLINK,
        inlines_1.INLINES.ENTRY_HYPERLINK,
        inlines_1.INLINES.ASSET_HYPERLINK,
        inlines_1.INLINES.EMBEDDED_ENTRY,
        'text'
    ];
    /**
	 * Marks before `superscript` & `subscript` release.
	 */ exports1.V1_MARKS = [
        marks_1.MARKS.BOLD,
        marks_1.MARKS.CODE,
        marks_1.MARKS.ITALIC,
        marks_1.MARKS.UNDERLINE
    ];
})($e2ae5481ea3ab6f0$var$schemaConstraints);
var $e2ae5481ea3ab6f0$var$types = {};
Object.defineProperty($e2ae5481ea3ab6f0$var$types, "__esModule", {
    value: true
});
var $e2ae5481ea3ab6f0$var$nodeTypes = {};
Object.defineProperty($e2ae5481ea3ab6f0$var$nodeTypes, "__esModule", {
    value: true
});
var $e2ae5481ea3ab6f0$var$emptyDocument = {};
Object.defineProperty($e2ae5481ea3ab6f0$var$emptyDocument, "__esModule", {
    value: true
});
$e2ae5481ea3ab6f0$var$emptyDocument.EMPTY_DOCUMENT = void 0;
var $e2ae5481ea3ab6f0$var$blocks_1$1 = $e2ae5481ea3ab6f0$var$blocks;
/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */ $e2ae5481ea3ab6f0$var$emptyDocument.EMPTY_DOCUMENT = {
    nodeType: $e2ae5481ea3ab6f0$var$blocks_1$1.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: $e2ae5481ea3ab6f0$var$blocks_1$1.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {}
                }
            ]
        }
    ]
};
var $e2ae5481ea3ab6f0$var$helpers = {};
Object.defineProperty($e2ae5481ea3ab6f0$var$helpers, "__esModule", {
    value: true
});
$e2ae5481ea3ab6f0$var$helpers.isInline = $e2ae5481ea3ab6f0$var$isInline;
$e2ae5481ea3ab6f0$var$helpers.isBlock = $e2ae5481ea3ab6f0$var$isBlock;
$e2ae5481ea3ab6f0$var$helpers.isText = $e2ae5481ea3ab6f0$var$isText;
var $e2ae5481ea3ab6f0$var$blocks_1 = $e2ae5481ea3ab6f0$var$blocks;
var $e2ae5481ea3ab6f0$var$inlines_1 = $e2ae5481ea3ab6f0$var$inlines;
/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */ function $e2ae5481ea3ab6f0$var$hasValue(obj, value) {
    for(var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++){
        var key = _a[_i];
        if (value === obj[key]) return true;
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */ function $e2ae5481ea3ab6f0$var$isInline(node) {
    return $e2ae5481ea3ab6f0$var$hasValue($e2ae5481ea3ab6f0$var$inlines_1.INLINES, node.nodeType);
}
/**
 * Checks if the node is an instance of Block.
 */ function $e2ae5481ea3ab6f0$var$isBlock(node) {
    return $e2ae5481ea3ab6f0$var$hasValue($e2ae5481ea3ab6f0$var$blocks_1.BLOCKS, node.nodeType);
}
/**
 * Checks if the node is an instance of Text.
 */ function $e2ae5481ea3ab6f0$var$isText(node) {
    return node.nodeType === 'text';
}
(function(exports1) {
    var __createBinding = $e2ae5481ea3ab6f0$var$commonjsGlobal && $e2ae5481ea3ab6f0$var$commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
            enumerable: true,
            get: function() {
                return m[k];
            }
        };
        Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var __setModuleDefault = $e2ae5481ea3ab6f0$var$commonjsGlobal && $e2ae5481ea3ab6f0$var$commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
        Object.defineProperty(o, "default", {
            enumerable: true,
            value: v
        });
    } : function(o, v) {
        o["default"] = v;
    });
    var __exportStar = $e2ae5481ea3ab6f0$var$commonjsGlobal && $e2ae5481ea3ab6f0$var$commonjsGlobal.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
    };
    var __importStar = $e2ae5481ea3ab6f0$var$commonjsGlobal && $e2ae5481ea3ab6f0$var$commonjsGlobal.__importStar || function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        }
        __setModuleDefault(result, mod);
        return result;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.helpers = exports1.EMPTY_DOCUMENT = exports1.MARKS = exports1.INLINES = exports1.BLOCKS = void 0;
    var blocks_1 = $e2ae5481ea3ab6f0$var$blocks;
    Object.defineProperty(exports1, "BLOCKS", {
        enumerable: true,
        get: function() {
            return blocks_1.BLOCKS;
        }
    });
    var inlines_1 = $e2ae5481ea3ab6f0$var$inlines;
    Object.defineProperty(exports1, "INLINES", {
        enumerable: true,
        get: function() {
            return inlines_1.INLINES;
        }
    });
    var marks_1 = $e2ae5481ea3ab6f0$var$marks;
    Object.defineProperty(exports1, "MARKS", {
        enumerable: true,
        get: function() {
            return marks_1.MARKS;
        }
    });
    __exportStar($e2ae5481ea3ab6f0$var$schemaConstraints, exports1);
    __exportStar($e2ae5481ea3ab6f0$var$types, exports1);
    __exportStar($e2ae5481ea3ab6f0$var$nodeTypes, exports1);
    var emptyDocument_1 = $e2ae5481ea3ab6f0$var$emptyDocument;
    Object.defineProperty(exports1, "EMPTY_DOCUMENT", {
        enumerable: true,
        get: function() {
            return emptyDocument_1.EMPTY_DOCUMENT;
        }
    });
    var helpers$1 = __importStar($e2ae5481ea3ab6f0$var$helpers);
    exports1.helpers = helpers$1;
})($e2ae5481ea3ab6f0$var$dist);
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */ /**
 * Module variables.
 * @private
 */ var $e2ae5481ea3ab6f0$var$matchHtmlRegExp = /["'&<>]/;
/**
 * Module exports.
 * @public
 */ var $e2ae5481ea3ab6f0$var$escapeHtml_1 = $e2ae5481ea3ab6f0$var$escapeHtml;
/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */ function $e2ae5481ea3ab6f0$var$escapeHtml(string) {
    var str = '' + string;
    var match = $e2ae5481ea3ab6f0$var$matchHtmlRegExp.exec(str);
    if (!match) return str;
    var escape;
    var html = '';
    var index = 0;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escape = '&quot;';
                break;
            case 38:
                escape = '&amp;';
                break;
            case 39:
                escape = '&#39;';
                break;
            case 60:
                escape = '&lt;';
                break;
            case 62:
                escape = '&gt;';
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.substring(lastIndex, index);
        lastIndex = index + 1;
        html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
var $e2ae5481ea3ab6f0$var$escape = /*@__PURE__*/ $e2ae5481ea3ab6f0$var$getDefaultExportFromCjs($e2ae5481ea3ab6f0$var$escapeHtml_1);
var $e2ae5481ea3ab6f0$var$_a, $e2ae5481ea3ab6f0$var$_b;
var $e2ae5481ea3ab6f0$var$attributeValue = function(value) {
    return "\"".concat(value.replace(/"/g, '&quot;'), "\"");
};
var $e2ae5481ea3ab6f0$var$defaultNodeRenderers = ($e2ae5481ea3ab6f0$var$_a = {}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.PARAGRAPH] = function(node, next) {
    return "<p>".concat(next(node.content), "</p>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.HEADING_1] = function(node, next) {
    return "<h1>".concat(next(node.content), "</h1>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.HEADING_2] = function(node, next) {
    return "<h2>".concat(next(node.content), "</h2>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.HEADING_3] = function(node, next) {
    return "<h3>".concat(next(node.content), "</h3>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.HEADING_4] = function(node, next) {
    return "<h4>".concat(next(node.content), "</h4>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.HEADING_5] = function(node, next) {
    return "<h5>".concat(next(node.content), "</h5>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.HEADING_6] = function(node, next) {
    return "<h6>".concat(next(node.content), "</h6>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.EMBEDDED_ENTRY] = function(node, next) {
    return "<div>".concat(next(node.content), "</div>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.EMBEDDED_RESOURCE] = function(node, next) {
    return "<div>".concat(next(node.content), "</div>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.UL_LIST] = function(node, next) {
    return "<ul>".concat(next(node.content), "</ul>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.OL_LIST] = function(node, next) {
    return "<ol>".concat(next(node.content), "</ol>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.LIST_ITEM] = function(node, next) {
    return "<li>".concat(next(node.content), "</li>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.QUOTE] = function(node, next) {
    return "<blockquote>".concat(next(node.content), "</blockquote>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.HR] = function() {
    return '<hr/>';
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.TABLE] = function(node, next) {
    return "<table>".concat(next(node.content), "</table>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.TABLE_ROW] = function(node, next) {
    return "<tr>".concat(next(node.content), "</tr>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.TABLE_HEADER_CELL] = function(node, next) {
    return "<th>".concat(next(node.content), "</th>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.BLOCKS.TABLE_CELL] = function(node, next) {
    return "<td>".concat(next(node.content), "</td>");
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.INLINES.ASSET_HYPERLINK] = function(node) {
    return $e2ae5481ea3ab6f0$var$defaultInline($e2ae5481ea3ab6f0$var$dist.INLINES.ASSET_HYPERLINK, node);
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.INLINES.ENTRY_HYPERLINK] = function(node) {
    return $e2ae5481ea3ab6f0$var$defaultInline($e2ae5481ea3ab6f0$var$dist.INLINES.ENTRY_HYPERLINK, node);
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.INLINES.RESOURCE_HYPERLINK] = function(node) {
    return $e2ae5481ea3ab6f0$var$defaultInlineResource($e2ae5481ea3ab6f0$var$dist.INLINES.RESOURCE_HYPERLINK, node);
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.INLINES.EMBEDDED_ENTRY] = function(node) {
    return $e2ae5481ea3ab6f0$var$defaultInline($e2ae5481ea3ab6f0$var$dist.INLINES.EMBEDDED_ENTRY, node);
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.INLINES.EMBEDDED_RESOURCE] = function(node) {
    return $e2ae5481ea3ab6f0$var$defaultInlineResource($e2ae5481ea3ab6f0$var$dist.INLINES.EMBEDDED_RESOURCE, node);
}, $e2ae5481ea3ab6f0$var$_a[$e2ae5481ea3ab6f0$var$dist.INLINES.HYPERLINK] = function(node, next) {
    var href = typeof node.data.uri === 'string' ? node.data.uri : '';
    return "<a href=".concat($e2ae5481ea3ab6f0$var$attributeValue(href), ">").concat(next(node.content), "</a>");
}, $e2ae5481ea3ab6f0$var$_a);
var $e2ae5481ea3ab6f0$var$defaultMarkRenderers = ($e2ae5481ea3ab6f0$var$_b = {}, $e2ae5481ea3ab6f0$var$_b[$e2ae5481ea3ab6f0$var$dist.MARKS.BOLD] = function(text) {
    return "<b>".concat(text, "</b>");
}, $e2ae5481ea3ab6f0$var$_b[$e2ae5481ea3ab6f0$var$dist.MARKS.ITALIC] = function(text) {
    return "<i>".concat(text, "</i>");
}, $e2ae5481ea3ab6f0$var$_b[$e2ae5481ea3ab6f0$var$dist.MARKS.UNDERLINE] = function(text) {
    return "<u>".concat(text, "</u>");
}, $e2ae5481ea3ab6f0$var$_b[$e2ae5481ea3ab6f0$var$dist.MARKS.CODE] = function(text) {
    return "<code>".concat(text, "</code>");
}, $e2ae5481ea3ab6f0$var$_b[$e2ae5481ea3ab6f0$var$dist.MARKS.SUPERSCRIPT] = function(text) {
    return "<sup>".concat(text, "</sup>");
}, $e2ae5481ea3ab6f0$var$_b[$e2ae5481ea3ab6f0$var$dist.MARKS.SUBSCRIPT] = function(text) {
    return "<sub>".concat(text, "</sub>");
}, $e2ae5481ea3ab6f0$var$_b[$e2ae5481ea3ab6f0$var$dist.MARKS.STRIKETHROUGH] = function(text) {
    return "<s>".concat(text, "</s>");
}, $e2ae5481ea3ab6f0$var$_b);
var $e2ae5481ea3ab6f0$var$defaultInline = function(type, node) {
    return "<span>type: ".concat($e2ae5481ea3ab6f0$var$escape(type), " id: ").concat($e2ae5481ea3ab6f0$var$escape(node.data.target.sys.id), "</span>");
};
var $e2ae5481ea3ab6f0$var$defaultInlineResource = function(type, node) {
    return "<span>type: ".concat($e2ae5481ea3ab6f0$var$escape(type), " urn: ").concat($e2ae5481ea3ab6f0$var$escape(node.data.target.sys.urn), "</span>");
};
/**
 * Serialize a Contentful Rich Text `document` to an html string.
 */ function $e2ae5481ea3ab6f0$var$documentToHtmlString(richTextDocument, options) {
    if (options === void 0) options = {};
    if (!richTextDocument || !richTextDocument.content) return '';
    return $e2ae5481ea3ab6f0$var$nodeListToHtmlString(richTextDocument.content, {
        renderNode: $e2ae5481ea3ab6f0$var$__assign($e2ae5481ea3ab6f0$var$__assign({}, $e2ae5481ea3ab6f0$var$defaultNodeRenderers), options.renderNode),
        renderMark: $e2ae5481ea3ab6f0$var$__assign($e2ae5481ea3ab6f0$var$__assign({}, $e2ae5481ea3ab6f0$var$defaultMarkRenderers), options.renderMark),
        preserveWhitespace: options.preserveWhitespace
    });
}
function $e2ae5481ea3ab6f0$var$nodeListToHtmlString(nodes, _a) {
    var renderNode = _a.renderNode, renderMark = _a.renderMark, preserveWhitespace = _a.preserveWhitespace;
    return nodes.map(function(node) {
        return $e2ae5481ea3ab6f0$var$nodeToHtmlString(node, {
            renderNode: renderNode,
            renderMark: renderMark,
            preserveWhitespace: preserveWhitespace
        });
    }).join('');
}
function $e2ae5481ea3ab6f0$var$nodeToHtmlString(node, _a) {
    var renderNode = _a.renderNode, renderMark = _a.renderMark, preserveWhitespace = _a.preserveWhitespace;
    if ($e2ae5481ea3ab6f0$var$dist.helpers.isText(node)) {
        var nodeValue = $e2ae5481ea3ab6f0$var$escape(node.value);
        // If preserveWhitespace is true, handle line breaks and spaces.
        if (preserveWhitespace) nodeValue = nodeValue.replace(/\n/g, '<br/>').replace(/ {2,}/g, function(match) {
            return '&nbsp;'.repeat(match.length);
        });
        if (node.marks.length > 0) return node.marks.reduce(function(value, mark) {
            if (!renderMark[mark.type]) return value;
            return renderMark[mark.type](value);
        }, nodeValue);
        return nodeValue;
    } else {
        var nextNode = function(nodes) {
            return $e2ae5481ea3ab6f0$var$nodeListToHtmlString(nodes, {
                renderMark: renderMark,
                renderNode: renderNode,
                preserveWhitespace: preserveWhitespace
            });
        };
        if (!node.nodeType || !renderNode[node.nodeType]) // TODO: Figure what to return when passed an unrecognized node.
        return '';
        return renderNode[node.nodeType](node, nextNode);
    }
}
$e2ae5481ea3ab6f0$export$7baf571c7f59ce7c = $e2ae5481ea3ab6f0$var$documentToHtmlString;





const $ed7324a8fd290016$var$PassportsVisas = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        className: "content_h3",
                        children: "Passport & Visas"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((el, i)=>{
                if (!el || !el.fields) return;
                const { internalName: internalName, passportsvisas: passportsvisas, governmentWebsites: governmentWebsites, additionalInfo: additionalInfo } = el.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        internalName && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                            style: {
                                marginTop: 10,
                                marginBottom: 30
                            },
                            className: "content_h3",
                            children: internalName
                        }),
                        passportsvisas && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Required Documentation"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: passportsvisas.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        governmentWebsites && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginBottom: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                        children: "Government Resources:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                    className: "list-style",
                                    dangerouslySetInnerHTML: {
                                        __html: (0, $e2ae5481ea3ab6f0$export$7baf571c7f59ce7c)(governmentWebsites)
                                    }
                                })
                            ]
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $ed7324a8fd290016$export$2e2bcd8739ae039 = $ed7324a8fd290016$var$PassportsVisas;


const $fc1b7e1c69c74761$var$EntryRequirements = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((requirement, i)=>{
                if (!requirement || !requirement.fields) return;
                const { medicalInformation: medicalInformation, passportsVisas: passportsVisas, additionalInfo: additionalInfo, passportVisasDisclaimer: passportVisasDisclaimer } = requirement.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        passportVisasDisclaimer && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            id: "passportVisasDisclaimer",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Passport & Visas Disclaimer"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: passportVisasDisclaimer
                                })
                            ]
                        }),
                        passportsVisas && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $ed7324a8fd290016$export$2e2bcd8739ae039), {
                            data: passportsVisas,
                            slug: "passportsVisas"
                        }),
                        medicalInformation && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $57d6a9b3d6b7082b$export$2e2bcd8739ae039), {
                            data: medicalInformation,
                            slug: "medicalInformation"
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            title: "additionalInfo",
                            slug: "entryRequirementsadditionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $fc1b7e1c69c74761$export$2e2bcd8739ae039 = $fc1b7e1c69c74761$var$EntryRequirements;



















var $ccea77f5aa9cfa56$exports = {};
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    $ccea77f5aa9cfa56$exports = factory();
})($ccea77f5aa9cfa56$exports, function() {
    'use strict';
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== 'undefined' && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: 'text/javascript'
            }));
        }
    }
    define([
        "exports"
    ], function(e1) {
        "use strict";
        var t = "undefined" != typeof self ? self : {}, i = "3.1.2";
        let r;
        const n = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                if (null == r) {
                    const e1 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                    try {
                        r = e1;
                    } catch (t) {
                        r = e1;
                    }
                }
                return r;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                if (!n.API_URL) return null;
                try {
                    const e1 = new URL(n.API_URL);
                    return "api.mapbox.cn" === e1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === e1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (e1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
        }, o = {
            supported: !1,
            testSupport: function(e1) {
                !l && a && (c ? h(e1) : s = e1);
            }
        };
        let s, a, l = !1, c = !1;
        function h(e1) {
            const t = e1.createTexture();
            e1.bindTexture(e1.TEXTURE_2D, t);
            try {
                if (e1.texImage2D(e1.TEXTURE_2D, 0, e1.RGBA, e1.RGBA, e1.UNSIGNED_BYTE, a), e1.isContextLost()) return;
                o.supported = !0;
            } catch (e1) {}
            e1.deleteTexture(t), l = !0;
        }
        t.document && (a = t.document.createElement("img"), a.onload = function() {
            s && h(s), s = null, c = !0;
        }, a.onerror = function() {
            l = !0, s = null;
        }, a.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const u = "01";
        function d(e1) {
            return e1 && e1.__esModule && Object.prototype.hasOwnProperty.call(e1, "default") ? e1.default : e1;
        }
        var p = f;
        function f(e1, t, i, r) {
            this.cx = 3 * e1, this.bx = 3 * (i - e1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * t, this.by = 3 * (r - t) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = e1, this.p1y = t, this.p2x = i, this.p2y = r;
        }
        f.prototype = {
            sampleCurveX: function(e1) {
                return ((this.ax * e1 + this.bx) * e1 + this.cx) * e1;
            },
            sampleCurveY: function(e1) {
                return ((this.ay * e1 + this.by) * e1 + this.cy) * e1;
            },
            sampleCurveDerivativeX: function(e1) {
                return (3 * this.ax * e1 + 2 * this.bx) * e1 + this.cx;
            },
            solveCurveX: function(e1, t) {
                if (void 0 === t && (t = 1e-6), e1 < 0) return 0;
                if (e1 > 1) return 1;
                for(var i = e1, r = 0; r < 8; r++){
                    var n = this.sampleCurveX(i) - e1;
                    if (Math.abs(n) < t) return i;
                    var o = this.sampleCurveDerivativeX(i);
                    if (Math.abs(o) < 1e-6) break;
                    i -= n / o;
                }
                var s = 0, a = 1;
                for(i = e1, r = 0; r < 20 && (n = this.sampleCurveX(i), !(Math.abs(n - e1) < t)); r++)e1 > n ? s = i : a = i, i = .5 * (a - s) + s;
                return i;
            },
            solve: function(e1, t) {
                return this.sampleCurveY(this.solveCurveX(e1, t));
            }
        };
        var m = d(p), _ = g;
        function g(e1, t) {
            this.x = e1, this.y = t;
        }
        g.prototype = {
            clone: function() {
                return new g(this.x, this.y);
            },
            add: function(e1) {
                return this.clone()._add(e1);
            },
            sub: function(e1) {
                return this.clone()._sub(e1);
            },
            multByPoint: function(e1) {
                return this.clone()._multByPoint(e1);
            },
            divByPoint: function(e1) {
                return this.clone()._divByPoint(e1);
            },
            mult: function(e1) {
                return this.clone()._mult(e1);
            },
            div: function(e1) {
                return this.clone()._div(e1);
            },
            rotate: function(e1) {
                return this.clone()._rotate(e1);
            },
            rotateAround: function(e1, t) {
                return this.clone()._rotateAround(e1, t);
            },
            matMult: function(e1) {
                return this.clone()._matMult(e1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(e1) {
                return this.x === e1.x && this.y === e1.y;
            },
            dist: function(e1) {
                return Math.sqrt(this.distSqr(e1));
            },
            distSqr: function(e1) {
                var t = e1.x - this.x, i = e1.y - this.y;
                return t * t + i * i;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(e1) {
                return Math.atan2(this.y - e1.y, this.x - e1.x);
            },
            angleWith: function(e1) {
                return this.angleWithSep(e1.x, e1.y);
            },
            angleWithSep: function(e1, t) {
                return Math.atan2(this.x * t - this.y * e1, this.x * e1 + this.y * t);
            },
            _matMult: function(e1) {
                var t = e1[2] * this.x + e1[3] * this.y;
                return this.x = e1[0] * this.x + e1[1] * this.y, this.y = t, this;
            },
            _add: function(e1) {
                return this.x += e1.x, this.y += e1.y, this;
            },
            _sub: function(e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            },
            _mult: function(e1) {
                return this.x *= e1, this.y *= e1, this;
            },
            _div: function(e1) {
                return this.x /= e1, this.y /= e1, this;
            },
            _multByPoint: function(e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            },
            _divByPoint: function(e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var e1 = this.y;
                return this.y = this.x, this.x = -e1, this;
            },
            _rotate: function(e1) {
                var t = Math.cos(e1), i = Math.sin(e1), r = i * this.x + t * this.y;
                return this.x = t * this.x - i * this.y, this.y = r, this;
            },
            _rotateAround: function(e1, t) {
                var i = Math.cos(e1), r = Math.sin(e1), n = t.y + r * (this.x - t.x) + i * (this.y - t.y);
                return this.x = t.x + i * (this.x - t.x) - r * (this.y - t.y), this.y = n, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, g.convert = function(e1) {
            return e1 instanceof g ? e1 : Array.isArray(e1) ? new g(e1[0], e1[1]) : e1;
        };
        var y = d(_);
        function x(e1, t) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(t) || e1.length !== t.length) return !1;
                for(let i = 0; i < e1.length; i++)if (!x(e1[i], t[i])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== t) {
                if ("object" != typeof t) return !1;
                if (Object.keys(e1).length !== Object.keys(t).length) return !1;
                for(const i in e1)if (!x(e1[i], t[i])) return !1;
                return !0;
            }
            return e1 === t;
        }
        const v = Math.PI / 180, b = 180 / Math.PI;
        function w(e1) {
            return e1 * v;
        }
        function T(e1) {
            return e1 * b;
        }
        const E = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function M(e1) {
            if (e1 <= 0) return 0;
            if (e1 >= 1) return 1;
            const t = e1 * e1, i = t * e1;
            return 4 * (e1 < .5 ? i : 3 * (e1 - t) + i - .75);
        }
        function A(e1) {
            let t = 1 / 0, i = 1 / 0, r = -1 / 0, n = -1 / 0;
            for (const o of e1)t = Math.min(t, o.x), i = Math.min(i, o.y), r = Math.max(r, o.x), n = Math.max(n, o.y);
            return {
                min: new y(t, i),
                max: new y(r, n)
            };
        }
        function S(e1, t, i = 0, r = !0) {
            const n = new y(i, i), o = e1.sub(n), s = t.add(n), a = [
                o,
                new y(s.x, o.y),
                s,
                new y(o.x, s.y)
            ];
            return r && a.push(o.clone()), a;
        }
        function I(e1, t, i, r) {
            const n = new m(e1, t, i, r);
            return function(e1) {
                return n.solve(e1);
            };
        }
        const C = I(.25, .1, .25, 1);
        function z(e1, t, i) {
            return Math.min(i, Math.max(t, e1));
        }
        function P(e1, t, i) {
            return (i = z((i - e1) / (t - e1), 0, 1)) * i * (3 - 2 * i);
        }
        function D(e1, t, i) {
            const r = i - t, n = ((e1 - t) % r + r) % r + t;
            return n === t ? i : n;
        }
        function R(e1, t, i) {
            if (!e1.length) return i(null, []);
            let r = e1.length;
            const n = new Array(e1.length);
            let o = null;
            e1.forEach((e1, s)=>{
                t(e1, (e1, t)=>{
                    e1 && (o = e1), n[s] = t, 0 == --r && i(o, n);
                });
            });
        }
        function L(e1) {
            const t = [];
            for(const i in e1)t.push(e1[i]);
            return t;
        }
        function k(e1, ...t) {
            for (const i of t)for(const t in i)e1[t] = i[t];
            return e1;
        }
        function O(e1, t) {
            const i = {};
            for(let r = 0; r < t.length; r++){
                const n = t[r];
                n in e1 && (i[n] = e1[n]);
            }
            return i;
        }
        let B = 1;
        function F() {
            return B++;
        }
        function N() {
            return function e1(t) {
                return t ? (t ^ Math.random() * (16 >> t / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, e1);
            }();
        }
        function U(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(e1) / Math.LN2));
        }
        function V(e1) {
            return !!e1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e1);
        }
        function j(e1, t) {
            e1.forEach((e1)=>{
                t[e1] && (t[e1] = t[e1].bind(t));
            });
        }
        function G(e1, t) {
            return -1 !== e1.indexOf(t, e1.length - t.length);
        }
        function q(e1, t, i) {
            const r = {};
            for(const n in e1)r[n] = t.call(i || this, e1[n], n, e1);
            return r;
        }
        function Z(e1, t, i) {
            const r = {};
            for(const n in e1)t.call(i || this, e1[n], n, e1) && (r[n] = e1[n]);
            return r;
        }
        function $(e1) {
            return Array.isArray(e1) ? e1.map($) : "object" == typeof e1 && e1 ? q(e1, $) : e1;
        }
        const W = {};
        function H(e1) {
            W[e1] || ("undefined" != typeof console && console.warn(e1), W[e1] = !0);
        }
        function X(e1, t, i) {
            return (i.y - e1.y) * (t.x - e1.x) > (t.y - e1.y) * (i.x - e1.x);
        }
        function Y(e1) {
            let t = 0;
            for(let i, r, n = 0, o = e1.length, s = o - 1; n < o; s = n++)i = e1[n], r = e1[s], t += (r.x - i.x) * (i.y + r.y);
            return t;
        }
        function K([e1, t, i]) {
            const r = w(t + 90), n = w(i);
            return {
                x: e1 * Math.cos(r) * Math.sin(n),
                y: e1 * Math.sin(r) * Math.sin(n),
                z: e1 * Math.cos(n),
                azimuthal: t,
                polar: i
            };
        }
        function J(e1, t, i) {
            const r = Math.sqrt(e1 * e1 + t * t + i * i), n = r > 0 ? Math.acos(i / r) * b : 0;
            let o = 0 !== e1 || 0 !== t ? Math.atan2(-t, -e1) * b + 90 : 0;
            return o < 0 && (o += 360), [
                r,
                o,
                n
            ];
        }
        function Q() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function ee(e1) {
            const t = {};
            if (e1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e1, i, r, n)=>{
                const o = r || n;
                return t[i] = !o || o.toLowerCase(), "";
            }), t["max-age"]) {
                const e1 = parseInt(t["max-age"], 10);
                isNaN(e1) ? delete t["max-age"] : t["max-age"] = e1;
            }
            return t;
        }
        let te = null;
        function ie() {
            return !!t.document.fullscreenElement || !!t.document.webkitFullscreenElement;
        }
        function re(e1) {
            try {
                const i = t[e1];
                return i.setItem("_mapbox_test_", 1), i.removeItem("_mapbox_test_"), !0;
            } catch (e1) {
                return !1;
            }
        }
        function ne(e1, t) {
            return [
                e1[4 * t],
                e1[4 * t + 1],
                e1[4 * t + 2],
                e1[4 * t + 3]
            ];
        }
        function oe(e1, t, i) {
            e1[4 * t + 0] = i[0], e1[4 * t + 1] = i[1], e1[4 * t + 2] = i[2], e1[4 * t + 3] = i[3];
        }
        function se(e1, t) {
            return [
                Math.pow(e1[0], 2.2) * t,
                Math.pow(e1[1], 2.2) * t,
                Math.pow(e1[2], 2.2) * t
            ];
        }
        function ae(e1) {
            return [
                Math.pow(e1[0], 1 / 2.2),
                Math.pow(e1[1], 1 / 2.2),
                Math.pow(e1[2], 1 / 2.2)
            ];
        }
        const le = "mapbox-tiles";
        let ce = 500, he = 50;
        let ue, de;
        function pe() {
            try {
                return t.caches;
            } catch (e1) {}
        }
        function fe() {
            pe() && !ue && (ue = t.caches.open(le));
        }
        function me(e1) {
            const t = e1.indexOf("?");
            if (t < 0) return e1;
            const i = function(e1) {
                const t = e1.indexOf("?");
                return t > 0 ? e1.slice(t + 1).split("&") : [];
            }(e1), r = i.filter((e1)=>{
                const t = e1.split("=");
                return "language" === t[0] || "worldview" === t[0];
            });
            return r.length ? `${e1.slice(0, t)}?${r.join("&")}` : e1.slice(0, t);
        }
        let _e = 1 / 0;
        function ge(e1) {
            _e++, _e > he && (e1.getActor().send("enforceCacheSizeLimit", ce), _e = 0);
        }
        const ye = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image",
            Model: "Model"
        };
        "function" == typeof Object.freeze && Object.freeze(ye);
        class xe extends Error {
            constructor(e1, t, i){
                401 === t && De(i) && (e1 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(e1), this.status = t, this.url = i;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        const ve = Q() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === t.location.protocol ? t.parent : t).location.href;
        const be = function(e1, i) {
            if (!(/^file:/.test(r = e1.url) || /^file:/.test(ve()) && !/^\w+:/.test(r))) {
                if (t.fetch && t.Request && t.AbortController && t.Request.prototype.hasOwnProperty("signal")) return function(e1, i) {
                    const r = new t.AbortController, n = new t.Request(e1.url, {
                        method: e1.method || "GET",
                        body: e1.body,
                        credentials: e1.credentials,
                        headers: e1.headers,
                        referrer: ve(),
                        referrerPolicy: e1.referrerPolicy,
                        signal: r.signal
                    });
                    let o = !1, s = !1;
                    const a = (l = n.url).indexOf("sku=") > 0 && De(l);
                    var l;
                    "json" === e1.type && n.headers.set("Accept", "application/json");
                    const c = (r, o, l)=>{
                        if (s) return;
                        if (r && "SecurityError" !== r.message && H(r.toString()), o && l) return h(o);
                        const c = Date.now();
                        t.fetch(n).then((t)=>{
                            if (t.ok) {
                                const e1 = a ? t.clone() : null;
                                return h(t, e1, c);
                            }
                            return i(new xe(t.statusText, t.status, e1.url));
                        }).catch((t)=>{
                            "AbortError" !== t.name && i(new Error(`${t.message} ${e1.url}`));
                        });
                    }, h = (r, a, l)=>{
                        ("arrayBuffer" === e1.type ? r.arrayBuffer() : "json" === e1.type ? r.json() : r.text()).then((e1)=>{
                            s || (a && l && function(e1, i, r) {
                                if (fe(), !ue) return;
                                const n = {
                                    status: i.status,
                                    statusText: i.statusText,
                                    headers: new t.Headers
                                };
                                i.headers.forEach((e1, t)=>n.headers.set(t, e1));
                                const o = ee(i.headers.get("Cache-Control") || "");
                                if (o["no-store"]) return;
                                o["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * o["max-age"]).toUTCString());
                                const s = n.headers.get("Expires");
                                s && (new Date(s).getTime() - r < 42e4 || function(e1, t) {
                                    if (void 0 === de) try {
                                        new Response(new ReadableStream), de = !0;
                                    } catch (e1) {
                                        de = !1;
                                    }
                                    de ? t(e1.body) : e1.blob().then(t);
                                }(i, (i)=>{
                                    const r = new t.Response(i, n);
                                    fe(), ue && ue.then((t)=>t.put(me(e1.url), r)).catch((e1)=>H(e1.message));
                                }));
                            }(n, a, l), o = !0, i(null, e1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch((e1)=>{
                            s || i(new Error(e1.message));
                        });
                    };
                    return a ? function(e1, t) {
                        if (fe(), !ue) return t(null);
                        const i = me(e1.url);
                        ue.then((e1)=>{
                            e1.match(i).then((r)=>{
                                const n = function(e1) {
                                    if (!e1) return !1;
                                    const t = new Date(e1.headers.get("Expires") || 0), i = ee(e1.headers.get("Cache-Control") || "");
                                    return t > Date.now() && !i["no-cache"];
                                }(r);
                                e1.delete(i), n && e1.put(i, r.clone()), t(null, r, n);
                            }).catch(t);
                        }).catch(t);
                    }(n, c) : c(null, null), {
                        cancel: ()=>{
                            s = !0, o || r.abort();
                        }
                    };
                }(e1, i);
                if (Q() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", e1, i, void 0, !0);
            }
            var r;
            return function(e1, i) {
                const r = new t.XMLHttpRequest;
                r.open(e1.method || "GET", e1.url, !0), "arrayBuffer" === e1.type && (r.responseType = "arraybuffer");
                for(const t in e1.headers)r.setRequestHeader(t, e1.headers[t]);
                return "json" === e1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === e1.credentials, r.onerror = ()=>{
                    i(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let t = r.response;
                        if ("json" === e1.type) try {
                            t = JSON.parse(r.response);
                        } catch (e1) {
                            return i(e1);
                        }
                        i(null, t, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else i(new xe(r.statusText, r.status, e1.url));
                }, r.send(e1.body), {
                    cancel: ()=>r.abort()
                };
            }(e1, i);
        }, we = function(e1, t) {
            return be(k(e1, {
                type: "json"
            }), t);
        }, Te = function(e1, t) {
            return be(k(e1, {
                type: "arrayBuffer"
            }), t);
        };
        function Ee(e1) {
            const i = t.document.createElement("a");
            return i.href = e1, i.protocol === t.document.location.protocol && i.host === t.document.location.host;
        }
        const Me = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let Ae, Se;
        Ae = [], Se = 0;
        const Ie = function(e1, i) {
            if (o.supported && (e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*"), Se >= n.MAX_PARALLEL_IMAGE_REQUESTS) {
                const t = {
                    requestParameters: e1,
                    callback: i,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return Ae.push(t), t;
            }
            Se++;
            let r = !1;
            const s = ()=>{
                if (!r) for(r = !0, Se--; Ae.length && Se < n.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const e1 = Ae.shift(), { requestParameters: t, callback: i, cancelled: r } = e1;
                    r || (e1.cancel = Ie(t, i).cancel);
                }
            }, a = Te(e1, (e1, r, n, o)=>{
                s(), e1 ? i(e1) : r && (t.createImageBitmap ? function(e1, i) {
                    const r = new t.Blob([
                        new Uint8Array(e1)
                    ], {
                        type: "image/png"
                    });
                    t.createImageBitmap(r).then((e1)=>{
                        i(null, e1);
                    }).catch((e1)=>{
                        i(new Error(`Could not load image because of ${e1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(r, (e1, t)=>i(e1, t, n, o)) : function(e1, i) {
                    const r = new t.Image, n = t.URL;
                    r.onload = ()=>{
                        i(null, r), n.revokeObjectURL(r.src), r.onload = null, t.requestAnimationFrame(()=>{
                            r.src = Me;
                        });
                    }, r.onerror = ()=>i(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    const o = new t.Blob([
                        new Uint8Array(e1)
                    ], {
                        type: "image/png"
                    });
                    r.src = e1.byteLength ? n.createObjectURL(o) : Me;
                }(r, (e1, t)=>i(e1, t, n, o)));
            });
            return {
                cancel: ()=>{
                    a.cancel(), s();
                }
            };
        }, Ce = "NO_ACCESS_TOKEN";
        class ze {
            constructor(e1, t, i){
                this._transformRequestFn = e1, this._customAccessToken = t, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
            _createSkuToken() {
                const e1 = function() {
                    let e1 = "";
                    for(let t = 0; t < 10; t++)e1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            u,
                            e1
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e1.token, this._skuTokenExpiresAt = e1.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e1, t) {
                return this._transformRequestFn && this._transformRequestFn(e1, t) || {
                    url: e1
                };
            }
            normalizeStyleURL(e1, t) {
                if (!Pe(e1)) return e1;
                const r = Be(e1);
                return r.params.push(`sdk=js-${i}`), r.path = `/styles/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || t);
            }
            normalizeGlyphsURL(e1, t) {
                if (!Pe(e1)) return e1;
                const i = Be(e1);
                return i.path = `/fonts/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t);
            }
            normalizeModelURL(e1, t) {
                if (!Pe(e1)) return e1;
                const i = Be(e1);
                return i.path = `/models/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t);
            }
            normalizeSourceURL(e1, t, i, r) {
                if (!Pe(e1)) return e1;
                const n = Be(e1);
                return n.path = `/v4/${n.authority}.json`, n.params.push("secure"), i && n.params.push(`language=${i}`), r && n.params.push(`worldview=${r}`), this._makeAPIURL(n, this._customAccessToken || t);
            }
            normalizeSpriteURL(e1, t, i, r) {
                const n = Be(e1);
                return Pe(e1) ? (n.path = `/styles/v1${n.path}/sprite${t}${i}`, this._makeAPIURL(n, this._customAccessToken || r)) : (n.path += `${t}${i}`, Fe(n));
            }
            normalizeTileURL(e1, t, i) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), e1 && !Pe(e1)) return e1;
                const r = Be(e1);
                r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${t || i && "raster" !== r.authority && 512 === i ? "@2x" : ""}${o.supported ? ".webp" : "$1"}`), "raster" === r.authority ? r.path = `/${n.RASTER_URL_PREFIX}${r.path}` : (r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = `/${n.TILE_URL_VERSION}${r.path}`);
                const s = this._customAccessToken || function(e1) {
                    for (const t of e1){
                        const e1 = t.match(/^access_token=(.*)$/);
                        if (e1) return e1[1];
                    }
                    return null;
                }(r.params) || n.ACCESS_TOKEN;
                return n.REQUIRE_ACCESS_TOKEN && s && this._skuToken && r.params.push(`sku=${this._skuToken}`), this._makeAPIURL(r, s);
            }
            canonicalizeTileURL(e1, t) {
                const i = Be(e1);
                if (!i.path.match(/^(\/v4\/|\/raster\/v1\/)/) || !i.path.match(/\.[\w]+$/)) return e1;
                let r = "mapbox://";
                i.path.match(/^\/raster\/v1\//) ? r += `raster/${i.path.replace(`/${n.RASTER_URL_PREFIX}/`, "")}` : r += `tiles/${i.path.replace(`/${n.TILE_URL_VERSION}/`, "")}`;
                let o = i.params;
                return t && (o = o.filter((e1)=>!e1.match(/^access_token=/))), o.length && (r += `?${o.join("&")}`), r;
            }
            canonicalizeTileset(e1, t) {
                const i = !!t && Pe(t), r = [];
                for (const t of e1.tiles || [])De(t) ? r.push(this.canonicalizeTileURL(t, i)) : r.push(t);
                return r;
            }
            _makeAPIURL(e1, t) {
                const i = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", r = Be(n.API_URL);
                if (e1.protocol = r.protocol, e1.authority = r.authority, "http" === e1.protocol) {
                    const t = e1.params.indexOf("secure");
                    t >= 0 && e1.params.splice(t, 1);
                }
                if ("/" !== r.path && (e1.path = `${r.path}${e1.path}`), !n.REQUIRE_ACCESS_TOKEN) return Fe(e1);
                if (t = t || n.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!t) throw new Error(`An API access token is required to use Mapbox GL. ${i}`);
                    if ("s" === t[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${i}`);
                }
                return e1.params = e1.params.filter((e1)=>-1 === e1.indexOf("access_token")), e1.params.push(`access_token=${t || ""}`), Fe(e1);
            }
        }
        function Pe(e1) {
            return 0 === e1.indexOf("mapbox:");
        }
        function De(e1) {
            return n.API_URL_REGEX.test(e1);
        }
        function Re(e1) {
            return n.API_CDN_URL_REGEX.test(e1);
        }
        function Le(e1) {
            return n.API_STYLE_REGEX.test(e1) && !ke(e1);
        }
        function ke(e1) {
            return n.API_SPRITE_REGEX.test(e1);
        }
        const Oe = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function Be(e1) {
            const t = e1.match(Oe);
            if (!t) throw new Error("Unable to parse URL object");
            return {
                protocol: t[1],
                authority: t[2],
                path: t[3] || "/",
                params: t[4] ? t[4].split("&") : []
            };
        }
        function Fe(e1) {
            const t = e1.params.length ? `?${e1.params.join("&")}` : "";
            return `${e1.protocol}://${e1.authority}${e1.path}${t}`;
        }
        const Ne = "mapbox.eventData";
        function Ue(e1) {
            if (!e1) return null;
            const i = e1.split(".");
            if (!i || 3 !== i.length) return null;
            try {
                return JSON.parse(decodeURIComponent(t.atob(i[1]).split("").map((e1)=>"%" + ("00" + e1.charCodeAt(0).toString(16)).slice(-2)).join("")));
            } catch (e1) {
                return null;
            }
        }
        class Ve {
            constructor(e1){
                this.type = e1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
            getStorageKey(e1) {
                const i = Ue(n.ACCESS_TOKEN);
                let r = "";
                return r = i && i.u ? t.btoa(encodeURIComponent(i.u).replace(/%([0-9A-F]{2})/g, (e1, t)=>String.fromCharCode(Number("0x" + t)))) : n.ACCESS_TOKEN || "", e1 ? `${Ne}.${e1}:${r}` : `${Ne}:${r}`;
            }
            fetchEventData() {
                const e1 = re("localStorage"), i = this.getStorageKey(), r = this.getStorageKey("uuid");
                if (e1) try {
                    const e1 = t.localStorage.getItem(i);
                    e1 && (this.eventData = JSON.parse(e1));
                    const n = t.localStorage.getItem(r);
                    n && (this.anonId = n);
                } catch (e1) {
                    H("Unable to read from LocalStorage");
                }
            }
            saveEventData() {
                const e1 = re("localStorage"), i = this.getStorageKey(), r = this.getStorageKey("uuid");
                if (e1) try {
                    t.localStorage.setItem(r, this.anonId), Object.keys(this.eventData).length >= 1 && t.localStorage.setItem(i, JSON.stringify(this.eventData));
                } catch (e1) {
                    H("Unable to write to LocalStorage");
                }
            }
            processRequests(e1) {}
            postEvent(e1, t, i, r) {
                if (!n.EVENTS_URL) return;
                const o = Be(n.EVENTS_URL);
                o.params.push(`access_token=${r || n.ACCESS_TOKEN || ""}`);
                const s = {
                    event: this.type,
                    created: new Date(e1).toISOString()
                }, a = t ? k(s, t) : s, l = {
                    url: Fe(o),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = function(e1, t) {
                    return be(k(e1, {
                        method: "POST"
                    }), t);
                }(l, (e1)=>{
                    this.pendingRequest = null, i(e1), this.saveEventData(), this.processRequests(r);
                });
            }
            queueRequest(e1, t) {
                this.queue.push(e1), this.processRequests(t);
            }
        }
        const je = new class extends Ve {
            constructor(e1){
                super("appUserTurnstile"), this._customAccessToken = e1;
            }
            postTurnstileEvent(e1, t) {
                n.EVENTS_URL && n.ACCESS_TOKEN && Array.isArray(e1) && e1.some((e1)=>Pe(e1) || De(e1)) && this.queueRequest(Date.now(), t);
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const t = Ue(n.ACCESS_TOKEN), r = t ? t.u : n.ACCESS_TOKEN;
                let o = r !== this.eventData.tokenU;
                V(this.anonId) || (this.anonId = N(), o = !0);
                const s = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e1 = new Date(this.eventData.lastSuccess), t = new Date(s), i = (s - this.eventData.lastSuccess) / 864e5;
                    o = o || i >= 1 || i < -1 || e1.getDate() !== t.getDate();
                } else o = !0;
                o ? this.postEvent(s, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: u,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (e1)=>{
                    e1 || (this.eventData.lastSuccess = s, this.eventData.tokenU = r);
                }, e1) : this.processRequests();
            }
        }, Ge = je.postTurnstileEvent.bind(je), qe = new class extends Ve {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(e1, t, i, r) {
                this.skuToken = t, this.errorCb = r, n.EVENTS_URL && (i || n.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Ce)));
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t, timestamp: r } = this.queue.shift();
                t && this.success[t] || (this.anonId || this.fetchEventData(), V(this.anonId) || (this.anonId = N()), this.postEvent(r, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: u,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (e1)=>{
                    e1 ? this.errorCb(e1) : t && (this.success[t] = !0);
                }, e1));
            }
        }, Ze = qe.postMapLoadEvent.bind(qe), $e = new class extends Ve {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(e1, t) {
                n.EVENTS_URL && (e1 || n.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: t
                }, e1);
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: r, performanceData: n } = this.queue.shift(), o = function(e1) {
                    const r = t.performance.getEntriesByType("resource"), n = t.performance.getEntriesByType("mark"), o = function(e1) {
                        const t = {};
                        if (e1) {
                            for(const i in e1)if ("other" !== i) for (const r of e1[i]){
                                const e1 = `${i}ResolveRangeMin`, n = `${i}ResolveRangeMax`, o = `${i}RequestCount`, s = `${i}RequestCachedCount`;
                                t[e1] = Math.min(t[e1] || 1 / 0, r.startTime), t[n] = Math.max(t[n] || -1 / 0, r.responseEnd);
                                const a = (e1)=>{
                                    void 0 === t[e1] && (t[e1] = 0), ++t[e1];
                                };
                                void 0 !== r.transferSize && 0 === r.transferSize && a(s), a(o);
                            }
                        }
                        return t;
                    }(function(e1, t) {
                        const i = {};
                        if (e1) for (const r of e1){
                            const e1 = t(r);
                            void 0 === i[e1] && (i[e1] = []), i[e1].push(r);
                        }
                        return i;
                    }(r, et)), s = t.devicePixelRatio, a = t.navigator.connection || t.navigator.mozConnection || t.navigator.webkitConnection, l = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, c = (e1, t, i)=>{
                        null != i && e1.push({
                            name: t,
                            value: i.toString()
                        });
                    };
                    for(const e1 in o)c(l.counters, e1, o[e1]);
                    if (e1.interactionRange[0] !== 1 / 0 && e1.interactionRange[1] !== -1 / 0 && (c(l.counters, "interactionRangeMin", e1.interactionRange[0]), c(l.counters, "interactionRangeMax", e1.interactionRange[1])), n) for (const e1 of Object.keys(Je)){
                        const t = Je[e1], i = n.find((e1)=>e1.name === t);
                        i && c(l.counters, t, i.startTime);
                    }
                    return c(l.counters, "visibilityHidden", e1.visibilityHidden), c(l.attributes, "style", function(e1) {
                        if (e1) for (const t of e1){
                            const e1 = t.name.split("?")[0];
                            if (Le(e1)) {
                                const t = e1.split("/").slice(-2);
                                if (2 === t.length) return `mapbox://styles/${t[0]}/${t[1]}`;
                            }
                        }
                    }(r)), c(l.attributes, "terrainEnabled", e1.terrainEnabled ? "true" : "false"), c(l.attributes, "fogEnabled", e1.fogEnabled ? "true" : "false"), c(l.attributes, "projection", e1.projection), c(l.attributes, "zoom", e1.zoom), c(l.metadata, "devicePixelRatio", s), c(l.metadata, "connectionEffectiveType", a ? a.effectiveType : void 0), c(l.metadata, "navigatorUserAgent", t.navigator.userAgent), c(l.metadata, "screenWidth", t.screen.width), c(l.metadata, "screenHeight", t.screen.height), c(l.metadata, "windowWidth", t.innerWidth), c(l.metadata, "windowHeight", t.innerHeight), c(l.metadata, "mapWidth", e1.width / s), c(l.metadata, "mapHeight", e1.height / s), c(l.metadata, "webglRenderer", e1.renderer), c(l.metadata, "webglVendor", e1.vendor), c(l.metadata, "sdkVersion", i), c(l.metadata, "sdkIdentifier", "mapbox-gl-js"), l;
                }(n);
                for (const e1 of o.metadata);
                for (const e1 of o.counters);
                for (const e1 of o.attributes);
                this.postEvent(r, o, ()=>{}, e1);
            }
        }, We = $e.postPerformanceEvent.bind($e), He = new class extends Ve {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(e1, t, i, r) {
                if (!n.API_URL || !n.SESSION_PATH) return;
                const o = Be(n.API_URL + n.SESSION_PATH);
                o.params.push(`sku=${t || ""}`), o.params.push(`access_token=${r || n.ACCESS_TOKEN || ""}`);
                const s = {
                    url: Fe(o),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = function(e1, t) {
                    return be(k(e1, {
                        method: "GET"
                    }), t);
                }(s, (e1)=>{
                    this.pendingRequest = null, i(e1), this.saveEventData(), this.processRequests(r);
                });
            }
            getSessionAPI(e1, t, i, r) {
                this.skuToken = t, this.errorCb = r, n.SESSION_PATH && n.API_URL && (i || n.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Ce)));
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t, timestamp: i } = this.queue.shift();
                t && this.success[t] || this.getSession(i, this.skuToken, (e1)=>{
                    e1 ? this.errorCb(e1) : t && (this.success[t] = !0);
                }, e1);
            }
        }, Xe = He.getSessionAPI.bind(He), Ye = new Set;
        function Ke(e1, t) {
            t ? Ye.add(e1) : Ye.delete(e1);
        }
        const Je = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, Qe = {
            mark (e1) {
                t.performance.mark(e1);
            },
            measure (e1, i, r) {
                t.performance.measure(e1, i, r);
            }
        };
        function et(e1) {
            const t = e1.name.split("?")[0];
            return Re(t) && t.includes("mapbox-gl.js") ? "javascript" : Re(t) && t.includes("mapbox-gl.css") ? "css" : function(e1) {
                return n.API_FONTS_REGEX.test(e1);
            }(t) ? "fontRange" : ke(t) ? "sprite" : Le(t) ? "style" : function(e1) {
                return n.API_TILEJSON_REGEX.test(e1);
            }(t) ? "tilejson" : "other";
        }
        const tt = t.performance;
        function it(e1) {
            const t = e1 ? e1.url.toString() : void 0;
            return tt.getEntriesByName(t);
        }
        var rt = nt;
        function nt(e1) {
            return !function(e1) {
                var t;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e1, t, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), r = URL.createObjectURL(i);
                    try {
                        t = new Worker(r), e1 = !0;
                    } catch (t) {
                        e1 = !1;
                    }
                    return t && t.terminate(), URL.revokeObjectURL(r), e1;
                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                    var e1 = document.createElement("canvas");
                    e1.width = e1.height = 1;
                    var t = e1.getContext("2d");
                    if (!t) return !1;
                    var i = t.getImageData(0, 0, 1, 1);
                    return i && i.width === e1.width;
                }() ? (void 0 === ot[t = e1 && e1.failIfMajorPerformanceCaveat] && (ot[t] = function(e1) {
                    var t, i = function(e1) {
                        var t = document.createElement("canvas"), i = Object.create(nt.webGLContextAttributes);
                        return i.failIfMajorPerformanceCaveat = e1, t.getContext("webgl", i) || t.getContext("experimental-webgl", i);
                    }(e1);
                    if (!i) return !1;
                    try {
                        t = i.createShader(i.VERTEX_SHADER);
                    } catch (e1) {
                        return !1;
                    }
                    return !(!t || i.isContextLost()) && (i.shaderSource(t, "void main() {}"), i.compileShader(t), !0 === i.getShaderParameter(t, i.COMPILE_STATUS));
                }(t)), ot[t] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }(e1);
        }
        var ot = {};
        let st, at, lt, ct, ht;
        function ut() {
            return null == st && (st = t.OffscreenCanvas && new t.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof t.createImageBitmap), st;
        }
        nt.webGLContextAttributes = {
            antialias: !1,
            alpha: !0,
            stencil: !0,
            depth: !0
        };
        const dt = {
            now: ()=>void 0 !== ct ? ct : t.performance.now(),
            setNow (e1) {
                ct = e1;
            },
            restoreNow () {
                ct = void 0;
            },
            frame (e1) {
                const i = t.requestAnimationFrame(e1);
                return {
                    cancel: ()=>t.cancelAnimationFrame(i)
                };
            },
            getImageData (e1, i = 0) {
                const { width: r, height: n } = e1;
                ht || (ht = t.document.createElement("canvas"));
                const o = ht.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!o) throw new Error("failed to create canvas 2d context");
                return (r > ht.width || n > ht.height) && (ht.width = r, ht.height = n), o.clearRect(-i, -i, r + 2 * i, n + 2 * i), o.drawImage(e1, 0, 0, r, n), o.getImageData(-i, -i, r + 2 * i, n + 2 * i);
            },
            resolveURL: (e1)=>(at || (at = t.document.createElement("a")), at.href = e1, at.href),
            get devicePixelRatio () {
                return t.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!t.matchMedia && (null == lt && (lt = t.matchMedia("(prefers-reduced-motion: reduce)")), lt.matches);
            },
            hasCanvasFingerprintNoise () {
                if (!ut()) return !1;
                const e1 = new t.OffscreenCanvas(85, 1), i = e1.getContext("2d", {
                    willReadFrequently: !0
                });
                let r = 0;
                for(let t = 0; t < e1.width; ++t)i.fillStyle = `rgba(${r++},${r++},${r++}, 255)`, i.fillRect(t, 0, 1, 1);
                const n = i.getImageData(0, 0, e1.width, e1.height);
                r = 0;
                for(let e1 = 0; e1 < n.data.length; ++e1)if (e1 % 4 != 3 && r++ !== n.data[e1]) return !0;
                return !1;
            }
        };
        function pt(e1, i, r) {
            const n = t.document.createElement(e1);
            return void 0 !== i && (n.className = i), r && r.appendChild(n), n;
        }
        function ft(e1, i, r) {
            const n = t.document.createElementNS("http://www.w3.org/2000/svg", e1);
            for (const e1 of Object.keys(i))n.setAttributeNS(null, e1, i[e1]);
            return r && r.appendChild(n), n;
        }
        const mt = t.document && t.document.documentElement.style, _t = mt && void 0 !== mt.userSelect ? "userSelect" : "WebkitUserSelect";
        let gt;
        function yt() {
            mt && _t && (gt = mt[_t], mt[_t] = "none");
        }
        function xt() {
            mt && _t && (mt[_t] = gt);
        }
        function vt(e1) {
            e1.preventDefault(), e1.stopPropagation(), t.removeEventListener("click", vt, !0);
        }
        function bt() {
            t.addEventListener("click", vt, !0), t.setTimeout(()=>{
                t.removeEventListener("click", vt, !0);
            }, 0);
        }
        function wt(e1, t) {
            const i = e1.getBoundingClientRect();
            return Mt(e1, i, t);
        }
        function Tt(e1, t) {
            const i = e1.getBoundingClientRect(), r = [];
            for(let n = 0; n < t.length; n++)r.push(Mt(e1, i, t[n]));
            return r;
        }
        function Et(e1) {
            return void 0 !== t.InstallTrigger && 2 === e1.button && e1.ctrlKey && t.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e1.button;
        }
        function Mt(e1, t, i) {
            const r = e1.offsetWidth === t.width ? 1 : e1.offsetWidth / t.width;
            return new y((i.clientX - t.left) * r, (i.clientY - t.top) * r);
        }
        function At(e1, t, i) {
            i[e1] && -1 !== i[e1].indexOf(t) || (i[e1] = i[e1] || [], i[e1].push(t));
        }
        function St(e1, t, i) {
            if (i && i[e1]) {
                const r = i[e1].indexOf(t);
                -1 !== r && i[e1].splice(r, 1);
            }
        }
        class It {
            constructor(e1, t = {}){
                k(this, t), this.type = e1;
            }
        }
        class Ct extends It {
            constructor(e1, t = {}){
                super("error", k({
                    error: e1
                }, t));
            }
        }
        class zt {
            on(e1, t) {
                return this._listeners = this._listeners || {}, At(e1, t, this._listeners), this;
            }
            off(e1, t) {
                return St(e1, t, this._listeners), St(e1, t, this._oneTimeListeners), this;
            }
            once(e1, t) {
                return t ? (this._oneTimeListeners = this._oneTimeListeners || {}, At(e1, t, this._oneTimeListeners), this) : new Promise((t)=>this.once(e1, t));
            }
            fire(e1, t) {
                "string" == typeof e1 && (e1 = new It(e1, t || {}));
                const i = e1.type;
                if (this.listens(i)) {
                    e1.target = this;
                    const t = this._listeners && this._listeners[i] ? this._listeners[i].slice() : [];
                    for (const i of t)i.call(this, e1);
                    const r = this._oneTimeListeners && this._oneTimeListeners[i] ? this._oneTimeListeners[i].slice() : [];
                    for (const t of r)St(i, t, this._oneTimeListeners), t.call(this, e1);
                    const n = this._eventedParent;
                    n && (k(e1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), n.fire(e1));
                } else e1 instanceof Ct && console.error(e1.error);
                return this;
            }
            listens(e1) {
                return !!(this._listeners && this._listeners[e1] && this._listeners[e1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[e1] && this._oneTimeListeners[e1].length > 0 || this._eventedParent && this._eventedParent.listens(e1));
            }
            setEventedParent(e1, t) {
                return this._eventedParent = e1, this._eventedParentData = t, this;
            }
        }
        var Pt = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"camera":{"type":"camera"},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"expression":{},"property-type":"data-constant"},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","default":[0,1],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"expression":{},"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"expression":{},"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
        class Dt {
            constructor(e1, t, i, r){
                this.message = (e1 ? `${e1}: ` : "") + i, r && (this.identifier = r), null != t && t.__line__ && (this.line = t.__line__);
            }
        }
        class Rt extends Dt {
        }
        function Lt(e1, ...t) {
            for (const i of t)for(const t in i)e1[t] = i[t];
            return e1;
        }
        function kt(e1) {
            return e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean ? e1.valueOf() : e1;
        }
        function Ot(e1) {
            if (Array.isArray(e1)) return e1.map(Ot);
            if (e1 instanceof Object && !(e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean)) {
                const t = {};
                for(const i in e1)t[i] = Ot(e1[i]);
                return t;
            }
            return kt(e1);
        }
        class Bt extends Error {
            constructor(e1, t){
                super(t), this.message = t, this.key = e1;
            }
        }
        var Ft = Bt;
        class Nt {
            constructor(e1, t = []){
                this.parent = e1, this.bindings = {};
                for (const [e1, i] of t)this.bindings[e1] = i;
            }
            concat(e1) {
                return new Nt(this, e1);
            }
            get(e1) {
                if (this.bindings[e1]) return this.bindings[e1];
                if (this.parent) return this.parent.get(e1);
                throw new Error(`${e1} not found in scope.`);
            }
            has(e1) {
                return !!this.bindings[e1] || !!this.parent && this.parent.has(e1);
            }
        }
        var Ut = Nt;
        const Vt = {
            kind: "null"
        }, jt = {
            kind: "number"
        }, Gt = {
            kind: "string"
        }, qt = {
            kind: "boolean"
        }, Zt = {
            kind: "color"
        }, $t = {
            kind: "object"
        }, Wt = {
            kind: "value"
        }, Ht = {
            kind: "collator"
        }, Xt = {
            kind: "formatted"
        }, Yt = {
            kind: "resolvedImage"
        };
        function Kt(e1, t) {
            return {
                kind: "array",
                itemType: e1,
                N: t
            };
        }
        function Jt(e1) {
            if ("array" === e1.kind) {
                const t = Jt(e1.itemType);
                return "number" == typeof e1.N ? `array<${t}, ${e1.N}>` : "value" === e1.itemType.kind ? "array" : `array<${t}>`;
            }
            return e1.kind;
        }
        const Qt = [
            Vt,
            jt,
            Gt,
            qt,
            Zt,
            Xt,
            $t,
            Kt(Wt),
            Yt
        ];
        function ei(e1, t) {
            if ("error" === t.kind) return null;
            if ("array" === e1.kind) {
                if ("array" === t.kind && (0 === t.N && "value" === t.itemType.kind || !ei(e1.itemType, t.itemType)) && ("number" != typeof e1.N || e1.N === t.N)) return null;
            } else {
                if (e1.kind === t.kind) return null;
                if ("value" === e1.kind) {
                    for (const e1 of Qt)if (!ei(e1, t)) return null;
                }
            }
            return `Expected ${Jt(e1)} but found ${Jt(t)} instead.`;
        }
        function ti(e1, t) {
            return t.some((t)=>t.kind === e1.kind);
        }
        function ii(e1, t) {
            return t.some((t)=>"null" === t ? null === e1 : "array" === t ? Array.isArray(e1) : "object" === t ? e1 && !Array.isArray(e1) && "object" == typeof e1 : t === typeof e1);
        }
        var ri, ni = {
            transparent: [
                0,
                0,
                0,
                0
            ],
            aliceblue: [
                240,
                248,
                255,
                1
            ],
            antiquewhite: [
                250,
                235,
                215,
                1
            ],
            aqua: [
                0,
                255,
                255,
                1
            ],
            aquamarine: [
                127,
                255,
                212,
                1
            ],
            azure: [
                240,
                255,
                255,
                1
            ],
            beige: [
                245,
                245,
                220,
                1
            ],
            bisque: [
                255,
                228,
                196,
                1
            ],
            black: [
                0,
                0,
                0,
                1
            ],
            blanchedalmond: [
                255,
                235,
                205,
                1
            ],
            blue: [
                0,
                0,
                255,
                1
            ],
            blueviolet: [
                138,
                43,
                226,
                1
            ],
            brown: [
                165,
                42,
                42,
                1
            ],
            burlywood: [
                222,
                184,
                135,
                1
            ],
            cadetblue: [
                95,
                158,
                160,
                1
            ],
            chartreuse: [
                127,
                255,
                0,
                1
            ],
            chocolate: [
                210,
                105,
                30,
                1
            ],
            coral: [
                255,
                127,
                80,
                1
            ],
            cornflowerblue: [
                100,
                149,
                237,
                1
            ],
            cornsilk: [
                255,
                248,
                220,
                1
            ],
            crimson: [
                220,
                20,
                60,
                1
            ],
            cyan: [
                0,
                255,
                255,
                1
            ],
            darkblue: [
                0,
                0,
                139,
                1
            ],
            darkcyan: [
                0,
                139,
                139,
                1
            ],
            darkgoldenrod: [
                184,
                134,
                11,
                1
            ],
            darkgray: [
                169,
                169,
                169,
                1
            ],
            darkgreen: [
                0,
                100,
                0,
                1
            ],
            darkgrey: [
                169,
                169,
                169,
                1
            ],
            darkkhaki: [
                189,
                183,
                107,
                1
            ],
            darkmagenta: [
                139,
                0,
                139,
                1
            ],
            darkolivegreen: [
                85,
                107,
                47,
                1
            ],
            darkorange: [
                255,
                140,
                0,
                1
            ],
            darkorchid: [
                153,
                50,
                204,
                1
            ],
            darkred: [
                139,
                0,
                0,
                1
            ],
            darksalmon: [
                233,
                150,
                122,
                1
            ],
            darkseagreen: [
                143,
                188,
                143,
                1
            ],
            darkslateblue: [
                72,
                61,
                139,
                1
            ],
            darkslategray: [
                47,
                79,
                79,
                1
            ],
            darkslategrey: [
                47,
                79,
                79,
                1
            ],
            darkturquoise: [
                0,
                206,
                209,
                1
            ],
            darkviolet: [
                148,
                0,
                211,
                1
            ],
            deeppink: [
                255,
                20,
                147,
                1
            ],
            deepskyblue: [
                0,
                191,
                255,
                1
            ],
            dimgray: [
                105,
                105,
                105,
                1
            ],
            dimgrey: [
                105,
                105,
                105,
                1
            ],
            dodgerblue: [
                30,
                144,
                255,
                1
            ],
            firebrick: [
                178,
                34,
                34,
                1
            ],
            floralwhite: [
                255,
                250,
                240,
                1
            ],
            forestgreen: [
                34,
                139,
                34,
                1
            ],
            fuchsia: [
                255,
                0,
                255,
                1
            ],
            gainsboro: [
                220,
                220,
                220,
                1
            ],
            ghostwhite: [
                248,
                248,
                255,
                1
            ],
            gold: [
                255,
                215,
                0,
                1
            ],
            goldenrod: [
                218,
                165,
                32,
                1
            ],
            gray: [
                128,
                128,
                128,
                1
            ],
            green: [
                0,
                128,
                0,
                1
            ],
            greenyellow: [
                173,
                255,
                47,
                1
            ],
            grey: [
                128,
                128,
                128,
                1
            ],
            honeydew: [
                240,
                255,
                240,
                1
            ],
            hotpink: [
                255,
                105,
                180,
                1
            ],
            indianred: [
                205,
                92,
                92,
                1
            ],
            indigo: [
                75,
                0,
                130,
                1
            ],
            ivory: [
                255,
                255,
                240,
                1
            ],
            khaki: [
                240,
                230,
                140,
                1
            ],
            lavender: [
                230,
                230,
                250,
                1
            ],
            lavenderblush: [
                255,
                240,
                245,
                1
            ],
            lawngreen: [
                124,
                252,
                0,
                1
            ],
            lemonchiffon: [
                255,
                250,
                205,
                1
            ],
            lightblue: [
                173,
                216,
                230,
                1
            ],
            lightcoral: [
                240,
                128,
                128,
                1
            ],
            lightcyan: [
                224,
                255,
                255,
                1
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210,
                1
            ],
            lightgray: [
                211,
                211,
                211,
                1
            ],
            lightgreen: [
                144,
                238,
                144,
                1
            ],
            lightgrey: [
                211,
                211,
                211,
                1
            ],
            lightpink: [
                255,
                182,
                193,
                1
            ],
            lightsalmon: [
                255,
                160,
                122,
                1
            ],
            lightseagreen: [
                32,
                178,
                170,
                1
            ],
            lightskyblue: [
                135,
                206,
                250,
                1
            ],
            lightslategray: [
                119,
                136,
                153,
                1
            ],
            lightslategrey: [
                119,
                136,
                153,
                1
            ],
            lightsteelblue: [
                176,
                196,
                222,
                1
            ],
            lightyellow: [
                255,
                255,
                224,
                1
            ],
            lime: [
                0,
                255,
                0,
                1
            ],
            limegreen: [
                50,
                205,
                50,
                1
            ],
            linen: [
                250,
                240,
                230,
                1
            ],
            magenta: [
                255,
                0,
                255,
                1
            ],
            maroon: [
                128,
                0,
                0,
                1
            ],
            mediumaquamarine: [
                102,
                205,
                170,
                1
            ],
            mediumblue: [
                0,
                0,
                205,
                1
            ],
            mediumorchid: [
                186,
                85,
                211,
                1
            ],
            mediumpurple: [
                147,
                112,
                219,
                1
            ],
            mediumseagreen: [
                60,
                179,
                113,
                1
            ],
            mediumslateblue: [
                123,
                104,
                238,
                1
            ],
            mediumspringgreen: [
                0,
                250,
                154,
                1
            ],
            mediumturquoise: [
                72,
                209,
                204,
                1
            ],
            mediumvioletred: [
                199,
                21,
                133,
                1
            ],
            midnightblue: [
                25,
                25,
                112,
                1
            ],
            mintcream: [
                245,
                255,
                250,
                1
            ],
            mistyrose: [
                255,
                228,
                225,
                1
            ],
            moccasin: [
                255,
                228,
                181,
                1
            ],
            navajowhite: [
                255,
                222,
                173,
                1
            ],
            navy: [
                0,
                0,
                128,
                1
            ],
            oldlace: [
                253,
                245,
                230,
                1
            ],
            olive: [
                128,
                128,
                0,
                1
            ],
            olivedrab: [
                107,
                142,
                35,
                1
            ],
            orange: [
                255,
                165,
                0,
                1
            ],
            orangered: [
                255,
                69,
                0,
                1
            ],
            orchid: [
                218,
                112,
                214,
                1
            ],
            palegoldenrod: [
                238,
                232,
                170,
                1
            ],
            palegreen: [
                152,
                251,
                152,
                1
            ],
            paleturquoise: [
                175,
                238,
                238,
                1
            ],
            palevioletred: [
                219,
                112,
                147,
                1
            ],
            papayawhip: [
                255,
                239,
                213,
                1
            ],
            peachpuff: [
                255,
                218,
                185,
                1
            ],
            peru: [
                205,
                133,
                63,
                1
            ],
            pink: [
                255,
                192,
                203,
                1
            ],
            plum: [
                221,
                160,
                221,
                1
            ],
            powderblue: [
                176,
                224,
                230,
                1
            ],
            purple: [
                128,
                0,
                128,
                1
            ],
            rebeccapurple: [
                102,
                51,
                153,
                1
            ],
            red: [
                255,
                0,
                0,
                1
            ],
            rosybrown: [
                188,
                143,
                143,
                1
            ],
            royalblue: [
                65,
                105,
                225,
                1
            ],
            saddlebrown: [
                139,
                69,
                19,
                1
            ],
            salmon: [
                250,
                128,
                114,
                1
            ],
            sandybrown: [
                244,
                164,
                96,
                1
            ],
            seagreen: [
                46,
                139,
                87,
                1
            ],
            seashell: [
                255,
                245,
                238,
                1
            ],
            sienna: [
                160,
                82,
                45,
                1
            ],
            silver: [
                192,
                192,
                192,
                1
            ],
            skyblue: [
                135,
                206,
                235,
                1
            ],
            slateblue: [
                106,
                90,
                205,
                1
            ],
            slategray: [
                112,
                128,
                144,
                1
            ],
            slategrey: [
                112,
                128,
                144,
                1
            ],
            snow: [
                255,
                250,
                250,
                1
            ],
            springgreen: [
                0,
                255,
                127,
                1
            ],
            steelblue: [
                70,
                130,
                180,
                1
            ],
            tan: [
                210,
                180,
                140,
                1
            ],
            teal: [
                0,
                128,
                128,
                1
            ],
            thistle: [
                216,
                191,
                216,
                1
            ],
            tomato: [
                255,
                99,
                71,
                1
            ],
            turquoise: [
                64,
                224,
                208,
                1
            ],
            violet: [
                238,
                130,
                238,
                1
            ],
            wheat: [
                245,
                222,
                179,
                1
            ],
            white: [
                255,
                255,
                255,
                1
            ],
            whitesmoke: [
                245,
                245,
                245,
                1
            ],
            yellow: [
                255,
                255,
                0,
                1
            ],
            yellowgreen: [
                154,
                205,
                50,
                1
            ]
        };
        function oi(e1) {
            return (e1 = Math.round(e1)) < 0 ? 0 : e1 > 255 ? 255 : e1;
        }
        function si(e1) {
            return oi("%" === e1[e1.length - 1] ? parseFloat(e1) / 100 * 255 : parseInt(e1));
        }
        function ai(e1) {
            var t;
            return (t = "%" === e1[e1.length - 1] ? parseFloat(e1) / 100 : parseFloat(e1)) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function li(e1, t, i) {
            return i < 0 ? i += 1 : i > 1 && (i -= 1), 6 * i < 1 ? e1 + (t - e1) * i * 6 : 2 * i < 1 ? t : 3 * i < 2 ? e1 + (t - e1) * (2 / 3 - i) * 6 : e1;
        }
        try {
            ri = ({}).parseCSSColor = function(e1) {
                var t, i = e1.replace(/ /g, "").toLowerCase();
                if (i in ni) return ni[i].slice();
                if ("#" === i[0]) return 4 === i.length ? (t = parseInt(i.substr(1), 16)) >= 0 && t <= 4095 ? [
                    (3840 & t) >> 4 | (3840 & t) >> 8,
                    240 & t | (240 & t) >> 4,
                    15 & t | (15 & t) << 4,
                    1
                ] : null : 7 === i.length && (t = parseInt(i.substr(1), 16)) >= 0 && t <= 16777215 ? [
                    (16711680 & t) >> 16,
                    (65280 & t) >> 8,
                    255 & t,
                    1
                ] : null;
                var r = i.indexOf("("), n = i.indexOf(")");
                if (-1 !== r && n + 1 === i.length) {
                    var o = i.substr(0, r), s = i.substr(r + 1, n - (r + 1)).split(","), a = 1;
                    switch(o){
                        case "rgba":
                            if (4 !== s.length) return null;
                            a = ai(s.pop());
                        case "rgb":
                            return 3 !== s.length ? null : [
                                si(s[0]),
                                si(s[1]),
                                si(s[2]),
                                a
                            ];
                        case "hsla":
                            if (4 !== s.length) return null;
                            a = ai(s.pop());
                        case "hsl":
                            if (3 !== s.length) return null;
                            var l = (parseFloat(s[0]) % 360 + 360) % 360 / 360, c = ai(s[1]), h = ai(s[2]), u = h <= .5 ? h * (c + 1) : h + c - h * c, d = 2 * h - u;
                            return [
                                oi(255 * li(d, u, l + 1 / 3)),
                                oi(255 * li(d, u, l)),
                                oi(255 * li(d, u, l - 1 / 3)),
                                a
                            ];
                        default:
                            return null;
                    }
                }
                return null;
            };
        } catch (e1) {}
        class ci {
            constructor(e1, t, i, r = 1){
                this.r = e1, this.g = t, this.b = i, this.a = r;
            }
            static parse(e1) {
                if (!e1) return;
                if (e1 instanceof ci) return e1;
                if ("string" != typeof e1) return;
                const t = ri(e1);
                return t ? new ci(t[0] / 255 * t[3], t[1] / 255 * t[3], t[2] / 255 * t[3], t[3]) : void 0;
            }
            toString() {
                const [e1, t, i, r] = this.toArray();
                return `rgba(${Math.round(e1)},${Math.round(t)},${Math.round(i)},${r})`;
            }
            toArray() {
                const { r: e1, g: t, b: i, a: r } = this;
                return 0 === r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * e1 / r,
                    255 * t / r,
                    255 * i / r,
                    r
                ];
            }
            toArray01() {
                const { r: e1, g: t, b: i, a: r } = this;
                return 0 === r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    e1 / r,
                    t / r,
                    i / r,
                    r
                ];
            }
            toArray01Scaled(e1) {
                const { r: t, g: i, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0
                ] : [
                    t / n * e1,
                    i / n * e1,
                    r / n * e1
                ];
            }
            toArray01PremultipliedAlpha() {
                const { r: e1, g: t, b: i, a: r } = this;
                return [
                    e1,
                    t,
                    i,
                    r
                ];
            }
            toArray01Linear() {
                const { r: e1, g: t, b: i, a: r } = this;
                return 0 === r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    Math.pow(e1 / r, 2.2),
                    Math.pow(t / r, 2.2),
                    Math.pow(i / r, 2.2),
                    r
                ];
            }
        }
        ci.black = new ci(0, 0, 0, 1), ci.white = new ci(1, 1, 1, 1), ci.transparent = new ci(0, 0, 0, 0), ci.red = new ci(1, 0, 0, 1), ci.blue = new ci(0, 0, 1, 1);
        var hi = ci;
        class ui {
            constructor(e1, t, i){
                this.sensitivity = e1 ? t ? "variant" : "case" : t ? "accent" : "base", this.locale = i, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(e1, t) {
                return this.collator.compare(e1, t);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class di {
            constructor(e1, t, i, r, n){
                this.text = e1.normalize ? e1.normalize() : e1, this.image = t, this.scale = i, this.fontStack = r, this.textColor = n;
            }
        }
        class pi {
            constructor(e1){
                this.sections = e1;
            }
            static fromString(e1) {
                return new pi([
                    new di(e1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((e1)=>0 !== e1.text.length || e1.image && 0 !== e1.image.namePrimary.length);
            }
            static factory(e1) {
                return e1 instanceof pi ? e1 : pi.fromString(e1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((e1)=>e1.text).join("");
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t of this.sections){
                    if (t.image) {
                        e1.push([
                            "image",
                            t.image.namePrimary
                        ]);
                        continue;
                    }
                    e1.push(t.text);
                    const i = {};
                    t.fontStack && (i["text-font"] = [
                        "literal",
                        t.fontStack.split(",")
                    ]), t.scale && (i["font-scale"] = t.scale), t.textColor && (i["text-color"] = [
                        "rgba"
                    ].concat(t.textColor.toArray())), e1.push(i);
                }
                return e1;
            }
        }
        class fi {
            constructor(e1){
                this.namePrimary = e1.namePrimary, e1.nameSecondary && (this.nameSecondary = e1.nameSecondary), this.available = e1.available;
            }
            toString() {
                return this.nameSecondary ? `[${this.namePrimary},${this.nameSecondary}]` : this.namePrimary;
            }
            static fromString(e1, t) {
                return e1 ? new fi({
                    namePrimary: e1,
                    nameSecondary: t,
                    available: !1
                }) : null;
            }
            serialize() {
                return this.nameSecondary ? [
                    "image",
                    this.namePrimary,
                    this.nameSecondary
                ] : [
                    "image",
                    this.namePrimary
                ];
            }
        }
        function mi(e1, t, i, r) {
            return "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof i && i >= 0 && i <= 255 ? void 0 === r || "number" == typeof r && r >= 0 && r <= 1 ? null : `Invalid rgba value [${[
                e1,
                t,
                i,
                r
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof r ? [
                e1,
                t,
                i,
                r
            ] : [
                e1,
                t,
                i
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function _i(e1) {
            if (null === e1) return !0;
            if ("string" == typeof e1) return !0;
            if ("boolean" == typeof e1) return !0;
            if ("number" == typeof e1) return !0;
            if (e1 instanceof hi) return !0;
            if (e1 instanceof ui) return !0;
            if (e1 instanceof pi) return !0;
            if (e1 instanceof fi) return !0;
            if (Array.isArray(e1)) {
                for (const t of e1)if (!_i(t)) return !1;
                return !0;
            }
            if ("object" == typeof e1) {
                for(const t in e1)if (!_i(e1[t])) return !1;
                return !0;
            }
            return !1;
        }
        function gi(e1) {
            if (null === e1) return Vt;
            if ("string" == typeof e1) return Gt;
            if ("boolean" == typeof e1) return qt;
            if ("number" == typeof e1) return jt;
            if (e1 instanceof hi) return Zt;
            if (e1 instanceof ui) return Ht;
            if (e1 instanceof pi) return Xt;
            if (e1 instanceof fi) return Yt;
            if (Array.isArray(e1)) {
                const t = e1.length;
                let i;
                for (const t of e1){
                    const e1 = gi(t);
                    if (i) {
                        if (i === e1) continue;
                        i = Wt;
                        break;
                    }
                    i = e1;
                }
                return Kt(i || Wt, t);
            }
            return $t;
        }
        function yi(e1) {
            const t = typeof e1;
            return null === e1 ? "" : "string" === t || "number" === t || "boolean" === t ? String(e1) : e1 instanceof hi || e1 instanceof pi || e1 instanceof fi ? e1.toString() : JSON.stringify(e1);
        }
        class xi {
            constructor(e1, t){
                this.type = e1, this.value = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'literal' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (!_i(e1[1])) return t.error("invalid value");
                const i = e1[1];
                let r = gi(i);
                const n = t.expectedType;
                return "array" !== r.kind || 0 !== r.N || !n || "array" !== n.kind || "number" == typeof n.N && 0 !== n.N || (r = n), new xi(r, i);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof hi ? [
                    "rgba"
                ].concat(this.value.toArray()) : this.value instanceof pi ? this.value.serialize() : this.value;
            }
        }
        var vi = xi, bi = class {
            constructor(e1){
                this.name = "ExpressionEvaluationError", this.message = e1;
            }
            toJSON() {
                return this.message;
            }
        };
        const wi = {
            string: Gt,
            number: jt,
            boolean: qt,
            object: $t
        };
        class Ti {
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                let i, r = 1;
                const n = e1[0];
                if ("array" === n) {
                    let n, o;
                    if (e1.length > 2) {
                        const i = e1[1];
                        if ("string" != typeof i || !(i in wi) || "object" === i) return t.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        n = wi[i], r++;
                    } else n = Wt;
                    if (e1.length > 3) {
                        if (null !== e1[2] && ("number" != typeof e1[2] || e1[2] < 0 || e1[2] !== Math.floor(e1[2]))) return t.error('The length argument to "array" must be a positive integer literal', 2);
                        o = e1[2], r++;
                    }
                    i = Kt(n, o);
                } else i = wi[n];
                const o = [];
                for(; r < e1.length; r++){
                    const i = t.parse(e1[r], r, Wt);
                    if (!i) return null;
                    o.push(i);
                }
                return new Ti(i, o);
            }
            evaluate(e1) {
                for(let t = 0; t < this.args.length; t++){
                    const i = this.args[t].evaluate(e1);
                    if (!ei(this.type, gi(i))) return i;
                    if (t === this.args.length - 1) throw new bi(`Expected value to be of type ${Jt(this.type)}, but found ${Jt(gi(i))} instead.`);
                }
                return null;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = this.type, t = [
                    e1.kind
                ];
                if ("array" === e1.kind) {
                    const i = e1.itemType;
                    if ("string" === i.kind || "number" === i.kind || "boolean" === i.kind) {
                        t.push(i.kind);
                        const r = e1.N;
                        ("number" == typeof r || this.args.length > 1) && t.push(r);
                    }
                }
                return t.concat(this.args.map((e1)=>e1.serialize()));
            }
        }
        var Ei = Ti;
        class Mi {
            constructor(e1){
                this.type = Xt, this.sections = e1;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                const i = e1[1];
                if (!Array.isArray(i) && "object" == typeof i) return t.error("First argument must be an image or text section.");
                const r = [];
                let n = !1;
                for(let i = 1; i <= e1.length - 1; ++i){
                    const o = e1[i];
                    if (n && "object" == typeof o && !Array.isArray(o)) {
                        n = !1;
                        let e1 = null;
                        if (o["font-scale"] && (e1 = t.parse(o["font-scale"], 1, jt), !e1)) return null;
                        let i = null;
                        if (o["text-font"] && (i = t.parse(o["text-font"], 1, Kt(Gt)), !i)) return null;
                        let s = null;
                        if (o["text-color"] && (s = t.parse(o["text-color"], 1, Zt), !s)) return null;
                        const a = r[r.length - 1];
                        a.scale = e1, a.font = i, a.textColor = s;
                    } else {
                        const o = t.parse(e1[i], 1, Wt);
                        if (!o) return null;
                        const s = o.type.kind;
                        if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return t.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        n = !0, r.push({
                            content: o,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Mi(r);
            }
            evaluate(e1) {
                return new pi(this.sections.map((t)=>{
                    const i = t.content.evaluate(e1);
                    return gi(i) === Yt ? new di("", i, null, null, null) : new di(yi(i), null, t.scale ? t.scale.evaluate(e1) : null, t.font ? t.font.evaluate(e1).join(",") : null, t.textColor ? t.textColor.evaluate(e1) : null);
                }));
            }
            eachChild(e1) {
                for (const t of this.sections)e1(t.content), t.scale && e1(t.scale), t.font && e1(t.font), t.textColor && e1(t.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t of this.sections){
                    e1.push(t.content.serialize());
                    const i = {};
                    t.scale && (i["font-scale"] = t.scale.serialize()), t.font && (i["text-font"] = t.font.serialize()), t.textColor && (i["text-color"] = t.textColor.serialize()), e1.push(i);
                }
                return e1;
            }
        }
        class Ai {
            constructor(e1, t){
                this.type = Yt, this.inputPrimary = e1, this.inputSecondary = t;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected two or more arguments.");
                const i = t.parse(e1[1], 1, Gt);
                if (!i) return t.error("No image name provided.");
                if (2 === e1.length) return new Ai(i);
                const r = t.parse(e1[2], 1, Gt);
                return r ? new Ai(i, r) : t.error("Secondary image variant is not a string.");
            }
            evaluate(e1) {
                const t = fi.fromString(this.inputPrimary.evaluate(e1), this.inputSecondary ? this.inputSecondary.evaluate(e1) : void 0);
                return t && e1.availableImages && (t.available = e1.availableImages.indexOf(t.namePrimary) > -1, t.nameSecondary && t.available && e1.availableImages && (t.available = e1.availableImages.indexOf(t.nameSecondary) > -1)), t;
            }
            eachChild(e1) {
                e1(this.inputPrimary), this.inputSecondary && e1(this.inputSecondary);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return this.inputSecondary ? [
                    "image",
                    this.inputPrimary.serialize(),
                    this.inputSecondary.serialize()
                ] : [
                    "image",
                    this.inputPrimary.serialize()
                ];
            }
        }
        function Si(e1) {
            return e1 instanceof Number ? "number" : e1 instanceof String ? "string" : e1 instanceof Boolean ? "boolean" : Array.isArray(e1) ? "array" : null === e1 ? "null" : typeof e1;
        }
        const Ii = {
            "to-boolean": qt,
            "to-color": Zt,
            "to-number": jt,
            "to-string": Gt
        };
        class Ci {
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                const i = e1[0], r = [];
                let n = Vt;
                if ("to-array" === i) {
                    if (!Array.isArray(e1[1])) return null;
                    const i = e1[1].length;
                    if (t.expectedType) {
                        if ("array" !== t.expectedType.kind) return t.error(`Expected ${t.expectedType.kind} but found array.`);
                        n = Kt(t.expectedType.itemType, i);
                    } else {
                        if (!(i > 0 && _i(e1[1][0]))) return null;
                        n = Kt(gi(e1[1][0]), i);
                    }
                    for(let o = 0; o < i; o++){
                        const i = e1[1][o];
                        let s;
                        if ("array" === Si(i)) s = t.parse(i, void 0, n.itemType);
                        else {
                            const e1 = Si(i);
                            if (e1 !== n.itemType.kind) return t.error(`Expected ${n.itemType.kind} but found ${e1}.`);
                            s = t.registry.literal.parse([
                                "literal",
                                void 0 === i ? null : i
                            ], t);
                        }
                        if (!s) return null;
                        r.push(s);
                    }
                } else {
                    if (("to-boolean" === i || "to-string" === i) && 2 !== e1.length) return t.error("Expected one argument.");
                    n = Ii[i];
                    for(let i = 1; i < e1.length; i++){
                        const n = t.parse(e1[i], i, Wt);
                        if (!n) return null;
                        r.push(n);
                    }
                }
                return new Ci(n, r);
            }
            evaluate(e1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e1));
                if ("color" === this.type.kind) {
                    let t, i;
                    for (const r of this.args){
                        if (t = r.evaluate(e1), i = null, t instanceof hi) return t;
                        if ("string" == typeof t) {
                            const i = e1.parseColor(t);
                            if (i) return i;
                        } else if (Array.isArray(t) && (i = t.length < 3 || t.length > 4 ? `Invalid rbga value ${JSON.stringify(t)}: expected an array containing either three or four numeric values.` : mi(t[0], t[1], t[2], t[3]), !i)) return new hi(t[0] / 255, t[1] / 255, t[2] / 255, t[3]);
                    }
                    throw new bi(i || `Could not parse color from value '${"string" == typeof t ? t : String(JSON.stringify(t))}'`);
                }
                if ("number" === this.type.kind) {
                    let t = null;
                    for (const i of this.args){
                        if (t = i.evaluate(e1), null === t) return 0;
                        const r = Number(t);
                        if (!isNaN(r)) return r;
                    }
                    throw new bi(`Could not convert ${JSON.stringify(t)} to number.`);
                }
                return "formatted" === this.type.kind ? pi.fromString(yi(this.args[0].evaluate(e1))) : "resolvedImage" === this.type.kind ? fi.fromString(yi(this.args[0].evaluate(e1))) : "array" === this.type.kind ? this.args.map((t)=>t.evaluate(e1)) : yi(this.args[0].evaluate(e1));
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Mi([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new Ai(this.args[0]).serialize();
                const e1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
        }
        var zi = Ci;
        const Pi = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        var Di = class {
            constructor(e1){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.options = e1;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Pi[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(e1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const e1 = this.featureDistanceData.center, t = this.featureDistanceData.scale, { x: i, y: r } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (i * t - e1[0]) + this.featureDistanceData.bearing[1] * (r * t - e1[1]);
                }
                return 0;
            }
            parseColor(e1) {
                let t = this._parseColorCache[e1];
                return t || (t = this._parseColorCache[e1] = hi.parse(e1)), t;
            }
            getConfig(e1) {
                return this.options ? this.options.get(e1) : null;
            }
        };
        class Ri {
            constructor(e1, t, i, r, n){
                this.name = e1, this.type = t, this._evaluate = i, this.args = r, this._overloadIndex = n;
            }
            evaluate(e1) {
                if (!this._evaluate) {
                    const e1 = Ri.definitions[this.name];
                    this._evaluate = Array.isArray(e1) ? e1[2] : e1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(e1, this.args);
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((e1)=>e1.serialize()));
            }
            static parse(e1, t) {
                const i = e1[0], r = Ri.definitions[i];
                if (!r) return t.error(`Unknown expression "${i}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const n = Array.isArray(r) ? r[0] : r.type, o = Array.isArray(r) ? [
                    [
                        r[1],
                        r[2]
                    ]
                ] : r.overloads, s = [];
                let a = null, l = -1;
                for (const [r, c] of o){
                    if (Array.isArray(r) && r.length !== e1.length - 1) continue;
                    s.push(r), l++, a = new $r(t.registry, t.path, null, t.scope, void 0, t.options);
                    const o = [];
                    let h = !1;
                    for(let t = 1; t < e1.length; t++){
                        const i = e1[t], n = Array.isArray(r) ? r[t - 1] : r.type, s = a.parse(i, 1 + o.length, n);
                        if (!s) {
                            h = !0;
                            break;
                        }
                        o.push(s);
                    }
                    if (!h) {
                        if (Array.isArray(r) && r.length !== o.length) a.error(`Expected ${r.length} arguments, but found ${o.length} instead.`);
                        else {
                            for(let e1 = 0; e1 < o.length; e1++){
                                const t = Array.isArray(r) ? r[e1] : r.type, i = o[e1];
                                a.concat(e1 + 1).checkSubtype(t, i.type);
                            }
                            if (0 === a.errors.length) return new Ri(i, n, c, o, l);
                        }
                    }
                }
                if (1 === s.length) t.errors.push(...a.errors);
                else {
                    const i = (s.length ? s : o.map(([e1])=>e1)).map(Li).join(" | "), r = [];
                    for(let i = 1; i < e1.length; i++){
                        const n = t.parse(e1[i], 1 + r.length);
                        if (!n) return null;
                        r.push(Jt(n.type));
                    }
                    t.error(`Expected arguments of type ${i}, but found (${r.join(", ")}) instead.`);
                }
                return null;
            }
            static register(e1, t) {
                Ri.definitions = t;
                for(const i in t)e1[i] = Ri;
            }
        }
        function Li(e1) {
            return Array.isArray(e1) ? `(${e1.map(Jt).join(", ")})` : `(${Jt(e1.type)}...)`;
        }
        var ki = Ri;
        class Oi {
            constructor(e1, t, i){
                this.type = Ht, this.locale = i, this.caseSensitive = e1, this.diacriticSensitive = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error("Expected one argument.");
                const i = e1[1];
                if ("object" != typeof i || Array.isArray(i)) return t.error("Collator options argument must be an object.");
                const r = t.parse(void 0 !== i["case-sensitive"] && i["case-sensitive"], 1, qt);
                if (!r) return null;
                const n = t.parse(void 0 !== i["diacritic-sensitive"] && i["diacritic-sensitive"], 1, qt);
                if (!n) return null;
                let o = null;
                return i.locale && (o = t.parse(i.locale, 1, Gt), !o) ? null : new Oi(r, n, o);
            }
            evaluate(e1) {
                return new ui(this.caseSensitive.evaluate(e1), this.diacriticSensitive.evaluate(e1), this.locale ? this.locale.evaluate(e1) : null);
            }
            eachChild(e1) {
                e1(this.caseSensitive), e1(this.diacriticSensitive), this.locale && e1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return e1["case-sensitive"] = this.caseSensitive.serialize(), e1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (e1.locale = this.locale.serialize()), [
                    "collator",
                    e1
                ];
            }
        }
        var Bi = {
            exports: {}
        };
        Bi.exports = function() {
            function e1(i, r, n, o, s) {
                for(; o > n;){
                    if (o - n > 600) {
                        var a = o - n + 1, l = r - n + 1, c = Math.log(a), h = .5 * Math.exp(2 * c / 3), u = .5 * Math.sqrt(c * h * (a - h) / a) * (l - a / 2 < 0 ? -1 : 1);
                        e1(i, r, Math.max(n, Math.floor(r - l * h / a + u)), Math.min(o, Math.floor(r + (a - l) * h / a + u)), s);
                    }
                    var d = i[r], p = n, f = o;
                    for(t(i, n, r), s(i[o], d) > 0 && t(i, n, o); p < f;){
                        for(t(i, p, f), p++, f--; s(i[p], d) < 0;)p++;
                        for(; s(i[f], d) > 0;)f--;
                    }
                    0 === s(i[n], d) ? t(i, n, f) : t(i, ++f, o), f <= r && (n = f + 1), r <= f && (o = f - 1);
                }
            }
            function t(e1, t, i) {
                var r = e1[t];
                e1[t] = e1[i], e1[i] = r;
            }
            function i(e1, t) {
                return e1 < t ? -1 : e1 > t ? 1 : 0;
            }
            return function(t, r, n, o, s) {
                e1(t, r, n || 0, o || t.length - 1, s || i);
            };
        }();
        var Fi = d(Bi.exports);
        function Ni(e1) {
            let t = 0;
            for(let i, r, n = 0, o = e1.length, s = o - 1; n < o; s = n++)i = e1[n], r = e1[s], t += (r.x - i.x) * (i.y + r.y);
            return t;
        }
        function Ui(e1, t) {
            e1[0] = Math.min(e1[0], t[0]), e1[1] = Math.min(e1[1], t[1]), e1[2] = Math.max(e1[2], t[0]), e1[3] = Math.max(e1[3], t[1]);
        }
        function Vi(e1, t) {
            return !(e1[0] <= t[0] || e1[2] >= t[2] || e1[1] <= t[1] || e1[3] >= t[3]);
        }
        function ji(e1, t, i) {
            const r = e1[0] - t[0], n = e1[1] - t[1], o = e1[0] - i[0], s = e1[1] - i[1];
            return r * s - o * n == 0 && r * o <= 0 && n * s <= 0;
        }
        function Gi(e1, t, i = !1) {
            let r = !1;
            for(let a = 0, l = t.length; a < l; a++){
                const l = t[a];
                for(let t = 0, a = l.length, c = a - 1; t < a; c = t++){
                    const a = l[c], h = l[t];
                    if (ji(e1, a, h)) return i;
                    (o = a)[1] > (n = e1)[1] != (s = h)[1] > n[1] && n[0] < (s[0] - o[0]) * (n[1] - o[1]) / (s[1] - o[1]) + o[0] && (r = !r);
                }
            }
            var n, o, s;
            return r;
        }
        function qi(e1, t, i, r) {
            const n = r[0] - i[0], o = r[1] - i[1], s = (e1[0] - i[0]) * o - n * (e1[1] - i[1]), a = (t[0] - i[0]) * o - n * (t[1] - i[1]);
            return s > 0 && a < 0 || s < 0 && a > 0;
        }
        function Zi(e1, t, i, r) {
            var n, o;
            return 0 != (n = [
                r[0] - i[0],
                r[1] - i[1]
            ])[0] * (o = [
                t[0] - e1[0],
                t[1] - e1[1]
            ])[1] - n[1] * o[0] && !(!qi(e1, t, i, r) || !qi(i, r, e1, t));
        }
        const $i = 8192;
        function Wi(e1, t) {
            const i = (180 + e1[0]) / 360, r = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1[1] * Math.PI / 360))) / 360, n = Math.pow(2, t.z);
            return [
                Math.round(i * n * $i),
                Math.round(r * n * $i)
            ];
        }
        function Hi(e1, t) {
            for(let i = 0; i < t.length; i++)if (Gi(e1, t[i])) return !0;
            return !1;
        }
        function Xi(e1, t, i) {
            for (const r of i)for(let i = 0, n = r.length, o = n - 1; i < n; o = i++)if (Zi(e1, t, r[o], r[i])) return !0;
            return !1;
        }
        function Yi(e1, t) {
            for(let i = 0; i < e1.length; ++i)if (!Gi(e1[i], t)) return !1;
            for(let i = 0; i < e1.length - 1; ++i)if (Xi(e1[i], e1[i + 1], t)) return !1;
            return !0;
        }
        function Ki(e1, t) {
            for(let i = 0; i < t.length; i++)if (Yi(e1, t[i])) return !0;
            return !1;
        }
        function Ji(e1, t, i) {
            const r = [];
            for(let n = 0; n < e1.length; n++){
                const o = [];
                for(let r = 0; r < e1[n].length; r++){
                    const s = Wi(e1[n][r], i);
                    Ui(t, s), o.push(s);
                }
                r.push(o);
            }
            return r;
        }
        function Qi(e1, t, i) {
            const r = [];
            for(let n = 0; n < e1.length; n++){
                const o = Ji(e1[n], t, i);
                r.push(o);
            }
            return r;
        }
        function er(e1, t, i, r) {
            if (e1[0] < i[0] || e1[0] > i[2]) {
                const t = .5 * r;
                let n = e1[0] - i[0] > t ? -r : i[0] - e1[0] > t ? r : 0;
                0 === n && (n = e1[0] - i[2] > t ? -r : i[2] - e1[0] > t ? r : 0), e1[0] += n;
            }
            Ui(t, e1);
        }
        function tr(e1, t, i, r) {
            const n = Math.pow(2, r.z) * $i, o = [
                r.x * $i,
                r.y * $i
            ], s = [];
            if (!e1) return s;
            for (const r of e1)for (const e1 of r){
                const r = [
                    e1.x + o[0],
                    e1.y + o[1]
                ];
                er(r, t, i, n), s.push(r);
            }
            return s;
        }
        function ir(e1, t, i, r) {
            const n = Math.pow(2, r.z) * $i, o = [
                r.x * $i,
                r.y * $i
            ], s = [];
            if (!e1) return s;
            for (const i of e1){
                const e1 = [];
                for (const r of i){
                    const i = [
                        r.x + o[0],
                        r.y + o[1]
                    ];
                    Ui(t, i), e1.push(i);
                }
                s.push(e1);
            }
            if (t[2] - t[0] <= n / 2) {
                (a = t)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
                for (const e1 of s)for (const r of e1)er(r, t, i, n);
            }
            var a;
            return s;
        }
        class rr {
            constructor(e1, t){
                this.type = qt, this.geojson = e1, this.geometries = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'within' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (_i(e1[1])) {
                    const t = e1[1];
                    if ("FeatureCollection" === t.type) for(let e1 = 0; e1 < t.features.length; ++e1){
                        const i = t.features[e1].geometry.type;
                        if ("Polygon" === i || "MultiPolygon" === i) return new rr(t, t.features[e1].geometry);
                    }
                    else if ("Feature" === t.type) {
                        const e1 = t.geometry.type;
                        if ("Polygon" === e1 || "MultiPolygon" === e1) return new rr(t, t.geometry);
                    } else if ("Polygon" === t.type || "MultiPolygon" === t.type) return new rr(t, t);
                }
                return t.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e1) {
                if (null != e1.geometry() && null != e1.canonicalID()) {
                    if ("Point" === e1.geometryType()) return function(e1, t) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = e1.canonicalID();
                        if (!n) return !1;
                        if ("Polygon" === t.type) {
                            const o = Ji(t.coordinates, r, n), s = tr(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Gi(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t.type) {
                            const o = Qi(t.coordinates, r, n), s = tr(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Hi(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = e1.canonicalID();
                        if (!n) return !1;
                        if ("Polygon" === t.type) {
                            const o = Ji(t.coordinates, r, n), s = ir(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Yi(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t.type) {
                            const o = Qi(t.coordinates, r, n), s = ir(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Ki(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        var nr = rr, or = {
            exports: {}
        };
        or.exports = function() {
            var e1 = {
                kilometers: 1,
                miles: 1e3 / 1609.344,
                nauticalmiles: 1e3 / 1852,
                meters: 1e3,
                metres: 1e3,
                yards: 1e3 / .9144,
                feet: 1e3 / .3048,
                inches: 1e3 / .0254
            }, t = 1 / 298.257223563, i = t * (2 - t), r = Math.PI / 180, n = function(t, n) {
                if (void 0 === t) throw new Error("No latitude given.");
                if (n && !e1[n]) throw new Error("Unknown unit " + n + ". Use one of: " + Object.keys(e1).join(", "));
                var o = 6378.137 * r * (n ? e1[n] : 1), s = Math.cos(t * r), a = 1 / (1 - i * (1 - s * s)), l = Math.sqrt(a);
                this.kx = o * l * s, this.ky = o * l * a * (1 - i);
            }, o = {
                units: {
                    configurable: !0
                }
            };
            function s(e1, t) {
                return e1[0] === t[0] && e1[1] === t[1];
            }
            function a(e1, t, i) {
                var r = l(t[0] - e1[0]);
                return [
                    e1[0] + r * i,
                    e1[1] + (t[1] - e1[1]) * i
                ];
            }
            function l(e1) {
                for(; e1 < -180;)e1 += 360;
                for(; e1 > 180;)e1 -= 360;
                return e1;
            }
            return n.fromTile = function(e1, t, i) {
                var o = Math.PI * (1 - 2 * (e1 + .5) / Math.pow(2, t)), s = Math.atan(.5 * (Math.exp(o) - Math.exp(-o))) / r;
                return new n(s, i);
            }, o.units.get = function() {
                return e1;
            }, n.prototype.distance = function(e1, t) {
                var i = l(e1[0] - t[0]) * this.kx, r = (e1[1] - t[1]) * this.ky;
                return Math.sqrt(i * i + r * r);
            }, n.prototype.bearing = function(e1, t) {
                var i = l(t[0] - e1[0]) * this.kx;
                return Math.atan2(i, (t[1] - e1[1]) * this.ky) / r;
            }, n.prototype.destination = function(e1, t, i) {
                var n = i * r;
                return this.offset(e1, Math.sin(n) * t, Math.cos(n) * t);
            }, n.prototype.offset = function(e1, t, i) {
                return [
                    e1[0] + t / this.kx,
                    e1[1] + i / this.ky
                ];
            }, n.prototype.lineDistance = function(e1) {
                for(var t = 0, i = 0; i < e1.length - 1; i++)t += this.distance(e1[i], e1[i + 1]);
                return t;
            }, n.prototype.area = function(e1) {
                for(var t = 0, i = 0; i < e1.length; i++)for(var r = e1[i], n = 0, o = r.length, s = o - 1; n < o; s = n++)t += l(r[n][0] - r[s][0]) * (r[n][1] + r[s][1]) * (i ? -1 : 1);
                return Math.abs(t) / 2 * this.kx * this.ky;
            }, n.prototype.along = function(e1, t) {
                var i = 0;
                if (t <= 0) return e1[0];
                for(var r = 0; r < e1.length - 1; r++){
                    var n = e1[r], o = e1[r + 1], s = this.distance(n, o);
                    if ((i += s) > t) return a(n, o, (t - (i - s)) / s);
                }
                return e1[e1.length - 1];
            }, n.prototype.pointToSegmentDistance = function(e1, t, i) {
                var r = t[0], n = t[1], o = l(i[0] - r) * this.kx, s = (i[1] - n) * this.ky, a = 0;
                return 0 === o && 0 === s || ((a = (l(e1[0] - r) * this.kx * o + (e1[1] - n) * this.ky * s) / (o * o + s * s)) > 1 ? (r = i[0], n = i[1]) : a > 0 && (r += o / this.kx * a, n += s / this.ky * a)), o = l(e1[0] - r) * this.kx, s = (e1[1] - n) * this.ky, Math.sqrt(o * o + s * s);
            }, n.prototype.pointOnLine = function(e1, t) {
                for(var i, r, n, o, s = 1 / 0, a = 0; a < e1.length - 1; a++){
                    var c = e1[a][0], h = e1[a][1], u = l(e1[a + 1][0] - c) * this.kx, d = (e1[a + 1][1] - h) * this.ky, p = 0;
                    0 === u && 0 === d || ((p = (l(t[0] - c) * this.kx * u + (t[1] - h) * this.ky * d) / (u * u + d * d)) > 1 ? (c = e1[a + 1][0], h = e1[a + 1][1]) : p > 0 && (c += u / this.kx * p, h += d / this.ky * p));
                    var f = (u = l(t[0] - c) * this.kx) * u + (d = (t[1] - h) * this.ky) * d;
                    f < s && (s = f, i = c, r = h, n = a, o = p);
                }
                return {
                    point: [
                        i,
                        r
                    ],
                    index: n,
                    t: Math.max(0, Math.min(1, o))
                };
            }, n.prototype.lineSlice = function(e1, t, i) {
                var r = this.pointOnLine(i, e1), n = this.pointOnLine(i, t);
                if (r.index > n.index || r.index === n.index && r.t > n.t) {
                    var o = r;
                    r = n, n = o;
                }
                var a = [
                    r.point
                ], l = r.index + 1, c = n.index;
                !s(i[l], a[0]) && l <= c && a.push(i[l]);
                for(var h = l + 1; h <= c; h++)a.push(i[h]);
                return s(i[c], n.point) || a.push(n.point), a;
            }, n.prototype.lineSliceAlong = function(e1, t, i) {
                for(var r = 0, n = [], o = 0; o < i.length - 1; o++){
                    var s = i[o], l = i[o + 1], c = this.distance(s, l);
                    if ((r += c) > e1 && 0 === n.length && n.push(a(s, l, (e1 - (r - c)) / c)), r >= t) return n.push(a(s, l, (t - (r - c)) / c)), n;
                    r > e1 && n.push(l);
                }
                return n;
            }, n.prototype.bufferPoint = function(e1, t) {
                var i = t / this.ky, r = t / this.kx;
                return [
                    e1[0] - r,
                    e1[1] - i,
                    e1[0] + r,
                    e1[1] + i
                ];
            }, n.prototype.bufferBBox = function(e1, t) {
                var i = t / this.ky, r = t / this.kx;
                return [
                    e1[0] - r,
                    e1[1] - i,
                    e1[2] + r,
                    e1[3] + i
                ];
            }, n.prototype.insideBBox = function(e1, t) {
                return l(e1[0] - t[0]) >= 0 && l(e1[0] - t[2]) <= 0 && e1[1] >= t[1] && e1[1] <= t[3];
            }, Object.defineProperties(n, o), n;
        }();
        var sr = d(or.exports), ar = {
            exports: {}
        };
        ar.exports = function() {
            var e1 = function(e1, i) {
                if (void 0 === e1 && (e1 = []), void 0 === i && (i = t), this.data = e1, this.length = this.data.length, this.compare = i, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
            };
            function t(e1, t) {
                return e1 < t ? -1 : e1 > t ? 1 : 0;
            }
            return e1.prototype.push = function(e1) {
                this.data.push(e1), this.length++, this._up(this.length - 1);
            }, e1.prototype.pop = function() {
                if (0 !== this.length) {
                    var e1 = this.data[0], t = this.data.pop();
                    return this.length--, this.length > 0 && (this.data[0] = t, this._down(0)), e1;
                }
            }, e1.prototype.peek = function() {
                return this.data[0];
            }, e1.prototype._up = function(e1) {
                for(var t = this.data, i = this.compare, r = t[e1]; e1 > 0;){
                    var n = e1 - 1 >> 1, o = t[n];
                    if (i(r, o) >= 0) break;
                    t[e1] = o, e1 = n;
                }
                t[e1] = r;
            }, e1.prototype._down = function(e1) {
                for(var t = this.data, i = this.compare, r = this.length >> 1, n = t[e1]; e1 < r;){
                    var o = 1 + (e1 << 1), s = t[o], a = o + 1;
                    if (a < this.length && i(t[a], s) < 0 && (o = a, s = t[a]), i(s, n) >= 0) break;
                    t[e1] = s, e1 = o;
                }
                t[e1] = n;
            }, e1;
        }();
        var lr = d(ar.exports), cr = 8192;
        function hr(e1, t) {
            return t.dist - e1.dist;
        }
        const ur = 100, dr = 50;
        function pr(e1) {
            const t = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (t.length !== e1.length) return !1;
            for(let i = 0; i < t.length; i++)if (t[i] !== e1[i]) return !1;
            return !0;
        }
        function fr(e1) {
            return e1[1] - e1[0] + 1;
        }
        function mr(e1, t) {
            const i = e1[1] >= e1[0] && e1[1] < t;
            return i || console.warn("Distance Expression: Index is out of range"), i;
        }
        function _r(e1, t) {
            if (e1[0] > e1[1]) return [
                null,
                null
            ];
            const i = fr(e1);
            if (t) {
                if (2 === i) return [
                    e1,
                    null
                ];
                const t = Math.floor(i / 2);
                return [
                    [
                        e1[0],
                        e1[0] + t
                    ],
                    [
                        e1[0] + t,
                        e1[1]
                    ]
                ];
            }
            {
                if (1 === i) return [
                    e1,
                    null
                ];
                const t = Math.floor(i / 2) - 1;
                return [
                    [
                        e1[0],
                        e1[0] + t
                    ],
                    [
                        e1[0] + t + 1,
                        e1[1]
                    ]
                ];
            }
        }
        function gr(e1, t) {
            const i = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!mr(t, e1.length)) return i;
            for(let r = t[0]; r <= t[1]; ++r)Ui(i, e1[r]);
            return i;
        }
        function yr(e1) {
            const t = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let i = 0; i < e1.length; ++i)for(let r = 0; r < e1[i].length; ++r)Ui(t, e1[i][r]);
            return t;
        }
        function xr(e1, t, i) {
            if (pr(e1) || pr(t)) return NaN;
            let r = 0, n = 0;
            return e1[2] < t[0] && (r = t[0] - e1[2]), e1[0] > t[2] && (r = e1[0] - t[2]), e1[1] > t[3] && (n = e1[1] - t[3]), e1[3] < t[1] && (n = t[1] - e1[3]), i.distance([
                0,
                0
            ], [
                r,
                n
            ]);
        }
        function vr(e1, t) {
            const i = Math.pow(2, t.z);
            var r, n;
            return [
                (n = (e1.x / cr + t.x) / i, 360 * n - 180),
                (r = (e1.y / cr + t.y) / i, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * r) * Math.PI / 180)) - 90)
            ];
        }
        function br(e1, t) {
            const i = [];
            for(let r = 0; r < e1.length; ++r)i.push(vr(e1[r], t));
            return i;
        }
        function wr(e1, t, i) {
            const r = i.pointOnLine(t, e1).point;
            return i.distance(e1, r);
        }
        function Tr(e1, t, i, r, n) {
            const o = i.slice(r[0], r[1] + 1);
            let s = 1 / 0;
            for(let i = t[0]; i <= t[1]; ++i)if (0 === (s = Math.min(s, wr(e1[i], o, n)))) return 0;
            return s;
        }
        function Er(e1, t, i, r, n) {
            const o = Math.min(n.pointToSegmentDistance(e1, i, r), n.pointToSegmentDistance(t, i, r)), s = Math.min(n.pointToSegmentDistance(i, e1, t), n.pointToSegmentDistance(r, e1, t));
            return Math.min(o, s);
        }
        function Mr(e1, t, i, r, n) {
            if (!mr(t, e1.length) || !mr(r, i.length)) return NaN;
            let o = 1 / 0;
            for(let s = t[0]; s < t[1]; ++s)for(let t = r[0]; t < r[1]; ++t){
                if (Zi(e1[s], e1[s + 1], i[t], i[t + 1])) return 0;
                o = Math.min(o, Er(e1[s], e1[s + 1], i[t], i[t + 1], n));
            }
            return o;
        }
        function Ar(e1, t, i, r, n) {
            if (!mr(t, e1.length) || !mr(r, i.length)) return NaN;
            let o = 1 / 0;
            for(let s = t[0]; s <= t[1]; ++s)for(let t = r[0]; t <= r[1]; ++t)if (0 === (o = Math.min(o, n.distance(e1[s], i[t])))) return o;
            return o;
        }
        function Sr(e1, t, i) {
            if (Gi(e1, t, !0)) return 0;
            let r = 1 / 0;
            for (const n of t){
                const t = n.length;
                if (t < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (n[0] !== n[t - 1] && 0 === (r = Math.min(r, i.pointToSegmentDistance(e1, n[t - 1], n[0])))) return r;
                if (0 === (r = Math.min(r, wr(e1, n, i)))) return r;
            }
            return r;
        }
        function Ir(e1, t, i, r) {
            if (!mr(t, e1.length)) return NaN;
            for(let r = t[0]; r <= t[1]; ++r)if (Gi(e1[r], i, !0)) return 0;
            let n = 1 / 0;
            for(let o = t[0]; o < t[1]; ++o)for (const t of i)for(let i = 0, s = t.length, a = s - 1; i < s; a = i++){
                if (Zi(e1[o], e1[o + 1], t[a], t[i])) return 0;
                n = Math.min(n, Er(e1[o], e1[o + 1], t[a], t[i], r));
            }
            return n;
        }
        function Cr(e1, t) {
            for (const i of e1)for(let e1 = 0; e1 <= i.length - 1; ++e1)if (Gi(i[e1], t, !0)) return !0;
            return !1;
        }
        function zr(e1, t, i, r = 1 / 0) {
            const n = yr(e1), o = yr(t);
            if (r !== 1 / 0 && xr(n, o, i) >= r) return r;
            if (Vi(n, o)) {
                if (Cr(e1, t)) return 0;
            } else if (Cr(t, e1)) return 0;
            let s = r;
            for (const r of e1)for(let e1 = 0, n = r.length, o = n - 1; e1 < n; o = e1++)for (const n of t)for(let t = 0, a = n.length, l = a - 1; t < a; l = t++){
                if (Zi(r[o], r[e1], n[l], n[t])) return 0;
                s = Math.min(s, Er(r[o], r[e1], n[l], n[t], i));
            }
            return s;
        }
        function Pr(e1, t, i, r, n, o, s) {
            if (null === o || null === s) return;
            const a = xr(gr(r, o), gr(n, s), i);
            a < t && e1.push({
                dist: a,
                range1: o,
                range2: s
            });
        }
        function Dr(e1, t, i, r, n = 1 / 0) {
            let o = Math.min(r.distance(e1[0], i[0][0]), n);
            if (0 === o) return o;
            const s = new lr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], hr), a = t ? dr : ur, l = yr(i);
            for(; s.length;){
                const n = s.pop();
                if (n.dist >= o) continue;
                const c = n.range1;
                if (fr(c) <= a) {
                    if (!mr(c, e1.length)) return NaN;
                    if (t) {
                        const t = Ir(e1, c, i, r);
                        if (0 === (o = Math.min(o, t))) return o;
                    } else for(let t = c[0]; t <= c[1]; ++t){
                        const n = Sr(e1[t], i, r);
                        if (0 === (o = Math.min(o, n))) return o;
                    }
                } else {
                    const i = _r(c, t);
                    if (null !== i[0]) {
                        const t = xr(gr(e1, i[0]), l, r);
                        t < o && s.push({
                            dist: t,
                            range1: i[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== i[1]) {
                        const t = xr(gr(e1, i[1]), l, r);
                        t < o && s.push({
                            dist: t,
                            range1: i[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return o;
        }
        function Rr(e1, t, i, r, n, o = 1 / 0) {
            let s = Math.min(o, n.distance(e1[0], i[0]));
            if (0 === s) return s;
            const a = new lr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        i.length - 1
                    ]
                }
            ], hr), l = t ? dr : ur, c = r ? dr : ur;
            for(; a.length;){
                const o = a.pop();
                if (o.dist >= s) continue;
                const h = o.range1, u = o.range2;
                if (fr(h) <= l && fr(u) <= c) {
                    if (!mr(h, e1.length) || !mr(u, i.length)) return NaN;
                    if (t && r ? s = Math.min(s, Mr(e1, h, i, u, n)) : t || r ? t && !r ? s = Math.min(s, Tr(i, u, e1, h, n)) : !t && r && (s = Math.min(s, Tr(e1, h, i, u, n))) : s = Math.min(s, Ar(e1, h, i, u, n)), 0 === s) return s;
                } else {
                    const o = _r(h, t), l = _r(u, r);
                    Pr(a, s, n, e1, i, o[0], l[0]), Pr(a, s, n, e1, i, o[0], l[1]), Pr(a, s, n, e1, i, o[1], l[0]), Pr(a, s, n, e1, i, o[1], l[1]);
                }
            }
            return s;
        }
        function Lr(e1, t, i, r, n = 1 / 0) {
            let o = n;
            const s = gr(e1, [
                0,
                e1.length - 1
            ]);
            for (const n of i)if (!(o !== 1 / 0 && xr(s, gr(n, [
                0,
                n.length - 1
            ]), r) >= o) && (o = Math.min(o, Rr(e1, t, n, !0, r, o)), 0 === o)) return o;
            return o;
        }
        function kr(e1, t, i, r, n = 1 / 0) {
            let o = n;
            const s = gr(e1, [
                0,
                e1.length - 1
            ]);
            for (const n of i){
                if (o !== 1 / 0 && xr(s, yr(n), r) >= o) continue;
                const i = Dr(e1, t, n, r, o);
                if (isNaN(i)) return i;
                if (0 === (o = Math.min(o, i))) return o;
            }
            return o;
        }
        function Or(e1) {
            return "Point" === e1 || "MultiPoint" === e1 || "LineString" === e1 || "MultiLineString" === e1 || "Polygon" === e1 || "MultiPolygon" === e1;
        }
        class Br {
            constructor(e1, t){
                this.type = jt, this.geojson = e1, this.geometries = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'distance' expression requires either one argument, but found ' ${e1.length - 1} instead.`);
                if (_i(e1[1])) {
                    const t = e1[1];
                    if ("FeatureCollection" === t.type) {
                        for(let e1 = 0; e1 < t.features.length; ++e1)if (Or(t.features[e1].geometry.type)) return new Br(t, t.features[e1].geometry);
                    } else if ("Feature" === t.type) {
                        if (Or(t.geometry.type)) return new Br(t, t.geometry);
                    } else if (Or(t.type)) return new Br(t, t);
                }
                return t.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(e1) {
                const t = e1.geometry(), i = e1.canonicalID();
                if (null != t && null != i) {
                    if ("Point" === e1.geometryType()) return function(e1, t, i) {
                        const r = [];
                        for (const i of e1)for (const e1 of i)r.push(vr(e1, t));
                        const n = new sr(r[0][1], "meters");
                        return "Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type ? Rr(r, !1, "Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, n) : "MultiLineString" === i.type ? Lr(r, !1, i.coordinates, n) : "Polygon" === i.type || "MultiPolygon" === i.type ? kr(r, !1, "Polygon" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, n) : null;
                    }(t, i, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t, i) {
                        const r = [];
                        for (const i of e1){
                            const e1 = [];
                            for (const r of i)e1.push(vr(r, t));
                            r.push(e1);
                        }
                        const n = new sr(r[0][0][1], "meters");
                        if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return Lr("Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, r, n);
                        if ("MultiLineString" === i.type) {
                            let e1 = 1 / 0;
                            for(let t = 0; t < i.coordinates.length; t++){
                                const o = Lr(i.coordinates[t], !0, r, n, e1);
                                if (isNaN(o)) return o;
                                if (0 === (e1 = Math.min(e1, o))) return e1;
                            }
                            return e1;
                        }
                        if ("Polygon" === i.type || "MultiPolygon" === i.type) {
                            let e1 = 1 / 0;
                            for(let t = 0; t < r.length; t++){
                                const o = kr(r[t], !0, "Polygon" === i.type ? [
                                    i.coordinates
                                ] : i.coordinates, n, e1);
                                if (isNaN(o)) return o;
                                if (0 === (e1 = Math.min(e1, o))) return e1;
                            }
                            return e1;
                        }
                        return null;
                    }(t, i, this.geometries);
                    if ("Polygon" === e1.geometryType()) return function(e1, t, i) {
                        const r = [];
                        for (const i of function(e1, t) {
                            const i = e1.length;
                            if (i <= 1) return [
                                e1
                            ];
                            const r = [];
                            let n, o;
                            for(let t = 0; t < i; t++){
                                const i = Ni(e1[t]);
                                0 !== i && (e1[t].area = Math.abs(i), void 0 === o && (o = i < 0), o === i < 0 ? (n && r.push(n), n = [
                                    e1[t]
                                ]) : n.push(e1[t]));
                            }
                            return n && r.push(n), r;
                        }(e1)){
                            const e1 = [];
                            for(let r = 0; r < i.length; ++r)e1.push(br(i[r], t));
                            r.push(e1);
                        }
                        const n = new sr(r[0][0][0][1], "meters");
                        if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return kr("Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, r, n);
                        if ("MultiLineString" === i.type) {
                            let e1 = 1 / 0;
                            for(let t = 0; t < i.coordinates.length; t++){
                                const o = kr(i.coordinates[t], !0, r, n, e1);
                                if (isNaN(o)) return o;
                                if (0 === (e1 = Math.min(e1, o))) return e1;
                            }
                            return e1;
                        }
                        return "Polygon" === i.type || "MultiPolygon" === i.type ? function(e1, t, i) {
                            let r = 1 / 0;
                            for (const n of e1)for (const e1 of t){
                                const t = zr(n, e1, i, r);
                                if (isNaN(t)) return t;
                                if (0 === (r = Math.min(r, t))) return r;
                            }
                            return r;
                        }("Polygon" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, r, n) : null;
                    }(t, i, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requirs valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
        }
        var Fr = Br;
        function Nr(e1) {
            if (e1 instanceof ki) {
                if ("get" === e1.name && 1 === e1.args.length) return !1;
                if ("feature-state" === e1.name) return !1;
                if ("has" === e1.name && 1 === e1.args.length) return !1;
                if ("properties" === e1.name || "geometry-type" === e1.name || "id" === e1.name) return !1;
                if (/^filter-/.test(e1.name)) return !1;
            }
            if (e1 instanceof nr) return !1;
            if (e1 instanceof Fr) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !Nr(e1) && (t = !1);
            }), t;
        }
        function Ur(e1) {
            if (e1 instanceof ki && "feature-state" === e1.name) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !Ur(e1) && (t = !1);
            }), t;
        }
        function Vr(e1) {
            if (e1 instanceof ki && "config" === e1.name) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !Vr(e1) && (t = !1);
            }), t;
        }
        function jr(e1, t) {
            if (e1 instanceof ki && t.indexOf(e1.name) >= 0) return !1;
            let i = !0;
            return e1.eachChild((e1)=>{
                i && !jr(e1, t) && (i = !1);
            }), i;
        }
        class Gr {
            constructor(e1, t){
                this.type = t.type, this.name = e1, this.boundExpression = t;
            }
            static parse(e1, t) {
                if (2 !== e1.length || "string" != typeof e1[1]) return t.error("'var' expression requires exactly one string literal argument.");
                const i = e1[1];
                return t.scope.has(i) ? new Gr(i, t.scope.get(i)) : t.error(`Unknown variable "${i}". Make sure "${i}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(e1) {
                return this.boundExpression.evaluate(e1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        var qr = Gr;
        class Zr {
            constructor(e1, t = [], i, r = new Ut, n = [], o){
                this.registry = e1, this.path = t, this.key = t.map((e1)=>`[${e1}]`).join(""), this.scope = r, this.errors = n, this.expectedType = i, this.options = o;
            }
            parse(e1, t, i, r, n = {}) {
                return t || i ? this.concat(t, i, r)._parse(e1, n) : this._parse(e1, n);
            }
            _parse(e1, t) {
                function i(e1, t, i) {
                    return "assert" === i ? new Ei(t, [
                        e1
                    ]) : "coerce" === i ? new zi(t, [
                        e1
                    ]) : e1;
                }
                if (null !== e1 && "string" != typeof e1 && "boolean" != typeof e1 && "number" != typeof e1 || (e1 = [
                    "literal",
                    e1
                ]), Array.isArray(e1)) {
                    if (0 === e1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const r = "string" == typeof e1[0] ? this.registry[e1[0]] : void 0;
                    if (r) {
                        let n = r.parse(e1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const e1 = this.expectedType, r = n.type;
                            if ("string" !== e1.kind && "number" !== e1.kind && "boolean" !== e1.kind && "object" !== e1.kind && "array" !== e1.kind || "value" !== r.kind) {
                                if ("color" !== e1.kind && "formatted" !== e1.kind && "resolvedImage" !== e1.kind || "value" !== r.kind && "string" !== r.kind) {
                                    if (this.checkSubtype(e1, r)) return null;
                                } else n = i(n, e1, t.typeAnnotation || "coerce");
                            } else n = i(n, e1, t.typeAnnotation || "assert");
                        }
                        if (!(n instanceof vi) && "resolvedImage" !== n.type.kind && Wr(n)) {
                            const e1 = new Di(this.options);
                            try {
                                n = new vi(n.type, n.evaluate(e1));
                            } catch (e1) {
                                return this.error(e1.message), null;
                            }
                        }
                        return n;
                    }
                    return zi.parse([
                        "to-array",
                        e1
                    ], this);
                }
                return this.error(void 0 === e1 ? "'undefined' value invalid. Use null instead." : "object" == typeof e1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof e1} instead.`);
            }
            concat(e1, t, i) {
                const r = "number" == typeof e1 ? this.path.concat(e1) : this.path, n = i ? this.scope.concat(i) : this.scope;
                return new Zr(this.registry, r, t || null, n, this.errors, this.options);
            }
            error(e1, ...t) {
                const i = `${this.key}${t.map((e1)=>`[${e1}]`).join("")}`;
                this.errors.push(new Ft(i, e1));
            }
            checkSubtype(e1, t) {
                const i = ei(e1, t);
                return i && this.error(i), i;
            }
        }
        var $r = Zr;
        function Wr(e1) {
            if (e1 instanceof qr) return Wr(e1.boundExpression);
            if (e1 instanceof ki && "error" === e1.name) return !1;
            if (e1 instanceof ki && "config" === e1.name) return !1;
            if (e1 instanceof Oi) return !1;
            if (e1 instanceof nr) return !1;
            if (e1 instanceof Fr) return !1;
            const t = e1 instanceof zi || e1 instanceof Ei;
            let i = !0;
            return e1.eachChild((e1)=>{
                i = t ? i && Wr(e1) : i && e1 instanceof vi;
            }), !!i && Nr(e1) && jr(e1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "raster-value",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center",
                "measure-light"
            ]);
        }
        function Hr(e1, t) {
            const i = e1.length - 1;
            let r, n, o = 0, s = i, a = 0;
            for(; o <= s;)if (a = Math.floor((o + s) / 2), r = e1[a], n = e1[a + 1], r <= t) {
                if (a === i || t < n) return a;
                o = a + 1;
            } else {
                if (!(r > t)) throw new bi("Input is not a number.");
                s = a - 1;
            }
            return 0;
        }
        class Xr {
            constructor(e1, t, i){
                this.type = e1, this.input = t, this.labels = [], this.outputs = [];
                for (const [e1, t] of i)this.labels.push(e1), this.outputs.push(t);
            }
            static parse(e1, t) {
                if (e1.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
                const i = t.parse(e1[1], 1, jt);
                if (!i) return null;
                const r = [];
                let n = null;
                t.expectedType && "value" !== t.expectedType.kind && (n = t.expectedType);
                for(let i = 1; i < e1.length; i += 2){
                    const o = 1 === i ? -1 / 0 : e1[i], s = e1[i + 1], a = i, l = i + 1;
                    if ("number" != typeof o) return t.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                    if (r.length && r[r.length - 1][0] >= o) return t.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                    const c = t.parse(s, l, n);
                    if (!c) return null;
                    n = n || c.type, r.push([
                        o,
                        c
                    ]);
                }
                return new Xr(n, i, r);
            }
            evaluate(e1) {
                const t = this.labels, i = this.outputs;
                if (1 === t.length) return i[0].evaluate(e1);
                const r = this.input.evaluate(e1);
                if (r <= t[0]) return i[0].evaluate(e1);
                const n = t.length;
                return r >= t[n - 1] ? i[n - 1].evaluate(e1) : i[Hr(t, r)].evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input);
                for (const t of this.outputs)e1(t);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let t = 0; t < this.labels.length; t++)t > 0 && e1.push(this.labels[t]), e1.push(this.outputs[t].serialize());
                return e1;
            }
        }
        var Yr = Xr;
        function Kr(e1, t, i) {
            return e1 * (1 - i) + t * i;
        }
        function Jr(e1, t, i) {
            return e1.map((e1, r)=>Kr(e1, t[r], i));
        }
        var Qr = Object.freeze({
            __proto__: null,
            array: Jr,
            color: function(e1, t, i) {
                return new hi(Kr(e1.r, t.r, i), Kr(e1.g, t.g, i), Kr(e1.b, t.b, i), Kr(e1.a, t.a, i));
            },
            number: Kr
        });
        const en = .95047, tn = 1.08883, rn = 4 / 29, nn = 6 / 29, on = 3 * nn * nn, sn = nn * nn * nn, an = Math.PI / 180, ln = 180 / Math.PI;
        function cn(e1) {
            return e1 > sn ? Math.pow(e1, 1 / 3) : e1 / on + rn;
        }
        function hn(e1) {
            return e1 > nn ? e1 * e1 * e1 : on * (e1 - rn);
        }
        function un(e1) {
            return 255 * (e1 <= .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, 1 / 2.4) - .055);
        }
        function dn(e1) {
            return (e1 /= 255) <= .04045 ? e1 / 12.92 : Math.pow((e1 + .055) / 1.055, 2.4);
        }
        function pn(e1) {
            const t = dn(e1.r), i = dn(e1.g), r = dn(e1.b), n = cn((.4124564 * t + .3575761 * i + .1804375 * r) / en), o = cn((.2126729 * t + .7151522 * i + .072175 * r) / 1);
            return {
                l: 116 * o - 16,
                a: 500 * (n - o),
                b: 200 * (o - cn((.0193339 * t + .119192 * i + .9503041 * r) / tn)),
                alpha: e1.a
            };
        }
        function fn(e1) {
            let t = (e1.l + 16) / 116, i = isNaN(e1.a) ? t : t + e1.a / 500, r = isNaN(e1.b) ? t : t - e1.b / 200;
            return t = 1 * hn(t), i = en * hn(i), r = tn * hn(r), new hi(un(3.2404542 * i - 1.5371385 * t - .4985314 * r), un(-0.969266 * i + 1.8760108 * t + .041556 * r), un(.0556434 * i - .2040259 * t + 1.0572252 * r), e1.alpha);
        }
        function mn(e1, t, i) {
            const r = t - e1;
            return e1 + i * (r > 180 || r < -180 ? r - 360 * Math.round(r / 360) : r);
        }
        const _n = {
            forward: pn,
            reverse: fn,
            interpolate: function(e1, t, i) {
                return {
                    l: Kr(e1.l, t.l, i),
                    a: Kr(e1.a, t.a, i),
                    b: Kr(e1.b, t.b, i),
                    alpha: Kr(e1.alpha, t.alpha, i)
                };
            }
        }, gn = {
            forward: function(e1) {
                const { l: t, a: i, b: r } = pn(e1), n = Math.atan2(r, i) * ln;
                return {
                    h: n < 0 ? n + 360 : n,
                    c: Math.sqrt(i * i + r * r),
                    l: t,
                    alpha: e1.a
                };
            },
            reverse: function(e1) {
                const t = e1.h * an, i = e1.c;
                return fn({
                    l: e1.l,
                    a: Math.cos(t) * i,
                    b: Math.sin(t) * i,
                    alpha: e1.alpha
                });
            },
            interpolate: function(e1, t, i) {
                return {
                    h: mn(e1.h, t.h, i),
                    c: Kr(e1.c, t.c, i),
                    l: Kr(e1.l, t.l, i),
                    alpha: Kr(e1.alpha, t.alpha, i)
                };
            }
        };
        var yn = Object.freeze({
            __proto__: null,
            hcl: gn,
            lab: _n
        });
        class xn {
            constructor(e1, t, i, r, n){
                this.type = e1, this.operator = t, this.interpolation = i, this.input = r, this.labels = [], this.outputs = [];
                for (const [e1, t] of n)this.labels.push(e1), this.outputs.push(t);
            }
            static interpolationFactor(e1, t, i, r) {
                let n = 0;
                if ("exponential" === e1.name) n = vn(t, e1.base, i, r);
                else if ("linear" === e1.name) n = vn(t, 1, i, r);
                else if ("cubic-bezier" === e1.name) {
                    const o = e1.controlPoints;
                    n = new m(o[0], o[1], o[2], o[3]).solve(vn(t, 1, i, r));
                }
                return n;
            }
            static parse(e1, t) {
                let [i, r, n, ...o] = e1;
                if (!Array.isArray(r) || 0 === r.length) return t.error("Expected an interpolation type expression.", 1);
                if ("linear" === r[0]) r = {
                    name: "linear"
                };
                else if ("exponential" === r[0]) {
                    const e1 = r[1];
                    if ("number" != typeof e1) return t.error("Exponential interpolation requires a numeric base.", 1, 1);
                    r = {
                        name: "exponential",
                        base: e1
                    };
                } else {
                    if ("cubic-bezier" !== r[0]) return t.error(`Unknown interpolation type ${String(r[0])}`, 1, 0);
                    {
                        const e1 = r.slice(1);
                        if (4 !== e1.length || e1.some((e1)=>"number" != typeof e1 || e1 < 0 || e1 > 1)) return t.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        r = {
                            name: "cubic-bezier",
                            controlPoints: e1
                        };
                    }
                }
                if (e1.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
                if (n = t.parse(n, 2, jt), !n) return null;
                const s = [];
                let a = null;
                "interpolate-hcl" === i || "interpolate-lab" === i ? a = Zt : t.expectedType && "value" !== t.expectedType.kind && (a = t.expectedType);
                for(let e1 = 0; e1 < o.length; e1 += 2){
                    const i = o[e1], r = o[e1 + 1], n = e1 + 3, l = e1 + 4;
                    if ("number" != typeof i) return t.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', n);
                    if (s.length && s[s.length - 1][0] >= i) return t.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', n);
                    const c = t.parse(r, l, a);
                    if (!c) return null;
                    a = a || c.type, s.push([
                        i,
                        c
                    ]);
                }
                return "number" === a.kind || "color" === a.kind || "array" === a.kind && "number" === a.itemType.kind && "number" == typeof a.N ? new xn(a, i, r, n, s) : t.error(`Type ${Jt(a)} is not interpolatable.`);
            }
            evaluate(e1) {
                const t = this.labels, i = this.outputs;
                if (1 === t.length) return i[0].evaluate(e1);
                const r = this.input.evaluate(e1);
                if (r <= t[0]) return i[0].evaluate(e1);
                const n = t.length;
                if (r >= t[n - 1]) return i[n - 1].evaluate(e1);
                const o = Hr(t, r), s = xn.interpolationFactor(this.interpolation, r, t[o], t[o + 1]), a = i[o].evaluate(e1), l = i[o + 1].evaluate(e1);
                return "interpolate" === this.operator ? Qr[this.type.kind.toLowerCase()](a, l, s) : "interpolate-hcl" === this.operator ? gn.reverse(gn.interpolate(gn.forward(a), gn.forward(l), s)) : _n.reverse(_n.interpolate(_n.forward(a), _n.forward(l), s));
            }
            eachChild(e1) {
                e1(this.input);
                for (const t of this.outputs)e1(t);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                let e1;
                e1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier"
                ].concat(this.interpolation.controlPoints);
                const t = [
                    this.operator,
                    e1,
                    this.input.serialize()
                ];
                for(let e1 = 0; e1 < this.labels.length; e1++)t.push(this.labels[e1], this.outputs[e1].serialize());
                return t;
            }
        }
        function vn(e1, t, i, r) {
            const n = r - i, o = e1 - i;
            return 0 === n ? 0 : 1 === t ? o / n : (Math.pow(t, o) - 1) / (Math.pow(t, n) - 1);
        }
        var bn = xn;
        class wn {
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expectected at least one argument.");
                let i = null;
                const r = t.expectedType;
                r && "value" !== r.kind && (i = r);
                const n = [];
                for (const r of e1.slice(1)){
                    const e1 = t.parse(r, 1 + n.length, i, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!e1) return null;
                    i = i || e1.type, n.push(e1);
                }
                const o = r && n.some((e1)=>ei(r, e1.type));
                return new wn(o ? Wt : i, n);
            }
            evaluate(e1) {
                let t, i = null, r = 0;
                for (const n of this.args){
                    if (r++, i = n.evaluate(e1), i && i instanceof fi && !i.available && (t || (t = i), i = null, r === this.args.length)) return t;
                    if (null !== i) break;
                }
                return i;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "coalesce"
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
        }
        var Tn = wn;
        class En {
            constructor(e1, t){
                this.type = t.type, this.bindings = [].concat(e1), this.result = t;
            }
            evaluate(e1) {
                return this.result.evaluate(e1);
            }
            eachChild(e1) {
                for (const t of this.bindings)e1(t[1]);
                e1(this.result);
            }
            static parse(e1, t) {
                if (e1.length < 4) return t.error(`Expected at least 3 arguments, but found ${e1.length - 1} instead.`);
                const i = [];
                for(let r = 1; r < e1.length - 1; r += 2){
                    const n = e1[r];
                    if ("string" != typeof n) return t.error(`Expected string, but found ${typeof n} instead.`, r);
                    if (/[^a-zA-Z0-9_]/.test(n)) return t.error("Variable names must contain only alphanumeric characters or '_'.", r);
                    const o = t.parse(e1[r + 1], r + 1);
                    if (!o) return null;
                    i.push([
                        n,
                        o
                    ]);
                }
                const r = t.parse(e1[e1.length - 1], e1.length - 1, t.expectedType, i);
                return r ? new En(i, r) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const e1 = [
                    "let"
                ];
                for (const [t, i] of this.bindings)e1.push(t, i.serialize());
                return e1.push(this.result.serialize()), e1;
            }
        }
        var Mn = En;
        class An {
            constructor(e1, t, i){
                this.type = e1, this.index = t, this.input = i;
            }
            static parse(e1, t) {
                if (3 !== e1.length) return t.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, jt), r = t.parse(e1[2], 2, Kt(t.expectedType || Wt));
                return i && r ? new An(r.type.itemType, i, r) : null;
            }
            evaluate(e1) {
                const t = this.index.evaluate(e1), i = this.input.evaluate(e1);
                if (t < 0) throw new bi(`Array index out of bounds: ${t} < 0.`);
                if (t >= i.length) throw new bi(`Array index out of bounds: ${t} > ${i.length - 1}.`);
                if (t !== Math.floor(t)) throw new bi(`Array index must be an integer, but found ${t} instead.`);
                return i[t];
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        var Sn = An;
        class In {
            constructor(e1, t){
                this.type = qt, this.needle = e1, this.haystack = t;
            }
            static parse(e1, t) {
                if (3 !== e1.length) return t.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, Wt), r = t.parse(e1[2], 2, Wt);
                return i && r ? ti(i.type, [
                    qt,
                    Gt,
                    jt,
                    Vt,
                    Wt
                ]) ? new In(i, r) : t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(i.type)} instead`) : null;
            }
            evaluate(e1) {
                const t = this.needle.evaluate(e1), i = this.haystack.evaluate(e1);
                if (null == i) return !1;
                if (!ii(t, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new bi(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(gi(t))} instead.`);
                if (!ii(i, [
                    "string",
                    "array"
                ])) throw new bi(`Expected second argument to be of type array or string, but found ${Jt(gi(i))} instead.`);
                return i.indexOf(t) >= 0;
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        var Cn = In;
        class zn {
            constructor(e1, t, i){
                this.type = jt, this.needle = e1, this.haystack = t, this.fromIndex = i;
            }
            static parse(e1, t) {
                if (e1.length <= 2 || e1.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, Wt), r = t.parse(e1[2], 2, Wt);
                if (!i || !r) return null;
                if (!ti(i.type, [
                    qt,
                    Gt,
                    jt,
                    Vt,
                    Wt
                ])) return t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(i.type)} instead`);
                if (4 === e1.length) {
                    const n = t.parse(e1[3], 3, jt);
                    return n ? new zn(i, r, n) : null;
                }
                return new zn(i, r);
            }
            evaluate(e1) {
                const t = this.needle.evaluate(e1), i = this.haystack.evaluate(e1);
                if (!ii(t, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new bi(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(gi(t))} instead.`);
                if (!ii(i, [
                    "string",
                    "array"
                ])) throw new bi(`Expected second argument to be of type array or string, but found ${Jt(gi(i))} instead.`);
                if (this.fromIndex) {
                    const r = this.fromIndex.evaluate(e1);
                    return i.indexOf(t, r);
                }
                return i.indexOf(t);
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack), this.fromIndex && e1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const e1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        e1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        var Pn = zn;
        class Dn {
            constructor(e1, t, i, r, n, o){
                this.inputType = e1, this.type = t, this.input = i, this.cases = r, this.outputs = n, this.otherwise = o;
            }
            static parse(e1, t) {
                if (e1.length < 5) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 1) return t.error("Expected an even number of arguments.");
                let i, r;
                t.expectedType && "value" !== t.expectedType.kind && (r = t.expectedType);
                const n = {}, o = [];
                for(let s = 2; s < e1.length - 1; s += 2){
                    let a = e1[s];
                    const l = e1[s + 1];
                    Array.isArray(a) || (a = [
                        a
                    ]);
                    const c = t.concat(s);
                    if (0 === a.length) return c.error("Expected at least one branch label.");
                    for (const e1 of a){
                        if ("number" != typeof e1 && "string" != typeof e1) return c.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof e1 && Math.abs(e1) > Number.MAX_SAFE_INTEGER) return c.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof e1 && Math.floor(e1) !== e1) return c.error("Numeric branch labels must be integer values.");
                        if (i) {
                            if (c.checkSubtype(i, gi(e1))) return null;
                        } else i = gi(e1);
                        if (void 0 !== n[String(e1)]) return c.error("Branch labels must be unique.");
                        n[String(e1)] = o.length;
                    }
                    const h = t.parse(l, s, r);
                    if (!h) return null;
                    r = r || h.type, o.push(h);
                }
                const s = t.parse(e1[1], 1, Wt);
                if (!s) return null;
                const a = t.parse(e1[e1.length - 1], e1.length - 1, r);
                return a ? "value" !== s.type.kind && t.concat(1).checkSubtype(i, s.type) ? null : new Dn(i, r, s, n, o, a) : null;
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1);
                return (gi(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input), this.outputs.forEach(e1), e1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "match",
                    this.input.serialize()
                ], t = Object.keys(this.cases).sort(), i = [], r = {};
                for (const e1 of t){
                    const t = r[this.cases[e1]];
                    void 0 === t ? (r[this.cases[e1]] = i.length, i.push([
                        this.cases[e1],
                        [
                            e1
                        ]
                    ])) : i[t][1].push(e1);
                }
                const n = (e1)=>"number" === this.inputType.kind ? Number(e1) : e1;
                for (const [t, r] of i)e1.push(1 === r.length ? n(r[0]) : r.map(n)), e1.push(this.outputs[t].serialize());
                return e1.push(this.otherwise.serialize()), e1;
            }
        }
        var Rn = Dn;
        class Ln {
            constructor(e1, t, i){
                this.type = e1, this.branches = t, this.otherwise = i;
            }
            static parse(e1, t) {
                if (e1.length < 4) return t.error(`Expected at least 3 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 0) return t.error("Expected an odd number of arguments.");
                let i;
                t.expectedType && "value" !== t.expectedType.kind && (i = t.expectedType);
                const r = [];
                for(let n = 1; n < e1.length - 1; n += 2){
                    const o = t.parse(e1[n], n, qt);
                    if (!o) return null;
                    const s = t.parse(e1[n + 1], n + 1, i);
                    if (!s) return null;
                    r.push([
                        o,
                        s
                    ]), i = i || s.type;
                }
                const n = t.parse(e1[e1.length - 1], e1.length - 1, i);
                return n ? new Ln(i, r, n) : null;
            }
            evaluate(e1) {
                for (const [t, i] of this.branches)if (t.evaluate(e1)) return i.evaluate(e1);
                return this.otherwise.evaluate(e1);
            }
            eachChild(e1) {
                for (const [t, i] of this.branches)e1(t), e1(i);
                e1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([e1, t])=>t.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "case"
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
        }
        var kn = Ln;
        class On {
            constructor(e1, t, i, r){
                this.type = e1, this.input = t, this.beginIndex = i, this.endIndex = r;
            }
            static parse(e1, t) {
                if (e1.length <= 2 || e1.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, Wt), r = t.parse(e1[2], 2, jt);
                if (!i || !r) return null;
                if (!ti(i.type, [
                    Kt(Wt),
                    Gt,
                    Wt
                ])) return t.error(`Expected first argument to be of type array or string, but found ${Jt(i.type)} instead`);
                if (4 === e1.length) {
                    const n = t.parse(e1[3], 3, jt);
                    return n ? new On(i.type, i, r, n) : null;
                }
                return new On(i.type, i, r);
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1), i = this.beginIndex.evaluate(e1);
                if (!ii(t, [
                    "string",
                    "array"
                ])) throw new bi(`Expected first argument to be of type array or string, but found ${Jt(gi(t))} instead.`);
                if (this.endIndex) {
                    const r = this.endIndex.evaluate(e1);
                    return t.slice(i, r);
                }
                return t.slice(i);
            }
            eachChild(e1) {
                e1(this.input), e1(this.beginIndex), this.endIndex && e1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const e1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        e1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        var Bn = On;
        function Fn(e1, t) {
            return "==" === e1 || "!=" === e1 ? "boolean" === t.kind || "string" === t.kind || "number" === t.kind || "null" === t.kind || "value" === t.kind : "string" === t.kind || "number" === t.kind || "value" === t.kind;
        }
        function Nn(e1, t, i, r) {
            return 0 === r.compare(t, i);
        }
        function Un(e1, t, i) {
            const r = "==" !== e1 && "!=" !== e1;
            return class n {
                constructor(e1, t, i){
                    this.type = qt, this.lhs = e1, this.rhs = t, this.collator = i, this.hasUntypedArgument = "value" === e1.type.kind || "value" === t.type.kind;
                }
                static parse(e1, t) {
                    if (3 !== e1.length && 4 !== e1.length) return t.error("Expected two or three arguments.");
                    const i = e1[0];
                    let o = t.parse(e1[1], 1, Wt);
                    if (!o) return null;
                    if (!Fn(i, o.type)) return t.concat(1).error(`"${i}" comparisons are not supported for type '${Jt(o.type)}'.`);
                    let s = t.parse(e1[2], 2, Wt);
                    if (!s) return null;
                    if (!Fn(i, s.type)) return t.concat(2).error(`"${i}" comparisons are not supported for type '${Jt(s.type)}'.`);
                    if (o.type.kind !== s.type.kind && "value" !== o.type.kind && "value" !== s.type.kind) return t.error(`Cannot compare types '${Jt(o.type)}' and '${Jt(s.type)}'.`);
                    r && ("value" === o.type.kind && "value" !== s.type.kind ? o = new Ei(s.type, [
                        o
                    ]) : "value" !== o.type.kind && "value" === s.type.kind && (s = new Ei(o.type, [
                        s
                    ])));
                    let a = null;
                    if (4 === e1.length) {
                        if ("string" !== o.type.kind && "string" !== s.type.kind && "value" !== o.type.kind && "value" !== s.type.kind) return t.error("Cannot use collator to compare non-string types.");
                        if (a = t.parse(e1[3], 3, Ht), !a) return null;
                    }
                    return new n(o, s, a);
                }
                evaluate(n) {
                    const o = this.lhs.evaluate(n), s = this.rhs.evaluate(n);
                    if (r && this.hasUntypedArgument) {
                        const t = gi(o), i = gi(s);
                        if (t.kind !== i.kind || "string" !== t.kind && "number" !== t.kind) throw new bi(`Expected arguments for "${e1}" to be (string, string) or (number, number), but found (${t.kind}, ${i.kind}) instead.`);
                    }
                    if (this.collator && !r && this.hasUntypedArgument) {
                        const e1 = gi(o), i = gi(s);
                        if ("string" !== e1.kind || "string" !== i.kind) return t(n, o, s);
                    }
                    return this.collator ? i(n, o, s, this.collator.evaluate(n)) : t(n, o, s);
                }
                eachChild(e1) {
                    e1(this.lhs), e1(this.rhs), this.collator && e1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const t = [
                        e1
                    ];
                    return this.eachChild((e1)=>{
                        t.push(e1.serialize());
                    }), t;
                }
            };
        }
        const Vn = Un("==", function(e1, t, i) {
            return t === i;
        }, Nn), jn = Un("!=", function(e1, t, i) {
            return t !== i;
        }, function(e1, t, i, r) {
            return !Nn(0, t, i, r);
        }), Gn = Un("<", function(e1, t, i) {
            return t < i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) < 0;
        }), qn = Un(">", function(e1, t, i) {
            return t > i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) > 0;
        }), Zn = Un("<=", function(e1, t, i) {
            return t <= i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) <= 0;
        }), $n = Un(">=", function(e1, t, i) {
            return t >= i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) >= 0;
        });
        class Wn {
            constructor(e1, t, i, r, n, o){
                this.type = Gt, this.number = e1, this.locale = t, this.currency = i, this.unit = r, this.minFractionDigits = n, this.maxFractionDigits = o;
            }
            static parse(e1, t) {
                if (3 !== e1.length) return t.error("Expected two arguments.");
                const i = t.parse(e1[1], 1, jt);
                if (!i) return null;
                const r = e1[2];
                if ("object" != typeof r || Array.isArray(r)) return t.error("NumberFormat options argument must be an object.");
                let n = null;
                if (r.locale && (n = t.parse(r.locale, 1, Gt), !n)) return null;
                let o = null;
                if (r.currency && (o = t.parse(r.currency, 1, Gt), !o)) return null;
                let s = null;
                if (r.unit && (s = t.parse(r.unit, 1, Gt), !s)) return null;
                let a = null;
                if (r["min-fraction-digits"] && (a = t.parse(r["min-fraction-digits"], 1, jt), !a)) return null;
                let l = null;
                return r["max-fraction-digits"] && (l = t.parse(r["max-fraction-digits"], 1, jt), !l) ? null : new Wn(i, n, o, s, a, l);
            }
            evaluate(e1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(e1) : void 0,
                    unit: this.unit ? this.unit.evaluate(e1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e1) : void 0
                }).format(this.number.evaluate(e1));
            }
            eachChild(e1) {
                e1(this.number), this.locale && e1(this.locale), this.currency && e1(this.currency), this.unit && e1(this.unit), this.minFractionDigits && e1(this.minFractionDigits), this.maxFractionDigits && e1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return this.locale && (e1.locale = this.locale.serialize()), this.currency && (e1.currency = this.currency.serialize()), this.unit && (e1.unit = this.unit.serialize()), this.minFractionDigits && (e1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (e1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    e1
                ];
            }
        }
        class Hn {
            constructor(e1){
                this.type = jt, this.input = e1;
            }
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`Expected 1 argument, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1);
                return i ? "array" !== i.type.kind && "string" !== i.type.kind && "value" !== i.type.kind ? t.error(`Expected argument of type string or array, but found ${Jt(i.type)} instead.`) : new Hn(i) : null;
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1);
                if ("string" == typeof t) return t.length;
                if (Array.isArray(t)) return t.length;
                throw new bi(`Expected value to be of type string or array, but found ${Jt(gi(t))} instead.`);
            }
            eachChild(e1) {
                e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "length"
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
        }
        function Xn(e1) {
            return function() {
                e1 = 1831565813 + (e1 |= 0) | 0;
                let t = Math.imul(e1 ^ e1 >>> 15, 1 | e1);
                return t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t, ((t ^ t >>> 14) >>> 0) / 4294967296;
            };
        }
        const Yn = {
            "==": Vn,
            "!=": jn,
            ">": qn,
            "<": Gn,
            ">=": $n,
            "<=": Zn,
            array: Ei,
            at: Sn,
            boolean: Ei,
            case: kn,
            coalesce: Tn,
            collator: Oi,
            format: Mi,
            image: Ai,
            in: Cn,
            "index-of": Pn,
            interpolate: bn,
            "interpolate-hcl": bn,
            "interpolate-lab": bn,
            length: Hn,
            let: Mn,
            literal: vi,
            match: Rn,
            number: Ei,
            "number-format": Wn,
            object: Ei,
            slice: Bn,
            step: Yr,
            string: Ei,
            "to-boolean": zi,
            "to-color": zi,
            "to-number": zi,
            "to-string": zi,
            var: qr,
            within: nr,
            distance: Fr
        };
        function Kn(e1, [t, i, r, n]) {
            t = t.evaluate(e1), i = i.evaluate(e1), r = r.evaluate(e1);
            const o = n ? n.evaluate(e1) : 1, s = mi(t, i, r, o);
            if (s) throw new bi(s);
            return new hi(t / 255 * o, i / 255 * o, r / 255 * o, o);
        }
        function Jn(e1, [t, i, r, n]) {
            t = t.evaluate(e1), i = i.evaluate(e1), r = r.evaluate(e1);
            const o = n ? n.evaluate(e1) : 1, s = function(e1, t, i, r) {
                return "number" == typeof e1 && e1 >= 0 && e1 <= 360 ? "number" == typeof t && t >= 0 && t <= 100 && "number" == typeof i && i >= 0 && i <= 100 ? void 0 === r || "number" == typeof r && r >= 0 && r <= 1 ? null : `Invalid hsla value [${[
                    e1,
                    t,
                    i,
                    r
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof r ? [
                    e1,
                    t,
                    i,
                    r
                ] : [
                    e1,
                    t,
                    i
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof r ? [
                    e1,
                    t,
                    i,
                    r
                ] : [
                    e1,
                    t,
                    i
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(t, i, r, o);
            if (s) throw new bi(s);
            const a = `hsla(${t}, ${i}%, ${r}%, ${o})`, l = hi.parse(a);
            if (!l) throw new bi(`Failed to parse HSLA color: ${a}`);
            return l;
        }
        function Qn(e1, t) {
            return e1 in t;
        }
        function eo(e1, t) {
            const i = t[e1];
            return void 0 === i ? null : i;
        }
        function to(e1, t) {
            switch(e1){
                case "string":
                    return String(t);
                case "number":
                    return +t;
                case "boolean":
                    return !!t;
                case "color":
                    return hi.parse(t);
            }
            return t;
        }
        function io(e1, t, i, r) {
            return void 0 !== r && (e1 = r * Math.round(e1 / r)), void 0 !== t && e1 < t && (e1 = t), void 0 !== i && e1 > i && (e1 = i), e1;
        }
        function ro(e1, t, i) {
            i.length && (t += `${i}`);
            const r = e1.getConfig(t);
            if (!r) return null;
            const { type: n, value: o, values: s, minValue: a, maxValue: l, stepValue: c } = r, h = r.default.evaluate(e1);
            let u = o ? o.evaluate(e1) : h;
            return n && (u = to(n, u)), void 0 !== o && void 0 !== u && s && !s.includes(u) && (u = h, n && (u = to(n, u))), void 0 === u || void 0 === a && void 0 === l && void 0 === c || ("number" == typeof u ? u = io(u, a, l, c) : Array.isArray(u) && (u = u.map((e1)=>"number" == typeof e1 ? io(e1, a, l, c) : e1))), u;
        }
        function no(e1) {
            return {
                type: e1
            };
        }
        ki.register(Yn, {
            error: [
                {
                    kind: "error"
                },
                [
                    Gt
                ],
                (e1, [t])=>{
                    throw new bi(t.evaluate(e1));
                }
            ],
            typeof: [
                Gt,
                [
                    Wt
                ],
                (e1, [t])=>Jt(gi(t.evaluate(e1)))
            ],
            "to-rgba": [
                Kt(jt, 4),
                [
                    Zt
                ],
                (e1, [t])=>t.evaluate(e1).toArray()
            ],
            rgb: [
                Zt,
                [
                    jt,
                    jt,
                    jt
                ],
                Kn
            ],
            rgba: [
                Zt,
                [
                    jt,
                    jt,
                    jt,
                    jt
                ],
                Kn
            ],
            hsl: [
                Zt,
                [
                    jt,
                    jt,
                    jt
                ],
                Jn
            ],
            hsla: [
                Zt,
                [
                    jt,
                    jt,
                    jt,
                    jt
                ],
                Jn
            ],
            has: {
                type: qt,
                overloads: [
                    [
                        [
                            Gt
                        ],
                        (e1, [t])=>Qn(t.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Gt,
                            $t
                        ],
                        (e1, [t, i])=>Qn(t.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            get: {
                type: Wt,
                overloads: [
                    [
                        [
                            Gt
                        ],
                        (e1, [t])=>eo(t.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Gt,
                            $t
                        ],
                        (e1, [t, i])=>eo(t.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            config: {
                type: Wt,
                overloads: [
                    [
                        [
                            Gt
                        ],
                        (e1, [t])=>ro(e1, t.evaluate(e1), "")
                    ],
                    [
                        [
                            Gt,
                            Gt
                        ],
                        (e1, [t, i])=>ro(e1, t.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            "feature-state": [
                Wt,
                [
                    Gt
                ],
                (e1, [t])=>eo(t.evaluate(e1), e1.featureState || {})
            ],
            properties: [
                $t,
                [],
                (e1)=>e1.properties()
            ],
            "geometry-type": [
                Gt,
                [],
                (e1)=>e1.geometryType()
            ],
            id: [
                Wt,
                [],
                (e1)=>e1.id()
            ],
            zoom: [
                jt,
                [],
                (e1)=>e1.globals.zoom
            ],
            pitch: [
                jt,
                [],
                (e1)=>e1.globals.pitch || 0
            ],
            "distance-from-center": [
                jt,
                [],
                (e1)=>e1.distanceFromCenter()
            ],
            "measure-light": [
                jt,
                [
                    Gt
                ],
                (e1, [t])=>e1.measureLight(t.evaluate(e1))
            ],
            "heatmap-density": [
                jt,
                [],
                (e1)=>e1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                jt,
                [],
                (e1)=>e1.globals.lineProgress || 0
            ],
            "raster-value": [
                jt,
                [],
                (e1)=>e1.globals.rasterValue || 0
            ],
            "sky-radial-progress": [
                jt,
                [],
                (e1)=>e1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                Wt,
                [],
                (e1)=>void 0 === e1.globals.accumulated ? null : e1.globals.accumulated
            ],
            "+": [
                jt,
                no(jt),
                (e1, t)=>{
                    let i = 0;
                    for (const r of t)i += r.evaluate(e1);
                    return i;
                }
            ],
            "*": [
                jt,
                no(jt),
                (e1, t)=>{
                    let i = 1;
                    for (const r of t)i *= r.evaluate(e1);
                    return i;
                }
            ],
            "-": {
                type: jt,
                overloads: [
                    [
                        [
                            jt,
                            jt
                        ],
                        (e1, [t, i])=>t.evaluate(e1) - i.evaluate(e1)
                    ],
                    [
                        [
                            jt
                        ],
                        (e1, [t])=>-t.evaluate(e1)
                    ]
                ]
            },
            "/": [
                jt,
                [
                    jt,
                    jt
                ],
                (e1, [t, i])=>t.evaluate(e1) / i.evaluate(e1)
            ],
            "%": [
                jt,
                [
                    jt,
                    jt
                ],
                (e1, [t, i])=>t.evaluate(e1) % i.evaluate(e1)
            ],
            ln2: [
                jt,
                [],
                ()=>Math.LN2
            ],
            pi: [
                jt,
                [],
                ()=>Math.PI
            ],
            e: [
                jt,
                [],
                ()=>Math.E
            ],
            "^": [
                jt,
                [
                    jt,
                    jt
                ],
                (e1, [t, i])=>Math.pow(t.evaluate(e1), i.evaluate(e1))
            ],
            sqrt: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.sqrt(t.evaluate(e1))
            ],
            log10: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN10
            ],
            ln: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.log(t.evaluate(e1))
            ],
            log2: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN2
            ],
            sin: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.sin(t.evaluate(e1))
            ],
            cos: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.cos(t.evaluate(e1))
            ],
            tan: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.tan(t.evaluate(e1))
            ],
            asin: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.asin(t.evaluate(e1))
            ],
            acos: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.acos(t.evaluate(e1))
            ],
            atan: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.atan(t.evaluate(e1))
            ],
            min: [
                jt,
                no(jt),
                (e1, t)=>Math.min(...t.map((t)=>t.evaluate(e1)))
            ],
            max: [
                jt,
                no(jt),
                (e1, t)=>Math.max(...t.map((t)=>t.evaluate(e1)))
            ],
            abs: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.abs(t.evaluate(e1))
            ],
            round: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>{
                    const i = t.evaluate(e1);
                    return i < 0 ? -Math.round(-i) : Math.round(i);
                }
            ],
            floor: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.floor(t.evaluate(e1))
            ],
            ceil: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.ceil(t.evaluate(e1))
            ],
            "filter-==": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>e1.properties()[t.value] === i.value
            ],
            "filter-id-==": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>e1.id() === t.value
            ],
            "filter-type-==": [
                qt,
                [
                    Gt
                ],
                (e1, [t])=>e1.geometryType() === t.value
            ],
            "filter-<": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter-id-<": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i < r;
                }
            ],
            "filter->": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-id->": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i > r;
                }
            ],
            "filter-<=": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter-id-<=": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i <= r;
                }
            ],
            "filter->=": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-id->=": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i >= r;
                }
            ],
            "filter-has": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>t.value in e1.properties()
            ],
            "filter-has-id": [
                qt,
                [],
                (e1)=>null !== e1.id() && void 0 !== e1.id()
            ],
            "filter-type-in": [
                qt,
                [
                    Kt(Gt)
                ],
                (e1, [t])=>t.value.indexOf(e1.geometryType()) >= 0
            ],
            "filter-id-in": [
                qt,
                [
                    Kt(Wt)
                ],
                (e1, [t])=>t.value.indexOf(e1.id()) >= 0
            ],
            "filter-in-small": [
                qt,
                [
                    Gt,
                    Kt(Wt)
                ],
                (e1, [t, i])=>i.value.indexOf(e1.properties()[t.value]) >= 0
            ],
            "filter-in-large": [
                qt,
                [
                    Gt,
                    Kt(Wt)
                ],
                (e1, [t, i])=>(function(e1, t, i, r) {
                        for(; i <= r;){
                            const n = i + r >> 1;
                            if (t[n] === e1) return !0;
                            t[n] > e1 ? r = n - 1 : i = n + 1;
                        }
                        return !1;
                    })(e1.properties()[t.value], i.value, 0, i.value.length - 1)
            ],
            all: {
                type: qt,
                overloads: [
                    [
                        [
                            qt,
                            qt
                        ],
                        (e1, [t, i])=>t.evaluate(e1) && i.evaluate(e1)
                    ],
                    [
                        no(qt),
                        (e1, t)=>{
                            for (const i of t)if (!i.evaluate(e1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: qt,
                overloads: [
                    [
                        [
                            qt,
                            qt
                        ],
                        (e1, [t, i])=>t.evaluate(e1) || i.evaluate(e1)
                    ],
                    [
                        no(qt),
                        (e1, t)=>{
                            for (const i of t)if (i.evaluate(e1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                qt,
                [
                    qt
                ],
                (e1, [t])=>!t.evaluate(e1)
            ],
            "is-supported-script": [
                qt,
                [
                    Gt
                ],
                (e1, [t])=>{
                    const i = e1.globals && e1.globals.isSupportedScript;
                    return !i || i(t.evaluate(e1));
                }
            ],
            upcase: [
                Gt,
                [
                    Gt
                ],
                (e1, [t])=>t.evaluate(e1).toUpperCase()
            ],
            downcase: [
                Gt,
                [
                    Gt
                ],
                (e1, [t])=>t.evaluate(e1).toLowerCase()
            ],
            concat: [
                Gt,
                no(Wt),
                (e1, t)=>t.map((t)=>yi(t.evaluate(e1))).join("")
            ],
            "resolved-locale": [
                Gt,
                [
                    Ht
                ],
                (e1, [t])=>t.evaluate(e1).resolvedLocale()
            ],
            random: [
                jt,
                [
                    jt,
                    jt,
                    Wt
                ],
                (e1, t)=>{
                    const [i, r, n] = t.map((t)=>t.evaluate(e1));
                    if (i > r) return i;
                    if (i === r) return i;
                    let o;
                    if ("string" == typeof n) o = function(e1) {
                        let t = 0;
                        if (0 === e1.length) return t;
                        for(let i = 0; i < e1.length; i++)t = (t << 5) - t + e1.charCodeAt(i), t &= t;
                        return t;
                    }(n);
                    else {
                        if ("number" != typeof n) throw new bi(`Invalid seed input: ${n}`);
                        o = n;
                    }
                    return i + Xn(o)() * (r - i);
                }
            ]
        });
        var oo = Yn;
        function so(e1) {
            return {
                result: "success",
                value: e1
            };
        }
        function ao(e1) {
            return {
                result: "error",
                value: e1
            };
        }
        function lo(e1, t) {
            return !!e1 && !!e1.parameters && e1.parameters.indexOf(t) > -1;
        }
        function co(e1) {
            return "data-driven" === e1["property-type"];
        }
        function ho(e1) {
            return lo(e1.expression, "measure-light");
        }
        function uo(e1) {
            return lo(e1.expression, "zoom");
        }
        function po(e1) {
            return !!e1.expression && e1.expression.interpolated;
        }
        function fo(e1) {
            return "object" == typeof e1 && null !== e1 && !Array.isArray(e1);
        }
        function mo(e1) {
            return e1;
        }
        function _o(e1, t) {
            const i = "color" === t.type, r = e1.stops && "object" == typeof e1.stops[0][0], n = r || !(r || void 0 !== e1.property), o = e1.type || (po(t) ? "exponential" : "interval");
            if (i && ((e1 = Lt({}, e1)).stops && (e1.stops = e1.stops.map((e1)=>[
                    e1[0],
                    hi.parse(e1[1])
                ])), e1.default = hi.parse(e1.default ? e1.default : t.default)), e1.colorSpace && "rgb" !== e1.colorSpace && !yn[e1.colorSpace]) throw new Error(`Unknown color space: ${e1.colorSpace}`);
            let s, a, l;
            if ("exponential" === o) s = vo;
            else if ("interval" === o) s = xo;
            else if ("categorical" === o) {
                s = yo, a = Object.create(null);
                for (const t of e1.stops)a[t[0]] = t[1];
                l = typeof e1.stops[0][0];
            } else {
                if ("identity" !== o) throw new Error(`Unknown function type "${o}"`);
                s = bo;
            }
            if (r) {
                const i = {}, r = [];
                for(let t = 0; t < e1.stops.length; t++){
                    const n = e1.stops[t], o = n[0].zoom;
                    void 0 === i[o] && (i[o] = {
                        zoom: o,
                        type: e1.type,
                        property: e1.property,
                        default: e1.default,
                        stops: []
                    }, r.push(o)), i[o].stops.push([
                        n[0].value,
                        n[1]
                    ]);
                }
                const n = [];
                for (const e1 of r)n.push([
                    i[e1].zoom,
                    _o(i[e1], t)
                ]);
                const o = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: o,
                    interpolationFactor: bn.interpolationFactor.bind(void 0, o),
                    zoomStops: n.map((e1)=>e1[0]),
                    evaluate: ({ zoom: i }, r)=>vo({
                            stops: n,
                            base: e1.base
                        }, t, i).evaluate(i, r)
                };
            }
            if (n) {
                const i = "exponential" === o ? {
                    name: "exponential",
                    base: void 0 !== e1.base ? e1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: i,
                    interpolationFactor: bn.interpolationFactor.bind(void 0, i),
                    zoomStops: e1.stops.map((e1)=>e1[0]),
                    evaluate: ({ zoom: i })=>s(e1, t, i, a, l)
                };
            }
            return {
                kind: "source",
                evaluate (i, r) {
                    const n = r && r.properties ? r.properties[e1.property] : void 0;
                    return void 0 === n ? go(e1.default, t.default) : s(e1, t, n, a, l);
                }
            };
        }
        function go(e1, t, i) {
            return void 0 !== e1 ? e1 : void 0 !== t ? t : void 0 !== i ? i : void 0;
        }
        function yo(e1, t, i, r, n) {
            return go(typeof i === n ? r[i] : void 0, e1.default, t.default);
        }
        function xo(e1, t, i) {
            if ("number" !== Si(i)) return go(e1.default, t.default);
            const r = e1.stops.length;
            if (1 === r) return e1.stops[0][1];
            if (i <= e1.stops[0][0]) return e1.stops[0][1];
            if (i >= e1.stops[r - 1][0]) return e1.stops[r - 1][1];
            const n = Hr(e1.stops.map((e1)=>e1[0]), i);
            return e1.stops[n][1];
        }
        function vo(e1, t, i) {
            const r = void 0 !== e1.base ? e1.base : 1;
            if ("number" !== Si(i)) return go(e1.default, t.default);
            const n = e1.stops.length;
            if (1 === n) return e1.stops[0][1];
            if (i <= e1.stops[0][0]) return e1.stops[0][1];
            if (i >= e1.stops[n - 1][0]) return e1.stops[n - 1][1];
            const o = Hr(e1.stops.map((e1)=>e1[0]), i), s = function(e1, t, i, r) {
                const n = r - i, o = e1 - i;
                return 0 === n ? 0 : 1 === t ? o / n : (Math.pow(t, o) - 1) / (Math.pow(t, n) - 1);
            }(i, r, e1.stops[o][0], e1.stops[o + 1][0]), a = e1.stops[o][1], l = e1.stops[o + 1][1];
            let c = Qr[t.type] || mo;
            if (e1.colorSpace && "rgb" !== e1.colorSpace) {
                const t = yn[e1.colorSpace];
                c = (e1, i)=>t.reverse(t.interpolate(t.forward(e1), t.forward(i), s));
            }
            return "function" == typeof a.evaluate ? {
                evaluate (...e1) {
                    const t = a.evaluate.apply(void 0, e1), i = l.evaluate.apply(void 0, e1);
                    if (void 0 !== t && void 0 !== i) return c(t, i, s);
                }
            } : c(a, l, s);
        }
        function bo(e1, t, i) {
            return "color" === t.type ? i = hi.parse(i) : "formatted" === t.type ? i = pi.fromString(i.toString()) : "resolvedImage" === t.type ? i = fi.fromString(i.toString()) : Si(i) === t.type || "enum" === t.type && t.values[i] || (i = void 0), go(i, e1.default, t.default);
        }
        class wo {
            constructor(e1, t, i){
                this.expression = e1, this._warningHistory = {}, this._evaluator = new Di(i), this._defaultValue = t ? function(e1) {
                    return "color" === e1.type && (fo(e1.default) || Array.isArray(e1.default)) ? new hi(0, 0, 0, 0) : "color" === e1.type ? hi.parse(e1.default) || null : void 0 === e1.default ? null : e1.default;
                }(t) : null, this._enumValues = t && "enum" === t.type ? t.values : null;
            }
            evaluateWithoutErrorHandling(e1, t, i, r, n, o, s, a) {
                return this._evaluator.globals = e1, this._evaluator.feature = t, this._evaluator.featureState = i, this._evaluator.canonical = r || null, this._evaluator.availableImages = n || null, this._evaluator.formattedSection = o, this._evaluator.featureTileCoord = s || null, this._evaluator.featureDistanceData = a || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(e1, t, i, r, n, o, s, a) {
                this._evaluator.globals = e1, this._evaluator.feature = t || null, this._evaluator.featureState = i || null, this._evaluator.canonical = r || null, this._evaluator.availableImages = n || null, this._evaluator.formattedSection = o || null, this._evaluator.featureTileCoord = s || null, this._evaluator.featureDistanceData = a || null;
                try {
                    const e1 = this.expression.evaluate(this._evaluator);
                    if (null == e1 || "number" == typeof e1 && e1 != e1) return this._defaultValue;
                    if (this._enumValues && !(e1 in this._enumValues)) throw new bi(`Expected value to be one of ${Object.keys(this._enumValues).map((e1)=>JSON.stringify(e1)).join(", ")}, but found ${JSON.stringify(e1)} instead.`);
                    return e1;
                } catch (e1) {
                    return this._warningHistory[e1.message] || (this._warningHistory[e1.message] = !0, "undefined" != typeof console && console.warn(e1.message)), this._defaultValue;
                }
            }
        }
        function To(e1) {
            return Array.isArray(e1) && e1.length > 0 && "string" == typeof e1[0] && e1[0] in oo;
        }
        function Eo(e1, t, i) {
            const r = new $r(oo, [], t ? function(e1) {
                const t = {
                    color: Zt,
                    string: Gt,
                    number: jt,
                    enum: Gt,
                    boolean: qt,
                    formatted: Xt,
                    resolvedImage: Yt
                };
                return "array" === e1.type ? Kt(t[e1.value] || Wt, e1.length) : t[e1.type];
            }(t) : void 0, void 0, void 0, i), n = r.parse(e1, void 0, void 0, void 0, t && "string" === t.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? so(new wo(n, t, i)) : ao(r.errors);
        }
        class Mo {
            constructor(e1, t, i){
                this.kind = e1, this._styleExpression = t, this.isLightConstant = i, this.isStateDependent = "constant" !== e1 && !Ur(t.expression), this.isConfigDependent = !Vr(t.expression);
            }
            evaluateWithoutErrorHandling(e1, t, i, r, n, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t, i, r, n, o);
            }
            evaluate(e1, t, i, r, n, o) {
                return this._styleExpression.evaluate(e1, t, i, r, n, o);
            }
        }
        class Ao {
            constructor(e1, t, i, r, n){
                this.kind = e1, this.zoomStops = i, this._styleExpression = t, this.isStateDependent = "camera" !== e1 && !Ur(t.expression), this.isLightConstant = n, this.isConfigDependent = !Vr(t.expression), this.interpolationType = r;
            }
            evaluateWithoutErrorHandling(e1, t, i, r, n, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t, i, r, n, o);
            }
            evaluate(e1, t, i, r, n, o) {
                return this._styleExpression.evaluate(e1, t, i, r, n, o);
            }
            interpolationFactor(e1, t, i) {
                return this.interpolationType ? bn.interpolationFactor(this.interpolationType, e1, t, i) : 0;
            }
        }
        function So(e1, t, i) {
            if ("error" === (e1 = Eo(e1, t, i)).result) return e1;
            const r = e1.value.expression, n = Nr(r);
            if (!n && !co(t)) return ao([
                new Ft("", "data expressions not supported")
            ]);
            const o = jr(r, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!o && !uo(t)) return ao([
                new Ft("", "zoom expressions not supported")
            ]);
            const s = jr(r, [
                "measure-light"
            ]);
            if (!s && !ho(t)) return ao([
                new Ft("", "measure-light expression not supported")
            ]);
            const a = t.expression && t.expression.relaxZoomRestriction, l = Co(r);
            return l || o || a ? l instanceof Ft ? ao([
                l
            ]) : l instanceof bn && !po(t) ? ao([
                new Ft("", '"interpolate" expressions cannot be used with this property')
            ]) : so(l ? new Ao(n ? "camera" : "composite", e1.value, l.labels, l instanceof bn ? l.interpolation : void 0, s) : new Mo(n ? "constant" : "source", e1.value, s)) : ao([
                new Ft("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class Io {
            constructor(e1, t){
                this._parameters = e1, this._specification = t, Lt(this, _o(this._parameters, this._specification));
            }
            static deserialize(e1) {
                return new Io(e1._parameters, e1._specification);
            }
            static serialize(e1) {
                return {
                    _parameters: e1._parameters,
                    _specification: e1._specification
                };
            }
        }
        function Co(e1) {
            let t = null;
            if (e1 instanceof Mn) t = Co(e1.result);
            else if (e1 instanceof Tn) {
                for (const i of e1.args)if (t = Co(i), t) break;
            } else (e1 instanceof Yr || e1 instanceof bn) && e1.input instanceof ki && "zoom" === e1.input.name && (t = e1);
            return t instanceof Ft || e1.eachChild((e1)=>{
                const i = Co(e1);
                i instanceof Ft ? t = i : t && i && t !== i && (t = new Ft("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), t;
        }
        function zo(e1) {
            const t = e1.key, i = e1.value, r = e1.valueSpec || {}, n = e1.objectElementValidators || {}, o = e1.style, s = e1.styleSpec;
            let a = [];
            const l = Si(i);
            if ("object" !== l) return [
                new Dt(t, i, `object expected, ${l} found`)
            ];
            for(const e1 in i){
                const l = e1.split(".")[0];
                let c;
                n[l] ? c = n[l] : r[l] ? c = ds : n["*"] ? c = n["*"] : r["*"] && (c = ds), c ? a = a.concat(c({
                    key: (t ? `${t}.` : t) + e1,
                    value: i[e1],
                    valueSpec: r[l] || r["*"],
                    style: o,
                    styleSpec: s,
                    object: i,
                    objectKey: e1
                }, i)) : a.push(new Rt(t, i[e1], `unknown property "${e1}"`));
            }
            for(const e1 in r)n[e1] || r[e1].required && void 0 === r[e1].default && void 0 === i[e1] && a.push(new Dt(t, i, `missing required property "${e1}"`));
            return a;
        }
        function Po(e1) {
            const t = e1.value, i = e1.valueSpec, r = e1.style, n = e1.styleSpec, o = e1.key, s = e1.arrayElementValidator || ds;
            if ("array" !== Si(t)) return [
                new Dt(o, t, `array expected, ${Si(t)} found`)
            ];
            if (i.length && t.length !== i.length) return [
                new Dt(o, t, `array length ${i.length} expected, length ${t.length} found`)
            ];
            if (i["min-length"] && t.length < i["min-length"]) return [
                new Dt(o, t, `array length at least ${i["min-length"]} expected, length ${t.length} found`)
            ];
            let a = {
                type: i.value,
                values: i.values,
                minimum: i.minimum,
                maximum: i.maximum,
                function: void 0
            };
            n.$version < 7 && (a.function = i.function), "object" === Si(i.value) && (a = i.value);
            let l = [];
            for(let e1 = 0; e1 < t.length; e1++)l = l.concat(s({
                array: t,
                arrayIndex: e1,
                value: t[e1],
                valueSpec: a,
                style: r,
                styleSpec: n,
                key: `${o}[${e1}]`
            }, !0));
            return l;
        }
        function Do(e1) {
            const t = e1.key, i = e1.value, r = e1.valueSpec;
            let n = Si(i);
            if ("number" === n && i != i && (n = "NaN"), "number" !== n) return [
                new Dt(t, i, `number expected, ${n} found`)
            ];
            if ("minimum" in r) {
                let n = r.minimum;
                if ("array" === Si(r.minimum) && (n = r.minimum[e1.arrayIndex]), i < n) return [
                    new Dt(t, i, `${i} is less than the minimum value ${n}`)
                ];
            }
            if ("maximum" in r) {
                let n = r.maximum;
                if ("array" === Si(r.maximum) && (n = r.maximum[e1.arrayIndex]), i > n) return [
                    new Dt(t, i, `${i} is greater than the maximum value ${n}`)
                ];
            }
            return [];
        }
        function Ro(e1) {
            const t = e1.valueSpec, i = kt(e1.value.type);
            let r, n, o, s = {};
            const a = "categorical" !== i && void 0 === e1.value.property, l = !a, c = "array" === Si(e1.value.stops) && "array" === Si(e1.value.stops[0]) && "object" === Si(e1.value.stops[0][0]), h = zo({
                key: e1.key,
                value: e1.value,
                valueSpec: e1.styleSpec.function,
                style: e1.style,
                styleSpec: e1.styleSpec,
                objectElementValidators: {
                    stops: function(e1) {
                        if ("identity" === i) return [
                            new Dt(e1.key, e1.value, 'identity function may not have a "stops" property')
                        ];
                        let t = [];
                        const r = e1.value;
                        return t = t.concat(Po({
                            key: e1.key,
                            value: r,
                            valueSpec: e1.valueSpec,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            arrayElementValidator: u
                        })), "array" === Si(r) && 0 === r.length && t.push(new Dt(e1.key, r, "array must have at least one stop")), t;
                    },
                    default: function(e1) {
                        return ds({
                            key: e1.key,
                            value: e1.value,
                            valueSpec: t,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        });
                    }
                }
            });
            return "identity" === i && a && h.push(new Dt(e1.key, e1.value, 'missing required property "property"')), "identity" === i || e1.value.stops || h.push(new Dt(e1.key, e1.value, 'missing required property "stops"')), "exponential" === i && e1.valueSpec.expression && !po(e1.valueSpec) && h.push(new Dt(e1.key, e1.value, "exponential functions not supported")), e1.styleSpec.$version >= 8 && (l && !co(e1.valueSpec) ? h.push(new Dt(e1.key, e1.value, "property functions not supported")) : a && !uo(e1.valueSpec) && h.push(new Dt(e1.key, e1.value, "zoom functions not supported"))), "categorical" !== i && !c || void 0 !== e1.value.property || h.push(new Dt(e1.key, e1.value, '"property" property is required')), h;
            function u(e1) {
                let i = [];
                const r = e1.value, a = e1.key;
                if ("array" !== Si(r)) return [
                    new Dt(a, r, `array expected, ${Si(r)} found`)
                ];
                if (2 !== r.length) return [
                    new Dt(a, r, `array length 2 expected, length ${r.length} found`)
                ];
                if (c) {
                    if ("object" !== Si(r[0])) return [
                        new Dt(a, r, `object expected, ${Si(r[0])} found`)
                    ];
                    if (void 0 === r[0].zoom) return [
                        new Dt(a, r, "object stop key must have zoom")
                    ];
                    if (void 0 === r[0].value) return [
                        new Dt(a, r, "object stop key must have value")
                    ];
                    const t = kt(r[0].zoom);
                    if ("number" != typeof t) return [
                        new Dt(a, r[0].zoom, "stop zoom values must be numbers")
                    ];
                    if (o && o > t) return [
                        new Dt(a, r[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    t !== o && (o = t, n = void 0, s = {}), i = i.concat(zo({
                        key: `${a}[0]`,
                        value: r[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: e1.style,
                        styleSpec: e1.styleSpec,
                        objectElementValidators: {
                            zoom: Do,
                            value: d
                        }
                    }));
                } else i = i.concat(d({
                    key: `${a}[0]`,
                    value: r[0],
                    valueSpec: {},
                    style: e1.style,
                    styleSpec: e1.styleSpec
                }, r));
                return To(Ot(r[1])) ? i.concat([
                    new Dt(`${a}[1]`, r[1], "expressions are not allowed in function stops.")
                ]) : i.concat(ds({
                    key: `${a}[1]`,
                    value: r[1],
                    valueSpec: t,
                    style: e1.style,
                    styleSpec: e1.styleSpec
                }));
            }
            function d(e1, o) {
                const a = Si(e1.value), l = kt(e1.value), c = null !== e1.value ? e1.value : o;
                if (r) {
                    if (a !== r) return [
                        new Dt(e1.key, c, `${a} stop domain type must match previous stop domain type ${r}`)
                    ];
                } else r = a;
                if ("number" !== a && "string" !== a && "boolean" !== a && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new Dt(e1.key, c, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== a && "categorical" !== i) {
                    let r = `number expected, ${a} found`;
                    return co(t) && void 0 === i && (r += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Dt(e1.key, c, r)
                    ];
                }
                return "categorical" !== i || "number" !== a || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== i && "number" === a && "number" == typeof l && "number" == typeof n && void 0 !== n && l < n ? [
                    new Dt(e1.key, c, "stop domain values must appear in ascending order")
                ] : (n = l, "categorical" === i && l in s ? [
                    new Dt(e1.key, c, "stop domain values must be unique")
                ] : (s[l] = !0, [])) : [
                    new Dt(e1.key, c, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function Lo(e1) {
            const t = ("property" === e1.expressionContext ? So : Eo)(Ot(e1.value), e1.valueSpec);
            if ("error" === t.result) return t.value.map((t)=>new Dt(`${e1.key}${t.key}`, e1.value, t.message));
            const i = t.value.expression || t.value._styleExpression.expression;
            if ("property" === e1.expressionContext && "text-font" === e1.propertyKey && !i.outputDefined()) return [
                new Dt(e1.key, e1.value, `Invalid data expression for "${e1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === e1.expressionContext && "layout" === e1.propertyType && !Ur(i)) return [
                new Dt(e1.key, e1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === e1.expressionContext) return ko(i, e1);
            if (e1.expressionContext && 0 === e1.expressionContext.indexOf("cluster")) {
                if (!jr(i, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Dt(e1.key, e1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === e1.expressionContext && !Nr(i)) return [
                    new Dt(e1.key, e1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function ko(e1, t) {
            const i = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (t.valueSpec && t.valueSpec.expression) for (const e1 of t.valueSpec.expression.parameters)i.delete(e1);
            if (0 === i.size) return [];
            const r = [];
            return e1 instanceof ki && i.has(e1.name) ? [
                new Dt(t.key, t.value, `["${e1.name}"] expression is not supported in a filter for a ${t.object.type} layer with id: ${t.object.id}`)
            ] : (e1.eachChild((e1)=>{
                r.push(...ko(e1, t));
            }), r);
        }
        function Oo(e1) {
            const t = e1.key, i = e1.value, r = e1.valueSpec, n = [];
            return Array.isArray(r.values) ? -1 === r.values.indexOf(kt(i)) && n.push(new Dt(t, i, `expected one of [${r.values.join(", ")}], ${JSON.stringify(i)} found`)) : -1 === Object.keys(r.values).indexOf(kt(i)) && n.push(new Dt(t, i, `expected one of [${Object.keys(r.values).join(", ")}], ${JSON.stringify(i)} found`)), n;
        }
        function Bo(e1) {
            if (!0 === e1 || !1 === e1) return !0;
            if (!Array.isArray(e1) || 0 === e1.length) return !1;
            switch(e1[0]){
                case "has":
                    return e1.length >= 2 && "$id" !== e1[1] && "$type" !== e1[1];
                case "in":
                    return e1.length >= 3 && ("string" != typeof e1[1] || Array.isArray(e1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== e1.length || Array.isArray(e1[1]) || Array.isArray(e1[2]);
                case "any":
                case "all":
                    for (const t of e1.slice(1))if (!Bo(t) && "boolean" != typeof t) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function Fo(e1, t = "fill") {
            if (null == e1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            Bo(e1) || (e1 = Zo(e1));
            const i = e1;
            let r = !0;
            try {
                r = function(e1) {
                    if (!Vo(e1)) return e1;
                    let t = Ot(e1);
                    return Uo(t), t = No(t), t;
                }(i);
            } catch (e1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(i, null, 2)}\n        `);
            }
            const n = Pt[`filter_${t}`], o = Eo(r, n);
            let s = null;
            if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
            s = (e1, t, i)=>o.value.evaluate(e1, t, {}, i);
            let a = null, l = null;
            if (r !== i) {
                const e1 = Eo(i, n);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                a = (t, i, r, n, o)=>e1.value.evaluate(t, i, {}, r, void 0, void 0, n, o), l = !Nr(e1.value.expression);
            }
            return {
                filter: s,
                dynamicFilter: a || void 0,
                needGeometry: qo(r),
                needFeature: !!l
            };
        }
        function No(e1) {
            if (!Array.isArray(e1)) return e1;
            const t = function(e1) {
                if (jo.has(e1[0])) {
                    for(let t = 1; t < e1.length; t++)if (Vo(e1[t])) return !0;
                }
                return e1;
            }(e1);
            return !0 === t ? t : t.map((e1)=>No(e1));
        }
        function Uo(e1) {
            let t = !1;
            const i = [];
            if ("case" === e1[0]) {
                for(let r = 1; r < e1.length - 1; r += 2)t = t || Vo(e1[r]), i.push(e1[r + 1]);
                i.push(e1[e1.length - 1]);
            } else if ("match" === e1[0]) {
                t = t || Vo(e1[1]);
                for(let t = 2; t < e1.length - 1; t += 2)i.push(e1[t + 1]);
                i.push(e1[e1.length - 1]);
            } else if ("step" === e1[0]) {
                t = t || Vo(e1[1]);
                for(let t = 1; t < e1.length - 1; t += 2)i.push(e1[t + 1]);
            }
            t && (e1.length = 0, e1.push("any", ...i));
            for(let t = 1; t < e1.length; t++)Uo(e1[t]);
        }
        function Vo(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("pitch" === (t = e1[0]) || "distance-from-center" === t) return !0;
            var t;
            for(let t = 1; t < e1.length; t++)if (Vo(e1[t])) return !0;
            return !1;
        }
        const jo = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function Go(e1, t) {
            return e1 < t ? -1 : e1 > t ? 1 : 0;
        }
        function qo(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("within" === e1[0] || "distance" === e1[0]) return !0;
            for(let t = 1; t < e1.length; t++)if (qo(e1[t])) return !0;
            return !1;
        }
        function Zo(e1) {
            if (!e1) return !0;
            const t = e1[0];
            var i;
            return e1.length <= 1 ? "any" !== t : "==" === t ? $o(e1[1], e1[2], "==") : "!=" === t ? Xo($o(e1[1], e1[2], "==")) : "<" === t || ">" === t || "<=" === t || ">=" === t ? $o(e1[1], e1[2], t) : "any" === t ? (i = e1.slice(1), [
                "any"
            ].concat(i.map(Zo))) : "all" === t ? [
                "all"
            ].concat(e1.slice(1).map(Zo)) : "none" === t ? [
                "all"
            ].concat(e1.slice(1).map(Zo).map(Xo)) : "in" === t ? Wo(e1[1], e1.slice(2)) : "!in" === t ? Xo(Wo(e1[1], e1.slice(2))) : "has" === t ? Ho(e1[1]) : "!has" !== t || Xo(Ho(e1[1]));
        }
        function $o(e1, t, i) {
            switch(e1){
                case "$type":
                    return [
                        `filter-type-${i}`,
                        t
                    ];
                case "$id":
                    return [
                        `filter-id-${i}`,
                        t
                    ];
                default:
                    return [
                        `filter-${i}`,
                        e1,
                        t
                    ];
            }
        }
        function Wo(e1, t) {
            if (0 === t.length) return !1;
            switch(e1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            t
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            t
                        ]
                    ];
                default:
                    return t.length > 200 && !t.some((e1)=>typeof e1 != typeof t[0]) ? [
                        "filter-in-large",
                        e1,
                        [
                            "literal",
                            t.sort(Go)
                        ]
                    ] : [
                        "filter-in-small",
                        e1,
                        [
                            "literal",
                            t
                        ]
                    ];
            }
        }
        function Ho(e1) {
            switch(e1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        e1
                    ];
            }
        }
        function Xo(e1) {
            return [
                "!",
                e1
            ];
        }
        function Yo(e1) {
            return Bo(Ot(e1.value)) ? Lo(Lt({}, e1, {
                expressionContext: "filter",
                valueSpec: e1.styleSpec[`filter_${e1.layerType || "fill"}`]
            })) : Ko(e1);
        }
        function Ko(e1) {
            const t = e1.value, i = e1.key;
            if ("array" !== Si(t)) return [
                new Dt(i, t, `array expected, ${Si(t)} found`)
            ];
            const r = e1.styleSpec;
            let n, o = [];
            if (t.length < 1) return [
                new Dt(i, t, "filter array must have at least 1 element")
            ];
            switch(o = o.concat(Oo({
                key: `${i}[0]`,
                value: t[0],
                valueSpec: r.filter_operator,
                style: e1.style,
                styleSpec: e1.styleSpec
            })), kt(t[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    t.length >= 2 && "$type" === kt(t[1]) && o.push(new Dt(i, t, `"$type" cannot be use with operator "${t[0]}"`));
                case "==":
                case "!=":
                    3 !== t.length && o.push(new Dt(i, t, `filter array for operator "${t[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    t.length >= 2 && (n = Si(t[1]), "string" !== n && o.push(new Dt(`${i}[1]`, t[1], `string expected, ${n} found`)));
                    for(let s = 2; s < t.length; s++)n = Si(t[s]), "$type" === kt(t[1]) ? o = o.concat(Oo({
                        key: `${i}[${s}]`,
                        value: t[s],
                        valueSpec: r.geometry_type,
                        style: e1.style,
                        styleSpec: e1.styleSpec
                    })) : "string" !== n && "number" !== n && "boolean" !== n && o.push(new Dt(`${i}[${s}]`, t[s], `string, number, or boolean expected, ${n} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let r = 1; r < t.length; r++)o = o.concat(Ko({
                        key: `${i}[${r}]`,
                        value: t[r],
                        style: e1.style,
                        styleSpec: e1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    n = Si(t[1]), 2 !== t.length ? o.push(new Dt(i, t, `filter array for "${t[0]}" operator must have 2 elements`)) : "string" !== n && o.push(new Dt(`${i}[1]`, t[1], `string expected, ${n} found`));
            }
            return o;
        }
        function Jo(e1, t) {
            const i = e1.key, r = e1.style, n = e1.layer, o = e1.styleSpec, s = e1.value, a = e1.objectKey, l = o[`${t}_${e1.layerType}`];
            if (!l) return [];
            const c = a.match(/^(.*)-transition$/);
            if ("paint" === t && c && l[c[1]] && l[c[1]].transition) return ds({
                key: i,
                value: s,
                valueSpec: o.transition,
                style: r,
                styleSpec: o
            });
            const h = e1.valueSpec || l[a];
            if (!h) return [
                new Rt(i, s, `unknown property "${a}"`)
            ];
            let u;
            if ("string" === Si(s) && co(h) && !h.tokens && (u = /^{([^}]+)}$/.exec(s))) {
                const e1 = `\`{ "type": "identity", "property": ${u ? JSON.stringify(u[1]) : '"_"'} }\``;
                return [
                    new Dt(i, s, `"${a}" does not support interpolation syntax\nUse an identity property function instead: ${e1}.`)
                ];
            }
            const d = [];
            if ("symbol" === e1.layerType) "text-field" !== a || !r || r.glyphs || r.imports || d.push(new Dt(i, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === a && fo(Ot(s)) && "identity" === kt(s.type) && d.push(new Dt(i, s, '"text-font" does not support identity functions'));
            else if ("model" === e1.layerType && "paint" === t && n && n.layout && n.layout.hasOwnProperty("model-id") && co(h) && (ho(h) || uo(h))) {
                const e1 = So(Ot(s), h), t = e1.value.expression || e1.value._styleExpression.expression;
                t && !jr(t, [
                    "measure-light"
                ]) && ("model-emissive-strength" === a && Nr(t) && Ur(t) || d.push(new Dt(i, s, `${a} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return d.concat(ds({
                key: e1.key,
                value: s,
                valueSpec: h,
                style: r,
                styleSpec: o,
                expressionContext: "property",
                propertyType: t,
                propertyKey: a
            }));
        }
        function Qo(e1) {
            return Jo(e1, "paint");
        }
        function es(e1) {
            return Jo(e1, "layout");
        }
        function ts(e1) {
            let t = [];
            const i = e1.value, r = e1.key, n = e1.style, o = e1.styleSpec;
            i.type || i.ref || t.push(new Dt(r, i, 'either "type" or "ref" is required'));
            let s = kt(i.type);
            const a = kt(i.ref);
            if (i.id) {
                const o = kt(i.id);
                for(let s = 0; s < e1.arrayIndex; s++){
                    const e1 = n.layers[s];
                    kt(e1.id) === o && t.push(new Dt(r, i.id, `duplicate layer id "${i.id}", previously used at line ${e1.id.__line__}`));
                }
            }
            if ("ref" in i) {
                let e1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((e1)=>{
                    e1 in i && t.push(new Dt(r, i[e1], `"${e1}" is prohibited for ref layers`));
                }), n.layers.forEach((t)=>{
                    kt(t.id) === a && (e1 = t);
                }), e1 ? e1.ref ? t.push(new Dt(r, i.ref, "ref cannot reference another ref layer")) : s = kt(e1.type) : "string" == typeof a && t.push(new Dt(r, i.ref, `ref layer "${a}" not found`));
            } else if ("background" !== s && "sky" !== s && "slot" !== s) {
                if (i.source) {
                    const e1 = n.sources && n.sources[i.source], o = e1 && kt(e1.type);
                    e1 ? "vector" === o && "raster" === s ? t.push(new Dt(r, i.source, `layer "${i.id}" requires a raster source`)) : "raster" === o && "raster" !== s ? t.push(new Dt(r, i.source, `layer "${i.id}" requires a vector source`)) : "vector" !== o || i["source-layer"] ? "raster-dem" === o && "hillshade" !== s ? t.push(new Dt(r, i.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !i.paint || !i.paint["line-gradient"] && !i.paint["line-trim-offset"] || "geojson" === o && e1.lineMetrics || t.push(new Dt(r, i, `layer "${i.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : t.push(new Dt(r, i, `layer "${i.id}" must specify a "source-layer"`)) : t.push(new Dt(r, i.source, `source "${i.source}" not found`));
                } else t.push(new Dt(r, i, 'missing required property "source"'));
            }
            return t = t.concat(zo({
                key: r,
                value: i,
                valueSpec: o.layer,
                style: e1.style,
                styleSpec: e1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>ds({
                            key: `${r}.type`,
                            value: i.type,
                            valueSpec: o.layer.type,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            object: i,
                            objectKey: "type"
                        }),
                    filter: (e1)=>Yo(Lt({
                            layerType: s
                        }, e1)),
                    layout: (e1)=>zo({
                            layer: i,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>es(Lt({
                                        layerType: s
                                    }, e1))
                            }
                        }),
                    paint: (e1)=>zo({
                            layer: i,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>Qo(Lt({
                                        layerType: s,
                                        layer: i
                                    }, e1))
                            }
                        })
                }
            })), t;
        }
        function is(e1) {
            const t = e1.value, i = e1.key, r = Si(t);
            return "string" !== r ? [
                new Dt(i, t, `string expected, ${r} found`)
            ] : [];
        }
        const rs = {
            promoteId: function({ key: e1, value: t }) {
                if ("string" === Si(t)) return is({
                    key: e1,
                    value: t
                });
                {
                    const i = [];
                    for(const r in t)i.push(...is({
                        key: `${e1}.${r}`,
                        value: t[r]
                    }));
                    return i;
                }
            }
        };
        function ns(e1) {
            const t = e1.value, i = e1.key, r = e1.styleSpec, n = e1.style;
            if (!t.type) return [
                new Dt(i, t, '"type" is required')
            ];
            const o = kt(t.type);
            let s = [];
            switch([
                "vector",
                "raster",
                "raster-dem"
            ].includes(o) && (t.url || t.tiles || s.push(new Dt(i, t, 'Either "url" or "tiles" is required.'))), o){
                case "vector":
                case "raster":
                case "raster-dem":
                    return s = s.concat(zo({
                        key: i,
                        value: t,
                        valueSpec: r[`source_${o.replace("-", "_")}`],
                        style: e1.style,
                        styleSpec: r,
                        objectElementValidators: rs
                    })), s;
                case "geojson":
                    if (s = zo({
                        key: i,
                        value: t,
                        valueSpec: r.source_geojson,
                        style: n,
                        styleSpec: r,
                        objectElementValidators: rs
                    }), t.cluster) for(const e1 in t.clusterProperties){
                        const [r, n] = t.clusterProperties[e1], o = "string" == typeof r ? [
                            r,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                e1
                            ]
                        ] : r;
                        s.push(...Lo({
                            key: `${i}.${e1}.map`,
                            value: n,
                            expressionContext: "cluster-map"
                        })), s.push(...Lo({
                            key: `${i}.${e1}.reduce`,
                            value: o,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return s;
                case "video":
                    return zo({
                        key: i,
                        value: t,
                        valueSpec: r.source_video,
                        style: n,
                        styleSpec: r
                    });
                case "image":
                    return zo({
                        key: i,
                        value: t,
                        valueSpec: r.source_image,
                        style: n,
                        styleSpec: r
                    });
                case "canvas":
                    return [
                        new Dt(i, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Oo({
                        key: `${i}.type`,
                        value: t.type,
                        valueSpec: {
                            values: os(r)
                        },
                        style: n,
                        styleSpec: r
                    });
            }
        }
        function os(e1) {
            return e1.source.reduce((t, i)=>{
                const r = e1[i];
                return "enum" === r.type.type && (t = t.concat(Object.keys(r.type.values))), t;
            }, []);
        }
        function ss(e1) {
            const t = e1.value;
            let i = [];
            if (!t) return i;
            const r = Si(t);
            return "string" !== r ? (i = i.concat([
                new Dt(e1.key, t, `string expected, "${r}" found`)
            ]), i) : (function(e1) {
                const t = -1 === e1.indexOf("://");
                try {
                    return new URL(e1, t ? "http://example.com" : void 0), !0;
                } catch (e1) {
                    return !1;
                }
            }(t) || (i = i.concat([
                new Dt(e1.key, t, `invalid url "${t}"`)
            ])), i);
        }
        function as(e1) {
            const t = e1.value, i = e1.styleSpec, r = i.light, n = e1.style;
            let o = [];
            const s = Si(t);
            if (void 0 === t) return o;
            if ("object" !== s) return o = o.concat([
                new Dt("light", t, `object expected, ${s} found`)
            ]), o;
            for(const e1 in t){
                const s = e1.match(/^(.*)-transition$/);
                o = o.concat(s && r[s[1]] && r[s[1]].transition ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: i.transition,
                    style: n,
                    styleSpec: i
                }) : r[e1] ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: r[e1],
                    style: n,
                    styleSpec: i
                }) : [
                    new Dt(e1, t[e1], `unknown property "${e1}"`)
                ]);
            }
            return o;
        }
        function ls(e1) {
            const t = e1.value;
            let i = [];
            if (!t) return i;
            const r = Si(t);
            if ("object" !== r) return i = i.concat([
                new Dt("light-3d", t, `object expected, ${r} found`)
            ]), i;
            const n = e1.styleSpec, o = n["light-3d"], s = e1.key, a = e1.style, l = e1.style.lights;
            for (const e1 of [
                "type",
                "id"
            ])if (!(e1 in t)) return i = i.concat([
                new Dt("light-3d", t, `missing property ${e1} on light`)
            ]), i;
            if (t.type && l) for(let r = 0; r < e1.arrayIndex; r++){
                const e1 = kt(t.type), n = l[r];
                kt(n.type) === e1 && i.push(new Dt(s, t.id, `duplicate light type "${t.type}", previously defined at line ${n.id.__line__}`));
            }
            const c = `properties_light_${t.type}`;
            if (!(c in n)) return i = i.concat([
                new Dt("light-3d", t, `Invalid light type ${t.type}`)
            ]), i;
            const h = n[c];
            for(const r in t)if ("properties" === r) {
                const o = t[r], s = Si(o);
                if ("object" !== s) return i = i.concat([
                    new Dt("properties", o, `object expected, ${s} found`)
                ]), i;
                for(const t in o)i = i.concat(h[t] ? ds({
                    key: t,
                    value: o[t],
                    valueSpec: h[t],
                    style: a,
                    styleSpec: n
                }) : [
                    new Rt(e1.key, o[t], `unknown property "${t}"`)
                ]);
            } else {
                const e1 = r.match(/^(.*)-transition$/);
                i = i.concat(e1 && o[e1[1]] && o[e1[1]].transition ? ds({
                    key: r,
                    value: t[r],
                    valueSpec: n.transition,
                    style: a,
                    styleSpec: n
                }) : o[r] ? ds({
                    key: r,
                    value: t[r],
                    valueSpec: o[r],
                    style: a,
                    styleSpec: n
                }) : [
                    new Rt(r, t[r], `unknown property "${r}"`)
                ]);
            }
            return i;
        }
        function cs(e1) {
            const t = e1.value, i = e1.key, r = e1.style, n = e1.styleSpec, o = n.terrain;
            let s = [];
            const a = Si(t);
            if (void 0 === t) return s;
            if ("null" === a) return s;
            if ("object" !== a) return s = s.concat([
                new Dt("terrain", t, `object expected, ${a} found`)
            ]), s;
            for(const e1 in t){
                const i = e1.match(/^(.*)-transition$/);
                s = s.concat(i && o[i[1]] && o[i[1]].transition ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: n.transition,
                    style: r,
                    styleSpec: n
                }) : o[e1] ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: o[e1],
                    style: r,
                    styleSpec: n
                }) : [
                    new Rt(e1, t[e1], `unknown property "${e1}"`)
                ]);
            }
            if (t.source) {
                const e1 = r.sources && r.sources[t.source], n = e1 && kt(e1.type);
                e1 ? "raster-dem" !== n && s.push(new Dt(i, t.source, `terrain cannot be used with a source of type ${String(n)}, it only be used with a "raster-dem" source type`)) : s.push(new Dt(i, t.source, `source "${t.source}" not found`));
            } else s.push(new Dt(i, t, 'terrain is missing required property "source"'));
            return s;
        }
        function hs(e1) {
            const t = e1.value, i = e1.style, r = e1.styleSpec, n = r.fog;
            let o = [];
            const s = Si(t);
            if (void 0 === t) return o;
            if ("object" !== s) return o = o.concat([
                new Dt("fog", t, `object expected, ${s} found`)
            ]), o;
            for(const e1 in t){
                const s = e1.match(/^(.*)-transition$/);
                o = o.concat(s && n[s[1]] && n[s[1]].transition ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: r.transition,
                    style: i,
                    styleSpec: r
                }) : n[e1] ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: n[e1],
                    style: i,
                    styleSpec: r
                }) : [
                    new Rt(e1, t[e1], `unknown property "${e1}"`)
                ]);
            }
            return o;
        }
        const us = {
            "*": ()=>[],
            array: Po,
            boolean: function(e1) {
                const t = e1.value, i = e1.key, r = Si(t);
                return "boolean" !== r ? [
                    new Dt(i, t, `boolean expected, ${r} found`)
                ] : [];
            },
            number: Do,
            color: function(e1) {
                const t = e1.key, i = e1.value, r = Si(i);
                return "string" !== r ? [
                    new Dt(t, i, `color expected, ${r} found`)
                ] : null === ri(i) ? [
                    new Dt(t, i, `color expected, "${i}" found`)
                ] : [];
            },
            enum: Oo,
            filter: Yo,
            function: Ro,
            layer: ts,
            object: zo,
            source: ns,
            model: ss,
            light: as,
            "light-3d": ls,
            terrain: cs,
            fog: hs,
            string: is,
            formatted: function(e1) {
                return 0 === is(e1).length ? [] : Lo(e1);
            },
            resolvedImage: function(e1) {
                return 0 === is(e1).length ? [] : Lo(e1);
            },
            projection: function(e1) {
                const t = e1.value, i = e1.styleSpec, r = i.projection, n = e1.style;
                let o = [];
                const s = Si(t);
                if ("object" === s) for(const e1 in t)o = o.concat(ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: r[e1],
                    style: n,
                    styleSpec: i
                }));
                else "string" !== s && (o = o.concat([
                    new Dt("projection", t, `object or string expected, ${s} found`)
                ]));
                return o;
            },
            import: function(e1) {
                const { value: t, styleSpec: i } = e1, { data: r, ...n } = t;
                Object.defineProperty(n, "__line__", {
                    value: t.__line__,
                    enumerable: !1
                });
                let o = zo(Lt({}, e1, {
                    value: n,
                    valueSpec: i.import
                }));
                return "" === kt(n.id) && o.push(new Dt(`${e1.key}.id`, n, "import id can't be an empty string")), r && (o = o.concat(fs(r, i, {
                    key: `${e1.key}.data`
                }))), o;
            }
        };
        function ds(e1, t = !1) {
            const i = e1.value, r = e1.valueSpec, n = e1.styleSpec;
            if (r.expression && fo(kt(i))) return Ro(e1);
            if (r.expression && To(Ot(i))) return Lo(e1);
            if (r.type && us[r.type]) {
                const i = us[r.type](e1);
                return !0 === t && i.length > 0 && "array" === Si(e1.value) ? Lo(e1) : i;
            }
            return zo(Lt({}, e1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function ps(e1) {
            const t = e1.value, i = e1.key, r = is(e1);
            return r.length || (-1 === t.indexOf("{fontstack}") && r.push(new Dt(i, t, '"glyphs" url must include a "{fontstack}" token')), -1 === t.indexOf("{range}") && r.push(new Dt(i, t, '"glyphs" url must include a "{range}" token'))), r;
        }
        function fs(e1, t = Pt, i = {}) {
            return ds({
                key: i.key || "",
                value: e1,
                valueSpec: t.$root,
                styleSpec: t,
                style: e1,
                objectElementValidators: {
                    glyphs: ps,
                    "*": ()=>[]
                }
            });
        }
        function ms(e1, t = Pt) {
            return As(fs(e1, t));
        }
        const _s = (e1)=>As(ns(e1)), gs = (e1)=>As(as(e1)), ys = (e1)=>As(ls(e1)), xs = (e1)=>As(cs(e1)), vs = (e1)=>As(hs(e1)), bs = (e1)=>As(ts(e1)), ws = (e1)=>As(Yo(e1)), Ts = (e1)=>As(Qo(e1)), Es = (e1)=>As(es(e1)), Ms = (e1)=>As(ss(e1));
        function As(e1) {
            return e1.slice().sort((e1, t)=>e1.line && t.line ? e1.line - t.line : 0);
        }
        function Ss(e1, t) {
            let i = !1;
            if (t && t.length) for (const r of t)r instanceof Rt ? H(r.message) : (e1.fire(new Ct(new Error(r.message))), i = !0);
            return i;
        }
        var Is = zs, Cs = 3;
        function zs(e1, t, i) {
            var r = this.cells = [];
            if (e1 instanceof ArrayBuffer) {
                this.arrayBuffer = e1;
                var n = new Int32Array(this.arrayBuffer);
                e1 = n[0], this.d = (t = n[1]) + 2 * (i = n[2]);
                for(var o = 0; o < this.d * this.d; o++){
                    var s = n[Cs + o], a = n[Cs + o + 1];
                    r.push(s === a ? null : n.subarray(s, a));
                }
                var l = n[Cs + r.length + 1];
                this.keys = n.subarray(n[Cs + r.length], l), this.bboxes = n.subarray(l), this.insert = this._insertReadonly;
            } else {
                this.d = t + 2 * i;
                for(var c = 0; c < this.d * this.d; c++)r.push([]);
                this.keys = [], this.bboxes = [];
            }
            this.n = t, this.extent = e1, this.padding = i, this.scale = t / e1, this.uid = 0;
            var h = i / t * e1;
            this.min = -h, this.max = e1 + h;
        }
        zs.prototype.insert = function(e1, t, i, r, n) {
            this._forEachCell(t, i, r, n, this._insertCell, this.uid++), this.keys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(r), this.bboxes.push(n);
        }, zs.prototype._insertReadonly = function() {
            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, zs.prototype._insertCell = function(e1, t, i, r, n, o) {
            this.cells[n].push(o);
        }, zs.prototype.query = function(e1, t, i, r, n) {
            var o = this.min, s = this.max;
            if (e1 <= o && t <= o && s <= i && s <= r && !n) return Array.prototype.slice.call(this.keys);
            var a = [];
            return this._forEachCell(e1, t, i, r, this._queryCell, a, {}, n), a;
        }, zs.prototype._queryCell = function(e1, t, i, r, n, o, s, a) {
            var l = this.cells[n];
            if (null !== l) for(var c = this.keys, h = this.bboxes, u = 0; u < l.length; u++){
                var d = l[u];
                if (void 0 === s[d]) {
                    var p = 4 * d;
                    (a ? a(h[p + 0], h[p + 1], h[p + 2], h[p + 3]) : e1 <= h[p + 2] && t <= h[p + 3] && i >= h[p + 0] && r >= h[p + 1]) ? (s[d] = !0, o.push(c[d])) : s[d] = !1;
                }
            }
        }, zs.prototype._forEachCell = function(e1, t, i, r, n, o, s, a) {
            for(var l = this._convertToCellCoord(e1), c = this._convertToCellCoord(t), h = this._convertToCellCoord(i), u = this._convertToCellCoord(r), d = l; d <= h; d++)for(var p = c; p <= u; p++){
                var f = this.d * p + d;
                if ((!a || a(this._convertFromCellCoord(d), this._convertFromCellCoord(p), this._convertFromCellCoord(d + 1), this._convertFromCellCoord(p + 1))) && n.call(this, e1, t, i, r, f, o, s, a)) return;
            }
        }, zs.prototype._convertFromCellCoord = function(e1) {
            return (e1 - this.padding) / this.scale;
        }, zs.prototype._convertToCellCoord = function(e1) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(e1 * this.scale) + this.padding));
        }, zs.prototype.toArrayBuffer = function() {
            if (this.arrayBuffer) return this.arrayBuffer;
            for(var e1 = this.cells, t = Cs + this.cells.length + 1 + 1, i = 0, r = 0; r < this.cells.length; r++)i += this.cells[r].length;
            var n = new Int32Array(t + i + this.keys.length + this.bboxes.length);
            n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
            for(var o = t, s = 0; s < e1.length; s++){
                var a = e1[s];
                n[Cs + s] = o, n.set(a, o), o += a.length;
            }
            return n[Cs + e1.length] = o, n.set(this.keys, o), n[Cs + e1.length + 1] = o += this.keys.length, n.set(this.bboxes, o), o += this.bboxes.length, n.buffer;
        };
        var Ps = d(Is);
        const Ds = {};
        function Rs(e1, t, i = {}) {
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), Ds[t] = {
                klass: e1,
                omit: i.omit || []
            };
        }
        Rs(Object, "Object"), Ps.serialize = function(e1, t) {
            const i = e1.toArrayBuffer();
            return t && t.add(i), {
                buffer: i
            };
        }, Ps.deserialize = function(e1) {
            return new Ps(e1.buffer);
        }, Object.defineProperty(Ps, "name", {
            value: "Grid"
        }), Rs(Ps, "Grid"), Rs(hi, "Color"), Rs(Error, "Error"), Rs(xe, "AJAXError"), Rs(fi, "ResolvedImage"), Rs(Io, "StylePropertyFunction"), Rs(wo, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), Rs(Ao, "ZoomDependentExpression"), Rs(Mo, "ZoomConstantExpression"), Rs(ki, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const e1 in oo)Ds[oo[e1]._classRegistryKey] || Rs(oo[e1], `Expression${e1}`);
        function Ls(e1) {
            return e1 && "undefined" != typeof ArrayBuffer && (e1 instanceof ArrayBuffer || e1.constructor && "ArrayBuffer" === e1.constructor.name);
        }
        function ks(e1) {
            return t.ImageBitmap && e1 instanceof t.ImageBitmap;
        }
        function Os(e1, i) {
            if (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp) return e1;
            if (Ls(e1) || ks(e1)) return i && i.add(e1), e1;
            if (ArrayBuffer.isView(e1)) {
                const t = e1;
                return i && i.add(t.buffer), t;
            }
            if (e1 instanceof t.ImageData) return i && i.add(e1.data.buffer), e1;
            if (Array.isArray(e1)) {
                const t = [];
                for (const r of e1)t.push(Os(r, i));
                return t;
            }
            if (e1 instanceof Map) {
                const t = {
                    $name: "Map"
                };
                for (const [i, r] of e1.entries())t[i] = Os(r);
                return t;
            }
            if ("object" == typeof e1) {
                const t = e1.constructor, r = t._classRegistryKey;
                if (!r) throw new Error(`can't serialize object of unregistered class ${r}`);
                const n = t.serialize ? t.serialize(e1, i) : {};
                if (!t.serialize) {
                    for(const t in e1)e1.hasOwnProperty(t) && (Ds[r].omit.indexOf(t) >= 0 || (n[t] = Os(e1[t], i)));
                    e1 instanceof Error && (n.message = e1.message);
                }
                if (n.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== r && (n.$name = r), n;
            }
            throw new Error("can't serialize object of type " + typeof e1);
        }
        function Bs(e1) {
            if (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp || Ls(e1) || ks(e1) || ArrayBuffer.isView(e1) || e1 instanceof t.ImageData) return e1;
            if (Array.isArray(e1)) return e1.map(Bs);
            if ("object" == typeof e1) {
                const t = e1.$name || "Object";
                if ("Map" === t) {
                    const t = new Map;
                    for (const i of Object.keys(e1))"$name" !== i && t.set(i, Bs(e1[i]));
                    return t;
                }
                const { klass: i } = Ds[t];
                if (!i) throw new Error(`can't deserialize unregistered class ${t}`);
                if (i.deserialize) return i.deserialize(e1);
                const r = Object.create(i.prototype);
                for (const t of Object.keys(e1))"$name" !== t && (r[t] = Bs(e1[t]));
                return r;
            }
            throw new Error("can't deserialize object of type " + typeof e1);
        }
        const Fs = {
            "Latin-1 Supplement": (e1)=>e1 >= 128 && e1 <= 255,
            Arabic: (e1)=>e1 >= 1536 && e1 <= 1791,
            "Arabic Supplement": (e1)=>e1 >= 1872 && e1 <= 1919,
            "Arabic Extended-A": (e1)=>e1 >= 2208 && e1 <= 2303,
            "Hangul Jamo": (e1)=>e1 >= 4352 && e1 <= 4607,
            "Unified Canadian Aboriginal Syllabics": (e1)=>e1 >= 5120 && e1 <= 5759,
            Khmer: (e1)=>e1 >= 6016 && e1 <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (e1)=>e1 >= 6320 && e1 <= 6399,
            "General Punctuation": (e1)=>e1 >= 8192 && e1 <= 8303,
            "Letterlike Symbols": (e1)=>e1 >= 8448 && e1 <= 8527,
            "Number Forms": (e1)=>e1 >= 8528 && e1 <= 8591,
            "Miscellaneous Technical": (e1)=>e1 >= 8960 && e1 <= 9215,
            "Control Pictures": (e1)=>e1 >= 9216 && e1 <= 9279,
            "Optical Character Recognition": (e1)=>e1 >= 9280 && e1 <= 9311,
            "Enclosed Alphanumerics": (e1)=>e1 >= 9312 && e1 <= 9471,
            "Geometric Shapes": (e1)=>e1 >= 9632 && e1 <= 9727,
            "Miscellaneous Symbols": (e1)=>e1 >= 9728 && e1 <= 9983,
            "Miscellaneous Symbols and Arrows": (e1)=>e1 >= 11008 && e1 <= 11263,
            "CJK Radicals Supplement": (e1)=>e1 >= 11904 && e1 <= 12031,
            "Kangxi Radicals": (e1)=>e1 >= 12032 && e1 <= 12255,
            "Ideographic Description Characters": (e1)=>e1 >= 12272 && e1 <= 12287,
            "CJK Symbols and Punctuation": (e1)=>e1 >= 12288 && e1 <= 12351,
            Hiragana: (e1)=>e1 >= 12352 && e1 <= 12447,
            Katakana: (e1)=>e1 >= 12448 && e1 <= 12543,
            Bopomofo: (e1)=>e1 >= 12544 && e1 <= 12591,
            "Hangul Compatibility Jamo": (e1)=>e1 >= 12592 && e1 <= 12687,
            Kanbun: (e1)=>e1 >= 12688 && e1 <= 12703,
            "Bopomofo Extended": (e1)=>e1 >= 12704 && e1 <= 12735,
            "CJK Strokes": (e1)=>e1 >= 12736 && e1 <= 12783,
            "Katakana Phonetic Extensions": (e1)=>e1 >= 12784 && e1 <= 12799,
            "Enclosed CJK Letters and Months": (e1)=>e1 >= 12800 && e1 <= 13055,
            "CJK Compatibility": (e1)=>e1 >= 13056 && e1 <= 13311,
            "CJK Unified Ideographs Extension A": (e1)=>e1 >= 13312 && e1 <= 19903,
            "Yijing Hexagram Symbols": (e1)=>e1 >= 19904 && e1 <= 19967,
            "CJK Unified Ideographs": (e1)=>e1 >= 19968 && e1 <= 40959,
            "Yi Syllables": (e1)=>e1 >= 40960 && e1 <= 42127,
            "Yi Radicals": (e1)=>e1 >= 42128 && e1 <= 42191,
            "Hangul Jamo Extended-A": (e1)=>e1 >= 43360 && e1 <= 43391,
            "Hangul Syllables": (e1)=>e1 >= 44032 && e1 <= 55215,
            "Hangul Jamo Extended-B": (e1)=>e1 >= 55216 && e1 <= 55295,
            "Private Use Area": (e1)=>e1 >= 57344 && e1 <= 63743,
            "CJK Compatibility Ideographs": (e1)=>e1 >= 63744 && e1 <= 64255,
            "Arabic Presentation Forms-A": (e1)=>e1 >= 64336 && e1 <= 65023,
            "Vertical Forms": (e1)=>e1 >= 65040 && e1 <= 65055,
            "CJK Compatibility Forms": (e1)=>e1 >= 65072 && e1 <= 65103,
            "Small Form Variants": (e1)=>e1 >= 65104 && e1 <= 65135,
            "Arabic Presentation Forms-B": (e1)=>e1 >= 65136 && e1 <= 65279,
            "Halfwidth and Fullwidth Forms": (e1)=>e1 >= 65280 && e1 <= 65519,
            "CJK Unified Ideographs Extension B": (e1)=>e1 >= 131072 && e1 <= 173791
        };
        function Ns(e1) {
            for (const t of e1)if (js(t.charCodeAt(0))) return !0;
            return !1;
        }
        function Us(e1) {
            for (const t of e1)if (!Vs(t.charCodeAt(0))) return !1;
            return !0;
        }
        function Vs(e1) {
            return !(Fs.Arabic(e1) || Fs["Arabic Supplement"](e1) || Fs["Arabic Extended-A"](e1) || Fs["Arabic Presentation Forms-A"](e1) || Fs["Arabic Presentation Forms-B"](e1));
        }
        function js(e1) {
            return !(746 !== e1 && 747 !== e1 && (e1 < 4352 || !(Fs["Bopomofo Extended"](e1) || Fs.Bopomofo(e1) || Fs["CJK Compatibility Forms"](e1) && !(e1 >= 65097 && e1 <= 65103) || Fs["CJK Compatibility Ideographs"](e1) || Fs["CJK Compatibility"](e1) || Fs["CJK Radicals Supplement"](e1) || Fs["CJK Strokes"](e1) || !(!Fs["CJK Symbols and Punctuation"](e1) || e1 >= 12296 && e1 <= 12305 || e1 >= 12308 && e1 <= 12319 || 12336 === e1) || Fs["CJK Unified Ideographs Extension A"](e1) || Fs["CJK Unified Ideographs"](e1) || Fs["Enclosed CJK Letters and Months"](e1) || Fs["Hangul Compatibility Jamo"](e1) || Fs["Hangul Jamo Extended-A"](e1) || Fs["Hangul Jamo Extended-B"](e1) || Fs["Hangul Jamo"](e1) || Fs["Hangul Syllables"](e1) || Fs.Hiragana(e1) || Fs["Ideographic Description Characters"](e1) || Fs.Kanbun(e1) || Fs["Kangxi Radicals"](e1) || Fs["Katakana Phonetic Extensions"](e1) || Fs.Katakana(e1) && 12540 !== e1 || !(!Fs["Halfwidth and Fullwidth Forms"](e1) || 65288 === e1 || 65289 === e1 || 65293 === e1 || e1 >= 65306 && e1 <= 65310 || 65339 === e1 || 65341 === e1 || 65343 === e1 || e1 >= 65371 && e1 <= 65503 || 65507 === e1 || e1 >= 65512 && e1 <= 65519) || !(!Fs["Small Form Variants"](e1) || e1 >= 65112 && e1 <= 65118 || e1 >= 65123 && e1 <= 65126) || Fs["Unified Canadian Aboriginal Syllabics"](e1) || Fs["Unified Canadian Aboriginal Syllabics Extended"](e1) || Fs["Vertical Forms"](e1) || Fs["Yijing Hexagram Symbols"](e1) || Fs["Yi Syllables"](e1) || Fs["Yi Radicals"](e1))));
        }
        function Gs(e1) {
            return !(js(e1) || function(e1) {
                return !!(Fs["Latin-1 Supplement"](e1) && (167 === e1 || 169 === e1 || 174 === e1 || 177 === e1 || 188 === e1 || 189 === e1 || 190 === e1 || 215 === e1 || 247 === e1) || Fs["General Punctuation"](e1) && (8214 === e1 || 8224 === e1 || 8225 === e1 || 8240 === e1 || 8241 === e1 || 8251 === e1 || 8252 === e1 || 8258 === e1 || 8263 === e1 || 8264 === e1 || 8265 === e1 || 8273 === e1) || Fs["Letterlike Symbols"](e1) || Fs["Number Forms"](e1) || Fs["Miscellaneous Technical"](e1) && (e1 >= 8960 && e1 <= 8967 || e1 >= 8972 && e1 <= 8991 || e1 >= 8996 && e1 <= 9e3 || 9003 === e1 || e1 >= 9085 && e1 <= 9114 || e1 >= 9150 && e1 <= 9165 || 9167 === e1 || e1 >= 9169 && e1 <= 9179 || e1 >= 9186 && e1 <= 9215) || Fs["Control Pictures"](e1) && 9251 !== e1 || Fs["Optical Character Recognition"](e1) || Fs["Enclosed Alphanumerics"](e1) || Fs["Geometric Shapes"](e1) || Fs["Miscellaneous Symbols"](e1) && !(e1 >= 9754 && e1 <= 9759) || Fs["Miscellaneous Symbols and Arrows"](e1) && (e1 >= 11026 && e1 <= 11055 || e1 >= 11088 && e1 <= 11097 || e1 >= 11192 && e1 <= 11243) || Fs["CJK Symbols and Punctuation"](e1) || Fs.Katakana(e1) || Fs["Private Use Area"](e1) || Fs["CJK Compatibility Forms"](e1) || Fs["Small Form Variants"](e1) || Fs["Halfwidth and Fullwidth Forms"](e1) || 8734 === e1 || 8756 === e1 || 8757 === e1 || e1 >= 9984 && e1 <= 10087 || e1 >= 10102 && e1 <= 10131 || 65532 === e1 || 65533 === e1);
            }(e1));
        }
        function qs(e1) {
            return e1 >= 1424 && e1 <= 2303 || Fs["Arabic Presentation Forms-A"](e1) || Fs["Arabic Presentation Forms-B"](e1);
        }
        function Zs(e1, t) {
            return !(!t && qs(e1) || e1 >= 2304 && e1 <= 3583 || e1 >= 3840 && e1 <= 4255 || Fs.Khmer(e1));
        }
        function $s(e1) {
            for (const t of e1)if (qs(t.charCodeAt(0))) return !0;
            return !1;
        }
        const Ws = "deferred", Hs = "loading", Xs = "loaded";
        let Ys = null, Ks = "unavailable", Js = null;
        const Qs = function(e1) {
            e1 && "string" == typeof e1 && e1.indexOf("NetworkError") > -1 && (Ks = "error"), Ys && Ys(e1);
        };
        function ea() {
            ta.fire(new It("pluginStateChange", {
                pluginStatus: Ks,
                pluginURL: Js
            }));
        }
        const ta = new zt, ia = function() {
            return Ks;
        }, ra = function() {
            if (Ks !== Ws || !Js) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Ks = Hs, ea(), Js && Te({
                url: Js
            }, (e1)=>{
                e1 ? Qs(e1) : (Ks = Xs, ea());
            });
        }, na = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Ks === Xs || null != na.applyArabicShaping,
            isLoading: ()=>Ks === Hs,
            setState (e1) {
                Ks = e1.pluginStatus, Js = e1.pluginURL;
            },
            isParsed: ()=>null != na.applyArabicShaping && null != na.processBidirectionalText && null != na.processStyledBidirectionalText,
            getPluginURL: ()=>Js
        };
        class oa {
            constructor(e1, t){
                this.zoom = e1, t ? (this.now = t.now, this.fadeDuration = t.fadeDuration, this.transition = t.transition, this.pitch = t.pitch, this.brightness = t.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(e1) {
                return function(e1, t) {
                    for (const i of e1)if (!Zs(i.charCodeAt(0), t)) return !1;
                    return !0;
                }(e1, na.isLoaded());
            }
        }
        class sa {
            constructor(e1, t, i){
                this.property = e1, this.value = t, this.expression = function(e1, t, i) {
                    if (fo(e1)) return new Io(e1, t);
                    if (To(e1) || Array.isArray(e1) && e1.length > 0) {
                        const r = So(e1, t, i);
                        if ("error" === r.result) throw new Error(r.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let i = e1;
                        return "string" == typeof e1 && "color" === t.type && (i = hi.parse(e1)), {
                            kind: "constant",
                            isConfigDependent: !1,
                            evaluate: ()=>i
                        };
                    }
                }(void 0 === t ? e1.specification.default : t, e1.specification, i);
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(e1, t, i) {
                return this.property.possiblyEvaluate(this, e1, t, i);
            }
        }
        class aa {
            constructor(e1, t){
                this.property = e1, this.value = new sa(e1, void 0, t);
            }
            transitioned(e1, t) {
                return new ca(this.property, this.value, t, k({}, e1.transition, this.transition), e1.now);
            }
            untransitioned() {
                return new ca(this.property, this.value, null, {}, 0);
            }
        }
        class la {
            constructor(e1, t){
                this._properties = e1, this._values = Object.create(e1.defaultTransitionablePropertyValues), this._options = t, this.isConfigDependent = !1;
            }
            getValue(e1) {
                return $(this._values[e1].value.value);
            }
            setValue(e1, t) {
                this._values.hasOwnProperty(e1) || (this._values[e1] = new aa(this._values[e1].property, this._options)), this._values[e1].value = new sa(this._values[e1].property, null === t ? void 0 : $(t), this._options), this.isConfigDependent = this.isConfigDependent || this._values[e1].value.expression.isConfigDependent;
            }
            setTransitionOrValue(e1, t) {
                t && (this._options = t);
                const i = this._properties.properties;
                if (e1) for(const t in e1){
                    const r = e1[t];
                    if (G(t, "-transition")) {
                        const e1 = t.slice(0, -11);
                        i[e1] && this.setTransition(e1, r);
                    } else i[t] && this.setValue(t, r);
                }
            }
            getTransition(e1) {
                return $(this._values[e1].transition);
            }
            setTransition(e1, t) {
                this._values.hasOwnProperty(e1) || (this._values[e1] = new aa(this._values[e1].property)), this._values[e1].transition = $(t) || void 0;
            }
            serialize() {
                const e1 = {};
                for (const t of Object.keys(this._values)){
                    const i = this.getValue(t);
                    void 0 !== i && (e1[t] = i);
                    const r = this.getTransition(t);
                    void 0 !== r && (e1[`${t}-transition`] = r);
                }
                return e1;
            }
            transitioned(e1, t) {
                const i = new ha(this._properties);
                for (const r of Object.keys(this._values))i._values[r] = this._values[r].transitioned(e1, t._values[r]);
                return i;
            }
            untransitioned() {
                const e1 = new ha(this._properties);
                for (const t of Object.keys(this._values))e1._values[t] = this._values[t].untransitioned();
                return e1;
            }
        }
        class ca {
            constructor(e1, t, i, r, n){
                const o = r.delay || 0, s = r.duration || 0;
                n = n || 0, this.property = e1, this.value = t, this.begin = n + o, this.end = this.begin + s, e1.specification.transition && (r.delay || r.duration) && (this.prior = i);
            }
            possiblyEvaluate(e1, t, i) {
                const r = e1.now || 0, n = this.value.possiblyEvaluate(e1, t, i), o = this.prior;
                if (o) {
                    if (r > this.end) return this.prior = null, n;
                    if (this.value.isDataDriven()) return this.prior = null, n;
                    if (r < this.begin) return o.possiblyEvaluate(e1, t, i);
                    {
                        const s = (r - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(o.possiblyEvaluate(e1, t, i), n, M(s));
                    }
                }
                return n;
            }
        }
        class ha {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(e1, t, i) {
                const r = new pa(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].possiblyEvaluate(e1, t, i);
                return r;
            }
            hasTransition() {
                for (const e1 of Object.keys(this._values))if (this._values[e1].prior) return !0;
                return !1;
            }
        }
        class ua {
            constructor(e1, t){
                this._properties = e1, this._values = Object.create(e1.defaultPropertyValues), this._options = t, this.isConfigDependent = !1;
            }
            getValue(e1) {
                return $(this._values[e1].value);
            }
            setValue(e1, t) {
                this._values[e1] = new sa(this._values[e1].property, null === t ? void 0 : $(t), this._options), this.isConfigDependent = this.isConfigDependent || this._values[e1].expression.isConfigDependent;
            }
            serialize() {
                const e1 = {};
                for (const t of Object.keys(this._values)){
                    const i = this.getValue(t);
                    void 0 !== i && (e1[t] = i);
                }
                return e1;
            }
            possiblyEvaluate(e1, t, i) {
                const r = new pa(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].possiblyEvaluate(e1, t, i);
                return r;
            }
        }
        class da {
            constructor(e1, t, i){
                this.property = e1, this.value = t, this.parameters = i;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(e1) {
                return "constant" === this.value.kind ? this.value.value : e1;
            }
            evaluate(e1, t, i, r) {
                return this.property.evaluate(this.value, this.parameters, e1, t, i, r);
            }
        }
        class pa {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultPossiblyEvaluatedValues);
            }
            get(e1) {
                return this._values[e1];
            }
        }
        class fa {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t) {
                return e1.expression.evaluate(t);
            }
            interpolate(e1, t, i) {
                const r = Qr[this.specification.type];
                return r ? r(e1, t, i) : e1;
            }
        }
        class ma {
            constructor(e1, t){
                this.specification = e1, this.overrides = t;
            }
            possiblyEvaluate(e1, t, i, r) {
                return new da(this, "constant" === e1.expression.kind || "camera" === e1.expression.kind ? {
                    kind: "constant",
                    value: e1.expression.evaluate(t, null, {}, i, r)
                } : e1.expression, t);
            }
            interpolate(e1, t, i) {
                if ("constant" !== e1.value.kind || "constant" !== t.value.kind) return e1;
                if (void 0 === e1.value.value || void 0 === t.value.value) return new da(this, {
                    kind: "constant",
                    value: void 0
                }, e1.parameters);
                const r = Qr[this.specification.type];
                return r ? new da(this, {
                    kind: "constant",
                    value: r(e1.value.value, t.value.value, i)
                }, e1.parameters) : e1;
            }
            evaluate(e1, t, i, r, n, o) {
                return "constant" === e1.kind ? e1.value : e1.evaluate(t, i, r, n, o);
            }
        }
        class _a {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t, i, r) {
                return !!e1.expression.evaluate(t, null, {}, i, r);
            }
            interpolate() {
                return !1;
            }
        }
        class ga {
            constructor(e1){
                this.properties = e1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const t = new oa(0, {});
                for(const i in e1){
                    const r = e1[i];
                    r.specification.overridable && this.overridableProperties.push(i);
                    const n = this.defaultPropertyValues[i] = new sa(r, void 0), o = this.defaultTransitionablePropertyValues[i] = new aa(r);
                    this.defaultTransitioningPropertyValues[i] = o.untransitioned(), this.defaultPossiblyEvaluatedValues[i] = n.possiblyEvaluate(t);
                }
            }
        }
        Rs(ma, "DataDrivenProperty"), Rs(fa, "DataConstantProperty"), Rs(_a, "ColorRampProperty");
        const ya = "";
        function xa(e1) {
            return e1.indexOf(ya) >= 0;
        }
        function va(e1, t) {
            return t ? `${e1}${ya}${t}` : e1;
        }
        function ba(e1) {
            const t = e1.indexOf(ya);
            return t >= 0 ? e1.slice(0, t) : e1;
        }
        const wa = "-transition";
        class Ta extends zt {
            constructor(e1, t, i){
                if (super(), this.id = e1.id, this.type = e1.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, this.isConfigDependent = !1, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && "sky" !== e1.type && "slot" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter), this.options = i, e1.slot && (this.slot = e1.slot), t.layout && (this._unevaluatedLayout = new ua(t.layout, i), this.isConfigDependent = this.isConfigDependent || this._unevaluatedLayout.isConfigDependent), t.paint)) {
                    this._transitionablePaint = new la(t.paint, i);
                    for(const t in e1.paint)this.setPaintProperty(t, e1.paint[t], {
                        validate: !1
                    });
                    for(const t in e1.layout)this.setLayoutProperty(t, e1.layout[t], {
                        validate: !1
                    });
                    this.isConfigDependent = this.isConfigDependent || this._transitionablePaint.isConfigDependent, this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new pa(t.paint);
                }
            }
            setScope(e1) {
                this.scope = e1, this.fqid = va(this.id, e1);
            }
            getLayoutProperty(e1) {
                return "visibility" === e1 ? this.visibility : this._unevaluatedLayout.getValue(e1);
            }
            setLayoutProperty(e1, t, i = {}) {
                if (null != t && this._validate(Es, `layers.${this.id}.layout.${e1}`, e1, t, i)) return;
                if ("custom" === this.type && "visibility" === e1) return void (this.visibility = t);
                const r = this._unevaluatedLayout;
                r._properties.properties[e1] && (r.setValue(e1, t), this.isConfigDependent = this.isConfigDependent || r.isConfigDependent, "visibility" === e1 && this.possiblyEvaluateVisibility());
            }
            possiblyEvaluateVisibility() {
                this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                });
            }
            getPaintProperty(e1) {
                return G(e1, wa) ? this._transitionablePaint.getTransition(e1.slice(0, -11)) : this._transitionablePaint.getValue(e1);
            }
            setPaintProperty(e1, t, i = {}) {
                if (null != t && this._validate(Ts, `layers.${this.id}.paint.${e1}`, e1, t, i)) return !1;
                const r = this._transitionablePaint, n = r._properties.properties;
                if (G(e1, wa)) {
                    const i = e1.slice(0, -11);
                    return n[i] && r.setTransition(i, t || void 0), !1;
                }
                if (!n[e1]) return !1;
                const o = r._values[e1], s = o.value.isDataDriven(), a = o.value;
                r.setValue(e1, t), this.isConfigDependent = this.isConfigDependent || r.isConfigDependent, this._handleSpecialPaintPropertyUpdate(e1);
                const l = r._values[e1].value, c = l.isDataDriven(), h = G(e1, "pattern") || "line-dasharray" === e1;
                return c || s || h || this._handleOverridablePaintPropertyUpdate(e1, a, l);
            }
            _handleSpecialPaintPropertyUpdate(e1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(e1, t) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(e1, t, i) {
                return !1;
            }
            isHidden(e1) {
                return !!(this.minzoom && e1 < this.minzoom) || !!(this.maxzoom && e1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(e1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(e1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(e1, t) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e1, void 0, t)), this.paint = this._transitioningPaint.possiblyEvaluate(e1, void 0, t);
            }
            serialize() {
                return Z({
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                }, (e1, t)=>!(void 0 === e1 || "layout" === t && !Object.keys(e1).length || "paint" === t && !Object.keys(e1).length));
            }
            _validate(e1, t, i, r, n = {}) {
                return (!n || !1 !== n.validate) && Ss(this, e1.call(ms, {
                    key: t,
                    layerType: this.type,
                    objectKey: i,
                    value: r,
                    styleSpec: Pt,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            resize() {}
            isStateDependent() {
                for(const e1 in this.paint._values){
                    const t = this.paint.get(e1);
                    if (t instanceof da && co(t.property.specification) && ("source" === t.value.kind || "composite" === t.value.kind) && t.value.isStateDependent) return !0;
                }
                return !1;
            }
            compileFilter() {
                this._filterCompiled || (this._featureFilter = Fo(this.filter), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats() {
                this._stats && (this._stats.numRenderedVerticesInShadowPass = 0, this._stats.numRenderedVerticesInTransparentPass = 0);
            }
        }
        class Ea {
            constructor(){
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set, this._updatedImages = new Set;
            }
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e1, t) {
                this._updatedSourceCaches[e1] = t, this.setDirty();
            }
            discardSourceCacheUpdate(e1) {
                delete this._updatedSourceCaches[e1];
            }
            updateLayer(e1) {
                const t = e1.scope;
                this._updatedLayers[t] = this._updatedLayers[t] || new Set, this._updatedLayers[t].add(e1.id), this.setDirty();
            }
            removeLayer(e1) {
                const t = e1.scope;
                this._removedLayers[t] = this._removedLayers[t] || {}, this._updatedLayers[t] = this._updatedLayers[t] || new Set, this._removedLayers[t][e1.id] = e1, this._updatedLayers[t].delete(e1.id), this._updatedPaintProps.delete(e1.fqid), this.setDirty();
            }
            getRemovedLayer(e1) {
                return this._removedLayers[e1.scope] ? this._removedLayers[e1.scope][e1.id] : null;
            }
            discardLayerRemoval(e1) {
                this._removedLayers[e1.scope] && delete this._removedLayers[e1.scope][e1.id];
            }
            getLayerUpdatesByScope() {
                const e1 = {};
                for(const t in this._updatedLayers)e1[t] = e1[t] || {}, e1[t].updatedIds = Array.from(this._updatedLayers[t].values());
                for(const t in this._removedLayers)e1[t] = e1[t] || {}, e1[t].removedIds = Object.keys(this._removedLayers[t]);
                return e1;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e1) {
                this._updatedPaintProps.add(e1.fqid), this.setDirty();
            }
            getUpdatedImages() {
                return Array.from(this._updatedImages.values());
            }
            updateImage(e1) {
                this._updatedImages.add(e1), this.setDirty();
            }
            resetUpdatedImages() {
                this._updatedImages.clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
            }
        }
        const Ma = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Aa {
            constructor(e1, t){
                this._structArray = e1, this._pos1 = t * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class Sa {
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            static serialize(e1, t) {
                return e1._trim(), t && (e1.isTransferred = !0, t.add(e1.arrayBuffer)), {
                    length: e1.length,
                    arrayBuffer: e1.arrayBuffer
                };
            }
            static deserialize(e1) {
                const t = Object.create(this.prototype);
                return t.arrayBuffer = e1.arrayBuffer, t.length = e1.length, t.capacity = e1.arrayBuffer.byteLength / t.bytesPerElement, t._refreshViews(), t;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(e1) {
                this.reserve(e1), this.length = e1;
            }
            reserve(e1) {
                if (e1 > this.capacity) {
                    this.capacity = Math.max(e1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const t = this.uint8;
                    this._refreshViews(), t && this.uint8.set(t);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function Ia(e1, t = 1) {
            let i = 0, r = 0;
            return {
                members: e1.map((e1)=>{
                    const n = Ma[e1.type].BYTES_PER_ELEMENT, o = i = Ca(i, Math.max(t, n)), s = e1.components || 1;
                    return r = Math.max(r, n), i += n * s, {
                        name: e1.name,
                        type: e1.type,
                        components: s,
                        offset: o
                    };
                }),
                size: Ca(i, Math.max(r, t)),
                alignment: t
            };
        }
        function Ca(e1, t) {
            return Math.ceil(e1 / t) * t;
        }
        class za extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t);
            }
            emplace(e1, t, i) {
                const r = 2 * e1;
                return this.int16[r + 0] = t, this.int16[r + 1] = i, e1;
            }
        }
        za.prototype.bytesPerElement = 4, Rs(za, "StructArrayLayout2i4");
        class Pa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t, i);
            }
            emplace(e1, t, i, r) {
                const n = 3 * e1;
                return this.int16[n + 0] = t, this.int16[n + 1] = i, this.int16[n + 2] = r, e1;
            }
        }
        Pa.prototype.bytesPerElement = 6, Rs(Pa, "StructArrayLayout3i6");
        class Da extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 4 * e1;
                return this.int16[o + 0] = t, this.int16[o + 1] = i, this.int16[o + 2] = r, this.int16[o + 3] = n, e1;
            }
        }
        Da.prototype.bytesPerElement = 8, Rs(Da, "StructArrayLayout4i8");
        class Ra extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 5 * e1;
                return this.int16[s + 0] = t, this.int16[s + 1] = i, this.int16[s + 2] = r, this.int16[s + 3] = n, this.int16[s + 4] = o, e1;
            }
        }
        Ra.prototype.bytesPerElement = 10, Rs(Ra, "StructArrayLayout5i10");
        class La extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 6 * e1, c = 12 * e1, h = 3 * e1;
                return this.int16[l + 0] = t, this.int16[l + 1] = i, this.uint8[c + 4] = r, this.uint8[c + 5] = n, this.uint8[c + 6] = o, this.uint8[c + 7] = s, this.float32[h + 2] = a, e1;
            }
        }
        La.prototype.bytesPerElement = 12, Rs(La, "StructArrayLayout2i4ub1f12");
        class ka extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 4 * e1;
                return this.float32[o + 0] = t, this.float32[o + 1] = i, this.float32[o + 2] = r, this.float32[o + 3] = n, e1;
            }
        }
        ka.prototype.bytesPerElement = 16, Rs(ka, "StructArrayLayout4f16");
        class Oa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 6 * e1, a = 3 * e1;
                return this.uint16[s + 0] = t, this.uint16[s + 1] = i, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.float32[a + 2] = o, e1;
            }
        }
        Oa.prototype.bytesPerElement = 12, Rs(Oa, "StructArrayLayout4ui1f12");
        class Ba extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 4 * e1;
                return this.uint16[o + 0] = t, this.uint16[o + 1] = i, this.uint16[o + 2] = r, this.uint16[o + 3] = n, e1;
            }
        }
        Ba.prototype.bytesPerElement = 8, Rs(Ba, "StructArrayLayout4ui8");
        class Fa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t, i, r, n, o);
            }
            emplace(e1, t, i, r, n, o, s) {
                const a = 6 * e1;
                return this.int16[a + 0] = t, this.int16[a + 1] = i, this.int16[a + 2] = r, this.int16[a + 3] = n, this.int16[a + 4] = o, this.int16[a + 5] = s, e1;
            }
        }
        Fa.prototype.bytesPerElement = 12, Rs(Fa, "StructArrayLayout6i12");
        class Na extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u) {
                const d = this.length;
                return this.resize(d + 1), this.emplace(d, e1, t, i, r, n, o, s, a, l, c, h, u);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
                const p = 12 * e1;
                return this.int16[p + 0] = t, this.int16[p + 1] = i, this.int16[p + 2] = r, this.int16[p + 3] = n, this.uint16[p + 4] = o, this.uint16[p + 5] = s, this.uint16[p + 6] = a, this.uint16[p + 7] = l, this.int16[p + 8] = c, this.int16[p + 9] = h, this.int16[p + 10] = u, this.int16[p + 11] = d, e1;
            }
        }
        Na.prototype.bytesPerElement = 24, Rs(Na, "StructArrayLayout4i4ui4i24");
        class Ua extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t, i, r, n, o);
            }
            emplace(e1, t, i, r, n, o, s) {
                const a = 10 * e1, l = 5 * e1;
                return this.int16[a + 0] = t, this.int16[a + 1] = i, this.int16[a + 2] = r, this.float32[l + 2] = n, this.float32[l + 3] = o, this.float32[l + 4] = s, e1;
            }
        }
        Ua.prototype.bytesPerElement = 20, Rs(Ua, "StructArrayLayout3i3f20");
        class Va extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint32[1 * e1 + 0] = t, e1;
            }
        }
        Va.prototype.bytesPerElement = 4, Rs(Va, "StructArrayLayout1ul4");
        class ja extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t);
            }
            emplace(e1, t, i) {
                const r = 2 * e1;
                return this.uint16[r + 0] = t, this.uint16[r + 1] = i, e1;
            }
        }
        ja.prototype.bytesPerElement = 4, Rs(ja, "StructArrayLayout2ui4");
        class Ga extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, e1, t, i, r, n, o, s, a, l, c, h, u, d);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p) {
                const f = 20 * e1, m = 10 * e1;
                return this.int16[f + 0] = t, this.int16[f + 1] = i, this.int16[f + 2] = r, this.int16[f + 3] = n, this.int16[f + 4] = o, this.float32[m + 3] = s, this.float32[m + 4] = a, this.float32[m + 5] = l, this.float32[m + 6] = c, this.int16[f + 14] = h, this.uint32[m + 8] = u, this.uint16[f + 18] = d, this.uint16[f + 19] = p, e1;
            }
        }
        Ga.prototype.bytesPerElement = 40, Rs(Ga, "StructArrayLayout5i4f1i1ul2ui40");
        class qa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 8 * e1;
                return this.int16[l + 0] = t, this.int16[l + 1] = i, this.int16[l + 2] = r, this.int16[l + 4] = n, this.int16[l + 5] = o, this.int16[l + 6] = s, this.int16[l + 7] = a, e1;
            }
        }
        qa.prototype.bytesPerElement = 16, Rs(qa, "StructArrayLayout3i2i2i16");
        class Za extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 4 * e1, a = 8 * e1;
                return this.float32[s + 0] = t, this.float32[s + 1] = i, this.float32[s + 2] = r, this.int16[a + 6] = n, this.int16[a + 7] = o, e1;
            }
        }
        Za.prototype.bytesPerElement = 16, Rs(Za, "StructArrayLayout2f1f2i16");
        class $a extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 12 * e1, s = 3 * e1;
                return this.uint8[o + 0] = t, this.uint8[o + 1] = i, this.float32[s + 1] = r, this.float32[s + 2] = n, e1;
            }
        }
        $a.prototype.bytesPerElement = 12, Rs($a, "StructArrayLayout2ub2f12");
        class Wa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t, i);
            }
            emplace(e1, t, i, r) {
                const n = 3 * e1;
                return this.uint16[n + 0] = t, this.uint16[n + 1] = i, this.uint16[n + 2] = r, e1;
            }
        }
        Wa.prototype.bytesPerElement = 6, Rs(Wa, "StructArrayLayout3ui6");
        class Ha extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v) {
                const b = this.length;
                return this.resize(b + 1), this.emplace(b, e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b) {
                const w = 30 * e1, T = 15 * e1, E = 60 * e1;
                return this.int16[w + 0] = t, this.int16[w + 1] = i, this.int16[w + 2] = r, this.float32[T + 2] = n, this.float32[T + 3] = o, this.uint16[w + 8] = s, this.uint16[w + 9] = a, this.uint32[T + 5] = l, this.uint32[T + 6] = c, this.uint32[T + 7] = h, this.uint16[w + 16] = u, this.uint16[w + 17] = d, this.uint16[w + 18] = p, this.float32[T + 10] = f, this.float32[T + 11] = m, this.uint8[E + 48] = _, this.uint8[E + 49] = g, this.uint8[E + 50] = y, this.uint32[T + 13] = x, this.int16[w + 28] = v, this.uint8[E + 58] = b, e1;
            }
        }
        Ha.prototype.bytesPerElement = 60, Rs(Ha, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class Xa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I, C, z, P) {
                const D = this.length;
                return this.resize(D + 1), this.emplace(D, e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I, C, z, P);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I, C, z, P, D) {
                const R = 20 * e1, L = 40 * e1, k = 80 * e1;
                return this.float32[R + 0] = t, this.float32[R + 1] = i, this.int16[L + 4] = r, this.int16[L + 5] = n, this.int16[L + 6] = o, this.int16[L + 7] = s, this.int16[L + 8] = a, this.int16[L + 9] = l, this.int16[L + 10] = c, this.int16[L + 11] = h, this.int16[L + 12] = u, this.uint16[L + 13] = d, this.uint16[L + 14] = p, this.uint16[L + 15] = f, this.uint16[L + 16] = m, this.uint16[L + 17] = _, this.uint16[L + 18] = g, this.uint16[L + 19] = y, this.uint16[L + 20] = x, this.uint16[L + 21] = v, this.uint16[L + 22] = b, this.uint16[L + 23] = w, this.uint16[L + 24] = T, this.uint16[L + 25] = E, this.uint16[L + 26] = M, this.uint16[L + 27] = A, this.uint32[R + 14] = S, this.float32[R + 15] = I, this.float32[R + 16] = C, this.float32[R + 17] = z, this.float32[R + 18] = P, this.uint8[k + 76] = D, e1;
            }
        }
        Xa.prototype.bytesPerElement = 80, Rs(Xa, "StructArrayLayout2f9i15ui1ul4f1ub80");
        class Ya extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.float32[1 * e1 + 0] = t, e1;
            }
        }
        Ya.prototype.bytesPerElement = 4, Rs(Ya, "StructArrayLayout1f4");
        class Ka extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 5 * e1;
                return this.float32[s + 0] = t, this.float32[s + 1] = i, this.float32[s + 2] = r, this.float32[s + 3] = n, this.float32[s + 4] = o, e1;
            }
        }
        Ka.prototype.bytesPerElement = 20, Rs(Ka, "StructArrayLayout5f20");
        class Ja extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 7 * e1;
                return this.float32[l + 0] = t, this.float32[l + 1] = i, this.float32[l + 2] = r, this.float32[l + 3] = n, this.float32[l + 4] = o, this.float32[l + 5] = s, this.float32[l + 6] = a, e1;
            }
        }
        Ja.prototype.bytesPerElement = 28, Rs(Ja, "StructArrayLayout7f28");
        class Qa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 6 * e1;
                return this.uint32[3 * e1 + 0] = t, this.uint16[o + 2] = i, this.uint16[o + 3] = r, this.uint16[o + 4] = n, e1;
            }
        }
        Qa.prototype.bytesPerElement = 12, Rs(Qa, "StructArrayLayout1ul3ui12");
        class el extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint16[1 * e1 + 0] = t, e1;
            }
        }
        el.prototype.bytesPerElement = 2, Rs(el, "StructArrayLayout1ui2");
        class tl extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t, i);
            }
            emplace(e1, t, i, r) {
                const n = 3 * e1;
                return this.float32[n + 0] = t, this.float32[n + 1] = i, this.float32[n + 2] = r, e1;
            }
        }
        tl.prototype.bytesPerElement = 12, Rs(tl, "StructArrayLayout3f12");
        class il extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t);
            }
            emplace(e1, t, i) {
                const r = 2 * e1;
                return this.float32[r + 0] = t, this.float32[r + 1] = i, e1;
            }
        }
        il.prototype.bytesPerElement = 8, Rs(il, "StructArrayLayout2f8");
        class rl extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
                const _ = this.length;
                return this.resize(_ + 1), this.emplace(_, e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _) {
                const g = 16 * e1;
                return this.float32[g + 0] = t, this.float32[g + 1] = i, this.float32[g + 2] = r, this.float32[g + 3] = n, this.float32[g + 4] = o, this.float32[g + 5] = s, this.float32[g + 6] = a, this.float32[g + 7] = l, this.float32[g + 8] = c, this.float32[g + 9] = h, this.float32[g + 10] = u, this.float32[g + 11] = d, this.float32[g + 12] = p, this.float32[g + 13] = f, this.float32[g + 14] = m, this.float32[g + 15] = _, e1;
            }
        }
        rl.prototype.bytesPerElement = 64, Rs(rl, "StructArrayLayout16f64");
        class nl extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 10 * e1, c = 5 * e1;
                return this.uint16[l + 0] = t, this.uint16[l + 1] = i, this.uint16[l + 2] = r, this.uint16[l + 3] = n, this.float32[c + 2] = o, this.float32[c + 3] = s, this.float32[c + 4] = a, e1;
            }
        }
        nl.prototype.bytesPerElement = 20, Rs(nl, "StructArrayLayout4ui3f20");
        class ol extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint8[1 * e1 + 0] = t, e1;
            }
        }
        ol.prototype.bytesPerElement = 1, Rs(ol, "StructArrayLayout1ub1");
        class sl extends Aa {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        sl.prototype.size = 40;
        class al extends Ga {
            get(e1) {
                return new sl(this, e1);
            }
        }
        Rs(al, "CollisionBoxArray");
        class ll extends Aa {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(e1) {
                this._structArray.uint8[this._pos1 + 49] = e1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(e1) {
                this._structArray.uint8[this._pos1 + 50] = e1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 13] = e1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(e1) {
                this._structArray.uint8[this._pos1 + 58] = e1;
            }
        }
        ll.prototype.size = 60;
        class cl extends Ha {
            get(e1) {
                return new ll(this, e1);
            }
        }
        Rs(cl, "PlacedSymbolArray");
        class hl extends Aa {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 14] = e1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(e1) {
                this._structArray.float32[this._pos4 + 18] = e1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
        }
        hl.prototype.size = 80;
        class ul extends Xa {
            get(e1) {
                return new hl(this, e1);
            }
        }
        Rs(ul, "SymbolInstanceArray");
        class dl extends Ya {
            getoffsetX(e1) {
                return this.float32[1 * e1 + 0];
            }
        }
        Rs(dl, "GlyphOffsetArray");
        class pl extends za {
            getx(e1) {
                return this.int16[2 * e1 + 0];
            }
            gety(e1) {
                return this.int16[2 * e1 + 1];
            }
        }
        Rs(pl, "SymbolLineVertexArray");
        class fl extends Aa {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        fl.prototype.size = 12;
        class ml extends Qa {
            get(e1) {
                return new fl(this, e1);
            }
        }
        Rs(ml, "FeatureIndexArray");
        class _l extends ja {
            geta_centroid_pos0(e1) {
                return this.uint16[2 * e1 + 0];
            }
            geta_centroid_pos1(e1) {
                return this.uint16[2 * e1 + 1];
            }
        }
        Rs(_l, "FillExtrusionCentroidArray");
        const gl = Ia([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), yl = Ia([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class xl {
            constructor(e1 = []){
                this.segments = e1;
            }
            _prepareSegment(e1, t, i, r) {
                let n = this.segments[this.segments.length - 1];
                return e1 > xl.MAX_VERTEX_ARRAY_LENGTH && H(`Max vertices per segment is ${xl.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${e1}`), (!n || n.vertexLength + e1 > xl.MAX_VERTEX_ARRAY_LENGTH || n.sortKey !== r) && (n = {
                    vertexOffset: t,
                    primitiveOffset: i,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== r && (n.sortKey = r), this.segments.push(n)), n;
            }
            prepareSegment(e1, t, i, r) {
                return this._prepareSegment(e1, t.length, i.length, r);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const e1 of this.segments)for(const t in e1.vaos)e1.vaos[t].destroy();
            }
            static simpleSegment(e1, t, i, r) {
                return new xl([
                    {
                        vertexOffset: e1,
                        primitiveOffset: t,
                        vertexLength: i,
                        primitiveLength: r,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function vl(e1, t) {
            return 256 * (e1 = z(Math.floor(e1), 0, 255)) + z(Math.floor(t), 0, 255);
        }
        xl.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Rs(xl, "SegmentVector");
        const bl = Ia([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), wl = Ia([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        var Tl = {
            exports: {}
        }, El = {
            exports: {}
        };
        !function(e1) {
            e1.exports = function(e1, t) {
                var i, r, n, o, s, a, l, c;
                for(r = e1.length - (i = 3 & e1.length), n = t, s = 3432918353, a = 461845907, c = 0; c < r;)l = 255 & e1.charCodeAt(c) | (255 & e1.charCodeAt(++c)) << 8 | (255 & e1.charCodeAt(++c)) << 16 | (255 & e1.charCodeAt(++c)) << 24, ++c, n = 27492 + (65535 & (o = 5 * (65535 & (n = (n ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 13 | n >>> 19)) + ((5 * (n >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (o >>> 16) & 65535) << 16);
                switch(l = 0, i){
                    case 3:
                        l ^= (255 & e1.charCodeAt(c + 2)) << 16;
                    case 2:
                        l ^= (255 & e1.charCodeAt(c + 1)) << 8;
                    case 1:
                        n ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e1.charCodeAt(c))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295;
                }
                return n ^= e1.length, n = 2246822507 * (65535 & (n ^= n >>> 16)) + ((2246822507 * (n >>> 16) & 65535) << 16) & 4294967295, n = 3266489909 * (65535 & (n ^= n >>> 13)) + ((3266489909 * (n >>> 16) & 65535) << 16) & 4294967295, (n ^= n >>> 16) >>> 0;
            };
        }(El);
        var Ml = El.exports, Al = {
            exports: {}
        };
        !function(e1) {
            e1.exports = function(e1, t) {
                for(var i, r = e1.length, n = t ^ r, o = 0; r >= 4;)i = 1540483477 * (65535 & (i = 255 & e1.charCodeAt(o) | (255 & e1.charCodeAt(++o)) << 8 | (255 & e1.charCodeAt(++o)) << 16 | (255 & e1.charCodeAt(++o)) << 24)) + ((1540483477 * (i >>> 16) & 65535) << 16), n = 1540483477 * (65535 & n) + ((1540483477 * (n >>> 16) & 65535) << 16) ^ (i = 1540483477 * (65535 & (i ^= i >>> 24)) + ((1540483477 * (i >>> 16) & 65535) << 16)), r -= 4, ++o;
                switch(r){
                    case 3:
                        n ^= (255 & e1.charCodeAt(o + 2)) << 16;
                    case 2:
                        n ^= (255 & e1.charCodeAt(o + 1)) << 8;
                    case 1:
                        n = 1540483477 * (65535 & (n ^= 255 & e1.charCodeAt(o))) + ((1540483477 * (n >>> 16) & 65535) << 16);
                }
                return n = 1540483477 * (65535 & (n ^= n >>> 13)) + ((1540483477 * (n >>> 16) & 65535) << 16), (n ^= n >>> 15) >>> 0;
            };
        }(Al);
        var Sl = Ml, Il = Al.exports;
        Tl.exports = Sl, Tl.exports.murmur3 = Sl, Tl.exports.murmur2 = Il;
        var Cl = d(Tl.exports);
        class zl {
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
            add(e1, t, i, r) {
                this.ids.push(Pl(e1)), this.positions.push(t, i, r);
            }
            eachPosition(e1, t) {
                const i = Pl(e1);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const e1 = r + n >> 1;
                    this.ids[e1] >= i ? n = e1 : r = e1 + 1;
                }
                for(; this.ids[r] === i;)t(this.positions[3 * r], this.positions[3 * r + 1], this.positions[3 * r + 2]), r++;
            }
            static serialize(e1, t) {
                const i = new Float64Array(e1.ids), r = new Uint32Array(e1.positions);
                return Dl(i, r, 0, i.length - 1), t && (t.add(i.buffer), t.add(r.buffer)), {
                    ids: i,
                    positions: r
                };
            }
            static deserialize(e1) {
                const t = new zl;
                let i;
                t.ids = e1.ids, t.positions = e1.positions;
                for (const e1 of t.ids)e1 !== i && t.uniqueIds.push(e1), i = e1;
                return t.indexed = !0, t;
            }
        }
        function Pl(e1) {
            const t = +e1;
            return !isNaN(t) && Number.MIN_SAFE_INTEGER <= t && t <= Number.MAX_SAFE_INTEGER ? t : Cl(String(e1));
        }
        function Dl(e1, t, i, r) {
            for(; i < r;){
                const n = e1[i + r >> 1];
                let o = i - 1, s = r + 1;
                for(;;){
                    do o++;
                    while (e1[o] < n);
                    do s--;
                    while (e1[s] > n);
                    if (o >= s) break;
                    Rl(e1, o, s), Rl(t, 3 * o, 3 * s), Rl(t, 3 * o + 1, 3 * s + 1), Rl(t, 3 * o + 2, 3 * s + 2);
                }
                s - i < r - s ? (Dl(e1, t, i, s), i = s + 1) : (Dl(e1, t, s + 1, r), r = s);
            }
        }
        function Rl(e1, t, i) {
            const r = e1[t];
            e1[t] = e1[i], e1[i] = r;
        }
        Rs(zl, "FeaturePositionMap");
        class Ll {
            constructor(e1){
                this.gl = e1.gl, this.initialized = !1;
            }
            fetchUniformLocation(e1, t) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(e1, t), this.initialized = !0), !!this.location;
            }
        }
        class kl extends Ll {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && this.current !== i && (this.current = i, this.gl.uniform1i(this.location, i));
            }
        }
        class Ol extends Ll {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && this.current !== i && (this.current = i, this.gl.uniform1f(this.location, i));
            }
        }
        class Bl extends Ll {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0
                ];
            }
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i[0] === this.current[0] && i[1] === this.current[1] || (this.current = i, this.gl.uniform2f(this.location, i[0], i[1])));
            }
        }
        class Fl extends Ll {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] || (this.current = i, this.gl.uniform3f(this.location, i[0], i[1], i[2])));
            }
        }
        class Nl extends Ll {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] && i[3] === this.current[3] || (this.current = i, this.gl.uniform4f(this.location, i[0], i[1], i[2], i[3])));
            }
        }
        class Ul extends Ll {
            constructor(e1){
                super(e1), this.current = hi.transparent;
            }
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i.r === this.current.r && i.g === this.current.g && i.b === this.current.b && i.a === this.current.a || (this.current = i, this.gl.uniform4f(this.location, i.r, i.g, i.b, i.a)));
            }
        }
        const Vl = new Float32Array(16);
        class jl extends Ll {
            constructor(e1){
                super(e1), this.current = Vl;
            }
            set(e1, t, i) {
                if (this.fetchUniformLocation(e1, t)) {
                    if (i[12] !== this.current[12] || i[0] !== this.current[0]) return this.current = i, void this.gl.uniformMatrix4fv(this.location, !1, i);
                    for(let e1 = 1; e1 < 16; e1++)if (i[e1] !== this.current[e1]) {
                        this.current = i, this.gl.uniformMatrix4fv(this.location, !1, i);
                        break;
                    }
                }
            }
        }
        const Gl = new Float32Array(9);
        class ql extends Ll {
            constructor(e1){
                super(e1), this.current = Gl;
            }
            set(e1, t, i) {
                if (this.fetchUniformLocation(e1, t)) {
                    for(let e1 = 0; e1 < 9; e1++)if (i[e1] !== this.current[e1]) {
                        this.current = i, this.gl.uniformMatrix3fv(this.location, !1, i);
                        break;
                    }
                }
            }
        }
        const Zl = new Float32Array(4);
        class $l extends Ll {
            constructor(e1){
                super(e1), this.current = Zl;
            }
            set(e1, t, i) {
                if (this.fetchUniformLocation(e1, t)) {
                    for(let e1 = 0; e1 < 4; e1++)if (i[e1] !== this.current[e1]) {
                        this.current = i, this.gl.uniformMatrix2fv(this.location, !1, i);
                        break;
                    }
                }
            }
        }
        function Wl(e1) {
            return [
                vl(255 * e1.r, 255 * e1.g),
                vl(255 * e1.b, 255 * e1.a)
            ];
        }
        class Hl {
            constructor(e1, t, i){
                this.value = e1, this.uniformNames = t.map((e1)=>`u_${e1}`), this.type = i;
            }
            setUniform(e1, t, i, r, n) {
                t.set(e1, n, r.constantOr(this.value));
            }
            getBinding(e1, t) {
                return "color" === this.type ? new Ul(e1) : new Ol(e1);
            }
        }
        class Xl {
            constructor(e1, t){
                this.uniformNames = t.map((e1)=>`u_${e1}`), this.pattern = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(e1) {
                this.pixelRatio = e1.pixelRatio || 1, this.pattern = e1.tl.concat(e1.br);
            }
            setUniform(e1, t, i, r, n) {
                const o = "u_pattern" === n || "u_dash" === n ? this.pattern : "u_pixel_ratio" === n ? this.pixelRatio : null;
                o && t.set(e1, n, o);
            }
            getBinding(e1, t) {
                return "u_pattern" === t || "u_dash" === t ? new Nl(e1) : new Ol(e1);
            }
        }
        class Yl {
            constructor(e1, t, i, r){
                this.expression = e1, this.type = i, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new r;
            }
            populatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.paintVertexArray.length, l = this.expression.evaluate(new oa(0, {
                    brightness: o
                }), t, {}, n, r, s);
                this.paintVertexArray.resize(e1), this._setPaintValue(a, e1, l);
            }
            updatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.expression.evaluate({
                    zoom: 0,
                    brightness: s
                }, i, r, void 0, n);
                this._setPaintValue(e1, t, a);
            }
            _setPaintValue(e1, t, i) {
                if ("color" === this.type) {
                    const r = Wl(i);
                    for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, r[0], r[1]);
                } else {
                    for(let r = e1; r < t; r++)this.paintVertexArray.emplace(r, i);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Kl {
            constructor(e1, t, i, r, n, o){
                this.expression = e1, this.uniformNames = t.map((e1)=>`u_${e1}_t`), this.type = i, this.useIntegerZoom = r, this.zoom = n, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new o;
            }
            populatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.expression.evaluate(new oa(this.zoom, {
                    brightness: o
                }), t, {}, n, r, s), l = this.expression.evaluate(new oa(this.zoom + 1, {
                    brightness: o
                }), t, {}, n, r, s), c = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValue(c, e1, a, l);
            }
            updatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.expression.evaluate({
                    zoom: this.zoom,
                    brightness: s
                }, i, r, void 0, n), l = this.expression.evaluate({
                    zoom: this.zoom + 1,
                    brightness: s
                }, i, r, void 0, n);
                this._setPaintValue(e1, t, a, l);
            }
            _setPaintValue(e1, t, i, r) {
                if ("color" === this.type) {
                    const n = Wl(i), o = Wl(r);
                    for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, n[0], n[1], o[0], o[1]);
                } else {
                    for(let n = e1; n < t; n++)this.paintVertexArray.emplace(n, i, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i), Math.abs(r));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(e1, t, i, r, n) {
                const o = this.useIntegerZoom ? Math.floor(i.zoom) : i.zoom, s = z(this.expression.interpolationFactor(o, this.zoom, this.zoom + 1), 0, 1);
                t.set(e1, n, s);
            }
            getBinding(e1, t) {
                return new Ol(e1);
            }
        }
        class Jl {
            constructor(e1, t, i, r, n){
                this.expression = e1, this.layerId = n, this.paintVertexAttributes = ("array" === i ? wl : bl).members;
                for(let e1 = 0; e1 < t.length; ++e1);
                this.paintVertexArray = new r;
            }
            populatePaintArray(e1, t, i) {
                const r = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValues(r, e1, t.patterns && t.patterns[this.layerId], i);
            }
            updatePaintArray(e1, t, i, r, n, o, s) {
                this._setPaintValues(e1, t, i.patterns && i.patterns[this.layerId], o);
            }
            _setPaintValues(e1, t, i, r) {
                if (!r || !i) return;
                const n = r[i];
                if (!n) return;
                const { tl: o, br: s, pixelRatio: a } = n;
                for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, o[0], o[1], s[0], s[1], a);
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class Ql {
            constructor(e1, t, i = ()=>!0){
                this.binders = {}, this._buffers = [];
                const r = [];
                for(const n in e1.paint._values){
                    const o = e1.paint.get(n);
                    if (!i(n)) continue;
                    if (!(o instanceof da && co(o.property.specification))) continue;
                    const s = ic(n, e1.type), a = o.value, l = o.property.specification.type, c = !!o.property.useIntegerZoom, h = "line-dasharray" === n || n.endsWith("pattern"), u = "line-dasharray" === n && "constant" !== e1.layout.get("line-cap").value.kind;
                    if ("constant" !== a.kind || u) {
                        if ("source" === a.kind || u || h) {
                            const t = oc(n, l, "source");
                            this.binders[n] = h ? new Jl(a, s, l, t, e1.id) : new Yl(a, s, l, t), r.push(`/a_${n}`);
                        } else {
                            const e1 = oc(n, l, "composite");
                            this.binders[n] = new Kl(a, s, l, c, t, e1), r.push(`/z_${n}`);
                        }
                    } else this.binders[n] = h ? new Xl(a.value, s) : new Hl(a.value, s, l), r.push(`/u_${n}`);
                }
                this.cacheKey = r.sort().join("");
            }
            getMaxValue(e1) {
                const t = this.binders[e1];
                return t instanceof Yl || t instanceof Kl ? t.maxValue : 0;
            }
            populatePaintArrays(e1, t, i, r, n, o, s) {
                for(const a in this.binders){
                    const l = this.binders[a];
                    (l instanceof Yl || l instanceof Kl || l instanceof Jl) && l.populatePaintArray(e1, t, i, r, n, o, s);
                }
            }
            setConstantPatternPositions(e1) {
                for(const t in this.binders){
                    const i = this.binders[t];
                    i instanceof Xl && i.setConstantPatternPositions(e1);
                }
            }
            updatePaintArrays(e1, t, i, r, n, o, s, a) {
                let l = !1;
                const c = Object.keys(e1), h = 0 !== c.length, u = h ? c : t.uniqueIds;
                for(const c in this.binders){
                    const d = this.binders[c];
                    if ((d instanceof Yl || d instanceof Kl || d instanceof Jl) && (!0 === d.expression.isStateDependent || !1 === d.expression.isLightConstant)) {
                        const p = n.paint.get(c);
                        d.expression = p.value;
                        for (const i of u){
                            const n = e1[i.toString()];
                            t.eachPosition(i, (e1, t, i)=>{
                                const l = r.feature(e1);
                                d.updatePaintArray(t, i, l, n, o, s, a);
                            });
                        }
                        if (!h) for (const t of i.uniqueIds){
                            const n = e1[t.toString()];
                            i.eachPosition(t, (e1, t, i)=>{
                                const l = r.feature(e1);
                                d.updatePaintArray(t, i, l, n, o, s, a);
                            });
                        }
                        l = !0;
                    }
                }
                return l;
            }
            defines() {
                const e1 = [];
                for(const t in this.binders){
                    const i = this.binders[t];
                    (i instanceof Hl || i instanceof Xl) && e1.push(...i.uniformNames.map((e1)=>`#define HAS_UNIFORM_${e1}`));
                }
                return e1;
            }
            getBinderAttributes() {
                const e1 = [];
                for(const t in this.binders){
                    const i = this.binders[t];
                    if (i instanceof Yl || i instanceof Kl || i instanceof Jl) for(let t = 0; t < i.paintVertexAttributes.length; t++)e1.push(i.paintVertexAttributes[t].name);
                }
                return e1;
            }
            getBinderUniforms() {
                const e1 = [];
                for(const t in this.binders){
                    const i = this.binders[t];
                    if (i instanceof Hl || i instanceof Xl || i instanceof Kl) for (const t of i.uniformNames)e1.push(t);
                }
                return e1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(e1) {
                const t = [];
                for(const i in this.binders){
                    const r = this.binders[i];
                    if (r instanceof Hl || r instanceof Xl || r instanceof Kl) for (const n of r.uniformNames)t.push({
                        name: n,
                        property: i,
                        binding: r.getBinding(e1, n)
                    });
                }
                return t;
            }
            setUniforms(e1, t, i, r, n) {
                for (const { name: t, property: o, binding: s } of i)this.binders[o].setUniform(e1, s, n, r.get(o), t);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const e1 in this.binders){
                    const t = this.binders[e1];
                    (t instanceof Yl || t instanceof Kl || t instanceof Jl) && t.paintVertexBuffer && this._buffers.push(t.paintVertexBuffer);
                }
            }
            upload(e1) {
                for(const t in this.binders){
                    const i = this.binders[t];
                    (i instanceof Yl || i instanceof Kl || i instanceof Jl) && i.upload(e1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const e1 in this.binders){
                    const t = this.binders[e1];
                    (t instanceof Yl || t instanceof Kl || t instanceof Jl) && t.destroy();
                }
            }
        }
        class ec {
            constructor(e1, t, i = ()=>!0){
                this.programConfigurations = {};
                for (const r of e1)this.programConfigurations[r.id] = new Ql(r, t, i);
                this.needsUpload = !1, this._featureMap = new zl, this._featureMapWithoutIds = new zl, this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(e1, t, i, r, n, o, s, a) {
                for(const i in this.programConfigurations)this.programConfigurations[i].populatePaintArrays(e1, t, r, n, o, s, a);
                void 0 !== t.id ? this._featureMap.add(t.id, i, this._bufferOffset, e1) : (this._featureMapWithoutIds.add(this._idlessCounter, i, this._bufferOffset, e1), this._idlessCounter += 1), this._bufferOffset = e1, this.needsUpload = !0;
            }
            updatePaintArrays(e1, t, i, r, n, o) {
                for (const s of i)this.needsUpload = this.programConfigurations[s.id].updatePaintArrays(e1, this._featureMap, this._featureMapWithoutIds, t, s, r, n, o || 0) || this.needsUpload;
            }
            get(e1) {
                return this.programConfigurations[e1];
            }
            upload(e1) {
                if (this.needsUpload) {
                    for(const t in this.programConfigurations)this.programConfigurations[t].upload(e1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const e1 in this.programConfigurations)this.programConfigurations[e1].destroy();
            }
        }
        const tc = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "line-dasharray": [
                "dash"
            ]
        };
        function ic(e1, t) {
            return tc[e1] || [
                e1.replace(`${t}-`, "").replace(/-/g, "_")
            ];
        }
        const rc = {
            "line-pattern": {
                source: Oa,
                composite: Oa
            },
            "fill-pattern": {
                source: Oa,
                composite: Oa
            },
            "fill-extrusion-pattern": {
                source: Oa,
                composite: Oa
            },
            "line-dasharray": {
                source: Ba,
                composite: Ba
            }
        }, nc = {
            color: {
                source: il,
                composite: ka
            },
            number: {
                source: Ya,
                composite: il
            }
        };
        function oc(e1, t, i) {
            const r = rc[e1];
            return r && r[i] || nc[t][i];
        }
        Rs(Hl, "ConstantBinder"), Rs(Xl, "PatternConstantBinder"), Rs(Yl, "SourceExpressionBinder"), Rs(Jl, "PatternCompositeBinder"), Rs(Kl, "CompositeExpressionBinder"), Rs(Ql, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), Rs(ec, "ProgramConfigurationSet");
        class sc {
            constructor(e1, t){
                e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : 4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1]));
            }
            setNorthEast(e1) {
                return this._ne = e1 instanceof Wd ? new Wd(e1.lng, e1.lat) : Wd.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof Wd ? new Wd(e1.lng, e1.lat) : Wd.convert(e1), this;
            }
            extend(e1) {
                const t = this._sw, i = this._ne;
                let r, n;
                if (e1 instanceof Wd) r = e1, n = e1;
                else {
                    if (!(e1 instanceof sc)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend(sc.convert(e1)) : this.extend(Wd.convert(e1)) : "object" == typeof e1 && null !== e1 && e1.hasOwnProperty("lat") && (e1.hasOwnProperty("lon") || e1.hasOwnProperty("lng")) ? this.extend(Wd.convert(e1)) : this;
                    if (r = e1._sw, n = e1._ne, !r || !n) return this;
                }
                return t || i ? (t.lng = Math.min(r.lng, t.lng), t.lat = Math.min(r.lat, t.lat), i.lng = Math.max(n.lng, i.lng), i.lat = Math.max(n.lat, i.lat)) : (this._sw = new Wd(r.lng, r.lat), this._ne = new Wd(n.lng, n.lat)), this;
            }
            getCenter() {
                return new Wd((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new Wd(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new Wd(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: t, lat: i } = Wd.convert(e1);
                let r = this._sw.lng <= t && t <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (r = this._sw.lng >= t && t >= this._ne.lng), this._sw.lat <= i && i <= this._ne.lat && r;
            }
            static convert(e1) {
                return !e1 || e1 instanceof sc ? e1 : new sc(e1);
            }
        }
        var ac = {}, lc = {};
        Object.defineProperty(lc, "__esModule", {
            value: !0
        }), lc.setMatrixArrayType = function(e1) {
            lc.ARRAY_TYPE = hc = e1;
        }, lc.toRadian = function(e1) {
            return e1 * dc;
        }, lc.equals = function(e1, t) {
            return Math.abs(e1 - t) <= cc * Math.max(1, Math.abs(e1), Math.abs(t));
        }, lc.RANDOM = lc.ARRAY_TYPE = lc.EPSILON = void 0;
        var cc = 1e-6;
        lc.EPSILON = cc;
        var hc = "undefined" != typeof Float32Array ? Float32Array : Array;
        lc.ARRAY_TYPE = hc;
        var uc = Math.random;
        lc.RANDOM = uc;
        var dc = Math.PI / 180;
        Math.hypot || (Math.hypot = function() {
            for(var e1 = 0, t = arguments.length; t--;)e1 += arguments[t] * arguments[t];
            return Math.sqrt(e1);
        });
        var pc = {};
        function fc(e1) {
            return fc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, fc(e1);
        }
        Object.defineProperty(pc, "__esModule", {
            value: !0
        }), pc.create = function() {
            var e1 = new mc.ARRAY_TYPE(4);
            return mc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
        }, pc.clone = function(e1) {
            var t = new mc.ARRAY_TYPE(4);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t;
        }, pc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1;
        }, pc.identity = function(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1;
        }, pc.fromValues = function(e1, t, i, r) {
            var n = new mc.ARRAY_TYPE(4);
            return n[0] = e1, n[1] = t, n[2] = i, n[3] = r, n;
        }, pc.set = function(e1, t, i, r, n) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1;
        }, pc.transpose = function(e1, t) {
            if (e1 === t) {
                var i = t[1];
                e1[1] = t[2], e1[2] = i;
            } else e1[0] = t[0], e1[1] = t[2], e1[2] = t[1], e1[3] = t[3];
            return e1;
        }, pc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i * o - n * r;
            return s ? (e1[0] = o * (s = 1 / s), e1[1] = -r * s, e1[2] = -n * s, e1[3] = i * s, e1) : null;
        }, pc.adjoint = function(e1, t) {
            var i = t[0];
            return e1[0] = t[3], e1[1] = -t[1], e1[2] = -t[2], e1[3] = i, e1;
        }, pc.determinant = function(e1) {
            return e1[0] * e1[3] - e1[2] * e1[1];
        }, pc.multiply = gc, pc.rotate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l + o * a, e1[1] = n * l + s * a, e1[2] = r * -a + o * l, e1[3] = n * -a + s * l, e1;
        }, pc.scale = function(e1, t, i) {
            var r = t[1], n = t[2], o = t[3], s = i[0], a = i[1];
            return e1[0] = t[0] * s, e1[1] = r * s, e1[2] = n * a, e1[3] = o * a, e1;
        }, pc.fromRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = -i, e1[3] = r, e1;
        }, pc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = t[1], e1;
        }, pc.str = function(e1) {
            return "mat2(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
        }, pc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3]);
        }, pc.LDU = function(e1, t, i, r) {
            return e1[2] = r[2] / r[0], i[0] = r[0], i[1] = r[1], i[3] = r[3] - e1[2] * i[1], [
                e1,
                t,
                i
            ];
        }, pc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1;
        }, pc.subtract = yc, pc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3];
        }, pc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = t[0], a = t[1], l = t[2], c = t[3];
            return Math.abs(i - s) <= mc.EPSILON * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(r - a) <= mc.EPSILON * Math.max(1, Math.abs(r), Math.abs(a)) && Math.abs(n - l) <= mc.EPSILON * Math.max(1, Math.abs(n), Math.abs(l)) && Math.abs(o - c) <= mc.EPSILON * Math.max(1, Math.abs(o), Math.abs(c));
        }, pc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1;
        }, pc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1;
        }, pc.sub = pc.mul = void 0;
        var mc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== fc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = _c(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function _c(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (_c = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function gc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[0], l = i[1], c = i[2], h = i[3];
            return e1[0] = r * a + o * l, e1[1] = n * a + s * l, e1[2] = r * c + o * h, e1[3] = n * c + s * h, e1;
        }
        function yc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1;
        }
        pc.mul = gc, pc.sub = yc;
        var xc = {};
        function vc(e1) {
            return vc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, vc(e1);
        }
        Object.defineProperty(xc, "__esModule", {
            value: !0
        }), xc.create = function() {
            var e1 = new bc.ARRAY_TYPE(6);
            return bc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0, e1[4] = 0, e1[5] = 0), e1[0] = 1, e1[3] = 1, e1;
        }, xc.clone = function(e1) {
            var t = new bc.ARRAY_TYPE(6);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t;
        }, xc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1;
        }, xc.identity = function(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = 0, e1[5] = 0, e1;
        }, xc.fromValues = function(e1, t, i, r, n, o) {
            var s = new bc.ARRAY_TYPE(6);
            return s[0] = e1, s[1] = t, s[2] = i, s[3] = r, s[4] = n, s[5] = o, s;
        }, xc.set = function(e1, t, i, r, n, o, s) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1;
        }, xc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = i * o - r * n;
            return l ? (e1[0] = o * (l = 1 / l), e1[1] = -r * l, e1[2] = -n * l, e1[3] = i * l, e1[4] = (n * a - o * s) * l, e1[5] = (r * s - i * a) * l, e1) : null;
        }, xc.determinant = function(e1) {
            return e1[0] * e1[3] - e1[1] * e1[2];
        }, xc.multiply = Tc, xc.rotate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = Math.sin(i), h = Math.cos(i);
            return e1[0] = r * h + o * c, e1[1] = n * h + s * c, e1[2] = r * -c + o * h, e1[3] = n * -c + s * h, e1[4] = a, e1[5] = l, e1;
        }, xc.scale = function(e1, t, i) {
            var r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = i[0], c = i[1];
            return e1[0] = t[0] * l, e1[1] = r * l, e1[2] = n * c, e1[3] = o * c, e1[4] = s, e1[5] = a, e1;
        }, xc.translate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = i[0], h = i[1];
            return e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = r * c + o * h + a, e1[5] = n * c + s * h + l, e1;
        }, xc.fromRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = -i, e1[3] = r, e1[4] = 0, e1[5] = 0, e1;
        }, xc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = t[1], e1[4] = 0, e1[5] = 0, e1;
        }, xc.fromTranslation = function(e1, t) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = t[0], e1[5] = t[1], e1;
        }, xc.str = function(e1) {
            return "mat2d(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ")";
        }, xc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], 1);
        }, xc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1;
        }, xc.subtract = Ec, xc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1;
        }, xc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1[4] = t[4] + i[4] * r, e1[5] = t[5] + i[5] * r, e1;
        }, xc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5];
        }, xc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = t[0], c = t[1], h = t[2], u = t[3], d = t[4], p = t[5];
            return Math.abs(i - l) <= bc.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(r - c) <= bc.EPSILON * Math.max(1, Math.abs(r), Math.abs(c)) && Math.abs(n - h) <= bc.EPSILON * Math.max(1, Math.abs(n), Math.abs(h)) && Math.abs(o - u) <= bc.EPSILON * Math.max(1, Math.abs(o), Math.abs(u)) && Math.abs(s - d) <= bc.EPSILON * Math.max(1, Math.abs(s), Math.abs(d)) && Math.abs(a - p) <= bc.EPSILON * Math.max(1, Math.abs(a), Math.abs(p));
        }, xc.sub = xc.mul = void 0;
        var bc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== vc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = wc(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function wc(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (wc = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Tc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = i[0], h = i[1], u = i[2], d = i[3], p = i[4], f = i[5];
            return e1[0] = r * c + o * h, e1[1] = n * c + s * h, e1[2] = r * u + o * d, e1[3] = n * u + s * d, e1[4] = r * p + o * f + a, e1[5] = n * p + s * f + l, e1;
        }
        function Ec(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1[4] = t[4] - i[4], e1[5] = t[5] - i[5], e1;
        }
        xc.mul = Tc, xc.sub = Ec;
        var Mc = {};
        function Ac(e1) {
            return Ac = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, Ac(e1);
        }
        Object.defineProperty(Mc, "__esModule", {
            value: !0
        }), Mc.create = function() {
            var e1 = new Sc.ARRAY_TYPE(9);
            return Sc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
        }, Mc.fromMat4 = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[4], e1[4] = t[5], e1[5] = t[6], e1[6] = t[8], e1[7] = t[9], e1[8] = t[10], e1;
        }, Mc.clone = function(e1) {
            var t = new Sc.ARRAY_TYPE(9);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t;
        }, Mc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1;
        }, Mc.fromValues = function(e1, t, i, r, n, o, s, a, l) {
            var c = new Sc.ARRAY_TYPE(9);
            return c[0] = e1, c[1] = t, c[2] = i, c[3] = r, c[4] = n, c[5] = o, c[6] = s, c[7] = a, c[8] = l, c;
        }, Mc.set = function(e1, t, i, r, n, o, s, a, l, c) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1[6] = a, e1[7] = l, e1[8] = c, e1;
        }, Mc.identity = function(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 1, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, Mc.transpose = function(e1, t) {
            if (e1 === t) {
                var i = t[1], r = t[2], n = t[5];
                e1[1] = t[3], e1[2] = t[6], e1[3] = i, e1[5] = t[7], e1[6] = r, e1[7] = n;
            } else e1[0] = t[0], e1[1] = t[3], e1[2] = t[6], e1[3] = t[1], e1[4] = t[4], e1[5] = t[7], e1[6] = t[2], e1[7] = t[5], e1[8] = t[8];
            return e1;
        }, Mc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = h * s - a * c, d = -h * o + a * l, p = c * o - s * l, f = i * u + r * d + n * p;
            return f ? (e1[0] = u * (f = 1 / f), e1[1] = (-h * r + n * c) * f, e1[2] = (a * r - n * s) * f, e1[3] = d * f, e1[4] = (h * i - n * l) * f, e1[5] = (-a * i + n * o) * f, e1[6] = p * f, e1[7] = (-c * i + r * l) * f, e1[8] = (s * i - r * o) * f, e1) : null;
        }, Mc.adjoint = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8];
            return e1[0] = s * h - a * c, e1[1] = n * c - r * h, e1[2] = r * a - n * s, e1[3] = a * l - o * h, e1[4] = i * h - n * l, e1[5] = n * o - i * a, e1[6] = o * c - s * l, e1[7] = r * l - i * c, e1[8] = i * s - r * o, e1;
        }, Mc.determinant = function(e1) {
            var t = e1[3], i = e1[4], r = e1[5], n = e1[6], o = e1[7], s = e1[8];
            return e1[0] * (s * i - r * o) + e1[1] * (-s * t + r * n) + e1[2] * (o * t - i * n);
        }, Mc.multiply = Cc, Mc.translate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = i[0], p = i[1];
            return e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = a, e1[5] = l, e1[6] = d * r + p * s + c, e1[7] = d * n + p * a + h, e1[8] = d * o + p * l + u, e1;
        }, Mc.rotate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = Math.sin(i), p = Math.cos(i);
            return e1[0] = p * r + d * s, e1[1] = p * n + d * a, e1[2] = p * o + d * l, e1[3] = p * s - d * r, e1[4] = p * a - d * n, e1[5] = p * l - d * o, e1[6] = c, e1[7] = h, e1[8] = u, e1;
        }, Mc.scale = function(e1, t, i) {
            var r = i[0], n = i[1];
            return e1[0] = r * t[0], e1[1] = r * t[1], e1[2] = r * t[2], e1[3] = n * t[3], e1[4] = n * t[4], e1[5] = n * t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1;
        }, Mc.fromTranslation = function(e1, t) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 1, e1[5] = 0, e1[6] = t[0], e1[7] = t[1], e1[8] = 1, e1;
        }, Mc.fromRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = 0, e1[3] = -i, e1[4] = r, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, Mc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = t[1], e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, Mc.fromMat2d = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = 0, e1[3] = t[2], e1[4] = t[3], e1[5] = 0, e1[6] = t[4], e1[7] = t[5], e1[8] = 1, e1;
        }, Mc.fromQuat = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i + i, a = r + r, l = n + n, c = i * s, h = r * s, u = r * a, d = n * s, p = n * a, f = n * l, m = o * s, _ = o * a, g = o * l;
            return e1[0] = 1 - u - f, e1[3] = h - g, e1[6] = d + _, e1[1] = h + g, e1[4] = 1 - c - f, e1[7] = p - m, e1[2] = d - _, e1[5] = p + m, e1[8] = 1 - c - u, e1;
        }, Mc.normalFromMat4 = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = t[9], d = t[10], p = t[11], f = t[12], m = t[13], _ = t[14], g = t[15], y = i * a - r * s, x = i * l - n * s, v = i * c - o * s, b = r * l - n * a, w = r * c - o * a, T = n * c - o * l, E = h * m - u * f, M = h * _ - d * f, A = h * g - p * f, S = u * _ - d * m, I = u * g - p * m, C = d * g - p * _, z = y * C - x * I + v * S + b * A - w * M + T * E;
            return z ? (e1[0] = (a * C - l * I + c * S) * (z = 1 / z), e1[1] = (l * A - s * C - c * M) * z, e1[2] = (s * I - a * A + c * E) * z, e1[3] = (n * I - r * C - o * S) * z, e1[4] = (i * C - n * A + o * M) * z, e1[5] = (r * A - i * I - o * E) * z, e1[6] = (m * T - _ * w + g * b) * z, e1[7] = (_ * v - f * T - g * x) * z, e1[8] = (f * w - m * v + g * y) * z, e1) : null;
        }, Mc.projection = function(e1, t, i) {
            return e1[0] = 2 / t, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = -2 / i, e1[5] = 0, e1[6] = -1, e1[7] = 1, e1[8] = 1, e1;
        }, Mc.str = function(e1) {
            return "mat3(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ", " + e1[6] + ", " + e1[7] + ", " + e1[8] + ")";
        }, Mc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], e1[6], e1[7], e1[8]);
        }, Mc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1[6] = t[6] + i[6], e1[7] = t[7] + i[7], e1[8] = t[8] + i[8], e1;
        }, Mc.subtract = zc, Mc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1[6] = t[6] * i, e1[7] = t[7] * i, e1[8] = t[8] * i, e1;
        }, Mc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1[4] = t[4] + i[4] * r, e1[5] = t[5] + i[5] * r, e1[6] = t[6] + i[6] * r, e1[7] = t[7] + i[7] * r, e1[8] = t[8] + i[8] * r, e1;
        }, Mc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7] && e1[8] === t[8];
        }, Mc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = e1[6], c = e1[7], h = e1[8], u = t[0], d = t[1], p = t[2], f = t[3], m = t[4], _ = t[5], g = t[6], y = t[7], x = t[8];
            return Math.abs(i - u) <= Sc.EPSILON * Math.max(1, Math.abs(i), Math.abs(u)) && Math.abs(r - d) <= Sc.EPSILON * Math.max(1, Math.abs(r), Math.abs(d)) && Math.abs(n - p) <= Sc.EPSILON * Math.max(1, Math.abs(n), Math.abs(p)) && Math.abs(o - f) <= Sc.EPSILON * Math.max(1, Math.abs(o), Math.abs(f)) && Math.abs(s - m) <= Sc.EPSILON * Math.max(1, Math.abs(s), Math.abs(m)) && Math.abs(a - _) <= Sc.EPSILON * Math.max(1, Math.abs(a), Math.abs(_)) && Math.abs(l - g) <= Sc.EPSILON * Math.max(1, Math.abs(l), Math.abs(g)) && Math.abs(c - y) <= Sc.EPSILON * Math.max(1, Math.abs(c), Math.abs(y)) && Math.abs(h - x) <= Sc.EPSILON * Math.max(1, Math.abs(h), Math.abs(x));
        }, Mc.sub = Mc.mul = void 0;
        var Sc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== Ac(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Ic(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function Ic(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Ic = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Cc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = i[0], p = i[1], f = i[2], m = i[3], _ = i[4], g = i[5], y = i[6], x = i[7], v = i[8];
            return e1[0] = d * r + p * s + f * c, e1[1] = d * n + p * a + f * h, e1[2] = d * o + p * l + f * u, e1[3] = m * r + _ * s + g * c, e1[4] = m * n + _ * a + g * h, e1[5] = m * o + _ * l + g * u, e1[6] = y * r + x * s + v * c, e1[7] = y * n + x * a + v * h, e1[8] = y * o + x * l + v * u, e1;
        }
        function zc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1[4] = t[4] - i[4], e1[5] = t[5] - i[5], e1[6] = t[6] - i[6], e1[7] = t[7] - i[7], e1[8] = t[8] - i[8], e1;
        }
        Mc.mul = Cc, Mc.sub = zc;
        var Pc = {};
        function Dc(e1) {
            return Dc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, Dc(e1);
        }
        Object.defineProperty(Pc, "__esModule", {
            value: !0
        }), Pc.create = function() {
            var e1 = new Rc.ARRAY_TYPE(16);
            return Rc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0), e1[0] = 1, e1[5] = 1, e1[10] = 1, e1[15] = 1, e1;
        }, Pc.clone = function(e1) {
            var t = new Rc.ARRAY_TYPE(16);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
        }, Pc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
        }, Pc.fromValues = function(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
            var _ = new Rc.ARRAY_TYPE(16);
            return _[0] = e1, _[1] = t, _[2] = i, _[3] = r, _[4] = n, _[5] = o, _[6] = s, _[7] = a, _[8] = l, _[9] = c, _[10] = h, _[11] = u, _[12] = d, _[13] = p, _[14] = f, _[15] = m, _;
        }, Pc.set = function(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1[6] = a, e1[7] = l, e1[8] = c, e1[9] = h, e1[10] = u, e1[11] = d, e1[12] = p, e1[13] = f, e1[14] = m, e1[15] = _, e1;
        }, Pc.identity = kc, Pc.transpose = function(e1, t) {
            if (e1 === t) {
                var i = t[1], r = t[2], n = t[3], o = t[6], s = t[7], a = t[11];
                e1[1] = t[4], e1[2] = t[8], e1[3] = t[12], e1[4] = i, e1[6] = t[9], e1[7] = t[13], e1[8] = r, e1[9] = o, e1[11] = t[14], e1[12] = n, e1[13] = s, e1[14] = a;
            } else e1[0] = t[0], e1[1] = t[4], e1[2] = t[8], e1[3] = t[12], e1[4] = t[1], e1[5] = t[5], e1[6] = t[9], e1[7] = t[13], e1[8] = t[2], e1[9] = t[6], e1[10] = t[10], e1[11] = t[14], e1[12] = t[3], e1[13] = t[7], e1[14] = t[11], e1[15] = t[15];
            return e1;
        }, Pc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = t[9], d = t[10], p = t[11], f = t[12], m = t[13], _ = t[14], g = t[15], y = i * a - r * s, x = i * l - n * s, v = i * c - o * s, b = r * l - n * a, w = r * c - o * a, T = n * c - o * l, E = h * m - u * f, M = h * _ - d * f, A = h * g - p * f, S = u * _ - d * m, I = u * g - p * m, C = d * g - p * _, z = y * C - x * I + v * S + b * A - w * M + T * E;
            return z ? (e1[0] = (a * C - l * I + c * S) * (z = 1 / z), e1[1] = (n * I - r * C - o * S) * z, e1[2] = (m * T - _ * w + g * b) * z, e1[3] = (d * w - u * T - p * b) * z, e1[4] = (l * A - s * C - c * M) * z, e1[5] = (i * C - n * A + o * M) * z, e1[6] = (_ * v - f * T - g * x) * z, e1[7] = (h * T - d * v + p * x) * z, e1[8] = (s * I - a * A + c * E) * z, e1[9] = (r * A - i * I - o * E) * z, e1[10] = (f * w - m * v + g * y) * z, e1[11] = (u * v - h * w - p * y) * z, e1[12] = (a * M - s * S - l * E) * z, e1[13] = (i * S - r * M + n * E) * z, e1[14] = (m * x - f * b - _ * y) * z, e1[15] = (h * b - u * x + d * y) * z, e1) : null;
        }, Pc.adjoint = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = t[9], d = t[10], p = t[11], f = t[12], m = t[13], _ = t[14], g = t[15];
            return e1[0] = a * (d * g - p * _) - u * (l * g - c * _) + m * (l * p - c * d), e1[1] = -(r * (d * g - p * _) - u * (n * g - o * _) + m * (n * p - o * d)), e1[2] = r * (l * g - c * _) - a * (n * g - o * _) + m * (n * c - o * l), e1[3] = -(r * (l * p - c * d) - a * (n * p - o * d) + u * (n * c - o * l)), e1[4] = -(s * (d * g - p * _) - h * (l * g - c * _) + f * (l * p - c * d)), e1[5] = i * (d * g - p * _) - h * (n * g - o * _) + f * (n * p - o * d), e1[6] = -(i * (l * g - c * _) - s * (n * g - o * _) + f * (n * c - o * l)), e1[7] = i * (l * p - c * d) - s * (n * p - o * d) + h * (n * c - o * l), e1[8] = s * (u * g - p * m) - h * (a * g - c * m) + f * (a * p - c * u), e1[9] = -(i * (u * g - p * m) - h * (r * g - o * m) + f * (r * p - o * u)), e1[10] = i * (a * g - c * m) - s * (r * g - o * m) + f * (r * c - o * a), e1[11] = -(i * (a * p - c * u) - s * (r * p - o * u) + h * (r * c - o * a)), e1[12] = -(s * (u * _ - d * m) - h * (a * _ - l * m) + f * (a * d - l * u)), e1[13] = i * (u * _ - d * m) - h * (r * _ - n * m) + f * (r * d - n * u), e1[14] = -(i * (a * _ - l * m) - s * (r * _ - n * m) + f * (r * l - n * a)), e1[15] = i * (a * d - l * u) - s * (r * d - n * u) + h * (r * l - n * a), e1;
        }, Pc.determinant = function(e1) {
            var t = e1[0], i = e1[1], r = e1[2], n = e1[3], o = e1[4], s = e1[5], a = e1[6], l = e1[7], c = e1[8], h = e1[9], u = e1[10], d = e1[11], p = e1[12], f = e1[13], m = e1[14], _ = e1[15];
            return (t * s - i * o) * (u * _ - d * m) - (t * a - r * o) * (h * _ - d * f) + (t * l - n * o) * (h * m - u * f) + (i * a - r * s) * (c * _ - d * p) - (i * l - n * s) * (c * m - u * p) + (r * l - n * a) * (c * f - h * p);
        }, Pc.multiply = Oc, Pc.translate = function(e1, t, i) {
            var r, n, o, s, a, l, c, h, u, d, p, f, m = i[0], _ = i[1], g = i[2];
            return t === e1 ? (e1[12] = t[0] * m + t[4] * _ + t[8] * g + t[12], e1[13] = t[1] * m + t[5] * _ + t[9] * g + t[13], e1[14] = t[2] * m + t[6] * _ + t[10] * g + t[14], e1[15] = t[3] * m + t[7] * _ + t[11] * g + t[15]) : (n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = t[9], p = t[10], f = t[11], e1[0] = r = t[0], e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = a, e1[5] = l, e1[6] = c, e1[7] = h, e1[8] = u, e1[9] = d, e1[10] = p, e1[11] = f, e1[12] = r * m + a * _ + u * g + t[12], e1[13] = n * m + l * _ + d * g + t[13], e1[14] = o * m + c * _ + p * g + t[14], e1[15] = s * m + h * _ + f * g + t[15]), e1;
        }, Pc.scale = function(e1, t, i) {
            var r = i[0], n = i[1], o = i[2];
            return e1[0] = t[0] * r, e1[1] = t[1] * r, e1[2] = t[2] * r, e1[3] = t[3] * r, e1[4] = t[4] * n, e1[5] = t[5] * n, e1[6] = t[6] * n, e1[7] = t[7] * n, e1[8] = t[8] * o, e1[9] = t[9] * o, e1[10] = t[10] * o, e1[11] = t[11] * o, e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
        }, Pc.rotate = function(e1, t, i, r) {
            var n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I = r[0], C = r[1], z = r[2], P = Math.hypot(I, C, z);
            return P < Rc.EPSILON ? null : (I *= P = 1 / P, C *= P, z *= P, n = Math.sin(i), o = Math.cos(i), l = t[1], c = t[2], h = t[3], d = t[5], p = t[6], f = t[7], _ = t[9], g = t[10], y = t[11], w = I * C * (s = 1 - o) - z * n, T = C * C * s + o, E = z * C * s + I * n, M = I * z * s + C * n, A = C * z * s - I * n, S = z * z * s + o, e1[0] = (a = t[0]) * (x = I * I * s + o) + (u = t[4]) * (v = C * I * s + z * n) + (m = t[8]) * (b = z * I * s - C * n), e1[1] = l * x + d * v + _ * b, e1[2] = c * x + p * v + g * b, e1[3] = h * x + f * v + y * b, e1[4] = a * w + u * T + m * E, e1[5] = l * w + d * T + _ * E, e1[6] = c * w + p * T + g * E, e1[7] = h * w + f * T + y * E, e1[8] = a * M + u * A + m * S, e1[9] = l * M + d * A + _ * S, e1[10] = c * M + p * A + g * S, e1[11] = h * M + f * A + y * S, t !== e1 && (e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1);
        }, Pc.rotateX = function(e1, t, i) {
            var r = Math.sin(i), n = Math.cos(i), o = t[4], s = t[5], a = t[6], l = t[7], c = t[8], h = t[9], u = t[10], d = t[11];
            return t !== e1 && (e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[4] = o * n + c * r, e1[5] = s * n + h * r, e1[6] = a * n + u * r, e1[7] = l * n + d * r, e1[8] = c * n - o * r, e1[9] = h * n - s * r, e1[10] = u * n - a * r, e1[11] = d * n - l * r, e1;
        }, Pc.rotateY = function(e1, t, i) {
            var r = Math.sin(i), n = Math.cos(i), o = t[0], s = t[1], a = t[2], l = t[3], c = t[8], h = t[9], u = t[10], d = t[11];
            return t !== e1 && (e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = o * n - c * r, e1[1] = s * n - h * r, e1[2] = a * n - u * r, e1[3] = l * n - d * r, e1[8] = o * r + c * n, e1[9] = s * r + h * n, e1[10] = a * r + u * n, e1[11] = l * r + d * n, e1;
        }, Pc.rotateZ = function(e1, t, i) {
            var r = Math.sin(i), n = Math.cos(i), o = t[0], s = t[1], a = t[2], l = t[3], c = t[4], h = t[5], u = t[6], d = t[7];
            return t !== e1 && (e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = o * n + c * r, e1[1] = s * n + h * r, e1[2] = a * n + u * r, e1[3] = l * n + d * r, e1[4] = c * n - o * r, e1[5] = h * n - s * r, e1[6] = u * n - a * r, e1[7] = d * n - l * r, e1;
        }, Pc.fromTranslation = function(e1, t) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = t[0], e1[13] = t[1], e1[14] = t[2], e1[15] = 1, e1;
        }, Pc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = t[1], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = t[2], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromRotation = function(e1, t, i) {
            var r, n, o, s = i[0], a = i[1], l = i[2], c = Math.hypot(s, a, l);
            return c < Rc.EPSILON ? null : (s *= c = 1 / c, a *= c, l *= c, r = Math.sin(t), n = Math.cos(t), e1[0] = s * s * (o = 1 - n) + n, e1[1] = a * s * o + l * r, e1[2] = l * s * o - a * r, e1[3] = 0, e1[4] = s * a * o - l * r, e1[5] = a * a * o + n, e1[6] = l * a * o + s * r, e1[7] = 0, e1[8] = s * l * o + a * r, e1[9] = a * l * o - s * r, e1[10] = l * l * o + n, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1);
        }, Pc.fromXRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = r, e1[6] = i, e1[7] = 0, e1[8] = 0, e1[9] = -i, e1[10] = r, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromYRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = 0, e1[2] = -i, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = i, e1[9] = 0, e1[10] = r, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromZRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = 0, e1[3] = 0, e1[4] = -i, e1[5] = r, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromRotationTranslation = Bc, Pc.fromQuat2 = function(e1, t) {
            var i = new Rc.ARRAY_TYPE(3), r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = r * r + n * n + o * o + s * s;
            return u > 0 ? (i[0] = 2 * (a * s + h * r + l * o - c * n) / u, i[1] = 2 * (l * s + h * n + c * r - a * o) / u, i[2] = 2 * (c * s + h * o + a * n - l * r) / u) : (i[0] = 2 * (a * s + h * r + l * o - c * n), i[1] = 2 * (l * s + h * n + c * r - a * o), i[2] = 2 * (c * s + h * o + a * n - l * r)), Bc(e1, t, i), e1;
        }, Pc.getTranslation = function(e1, t) {
            return e1[0] = t[12], e1[1] = t[13], e1[2] = t[14], e1;
        }, Pc.getScaling = Fc, Pc.getRotation = function(e1, t) {
            var i = new Rc.ARRAY_TYPE(3);
            Fc(i, t);
            var r = 1 / i[0], n = 1 / i[1], o = 1 / i[2], s = t[0] * r, a = t[1] * n, l = t[2] * o, c = t[4] * r, h = t[5] * n, u = t[6] * o, d = t[8] * r, p = t[9] * n, f = t[10] * o, m = s + h + f, _ = 0;
            return m > 0 ? (_ = 2 * Math.sqrt(m + 1), e1[3] = .25 * _, e1[0] = (u - p) / _, e1[1] = (d - l) / _, e1[2] = (a - c) / _) : s > h && s > f ? (_ = 2 * Math.sqrt(1 + s - h - f), e1[3] = (u - p) / _, e1[0] = .25 * _, e1[1] = (a + c) / _, e1[2] = (d + l) / _) : h > f ? (_ = 2 * Math.sqrt(1 + h - s - f), e1[3] = (d - l) / _, e1[0] = (a + c) / _, e1[1] = .25 * _, e1[2] = (u + p) / _) : (_ = 2 * Math.sqrt(1 + f - s - h), e1[3] = (a - c) / _, e1[0] = (d + l) / _, e1[1] = (u + p) / _, e1[2] = .25 * _), e1;
        }, Pc.fromRotationTranslationScale = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2], a = t[3], l = n + n, c = o + o, h = s + s, u = n * l, d = n * c, p = n * h, f = o * c, m = o * h, _ = s * h, g = a * l, y = a * c, x = a * h, v = r[0], b = r[1], w = r[2];
            return e1[0] = (1 - (f + _)) * v, e1[1] = (d + x) * v, e1[2] = (p - y) * v, e1[3] = 0, e1[4] = (d - x) * b, e1[5] = (1 - (u + _)) * b, e1[6] = (m + g) * b, e1[7] = 0, e1[8] = (p + y) * w, e1[9] = (m - g) * w, e1[10] = (1 - (u + f)) * w, e1[11] = 0, e1[12] = i[0], e1[13] = i[1], e1[14] = i[2], e1[15] = 1, e1;
        }, Pc.fromRotationTranslationScaleOrigin = function(e1, t, i, r, n) {
            var o = t[0], s = t[1], a = t[2], l = t[3], c = o + o, h = s + s, u = a + a, d = o * c, p = o * h, f = o * u, m = s * h, _ = s * u, g = a * u, y = l * c, x = l * h, v = l * u, b = r[0], w = r[1], T = r[2], E = n[0], M = n[1], A = n[2], S = (1 - (m + g)) * b, I = (p + v) * b, C = (f - x) * b, z = (p - v) * w, P = (1 - (d + g)) * w, D = (_ + y) * w, R = (f + x) * T, L = (_ - y) * T, k = (1 - (d + m)) * T;
            return e1[0] = S, e1[1] = I, e1[2] = C, e1[3] = 0, e1[4] = z, e1[5] = P, e1[6] = D, e1[7] = 0, e1[8] = R, e1[9] = L, e1[10] = k, e1[11] = 0, e1[12] = i[0] + E - (S * E + z * M + R * A), e1[13] = i[1] + M - (I * E + P * M + L * A), e1[14] = i[2] + A - (C * E + D * M + k * A), e1[15] = 1, e1;
        }, Pc.fromQuat = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i + i, a = r + r, l = n + n, c = i * s, h = r * s, u = r * a, d = n * s, p = n * a, f = n * l, m = o * s, _ = o * a, g = o * l;
            return e1[0] = 1 - u - f, e1[1] = h + g, e1[2] = d - _, e1[3] = 0, e1[4] = h - g, e1[5] = 1 - c - f, e1[6] = p + m, e1[7] = 0, e1[8] = d + _, e1[9] = p - m, e1[10] = 1 - c - u, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.frustum = function(e1, t, i, r, n, o, s) {
            var a = 1 / (i - t), l = 1 / (n - r), c = 1 / (o - s);
            return e1[0] = 2 * o * a, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 2 * o * l, e1[6] = 0, e1[7] = 0, e1[8] = (i + t) * a, e1[9] = (n + r) * l, e1[10] = (s + o) * c, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[14] = s * o * 2 * c, e1[15] = 0, e1;
        }, Pc.perspectiveNO = Nc, Pc.perspectiveZO = function(e1, t, i, r, n) {
            var o, s = 1 / Math.tan(t / 2);
            return e1[0] = s / i, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = s, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != n && n !== 1 / 0 ? (e1[10] = n * (o = 1 / (r - n)), e1[14] = n * r * o) : (e1[10] = -1, e1[14] = -r), e1;
        }, Pc.perspectiveFromFieldOfView = function(e1, t, i, r) {
            var n = Math.tan(t.upDegrees * Math.PI / 180), o = Math.tan(t.downDegrees * Math.PI / 180), s = Math.tan(t.leftDegrees * Math.PI / 180), a = Math.tan(t.rightDegrees * Math.PI / 180), l = 2 / (s + a), c = 2 / (n + o);
            return e1[0] = l, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = c, e1[6] = 0, e1[7] = 0, e1[8] = -(s - a) * l * .5, e1[9] = (n - o) * c * .5, e1[10] = r / (i - r), e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[14] = r * i / (i - r), e1[15] = 0, e1;
        }, Pc.orthoNO = Uc, Pc.orthoZO = function(e1, t, i, r, n, o, s) {
            var a = 1 / (t - i), l = 1 / (r - n), c = 1 / (o - s);
            return e1[0] = -2 * a, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = c, e1[11] = 0, e1[12] = (t + i) * a, e1[13] = (n + r) * l, e1[14] = o * c, e1[15] = 1, e1;
        }, Pc.lookAt = function(e1, t, i, r) {
            var n, o, s, a, l, c, h, u, d, p, f = t[0], m = t[1], _ = t[2], g = r[0], y = r[1], x = r[2], v = i[0], b = i[1], w = i[2];
            return Math.abs(f - v) < Rc.EPSILON && Math.abs(m - b) < Rc.EPSILON && Math.abs(_ - w) < Rc.EPSILON ? kc(e1) : (h = f - v, u = m - b, d = _ - w, n = y * (d *= p = 1 / Math.hypot(h, u, d)) - x * (u *= p), o = x * (h *= p) - g * d, s = g * u - y * h, (p = Math.hypot(n, o, s)) ? (n *= p = 1 / p, o *= p, s *= p) : (n = 0, o = 0, s = 0), a = u * s - d * o, l = d * n - h * s, c = h * o - u * n, (p = Math.hypot(a, l, c)) ? (a *= p = 1 / p, l *= p, c *= p) : (a = 0, l = 0, c = 0), e1[0] = n, e1[1] = a, e1[2] = h, e1[3] = 0, e1[4] = o, e1[5] = l, e1[6] = u, e1[7] = 0, e1[8] = s, e1[9] = c, e1[10] = d, e1[11] = 0, e1[12] = -(n * f + o * m + s * _), e1[13] = -(a * f + l * m + c * _), e1[14] = -(h * f + u * m + d * _), e1[15] = 1, e1);
        }, Pc.targetTo = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2], a = r[0], l = r[1], c = r[2], h = n - i[0], u = o - i[1], d = s - i[2], p = h * h + u * u + d * d;
            p > 0 && (h *= p = 1 / Math.sqrt(p), u *= p, d *= p);
            var f = l * d - c * u, m = c * h - a * d, _ = a * u - l * h;
            return (p = f * f + m * m + _ * _) > 0 && (f *= p = 1 / Math.sqrt(p), m *= p, _ *= p), e1[0] = f, e1[1] = m, e1[2] = _, e1[3] = 0, e1[4] = u * _ - d * m, e1[5] = d * f - h * _, e1[6] = h * m - u * f, e1[7] = 0, e1[8] = h, e1[9] = u, e1[10] = d, e1[11] = 0, e1[12] = n, e1[13] = o, e1[14] = s, e1[15] = 1, e1;
        }, Pc.str = function(e1) {
            return "mat4(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ", " + e1[6] + ", " + e1[7] + ", " + e1[8] + ", " + e1[9] + ", " + e1[10] + ", " + e1[11] + ", " + e1[12] + ", " + e1[13] + ", " + e1[14] + ", " + e1[15] + ")";
        }, Pc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], e1[6], e1[7], e1[8], e1[9], e1[10], e1[11], e1[12], e1[13], e1[14], e1[15]);
        }, Pc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1[6] = t[6] + i[6], e1[7] = t[7] + i[7], e1[8] = t[8] + i[8], e1[9] = t[9] + i[9], e1[10] = t[10] + i[10], e1[11] = t[11] + i[11], e1[12] = t[12] + i[12], e1[13] = t[13] + i[13], e1[14] = t[14] + i[14], e1[15] = t[15] + i[15], e1;
        }, Pc.subtract = Vc, Pc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1[6] = t[6] * i, e1[7] = t[7] * i, e1[8] = t[8] * i, e1[9] = t[9] * i, e1[10] = t[10] * i, e1[11] = t[11] * i, e1[12] = t[12] * i, e1[13] = t[13] * i, e1[14] = t[14] * i, e1[15] = t[15] * i, e1;
        }, Pc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1[4] = t[4] + i[4] * r, e1[5] = t[5] + i[5] * r, e1[6] = t[6] + i[6] * r, e1[7] = t[7] + i[7] * r, e1[8] = t[8] + i[8] * r, e1[9] = t[9] + i[9] * r, e1[10] = t[10] + i[10] * r, e1[11] = t[11] + i[11] * r, e1[12] = t[12] + i[12] * r, e1[13] = t[13] + i[13] * r, e1[14] = t[14] + i[14] * r, e1[15] = t[15] + i[15] * r, e1;
        }, Pc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7] && e1[8] === t[8] && e1[9] === t[9] && e1[10] === t[10] && e1[11] === t[11] && e1[12] === t[12] && e1[13] === t[13] && e1[14] === t[14] && e1[15] === t[15];
        }, Pc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = e1[6], c = e1[7], h = e1[8], u = e1[9], d = e1[10], p = e1[11], f = e1[12], m = e1[13], _ = e1[14], g = e1[15], y = t[0], x = t[1], v = t[2], b = t[3], w = t[4], T = t[5], E = t[6], M = t[7], A = t[8], S = t[9], I = t[10], C = t[11], z = t[12], P = t[13], D = t[14], R = t[15];
            return Math.abs(i - y) <= Rc.EPSILON * Math.max(1, Math.abs(i), Math.abs(y)) && Math.abs(r - x) <= Rc.EPSILON * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - v) <= Rc.EPSILON * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(o - b) <= Rc.EPSILON * Math.max(1, Math.abs(o), Math.abs(b)) && Math.abs(s - w) <= Rc.EPSILON * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(a - T) <= Rc.EPSILON * Math.max(1, Math.abs(a), Math.abs(T)) && Math.abs(l - E) <= Rc.EPSILON * Math.max(1, Math.abs(l), Math.abs(E)) && Math.abs(c - M) <= Rc.EPSILON * Math.max(1, Math.abs(c), Math.abs(M)) && Math.abs(h - A) <= Rc.EPSILON * Math.max(1, Math.abs(h), Math.abs(A)) && Math.abs(u - S) <= Rc.EPSILON * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(d - I) <= Rc.EPSILON * Math.max(1, Math.abs(d), Math.abs(I)) && Math.abs(p - C) <= Rc.EPSILON * Math.max(1, Math.abs(p), Math.abs(C)) && Math.abs(f - z) <= Rc.EPSILON * Math.max(1, Math.abs(f), Math.abs(z)) && Math.abs(m - P) <= Rc.EPSILON * Math.max(1, Math.abs(m), Math.abs(P)) && Math.abs(_ - D) <= Rc.EPSILON * Math.max(1, Math.abs(_), Math.abs(D)) && Math.abs(g - R) <= Rc.EPSILON * Math.max(1, Math.abs(g), Math.abs(R));
        }, Pc.sub = Pc.mul = Pc.ortho = Pc.perspective = void 0;
        var Rc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== Dc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Lc(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function Lc(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Lc = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function kc(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function Oc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = t[9], p = t[10], f = t[11], m = t[12], _ = t[13], g = t[14], y = t[15], x = i[0], v = i[1], b = i[2], w = i[3];
            return e1[0] = x * r + v * a + b * u + w * m, e1[1] = x * n + v * l + b * d + w * _, e1[2] = x * o + v * c + b * p + w * g, e1[3] = x * s + v * h + b * f + w * y, e1[4] = (x = i[4]) * r + (v = i[5]) * a + (b = i[6]) * u + (w = i[7]) * m, e1[5] = x * n + v * l + b * d + w * _, e1[6] = x * o + v * c + b * p + w * g, e1[7] = x * s + v * h + b * f + w * y, e1[8] = (x = i[8]) * r + (v = i[9]) * a + (b = i[10]) * u + (w = i[11]) * m, e1[9] = x * n + v * l + b * d + w * _, e1[10] = x * o + v * c + b * p + w * g, e1[11] = x * s + v * h + b * f + w * y, e1[12] = (x = i[12]) * r + (v = i[13]) * a + (b = i[14]) * u + (w = i[15]) * m, e1[13] = x * n + v * l + b * d + w * _, e1[14] = x * o + v * c + b * p + w * g, e1[15] = x * s + v * h + b * f + w * y, e1;
        }
        function Bc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = r + r, l = n + n, c = o + o, h = r * a, u = r * l, d = r * c, p = n * l, f = n * c, m = o * c, _ = s * a, g = s * l, y = s * c;
            return e1[0] = 1 - (p + m), e1[1] = u + y, e1[2] = d - g, e1[3] = 0, e1[4] = u - y, e1[5] = 1 - (h + m), e1[6] = f + _, e1[7] = 0, e1[8] = d + g, e1[9] = f - _, e1[10] = 1 - (h + p), e1[11] = 0, e1[12] = i[0], e1[13] = i[1], e1[14] = i[2], e1[15] = 1, e1;
        }
        function Fc(e1, t) {
            var i = t[4], r = t[5], n = t[6], o = t[8], s = t[9], a = t[10];
            return e1[0] = Math.hypot(t[0], t[1], t[2]), e1[1] = Math.hypot(i, r, n), e1[2] = Math.hypot(o, s, a), e1;
        }
        function Nc(e1, t, i, r, n) {
            var o, s = 1 / Math.tan(t / 2);
            return e1[0] = s / i, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = s, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != n && n !== 1 / 0 ? (e1[10] = (n + r) * (o = 1 / (r - n)), e1[14] = 2 * n * r * o) : (e1[10] = -1, e1[14] = -2 * r), e1;
        }
        function Uc(e1, t, i, r, n, o, s) {
            var a = 1 / (t - i), l = 1 / (r - n), c = 1 / (o - s);
            return e1[0] = -2 * a, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 2 * c, e1[11] = 0, e1[12] = (t + i) * a, e1[13] = (n + r) * l, e1[14] = (s + o) * c, e1[15] = 1, e1;
        }
        function Vc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1[4] = t[4] - i[4], e1[5] = t[5] - i[5], e1[6] = t[6] - i[6], e1[7] = t[7] - i[7], e1[8] = t[8] - i[8], e1[9] = t[9] - i[9], e1[10] = t[10] - i[10], e1[11] = t[11] - i[11], e1[12] = t[12] - i[12], e1[13] = t[13] - i[13], e1[14] = t[14] - i[14], e1[15] = t[15] - i[15], e1;
        }
        Pc.perspective = Nc, Pc.ortho = Uc, Pc.mul = Oc, Pc.sub = Vc;
        var jc = {}, Gc = {};
        function qc(e1) {
            return qc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, qc(e1);
        }
        Object.defineProperty(Gc, "__esModule", {
            value: !0
        }), Gc.create = Wc, Gc.clone = function(e1) {
            var t = new Zc.ARRAY_TYPE(3);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t;
        }, Gc.length = Hc, Gc.fromValues = function(e1, t, i) {
            var r = new Zc.ARRAY_TYPE(3);
            return r[0] = e1, r[1] = t, r[2] = i, r;
        }, Gc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1;
        }, Gc.set = function(e1, t, i, r) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1;
        }, Gc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1;
        }, Gc.subtract = Xc, Gc.multiply = Yc, Gc.divide = Kc, Gc.ceil = function(e1, t) {
            return e1[0] = Math.ceil(t[0]), e1[1] = Math.ceil(t[1]), e1[2] = Math.ceil(t[2]), e1;
        }, Gc.floor = function(e1, t) {
            return e1[0] = Math.floor(t[0]), e1[1] = Math.floor(t[1]), e1[2] = Math.floor(t[2]), e1;
        }, Gc.min = function(e1, t, i) {
            return e1[0] = Math.min(t[0], i[0]), e1[1] = Math.min(t[1], i[1]), e1[2] = Math.min(t[2], i[2]), e1;
        }, Gc.max = function(e1, t, i) {
            return e1[0] = Math.max(t[0], i[0]), e1[1] = Math.max(t[1], i[1]), e1[2] = Math.max(t[2], i[2]), e1;
        }, Gc.round = function(e1, t) {
            return e1[0] = Math.round(t[0]), e1[1] = Math.round(t[1]), e1[2] = Math.round(t[2]), e1;
        }, Gc.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1;
        }, Gc.scaleAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1;
        }, Gc.distance = Jc, Gc.squaredDistance = Qc, Gc.squaredLength = eh, Gc.negate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1;
        }, Gc.inverse = function(e1, t) {
            return e1[0] = 1 / t[0], e1[1] = 1 / t[1], e1[2] = 1 / t[2], e1;
        }, Gc.normalize = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = i * i + r * r + n * n;
            return o > 0 && (o = 1 / Math.sqrt(o)), e1[0] = t[0] * o, e1[1] = t[1] * o, e1[2] = t[2] * o, e1;
        }, Gc.dot = th, Gc.cross = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = i[0], a = i[1], l = i[2];
            return e1[0] = n * l - o * a, e1[1] = o * s - r * l, e1[2] = r * a - n * s, e1;
        }, Gc.lerp = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2];
            return e1[0] = n + r * (i[0] - n), e1[1] = o + r * (i[1] - o), e1[2] = s + r * (i[2] - s), e1;
        }, Gc.hermite = function(e1, t, i, r, n, o) {
            var s = o * o, a = s * (2 * o - 3) + 1, l = s * (o - 2) + o, c = s * (o - 1), h = s * (3 - 2 * o);
            return e1[0] = t[0] * a + i[0] * l + r[0] * c + n[0] * h, e1[1] = t[1] * a + i[1] * l + r[1] * c + n[1] * h, e1[2] = t[2] * a + i[2] * l + r[2] * c + n[2] * h, e1;
        }, Gc.bezier = function(e1, t, i, r, n, o) {
            var s = 1 - o, a = s * s, l = o * o, c = a * s, h = 3 * o * a, u = 3 * l * s, d = l * o;
            return e1[0] = t[0] * c + i[0] * h + r[0] * u + n[0] * d, e1[1] = t[1] * c + i[1] * h + r[1] * u + n[1] * d, e1[2] = t[2] * c + i[2] * h + r[2] * u + n[2] * d, e1;
        }, Gc.random = function(e1, t) {
            t = t || 1;
            var i = 2 * Zc.RANDOM() * Math.PI, r = 2 * Zc.RANDOM() - 1, n = Math.sqrt(1 - r * r) * t;
            return e1[0] = Math.cos(i) * n, e1[1] = Math.sin(i) * n, e1[2] = r * t, e1;
        }, Gc.transformMat4 = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = i[3] * r + i[7] * n + i[11] * o + i[15];
            return e1[0] = (i[0] * r + i[4] * n + i[8] * o + i[12]) / (s = s || 1), e1[1] = (i[1] * r + i[5] * n + i[9] * o + i[13]) / s, e1[2] = (i[2] * r + i[6] * n + i[10] * o + i[14]) / s, e1;
        }, Gc.transformMat3 = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2];
            return e1[0] = r * i[0] + n * i[3] + o * i[6], e1[1] = r * i[1] + n * i[4] + o * i[7], e1[2] = r * i[2] + n * i[5] + o * i[8], e1;
        }, Gc.transformQuat = function(e1, t, i) {
            var r = i[0], n = i[1], o = i[2], s = t[0], a = t[1], l = t[2], c = n * l - o * a, h = o * s - r * l, u = r * a - n * s, d = n * u - o * h, p = o * c - r * u, f = r * h - n * c, m = 2 * i[3];
            return h *= m, u *= m, p *= 2, f *= 2, e1[0] = s + (c *= m) + (d *= 2), e1[1] = a + h + p, e1[2] = l + u + f, e1;
        }, Gc.rotateX = function(e1, t, i, r) {
            var n = [], o = [];
            return n[0] = t[0] - i[0], n[1] = t[1] - i[1], n[2] = t[2] - i[2], o[0] = n[0], o[1] = n[1] * Math.cos(r) - n[2] * Math.sin(r), o[2] = n[1] * Math.sin(r) + n[2] * Math.cos(r), e1[0] = o[0] + i[0], e1[1] = o[1] + i[1], e1[2] = o[2] + i[2], e1;
        }, Gc.rotateY = function(e1, t, i, r) {
            var n = [], o = [];
            return n[0] = t[0] - i[0], n[1] = t[1] - i[1], n[2] = t[2] - i[2], o[0] = n[2] * Math.sin(r) + n[0] * Math.cos(r), o[1] = n[1], o[2] = n[2] * Math.cos(r) - n[0] * Math.sin(r), e1[0] = o[0] + i[0], e1[1] = o[1] + i[1], e1[2] = o[2] + i[2], e1;
        }, Gc.rotateZ = function(e1, t, i, r) {
            var n = [], o = [];
            return n[0] = t[0] - i[0], n[1] = t[1] - i[1], n[2] = t[2] - i[2], o[0] = n[0] * Math.cos(r) - n[1] * Math.sin(r), o[1] = n[0] * Math.sin(r) + n[1] * Math.cos(r), o[2] = n[2], e1[0] = o[0] + i[0], e1[1] = o[1] + i[1], e1[2] = o[2] + i[2], e1;
        }, Gc.angle = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = t[0], s = t[1], a = t[2], l = Math.sqrt(i * i + r * r + n * n) * Math.sqrt(o * o + s * s + a * a), c = l && th(e1, t) / l;
            return Math.acos(Math.min(Math.max(c, -1), 1));
        }, Gc.zero = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1;
        }, Gc.str = function(e1) {
            return "vec3(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ")";
        }, Gc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2];
        }, Gc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = t[0], s = t[1], a = t[2];
            return Math.abs(i - o) <= Zc.EPSILON * Math.max(1, Math.abs(i), Math.abs(o)) && Math.abs(r - s) <= Zc.EPSILON * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(n - a) <= Zc.EPSILON * Math.max(1, Math.abs(n), Math.abs(a));
        }, Gc.forEach = Gc.sqrLen = Gc.len = Gc.sqrDist = Gc.dist = Gc.div = Gc.mul = Gc.sub = void 0;
        var Zc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== qc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = $c(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function $c(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return ($c = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Wc() {
            var e1 = new Zc.ARRAY_TYPE(3);
            return Zc.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1;
        }
        function Hc(e1) {
            return Math.hypot(e1[0], e1[1], e1[2]);
        }
        function Xc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1;
        }
        function Yc(e1, t, i) {
            return e1[0] = t[0] * i[0], e1[1] = t[1] * i[1], e1[2] = t[2] * i[2], e1;
        }
        function Kc(e1, t, i) {
            return e1[0] = t[0] / i[0], e1[1] = t[1] / i[1], e1[2] = t[2] / i[2], e1;
        }
        function Jc(e1, t) {
            return Math.hypot(t[0] - e1[0], t[1] - e1[1], t[2] - e1[2]);
        }
        function Qc(e1, t) {
            var i = t[0] - e1[0], r = t[1] - e1[1], n = t[2] - e1[2];
            return i * i + r * r + n * n;
        }
        function eh(e1) {
            var t = e1[0], i = e1[1], r = e1[2];
            return t * t + i * i + r * r;
        }
        function th(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2];
        }
        Gc.sub = Xc, Gc.mul = Yc, Gc.div = Kc, Gc.dist = Jc, Gc.sqrDist = Qc, Gc.len = Hc, Gc.sqrLen = eh;
        var ih, rh = (ih = Wc(), function(e1, t, i, r, n, o) {
            var s, a;
            for(t || (t = 3), i || (i = 0), a = r ? Math.min(r * t + i, e1.length) : e1.length, s = i; s < a; s += t)ih[0] = e1[s], ih[1] = e1[s + 1], ih[2] = e1[s + 2], n(ih, ih, o), e1[s] = ih[0], e1[s + 1] = ih[1], e1[s + 2] = ih[2];
            return e1;
        });
        Gc.forEach = rh;
        var nh = {};
        function oh(e1) {
            return oh = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, oh(e1);
        }
        Object.defineProperty(nh, "__esModule", {
            value: !0
        }), nh.create = lh, nh.clone = function(e1) {
            var t = new sh.ARRAY_TYPE(4);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t;
        }, nh.fromValues = function(e1, t, i, r) {
            var n = new sh.ARRAY_TYPE(4);
            return n[0] = e1, n[1] = t, n[2] = i, n[3] = r, n;
        }, nh.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1;
        }, nh.set = function(e1, t, i, r, n) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1;
        }, nh.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1;
        }, nh.subtract = ch, nh.multiply = hh, nh.divide = uh, nh.ceil = function(e1, t) {
            return e1[0] = Math.ceil(t[0]), e1[1] = Math.ceil(t[1]), e1[2] = Math.ceil(t[2]), e1[3] = Math.ceil(t[3]), e1;
        }, nh.floor = function(e1, t) {
            return e1[0] = Math.floor(t[0]), e1[1] = Math.floor(t[1]), e1[2] = Math.floor(t[2]), e1[3] = Math.floor(t[3]), e1;
        }, nh.min = function(e1, t, i) {
            return e1[0] = Math.min(t[0], i[0]), e1[1] = Math.min(t[1], i[1]), e1[2] = Math.min(t[2], i[2]), e1[3] = Math.min(t[3], i[3]), e1;
        }, nh.max = function(e1, t, i) {
            return e1[0] = Math.max(t[0], i[0]), e1[1] = Math.max(t[1], i[1]), e1[2] = Math.max(t[2], i[2]), e1[3] = Math.max(t[3], i[3]), e1;
        }, nh.round = function(e1, t) {
            return e1[0] = Math.round(t[0]), e1[1] = Math.round(t[1]), e1[2] = Math.round(t[2]), e1[3] = Math.round(t[3]), e1;
        }, nh.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1;
        }, nh.scaleAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1;
        }, nh.distance = dh, nh.squaredDistance = ph, nh.length = fh, nh.squaredLength = mh, nh.negate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1[3] = -t[3], e1;
        }, nh.inverse = function(e1, t) {
            return e1[0] = 1 / t[0], e1[1] = 1 / t[1], e1[2] = 1 / t[2], e1[3] = 1 / t[3], e1;
        }, nh.normalize = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i * i + r * r + n * n + o * o;
            return s > 0 && (s = 1 / Math.sqrt(s)), e1[0] = i * s, e1[1] = r * s, e1[2] = n * s, e1[3] = o * s, e1;
        }, nh.dot = function(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] * t[3];
        }, nh.cross = function(e1, t, i, r) {
            var n = i[0] * r[1] - i[1] * r[0], o = i[0] * r[2] - i[2] * r[0], s = i[0] * r[3] - i[3] * r[0], a = i[1] * r[2] - i[2] * r[1], l = i[1] * r[3] - i[3] * r[1], c = i[2] * r[3] - i[3] * r[2], h = t[0], u = t[1], d = t[2], p = t[3];
            return e1[0] = u * c - d * l + p * a, e1[1] = -h * c + d * s - p * o, e1[2] = h * l - u * s + p * n, e1[3] = -h * a + u * o - d * n, e1;
        }, nh.lerp = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2], a = t[3];
            return e1[0] = n + r * (i[0] - n), e1[1] = o + r * (i[1] - o), e1[2] = s + r * (i[2] - s), e1[3] = a + r * (i[3] - a), e1;
        }, nh.random = function(e1, t) {
            var i, r, n, o, s, a;
            t = t || 1;
            do s = (i = 2 * sh.RANDOM() - 1) * i + (r = 2 * sh.RANDOM() - 1) * r;
            while (s >= 1);
            do a = (n = 2 * sh.RANDOM() - 1) * n + (o = 2 * sh.RANDOM() - 1) * o;
            while (a >= 1);
            var l = Math.sqrt((1 - s) / a);
            return e1[0] = t * i, e1[1] = t * r, e1[2] = t * n * l, e1[3] = t * o * l, e1;
        }, nh.transformMat4 = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3];
            return e1[0] = i[0] * r + i[4] * n + i[8] * o + i[12] * s, e1[1] = i[1] * r + i[5] * n + i[9] * o + i[13] * s, e1[2] = i[2] * r + i[6] * n + i[10] * o + i[14] * s, e1[3] = i[3] * r + i[7] * n + i[11] * o + i[15] * s, e1;
        }, nh.transformQuat = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = i[0], a = i[1], l = i[2], c = i[3], h = c * r + a * o - l * n, u = c * n + l * r - s * o, d = c * o + s * n - a * r, p = -s * r - a * n - l * o;
            return e1[0] = h * c + p * -s + u * -l - d * -a, e1[1] = u * c + p * -a + d * -s - h * -l, e1[2] = d * c + p * -l + h * -a - u * -s, e1[3] = t[3], e1;
        }, nh.zero = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1;
        }, nh.str = function(e1) {
            return "vec4(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
        }, nh.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3];
        }, nh.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = t[0], a = t[1], l = t[2], c = t[3];
            return Math.abs(i - s) <= sh.EPSILON * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(r - a) <= sh.EPSILON * Math.max(1, Math.abs(r), Math.abs(a)) && Math.abs(n - l) <= sh.EPSILON * Math.max(1, Math.abs(n), Math.abs(l)) && Math.abs(o - c) <= sh.EPSILON * Math.max(1, Math.abs(o), Math.abs(c));
        }, nh.forEach = nh.sqrLen = nh.len = nh.sqrDist = nh.dist = nh.div = nh.mul = nh.sub = void 0;
        var sh = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== oh(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = ah(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function ah(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (ah = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function lh() {
            var e1 = new sh.ARRAY_TYPE(4);
            return sh.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0), e1;
        }
        function ch(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1;
        }
        function hh(e1, t, i) {
            return e1[0] = t[0] * i[0], e1[1] = t[1] * i[1], e1[2] = t[2] * i[2], e1[3] = t[3] * i[3], e1;
        }
        function uh(e1, t, i) {
            return e1[0] = t[0] / i[0], e1[1] = t[1] / i[1], e1[2] = t[2] / i[2], e1[3] = t[3] / i[3], e1;
        }
        function dh(e1, t) {
            return Math.hypot(t[0] - e1[0], t[1] - e1[1], t[2] - e1[2], t[3] - e1[3]);
        }
        function ph(e1, t) {
            var i = t[0] - e1[0], r = t[1] - e1[1], n = t[2] - e1[2], o = t[3] - e1[3];
            return i * i + r * r + n * n + o * o;
        }
        function fh(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3]);
        }
        function mh(e1) {
            var t = e1[0], i = e1[1], r = e1[2], n = e1[3];
            return t * t + i * i + r * r + n * n;
        }
        nh.sub = ch, nh.mul = hh, nh.div = uh, nh.dist = dh, nh.sqrDist = ph, nh.len = fh, nh.sqrLen = mh;
        var _h = function() {
            var e1 = lh();
            return function(t, i, r, n, o, s) {
                var a, l;
                for(i || (i = 4), r || (r = 0), l = n ? Math.min(n * i + r, t.length) : t.length, a = r; a < l; a += i)e1[0] = t[a], e1[1] = t[a + 1], e1[2] = t[a + 2], e1[3] = t[a + 3], o(e1, e1, s), t[a] = e1[0], t[a + 1] = e1[1], t[a + 2] = e1[2], t[a + 3] = e1[3];
                return t;
            };
        }();
        function gh(e1) {
            return gh = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, gh(e1);
        }
        nh.forEach = _h, Object.defineProperty(jc, "__esModule", {
            value: !0
        }), jc.create = Eh, jc.identity = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1;
        }, jc.setAxisAngle = Mh, jc.getAxisAngle = function(e1, t) {
            var i = 2 * Math.acos(t[3]), r = Math.sin(i / 2);
            return r > yh.EPSILON ? (e1[0] = t[0] / r, e1[1] = t[1] / r, e1[2] = t[2] / r) : (e1[0] = 1, e1[1] = 0, e1[2] = 0), i;
        }, jc.getAngle = function(e1, t) {
            var i = Dh(e1, t);
            return Math.acos(2 * i * i - 1);
        }, jc.multiply = Ah, jc.rotateX = function(e1, t, i) {
            i *= .5;
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l + s * a, e1[1] = n * l + o * a, e1[2] = o * l - n * a, e1[3] = s * l - r * a, e1;
        }, jc.rotateY = function(e1, t, i) {
            i *= .5;
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l - o * a, e1[1] = n * l + s * a, e1[2] = o * l + r * a, e1[3] = s * l - n * a, e1;
        }, jc.rotateZ = function(e1, t, i) {
            i *= .5;
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l + n * a, e1[1] = n * l - r * a, e1[2] = o * l + s * a, e1[3] = s * l - o * a, e1;
        }, jc.calculateW = function(e1, t) {
            var i = t[0], r = t[1], n = t[2];
            return e1[0] = i, e1[1] = r, e1[2] = n, e1[3] = Math.sqrt(Math.abs(1 - i * i - r * r - n * n)), e1;
        }, jc.exp = Sh, jc.ln = Ih, jc.pow = function(e1, t, i) {
            return Ih(e1, t), Ph(e1, e1, i), Sh(e1, e1), e1;
        }, jc.slerp = Ch, jc.random = function(e1) {
            var t = yh.RANDOM(), i = yh.RANDOM(), r = yh.RANDOM(), n = Math.sqrt(1 - t), o = Math.sqrt(t);
            return e1[0] = n * Math.sin(2 * Math.PI * i), e1[1] = n * Math.cos(2 * Math.PI * i), e1[2] = o * Math.sin(2 * Math.PI * r), e1[3] = o * Math.cos(2 * Math.PI * r), e1;
        }, jc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i * i + r * r + n * n + o * o, a = s ? 1 / s : 0;
            return e1[0] = -i * a, e1[1] = -r * a, e1[2] = -n * a, e1[3] = o * a, e1;
        }, jc.conjugate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1[3] = t[3], e1;
        }, jc.fromMat3 = zh, jc.fromEuler = function(e1, t, i, r) {
            var n = .5 * Math.PI / 180;
            t *= n, i *= n, r *= n;
            var o = Math.sin(t), s = Math.cos(t), a = Math.sin(i), l = Math.cos(i), c = Math.sin(r), h = Math.cos(r);
            return e1[0] = o * l * h - s * a * c, e1[1] = s * a * h + o * l * c, e1[2] = s * l * c - o * a * h, e1[3] = s * l * h + o * a * c, e1;
        }, jc.str = function(e1) {
            return "quat(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
        }, jc.setAxes = jc.sqlerp = jc.rotationTo = jc.equals = jc.exactEquals = jc.normalize = jc.sqrLen = jc.squaredLength = jc.len = jc.length = jc.lerp = jc.dot = jc.scale = jc.mul = jc.add = jc.set = jc.copy = jc.fromValues = jc.clone = void 0;
        var yh = Th(lc), xh = Th(Mc), vh = Th(Gc), bh = Th(nh);
        function wh(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (wh = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Th(e1, t) {
            if (!t && e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== gh(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = wh(t);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }
        function Eh() {
            var e1 = new yh.ARRAY_TYPE(4);
            return yh.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1[3] = 1, e1;
        }
        function Mh(e1, t, i) {
            i *= .5;
            var r = Math.sin(i);
            return e1[0] = r * t[0], e1[1] = r * t[1], e1[2] = r * t[2], e1[3] = Math.cos(i), e1;
        }
        function Ah(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[0], l = i[1], c = i[2], h = i[3];
            return e1[0] = r * h + s * a + n * c - o * l, e1[1] = n * h + s * l + o * a - r * c, e1[2] = o * h + s * c + r * l - n * a, e1[3] = s * h - r * a - n * l - o * c, e1;
        }
        function Sh(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = Math.sqrt(i * i + r * r + n * n), a = Math.exp(o), l = s > 0 ? a * Math.sin(s) / s : 0;
            return e1[0] = i * l, e1[1] = r * l, e1[2] = n * l, e1[3] = a * Math.cos(s), e1;
        }
        function Ih(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = Math.sqrt(i * i + r * r + n * n), a = s > 0 ? Math.atan2(s, o) / s : 0;
            return e1[0] = i * a, e1[1] = r * a, e1[2] = n * a, e1[3] = .5 * Math.log(i * i + r * r + n * n + o * o), e1;
        }
        function Ch(e1, t, i, r) {
            var n, o, s, a, l, c = t[0], h = t[1], u = t[2], d = t[3], p = i[0], f = i[1], m = i[2], _ = i[3];
            return (o = c * p + h * f + u * m + d * _) < 0 && (o = -o, p = -p, f = -f, m = -m, _ = -_), 1 - o > yh.EPSILON ? (n = Math.acos(o), s = Math.sin(n), a = Math.sin((1 - r) * n) / s, l = Math.sin(r * n) / s) : (a = 1 - r, l = r), e1[0] = a * c + l * p, e1[1] = a * h + l * f, e1[2] = a * u + l * m, e1[3] = a * d + l * _, e1;
        }
        function zh(e1, t) {
            var i, r = t[0] + t[4] + t[8];
            if (r > 0) i = Math.sqrt(r + 1), e1[3] = .5 * i, e1[0] = (t[5] - t[7]) * (i = .5 / i), e1[1] = (t[6] - t[2]) * i, e1[2] = (t[1] - t[3]) * i;
            else {
                var n = 0;
                t[4] > t[0] && (n = 1), t[8] > t[3 * n + n] && (n = 2);
                var o = (n + 1) % 3, s = (n + 2) % 3;
                i = Math.sqrt(t[3 * n + n] - t[3 * o + o] - t[3 * s + s] + 1), e1[n] = .5 * i, e1[3] = (t[3 * o + s] - t[3 * s + o]) * (i = .5 / i), e1[o] = (t[3 * o + n] + t[3 * n + o]) * i, e1[s] = (t[3 * s + n] + t[3 * n + s]) * i;
            }
            return e1;
        }
        jc.clone = bh.clone, jc.fromValues = bh.fromValues, jc.copy = bh.copy, jc.set = bh.set, jc.add = bh.add, jc.mul = Ah;
        var Ph = bh.scale;
        jc.scale = Ph;
        var Dh = bh.dot;
        jc.dot = Dh, jc.lerp = bh.lerp;
        var Rh = bh.length;
        jc.length = Rh, jc.len = Rh;
        var Lh = bh.squaredLength;
        jc.squaredLength = Lh, jc.sqrLen = Lh;
        var kh = bh.normalize;
        jc.normalize = kh, jc.exactEquals = bh.exactEquals, jc.equals = bh.equals;
        var Oh, Bh, Fh, Nh = (Oh = vh.create(), Bh = vh.fromValues(1, 0, 0), Fh = vh.fromValues(0, 1, 0), function(e1, t, i) {
            var r = vh.dot(t, i);
            return r < -0.999999 ? (vh.cross(Oh, Bh, t), vh.len(Oh) < 1e-6 && vh.cross(Oh, Fh, t), vh.normalize(Oh, Oh), Mh(e1, Oh, Math.PI), e1) : r > .999999 ? (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1) : (vh.cross(Oh, t, i), e1[0] = Oh[0], e1[1] = Oh[1], e1[2] = Oh[2], e1[3] = 1 + r, kh(e1, e1));
        });
        jc.rotationTo = Nh;
        var Uh, Vh, jh = (Uh = Eh(), Vh = Eh(), function(e1, t, i, r, n, o) {
            return Ch(Uh, t, n, o), Ch(Vh, i, r, o), Ch(e1, Uh, Vh, 2 * o * (1 - o)), e1;
        });
        jc.sqlerp = jh;
        var Gh, qh = (Gh = xh.create(), function(e1, t, i, r) {
            return Gh[0] = i[0], Gh[3] = i[1], Gh[6] = i[2], Gh[1] = r[0], Gh[4] = r[1], Gh[7] = r[2], Gh[2] = -t[0], Gh[5] = -t[1], Gh[8] = -t[2], kh(e1, zh(e1, Gh));
        });
        jc.setAxes = qh;
        var Zh = {};
        function $h(e1) {
            return $h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, $h(e1);
        }
        Object.defineProperty(Zh, "__esModule", {
            value: !0
        }), Zh.create = function() {
            var e1 = new Wh.ARRAY_TYPE(8);
            return Wh.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[4] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[3] = 1, e1;
        }, Zh.clone = function(e1) {
            var t = new Wh.ARRAY_TYPE(8);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t;
        }, Zh.fromValues = function(e1, t, i, r, n, o, s, a) {
            var l = new Wh.ARRAY_TYPE(8);
            return l[0] = e1, l[1] = t, l[2] = i, l[3] = r, l[4] = n, l[5] = o, l[6] = s, l[7] = a, l;
        }, Zh.fromRotationTranslationValues = function(e1, t, i, r, n, o, s) {
            var a = new Wh.ARRAY_TYPE(8);
            a[0] = e1, a[1] = t, a[2] = i, a[3] = r;
            var l = .5 * n, c = .5 * o, h = .5 * s;
            return a[4] = l * r + c * i - h * t, a[5] = c * r + h * e1 - l * i, a[6] = h * r + l * t - c * e1, a[7] = -l * e1 - c * t - h * i, a;
        }, Zh.fromRotationTranslation = Jh, Zh.fromTranslation = function(e1, t) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = .5 * t[0], e1[5] = .5 * t[1], e1[6] = .5 * t[2], e1[7] = 0, e1;
        }, Zh.fromRotation = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1;
        }, Zh.fromMat4 = function(e1, t) {
            var i = Hh.create();
            Xh.getRotation(i, t);
            var r = new Wh.ARRAY_TYPE(3);
            return Xh.getTranslation(r, t), Jh(e1, i, r), e1;
        }, Zh.copy = Qh, Zh.identity = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1;
        }, Zh.set = function(e1, t, i, r, n, o, s, a, l) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1[6] = a, e1[7] = l, e1;
        }, Zh.getDual = function(e1, t) {
            return e1[0] = t[4], e1[1] = t[5], e1[2] = t[6], e1[3] = t[7], e1;
        }, Zh.setDual = function(e1, t) {
            return e1[4] = t[0], e1[5] = t[1], e1[6] = t[2], e1[7] = t[3], e1;
        }, Zh.getTranslation = function(e1, t) {
            var i = t[4], r = t[5], n = t[6], o = t[7], s = -t[0], a = -t[1], l = -t[2], c = t[3];
            return e1[0] = 2 * (i * c + o * s + r * l - n * a), e1[1] = 2 * (r * c + o * a + n * s - i * l), e1[2] = 2 * (n * c + o * l + i * a - r * s), e1;
        }, Zh.translate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = .5 * i[0], l = .5 * i[1], c = .5 * i[2], h = t[4], u = t[5], d = t[6], p = t[7];
            return e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = s * a + n * c - o * l + h, e1[5] = s * l + o * a - r * c + u, e1[6] = s * c + r * l - n * a + d, e1[7] = -r * a - n * l - o * c + p, e1;
        }, Zh.rotateX = function(e1, t, i) {
            var r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = a * s + h * r + l * o - c * n, d = l * s + h * n + c * r - a * o, p = c * s + h * o + a * n - l * r, f = h * s - a * r - l * n - c * o;
            return Hh.rotateX(e1, t, i), e1[4] = u * (s = e1[3]) + f * (r = e1[0]) + d * (o = e1[2]) - p * (n = e1[1]), e1[5] = d * s + f * n + p * r - u * o, e1[6] = p * s + f * o + u * n - d * r, e1[7] = f * s - u * r - d * n - p * o, e1;
        }, Zh.rotateY = function(e1, t, i) {
            var r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = a * s + h * r + l * o - c * n, d = l * s + h * n + c * r - a * o, p = c * s + h * o + a * n - l * r, f = h * s - a * r - l * n - c * o;
            return Hh.rotateY(e1, t, i), e1[4] = u * (s = e1[3]) + f * (r = e1[0]) + d * (o = e1[2]) - p * (n = e1[1]), e1[5] = d * s + f * n + p * r - u * o, e1[6] = p * s + f * o + u * n - d * r, e1[7] = f * s - u * r - d * n - p * o, e1;
        }, Zh.rotateZ = function(e1, t, i) {
            var r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = a * s + h * r + l * o - c * n, d = l * s + h * n + c * r - a * o, p = c * s + h * o + a * n - l * r, f = h * s - a * r - l * n - c * o;
            return Hh.rotateZ(e1, t, i), e1[4] = u * (s = e1[3]) + f * (r = e1[0]) + d * (o = e1[2]) - p * (n = e1[1]), e1[5] = d * s + f * n + p * r - u * o, e1[6] = p * s + f * o + u * n - d * r, e1[7] = f * s - u * r - d * n - p * o, e1;
        }, Zh.rotateByQuatAppend = function(e1, t, i) {
            var r = i[0], n = i[1], o = i[2], s = i[3], a = t[0], l = t[1], c = t[2], h = t[3];
            return e1[0] = a * s + h * r + l * o - c * n, e1[1] = l * s + h * n + c * r - a * o, e1[2] = c * s + h * o + a * n - l * r, e1[3] = h * s - a * r - l * n - c * o, e1[4] = (a = t[4]) * s + (h = t[7]) * r + (l = t[5]) * o - (c = t[6]) * n, e1[5] = l * s + h * n + c * r - a * o, e1[6] = c * s + h * o + a * n - l * r, e1[7] = h * s - a * r - l * n - c * o, e1;
        }, Zh.rotateByQuatPrepend = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[0], l = i[1], c = i[2], h = i[3];
            return e1[0] = r * h + s * a + n * c - o * l, e1[1] = n * h + s * l + o * a - r * c, e1[2] = o * h + s * c + r * l - n * a, e1[3] = s * h - r * a - n * l - o * c, e1[4] = r * (h = i[7]) + s * (a = i[4]) + n * (c = i[6]) - o * (l = i[5]), e1[5] = n * h + s * l + o * a - r * c, e1[6] = o * h + s * c + r * l - n * a, e1[7] = s * h - r * a - n * l - o * c, e1;
        }, Zh.rotateAroundAxis = function(e1, t, i, r) {
            if (Math.abs(r) < Wh.EPSILON) return Qh(e1, t);
            var n = Math.hypot(i[0], i[1], i[2]);
            r *= .5;
            var o = Math.sin(r), s = o * i[0] / n, a = o * i[1] / n, l = o * i[2] / n, c = Math.cos(r), h = t[0], u = t[1], d = t[2], p = t[3];
            e1[0] = h * c + p * s + u * l - d * a, e1[1] = u * c + p * a + d * s - h * l, e1[2] = d * c + p * l + h * a - u * s, e1[3] = p * c - h * s - u * a - d * l;
            var f = t[4], m = t[5], _ = t[6], g = t[7];
            return e1[4] = f * c + g * s + m * l - _ * a, e1[5] = m * c + g * a + _ * s - f * l, e1[6] = _ * c + g * l + f * a - m * s, e1[7] = g * c - f * s - m * a - _ * l, e1;
        }, Zh.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1[6] = t[6] + i[6], e1[7] = t[7] + i[7], e1;
        }, Zh.multiply = eu, Zh.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1[6] = t[6] * i, e1[7] = t[7] * i, e1;
        }, Zh.lerp = function(e1, t, i, r) {
            var n = 1 - r;
            return tu(t, i) < 0 && (r = -r), e1[0] = t[0] * n + i[0] * r, e1[1] = t[1] * n + i[1] * r, e1[2] = t[2] * n + i[2] * r, e1[3] = t[3] * n + i[3] * r, e1[4] = t[4] * n + i[4] * r, e1[5] = t[5] * n + i[5] * r, e1[6] = t[6] * n + i[6] * r, e1[7] = t[7] * n + i[7] * r, e1;
        }, Zh.invert = function(e1, t) {
            var i = ru(t);
            return e1[0] = -t[0] / i, e1[1] = -t[1] / i, e1[2] = -t[2] / i, e1[3] = t[3] / i, e1[4] = -t[4] / i, e1[5] = -t[5] / i, e1[6] = -t[6] / i, e1[7] = t[7] / i, e1;
        }, Zh.conjugate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1[3] = t[3], e1[4] = -t[4], e1[5] = -t[5], e1[6] = -t[6], e1[7] = t[7], e1;
        }, Zh.normalize = function(e1, t) {
            var i = ru(t);
            if (i > 0) {
                i = Math.sqrt(i);
                var r = t[0] / i, n = t[1] / i, o = t[2] / i, s = t[3] / i, a = t[4], l = t[5], c = t[6], h = t[7], u = r * a + n * l + o * c + s * h;
                e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = (a - r * u) / i, e1[5] = (l - n * u) / i, e1[6] = (c - o * u) / i, e1[7] = (h - s * u) / i;
            }
            return e1;
        }, Zh.str = function(e1) {
            return "quat2(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ", " + e1[6] + ", " + e1[7] + ")";
        }, Zh.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7];
        }, Zh.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = e1[6], c = e1[7], h = t[0], u = t[1], d = t[2], p = t[3], f = t[4], m = t[5], _ = t[6], g = t[7];
            return Math.abs(i - h) <= Wh.EPSILON * Math.max(1, Math.abs(i), Math.abs(h)) && Math.abs(r - u) <= Wh.EPSILON * Math.max(1, Math.abs(r), Math.abs(u)) && Math.abs(n - d) <= Wh.EPSILON * Math.max(1, Math.abs(n), Math.abs(d)) && Math.abs(o - p) <= Wh.EPSILON * Math.max(1, Math.abs(o), Math.abs(p)) && Math.abs(s - f) <= Wh.EPSILON * Math.max(1, Math.abs(s), Math.abs(f)) && Math.abs(a - m) <= Wh.EPSILON * Math.max(1, Math.abs(a), Math.abs(m)) && Math.abs(l - _) <= Wh.EPSILON * Math.max(1, Math.abs(l), Math.abs(_)) && Math.abs(c - g) <= Wh.EPSILON * Math.max(1, Math.abs(c), Math.abs(g));
        }, Zh.sqrLen = Zh.squaredLength = Zh.len = Zh.length = Zh.dot = Zh.mul = Zh.setReal = Zh.getReal = void 0;
        var Wh = Kh(lc), Hh = Kh(jc), Xh = Kh(Pc);
        function Yh(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Yh = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Kh(e1, t) {
            if (!t && e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== $h(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Yh(t);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }
        function Jh(e1, t, i) {
            var r = .5 * i[0], n = .5 * i[1], o = .5 * i[2], s = t[0], a = t[1], l = t[2], c = t[3];
            return e1[0] = s, e1[1] = a, e1[2] = l, e1[3] = c, e1[4] = r * c + n * l - o * a, e1[5] = n * c + o * s - r * l, e1[6] = o * c + r * a - n * s, e1[7] = -r * s - n * a - o * l, e1;
        }
        function Qh(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1;
        }
        function eu(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[4], l = i[5], c = i[6], h = i[7], u = t[4], d = t[5], p = t[6], f = t[7], m = i[0], _ = i[1], g = i[2], y = i[3];
            return e1[0] = r * y + s * m + n * g - o * _, e1[1] = n * y + s * _ + o * m - r * g, e1[2] = o * y + s * g + r * _ - n * m, e1[3] = s * y - r * m - n * _ - o * g, e1[4] = r * h + s * a + n * c - o * l + u * y + f * m + d * g - p * _, e1[5] = n * h + s * l + o * a - r * c + d * y + f * _ + p * m - u * g, e1[6] = o * h + s * c + r * l - n * a + p * y + f * g + u * _ - d * m, e1[7] = s * h - r * a - n * l - o * c + f * y - u * m - d * _ - p * g, e1;
        }
        Zh.getReal = Hh.copy, Zh.setReal = Hh.copy, Zh.mul = eu;
        var tu = Hh.dot;
        Zh.dot = tu;
        var iu = Hh.length;
        Zh.length = iu, Zh.len = iu;
        var ru = Hh.squaredLength;
        Zh.squaredLength = ru, Zh.sqrLen = ru;
        var nu = {};
        function ou(e1) {
            return ou = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, ou(e1);
        }
        Object.defineProperty(nu, "__esModule", {
            value: !0
        }), nu.create = lu, nu.clone = function(e1) {
            var t = new su.ARRAY_TYPE(2);
            return t[0] = e1[0], t[1] = e1[1], t;
        }, nu.fromValues = function(e1, t) {
            var i = new su.ARRAY_TYPE(2);
            return i[0] = e1, i[1] = t, i;
        }, nu.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1;
        }, nu.set = function(e1, t, i) {
            return e1[0] = t, e1[1] = i, e1;
        }, nu.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1;
        }, nu.subtract = cu, nu.multiply = hu, nu.divide = uu, nu.ceil = function(e1, t) {
            return e1[0] = Math.ceil(t[0]), e1[1] = Math.ceil(t[1]), e1;
        }, nu.floor = function(e1, t) {
            return e1[0] = Math.floor(t[0]), e1[1] = Math.floor(t[1]), e1;
        }, nu.min = function(e1, t, i) {
            return e1[0] = Math.min(t[0], i[0]), e1[1] = Math.min(t[1], i[1]), e1;
        }, nu.max = function(e1, t, i) {
            return e1[0] = Math.max(t[0], i[0]), e1[1] = Math.max(t[1], i[1]), e1;
        }, nu.round = function(e1, t) {
            return e1[0] = Math.round(t[0]), e1[1] = Math.round(t[1]), e1;
        }, nu.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1;
        }, nu.scaleAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1;
        }, nu.distance = du, nu.squaredDistance = pu, nu.length = fu, nu.squaredLength = mu, nu.negate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1;
        }, nu.inverse = function(e1, t) {
            return e1[0] = 1 / t[0], e1[1] = 1 / t[1], e1;
        }, nu.normalize = function(e1, t) {
            var i = t[0], r = t[1], n = i * i + r * r;
            return n > 0 && (n = 1 / Math.sqrt(n)), e1[0] = t[0] * n, e1[1] = t[1] * n, e1;
        }, nu.dot = function(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1];
        }, nu.cross = function(e1, t, i) {
            var r = t[0] * i[1] - t[1] * i[0];
            return e1[0] = e1[1] = 0, e1[2] = r, e1;
        }, nu.lerp = function(e1, t, i, r) {
            var n = t[0], o = t[1];
            return e1[0] = n + r * (i[0] - n), e1[1] = o + r * (i[1] - o), e1;
        }, nu.random = function(e1, t) {
            t = t || 1;
            var i = 2 * su.RANDOM() * Math.PI;
            return e1[0] = Math.cos(i) * t, e1[1] = Math.sin(i) * t, e1;
        }, nu.transformMat2 = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[2] * n, e1[1] = i[1] * r + i[3] * n, e1;
        }, nu.transformMat2d = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[2] * n + i[4], e1[1] = i[1] * r + i[3] * n + i[5], e1;
        }, nu.transformMat3 = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[3] * n + i[6], e1[1] = i[1] * r + i[4] * n + i[7], e1;
        }, nu.transformMat4 = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[4] * n + i[12], e1[1] = i[1] * r + i[5] * n + i[13], e1;
        }, nu.rotate = function(e1, t, i, r) {
            var n = t[0] - i[0], o = t[1] - i[1], s = Math.sin(r), a = Math.cos(r);
            return e1[0] = n * a - o * s + i[0], e1[1] = n * s + o * a + i[1], e1;
        }, nu.angle = function(e1, t) {
            var i = e1[0], r = e1[1], n = t[0], o = t[1], s = Math.sqrt(i * i + r * r) * Math.sqrt(n * n + o * o);
            return Math.acos(Math.min(Math.max(s && (i * n + r * o) / s, -1), 1));
        }, nu.zero = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1;
        }, nu.str = function(e1) {
            return "vec2(" + e1[0] + ", " + e1[1] + ")";
        }, nu.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1];
        }, nu.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = t[0], o = t[1];
            return Math.abs(i - n) <= su.EPSILON * Math.max(1, Math.abs(i), Math.abs(n)) && Math.abs(r - o) <= su.EPSILON * Math.max(1, Math.abs(r), Math.abs(o));
        }, nu.forEach = nu.sqrLen = nu.sqrDist = nu.dist = nu.div = nu.mul = nu.sub = nu.len = void 0;
        var su = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== ou(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = au(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function au(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (au = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function lu() {
            var e1 = new su.ARRAY_TYPE(2);
            return su.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0), e1;
        }
        function cu(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1;
        }
        function hu(e1, t, i) {
            return e1[0] = t[0] * i[0], e1[1] = t[1] * i[1], e1;
        }
        function uu(e1, t, i) {
            return e1[0] = t[0] / i[0], e1[1] = t[1] / i[1], e1;
        }
        function du(e1, t) {
            return Math.hypot(t[0] - e1[0], t[1] - e1[1]);
        }
        function pu(e1, t) {
            var i = t[0] - e1[0], r = t[1] - e1[1];
            return i * i + r * r;
        }
        function fu(e1) {
            return Math.hypot(e1[0], e1[1]);
        }
        function mu(e1) {
            var t = e1[0], i = e1[1];
            return t * t + i * i;
        }
        nu.len = fu, nu.sub = cu, nu.mul = hu, nu.div = uu, nu.dist = du, nu.sqrDist = pu, nu.sqrLen = mu;
        var _u = function() {
            var e1 = lu();
            return function(t, i, r, n, o, s) {
                var a, l;
                for(i || (i = 2), r || (r = 0), l = n ? Math.min(n * i + r, t.length) : t.length, a = r; a < l; a += i)e1[0] = t[a], e1[1] = t[a + 1], o(e1, e1, s), t[a] = e1[0], t[a + 1] = e1[1];
                return t;
            };
        }();
        function gu(e1) {
            return gu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, gu(e1);
        }
        nu.forEach = _u, Object.defineProperty(ac, "__esModule", {
            value: !0
        });
        var yu = ac.vec4 = Du = ac.vec3 = ac.vec2 = ac.quat2 = Iu = ac.quat = Au = ac.mat4 = Eu = ac.mat3 = ac.mat2d = bu = ac.mat2 = ac.glMatrix = void 0, xu = ku(lc);
        ac.glMatrix = xu;
        var vu = ku(pc), bu = ac.mat2 = vu, wu = ku(xc);
        ac.mat2d = wu;
        var Tu = ku(Mc), Eu = ac.mat3 = Tu, Mu = ku(Pc), Au = ac.mat4 = Mu, Su = ku(jc), Iu = ac.quat = Su, Cu = ku(Zh);
        ac.quat2 = Cu;
        var zu = ku(nu);
        ac.vec2 = zu;
        var Pu = ku(Gc), Du = ac.vec3 = Pu, Ru = ku(nh);
        function Lu(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Lu = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function ku(e1, t) {
            if (!t && e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== gu(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Lu(t);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }
        yu = ac.vec4 = Ru;
        const Ou = Ia([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: Bu } = Ou, Fu = Ia([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var Nu = Ia([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]), Uu = {};
        !function(e1, t) {
            !function(e1) {
                function t(e1, t, r) {
                    var n = i(256 * e1, 256 * (t = Math.pow(2, r) - t - 1), r), o = i(256 * (e1 + 1), 256 * (t + 1), r);
                    return n[0] + "," + n[1] + "," + o[0] + "," + o[1];
                }
                function i(e1, t, i) {
                    var r = 2 * Math.PI * 6378137 / 256 / Math.pow(2, i);
                    return [
                        e1 * r - 2 * Math.PI * 6378137 / 2,
                        t * r - 2 * Math.PI * 6378137 / 2
                    ];
                }
                e1.getURL = function(e1, i, r, n, o, s) {
                    return s = s || {}, e1 + "?" + [
                        "bbox=" + t(r, n, o),
                        "format=" + (s.format || "image/png"),
                        "service=" + (s.service || "WMS"),
                        "version=" + (s.version || "1.1.1"),
                        "request=" + (s.request || "GetMap"),
                        "srs=" + (s.srs || "EPSG:3857"),
                        "width=" + (s.width || 256),
                        "height=" + (s.height || 256),
                        "layers=" + i
                    ].join("&");
                }, e1.getTileBBox = t, e1.getMercCoords = i, Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
            }(t);
        }(0, Uu);
        var Vu = Uu;
        class ju {
            constructor(e1, t, i){
                this.z = e1, this.x = t, this.y = i, this.key = Zu(0, e1, e1, t, i);
            }
            equals(e1) {
                return this.z === e1.z && this.x === e1.x && this.y === e1.y;
            }
            url(e1, t) {
                const i = Vu.getTileBBox(this.x, this.y, this.z), r = function(e1, t, i) {
                    let r, n = "";
                    for(let o = e1; o > 0; o--)r = 1 << o - 1, n += (t & r ? 1 : 0) + (i & r ? 2 : 0);
                    return n;
                }(this.z, this.x, this.y);
                return e1[(this.x + this.y) % e1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === t ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", r).replace("{bbox-epsg-3857}", i);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class Gu {
            constructor(e1, t){
                this.wrap = e1, this.canonical = t, this.key = Zu(e1, t.z, t.z, t.x, t.y);
            }
        }
        class qu {
            constructor(e1, t, i, r, n){
                this.overscaledZ = e1, this.wrap = t, this.canonical = new ju(i, +r, +n), this.key = 0 === t && e1 === i ? this.canonical.key : Zu(t, e1, i, r, n);
            }
            equals(e1) {
                return this.overscaledZ === e1.overscaledZ && this.wrap === e1.wrap && this.canonical.equals(e1.canonical);
            }
            scaledTo(e1) {
                const t = this.canonical.z - e1;
                return e1 > this.canonical.z ? new qu(e1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new qu(e1, this.wrap, e1, this.canonical.x >> t, this.canonical.y >> t);
            }
            calculateScaledKey(e1, t = !0) {
                if (this.overscaledZ === e1 && t) return this.key;
                if (e1 > this.canonical.z) return Zu(this.wrap * +t, e1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const i = this.canonical.z - e1;
                    return Zu(this.wrap * +t, e1, e1, this.canonical.x >> i, this.canonical.y >> i);
                }
            }
            isChildOf(e1) {
                if (e1.wrap !== this.wrap) return !1;
                const t = this.canonical.z - e1.canonical.z;
                return 0 === e1.overscaledZ || e1.overscaledZ < this.overscaledZ && e1.canonical.z < this.canonical.z && e1.canonical.x === this.canonical.x >> t && e1.canonical.y === this.canonical.y >> t;
            }
            children(e1) {
                if (this.overscaledZ >= e1) return [
                    new qu(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const t = this.canonical.z + 1, i = 2 * this.canonical.x, r = 2 * this.canonical.y;
                return [
                    new qu(t, this.wrap, t, i, r),
                    new qu(t, this.wrap, t, i + 1, r),
                    new qu(t, this.wrap, t, i, r + 1),
                    new qu(t, this.wrap, t, i + 1, r + 1)
                ];
            }
            isLessThan(e1) {
                return this.wrap < e1.wrap || !(this.wrap > e1.wrap) && (this.overscaledZ < e1.overscaledZ || !(this.overscaledZ > e1.overscaledZ) && (this.canonical.x < e1.canonical.x || !(this.canonical.x > e1.canonical.x) && this.canonical.y < e1.canonical.y));
            }
            wrapped() {
                return new qu(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(e1) {
                return new qu(this.overscaledZ, e1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Gu(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function Zu(e1, t, i, r, n) {
            const o = 1 << Math.min(i, 22);
            let s = o * (n % o) + r % o;
            return e1 && i < 22 && (s += o * o * ((e1 < 0 ? -2 * e1 - 1 : 2 * e1) % (1 << 2 * (22 - i)))), 16 * (32 * s + i) + (t - i);
        }
        const $u = [
            (e1)=>{
                let t = e1.canonical.x - 1, i = e1.wrap;
                return t < 0 && (t = (1 << e1.canonical.z) - 1, i--), new qu(e1.overscaledZ, i, e1.canonical.z, t, e1.canonical.y);
            },
            (e1)=>{
                let t = e1.canonical.x + 1, i = e1.wrap;
                return t === 1 << e1.canonical.z && (t = 0, i++), new qu(e1.overscaledZ, i, e1.canonical.z, t, e1.canonical.y);
            },
            (e1)=>new qu(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, (0 === e1.canonical.y ? 1 << e1.canonical.z : e1.canonical.y) - 1),
            (e1)=>new qu(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y === (1 << e1.canonical.z) - 1 ? 0 : e1.canonical.y + 1)
        ];
        Rs(ju, "CanonicalTileID"), Rs(qu, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        class Wu {
            constructor(e1, t){
                this.pos = e1, this.dir = t;
            }
            intersectsPlane(e1, t, i) {
                const r = Du.dot(t, this.dir);
                if (Math.abs(r) < 1e-6) return !1;
                const n = ((e1[0] - this.pos[0]) * t[0] + (e1[1] - this.pos[1]) * t[1] + (e1[2] - this.pos[2]) * t[2]) / r;
                return i[0] = this.pos[0] + this.dir[0] * n, i[1] = this.pos[1] + this.dir[1] * n, i[2] = this.pos[2] + this.dir[2] * n, !0;
            }
            closestPointOnSphere(e1, t, i) {
                if (Du.equals(this.pos, e1) || 0 === t) return i[0] = i[1] = i[2] = 0, !1;
                const [r, n, o] = this.dir, s = this.pos[0] - e1[0], a = this.pos[1] - e1[1], l = this.pos[2] - e1[2], c = r * r + n * n + o * o, h = 2 * (s * r + a * n + l * o), u = h * h - 4 * c * (s * s + a * a + l * l - t * t);
                if (u < 0) {
                    const e1 = Math.max(-h / 2, 0), c = s + r * e1, u = a + n * e1, d = l + o * e1, p = Math.hypot(c, u, d);
                    return i[0] = c * t / p, i[1] = u * t / p, i[2] = d * t / p, !1;
                }
                {
                    const e1 = (-h - Math.sqrt(u)) / (2 * c);
                    if (e1 < 0) {
                        const e1 = Math.hypot(s, a, l);
                        return i[0] = s * t / e1, i[1] = a * t / e1, i[2] = l * t / e1, !1;
                    }
                    return i[0] = s + r * e1, i[1] = a + n * e1, i[2] = l + o * e1, !0;
                }
            }
        }
        class Hu {
            constructor(e1, t, i, r, n){
                this.TL = e1, this.TR = t, this.BR = i, this.BL = r, this.horizon = n;
            }
            static fromInvProjectionMatrix(e1, t, i) {
                const r = [
                    -1,
                    1,
                    1
                ], n = [
                    1,
                    1,
                    1
                ], o = [
                    1,
                    -1,
                    1
                ], s = [
                    -1,
                    -1,
                    1
                ], a = Du.transformMat4(r, r, e1), l = Du.transformMat4(n, n, e1), c = Du.transformMat4(o, o, e1), h = Du.transformMat4(s, s, e1);
                return new Hu(a, l, c, h, t / i);
            }
        }
        function Xu(e1, t, i) {
            let r = 1 / 0, n = -1 / 0;
            const o = [];
            for (const s of e1){
                Du.sub(o, s, t);
                const e1 = Du.dot(o, i);
                r = Math.min(r, e1), n = Math.max(n, e1);
            }
            return [
                r,
                n
            ];
        }
        function Yu(e1, t) {
            let i = !0;
            for(let r = 0; r < e1.planes.length; r++){
                const n = e1.planes[r];
                let o = 0;
                for(let e1 = 0; e1 < t.length; e1++)o += Du.dot(n, t[e1]) + n[3] >= 0;
                if (0 === o) return 0;
                o !== t.length && (i = !1);
            }
            return i ? 2 : 1;
        }
        function Ku(e1, t) {
            for (const i of e1.projections){
                const r = Xu(t, e1.points[0], i.axis);
                if (i.projection[1] < r[0] || i.projection[0] > r[1]) return 0;
            }
            return 1;
        }
        function Ju(e1, t) {
            let i = 0;
            const r = [
                0,
                0,
                0,
                0
            ];
            for(let n = 0; n < e1.length; n++)r[0] = e1[n][0], r[1] = e1[n][1], r[2] = e1[n][2], r[3] = 1, yu.dot(r, t) >= 0 && i++;
            return i;
        }
        class Qu {
            constructor(e1, t){
                this.points = e1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = t || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = ed.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    Du.sub([], this.points[2], this.points[3]),
                    Du.sub([], this.points[0], this.points[3]),
                    Du.sub([], this.points[4], this.points[0]),
                    Du.sub([], this.points[5], this.points[1]),
                    Du.sub([], this.points[6], this.points[2]),
                    Du.sub([], this.points[7], this.points[3])
                ];
                for (const e1 of this.frustumEdges){
                    const t = [
                        0,
                        -e1[2],
                        e1[1]
                    ], i = [
                        e1[2],
                        0,
                        -e1[0]
                    ];
                    this.projections.push({
                        axis: t,
                        projection: Xu(this.points, this.points[0], t)
                    }), this.projections.push({
                        axis: i,
                        projection: Xu(this.points, this.points[0], i)
                    });
                }
            }
            static fromInvProjectionMatrix(e1, t, i, r) {
                const n = Math.pow(2, i), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((i)=>{
                    const o = yu.transformMat4([], i, e1), s = 1 / o[3] / t * n;
                    return yu.mul(o, o, [
                        s,
                        s,
                        r ? 1 / o[3] : s,
                        s
                    ]);
                }), s = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e1)=>{
                    const t = Du.sub([], o[e1[0]], o[e1[1]]), i = Du.sub([], o[e1[2]], o[e1[1]]), r = Du.normalize([], Du.cross([], t, i)), n = -Du.dot(r, o[e1[1]]);
                    return r.concat(n);
                }), a = [];
                for(let e1 = 0; e1 < o.length; e1++)a.push([
                    o[e1][0],
                    o[e1][1],
                    o[e1][2]
                ]);
                return new Qu(a, s);
            }
            intersectsPrecise(e1, t, i) {
                for(let i = 0; i < t.length; i++)if (!Ju(e1, t[i])) return 0;
                for(let t = 0; t < this.planes.length; t++)if (!Ju(e1, this.planes[t])) return 0;
                for (const t of i)for (const i of this.frustumEdges){
                    const r = Du.cross([], t, i), n = Du.length(r);
                    if (0 === n) continue;
                    Du.scale(r, r, 1 / n);
                    const o = Xu(this.points, this.points[0], r), s = Xu(e1, this.points[0], r);
                    if (o[0] > s[1] || s[0] > o[1]) return 0;
                }
                return 1;
            }
        }
        class ed {
            static fromPoints(e1) {
                const t = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], i = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const r of e1)Du.min(t, t, r), Du.max(i, i, r);
                return new ed(t, i);
            }
            static fromTileIdAndHeight(e1, t, i) {
                const r = 1 << e1.canonical.z, n = e1.canonical.x, o = e1.canonical.y;
                return new ed([
                    n / r,
                    o / r,
                    t
                ], [
                    (n + 1) / r,
                    (o + 1) / r,
                    i
                ]);
            }
            static applyTransform(e1, t) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)Du.transformMat4(i[e1], i[e1], t);
                return ed.fromPoints(i);
            }
            static projectAabbCorners(e1, t) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)Du.transformMat4(i[e1], i[e1], t);
                return i;
            }
            constructor(e1, t){
                this.min = e1, this.max = t, this.center = Du.scale([], Du.add([], this.min, this.max), .5);
            }
            quadrant(e1) {
                const t = [
                    e1 % 2 == 0,
                    e1 < 2
                ], i = Du.clone(this.min), r = Du.clone(this.max);
                for(let e1 = 0; e1 < t.length; e1++)i[e1] = t[e1] ? this.min[e1] : this.center[e1], r[e1] = t[e1] ? this.center[e1] : this.max[e1];
                return r[2] = this.max[2], new ed(i, r);
            }
            distanceX(e1) {
                return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
            }
            distanceY(e1) {
                return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
            }
            distanceZ(e1) {
                return Math.max(Math.min(this.max[2], e1[2]), this.min[2]) - e1[2];
            }
            getCorners() {
                const e1 = this.min, t = this.max;
                return [
                    [
                        e1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t[0],
                        t[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        t[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        t[2]
                    ],
                    [
                        t[0],
                        e1[1],
                        t[2]
                    ],
                    [
                        t[0],
                        t[1],
                        t[2]
                    ],
                    [
                        e1[0],
                        t[1],
                        t[2]
                    ]
                ];
            }
            intersects(e1) {
                return this.intersectsAabb(e1.bounds) ? Yu(e1, this.getCorners()) : 0;
            }
            intersectsFlat(e1) {
                return this.intersectsAabb(e1.bounds) ? Yu(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(e1, t) {
                return t || this.intersects(e1) ? Ku(e1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(e1, t) {
                return t || this.intersectsFlat(e1) ? Ku(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(e1) {
                for(let t = 0; t < 3; ++t)if (this.min[t] > e1.max[t] || e1.min[t] > this.max[t]) return !1;
                return !0;
            }
            intersectsAabbXY(e1) {
                return !(this.min[0] > e1.max[0] || e1.min[0] > this.max[0] || this.min[1] > e1.max[1] || e1.min[1] > this.max[1]);
            }
            encapsulate(e1) {
                for(let t = 0; t < 3; t++)this.min[t] = Math.min(this.min[t], e1.min[t]), this.max[t] = Math.max(this.max[t], e1.max[t]);
            }
            encapsulatePoint(e1) {
                for(let t = 0; t < 3; t++)this.min[t] = Math.min(this.min[t], e1[t]), this.max[t] = Math.max(this.max[t], e1[t]);
            }
            closestPoint(e1) {
                return [
                    Math.max(Math.min(this.max[0], e1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], e1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], e1[2]), this.min[2])
                ];
            }
        }
        Rs(ed, "Aabb");
        const td = 5, id = 6, rd = cr / Math.PI / 2, nd = 16383, od = 64, sd = [
            od,
            32,
            16
        ], ad = -rd, ld = rd, cd = [
            new ed([
                ad,
                ad,
                ad
            ], [
                ld,
                ld,
                ld
            ]),
            new ed([
                ad,
                ad,
                ad
            ], [
                0,
                0,
                ld
            ]),
            new ed([
                0,
                ad,
                ad
            ], [
                ld,
                0,
                ld
            ]),
            new ed([
                ad,
                0,
                ad
            ], [
                0,
                ld,
                ld
            ]),
            new ed([
                0,
                0,
                ad
            ], [
                ld,
                ld,
                ld
            ])
        ];
        function hd(e1) {
            return e1 * rd / qd;
        }
        function ud(e1, t, i, r = !0) {
            const n = Du.scale([], e1._camera.position, e1.worldSize), o = [
                t,
                i,
                1,
                1
            ];
            yu.transformMat4(o, o, e1.pixelMatrixInverse), yu.scale(o, o, 1 / o[3]);
            const s = Du.sub([], o, n), a = Du.normalize([], s), l = e1.globeMatrix, c = [
                l[12],
                l[13],
                l[14]
            ], h = Du.sub([], c, n), u = Du.length(h), d = Du.normalize([], h), p = e1.worldSize / (2 * Math.PI), f = Du.dot(d, a), m = Math.asin(p / u);
            if (m < Math.acos(f)) {
                if (!r) return null;
                const e1 = [], t = [];
                Du.scale(e1, a, u / f), Du.normalize(t, Du.sub(t, e1, h)), Du.normalize(a, Du.add(a, h, Du.scale(a, t, Math.tan(m) * u)));
            }
            const _ = [];
            new Wu(n, a).closestPointOnSphere(c, p, _);
            const g = Du.normalize([], ne(l, 0)), y = Du.normalize([], ne(l, 1)), x = Du.normalize([], ne(l, 2)), v = Du.dot(g, _), b = Du.dot(y, _), w = Du.dot(x, _), E = T(Math.asin(-b / p));
            let M = T(Math.atan2(v, w));
            M = e1.center.lng + function(e1, t) {
                const i = (t - e1 + 180) % 360 - 180;
                return i < -180 ? i + 360 : i;
            }(e1.center.lng, M);
            const A = Kd(M), S = z(Jd(E), 0, 1);
            return new lp(A, S);
        }
        class dd {
            constructor(e1, t, i){
                this.a = Du.sub([], e1, i), this.b = Du.sub([], t, i), this.center = i;
                const r = Du.normalize([], this.a), n = Du.normalize([], this.b);
                this.angle = Math.acos(Du.dot(r, n));
            }
        }
        function pd(e1, t) {
            if (0 === e1.angle) return null;
            let i;
            return i = 0 === e1.a[t] ? 1 / e1.angle * .5 * Math.PI : 1 / e1.angle * Math.atan(e1.b[t] / e1.a[t] / Math.sin(e1.angle) - 1 / Math.tan(e1.angle)), i < 0 || i > 1 ? null : function(e1, t, i, r) {
                const n = Math.sin(i);
                return e1 * (Math.sin((1 - r) * i) / n) + t * (Math.sin(r * i) / n);
            }(e1.a[t], e1.b[t], e1.angle, z(i, 0, 1)) + e1.center[t];
        }
        function fd(e1) {
            if (e1.z <= 1) return cd[e1.z + 2 * e1.y + e1.x];
            const t = vd(xd(e1));
            return ed.fromPoints(t);
        }
        function md(e1, t, i) {
            return Du.scale(e1, e1, 1 - i), Du.scaleAndAdd(e1, e1, t, i);
        }
        function _d(e1, t) {
            const i = Dd(t.zoom);
            if (0 === i) return fd(e1);
            const r = xd(e1), n = vd(r), o = Kd(r.getWest()) * t.worldSize, s = Kd(r.getEast()) * t.worldSize, a = Jd(r.getNorth()) * t.worldSize, l = Jd(r.getSouth()) * t.worldSize, c = [
                o,
                a,
                0
            ], h = [
                s,
                a,
                0
            ], u = [
                o,
                l,
                0
            ], d = [
                s,
                l,
                0
            ], p = Au.invert([], t.globeMatrix);
            return Du.transformMat4(c, c, p), Du.transformMat4(h, h, p), Du.transformMat4(u, u, p), Du.transformMat4(d, d, p), n[0] = md(n[0], u, i), n[1] = md(n[1], d, i), n[2] = md(n[2], h, i), n[3] = md(n[3], c, i), ed.fromPoints(n);
        }
        function gd(e1, t, i) {
            for (const r of e1)Du.transformMat4(r, r, t), Du.scale(r, r, i);
        }
        function yd(e1, t, i, r) {
            const n = t / e1.worldSize, o = e1.globeMatrix;
            if (i.z <= 1) {
                const e1 = fd(i).getCorners();
                return gd(e1, o, n), ed.fromPoints(e1);
            }
            const s = xd(i, r), a = vd(s);
            gd(a, o, n);
            const l = Number.MAX_VALUE, c = [
                -l,
                -l,
                -l
            ], h = [
                l,
                l,
                l
            ];
            if (s.contains(e1.center)) {
                for (const e1 of a)Du.min(h, h, e1), Du.max(c, c, e1);
                c[2] = 0;
                const t = e1.point, i = [
                    t.x * n,
                    t.y * n,
                    0
                ];
                return Du.min(h, h, i), Du.max(c, c, i), new ed(h, c);
            }
            const u = [
                o[12] * n,
                o[13] * n,
                o[14] * n
            ], d = s.getCenter(), p = z(e1.center.lat, -rp, rp), f = z(d.lat, -rp, rp), m = Kd(e1.center.lng), _ = Jd(p);
            let g = m - Kd(d.lng);
            const y = _ - Jd(f);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let x = 0;
            if (Math.abs(g) > Math.abs(y)) x = g >= 0 ? 1 : 3;
            else {
                x = y >= 0 ? 0 : 2;
                const e1 = [
                    o[4] * n,
                    o[5] * n,
                    o[6] * n
                ], t = -Math.sin(w(y >= 0 ? s.getSouth() : s.getNorth())) * rd;
                Du.scaleAndAdd(u, u, e1, t);
            }
            const v = a[x], b = a[(x + 1) % 4], T = new dd(v, b, u), E = [
                pd(T, 0) || v[0],
                pd(T, 1) || v[1],
                pd(T, 2) || v[2]
            ], M = Dd(e1.zoom);
            if (M > 0) {
                const r = function({ x: e1, y: t, z: i }, r, n, o, s) {
                    const a = 1 / (1 << i);
                    let l = e1 * a, c = l + a, h = t * a, u = h + a, d = 0;
                    const p = (l + c) / 2 - o;
                    return p > .5 ? d = -1 : p < -0.5 && (d = 1), l = ((l + d) * r - (o *= r)) * n + o, c = ((c + d) * r - o) * n + o, h = (h * r - (s *= r)) * n + s, u = (u * r - s) * n + s, [
                        [
                            l,
                            u,
                            0
                        ],
                        [
                            c,
                            u,
                            0
                        ],
                        [
                            c,
                            h,
                            0
                        ],
                        [
                            l,
                            h,
                            0
                        ]
                    ];
                }(i, t, e1._pixelsPerMercatorPixel, m, _);
                for(let e1 = 0; e1 < a.length; e1++)md(a[e1], r[e1], M);
                const n = Du.add([], r[x], r[(x + 1) % 4]);
                Du.scale(n, n, .5), md(E, n, M);
            }
            for (const e1 of a)Du.min(h, h, e1), Du.max(c, c, e1);
            return h[2] = Math.min(v[2], b[2]), Du.min(h, h, E), Du.max(c, c, E), new ed(h, c);
        }
        function xd({ x: e1, y: t, z: i }, r = !1) {
            const n = 1 / (1 << i), o = new Wd(ep(e1 * n), t === (1 << i) - 1 && r ? -90 : tp((t + 1) * n)), s = new Wd(ep((e1 + 1) * n), 0 === t && r ? 90 : tp(t * n));
            return new sc(o, s);
        }
        function vd(e1) {
            const t = w(e1.getNorth()), i = w(e1.getSouth()), r = Math.cos(t), n = Math.cos(i), o = Math.sin(t), s = Math.sin(i), a = e1.getWest(), l = e1.getEast();
            return [
                bd(n, s, a),
                bd(n, s, l),
                bd(r, o, l),
                bd(r, o, a)
            ];
        }
        function bd(e1, t, i, r = rd) {
            return i = w(i), [
                e1 * Math.sin(i) * r,
                -t * r,
                e1 * Math.cos(i) * r
            ];
        }
        function wd(e1, t, i) {
            return bd(Math.cos(w(e1)), Math.sin(w(e1)), t, i);
        }
        function Td(e1, t, i, r) {
            const n = 1 << i.z, o = (e1 / cr + i.x) / n;
            return wd(tp((t / cr + i.y) / n), ep(o), r);
        }
        function Ed({ min: e1, max: t }) {
            return nd / Math.max(t[0] - e1[0], t[1] - e1[1], t[2] - e1[2]);
        }
        const Md = new Float64Array(16);
        function Ad(e1) {
            const t = Ed(e1), i = Au.fromScaling(Md, [
                t,
                t,
                t
            ]);
            return Au.translate(i, i, Du.negate([], e1.min));
        }
        function Sd(e1) {
            const t = Au.fromTranslation(Md, e1.min), i = 1 / Ed(e1);
            return Au.scale(t, t, [
                i,
                i,
                i
            ]);
        }
        function Id(e1) {
            const t = cr / (2 * Math.PI);
            return e1 / (2 * Math.PI) / t;
        }
        function Cd(e1, t) {
            return cr / (512 * Math.pow(2, e1)) * Ed(fd(t));
        }
        function zd(e1, t, i, r, n) {
            const o = Id(i), s = [
                e1,
                t,
                -i / (2 * Math.PI)
            ], a = Au.identity(new Float64Array(16));
            return Au.translate(a, a, s), Au.scale(a, a, [
                o,
                o,
                o
            ]), Au.rotateX(a, a, w(-n)), Au.rotateY(a, a, w(-r)), a;
        }
        function Pd(e1) {
            const t = e1.pixelsPerMeter, i = t / Qd(1, e1.center.lat), r = Au.identity(new Float64Array(16));
            return Au.translate(r, r, [
                e1.point.x,
                e1.point.y,
                0
            ]), Au.scale(r, r, [
                i,
                i,
                t
            ]), Float32Array.from(r);
        }
        function Dd(e1) {
            return P(td, id, e1);
        }
        function Rd(e1, t, i) {
            const r = Au.identity(new Float64Array(16)), n = (t / (1 << e1) - .5) * Math.PI * 2;
            return Au.rotateY(r, i.globeMatrix, n), Float32Array.from(r);
        }
        function Ld(e1, t, i) {
            const r = Dd(i.zoom), n = e1.style.map._antialias, o = t.options.extStandardDerivativesForceOff || e1.terrain && e1.terrain.exaggeration() > 0;
            return 0 === r && !n && !o;
        }
        function kd(e1, t, i, r) {
            const n = t.getNorth(), o = t.getSouth(), s = t.getWest(), a = t.getEast(), l = 1 << e1.z, c = a - s, h = n - o, u = c / od, d = -h / sd[i], p = [
                0,
                u,
                0,
                d,
                0,
                0,
                n,
                s,
                0
            ];
            if (e1.z > 0) {
                const e1 = 180 / r;
                Eu.multiply(p, p, [
                    e1 / c + 1,
                    0,
                    0,
                    0,
                    e1 / h + 1,
                    0,
                    -0.5 * e1 / u,
                    .5 * e1 / d,
                    1
                ]);
            }
            return p[2] = l, p[5] = e1.x, p[8] = e1.y, p;
        }
        function Od(e1) {
            const t = rp - 5;
            e1 = z(e1, -t, t) / t * 90;
            const i = Math.pow(Math.abs(Math.sin(w(e1))), 3);
            return Math.round(i * (sd.length - 1));
        }
        function Bd(e1) {
            const t = [
                0,
                0,
                0
            ], i = Au.identity(new Float64Array(16));
            return Au.multiply(i, e1.pixelMatrix, e1.globeMatrix), Du.transformMat4(t, t, i), new y(t[0], t[1]);
        }
        function Fd(e1, t) {
            const i = wd(t.lat, t.lng), r = function(e1) {
                const t = wd(e1._center.lat, e1._center.lng), i = Du.fromValues(0, 1, 0);
                let r = Du.cross([], i, t);
                const n = Au.fromRotation([], -e1.angle, t);
                r = Du.transformMat4(r, r, n), Au.fromRotation(n, -e1._pitch, r);
                const o = Du.normalize([], t);
                return Du.scale(o, o, hd(e1.cameraToCenterDistance / e1.pixelsPerMeter)), Du.transformMat4(o, o, n), Du.add([], t, o);
            }(e1), n = Du.subtract([], r, i);
            return Du.angle(n, i);
        }
        function Nd(e1, t) {
            return Fd(e1, t) > Math.PI / 2 * 1.01;
        }
        const Ud = w(85), Vd = Math.cos(Ud), jd = Math.sin(Ud);
        class Gd {
            constructor(e1){
                this._createGrid(e1), this._createPoles(e1);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const e1 of this._poleSegments)e1.destroy();
                for (const e1 of this._gridSegments)e1.withSkirts.destroy(), e1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(e1, t) {
                const i = new za, r = new Wa, n = [], o = e1 + 1 + 2, s = t[0] + 1, a = t[0] + 1 + (1 + t.length), l = (e1, t, i)=>{
                    let r = e1 === o - 1 ? e1 - 2 : 0 === e1 ? e1 : e1 - 1;
                    return r += i ? 24575 : 0, [
                        r,
                        t
                    ];
                };
                for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, 0, !0));
                for(let e1 = 0; e1 < s; ++e1)for(let t = 0; t < o; ++t)i.emplaceBack(...l(t, e1, (0 === t || t === o - 1) && !0));
                for(let e1 = 0; e1 < t.length; ++e1){
                    const r = t[e1];
                    for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, r, !0));
                }
                for(let e1 = 0; e1 < t.length; ++e1){
                    const s = r.length, l = t[e1] + 1 + 2, c = new Wa;
                    for(let i = 0; i < l - 1; i++){
                        const n = i === l - 2, s = n ? o * (a - t.length + e1 - i) : o;
                        for(let e1 = 0; e1 < o - 1; e1++){
                            const t = i * o + e1;
                            0 === i || n || 0 === e1 || e1 === o - 2 ? (c.emplaceBack(t + 1, t, t + s), c.emplaceBack(t + s, t + s + 1, t + 1)) : (r.emplaceBack(t + 1, t, t + s), r.emplaceBack(t + s, t + s + 1, t + 1));
                        }
                    }
                    const h = xl.simpleSegment(0, s, i.length, r.length - s);
                    for(let e1 = 0; e1 < c.uint16.length; e1 += 3)r.emplaceBack(c.uint16[e1], c.uint16[e1 + 1], c.uint16[e1 + 2]);
                    const u = xl.simpleSegment(0, s, i.length, r.length - s);
                    n.push({
                        withoutSkirts: h,
                        withSkirts: u
                    });
                }
                return {
                    vertices: i,
                    indices: r,
                    segments: n
                };
            }
            _createGrid(e1) {
                const t = this._fillGridMeshWithLods(od, sd);
                this._gridSegments = t.segments, this._gridBuffer = e1.createVertexBuffer(t.vertices, Nu.members), this._gridIndexBuffer = e1.createIndexBuffer(t.indices, !0);
            }
            _createPoles(e1) {
                const t = new Wa;
                for(let e1 = 0; e1 <= od; e1++)t.emplaceBack(0, e1 + 1, e1 + 2);
                this._poleIndexBuffer = e1.createIndexBuffer(t, !0);
                const i = new Ka, r = new Ka, n = new Ka, o = new Ka;
                this._poleSegments = [];
                for(let e1 = 0, t = 0; e1 < td; e1++){
                    const s = 360 / (1 << e1);
                    i.emplaceBack(0, -rd, 0, .5, 0), r.emplaceBack(0, -rd, 0, .5, 1), n.emplaceBack(0, -rd, 0, .5, .5), o.emplaceBack(0, -rd, 0, .5, .5);
                    for(let e1 = 0; e1 <= od; e1++){
                        let t = e1 / od, a = 0;
                        const l = Kr(0, s, t), [c, h, u] = bd(Vd, jd, l, rd);
                        i.emplaceBack(c, h, u, t, a), r.emplaceBack(c, h, u, t, 1 - a);
                        const d = w(l);
                        t = .5 + .5 * Math.sin(d), a = .5 + .5 * Math.cos(d), n.emplaceBack(c, h, u, t, a), o.emplaceBack(c, h, u, t, 1 - a);
                    }
                    this._poleSegments.push(xl.simpleSegment(t, 0, 66, 64)), t += 66;
                }
                this._poleNorthVertexBuffer = e1.createVertexBuffer(i, Bu, !1), this._poleSouthVertexBuffer = e1.createVertexBuffer(r, Bu, !1), this._texturedPoleNorthVertexBuffer = e1.createVertexBuffer(n, Bu, !1), this._texturedPoleSouthVertexBuffer = e1.createVertexBuffer(o, Bu, !1);
            }
            getGridBuffers(e1, t) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    t ? this._gridSegments[e1].withSkirts : this._gridSegments[e1].withoutSkirts
                ];
            }
            getPoleBuffers(e1, t) {
                return [
                    t ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    t ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[e1]
                ];
            }
        }
        const qd = 6371008.8, Zd = 2 * Math.PI * qd;
        class $d {
            constructor(e1, t){
                if (isNaN(e1) || isNaN(t)) throw new Error(`Invalid LngLat object: (${e1}, ${t})`);
                if (this.lng = +e1, this.lat = +t, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new $d(D(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(e1) {
                const t = Math.PI / 180, i = this.lat * t, r = e1.lat * t, n = Math.sin(i) * Math.sin(r) + Math.cos(i) * Math.cos(r) * Math.cos((e1.lng - this.lng) * t);
                return qd * Math.acos(Math.min(n, 1));
            }
            toBounds(e1 = 0) {
                const t = 360 * e1 / 40075017, i = t / Math.cos(Math.PI / 180 * this.lat);
                return new sc(new $d(this.lng - i, this.lat - t), new $d(this.lng + i, this.lat + t));
            }
            toEcef(e1) {
                const t = hd(e1);
                return wd(this.lat, this.lng, rd + t);
            }
            static convert(e1) {
                if (e1 instanceof $d) return e1;
                if (Array.isArray(e1) && (2 === e1.length || 3 === e1.length)) return new $d(Number(e1[0]), Number(e1[1]));
                if (!Array.isArray(e1) && "object" == typeof e1 && null !== e1) return new $d(Number("lng" in e1 ? e1.lng : e1.lon), Number(e1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        var Wd = $d;
        const Hd = 0, Xd = 25.5;
        function Yd(e1) {
            return Zd * Math.cos(e1 * Math.PI / 180);
        }
        function Kd(e1) {
            return (180 + e1) / 360;
        }
        function Jd(e1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
        }
        function Qd(e1, t) {
            return e1 / Yd(t);
        }
        function ep(e1) {
            return 360 * e1 - 180;
        }
        function tp(e1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
        }
        function ip(e1, t) {
            return e1 * Yd(tp(t));
        }
        const rp = 85.051129;
        function np(e1) {
            return Math.cos(w(z(e1, -rp, rp)));
        }
        function op(e1, t) {
            const i = z(t, Hd, Xd), r = Math.pow(2, i);
            return np(e1) * Zd / (512 * r);
        }
        function sp(e1) {
            return 1 / Math.cos(e1 * Math.PI / 180);
        }
        function ap(e1, t = 0) {
            const i = Math.exp(Math.PI * (1 - (e1.y + t / cr) / (1 << e1.z) * 2));
            return 80150034 * i / (i * i + 1) / cr / (1 << e1.z);
        }
        class lp {
            constructor(e1, t, i = 0){
                this.x = +e1, this.y = +t, this.z = +i;
            }
            static fromLngLat(e1, t = 0) {
                const i = Wd.convert(e1);
                return new lp(Kd(i.lng), Jd(i.lat), Qd(t, i.lat));
            }
            toLngLat() {
                return new Wd(ep(this.x), tp(this.y));
            }
            toAltitude() {
                return ip(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / Zd * sp(tp(this.y));
            }
        }
        function cp(e1, t, i, r, n, o, s, a, l) {
            const c = (t + r) / 2, h = (i + n) / 2, u = new y(c, h);
            a(u), function(e1, t, i, r, n, o) {
                const s = i - n, a = r - o;
                return Math.abs((r - t) * s - (i - e1) * a) / Math.hypot(s, a);
            }(u.x, u.y, o.x, o.y, s.x, s.y) >= l ? (cp(e1, t, i, c, h, o, u, a, l), cp(e1, c, h, r, n, u, s, a, l)) : e1.push(s);
        }
        function hp(e1, t, i) {
            let r = e1[0], n = r.x, o = r.y;
            t(r);
            const s = [
                r
            ];
            for(let a = 1; a < e1.length; a++){
                const l = e1[a], { x: c, y: h } = l;
                t(l), cp(s, n, o, c, h, r, l, t, i), n = c, o = h, r = l;
            }
            return s;
        }
        function up(e1, t, i, r) {
            if (r(t, i)) {
                const n = t.add(i)._mult(.5);
                up(e1, t, n, r), up(e1, n, i, r);
            } else e1.push(i);
        }
        function dp(e1, t) {
            let i = e1[0];
            const r = [
                i
            ];
            for(let n = 1; n < e1.length; n++){
                const o = e1[n];
                up(r, i, o, t), i = o;
            }
            return r;
        }
        const pp = Math.pow(2, 14) - 1, fp = -pp - 1;
        function mp(e1, t) {
            const i = Math.round(e1.x * t), r = Math.round(e1.y * t);
            return e1.x = z(i, fp, pp), e1.y = z(r, fp, pp), (i < e1.x || i > e1.x + 1 || r < e1.y || r > e1.y + 1) && H("Geometry exceeds allowed extent, reduce your vector tile buffer size"), e1;
        }
        function _p(e1, t, i) {
            const r = e1.loadGeometry(), n = e1.extent, o = cr / n;
            if (t && i && i.projection.isReprojectedInTileSpace) {
                const o = 1 << t.z, { scale: s, x: a, y: l, projection: c } = i, h = (e1)=>{
                    const i = ep((t.x + e1.x / n) / o), r = tp((t.y + e1.y / n) / o), h = c.project(i, r);
                    e1.x = (h.x * s - a) * n, e1.y = (h.y * s - l) * n;
                };
                for(let t = 0; t < r.length; t++)if (1 !== e1.type) r[t] = hp(r[t], h, 1);
                else {
                    const e1 = [];
                    for (const i of r[t])i.x < 0 || i.x >= n || i.y < 0 || i.y >= n || (h(i), e1.push(i));
                    r[t] = e1;
                }
            }
            for (const e1 of r)for (const t of e1)mp(t, o);
            return r;
        }
        function gp(e1, t) {
            return {
                type: e1.type,
                id: e1.id,
                properties: e1.properties,
                geometry: t ? _p(e1) : []
            };
        }
        function yp(e1, t, i, r, n) {
            e1.emplaceBack(2 * t + (r + 1) / 2, 2 * i + (n + 1) / 2);
        }
        function xp(e1, t, i) {
            const r = 16384;
            e1.emplaceBack(t.x, t.y, t.z, i[0] * r, i[1] * r, i[2] * r);
        }
        class vp {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.projection = e1.projection, this.layoutVertexArray = new za, this.indexArray = new Wa, this.segments = new xl, this.programConfigurations = new ec(e1.layers, e1.zoom), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
            populate(e1, t, i, r) {
                const n = this.layers[0], o = [];
                let s = null;
                "circle" === n.type && (s = n.layout.get("circle-sort-key"));
                for (const { feature: t, id: n, index: a, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = gp(t, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), c, i)) continue;
                    const h = s ? s.evaluate(c, {}, i) : void 0, u = {
                        id: n,
                        properties: t.properties,
                        type: t.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: e1 ? c.geometry : _p(t, i, r),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(u);
                }
                s && o.sort((e1, t)=>e1.sortKey - t.sortKey);
                let a = null;
                "globe" === r.projection.name && (this.globeExtVertexArray = new Fa, a = r.projection);
                for (const r of o){
                    const { geometry: n, index: o, sourceLayerIndex: s } = r, l = e1[o].feature;
                    this.addFeature(r, n, o, t.availableImages, i, a, t.brightness), t.featureIndex.insert(l, n, o, s, this.index);
                }
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                o && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(e1, t, o ? this.stateDependentLayers : this.layers, i, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, gl.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, yl.members))), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
            addFeature(e1, t, i, r, n, o, s) {
                for (const i of t)for (const t of i){
                    const i = t.x, r = t.y;
                    if (i < 0 || i >= cr || r < 0 || r >= cr) continue;
                    if (o) {
                        const e1 = o.projectTilePoint(i, r, n), t = o.upVector(n, i, r), s = this.globeExtVertexArray;
                        xp(s, e1, t), xp(s, e1, t), xp(s, e1, t), xp(s, e1, t);
                    }
                    const s = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, e1.sortKey), a = s.vertexLength;
                    yp(this.layoutVertexArray, i, r, -1, -1), yp(this.layoutVertexArray, i, r, 1, -1), yp(this.layoutVertexArray, i, r, 1, 1), yp(this.layoutVertexArray, i, r, -1, 1), this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 2, a + 3), s.vertexLength += 4, s.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {}, r, n, s);
            }
        }
        function bp(e1, t) {
            for(let i = 0; i < e1.length; i++)if (zp(t, e1[i])) return !0;
            for(let i = 0; i < t.length; i++)if (zp(e1, t[i])) return !0;
            return !!Mp(e1, t);
        }
        function wp(e1, t, i) {
            return !!zp(e1, t) || !!Sp(t, e1, i);
        }
        function Tp(e1, t) {
            if (1 === e1.length) return Cp(t, e1[0]);
            for(let i = 0; i < t.length; i++){
                const r = t[i];
                for(let t = 0; t < r.length; t++)if (zp(e1, r[t])) return !0;
            }
            for(let i = 0; i < e1.length; i++)if (Cp(t, e1[i])) return !0;
            for(let i = 0; i < t.length; i++)if (Mp(e1, t[i])) return !0;
            return !1;
        }
        function Ep(e1, t, i) {
            if (e1.length > 1) {
                if (Mp(e1, t)) return !0;
                for(let r = 0; r < t.length; r++)if (Sp(t[r], e1, i)) return !0;
            }
            for(let r = 0; r < e1.length; r++)if (Sp(e1[r], t, i)) return !0;
            return !1;
        }
        function Mp(e1, t) {
            if (0 === e1.length || 0 === t.length) return !1;
            for(let i = 0; i < e1.length - 1; i++){
                const r = e1[i], n = e1[i + 1];
                for(let e1 = 0; e1 < t.length - 1; e1++)if (Ap(r, n, t[e1], t[e1 + 1])) return !0;
            }
            return !1;
        }
        function Ap(e1, t, i, r) {
            return X(e1, i, r) !== X(t, i, r) && X(e1, t, i) !== X(e1, t, r);
        }
        function Sp(e1, t, i) {
            const r = i * i;
            if (1 === t.length) return e1.distSqr(t[0]) < r;
            for(let i = 1; i < t.length; i++)if (Ip(e1, t[i - 1], t[i]) < r) return !0;
            return !1;
        }
        function Ip(e1, t, i) {
            const r = t.distSqr(i);
            if (0 === r) return e1.distSqr(t);
            const n = ((e1.x - t.x) * (i.x - t.x) + (e1.y - t.y) * (i.y - t.y)) / r;
            return e1.distSqr(n < 0 ? t : n > 1 ? i : i.sub(t)._mult(n)._add(t));
        }
        function Cp(e1, t) {
            let i, r, n, o = !1;
            for(let s = 0; s < e1.length; s++){
                i = e1[s];
                for(let e1 = 0, s = i.length - 1; e1 < i.length; s = e1++)r = i[e1], n = i[s], r.y > t.y != n.y > t.y && t.x < (n.x - r.x) * (t.y - r.y) / (n.y - r.y) + r.x && (o = !o);
            }
            return o;
        }
        function zp(e1, t) {
            let i = !1;
            for(let r = 0, n = e1.length - 1; r < e1.length; n = r++){
                const o = e1[r], s = e1[n];
                o.y > t.y != s.y > t.y && t.x < (s.x - o.x) * (t.y - o.y) / (s.y - o.y) + o.x && (i = !i);
            }
            return i;
        }
        function Pp(e1, t, i, r, n) {
            for (const o of e1)if (t <= o.x && i <= o.y && r >= o.x && n >= o.y) return !0;
            const o = [
                new y(t, i),
                new y(t, n),
                new y(r, n),
                new y(r, i)
            ];
            if (e1.length > 2) {
                for (const t of o)if (zp(e1, t)) return !0;
            }
            for(let t = 0; t < e1.length - 1; t++)if (Dp(e1[t], e1[t + 1], o)) return !0;
            return !1;
        }
        function Dp(e1, t, i) {
            const r = i[0], n = i[2];
            if (e1.x < r.x && t.x < r.x || e1.x > n.x && t.x > n.x || e1.y < r.y && t.y < r.y || e1.y > n.y && t.y > n.y) return !1;
            const o = X(e1, t, i[0]);
            return o !== X(e1, t, i[1]) || o !== X(e1, t, i[2]) || o !== X(e1, t, i[3]);
        }
        function Rp(e1, t, i, r, n, o) {
            let s = t.y - e1.y, a = e1.x - t.x;
            if (o = o || 0) {
                const e1 = s * s + a * a;
                if (0 === e1) return !0;
                const t = Math.sqrt(e1);
                s /= t, a /= t;
            }
            return !((i.x - e1.x) * s + (i.y - e1.y) * a - o < 0 || (r.x - e1.x) * s + (r.y - e1.y) * a - o < 0 || (n.x - e1.x) * s + (n.y - e1.y) * a - o < 0);
        }
        function Lp(e1, t, i, r, n, o, s) {
            return !(Rp(e1, t, r, n, o, s) || Rp(t, i, r, n, o, s) || Rp(i, e1, r, n, o, s) || Rp(r, n, e1, t, i, s) || Rp(n, o, e1, t, i, s) || Rp(o, r, e1, t, i, s));
        }
        function kp(e1, t, i) {
            const r = t.paint.get(e1).value;
            return "constant" === r.kind ? r.value : i.programConfigurations.get(t.id).getMaxValue(e1);
        }
        function Op(e1) {
            return Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]);
        }
        function Bp(e1, t, i, r, n) {
            if (!t[0] && !t[1]) return e1;
            const o = y.convert(t)._mult(n);
            "viewport" === i && o._rotate(-r);
            const s = [];
            for(let t = 0; t < e1.length; t++)s.push(e1[t].sub(o));
            return s;
        }
        function Fp(e1, t, i, r) {
            const n = y.convert(e1)._mult(r);
            return "viewport" === t && n._rotate(-i), n;
        }
        Rs(vp, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        const Np = new ga({
            "circle-sort-key": new ma(Pt.layout_circle["circle-sort-key"]),
            visibility: new fa(Pt.layout_circle.visibility)
        });
        var Up = {
            paint: new ga({
                "circle-radius": new ma(Pt.paint_circle["circle-radius"]),
                "circle-color": new ma(Pt.paint_circle["circle-color"]),
                "circle-blur": new ma(Pt.paint_circle["circle-blur"]),
                "circle-opacity": new ma(Pt.paint_circle["circle-opacity"]),
                "circle-translate": new fa(Pt.paint_circle["circle-translate"]),
                "circle-translate-anchor": new fa(Pt.paint_circle["circle-translate-anchor"]),
                "circle-pitch-scale": new fa(Pt.paint_circle["circle-pitch-scale"]),
                "circle-pitch-alignment": new fa(Pt.paint_circle["circle-pitch-alignment"]),
                "circle-stroke-width": new ma(Pt.paint_circle["circle-stroke-width"]),
                "circle-stroke-color": new ma(Pt.paint_circle["circle-stroke-color"]),
                "circle-stroke-opacity": new ma(Pt.paint_circle["circle-stroke-opacity"]),
                "circle-emissive-strength": new fa(Pt.paint_circle["circle-emissive-strength"])
            }),
            layout: Np
        };
        const Vp = Au.create(), jp = (e1, t, i, r, n, o)=>{
            const s = e1.transform, a = "globe" === s.projection.name;
            let l;
            if ("map" === o.paint.get("circle-pitch-alignment")) {
                if (a) {
                    const e1 = Cd(s.zoom, t.canonical) * s._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        e1,
                        0,
                        0,
                        e1
                    ]);
                } else l = s.calculatePixelsToTileUnitsMatrix(i);
            } else l = new Float32Array([
                s.pixelsToGLUnits[0],
                0,
                0,
                s.pixelsToGLUnits[1]
            ]);
            const c = {
                u_camera_to_center_distance: e1.transform.getCameraToCenterDistance(s.projection),
                u_matrix: e1.translatePosMatrix(t.projMatrix, i, o.paint.get("circle-translate"), o.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: dt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: Vp,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: o.paint.get("circle-emissive-strength")
            };
            if (a) {
                c.u_inv_rot_matrix = r, c.u_merc_center = n, c.u_tile_id = [
                    t.canonical.x,
                    t.canonical.y,
                    1 << t.canonical.z
                ], c.u_zoom_transition = Dd(s.zoom);
                const e1 = n[0] * cr, i = n[1] * cr;
                c.u_up_dir = s.projection.upVector(new ju(0, 0, 0), e1, i);
            }
            return c;
        }, Gp = (e1)=>{
            const t = [];
            return "map" === e1.paint.get("circle-pitch-alignment") && t.push("PITCH_WITH_MAP"), "map" === e1.paint.get("circle-pitch-scale") && t.push("SCALE_WITH_MAP"), t;
        };
        function qp(e1, t, i, r, n, o, s, a, l) {
            if (o && e1.queryGeometry.isAboveHorizon) return !1;
            o && (l *= e1.pixelToTileUnitsFactor);
            const c = e1.tileID.canonical, h = i.projection.upVectorScale(c, i.center.lat, i.worldSize).metersToTile;
            for (const u of t)for (const t of u){
                const u = t.add(a), d = n && i.elevation ? i.elevation.exaggeration() * n.getElevationAt(u.x, u.y, !0) : 0, p = i.projection.projectTilePoint(u.x, u.y, c);
                if (d > 0) {
                    const e1 = i.projection.upVector(c, u.x, u.y);
                    p.x += e1[0] * h * d, p.y += e1[1] * h * d, p.z += e1[2] * h * d;
                }
                const f = o ? u : Zp(p.x, p.y, p.z, r), m = o ? e1.tilespaceRays.map((e1)=>Hp(e1, d)) : e1.queryGeometry.screenGeometry, _ = yu.transformMat4([], [
                    p.x,
                    p.y,
                    p.z,
                    1
                ], r);
                if (!s && o ? l *= _[3] / i.cameraToCenterDistance : s && !o && (l *= i.cameraToCenterDistance / _[3]), o) {
                    const e1 = tp((t.y / cr + c.y) / (1 << c.z));
                    l /= i.projection.pixelsPerMeter(e1, 1) / Qd(1, e1);
                }
                if (wp(m, f, l)) return !0;
            }
            return !1;
        }
        function Zp(e1, t, i, r) {
            const n = yu.transformMat4([], [
                e1,
                t,
                i,
                1
            ], r);
            return new y(n[0] / n[3], n[1] / n[3]);
        }
        const $p = Du.fromValues(0, 0, 0), Wp = Du.fromValues(0, 0, 1);
        function Hp(e1, t) {
            const i = Du.create();
            return $p[2] = t, e1.intersectsPlane($p, Wp, i), new y(i[0], i[1]);
        }
        class Xp extends vp {
        }
        function Yp(e1, { width: t, height: i }, r, n) {
            if (n) {
                if (n instanceof Uint8ClampedArray) n = new Uint8Array(n.buffer);
                else if (n.length !== t * i * r) throw new RangeError("mismatched image size");
            } else n = new Uint8Array(t * i * r);
            return e1.width = t, e1.height = i, e1.data = n, e1;
        }
        function Kp(e1, t, i) {
            const { width: r, height: n } = t;
            r === e1.width && n === e1.height || (Jp(e1, t, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e1.width, r),
                height: Math.min(e1.height, n)
            }, i), e1.width = r, e1.height = n, e1.data = t.data);
        }
        function Jp(e1, t, i, r, n, o) {
            if (0 === n.width || 0 === n.height) return t;
            if (n.width > e1.width || n.height > e1.height || i.x > e1.width - n.width || i.y > e1.height - n.height) throw new RangeError("out of range source coordinates for image copy");
            if (n.width > t.width || n.height > t.height || r.x > t.width - n.width || r.y > t.height - n.height) throw new RangeError("out of range destination coordinates for image copy");
            const s = e1.data, a = t.data;
            for(let l = 0; l < n.height; l++){
                const c = ((i.y + l) * e1.width + i.x) * o, h = ((r.y + l) * t.width + r.x) * o;
                for(let e1 = 0; e1 < n.width * o; e1++)a[h + e1] = s[c + e1];
            }
            return t;
        }
        Rs(Xp, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class Qp {
            constructor(e1, t){
                Yp(this, e1, 1, t);
            }
            resize(e1) {
                Kp(this, new Qp(e1), 1);
            }
            clone() {
                return new Qp({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t, i, r, n) {
                Jp(e1, t, i, r, n, 1);
            }
        }
        class ef {
            constructor(e1, t){
                Yp(this, e1, 4, t);
            }
            resize(e1) {
                Kp(this, new ef(e1), 4);
            }
            replace(e1, t) {
                t ? this.data.set(e1) : this.data = e1 instanceof Uint8ClampedArray ? new Uint8Array(e1.buffer) : e1;
            }
            clone() {
                return new ef({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t, i, r, n) {
                Jp(e1, t, i, r, n, 4);
            }
        }
        class tf {
            constructor(e1, t){
                this.width = e1.width, this.height = e1.height, this.data = t instanceof Uint8Array ? new Float32Array(t.buffer) : t;
            }
        }
        Rs(Qp, "AlphaImage"), Rs(ef, "RGBAImage");
        const rf = new ga({
            visibility: new fa(Pt.layout_heatmap.visibility)
        });
        var nf = {
            paint: new ga({
                "heatmap-radius": new ma(Pt.paint_heatmap["heatmap-radius"]),
                "heatmap-weight": new ma(Pt.paint_heatmap["heatmap-weight"]),
                "heatmap-intensity": new fa(Pt.paint_heatmap["heatmap-intensity"]),
                "heatmap-color": new _a(Pt.paint_heatmap["heatmap-color"]),
                "heatmap-opacity": new fa(Pt.paint_heatmap["heatmap-opacity"])
            }),
            layout: rf
        };
        function of(e1) {
            const t = {}, i = e1.resolution || 256, r = e1.clips ? e1.clips.length : 1, n = e1.image || new ef({
                width: i,
                height: r
            }), o = (i, r, o)=>{
                t[e1.evaluationKey] = o;
                const s = e1.expression.evaluate(t);
                s && (n.data[i + r + 0] = Math.floor(255 * s.r / s.a), n.data[i + r + 1] = Math.floor(255 * s.g / s.a), n.data[i + r + 2] = Math.floor(255 * s.b / s.a), n.data[i + r + 3] = Math.floor(255 * s.a));
            };
            if (e1.clips) for(let t = 0, n = 0; t < r; ++t, n += 4 * i)for(let r = 0, s = 0; r < i; r++, s += 4){
                const a = r / (i - 1), { start: l, end: c } = e1.clips[t];
                o(n, s, l * (1 - a) + c * a);
            }
            else for(let e1 = 0, t = 0; e1 < i; e1++, t += 4)o(0, t, e1 / (i - 1));
            return n;
        }
        const sf = new ga({
            visibility: new fa(Pt.layout_hillshade.visibility)
        });
        var af = {
            paint: new ga({
                "hillshade-illumination-direction": new fa(Pt.paint_hillshade["hillshade-illumination-direction"]),
                "hillshade-illumination-anchor": new fa(Pt.paint_hillshade["hillshade-illumination-anchor"]),
                "hillshade-exaggeration": new fa(Pt.paint_hillshade["hillshade-exaggeration"]),
                "hillshade-shadow-color": new fa(Pt.paint_hillshade["hillshade-shadow-color"]),
                "hillshade-highlight-color": new fa(Pt.paint_hillshade["hillshade-highlight-color"]),
                "hillshade-accent-color": new fa(Pt.paint_hillshade["hillshade-accent-color"]),
                "hillshade-emissive-strength": new fa(Pt.paint_hillshade["hillshade-emissive-strength"])
            }),
            layout: sf
        };
        const lf = Ia([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: cf } = lf;
        var hf = {
            exports: {}
        };
        function uf(e1, t, i) {
            i = i || 2;
            var r, n, o, s, a, l, c, h = t && t.length, u = h ? t[0] * i : e1.length, d = df(e1, 0, u, i, !0), p = [];
            if (!d || d.next === d.prev) return p;
            if (h && (d = function(e1, t, i, r) {
                var n, o, s, a = [];
                for(n = 0, o = t.length; n < o; n++)(s = df(e1, t[n] * r, n < o - 1 ? t[n + 1] * r : e1.length, r, !1)) === s.next && (s.steiner = !0), a.push(Tf(s));
                for(a.sort(xf), n = 0; n < a.length; n++)i = vf(a[n], i);
                return i;
            }(e1, t, d, i)), e1.length > 80 * i) {
                r = o = e1[0], n = s = e1[1];
                for(var f = i; f < u; f += i)(a = e1[f]) < r && (r = a), (l = e1[f + 1]) < n && (n = l), a > o && (o = a), l > s && (s = l);
                c = 0 !== (c = Math.max(o - r, s - n)) ? 32767 / c : 0;
            }
            return ff(d, p, i, r, n, c, 0), p;
        }
        function df(e1, t, i, r, n) {
            var o, s;
            if (n === Of(e1, t, i, r) > 0) for(o = t; o < i; o += r)s = Rf(o, e1[o], e1[o + 1], s);
            else for(o = i - r; o >= t; o -= r)s = Rf(o, e1[o], e1[o + 1], s);
            return s && Sf(s, s.next) && (Lf(s), s = s.next), s;
        }
        function pf(e1, t) {
            if (!e1) return e1;
            t || (t = e1);
            var i, r = e1;
            do if (i = !1, r.steiner || !Sf(r, r.next) && 0 !== Af(r.prev, r, r.next)) r = r.next;
            else {
                if (Lf(r), (r = t = r.prev) === r.next) break;
                i = !0;
            }
            while (i || r !== t);
            return t;
        }
        function ff(e1, t, i, r, n, o, s) {
            if (e1) {
                !s && o && function(e1, t, i, r) {
                    var n = e1;
                    do 0 === n.z && (n.z = wf(n.x, n.y, t, i, r)), n.prevZ = n.prev, n.nextZ = n.next, n = n.next;
                    while (n !== e1);
                    n.prevZ.nextZ = null, n.prevZ = null, function(e1) {
                        var t, i, r, n, o, s, a, l, c = 1;
                        do {
                            for(i = e1, e1 = null, o = null, s = 0; i;){
                                for(s++, r = i, a = 0, t = 0; t < c && (a++, r = r.nextZ); t++);
                                for(l = c; a > 0 || l > 0 && r;)0 !== a && (0 === l || !r || i.z <= r.z) ? (n = i, i = i.nextZ, a--) : (n = r, r = r.nextZ, l--), o ? o.nextZ = n : e1 = n, n.prevZ = o, o = n;
                                i = r;
                            }
                            o.nextZ = null, c *= 2;
                        }while (s > 1);
                    }(n);
                }(e1, r, n, o);
                for(var a, l, c = e1; e1.prev !== e1.next;)if (a = e1.prev, l = e1.next, o ? _f(e1, r, n, o) : mf(e1)) t.push(a.i / i | 0), t.push(e1.i / i | 0), t.push(l.i / i | 0), Lf(e1), e1 = l.next, c = l.next;
                else if ((e1 = l) === c) {
                    s ? 1 === s ? ff(e1 = gf(pf(e1), t, i), t, i, r, n, o, 2) : 2 === s && yf(e1, t, i, r, n, o) : ff(pf(e1), t, i, r, n, o, 1);
                    break;
                }
            }
        }
        function mf(e1) {
            var t = e1.prev, i = e1, r = e1.next;
            if (Af(t, i, r) >= 0) return !1;
            for(var n = t.x, o = i.x, s = r.x, a = t.y, l = i.y, c = r.y, h = n < o ? n < s ? n : s : o < s ? o : s, u = a < l ? a < c ? a : c : l < c ? l : c, d = n > o ? n > s ? n : s : o > s ? o : s, p = a > l ? a > c ? a : c : l > c ? l : c, f = r.next; f !== t;){
                if (f.x >= h && f.x <= d && f.y >= u && f.y <= p && Ef(n, a, o, l, s, c, f.x, f.y) && Af(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function _f(e1, t, i, r) {
            var n = e1.prev, o = e1, s = e1.next;
            if (Af(n, o, s) >= 0) return !1;
            for(var a = n.x, l = o.x, c = s.x, h = n.y, u = o.y, d = s.y, p = a < l ? a < c ? a : c : l < c ? l : c, f = h < u ? h < d ? h : d : u < d ? u : d, m = a > l ? a > c ? a : c : l > c ? l : c, _ = h > u ? h > d ? h : d : u > d ? u : d, g = wf(p, f, t, i, r), y = wf(m, _, t, i, r), x = e1.prevZ, v = e1.nextZ; x && x.z >= g && v && v.z <= y;){
                if (x.x >= p && x.x <= m && x.y >= f && x.y <= _ && x !== n && x !== s && Ef(a, h, l, u, c, d, x.x, x.y) && Af(x.prev, x, x.next) >= 0) return !1;
                if (x = x.prevZ, v.x >= p && v.x <= m && v.y >= f && v.y <= _ && v !== n && v !== s && Ef(a, h, l, u, c, d, v.x, v.y) && Af(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            for(; x && x.z >= g;){
                if (x.x >= p && x.x <= m && x.y >= f && x.y <= _ && x !== n && x !== s && Ef(a, h, l, u, c, d, x.x, x.y) && Af(x.prev, x, x.next) >= 0) return !1;
                x = x.prevZ;
            }
            for(; v && v.z <= y;){
                if (v.x >= p && v.x <= m && v.y >= f && v.y <= _ && v !== n && v !== s && Ef(a, h, l, u, c, d, v.x, v.y) && Af(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            return !0;
        }
        function gf(e1, t, i) {
            var r = e1;
            do {
                var n = r.prev, o = r.next.next;
                !Sf(n, o) && If(n, r, r.next, o) && Pf(n, o) && Pf(o, n) && (t.push(n.i / i | 0), t.push(r.i / i | 0), t.push(o.i / i | 0), Lf(r), Lf(r.next), r = e1 = o), r = r.next;
            }while (r !== e1);
            return pf(r);
        }
        function yf(e1, t, i, r, n, o) {
            var s = e1;
            do {
                for(var a = s.next.next; a !== s.prev;){
                    if (s.i !== a.i && Mf(s, a)) {
                        var l = Df(s, a);
                        return s = pf(s, s.next), l = pf(l, l.next), ff(s, t, i, r, n, o, 0), void ff(l, t, i, r, n, o, 0);
                    }
                    a = a.next;
                }
                s = s.next;
            }while (s !== e1);
        }
        function xf(e1, t) {
            return e1.x - t.x;
        }
        function vf(e1, t) {
            var i = function(e1, t) {
                var i, r = t, n = e1.x, o = e1.y, s = -1 / 0;
                do {
                    if (o <= r.y && o >= r.next.y && r.next.y !== r.y) {
                        var a = r.x + (o - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (a <= n && a > s && (s = a, i = r.x < r.next.x ? r : r.next, a === n)) return i;
                    }
                    r = r.next;
                }while (r !== t);
                if (!i) return null;
                var l, c = i, h = i.x, u = i.y, d = 1 / 0;
                r = i;
                do n >= r.x && r.x >= h && n !== r.x && Ef(o < u ? n : s, o, h, u, o < u ? s : n, o, r.x, r.y) && (l = Math.abs(o - r.y) / (n - r.x), Pf(r, e1) && (l < d || l === d && (r.x > i.x || r.x === i.x && bf(i, r))) && (i = r, d = l)), r = r.next;
                while (r !== c);
                return i;
            }(e1, t);
            if (!i) return t;
            var r = Df(i, e1);
            return pf(r, r.next), pf(i, i.next);
        }
        function bf(e1, t) {
            return Af(e1.prev, e1, t.prev) < 0 && Af(t.next, e1, e1.next) < 0;
        }
        function wf(e1, t, i, r, n) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - i) * n | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * n | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
        }
        function Tf(e1) {
            var t = e1, i = e1;
            do (t.x < i.x || t.x === i.x && t.y < i.y) && (i = t), t = t.next;
            while (t !== e1);
            return i;
        }
        function Ef(e1, t, i, r, n, o, s, a) {
            return (n - s) * (t - a) >= (e1 - s) * (o - a) && (e1 - s) * (r - a) >= (i - s) * (t - a) && (i - s) * (o - a) >= (n - s) * (r - a);
        }
        function Mf(e1, t) {
            return e1.next.i !== t.i && e1.prev.i !== t.i && !function(e1, t) {
                var i = e1;
                do {
                    if (i.i !== e1.i && i.next.i !== e1.i && i.i !== t.i && i.next.i !== t.i && If(i, i.next, e1, t)) return !0;
                    i = i.next;
                }while (i !== e1);
                return !1;
            }(e1, t) && (Pf(e1, t) && Pf(t, e1) && function(e1, t) {
                var i = e1, r = !1, n = (e1.x + t.x) / 2, o = (e1.y + t.y) / 2;
                do i.y > o != i.next.y > o && i.next.y !== i.y && n < (i.next.x - i.x) * (o - i.y) / (i.next.y - i.y) + i.x && (r = !r), i = i.next;
                while (i !== e1);
                return r;
            }(e1, t) && (Af(e1.prev, e1, t.prev) || Af(e1, t.prev, t)) || Sf(e1, t) && Af(e1.prev, e1, e1.next) > 0 && Af(t.prev, t, t.next) > 0);
        }
        function Af(e1, t, i) {
            return (t.y - e1.y) * (i.x - t.x) - (t.x - e1.x) * (i.y - t.y);
        }
        function Sf(e1, t) {
            return e1.x === t.x && e1.y === t.y;
        }
        function If(e1, t, i, r) {
            var n = zf(Af(e1, t, i)), o = zf(Af(e1, t, r)), s = zf(Af(i, r, e1)), a = zf(Af(i, r, t));
            return n !== o && s !== a || !(0 !== n || !Cf(e1, i, t)) || !(0 !== o || !Cf(e1, r, t)) || !(0 !== s || !Cf(i, e1, r)) || !(0 !== a || !Cf(i, t, r));
        }
        function Cf(e1, t, i) {
            return t.x <= Math.max(e1.x, i.x) && t.x >= Math.min(e1.x, i.x) && t.y <= Math.max(e1.y, i.y) && t.y >= Math.min(e1.y, i.y);
        }
        function zf(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function Pf(e1, t) {
            return Af(e1.prev, e1, e1.next) < 0 ? Af(e1, t, e1.next) >= 0 && Af(e1, e1.prev, t) >= 0 : Af(e1, t, e1.prev) < 0 || Af(e1, e1.next, t) < 0;
        }
        function Df(e1, t) {
            var i = new kf(e1.i, e1.x, e1.y), r = new kf(t.i, t.x, t.y), n = e1.next, o = t.prev;
            return e1.next = t, t.prev = e1, i.next = n, n.prev = i, r.next = i, i.prev = r, o.next = r, r.prev = o, r;
        }
        function Rf(e1, t, i, r) {
            var n = new kf(e1, t, i);
            return r ? (n.next = r.next, n.prev = r, r.next.prev = n, r.next = n) : (n.prev = n, n.next = n), n;
        }
        function Lf(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function kf(e1, t, i) {
            this.i = e1, this.x = t, this.y = i, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Of(e1, t, i, r) {
            for(var n = 0, o = t, s = i - r; o < i; o += r)n += (e1[s] - e1[o]) * (e1[o + 1] + e1[s + 1]), s = o;
            return n;
        }
        hf.exports = uf, hf.exports.default = uf, uf.deviation = function(e1, t, i, r) {
            var n = t && t.length, o = Math.abs(Of(e1, 0, n ? t[0] * i : e1.length, i));
            if (n) for(var s = 0, a = t.length; s < a; s++)o -= Math.abs(Of(e1, t[s] * i, s < a - 1 ? t[s + 1] * i : e1.length, i));
            var l = 0;
            for(s = 0; s < r.length; s += 3){
                var c = r[s] * i, h = r[s + 1] * i, u = r[s + 2] * i;
                l += Math.abs((e1[c] - e1[u]) * (e1[h + 1] - e1[c + 1]) - (e1[c] - e1[h]) * (e1[u + 1] - e1[c + 1]));
            }
            return 0 === o && 0 === l ? 0 : Math.abs((l - o) / o);
        }, uf.flatten = function(e1) {
            for(var t = e1[0][0].length, i = {
                vertices: [],
                holes: [],
                dimensions: t
            }, r = 0, n = 0; n < e1.length; n++){
                for(var o = 0; o < e1[n].length; o++)for(var s = 0; s < t; s++)i.vertices.push(e1[n][o][s]);
                n > 0 && i.holes.push(r += e1[n - 1].length);
            }
            return i;
        };
        var Bf = d(hf.exports);
        function Ff(e1, t) {
            const i = e1.length;
            if (i <= 1) return [
                e1
            ];
            const r = [];
            let n, o;
            for(let t = 0; t < i; t++){
                const i = Y(e1[t]);
                0 !== i && (e1[t].area = Math.abs(i), void 0 === o && (o = i < 0), o === i < 0 ? (n && r.push(n), n = [
                    e1[t]
                ]) : n.push(e1[t]));
            }
            if (n && r.push(n), t > 1) for(let e1 = 0; e1 < r.length; e1++)r[e1].length <= t || (Fi(r[e1], t, 1, r[e1].length - 1, Nf), r[e1] = r[e1].slice(0, t));
            return r;
        }
        function Nf(e1, t) {
            return t.area - e1.area;
        }
        function Uf(e1, t, i) {
            const r = i.patternDependencies;
            let n = !1;
            for (const i of t){
                const t = i.paint.get(`${e1}-pattern`);
                t.isConstant() || (n = !0);
                const o = t.constantOr(null);
                o && (n = !0, r[o] = !0);
            }
            return n;
        }
        function Vf(e1, t, i, r, n) {
            const o = n.patternDependencies;
            for (const s of t){
                const t = s.paint.get(`${e1}-pattern`).value;
                if ("constant" !== t.kind) {
                    let e1 = t.evaluate({
                        zoom: r
                    }, i, {}, n.availableImages);
                    e1 = e1 && e1.name ? e1.name : e1, o[e1] = !0, i.patterns[s.id] = e1;
                }
            }
            return i;
        }
        class jf {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new za, this.indexArray = new Wa, this.indexArray2 = new ja, this.programConfigurations = new ec(e1.layers, e1.zoom), this.segments = new xl, this.segments2 = new xl, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection;
            }
            populate(e1, t, i, r) {
                this.hasPattern = Uf("fill", this.layers, t);
                const n = this.layers[0].layout.get("fill-sort-key"), o = [];
                for (const { feature: s, id: a, index: l, sourceLayerIndex: c } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, h = gp(s, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), h, i)) continue;
                    const u = n ? n.evaluate(h, {}, i, t.availableImages) : void 0, d = {
                        id: a,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: c,
                        index: l,
                        geometry: e1 ? h.geometry : _p(s, i, r),
                        patterns: {},
                        sortKey: u
                    };
                    o.push(d);
                }
                n && o.sort((e1, t)=>e1.sortKey - t.sortKey);
                for (const r of o){
                    const { geometry: n, index: o, sourceLayerIndex: s } = r;
                    if (this.hasPattern) {
                        const e1 = Vf("fill", this.layers, r, this.zoom, t);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(r, n, o, i, {}, t.availableImages, t.brightness);
                    t.featureIndex.insert(e1[o].feature, n, o, s, this.index);
                }
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                o && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(e1, t, o ? this.stateDependentLayers : this.layers, i, r, n);
            }
            addFeatures(e1, t, i, r, n, o) {
                for (const e1 of this.patternFeatures)this.addFeature(e1, e1.geometry, e1.index, t, i, r, o);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, cf), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.indexBuffer2 = e1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(e1, t, i, r, n, o = [], s) {
                for (const e1 of Ff(t, 500)){
                    let t = 0;
                    for (const i of e1)t += i.length;
                    const i = this.segments.prepareSegment(t, this.layoutVertexArray, this.indexArray), r = i.vertexLength, n = [], o = [];
                    for (const t of e1){
                        if (0 === t.length) continue;
                        t !== e1[0] && o.push(n.length / 2);
                        const i = this.segments2.prepareSegment(t.length, this.layoutVertexArray, this.indexArray2), r = i.vertexLength;
                        this.layoutVertexArray.emplaceBack(t[0].x, t[0].y), this.indexArray2.emplaceBack(r + t.length - 1, r), n.push(t[0].x), n.push(t[0].y);
                        for(let e1 = 1; e1 < t.length; e1++)this.layoutVertexArray.emplaceBack(t[e1].x, t[e1].y), this.indexArray2.emplaceBack(r + e1 - 1, r + e1), n.push(t[e1].x), n.push(t[e1].y);
                        i.vertexLength += t.length, i.primitiveLength += t.length;
                    }
                    const s = Bf(n, o);
                    for(let e1 = 0; e1 < s.length; e1 += 3)this.indexArray.emplaceBack(r + s[e1], r + s[e1 + 1], r + s[e1 + 2]);
                    i.vertexLength += t, i.primitiveLength += s.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, n, o, r, s);
            }
        }
        Rs(jf, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const Gf = new ga({
            "fill-sort-key": new ma(Pt.layout_fill["fill-sort-key"]),
            visibility: new fa(Pt.layout_fill.visibility)
        });
        var qf = {
            paint: new ga({
                "fill-antialias": new fa(Pt.paint_fill["fill-antialias"]),
                "fill-opacity": new ma(Pt.paint_fill["fill-opacity"]),
                "fill-color": new ma(Pt.paint_fill["fill-color"]),
                "fill-outline-color": new ma(Pt.paint_fill["fill-outline-color"]),
                "fill-translate": new fa(Pt.paint_fill["fill-translate"]),
                "fill-translate-anchor": new fa(Pt.paint_fill["fill-translate-anchor"]),
                "fill-pattern": new ma(Pt.paint_fill["fill-pattern"]),
                "fill-emissive-strength": new fa(Pt.paint_fill["fill-emissive-strength"])
            }),
            layout: Gf
        };
        const Zf = Ia([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), $f = Ia([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), Wf = Ia([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Hf = Ia([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), Xf = Ia([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: Yf } = Zf;
        var Kf = {}, Jf = _, Qf = em;
        function em(e1, t, i, r, n) {
            this.properties = {}, this.extent = i, this.type = 0, this._pbf = e1, this._geometry = -1, this._keys = r, this._values = n, e1.readFields(tm, this, t);
        }
        function tm(e1, t, i) {
            1 == e1 ? t.id = i.readVarint() : 2 == e1 ? function(e1, t) {
                for(var i = e1.readVarint() + e1.pos; e1.pos < i;){
                    var r = t._keys[e1.readVarint()], n = t._values[e1.readVarint()];
                    t.properties[r] = n;
                }
            }(i, t) : 3 == e1 ? t.type = i.readVarint() : 4 == e1 && (t._geometry = i.pos);
        }
        function im(e1) {
            for(var t, i, r = 0, n = 0, o = e1.length, s = o - 1; n < o; s = n++)r += ((i = e1[s]).x - (t = e1[n]).x) * (t.y + i.y);
            return r;
        }
        em.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], em.prototype.loadGeometry = function() {
            var e1 = this._pbf;
            e1.pos = this._geometry;
            for(var t, i = e1.readVarint() + e1.pos, r = 1, n = 0, o = 0, s = 0, a = []; e1.pos < i;){
                if (n <= 0) {
                    var l = e1.readVarint();
                    r = 7 & l, n = l >> 3;
                }
                if (n--, 1 === r || 2 === r) o += e1.readSVarint(), s += e1.readSVarint(), 1 === r && (t && a.push(t), t = []), t.push(new Jf(o, s));
                else {
                    if (7 !== r) throw new Error("unknown command " + r);
                    t && t.push(t[0].clone());
                }
            }
            return t && a.push(t), a;
        }, em.prototype.bbox = function() {
            var e1 = this._pbf;
            e1.pos = this._geometry;
            for(var t = e1.readVarint() + e1.pos, i = 1, r = 0, n = 0, o = 0, s = 1 / 0, a = -1 / 0, l = 1 / 0, c = -1 / 0; e1.pos < t;){
                if (r <= 0) {
                    var h = e1.readVarint();
                    i = 7 & h, r = h >> 3;
                }
                if (r--, 1 === i || 2 === i) (n += e1.readSVarint()) < s && (s = n), n > a && (a = n), (o += e1.readSVarint()) < l && (l = o), o > c && (c = o);
                else if (7 !== i) throw new Error("unknown command " + i);
            }
            return [
                s,
                l,
                a,
                c
            ];
        }, em.prototype.toGeoJSON = function(e1, t, i) {
            var r, n, o = this.extent * Math.pow(2, i), s = this.extent * e1, a = this.extent * t, l = this.loadGeometry(), c = em.types[this.type];
            function h(e1) {
                for(var t = 0; t < e1.length; t++){
                    var i = e1[t];
                    e1[t] = [
                        360 * (i.x + s) / o - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (i.y + a) / o) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var u = [];
                    for(r = 0; r < l.length; r++)u[r] = l[r][0];
                    h(l = u);
                    break;
                case 2:
                    for(r = 0; r < l.length; r++)h(l[r]);
                    break;
                case 3:
                    for(l = function(e1) {
                        var t = e1.length;
                        if (t <= 1) return [
                            e1
                        ];
                        for(var i, r, n = [], o = 0; o < t; o++){
                            var s = im(e1[o]);
                            0 !== s && (void 0 === r && (r = s < 0), r === s < 0 ? (i && n.push(i), i = [
                                e1[o]
                            ]) : i.push(e1[o]));
                        }
                        return i && n.push(i), n;
                    }(l), r = 0; r < l.length; r++)for(n = 0; n < l[r].length; n++)h(l[r][n]);
            }
            1 === l.length ? l = l[0] : c = "Multi" + c;
            var d = {
                type: "Feature",
                geometry: {
                    type: c,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (d.id = this.id), d;
        };
        var rm = Qf, nm = om;
        function om(e1, t) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], e1.readFields(sm, this, t), this.length = this._features.length;
        }
        function sm(e1, t, i) {
            15 === e1 ? t.version = i.readVarint() : 1 === e1 ? t.name = i.readString() : 5 === e1 ? t.extent = i.readVarint() : 2 === e1 ? t._features.push(i.pos) : 3 === e1 ? t._keys.push(i.readString()) : 4 === e1 && t._values.push(function(e1) {
                for(var t = null, i = e1.readVarint() + e1.pos; e1.pos < i;){
                    var r = e1.readVarint() >> 3;
                    t = 1 === r ? e1.readString() : 2 === r ? e1.readFloat() : 3 === r ? e1.readDouble() : 4 === r ? e1.readVarint64() : 5 === r ? e1.readVarint() : 6 === r ? e1.readSVarint() : 7 === r ? e1.readBoolean() : null;
                }
                return t;
            }(i));
        }
        om.prototype.feature = function(e1) {
            if (e1 < 0 || e1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[e1];
            var t = this._pbf.readVarint() + this._pbf.pos;
            return new rm(this._pbf, t, this.extent, this._keys, this._values);
        };
        var am = nm;
        function lm(e1, t, i) {
            if (3 === e1) {
                var r = new am(i, i.readVarint() + i.pos);
                r.length && (t[r.name] = r);
            }
        }
        var cm = Kf.VectorTile = function(e1, t) {
            this.layers = e1.readFields(lm, {}, t);
        }, hm = Kf.VectorTileFeature = Qf;
        function um(e1, t, i, r) {
            const n = [], o = 0 === r ? (e1, t, i, r, n, o)=>{
                e1.push(new y(o, i + (o - t) / (r - t) * (n - i)));
            } : (e1, t, i, r, n, o)=>{
                e1.push(new y(t + (o - i) / (n - i) * (r - t), o));
            };
            for (const s of e1){
                const e1 = [];
                for (const n of s){
                    if (n.length <= 2) continue;
                    const s = [];
                    for(let e1 = 0; e1 < n.length - 1; e1++){
                        const a = n[e1].x, l = n[e1].y, c = n[e1 + 1].x, h = n[e1 + 1].y, u = 0 === r ? a : l, d = 0 === r ? c : h;
                        u < t ? d > t && o(s, a, l, c, h, t) : u > i ? d < i && o(s, a, l, c, h, i) : s.push(n[e1]), d < t && u >= t && o(s, a, l, c, h, t), d > i && u <= i && o(s, a, l, c, h, i);
                    }
                    let a = n[n.length - 1];
                    const l = 0 === r ? a.x : a.y;
                    l >= t && l <= i && s.push(a), s.length && (a = s[s.length - 1], s[0].x === a.x && s[0].y === a.y || s.push(s[0]), e1.push(s));
                }
                e1.length && n.push(e1);
            }
            return n;
        }
        Kf.VectorTileLayer = nm;
        class dm {
            constructor(e1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let t = 0; t < e1.length; t++){
                    const i = e1[t];
                    this._stringToNumber[i] = t, this._numberToString[t] = i;
                }
            }
            encode(e1) {
                return this._stringToNumber[e1];
            }
            decode(e1) {
                return this._numberToString[e1];
            }
        }
        var pm = {
            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ read: function(e1, t, i, r, n) {
                var o, s, a = 8 * n - r - 1, l = (1 << a) - 1, c = l >> 1, h = -7, u = i ? n - 1 : 0, d = i ? -1 : 1, p = e1[t + u];
                for(u += d, o = p & (1 << -h) - 1, p >>= -h, h += a; h > 0; o = 256 * o + e1[t + u], u += d, h -= 8);
                for(s = o & (1 << -h) - 1, o >>= -h, h += r; h > 0; s = 256 * s + e1[t + u], u += d, h -= 8);
                if (0 === o) o = 1 - c;
                else {
                    if (o === l) return s ? NaN : 1 / 0 * (p ? -1 : 1);
                    s += Math.pow(2, r), o -= c;
                }
                return (p ? -1 : 1) * s * Math.pow(2, o - r);
            },
            write: function(e1, t, i, r, n, o) {
                var s, a, l, c = 8 * o - n - 1, h = (1 << c) - 1, u = h >> 1, d = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : o - 1, f = r ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = h) : (s = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (t += s + u >= 1 ? d / l : d * Math.pow(2, 1 - u)) * l >= 2 && (s++, l /= 2), s + u >= h ? (a = 0, s = h) : s + u >= 1 ? (a = (t * l - 1) * Math.pow(2, n), s += u) : (a = t * Math.pow(2, u - 1) * Math.pow(2, n), s = 0)); n >= 8; e1[i + p] = 255 & a, p += f, a /= 256, n -= 8);
                for(s = s << n | a, c += n; c > 0; e1[i + p] = 255 & s, p += f, s /= 256, c -= 8);
                e1[i + p - f] |= 128 * m;
            }
        }, fm = _m, mm = pm;
        function _m(e1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        _m.Varint = 0, _m.Fixed64 = 1, _m.Bytes = 2, _m.Fixed32 = 5;
        var gm = 4294967296, ym = 1 / gm, xm = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function vm(e1) {
            return e1.type === _m.Bytes ? e1.readVarint() + e1.pos : e1.pos + 1;
        }
        function bm(e1, t, i) {
            return i ? 4294967296 * t + (e1 >>> 0) : 4294967296 * (t >>> 0) + (e1 >>> 0);
        }
        function wm(e1, t, i) {
            var r = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.floor(Math.log(t) / (7 * Math.LN2));
            i.realloc(r);
            for(var n = i.pos - 1; n >= e1; n--)i.buf[n + r] = i.buf[n];
        }
        function Tm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeVarint(e1[i]);
        }
        function Em(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeSVarint(e1[i]);
        }
        function Mm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeFloat(e1[i]);
        }
        function Am(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeDouble(e1[i]);
        }
        function Sm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeBoolean(e1[i]);
        }
        function Im(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeFixed32(e1[i]);
        }
        function Cm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeSFixed32(e1[i]);
        }
        function zm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeFixed64(e1[i]);
        }
        function Pm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeSFixed64(e1[i]);
        }
        function Dm(e1, t) {
            return (e1[t] | e1[t + 1] << 8 | e1[t + 2] << 16) + 16777216 * e1[t + 3];
        }
        function Rm(e1, t, i) {
            e1[i] = t, e1[i + 1] = t >>> 8, e1[i + 2] = t >>> 16, e1[i + 3] = t >>> 24;
        }
        function Lm(e1, t) {
            return (e1[t] | e1[t + 1] << 8 | e1[t + 2] << 16) + (e1[t + 3] << 24);
        }
        _m.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(e1, t, i) {
                for(i = i || this.length; this.pos < i;){
                    var r = this.readVarint(), n = r >> 3, o = this.pos;
                    this.type = 7 & r, e1(n, t, this), this.pos === o && this.skip(r);
                }
                return t;
            },
            readMessage: function(e1, t) {
                return this.readFields(e1, t, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var e1 = Dm(this.buf, this.pos);
                return this.pos += 4, e1;
            },
            readSFixed32: function() {
                var e1 = Lm(this.buf, this.pos);
                return this.pos += 4, e1;
            },
            readFixed64: function() {
                var e1 = Dm(this.buf, this.pos) + Dm(this.buf, this.pos + 4) * gm;
                return this.pos += 8, e1;
            },
            readSFixed64: function() {
                var e1 = Dm(this.buf, this.pos) + Lm(this.buf, this.pos + 4) * gm;
                return this.pos += 8, e1;
            },
            readFloat: function() {
                var e1 = mm.read(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, e1;
            },
            readDouble: function() {
                var e1 = mm.read(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, e1;
            },
            readVarint: function(e1) {
                var t, i, r = this.buf;
                return t = 127 & (i = r[this.pos++]), i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 7, i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 14, i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 21, i < 128 ? t : function(e1, t, i) {
                    var r, n, o = i.buf;
                    if (r = (112 & (n = o[i.pos++])) >> 4, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 3, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 10, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 17, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 24, n < 128) return bm(e1, r, t);
                    if (r |= (1 & (n = o[i.pos++])) << 31, n < 128) return bm(e1, r, t);
                    throw new Error("Expected varint not more than 10 bytes");
                }(t |= (15 & (i = r[this.pos])) << 28, e1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var e1 = this.readVarint();
                return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var e1 = this.readVarint() + this.pos, t = this.pos;
                return this.pos = e1, e1 - t >= 12 && xm ? function(e1, t, i) {
                    return xm.decode(e1.subarray(t, i));
                }(this.buf, t, e1) : function(e1, t, i) {
                    for(var r = "", n = t; n < i;){
                        var o, s, a, l = e1[n], c = null, h = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (n + h > i) break;
                        1 === h ? l < 128 && (c = l) : 2 === h ? 128 == (192 & (o = e1[n + 1])) && (c = (31 & l) << 6 | 63 & o) <= 127 && (c = null) : 3 === h ? (s = e1[n + 2], 128 == (192 & (o = e1[n + 1])) && 128 == (192 & s) && ((c = (15 & l) << 12 | (63 & o) << 6 | 63 & s) <= 2047 || c >= 55296 && c <= 57343) && (c = null)) : 4 === h && (s = e1[n + 2], a = e1[n + 3], 128 == (192 & (o = e1[n + 1])) && 128 == (192 & s) && 128 == (192 & a) && ((c = (15 & l) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) <= 65535 || c >= 1114112) && (c = null)), null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, r += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), r += String.fromCharCode(c), n += h;
                    }
                    return r;
                }(this.buf, t, e1);
            },
            readBytes: function() {
                var e1 = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e1);
                return this.pos = e1, t;
            },
            readPackedVarint: function(e1, t) {
                if (this.type !== _m.Bytes) return e1.push(this.readVarint(t));
                var i = vm(this);
                for(e1 = e1 || []; this.pos < i;)e1.push(this.readVarint(t));
                return e1;
            },
            readPackedSVarint: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readSVarint());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readSVarint());
                return e1;
            },
            readPackedBoolean: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readBoolean());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readBoolean());
                return e1;
            },
            readPackedFloat: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readFloat());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readFloat());
                return e1;
            },
            readPackedDouble: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readDouble());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readDouble());
                return e1;
            },
            readPackedFixed32: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readFixed32());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readFixed32());
                return e1;
            },
            readPackedSFixed32: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readSFixed32());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readSFixed32());
                return e1;
            },
            readPackedFixed64: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readFixed64());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readFixed64());
                return e1;
            },
            readPackedSFixed64: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readSFixed64());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readSFixed64());
                return e1;
            },
            skip: function(e1) {
                var t = 7 & e1;
                if (t === _m.Varint) for(; this.buf[this.pos++] > 127;);
                else if (t === _m.Bytes) this.pos = this.readVarint() + this.pos;
                else if (t === _m.Fixed32) this.pos += 4;
                else {
                    if (t !== _m.Fixed64) throw new Error("Unimplemented type: " + t);
                    this.pos += 8;
                }
            },
            writeTag: function(e1, t) {
                this.writeVarint(e1 << 3 | t);
            },
            realloc: function(e1) {
                for(var t = this.length || 16; t < this.pos + e1;)t *= 2;
                if (t !== this.length) {
                    var i = new Uint8Array(t);
                    i.set(this.buf), this.buf = i, this.length = t;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(e1) {
                this.realloc(4), Rm(this.buf, e1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(e1) {
                this.realloc(4), Rm(this.buf, e1, this.pos), this.pos += 4;
            },
            writeFixed64: function(e1) {
                this.realloc(8), Rm(this.buf, -1 & e1, this.pos), Rm(this.buf, Math.floor(e1 * ym), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(e1) {
                this.realloc(8), Rm(this.buf, -1 & e1, this.pos), Rm(this.buf, Math.floor(e1 * ym), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(e1) {
                (e1 = +e1 || 0) > 268435455 || e1 < 0 ? function(e1, t) {
                    var i, r;
                    if (e1 >= 0 ? (i = e1 % 4294967296 | 0, r = e1 / 4294967296 | 0) : (r = ~(-e1 / 4294967296), 4294967295 ^ (i = ~(-e1 % 4294967296)) ? i = i + 1 | 0 : (i = 0, r = r + 1 | 0)), e1 >= 0x10000000000000000 || e1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    t.realloc(10), function(e1, t, i) {
                        i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, i.buf[i.pos] = 127 & (e1 >>>= 7);
                    }(i, 0, t), function(e1, t) {
                        var i = (7 & e1) << 4;
                        t.buf[t.pos++] |= i | ((e1 >>>= 3) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1)))));
                    }(r, t);
                }(e1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e1 | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = e1 >>> 7 & 127))));
            },
            writeSVarint: function(e1) {
                this.writeVarint(e1 < 0 ? 2 * -e1 - 1 : 2 * e1);
            },
            writeBoolean: function(e1) {
                this.writeVarint(Boolean(e1));
            },
            writeString: function(e1) {
                e1 = String(e1), this.realloc(4 * e1.length), this.pos++;
                var t = this.pos;
                this.pos = function(e1, t, i) {
                    for(var r, n, o = 0; o < t.length; o++){
                        if ((r = t.charCodeAt(o)) > 55295 && r < 57344) {
                            if (!n) {
                                r > 56319 || o + 1 === t.length ? (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189) : n = r;
                                continue;
                            }
                            if (r < 56320) {
                                e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, n = r;
                                continue;
                            }
                            r = n - 55296 << 10 | r - 56320 | 65536, n = null;
                        } else n && (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, n = null);
                        r < 128 ? e1[i++] = r : (r < 2048 ? e1[i++] = r >> 6 | 192 : (r < 65536 ? e1[i++] = r >> 12 | 224 : (e1[i++] = r >> 18 | 240, e1[i++] = r >> 12 & 63 | 128), e1[i++] = r >> 6 & 63 | 128), e1[i++] = 63 & r | 128);
                    }
                    return i;
                }(this.buf, e1, this.pos);
                var i = this.pos - t;
                i >= 128 && wm(t, i, this), this.pos = t - 1, this.writeVarint(i), this.pos += i;
            },
            writeFloat: function(e1) {
                this.realloc(4), mm.write(this.buf, e1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(e1) {
                this.realloc(8), mm.write(this.buf, e1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(e1) {
                var t = e1.length;
                this.writeVarint(t), this.realloc(t);
                for(var i = 0; i < t; i++)this.buf[this.pos++] = e1[i];
            },
            writeRawMessage: function(e1, t) {
                this.pos++;
                var i = this.pos;
                e1(t, this);
                var r = this.pos - i;
                r >= 128 && wm(i, r, this), this.pos = i - 1, this.writeVarint(r), this.pos += r;
            },
            writeMessage: function(e1, t, i) {
                this.writeTag(e1, _m.Bytes), this.writeRawMessage(t, i);
            },
            writePackedVarint: function(e1, t) {
                t.length && this.writeMessage(e1, Tm, t);
            },
            writePackedSVarint: function(e1, t) {
                t.length && this.writeMessage(e1, Em, t);
            },
            writePackedBoolean: function(e1, t) {
                t.length && this.writeMessage(e1, Sm, t);
            },
            writePackedFloat: function(e1, t) {
                t.length && this.writeMessage(e1, Mm, t);
            },
            writePackedDouble: function(e1, t) {
                t.length && this.writeMessage(e1, Am, t);
            },
            writePackedFixed32: function(e1, t) {
                t.length && this.writeMessage(e1, Im, t);
            },
            writePackedSFixed32: function(e1, t) {
                t.length && this.writeMessage(e1, Cm, t);
            },
            writePackedFixed64: function(e1, t) {
                t.length && this.writeMessage(e1, zm, t);
            },
            writePackedSFixed64: function(e1, t) {
                t.length && this.writeMessage(e1, Pm, t);
            },
            writeBytesField: function(e1, t) {
                this.writeTag(e1, _m.Bytes), this.writeBytes(t);
            },
            writeFixed32Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed32), this.writeFixed32(t);
            },
            writeSFixed32Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed32), this.writeSFixed32(t);
            },
            writeFixed64Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed64), this.writeFixed64(t);
            },
            writeSFixed64Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed64), this.writeSFixed64(t);
            },
            writeVarintField: function(e1, t) {
                this.writeTag(e1, _m.Varint), this.writeVarint(t);
            },
            writeSVarintField: function(e1, t) {
                this.writeTag(e1, _m.Varint), this.writeSVarint(t);
            },
            writeStringField: function(e1, t) {
                this.writeTag(e1, _m.Bytes), this.writeString(t);
            },
            writeFloatField: function(e1, t) {
                this.writeTag(e1, _m.Fixed32), this.writeFloat(t);
            },
            writeDoubleField: function(e1, t) {
                this.writeTag(e1, _m.Fixed64), this.writeDouble(t);
            },
            writeBooleanField: function(e1, t) {
                this.writeVarintField(e1, Boolean(t));
            }
        };
        var km = d(fm);
        const Om = [
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class Bm {
            constructor(e1, t, i, r, n){
                this.type = "Feature", this._vectorTileFeature = e1, this._z = t, this._x = i, this._y = r, this.properties = e1.properties, this.id = n;
            }
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(e1) {
                this._geometry = e1;
            }
            toJSON() {
                const e1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                void 0 !== this.id && (e1.id = this.id);
                for (const t of Om)void 0 !== this[t] && (e1[t] = this[t]);
                return e1;
            }
        }
        class Fm {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e1, t, i) {
                const r = String(t);
                if (this.stateChanges[e1] = this.stateChanges[e1] || {}, this.stateChanges[e1][r] = this.stateChanges[e1][r] || {}, k(this.stateChanges[e1][r], i), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = {};
                    for(const t in this.state[e1])t !== r && (this.deletedStates[e1][t] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][r]) {
                    this.deletedStates[e1][r] = {};
                    for(const t in this.state[e1][r])i[t] || (this.deletedStates[e1][r][t] = null);
                } else for(const t in i)this.deletedStates[e1] && this.deletedStates[e1][r] && null === this.deletedStates[e1][r][t] && delete this.deletedStates[e1][r][t];
            }
            removeFeatureState(e1, t, i) {
                if (null === this.deletedStates[e1]) return;
                const r = String(t);
                if (this.deletedStates[e1] = this.deletedStates[e1] || {}, i && void 0 !== t) null !== this.deletedStates[e1][r] && (this.deletedStates[e1][r] = this.deletedStates[e1][r] || {}, this.deletedStates[e1][r][i] = null);
                else if (void 0 !== t) {
                    if (this.stateChanges[e1] && this.stateChanges[e1][r]) for(i in this.deletedStates[e1][r] = {}, this.stateChanges[e1][r])this.deletedStates[e1][r][i] = null;
                    else this.deletedStates[e1][r] = null;
                } else this.deletedStates[e1] = null;
            }
            getState(e1, t) {
                const i = String(t), r = k({}, (this.state[e1] || {})[i], (this.stateChanges[e1] || {})[i]);
                if (null === this.deletedStates[e1]) return {};
                if (this.deletedStates[e1]) {
                    const i = this.deletedStates[e1][t];
                    if (null === i) return {};
                    for(const e1 in i)delete r[e1];
                }
                return r;
            }
            initializeTileState(e1, t) {
                e1.setFeatureState(this.state, t);
            }
            coalesceChanges(e1, t) {
                const i = {};
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || {};
                    const t = {};
                    for(const i in this.stateChanges[e1])this.state[e1][i] || (this.state[e1][i] = {}), k(this.state[e1][i], this.stateChanges[e1][i]), t[i] = this.state[e1][i];
                    i[e1] = t;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || {};
                    const t = {};
                    if (null === this.deletedStates[e1]) for(const i in this.state[e1])t[i] = {}, this.state[e1][i] = {};
                    else for(const i in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][i]) this.state[e1][i] = {};
                        else if (this.state[e1][i]) for (const t of Object.keys(this.deletedStates[e1][i]))delete this.state[e1][i][t];
                        t[i] = this.state[e1][i];
                    }
                    i[e1] = i[e1] || {}, k(i[e1], t);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(i).length) for(const r in e1)e1[r].setFeatureState(i, t);
            }
        }
        class Nm {
            constructor(e1){
                this.size = e1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(e1, t) {
                const i = this.toIdx(e1, t);
                return {
                    min: this.minimums[i],
                    max: this.maximums[i]
                };
            }
            isLeaf(e1, t) {
                return this.leaves[this.toIdx(e1, t)];
            }
            toIdx(e1, t) {
                return t * this.size + e1;
            }
        }
        function Um(e1, t, i, r) {
            let n = 0, o = Number.MAX_VALUE;
            for(let s = 0; s < 3; s++)if (Math.abs(r[s]) < 1e-15) {
                if (i[s] < e1[s] || i[s] > t[s]) return null;
            } else {
                const a = 1 / r[s];
                let l = (e1[s] - i[s]) * a, c = (t[s] - i[s]) * a;
                if (l > c) {
                    const e1 = l;
                    l = c, c = e1;
                }
                if (l > n && (n = l), c < o && (o = c), n > o) return null;
            }
            return n;
        }
        function Vm(e1, t, i, r, n, o, s, a, l, c, h) {
            const u = r - e1, d = n - t, p = o - i, f = s - e1, m = a - t, _ = l - i, g = h[1] * _ - h[2] * m, y = h[2] * f - h[0] * _, x = h[0] * m - h[1] * f, v = u * g + d * y + p * x;
            if (Math.abs(v) < 1e-15) return null;
            const b = 1 / v, w = c[0] - e1, T = c[1] - t, E = c[2] - i, M = (w * g + T * y + E * x) * b;
            if (M < 0 || M > 1) return null;
            const A = T * p - E * d, S = E * u - w * p, I = w * d - T * u, C = (h[0] * A + h[1] * S + h[2] * I) * b;
            return C < 0 || M + C > 1 ? null : (f * A + m * S + _ * I) * b;
        }
        function jm(e1, t, i) {
            return (e1 - t) / (i - t);
        }
        function Gm(e1, t, i, r, n, o, s, a, l) {
            const c = 1 << i, h = o - r, u = s - n, d = (e1 + 1) / c * h + r, p = (t + 0) / c * u + n, f = (t + 1) / c * u + n;
            a[0] = (e1 + 0) / c * h + r, a[1] = p, l[0] = d, l[1] = f;
        }
        class qm {
            constructor(e1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = e1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const t = function(e1) {
                    const t = Math.ceil(Math.log2(e1.dim / 8)), i = [];
                    let r = Math.ceil(Math.pow(2, t));
                    const n = 1 / r, o = (e1, t, i, r, n)=>{
                        const o = r ? 1 : 0, s = (e1 + 1) * i - o, a = t * i, l = (t + 1) * i - o;
                        n[0] = e1 * i, n[1] = a, n[2] = s, n[3] = l;
                    };
                    let s = new Nm(r);
                    const a = [];
                    for(let t = 0; t < r * r; t++){
                        o(t % r, Math.floor(t / r), n, !1, a);
                        const i = $m(a[0], a[1], e1), l = $m(a[2], a[1], e1), c = $m(a[2], a[3], e1), h = $m(a[0], a[3], e1);
                        s.minimums.push(Math.min(i, l, c, h)), s.maximums.push(Math.max(i, l, c, h)), s.leaves.push(1);
                    }
                    for(i.push(s), r /= 2; r >= 1; r /= 2){
                        const e1 = i[i.length - 1];
                        s = new Nm(r);
                        for(let t = 0; t < r * r; t++){
                            o(t % r, Math.floor(t / r), 2, !0, a);
                            const i = e1.getElevation(a[0], a[1]), n = e1.getElevation(a[2], a[1]), l = e1.getElevation(a[2], a[3]), c = e1.getElevation(a[0], a[3]), h = e1.isLeaf(a[0], a[1]), u = e1.isLeaf(a[2], a[1]), d = e1.isLeaf(a[2], a[3]), p = e1.isLeaf(a[0], a[3]), f = Math.min(i.min, n.min, l.min, c.min), m = Math.max(i.max, n.max, l.max, c.max), _ = h && u && d && p;
                            s.maximums.push(m), s.minimums.push(f), s.leaves.push(m - f <= 5 && _ ? 1 : 0);
                        }
                        i.push(s);
                    }
                    return i;
                }(this.dem), i = t.length - 1, r = t[i];
                this._addNode(r.minimums[0], r.maximums[0], r.leaves[0]), this._construct(t, 0, 0, i, 0);
            }
            raycastRoot(e1, t, i, r, n, o, s = 1) {
                return Um([
                    e1,
                    t,
                    -100
                ], [
                    i,
                    r,
                    this.maximums[0] * s
                ], n, o);
            }
            raycast(e1, t, i, r, n, o, s = 1) {
                if (!this.nodeCount) return null;
                const a = this.raycastRoot(e1, t, i, r, n, o, s);
                if (null == a) return null;
                const l = [], c = [], h = [], u = [], d = [
                    {
                        idx: 0,
                        t: a,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; d.length > 0;){
                    const { idx: a, t: p, nodex: f, nodey: m, depth: _ } = d.pop();
                    if (this.leaves[a]) {
                        Gm(f, m, _, e1, t, i, r, h, u);
                        const a = 1 << _, l = (f + 0) / a, c = (f + 1) / a, d = (m + 0) / a, g = (m + 1) / a, y = $m(l, d, this.dem) * s, x = $m(c, d, this.dem) * s, v = $m(c, g, this.dem) * s, b = $m(l, g, this.dem) * s, w = Vm(h[0], h[1], y, u[0], h[1], x, u[0], u[1], v, n, o), T = Vm(u[0], u[1], v, h[0], u[1], b, h[0], h[1], y, n, o), E = Math.min(null !== w ? w : Number.MAX_VALUE, null !== T ? T : Number.MAX_VALUE);
                        if (E !== Number.MAX_VALUE) return E;
                        {
                            const e1 = Du.scaleAndAdd([], n, o, p);
                            if (Zm(y, x, b, v, jm(e1[0], h[0], u[0]), jm(e1[1], h[1], u[1])) >= e1[2]) return p;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let d = 0; d < this._siblingOffset.length; d++){
                        Gm((f << 1) + this._siblingOffset[d][0], (m << 1) + this._siblingOffset[d][1], _ + 1, e1, t, i, r, h, u), h[2] = -100, u[2] = this.maximums[this.childOffsets[a] + d] * s;
                        const p = Um(h, u, n, o);
                        if (null != p) {
                            const e1 = p;
                            l[d] = e1;
                            let t = !1;
                            for(let i = 0; i < g && !t; i++)e1 >= l[c[i]] && (c.splice(i, 0, d), t = !0);
                            t || (c[g] = d), g++;
                        }
                    }
                    for(let e1 = 0; e1 < g; e1++){
                        const t = c[e1];
                        d.push({
                            idx: this.childOffsets[a] + t,
                            t: l[t],
                            nodex: (f << 1) + this._siblingOffset[t][0],
                            nodey: (m << 1) + this._siblingOffset[t][1],
                            depth: _ + 1
                        });
                    }
                }
                return null;
            }
            _addNode(e1, t, i) {
                return this.minimums.push(e1), this.maximums.push(t), this.leaves.push(i), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(e1, t, i, r, n) {
                if (1 === e1[r].isLeaf(t, i)) return;
                this.childOffsets[n] || (this.childOffsets[n] = this.nodeCount);
                const o = r - 1, s = e1[o];
                let a = 0, l = 0;
                for(let e1 = 0; e1 < this._siblingOffset.length; e1++){
                    const r = 2 * t + this._siblingOffset[e1][0], n = 2 * i + this._siblingOffset[e1][1], o = s.getElevation(r, n), c = s.isLeaf(r, n), h = this._addNode(o.min, o.max, c);
                    c && (a |= 1 << e1), l || (l = h);
                }
                for(let r = 0; r < this._siblingOffset.length; r++)a & 1 << r || this._construct(e1, 2 * t + this._siblingOffset[r][0], 2 * i + this._siblingOffset[r][1], o, l + r);
            }
        }
        function Zm(e1, t, i, r, n, o) {
            return Kr(Kr(e1, i, o), Kr(t, r, o), n);
        }
        function $m(e1, t, i) {
            const r = i.dim, n = z(e1 * r - .5, 0, r - 1), o = z(t * r - .5, 0, r - 1), s = Math.floor(n), a = Math.floor(o), l = Math.min(s + 1, r - 1), c = Math.min(a + 1, r - 1);
            return Zm(i.get(s, a), i.get(l, a), i.get(s, c), i.get(l, c), n - s, o - a);
        }
        const Wm = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function Hm(e1, t, i) {
            return (256 * e1 * 256 + 256 * t + i) / 10 - 1e4;
        }
        function Xm(e1, t, i) {
            return 256 * e1 + t + i / 256 - 32768;
        }
        class Ym {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(e1, t, i, r = !1){
                if (this.uid = e1, t.height !== t.width) throw new RangeError("DEM tiles must be square");
                if (i && "mapbox" !== i && "terrarium" !== i) return H(`"${i}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = t.height;
                const n = this.dim = t.height - 2, o = new Uint32Array(t.data.buffer);
                if (this.pixels = new Uint8Array(t.data.buffer), this.floatView = new Float32Array(t.data.buffer), this.borderReady = r, this._modifiedForSources = {}, !r) {
                    for(let e1 = 0; e1 < n; e1++)o[this._idx(-1, e1)] = o[this._idx(0, e1)], o[this._idx(n, e1)] = o[this._idx(n - 1, e1)], o[this._idx(e1, -1)] = o[this._idx(e1, 0)], o[this._idx(e1, n)] = o[this._idx(e1, n - 1)];
                    o[this._idx(-1, -1)] = o[this._idx(0, 0)], o[this._idx(n, -1)] = o[this._idx(n - 1, 0)], o[this._idx(-1, n)] = o[this._idx(0, n - 1)], o[this._idx(n, n)] = o[this._idx(n - 1, n - 1)];
                }
                const s = "terrarium" === i ? Xm : Hm;
                for(let e1 = 0; e1 < o.length; ++e1){
                    const t = 4 * e1;
                    this.floatView[e1] = s(this.pixels[t], this.pixels[t + 1], this.pixels[t + 2]);
                }
                this._timestamp = dt.now();
            }
            _buildQuadTree() {
                this._tree = new qm(this);
            }
            get(e1, t, i = !1) {
                i && (e1 = z(e1, -1, this.dim), t = z(t, -1, this.dim));
                const r = this._idx(e1, t);
                return this.floatView[r];
            }
            set(e1, t, i) {
                const r = this._idx(e1, t), n = this.floatView[r];
                return this.floatView[r] = i, i - n;
            }
            static getUnpackVector(e1) {
                return Wm[e1];
            }
            _idx(e1, t) {
                if (e1 < -1 || e1 >= this.dim + 1 || t < -1 || t >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (t + 1) * this.stride + (e1 + 1);
            }
            static pack(e1, t) {
                const i = [
                    0,
                    0,
                    0,
                    0
                ], r = Ym.getUnpackVector(t);
                let n = Math.floor((e1 + r[3]) / r[2]);
                return i[2] = n % 256, n = Math.floor(n / 256), i[1] = n % 256, n = Math.floor(n / 256), i[0] = n, i;
            }
            getPixels() {
                return new tf({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(e1, t, i) {
                if (this.dim !== e1.dim) throw new Error("dem dimension mismatch");
                let r = t * this.dim, n = t * this.dim + this.dim, o = i * this.dim, s = i * this.dim + this.dim;
                switch(t){
                    case -1:
                        r = n - 1;
                        break;
                    case 1:
                        n = r + 1;
                }
                switch(i){
                    case -1:
                        o = s - 1;
                        break;
                    case 1:
                        s = o + 1;
                }
                const a = -t * this.dim, l = -i * this.dim;
                for(let t = o; t < s; t++)for(let i = r; i < n; i++){
                    const r = 4 * this._idx(i, t), n = 4 * this._idx(i + a, t + l);
                    this.pixels[r + 0] = e1.pixels[n + 0], this.pixels[r + 1] = e1.pixels[n + 1], this.pixels[r + 2] = e1.pixels[n + 2], this.pixels[r + 3] = e1.pixels[n + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        Rs(Ym, "DEMData"), Rs(qm, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        class Km {
            isDataAvailableAtPoint(e1) {
                const t = this._source();
                if (this.isUsingMockSource() || !t || e1.y < 0 || e1.y > 1) return !1;
                const i = t.getSource().maxzoom, r = 1 << i, n = Math.floor(e1.x), o = Math.floor((e1.x - n) * r), s = Math.floor(e1.y * r), a = this.findDEMTileFor(new qu(i, n, i, o, s));
                return !(!a || !a.dem);
            }
            getAtPointOrZero(e1, t = 0) {
                return this.getAtPoint(e1, t) || 0;
            }
            getAtPoint(e1, t, i = !0) {
                if (this.isUsingMockSource()) return null;
                null == t && (t = null);
                const r = this._source();
                if (!r) return t;
                if (e1.y < 0 || e1.y > 1) return t;
                const n = r.getSource().maxzoom, o = 1 << n, s = Math.floor(e1.x), a = e1.x - s, l = new qu(n, s, n, Math.floor(a * o), Math.floor(e1.y * o)), c = this.findDEMTileFor(l);
                if (!c || !c.dem) return t;
                const h = c.dem, u = 1 << c.tileID.canonical.z, d = (a * u - c.tileID.canonical.x) * h.dim, p = (e1.y * u - c.tileID.canonical.y) * h.dim, f = Math.floor(d), m = Math.floor(p);
                return (i ? this.exaggeration() : 1) * Kr(Kr(h.get(f, m), h.get(f, m + 1), p - m), Kr(h.get(f + 1, m), h.get(f + 1, m + 1), p - m), d - f);
            }
            getAtTileOffset(e1, t, i) {
                const r = 1 << e1.canonical.z;
                return this.getAtPointOrZero(new lp(e1.wrap + (e1.canonical.x + t / cr) / r, (e1.canonical.y + i / cr) / r));
            }
            getAtTileOffsetFunc(e1, t, i, r) {
                return (n)=>{
                    const o = this.getAtTileOffset(e1, n.x, n.y), s = r.upVector(e1.canonical, n.x, n.y), a = r.upVectorScale(e1.canonical, t, i).metersToTile;
                    return Du.scale(s, s, o * a), s;
                };
            }
            getForTilePoints(e1, t, i, r) {
                if (this.isUsingMockSource()) return !1;
                const n = Jm.create(this, e1, r);
                return !!n && (t.forEach((e1)=>{
                    e1[2] = this.exaggeration() * n.getElevationAt(e1[0], e1[1], i);
                }), !0);
            }
            getMinMaxForTile(e1) {
                if (this.isUsingMockSource()) return null;
                const t = this.findDEMTileFor(e1);
                if (!t || !t.dem) return null;
                const i = t.dem.tree, r = t.tileID, n = 1 << e1.canonical.z - r.canonical.z;
                let o = e1.canonical.x / n - r.canonical.x, s = e1.canonical.y / n - r.canonical.y, a = 0;
                for(let t = 0; t < e1.canonical.z - r.canonical.z && !i.leaves[a]; t++){
                    o *= 2, s *= 2;
                    const e1 = 2 * Math.floor(s) + Math.floor(o);
                    a = i.childOffsets[a] + e1, o %= 1, s %= 1;
                }
                return {
                    min: this.exaggeration() * i.minimums[a],
                    max: this.exaggeration() * i.maximums[a]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(e1, t, i) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(e1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(e1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const e1 = this.visibleDemTiles;
                if (0 === e1.length) return null;
                let t = !1, i = Number.MAX_VALUE, r = Number.MIN_VALUE;
                for (const n of e1){
                    const e1 = this.getMinMaxForTile(n.tileID);
                    e1 && (i = Math.min(i, e1.min), r = Math.max(r, e1.max), t = !0);
                }
                return t ? {
                    min: i,
                    max: r
                } : null;
            }
        }
        class Jm {
            constructor(e1, t, i){
                this._demTile = e1, this._dem = this._demTile.dem, this._scale = t, this._offset = i;
            }
            static create(e1, t, i) {
                const r = i || e1.findDEMTileFor(t);
                if (!r || !r.dem) return;
                const n = r.dem, o = r.tileID, s = 1 << t.canonical.z - o.canonical.z;
                return new Jm(r, n.dim / cr / s, [
                    (t.canonical.x / s - o.canonical.x) * n.dim,
                    (t.canonical.y / s - o.canonical.y) * n.dim
                ]);
            }
            tileCoordToPixel(e1, t) {
                const i = t * this._scale + this._offset[1], r = Math.floor(e1 * this._scale + this._offset[0]), n = Math.floor(i);
                return new y(r, n);
            }
            getElevationAt(e1, t, i, r) {
                const n = e1 * this._scale + this._offset[0], o = t * this._scale + this._offset[1], s = Math.floor(n), a = Math.floor(o), l = this._dem;
                return r = !!r, i ? Kr(Kr(l.get(s, a, r), l.get(s, a + 1, r), o - a), Kr(l.get(s + 1, a, r), l.get(s + 1, a + 1, r), o - a), n - s) : l.get(s, a, r);
            }
            getElevationAtPixel(e1, t, i) {
                return this._dem.get(e1, t, !!i);
            }
            getMeterToDEM(e1) {
                return (1 << this._demTile.tileID.canonical.z) * Qd(1, e1) * this._dem.stride;
            }
        }
        class Qm {
            constructor(e1, t){
                this.tileID = e1, this.x = e1.canonical.x, this.y = e1.canonical.y, this.z = e1.canonical.z, this.grid = new Ps(cr, 16, 0), this.featureIndexArray = new ml, this.promoteId = t;
            }
            insert(e1, t, i, r, n, o = 0) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(i, r, n, o);
                const a = this.grid;
                for(let e1 = 0; e1 < t.length; e1++){
                    const i = t[e1], r = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const t = i[e1];
                        r[0] = Math.min(r[0], t.x), r[1] = Math.min(r[1], t.y), r[2] = Math.max(r[2], t.x), r[3] = Math.max(r[3], t.y);
                    }
                    r[0] < cr && r[1] < cr && r[2] >= 0 && r[3] >= 0 && a.insert(s, r[0], r[1], r[2], r[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new cm(new km(this.rawTileData)).layers, this.sourceLayerCoder = new dm(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const e1 in this.vtLayers)this.vtFeatures[e1] = [];
                }
                return this.vtLayers;
            }
            query(e1, t, i, r) {
                this.loadVTLayers();
                const n = e1.params || {}, o = Fo(n.filter), s = e1.tileResult, a = e1.transform, l = s.bufferedTilespaceBounds, c = this.grid.query(l.min.x, l.min.y, l.max.x, l.max.y, (e1, t, i, r)=>Pp(s.bufferedTilespaceGeometry, e1, t, i, r));
                c.sort(t_);
                let h = null;
                a.elevation && c.length > 0 && (h = Jm.create(a.elevation, this.tileID));
                const u = {};
                let d;
                for(let a = 0; a < c.length; a++){
                    const l = c[a];
                    if (l === d) continue;
                    d = l;
                    const p = this.featureIndexArray.get(l);
                    let f = null;
                    this.loadMatchingFeature(u, p, o, n.layers, n.availableImages, t, i, r, (t, i, r, n = 0)=>(f || (f = _p(t, this.tileID.canonical, e1.tileTransform)), i.queryIntersectsFeature(s, t, r, f, this.z, e1.transform, e1.pixelPosMatrix, h, n)));
                }
                return u;
            }
            loadMatchingFeature(e1, t, i, r, n, o, s, a, l) {
                const { featureIndex: c, bucketIndex: h, sourceLayerIndex: u, layoutVertexArrayOffset: d } = t, p = this.bucketLayerIDs[h];
                if (r && !function(e1, t) {
                    for(let i = 0; i < e1.length; i++)if (t.indexOf(e1[i]) >= 0) return !0;
                    return !1;
                }(r, p)) return;
                const f = this.sourceLayerCoder.decode(u), m = this.vtLayers[f].feature(c);
                if (i.needGeometry) {
                    const e1 = gp(m, !0);
                    if (!i.filter(new oa(this.tileID.overscaledZ), e1, this.tileID.canonical)) return;
                } else if (!i.filter(new oa(this.tileID.overscaledZ), m)) return;
                const _ = this.getId(m, f);
                for(let t = 0; t < p.length; t++){
                    const i = p[t];
                    if (r && r.indexOf(i) < 0) continue;
                    const h = o[i];
                    if (!h) continue;
                    let u = {};
                    void 0 !== _ && a && (u = a.getState(h.sourceLayer || "_geojsonTileLayer", _));
                    const f = k({}, s[i]);
                    f.paint = e_(f.paint, h.paint, m, u, n), f.layout = e_(f.layout, h.layout, m, u, n);
                    const g = !l || l(m, h, u, d);
                    if (!g) continue;
                    const y = new Bm(m, this.z, this.x, this.y, _);
                    y.layer = f;
                    let x = e1[i];
                    void 0 === x && (x = e1[i] = []), x.push({
                        featureIndex: c,
                        feature: y,
                        intersectionZ: g
                    });
                }
            }
            lookupSymbolFeatures(e1, t, i, r, n, o, s, a) {
                const l = {};
                this.loadVTLayers();
                const c = Fo(n);
                for (const n of e1)this.loadMatchingFeature(l, {
                    bucketIndex: i,
                    sourceLayerIndex: r,
                    featureIndex: n,
                    layoutVertexArrayOffset: 0
                }, c, o, s, a, t);
                return l;
            }
            loadFeature(e1) {
                const { featureIndex: t, sourceLayerIndex: i } = e1;
                this.loadVTLayers();
                const r = this.sourceLayerCoder.decode(i), n = this.vtFeatures[r];
                if (n[t]) return n[t];
                const o = this.vtLayers[r].feature(t);
                return n[t] = o, o;
            }
            hasLayer(e1) {
                for (const t of this.bucketLayerIDs)for (const i of t)if (e1 === i) return !0;
                return !1;
            }
            getId(e1, t) {
                let i = e1.id;
                if (this.promoteId) {
                    const r = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[t];
                    null != r && (i = e1.properties[r]), "boolean" == typeof i && (i = Number(i));
                }
                return i;
            }
        }
        function e_(e1, t, i, r, n) {
            return q(e1, (e1, o)=>{
                const s = t instanceof pa ? t.get(o) : null;
                return s && s.evaluate ? s.evaluate(i, r, n) : s;
            });
        }
        function t_(e1, t) {
            return t - e1;
        }
        Rs(Qm, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const i_ = Ia([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), r_ = Ia([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), n_ = Ia([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        Ia([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const o_ = Ia([
            {
                name: "a_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), s_ = Ia([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), a_ = Ia([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]), l_ = Ia([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        Ia([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const c_ = Ia([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), h_ = Ia([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        Ia([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Ia([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), Ia([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            }
        ]), Ia([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Ia([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        var u_ = 24;
        const d_ = 128;
        function p_(e1, t) {
            const { expression: i } = t;
            if ("constant" === i.kind) return {
                kind: "constant",
                layoutSize: i.evaluate(new oa(e1 + 1))
            };
            if ("source" === i.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: t, interpolationType: r } = i;
                let n = 0;
                for(; n < t.length && t[n] <= e1;)n++;
                n = Math.max(0, n - 1);
                let o = n;
                for(; o < t.length && t[o] < e1 + 1;)o++;
                o = Math.min(t.length - 1, o);
                const s = t[n], a = t[o];
                return "composite" === i.kind ? {
                    kind: "composite",
                    minZoom: s,
                    maxZoom: a,
                    interpolationType: r
                } : {
                    kind: "camera",
                    minZoom: s,
                    maxZoom: a,
                    minSize: i.evaluate(new oa(s)),
                    maxSize: i.evaluate(new oa(a)),
                    interpolationType: r
                };
            }
        }
        function f_(e1, { uSize: t, uSizeT: i }, { lowerSize: r, upperSize: n }) {
            return "source" === e1.kind ? r / d_ : "composite" === e1.kind ? Kr(r / d_, n / d_, i) : t;
        }
        function m_(e1, t) {
            let i = 0, r = 0;
            if ("constant" === e1.kind) r = e1.layoutSize;
            else if ("source" !== e1.kind) {
                const { interpolationType: n, minZoom: o, maxZoom: s } = e1, a = n ? z(bn.interpolationFactor(n, t, o, s), 0, 1) : 0;
                "camera" === e1.kind ? r = Kr(e1.minSize, e1.maxSize, a) : i = a;
            }
            return {
                uSizeT: i,
                uSize: r
            };
        }
        var __ = Object.freeze({
            __proto__: null,
            SIZE_PACK_FACTOR: d_,
            evaluateSizeForFeature: f_,
            evaluateSizeForZoom: m_,
            getSizeData: p_
        });
        function g_(e1, t, i) {
            return e1.sections.forEach((e1)=>{
                e1.text = function(e1, t, i) {
                    const r = t.layout.get("text-transform").evaluate(i, {});
                    return "uppercase" === r ? e1 = e1.toLocaleUpperCase() : "lowercase" === r && (e1 = e1.toLocaleLowerCase()), na.applyArabicShaping && (e1 = na.applyArabicShaping(e1)), e1;
                }(e1.text, t, i);
            }), e1;
        }
        const y_ = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42",
            "\u2190": "\u2191",
            "\u2192": "\u2193"
        };
        function x_(e1) {
            return "\uFE36" === e1 || "\uFE48" === e1 || "\uFE38" === e1 || "\uFE44" === e1 || "\uFE42" === e1 || "\uFE3E" === e1 || "\uFE3C" === e1 || "\uFE3A" === e1 || "\uFE18" === e1 || "\uFE40" === e1 || "\uFE10" === e1 || "\uFE13" === e1 || "\uFE14" === e1 || "\uFF40" === e1 || "\uFFE3" === e1 || "\uFE11" === e1 || "\uFE12" === e1;
        }
        function v_(e1) {
            return "\uFE35" === e1 || "\uFE47" === e1 || "\uFE37" === e1 || "\uFE43" === e1 || "\uFE41" === e1 || "\uFE3D" === e1 || "\uFE3B" === e1 || "\uFE39" === e1 || "\uFE17" === e1 || "\uFE3F" === e1;
        }
        const b_ = 3;
        function w_(e1, t, i) {
            t.glyphs = [], 1 === e1 && i.readMessage(T_, t);
        }
        function T_(e1, t, i) {
            if (3 === e1) {
                const { id: e1, bitmap: r, width: n, height: o, left: s, top: a, advance: l } = i.readMessage(E_, {});
                t.glyphs.push({
                    id: e1,
                    bitmap: new Qp({
                        width: n + 2 * b_,
                        height: o + 2 * b_
                    }, r),
                    metrics: {
                        width: n,
                        height: o,
                        left: s,
                        top: a,
                        advance: l
                    }
                });
            } else 4 === e1 ? t.ascender = i.readSVarint() : 5 === e1 && (t.descender = i.readSVarint());
        }
        function E_(e1, t, i) {
            1 === e1 ? t.id = i.readVarint() : 2 === e1 ? t.bitmap = i.readBytes() : 3 === e1 ? t.width = i.readVarint() : 4 === e1 ? t.height = i.readVarint() : 5 === e1 ? t.left = i.readSVarint() : 6 === e1 ? t.top = i.readSVarint() : 7 === e1 && (t.advance = i.readVarint());
        }
        const M_ = b_, A_ = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        }, S_ = -17;
        class I_ {
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
            static forText(e1, t) {
                const i = new I_;
                return i.scale = e1 || 1, i.fontStack = t, i;
            }
            static forImage(e1) {
                const t = new I_;
                return t.imageName = e1, t;
            }
        }
        class C_ {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(e1, t) {
                const i = new C_;
                for(let r = 0; r < e1.sections.length; r++){
                    const n = e1.sections[r];
                    n.image ? i.addImageSection(n) : i.addTextSection(n, t);
                }
                return i;
            }
            length() {
                return this.text.length;
            }
            getSection(e1) {
                return this.sections[this.sectionIndex[e1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(e1) {
                return this.sectionIndex[e1];
            }
            getCodePoint(e1) {
                return this.text.codePointAt(e1);
            }
            verticalizePunctuation(e1) {
                this.text = function(e1, t) {
                    let i = "";
                    for(let r = 0; r < e1.length; r++){
                        const n = e1.charCodeAt(r + 1) || null, o = e1.charCodeAt(r - 1) || null;
                        i += !t && (n && Gs(n) && !y_[e1[r + 1]] || o && Gs(o) && !y_[e1[r - 1]]) || !y_[e1[r]] ? e1[r] : y_[e1[r]];
                    }
                    return i;
                }(this.text, e1);
            }
            trim() {
                let e1 = 0;
                for(let t = 0; t < this.text.length && P_[this.text.charCodeAt(t)]; t++)e1++;
                let t = this.text.length;
                for(let i = this.text.length - 1; i >= 0 && i >= e1 && P_[this.text.charCodeAt(i)]; i--)t--;
                this.text = this.text.substring(e1, t), this.sectionIndex = this.sectionIndex.slice(e1, t);
            }
            substring(e1, t) {
                const i = new C_;
                return i.text = this.text.substring(e1, t), i.sectionIndex = this.sectionIndex.slice(e1, t), i.sections = this.sections, i;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((e1, t)=>Math.max(e1, this.sections[t].scale), 0);
            }
            addTextSection(e1, t) {
                this.text += e1.text, this.sections.push(I_.forText(e1.scale, e1.fontStack || t));
                const i = this.sections.length - 1;
                for(let t = 0; t < e1.text.length; ++t)this.sectionIndex.push(i);
            }
            addImageSection(e1) {
                const t = e1.image ? e1.image.namePrimary : "";
                if (0 === t.length) return void H("Can't add FormattedSection with an empty image.");
                const i = this.getNextImageSectionCharCode();
                i ? (this.text += String.fromCodePoint(i), this.sections.push(I_.forImage(t)), this.sectionIndex.push(this.sections.length - 1)) : H("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function z_(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f) {
            const m = C_.fromFeature(e1, n);
            u === A_.vertical && m.verticalizePunctuation(d);
            let _ = [];
            const g = function(e1, t, i, r, n, o) {
                if (!e1) return [];
                const s = [], a = function(e1, t, i, r, n, o) {
                    let s = 0;
                    for(let i = 0; i < e1.length(); i++){
                        const a = e1.getSection(i);
                        s += R_(e1.getCodePoint(i), a, r, n, t, o);
                    }
                    return s / Math.max(1, Math.ceil(s / i));
                }(e1, t, i, r, n, o), l = e1.text.indexOf("\u200B") >= 0;
                let c = 0;
                for(let i = 0; i < e1.length(); i++){
                    const u = e1.getSection(i), d = e1.getCodePoint(i);
                    if (P_[d] || (c += R_(d, u, r, n, t, o)), i < e1.length() - 1) {
                        const t = !((h = d) < 11904 || !(Fs["Bopomofo Extended"](h) || Fs.Bopomofo(h) || Fs["CJK Compatibility Forms"](h) || Fs["CJK Compatibility Ideographs"](h) || Fs["CJK Compatibility"](h) || Fs["CJK Radicals Supplement"](h) || Fs["CJK Strokes"](h) || Fs["CJK Symbols and Punctuation"](h) || Fs["CJK Unified Ideographs Extension A"](h) || Fs["CJK Unified Ideographs"](h) || Fs["Enclosed CJK Letters and Months"](h) || Fs["Halfwidth and Fullwidth Forms"](h) || Fs.Hiragana(h) || Fs["Ideographic Description Characters"](h) || Fs["Kangxi Radicals"](h) || Fs["Katakana Phonetic Extensions"](h) || Fs.Katakana(h) || Fs["Vertical Forms"](h) || Fs["Yi Radicals"](h) || Fs["Yi Syllables"](h)));
                        (D_[d] || t || u.imageName) && s.push(O_(i + 1, c, a, s, k_(d, e1.getCodePoint(i + 1), t && l), !1));
                    }
                }
                var h;
                return B_(O_(e1.length(), c, a, s, 0, !0));
            }(m, c, o, t, r, p), { processBidirectionalText: y, processStyledBidirectionalText: x } = na;
            if (y && 1 === m.sections.length) {
                const e1 = y(m.toString(), g);
                for (const t of e1){
                    const e1 = new C_;
                    e1.text = t, e1.sections = m.sections;
                    for(let i = 0; i < t.length; i++)e1.sectionIndex.push(0);
                    _.push(e1);
                }
            } else if (x) {
                const e1 = x(m.text, m.sectionIndex, g);
                for (const t of e1){
                    const e1 = new C_;
                    e1.text = t[0], e1.sectionIndex = t[1], e1.sections = m.sections, _.push(e1);
                }
            } else _ = function(e1, t) {
                const i = [], r = e1.text;
                let n = 0;
                for (const r of t)i.push(e1.substring(n, r)), n = r;
                return n < r.length && i.push(e1.substring(n, r.length)), i;
            }(m, g);
            const v = [], b = {
                positionedLines: v,
                text: m.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: u,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            return function(e1, t, i, r, n, o, s, a, l, c, h, u) {
                let d = 0, p = 0, f = 0;
                const m = "right" === a ? 1 : "left" === a ? 0 : .5;
                let _ = !1;
                for (const e1 of n){
                    const i = e1.getSections();
                    for (const e1 of i){
                        if (e1.imageName) continue;
                        const i = t[e1.fontStack];
                        if (i && (_ = void 0 !== i.ascender && void 0 !== i.descender, !_)) break;
                    }
                    if (!_) break;
                }
                let g = 0;
                for (const s of n){
                    s.trim();
                    const n = s.getMaxScale(), a = (n - 1) * u_, x = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e1.positionedLines[g] = x;
                    const v = x.positionedGlyphs;
                    let b = 0;
                    if (!s.length()) {
                        p += o, ++g;
                        continue;
                    }
                    let w = 0, T = 0;
                    for(let o = 0; o < s.length(); o++){
                        const a = s.getSection(o), f = s.getSectionIndex(o), m = s.getCodePoint(o);
                        let g = a.scale, x = null, E = null, M = null, A = u_, S = 0;
                        const I = !(l === A_.horizontal || !h && !js(m) || h && (P_[m] || (y = m, Fs.Arabic(y) || Fs["Arabic Supplement"](y) || Fs["Arabic Extended-A"](y) || Fs["Arabic Presentation Forms-A"](y) || Fs["Arabic Presentation Forms-B"](y))));
                        if (a.imageName) {
                            const t = r[a.imageName];
                            if (!t) continue;
                            M = a.imageName, e1.iconsInText = e1.iconsInText || !0, E = t.paddedRect;
                            const i = t.displaySize;
                            g = g * u_ / u, x = {
                                width: i[0],
                                height: i[1],
                                left: 0,
                                top: -M_,
                                advance: I ? i[1] : i[0],
                                localGlyph: !1
                            }, S = _ ? -x.height * g : S_ + n * u_ - i[1] * g, A = x.advance;
                            const o = (I ? i[0] : i[1]) * g - u_ * n;
                            o > 0 && o > b && (b = o);
                        } else {
                            const e1 = i[a.fontStack];
                            if (!e1) continue;
                            e1[m] && (E = e1[m]);
                            const r = t[a.fontStack];
                            if (!r) continue;
                            const o = r.glyphs[m];
                            if (!o) continue;
                            if (x = o.metrics, A = 8203 !== m ? u_ : 0, _) {
                                const e1 = void 0 !== r.ascender ? Math.abs(r.ascender) : 0, t = void 0 !== r.descender ? Math.abs(r.descender) : 0, i = (e1 + t) * g;
                                w < i && (w = i, T = (e1 - t) / 2 * g), S = -e1 * g;
                            } else S = S_ + (n - g) * u_;
                        }
                        I ? (e1.verticalizable = !0, v.push({
                            glyph: m,
                            imageName: M,
                            x: d,
                            y: p + S,
                            vertical: I,
                            scale: g,
                            localGlyph: x.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: f,
                            metrics: x,
                            rect: E
                        }), d += A * g + c) : (v.push({
                            glyph: m,
                            imageName: M,
                            x: d,
                            y: p + S,
                            vertical: I,
                            scale: g,
                            localGlyph: x.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: f,
                            metrics: x,
                            rect: E
                        }), d += x.advance * g + c);
                    }
                    0 !== v.length && (f = Math.max(d - c, f), _ ? N_(v, m, b, T, o * n / 2) : N_(v, m, b, 0, o / 2)), d = 0;
                    const E = o * n + b;
                    x.lineOffset = Math.max(b, a), p += E, ++g;
                }
                var y;
                const x = p, { horizontalAlign: v, verticalAlign: b } = F_(s);
                (function(e1, t, i, r, n, o) {
                    const s = (t - i) * n, a = -o * r;
                    for (const t of e1)for (const e1 of t.positionedGlyphs)e1.x += s, e1.y += a;
                })(e1.positionedLines, m, v, b, f, x), e1.top += -b * x, e1.bottom = e1.top + x, e1.left += -v * f, e1.right = e1.left + f, e1.hasBaseline = _;
            }(b, t, i, r, _, s, a, l, u, c, d, f), !function(e1) {
                for (const t of e1)if (0 !== t.positionedGlyphs.length) return !1;
                return !0;
            }(v) && b;
        }
        const P_ = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, D_ = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function R_(e1, t, i, r, n, o) {
            if (t.imageName) {
                const e1 = r[t.imageName];
                return e1 ? e1.displaySize[0] * t.scale * u_ / o + n : 0;
            }
            {
                const r = i[t.fontStack], o = r && r.glyphs[e1];
                return o ? o.metrics.advance * t.scale + n : 0;
            }
        }
        function L_(e1, t, i, r) {
            const n = Math.pow(e1 - t, 2);
            return r ? e1 < t ? n / 2 : 2 * n : n + Math.abs(i) * i;
        }
        function k_(e1, t, i) {
            let r = 0;
            return 10 === e1 && (r -= 1e4), i && (r += 150), 40 !== e1 && 65288 !== e1 || (r += 50), 41 !== t && 65289 !== t || (r += 50), r;
        }
        function O_(e1, t, i, r, n, o) {
            let s = null, a = L_(t, i, n, o);
            for (const e1 of r){
                const r = L_(t - e1.x, i, n, o) + e1.badness;
                r <= a && (s = e1, a = r);
            }
            return {
                index: e1,
                x: t,
                priorBreak: s,
                badness: a
            };
        }
        function B_(e1) {
            return e1 ? B_(e1.priorBreak).concat(e1.index) : [];
        }
        function F_(e1) {
            let t = .5, i = .5;
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    t = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    t = 0;
            }
            switch(e1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    i = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    i = 0;
            }
            return {
                horizontalAlign: t,
                verticalAlign: i
            };
        }
        function N_(e1, t, i, r, n) {
            if (!(t || i || r || n)) return;
            const o = e1.length - 1, s = e1[o], a = (s.x + s.metrics.advance * s.scale) * t;
            for(let t = 0; t <= o; t++)e1[t].x -= a, e1[t].y += i + r + n;
        }
        function U_(e1, t, i, r) {
            const { horizontalAlign: n, verticalAlign: o } = F_(r), s = i[0] - e1.displaySize[0] * n, a = i[1] - e1.displaySize[1] * o;
            return {
                imagePrimary: e1,
                imageSecondary: t,
                top: a,
                bottom: a + e1.displaySize[1],
                left: s,
                right: s + e1.displaySize[0]
            };
        }
        function V_(e1, t, i, r, n, o) {
            const s = e1.imagePrimary;
            let a;
            if (s.content) {
                const e1 = s.content, t = s.pixelRatio || 1;
                a = [
                    e1[0] / t,
                    e1[1] / t,
                    s.displaySize[0] - e1[2] / t,
                    s.displaySize[1] - e1[3] / t
                ];
            }
            const l = t.left * o, c = t.right * o;
            let h, u, d, p;
            "width" === i || "both" === i ? (p = n[0] + l - r[3], u = n[0] + c + r[1]) : (p = n[0] + (l + c - s.displaySize[0]) / 2, u = p + s.displaySize[0]);
            const f = t.top * o, m = t.bottom * o;
            return "height" === i || "both" === i ? (h = n[1] + f - r[0], d = n[1] + m + r[2]) : (h = n[1] + (f + m - s.displaySize[1]) / 2, d = h + s.displaySize[1]), {
                imagePrimary: s,
                imageSecondary: void 0,
                top: h,
                right: u,
                bottom: d,
                left: p,
                collisionPadding: a
            };
        }
        class j_ extends y {
            constructor(e1, t, i, r, n){
                super(e1, t), this.angle = r, this.z = i, void 0 !== n && (this.segment = n);
            }
            clone() {
                return new j_(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function G_(e1, t, i, r, n) {
            if (void 0 === t.segment) return !0;
            let o = t, s = t.segment + 1, a = 0;
            for(; a > -i / 2;){
                if (s--, s < 0) return !1;
                a -= e1[s].dist(o), o = e1[s];
            }
            a += e1[s].dist(e1[s + 1]), s++;
            const l = [];
            let c = 0;
            for(; a < i / 2;){
                const t = e1[s], i = e1[s + 1];
                if (!i) return !1;
                let o = e1[s - 1].angleTo(t) - t.angleTo(i);
                for(o = Math.abs((o + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: o
                }), c += o; a - l[0].distance > r;)c -= l.shift().angleDelta;
                if (c > n) return !1;
                s++, a += t.dist(i);
            }
            return !0;
        }
        function q_(e1) {
            let t = 0;
            for(let i = 0; i < e1.length - 1; i++)t += e1[i].dist(e1[i + 1]);
            return t;
        }
        function Z_(e1, t, i) {
            return e1 ? .6 * t * i : 0;
        }
        function $_(e1, t) {
            return Math.max(e1 ? e1.right - e1.left : 0, t ? t.right - t.left : 0);
        }
        function W_(e1, t, i, r, n, o) {
            const s = Z_(i, n, o), a = $_(i, r) * o;
            let l = 0;
            const c = q_(e1) / 2;
            for(let i = 0; i < e1.length - 1; i++){
                const r = e1[i], n = e1[i + 1], o = r.dist(n);
                if (l + o > c) {
                    const h = (c - l) / o, u = Kr(r.x, n.x, h), d = Kr(r.y, n.y, h), p = new j_(u, d, 0, n.angleTo(r), i);
                    return !s || G_(e1, p, a, s, t) ? p : void 0;
                }
                l += o;
            }
        }
        function H_(e1, t, i, r, n, o, s, a, l) {
            const c = Z_(r, o, s), h = $_(r, n), u = h * s, d = 0 === e1[0].x || e1[0].x === l || 0 === e1[0].y || e1[0].y === l;
            return t - u < t / 4 && (t = u + t / 4), X_(e1, d ? t / 2 * a % t : (h / 2 + 2 * o) * s * a % t, t, c, i, u, d, !1, l);
        }
        function X_(e1, t, i, r, n, o, s, a, l) {
            const c = o / 2, h = q_(e1);
            let u = 0, d = t - i, p = [];
            for(let t = 0; t < e1.length - 1; t++){
                const s = e1[t], a = e1[t + 1], f = s.dist(a), m = a.angleTo(s);
                for(; d + i < u + f;){
                    d += i;
                    const _ = (d - u) / f, g = Kr(s.x, a.x, _), y = Kr(s.y, a.y, _);
                    if (g >= 0 && g < l && y >= 0 && y < l && d - c >= 0 && d + c <= h) {
                        const i = new j_(g, y, 0, m, t);
                        r && !G_(e1, i, o, r, n) || p.push(i);
                    }
                }
                u += f;
            }
            return a || p.length || s || (p = X_(e1, u / 2, i, r, n, o, s, !0, l)), p;
        }
        function Y_(e1, t, i, r, n) {
            const o = [];
            for(let s = 0; s < e1.length; s++){
                const a = e1[s];
                let l;
                for(let e1 = 0; e1 < a.length - 1; e1++){
                    let s = a[e1], c = a[e1 + 1];
                    s.x < t && c.x < t || (s.x < t ? s = new y(t, s.y + (t - s.x) / (c.x - s.x) * (c.y - s.y))._round() : c.x < t && (c = new y(t, s.y + (t - s.x) / (c.x - s.x) * (c.y - s.y))._round()), s.y < i && c.y < i || (s.y < i ? s = new y(s.x + (i - s.y) / (c.y - s.y) * (c.x - s.x), i)._round() : c.y < i && (c = new y(s.x + (i - s.y) / (c.y - s.y) * (c.x - s.x), i)._round()), s.x >= r && c.x >= r || (s.x >= r ? s = new y(r, s.y + (r - s.x) / (c.x - s.x) * (c.y - s.y))._round() : c.x >= r && (c = new y(r, s.y + (r - s.x) / (c.x - s.x) * (c.y - s.y))._round()), s.y >= n && c.y >= n || (s.y >= n ? s = new y(s.x + (n - s.y) / (c.y - s.y) * (c.x - s.x), n)._round() : c.y >= n && (c = new y(s.x + (n - s.y) / (c.y - s.y) * (c.x - s.x), n)._round()), l && s.equals(l[l.length - 1]) || (l = [
                        s
                    ], o.push(l)), l.push(c)))));
                }
            }
            return o;
        }
        function K_(e1) {
            let t = 0, i = 0;
            for (const r of e1)t += r.w * r.h, i = Math.max(i, r.w);
            e1.sort((e1, t)=>t.h - e1.h);
            const r = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(t / .95)), i),
                    h: 1 / 0
                }
            ];
            let n = 0, o = 0;
            for (const t of e1)for(let e1 = r.length - 1; e1 >= 0; e1--){
                const i = r[e1];
                if (!(t.w > i.w || t.h > i.h)) {
                    if (t.x = i.x, t.y = i.y, o = Math.max(o, t.y + t.h), n = Math.max(n, t.x + t.w), t.w === i.w && t.h === i.h) {
                        const t = r.pop();
                        e1 < r.length && (r[e1] = t);
                    } else t.h === i.h ? (i.x += t.w, i.w -= t.w) : t.w === i.w ? (i.y += t.h, i.h -= t.h) : (r.push({
                        x: i.x + t.w,
                        y: i.y,
                        w: i.w - t.w,
                        h: t.h
                    }), i.y += t.h, i.h -= t.h);
                    break;
                }
            }
            return {
                w: n,
                h: o,
                fill: t / (n * o) || 0
            };
        }
        Rs(j_, "Anchor");
        const J_ = 1;
        class Q_ {
            constructor(e1, { pixelRatio: t, version: i, stretchX: r, stretchY: n, content: o }){
                this.paddedRect = e1, this.pixelRatio = t, this.stretchX = r, this.stretchY = n, this.content = o, this.version = i;
            }
            get tl() {
                return [
                    this.paddedRect.x + J_,
                    this.paddedRect.y + J_
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - J_,
                    this.paddedRect.y + this.paddedRect.h - J_
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * J_) / this.pixelRatio,
                    (this.paddedRect.h - 2 * J_) / this.pixelRatio
                ];
            }
        }
        class eg {
            constructor(e1, t){
                const i = {}, r = {};
                this.haveRenderCallbacks = [];
                const n = [];
                this.addImages(e1, i, n), this.addImages(t, r, n);
                const { w: o, h: s } = K_(n), a = new ef({
                    width: o || 1,
                    height: s || 1
                });
                for(const t in e1){
                    const r = e1[t], n = i[t].paddedRect;
                    ef.copy(r.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n.x + J_,
                        y: n.y + J_
                    }, r.data);
                }
                for(const e1 in t){
                    const i = t[e1], n = r[e1].paddedRect, o = n.x + J_, s = n.y + J_, l = i.data.width, c = i.data.height;
                    ef.copy(i.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: s
                    }, i.data), ef.copy(i.data, a, {
                        x: 0,
                        y: c - 1
                    }, {
                        x: o,
                        y: s - 1
                    }, {
                        width: l,
                        height: 1
                    }), ef.copy(i.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: s + c
                    }, {
                        width: l,
                        height: 1
                    }), ef.copy(i.data, a, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: o - 1,
                        y: s
                    }, {
                        width: 1,
                        height: c
                    }), ef.copy(i.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + l,
                        y: s
                    }, {
                        width: 1,
                        height: c
                    });
                }
                this.image = a, this.iconPositions = i, this.patternPositions = r;
            }
            addImages(e1, t, i) {
                for(const r in e1){
                    const n = e1[r], o = {
                        x: 0,
                        y: 0,
                        w: n.data.width + 2 * J_,
                        h: n.data.height + 2 * J_
                    };
                    i.push(o), t[r] = new Q_(o, n), n.hasRenderCallback && this.haveRenderCallbacks.push(r);
                }
            }
            patchUpdatedImages(e1, t, i) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((t)=>e1.hasImage(t, i)), e1.dispatchRenderCallbacks(this.haveRenderCallbacks, i);
                for(const r in e1.getUpdatedImages(i))this.patchUpdatedImage(this.iconPositions[r], e1.getImage(r, i), t), this.patchUpdatedImage(this.patternPositions[r], e1.getImage(r, i), t);
            }
            patchUpdatedImage(e1, t, i) {
                if (!e1 || !t) return;
                if (e1.version === t.version) return;
                e1.version = t.version;
                const [r, n] = e1.tl;
                i.update(t.data, void 0, {
                    x: r,
                    y: n
                });
            }
        }
        Rs(Q_, "ImagePosition"), Rs(eg, "ImageAtlas");
        const tg = 1e20;
        function ig(e1, t, i, r, n, o, s, a, l) {
            for(let c = t; c < t + r; c++)rg(e1, i * o + c, o, n, s, a, l);
            for(let c = i; c < i + n; c++)rg(e1, c * o + t, 1, r, s, a, l);
        }
        function rg(e1, t, i, r, n, o, s) {
            o[0] = 0, s[0] = -tg, s[1] = tg, n[0] = e1[t];
            for(let a = 1, l = 0, c = 0; a < r; a++){
                n[a] = e1[t + a * i];
                const r = a * a;
                do {
                    const e1 = o[l];
                    c = (n[a] - n[e1] + r - e1 * e1) / (a - e1) / 2;
                }while (c <= s[l] && --l > -1);
                l++, o[l] = a, s[l] = c, s[l + 1] = tg;
            }
            for(let a = 0, l = 0; a < r; a++){
                for(; s[l + 1] < a;)l++;
                const r = o[l], c = a - r;
                e1[t + a * i] = n[r] + c * c;
            }
        }
        const ng = 2;
        class og {
            constructor(e1, t, i){
                this.requestManager = e1, this.localGlyphMode = t, this.localFontFamily = i, this.urls = {}, this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
            setURL(e1, t) {
                this.urls[t] = e1;
            }
            getGlyphs(e1, t, i) {
                const r = [], o = this.urls[t] || n.GLYPHS_URL;
                for(const t in e1)for (const i of e1[t])r.push({
                    stack: t,
                    id: i
                });
                R(r, ({ stack: e1, id: t }, i)=>{
                    let r = this.entries[e1];
                    r || (r = this.entries[e1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let n = r.glyphs[t];
                    if (void 0 !== n) return void i(null, {
                        stack: e1,
                        id: t,
                        glyph: n
                    });
                    if (n = this._tinySDF(r, e1, t), n) return r.glyphs[t] = n, void i(null, {
                        stack: e1,
                        id: t,
                        glyph: n
                    });
                    const s = Math.floor(t / 256);
                    if (256 * s > 65535) return void i(new Error("glyphs > 65535 not supported"));
                    if (r.ranges[s]) return void i(null, {
                        stack: e1,
                        id: t,
                        glyph: n
                    });
                    let a = r.requests[s];
                    a || (a = r.requests[s] = [], og.loadGlyphRange(e1, s, o, this.requestManager, (e1, t)=>{
                        if (t) {
                            r.ascender = t.ascender, r.descender = t.descender;
                            for(const e1 in t.glyphs)this._doesCharSupportLocalGlyph(+e1) || (r.glyphs[+e1] = t.glyphs[+e1]);
                            r.ranges[s] = !0;
                        }
                        for (const i of a)i(e1, t);
                        delete r.requests[s];
                    })), a.push((r, n)=>{
                        r ? i(r) : n && i(null, {
                            stack: e1,
                            id: t,
                            glyph: n.glyphs[t] || null
                        });
                    });
                }, (e1, t)=>{
                    if (e1) i(e1);
                    else if (t) {
                        const e1 = {};
                        for (const { stack: i, id: r, glyph: n } of t)void 0 === e1[i] && (e1[i] = {}), void 0 === e1[i].glyphs && (e1[i].glyphs = {}), e1[i].glyphs[r] = n && {
                            id: n.id,
                            bitmap: n.bitmap.clone(),
                            metrics: n.metrics
                        }, e1[i].ascender = this.entries[i].ascender, e1[i].descender = this.entries[i].descender;
                        i(null, e1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e1) {
                return 0 !== this.localGlyphMode && (2 === this.localGlyphMode ? !!this.localFontFamily : !!this.localFontFamily && (Fs["CJK Unified Ideographs"](e1) || Fs["Hangul Syllables"](e1) || Fs.Hiragana(e1) || Fs.Katakana(e1) || Fs["CJK Symbols and Punctuation"](e1) || Fs["CJK Unified Ideographs Extension A"](e1) || Fs["CJK Unified Ideographs Extension B"](e1)));
            }
            _tinySDF(e1, t, i) {
                const r = this.localFontFamily;
                if (!r || !this._doesCharSupportLocalGlyph(i)) return;
                let n = e1.tinySDF;
                if (!n) {
                    let i = "400";
                    /bold/i.test(t) ? i = "900" : /medium/i.test(t) ? i = "500" : /light/i.test(t) && (i = "200"), n = e1.tinySDF = new og.TinySDF({
                        fontFamily: r,
                        fontWeight: i,
                        fontSize: 24 * ng,
                        buffer: 3 * ng,
                        radius: 8 * ng
                    }), n.fontWeight = i;
                }
                if (this.localGlyphs[n.fontWeight][i]) return this.localGlyphs[n.fontWeight][i];
                const o = String.fromCodePoint(i), { data: s, width: a, height: l, glyphWidth: c, glyphHeight: h, glyphLeft: u, glyphTop: d, glyphAdvance: p } = n.draw(o);
                return this.localGlyphs[n.fontWeight][i] = {
                    id: i,
                    bitmap: new Qp({
                        width: a,
                        height: l
                    }, s),
                    metrics: {
                        width: c / ng,
                        height: h / ng,
                        left: u / ng,
                        top: d / ng - 27,
                        advance: p / ng,
                        localGlyph: !0
                    }
                };
            }
        }
        og.loadGlyphRange = function(e1, t, i, r, n) {
            const o = 256 * t, s = o + 255, a = r.transformRequest(r.normalizeGlyphsURL(i).replace("{fontstack}", e1).replace("{range}", `${o}-${s}`), ye.Glyphs);
            Te(a, (e1, t)=>{
                if (e1) n(e1);
                else if (t) {
                    const e1 = {}, i = function(e1) {
                        return new km(e1).readFields(w_, {});
                    }(t);
                    for (const t of i.glyphs)e1[t.id] = t;
                    n(null, {
                        glyphs: e1,
                        ascender: i.ascender,
                        descender: i.descender
                    });
                }
            });
        }, og.TinySDF = class {
            constructor({ fontSize: e1 = 24, buffer: t = 3, radius: i = 8, cutoff: r = .25, fontFamily: n = "sans-serif", fontWeight: o = "normal", fontStyle: s = "normal" } = {}){
                this.buffer = t, this.cutoff = r, this.radius = i;
                const a = this.size = e1 + 4 * t, l = this._createCanvas(a), c = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${s} ${o} ${e1}px ${n}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(a * a), this.gridInner = new Float64Array(a * a), this.f = new Float64Array(a), this.z = new Float64Array(a + 1), this.v = new Uint16Array(a);
            }
            _createCanvas(e1) {
                const t = document.createElement("canvas");
                return t.width = t.height = e1, t;
            }
            draw(e1) {
                const { width: t, actualBoundingBoxAscent: i, actualBoundingBoxDescent: r, actualBoundingBoxLeft: n, actualBoundingBoxRight: o } = this.ctx.measureText(e1), s = Math.ceil(i), a = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - n))), l = Math.min(this.size - this.buffer, s + Math.ceil(r)), c = a + 2 * this.buffer, h = l + 2 * this.buffer, u = Math.max(c * h, 0), d = new Uint8ClampedArray(u), p = {
                    data: d,
                    width: c,
                    height: h,
                    glyphWidth: a,
                    glyphHeight: l,
                    glyphTop: s,
                    glyphLeft: 0,
                    glyphAdvance: t
                };
                if (0 === a || 0 === l) return p;
                const { ctx: f, buffer: m, gridInner: _, gridOuter: g } = this;
                f.clearRect(m, m, a, l), f.fillText(e1, m, m + s);
                const y = f.getImageData(m, m, a, l);
                g.fill(tg, 0, u), _.fill(0, 0, u);
                for(let e1 = 0; e1 < l; e1++)for(let t = 0; t < a; t++){
                    const i = y.data[4 * (e1 * a + t) + 3] / 255;
                    if (0 === i) continue;
                    const r = (e1 + m) * c + t + m;
                    if (1 === i) g[r] = 0, _[r] = tg;
                    else {
                        const e1 = .5 - i;
                        g[r] = e1 > 0 ? e1 * e1 : 0, _[r] = e1 < 0 ? e1 * e1 : 0;
                    }
                }
                ig(g, 0, 0, c, h, c, this.f, this.v, this.z), ig(_, m, m, a, l, c, this.f, this.v, this.z);
                for(let e1 = 0; e1 < u; e1++){
                    const t = Math.sqrt(g[e1]) - Math.sqrt(_[e1]);
                    d[e1] = Math.round(255 - 255 * (t / this.radius + this.cutoff));
                }
                return p;
            }
        };
        const sg = J_;
        function ag(e1, t, i, r) {
            const n = [], o = e1.imagePrimary, s = o.pixelRatio, a = o.paddedRect.w - 2 * sg, l = o.paddedRect.h - 2 * sg, c = e1.right - e1.left, h = e1.bottom - e1.top, u = o.stretchX || [
                [
                    0,
                    a
                ]
            ], d = o.stretchY || [
                [
                    0,
                    l
                ]
            ], p = (e1, t)=>e1 + t[1] - t[0], f = u.reduce(p, 0), m = d.reduce(p, 0), _ = a - f, g = l - m;
            let x = 0, v = f, b = 0, w = m, T = 0, E = _, M = 0, A = g;
            if (o.content && r) {
                const e1 = o.content;
                x = lg(u, 0, e1[0]), b = lg(d, 0, e1[1]), v = lg(u, e1[0], e1[2]), w = lg(d, e1[1], e1[3]), T = e1[0] - x, M = e1[1] - b, E = e1[2] - e1[0] - v, A = e1[3] - e1[1] - w;
            }
            const S = (r, n, a, l)=>{
                const u = hg(r.stretch - x, v, c, e1.left), d = ug(r.fixed - T, E, r.stretch, f), p = hg(n.stretch - b, w, h, e1.top), _ = ug(n.fixed - M, A, n.stretch, m), g = hg(a.stretch - x, v, c, e1.left), S = ug(a.fixed - T, E, a.stretch, f), I = hg(l.stretch - b, w, h, e1.top), C = ug(l.fixed - M, A, l.stretch, m), z = new y(u, p), P = new y(g, p), D = new y(g, I), R = new y(u, I), L = new y(d / s, _ / s), k = new y(S / s, C / s), O = t * Math.PI / 180;
                if (O) {
                    const e1 = Math.sin(O), t = Math.cos(O), i = [
                        t,
                        -e1,
                        e1,
                        t
                    ];
                    z._matMult(i), P._matMult(i), R._matMult(i), D._matMult(i);
                }
                const B = r.stretch + r.fixed, F = a.stretch + a.fixed, N = n.stretch + n.fixed, U = l.stretch + l.fixed, V = e1.imageSecondary;
                return {
                    tl: z,
                    tr: P,
                    bl: R,
                    br: D,
                    texPrimary: {
                        x: o.paddedRect.x + sg + B,
                        y: o.paddedRect.y + sg + N,
                        w: F - B,
                        h: U - N
                    },
                    texSecondary: V ? {
                        x: V.paddedRect.x + sg + B,
                        y: V.paddedRect.y + sg + N,
                        w: F - B,
                        h: U - N
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: L,
                    pixelOffsetBR: k,
                    minFontScaleX: E / s / c,
                    minFontScaleY: A / s / h,
                    isSDF: i
                };
            };
            if (r && (o.stretchX || o.stretchY)) {
                const e1 = cg(u, _, f), t = cg(d, g, m);
                for(let i = 0; i < e1.length - 1; i++){
                    const r = e1[i], o = e1[i + 1];
                    for(let e1 = 0; e1 < t.length - 1; e1++)n.push(S(r, t[e1], o, t[e1 + 1]));
                }
            } else n.push(S({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: a + 1
            }, {
                fixed: 0,
                stretch: l + 1
            }));
            return n;
        }
        function lg(e1, t, i) {
            let r = 0;
            for (const n of e1)r += Math.max(t, Math.min(i, n[1])) - Math.max(t, Math.min(i, n[0]));
            return r;
        }
        function cg(e1, t, i) {
            const r = [
                {
                    fixed: -sg,
                    stretch: 0
                }
            ];
            for (const [t, i] of e1){
                const e1 = r[r.length - 1];
                r.push({
                    fixed: t - e1.stretch,
                    stretch: e1.stretch
                }), r.push({
                    fixed: t - e1.stretch,
                    stretch: e1.stretch + (i - t)
                });
            }
            return r.push({
                fixed: t + sg,
                stretch: i
            }), r;
        }
        function hg(e1, t, i, r) {
            return e1 / t * i + r;
        }
        function ug(e1, t, i, r) {
            return e1 - t * i / r;
        }
        function dg(e1, t, i, r) {
            const n = t + e1.positionedLines[r].lineOffset;
            return 0 === r ? i + n / 2 : i + (n + (t + e1.positionedLines[r - 1].lineOffset)) / 2;
        }
        function pg(e1, t = 1, i = !1) {
            let r = 1 / 0, n = 1 / 0, o = -1 / 0, s = -1 / 0;
            const a = e1[0];
            for(let e1 = 0; e1 < a.length; e1++){
                const t = a[e1];
                (!e1 || t.x < r) && (r = t.x), (!e1 || t.y < n) && (n = t.y), (!e1 || t.x > o) && (o = t.x), (!e1 || t.y > s) && (s = t.y);
            }
            const l = Math.min(o - r, s - n);
            let c = l / 2;
            const h = new lr([], fg);
            if (0 === l) return new y(r, n);
            for(let t = r; t < o; t += l)for(let i = n; i < s; i += l)h.push(new mg(t + c, i + c, c, e1));
            let u = function(e1) {
                let t = 0, i = 0, r = 0;
                const n = e1[0];
                for(let e1 = 0, o = n.length, s = o - 1; e1 < o; s = e1++){
                    const o = n[e1], a = n[s], l = o.x * a.y - a.x * o.y;
                    i += (o.x + a.x) * l, r += (o.y + a.y) * l, t += 3 * l;
                }
                return new mg(i / t, r / t, 0, e1);
            }(e1), d = h.length;
            for(; h.length;){
                const r = h.pop();
                (r.d > u.d || !u.d) && (u = r, i && console.log("found best %d after %d probes", Math.round(1e4 * r.d) / 1e4, d)), r.max - u.d <= t || (c = r.h / 2, h.push(new mg(r.p.x - c, r.p.y - c, c, e1)), h.push(new mg(r.p.x + c, r.p.y - c, c, e1)), h.push(new mg(r.p.x - c, r.p.y + c, c, e1)), h.push(new mg(r.p.x + c, r.p.y + c, c, e1)), d += 4);
            }
            return i && (console.log(`num probes: ${d}`), console.log(`best distance: ${u.d}`)), u.p;
        }
        function fg(e1, t) {
            return t.max - e1.max;
        }
        class mg {
            constructor(e1, t, i, r){
                this.p = new y(e1, t), this.h = i, this.d = function(e1, t) {
                    let i = !1, r = 1 / 0;
                    for(let n = 0; n < t.length; n++){
                        const o = t[n];
                        for(let t = 0, n = o.length, s = n - 1; t < n; s = t++){
                            const n = o[t], a = o[s];
                            n.y > e1.y != a.y > e1.y && e1.x < (a.x - n.x) * (e1.y - n.y) / (a.y - n.y) + n.x && (i = !i), r = Math.min(r, Ip(e1, n, a));
                        }
                    }
                    return (i ? 1 : -1) * Math.sqrt(r);
                }(this.p, r), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const _g = 7, gg = Number.POSITIVE_INFINITY, yg = Math.sqrt(2);
        function xg(e1, [t, i]) {
            let r = 0, n = 0;
            if (i === gg) {
                t < 0 && (t = 0);
                const i = t / yg;
                switch(e1){
                    case "top-right":
                    case "top-left":
                        n = i - _g;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = -i + _g;
                        break;
                    case "bottom":
                        n = -t + _g;
                        break;
                    case "top":
                        n = t - _g;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = t;
                        break;
                    case "right":
                        r = -t;
                }
            } else {
                switch(t = Math.abs(t), i = Math.abs(i), e1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        n = i - _g;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        n = -i + _g;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        r = -t;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        r = t;
                }
            }
            return [
                r,
                n
            ];
        }
        function vg(e1, t, i, r, n, o, s, a, l, c, h) {
            e1.createArrays(), e1.tilePixelRatio = cr / (512 * e1.overscaling), e1.compareText = {}, e1.iconsNeedLinear = !1;
            const u = e1.layers[0].layout, d = e1.layers[0]._unevaluatedLayout._values, p = {};
            if ("composite" === e1.textSizeData.kind) {
                const { minZoom: t, maxZoom: i } = e1.textSizeData;
                p.compositeTextSizes = [
                    d["text-size"].possiblyEvaluate(new oa(t), a),
                    d["text-size"].possiblyEvaluate(new oa(i), a)
                ];
            }
            if ("composite" === e1.iconSizeData.kind) {
                const { minZoom: t, maxZoom: i } = e1.iconSizeData;
                p.compositeIconSizes = [
                    d["icon-size"].possiblyEvaluate(new oa(t), a),
                    d["icon-size"].possiblyEvaluate(new oa(i), a)
                ];
            }
            p.layoutTextSize = d["text-size"].possiblyEvaluate(new oa(l + 1), a), p.layoutIconSize = d["icon-size"].possiblyEvaluate(new oa(l + 1), a), p.textMaxSize = d["text-size"].possiblyEvaluate(new oa(18), a);
            const f = "map" === u.get("text-rotation-alignment") && "point" !== u.get("symbol-placement"), m = u.get("text-size");
            let _ = !1;
            for (const t of e1.features)if (t.icon && t.icon.nameSecondary) {
                _ = !0;
                break;
            }
            for (const o of e1.features){
                const l = u.get("text-font").evaluate(o, {}, a).join(","), d = m.evaluate(o, {}, a), g = p.layoutTextSize.evaluate(o, {}, a), y = (p.layoutIconSize.evaluate(o, {}, a), {
                    horizontal: {},
                    vertical: void 0
                }), x = o.text;
                let v, b = [
                    0,
                    0
                ];
                if (x) {
                    const r = x.toString(), s = u.get("text-letter-spacing").evaluate(o, {}, a) * u_, c = u.get("text-line-height").evaluate(o, {}, a) * u_, h = Us(r) ? s : 0, p = u.get("text-anchor").evaluate(o, {}, a), m = u.get("text-variable-anchor");
                    if (!m) {
                        const e1 = u.get("text-radial-offset").evaluate(o, {}, a);
                        b = e1 ? xg(p, [
                            e1 * u_,
                            gg
                        ]) : u.get("text-offset").evaluate(o, {}, a).map((e1)=>e1 * u_);
                    }
                    let _ = f ? "center" : u.get("text-justify").evaluate(o, {}, a);
                    const v = "point" === u.get("symbol-placement"), w = v ? u.get("text-max-width").evaluate(o, {}, a) * u_ : 1 / 0, T = (o)=>{
                        e1.allowVerticalPlacement && Ns(r) && (y.vertical = z_(x, t, i, n, l, w, c, p, o, h, b, A_.vertical, !0, g, d));
                    };
                    if (!f && m) {
                        const e1 = "auto" === _ ? m.map((e1)=>bg(e1)) : [
                            _
                        ];
                        let r = !1;
                        for(let o = 0; o < e1.length; o++){
                            const s = e1[o];
                            if (!y.horizontal[s]) {
                                if (r) y.horizontal[s] = y.horizontal[0];
                                else {
                                    const e1 = z_(x, t, i, n, l, w, c, "center", s, h, b, A_.horizontal, !1, g, d);
                                    e1 && (y.horizontal[s] = e1, r = 1 === e1.positionedLines.length);
                                }
                            }
                        }
                        T("left");
                    } else {
                        if ("auto" === _ && (_ = bg(p)), v || u.get("text-writing-mode").indexOf("horizontal") >= 0 || !Ns(r)) {
                            const e1 = z_(x, t, i, n, l, w, c, p, _, h, b, A_.horizontal, !1, g, d);
                            e1 && (y.horizontal[_] = e1);
                        }
                        T(v ? "left" : _);
                    }
                }
                let w = !1;
                if (o.icon && o.icon.namePrimary) {
                    const t = r[o.icon.namePrimary];
                    t && (v = U_(n[o.icon.namePrimary], o.icon.nameSecondary ? n[o.icon.nameSecondary] : void 0, u.get("icon-offset").evaluate(o, {}, a), u.get("icon-anchor").evaluate(o, {}, a)), w = t.sdf, void 0 === e1.sdfIcons ? e1.sdfIcons = t.sdf : e1.sdfIcons !== t.sdf && H("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t.pixelRatio !== e1.pixelRatio || 0 !== u.get("icon-rotate").constantOr(1)) && (e1.iconsNeedLinear = !0));
                }
                const T = Ag(y.horizontal) || y.vertical;
                e1.iconsInText || (e1.iconsInText = !!T && T.iconsInText), (T || v) && wg(e1, o, y, v, r, p, g, 0, b, w, s, a, c, h, _);
            }
            o && e1.generateCollisionDebugBuffers(l, e1.collisionBoxArray);
        }
        function bg(e1) {
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function wg(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f) {
            let m = o.textMaxSize.evaluate(t, {}, u);
            void 0 === m && (m = s);
            const _ = e1.layers[0].layout, g = _.get("icon-offset").evaluate(t, {}, u), y = Ag(i.horizontal) || i.vertical, x = "globe" === d.name, v = u_, b = s / v, T = e1.tilePixelRatio * m / v, E = (D = e1.overscaling, e1.zoom > 18 && D > 2 && (D >>= 1), Math.max(cr / (512 * D), 1) * _.get("symbol-spacing")), M = _.get("text-padding") * e1.tilePixelRatio, A = _.get("icon-padding") * e1.tilePixelRatio, S = w(_.get("text-max-angle")), I = "map" === _.get("text-rotation-alignment") && "point" !== _.get("symbol-placement"), C = "map" === _.get("icon-rotation-alignment") && "point" !== _.get("symbol-placement"), z = _.get("symbol-placement"), P = E / 2;
            var D;
            const R = _.get("icon-text-fit").evaluate(t, {}, u), L = _.get("icon-text-fit-padding").evaluate(t, {}, u), k = "none" !== R;
            let O;
            !1 === e1.hasAnyIconTextFit && k && (e1.hasAnyIconTextFit = !0), r && k && (e1.allowVerticalPlacement && i.vertical && (O = V_(r, i.vertical, R, L, g, b)), y && (r = V_(r, y, R, L, g, b)));
            const B = (s, a, m)=>{
                if (a.x < 0 || a.x >= cr || a.y < 0 || a.y >= cr) return;
                let _ = null;
                if (x) {
                    const { x: e1, y: t, z: i } = d.projectTilePoint(a.x, a.y, m);
                    _ = {
                        anchor: new j_(e1, t, i, 0, void 0),
                        up: d.upVector(m, a.x, a.y)
                    };
                }
                !function(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A) {
                    const S = e1.addToLineVertexArray(t, r);
                    let I, C, z, P, D, R, L, k = 0, O = 0, B = 0, F = 0, N = -1, U = -1;
                    const V = {};
                    let j = Cl("");
                    const G = i ? i.anchor : t, q = "none" !== l.layout.get("icon-text-fit").evaluate(v, {}, E);
                    let Z = 0, $ = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [Z, $] = l.layout.get("text-offset").evaluate(v, {}, E).map((e1)=>e1 * u_) : (Z = l.layout.get("text-radial-offset").evaluate(v, {}, E) * u_, $ = gg), e1.allowVerticalPlacement && n.vertical) {
                        const e1 = n.vertical;
                        if (f) R = Ig(e1), a && (L = Ig(a));
                        else {
                            const i = l.layout.get("text-rotate").evaluate(v, {}, E) + 90;
                            z = Sg(c, G, t, h, u, d, e1, p, i, m), a && (P = Sg(c, G, t, h, u, d, a, g, i));
                        }
                    }
                    if (o) {
                        const r = l.layout.get("icon-rotate").evaluate(v, {}, E), n = ag(o, r, w, q), s = a ? ag(a, r, w, q) : void 0;
                        C = Sg(c, G, t, h, u, d, o, g, r), k = 4 * n.length;
                        const p = e1.iconSizeData;
                        let f = null;
                        "source" === p.kind ? (f = [
                            d_ * l.layout.get("icon-size").evaluate(v, {}, E)
                        ], f[0] > Eg && H(`${e1.layerIds[0]}: Value for "icon-size" is >= ${Tg}. Reduce your "icon-size".`)) : "composite" === p.kind && (f = [
                            d_ * b.compositeIconSizes[0].evaluate(v, {}, E),
                            d_ * b.compositeIconSizes[1].evaluate(v, {}, E)
                        ], (f[0] > Eg || f[1] > Eg) && H(`${e1.layerIds[0]}: Value for "icon-size" is >= ${Tg}. Reduce your "icon-size".`)), e1.addSymbols(e1.icon, n, f, x, y, v, !1, i, t, S.lineStartIndex, S.lineLength, -1, T, E, M, A), N = e1.icon.placedSymbolArray.length - 1, s && (O = 4 * s.length, e1.addSymbols(e1.icon, s, f, x, y, v, A_.vertical, i, t, S.lineStartIndex, S.lineLength, -1, T, E, M, A), U = e1.icon.placedSymbolArray.length - 1);
                    }
                    for(const r in n.horizontal){
                        const o = n.horizontal[r];
                        I || (j = Cl(o.text), f ? D = Ig(o) : I = Sg(c, G, t, h, u, d, o, p, l.layout.get("text-rotate").evaluate(v, {}, E), m));
                        const a = 1 === o.positionedLines.length;
                        if (B += Mg(e1, i, t, o, s, l, f, v, m, S, n.vertical ? A_.horizontal : A_.horizontalOnly, a ? Object.keys(n.horizontal) : [
                            r
                        ], V, N, b, T, E, M), a) break;
                    }
                    n.vertical && (F += Mg(e1, i, t, n.vertical, s, l, f, v, m, S, A_.vertical, [
                        "vertical"
                    ], V, U, b, T, E, M));
                    let W = -1;
                    const X = (e1, t)=>e1 ? Math.max(e1, t) : t;
                    W = X(D, W), W = X(R, W), W = X(L, W);
                    const Y = W > -1 ? 1 : 0;
                    e1.glyphOffsetArray.length >= gy.MAX_GLYPHS && H("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== v.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, v.sortKey), e1.symbolInstances.emplaceBack(t.x, t.y, G.x, G.y, G.z, V.right >= 0 ? V.right : -1, V.center >= 0 ? V.center : -1, V.left >= 0 ? V.left : -1, V.vertical >= 0 ? V.vertical : -1, N, U, j, void 0 !== I ? I : e1.collisionBoxArray.length, void 0 !== I ? I + 1 : e1.collisionBoxArray.length, void 0 !== z ? z : e1.collisionBoxArray.length, void 0 !== z ? z + 1 : e1.collisionBoxArray.length, void 0 !== C ? C : e1.collisionBoxArray.length, void 0 !== C ? C + 1 : e1.collisionBoxArray.length, P || e1.collisionBoxArray.length, P ? P + 1 : e1.collisionBoxArray.length, h, B, F, k, O, Y, 0, Z, $, W, 0, q ? 1 : 0);
                }(e1, a, _, s, i, r, n, O, e1.layers[0], e1.collisionBoxArray, t.index, t.sourceLayerIndex, e1.index, M, I, l, 0, A, C, g, t, o, c, h, u, p, f);
            };
            if ("line" === z) for (const n of Y_(t.geometry, 0, 0, cr, cr)){
                const t = H_(n, E, S, i.vertical || y, r, v, T, e1.overscaling, cr);
                for (const i of t)y && Cg(e1, y.text, P, i) || B(n, i, u);
            }
            else if ("line-center" === z) {
                for (const e1 of t.geometry)if (e1.length > 1) {
                    const t = W_(e1, S, i.vertical || y, r, v, T);
                    t && B(e1, t, u);
                }
            } else if ("Polygon" === t.type) for (const e1 of Ff(t.geometry, 0)){
                const t = pg(e1, 16);
                B(e1[0], new j_(t.x, t.y, 0, 0, void 0), u);
            }
            else if ("LineString" === t.type) for (const e1 of t.geometry)B(e1, new j_(e1[0].x, e1[0].y, 0, 0, void 0), u);
            else if ("Point" === t.type) for (const e1 of t.geometry)for (const t of e1)B([
                t
            ], new j_(t.x, t.y, 0, 0, void 0), u);
        }
        const Tg = 255, Eg = Tg * d_;
        function Mg(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g) {
            const x = function(e1, t, i, r, n, o, s, a) {
                const l = [];
                if (0 === t.positionedLines.length) return l;
                const c = r.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, h = function(e1) {
                    const t = e1[0], i = e1[1], r = t * i;
                    return r > 0 ? [
                        t,
                        -i
                    ] : r < 0 ? [
                        -t,
                        i
                    ] : 0 === t ? [
                        i,
                        t
                    ] : [
                        i,
                        -t
                    ];
                }(i);
                let u = Math.abs(t.top - t.bottom);
                for (const e1 of t.positionedLines)u -= e1.lineOffset;
                const d = t.positionedLines.length, p = u / d;
                let f = t.top - i[1];
                for(let e1 = 0; e1 < d; ++e1){
                    const r = t.positionedLines[e1];
                    f = dg(t, p, f, e1);
                    for (const e1 of r.positionedGlyphs){
                        if (!e1.rect) continue;
                        const r = e1.rect || {};
                        let o = M_ + 1, u = !0, d = 1, p = 0;
                        if (e1.imageName) {
                            const t = s[e1.imageName];
                            if (!t) continue;
                            if (t.sdf) {
                                H("SDF images are not supported in formatted text and will be ignored.");
                                continue;
                            }
                            u = !1, d = t.pixelRatio, o = J_ / d;
                        }
                        const m = (n || a) && e1.vertical, _ = e1.metrics.advance * e1.scale / 2, g = e1.metrics, x = e1.rect;
                        if (null === x) continue;
                        a && t.verticalizable && (p = e1.imageName ? _ - e1.metrics.width * e1.scale / 2 : 0);
                        const v = n ? [
                            e1.x + _,
                            e1.y
                        ] : [
                            0,
                            0
                        ];
                        let b = [
                            0,
                            0
                        ], w = [
                            0,
                            0
                        ], T = !1;
                        n || (m ? (w = [
                            e1.x + _ + h[0],
                            e1.y + h[1] - p
                        ], T = !0) : b = [
                            e1.x + _ + i[0],
                            e1.y + i[1] - p
                        ]);
                        const E = x.w * e1.scale / (d * (e1.localGlyph ? ng : 1)), M = x.h * e1.scale / (d * (e1.localGlyph ? ng : 1));
                        let A, S, I, C;
                        if (m) {
                            const t = e1.y - f, i = new y(-_, _ - t), r = -Math.PI / 2, n = new y(...w);
                            A = new y(-_ + b[0], b[1]), A._rotateAround(r, i)._add(n), A.x += -t + _, A.y -= (g.left - o) * e1.scale;
                            const s = e1.imageName ? g.advance * e1.scale : u_ * e1.scale, a = String.fromCodePoint(e1.glyph);
                            x_(a) ? A.x += (1 - o) * e1.scale : v_(a) ? A.x += s - g.height * e1.scale + (-o - 1) * e1.scale : A.x += e1.imageName || g.width + 2 * o === x.w && g.height + 2 * o === x.h ? (s - M) / 2 : (s - (g.height + 2 * o) * e1.scale) / 2, S = new y(A.x, A.y - E), I = new y(A.x + M, A.y), C = new y(A.x + M, A.y - E);
                        } else {
                            const t = (g.left - o) * e1.scale - _ + b[0], i = (-g.top - o) * e1.scale + b[1], r = t + E, n = i + M;
                            A = new y(t, i), S = new y(r, i), I = new y(t, n), C = new y(r, n);
                        }
                        if (c) {
                            let e1;
                            e1 = n ? new y(0, 0) : T ? new y(h[0], h[1]) : new y(i[0], i[1]), A._rotateAround(c, e1), S._rotateAround(c, e1), I._rotateAround(c, e1), C._rotateAround(c, e1);
                        }
                        const z = new y(0, 0), P = new y(0, 0);
                        l.push({
                            tl: A,
                            tr: S,
                            bl: I,
                            br: C,
                            texPrimary: r,
                            texSecondary: void 0,
                            writingMode: t.writingMode,
                            glyphOffset: v,
                            sectionIndex: e1.sectionIndex,
                            isSDF: u,
                            pixelOffsetTL: z,
                            pixelOffsetBR: P,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return l;
            }(0, r, l, o, s, a, n, e1.allowVerticalPlacement), v = e1.textSizeData;
            let b = null;
            "source" === v.kind ? (b = [
                d_ * o.layout.get("text-size").evaluate(a, {}, _)
            ], b[0] > Eg && H(`${e1.layerIds[0]}: Value for "text-size" is >= ${Tg}. Reduce your "text-size".`)) : "composite" === v.kind && (b = [
                d_ * f.compositeTextSizes[0].evaluate(a, {}, _),
                d_ * f.compositeTextSizes[1].evaluate(a, {}, _)
            ], (b[0] > Eg || b[1] > Eg) && H(`${e1.layerIds[0]}: Value for "text-size" is >= ${Tg}. Reduce your "text-size".`)), e1.addSymbols(e1.text, x, b, l, s, a, h, t, i, c.lineStartIndex, c.lineLength, p, m, _, g, !1);
            for (const t of u)d[t] = e1.text.placedSymbolArray.length - 1;
            return 4 * x.length;
        }
        function Ag(e1) {
            for(const t in e1)return e1[t];
            return null;
        }
        function Sg(e1, t, i, r, n, o, s, a, l, c) {
            let h = s.top, u = s.bottom, d = s.left, p = s.right;
            const f = s.collisionPadding;
            if (f && (d -= f[0], h -= f[1], p += f[2], u += f[3]), l) {
                const e1 = new y(d, h), t = new y(p, h), i = new y(d, u), r = new y(p, u), n = w(l);
                let o = new y(0, 0);
                c && (o = new y(c[0], c[1])), e1._rotateAround(n, o), t._rotateAround(n, o), i._rotateAround(n, o), r._rotateAround(n, o), d = Math.min(e1.x, t.x, i.x, r.x), p = Math.max(e1.x, t.x, i.x, r.x), h = Math.min(e1.y, t.y, i.y, r.y), u = Math.max(e1.y, t.y, i.y, r.y);
            }
            return e1.emplaceBack(t.x, t.y, t.z, i.x, i.y, d, h, p, u, a, r, n, o), e1.length - 1;
        }
        function Ig(e1) {
            e1.collisionPadding && (e1.top -= e1.collisionPadding[1], e1.bottom += e1.collisionPadding[3]);
            const t = e1.bottom - e1.top;
            return t > 0 ? Math.max(10, t) : null;
        }
        function Cg(e1, t, i, r) {
            const n = e1.compareText;
            if (t in n) {
                const e1 = n[t];
                for(let t = e1.length - 1; t >= 0; t--)if (r.dist(e1[t]) < i) return !0;
            } else n[t] = [];
            return n[t].push(r), !1;
        }
        function zg(e1, t) {
            const i = e1.fovAboveCenter, r = e1.elevation ? e1.elevation.getMinElevationBelowMSL() * t : 0, n = (e1._camera.position[2] * e1.worldSize - r) / Math.cos(e1._pitch), o = Math.sin(i) * n / Math.sin(Math.max(Math.PI / 2 - e1._pitch - i, .01)), s = Math.sin(e1._pitch) * o + n;
            return Math.min(1.01 * s, n * (1 / e1._horizonShift));
        }
        function Pg(e1, t) {
            if (!t.isReprojectedInTileSpace) return {
                scale: 1 << e1.z,
                x: e1.x,
                y: e1.y,
                x2: e1.x + 1,
                y2: e1.y + 1,
                projection: t
            };
            const i = Math.pow(2, -e1.z), r = e1.x * i, n = (e1.x + 1) * i, o = e1.y * i, s = (e1.y + 1) * i, a = ep(r), l = ep(n), c = tp(o), h = tp(s), u = t.project(a, c), d = t.project(l, c), p = t.project(l, h), f = t.project(a, h);
            let m = Math.min(u.x, d.x, p.x, f.x), _ = Math.min(u.y, d.y, p.y, f.y), g = Math.max(u.x, d.x, p.x, f.x), y = Math.max(u.y, d.y, p.y, f.y);
            const x = i / 16;
            function v(e1, i, r, n, o, s) {
                const a = (r + o) / 2, l = (n + s) / 2, c = t.project(ep(a), tp(l)), h = Math.max(0, m - c.x, _ - c.y, c.x - g, c.y - y);
                m = Math.min(m, c.x), g = Math.max(g, c.x), _ = Math.min(_, c.y), y = Math.max(y, c.y), h > x && (v(e1, c, r, n, a, l), v(c, i, a, l, o, s));
            }
            v(u, d, r, o, n, o), v(d, p, n, o, n, s), v(p, f, n, s, r, s), v(f, u, r, s, r, o), m -= x, _ -= x, g += x, y += x;
            const b = 1 / Math.max(g - m, y - _);
            return {
                scale: b,
                x: m * b,
                y: _ * b,
                x2: g * b,
                y2: y * b,
                projection: t
            };
        }
        function Dg(e1, t, i, r, n, o, s, a, l) {
            if ("globe" === l.name) return yd(e1, t, new ju(i, r, n), !1);
            const c = Pg({
                z: i,
                x: r,
                y: n
            }, l);
            return new ed([
                (o + c.x / c.scale) * t,
                t * (c.y / c.scale),
                s
            ], [
                (o + c.x2 / c.scale) * t,
                t * (c.y2 / c.scale),
                a
            ]);
        }
        function Rg(e1, { x: t, y: i }, r = 0) {
            return new y(((t - r) * e1.scale - e1.x) * cr, (i * e1.scale - e1.y) * cr);
        }
        function Lg(e1, t, i = 0) {
            return Du.fromValues(((t.x - i) * e1.scale - e1.x) * cr, (t.y * e1.scale - e1.y) * cr, ip(t.z, t.y));
        }
        const kg = Au.identity(new Float32Array(16));
        class Og {
            constructor(e1){
                this.spec = e1, this.name = e1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(e1, t) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(e1, t) {
                return new Wd(0, 0);
            }
            projectTilePoint(e1, t, i) {
                return {
                    x: e1,
                    y: t,
                    z: 0
                };
            }
            locationPoint(e1, t, i = !0) {
                return e1._coordinatePoint(e1.locationCoordinate(t), i);
            }
            pixelsPerMeter(e1, t) {
                return Qd(1, e1) * t;
            }
            pixelSpaceConversion(e1, t, i) {
                return 1;
            }
            farthestPixelDistance(e1) {
                return zg(e1, e1.pixelsPerMeter);
            }
            pointCoordinate(e1, t, i, r) {
                const n = e1.horizonLineFromTop(!1), o = new y(t, Math.max(n, i));
                return e1.rayIntersectionCoordinate(e1.pointRayIntersection(o, r));
            }
            pointCoordinate3D(e1, t, i) {
                const r = new y(t, i);
                if (e1.elevation) return e1.elevation.pointCoordinate(r);
                {
                    const t = this.pointCoordinate(e1, r.x, r.y, 0);
                    return [
                        t.x,
                        t.y,
                        t.z
                    ];
                }
            }
            isPointAboveHorizon(e1, t) {
                if (e1.elevation) return !this.pointCoordinate3D(e1, t.x, t.y);
                const i = e1.horizonLineFromTop();
                return t.y < i;
            }
            createInversionMatrix(e1, t) {
                return kg;
            }
            createTileMatrix(e1, t, i) {
                let r, n, o;
                const s = i.canonical, a = Au.identity(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = Pg(s, this);
                    r = 1, n = l.x + i.wrap * l.scale, o = l.y, Au.scale(a, a, [
                        r / l.scale,
                        r / l.scale,
                        e1.pixelsPerMeter / t
                    ]);
                } else r = t / e1.zoomScale(s.z), n = (s.x + Math.pow(2, s.z) * i.wrap) * r, o = s.y * r;
                return Au.translate(a, a, [
                    n,
                    o,
                    0
                ]), Au.scale(a, a, [
                    r / cr,
                    r / cr,
                    1
                ]), a;
            }
            upVector(e1, t, i) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(e1, t, i) {
                return {
                    metersToTile: 1
                };
            }
        }
        class Bg extends Og {
            constructor(e1){
                super(e1), this.range = [
                    4,
                    7
                ], this.center = e1.center || [
                    -96,
                    37.5
                ];
                const [t, i] = this.parallels = e1.parallels || [
                    29.5,
                    45.5
                ], r = Math.sin(w(t));
                this.n = (r + Math.sin(w(i))) / 2, this.c = 1 + r * (2 * this.n - r), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(e1, t) {
                const { n: i, c: r, r0: n } = this, o = w(e1 - this.center[0]), s = w(t), a = Math.sqrt(r - 2 * i * Math.sin(s)) / i;
                return {
                    x: a * Math.sin(o * i),
                    y: a * Math.cos(o * i) - n,
                    z: 0
                };
            }
            unproject(e1, t) {
                const { n: i, c: r, r0: n } = this, o = n + t;
                let s = Math.atan2(e1, Math.abs(o)) * Math.sign(o);
                o * i < 0 && (s -= Math.PI * Math.sign(e1) * Math.sign(o));
                const a = w(this.center[0]) * i;
                s = D(s, -Math.PI - a, Math.PI - a);
                const l = z(T(s / i) + this.center[0], -180, 180), c = Math.asin(z((r - (e1 * e1 + o * o) * i * i) / (2 * i), -1, 1)), h = z(T(c), -rp, rp);
                return new Wd(l, h);
            }
        }
        const Fg = 1.340264, Ng = -0.081106, Ug = 893e-6, Vg = .003796, jg = Math.sqrt(3) / 2;
        class Gg extends Og {
            project(e1, t) {
                t = t / 180 * Math.PI, e1 = e1 / 180 * Math.PI;
                const i = Math.asin(jg * Math.sin(t)), r = i * i, n = r * r * r;
                return {
                    x: .5 * (e1 * Math.cos(i) / (jg * (Fg + 3 * Ng * r + n * (7 * Ug + 9 * Vg * r))) / Math.PI + .5),
                    y: 1 - .5 * (i * (Fg + Ng * r + n * (Ug + Vg * r)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t = (2 * (1 - t) - 1) * Math.PI, r = i * i, n = r * r * r;
                for(let e1, o, s, a = 0; a < 12 && (o = i * (Fg + Ng * r + n * (Ug + Vg * r)) - t, s = Fg + 3 * Ng * r + n * (7 * Ug + 9 * Vg * r), e1 = o / s, i = z(i - e1, -Math.PI / 3, Math.PI / 3), r = i * i, n = r * r * r, !(Math.abs(e1) < 1e-12)); ++a);
                const o = jg * e1 * (Fg + 3 * Ng * r + n * (7 * Ug + 9 * Vg * r)) / Math.cos(i), s = Math.asin(Math.sin(i) / jg), a = z(180 * o / Math.PI, -180, 180), l = z(180 * s / Math.PI, -rp, rp);
                return new Wd(a, l);
            }
        }
        class qg extends Og {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t) {
                return {
                    x: .5 + e1 / 360,
                    y: .5 - t / 360,
                    z: 0
                };
            }
            unproject(e1, t) {
                const i = 360 * (e1 - .5), r = z(360 * (.5 - t), -rp, rp);
                return new Wd(i, r);
            }
        }
        const Zg = Math.PI / 2;
        function $g(e1) {
            return Math.tan((Zg + e1) / 2);
        }
        class Wg extends Og {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    30
                ];
                const [t, i] = this.parallels = e1.parallels || [
                    30,
                    30
                ];
                let r = w(t), n = w(i);
                this.southernCenter = r + n < 0, this.southernCenter && (r = -r, n = -n);
                const o = Math.cos(r), s = $g(r);
                this.n = r === n ? Math.sin(r) : Math.log(o / Math.cos(n)) / Math.log($g(n) / s), this.f = o * Math.pow($g(r), this.n) / this.n;
            }
            project(e1, t) {
                t = w(t), this.southernCenter && (t = -t), e1 = w(e1 - this.center[0]);
                const i = 1e-6, { n: r, f: n } = this;
                n > 0 ? t < -Zg + i && (t = -Zg + i) : t > Zg - i && (t = Zg - i);
                const o = n / Math.pow($g(t), r);
                let s = o * Math.sin(r * e1), a = n - o * Math.cos(r * e1);
                return s = .5 * (s / Math.PI + .5), a = .5 * (a / Math.PI + .5), {
                    x: s,
                    y: this.southernCenter ? a : 1 - a,
                    z: 0
                };
            }
            unproject(e1, t) {
                e1 = (2 * e1 - .5) * Math.PI, this.southernCenter && (t = 1 - t), t = (2 * (1 - t) - .5) * Math.PI;
                const { n: i, f: r } = this, n = r - t, o = Math.sign(n), s = Math.sign(i) * Math.sqrt(e1 * e1 + n * n);
                let a = Math.atan2(e1, Math.abs(n)) * o;
                n * i < 0 && (a -= Math.PI * Math.sign(e1) * o);
                const l = z(T(a / i) + this.center[0], -180, 180), c = z(T(2 * Math.atan(Math.pow(r / s, 1 / i)) - Zg), -rp, rp);
                return new Wd(l, this.southernCenter ? -c : c);
            }
        }
        class Hg extends Og {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(e1, t) {
                return {
                    x: Kd(e1),
                    y: Jd(t),
                    z: 0
                };
            }
            unproject(e1, t) {
                const i = ep(e1), r = tp(t);
                return new Wd(i, r);
            }
        }
        const Xg = w(rp);
        class Yg extends Og {
            project(e1, t) {
                const i = (t = w(t)) * t, r = i * i;
                return {
                    x: .5 * ((e1 = w(e1)) * (.8707 - .131979 * i + r * (r * (.003971 * i - .001529 * r) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (t * (1.007226 + i * (.015085 + r * (.028874 * i - .044475 - .005916 * r))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t = (2 * (1 - t) - 1) * Math.PI, r = 25, n = 0, o = i * i;
                do {
                    o = i * i;
                    const e1 = o * o;
                    n = (i * (1.007226 + o * (.015085 + e1 * (.028874 * o - .044475 - .005916 * e1))) - t) / (1.007226 + o * (.045255 + e1 * (.259866 * o - .311325 - .005916 * 11 * e1))), i = z(i - n, -Xg, Xg);
                }while (Math.abs(n) > 1e-6 && --r > 0);
                o = i * i;
                const s = z(T(e1 / (.8707 + o * (o * (o * o * o * (.003971 - .001529 * o) - .013791) - .131979))), -180, 180), a = T(i);
                return new Wd(s, a);
            }
        }
        const Kg = w(rp);
        class Jg extends Og {
            project(e1, t) {
                t = w(t), e1 = w(e1);
                const i = Math.cos(t), r = 2 / Math.PI, n = Math.acos(i * Math.cos(e1 / 2)), o = Math.sin(n) / n, s = .5 * (e1 * r + 2 * i * Math.sin(e1 / 2) / o) || 0, a = .5 * (t + Math.sin(t) / o) || 0;
                return {
                    x: .5 * (s / Math.PI + .5),
                    y: 1 - .5 * (a / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t) {
                let i = e1 = (2 * e1 - .5) * Math.PI, r = t = (2 * (1 - t) - 1) * Math.PI, n = 25;
                const o = 1e-6;
                let s = 0, a = 0;
                do {
                    const n = Math.cos(r), o = Math.sin(r), l = 2 * o * n, c = o * o, h = n * n, u = Math.cos(i / 2), d = Math.sin(i / 2), p = 2 * u * d, f = d * d, m = 1 - h * u * u, _ = m ? 1 / m : 0, g = m ? Math.acos(n * u) * Math.sqrt(1 / m) : 0, y = .5 * (2 * g * n * d + 2 * i / Math.PI) - e1, x = .5 * (g * o + r) - t, v = .5 * _ * (h * f + g * n * u * c) + 1 / Math.PI, b = _ * (p * l / 4 - g * o * d), w = .125 * _ * (l * d - g * o * h * p), T = .5 * _ * (c * u + g * f * n) + .5, E = b * w - T * v;
                    s = (x * b - y * T) / E, a = (y * w - x * v) / E, i = z(i - s, -Math.PI, Math.PI), r = z(r - a, -Kg, Kg);
                }while ((Math.abs(s) > o || Math.abs(a) > o) && --n > 0);
                return new Wd(T(i), T(r));
            }
        }
        class Qg extends Og {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    0
                ], this.parallels = e1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(w(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t) {
                const { scale: i, cosPhi: r } = this;
                return {
                    x: w(e1) * r * i + .5,
                    y: -Math.sin(w(t)) / r * i + .5,
                    z: 0
                };
            }
            unproject(e1, t) {
                const { scale: i, cosPhi: r } = this, n = -(t - .5) / i, o = z(T((e1 - .5) / i) / r, -180, 180), s = Math.asin(z(n * r, -1, 1)), a = z(T(s), -rp, rp);
                return new Wd(o, a);
            }
        }
        class ey extends Hg {
            constructor(e1){
                super(e1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(e1, t, i) {
                const r = Td(e1, t, i), n = Ad(fd(i));
                return Du.transformMat4(r, r, n), {
                    x: r[0],
                    y: r[1],
                    z: r[2]
                };
            }
            locationPoint(e1, t) {
                const i = wd(t.lat, t.lng), r = Du.normalize([], i), n = e1.elevation ? e1.elevation.getAtPointOrZero(e1.locationCoordinate(t), e1._centerAltitude) : e1._centerAltitude, o = Qd(1, 0) * cr * n;
                Du.scaleAndAdd(i, i, r, o);
                const s = Au.identity(new Float64Array(16));
                return Au.multiply(s, e1.pixelMatrix, e1.globeMatrix), Du.transformMat4(i, i, s), new y(i[0], i[1]);
            }
            pixelsPerMeter(e1, t) {
                return Qd(1, 0) * t;
            }
            pixelSpaceConversion(e1, t, i) {
                const r = Qd(1, e1) * t, n = Kr(Qd(1, 45) * t, r, i);
                return this.pixelsPerMeter(e1, t) / n;
            }
            createTileMatrix(e1, t, i) {
                const r = Sd(fd(i.canonical));
                return Au.multiply(new Float64Array(16), e1.globeMatrix, r);
            }
            createInversionMatrix(e1, t) {
                const { center: i } = e1, r = Ad(fd(t));
                return Au.rotateY(r, r, w(i.lng)), Au.rotateX(r, r, w(i.lat)), Au.scale(r, r, [
                    e1._pixelsPerMercatorPixel,
                    e1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(r);
            }
            pointCoordinate(e1, t, i, r) {
                return ud(e1, t, i, !0) || new lp(0, 0);
            }
            pointCoordinate3D(e1, t, i) {
                const r = this.pointCoordinate(e1, t, i, 0);
                return [
                    r.x,
                    r.y,
                    r.z
                ];
            }
            isPointAboveHorizon(e1, t) {
                return !ud(e1, t.x, t.y, !1);
            }
            farthestPixelDistance(e1) {
                const t = function(e1, t) {
                    const i = e1.cameraToCenterDistance, r = e1._centerAltitude * t, n = e1._camera, o = e1._camera.forward(), s = Du.add([], Du.scale([], o, -i), [
                        0,
                        0,
                        r
                    ]), a = e1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -a
                    ], c = e1.width / e1.height, h = Math.tan(e1.fovAboveCenter), u = Du.scale([], n.up(), h), d = Du.scale([], n.right(), h * c), p = Du.normalize([], Du.add([], Du.add([], o, u), d)), f = [];
                    let m;
                    if (new Wu(s, p).closestPointOnSphere(l, a, f)) {
                        const t = Du.add([], f, l), i = Du.sub([], t, s);
                        m = Math.cos(e1.fovAboveCenter) * Du.length(i);
                    } else {
                        const e1 = Du.sub([], s, l), t = Du.sub([], l, s);
                        Du.normalize(t, t);
                        const i = Du.length(e1) - a;
                        m = Math.sqrt(i * (i + 2 * a));
                        const r = Math.acos(m / (a + i)) - Math.acos(Du.dot(o, t));
                        m *= Math.cos(r);
                    }
                    return 1.01 * m;
                }(e1, this.pixelsPerMeter(e1.center.lat, e1.worldSize)), i = Dd(e1.zoom);
                if (i > 0) {
                    const r = zg(e1, Qd(1, e1.center.lat) * e1.worldSize), n = e1.worldSize / (2 * Math.PI), o = Math.max(e1.width, e1.height) / e1.worldSize * Math.PI;
                    return Kr(t, r + n * (1 - Math.cos(o)), Math.pow(i, 10));
                }
                return t;
            }
            upVector(e1, t, i) {
                return Td(t, i, e1, 1);
            }
            upVectorScale(e1) {
                return {
                    metersToTile: hd(Ed(fd(e1)))
                };
            }
        }
        function ty(e1) {
            const t = e1.parallels, i = !!t && Math.abs(t[0] + t[1]) < .01;
            switch(e1.name){
                case "mercator":
                    return new Hg(e1);
                case "equirectangular":
                    return new qg(e1);
                case "naturalEarth":
                    return new Yg(e1);
                case "equalEarth":
                    return new Gg(e1);
                case "winkelTripel":
                    return new Jg(e1);
                case "albers":
                    return i ? new Qg(e1) : new Bg(e1);
                case "lambertConformalConic":
                    return i ? new Qg(e1) : new Wg(e1);
                case "globe":
                    return new ey(e1);
            }
            throw new Error(`Invalid projection name: ${e1.name}`);
        }
        const iy = new ga({
            "symbol-placement": new fa(Pt.layout_symbol["symbol-placement"]),
            "symbol-spacing": new fa(Pt.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new fa(Pt.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new ma(Pt.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new fa(Pt.layout_symbol["symbol-z-order"]),
            "symbol-z-elevate": new fa(Pt.layout_symbol["symbol-z-elevate"]),
            "icon-allow-overlap": new fa(Pt.layout_symbol["icon-allow-overlap"]),
            "icon-ignore-placement": new fa(Pt.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new fa(Pt.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new fa(Pt.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new ma(Pt.layout_symbol["icon-size"]),
            "icon-text-fit": new ma(Pt.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new ma(Pt.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new ma(Pt.layout_symbol["icon-image"]),
            "icon-rotate": new ma(Pt.layout_symbol["icon-rotate"]),
            "icon-padding": new fa(Pt.layout_symbol["icon-padding"]),
            "icon-keep-upright": new fa(Pt.layout_symbol["icon-keep-upright"]),
            "icon-offset": new ma(Pt.layout_symbol["icon-offset"]),
            "icon-anchor": new ma(Pt.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new fa(Pt.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new fa(Pt.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new fa(Pt.layout_symbol["text-rotation-alignment"]),
            "text-field": new ma(Pt.layout_symbol["text-field"]),
            "text-font": new ma(Pt.layout_symbol["text-font"]),
            "text-size": new ma(Pt.layout_symbol["text-size"]),
            "text-max-width": new ma(Pt.layout_symbol["text-max-width"]),
            "text-line-height": new ma(Pt.layout_symbol["text-line-height"]),
            "text-letter-spacing": new ma(Pt.layout_symbol["text-letter-spacing"]),
            "text-justify": new ma(Pt.layout_symbol["text-justify"]),
            "text-radial-offset": new ma(Pt.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new fa(Pt.layout_symbol["text-variable-anchor"]),
            "text-anchor": new ma(Pt.layout_symbol["text-anchor"]),
            "text-max-angle": new fa(Pt.layout_symbol["text-max-angle"]),
            "text-writing-mode": new fa(Pt.layout_symbol["text-writing-mode"]),
            "text-rotate": new ma(Pt.layout_symbol["text-rotate"]),
            "text-padding": new fa(Pt.layout_symbol["text-padding"]),
            "text-keep-upright": new fa(Pt.layout_symbol["text-keep-upright"]),
            "text-transform": new ma(Pt.layout_symbol["text-transform"]),
            "text-offset": new ma(Pt.layout_symbol["text-offset"]),
            "text-allow-overlap": new fa(Pt.layout_symbol["text-allow-overlap"]),
            "text-ignore-placement": new fa(Pt.layout_symbol["text-ignore-placement"]),
            "text-optional": new fa(Pt.layout_symbol["text-optional"]),
            visibility: new fa(Pt.layout_symbol.visibility)
        });
        var ry = {
            paint: new ga({
                "icon-opacity": new ma(Pt.paint_symbol["icon-opacity"]),
                "icon-emissive-strength": new ma(Pt.paint_symbol["icon-emissive-strength"]),
                "text-emissive-strength": new ma(Pt.paint_symbol["text-emissive-strength"]),
                "icon-color": new ma(Pt.paint_symbol["icon-color"]),
                "icon-halo-color": new ma(Pt.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new ma(Pt.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new ma(Pt.paint_symbol["icon-halo-blur"]),
                "icon-translate": new fa(Pt.paint_symbol["icon-translate"]),
                "icon-translate-anchor": new fa(Pt.paint_symbol["icon-translate-anchor"]),
                "icon-image-cross-fade": new ma(Pt.paint_symbol["icon-image-cross-fade"]),
                "text-opacity": new ma(Pt.paint_symbol["text-opacity"]),
                "text-color": new ma(Pt.paint_symbol["text-color"], {
                    runtimeType: Zt,
                    getOverride: (e1)=>e1.textColor,
                    hasOverride: (e1)=>!!e1.textColor
                }),
                "text-halo-color": new ma(Pt.paint_symbol["text-halo-color"]),
                "text-halo-width": new ma(Pt.paint_symbol["text-halo-width"]),
                "text-halo-blur": new ma(Pt.paint_symbol["text-halo-blur"]),
                "text-translate": new fa(Pt.paint_symbol["text-translate"]),
                "text-translate-anchor": new fa(Pt.paint_symbol["text-translate-anchor"]),
                "icon-color-saturation": new fa(Pt.paint_symbol["icon-color-saturation"])
            }),
            layout: iy
        };
        class ny {
            constructor(e1){
                this.type = e1.property.overrides ? e1.property.overrides.runtimeType : Vt, this.defaultValue = e1;
            }
            evaluate(e1) {
                if (e1.formattedSection) {
                    const t = this.defaultValue.property.overrides;
                    if (t && t.hasOverride(e1.formattedSection)) return t.getOverride(e1.formattedSection);
                }
                return e1.feature && e1.featureState ? this.defaultValue.evaluate(e1.feature, e1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(e1) {
                this.defaultValue.isConstant() || e1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        Rs(ny, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        class oy extends Ta {
            constructor(e1, t){
                super(e1, ry, t);
            }
            recalculate(e1, t) {
                super.recalculate(e1, t), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const i = this.layout.get("text-writing-mode");
                if (i) {
                    const e1 = [];
                    for (const t of i)e1.indexOf(t) < 0 && e1.push(t);
                    this.layout._values["text-writing-mode"] = e1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(e1, t, i, r) {
                const n = this.layout.get(e1).evaluate(t, {}, i, r), o = this._unevaluatedLayout._values[e1];
                return o.isDataDriven() || To(o.value) || !n ? n : function(e1, t) {
                    return t.replace(/{([^{}]+)}/g, (t, i)=>i in e1 ? String(e1[i]) : "");
                }(t.properties, n);
            }
            createBucket(e1) {
                return new gy(e1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const e1 of ry.paint.overridableProperties){
                    if (!oy.hasPaintOverride(this.layout, e1)) continue;
                    const t = this.paint.get(e1), i = new ny(t), r = new wo(i, t.property.specification);
                    let n = null;
                    n = "constant" === t.value.kind || "source" === t.value.kind ? new Mo("source", r) : new Ao("composite", r, t.value.zoomStops, t.value._interpolationType), this.paint._values[e1] = new da(t.property, n, t.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(e1, t, i) {
                return !(!this.layout || t.isDataDriven() || i.isDataDriven()) && oy.hasPaintOverride(this.layout, e1);
            }
            static hasPaintOverride(e1, t) {
                const i = e1.get("text-field"), r = ry.paint.properties[t];
                let n = !1;
                const o = (e1)=>{
                    for (const t of e1)if (r.overrides && r.overrides.hasOverride(t)) return void (n = !0);
                };
                if ("constant" === i.value.kind && i.value.value instanceof pi) o(i.value.value.sections);
                else if ("source" === i.value.kind) {
                    const e1 = (t)=>{
                        n || (t instanceof vi && gi(t.value) === Xt ? o(t.value.sections) : t instanceof Mi ? o(t.sections) : t.eachChild(e1));
                    }, t = i.value;
                    t._styleExpression && e1(t._styleExpression.expression);
                }
                return n;
            }
            getProgramIds() {
                const e1 = 0 !== this.paint.get("icon-opacity").constantOr(1), t = 0 !== this.paint.get("text-opacity").constantOr(1), i = [];
                return e1 && i.push("symbolIcon"), t && i.push("symbolSDF"), i;
            }
            getDefaultProgramParams(e1, t) {
                return {
                    config: new Ql(this, t),
                    overrideFog: !1
                };
            }
        }
        const sy = hm.types, ay = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function ly(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
            const p = a ? Math.min(Eg, Math.round(a[0])) : 0, f = a ? Math.min(Eg, Math.round(a[1])) : 0;
            e1.emplaceBack(t, i, Math.round(32 * r), Math.round(32 * n), o, s, (p << 1) + (l ? 1 : 0), f, 16 * c, 16 * h, 256 * u, 256 * d);
        }
        function cy(e1, t, i) {
            e1.emplaceBack(t, i);
        }
        function hy(e1, t, i, r, n, o, s) {
            e1.emplaceBack(t, i, r, n, o, s);
        }
        function uy(e1, t, i, r, n) {
            const o = 5 * t + 2;
            e1.float32[o + 0] = i, e1.float32[o + 1] = r, e1.float32[o + 2] = n;
        }
        function dy(e1, t, i, r, n) {
            e1.emplaceBack(t, i, r, n), e1.emplaceBack(t, i, r, n), e1.emplaceBack(t, i, r, n), e1.emplaceBack(t, i, r, n);
        }
        function py(e1) {
            for (const t of e1.sections)if ($s(t.text)) return !0;
            return !1;
        }
        class fy {
            constructor(e1){
                this.layoutVertexArray = new Na, this.indexArray = new Wa, this.programConfigurations = e1, this.segments = new xl, this.dynamicLayoutVertexArray = new ka, this.opacityVertexArray = new Va, this.placedSymbolArray = new cl, this.iconTransitioningVertexArray = new ja, this.globeExtVertexArray = new Ua, this.zOffsetVertexArray = new Ya;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            upload(e1, t, i, r, n) {
                this.isEmpty() || (i && (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, i_.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray, t), this.dynamicLayoutVertexBuffer = e1.createVertexBuffer(this.dynamicLayoutVertexArray, n_.members, !0), this.opacityVertexBuffer = e1.createVertexBuffer(this.opacityVertexArray, ay, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = e1.createVertexBuffer(this.iconTransitioningVertexArray, s_.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, r_.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || n) && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, o_.members, !0)), this.opacityVertexBuffer.itemSize = 1), (i || r) && this.programConfigurations.upload(e1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
            }
        }
        Rs(fy, "SymbolBuffers");
        class my {
            constructor(e1, t, i){
                this.layoutVertexArray = new e1, this.layoutAttributes = t, this.indexArray = new i, this.segments = new xl, this.collisionVertexArray = new $a, this.collisionVertexArrayExt = new ka;
            }
            upload(e1) {
                this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e1.createVertexBuffer(this.collisionVertexArray, a_.members, !0), this.collisionVertexBufferExt = e1.createVertexBuffer(this.collisionVertexArrayExt, l_.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        Rs(my, "CollisionBuffers");
        class _y {
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Au.identity([]), this.placementViewportMatrix = Au.identity([]);
                const t = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = p_(this.zoom, t["text-size"]), this.iconSizeData = p_(this.zoom, t["icon-size"]);
                const i = this.layers[0].layout, r = i.get("symbol-sort-key"), n = i.get("symbol-z-order");
                this.canOverlap = i.get("text-allow-overlap") || i.get("icon-allow-overlap") || i.get("text-ignore-placement") || i.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== n && void 0 !== r.constantOr(1), this.sortFeaturesByY = ("viewport-y" === n || "auto" === n && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = i.get("text-writing-mode").map((e1)=>A_[e1]), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.sourceID = e1.sourceID, this.projection = e1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = i.get("symbol-z-elevate");
            }
            createArrays() {
                this.text = new fy(new ec(this.layers, this.zoom, (e1)=>/^text/.test(e1))), this.icon = new fy(new ec(this.layers, this.zoom, (e1)=>/^icon/.test(e1))), this.glyphOffsetArray = new dl, this.lineVertexArray = new pl, this.symbolInstances = new ul;
            }
            calculateGlyphDependencies(e1, t, i, r, n) {
                for(let i = 0; i < e1.length; i++){
                    const o = e1.codePointAt(i);
                    if (void 0 === o) break;
                    if (t[o] = !0, r && n && o <= 65535) {
                        const r = y_[e1.charAt(i)];
                        r && (t[r.charCodeAt(0)] = !0);
                    }
                }
            }
            populate(e1, t, i, r) {
                const n = this.layers[0], o = n.layout, s = "globe" === this.projection.name, a = o.get("text-font"), l = o.get("text-field"), c = o.get("icon-image"), h = ("constant" !== l.value.kind || l.value.value instanceof pi && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), u = "constant" !== c.value.kind || !!c.value.value || Object.keys(c.parameters).length > 0, d = o.get("symbol-sort-key");
                if (this.features = [], !h && !u) return;
                const p = t.iconDependencies, f = t.glyphDependencies, m = t.availableImages, _ = new oa(this.zoom);
                for (const { feature: t, id: l, index: c, sourceLayerIndex: g } of e1){
                    const e1 = n._featureFilter.needGeometry, y = gp(t, e1);
                    if (!n._featureFilter.filter(_, y, i)) continue;
                    if (e1 || (y.geometry = _p(t, i, r)), s && 1 !== t.type && i.z <= 5) {
                        const e1 = y.geometry, t = .98078528056, r = (e1, r)=>{
                            const n = Td(e1.x, e1.y, i, 1), o = Td(r.x, r.y, i, 1);
                            return Du.dot(n, o) < t;
                        };
                        for(let t = 0; t < e1.length; t++)e1[t] = dp(e1[t], r);
                    }
                    let x, v;
                    if (h) {
                        const e1 = n.getValueAndResolveTokens("text-field", y, i, m), t = pi.factory(e1);
                        py(t) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ia() || this.hasRTLText && na.isParsed()) && (x = g_(t, n, y));
                    }
                    if (u) {
                        const e1 = n.getValueAndResolveTokens("icon-image", y, i, m);
                        v = e1 instanceof fi ? e1 : fi.fromString(e1);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? d.evaluate(y, {}, i) : void 0;
                    if (this.features.push({
                        id: l,
                        text: x,
                        icon: v,
                        index: c,
                        sourceLayerIndex: g,
                        geometry: y.geometry,
                        properties: t.properties,
                        type: sy[t.type],
                        sortKey: b
                    }), v && (p[v.namePrimary] = !0, v.nameSecondary && (p[v.nameSecondary] = !0)), x) {
                        const e1 = a.evaluate(y, {}, i).join(","), t = "map" === o.get("text-rotation-alignment") && "point" !== o.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(A_.vertical) >= 0;
                        for (const i of x.sections)if (i.image) p[i.image.namePrimary] = !0;
                        else {
                            const r = Ns(x.toString()), n = i.fontStack || e1, o = f[n] = f[n] || {};
                            this.calculateGlyphDependencies(i.text, o, t, this.allowVerticalPlacement, r);
                        }
                    }
                }
                "line" === o.get("symbol-placement") && (this.features = function(e1) {
                    const t = {}, i = {}, r = [];
                    let n = 0;
                    function o(t) {
                        r.push(e1[t]), n++;
                    }
                    function s(e1, t, n) {
                        const o = i[e1];
                        return delete i[e1], i[t] = o, r[o].geometry[0].pop(), r[o].geometry[0] = r[o].geometry[0].concat(n[0]), o;
                    }
                    function a(e1, i, n) {
                        const o = t[i];
                        return delete t[i], t[e1] = o, r[o].geometry[0].shift(), r[o].geometry[0] = n[0].concat(r[o].geometry[0]), o;
                    }
                    function l(e1, t, i) {
                        const r = i ? t[0][t[0].length - 1] : t[0][0];
                        return `${e1}:${r.x}:${r.y}`;
                    }
                    for(let c = 0; c < e1.length; c++){
                        const h = e1[c], u = h.geometry, d = h.text ? h.text.toString() : null;
                        if (!d) {
                            o(c);
                            continue;
                        }
                        const p = l(d, u), f = l(d, u, !0);
                        if (p in i && f in t && i[p] !== t[f]) {
                            const e1 = a(p, f, u), n = s(p, f, r[e1].geometry);
                            delete t[p], delete i[f], i[l(d, r[n].geometry, !0)] = n, r[e1].geometry = null;
                        } else p in i ? s(p, f, u) : f in t ? a(p, f, u) : (o(c), t[p] = n - 1, i[f] = n - 1);
                    }
                    return r.filter((e1)=>e1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((e1, t)=>e1.sortKey - t.sortKey);
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                if (o && !this.stateDependentLayers.length) return;
                const s = o ? this.stateDependentLayers : this.layers;
                this.text.programConfigurations.updatePaintArrays(e1, t, s, i, r, n), this.icon.programConfigurations.updatePaintArrays(e1, t, s, i, r, n);
            }
            updateZOffset() {
                const e1 = (e1, t, r)=>{
                    i += t, i > e1.length && e1.resize(i);
                    for(let n = -t; n < 0; n++)e1.emplace(n + i, r);
                }, t = (e1, t, i)=>{
                    r += t, r > e1.length && e1.resize(r);
                    for(let n = -t; n < 0; n++)e1.emplace(n + r, i);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let i = 0, r = 0;
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const r = this.symbolInstances.get(i), { numHorizontalGlyphVertices: n, numVerticalGlyphVertices: o, numIconVertices: s } = r, a = r.zOffset, l = s > 0;
                    if ((n > 0 || o > 0) && (e1(this.text.zOffsetVertexArray, n, a), e1(this.text.zOffsetVertexArray, o, a)), l) {
                        const { placedIconSymbolIndex: e1, verticalPlacedIconSymbolIndex: i } = r;
                        e1 >= 0 && t(this.icon.zOffsetVertexArray, s, a), i >= 0 && t(this.icon.zOffsetVertexArray, r.numVerticalIconVertices, a);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(e1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e1), this.iconCollisionBox.upload(e1)), this.text.upload(e1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(e1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = ty(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(e1, t) {
                const i = this.lineVertexArray.length;
                if (void 0 !== e1.segment) for (const { x: e1, y: i } of t)this.lineVertexArray.emplaceBack(e1, i);
                return {
                    lineStartIndex: i,
                    lineLength: this.lineVertexArray.length - i
                };
            }
            addSymbols(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
                const _ = e1.indexArray, g = e1.layoutVertexArray, y = e1.globeExtVertexArray, x = e1.segments.prepareSegment(4 * t.length, g, _, this.canOverlap ? o.sortKey : void 0), v = this.glyphOffsetArray.length, b = x.vertexLength, w = this.allowVerticalPlacement && s === A_.vertical ? Math.PI / 2 : 0, T = o.text && o.text.sections;
                for(let r = 0; r < t.length; r++){
                    const { tl: n, tr: s, bl: c, br: h, texPrimary: u, texSecondary: v, pixelOffsetTL: b, pixelOffsetBR: E, minFontScaleX: M, minFontScaleY: A, glyphOffset: S, isSDF: I, sectionIndex: C } = t[r], z = x.vertexLength, P = S[1];
                    if (ly(g, l.x, l.y, n.x, P + n.y, u.x, u.y, i, I, b.x, b.y, M, A), ly(g, l.x, l.y, s.x, P + s.y, u.x + u.w, u.y, i, I, E.x, b.y, M, A), ly(g, l.x, l.y, c.x, P + c.y, u.x, u.y + u.h, i, I, b.x, E.y, M, A), ly(g, l.x, l.y, h.x, P + h.y, u.x + u.w, u.y + u.h, i, I, E.x, E.y, M, A), a) {
                        const { x: t, y: i, z: r } = a.anchor, [n, o, s] = a.up;
                        hy(y, t, i, r, n, o, s), hy(y, t, i, r, n, o, s), hy(y, t, i, r, n, o, s), hy(y, t, i, r, n, o, s), dy(e1.dynamicLayoutVertexArray, t, i, r, w);
                    } else dy(e1.dynamicLayoutVertexArray, l.x, l.y, l.z, w);
                    if (m) {
                        const t = v || u;
                        cy(e1.iconTransitioningVertexArray, t.x, t.y), cy(e1.iconTransitioningVertexArray, t.x + t.w, t.y), cy(e1.iconTransitioningVertexArray, t.x, t.y + t.h), cy(e1.iconTransitioningVertexArray, t.x + t.w, t.y + t.h);
                    }
                    _.emplaceBack(z, z + 1, z + 2), _.emplaceBack(z + 1, z + 2, z + 3), x.vertexLength += 4, x.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(S[0]), r !== t.length - 1 && C === t[r + 1].sectionIndex || e1.programConfigurations.populatePaintArrays(g.length, o, o.index, {}, d, p, f, T && T[C]);
                }
                const E = a ? a.anchor : l;
                e1.placedSymbolArray.emplaceBack(E.x, E.y, E.z, l.x, l.y, v, this.glyphOffsetArray.length - v, b, c, h, l.segment, i ? i[0] : 0, i ? i[1] : 0, r[0], r[1], s, 0, !1, 0, u, 0);
            }
            _commitLayoutVertex(e1, t, i, r, n, o, s) {
                e1.emplaceBack(t, i, r, n, o, Math.round(s.x), Math.round(s.y));
            }
            _addCollisionDebugVertices(e1, t, i, r, n, o, s) {
                const a = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), l = a.vertexLength, c = s.tileAnchorX, h = s.tileAnchorY;
                for(let e1 = 0; e1 < 4; e1++)i.collisionVertexArray.emplaceBack(0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(i.collisionVertexArrayExt, t, e1.padding, s.zOffset), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x1, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x2, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x2, e1.y2)), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x1, e1.y2)), a.vertexLength += 4;
                const u = i.indexArray;
                u.emplaceBack(l, l + 1), u.emplaceBack(l + 1, l + 2), u.emplaceBack(l + 2, l + 3), u.emplaceBack(l + 3, l), a.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceTextSize(e1, o, t, s);
                    this._addCollisionDebugVertices(r, n, this.textCollisionBox, r.projectedAnchorX, r.projectedAnchorY, r.projectedAnchorZ, o);
                }
            }
            _addIconDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceIconSize(e1, t, o.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(r, n, this.iconCollisionBox, r.projectedAnchorX, r.projectedAnchorY, r.projectedAnchorZ, o);
                }
            }
            generateCollisionDebugBuffers(e1, t) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new my(qa, c_.members, ja), this.iconCollisionBox = new my(qa, c_.members, ja);
                const i = m_(this.iconSizeData, e1), r = m_(this.textSizeData, e1);
                for(let n = 0; n < this.symbolInstances.length; n++){
                    const o = this.symbolInstances.get(n);
                    this._addTextDebugCollisionBoxes(r, e1, t, o.textBoxStartIndex, o.textBoxEndIndex, o), this._addTextDebugCollisionBoxes(r, e1, t, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o), this._addIconDebugCollisionBoxes(i, e1, t, o.iconBoxStartIndex, o.iconBoxEndIndex, o), this._addIconDebugCollisionBoxes(i, e1, t, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o);
                }
            }
            getSymbolInstanceTextSize(e1, t, i, r) {
                const n = this.text.placedSymbolArray.get(t.rightJustifiedTextSymbolIndex >= 0 ? t.rightJustifiedTextSymbolIndex : t.centerJustifiedTextSymbolIndex >= 0 ? t.centerJustifiedTextSymbolIndex : t.leftJustifiedTextSymbolIndex >= 0 ? t.leftJustifiedTextSymbolIndex : t.verticalPlacedTextSymbolIndex >= 0 ? t.verticalPlacedTextSymbolIndex : r), o = f_(this.textSizeData, e1, n) / u_;
                return this.tilePixelRatio * o;
            }
            getSymbolInstanceIconSize(e1, t, i) {
                const r = this.icon.placedSymbolArray.get(i), n = f_(this.iconSizeData, e1, r);
                return this.tilePixelRatio * n;
            }
            _commitDebugCollisionVertexUpdate(e1, t, i, r) {
                e1.emplaceBack(t, -i, -i, r), e1.emplaceBack(t, i, -i, r), e1.emplaceBack(t, i, i, r), e1.emplaceBack(t, -i, i, r);
            }
            _updateTextDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceTextSize(e1, o, t, s);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, n, r.padding, o.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceIconSize(e1, t, o.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, n, r.padding, o.zOffset);
                }
            }
            updateCollisionDebugBuffers(e1, t) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const i = m_(this.iconSizeData, e1), r = m_(this.textSizeData, e1);
                for(let n = 0; n < this.symbolInstances.length; n++){
                    const o = this.symbolInstances.get(n);
                    this._updateTextDebugCollisionBoxes(r, e1, t, o.textBoxStartIndex, o.textBoxEndIndex, o), this._updateTextDebugCollisionBoxes(r, e1, t, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o), this._updateIconDebugCollisionBoxes(i, e1, t, o.iconBoxStartIndex, o.iconBoxEndIndex, o), this._updateIconDebugCollisionBoxes(i, e1, t, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(e1, t, i, r, n, o, s, a, l) {
                const c = {};
                if (t < i) {
                    const { x1: i, y1: r, x2: n, y2: o, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(t);
                    c.textBox = {
                        x1: i,
                        y1: r,
                        x2: n,
                        y2: o,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.textFeatureIndex = p;
                }
                if (r < n) {
                    const { x1: t, y1: i, x2: n, y2: o, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(r);
                    c.verticalTextBox = {
                        x1: t,
                        y1: i,
                        x2: n,
                        y2: o,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.verticalTextFeatureIndex = p;
                }
                if (o < s) {
                    const { x1: t, y1: i, x2: r, y2: n, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(o);
                    c.iconBox = {
                        x1: t,
                        y1: i,
                        x2: r,
                        y2: n,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.iconFeatureIndex = p;
                }
                if (a < l) {
                    const { x1: t, y1: i, x2: r, y2: n, padding: o, projectedAnchorX: s, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(a);
                    c.verticalIconBox = {
                        x1: t,
                        y1: i,
                        x2: r,
                        y2: n,
                        padding: o,
                        projectedAnchorX: s,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.verticalIconFeatureIndex = p;
                }
                return c;
            }
            deserializeCollisionBoxes(e1) {
                this.collisionArrays = [];
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const i = this.symbolInstances.get(t);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e1, i.textBoxStartIndex, i.textBoxEndIndex, i.verticalTextBoxStartIndex, i.verticalTextBoxEndIndex, i.iconBoxStartIndex, i.iconBoxEndIndex, i.verticalIconBoxStartIndex, i.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(e1, t) {
                const i = e1.placedSymbolArray.get(t), r = i.vertexStartIndex + 4 * i.numGlyphs;
                for(let t = i.vertexStartIndex; t < r; t += 4)e1.indexArray.emplaceBack(t, t + 1, t + 2), e1.indexArray.emplaceBack(t + 1, t + 2, t + 3);
            }
            getSortedSymbolIndexes(e1) {
                if (this.sortedAngle === e1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const t = Math.sin(e1), i = Math.cos(e1), r = [], n = [], o = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; ++e1){
                    o.push(e1);
                    const s = this.symbolInstances.get(e1);
                    r.push(0 | Math.round(t * s.tileAnchorX + i * s.tileAnchorY)), n.push(s.featureIndex);
                }
                return o.sort((e1, t)=>r[e1] - r[t] || n[t] - n[e1]), o;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let e1 = 0; e1 < this.symbolInstances.length; ++e1)this.symbolInstanceIndexesSortedZOffset.push(e1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((e1, t)=>this.symbolInstances.get(t).zOffset - this.symbolInstances.get(e1).zOffset);
            }
            addToSortKeyRanges(e1, t) {
                const i = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                i && i.sortKey === t ? i.symbolInstanceEnd = e1 + 1 : this.sortKeyRanges.push({
                    sortKey: t,
                    symbolInstanceStart: e1,
                    symbolInstanceEnd: e1 + 1
                });
            }
            sortFeatures(e1) {
                if (this.sortFeaturesByY && this.sortedAngle !== e1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e1), this.sortedAngle = e1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const e1 of this.symbolInstanceIndexes){
                        const t = this.symbolInstances.get(e1);
                        this.featureSortOrder.push(t.featureIndex);
                        const { rightJustifiedTextSymbolIndex: i, centerJustifiedTextSymbolIndex: r, leftJustifiedTextSymbolIndex: n, verticalPlacedTextSymbolIndex: o, placedIconSymbolIndex: s, verticalPlacedIconSymbolIndex: a } = t;
                        i >= 0 && this.addIndicesForPlacedSymbol(this.text, i), r >= 0 && r !== i && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && n !== i && this.addIndicesForPlacedSymbol(this.text, n), o >= 0 && this.addIndicesForPlacedSymbol(this.text, o), s >= 0 && this.addIndicesForPlacedSymbol(this.icon, s), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
        }
        Rs(_y, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), _y.MAX_GLYPHS = 65535, _y.addDynamicAttributes = dy;
        var gy = _y;
        const yy = Ia([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: xy } = yy, vy = Ia([
            {
                name: "a_packed",
                components: 4,
                type: "Float32"
            }
        ]), { members: by } = vy, wy = hm.types, Ty = Math.cos(Math.PI / 180 * 37.5);
        class Ey {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.projection = e1.projection, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((e1)=>{
                    this.gradients[e1.id] = {};
                }), this.layoutVertexArray = new La, this.layoutVertexArray2 = new ka, this.indexArray = new Wa, this.programConfigurations = new ec(e1.layers, e1.zoom), this.segments = new xl, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
            populate(e1, t, i, r) {
                this.hasPattern = Uf("line", this.layers, t);
                const n = this.layers[0].layout.get("line-sort-key"), o = [];
                for (const { feature: t, id: s, index: a, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = gp(t, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), c, i)) continue;
                    const h = n ? n.evaluate(c, {}, i) : void 0, u = {
                        id: s,
                        properties: t.properties,
                        type: t.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: e1 ? c.geometry : _p(t, i, r),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(u);
                }
                n && o.sort((e1, t)=>e1.sortKey - t.sortKey);
                const { lineAtlas: s, featureIndex: a } = t, l = this.addConstantDashes(s);
                for (const r of o){
                    const { geometry: n, index: o, sourceLayerIndex: c } = r;
                    if (l && this.addFeatureDashes(r, s), this.hasPattern) {
                        const e1 = Vf("line", this.layers, r, this.zoom, t);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(r, n, o, i, s.positions, t.availableImages, t.brightness);
                    a.insert(e1[o].feature, n, o, c, this.index);
                }
            }
            addConstantDashes(e1) {
                let t = !1;
                for (const i of this.layers){
                    const r = i.paint.get("line-dasharray").value, n = i.layout.get("line-cap").value;
                    if ("constant" !== r.kind || "constant" !== n.kind) t = !0;
                    else {
                        const t = n.value, i = r.value;
                        if (!i) continue;
                        e1.addDash(i, t);
                    }
                }
                return t;
            }
            addFeatureDashes(e1, t) {
                const i = this.zoom;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, o = r.layout.get("line-cap").value;
                    if ("constant" === n.kind && "constant" === o.kind) continue;
                    let s, a;
                    if ("constant" === n.kind) {
                        if (s = n.value, !s) continue;
                    } else s = n.evaluate({
                        zoom: i
                    }, e1);
                    a = "constant" === o.kind ? o.value : o.evaluate({
                        zoom: i
                    }, e1), t.addDash(s, a), e1.patterns[r.id] = t.getKey(s, a);
                }
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                o && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(e1, t, o ? this.stateDependentLayers : this.layers, i, r, n);
            }
            addFeatures(e1, t, i, r, n, o) {
                for (const e1 of this.patternFeatures)this.addFeature(e1, e1.geometry, e1.index, t, i, r, o);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e1.createVertexBuffer(this.layoutVertexArray2, by)), this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, xy), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(e1) {
                if (e1.properties && e1.properties.hasOwnProperty("mapbox_clip_start") && e1.properties.hasOwnProperty("mapbox_clip_end")) return {
                    start: +e1.properties.mapbox_clip_start,
                    end: +e1.properties.mapbox_clip_end
                };
            }
            addFeature(e1, t, i, r, n, o, s) {
                const a = this.layers[0].layout, l = a.get("line-join").evaluate(e1, {}), c = a.get("line-cap").evaluate(e1, {}), h = a.get("line-miter-limit"), u = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(e1);
                for (const i of t)this.addLine(i, e1, l, c, h, u);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, n, o, r, s);
            }
            addLine(e1, t, i, r, n, o) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let t = 0; t < e1.length - 1; t++)this.totalDistance += e1[t].dist(e1[t + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const s = "Polygon" === wy[t.type];
                let a = e1.length;
                for(; a >= 2 && e1[a - 1].equals(e1[a - 2]);)a--;
                let l = 0;
                for(; l < a - 1 && e1[l].equals(e1[l + 1]);)l++;
                if (a < (s ? 3 : 2)) return;
                "bevel" === i && (n = 1.05);
                const c = this.overscaling <= 16 ? 15 * cr / (512 * this.overscaling) : 0, h = this.segments.prepareSegment(10 * a, this.layoutVertexArray, this.indexArray);
                let u, d, p, f, m;
                this.e1 = this.e2 = -1, s && (u = e1[a - 2], m = e1[l].sub(u)._unit()._perp());
                for(let t = l; t < a; t++){
                    if (p = t === a - 1 ? s ? e1[l + 1] : void 0 : e1[t + 1], p && e1[t].equals(p)) continue;
                    m && (f = m), u && (d = u), u = e1[t], m = p ? p.sub(u)._unit()._perp() : f, f = f || m;
                    let _ = f.add(m);
                    0 === _.x && 0 === _.y || _._unit();
                    const g = f.x * m.x + f.y * m.y, y = _.x * m.x + _.y * m.y, x = 0 !== y ? 1 / y : 1 / 0, v = 2 * Math.sqrt(2 - 2 * y), b = y < Ty && d && p, w = f.x * m.y - f.y * m.x > 0;
                    if (b && t > l) {
                        const e1 = u.dist(d);
                        if (e1 > 2 * c) {
                            const t = u.sub(u.sub(d)._mult(c / e1)._round());
                            this.updateDistance(d, t), this.addCurrentVertex(t, f, 0, 0, h), d = t;
                        }
                    }
                    const T = d && p;
                    let E = T ? i : s ? "butt" : r;
                    if (T && "round" === E && (x < o ? E = "miter" : x <= 2 && (E = "fakeround")), "miter" === E && x > n && (E = "bevel"), "bevel" === E && (x > 2 && (E = "flipbevel"), x < n && (E = "miter")), d && this.updateDistance(d, u), "miter" === E) _._mult(x), this.addCurrentVertex(u, _, 0, 0, h);
                    else if ("flipbevel" === E) {
                        if (x > 100) _ = m.mult(-1);
                        else {
                            const e1 = x * f.add(m).mag() / f.sub(m).mag();
                            _._perp()._mult(e1 * (w ? -1 : 1));
                        }
                        this.addCurrentVertex(u, _, 0, 0, h), this.addCurrentVertex(u, _.mult(-1), 0, 0, h);
                    } else if ("bevel" === E || "fakeround" === E) {
                        const e1 = -Math.sqrt(x * x - 1), t = w ? e1 : 0, i = w ? 0 : e1;
                        if (d && this.addCurrentVertex(u, f, t, i, h), "fakeround" === E) {
                            const e1 = Math.round(180 * v / Math.PI / 20);
                            for(let t = 1; t < e1; t++){
                                let i = t / e1;
                                if (.5 !== i) {
                                    const e1 = i - .5;
                                    i += i * e1 * (i - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * e1 * e1 + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const r = m.sub(f)._mult(i)._add(f)._unit()._mult(w ? -1 : 1);
                                this.addHalfVertex(u, r.x, r.y, !1, w, 0, h);
                            }
                        }
                        p && this.addCurrentVertex(u, m, -t, -i, h);
                    } else if ("butt" === E) this.addCurrentVertex(u, _, 0, 0, h);
                    else if ("square" === E) {
                        const e1 = d ? 1 : -1;
                        d || this.addCurrentVertex(u, _, e1, e1, h), this.addCurrentVertex(u, _, 0, 0, h), d && this.addCurrentVertex(u, _, e1, e1, h);
                    } else "round" === E && (d && (this.addCurrentVertex(u, f, 0, 0, h), this.addCurrentVertex(u, f, 1, 1, h, !0)), p && (this.addCurrentVertex(u, m, -1, -1, h, !0), this.addCurrentVertex(u, m, 0, 0, h)));
                    if (b && t < a - 1) {
                        const e1 = u.dist(p);
                        if (e1 > 2 * c) {
                            const t = u.add(p.sub(u)._mult(c / e1)._round());
                            this.updateDistance(u, t), this.addCurrentVertex(t, m, 0, 0, h), u = t;
                        }
                    }
                }
            }
            addCurrentVertex(e1, t, i, r, n, o = !1) {
                const s = t.y * r - t.x, a = -t.y - t.x * r;
                this.addHalfVertex(e1, t.x + t.y * i, t.y - t.x * i, o, !1, i, n), this.addHalfVertex(e1, s, a, o, !0, -r, n);
            }
            addHalfVertex({ x: e1, y: t }, i, r, n, o, s, a) {
                this.layoutVertexArray.emplaceBack((e1 << 1) + (n ? 1 : 0), (t << 1) + (o ? 1 : 0), Math.round(63 * i) + 128, Math.round(63 * r) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1), 0, this.lineSoFar), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
                const l = a.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, l), a.primitiveLength++), o ? this.e2 = l : this.e1 = l;
            }
            updateScaledDistance() {
                if (this.lineClips) {
                    const e1 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                    this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = e1 * this.lineClips.start + this.distance;
                } else this.lineSoFar = this.distance;
            }
            updateDistance(e1, t) {
                this.distance += e1.dist(t), this.updateScaledDistance();
            }
        }
        Rs(Ey, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        class My {
            constructor(e1, t, i, r){
                this.context = e1, this.format = i, this.texture = e1.gl.createTexture(), this.update(t, r);
            }
            update(e1, i, r) {
                const { width: n, height: o } = e1, { context: s } = this, { gl: a } = s, { HTMLImageElement: l, HTMLCanvasElement: c, HTMLVideoElement: h, ImageData: u, ImageBitmap: d } = t;
                if (a.bindTexture(a.TEXTURE_2D, this.texture), s.pixelStoreUnpackFlipY.set(!1), s.pixelStoreUnpack.set(1), s.pixelStoreUnpackPremultiplyAlpha.set(this.format === a.RGBA && (!i || !1 !== i.premultiply)), r || this.size && this.size[0] === n && this.size[1] === o) {
                    const { x: t, y: i } = r || {
                        x: 0,
                        y: 0
                    };
                    if (e1 instanceof l || e1 instanceof c || e1 instanceof h || e1 instanceof u || d && e1 instanceof d) a.texSubImage2D(a.TEXTURE_2D, 0, t, i, a.RGBA, a.UNSIGNED_BYTE, e1);
                    else {
                        let r = this.format, s = a.UNSIGNED_BYTE;
                        this.format === a.R32F && (r = a.RED, s = a.FLOAT), a.texSubImage2D(a.TEXTURE_2D, 0, t, i, n, o, r, s, e1.data);
                    }
                } else if (this.size = [
                    n,
                    o
                ], e1 instanceof l || e1 instanceof c || e1 instanceof h || e1 instanceof u || d && e1 instanceof d) {
                    let t = this.format;
                    this.format === a.R8 && (t = a.RED), a.texImage2D(a.TEXTURE_2D, 0, this.format, t, a.UNSIGNED_BYTE, e1);
                } else {
                    let t = this.format, i = this.format, r = a.UNSIGNED_BYTE;
                    this.format === a.DEPTH_COMPONENT && (t = a.DEPTH_COMPONENT16, r = a.UNSIGNED_SHORT), this.format === a.R32F && (r = a.FLOAT, i = a.RED), a.texImage2D(a.TEXTURE_2D, 0, t, n, o, 0, i, r, e1.data);
                }
                this.useMipmap = Boolean(i && i.useMipmap), this.useMipmap && a.generateMipmap(a.TEXTURE_2D);
            }
            bind(e1, t) {
                const { context: i } = this, { gl: r } = i;
                r.bindTexture(r.TEXTURE_2D, this.texture), e1 !== this.minFilter && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.useMipmap ? e1 === r.NEAREST ? r.NEAREST_MIPMAP_NEAREST : r.LINEAR_MIPMAP_NEAREST : e1), this.minFilter = e1), t !== this.wrapS && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, t), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, t), this.wrapS = t);
            }
            bindExtraParam(e1, t, i, r) {
                const { context: n } = this, { gl: o } = n;
                o.bindTexture(o.TEXTURE_2D, this.texture), t !== this.magFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, t), this.magFilter = t), e1 !== this.minFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, this.useMipmap ? e1 === o.NEAREST ? o.NEAREST_MIPMAP_NEAREST : o.LINEAR_MIPMAP_NEAREST : e1), this.minFilter = e1), i !== this.wrapS && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, i), this.wrapS = i), r !== this.wrapT && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, r), this.wrapT = r);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class Ay {
            constructor(e1, t){
                this.context = e1, this.texture = t;
            }
            bind(e1, t) {
                const { context: i } = this, { gl: r } = i;
                r.bindTexture(r.TEXTURE_2D, this.texture), e1 !== this.minFilter && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t !== this.wrapS && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, t), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, t), this.wrapS = t);
            }
        }
        const Sy = 32, Iy = 33, Cy = new Uint16Array(8184);
        for(let e1 = 0; e1 < 2046; e1++){
            let t = e1 + 2, i = 0, r = 0, n = 0, o = 0, s = 0, a = 0;
            for(1 & t ? n = o = s = Sy : i = r = a = Sy; (t >>= 1) > 1;){
                const e1 = i + n >> 1, l = r + o >> 1;
                1 & t ? (n = i, o = r, i = s, r = a) : (i = n, r = o, n = s, o = a), s = e1, a = l;
            }
            const l = 4 * e1;
            Cy[l + 0] = i, Cy[l + 1] = r, Cy[l + 2] = n, Cy[l + 3] = o;
        }
        const zy = new Uint16Array(2178), Py = new Uint8Array(1089), Dy = new Uint16Array(1089);
        function Ry(e1) {
            return 0 === e1 ? -0.03125 : 32 === e1 ? .03125 : 0;
        }
        var Ly = Ia([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const ky = {
            type: 2,
            extent: cr,
            loadGeometry: ()=>[
                    [
                        new y(0, 0),
                        new y(cr + 1, 0),
                        new y(cr + 1, cr + 1),
                        new y(0, cr + 1),
                        new y(0, 0)
                    ]
                ]
        };
        class Oy {
            constructor(e1, t, i, r, n){
                this.tileID = e1, this.uid = F(), this.uses = 0, this.tileSize = t, this.tileZoom = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = n, r && r.style && (this._lastUpdatedBrightness = r.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", r && r.transform && (this.projection = r.transform.projection);
            }
            registerFadeDuration(e1) {
                const t = e1 + this.timeAdded;
                t < dt.now() || this.fadeEndTime && t < this.fadeEndTime || (this.fadeEndTime = t);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = Pg(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(e1, t, i) {
                if (this.unloadVectorData(), this.state = "loaded", e1) {
                    e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestFeatureIndex.rawTileData = e1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(e1, t) {
                        const i = {};
                        if (!t) return i;
                        for (const r of e1){
                            const e1 = r.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
                            if (0 !== e1.length) {
                                r.layers = e1, r.stateDependentLayerIds && (r.stateDependentLayers = r.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
                                for (const t of e1)i[t.fqid] = r;
                            }
                        }
                        return i;
                    }(e1.buckets, t.style), this.hasSymbolBuckets = !1;
                    for(const e1 in this.buckets){
                        const t = this.buckets[e1];
                        if (t instanceof gy) {
                            if (this.hasSymbolBuckets = !0, !i) break;
                            t.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e1 in this.buckets){
                        const t = this.buckets[e1];
                        if (t instanceof gy && t.hasRTLText) {
                            this.hasRTLText = !0, na.isLoading() || na.isLoaded() || "deferred" !== ia() || ra();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e1 in this.buckets){
                        const i = this.buckets[e1], r = t.style.getOwnLayer(e1);
                        if (!r) continue;
                        const n = r.queryRadius(i);
                        this.queryPadding = Math.max(this.queryPadding, n);
                    }
                    e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), e1.lineAtlas && (this.lineAtlas = e1.lineAtlas), this._lastUpdatedBrightness = e1.brightness;
                } else this.collisionBoxArray = new al;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e1 in this.buckets)this.buckets[e1].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            getBucket(e1) {
                return this.buckets[e1.fqid];
            }
            upload(e1) {
                for(const t in this.buckets){
                    const i = this.buckets[t];
                    i.uploadPending() && i.upload(e1);
                }
                const t = e1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new My(e1, this.imageAtlas.image, t.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new My(e1, this.glyphAtlasImage, t.ALPHA), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new My(e1, this.lineAtlas.image, t.ALPHA), this.lineAtlas.uploaded = !0);
            }
            prepare(e1, t, i) {
                if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture, i), !t || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const r = t.style.getBrightness();
                (this._lastUpdatedBrightness || r) && (this._lastUpdatedBrightness && r && Math.abs(this._lastUpdatedBrightness - r) < .001 || (this._lastUpdatedBrightness = r, this.updateBuckets(void 0, t)));
            }
            queryRenderedFeatures(e1, t, i, r, n, o, s, a) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    tileResult: r,
                    pixelPosMatrix: s,
                    transform: o,
                    params: n,
                    tileTransform: this.tileTransform
                }, e1, t, i) : {};
            }
            querySourceFeatures(e1, t) {
                const i = this.latestFeatureIndex;
                if (!i || !i.rawTileData) return;
                const r = i.loadVTLayers(), n = t ? t.sourceLayer : "", o = r._geojsonTileLayer || r[n];
                if (!o) return;
                const s = Fo(t && t.filter), { z: a, x: l, y: c } = this.tileID.canonical, h = {
                    z: a,
                    x: l,
                    y: c
                };
                for(let t = 0; t < o.length; t++){
                    const r = o.feature(t);
                    if (s.needGeometry) {
                        const e1 = gp(r, !0);
                        if (!s.filter(new oa(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
                    } else if (!s.filter(new oa(this.tileID.overscaledZ), r)) continue;
                    const u = i.getId(r, n), d = new Bm(r, a, l, c, u);
                    d.tile = h, e1.push(d);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            bucketsLoaded() {
                for(const e1 in this.buckets)if (this.buckets[e1].uploadPending()) return !1;
                return !0;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e1) {
                const t = this.expirationTime;
                if (e1.cacheControl) {
                    const t = ee(e1.cacheControl);
                    t["max-age"] && (this.expirationTime = Date.now() + 1e3 * t["max-age"]);
                } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                if (this.expirationTime) {
                    const e1 = Date.now();
                    let i = !1;
                    if (this.expirationTime > e1) i = !1;
                    else if (t) {
                        if (this.expirationTime < t) i = !0;
                        else {
                            const r = this.expirationTime - t;
                            r ? this.expirationTime = e1 + Math.max(r, 3e4) : i = !0;
                        }
                    } else i = !0;
                    i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(e1, t) {
                this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(e1).length && t && this.updateBuckets(e1, t);
            }
            updateBuckets(e1, t) {
                if (!this.latestFeatureIndex) return;
                const i = this.latestFeatureIndex.loadVTLayers(), r = t.style.listImages(), n = t.style.getBrightness();
                for(const o in this.buckets){
                    if (!t.style.hasLayer(o)) continue;
                    const s = this.buckets[o], a = s.layers[0].sourceLayer || "_geojsonTileLayer", l = i[a];
                    let c = {};
                    if (e1 && (c = e1[a], !l || !c || 0 === Object.keys(c).length)) continue;
                    if (s.update(c, l, r, this.imageAtlas && this.imageAtlas.patternPositions || {}, n), s instanceof Ey || s instanceof jf) {
                        const e1 = t.style.getOwnSourceCache(s.layers[0].source);
                        t._terrain && t._terrain.enabled && e1 && s.programConfigurations.needsUpload && t._terrain._clearRenderCacheForTile(e1.id, this.tileID);
                    }
                    const h = t && t.style && t.style.getOwnLayer(o);
                    h && (this.queryPadding = Math.max(this.queryPadding, h.queryRadius(s)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < dt.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e1) {
                this.symbolFadeHoldUntil = dt.now() + e1;
            }
            setTexture(e1, t) {
                const i = t.context, r = i.gl;
                this.texture = this.texture || t.getTileTexture(e1.width), this.texture && this.texture instanceof My ? this.texture.update(e1, {
                    useMipmap: !0
                }) : (this.texture = new My(i, e1, r.RGBA, {
                    useMipmap: !0
                }), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE));
            }
            setDependencies(e1, t) {
                const i = {};
                for (const e1 of t)i[e1] = !0;
                this.dependencies[e1] = i;
            }
            hasDependency(e1, t) {
                for (const i of e1){
                    const e1 = this.dependencies[i];
                    if (e1) {
                        for (const i of t)if (e1[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(e1, t) {
                if (!t || "mercator" === t.name || this._tileDebugBuffer) return;
                const i = _p(ky, this.tileID.canonical, this.tileTransform)[0], r = new za, n = new el;
                for(let e1 = 0; e1 < i.length; e1++){
                    const { x: t, y: o } = i[e1];
                    r.emplaceBack(t, o), n.emplaceBack(e1);
                }
                n.emplaceBack(0), this._tileDebugIndexBuffer = e1.createIndexBuffer(n), this._tileDebugBuffer = e1.createVertexBuffer(r, Nu.members), this._tileDebugSegments = xl.simpleSegment(0, 0, r.length, n.length);
            }
            _makeTileBoundsBuffers(e1, t) {
                if (this._tileBoundsBuffer || !t || "mercator" === t.name) return;
                const i = _p(ky, this.tileID.canonical, this.tileTransform)[0];
                let r, n;
                if (this.isRaster) {
                    const e1 = function(e1, t) {
                        const i = Pg(e1, t), r = Math.pow(2, e1.z);
                        for(let n = 0; n < Iy; n++)for(let o = 0; o < Iy; o++){
                            const s = ep((e1.x + (o + Ry(o)) / Sy) / r), a = tp((e1.y + (n + Ry(n)) / Sy) / r), l = t.project(s, a), c = n * Iy + o;
                            zy[2 * c + 0] = Math.round((l.x * i.scale - i.x) * cr), zy[2 * c + 1] = Math.round((l.y * i.scale - i.y) * cr);
                        }
                        Py.fill(0), Dy.fill(0);
                        for(let e1 = 2045; e1 >= 0; e1--){
                            const t = 4 * e1, i = Cy[t + 0], r = Cy[t + 1], n = Cy[t + 2], o = Cy[t + 3], s = i + n >> 1, a = r + o >> 1, l = s + a - r, c = a + i - s, h = r * Iy + i, u = o * Iy + n, d = a * Iy + s, p = Math.hypot((zy[2 * h + 0] + zy[2 * u + 0]) / 2 - zy[2 * d + 0], (zy[2 * h + 1] + zy[2 * u + 1]) / 2 - zy[2 * d + 1]) >= 16;
                            Py[d] = Py[d] || (p ? 1 : 0), e1 < 1022 && (Py[d] = Py[d] || Py[(r + c >> 1) * Iy + (i + l >> 1)] || Py[(o + c >> 1) * Iy + (n + l >> 1)]);
                        }
                        const n = new Da, o = new Wa;
                        let s = 0;
                        function a(e1, t) {
                            const i = t * Iy + e1;
                            return 0 === Dy[i] && (n.emplaceBack(zy[2 * i + 0], zy[2 * i + 1], e1 * cr / Sy, t * cr / Sy), Dy[i] = ++s), Dy[i] - 1;
                        }
                        function l(e1, t, i, r, n, s) {
                            const c = e1 + i >> 1, h = t + r >> 1;
                            if (Math.abs(e1 - n) + Math.abs(t - s) > 1 && Py[h * Iy + c]) l(n, s, e1, t, c, h), l(i, r, n, s, c, h);
                            else {
                                const l = a(e1, t), c = a(i, r), h = a(n, s);
                                o.emplaceBack(l, c, h);
                            }
                        }
                        return l(0, 0, Sy, Sy, Sy, 0), l(Sy, Sy, 0, 0, 0, Sy), {
                            vertices: n,
                            indices: o
                        };
                    }(this.tileID.canonical, t);
                    r = e1.vertices, n = e1.indices;
                } else {
                    r = new Da, n = new Wa;
                    for (const { x: e1, y: t } of i)r.emplaceBack(e1, t, 0, 0);
                    const e1 = Bf(r.int16, void 0, 4);
                    for(let t = 0; t < e1.length; t += 3)n.emplaceBack(e1[t], e1[t + 1], e1[t + 2]);
                }
                this._tileBoundsBuffer = e1.createVertexBuffer(r, Ly.members), this._tileBoundsIndexBuffer = e1.createIndexBuffer(n), this._tileBoundsSegments = xl.simpleSegment(0, 0, r.length, n.length);
            }
            _makeGlobeTileDebugBuffers(e1, t) {
                const i = t.projection;
                if (!i || "globe" !== i.name || t.freezeTileCoverage) return;
                const r = this.tileID.canonical, n = Ad(_d(r, t)), o = Dd(t.zoom);
                let s;
                o > 0 && (s = Au.invert(new Float64Array(16), t.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(e1, r, t, n, s, o), this._makeGlobeTileDebugTextBuffer(e1, r, t, n, s, o);
            }
            _globePoint(e1, t, i, r, n, o, s) {
                let a = Td(e1, t, i);
                if (o) {
                    const n = 1 << i.z, l = Kd(r.center.lng), c = Jd(r.center.lat), h = (i.x + .5) / n - l;
                    let u = 0;
                    h > .5 ? u = -1 : h < -0.5 && (u = 1);
                    let d = (e1 / cr + i.x) / n + u, p = (t / cr + i.y) / n;
                    d = (d - l) * r._pixelsPerMercatorPixel + l, p = (p - c) * r._pixelsPerMercatorPixel + c;
                    const f = [
                        d * r.worldSize,
                        p * r.worldSize,
                        0
                    ];
                    Du.transformMat4(f, f, o), a = md(a, f, s);
                }
                return Du.transformMat4(a, a, n);
            }
            _makeGlobeTileDebugBorderBuffer(e1, t, i, r, n, o) {
                const s = new za, a = new el, l = new Pa, c = (e1, c, h, u, d)=>{
                    const p = (h - e1) / (d - 1), f = (u - c) / (d - 1), m = s.length;
                    for(let h = 0; h < d; h++){
                        const u = e1 + h * p, d = c + h * f;
                        s.emplaceBack(u, d);
                        const _ = this._globePoint(u, d, t, i, r, n, o);
                        l.emplaceBack(_[0], _[1], _[2]), a.emplaceBack(m + h);
                    }
                }, h = cr;
                c(0, 0, h, 0, 16), c(h, 0, h, h, 16), c(h, h, 0, h, 16), c(0, h, 0, 0, 16), this._tileDebugIndexBuffer = e1.createIndexBuffer(a), this._tileDebugBuffer = e1.createVertexBuffer(s, Nu.members), this._globeTileDebugBorderBuffer = e1.createVertexBuffer(l, Fu.members), this._tileDebugSegments = xl.simpleSegment(0, 0, s.length, a.length);
            }
            _makeGlobeTileDebugTextBuffer(e1, t, i, r, n, o) {
                const s = cr / 4, a = new za, l = new Wa, c = new Pa, h = 25;
                l.reserve(32), a.reserve(h), c.reserve(h);
                const u = (e1, t)=>h * e1 + t;
                for(let e1 = 0; e1 < h; e1++){
                    const l = e1 * s;
                    for(let e1 = 0; e1 < h; e1++){
                        const h = e1 * s;
                        a.emplaceBack(h, l);
                        const u = this._globePoint(h, l, t, i, r, n, o);
                        c.emplaceBack(u[0], u[1], u[2]);
                    }
                }
                for(let e1 = 0; e1 < 4; e1++)for(let t = 0; t < 4; t++){
                    const i = u(e1, t), r = u(e1, t + 1), n = u(e1 + 1, t), o = u(e1 + 1, t + 1);
                    l.emplaceBack(i, r, n), l.emplaceBack(n, r, o);
                }
                this._tileDebugTextIndexBuffer = e1.createIndexBuffer(l), this._tileDebugTextBuffer = e1.createVertexBuffer(a, Nu.members), this._globeTileDebugTextBuffer = e1.createVertexBuffer(c, Fu.members), this._tileDebugTextSegments = xl.simpleSegment(0, 0, h, 32);
            }
            destroy(e1 = !1) {
                for(const e1 in this.buckets)this.buckets[e1].destroy();
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !e1 && this.texture && this.texture instanceof My && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.latestFeatureIndex = null, this.state = "unloaded";
            }
        }
        class By {
            constructor(e1, t){
                this.max = e1, this.onRemove = t, this.reset();
            }
            reset() {
                for(const e1 in this.data)for (const t of this.data[e1])t.timeout && clearTimeout(t.timeout), this.onRemove(t.value);
                return this.data = {}, this.order = [], this;
            }
            add(e1, t, i) {
                const r = e1.wrapped().key;
                void 0 === this.data[r] && (this.data[r] = []);
                const n = {
                    value: t,
                    timeout: void 0
                };
                if (void 0 !== i && (n.timeout = setTimeout(()=>{
                    this.remove(e1, n);
                }, i)), this.data[r].push(n), this.order.push(r), this.order.length > this.max) {
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            has(e1) {
                return e1.wrapped().key in this.data;
            }
            getAndRemove(e1) {
                return this.has(e1) ? this._getAndRemoveByKey(e1.wrapped().key) : null;
            }
            _getAndRemoveByKey(e1) {
                const t = this.data[e1].shift();
                return t.timeout && clearTimeout(t.timeout), 0 === this.data[e1].length && delete this.data[e1], this.order.splice(this.order.indexOf(e1), 1), t.value;
            }
            getByKey(e1) {
                const t = this.data[e1];
                return t ? t[0].value : null;
            }
            get(e1) {
                return this.has(e1) ? this.data[e1.wrapped().key][0].value : null;
            }
            remove(e1, t) {
                if (!this.has(e1)) return this;
                const i = e1.wrapped().key, r = void 0 === t ? 0 : this.data[i].indexOf(t), n = this.data[i][r];
                return this.data[i].splice(r, 1), n.timeout && clearTimeout(n.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(n.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e1) {
                for(this.max = e1; this.order.length > this.max;){
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            filter(e1) {
                const t = [];
                for(const i in this.data)for (const r of this.data[i])e1(r.value) || t.push(r);
                for (const e1 of t)this.remove(e1.value.tileID, e1);
            }
        }
        class Fy {
            constructor(e1, t, i, r){
                this.id = Fy.uniqueIdxCounter, Fy.uniqueIdxCounter++, this.context = e1;
                const n = e1.gl;
                this.buffer = n.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), n.bufferData(n.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || r || t.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                this.id = Fy.uniqueIdxCounter, Fy.uniqueIdxCounter++;
                const t = this.context.gl;
                this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        Fy.uniqueIdxCounter = 0;
        const Ny = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Uy {
            constructor(e1, t, i, r, n, o){
                this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = r, this.instanceCount = o, this.context = e1;
                const s = e1.gl;
                this.buffer = s.createBuffer(), e1.bindVertexBuffer.set(this.buffer), s.bufferData(s.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || n || t.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t = this.context.gl;
                this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t) {
                for(let i = 0; i < this.attributes.length; i++){
                    const r = t.attributes[this.attributes[i].name];
                    void 0 !== r && e1.enableVertexAttribArray(r);
                }
            }
            setVertexAttribPointers(e1, t, i) {
                for(let r = 0; r < this.attributes.length; r++){
                    const n = this.attributes[r], o = t.attributes[n.name];
                    void 0 !== o && e1.vertexAttribPointer(o, n.components, e1[Ny[n.type]], !1, this.itemSize, n.offset + this.itemSize * (i || 0));
                }
            }
            setVertexAttribDivisor(e1, t, i) {
                for(let r = 0; r < this.attributes.length; r++){
                    const n = t.attributes[this.attributes[r].name];
                    void 0 !== n && this.instanceCount && this.instanceCount > 0 && e1.vertexAttribDivisor(n, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class Vy {
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class jy extends Vy {
            getDefault() {
                return hi.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Gy extends Vy {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class qy extends Vy {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Zy extends Vy {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class $y extends Vy {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Wy extends Vy {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Hy extends Vy {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t = this.current;
                (e1.func !== t.func || e1.ref !== t.ref || e1.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class Xy extends Vy {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class Yy extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Ky extends Vy {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class Jy extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Qy extends Vy {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ex extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class tx extends Vy {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO,
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.blendFuncSeparate(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class ix extends Vy {
            getDefault() {
                return hi.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class rx extends Vy {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e1, e1), this.current = e1, this.dirty = !1);
            }
        }
        class nx extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class ox extends Vy {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class sx extends Vy {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        let ax = class extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        };
        class lx extends Vy {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class cx extends Vy {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class hx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ux extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class dx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class px extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class fx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                const t = this.gl;
                t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class mx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                this.gl && (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
            }
        }
        class _x extends Vy {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class gx extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class yx extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class xx extends Vy {
            constructor(e1, t){
                super(e1), this.context = e1, this.parent = t;
            }
            getDefault() {
                return null;
            }
        }
        class vx extends xx {
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class bx extends xx {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, this.attachment(), t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class wx extends xx {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferTexture2D(t.FRAMEBUFFER, this.attachment(), t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Tx extends bx {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        class Ex {
            constructor(e1, t, i, r, n){
                this.context = e1, this.width = t, this.height = i;
                const o = this.framebuffer = e1.gl.createFramebuffer();
                r && (this.colorAttachment = new vx(e1, o)), n && (this.depthAttachmentType = n, this.depthAttachment = "renderbuffer" === n ? new bx(e1, o) : new wx(e1, o));
            }
            destroy() {
                const e1 = this.context.gl;
                if (this.colorAttachment) {
                    const t = this.colorAttachment.get();
                    t && e1.deleteTexture(t);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t = this.depthAttachment.get();
                        t && e1.deleteRenderbuffer(t);
                    } else {
                        const t = this.depthAttachment.get();
                        t && e1.deleteTexture(t);
                    }
                }
                e1.deleteFramebuffer(this.framebuffer);
            }
        }
        class Mx {
            constructor(e1, t, i){
                this.func = e1, this.mask = t, this.range = i;
            }
        }
        Mx.ReadOnly = !1, Mx.ReadWrite = !0, Mx.disabled = new Mx(519, Mx.ReadOnly, [
            0,
            1
        ]);
        const Ax = 7680;
        class Sx {
            constructor(e1, t, i, r, n, o){
                this.test = e1, this.ref = t, this.mask = i, this.fail = r, this.depthFail = n, this.pass = o;
            }
        }
        Sx.disabled = new Sx({
            func: 519,
            mask: 0
        }, 0, 0, Ax, Ax, Ax);
        const Ix = 771;
        class Cx {
            constructor(e1, t, i, r){
                this.blendFunction = e1, this.blendColor = t, this.mask = i, this.blendEquation = r;
            }
        }
        Cx.Replace = [
            1,
            0,
            1,
            0
        ], Cx.disabled = new Cx(Cx.Replace, hi.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Cx.unblended = new Cx(Cx.Replace, hi.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Cx.alphaBlended = new Cx([
            1,
            Ix,
            1,
            Ix
        ], hi.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Cx.multiply = new Cx([
            774,
            0,
            774,
            0
        ], hi.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        const zx = 1029, Px = 2305;
        class Dx {
            constructor(e1, t, i){
                this.enable = e1, this.mode = t, this.frontFace = i;
            }
        }
        Dx.disabled = new Dx(!1, zx, Px), Dx.backCCW = new Dx(!0, zx, Px), Dx.backCW = new Dx(!0, zx, 2304), Dx.frontCW = new Dx(!0, 1028, 2304), Dx.frontCCW = new Dx(!0, 1028, Px);
        class Rx {
            constructor(e1, t){
                this.gl = e1, this.clearColor = new jy(this), this.clearDepth = new Gy(this), this.clearStencil = new qy(this), this.colorMask = new Zy(this), this.depthMask = new $y(this), this.stencilMask = new Wy(this), this.stencilFunc = new Hy(this), this.stencilOp = new Xy(this), this.stencilTest = new Yy(this), this.depthRange = new Ky(this), this.depthTest = new Jy(this), this.depthFunc = new Qy(this), this.blend = new ex(this), this.blendFunc = new tx(this), this.blendColor = new ix(this), this.blendEquation = new rx(this), this.cullFace = new nx(this), this.cullFaceSide = new ox(this), this.frontFace = new sx(this), this.program = new ax(this), this.activeTexture = new lx(this), this.viewport = new cx(this), this.bindFramebuffer = new hx(this), this.bindRenderbuffer = new ux(this), this.bindTexture = new dx(this), this.bindVertexBuffer = new px(this), this.bindElementBuffer = new fx(this), this.bindVertexArrayOES = new mx(this), this.pixelStoreUnpack = new _x(this), this.pixelStoreUnpackPremultiplyAlpha = new gx(this), this.pixelStoreUnpackFlipY = new yx(this), this.options = t ? {
                    ...t
                } : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e1.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e1.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e1.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e1.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e1.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e1.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE);
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t, i) {
                return new Fy(this, e1, t, i);
            }
            createVertexBuffer(e1, t, i, r, n) {
                return new Uy(this, e1, t, i, r, n);
            }
            createRenderbuffer(e1, t, i) {
                const r = this.gl, n = r.createRenderbuffer();
                return this.bindRenderbuffer.set(n), r.renderbufferStorage(r.RENDERBUFFER, e1, t, i), this.bindRenderbuffer.set(null), n;
            }
            createFramebuffer(e1, t, i, r) {
                return new Ex(this, e1, t, i, r);
            }
            clear({ color: e1, depth: t, stencil: i, colorMask: r }) {
                const n = this.gl;
                let o = 0;
                e1 && (o |= n.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set(r || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t && (o |= n.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t), this.depthMask.set(!0)), void 0 !== i && (o |= n.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), n.clear(o);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e1) {
                x(e1.blendFunction, Cx.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor), e1.blendEquation ? this.blendEquation.set(e1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(e1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
        }
        class Lx extends zt {
            constructor(e1, t, i){
                super(), this.id = e1, this._onlySymbols = i, t.on("data", (e1)=>{
                    "source" === e1.dataType && "metadata" === e1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e1.dataType && "content" === e1.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), t.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = t, this._tiles = {}, this._cache = new By(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t.minTileCacheSize, this._maxTileCacheSize = t.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new Fm, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
            onAdd(e1) {
                this.map = e1, this._minTileCacheSize = void 0 === this._minTileCacheSize && e1 ? e1._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e1 ? e1._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e1 in this._tiles){
                    const t = this._tiles[e1];
                    if ("errored" !== t.state && ("loaded" !== t.state || !t.bucketsLoaded())) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(e1, t) {
                return e1.isSymbolTile = this._onlySymbols, e1.isExtraShadowCaster = this._shadowCasterTiles[e1.tileID.key], this._source.loadTile(e1, t);
            }
            _unloadTile(e1) {
                if (this._source.unloadTile) return this._source.unloadTile(e1, ()=>{});
            }
            _abortTile(e1) {
                if (this._source.abortTile) return this._source.abortTile(e1, ()=>{});
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    i.upload(e1), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return L(this._tiles).map((e1)=>e1.tileID).sort(kx).map((e1)=>e1.key);
            }
            getRenderableIds(e1, t) {
                const i = [];
                for(const r in this._tiles)this._isIdRenderable(+r, e1, t) && i.push(this._tiles[r]);
                return e1 ? i.sort((e1, t)=>{
                    const i = e1.tileID, r = t.tileID, n = new y(i.canonical.x, i.canonical.y)._rotate(this.transform.angle), o = new y(r.canonical.x, r.canonical.y)._rotate(this.transform.angle);
                    return i.overscaledZ - r.overscaledZ || o.y - n.y || o.x - n.x;
                }).map((e1)=>e1.tileID.key) : i.map((e1)=>e1.tileID).sort(kx).map((e1)=>e1.key);
            }
            hasRenderableParent(e1) {
                const t = this.findLoadedParent(e1, 0);
                return !!t && this._isIdRenderable(t.tileID.key);
            }
            _isIdRenderable(e1, t, i) {
                return this._tiles[e1] && this._tiles[e1].hasData() && !this._coveredTiles[e1] && (t || !this._tiles[e1].holdingForFade()) && (i || !this._shadowCasterTiles[e1]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e1 in this._tiles)"errored" !== this._tiles[e1].state && this._reloadTile(+e1, "reloading");
                }
            }
            _reloadTile(e1, t) {
                const i = this._tiles[e1];
                i && ("loading" !== i.state && (i.state = t), this._loadTile(i, this._tileLoaded.bind(this, i, e1, t)));
            }
            _tileLoaded(e1, t, i, r) {
                if (r) {
                    if (e1.state = "errored", 404 !== r.status) this._source.fire(new Ct(r, {
                        tile: e1
                    }));
                    else {
                        if (!(e1.tileID.key in this._loadedParentTiles)) return void this._source.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id
                        }));
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e1 = this.map.painter.terrain;
                            this.update(this.transform, e1.getScaledDemTileSize(), !0), e1.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    }
                } else e1.timeAdded = dt.now(), "expired" === i && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(t, e1), "raster-dem" === this._source.type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._source.fire(new It("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID,
                    sourceCacheId: this.id
                }));
            }
            _backfillDEM(e1) {
                const t = this.getRenderableIds();
                for(let r = 0; r < t.length; r++){
                    const n = t[r];
                    if (e1.neighboringTiles && e1.neighboringTiles[n]) {
                        const t = this.getTileByID(n);
                        i(e1, t), i(t, e1);
                    }
                }
                function i(e1, t) {
                    if (!e1.dem || e1.dem.borderReady) return;
                    e1.needsHillshadePrepare = !0, e1.needsDEMTextureUpload = !0;
                    let i = t.tileID.canonical.x - e1.tileID.canonical.x;
                    const r = t.tileID.canonical.y - e1.tileID.canonical.y, n = Math.pow(2, e1.tileID.canonical.z), o = t.tileID.key;
                    0 === i && 0 === r || Math.abs(r) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + n) ? i += n : 1 === Math.abs(i - n) && (i -= n)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, i, r), e1.neighboringTiles && e1.neighboringTiles[o] && (e1.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(e1) {
                return this.getTileByID(e1.key);
            }
            getTileByID(e1) {
                return this._tiles[e1];
            }
            _retainLoadedChildren(e1, t, i, r) {
                for(const n in this._tiles){
                    let o = this._tiles[n];
                    if (r[n] || !o.hasData() || o.tileID.overscaledZ <= t || o.tileID.overscaledZ > i) continue;
                    let s = o.tileID;
                    for(; o && o.tileID.overscaledZ > t + 1;){
                        const e1 = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                        o = this._tiles[e1.key], o && o.hasData() && (s = e1);
                    }
                    let a = s;
                    for(; a.overscaledZ > t;)if (a = a.scaledTo(a.overscaledZ - 1), e1[a.key]) {
                        r[s.key] = s;
                        break;
                    }
                }
            }
            findLoadedParent(e1, t) {
                if (e1.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e1.key];
                    return i && i.tileID.overscaledZ >= t ? i : null;
                }
                for(let i = e1.overscaledZ - 1; i >= t; i--){
                    const t = e1.scaledTo(i), r = this._getLoadedTile(t);
                    if (r) return r;
                }
            }
            _getLoadedTile(e1) {
                const t = this._tiles[e1.key];
                return t && t.hasData() ? t : this._cache.getByKey(this._source.reparseOverscaled ? e1.wrapped().key : e1.canonical.key);
            }
            updateCacheSize(e1, t) {
                t = t || this._source.tileSize;
                const i = Math.ceil(e1.width / t) + 1, r = Math.ceil(e1.height / t) + 1, n = Math.floor(i * r * 5), o = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, n) : n, s = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(s);
            }
            handleWrapJump(e1) {
                const t = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                if (this._prevLng = e1, t) {
                    const e1 = {};
                    for(const i in this._tiles){
                        const r = this._tiles[i];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t), e1[r.tileID.key] = r;
                    }
                    this._tiles = e1;
                    for(const e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
                    for(const e1 in this._tiles)this._setTileReloadTimer(+e1, this._tiles[e1]);
                }
            }
            update(e1, t, i, r) {
                if (this.transform = e1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !i) return;
                let n;
                if (this.updateCacheSize(e1, t), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? n = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new qu(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (n = e1.coveringTiles({
                    tileSize: t || this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom && !i,
                    reparseOverscaled: this._source.reparseOverscaled,
                    isTerrainDEM: this.usedForTerrain
                }), this._source.hasTile && (n = n.filter((e1)=>this._source.hasTile(e1)))) : n = [], n.length > 0 && this.castsShadows && r && "globe" !== this.transform.projection.name && !this.usedForTerrain && !Ox(this._source.type)) {
                    const o = e1.coveringZoomLevel({
                        tileSize: t || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !i
                    }), s = Math.min(o, this._source.maxzoom), a = e1.extendTileCoverForShadows(n, r, s);
                    for (const e1 of a)this._shadowCasterTiles[e1.key] = !0, n.push(e1);
                }
                const o = this._updateRetainedTiles(n);
                if (Ox(this._source.type) && 0 !== n.length) {
                    const e1 = {}, t = {}, i = Object.keys(o);
                    for (const r of i){
                        const i = o[r], n = this._tiles[r];
                        if (!n || n.fadeEndTime && n.fadeEndTime <= dt.now()) continue;
                        const s = this.findLoadedParent(i, Math.max(i.overscaledZ - Lx.maxOverzooming, this._source.minzoom));
                        s && (this._addTile(s.tileID), e1[s.tileID.key] = s.tileID), t[r] = i;
                    }
                    const r = n[n.length - 1].overscaledZ;
                    for(const e1 in this._tiles){
                        const i = this._tiles[e1];
                        if (o[e1] || !i.hasData()) continue;
                        let n = i.tileID;
                        for(; n.overscaledZ > r;){
                            n = n.scaledTo(n.overscaledZ - 1);
                            const r = this._tiles[n.key];
                            if (r && r.hasData() && t[n.key]) {
                                o[e1] = i.tileID;
                                break;
                            }
                        }
                    }
                    for(const t in e1)o[t] || (this._coveredTiles[t] = !0, o[t] = e1[t]);
                }
                for(const e1 in o)this._tiles[e1].clearFadeHold();
                const s = function(e1, t) {
                    const i = [];
                    for(const r in e1)r in t || i.push(r);
                    return i;
                }(this._tiles, o);
                for (const e1 of s){
                    const t = this._tiles[e1];
                    t.hasSymbolBuckets && !t.holdingForFade() ? t.setHoldDuration(this.map._fadeDuration) : t.hasSymbolBuckets && !t.symbolFadeFinished() || this._removeTile(+e1);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e1 in this._tiles)this._tiles[e1].holdingForFade() && this._removeTile(+e1);
            }
            _updateRetainedTiles(e1) {
                const t = {};
                if (0 === e1.length) return t;
                const i = {}, r = e1.reduce((e1, t)=>Math.min(e1, t.overscaledZ), 1 / 0), n = e1[0].overscaledZ, o = Math.max(n - Lx.maxOverzooming, this._source.minzoom), s = Math.max(n + Lx.maxUnderzooming, this._source.minzoom), a = {};
                for (const i of e1){
                    const e1 = this._addTile(i);
                    t[i.key] = i, e1.hasData() || r < this._source.maxzoom && (a[i.key] = i);
                }
                this._retainLoadedChildren(a, r, s, t);
                for (const r of e1){
                    let e1 = this._tiles[r.key];
                    if (e1.hasData()) continue;
                    if (r.canonical.z >= this._source.maxzoom) {
                        const e1 = r.children(this._source.maxzoom)[0], i = this.getTile(e1);
                        if (i && i.hasData()) {
                            t[e1.key] = e1;
                            continue;
                        }
                    } else {
                        const e1 = r.children(this._source.maxzoom);
                        if (t[e1[0].key] && t[e1[1].key] && t[e1[2].key] && t[e1[3].key]) continue;
                    }
                    let n = e1.wasRequested();
                    for(let s = r.overscaledZ - 1; s >= o; --s){
                        const o = r.scaledTo(s);
                        if (i[o.key]) break;
                        if (i[o.key] = !0, e1 = this.getTile(o), !e1 && n && (e1 = this._addTile(o)), e1 && (t[o.key] = o, n = e1.wasRequested(), e1.hasData())) break;
                    }
                }
                return t;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e1 in this._tiles){
                    const t = [];
                    let i, r = this._tiles[e1].tileID;
                    for(; r.overscaledZ > 0;){
                        if (r.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[r.key];
                            break;
                        }
                        t.push(r.key);
                        const e1 = r.scaledTo(r.overscaledZ - 1);
                        if (i = this._getLoadedTile(e1), i) break;
                        r = e1;
                    }
                    for (const e1 of t)this._loadedParentTiles[e1] = i;
                }
            }
            _addTile(e1) {
                let t = this._tiles[e1.key];
                if (t) return !0 !== t.isExtraShadowCaster || !!this._shadowCasterTiles[e1.key] || this._reloadTile(e1.key, "reloading"), t;
                t = this._cache.getAndRemove(e1), t && (this._setTileReloadTimer(e1.key, t), t.tileID = e1, this._state.initializeTileState(t, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, t)));
                const i = Boolean(t);
                if (!i) {
                    const i = this.map ? this.map.painter : null;
                    t = new Oy(e1, this._source.tileSize * e1.overscaleFactor(), this.transform.tileZoom, i, this._isRaster), this._loadTile(t, this._tileLoaded.bind(this, t, e1.key, t.state));
                }
                return t ? (t.uses++, this._tiles[e1.key] = t, i || this._source.fire(new It("dataloading", {
                    tile: t,
                    coord: t.tileID,
                    dataType: "source"
                })), t) : null;
            }
            _setTileReloadTimer(e1, t) {
                e1 in this._timers && (clearTimeout(this._timers[e1]), delete this._timers[e1]);
                const i = t.getExpiryTimeout();
                i && (this._timers[e1] = setTimeout(()=>{
                    this._reloadTile(e1, "expired"), delete this._timers[e1];
                }, i));
            }
            _removeTile(e1) {
                const t = this._tiles[e1];
                t && (t.uses--, delete this._tiles[e1], this._timers[e1] && (clearTimeout(this._timers[e1]), delete this._timers[e1]), t.uses > 0 || (t.hasData() && "reloading" !== t.state ? this._cache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e1 in this._tiles)this._removeTile(+e1);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(e1, t, i) {
                const r = [], n = this.transform;
                if (!n) return r;
                const o = "globe" === n.projection.name, s = Kd(n.center.lng);
                for(const a in this._tiles){
                    const l = this._tiles[a];
                    if (i && l.clearQueryDebugViz(), l.holdingForFade()) continue;
                    let c;
                    if (o) {
                        const e1 = l.tileID.canonical;
                        if (0 === e1.z) {
                            const t = [
                                Math.abs(z(s, ...Bx(e1, -1)) - s),
                                Math.abs(z(s, ...Bx(e1, 1)) - s)
                            ];
                            c = [
                                0,
                                2 * t.indexOf(Math.min(...t)) - 1
                            ];
                        } else {
                            const t = [
                                Math.abs(z(s, ...Bx(e1, -1)) - s),
                                Math.abs(z(s, ...Bx(e1, 0)) - s),
                                Math.abs(z(s, ...Bx(e1, 1)) - s)
                            ];
                            c = [
                                t.indexOf(Math.min(...t)) - 1
                            ];
                        }
                    } else c = [
                        0
                    ];
                    for (const i of c){
                        const o = e1.containsTile(l, n, t, i);
                        o && r.push(o);
                    }
                }
                return r;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e1) {
                return this._getRenderableCoordinates(e1);
            }
            _getRenderableCoordinates(e1, t) {
                const i = this.getRenderableIds(e1, t).map((e1)=>this._tiles[e1].tileID), r = "globe" === this.transform.projection.name;
                for (const e1 of i)e1.projMatrix = this.transform.calculateProjMatrix(e1.toUnwrapped()), e1.expandedProjMatrix = r ? this.transform.calculateProjMatrix(e1.toUnwrapped(), !1, !0) : e1.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e1) {
                const t = e1.slice(), i = this.transform._camera.position, r = this.transform._camera.forward(), n = {};
                for (const e1 of t){
                    const t = 1 / (1 << e1.canonical.z);
                    n[e1.key] = ((e1.canonical.x + .5) * t + e1.wrap - i[0]) * r[0] + ((e1.canonical.y + .5) * t - i[1]) * r[1] - i[2] * r[2];
                }
                return t.sort((e1, t)=>n[e1.key] - n[t.key]), t;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Ox(this._source.type)) for(const e1 in this._tiles){
                    const t = this._tiles[e1];
                    if (void 0 !== t.fadeEndTime && t.fadeEndTime >= dt.now()) return !0;
                }
                return !1;
            }
            setFeatureState(e1, t, i) {
                this._state.updateState(e1 = e1 || "_geojsonTileLayer", t, i);
            }
            removeFeatureState(e1, t, i) {
                this._state.removeFeatureState(e1 = e1 || "_geojsonTileLayer", t, i);
            }
            getFeatureState(e1, t) {
                return this._state.getState(e1 = e1 || "_geojsonTileLayer", t);
            }
            setDependencies(e1, t, i) {
                const r = this._tiles[e1];
                r && r.setDependencies(t, i);
            }
            reloadTilesForDependencies(e1, t) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e1, t) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e1, t));
            }
            _preloadTiles(e1, t) {
                if (!this._sourceLoaded) {
                    const i = ()=>{
                        this._sourceLoaded && (this._source.off("data", i), this._preloadTiles(e1, t));
                    };
                    return void this._source.on("data", i);
                }
                const i = new Map, r = Array.isArray(e1) ? e1 : [
                    e1
                ], n = this.map.painter.terrain, o = this.usedForTerrain && n ? n.getScaledDemTileSize() : this._source.tileSize;
                for (const e1 of r){
                    const t = e1.coveringTiles({
                        tileSize: o,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e1 of t)i.set(e1.key, e1);
                    this.usedForTerrain && e1.updateElevation(!1);
                }
                R(Array.from(i.values()), (e1, t)=>{
                    const i = new Oy(e1, this._source.tileSize * e1.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
                    this._loadTile(i, (e1)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t(e1, i);
                    });
                }, t);
            }
        }
        function kx(e1, t) {
            const i = Math.abs(2 * e1.wrap) - +(e1.wrap < 0), r = Math.abs(2 * t.wrap) - +(t.wrap < 0);
            return e1.overscaledZ - t.overscaledZ || r - i || t.canonical.y - e1.canonical.y || t.canonical.x - e1.canonical.x;
        }
        function Ox(e1) {
            return "raster" === e1 || "image" === e1 || "video" === e1 || "custom" === e1;
        }
        function Bx(e1, t) {
            const i = 1 << e1.z;
            return [
                e1.x / i + t,
                (e1.x + 1) / i + t
            ];
        }
        Lx.maxOverzooming = 10, Lx.maxUnderzooming = 3;
        const Fx = Ia([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Nx = Ia([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), Ux = Ia([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), Vx = Ia([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), jx = Ia([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), Gx = Ia([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), qx = Ia([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]);
        class Zx {
            constructor(e1 = 0, t = 0, i = 0, r = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(i) || i < 0 || isNaN(r) || r < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t, this.left = i, this.right = r;
            }
            interpolate(e1, t, i) {
                return null != t.top && null != e1.top && (this.top = Kr(e1.top, t.top, i)), null != t.bottom && null != e1.bottom && (this.bottom = Kr(e1.bottom, t.bottom, i)), null != t.left && null != e1.left && (this.left = Kr(e1.left, t.left, i)), null != t.right && null != e1.right && (this.right = Kr(e1.right, t.right, i)), this;
            }
            getCenter(e1, t) {
                const i = z((this.left + e1 - this.right) / 2, 0, e1), r = z((this.top + t - this.bottom) / 2, 0, t);
                return new y(i, r);
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new Zx(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        function $x(e1, t) {
            const i = ne(e1, 3);
            Au.fromQuat(e1, t), oe(e1, 3, i);
        }
        function Wx(e1, t) {
            const i = Iu.identity([]);
            return Iu.rotateZ(i, i, -t), Iu.rotateX(i, i, -e1), i;
        }
        function Hx(e1, t) {
            const i = [
                e1[0],
                e1[1],
                0
            ], r = [
                t[0],
                t[1],
                0
            ];
            if (Du.length(i) >= 1e-15) {
                const e1 = Du.normalize([], i);
                Du.scale(r, e1, Du.dot(r, e1)), t[0] = r[0], t[1] = r[1];
            }
            const n = Du.cross([], t, e1);
            if (Du.len(n) < 1e-15) return null;
            const o = Math.atan2(-n[1], n[0]);
            return Wx(Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2]), o);
        }
        class Xx {
            constructor(e1, t){
                this.position = e1, this.orientation = t;
            }
            get position() {
                return this._position;
            }
            set position(e1) {
                if (e1) {
                    const t = e1 instanceof lp ? e1 : new lp(e1[0], e1[1], e1[2]);
                    this._renderWorldCopies && (t.x = D(t.x, 0, 1)), this._position = t;
                } else this._position = null;
            }
            lookAtPoint(e1, t) {
                if (this.orientation = null, !this.position) return;
                const i = this.position, r = this._elevation ? this._elevation.getAtPointOrZero(lp.fromLngLat(e1)) : 0, n = lp.fromLngLat(e1, r), o = [
                    n.x - i.x,
                    n.y - i.y,
                    n.z - i.z
                ];
                t || (t = [
                    0,
                    0,
                    1
                ]), t[2] = Math.abs(t[2]), this.orientation = Hx(o, t);
            }
            setPitchBearing(e1, t) {
                this.orientation = Wx(w(e1), w(-t));
            }
        }
        class Yx {
            constructor(e1, t){
                this._transform = Au.identity([]), this.orientation = t, this.position = e1;
            }
            get mercatorPosition() {
                const e1 = this.position;
                return new lp(e1[0], e1[1], e1[2]);
            }
            get position() {
                const e1 = ne(this._transform, 3);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            set position(e1) {
                var t;
                e1 && oe(this._transform, 3, [
                    (t = e1)[0],
                    t[1],
                    t[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(e1) {
                this._orientation = e1 || Iu.identity([]), e1 && $x(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e1 = this.forward(), t = this.right();
                return {
                    bearing: Math.atan2(-t[1], t[0]),
                    pitch: Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2])
                };
            }
            setPitchBearing(e1, t) {
                this._orientation = Wx(e1, t), $x(this._transform, this._orientation);
            }
            forward() {
                const e1 = ne(this._transform, 2);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            up() {
                const e1 = ne(this._transform, 1);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            right() {
                const e1 = ne(this._transform, 0);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            getCameraToWorld(e1, t) {
                const i = new Float64Array(16);
                return Au.invert(i, this.getWorldToCamera(e1, t)), i;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(e1, t, i) {
                const r = this.position;
                Du.scale(r, r, -e1);
                const n = new Float64Array(16);
                return Au.fromScaling(n, [
                    i,
                    i,
                    i
                ]), Au.translate(n, n, r), n[10] *= t, n;
            }
            getWorldToCamera(e1, t) {
                const i = new Float64Array(16), r = new Float64Array(4), n = this.position;
                return Iu.conjugate(r, this._orientation), Du.scale(n, n, -e1), Au.fromQuat(i, r), Au.translate(i, i, n), i[1] *= -1, i[5] *= -1, i[9] *= -1, i[13] *= -1, i[8] *= t, i[9] *= t, i[10] *= t, i[11] *= t, i;
            }
            getCameraToClipPerspective(e1, t, i, r) {
                const n = new Float64Array(16);
                return Au.perspective(n, e1, t, i, r), n;
            }
            getCameraToClipOrthographic(e1, t, i, r, n, o) {
                const s = new Float64Array(16);
                return Au.ortho(s, e1, t, i, r, n, o), s;
            }
            getDistanceToElevation(e1, t = !1) {
                const i = 0 === e1 ? 0 : Qd(e1, t ? tp(this.position[1]) : this.position[1]), r = this.forward();
                return (i - this.position[2]) / r[2];
            }
            clone() {
                return new Yx([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        function Kx(e1, t) {
            const i = Qx(e1.projection, e1.zoom, e1.width, e1.height), r = function(e1, t, i, r, n) {
                const o = new Wd(i.lng - 180 * ev, i.lat), s = new Wd(i.lng + 180 * ev, i.lat), a = e1.project(o.lng, o.lat), l = e1.project(s.lng, s.lat), c = -Math.atan2(l.y - a.y, l.x - a.x), h = lp.fromLngLat(i);
                h.y = z(h.y, -1 + ev, 1 - ev);
                const u = h.toLngLat(), d = e1.project(u.lng, u.lat), p = lp.fromLngLat(u);
                p.x += ev;
                const f = p.toLngLat(), m = e1.project(f.lng, f.lat), _ = iv(m.x - d.x, m.y - d.y, c), g = lp.fromLngLat(u);
                g.y += ev;
                const y = g.toLngLat(), x = e1.project(y.lng, y.lat), v = iv(x.x - d.x, x.y - d.y, c), b = Math.abs(_.x) / Math.abs(v.y), w = Au.identity([]);
                Au.rotateZ(w, w, -c * (1 - (n ? 0 : r)));
                const T = Au.identity([]);
                return Au.scale(T, T, [
                    1,
                    1 - (1 - b) * r,
                    1
                ]), T[4] = -v.x / v.y * r, Au.rotateZ(T, T, c), Au.multiply(T, w, T), T;
            }(e1.projection, 0, e1.center, i, t), n = Jx(e1);
            return Au.scale(r, r, [
                n,
                n,
                1
            ]), r;
        }
        function Jx(e1) {
            const t = e1.projection, i = Qx(e1.projection, e1.zoom, e1.width, e1.height), r = tv(t, e1.center), n = tv(t, Wd.convert(t.center));
            return Math.pow(2, r * i + (1 - i) * n);
        }
        function Qx(e1, t, i, r, n = 1 / 0) {
            const o = e1.range;
            if (!o) return 0;
            const s = Math.min(n, Math.max(i, r)), a = Math.log(s / 1024) / Math.LN2;
            return P(o[0] + a, o[1] + a, t);
        }
        const ev = 1 / 4e4;
        function tv(e1, t) {
            const i = z(t.lat, -rp, rp), r = new Wd(t.lng - 180 * ev, i), n = new Wd(t.lng + 180 * ev, i), o = e1.project(r.lng, i), s = e1.project(n.lng, i), a = lp.fromLngLat(r), l = lp.fromLngLat(n), c = s.x - o.x, h = s.y - o.y, u = l.x - a.x, d = l.y - a.y, p = Math.sqrt((u * u + d * d) / (c * c + h * h));
            return Math.log(p) / Math.LN2;
        }
        function iv(e1, t, i) {
            const r = Math.cos(i), n = Math.sin(i);
            return {
                x: e1 * r - t * n,
                y: e1 * n + t * r
            };
        }
        function rv(e1, t, i) {
            return t * (cr / (e1.tileSize * Math.pow(2, i - e1.tileID.overscaledZ)));
        }
        const nv = {
            unknown: 0,
            flipRequired: 1,
            flipNotRequired: 2
        }, ov = Math.tan(85 * Math.PI / 180);
        function sv(e1, t, i, r, n, o, s) {
            const a = Au.create();
            if (i) {
                if ("globe" === o.name) {
                    const e1 = function(e1, t) {
                        const { x: i, y: r } = e1.point, n = zd(i, r, e1.worldSize / e1._pixelsPerMercatorPixel, 0, 0);
                        return Au.multiply(n, n, Sd(fd(t)));
                    }(n, t);
                    Au.multiply(a, a, e1);
                } else {
                    const e1 = bu.invert([], s);
                    a[0] = e1[0], a[1] = e1[1], a[4] = e1[2], a[5] = e1[3], r || Au.rotateZ(a, a, n.angle);
                }
            } else Au.multiply(a, n.labelPlaneMatrix, e1);
            return a;
        }
        function av(e1, t, i, r, n, o, s) {
            const a = sv(e1, t, i, r, n, o, s);
            return "globe" === o.name && i || (a[2] = a[6] = a[10] = a[14] = 0), a;
        }
        function lv(e1, t, i, r, n, o, s) {
            if (i) {
                if ("globe" === o.name) {
                    const a = sv(e1, t, i, r, n, o, s);
                    return Au.invert(a, a), Au.multiply(a, e1, a), a;
                }
                {
                    const t = Au.clone(e1), i = Au.identity([]);
                    return i[0] = s[0], i[1] = s[1], i[4] = s[2], i[5] = s[3], Au.multiply(t, t, i), r || Au.rotateZ(t, t, -n.angle), t;
                }
            }
            return n.glCoordMatrix;
        }
        function cv(e1, t, i, r) {
            const n = [
                e1,
                t,
                i,
                1
            ];
            i ? yu.transformMat4(n, n, r) : vv(n, n, r);
            const o = n[3];
            return n[0] /= o, n[1] /= o, n[2] /= o, n;
        }
        function hv(e1, t) {
            return Math.min(.5 + e1 / t * .5, 1.5);
        }
        function uv(e1, t) {
            const i = e1[0] / e1[3], r = e1[1] / e1[3];
            return i >= -t[0] && i <= t[0] && r >= -t[1] && r <= t[1];
        }
        function dv(e1, t, i, r, n, o, s, a, l, c) {
            const h = i.transform, u = r ? e1.textSizeData : e1.iconSizeData, d = m_(u, i.transform.zoom), p = "globe" === h.projection.name, f = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], m = r ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            m.clear();
            let _ = null;
            p && (_ = r ? e1.text.globeExtVertexArray : e1.icon.globeExtVertexArray);
            const g = e1.lineVertexArray, x = r ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, v = i.transform.width / i.transform.height;
            let b, w = !1;
            for(let r = 0; r < x.length; r++){
                const p = x.get(r), { numGlyphs: T, writingMode: E } = p;
                if (E !== A_.vertical || w || b === A_.horizontal || (w = !0), b = E, (p.hidden || E === A_.vertical) && !w) {
                    xv(T, m);
                    continue;
                }
                w = !1;
                const M = new y(p.tileAnchorX, p.tileAnchorY);
                let { x: A, y: S, z: I } = h.projection.projectTilePoint(M.x, M.y, c.canonical);
                if (l) {
                    const [e1, t, i] = l(M);
                    A += e1, S += t, I += i;
                }
                const C = [
                    A,
                    S,
                    I,
                    1
                ];
                if (yu.transformMat4(C, C, t), !uv(C, f)) {
                    xv(T, m);
                    continue;
                }
                const z = C[3], P = hv(i.transform.getCameraToCenterDistance(h.projection), z), D = f_(u, d, p), R = s ? D / P : D * P, L = cv(A, S, I, n);
                if (L[3] <= 0) {
                    xv(T, m);
                    continue;
                }
                let k = {};
                const O = s ? null : l, B = mv(p, R, !1, a, t, n, o, e1.glyphOffsetArray, g, m, _, L, M, k, v, O, h.projection, c, s);
                w = B.useVertical, O && B.needsFlipping && (k = {}), (B.notEnoughRoom || w || B.needsFlipping && mv(p, R, !0, a, t, n, o, e1.glyphOffsetArray, g, m, _, L, M, k, v, O, h.projection, c, s).notEnoughRoom) && xv(T, m);
            }
            r ? (e1.text.dynamicLayoutVertexBuffer.updateData(m), _ && e1.text.globeExtVertexBuffer && e1.text.globeExtVertexBuffer.updateData(_)) : (e1.icon.dynamicLayoutVertexBuffer.updateData(m), _ && e1.icon.globeExtVertexBuffer && e1.icon.globeExtVertexBuffer.updateData(_));
        }
        function pv(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
            const { lineStartIndex: _, glyphStartIndex: g, segment: y } = a, x = g + a.numGlyphs, v = _ + a.lineLength, b = t.getoffsetX(g), w = t.getoffsetX(x - 1), T = yv(e1 * b, i, r, n, o, s, y, _, v, l, c, h, u, d, !0, p, f, m);
            if (!T) return null;
            const E = yv(e1 * w, i, r, n, o, s, y, _, v, l, c, h, u, d, !0, p, f, m);
            return E ? {
                first: T,
                last: E
            } : null;
        }
        function fv(e1, t, i, r) {
            return e1 === A_.horizontal && Math.abs(r) > Math.abs(i) ? {
                useVertical: !0
            } : e1 === A_.vertical ? r > 0 ? {
                needsFlipping: !0
            } : null : t !== nv.unknown && function(e1, t) {
                return 0 === e1 || Math.abs(t / e1) > ov;
            }(i, r) ? t === nv.flipRequired ? {
                needsFlipping: !0
            } : null : i < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function mv(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, x) {
            const v = t / 24, b = e1.lineOffsetX * v, w = e1.lineOffsetY * v, { lineStartIndex: T, glyphStartIndex: E, numGlyphs: M, segment: A, writingMode: S, flipState: I } = e1, C = T + e1.lineLength, z = (e1)=>{
                if (h) {
                    const [t, i, r] = e1.up, n = c.length;
                    uy(h, n + 0, t, i, r), uy(h, n + 1, t, i, r), uy(h, n + 2, t, i, r), uy(h, n + 3, t, i, r);
                }
                const [t, i, r] = e1.point;
                dy(c, t, i, r, e1.angle);
            };
            if (M > 1) {
                const t = pv(v, a, b, w, i, u, d, e1, l, o, p, m, !1, _, g, x);
                if (!t) return {
                    notEnoughRoom: !0
                };
                if (r && !i) {
                    let [i, r, n] = t.first.point, [o, a, l] = t.last.point;
                    [i, r] = cv(i, r, n, s), [o, a] = cv(o, a, l, s);
                    const c = fv(S, I, (o - i) * f, a - r);
                    if (e1.flipState = c && c.needsFlipping ? nv.flipRequired : nv.flipNotRequired, c) return c;
                }
                z(t.first);
                for(let e1 = E + 1; e1 < E + M - 1; e1++){
                    const t = yv(v * a.getoffsetX(e1), b, w, i, u, d, A, T, C, l, o, p, m, !1, !1, _, g, x);
                    if (!t) return c.length -= 4 * (e1 - E), {
                        notEnoughRoom: !0
                    };
                    z(t);
                }
                z(t.last);
            } else {
                if (r && !i) {
                    const t = cv(d.x, d.y, 0, n), i = T + A + 1, r = new y(l.getx(i), l.gety(i)), o = cv(r.x, r.y, 0, n), s = o[3] > 0 ? o : gv(d, r, t, 1, n, void 0, _, g.canonical), a = fv(S, I, (s[0] - t[0]) * f, s[1] - t[1]);
                    if (e1.flipState = a && a.needsFlipping ? nv.flipRequired : nv.flipNotRequired, a) return a;
                }
                const t = yv(v * a.getoffsetX(E), b, w, i, u, d, A, T, C, l, o, p, m, !1, !1, _, g, x);
                if (!t) return {
                    notEnoughRoom: !0
                };
                z(t);
            }
            return {};
        }
        function _v(e1, t, i, r, n) {
            const { x: o, y: s, z: a } = r.projectTilePoint(e1.x, e1.y, t);
            if (!n) return cv(o, s, a, i);
            const [l, c, h] = n(e1);
            return cv(o + l, s + c, a + h, i);
        }
        function gv(e1, t, i, r, n, o, s, a) {
            const l = _v(e1.sub(t)._unit()._add(e1), a, n, s, o);
            return Du.sub(l, i, l), Du.normalize(l, l), Du.scaleAndAdd(l, i, l, r);
        }
        function yv(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g) {
            const x = r ? e1 - t : e1 + t;
            let v = x > 0 ? 1 : -1, b = 0;
            r && (v *= -1, b = Math.PI), v < 0 && (b += Math.PI);
            let w = a + s + (v > 0 ? 0 : 1) | 0, T = n, E = n, M = 0, A = 0;
            const S = Math.abs(x), I = [], C = [];
            let z = o, P = z;
            const D = ()=>gv(P, z, E, S - M + 1, h, d, m, _.canonical);
            for(; M + A <= S;){
                if (w += v, w < a || w >= l) return null;
                if (E = T, P = z, I.push(E), p && C.push(P), z = new y(c.getx(w), c.gety(w)), T = u[w], !T) {
                    const e1 = _v(z, _.canonical, h, m, d);
                    T = e1[3] > 0 ? u[w] = e1 : D();
                }
                M += A, A = Du.distance(E, T);
            }
            f && d && (u[w] && (T = D(), A = Du.distance(E, T)), u[w] = T);
            const R = (S - M) / A, L = z.sub(P)._mult(R)._add(P), k = Du.sub([], T, E), O = Du.scaleAndAdd([], E, k, R);
            let B = [
                0,
                0,
                1
            ], F = k[0], N = k[1];
            if (g && (B = m.upVector(_.canonical, L.x, L.y), 0 !== B[0] || 0 !== B[1] || 1 !== B[2])) {
                const e1 = [
                    B[2],
                    0,
                    -B[0]
                ], t = Du.cross([], B, e1);
                Du.normalize(e1, e1), Du.normalize(t, t), F = Du.dot(k, e1), N = Du.dot(k, t);
            }
            if (i) {
                const e1 = Du.cross([], B, k);
                Du.normalize(e1, e1), Du.scaleAndAdd(O, O, e1, i * v);
            }
            const U = b + Math.atan2(N, F);
            return I.push(O), p && C.push(L), {
                point: O,
                angle: U,
                path: I,
                tilePath: C,
                up: B
            };
        }
        function xv(e1, t) {
            const i = t.length, r = i + 4 * e1;
            t.resize(r), t.float32.fill(-1 / 0, 4 * i, 4 * r);
        }
        function vv(e1, t, i) {
            const r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[4] * n + i[12], e1[1] = i[1] * r + i[5] * n + i[13], e1[3] = i[3] * r + i[7] * n + i[15], e1;
        }
        const bv = (e1, t, i)=>(1 - i) * e1 + i * t, wv = (e1)=>e1 * e1 * e1 * e1 * e1;
        class Tv {
            constructor(e1, t, i, r, n, o, s){
                this.tileSize = 512, this._renderWorldCopies = void 0 === n || n, this._minZoom = e1 || 0, this._maxZoom = t || 22, this._minPitch = null == i ? 0 : i, this._maxPitch = null == r ? 60 : r, this.setProjection(o), this.setMaxBounds(s), this.width = 0, this.height = 0, this._center = new Wd(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Zx, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Yx, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1;
            }
            clone() {
                const e1 = new Tv(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
                return e1._elevation = this._elevation, e1._centerAltitude = this._centerAltitude, e1._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e1.tileSize = this.tileSize, e1.mercatorFromTransition = this.mercatorFromTransition, e1.width = this.width, e1.height = this.height, e1.cameraElevationReference = this.cameraElevationReference, e1._center = this._center, e1._setZoom(this.zoom), e1._seaLevelZoom = this._seaLevelZoom, e1.angle = this.angle, e1._fov = this._fov, e1._pitch = this._pitch, e1._nearZ = this._nearZ, e1._farZ = this._farZ, e1._averageElevation = this._averageElevation, e1._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e1._unmodified = this._unmodified, e1._edgeInsets = this._edgeInsets.clone(), e1._camera = this._camera.clone(), e1._calcMatrices(), e1.freezeTileCoverage = this.freezeTileCoverage, e1.frustumCorners = this.frustumCorners, e1;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < 15;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e1) {
                this._elevation !== e1 && (this._elevation = e1, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e1, t = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e1 || i) && this._constrainCamera(t), this._calcMatrices();
            }
            getProjection() {
                return O(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(e1) {
                this.projectionOptions = e1 || {
                    name: "mercator"
                };
                const t = this.projection ? this.getProjection() : void 0;
                this.projection = ty(this.projectionOptions);
                const i = !x(t, this.getProjection());
                return i && this._calcMatrices(), this.mercatorFromTransition = !1, i;
            }
            setOrthographicProjectionAtLowPitch(e1) {
                return this._orthographicProjectionAtLowPitch !== e1 && (this._orthographicProjectionAtLowPitch = e1, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const e1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = ty({
                    name: "mercator"
                });
                const t = e1 !== this.projection.name;
                return t && this._calcMatrices(), t;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.zoom = Math.max(this.zoom, e1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.zoom = Math.min(this.zoom, e1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.pitch = Math.max(this.pitch, e1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.pitch = Math.min(this.pitch, e1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get cameraWorldSize() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return Qd(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new y(this.width, this.height);
            }
            get bearing() {
                return D(this.rotation, -180, 180);
            }
            set bearing(e1) {
                this.rotation = e1;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(e1) {
                const t = -e1 * Math.PI / 180;
                this.angle !== t && (this._unmodified = !1, this.angle = t, this._calcMatrices(), this.rotationMatrix = bu.create(), bu.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e1) {
                const t = z(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== t && (this._unmodified = !1, this._pitch = t, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e1 = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e1);
            }
            set fov(e1) {
                e1 = Math.max(.01, Math.min(60, e1)), this._fov !== e1 && (this._unmodified = !1, this._fov = w(e1), this._calcMatrices());
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e1) {
                this._averageElevation = e1, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e1) {
                const t = Math.min(Math.max(e1, this.minZoom), this.maxZoom);
                this._zoom !== t && (this._unmodified = !1, this._setZoom(t), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e1) {
                this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom;
            }
            _updateCameraOnTerrain() {
                const e1 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t = this.elevation && e1 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e1 === Number.NEGATIVE_INFINITY && (!t || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e1 || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const e1 = this._elevation, t = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], i = this.horizonLineFromTop();
                let r = 0, n = 0;
                for(let o = 0; o < t.length; o++){
                    const s = new y(t[o][0] * this.width, i + t[o][1] * (this.height - i)), a = e1.pointCoordinate(s);
                    if (!a) continue;
                    const l = 1 / Math.hypot(a[0] - this._camera.position[0], a[1] - this._camera.position[1]);
                    r += a[3] * l, n += l;
                }
                return 0 === n ? NaN : r / n;
            }
            get center() {
                return this._center;
            }
            set center(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e1 = this._seaLevelZoom, t = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t, r = this._mercatorZfromZoom(e1), n = this._mercatorZfromZoom(this._maxZoom), o = Math.max(r - i, n);
                this._setZoom(this._zoomFromMercatorZ(o));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(e1) {
                const t = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, e1.toAltitude()));
                let i;
                i = e1.z < this._camera.position[2] ? [
                    t.x,
                    t.y,
                    t.z
                ] : [
                    e1.x,
                    e1.y,
                    e1.z
                ];
                const r = Du.length(Du.sub([], this._camera.position, i));
                return z(this._zoomFromMercatorZ(r), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(e1) {
                if (!this.height) return;
                if (!e1.position && !e1.orientation) return;
                this._updateCameraState();
                let t = !1;
                if (e1.orientation && !Iu.exactEquals(e1.orientation, this._camera.orientation) && (t = this._setCameraOrientation(e1.orientation)), e1.position) {
                    const i = [
                        e1.position.x,
                        e1.position.y,
                        e1.position.z
                    ];
                    Du.exactEquals(i, this._camera.position) || (this._setCameraPosition(i), t = !0);
                }
                t && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const e1 = this._camera.position, t = new Xx;
                return t.position = new lp(e1[0], e1[1], e1[2]), t.orientation = this._camera.orientation, t._elevation = this.elevation, t._renderWorldCopies = this.renderWorldCopies, t;
            }
            _setCameraOrientation(e1) {
                if (!Iu.length(e1)) return !1;
                Iu.normalize(e1, e1);
                const t = Du.transformQuat([], [
                    0,
                    0,
                    -1
                ], e1), i = Du.transformQuat([], [
                    0,
                    -1,
                    0
                ], e1);
                if (i[2] < 0) return !1;
                const r = Hx(t, i);
                return !!r && (this._camera.orientation = r, !0);
            }
            _setCameraPosition(e1) {
                const t = this.zoomScale(this.minZoom) * this.tileSize, i = this.zoomScale(this.maxZoom) * this.tileSize, r = this.cameraToCenterDistance;
                e1[2] = z(e1[2], r / i, r / t), this._camera.position = e1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e1) {
                const t = (e1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e1.tileSize));
                return Math.max(0, t);
            }
            getVisibleUnwrappedCoordinates(e1) {
                const t = [
                    new Gu(0, e1)
                ];
                if (this.renderWorldCopies) {
                    const i = this.pointCoordinate(new y(0, 0)), r = this.pointCoordinate(new y(this.width, 0)), n = this.pointCoordinate(new y(this.width, this.height)), o = this.pointCoordinate(new y(0, this.height)), s = Math.floor(Math.min(i.x, r.x, n.x, o.x)), a = Math.floor(Math.max(i.x, r.x, n.x, o.x)), l = 1;
                    for(let i = s - l; i <= a + l; i++)0 !== i && t.push(new Gu(i, e1));
                }
                return t;
            }
            isLODDisabled(e1) {
                return (!e1 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCoverForShadows(e1, t, i) {
                let r = [];
                if (0 === t[0] && 0 === t[1]) return r;
                for (const i of e1){
                    const e1 = i.canonical, n = i.overscaledZ, o = i.wrap, s = 1 << e1.z, a = e1.x + 1 < s, l = e1.x > 0, c = e1.y + 1 < s, h = e1.y > 0, u = i.wrap - (l ? 0 : 1), d = i.wrap + (a ? 0 : 1), p = l ? e1.x - 1 : s - 1, f = a ? e1.x + 1 : 0;
                    t[0] < 0 ? (r.push(new qu(n, d, e1.z, f, e1.y)), t[1] < 0 && c && (r.push(new qu(n, o, e1.z, e1.x, e1.y + 1)), r.push(new qu(n, d, e1.z, f, e1.y + 1))), t[1] > 0 && h && (r.push(new qu(n, o, e1.z, e1.x, e1.y - 1)), r.push(new qu(n, d, e1.z, f, e1.y - 1)))) : t[0] > 0 ? (r.push(new qu(n, u, e1.z, p, e1.y)), t[1] < 0 && c && (r.push(new qu(n, o, e1.z, e1.x, e1.y + 1)), r.push(new qu(n, u, e1.z, p, e1.y + 1))), t[1] > 0 && h && (r.push(new qu(n, o, e1.z, e1.x, e1.y - 1)), r.push(new qu(n, u, e1.z, p, e1.y - 1)))) : t[1] < 0 && c ? r.push(new qu(n, o, e1.z, e1.x, e1.y + 1)) : h && r.push(new qu(n, o, e1.z, e1.x, e1.y - 1));
                }
                if (r.length > 1) {
                    r.sort((e1, t)=>e1.overscaledZ - t.overscaledZ || e1.wrap - t.wrap || e1.canonical.z - t.canonical.z || e1.canonical.x - t.canonical.x || e1.canonical.y - t.canonical.y);
                    let e1 = 0, t = 0;
                    for(; t < r.length;)r[t].equals(r[e1]) ? ++t : r[++e1] = r[t++];
                    r.length = e1 + 1;
                }
                const n = [];
                for (const e1 of r)r.some((t)=>e1.isChildOf(t)) || n.push(e1);
                return r = n.filter((t)=>!e1.some((e1)=>!!(t.overscaledZ < i && e1.isChildOf(t)) || t.equals(e1) || t.isChildOf(e1))), r;
            }
            coveringTiles(e1) {
                let t = this.coveringZoomLevel(e1);
                const i = t, r = this.elevation && this.elevation.exaggeration(), n = r && !e1.isTerrainDEM, o = "mercator" === this.projection.name;
                if (void 0 !== e1.minzoom && t < e1.minzoom) return [];
                void 0 !== e1.maxzoom && t > e1.maxzoom && (t = e1.maxzoom);
                const s = this.locationCoordinate(this.center), a = this.center.lat, l = 1 << t, c = [
                    l * s.x,
                    l * s.y,
                    0
                ], h = "globe" === this.projection.name, u = !h, d = Qu.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t, u), p = h ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f = l * Qd(1, this.center.lat), m = this._camera.position[2] / Qd(1, this.center.lat), _ = [
                    l * p.x,
                    l * p.y,
                    m * (u ? 1 : f)
                ], g = h || r, y = this.cameraToCenterDistance / e1.tileSize * (e1.roundZoom ? 1 : .502), x = this.isLODDisabled(!0) ? t : 0;
                let v;
                if (this._elevation && e1.isTerrainDEM) v = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e1 = this._elevation.getMinMaxForVisibleTiles();
                    v = e1 ? e1.max : this._centerAltitude;
                } else v = this._centerAltitude;
                const b = e1.isTerrainDEM ? -v : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, w = this.projection.isReprojectedInTileSpace ? Jx(this) : 1, T = (e1)=>{
                    const t = 1 / 4e4, i = new lp(e1.x + t, e1.y, e1.z), r = new lp(e1.x, e1.y + t, e1.z), n = e1.toLngLat(), o = i.toLngLat(), s = r.toLngLat(), a = this.locationCoordinate(n), l = this.locationCoordinate(o), c = this.locationCoordinate(s), h = Math.hypot(l.x - a.x, l.y - a.y), u = Math.hypot(c.x - a.x, c.y - a.y);
                    return Math.sqrt(h * u) * w / t;
                }, M = (e1)=>{
                    const t = v, i = b;
                    return {
                        aabb: Dg(this, l, 0, 0, 0, e1, i, t, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: i,
                        maxZ: t,
                        wrap: e1,
                        fullyVisible: !1
                    };
                }, A = [];
                let S = [];
                const I = t, C = e1.reparseOverscaled ? i : t, z = (e1)=>e1 * e1, P = z((m - this._centerAltitude) * f), D = (e1)=>{
                    if (!this._elevation || !e1.tileID || !o) return;
                    const t = this._elevation.getMinMaxForTile(e1.tileID), i = e1.aabb;
                    t ? (i.min[2] = t.min, i.max[2] = t.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e1.shouldSplit = R(e1), e1.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, R = (e1)=>{
                    if (e1.zoom < x) return !0;
                    if (e1.zoom === I) return !1;
                    if (null != e1.shouldSplit) return e1.shouldSplit;
                    const t = e1.aabb.distanceX(_), r = e1.aabb.distanceY(_);
                    let o = P, s = 1;
                    if (h) {
                        o = z(e1.aabb.distanceZ(_));
                        const t = Math.pow(2, e1.zoom), i = tp((e1.y + 1) / t), r = tp(e1.y / t), n = Math.min(Math.max(a, i), r), l = Yd(n) / Yd(a);
                        if (s = n === a ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, l / this._mercatorScaleRatio), this.zoom <= td && e1.zoom === I - 1 && l >= .9) return !0;
                    } else if (n && (o = z(e1.aabb.distanceZ(_) * f)), this.projection.isReprojectedInTileSpace && i <= 5) {
                        const t = Math.pow(2, e1.zoom), i = T(new lp((e1.x + .5) / t, (e1.y + .5) / t));
                        s = i > .85 ? 1 : i;
                    }
                    const l = t * t + r * r + o, c = z((1 << I - e1.zoom) * y * s * ((e1, t)=>{
                        if (t * z(.707) < e1) return 1;
                        const i = Math.sqrt(t / e1);
                        return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                    })(Math.max(o, P), l));
                    return l < c;
                };
                if (this.renderWorldCopies) for(let e1 = 1; e1 <= 3; e1++)A.push(M(-e1)), A.push(M(e1));
                for(A.push(M(0)); A.length > 0;){
                    const i = A.pop(), r = i.x, s = i.y;
                    let a = i.fullyVisible;
                    const u = ()=>"globe" === this.projection.name && (0 === i.y || i.y === (1 << i.zoom) - 1);
                    if (!a) {
                        let e1 = g ? i.aabb.intersects(d) : i.aabb.intersectsFlat(d);
                        if (0 === e1 && u()) {
                            const t = new ju(i.zoom, r, s);
                            e1 = yd(this, l, t, !0).intersects(d);
                        }
                        if (0 === e1) continue;
                        a = 2 === e1;
                    }
                    if (i.zoom !== I && R(i)) for(let e1 = 0; e1 < 4; e1++){
                        const t = (r << 1) + e1 % 2, c = (s << 1) + (e1 >> 1), u = {
                            aabb: o ? i.aabb.quadrant(e1) : Dg(this, l, i.zoom + 1, t, c, i.wrap, i.minZ, i.maxZ, this.projection),
                            zoom: i.zoom + 1,
                            x: t,
                            y: c,
                            wrap: i.wrap,
                            fullyVisible: a,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: i.minZ,
                            maxZ: i.maxZ
                        };
                        n && !h && (u.tileID = new qu(i.zoom + 1 === I ? C : i.zoom + 1, i.wrap, i.zoom + 1, t, c), D(u)), A.push(u);
                    }
                    else {
                        const n = i.zoom === I ? C : i.zoom;
                        if (e1.minzoom && e1.minzoom > n) continue;
                        if (!a) {
                            let e1 = g ? i.aabb.intersectsPrecise(d) : i.aabb.intersectsPreciseFlat(d);
                            if (0 === e1 && u()) {
                                const t = new ju(i.zoom, r, s);
                                e1 = yd(this, l, t, !0).intersectsPrecise(d);
                            }
                            if (0 === e1) continue;
                        }
                        const o = c[0] - (.5 + r + (i.wrap << i.zoom)) * (1 << t - i.zoom), h = c[1] - .5 - s, p = i.tileID ? i.tileID : new qu(n, i.wrap, i.zoom, r, s);
                        S.push({
                            tileID: p,
                            distanceSq: o * o + h * h
                        });
                    }
                }
                if (this.fogCullDistSq) {
                    const t = this.fogCullDistSq, i = this.horizonLineFromTop();
                    S = S.filter((r)=>{
                        const n = [
                            0,
                            0,
                            0,
                            1
                        ], o = [
                            cr,
                            cr,
                            0,
                            1
                        ], s = this.calculateFogTileMatrix(r.tileID.toUnwrapped());
                        yu.transformMat4(n, n, s), yu.transformMat4(o, o, s);
                        const a = function(e1, t, i) {
                            let r = 0;
                            for(let i = 0; i < 2; ++i){
                                const n = 0;
                                e1[i] > n && (r += (e1[i] - n) * (e1[i] - n)), t[i] < n && (r += (n - t[i]) * (n - t[i]));
                            }
                            return r;
                        }(yu.min([], n, o), yu.max([], n, o));
                        if (0 === a) return !0;
                        let l = !1;
                        const c = this._elevation;
                        if (c && a > t && 0 !== i) {
                            const t = this.calculateProjMatrix(r.tileID.toUnwrapped());
                            let n;
                            e1.isTerrainDEM || (n = c.getMinMaxForTile(r.tileID)), n || (n = {
                                min: b,
                                max: v
                            });
                            const o = function(e1) {
                                const t = Math.round((e1 + 45 + 360) % 360 / 90) % 4;
                                return E[t];
                            }(this.rotation), s = [
                                o[0] * cr,
                                o[1] * cr,
                                n.max
                            ];
                            Du.transformMat4(s, s, t), l = (1 - s[1]) * this.height * .5 < i;
                        }
                        return a < t || l;
                    });
                }
                return S.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
            }
            resize(e1, t) {
                this.width = e1, this.height = t, this.pixelsToGLUnits = [
                    2 / e1,
                    -2 / t
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e1) {
                return Math.pow(2, e1);
            }
            scaleZoom(e1) {
                return Math.log(e1) / Math.LN2;
            }
            project(e1) {
                const t = z(e1.lat, -rp, rp), i = this.projection.project(e1.lng, t);
                return new y(i.x * this.worldSize, i.y * this.worldSize);
            }
            unproject(e1) {
                return this.projection.unproject(e1.x / this.worldSize, e1.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / Qd(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(e1, t) {
                let i, r;
                const n = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e1 = this.worldSize;
                    i = (t.x - n.x) / e1, r = (t.y - n.y) / e1;
                } else {
                    const e1 = this.pointCoordinate(t), o = this.pointCoordinate(n);
                    i = e1.x - o.x, r = e1.y - o.y;
                }
                const o = this.locationCoordinate(e1);
                this.setLocation(new lp(o.x - i, o.y - r));
            }
            setLocation(e1) {
                this.center = this.coordinateLocation(e1), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e1) {
                return this.projection.locationPoint(this, e1);
            }
            locationPoint3D(e1) {
                return this.projection.locationPoint(this, e1, !0);
            }
            pointLocation(e1) {
                return this.coordinateLocation(this.pointCoordinate(e1));
            }
            pointLocation3D(e1) {
                return this.coordinateLocation(this.pointCoordinate3D(e1));
            }
            locationCoordinate(e1, t) {
                const i = t ? Qd(t, e1.lat) : void 0, r = this.projection.project(e1.lng, e1.lat);
                return new lp(r.x, r.y, i);
            }
            coordinateLocation(e1) {
                return this.projection.unproject(e1.x, e1.y);
            }
            pointRayIntersection(e1, t) {
                const i = null != t ? t : this._centerAltitude, r = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], n = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                yu.transformMat4(r, r, this.pixelMatrixInverse), yu.transformMat4(n, n, this.pixelMatrixInverse);
                const o = n[3];
                yu.scale(r, r, 1 / r[3]), yu.scale(n, n, 1 / o);
                const s = r[2], a = n[2];
                return {
                    p0: r,
                    p1: n,
                    t: s === a ? 0 : (i - s) / (a - s)
                };
            }
            screenPointToMercatorRay(e1) {
                const t = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], i = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                return yu.transformMat4(t, t, this.pixelMatrixInverse), yu.transformMat4(i, i, this.pixelMatrixInverse), yu.scale(t, t, 1 / t[3]), yu.scale(i, i, 1 / i[3]), t[2] = Qd(t[2], this._center.lat) * this.worldSize, i[2] = Qd(i[2], this._center.lat) * this.worldSize, yu.scale(t, t, 1 / this.worldSize), yu.scale(i, i, 1 / this.worldSize), new Wu([
                    t[0],
                    t[1],
                    t[2]
                ], Du.normalize([], Du.sub([], i, t)));
            }
            rayIntersectionCoordinate(e1) {
                const { p0: t, p1: i, t: r } = e1, n = Qd(t[2], this._center.lat), o = Qd(i[2], this._center.lat);
                return new lp(Kr(t[0], i[0], r) / this.worldSize, Kr(t[1], i[1], r) / this.worldSize, Kr(n, o, r));
            }
            pointCoordinate(e1, t = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e1.x, e1.y, t);
            }
            pointCoordinate3D(e1) {
                if (!this.elevation) return this.pointCoordinate(e1);
                let t = this.projection.pointCoordinate3D(this, e1.x, e1.y);
                if (t) return new lp(t[0], t[1], t[2]);
                let i = 0, r = this.horizonLineFromTop();
                if (e1.y > r) return this.pointCoordinate(e1);
                const n = .02 * r, o = e1.clone();
                for(let e1 = 0; e1 < 10 && r - i > n; e1++){
                    o.y = Kr(i, r, .66);
                    const e1 = this.projection.pointCoordinate3D(this, o.x, o.y);
                    e1 ? (r = o.y, t = e1) : i = o.y;
                }
                return t ? new lp(t[0], t[1], t[2]) : this.pointCoordinate(e1);
            }
            isPointAboveHorizon(e1) {
                return this.projection.isPointAboveHorizon(this, e1);
            }
            isPointOnSurface(e1) {
                if (e1.y < 0 || e1.y > this.height || e1.x < 0 || e1.x > this.width) return !1;
                if (this.elevation || this.zoom >= id) return !this.isPointAboveHorizon(e1);
                const t = this.pointCoordinate(e1);
                return t.y >= 0 && t.y <= 1;
            }
            _coordinatePoint(e1, t) {
                const i = t && this.elevation ? this.elevation.getAtPointOrZero(e1, this._centerAltitude) : this._centerAltitude, r = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i + e1.toAltitude(),
                    1
                ];
                return yu.transformMat4(r, r, this.pixelMatrix), r[3] > 0 ? new y(r[0] / r[3], r[1] / r[3]) : new y(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: e1, left: t } = this._edgeInsets, i = this.height - this._edgeInsets.bottom, r = this.width - this._edgeInsets.right, n = this.pointLocation3D(new y(t, e1)), o = this.pointLocation3D(new y(r, e1)), s = this.pointLocation3D(new y(r, i)), a = this.pointLocation3D(new y(t, i));
                let l = Math.min(n.lng, o.lng, s.lng, a.lng), c = Math.max(n.lng, o.lng, s.lng, a.lng), h = Math.min(n.lat, o.lat, s.lat, a.lat), u = Math.max(n.lat, o.lat, s.lat, a.lat);
                const d = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, f = (e1, t, i, r, n)=>{
                    const o = (e1 + i) / 2, s = (t + r) / 2, a = new y(o, s), { lng: m, lat: _ } = this.pointLocation3D(a), g = Math.max(0, l - m, h - _, m - c, _ - u);
                    l = Math.min(l, m), c = Math.max(c, m), h = Math.min(h, _), u = Math.max(u, _), (n < p || g > d) && (f(e1, t, o, s, n + 1), f(o, s, i, r, n + 1));
                };
                if (f(t, e1, r, e1, 1), f(r, e1, r, i, 1), f(r, i, t, i, 1), f(t, i, t, e1, 1), "globe" === this.projection.name) {
                    const [e1, t] = function(e1) {
                        const t = Au.identity(new Float64Array(16));
                        Au.multiply(t, e1.pixelMatrix, e1.globeMatrix);
                        const i = [
                            0,
                            ad,
                            0
                        ], r = [
                            0,
                            ld,
                            0
                        ];
                        return Du.transformMat4(i, i, t), Du.transformMat4(r, r, t), [
                            i[0] > 0 && i[0] <= e1.width && i[1] > 0 && i[1] <= e1.height && !Nd(e1, new Wd(e1.center.lat, 90)),
                            r[0] > 0 && r[0] <= e1.width && r[1] > 0 && r[1] <= e1.height && !Nd(e1, new Wd(e1.center.lat, -90))
                        ];
                    }(this);
                    e1 ? (u = 90, c = 180, l = -180) : t && (h = -90, c = 180, l = -180);
                }
                return new sc(new Wd(l, h), new Wd(c, u));
            }
            _getBoundsRectangular(e1, t) {
                const { top: i, left: r } = this._edgeInsets, n = this.height - this._edgeInsets.bottom, o = this.width - this._edgeInsets.right, s = new y(r, i), a = new y(o, i), l = new y(o, n), c = new y(r, n);
                let h = this.pointCoordinate(s, e1), u = this.pointCoordinate(a, e1);
                const d = this.pointCoordinate(l, t), p = this.pointCoordinate(c, t), f = (e1, t)=>(t.y - e1.y) / (t.x - e1.x);
                return h.y > 1 && u.y >= 0 ? h = new lp((1 - p.y) / f(p, h) + p.x, 1) : h.y < 0 && u.y <= 1 && (h = new lp(-p.y / f(p, h) + p.x, 0)), u.y > 1 && h.y >= 0 ? u = new lp((1 - d.y) / f(d, u) + d.x, 1) : u.y < 0 && h.y <= 1 && (u = new lp(-d.y / f(d, u) + d.x, 0)), (new sc).extend(this.coordinateLocation(h)).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(d));
            }
            _getBoundsRectangularTerrain() {
                const e1 = this.elevation;
                if (!e1.visibleDemTiles.length || e1.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t = e1.visibleDemTiles.reduce((e1, t)=>{
                    if (t.dem) {
                        const i = t.dem.tree;
                        e1.min = Math.min(e1.min, i.minimums[0]), e1.max = Math.max(e1.max, i.maximums[0]);
                    }
                    return e1;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t.min * e1.exaggeration(), t.max * e1.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e1 = !0) {
                const t = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t * (1 - this._horizonShift);
                return e1 ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(e1) {
                this.maxBounds = e1, this.minLat = -rp, this.maxLat = rp, this.minLng = -180, this.maxLng = 180, e1 && (this.minLat = e1.getSouth(), this.maxLat = e1.getNorth(), this.minLng = e1.getWest(), this.maxLng = e1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = Kd(this.minLng) * this.tileSize, this.worldMaxX = Kd(this.maxLng) * this.tileSize, this.worldMinY = Jd(this.maxLat) * this.tileSize, this.worldMaxY = Jd(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e1, t) {
                return this.projection.createTileMatrix(this, t, e1);
            }
            calculateDistanceTileData(e1) {
                const t = e1.key, i = this._distanceTileDataCache;
                if (i[t]) return i[t];
                const r = e1.canonical, n = 1 / this.height, o = this.cameraWorldSize, s = o / this.zoomScale(r.z), a = (r.x + Math.pow(2, r.z) * e1.wrap) * s, l = r.y * s, c = this.point;
                c.x *= o / this.worldSize, c.y *= o / this.worldSize;
                const h = this.angle, u = Math.sin(-h), d = -Math.cos(-h);
                return i[t] = {
                    bearing: [
                        u,
                        d
                    ],
                    center: [
                        (c.x - a) * n,
                        (c.y - l) * n
                    ],
                    scale: s / cr * n
                }, i[t];
            }
            calculateFogTileMatrix(e1) {
                const t = e1.key, i = this._fogTileMatrixCache;
                if (i[t]) return i[t];
                const r = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, e1);
                return Au.multiply(r, this.worldToFogMatrix, r), i[t] = new Float32Array(r), i[t];
            }
            calculateProjMatrix(e1, t = !1, i = !1) {
                const r = e1.key;
                let n;
                if (n = i ? this._expandedProjMatrixCache : t ? this._alignedProjMatrixCache : this._projMatrixCache, n[r]) return n[r];
                const o = this.calculatePosMatrix(e1, this.worldSize);
                let s;
                return s = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : i ? this.expandedFarZProjMatrix : t ? this.alignedProjMatrix : this.projMatrix, Au.multiply(o, s, o), n[r] = new Float32Array(o), n[r];
            }
            calculatePixelsToTileUnitsMatrix(e1) {
                const t = e1.tileID.key, i = this._pixelsToTileUnitsCache;
                if (i[t]) return i[t];
                const r = function(e1, t) {
                    const { scale: i } = e1.tileTransform, r = i * cr / (e1.tileSize * Math.pow(2, t.zoom - e1.tileID.overscaledZ + e1.tileID.canonical.z));
                    return bu.scale(new Float32Array(4), t.inverseAdjustmentMatrix, [
                        r,
                        r
                    ]);
                }(e1, this);
                return i[t] = r, i[t];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const e1 = 1 / this.worldSize, t = Au.fromScaling([], [
                        e1,
                        e1,
                        e1
                    ]);
                    return Au.multiply(t, t, this.globeMatrix), t;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const e1 = this._elevation;
                this._updateCameraState();
                const t = Qd(1, this._center.lat) * this.worldSize, i = this._computeCameraPosition(t), r = this._camera.forward(), n = Qd(1, this._center.lat);
                i[2] /= n, r[2] /= n, Du.normalize(r, r);
                const o = e1.raycast(i, r, e1.exaggeration());
                if (o) {
                    const e1 = Du.scaleAndAdd([], i, r, o), t = new lp(e1[0], e1[1], Qd(e1[2], tp(e1[1]))), s = (t.z + Du.length([
                        t.x - i[0],
                        t.y - i[1],
                        t.z - i[2] * n
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(s), this._centerAltitude = t.toAltitude(), this._center = this.coordinateLocation(t), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(e1 = !1) {
                if (!this._elevation) return;
                const t = this._elevation, i = Qd(1, this._center.lat) * this.worldSize, r = this._computeCameraPosition(i), n = t.getAtPointOrZero(new lp(...r)), o = this.pixelsPerMeter / this.worldSize * n, s = this._minimumHeightOverTerrain(), a = r[2] - o;
                if (a <= s) {
                    if (a < 0 || e1) {
                        const e1 = this.locationCoordinate(this._center, this._centerAltitude), t = [
                            r[0],
                            r[1],
                            e1.z - r[2]
                        ], i = Du.length(t);
                        t[2] -= (s - a) / this._pixelsPerMercatorPixel;
                        const n = Du.length(t);
                        if (0 === n) return;
                        Du.scale(t, t, i / n * this._pixelsPerMercatorPixel), this._camera.position = [
                            r[0],
                            r[1],
                            e1.z * this._pixelsPerMercatorPixel - t[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const e1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || e1) {
                    const t = this.center;
                    return t.lat = z(t.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !e1) && (t.lng = z(t.lng, this.minLng, this.maxLng)), this.center = t, void (this._constraining = !1);
                }
                const t = this._unmodified, { x: i, y: r } = this.point;
                let n = 0, o = i, s = r;
                const a = this.width / 2, l = this.height / 2, c = this.worldMinY * this.scale, h = this.worldMaxY * this.scale;
                if (r - l < c && (s = c + l), r + l > h && (s = h - l), h - c < this.height && (n = Math.max(n, this.height / (h - c)), s = (h + c) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e1 = this.worldMinX * this.scale, t = this.worldMaxX * this.scale, r = this.worldSize / 2 - (e1 + t) / 2;
                    o = (i + r + this.worldSize) % this.worldSize - r, o - a < e1 && (o = e1 + a), o + a > t && (o = t - a), t - e1 < this.width && (n = Math.max(n, this.width / (t - e1)), o = (t + e1) / 2);
                }
                o === i && s === r || (this.center = this.unproject(new y(o, s))), n && (this.zoom += this.scaleZoom(n)), this._constrainCamera(), this._unmodified = t, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e1 = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e1 = Math.max(e1, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e1;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const e1 = this.centerOffset, t = "globe" === this.projection.name, i = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = Qd(1, this.center.lat) / Qd(1, 45));
                const r = Qx(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, r), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const n = "meters" === this.projection.zAxisUnit ? i : 1, o = this._camera.getWorldToCamera(this.worldSize, n);
                let s;
                const a = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (a[8] = 2 * -e1.x / this.width, a[9] = 2 * e1.y / this.height, this.isOrthographic) {
                    let t = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), i = t * this.aspect, r = -i, n = -t;
                    i -= e1.x, r -= e1.x, t += e1.y, n += e1.y, s = this._camera.getCameraToClipOrthographic(r, i, n, t, this._nearZ, this._farZ), ((e1, t, i, r)=>{
                        for(let n = 0; n < 16; n++)e1[n] = bv(t[n], i[n], r);
                    })(s, s, a, wv(this.pitch >= 15 ? 1 : this.pitch / 15));
                } else s = a;
                const l = Au.mul([], a, o);
                let c = Au.mul([], s, o);
                if (this.projection.isReprojectedInTileSpace) {
                    const e1 = this.locationCoordinate(this.center), t = Au.identity([]);
                    Au.translate(t, t, [
                        e1.x * this.worldSize,
                        e1.y * this.worldSize,
                        0
                    ]), Au.multiply(t, t, Kx(this)), Au.translate(t, t, [
                        -e1.x * this.worldSize,
                        -e1.y * this.worldSize,
                        0
                    ]), Au.multiply(c, c, t), Au.multiply(l, l, t), this.inverseAdjustmentMatrix = function(e1) {
                        const t = Kx(e1, !0);
                        return bu.invert([], [
                            t[0],
                            t[1],
                            t[4],
                            t[5]
                        ]);
                    }(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (this.mercatorMatrix = Au.scale([], c, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / n,
                    1
                ]), this.projMatrix = c, this.invProjMatrix = Au.invert(new Float64Array(16), this.projMatrix), t) {
                    const t = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    t[8] = 2 * -e1.x / this.width, t[9] = 2 * e1.y / this.height, this.expandedFarZProjMatrix = Au.mul([], t, o);
                } else this.expandedFarZProjMatrix = this.projMatrix;
                const h = Au.invert([], s);
                this.frustumCorners = Hu.fromInvProjectionMatrix(h, this.horizonLineFromTop(), this.height), this.cameraFrustum = Qu.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !t);
                const u = new Float32Array(16);
                Au.identity(u), Au.scale(u, u, [
                    1,
                    -1,
                    1
                ]), Au.rotateX(u, u, this._pitch), Au.rotateZ(u, u, this.angle);
                const d = Au.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
                this.starsProjMatrix = Au.clone(d);
                const p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                d[8] = 2 * -e1.x / this.width, d[9] = 2 * (e1.y + p) / this.height, this.skyboxMatrix = Au.multiply(u, d, u);
                const f = this.point, m = f.x, _ = f.y, g = this.width % 2 / 2, y = this.height % 2 / 2, x = Math.cos(this.angle), v = Math.sin(this.angle), b = m - Math.round(m) + x * g + v * y, w = _ - Math.round(_) + x * y + v * g, T = new Float64Array(c);
                if (Au.translate(T, T, [
                    b > .5 ? b - 1 : b,
                    w > .5 ? w - 1 : w,
                    0
                ]), this.alignedProjMatrix = T, c = Au.create(), Au.scale(c, c, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), Au.translate(c, c, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = c, c = Au.create(), Au.scale(c, c, [
                    1,
                    -1,
                    1
                ]), Au.translate(c, c, [
                    -1,
                    -1,
                    0
                ]), Au.scale(c, c, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = c, this.pixelMatrix = Au.multiply(new Float64Array(16), this.labelPlaneMatrix, l), this._calcFogMatrices(), this._distanceTileDataCache = {}, c = Au.invert(new Float64Array(16), this.pixelMatrix), !c) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = c, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = function(e1) {
                        const { x: t, y: i } = e1.point, { lng: r, lat: n } = e1._center;
                        return zd(t, i, e1.worldSize, r, n);
                    }(this);
                    const e1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = Du.transformMat4(e1, e1, o), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = c;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const e1 = this.cameraWorldSizeForFog, t = this.cameraPixelsPerMeter, i = this._camera.position, r = 1 / this.height / this._pixelsPerMercatorPixel, n = [
                    e1,
                    e1,
                    t
                ];
                Du.scale(n, n, r), Du.scale(i, i, -1), Du.multiply(i, i, n);
                const o = Au.create();
                Au.translate(o, o, i), Au.scale(o, o, n), this.mercatorFogMatrix = o, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(e1, t, r);
            }
            _computeCameraPosition(e1) {
                const t = (e1 = e1 || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), r = this.point, n = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t - e1 / this.worldSize * this._centerAltitude;
                return [
                    r.x / this.worldSize - i[0] * n,
                    r.y / this.worldSize - i[1] * n,
                    e1 / this.worldSize * this._centerAltitude - i[2] * n
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(e1) {
                const t = this._maxCameraBoundsDistance() * Math.cos(this._pitch), i = this._camera.position[2], r = e1[2];
                let n = 1;
                this.projection.wrap && (this.center = this.center.wrap()), r > 0 && (n = Math.min((t - i) / r, 1)), this._camera.position = Du.scaleAndAdd([], this._camera.position, e1, n), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const e1 = this._camera.position, t = this._camera.forward(), { pitch: i, bearing: r } = this._camera.getPitchBearing(), n = Qd(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, o = this._mercatorZfromZoom(this._maxZoom) * Math.cos(w(this._maxPitch)), s = Math.max((e1[2] - n) / Math.cos(i), o), a = this._zoomFromMercatorZ(s);
                Du.scaleAndAdd(e1, e1, t, s), this._pitch = z(i, w(this.minPitch), w(this.maxPitch)), this.angle = D(r, -Math.PI, Math.PI), this._setZoom(z(a, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new lp(e1[0], e1[1], e1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e1) {
                return Math.pow(2, e1) * this.tileSize;
            }
            _mercatorZfromZoom(e1) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e1);
            }
            _minimumHeightOverTerrain() {
                const e1 = Math.min((null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom) + 4, this._maxZoom);
                return this._mercatorZfromZoom(e1);
            }
            _zoomFromMercatorZ(e1) {
                return this.scaleZoom(this.cameraToCenterDistance / (e1 * this.tileSize));
            }
            zoomFromMercatorZAdjusted(e1) {
                let t = 0, i = id, r = 0, n = 1 / 0;
                for(; i - t > 1e-6 && i > t;){
                    const o = t + .5 * (i - t), s = this.tileSize * Math.pow(2, o), a = this.getCameraToCenterDistance(this.projection, o, s), l = this.scaleZoom(a / (e1 * this.tileSize)), c = Math.abs(o - l);
                    c < n && (n = c, r = o), o < l ? t = o : i = o;
                }
                return r;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (H("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(e1, t) {
                const i = Math.min(e1.x, t.x), r = Math.max(e1.x, t.x), n = Math.min(e1.y, t.y), o = Math.max(e1.y, t.y);
                if (n < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const s = [
                    new y(i, n),
                    new y(r, o),
                    new y(i, o),
                    new y(r, n)
                ], a = this.renderWorldCopies ? -3 : 0, l = this.renderWorldCopies ? 4 : 1;
                for (const e1 of s){
                    const t = this.pointRayIntersection(e1);
                    if (t.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t);
                    if (i.x < a || i.y < 0 || i.x > l || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + T(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new y(0, 0), new y(this.width, this.height));
            }
            zoomDeltaToMovement(e1, t) {
                const i = Du.length(Du.sub([], this._camera.position, e1)), r = this._zoomFromMercatorZ(i) + t;
                return i - this._mercatorZfromZoom(r);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const e1 = function([e1, t, i], r) {
                        const n = [
                            e1,
                            t,
                            i,
                            1
                        ];
                        yu.transformMat4(n, n, r);
                        const o = n[3] = Math.max(n[3], 1e-6);
                        return n[0] /= o, n[1] /= o, n[2] /= o, n;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new y(e1[0], e1[1]);
                }
                {
                    const e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new y(0, e1));
                }
            }
            getCameraToCenterDistance(e1, t = this.zoom, i = this.worldSize) {
                const r = Qx(e1, t, this.width, this.height, 1024), n = e1.pixelSpaceConversion(this.center.lat, i, r);
                let o = .5 / Math.tan(.5 * this._fov) * this.height * n;
                return this.isOrthographic && (o = bv(1, o, wv(this.pitch >= 15 ? 1 : this.pitch / 15))), o;
            }
            getWorldToCameraMatrix() {
                const e1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && Au.multiply(e1, e1, this.globeMatrix), e1;
            }
            getFrustum(e1) {
                return Qu.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, e1, "meters" === this.projection.zAxisUnit);
            }
        }
        function Ev(e1, t, i) {
            Au.identity(e1), Au.rotateZ(e1, e1, w(t[2])), Au.rotateX(e1, e1, w(t[0])), Au.rotateY(e1, e1, w(t[1])), Au.scale(e1, e1, i), Au.multiply(e1, e1, [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }
        function Mv(e1, t, i, r, n, o, s, a) {
            const l = [
                i[0] - t[0],
                i[1] - t[1],
                0
            ], c = [
                r[0] - t[0],
                r[1] - t[1],
                0
            ];
            if (Du.length(l) < 1e-12 || Du.length(c) < 1e-12) return Iu.identity(e1);
            const h = Du.cross([], l, c);
            Du.normalize(h, h), Du.subtract(c, r, t), l[2] = (o - n) * a, c[2] = (s - n) * a;
            const u = l;
            return Du.cross(u, l, c), Du.normalize(u, u), Iu.rotationTo(e1, h, u);
        }
        function Av(e1, t, i = !1) {
            const r = Dd(t.zoom), n = function(e1, t, i) {
                const r = t.worldSize, n = [
                    e1[12],
                    e1[13],
                    e1[14]
                ], o = tp(n[1] / r), s = ep(n[0] / r), a = Au.identity([]), l = Qd(1, o) * r, c = Qd(1, 0) * r * op(o, t.zoom), h = 1 / Id(r);
                let u = c * h;
                if (i) {
                    const e1 = Qx(t.projection, t.zoom, t.width, t.height, 1024);
                    u = h * t.projection.pixelSpaceConversion(t.center.lat, r, e1);
                }
                const d = wd(o, s);
                Du.add(d, d, Du.scale([], Du.normalize([], d), l * u * n[2]));
                const p = function(e1) {
                    const t = [
                        e1[0],
                        e1[1],
                        e1[2]
                    ];
                    let i = [
                        0,
                        1,
                        0
                    ];
                    const r = Du.cross([], i, t);
                    return Du.cross(i, t, r), 0 === Du.squaredLength(i) && (i = [
                        0,
                        1,
                        0
                    ], Du.cross(r, t, i)), Du.normalize(r, r), Du.normalize(i, i), Du.normalize(t, t), [
                        r[0],
                        r[1],
                        r[2],
                        0,
                        i[0],
                        i[1],
                        i[2],
                        0,
                        t[0],
                        t[1],
                        t[2],
                        0,
                        e1[0],
                        e1[1],
                        e1[2],
                        1
                    ];
                }(d);
                Au.scale(a, a, [
                    u,
                    u,
                    u * l
                ]), Au.translate(a, a, [
                    -n[0],
                    -n[1],
                    -n[2]
                ]);
                const f = Au.multiply([], t.globeMatrix, p);
                return Au.multiply(f, f, a), Au.multiply(f, f, e1), f;
            }(e1, t, i);
            if (r > 0) {
                const i = function(e1, t) {
                    const i = t.worldSize, r = Qd(1, 0) * i * op(t.center.lat, t.zoom) / Id(i), n = Qd(1, t.center.lat) * i, o = Au.identity([]);
                    return Au.rotateY(o, o, w(t.center.lng)), Au.rotateX(o, o, w(t.center.lat)), Au.translate(o, o, [
                        0,
                        0,
                        rd
                    ]), Au.scale(o, o, [
                        r,
                        r,
                        r * n
                    ]), Au.translate(o, o, [
                        t.point.x - .5 * i,
                        t.point.y - .5 * i,
                        0
                    ]), Au.multiply(o, o, e1), Au.multiply(o, t.globeMatrix, o);
                }(e1, t);
                return function(e1, t, i) {
                    const r = (e1, t, i)=>{
                        const r = Du.length(e1), n = Du.length(t), o = md(e1, t, i);
                        return Du.scale(o, o, 1 / Du.length(o) * Kr(r, n, i));
                    }, n = r([
                        e1[0],
                        e1[1],
                        e1[2]
                    ], [
                        t[0],
                        t[1],
                        t[2]
                    ], i), o = r([
                        e1[4],
                        e1[5],
                        e1[6]
                    ], [
                        t[4],
                        t[5],
                        t[6]
                    ], i), s = r([
                        e1[8],
                        e1[9],
                        e1[10]
                    ], [
                        t[8],
                        t[9],
                        t[10]
                    ], i), a = md([
                        e1[12],
                        e1[13],
                        e1[14]
                    ], [
                        t[12],
                        t[13],
                        t[14]
                    ], i);
                    return [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        1
                    ];
                }(n, i, r);
            }
            return n;
        }
        const Sv = 64, Iv = [
            1,
            1,
            1
        ];
        class Cv {
            constructor(e1, t, i, r){
                this.id = e1, this.position = null != t ? new Wd(t[0], t[1]) : new Wd(0, 0), this.orientation = null != i ? i : [
                    0,
                    0,
                    0
                ], this.nodes = r, this.uploaded = !1, this.aabb = new ed([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
            _applyTransformations(e1, t) {
                if (Au.multiply(e1.matrix, t, e1.matrix), e1.meshes) for (const t of e1.meshes){
                    const i = ed.applyTransform(t.aabb, e1.matrix);
                    this.aabb.encapsulate(i);
                }
                if (e1.children) for (const t of e1.children)this._applyTransformations(t, e1.matrix);
            }
            computeBoundsAndApplyParent() {
                const e1 = Au.identity([]);
                for (const t of this.nodes)this._applyTransformations(t, e1);
            }
            _positionModelOnTerrain(e1, t) {
                const i = e1.elevation;
                if (!i) return 0;
                const r = ed.projectAabbCorners(this.aabb, this.matrix), n = Qd(1, this.position.lat) * e1.worldSize, o = function(e1, t) {
                    const i = [
                        0,
                        0,
                        1
                    ], r = [
                        {
                            corners: [
                                0,
                                1,
                                3,
                                2
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                1,
                                5,
                                2,
                                6
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                0,
                                4,
                                1,
                                5
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                2,
                                6,
                                3,
                                7
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                4,
                                7,
                                5,
                                6
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                0,
                                3,
                                4,
                                7
                            ],
                            dotProductWithUp: 0
                        }
                    ];
                    for (const n of r){
                        const r = e1[n.corners[0]], o = e1[n.corners[1]], s = e1[n.corners[2]], a = [
                            o[0] - r[0],
                            o[1] - r[1],
                            t * (o[2] - r[2])
                        ], l = Du.cross(a, a, [
                            s[0] - r[0],
                            s[1] - r[1],
                            t * (s[2] - r[2])
                        ]);
                        Du.normalize(l, l), n.dotProductWithUp = Du.dot(l, i);
                    }
                    return r.sort((e1, t)=>e1.dotProductWithUp - t.dotProductWithUp), r[0].corners;
                }(r, n), s = r[o[0]], a = r[o[1]], l = r[o[2]], c = r[o[3]], h = i.getAtPointOrZero(new lp(s[0] / e1.worldSize, s[1] / e1.worldSize), 0), u = i.getAtPointOrZero(new lp(a[0] / e1.worldSize, a[1] / e1.worldSize), 0), d = i.getAtPointOrZero(new lp(l[0] / e1.worldSize, l[1] / e1.worldSize), 0), p = i.getAtPointOrZero(new lp(c[0] / e1.worldSize, c[1] / e1.worldSize), 0), f = (h + p) / 2, m = (u + d) / 2;
                return f > m ? u < d ? Mv(t, a, c, s, u, p, h, n) : Mv(t, l, s, c, d, h, p, n) : h < p ? Mv(t, s, a, l, h, u, d, n) : Mv(t, c, l, a, p, d, u, n), Math.max(f, m);
            }
            computeModelMatrix(e1, t, i, r, n, o, s = !1) {
                const a = e1.transform, l = a.zoom, c = a.project(this.position), h = op(this.position.lat, l), u = 1 / h;
                Au.identity(this.matrix), Au.translate(this.matrix, this.matrix, [
                    c.x + r[0] * u,
                    c.y + r[1] * u,
                    r[2]
                ]);
                let d = 1, p = 1;
                const f = a.worldSize;
                if (s) {
                    if ("mercator" === a.projection.name) {
                        let e1 = 0;
                        a.elevation && (e1 = a.elevation.getAtPointOrZero(new lp(c.x / f, c.y / f), 0));
                        const t = yu.transformMat4([], [
                            c.x,
                            c.y,
                            e1,
                            1
                        ], a.projMatrix)[3] / a.cameraToCenterDistance;
                        d = t, p = t * op(a.center.lat, l);
                    } else if ("globe" === a.projection.name) {
                        const e1 = Av(this.matrix, a), t = Au.multiply([], a.projMatrix, e1), i = [
                            0,
                            0,
                            0,
                            1
                        ];
                        yu.transformMat4(i, i, t);
                        const r = i[3] / a.cameraToCenterDistance, n = Dd(l), o = a.projection.pixelsPerMeter(this.position.lat, f) * op(this.position.lat, l), s = a.projection.pixelsPerMeter(a.center.lat, f) * op(a.center.lat, l);
                        d = r / Kr(o, np(a.center.lat), n), p = r * h / o, d *= s, p *= s;
                    }
                } else d = u;
                Au.scale(this.matrix, this.matrix, [
                    d,
                    d,
                    p
                ]);
                const m = [
                    ...this.matrix
                ], _ = this.orientation, g = [];
                if (Ev(g, [
                    _[0] + t[0],
                    _[1] + t[1],
                    _[2] + t[2]
                ], i), Au.multiply(this.matrix, m, g), n && a.elevation) {
                    let e1 = 0;
                    const t = [];
                    if (o && a.elevation) {
                        e1 = this._positionModelOnTerrain(a, t);
                        const i = Au.fromQuat([], t), r = Au.multiply([], i, g);
                        Au.multiply(this.matrix, m, r);
                    } else e1 = a.elevation.getAtPointOrZero(new lp(c.x / f, c.y / f), 0);
                    0 !== e1 && (this.matrix[14] += e1);
                }
            }
            upload(e1) {
                if (!this.uploaded) {
                    for (const t of this.nodes)Dv(t, e1);
                    for (const e1 of this.nodes)Rv(e1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const e1 of this.nodes)Lv(e1);
            }
        }
        function zv(e1, t, i = !1) {
            e1.uploaded || (e1.gfxTexture = new My(t, e1.image, i ? t.gl.R8 : t.gl.RGBA, {
                useMipmap: e1.sampler.minFilter >= t.gl.NEAREST_MIPMAP_NEAREST
            }), e1.uploaded = !0, e1.image = null);
        }
        function Pv(e1, t, i) {
            e1.indexBuffer = t.createIndexBuffer(e1.indexArray, !1, !0), e1.vertexBuffer = t.createVertexBuffer(e1.vertexArray, Fx.members, !1, !0), e1.normalArray && (e1.normalBuffer = t.createVertexBuffer(e1.normalArray, jx.members, !1, !0)), e1.texcoordArray && (e1.texcoordBuffer = t.createVertexBuffer(e1.texcoordArray, Vx.members, !1, !0)), e1.colorArray && (e1.colorBuffer = t.createVertexBuffer(e1.colorArray, (12 === e1.colorArray.bytesPerElement ? Nx : Ux).members, !1, !0)), e1.featureArray && (e1.pbrBuffer = t.createVertexBuffer(e1.featureArray, qx.members, !0)), e1.segments = xl.simpleSegment(0, 0, e1.vertexArray.length, e1.indexArray.length);
            const r = e1.material;
            r.pbrMetallicRoughness.baseColorTexture && zv(r.pbrMetallicRoughness.baseColorTexture, t), r.pbrMetallicRoughness.metallicRoughnessTexture && zv(r.pbrMetallicRoughness.metallicRoughnessTexture, t), r.normalTexture && zv(r.normalTexture, t), r.occlusionTexture && zv(r.occlusionTexture, t, i), r.emissionTexture && zv(r.emissionTexture, t);
        }
        function Dv(e1, t, i) {
            if (e1.meshes) for (const r of e1.meshes)Pv(r, t, i);
            if (e1.children) for (const r of e1.children)Dv(r, t, i);
        }
        function Rv(e1) {
            if (e1.meshes) for (const t of e1.meshes)t.indexArray.destroy(), t.vertexArray.destroy(), t.colorArray && t.colorArray.destroy(), t.normalArray && t.normalArray.destroy(), t.texcoordArray && t.texcoordArray.destroy(), t.featureArray && t.featureArray.destroy();
            if (e1.children) for (const t of e1.children)Rv(t);
        }
        function Lv(e1) {
            if (e1.meshes) for (const i of e1.meshes)i.vertexBuffer && (i.vertexBuffer.destroy(), i.indexBuffer.destroy(), i.normalBuffer && i.normalBuffer.destroy(), i.texcoordBuffer && i.texcoordBuffer.destroy(), i.colorBuffer && i.colorBuffer.destroy(), i.pbrBuffer && i.pbrBuffer.destroy(), i.segments.destroy(), i.material && ((t = i.material).pbrMetallicRoughness.baseColorTexture && t.pbrMetallicRoughness.baseColorTexture.gfxTexture && t.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), t.pbrMetallicRoughness.metallicRoughnessTexture && t.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && t.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), t.normalTexture && t.normalTexture.gfxTexture && t.normalTexture.gfxTexture.destroy(), t.emissionTexture && t.emissionTexture.gfxTexture && t.emissionTexture.gfxTexture.destroy(), t.occlusionTexture && t.occlusionTexture.gfxTexture && t.occlusionTexture.gfxTexture.destroy()));
            var t;
            if (e1.children) for (const t of e1.children)Lv(t);
        }
        class kv {
            constructor(e1, t){
                this.feature = e1, this.instancedDataOffset = t, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Ov {
            constructor(){
                this.instancedDataArray = new rl, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
        }
        class Bv {
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.projection = e1.projection, this.index = e1.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                };
            }
            populate(e1, t, i, r) {
                this.tileToMeter = ap(i);
                const n = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                for (const { feature: o, id: s, index: a, sourceLayerIndex: l } of e1){
                    const e1 = gp(o, n);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), e1, i)) continue;
                    const c = {
                        id: s,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: n ? e1.geometry : _p(o, i, r),
                        properties: o.properties,
                        type: o.type,
                        patterns: {}
                    }, h = this.addFeature(c, c.geometry, e1);
                    h && t.featureIndex.insert(o, c.geometry, a, l, this.index, this.instancesPerModel[h].instancedDataArray.length);
                }
                this.lookup = null;
            }
            update(e1, t, i, r) {
                for(const t in this.instancesPerModel){
                    const i = this.instancesPerModel[t];
                    for(const t in e1)i.idToFeaturesIndex.hasOwnProperty(t) && this.evaluate(i.features[i.idToFeaturesIndex[t]], e1[t], i, !0);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let e1 = !1;
                for(const t in this.instancesPerModel){
                    const i = this.instancesPerModel[t];
                    for (const t of i.features){
                        const r = this.layers[0], n = t.feature, o = this.canonical, s = r.paint.get("model-rotation").evaluate(n, {}, o), a = r.paint.get("model-scale").evaluate(n, {}, o), l = r.paint.get("model-translation").evaluate(n, {}, o);
                        Du.exactEquals(t.rotation, s) && Du.exactEquals(t.scale, a) && Du.exactEquals(t.translation, l) || (this.evaluate(t, t.featureStates, i, !0), e1 = !0);
                    }
                }
                return e1;
            }
            isEmpty() {
                for(const e1 in this.instancesPerModel)if (0 !== this.instancesPerModel[e1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(e1) {
                if (!this.uploaded) for(const t in this.instancesPerModel){
                    const i = this.instancesPerModel[t];
                    i.instancedDataArray.length < 0 || 0 === i.instancedDataArray.length || (i.instancedDataBuffer ? i.instancedDataBuffer.updateData(i.instancedDataArray) : i.instancedDataBuffer = e1.createVertexBuffer(i.instancedDataArray, Gx.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy() {
                for(const e1 in this.instancesPerModel){
                    const t = this.instancesPerModel[e1];
                    0 !== t.instancedDataArray.length && t.instancedDataBuffer && t.instancedDataBuffer.destroy();
                }
            }
            addFeature(e1, t, i) {
                const r = this.layers[0], n = r.layout.get("model-id").evaluate(i, {}, this.canonical);
                if (!n) return H(`modelId is not evaluated for layer ${r.id} and it is not going to get rendered.`), n;
                this.instancesPerModel[n] || (this.instancesPerModel[n] = new Ov);
                const o = this.instancesPerModel[n], s = o.instancedDataArray, a = new kv(i, s.length);
                for (const e1 of t)for (const t of e1){
                    if (t.x < 0 || t.x >= cr || t.y < 0 || t.y >= cr) continue;
                    const e1 = (this.lookupDim - 1) / cr, i = this.lookupDim * (t.y * e1 | 0) + t.x * e1 | 0;
                    if (this.lookup) {
                        if (0 !== this.lookup[i]) continue;
                        this.lookup[i] = 1;
                    }
                    this.instanceCount++;
                    const r = s.length;
                    s.resize(r + 1), o.instancesEvaluatedElevation.push(0), s.float32[16 * r] = t.x, s.float32[16 * r + 1] = t.y;
                }
                return a.instancedDataCount = o.instancedDataArray.length - a.instancedDataOffset, a.instancedDataCount > 0 && (e1.id && (o.idToFeaturesIndex[e1.id] = o.features.length), o.features.push(a), this.evaluate(a, {}, o, !1)), n;
            }
            evaluate(e1, t, i, r) {
                const n = this.layers[0], o = e1.feature, s = this.canonical, a = e1.rotation = n.paint.get("model-rotation").evaluate(o, t, s), l = e1.scale = n.paint.get("model-scale").evaluate(o, t, s), c = e1.translation = n.paint.get("model-translation").evaluate(o, t, s), h = n.paint.get("model-color").evaluate(o, t, s);
                h.a = n.paint.get("model-color-mix-intensity").evaluate(o, t, s);
                const u = [];
                this.maxVerticalOffset < c[2] && (this.maxVerticalOffset = c[2]), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), Ev(u, a, l);
                const d = Math.round(100 * h.a) + h.b / 1.05;
                for(let t = 0; t < e1.instancedDataCount; ++t){
                    const n = e1.instancedDataOffset + t, o = 16 * n, a = i.instancedDataArray.float32;
                    let l = 0;
                    r && (l = a[o + 6] - i.instancesEvaluatedElevation[n]);
                    const p = 0 | a[o + 1];
                    a[o] = (0 | a[o]) + h.r / 1.05, a[o + 1] = p + h.g / 1.05, a[o + 2] = d, a[o + 3] = 1 / (s.z > 10 ? this.tileToMeter : ap(s, p)), a[o + 4] = c[0], a[o + 5] = c[1], a[o + 6] = c[2] + l, a[o + 7] = u[0], a[o + 8] = u[1], a[o + 9] = u[2], a[o + 10] = u[4], a[o + 11] = u[5], a[o + 12] = u[6], a[o + 13] = u[8], a[o + 14] = u[9], a[o + 15] = u[10], i.instancesEvaluatedElevation[n] = c[2];
                }
            }
        }
        Rs(Bv, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), Rs(Ov, "PerModelAttributes"), Rs(kv, "ModelFeature");
        const Fv = new ga({
            visibility: new fa(Pt.layout_model.visibility),
            "model-id": new ma(Pt.layout_model["model-id"])
        });
        var Nv = {
            paint: new ga({
                "model-opacity": new fa(Pt.paint_model["model-opacity"]),
                "model-rotation": new ma(Pt.paint_model["model-rotation"]),
                "model-scale": new ma(Pt.paint_model["model-scale"]),
                "model-translation": new ma(Pt.paint_model["model-translation"]),
                "model-color": new ma(Pt.paint_model["model-color"]),
                "model-color-mix-intensity": new ma(Pt.paint_model["model-color-mix-intensity"]),
                "model-type": new fa(Pt.paint_model["model-type"]),
                "model-cast-shadows": new fa(Pt.paint_model["model-cast-shadows"]),
                "model-receive-shadows": new fa(Pt.paint_model["model-receive-shadows"]),
                "model-ambient-occlusion-intensity": new fa(Pt.paint_model["model-ambient-occlusion-intensity"]),
                "model-emissive-strength": new ma(Pt.paint_model["model-emissive-strength"]),
                "model-roughness": new ma(Pt.paint_model["model-roughness"]),
                "model-height-based-emissive-strength-multiplier": new ma(Pt.paint_model["model-height-based-emissive-strength-multiplier"]),
                "model-cutoff-fade-range": new fa(Pt.paint_model["model-cutoff-fade-range"])
            }),
            layout: Fv
        };
        const Uv = new Float32Array(262144), Vv = new Uint8Array(262144);
        function jv(e1) {
            let t = 0;
            if (e1.meshes) for (const i of e1.meshes)t = Math.max(t, i.aabb.max[2]);
            if (e1.children) for (const i of e1.children)t = Math.max(t, jv(i));
            return t;
        }
        const Gv = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class qv {
            constructor(e1){
                this.node = e1, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.feature = {
                    type: "Point",
                    id: e1.id,
                    geometry: [],
                    properties: {
                        height: jv(e1)
                    }
                };
            }
        }
        class Zv {
            constructor(e1, t, i, r){
                this.nodes = e1, this.id = t, this.modelTraits |= 1, this.uploaded = !1, this.hasPattern = !1, i && (this.modelTraits |= 4), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = r, this.dirty = !0, this.needsUpload = !1;
            }
            update() {
                console.log("Update 3D model bucket");
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(e1) {
                if (!this.needsUpload) return;
                const t = this.getNodesInfo();
                for (const i of t){
                    const t = i.node;
                    this.uploaded ? this.updatePbrBuffer(t) : Dv(t, e1, !0);
                }
                for (const e1 of t)Rv(e1.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(e1) {
                let t = !1;
                if (!e1.meshes) return t;
                for (const i of e1.meshes)i.pbrBuffer && (i.pbrBuffer.updateData(i.featureArray), t = !0);
                return t;
            }
            needsReEvaluation(e1, t, i) {
                const r = e1.transform.projectionOptions, n = e1.style.getBrightness(), o = this.brightness !== n;
                return !!(!this.uploaded || this.dirty || r.name !== this.projection.name || $v(i.paint.get("model-color").value, o) || $v(i.paint.get("model-color-mix-intensity").value, o) || $v(i.paint.get("model-roughness").value, o) || $v(i.paint.get("model-emissive-strength").value, o) || $v(i.paint.get("model-height-based-emissive-strength-multiplier").value, o)) && (this.projection = r, this.brightness = n, !0);
            }
            evaluateScale(e1, t) {
                if (e1.transform.zoom === this.zoom) return;
                this.zoom = e1.transform.zoom;
                const i = this.getNodesInfo(), r = this.id.canonical;
                for (const e1 of i){
                    const i = e1.feature;
                    e1.evaluatedScale = t.paint.get("model-scale").evaluate(i, {}, r);
                }
            }
            evaluate(e1) {
                const t = this.getNodesInfo();
                for (const i of t){
                    if (!i.node.meshes) continue;
                    const t = i.feature, r = i.node.meshes && i.node.meshes[0].featureData, n = i.evaluatedColor[2], o = i.evaluatedRMEA[2], s = this.id.canonical;
                    if (i.hasTranslucentParts = !1, r) {
                        for(let r = 0; r < Gv.length; r++){
                            const n = Gv[r];
                            n.length && (t.properties.part = n);
                            const o = e1.paint.get("model-color").evaluate(t, {}, s), a = e1.paint.get("model-color-mix-intensity").evaluate(t, {}, s);
                            i.evaluatedColor[r] = [
                                o.r,
                                o.g,
                                o.b,
                                a
                            ], i.evaluatedRMEA[r][0] = e1.paint.get("model-roughness").evaluate(t, {}, s), i.evaluatedRMEA[r][2] = e1.paint.get("model-emissive-strength").evaluate(t, {}, s), i.evaluatedRMEA[r][3] = o.a, i.emissionHeightBasedParams[r] = e1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(t, {}, s), !i.hasTranslucentParts && o.a < 1 && (i.hasTranslucentParts = !0);
                        }
                        delete t.properties.part, Hv(i, n !== i.evaluatedColor[2] || o !== i.evaluatedRMEA[2]);
                    }
                    i.evaluatedScale = e1.paint.get("model-scale").evaluate(t, {}, s), this.updatePbrBuffer(i.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(e1, t, i, r) {
                const n = e1.findDEMTileFor(i);
                if (n && (n.tileID.canonical !== this.terrainTile || t !== this.terrainExaggeration)) {
                    if (n.dem && n.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = n.tileID.overscaledZ;
                        const t = Jm.create(e1, i, n);
                        if (!t) return;
                        4 & this.modelTraits && this.updateDEM(e1, t, i, r);
                        for (const e1 of this.getNodesInfo()){
                            const i = e1.node;
                            if (!i.footprint || !i.footprint.vertices || !i.footprint.vertices.length) continue;
                            const r = i.footprint.vertices;
                            let n = t.getElevationAt(r[0].x, r[0].y, !0, !0);
                            for(let e1 = 1; e1 < r.length; e1++)n = Math.min(n, t.getElevationAt(r[e1].x, r[e1].y, !0, !0));
                            i.elevation = n;
                        }
                    }
                    this.terrainTile = n.tileID.canonical, this.terrainExaggeration = t;
                }
            }
            updateDEM(e1, t, i, r) {
                let n = t._dem._modifiedForSources[r];
                if (void 0 === n && (t._dem._modifiedForSources[r] = [], n = t._dem._modifiedForSources[r]), n.includes(i.canonical)) return;
                const o = t._dem.dim;
                n.push(i.canonical);
                let s = !1;
                for (const e1 of this.getNodesInfo()){
                    const i = e1.node;
                    if (!i.footprint || !i.footprint.grid) continue;
                    const r = i.footprint.grid, n = t.tileCoordToPixel(r.min.x, r.min.y), a = t.tileCoordToPixel(r.max.x, r.max.y), l = Math.min(Math.min(o - a.y, n.x), Math.min(n.y, o - a.x));
                    if (l < 0) continue;
                    const c = z(l, 2, 5);
                    let h = Math.max(0, n.x - c), u = Math.max(0, n.y - c), d = Math.min(a.x + c, o - 1), p = Math.min(a.y + c, o - 1);
                    for(let e1 = u; e1 <= p; ++e1)for(let t = h; t <= d; ++t)Vv[e1 * o + t] = 255;
                    let f = 0, m = 0;
                    for(let e1 = 0; e1 < r.cellsY; ++e1)for(let i = 0; i < r.cellsX; ++i){
                        if (!r.cells[e1 * r.cellsX + i]) continue;
                        const n = t.tileCoordToPixel(r.min.x + i / r.xScale, r.min.y + e1 / r.yScale), s = t.tileCoordToPixel(r.min.x + (i + 1) / r.xScale, r.min.y + (e1 + 1) / r.yScale);
                        for(let e1 = n.y; e1 <= Math.min(s.y + 1, o - 1); ++e1)for(let i = n.x; i <= Math.min(s.x + 1, o - 1); ++i)255 === Vv[e1 * o + i] && (Vv[e1 * o + i] = 0, f += t.getElevationAtPixel(i, e1), m++);
                    }
                    const _ = f / m;
                    h = Math.max(1, n.x - c), u = Math.max(1, n.y - c), d = Math.min(a.x + c, o - 2), p = Math.min(a.y + c, o - 2), s = !0;
                    for(let e1 = u; e1 <= p; ++e1)for(let i = h; i <= d; ++i)0 === Vv[e1 * o + i] && (Uv[e1 * o + i] = t._dem.set(i, e1, _));
                    for(let e1 = 1; e1 < c; ++e1){
                        h = Math.max(1, n.x - e1), u = Math.max(1, n.y - e1), d = Math.min(a.x + e1, o - 2), p = Math.min(a.y + e1, o - 2);
                        for(let i = u; i <= p; ++i)for(let r = h; r <= d; ++r){
                            const n = i * o + r;
                            if (255 === Vv[n]) {
                                let s = 0, a = 0, l = -1, h = -1;
                                for(let t = -1; t <= 1; ++t)for(let n = -1; n <= 1; ++n){
                                    const c = (i + t) * o + r + n;
                                    if (Vv[c] >= e1) continue;
                                    const u = Uv[c], d = Math.abs(u);
                                    d > a && (s = u, a = d, l = n, h = t);
                                }
                                if (a > .1) {
                                    const o = 1 - (e1 + .5 * Math.abs(l * h)) / c;
                                    let a = t._dem.get(r, i) + s * o;
                                    const u = t._dem.get(r + l, i + h), d = t._dem.get(r - l, i - h, !0);
                                    (a - u) * (a - d) > 0 && (a = (u + d) / 2), Uv[n] = t._dem.set(r, i, a), Vv[n] = e1;
                                }
                            }
                        }
                    }
                }
                s && (t._demTile.needsDEMTextureUpload = !0, t._dem._timestamp = dt.now());
            }
            getNodesInfo() {
                if (!this.nodesInfo) {
                    this.nodesInfo = [];
                    for (const e1 of this.nodes)this.nodesInfo.push(new qv(e1));
                    this.freeNodes();
                }
                return this.nodesInfo;
            }
            freeNodes() {
                if (this.nodes) {
                    for (const e1 of this.nodes)Lv(e1);
                    this.nodes.splice(0, this.nodes.length);
                }
            }
            destroy() {
                this.freeNodes();
                const e1 = this.getNodesInfo();
                for (const t of e1)Rv(t.node), Lv(t.node);
            }
            isEmpty() {
                return !this.nodes.length;
            }
            updateReplacement(e1, t) {
                if (t.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t.updateTime;
                const i = t.getReplacementRegionsForTile(e1.toUnwrapped()), r = this.getNodesInfo();
                for(let e1 = 0; e1 < this.nodesInfo.length; e1++){
                    const t = r[e1].node;
                    r[e1].hiddenByReplacement = !!t.footprint && !i.find((e1)=>e1.footprint === t.footprint);
                }
            }
            getHeightAtTileCoord(e1, t) {
                const i = this.getNodesInfo(), r = [];
                for(let n = 0; n < this.nodesInfo.length; n++){
                    const o = i[n], s = o.node.meshes[0];
                    if (e1 < s.aabb.min[0] || t < s.aabb.min[1] || e1 > s.aabb.max[0] || t > s.aabb.max[1]) continue;
                    const a = (e1 - s.aabb.min[0]) / (s.aabb.max[0] - s.aabb.min[0]) * Sv | 0, l = Math.min(63, (t - s.aabb.min[1]) / (s.aabb.max[1] - s.aabb.min[1]) * Sv | 0) * Sv + Math.min(63, a);
                    if (!(s.heightmap[l] < 0 && o.node.footprint)) {
                        if (o.hiddenByReplacement) return;
                        return {
                            height: s.heightmap[l],
                            maxHeight: o.feature.properties.height,
                            hidden: !1,
                            verticalScale: o.evaluatedScale[2]
                        };
                    }
                    if (o.node.footprint.grid.query(new y(e1, t), new y(e1, t), r), r.length > 0) return {
                        height: void 0,
                        maxHeight: o.feature.properties.height,
                        hidden: o.hiddenByReplacement,
                        verticalScale: o.evaluatedScale[2]
                    };
                }
            }
        }
        function $v(e1, t) {
            return !e1.isLightConstant && t;
        }
        function Wv(e1, t, i, r, n, o, s, a) {
            let l = (61440 & t | (61440 & t) >> 4) >> 8, c = (3840 & t | (3840 & t) >> 4) >> 4, h = 240 & t | (240 & t) >> 4;
            i[3] > 0 && (l = Kr(l, 255 * i[0], i[3]), c = Kr(c, 255 * i[1], i[3]), h = Kr(h, 255 * i[2], i[3]));
            const u = l << 8 | c, d = h << 8 | Math.floor(255 * r[3]), p = function(e1) {
                const t = z(e1, 0, 2);
                return Math.min(Math.round(.5 * t * 255), 255);
            }(r[2]) << 8 | 15 * r[0] << 4 | 15 * r[1], f = z(n[0], 0, 1), m = z(n[1], 0, 1), _ = z(n[2], 0, 1), g = z(n[3], 0, 1);
            let y, x, v, b;
            if (f !== m && s !== o && m !== f) {
                const e1 = s - o;
                x = 1 / (e1 * (m - f)), v = -(o + e1 * f) / (e1 * (m - f));
                const t = z(n[4], -1, 1);
                b = Math.pow(10, t), y = 255 * _ << 8 | 255 * g;
            } else y = 65535, x = 0, v = 1, b = 1;
            if (e1.emplaceBack(u, d, p, y, x, v, b), a) {
                const e1 = a.length;
                a.clear();
                for(let t = 0; t < e1; t++)a.emplaceBack(u, d, p, y, x, v, b);
            }
        }
        function Hv(e1, t) {
            const i = e1.node;
            let r = 0;
            for (const n of i.meshes){
                if (i.lights && i.lightMeshIndex === r) continue;
                if (!n.featureData) continue;
                n.featureArray = new nl, n.featureArray.reserve(n.featureData.length);
                let o = t;
                for (const t of n.featureData){
                    let r;
                    const s = 65535 & t, a = (15 & s) < 8 ? 15 & s : 0, l = t >> 16 & 65535, c = e1.evaluatedRMEA[a], h = e1.evaluatedColor[a], u = e1.emissionHeightBasedParams[a];
                    if (o && 2 === a && i.lights && (r = new nl, r.resize(10 * i.lights.length)), Wv(n.featureArray, l, h, c, u, n.aabb.min[2], n.aabb.max[2], r), r && o) {
                        o = !1;
                        const e1 = i.meshes[i.lightMeshIndex];
                        e1.featureArray = r, e1.featureArray._trim();
                    }
                }
                n.featureArray._trim(), r++;
            }
        }
        Rs(Zv, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), Rs(qv, "Tiled3dModelFeature");
        class Xv {
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [];
            }
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(e1) {
                const t = Qv(new y(0, 0), new y(cr, cr), e1), i = [];
                for (const r of this._activeRegions){
                    if (r.hiddenByOverlap) continue;
                    if (!Jv(t, r)) continue;
                    const n = eb(r.min, r.max, e1);
                    i.push({
                        min: n.min,
                        max: n.max,
                        sourceId: this._sourceIds[r.priority],
                        footprint: r.footprint,
                        footprintTileId: r.tileId
                    });
                }
                return i;
            }
            setSources(e1) {
                this._setSources(e1.map((e1)=>({
                        getSourceId: ()=>e1.cache.id,
                        getFootprints: ()=>{
                            const t = [];
                            for (const i of e1.cache.getVisibleCoordinates()){
                                const r = e1.cache.getTile(i).buckets[e1.layer];
                                if (r) for (const e1 of r.getNodesInfo()){
                                    const r = e1.node;
                                    r.footprint && t.push({
                                        footprint: r.footprint,
                                        id: i.toUnwrapped()
                                    });
                                }
                            }
                            return t;
                        }
                    })));
            }
            _addSource(e1) {
                const t = e1.getFootprints();
                if (0 !== t.length) {
                    for (const e1 of t){
                        if (!e1.footprint) continue;
                        const t = Qv(e1.footprint.min, e1.footprint.max, e1.id);
                        this._activeRegions.push({
                            min: t.min,
                            max: t.max,
                            hiddenByOverlap: !1,
                            priority: this._sourceIds.length,
                            tileId: e1.id,
                            footprint: e1.footprint
                        });
                    }
                    this._sourceIds.push(e1.getSourceId());
                }
            }
            _computeReplacement() {
                this._activeRegions.sort((e1, t)=>e1.priority - t.priority || Yv(e1.min, t.min) || Yv(e1.max, t.max));
                let e1 = this._activeRegions.length !== this._prevRegions.length;
                if (!e1) {
                    let t = 0, i = 0;
                    for(; !e1 && t !== this._activeRegions.length;){
                        const r = this._activeRegions[t], n = this._prevRegions[i];
                        e1 = r.priority !== n.priority || !Kv(r, n), ++t, ++i;
                    }
                }
                if (e1) {
                    ++this._updateTime;
                    const e1 = (e1)=>{
                        const t = this._activeRegions;
                        if (e1 >= t.length) return e1;
                        const i = t[e1].priority;
                        for(; e1 < t.length && t[e1].priority === i;)++e1;
                        return e1;
                    };
                    if (this._sourceIds.length > 1) {
                        let t = 0, i = e1(t);
                        for(; t !== i;){
                            let r = t;
                            const n = t;
                            for(; r !== i;){
                                const e1 = this._activeRegions[r];
                                e1.hiddenByOverlap = !1;
                                for(let t = 0; t < n; t++){
                                    const i = this._activeRegions[t];
                                    if (!i.hiddenByOverlap && Jv(e1, i) && (e1.hiddenByOverlap = ib(e1.footprint, e1.tileId, i.footprint, i.tileId), e1.hiddenByOverlap)) break;
                                }
                                ++r;
                            }
                            t = i, i = e1(t);
                        }
                    }
                }
            }
            _setSources(e1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let t = e1.length - 1; t >= 0; t--)this._addSource(e1[t]);
                this._computeReplacement();
            }
        }
        function Yv(e1, t) {
            return e1.x - t.x || e1.y - t.y;
        }
        function Kv(e1, t) {
            return 0 === Yv(e1.min, t.min) && 0 === Yv(e1.max, t.max);
        }
        function Jv(e1, t) {
            return !(e1.min.x > t.max.x || e1.max.x < t.min.x || e1.min.y > t.max.y || e1.max.y < t.min.y);
        }
        function Qv(e1, t, i) {
            const r = 1 / cr, n = 1 / (1 << i.canonical.z), o = (t.x * r + i.canonical.x) * n + i.wrap, s = (t.y * r + i.canonical.y) * n;
            return {
                min: new y((e1.x * r + i.canonical.x) * n + i.wrap, (e1.y * r + i.canonical.y) * n),
                max: new y(o, s)
            };
        }
        function eb(e1, t, i) {
            const r = 1 << i.canonical.z, n = ((t.x - i.wrap) * r - i.canonical.x) * cr, o = (t.y * r - i.canonical.y) * cr;
            return {
                min: new y(((e1.x - i.wrap) * r - i.canonical.x) * cr, (e1.y * r - i.canonical.y) * cr),
                max: new y(n, o)
            };
        }
        function tb(e1, t, i, r, n, o, s) {
            const a = e1.indices, l = e1.vertices, c = [];
            for(let h = r; h < r + n; h += 3){
                const r = t[i[h + 0] + o], n = t[i[h + 1] + o], u = t[i[h + 2] + o], d = Math.min(r.x, n.x, u.x), p = Math.max(r.x, n.x, u.x), f = Math.min(r.y, n.y, u.y), m = Math.max(r.y, n.y, u.y);
                c.length = 0, e1.grid.query(new y(d, f), new y(p, m), c);
                for(let e1 = 0; e1 < c.length; e1++){
                    const t = c[e1];
                    if (Lp(l[a[3 * t + 0]], l[a[3 * t + 1]], l[a[3 * t + 2]], r, n, u, s)) return !0;
                }
            }
            return !1;
        }
        function ib(e1, t, i, r) {
            if (!e1 || !i) return !1;
            let n = e1.vertices;
            if (!t.canonical.equals(r.canonical) || t.wrap !== r.wrap) {
                if (i.vertices.length < e1.vertices.length) return ib(i, r, e1, t);
                const o = t.canonical, s = r.canonical, a = Math.pow(2, s.z - o.z);
                n = e1.vertices.map((e1)=>new y(e1.x * o.x * cr * a - s.x * cr, e1.y * o.y * cr * a - s.y * cr));
            }
            return tb(i, n, e1.indices, 0, e1.indices.length, 0, 0);
        }
        const rb = hm.types, nb = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius"
        ], ob = [
            "fill-extrusion-flood-light-ground-radius"
        ], sb = Math.pow(2, 13), ab = Math.pow(2, 15) - 1, lb = new y(0, 1), cb = 2147483648;
        function hb(e1, t, i, r, n, o, s, a) {
            e1.emplaceBack((t << 1) + s, (i << 1) + o, (Math.floor(r * sb) << 1) + n, Math.round(a));
        }
        function ub(e1, t, i, r, n, o) {
            e1.emplaceBack(t.x, t.y, (i.x << 1) + r, (i.y << 1) + n, o);
        }
        function db(e1, t, i) {
            const r = 16384;
            e1.emplaceBack(t.x, t.y, t.z, i[0] * r, i[1] * r, i[2] * r);
        }
        class pb {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class fb {
            constructor(){
                this.centroidXY = new y(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new y(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new y(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
            }
            span() {
                return new y(this.max.x - this.min.x, this.max.y - this.min.y);
            }
        }
        class mb {
            constructor(){
                this.acc = new y(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(e1, t) {
                e1.min.x === Number.MAX_VALUE && (e1.min.x = e1.max.x = t.x, e1.min.y = e1.max.y = t.y);
            }
            appendEdge(e1, t, i) {
                this.accCount++, this.acc._add(t);
                let r = !!this.borders;
                t.x < e1.min.x ? (e1.min.x = t.x, r = !0) : t.x > e1.max.x && (e1.max.x = t.x, r = !0), t.y < e1.min.y ? (e1.min.y = t.y, r = !0) : t.y > e1.max.y && (e1.max.y = t.y, r = !0), ((0 === t.x || t.x === cr) && t.x === i.x) != ((0 === t.y || t.y === cr) && t.y === i.y) && this.processBorderOverlap(t, i), r && this.checkBorderIntersection(t, i);
            }
            checkBorderIntersection(e1, t) {
                t.x < 0 != e1.x < 0 && this.addBorderIntersection(0, Kr(t.y, e1.y, (0 - t.x) / (e1.x - t.x))), t.x > cr != e1.x > cr && this.addBorderIntersection(1, Kr(t.y, e1.y, (cr - t.x) / (e1.x - t.x))), t.y < 0 != e1.y < 0 && this.addBorderIntersection(2, Kr(t.x, e1.x, (0 - t.y) / (e1.y - t.y))), t.y > cr != e1.y > cr && this.addBorderIntersection(3, Kr(t.x, e1.x, (cr - t.y) / (e1.y - t.y)));
            }
            addBorderIntersection(e1, t) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const i = this.borders[e1];
                t < i[0] && (i[0] = t), t > i[1] && (i[1] = t);
            }
            processBorderOverlap(e1, t) {
                if (e1.x === t.x) {
                    if (e1.y === t.y) return;
                    const i = 0 === e1.x ? 0 : 1;
                    this.addBorderIntersection(i, t.y), this.addBorderIntersection(i, e1.y);
                } else {
                    const i = 0 === e1.y ? 2 : 3;
                    this.addBorderIntersection(i, t.x), this.addBorderIntersection(i, e1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new y(0, 0) : new y(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((e1, t)=>e1 + +(t[0] !== Number.MAX_VALUE), 0) : 0;
            }
        }
        function _b(e1, t) {
            const i = e1.add(t)._unit(), r = z(e1.x * i.x + e1.y * i.y, -1, 1);
            var n, o, s;
            return n = Math.acos(r), Math.min(4, Math.max(-4, Math.tan(n))) / 4 * ab * ((o = e1).x * (s = t).y - o.y * s.x < 0 ? -1 : 1);
        }
        const gb = [
            (e1)=>e1.x < 0,
            (e1)=>e1.x > cr,
            (e1)=>e1.y < 0,
            (e1)=>e1.y > cr
        ];
        function yb(e1, t, i, r) {
            const n = [
                4
            ];
            if (0 === r) return n;
            i._mult(r);
            const o = e1.sub(i), s = t.sub(i), a = [
                e1,
                t,
                o,
                s
            ];
            for(let e1 = 0; e1 < 4; e1++)for (const t of a)if (gb[e1](t)) {
                n.push(e1);
                break;
            }
            return n;
        }
        class xb {
            constructor(e1){
                this.vertexArray = new Ra, this.indexArray = new Wa, this.programConfigurations = new ec(e1.layers, e1.zoom, (e1)=>ob.includes(e1)), this._segments = new xl, this.hiddenByLandmarkVertexArray = new ol, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new xl;
            }
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(e1, t, i, r = !1) {
                const n = e1.length;
                if (n > 2) {
                    let o = Math.max(0, this._segments.get().length - 1);
                    const s = this._segments._prepareSegment(4 * n, this.vertexArray.length, 2 * this._segmentToGroundQuads[o].length);
                    let a;
                    o !== this._segments.get().length - 1 && (o++, this._segmentToGroundQuads[o] = [], this._segmentToRegionTriCounts[o] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const t = e1[0], i = e1[1];
                        a = _b(t.sub(e1[n - 1])._perp()._unit(), i.sub(t)._perp()._unit());
                    }
                    for(let l = 0; l < n; l++){
                        const c = l === n - 1 ? 0 : l + 1, h = e1[l], u = e1[c], d = e1[c === n - 1 ? 0 : c + 1], p = u.sub(h)._perp()._unit(), f = _b(p, d.sub(u)._perp()._unit()), m = a, _ = f;
                        if (Eb(h, u, t) || r && Mb(h, t) && Mb(u, t)) {
                            a = f;
                            continue;
                        }
                        const g = s.vertexLength;
                        ub(this.vertexArray, h, u, 1, 1, m), ub(this.vertexArray, h, u, 1, 0, m), ub(this.vertexArray, h, u, 0, 1, _), ub(this.vertexArray, h, u, 0, 0, _), s.vertexLength += 4;
                        const y = yb(h, u, p, i);
                        for (const e1 of y)this._segmentToGroundQuads[o].push({
                            id: g,
                            region: e1
                        }), this._segmentToRegionTriCounts[o][e1] += 2, s.primitiveLength += 2;
                        a = f;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const e1 = this._segments.get(), t = e1.length;
                for(let e1 = 0; e1 < t; e1++)this._segmentToGroundQuads[e1].sort((e1, t)=>e1.region - t.region);
                for(let i = 0; i < t; i++){
                    const t = this._segmentToGroundQuads[i], r = e1[i], n = this._segmentToRegionTriCounts[i];
                    n.reduce((e1, t)=>e1 + t, 0);
                    let o = 0;
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t = n[e1];
                        if (0 !== t) {
                            let i = this.regionSegments[e1];
                            i || (i = this.regionSegments[e1] = new xl);
                            const n = {
                                vertexOffset: r.vertexOffset,
                                primitiveOffset: r.primitiveOffset + o,
                                vertexLength: r.vertexLength,
                                primitiveLength: t
                            };
                            i.get().push(n);
                        }
                        o += t;
                    }
                    for(let e1 = 0; e1 < t.length; e1++){
                        const i = t[e1].id;
                        this.indexArray.emplaceBack(i, i + 1, i + 3), this.indexArray.emplaceBack(i, i + 3, i + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(e1, t, i, r, n, o) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, e1, t, i, r, n, o);
            }
            upload(e1) {
                this.hasData() && (this.vertexBuffer = e1.createVertexBuffer(this.vertexArray, $f.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray));
            }
            uploadPaintProperties(e1) {
                this.hasData() && this.programConfigurations.upload(e1);
            }
            update(e1, t, i, r, n, o) {
                this.hasData() && this.programConfigurations.updatePaintArrays(e1, t, i, r, n, o);
            }
            updateHiddenByLandmark(e1) {
                if (!this.hasData()) return;
                const t = e1.groundVertexCount + e1.groundVertexArrayOffset;
                if (0 === e1.groundVertexCount) return;
                const i = e1.flags & cb ? 1 : 0;
                for(let r = e1.groundVertexArrayOffset; r < t; ++r)this.hiddenByLandmarkVertexArray.emplace(r, i);
                this._needsHiddenByLandmarkUpdate = !0;
            }
            uploadHiddenByLandmark(e1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = e1.createVertexBuffer(this.hiddenByLandmarkVertexArray, Hf.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t = this.regionSegments[e1];
                        t && t.destroy();
                    }
                }
            }
        }
        class vb {
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = e1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new Wa, this.footprintVertices = new za, this.footprintSegments = [], this.layoutVertexArray = new Da, this.centroidVertexArray = new _l, this.indexArray = new Wa, this.programConfigurations = new ec(e1.layers, e1.zoom, (e1)=>nb.includes(e1)), this.segments = new xl, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.groundEffect = new xb(e1), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
            }
            populate(e1, t, i, r) {
                this.features = [], this.hasPattern = Uf("fill-extrusion", this.layers, t), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.tileToMeter = ap(i), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter;
                for (const { feature: n, id: o, index: s, sourceLayerIndex: a } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, l = gp(n, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), l, i)) continue;
                    const c = {
                        id: o,
                        sourceLayerIndex: a,
                        index: s,
                        geometry: e1 ? l.geometry : _p(n, i, r),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    }, h = this.layoutVertexArray.length;
                    this.hasPattern ? this.features.push(Vf("fill-extrusion", this.layers, c, this.zoom, t)) : this.addFeature(c, c.geometry, s, i, {}, t.availableImages, r, t.brightness), t.featureIndex.insert(n, c.geometry, s, a, this.index, h);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(e1, t, i, r, n, o) {
                for (const e1 of this.features){
                    const { geometry: s } = e1;
                    this.addFeature(e1, s, e1.index, t, i, r, n, o);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                if (o && !this.stateDependentLayers.length) return;
                const s = o ? this.stateDependentLayers : this.layers;
                this.programConfigurations.updatePaintArrays(e1, t, s, i, r, n), this.groundEffect.update(e1, t, s, i, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Yf), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = e1.createVertexBuffer(this.layoutVertexExtArray, Xf.members, !0)), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            uploadCentroid(e1) {
                this.groundEffect.uploadHiddenByLandmark(e1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = e1.createVertexBuffer(this.centroidVertexArray, Wf.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(e1, t, i, r, n, o, s, a) {
                const l = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(e1, {}) / this.tileToMeter, c = [
                    new y(0, 0),
                    new y(cr, cr)
                ], h = s.projection, u = "globe" === h.name, d = "Polygon" === rb[e1.type], p = new mb;
                p.centroidDataIndex = this.centroidData.length;
                const f = new fb, m = this.layers[0].paint.get("fill-extrusion-base").evaluate(e1, {}, r) <= 0, _ = this.layers[0].paint.get("fill-extrusion-height").evaluate(e1, {}, r);
                f.height = _, f.vertexArrayOffset = this.layoutVertexArray.length, f.groundVertexArrayOffset = this.groundEffect.vertexArray.length, u && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Fa);
                const g = Ff(t, 500);
                for(let e1 = g.length - 1; e1 >= 0; e1--){
                    const t = g[e1];
                    (0 === t.length || (x = t[0]).every((e1)=>e1.x <= 0) || x.every((e1)=>e1.x >= cr) || x.every((e1)=>e1.y <= 0) || x.every((e1)=>e1.y >= cr)) && g.splice(e1, 1);
                }
                var x;
                let v;
                if (u) v = Cb(g, c, r);
                else {
                    v = [];
                    for (const e1 of g)v.push({
                        polygon: e1,
                        bounds: c
                    });
                }
                const b = d ? this.edgeRadius : 0, w = b > 0 && this.zoom < 17, T = (e1, t)=>{
                    if (0 === e1.length) return !1;
                    const i = e1[e1.length - 1];
                    return t.x === i.x && t.y === i.y;
                };
                for (const { polygon: e1, bounds: t } of v){
                    let i = 0, n = 0;
                    for (const t of e1)d && !t[0].equals(t[t.length - 1]) && t.push(t[0]), n += d ? t.length - 1 : t.length;
                    const o = this.segments.prepareSegment((d ? 5 : 4) * n, this.layoutVertexArray, this.indexArray);
                    f.footprintSegIdx < 0 && (f.footprintSegIdx = this.footprintSegments.length), f.polygonSegIdx < 0 && (f.polygonSegIdx = this.polygonSegments.length);
                    const s = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, a = new pb;
                    if (a.vertexOffset = this.footprintVertices.length, a.indexOffset = 3 * this.footprintIndices.length, a.ringIndices = [], d) {
                        const n = [], s = [];
                        i = o.vertexLength;
                        for(let i = 0; i < e1.length; i++){
                            const c = e1[i];
                            c.length && 0 !== i && s.push(n.length / 2);
                            const d = [];
                            let p, f;
                            p = c[1].sub(c[0])._perp()._unit(), a.ringIndices.push(c.length - 1);
                            for(let e1 = 1; e1 < c.length; e1++){
                                const t = c[e1], i = c[e1 === c.length - 1 ? 1 : e1 + 1], s = t.clone();
                                if (b) {
                                    f = i.sub(t)._perp()._unit();
                                    const e1 = p.add(f)._unit(), r = b * Math.min(4, 1 / (p.x * e1.x + p.y * e1.y));
                                    s.x += r * e1.x, s.y += r * e1.y, s.x = Math.round(s.x), s.y = Math.round(s.y), p = f;
                                }
                                !m || 0 !== b && !w || T(d, s) || d.push(s), hb(this.layoutVertexArray, s.x, s.y, 0, 0, 1, 1, 0), o.vertexLength++, this.footprintVertices.emplaceBack(t.x, t.y), n.push(t.x, t.y), u && db(this.layoutVertexExtArray, h.projectTilePoint(s.x, s.y, r), h.upVector(r, s.x, s.y));
                            }
                            m && (0 === b || w) && (0 !== d.length && T(d, d[0]) && d.pop(), this.groundEffect.addData(d, t, l));
                        }
                        const c = Bf(n, s);
                        for(let e1 = 0; e1 < c.length; e1 += 3)this.footprintIndices.emplaceBack(a.vertexOffset + c[e1 + 0], a.vertexOffset + c[e1 + 1], a.vertexOffset + c[e1 + 2]), this.indexArray.emplaceBack(i + c[e1], i + c[e1 + 2], i + c[e1 + 1]), o.primitiveLength++;
                        a.indexCount += c.length, a.vertexCount += this.footprintVertices.length - a.vertexOffset;
                    }
                    for(let n = 0; n < e1.length; n++){
                        const s = e1[n];
                        p.startRing(f, s[0]);
                        let a = s.length > 4 && Ab(s[s.length - 2], s[0], s[1]), c = b ? wb(s[s.length - 2], s[0], s[1], b) : 0;
                        const _ = [];
                        let g, y, x;
                        y = s[1].sub(s[0])._perp()._unit();
                        let v = !0;
                        for(let e1 = 1, n = 0; e1 < s.length; e1++){
                            let l = s[e1 - 1], d = s[e1];
                            const w = s[e1 === s.length - 1 ? 1 : e1 + 1];
                            if (p.appendEdge(f, d, l), Eb(d, l, t)) {
                                b && (y = w.sub(d)._perp()._unit(), v = !v);
                                continue;
                            }
                            const E = d.sub(l)._perp(), M = E.x / (Math.abs(E.x) + Math.abs(E.y)), A = E.y > 0 ? 1 : 0, S = l.dist(d);
                            if (n + S > 32768 && (n = 0), b) {
                                x = w.sub(d)._perp()._unit();
                                let e1 = Tb(l, d, w, bb(y, x), b);
                                isNaN(e1) && (e1 = 0);
                                const t = d.sub(l)._unit();
                                l = l.add(t.mult(c))._round(), d = d.add(t.mult(-e1))._round(), c = e1, y = x, m && this.zoom >= 17 && (T(_, l) || _.push(l), T(_, d) || _.push(d));
                            }
                            const I = o.vertexLength, C = s.length > 4 && Ab(l, d, w);
                            let z = Sb(n, a, v);
                            if (hb(this.layoutVertexArray, l.x, l.y, M, A, 0, 0, z), hb(this.layoutVertexArray, l.x, l.y, M, A, 0, 1, z), n += S, z = Sb(n, C, !v), a = C, hb(this.layoutVertexArray, d.x, d.y, M, A, 0, 0, z), hb(this.layoutVertexArray, d.x, d.y, M, A, 0, 1, z), o.vertexLength += 4, this.indexArray.emplaceBack(I + 0, I + 1, I + 2), this.indexArray.emplaceBack(I + 1, I + 3, I + 2), o.primitiveLength += 2, b) {
                                const r = i + (1 === e1 ? s.length - 2 : e1 - 2), n = 1 === e1 ? i : r + 1;
                                if (this.indexArray.emplaceBack(I + 1, r, I + 3), this.indexArray.emplaceBack(r, n, I + 3), o.primitiveLength += 2, void 0 === g && (g = I), !Eb(w, s[e1], t)) {
                                    const t = e1 === s.length - 1 ? g : o.vertexLength;
                                    this.indexArray.emplaceBack(I + 2, I + 3, t), this.indexArray.emplaceBack(I + 3, t + 1, t), this.indexArray.emplaceBack(I + 3, n, t + 1), o.primitiveLength += 3;
                                }
                                v = !v;
                            }
                            if (u) {
                                const e1 = this.layoutVertexExtArray, t = h.projectTilePoint(l.x, l.y, r), i = h.projectTilePoint(d.x, d.y, r), n = h.upVector(r, l.x, l.y), o = h.upVector(r, d.x, d.y);
                                db(e1, t, n), db(e1, t, n), db(e1, i, o), db(e1, i, o);
                            }
                        }
                        d && (i += s.length - 1), m && b && this.zoom >= 17 && (0 !== _.length && T(_, _[0]) && _.pop(), this.groundEffect.addData(_, t, l, b > 0));
                    }
                    this.footprintSegments.push(a), s.triangleCount = this.indexArray.length - s.triangleArrayOffset, this.polygonSegments.push(s), ++f.footprintSegLen, ++f.polygonSegLen;
                }
                if (f.vertexCount = this.layoutVertexArray.length - f.vertexArrayOffset, f.groundVertexCount = this.groundEffect.vertexArray.length - f.groundVertexArrayOffset, 0 !== f.vertexCount) {
                    if (f.centroidXY = p.borders ? lb : this.encodeCentroid(p, f), this.centroidData.push(f), p.borders) {
                        this.featuresOnBorder.push(p);
                        const e1 = this.featuresOnBorder.length - 1;
                        for(let t = 0; t < p.borders.length; t++)p.borders[t][0] !== Number.MAX_VALUE && this.borderFeatureIndices[t].push(e1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, n, o, r, a), this.groundEffect.addPaintPropertiesData(e1, i, n, o, r, a), this.maxHeight = Math.max(this.maxHeight, _);
                }
            }
            sortBorders() {
                for(let e1 = 0; e1 < this.borderFeatureIndices.length; e1++)this.borderFeatureIndices[e1].sort((t, i)=>this.featuresOnBorder[t].borders[e1][0] - this.featuresOnBorder[i].borders[e1][0]);
            }
            splitToSubtiles() {
                const e1 = [];
                for(let t = 0; t < this.centroidData.length; t++){
                    const i = this.centroidData[t], r = +(i.min.y + i.max.y > cr), n = 2 * r + (+(i.min.x + i.max.x > cr) ^ r);
                    for(let r = 0; r < i.polygonSegLen; r++){
                        const o = i.polygonSegIdx + r;
                        e1.push({
                            centroidIdx: t,
                            subtile: n,
                            polygonSegmentIdx: o,
                            triangleSegmentIdx: this.polygonSegments[o].triangleSegIdx
                        });
                    }
                }
                const t = new Wa;
                e1.sort((e1, t)=>e1.triangleSegmentIdx === t.triangleSegmentIdx ? e1.subtile - t.subtile : e1.triangleSegmentIdx - t.triangleSegmentIdx);
                let i = 0, r = 0, n = 0;
                for (const t of e1){
                    if (t.triangleSegmentIdx !== i) break;
                    n++;
                }
                const o = e1.length;
                for(; r !== e1.length;){
                    i = e1[r].triangleSegmentIdx;
                    let s = 0, a = r, l = r;
                    for(let t = a; t < n && e1[t].subtile === s; t++)l++;
                    for(; a !== n;){
                        const r = e1[a];
                        s = r.subtile;
                        const o = this.centroidData[r.centroidIdx].min.clone(), c = this.centroidData[r.centroidIdx].max.clone(), h = {
                            vertexOffset: this.segments.segments[i].vertexOffset,
                            primitiveOffset: t.length,
                            vertexLength: this.segments.segments[i].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let i = a; i < l; i++){
                            const r = e1[i], n = this.polygonSegments[r.polygonSegmentIdx], s = this.centroidData[r.centroidIdx].min, a = this.centroidData[r.centroidIdx].max, l = this.indexArray.uint16;
                            for(let e1 = n.triangleArrayOffset; e1 < n.triangleArrayOffset + n.triangleCount; e1++)t.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
                            h.primitiveLength += n.triangleCount, o.x = Math.min(o.x, s.x), o.y = Math.min(o.y, s.y), c.x = Math.max(c.x, a.x), c.y = Math.max(c.y, a.y);
                        }
                        h.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: h,
                            min: o,
                            max: c
                        }), a = l;
                        for(let t = a; t < n && e1[t].subtile === e1[a].subtile; t++)l++;
                    }
                    r = n;
                    for(let t = r; t < o && e1[t].triangleSegmentIdx === e1[r].triangleSegmentIdx; t++)n++;
                }
                t._trim(), this.indexArray = t;
            }
            getVisibleSegments(e1, t, i) {
                let r = 0, n = 0;
                const o = 1 << e1.canonical.z;
                if (t) {
                    const i = t.getMinMaxForTile(e1);
                    i && (r = i.min, n = i.max);
                }
                n += this.maxHeight;
                const s = e1.toUnwrapped();
                let a;
                const l = [
                    s.canonical.x / o + s.wrap,
                    s.canonical.y / o
                ], c = [
                    (s.canonical.x + 1) / o + s.wrap,
                    (s.canonical.y + 1) / o
                ], h = new xl, u = (e1, t, i)=>[
                        e1[0] * (1 - i[0]) + t[0] * i[0],
                        e1[1] * (1 - i[1]) + t[1] * i[1]
                    ], d = [], p = [];
                for (const e1 of this.triangleSubSegments){
                    d[0] = e1.min.x / cr, d[1] = e1.min.y / cr, p[0] = e1.max.x / cr, p[1] = e1.max.y / cr;
                    const t = u(l, c, d), o = u(l, c, p);
                    if (0 === new ed([
                        t[0],
                        t[1],
                        r
                    ], [
                        o[0],
                        o[1],
                        n
                    ]).intersectsPrecise(i)) {
                        a && (h.segments.push(a), a = void 0);
                        continue;
                    }
                    const s = e1.segment;
                    a && a.vertexOffset !== s.vertexOffset && (h.segments.push(a), a = void 0), a ? (a.vertexLength += s.vertexLength, a.primitiveLength += s.primitiveLength) : a = {
                        vertexOffset: s.vertexOffset,
                        primitiveLength: s.primitiveLength,
                        vertexLength: s.vertexLength,
                        primitiveOffset: s.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return a && h.segments.push(a), h;
            }
            encodeCentroid(e1, t) {
                const i = e1.centroid(), r = t.span(), n = Math.min(7, Math.round(r.x * this.tileToMeter / 10)), o = Math.min(7, Math.round(r.y * this.tileToMeter / 10));
                return new y(z(i.x, 1, cr - 1) << 3 | n, z(i.y, 1, cr - 1) << 3 | o);
            }
            showCentroid(e1) {
                const t = this.centroidData[e1.centroidDataIndex];
                t.flags &= cb, t.centroidXY.x = 0, t.centroidXY.y = 0, this.writeCentroidToBuffer(t);
            }
            writeCentroidToBuffer(e1) {
                this.groundEffect.updateHiddenByLandmark(e1);
                const t = e1.vertexArrayOffset, i = e1.vertexCount + e1.vertexArrayOffset, r = e1.flags & cb ? lb : e1.centroidXY, n = this.centroidVertexArray.geta_centroid_pos0(t);
                if (this.centroidVertexArray.geta_centroid_pos1(t) !== r.y || n !== r.x) {
                    for(let e1 = t; e1 < i; ++e1)this.centroidVertexArray.emplace(e1, r.x, r.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
            }
            updateReplacement(e1, t) {
                if (t.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t.updateTime;
                const i = t.getReplacementRegionsForTile(e1.toUnwrapped());
                if (function(e1, t) {
                    if (e1.length !== t.length) return !1;
                    for(let i = 0; i < e1.length; i++)if (e1[i].sourceId !== t[i].sourceId || !Kv(e1[i], t[i])) return !1;
                    return !0;
                }(this.activeReplacements, i)) return;
                if (this.activeReplacements = i, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const e1 of this.centroidData)e1.flags &= 2147483647;
                const r = [];
                for (const t of this.activeReplacements){
                    const i = Math.pow(2, t.footprintTileId.canonical.z - e1.canonical.z);
                    for (const n of this.centroidData)if (!(n.flags & cb || t.min.x > n.max.x || n.min.x > t.max.x || t.min.y > n.max.y || n.min.y > t.max.y)) for(let o = 0; o < n.footprintSegLen; o++){
                        const s = this.footprintSegments[n.footprintSegIdx + o];
                        if (r.length = 0, zb(this.footprintVertices, s.vertexOffset, s.vertexCount, t.footprintTileId.canonical, e1.canonical, r), tb(t.footprint, r, this.footprintIndices.uint16, s.indexOffset, s.indexCount, -s.vertexOffset, -i)) {
                            n.flags |= cb;
                            break;
                        }
                    }
                }
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(e1, t, i) {
                let r = !1;
                for(let n = 0; n < i.footprintSegLen; n++){
                    const o = this.footprintSegments[i.footprintSegIdx + n];
                    let s = 0;
                    for (const i of o.ringIndices){
                        for(let n = s, a = i + s - 1; n < i + s; a = n++){
                            const i = this.footprintVertices.int16[2 * (n + o.vertexOffset) + 0], s = this.footprintVertices.int16[2 * (n + o.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (a + o.vertexOffset) + 1];
                            s > t != l > t && e1 < (this.footprintVertices.int16[2 * (a + o.vertexOffset) + 0] - i) * (t - s) / (l - s) + i && (r = !r);
                        }
                        s = i;
                    }
                }
                return r;
            }
            getHeightAtTileCoord(e1, t) {
                let i = Number.NEGATIVE_INFINITY, r = !0;
                const n = 4 * (e1 + cr) * cr + (t + cr);
                if (this.partLookup.hasOwnProperty(n)) {
                    const e1 = this.partLookup[n];
                    return e1 ? {
                        height: e1.height,
                        hidden: !!(e1.flags & cb)
                    } : void 0;
                }
                for (const o of this.centroidData)e1 > o.max.x || o.min.x > e1 || t > o.max.y || o.min.y > t || this.footprintContainsPoint(e1, t, o) && o && o.height > i && (i = o.height, this.partLookup[n] = o, r = !!(o.flags & cb));
                if (i !== Number.NEGATIVE_INFINITY) return {
                    height: i,
                    hidden: r
                };
                this.partLookup[n] = void 0;
            }
        }
        function bb(e1, t) {
            const i = e1.add(t)._unit();
            return e1.x * i.x + e1.y * i.y;
        }
        function wb(e1, t, i, r) {
            const n = t.sub(e1)._perp()._unit(), o = i.sub(t)._perp()._unit();
            return Tb(e1, t, i, bb(n, o), r);
        }
        function Tb(e1, t, i, r, n) {
            const o = Math.sqrt(1 - r * r);
            return Math.min(e1.dist(t) / 3, t.dist(i) / 3, n * o / r);
        }
        function Eb(e1, t, i) {
            return e1.x < i[0].x && t.x < i[0].x || e1.x > i[1].x && t.x > i[1].x || e1.y < i[0].y && t.y < i[0].y || e1.y > i[1].y && t.y > i[1].y;
        }
        function Mb(e1, t) {
            return e1.x < t[0].x || e1.x > t[1].x || e1.y < t[0].y || e1.y > t[1].y;
        }
        function Ab(e1, t, i) {
            if (e1.x < 0 || e1.x >= cr || t.x < 0 || t.x >= cr || i.x < 0 || i.x >= cr) return !1;
            const r = i.sub(t), n = r.perp(), o = e1.sub(t);
            return (r.x * o.x + r.y * o.y) / Math.sqrt((r.x * r.x + r.y * r.y) * (o.x * o.x + o.y * o.y)) > -0.866 && n.x * o.x + n.y * o.y < 0;
        }
        function Sb(e1, t, i) {
            const r = t ? 2 | e1 : -3 & e1;
            return i ? 1 | r : -2 & r;
        }
        function Ib() {
            const e1 = Math.PI / 32, t = Math.tan(e1), i = qd;
            return i * Math.sqrt(1 + 2 * t * t) - i;
        }
        function Cb(e1, t, i) {
            const r = 1 << i.z, n = ep(i.x / r), o = ep((i.x + 1) / r), s = tp(i.y / r), a = tp((i.y + 1) / r);
            return function(e1, t, i, r, n = 0, o) {
                const s = [];
                if (!e1.length || !i || !r) return s;
                const a = (e1, t)=>{
                    for (const i of e1)s.push({
                        polygon: i,
                        bounds: t
                    });
                }, l = Math.ceil(Math.log2(i)), c = Math.ceil(Math.log2(r)), h = l - c, u = [];
                for(let e1 = 0; e1 < Math.abs(h); e1++)u.push(h > 0 ? 0 : 1);
                for(let e1 = 0; e1 < Math.min(l, c); e1++)u.push(0), u.push(1);
                let d = e1;
                if (d = um(d, t[0].y - n, t[1].y + n, 1), d = um(d, t[0].x - n, t[1].x + n, 0), !d.length) return s;
                const p = [];
                for(u.length ? p.push({
                    polygons: d,
                    bounds: t,
                    depth: 0
                }) : a(d, t); p.length;){
                    const e1 = p.pop(), t = e1.depth, i = u[t], r = e1.bounds[0], s = e1.bounds[1], l = 0 === i ? r.x : r.y, c = 0 === i ? s.x : s.y, h = o ? o(i, l, c) : .5 * (l + c), d = um(e1.polygons, l - n, h + n, i), f = um(e1.polygons, h - n, c + n, i);
                    if (d.length) {
                        const e1 = [
                            r,
                            new y(0 === i ? h : s.x, 1 === i ? h : s.y)
                        ];
                        u.length > t + 1 ? p.push({
                            polygons: d,
                            bounds: e1,
                            depth: t + 1
                        }) : a(d, e1);
                    }
                    if (f.length) {
                        const e1 = [
                            new y(0 === i ? h : r.x, 1 === i ? h : r.y),
                            s
                        ];
                        u.length > t + 1 ? p.push({
                            polygons: f,
                            bounds: e1,
                            depth: t + 1
                        }) : a(f, e1);
                    }
                }
                return s;
            }(e1, t, Math.ceil((o - n) / 11.25), Math.ceil((s - a) / 11.25), 1, (e1, t, n)=>{
                if (0 === e1) return .5 * (t + n);
                {
                    const e1 = tp((i.y + t / cr) / r);
                    return (Jd(.5 * (tp((i.y + n / cr) / r) + e1)) * r - i.y) * cr;
                }
            });
        }
        function zb(e1, t, i, r, n, o) {
            const s = Math.pow(2, r.z - n.z);
            for(let a = 0; a < i; a++){
                let i = e1.int16[2 * (a + t) + 0], l = e1.int16[2 * (a + t) + 1];
                i = (i + n.x * cr) * s - r.x * cr, l = (l + n.y * cr) * s - r.y * cr, o.push(new y(i, l));
            }
        }
        Rs(vb, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), Rs(fb, "PartData"), Rs(pb, "FootprintSegment"), Rs(mb, "BorderCentroidData"), Rs(xb, "GroundEffect");
        const Pb = new ga({
            visibility: new fa(Pt["layout_fill-extrusion"].visibility),
            "fill-extrusion-edge-radius": new fa(Pt["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
        });
        var Db = {
            paint: new ga({
                "fill-extrusion-opacity": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                "fill-extrusion-color": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-color"]),
                "fill-extrusion-translate": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                "fill-extrusion-translate-anchor": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                "fill-extrusion-pattern": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                "fill-extrusion-height": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-height"]),
                "fill-extrusion-base": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-base"]),
                "fill-extrusion-vertical-gradient": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                "fill-extrusion-ambient-occlusion-intensity": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                "fill-extrusion-ambient-occlusion-radius": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                "fill-extrusion-ambient-occlusion-wall-radius": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                "fill-extrusion-ambient-occlusion-ground-radius": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                "fill-extrusion-ambient-occlusion-ground-attenuation": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                "fill-extrusion-flood-light-color": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                "fill-extrusion-flood-light-intensity": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                "fill-extrusion-flood-light-wall-radius": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                "fill-extrusion-flood-light-ground-radius": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                "fill-extrusion-flood-light-ground-attenuation": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                "fill-extrusion-vertical-scale": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                "fill-extrusion-rounded-roof": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                "fill-extrusion-cutoff-fade-range": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                "fill-extrusion-emissive-strength": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-emissive-strength"])
            }),
            layout: Pb
        };
        class Rb extends y {
            constructor(e1, t, i){
                super(e1, t), this.z = i;
            }
        }
        function Lb(e1, t) {
            return e1.x * t.x + e1.y * t.y;
        }
        function kb(e1, t) {
            if (1 === e1.length) {
                let i = 0;
                const r = t[i++];
                let n;
                for(; !n || r.equals(n);)if (n = t[i++], !n) return 1 / 0;
                for(; i < t.length; i++){
                    const o = t[i], s = e1[0], a = n.sub(r), l = o.sub(r), c = s.sub(r), h = Lb(a, a), u = Lb(a, l), d = Lb(l, l), p = Lb(c, a), f = Lb(c, l), m = h * d - u * u, _ = (d * p - u * f) / m, g = (h * f - u * p) / m, y = r.z * (1 - _ - g) + n.z * _ + o.z * g;
                    if (isFinite(y)) return y;
                }
                return 1 / 0;
            }
            {
                let e1 = 1 / 0;
                for (const i of t)e1 = Math.min(e1, i.z);
                return e1;
            }
        }
        function Ob(e1, t, i, r, n, o, s, a) {
            const l = s * n.getElevationAt(e1, t, !0, !0), c = 0 !== o[0], h = c ? 0 === o[1] ? s * (o[0] / 7 - 450) : s * function(e1, t, i) {
                const r = Math.floor(t[0] / 8), n = Math.floor(t[1] / 8), o = 10 * (t[0] - 8 * r), s = 10 * (t[1] - 8 * n), a = e1.getElevationAt(r, n, !0, !0), l = e1.getMeterToDEM(i), c = Math.floor(.5 * (o * l - 1)), h = Math.floor(.5 * (s * l - 1)), u = e1.tileCoordToPixel(r, n), d = 2 * c + 1, p = 2 * h + 1, f = function(e1, t, i, r, n) {
                    return [
                        e1.getElevationAtPixel(t, i, !0),
                        e1.getElevationAtPixel(t + n, i, !0),
                        e1.getElevationAtPixel(t, i + n, !0),
                        e1.getElevationAtPixel(t + r, i + n, !0)
                    ];
                }(e1, u.x - c, u.y - h, d, p), m = Math.abs(f[0] - f[1]), _ = Math.abs(f[2] - f[3]), g = Math.abs(f[0] - f[2]) + Math.abs(f[1] - f[3]), y = Math.min(.25, .5 * l * (m + _) / d), x = Math.min(.25, .5 * l * g / p);
                return a + Math.max(y * o, x * s);
            }(n, o, a) : l;
            return {
                base: l + (0 === i) ? -1 : i,
                top: c ? Math.max(h + r, l + i + 2) : l + r
            };
        }
        const Bb = new ga({
            "line-cap": new ma(Pt.layout_line["line-cap"]),
            "line-join": new ma(Pt.layout_line["line-join"]),
            "line-miter-limit": new fa(Pt.layout_line["line-miter-limit"]),
            "line-round-limit": new fa(Pt.layout_line["line-round-limit"]),
            "line-sort-key": new ma(Pt.layout_line["line-sort-key"]),
            visibility: new fa(Pt.layout_line.visibility)
        });
        var Fb = {
            paint: new ga({
                "line-opacity": new ma(Pt.paint_line["line-opacity"]),
                "line-color": new ma(Pt.paint_line["line-color"]),
                "line-translate": new fa(Pt.paint_line["line-translate"]),
                "line-translate-anchor": new fa(Pt.paint_line["line-translate-anchor"]),
                "line-width": new ma(Pt.paint_line["line-width"]),
                "line-gap-width": new ma(Pt.paint_line["line-gap-width"]),
                "line-offset": new ma(Pt.paint_line["line-offset"]),
                "line-blur": new ma(Pt.paint_line["line-blur"]),
                "line-dasharray": new ma(Pt.paint_line["line-dasharray"]),
                "line-pattern": new ma(Pt.paint_line["line-pattern"]),
                "line-gradient": new _a(Pt.paint_line["line-gradient"]),
                "line-trim-offset": new fa(Pt.paint_line["line-trim-offset"]),
                "line-emissive-strength": new fa(Pt.paint_line["line-emissive-strength"]),
                "line-border-width": new ma(Pt.paint_line["line-border-width"]),
                "line-border-color": new ma(Pt.paint_line["line-border-color"])
            }),
            layout: Bb
        };
        const Nb = (e1, t, i, r, n, o, s)=>{
            const a = e1.transform, l = a.calculatePixelsToTileUnitsMatrix(t);
            return {
                u_matrix: jb(e1, t, i, r),
                u_pixels_to_tile_units: l,
                u_device_pixel_ratio: o,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: n,
                u_texsize: qb(i) && t.lineAtlasTexture ? t.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: Vb(t, e1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: s,
                u_emissive_strength: i.paint.get("line-emissive-strength")
            };
        }, Ub = (e1, t, i, r, n)=>{
            const o = e1.transform;
            return {
                u_matrix: jb(e1, t, i, r),
                u_texsize: t.imageAtlasTexture ? t.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: o.calculatePixelsToTileUnitsMatrix(t),
                u_device_pixel_ratio: n,
                u_image: 0,
                u_tile_units_to_pixels: Vb(t, o),
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0
            };
        };
        function Vb(e1, t) {
            return 1 / rv(e1, 1, t.tileZoom);
        }
        function jb(e1, t, i, r) {
            return e1.translatePosMatrix(r || t.tileID.projMatrix, t, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        const Gb = (e1)=>{
            const t = [];
            qb(e1) && t.push("RENDER_LINE_DASH"), e1.paint.get("line-gradient") && t.push("RENDER_LINE_GRADIENT");
            const i = e1.paint.get("line-trim-offset");
            return 0 === i[0] && 0 === i[1] || t.push("RENDER_LINE_TRIM_OFFSET"), 0 !== e1.paint.get("line-border-width").constantOr(1) && t.push("RENDER_LINE_BORDER"), t;
        };
        function qb(e1) {
            const t = e1.paint.get("line-dasharray").value;
            return t.value || "constant" !== t.kind;
        }
        const Zb = new class extends ma {
            possiblyEvaluate(e1, t) {
                return t = new oa(Math.floor(t.zoom), {
                    now: t.now,
                    fadeDuration: t.fadeDuration,
                    transition: t.transition
                }), super.possiblyEvaluate(e1, t);
            }
            evaluate(e1, t, i, r) {
                return t = k({}, t, {
                    zoom: Math.floor(t.zoom)
                }), super.evaluate(e1, t, i, r);
            }
        }(Fb.paint.properties["line-width"].specification);
        function $b(e1, t) {
            return t > 0 ? t + 2 * e1 : e1;
        }
        Zb.useIntegerZoom = !0;
        const Wb = new ga({
            visibility: new fa(Pt.layout_background.visibility)
        });
        var Hb = {
            paint: new ga({
                "background-color": new fa(Pt.paint_background["background-color"]),
                "background-pattern": new fa(Pt.paint_background["background-pattern"]),
                "background-opacity": new fa(Pt.paint_background["background-opacity"]),
                "background-emissive-strength": new fa(Pt.paint_background["background-emissive-strength"])
            }),
            layout: Wb
        };
        const Xb = new ga({
            visibility: new fa(Pt.layout_raster.visibility)
        });
        var Yb = {
            paint: new ga({
                "raster-opacity": new fa(Pt.paint_raster["raster-opacity"]),
                "raster-color": new _a(Pt.paint_raster["raster-color"]),
                "raster-color-mix": new fa(Pt.paint_raster["raster-color-mix"]),
                "raster-color-range": new fa(Pt.paint_raster["raster-color-range"]),
                "raster-hue-rotate": new fa(Pt.paint_raster["raster-hue-rotate"]),
                "raster-brightness-min": new fa(Pt.paint_raster["raster-brightness-min"]),
                "raster-brightness-max": new fa(Pt.paint_raster["raster-brightness-max"]),
                "raster-saturation": new fa(Pt.paint_raster["raster-saturation"]),
                "raster-contrast": new fa(Pt.paint_raster["raster-contrast"]),
                "raster-resampling": new fa(Pt.paint_raster["raster-resampling"]),
                "raster-fade-duration": new fa(Pt.paint_raster["raster-fade-duration"]),
                "raster-emissive-strength": new fa(Pt.paint_raster["raster-emissive-strength"]),
                "raster-array-band": new fa(Pt.paint_raster["raster-array-band"]),
                "raster-elevation": new fa(Pt.paint_raster["raster-elevation"])
            }),
            layout: Xb
        };
        function Kb(e1, t, i, r, n, o, s, a) {
            const l = [
                e1,
                i,
                n,
                t,
                r,
                o,
                1,
                1,
                1
            ], c = [
                s,
                a,
                1
            ], h = Eu.adjoint([], l), [u, d, p] = Du.transformMat3(c, c, Eu.transpose(h, h));
            return Eu.multiply(l, [
                u,
                0,
                0,
                0,
                d,
                0,
                0,
                0,
                p
            ], l);
        }
        class Jb extends zt {
            constructor(e1, t, i, r){
                super(), this.id = e1, this.dispatcher = i, this.coordinates = t.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(r), this.options = t, this._dirty = !1;
            }
            load(e1, i) {
                if (this._loaded = i || !1, this.fire(new It("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return e1 && (this.coordinates = e1), this._loaded = !0, void this._finishLoading();
                this._imageRequest = Ie(this.map._requestManager.transformRequest(this.url, ye.Image), (i, r)=>{
                    if (this._imageRequest = null, this._loaded = !0, i) this.fire(new Ct(i));
                    else if (r) {
                        const { HTMLImageElement: i } = t;
                        this.image = r instanceof i ? dt.getImageData(r) : r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, e1 && (this.coordinates = e1), this._finishLoading();
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return e1.url ? (this._imageRequest && e1.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = e1.url, this.load(e1.coordinates, this._loaded), this) : this;
            }
            setTexture(e1) {
                if (!(e1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new Ay(this.map.painter.context, e1.handle), this.width = e1.dimensions[0], this.height = e1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new It("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof Ay || this.texture.destroy();
            }
            setCoordinates(e1) {
                if (this.coordinates = e1, this._boundsArray = void 0, !e1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let t = e1[0][1], i = e1[0][1];
                for (const r of e1)r[1] > i && (i = r[1]), r[1] < t && (t = r[1]);
                const r = (i + t) / 2;
                if (r > rp ? this.onNorthPole = !0 : r < -rp && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const t = e1.map(lp.fromLngLat);
                    this.tileID = function(e1) {
                        let t = 1 / 0, i = 1 / 0, r = -1 / 0, n = -1 / 0;
                        for (const o of e1)t = Math.min(t, o.x), i = Math.min(i, o.y), r = Math.max(r, o.x), n = Math.max(n, o.y);
                        const o = Math.max(r - t, n - i), s = Math.max(0, Math.floor(-Math.log(o) / Math.LN2)), a = Math.pow(2, s);
                        return new ju(s, Math.floor((t + r) / 2 * a), Math.floor((i + n) / 2 * a));
                    }(t), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new It("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                this._boundsArray = void 0;
            }
            _prepareData(e1) {
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture);
                }
                if (this._boundsArray) return;
                const t = Pg(this.tileID, this.map.transform.projection), [i, r, n, o] = this.coordinates.map((e1)=>{
                    const i = t.projection.project(e1[0], e1[1]);
                    return Rg(t, i)._round();
                });
                this.perspectiveTransform = function(e1, t, i, r, n, o, s, a, l, c) {
                    const h = Kb(0, 0, e1, 0, 0, t, e1, t), u = Kb(i, r, n, o, s, a, l, c);
                    return Eu.multiply(u, Eu.adjoint(h, h), u), [
                        u[6] / u[8] * e1 / cr,
                        u[7] / u[8] * t / cr
                    ];
                }(this.width, this.height, i.x, i.y, r.x, r.y, o.x, o.y, n.x, n.y);
                const s = this._boundsArray = new Da;
                s.emplaceBack(i.x, i.y, 0, 0), s.emplaceBack(r.x, r.y, cr, 0), s.emplaceBack(o.x, o.y, 0, cr), s.emplaceBack(n.x, n.y, cr, cr), this.boundsBuffer && this.boundsBuffer.destroy(), this.boundsBuffer = e1.createVertexBuffer(s, Ly.members), this.boundsSegments = xl.simpleSegment(0, 0, 4, 2);
            }
            prepare() {
                const e1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !e1) return;
                const t = this.map.painter.context, i = t.gl;
                !this._dirty || this.texture instanceof Ay || (this.texture ? this.texture.update(this.image) : (this.texture = new My(t, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this._dirty = !1), e1 && this._prepareData(t);
            }
            loadTile(e1, t) {
                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}, t(null)) : (e1.state = "errored", t(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
        }
        class Qb extends Ta {
            constructor(e1){
                super(e1, {}), this.implementation = e1, e1.slot && (this.slot = e1.slot);
            }
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isLayerDraped(e1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(e1) {
                this.implementation.onAdd && this.implementation.onAdd(e1, e1.painter.context.gl);
            }
            onRemove(e1) {
                this.implementation.onRemove && this.implementation.onRemove(e1, e1.painter.context.gl);
            }
        }
        const ew = new ga({
            visibility: new fa(Pt.layout_sky.visibility)
        });
        var tw = {
            paint: new ga({
                "sky-type": new fa(Pt.paint_sky["sky-type"]),
                "sky-atmosphere-sun": new fa(Pt.paint_sky["sky-atmosphere-sun"]),
                "sky-atmosphere-sun-intensity": new fa(Pt.paint_sky["sky-atmosphere-sun-intensity"]),
                "sky-gradient-center": new fa(Pt.paint_sky["sky-gradient-center"]),
                "sky-gradient-radius": new fa(Pt.paint_sky["sky-gradient-radius"]),
                "sky-gradient": new _a(Pt.paint_sky["sky-gradient"]),
                "sky-atmosphere-halo-color": new fa(Pt.paint_sky["sky-atmosphere-halo-color"]),
                "sky-atmosphere-color": new fa(Pt.paint_sky["sky-atmosphere-color"]),
                "sky-opacity": new fa(Pt.paint_sky["sky-opacity"])
            }),
            layout: ew
        };
        function iw(e1, t, i) {
            const r = [
                0,
                0,
                1
            ], n = Iu.identity([]);
            return Iu.rotateY(n, n, i ? -w(e1) + Math.PI : w(e1)), Iu.rotateX(n, n, -w(t)), Du.transformQuat(r, r, n), Du.normalize(r, r);
        }
        var rw = {
            paint: new ga({})
        };
        const nw = {
            circle: class extends Ta {
                constructor(e1, t){
                    super(e1, Up, t);
                }
                createBucket(e1) {
                    return new vp(e1);
                }
                queryRadius(e1) {
                    const t = e1;
                    return kp("circle-radius", this, t) + kp("circle-stroke-width", this, t) + Op(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(e1, t, i, r, n, o, s, a) {
                    const l = Fp(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), c = this.paint.get("circle-radius").evaluate(t, i) + this.paint.get("circle-stroke-width").evaluate(t, i);
                    return qp(e1, r, o, s, a, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, c);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    const i = Gp(this);
                    return {
                        config: new Ql(this, t),
                        defines: i,
                        overrideFog: !1
                    };
                }
            },
            heatmap: class extends Ta {
                createBucket(e1) {
                    return new Xp(e1);
                }
                constructor(e1, t){
                    super(e1, nf, t), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "heatmap-color" === e1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = of({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius(e1) {
                    return kp("heatmap-radius", this, e1);
                }
                queryIntersectsFeature(e1, t, i, r, n, o, s, a) {
                    const l = this.paint.get("heatmap-radius").evaluate(t, i);
                    return qp(e1, r, o, s, a, !0, !0, new y(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    return "heatmap" === e1 ? {
                        config: new Ql(this, t),
                        overrideFog: !1
                    } : {};
                }
            },
            hillshade: class extends Ta {
                constructor(e1, t){
                    super(e1, af, t);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            fill: class extends Ta {
                constructor(e1, t){
                    super(e1, qf, t);
                }
                getProgramIds() {
                    const e1 = this.paint.get("fill-pattern"), t = e1 && e1.constantOr(1), i = [
                        t ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && i.push(t && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), i;
                }
                getDefaultProgramParams(e1, t) {
                    return {
                        config: new Ql(this, t),
                        overrideFog: !1
                    };
                }
                recalculate(e1, t) {
                    super.recalculate(e1, t);
                    const i = this.paint._values["fill-outline-color"];
                    "constant" === i.value.kind && void 0 === i.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(e1) {
                    return new jf(e1);
                }
                queryRadius() {
                    return Op(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(e1, t, i, r, n, o) {
                    return !e1.queryGeometry.isAboveHorizon && Tp(Bp(e1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), r);
                }
                isTileClipped() {
                    return !0;
                }
            },
            "fill-extrusion": class extends Ta {
                constructor(e1, t){
                    super(e1, Db, t), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e1) {
                    return new vb(e1);
                }
                queryRadius() {
                    return Op(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(e1, t, i, r, n, o, s, a, l) {
                    const c = Fp(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), h = this.paint.get("fill-extrusion-height").evaluate(t, i), u = this.paint.get("fill-extrusion-base").evaluate(t, i), d = [
                        0,
                        0
                    ], p = a && o.elevation, f = o.elevation ? o.elevation.exaggeration() : 1, m = e1.tile.getBucket(this);
                    if (p && m instanceof vb) {
                        const e1 = m.centroidVertexArray, t = l + 1;
                        t < e1.length && (d[0] = e1.geta_centroid_pos0(t), d[1] = e1.geta_centroid_pos1(t));
                    }
                    if (0 === d[0] && 1 === d[1]) return !1;
                    "globe" === o.projection.name && (r = Cb([
                        r
                    ], [
                        new y(0, 0),
                        new y(cr, cr)
                    ], e1.tileID.canonical).map((e1)=>e1.polygon).flat());
                    const _ = p ? a : null, [g, x] = function(e1, t, i, r, n, o, s, a, l, c, h) {
                        return "globe" === e1.projection.name ? function(e1, t, i, r, n, o, s, a, l, c, h) {
                            const u = [], d = [], p = e1.projection.upVectorScale(h, e1.center.lat, e1.worldSize).metersToTile, f = [
                                0,
                                0,
                                0,
                                1
                            ], m = [
                                0,
                                0,
                                0,
                                1
                            ], _ = (e1, t, i, r)=>{
                                e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = 1;
                            }, g = Ib();
                            i > 0 && (i += g), r += g;
                            for (const g of t){
                                const t = [], y = [];
                                for (const u of g){
                                    const d = u.x + n.x, g = u.y + n.y, x = e1.projection.projectTilePoint(d, g, h), v = e1.projection.upVector(h, u.x, u.y);
                                    let b = i, w = r;
                                    if (s) {
                                        const e1 = Ob(d, g, i, r, s, a, l, c);
                                        b += e1.base, w += e1.top;
                                    }
                                    0 !== i ? _(f, x.x + v[0] * p * b, x.y + v[1] * p * b, x.z + v[2] * p * b) : _(f, x.x, x.y, x.z), _(m, x.x + v[0] * p * w, x.y + v[1] * p * w, x.z + v[2] * p * w), Du.transformMat4(f, f, o), Du.transformMat4(m, m, o), t.push(new Rb(f[0], f[1], f[2])), y.push(new Rb(m[0], m[1], m[2]));
                                }
                                u.push(t), d.push(y);
                            }
                            return [
                                u,
                                d
                            ];
                        }(e1, t, i, r, n, o, s, a, l, c, h) : s ? function(e1, t, i, r, n, o, s, a, l) {
                            const c = [], h = [], u = [
                                0,
                                0,
                                0,
                                1
                            ];
                            for (const d of e1){
                                const e1 = [], p = [];
                                for (const c of d){
                                    const h = c.x + r.x, d = c.y + r.y, f = Ob(h, d, t, i, o, s, a, l);
                                    u[0] = h, u[1] = d, u[2] = f.base, u[3] = 1, yu.transformMat4(u, u, n), u[3] = Math.max(u[3], 1e-5);
                                    const m = new Rb(u[0] / u[3], u[1] / u[3], u[2] / u[3]);
                                    u[0] = h, u[1] = d, u[2] = f.top, u[3] = 1, yu.transformMat4(u, u, n), u[3] = Math.max(u[3], 1e-5);
                                    const _ = new Rb(u[0] / u[3], u[1] / u[3], u[2] / u[3]);
                                    e1.push(m), p.push(_);
                                }
                                c.push(e1), h.push(p);
                            }
                            return [
                                c,
                                h
                            ];
                        }(t, i, r, n, o, s, a, l, c) : function(e1, t, i, r, n) {
                            const o = [], s = [], a = n[8] * t, l = n[9] * t, c = n[10] * t, h = n[11] * t, u = n[8] * i, d = n[9] * i, p = n[10] * i, f = n[11] * i;
                            for (const t of e1){
                                const e1 = [], i = [];
                                for (const o of t){
                                    const t = o.x + r.x, s = o.y + r.y, m = n[0] * t + n[4] * s + n[12], _ = n[1] * t + n[5] * s + n[13], g = n[2] * t + n[6] * s + n[14], y = n[3] * t + n[7] * s + n[15], x = m + a, v = _ + l, b = g + c, w = Math.max(y + h, 1e-5), T = m + u, E = _ + d, M = g + p, A = Math.max(y + f, 1e-5);
                                    e1.push(new Rb(x / w, v / w, b / w)), i.push(new Rb(T / A, E / A, M / A));
                                }
                                o.push(e1), s.push(i);
                            }
                            return [
                                o,
                                s
                            ];
                        }(t, i, r, n, o);
                    }(o, r, u, h, c, s, _, d, f, o.center.lat, e1.tileID.canonical), v = e1.queryGeometry;
                    return function(e1, t, i) {
                        let r = 1 / 0;
                        Tp(i, t) && (r = kb(i, t[0]));
                        for(let n = 0; n < t.length; n++){
                            const o = t[n], s = e1[n];
                            for(let e1 = 0; e1 < o.length - 1; e1++){
                                const t = o[e1], n = [
                                    t,
                                    o[e1 + 1],
                                    s[e1 + 1],
                                    s[e1],
                                    t
                                ];
                                bp(i, n) && (r = Math.min(r, kb(i, n)));
                            }
                        }
                        return r !== 1 / 0 && r;
                    }(g, x, v.isPointQuery() ? v.screenBounds : v.screenGeometry);
                }
            },
            line: class extends Ta {
                constructor(e1, t){
                    super(e1, Fb, t), this.gradientVersion = 0;
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    if ("line-gradient" === e1) {
                        const e1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = e1._styleExpression && e1._styleExpression.expression instanceof Yr, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                recalculate(e1, t) {
                    super.recalculate(e1, t), this.paint._values["line-floorwidth"] = Zb.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
                }
                createBucket(e1) {
                    return new Ey(e1);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    const i = Gb(this);
                    return {
                        config: new Ql(this, t),
                        defines: i,
                        overrideFog: !1
                    };
                }
                queryRadius(e1) {
                    const t = e1, i = $b(kp("line-width", this, t), kp("line-gap-width", this, t)), r = kp("line-offset", this, t);
                    return i / 2 + Math.abs(r) + Op(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(e1, t, i, r, n, o) {
                    if (e1.queryGeometry.isAboveHorizon) return !1;
                    const s = Bp(e1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), a = e1.pixelToTileUnitsFactor / 2 * $b(this.paint.get("line-width").evaluate(t, i), this.paint.get("line-gap-width").evaluate(t, i)), l = this.paint.get("line-offset").evaluate(t, i);
                    return l && (r = function(e1, t) {
                        const i = [], r = new y(0, 0);
                        for(let n = 0; n < e1.length; n++){
                            const o = e1[n], s = [];
                            for(let e1 = 0; e1 < o.length; e1++){
                                const i = o[e1], n = o[e1 + 1], a = 0 === e1 ? r : i.sub(o[e1 - 1])._unit()._perp(), l = e1 === o.length - 1 ? r : n.sub(i)._unit()._perp(), c = a._add(l)._unit();
                                c._mult(1 / (c.x * l.x + c.y * l.y)), s.push(c._mult(t)._add(i));
                            }
                            i.push(s);
                        }
                        return i;
                    }(r, l * e1.pixelToTileUnitsFactor)), function(e1, t, i) {
                        for(let r = 0; r < t.length; r++){
                            const n = t[r];
                            if (e1.length >= 3) {
                                for(let t = 0; t < n.length; t++)if (zp(e1, n[t])) return !0;
                            }
                            if (Ep(e1, n, i)) return !0;
                        }
                        return !1;
                    }(s, r, a);
                }
                isTileClipped() {
                    return !0;
                }
            },
            symbol: oy,
            background: class extends Ta {
                constructor(e1, t){
                    super(e1, Hb, t);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            raster: class extends Ta {
                constructor(e1, t){
                    super(e1, Yb, t), this._updateColorRamp();
                }
                getProgramIds() {
                    return [
                        "raster"
                    ];
                }
                hasColorMap() {
                    return !!this._transitionablePaint._values["raster-color"].value.value;
                }
                isLayerDraped(e1) {
                    return !(e1 && e1._source instanceof Jb) || !e1._source.onNorthPole && !e1._source.onSouthPole && 0 === this.paint.get("raster-elevation");
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "raster-color" !== e1 && "raster-color-range" !== e1 || this._updateColorRamp();
                }
                _updateColorRamp() {
                    if (!this.hasColorMap()) return;
                    const e1 = this._transitionablePaint._values["raster-color"].value.expression, [t, i] = this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                        zoom: 0
                    });
                    this.colorRamp = of({
                        expression: e1,
                        evaluationKey: "rasterValue",
                        image: this.colorRamp,
                        clips: [
                            {
                                start: t,
                                end: i
                            }
                        ],
                        resolution: 256
                    }), this.colorRampTexture = null;
                }
            },
            sky: class extends Ta {
                constructor(e1, t){
                    super(e1, tw, t), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "sky-gradient" === e1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== e1 && "sky-atmosphere-halo-color" !== e1 && "sky-atmosphere-color" !== e1 && "sky-atmosphere-sun-intensity" !== e1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = of({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(e1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const t = e1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== t.azimuthal || this._lightPosition.polar !== t.polar;
                    }
                    return !1;
                }
                getCenter(e1, t) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const i = this.paint.get("sky-atmosphere-sun"), r = !i, n = e1.style.light, o = n.properties.get("position");
                        return r && "viewport" === n.properties.get("anchor") && H("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), r ? iw(o.azimuthal, 90 - o.polar, t) : iw(i[0], 90 - i[1], t);
                    }
                    const i = this.paint.get("sky-gradient-center");
                    return iw(i[0], 90 - i[1], t);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(e1) {
                    this._skyboxInvalidated = !1, this._lightPosition = e1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const e1 = this.paint.get("sky-type");
                    return "atmosphere" === e1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === e1 ? [
                        "skyboxGradient"
                    ] : null;
                }
            },
            slot: class extends Ta {
                constructor(e1, t){
                    super(e1, rw);
                }
            },
            model: class extends Ta {
                constructor(e1, t){
                    super(e1, Nv, t);
                }
                createBucket(e1) {
                    return new Bv(e1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius() {
                    return 0;
                }
                queryIntersectsFeature() {
                    return !1;
                }
                _handleOverridablePaintPropertyUpdate(e1, t, i) {
                    return !(!this.layout || t.isDataDriven() || i.isDataDriven() || "model-color" !== e1 && "model-color-mix-intensity" !== e1 && "model-rotation" !== e1 && "model-scale" !== e1 && "model-translation" !== e1 && "model-emissive-strength" !== e1);
                }
                _isPropertyZoomDependent(e1) {
                    const t = this._transitionablePaint._values[e1];
                    return null != t && null != t.value && null != t.value.expression && t.value.expression instanceof Ao;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
            }
        };
        function ow(e1, t) {
            return "custom" === e1.type ? new Qb(e1) : new nw[e1.type](e1, t);
        }
        function sw(e1) {
            const { userImage: t } = e1;
            return !!(t && t.render && t.render()) && (e1.data.replace(new Uint8Array(t.data.buffer)), !0);
        }
        class aw extends zt {
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = {}, this.requestors = [], this.patterns = {}, this.atlasImage = {}, this.atlasTexture = {}, this.dirty = !0;
            }
            createScope(e1) {
                this.images[e1] = {}, this.loaded[e1] = !1, this.updatedImages[e1] = {}, this.patterns[e1] = {}, this.callbackDispatchedThisFrame[e1] = {}, this.atlasImage[e1] = new ef({
                    width: 1,
                    height: 1
                });
            }
            isLoaded() {
                for(const e1 in this.loaded)if (!this.loaded[e1]) return !1;
                return !0;
            }
            setLoaded(e1, t) {
                if (this.loaded[t] !== e1 && (this.loaded[t] = e1, e1)) {
                    for (const { ids: e1, callback: i } of this.requestors)this._notify(e1, t, i);
                    this.requestors = [];
                }
            }
            hasImage(e1, t) {
                return !!this.getImage(e1, t);
            }
            getImage(e1, t) {
                return this.images[t][e1];
            }
            addImage(e1, t, i) {
                this._validate(e1, i) && (this.images[t][e1] = i);
            }
            _validate(e1, t) {
                let i = !0;
                return this._validateStretch(t.stretchX, t.data && t.data.width) || (this.fire(new Ct(new Error(`Image "${e1}" has invalid "stretchX" value`))), i = !1), this._validateStretch(t.stretchY, t.data && t.data.height) || (this.fire(new Ct(new Error(`Image "${e1}" has invalid "stretchY" value`))), i = !1), this._validateContent(t.content, t) || (this.fire(new Ct(new Error(`Image "${e1}" has invalid "content" value`))), i = !1), i;
            }
            _validateStretch(e1, t) {
                if (!e1) return !0;
                let i = 0;
                for (const r of e1){
                    if (r[0] < i || r[1] < r[0] || t < r[1]) return !1;
                    i = r[1];
                }
                return !0;
            }
            _validateContent(e1, t) {
                return !(e1 && (4 !== e1.length || e1[0] < 0 || t.data.width < e1[0] || e1[1] < 0 || t.data.height < e1[1] || e1[2] < 0 || t.data.width < e1[2] || e1[3] < 0 || t.data.height < e1[3] || e1[2] < e1[0] || e1[3] < e1[1]));
            }
            updateImage(e1, t, i) {
                i.version = this.images[t][e1].version + 1, this.images[t][e1] = i, this.updatedImages[t][e1] = !0;
            }
            removeImage(e1, t) {
                const i = this.images[t][e1];
                delete this.images[t][e1], delete this.patterns[t][e1], i.userImage && i.userImage.onRemove && i.userImage.onRemove();
            }
            listImages(e1) {
                return Object.keys(this.images[e1]);
            }
            getImages(e1, t, i) {
                let r = !0;
                const n = !!this.loaded[t];
                if (!n) for (const i of e1)this.images[t][i] || (r = !1);
                n || r ? this._notify(e1, t, i) : this.requestors.push({
                    ids: e1,
                    scope: t,
                    callback: i
                });
            }
            getUpdatedImages(e1) {
                return this.updatedImages[e1];
            }
            _notify(e1, t, i) {
                const r = {};
                for (const i of e1){
                    this.images[t][i] || this.fire(new It("styleimagemissing", {
                        id: i
                    }));
                    const e1 = this.images[t][i];
                    e1 ? r[i] = {
                        data: e1.data.clone(),
                        pixelRatio: e1.pixelRatio,
                        sdf: e1.sdf,
                        version: e1.version,
                        stretchX: e1.stretchX,
                        stretchY: e1.stretchY,
                        content: e1.content,
                        hasRenderCallback: Boolean(e1.userImage && e1.userImage.render)
                    } : H(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, r);
            }
            getPixelSize(e1) {
                const { width: t, height: i } = this.atlasImage[e1];
                return {
                    width: t,
                    height: i
                };
            }
            getPattern(e1, t) {
                const i = this.patterns[t][e1], r = this.getImage(e1, t);
                if (!r) return null;
                if (i && i.position.version === r.version) return i.position;
                if (i) i.position.version = r.version;
                else {
                    const i = {
                        w: r.data.width + 2,
                        h: r.data.height + 2,
                        x: 0,
                        y: 0
                    }, n = new Q_(i, r);
                    this.patterns[t][e1] = {
                        bin: i,
                        position: n
                    };
                }
                return this._updatePatternAtlas(t), this.patterns[t][e1].position;
            }
            bind(e1, t) {
                const i = e1.gl;
                let r = this.atlasTexture[t];
                r ? this.dirty && (r.update(this.atlasImage[t]), this.dirty = !1) : (r = new My(e1, this.atlasImage[t], i.RGBA), this.atlasTexture[t] = r), r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(e1) {
                const t = [];
                for(const i in this.patterns[e1])t.push(this.patterns[e1][i].bin);
                const { w: i, h: r } = K_(t), n = this.atlasImage[e1];
                n.resize({
                    width: i || 1,
                    height: r || 1
                });
                for(const t in this.patterns[e1]){
                    const { bin: i } = this.patterns[e1][t], r = i.x + 1, o = i.y + 1, s = this.images[e1][t].data, a = s.width, l = s.height;
                    ef.copy(s, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: r,
                        y: o
                    }, {
                        width: a,
                        height: l
                    }), ef.copy(s, n, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: r,
                        y: o - 1
                    }, {
                        width: a,
                        height: 1
                    }), ef.copy(s, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: r,
                        y: o + l
                    }, {
                        width: a,
                        height: 1
                    }), ef.copy(s, n, {
                        x: a - 1,
                        y: 0
                    }, {
                        x: r - 1,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    }), ef.copy(s, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: r + a,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                for(const e1 in this.images)this.callbackDispatchedThisFrame[e1] = {};
            }
            dispatchRenderCallbacks(e1, t) {
                for (const i of e1){
                    if (this.callbackDispatchedThisFrame[t][i]) continue;
                    this.callbackDispatchedThisFrame[t][i] = !0;
                    const e1 = this.images[t][i];
                    sw(e1) && this.updateImage(i, t, e1);
                }
            }
        }
        const lw = new ga({
            anchor: new fa(Pt.light.anchor),
            position: new class {
                constructor(e1){
                    this.specification = e1;
                }
                possiblyEvaluate(e1, t) {
                    return K(e1.expression.evaluate(t));
                }
                interpolate(e1, t, i) {
                    return {
                        x: Kr(e1.x, t.x, i),
                        y: Kr(e1.y, t.y, i),
                        z: Kr(e1.z, t.z, i),
                        azimuthal: Kr(e1.azimuthal, t.azimuthal, i),
                        polar: Kr(e1.polar, t.polar, i)
                    };
                }
            }(Pt.light.position),
            color: new fa(Pt.light.color),
            intensity: new fa(Pt.light.intensity)
        });
        class cw extends zt {
            constructor(e1, t = "flat"){
                super(), this._transitionable = new la(lw), this.setLight(e1, t), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, t, i = {}) {
                this._validate(gs, e1, i) || (this._transitionable.setTransitionOrValue(e1), this.id = t);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, t, i) {
                return (!i || !1 !== i.validate) && Ss(this, e1.call(ms, k({
                    value: t,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: Pt
                })));
            }
        }
        const hw = new ga({
            source: new fa(Pt.terrain.source),
            exaggeration: new fa(Pt.terrain.exaggeration)
        });
        let uw = class extends zt {
            constructor(e1, t, i, r){
                super(), this.scope = i, this._transitionable = new la(hw, r), this._transitionable.setTransitionOrValue(e1, r), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = t;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t) {
                this._transitionable.setTransitionOrValue(e1, t);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            getExaggeration(e1) {
                return this._transitioning.possiblyEvaluate(new oa(e1)).get("exaggeration");
            }
            isZoomDependent() {
                const e1 = this._transitionable._values.exaggeration;
                return null != e1 && null != e1.value && null != e1.value.expression && e1.value.expression instanceof Ao;
            }
        };
        const dw = 45, pw = 65, fw = .05;
        function mw(e1, t, i, r) {
            const n = P(dw, pw, i), [o, s] = _w(e1, r);
            let a = 1 - Math.min(1, Math.exp((t - o) / (s - o) * -6));
            return a *= a * a, a = Math.min(1, 1.00747 * a), a * n * e1.alpha;
        }
        function _w(e1, t) {
            const i = .5 / Math.tan(.5 * t);
            return [
                e1.range[0] + i,
                e1.range[1] + i
            ];
        }
        function gw(e1, t, i, r, n) {
            const o = Du.transformMat4([], [
                t,
                i,
                r
            ], n.mercatorFogMatrix);
            return mw(e1, Du.length(o), n.pitch, n._fov);
        }
        function yw(e1, t, i, r, n, o, s) {
            const a = [
                [
                    i,
                    r,
                    0
                ],
                [
                    n,
                    r,
                    0
                ],
                [
                    n,
                    o,
                    0
                ],
                [
                    i,
                    o,
                    0
                ]
            ];
            let l = Number.MAX_VALUE, c = -Number.MAX_VALUE;
            for (const e1 of a){
                const i = Du.transformMat4([], e1, t), r = Du.length(i);
                l = Math.min(l, r), c = Math.max(c, r);
            }
            return [
                mw(e1, l, s.pitch, s._fov),
                mw(e1, c, s.pitch, s._fov)
            ];
        }
        const xw = new ga({
            range: new fa(Pt.fog.range),
            color: new fa(Pt.fog.color),
            "high-color": new fa(Pt.fog["high-color"]),
            "space-color": new fa(Pt.fog["space-color"]),
            "horizon-blend": new fa(Pt.fog["horizon-blend"]),
            "star-intensity": new fa(Pt.fog["star-intensity"]),
            "vertical-range": new fa(Pt.fog["vertical-range"])
        });
        class vw extends zt {
            constructor(e1, t){
                super(), this._transitionable = new la(xw), this.set(e1), this._transitioning = this._transitionable.untransitioned(), this._transform = t;
            }
            get state() {
                const e1 = this._transform, t = "globe" === e1.projection.name, i = Dd(e1.zoom), r = this.properties.get("range"), n = [
                    .5,
                    3
                ];
                return {
                    range: t ? [
                        Kr(n[0], r[0], i),
                        Kr(n[1], r[1], i)
                    ] : r,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t = {}) {
                if (this._validate(vs, e1, t)) return;
                const i = k({}, e1);
                for (const e1 of Object.keys(Pt.fog))void 0 === i[e1] && (i[e1] = Pt.fog[e1].default);
                this._transitionable.setTransitionOrValue(i);
            }
            getOpacity(e1) {
                if (!this._transform.projection.supportsFog) return 0;
                const t = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : P(dw, pw, e1)) * t.a;
            }
            getOpacityAtLatLng(e1, t) {
                return this._transform.projection.supportsFog ? function(e1, t, i) {
                    const r = lp.fromLngLat(t), n = i.elevation ? i.elevation.getAtPointOrZero(r) : 0;
                    return gw(e1, r.x, r.y, n, i);
                }(this.state, e1, t) : 0;
            }
            getOpacityForTile(e1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const t = this._transform.calculateFogTileMatrix(e1.toUnwrapped());
                return yw(this.state, t, 0, 0, cr, cr, this._transform);
            }
            getOpacityForBounds(e1, t, i, r, n) {
                return this._transform.projection.supportsFog ? yw(this.state, e1, t, i, r, n, this._transform) : [
                    1,
                    1
                ];
            }
            getFovAdjustedRange(e1) {
                return this._transform.projection.supportsFog ? _w(this.state, e1) : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(e1) {
                if (!this._transform.projection.supportsFog) return !1;
                const t = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const i of t){
                    const t = e1.points[i];
                    let r;
                    if (t[2] >= 0) r = t;
                    else {
                        const n = e1.points[i - 4];
                        r = Jr(n, t, n[2] / (n[2] - t[2]));
                    }
                    if (gw(this.state, r[0], r[1], 0, this._transform) >= fw) return !0;
                }
                return !1;
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, t, i) {
                return (!i || !1 !== i.validate) && Ss(this, e1.call(ms, k({
                    value: t,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: Pt
                })));
            }
        }
        class bw {
            constructor(e1){
                this._callback = e1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
        }
        class ww {
            constructor(){
                this.tasks = {}, this.taskQueue = [], j([
                    "process"
                ], this), this.invoker = new bw(this.process), this.nextId = 0;
            }
            add(e1, t) {
                const i = this.nextId++, r = function({ type: e1, isSymbolTile: t, zoom: i }) {
                    return i = i || 0, "message" === e1 ? 0 : "maybePrepare" !== e1 || t ? "parseTile" !== e1 || t ? "parseTile" === e1 && t ? 300 - i : "maybePrepare" === e1 && t ? 400 - i : 500 : 200 - i : 100 - i;
                }(t);
                if (0 === r) {
                    Q();
                    e1();
                    return {
                        cancel: ()=>{}
                    };
                }
                return this.tasks[i] = {
                    fn: e1,
                    metadata: t,
                    priority: r,
                    id: i
                }, this.taskQueue.push(i), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[i];
                    }
                };
            }
            process() {
                Q();
                {
                    if (this.taskQueue = this.taskQueue.filter((e1)=>!!this.tasks[e1]), !this.taskQueue.length) return;
                    const e1 = this.pick();
                    if (null === e1) return;
                    const t = this.tasks[e1];
                    if (delete this.tasks[e1], this.taskQueue.length && this.invoker.trigger(), !t) return;
                    t.fn();
                }
            }
            pick() {
                let e1 = null, t = 1 / 0;
                for(let i = 0; i < this.taskQueue.length; i++){
                    const r = this.tasks[this.taskQueue[i]];
                    r.priority < t && (t = r.priority, e1 = i);
                }
                if (null === e1) return null;
                const i = this.taskQueue[e1];
                return this.taskQueue.splice(e1, 1), i;
            }
            remove() {
                this.invoker.remove();
            }
        }
        class Tw {
            constructor(e1, t, i){
                this.target = e1, this.parent = t, this.mapId = i, this.callbacks = {}, this.cancelCallbacks = {}, j([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new ww;
            }
            send(e1, t, i, r, n = !1, o) {
                const s = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                i && (i.metadata = o, this.callbacks[s] = i);
                const a = new Set;
                return this.target.postMessage({
                    id: s,
                    type: e1,
                    hasCallback: !!i,
                    targetMapId: r,
                    mustQueue: n,
                    sourceMapId: this.mapId,
                    data: Os(t, a)
                }, a), {
                    cancel: ()=>{
                        i && delete this.callbacks[s], this.target.postMessage({
                            id: s,
                            type: "<cancel>",
                            targetMapId: r,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(e1) {
                const t = e1.data, i = t.id;
                if (i && (!t.targetMapId || this.mapId === t.targetMapId)) {
                    if ("<cancel>" === t.type) {
                        const e1 = this.cancelCallbacks[i];
                        delete this.cancelCallbacks[i], e1 && e1.cancel();
                    } else if (t.mustQueue || Q()) {
                        const e1 = this.callbacks[i];
                        this.cancelCallbacks[i] = this.scheduler.add(()=>this.processTask(i, t), e1 && e1.metadata || {
                            type: "message"
                        });
                    } else this.processTask(i, t);
                }
            }
            processTask(e1, t) {
                if ("<response>" === t.type) {
                    const i = this.callbacks[e1];
                    delete this.callbacks[e1], i && (t.error ? i(Bs(t.error)) : i(null, Bs(t.data)));
                } else {
                    const i = new Set, r = t.hasCallback ? (t, r)=>{
                        delete this.cancelCallbacks[e1], this.target.postMessage({
                            id: e1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: t ? Os(t) : null,
                            data: Os(r, i)
                        }, i);
                    } : (e1)=>{}, n = Bs(t.data);
                    if (this.parent[t.type]) this.parent[t.type](t.sourceMapId, n, r);
                    else if (this.parent.getWorkerSource) {
                        const e1 = t.type.split(".");
                        this.parent.getWorkerSource(t.sourceMapId, e1[0], n.source, n.scope)[e1[1]](n, r);
                    } else r(new Error(`Could not find function ${t.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }
        class Ew {
            constructor(e1, t){
                this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = F();
                const i = this.workerPool.acquire(this.id);
                for(let e1 = 0; e1 < i.length; e1++){
                    const r = new Ew.Actor(i[e1], t, this.id);
                    r.name = `Worker ${e1}`, this.actors.push(r);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
            broadcast(e1, t, i) {
                R(this.actors, (i, r)=>{
                    i.send(e1, t, r);
                }, i = i || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        Ew.Actor = Tw;
        class Mw extends zt {
            constructor(e1, t, i, r){
                super(), this.scope = i, this._options = e1, this.properties = new pa(t), this._transitionable = new la(t, new Map(r)), this._transitionable.setTransitionOrValue(e1.properties), this._transitioning = this._transitionable.untransitioned();
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options.properties, new Map(e1));
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e1, t) {
                this._options = e1, this._transitionable.setTransitionOrValue(e1.properties, t);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
        }
        const Aw = new ga({
            color: new fa(Pt.properties_light_ambient.color),
            intensity: new fa(Pt.properties_light_ambient.intensity)
        }), Sw = new ga({
            direction: new class {
                constructor(e1){
                    this.specification = e1;
                }
                possiblyEvaluate(e1, t) {
                    return function([e1, t]) {
                        const i = K([
                            1,
                            e1,
                            t
                        ]);
                        return {
                            x: i.x,
                            y: i.y,
                            z: i.z
                        };
                    }(e1.expression.evaluate(t));
                }
                interpolate(e1, t, i) {
                    return {
                        x: Kr(e1.x, t.x, i),
                        y: Kr(e1.y, t.y, i),
                        z: Kr(e1.z, t.z, i)
                    };
                }
            }(Pt.properties_light_directional.direction),
            color: new fa(Pt.properties_light_directional.color),
            intensity: new fa(Pt.properties_light_directional.intensity),
            "cast-shadows": new fa(Pt.properties_light_directional["cast-shadows"]),
            "shadow-intensity": new fa(Pt.properties_light_directional["shadow-intensity"])
        });
        class Iw {
            constructor(e1, t, i, r){
                this.screenBounds = e1, this.cameraPoint = t, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, r);
            }
            static createFromScreenPoints(e1, t) {
                let i, r;
                if (e1 instanceof y || "number" == typeof e1[0]) {
                    const n = y.convert(e1);
                    i = [
                        n
                    ], r = t.isPointAboveHorizon(n);
                } else {
                    const n = y.convert(e1[0]), o = y.convert(e1[1]);
                    i = [
                        n,
                        o
                    ], r = S(n, o).every((e1)=>t.isPointAboveHorizon(e1));
                }
                return new Iw(i, t.getCameraPoint(), r, t);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(e1) {
                return S(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], e1);
            }
            bufferedCameraGeometry(e1) {
                const t = this.screenBounds[0], i = 1 === this.screenBounds.length ? this.screenBounds[0].add(new y(1, 1)) : this.screenBounds[1], r = S(t, i, 0, !1);
                return this.cameraPoint.y > i.y && (this.cameraPoint.x > t.x && this.cameraPoint.x < i.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= i.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= t.x && (r[3] = this.cameraPoint)), function(e1, t) {
                    const i = [];
                    for(let r = 0; r < e1.length; r++){
                        const n = D(r - 1, -1, e1.length - 1), o = D(r + 1, -1, e1.length - 1), s = e1[r], a = e1[o], l = e1[n].sub(s).unit(), c = a.sub(s).unit(), h = c.angleWithSep(l.x, l.y), u = l.add(c).unit().mult(-1 * t / Math.sin(h / 2));
                        i.push(s.add(u));
                    }
                    return i;
                }(r, e1);
            }
            bufferedCameraGeometryGlobe(e1) {
                const t = this.screenBounds[0], i = 1 === this.screenBounds.length ? this.screenBounds[0].add(new y(1, 1)) : this.screenBounds[1], r = S(t, i, e1), n = this.cameraPoint.clone();
                switch(3 * ((n.y > t.y) + (n.y > i.y)) + ((n.x > t.x) + (n.x > i.x))){
                    case 0:
                        r[0] = n, r[4] = n.clone();
                        break;
                    case 1:
                        r.splice(1, 0, n);
                        break;
                    case 2:
                        r[1] = n;
                        break;
                    case 3:
                        r.splice(4, 0, n);
                        break;
                    case 5:
                        r.splice(2, 0, n);
                        break;
                    case 6:
                        r[3] = n;
                        break;
                    case 7:
                        r.splice(3, 0, n);
                        break;
                    case 8:
                        r[2] = n;
                }
                return r;
            }
            containsTile(e1, t, i, r = 0) {
                const n = e1.queryPadding / t._pixelsPerMercatorPixel + 1, o = i ? this._bufferedCameraMercator(n, t) : this._bufferedScreenMercator(n, t);
                let s = e1.tileID.wrap + (o.unwrapped ? r : 0);
                const a = o.polygon.map((t)=>Rg(e1.tileTransform, t, s));
                if (!Pp(a, 0, 0, cr, cr)) return;
                s = e1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const l = this.screenGeometryMercator.polygon.map((t)=>Lg(e1.tileTransform, t, s)), c = l.map((e1)=>new y(e1[0], e1[1])), h = t.getFreeCameraOptions().position || new lp(0, 0, 0), u = Lg(e1.tileTransform, h, s), d = l.map((e1)=>{
                    const t = Du.sub(e1, e1, u);
                    return Du.normalize(t, t), new Wu(u, t);
                }), p = rv(e1, 1, t.zoom) * t._pixelsPerMercatorPixel;
                var f;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: c,
                    tilespaceRays: d,
                    bufferedTilespaceGeometry: a,
                    bufferedTilespaceBounds: (f = A(a), f.min.x = z(f.min.x, 0, cr), f.min.y = z(f.min.y, 0, cr), f.max.x = z(f.max.x, 0, cr), f.max.y = z(f.max.y, 0, cr), f),
                    tile: e1,
                    tileID: e1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e1, t) {
                const i = Pw(e1);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let r;
                    return r = "globe" === t.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e1), t) : {
                        polygon: this.bufferedScreenGeometry(e1).map((e1)=>t.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = r, r;
                }
            }
            _bufferedCameraMercator(e1, t) {
                const i = Pw(e1);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let r;
                    return r = "globe" === t.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e1), t) : {
                        polygon: this.bufferedCameraGeometry(e1).map((e1)=>t.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = r, r;
                }
            }
            _projectAndResample(e1, t) {
                const i = function(e1, t) {
                    const i = Au.multiply([], t.pixelMatrix, t.globeMatrix), r = [
                        0,
                        -rd,
                        0,
                        1
                    ], n = [
                        0,
                        rd,
                        0,
                        1
                    ], o = [
                        0,
                        0,
                        0,
                        1
                    ];
                    yu.transformMat4(r, r, i), yu.transformMat4(n, n, i), yu.transformMat4(o, o, i);
                    const s = new y(r[0] / r[3], r[1] / r[3]), a = new y(n[0] / n[3], n[1] / n[3]), l = zp(e1, s) && r[3] < o[3], c = zp(e1, a) && n[3] < o[3];
                    if (!l && !c) return null;
                    const h = function(e1, t, i) {
                        for(let r = 1; r < e1.length; r++){
                            const n = zw(t.pointCoordinate3D(e1[r - 1]).x), o = zw(t.pointCoordinate3D(e1[r]).x);
                            if (i < 0) {
                                if (n < o) return {
                                    idx: r,
                                    t: -n / (o - 1 - n)
                                };
                            } else if (o < n) return {
                                idx: r,
                                t: (1 - n) / (o + 1 - n)
                            };
                        }
                        return null;
                    }(e1, t, l ? -1 : 1);
                    if (!h) return null;
                    const { idx: u, t: d } = h;
                    let p = u > 1 ? Cw(e1.slice(0, u), t) : [], f = u < e1.length ? Cw(e1.slice(u), t) : [];
                    p = p.map((e1)=>new y(zw(e1.x), e1.y)), f = f.map((e1)=>new y(zw(e1.x), e1.y));
                    const m = [
                        ...p
                    ];
                    0 === m.length && m.push(f[f.length - 1]);
                    const _ = Kr(m[m.length - 1].y, (0 === f.length ? p[0] : f[0]).y, d);
                    let g;
                    return g = l ? [
                        new y(0, _),
                        new y(0, 0),
                        new y(1, 0),
                        new y(1, _)
                    ] : [
                        new y(1, _),
                        new y(1, 1),
                        new y(0, 1),
                        new y(0, _)
                    ], m.push(...g), 0 === f.length ? m.push(p[0]) : m.push(...f), {
                        polygon: m.map((e1)=>new lp(e1.x, e1.y)),
                        unwrapped: !1
                    };
                }(e1, t);
                if (i) return i;
                const r = function(e1, t) {
                    let i = !1, r = -1 / 0, n = 0;
                    for(let t = 0; t < e1.length - 1; t++)e1[t].x > r && (r = e1[t].x, n = t);
                    for(let t = 0; t < e1.length - 1; t++){
                        const r = (n + t) % (e1.length - 1), o = e1[r], s = e1[r + 1];
                        Math.abs(o.x - s.x) > .5 && (o.x < s.x ? (o.x += 1, 0 === r && (e1[e1.length - 1].x += 1)) : (s.x += 1, r + 1 === e1.length - 1 && (e1[0].x += 1)), i = !0);
                    }
                    const o = Kd(t.center.lng);
                    return i && o < Math.abs(o - 1) && e1.forEach((e1)=>{
                        e1.x -= 1;
                    }), {
                        polygon: e1,
                        unwrapped: i
                    };
                }(Cw(e1, t).map((e1)=>new y(zw(e1.x), e1.y)), t);
                return {
                    polygon: r.polygon.map((e1)=>new lp(e1.x, e1.y)),
                    unwrapped: r.unwrapped
                };
            }
        }
        function Cw(e1, t) {
            return hp(e1, (e1)=>{
                const i = t.pointCoordinate3D(e1);
                e1.x = i.x, e1.y = i.y;
            }, 1 / 256);
        }
        function zw(e1) {
            return e1 < 0 ? 1 + e1 % 1 : e1 % 1;
        }
        function Pw(e1) {
            return 100 * e1 | 0;
        }
        function Dw(e1, t, i, r, n) {
            const o = function(i, r) {
                if (i) return n(i);
                if (r) {
                    e1.url && r.tiles && e1.tiles && delete e1.tiles;
                    const i = O(k(r, e1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    r.vector_layers && (i.vectorLayers = r.vector_layers, i.vectorLayerIds = i.vectorLayers.map((e1)=>e1.id)), i.tiles = t.canonicalizeTileset(i, e1.url), n(null, i);
                }
            };
            return e1.url ? we(t.transformRequest(t.normalizeSourceURL(e1.url, null, i, r), ye.Source), o) : dt.frame(()=>o(null, e1));
        }
        class Rw {
            constructor(e1, t, i){
                this.bounds = sc.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = i || 24;
            }
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e1) {
                const t = Math.pow(2, e1.z), i = Math.floor(Kd(this.bounds.getWest()) * t), r = Math.floor(Jd(this.bounds.getNorth()) * t), n = Math.ceil(Kd(this.bounds.getEast()) * t), o = Math.ceil(Jd(this.bounds.getSouth()) * t);
                return e1.x >= i && e1.x < n && e1.y >= r && e1.y < o;
            }
        }
        class Lw {
            constructor(e1, t){
                this.width = e1, this.height = t, this.nextRow = 0, this.image = new Qp({
                    width: e1,
                    height: t
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(e1, t) {
                const i = this.getKey(e1, t);
                return this.positions[i];
            }
            trim() {
                const e1 = this.width, t = this.height = U(this.nextRow);
                this.image.resize({
                    width: e1,
                    height: t
                });
            }
            getKey(e1, t) {
                return e1.join(",") + t;
            }
            getDashRanges(e1, t, i) {
                const r = [];
                let n = e1.length % 2 == 1 ? -e1[e1.length - 1] * i : 0, o = e1[0] * i, s = !0;
                r.push({
                    left: n,
                    right: o,
                    isDash: s,
                    zeroLength: 0 === e1[0]
                });
                let a = e1[0];
                for(let t = 1; t < e1.length; t++){
                    s = !s;
                    const l = e1[t];
                    n = a * i, a += l, o = a * i, r.push({
                        left: n,
                        right: o,
                        isDash: s,
                        zeroLength: 0 === l
                    });
                }
                return r;
            }
            addRoundDash(e1, t, i) {
                const r = t / 2;
                for(let t = -i; t <= i; t++){
                    const n = this.width * (this.nextRow + i + t);
                    let o = 0, s = e1[o];
                    for(let a = 0; a < this.width; a++){
                        a / s.right > 1 && (s = e1[++o]);
                        const l = Math.abs(a - s.left), c = Math.abs(a - s.right), h = Math.min(l, c);
                        let u;
                        const d = t / i * (r + 1);
                        if (s.isDash) {
                            const e1 = r - Math.abs(d);
                            u = Math.sqrt(h * h + e1 * e1);
                        } else u = r - Math.sqrt(h * h + d * d);
                        this.image.data[n + a] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(e1, t) {
                for(let t = e1.length - 1; t >= 0; --t){
                    const i = e1[t], r = e1[t + 1];
                    i.zeroLength ? e1.splice(t, 1) : r && r.isDash === i.isDash && (r.left = i.left, e1.splice(t, 1));
                }
                const i = e1[0], r = e1[e1.length - 1];
                i.isDash === r.isDash && (i.left = r.left - this.width, r.right = i.right + this.width);
                const n = this.width * this.nextRow;
                let o = 0, s = e1[o];
                for(let i = 0; i < this.width; i++){
                    i / s.right > 1 && (s = e1[++o]);
                    const r = Math.abs(i - s.left), a = Math.abs(i - s.right), l = Math.min(r, a);
                    this.image.data[n + i] = Math.max(0, Math.min(255, (s.isDash ? l : -l) + t + 128));
                }
            }
            addDash(e1, t) {
                const i = this.getKey(e1, t);
                if (this.positions[i]) return this.positions[i];
                const r = "round" === t, n = r ? 7 : 0, o = 2 * n + 1;
                if (this.nextRow + o > this.height) return H("LineAtlas out of space"), null;
                0 === e1.length && e1.push(1);
                let s = 0;
                for(let t = 0; t < e1.length; t++)e1[t] < 0 && (H("Negative value is found in line dasharray, replacing values with 0"), e1[t] = 0), s += e1[t];
                if (0 !== s) {
                    const i = this.width / s, o = this.getDashRanges(e1, this.width, i);
                    r ? this.addRoundDash(o, i, n) : this.addRegularDash(o, "square" === t ? .5 * i : 0);
                }
                const a = this.nextRow + n;
                this.nextRow += o;
                const l = {
                    tl: [
                        a,
                        n
                    ],
                    br: [
                        s,
                        0
                    ]
                };
                return this.positions[i] = l, l;
            }
        }
        Rs(Lw, "LineAtlas");
        const kw = 1 * ng;
        class Ow {
            constructor(e1){
                const t = {}, i = [];
                for(const r in e1){
                    const n = e1[r], o = t[r] = {};
                    for(const e1 in n.glyphs){
                        const t = n.glyphs[+e1];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const r = t.metrics.localGlyph ? kw : 1, s = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2 * r,
                            h: t.bitmap.height + 2 * r
                        };
                        i.push(s), o[e1] = s;
                    }
                }
                const { w: r, h: n } = K_(i), o = new Qp({
                    width: r || 1,
                    height: n || 1
                });
                for(const i in e1){
                    const r = e1[i];
                    for(const e1 in r.glyphs){
                        const n = r.glyphs[+e1];
                        if (!n || 0 === n.bitmap.width || 0 === n.bitmap.height) continue;
                        const s = t[i][e1], a = n.metrics.localGlyph ? kw : 1;
                        Qp.copy(n.bitmap, o, {
                            x: 0,
                            y: 0
                        }, {
                            x: s.x + a,
                            y: s.y + a
                        }, n.bitmap);
                    }
                }
                this.image = o, this.positions = t;
            }
        }
        Rs(Ow, "GlyphAtlas");
        class Bw {
            constructor(e1){
                this.tileID = new qu(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.tileZoom = e1.tileZoom, this.uid = e1.uid, this.zoom = e1.zoom, this.canonical = e1.tileID.canonical, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.scope = e1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e1.showCollisionBoxes, this.collectResourceTiming = !!e1.collectResourceTiming, this.promoteId = e1.promoteId, this.isSymbolTile = e1.isSymbolTile, this.tileTransform = Pg(e1.tileID.canonical, e1.projection), this.projection = e1.projection, this.brightness = e1.brightness, this.extraShadowCaster = !!e1.extraShadowCaster;
            }
            parse(e1, t, i, r, n) {
                this.status = "parsing", this.data = e1, this.collisionBoxArray = new al;
                const o = new dm(Object.keys(e1.layers).sort()), s = new Qm(this.tileID, this.promoteId);
                s.bucketLayerIDs = [];
                const a = {}, l = new Lw(256, 256), c = {
                    featureIndex: s,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    lineAtlas: l,
                    availableImages: i,
                    brightness: this.brightness
                }, h = t.familiesBySource[this.source];
                for(const t in h){
                    const r = e1.layers[t];
                    if (!r) continue;
                    let n = !1, l = !1, u = !1;
                    for (const e1 of h[t])"symbol" === e1[0].type ? n = !0 : l = !0, e1[0].is3D() && "model" !== e1[0].type && (u = !0);
                    if (this.extraShadowCaster && !u) continue;
                    if (!0 === this.isSymbolTile && !n) continue;
                    if (!1 === this.isSymbolTile && !l) continue;
                    1 === r.version && H(`Vector tile source "${this.source}" layer "${t}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const d = o.encode(t), p = [];
                    for(let e1 = 0; e1 < r.length; e1++){
                        const i = r.feature(e1), n = s.getId(i, t);
                        p.push({
                            feature: i,
                            id: n,
                            index: e1,
                            sourceLayerIndex: d
                        });
                    }
                    for (const e1 of h[t]){
                        const t = e1[0];
                        (!this.extraShadowCaster || t.is3D() && "model" !== t.type) && (void 0 !== this.isSymbolTile && "symbol" === t.type !== this.isSymbolTile || t.minzoom && this.zoom < Math.floor(t.minzoom) || t.maxzoom && this.zoom >= t.maxzoom || "none" !== t.visibility && (Fw(e1, this.zoom, c.brightness, i), (a[t.id] = t.createBucket({
                            index: s.bucketLayerIDs.length,
                            layers: e1,
                            zoom: this.zoom,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: d,
                            sourceID: this.source,
                            projection: this.projection.spec
                        })).populate(p, c, this.tileID.canonical, this.tileTransform), s.bucketLayerIDs.push(e1.map((e1)=>e1.id))));
                    }
                }
                let u, d, p, f;
                l.trim();
                const m = {
                    type: "maybePrepare",
                    isSymbolTile: this.isSymbolTile,
                    zoom: this.zoom
                }, _ = ()=>{
                    if (u) return this.status = "done", n(u);
                    if (this.extraShadowCaster) this.status = "done", n(null, {
                        buckets: L(a).filter((e1)=>!e1.isEmpty()),
                        featureIndex: s,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: c.brightness,
                        glyphMap: null,
                        iconMap: null,
                        glyphPositions: null
                    });
                    else if (d && p && f) {
                        const e1 = new Ow(d), t = new eg(p, f);
                        for(const r in a){
                            const n = a[r];
                            n instanceof gy ? (Fw(n.layers, this.zoom, c.brightness, i), vg(n, d, e1.positions, p, t.iconPositions, this.showCollisionBoxes, i, this.tileID.canonical, this.tileZoom, this.projection, this.brightness)) : n.hasPattern && (n instanceof Ey || n instanceof jf || n instanceof vb) && (Fw(n.layers, this.zoom, c.brightness, i), n.addFeatures(c, this.tileID.canonical, t.patternPositions, i, this.tileTransform, this.brightness));
                        }
                        this.status = "done", n(null, {
                            buckets: L(a).filter((e1)=>!e1.isEmpty()),
                            featureIndex: s,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: e1.image,
                            lineAtlas: l,
                            imageAtlas: t,
                            brightness: c.brightness
                        });
                    }
                };
                if (!this.extraShadowCaster) {
                    const e1 = q(c.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                    Object.keys(e1).length ? r.send("getGlyphs", {
                        uid: this.uid,
                        stacks: e1,
                        scope: this.scope
                    }, (e1, t)=>{
                        u || (u = e1, d = t, _());
                    }, void 0, !1, m) : d = {};
                    const t = Object.keys(c.iconDependencies);
                    t.length ? r.send("getImages", {
                        icons: t,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "icons"
                    }, (e1, t)=>{
                        u || (u = e1, p = t, _());
                    }, void 0, !1, m) : p = {};
                    const i = Object.keys(c.patternDependencies);
                    i.length ? r.send("getImages", {
                        icons: i,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "patterns"
                    }, (e1, t)=>{
                        u || (u = e1, f = t, _());
                    }, void 0, !1, m) : f = {};
                }
                _();
            }
        }
        function Fw(e1, t, i, r) {
            const n = new oa(t, {
                brightness: i
            });
            for (const t of e1)t.recalculate(n, r);
        }
        class Nw {
            constructor(e1){
                this.entries = {}, this.scheduler = e1;
            }
            request(e1, t, i, r) {
                const n = this.entries[e1] = this.entries[e1] || {
                    callbacks: []
                };
                if (n.result) {
                    const [e1, i] = n.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        r(e1, i);
                    }, t) : r(e1, i), ()=>{};
                }
                return n.callbacks.push(r), n.cancel || (n.cancel = i((i, r)=>{
                    n.result = [
                        i,
                        r
                    ];
                    for (const e1 of n.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        e1(i, r);
                    }, t) : e1(i, r);
                    setTimeout(()=>delete this.entries[e1], 3e3);
                })), ()=>{
                    n.result || (n.callbacks = n.callbacks.filter((e1)=>e1 !== r), n.callbacks.length || (n.cancel(), delete this.entries[e1]));
                };
            }
        }
        function Uw(e1, t, i) {
            const r = JSON.stringify(e1.request);
            return e1.data && (this.deduped.entries[r] = {
                result: [
                    null,
                    e1.data
                ]
            }), this.deduped.request(r, {
                type: "parseTile",
                isSymbolTile: e1.isSymbolTile,
                zoom: e1.tileZoom
            }, (t)=>{
                const r = Te(e1.request, (e1, r, n, o)=>{
                    e1 ? t(e1) : r && t(null, {
                        vectorTile: i ? void 0 : new cm(new km(r)),
                        rawData: r,
                        cacheControl: n,
                        expires: o
                    });
                });
                return ()=>{
                    r.cancel(), t();
                };
            }, t);
        }
        class Vw extends zt {
            constructor(e1, t, i, r){
                if (super(), this.id = e1, this.dispatcher = i, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, k(this, O(t, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = k({
                    type: "vector"
                }, t), this._collectResourceTiming = !!t.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new Nw;
            }
            load(e1) {
                this._loaded = !1, this.fire(new It("dataloading", {
                    dataType: "source"
                }));
                const t = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, i = this.map._worldview;
                this._tileJSONRequest = Dw(this._options, this.map._requestManager, t, i, (r, n)=>{
                    this._tileJSONRequest = null, this._loaded = !0, r ? (t && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${t}`), i && 2 !== i.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${i}`), this.fire(new Ct(r))) : n && (k(this, n), n.bounds && (this.tileBounds = new Rw(n.bounds, this.minzoom, this.maxzoom)), Ge(n.tiles, this.map._requestManager._customAccessToken), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), e1 && e1(r);
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const e1 = va(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(e1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove() {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return k({}, this._options);
            }
            loadTile(e1, t) {
                const i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                    request: this.map._requestManager.transformRequest(i, ye.Tile),
                    data: void 0,
                    uid: e1.uid,
                    tileID: e1.tileID,
                    tileZoom: e1.tileZoom,
                    zoom: e1.tileID.overscaledZ,
                    tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: dt.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    isSymbolTile: e1.isSymbolTile,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: e1.isExtraShadowCaster
                };
                if (r.request.collectResourceTiming = this._collectResourceTiming, e1.actor && "expired" !== e1.state) "loading" === e1.state ? e1.reloadCallback = t : e1.request = e1.actor.send("reloadTile", r, n.bind(this));
                else if (e1.actor = this._tileWorkers[i] = this._tileWorkers[i] || this.dispatcher.getActor(), this.dispatcher.ready) e1.request = e1.actor.send("loadTile", r, n.bind(this), void 0, !0);
                else {
                    const t = Uw.call({
                        deduped: this._deduped
                    }, r, (t, i)=>{
                        t || !i ? n.call(this, t) : (r.data = {
                            cacheControl: i.cacheControl,
                            expires: i.expires,
                            rawData: i.rawData.slice(0)
                        }, e1.actor && e1.actor.send("loadTile", r, n.bind(this), void 0, !0));
                    }, !0);
                    e1.request = {
                        cancel: t
                    };
                }
                function n(i, r) {
                    return delete e1.request, e1.aborted ? t(null) : i && 404 !== i.status ? t(i) : (r && r.resourceTiming && (e1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && e1.setExpiryData(r), e1.loadVectorData(r, this.map.painter), ge(this.dispatcher), t(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null)));
                }
            }
            abortTile(e1) {
                e1.request && (e1.request.cancel(), delete e1.request), e1.actor && e1.actor.send("abortTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e1) {
                e1.actor && e1.actor.send("removeTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e1.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class jw extends zt {
            constructor(e1, t, i, r){
                super(), this.id = e1, this.dispatcher = i, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = k({
                    type: "raster"
                }, t), k(this, O(t, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(e1) {
                this._loaded = !1, this.fire(new It("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = Dw(this._options, this.map._requestManager, null, null, (t, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, t ? this.fire(new Ct(t)) : i && (k(this, i), i.bounds && (this.tileBounds = new Rw(i.bounds, this.minzoom, this.maxzoom)), Ge(i.tiles), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), e1 && e1(t);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const e1 = va(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(e1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove() {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return k({}, this._options);
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            loadTile(e1, t) {
                const i = dt.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), i, this.tileSize);
                e1.request = Ie(this.map._requestManager.transformRequest(r, ye.Tile), (i, r, n, o)=>(delete e1.request, e1.aborted ? (e1.state = "unloaded", t(null)) : i ? (e1.state = "errored", t(i)) : r ? (this.map._refreshExpiredTiles && e1.setExpiryData({
                        cacheControl: n,
                        expires: o
                    }), e1.setTexture(r, this.map.painter), e1.state = "loaded", ge(this.dispatcher), void t(null)) : t(null)));
            }
            abortTile(e1, t) {
                e1.request && (e1.request.cancel(), delete e1.request), t();
            }
            unloadTile(e1, t) {
                e1.texture && e1.texture instanceof My ? (e1.destroy(!0), e1.texture && e1.texture instanceof My && this.map.painter.saveTileTexture(e1.texture)) : e1.destroy(), t();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        function Gw() {
            return null != xI.workerClass ? new xI.workerClass : new t.Worker(xI.workerUrl);
        }
        const qw = "mapboxgl_preloaded_worker_pool";
        class Zw {
            constructor(){
                this.active = {};
            }
            acquire(e1) {
                if (!this.workers) for(this.workers = []; this.workers.length < Zw.workerCount;)this.workers.push(new Gw);
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], this.workers && 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[qw];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        let $w;
        function Ww() {
            return $w || ($w = new Zw), $w;
        }
        Zw.workerCount = 2;
        let Hw, Xw, Yw, Kw = null;
        function Jw() {
            return Q() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : Xw || n.DRACO_URL;
        }
        const Qw = 5123, eT = 5126, tT = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            [Qw]: Uint16Array,
            5125: Uint32Array,
            [eT]: Float32Array
        }, iT = {
            5120: "DT_INT8",
            5121: "DT_UINT8",
            5122: "DT_INT16",
            [Qw]: "DT_UINT16",
            5125: "DT_UINT32",
            [eT]: "DT_FLOAT32"
        }, rT = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function nT(e1, t, i) {
            const r = i.json.bufferViews.length, n = i.buffers.length;
            t.bufferView = r, i.json.bufferViews[r] = {
                buffer: n,
                byteLength: e1.byteLength
            }, i.buffers[n] = e1;
        }
        const oT = "KHR_draco_mesh_compression";
        function sT(e1, t) {
            const i = e1.extensions && e1.extensions[oT];
            if (!i) return;
            const r = new Yw.Decoder, n = uT(t, i.bufferView), o = new Yw.Mesh;
            if (!r.DecodeArrayToMesh(n, n.byteLength, o)) throw new Error("Failed to decode Draco mesh");
            const s = t.json.accessors[e1.indices], a = tT[s.componentType], l = s.count * a.BYTES_PER_ELEMENT, c = Yw._malloc(l);
            a === Uint16Array ? r.GetTrianglesUInt16Array(o, l, c) : r.GetTrianglesUInt32Array(o, l, c), nT(Yw.memory.buffer.slice(c, c + l), s, t), Yw._free(c);
            for (const n of Object.keys(i.attributes)){
                const s = r.GetAttributeByUniqueId(o, i.attributes[n]), a = t.json.accessors[e1.attributes[n]], l = iT[a.componentType], c = a.count * rT[a.type] * tT[a.componentType].BYTES_PER_ELEMENT, h = Yw._malloc(c);
                r.GetAttributeDataArrayForAllPoints(o, s, Yw[l], c, h), nT(Yw.memory.buffer.slice(h, h + c), a, t), Yw._free(h);
            }
            r.destroy(), o.destroy(), delete e1.extensions[oT];
        }
        const aT = 1179937895, lT = new TextDecoder("utf8");
        function cT(e1, t) {
            return new URL(e1, t).href;
        }
        function hT(e1, t, i, r) {
            return fetch(cT(e1.uri, r)).then((e1)=>e1.arrayBuffer()).then((e1)=>{
                t.buffers[i] = e1;
            });
        }
        function uT(e1, t) {
            const i = e1.json.bufferViews[t];
            return new Uint8Array(e1.buffers[i.buffer], i.byteOffset || 0, i.byteLength);
        }
        function dT(e1, i, r, n) {
            if (e1.uri) {
                const o = cT(e1.uri, n);
                return fetch(o).then((e1)=>e1.blob()).then((e1)=>t.createImageBitmap(e1)).then((e1)=>{
                    i.images[r] = e1;
                });
            }
            if (void 0 !== e1.bufferView) {
                const n = uT(i, e1.bufferView), o = new t.Blob([
                    n
                ], {
                    type: e1.mimeType
                });
                return t.createImageBitmap(o).then((e1)=>{
                    i.images[r] = e1;
                });
            }
        }
        function pT(e1, t = 0, i) {
            const r = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(e1, t, 1)[0] === aT) {
                const i = new Uint32Array(e1, t);
                let n = 2;
                const o = (i[n++] >> 2) - 3, s = i[n++] >> 2;
                if (n++, r.json = JSON.parse(lT.decode(i.subarray(n, n + s))), n += s, n < o) {
                    const o = i[n++];
                    n++;
                    const s = t + (n << 2);
                    r.buffers[0] = e1.slice(s, s + o);
                }
            } else r.json = JSON.parse(lT.decode(new Uint8Array(e1, t)));
            const { buffers: n, images: o, meshes: s, extensionsUsed: a } = r.json;
            let l = Promise.resolve();
            if (n) {
                const e1 = [];
                for(let t = 0; t < n.length; t++){
                    const o = n[t];
                    o.uri ? e1.push(hT(o, r, t, i)) : r.buffers[t] || (r.buffers[t] = null);
                }
                l = Promise.all(e1);
            }
            return l.then(()=>{
                const e1 = [], t = a && a.includes(oT);
                if (t && e1.push(function() {
                    if (!Yw) return Hw || (Hw = function(e1) {
                        let t, i = null;
                        function r() {
                            t = new Uint8Array(i.buffer);
                        }
                        function n() {
                            throw new Error("Unexpected Draco error.");
                        }
                        const o = {
                            a: {
                                a: n,
                                d: function(e1, i, r) {
                                    return t.copyWithin(e1, i, i + r);
                                },
                                c: function(e1) {
                                    const n = t.length, o = Math.max(e1 >>> 0, Math.ceil(1.2 * n)), s = Math.ceil((o - n) / 65536);
                                    try {
                                        return i.grow(s), r(), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                },
                                b: n
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e1, o) : e1.then((e1)=>e1.arrayBuffer()).then((e1)=>WebAssembly.instantiate(e1, o))).then((e1)=>{
                            const { Rb: n, Qb: o, P: s, T: a, X: l, Ja: c, La: h, Qa: u, Va: d, Wa: p, eb: f, jb: m, f: _, e: g, yb: y, zb: x, Ab: v, Bb: b, Db: w, Gb: T } = e1.instance.exports;
                            i = g;
                            const E = (()=>{
                                let e1 = 0, i = 0, r = 0, s = 0;
                                return (a)=>{
                                    r && (n(s), n(e1), i += r, r = e1 = 0), e1 || (i += 128, e1 = o(i));
                                    const l = a.length + 7 & -8;
                                    let c = e1;
                                    l >= i && (r = l, c = s = o(l));
                                    for(let e1 = 0; e1 < a.length; e1++)t[c + e1] = a[e1];
                                    return c;
                                };
                            })();
                            return r(), _(), {
                                memory: g,
                                _free: n,
                                _malloc: o,
                                Mesh: class {
                                    constructor(){
                                        this.ptr = s();
                                    }
                                    destroy() {
                                        a(this.ptr);
                                    }
                                },
                                Decoder: class {
                                    constructor(){
                                        this.ptr = c();
                                    }
                                    destroy() {
                                        m(this.ptr);
                                    }
                                    DecodeArrayToMesh(e1, t, i) {
                                        const r = E(e1), n = h(this.ptr, r, t, i.ptr);
                                        return !!l(n);
                                    }
                                    GetAttributeByUniqueId(e1, t) {
                                        return {
                                            ptr: u(this.ptr, e1.ptr, t)
                                        };
                                    }
                                    GetTrianglesUInt16Array(e1, t, i) {
                                        d(this.ptr, e1.ptr, t, i);
                                    }
                                    GetTrianglesUInt32Array(e1, t, i) {
                                        p(this.ptr, e1.ptr, t, i);
                                    }
                                    GetAttributeDataArrayForAllPoints(e1, t, i, r, n) {
                                        f(this.ptr, e1.ptr, t.ptr, i, r, n);
                                    }
                                },
                                DT_INT8: y(),
                                DT_UINT8: x(),
                                DT_INT16: v(),
                                DT_UINT16: b(),
                                DT_UINT32: w(),
                                DT_FLOAT32: T()
                            };
                        });
                    }(fetch(Jw())), Hw.then((e1)=>{
                        Yw = e1, Hw = void 0;
                    }));
                }()), o) for(let t = 0; t < o.length; t++)e1.push(dT(o[t], r, t, i));
                return (e1.length ? Promise.all(e1) : Promise.resolve()).then(()=>{
                    if (t && s) for (const { primitives: e1 } of s)for (const t of e1)sT(t, r);
                    return r;
                });
            });
        }
        function fT(e1) {
            return fetch(e1).then((e1)=>e1.arrayBuffer()).then((t)=>pT(t, 0, e1));
        }
        class mT {
            constructor(e1, t, i){
                if (this.triangleCount = t.length / 3, this.min = new y(0, 0), this.max = new y(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === e1.length || 0 === i) return;
                const r = e1.map((e1)=>e1.x), n = e1.map((e1)=>e1.y);
                this.min = new y(Math.min(...r), Math.min(...n)), this.max = new y(Math.max(...r), Math.max(...n));
                const o = this.max.sub(this.min);
                o.x = Math.max(o.x, 1), o.y = Math.max(o.y, 1);
                const s = Math.max(o.x, o.y) / i;
                this.cellsX = Math.max(1, Math.ceil(o.x / s)), this.cellsY = Math.max(1, Math.ceil(o.y / s)), this.xScale = 1 / s, this.yScale = 1 / s;
                const a = [];
                for(let i = 0; i < this.triangleCount; i++){
                    const r = e1[t[3 * i + 0]].sub(this.min), n = e1[t[3 * i + 1]].sub(this.min), o = e1[t[3 * i + 2]].sub(this.min), l = _T(Math.floor(Math.min(r.x, n.x, o.x)), this.xScale, this.cellsX), c = _T(Math.floor(Math.max(r.x, n.x, o.x)), this.xScale, this.cellsX), h = _T(Math.floor(Math.min(r.y, n.y, o.y)), this.yScale, this.cellsY), u = _T(Math.floor(Math.max(r.y, n.y, o.y)), this.yScale, this.cellsY), d = new y(0, 0), p = new y(0, 0), f = new y(0, 0), m = new y(0, 0);
                    for(let e1 = h; e1 <= u; ++e1){
                        d.y = p.y = e1 * s, f.y = m.y = (e1 + 1) * s;
                        for(let t = l; t <= c; ++t)d.x = f.x = t * s, p.x = m.x = (t + 1) * s, (Lp(r, n, o, d, p, m) || Lp(r, n, o, d, m, f)) && a.push({
                            cellIdx: e1 * this.cellsX + t,
                            triIdx: i
                        });
                    }
                }
                if (0 === a.length) return;
                a.sort((e1, t)=>e1.cellIdx - t.cellIdx || e1.triIdx - t.triIdx);
                let l = 0;
                for(; l < a.length;){
                    const e1 = a[l].cellIdx, t = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; l < a.length && a[l].cellIdx === e1;)++t.len, this.payload.push(a[l++].triIdx);
                    this.cells[e1] = t;
                }
            }
            query(e1, t, i) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e1.x > this.max.x || this.min.x > t.x) return;
                if (e1.y > this.max.y || this.min.y > t.y) return;
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8)));
                for(let e1 = 0; e1 < this.lookup.length; e1++)this.lookup[e1] = 0;
                const r = _T(e1.x - this.min.x, this.xScale, this.cellsX), n = _T(t.x - this.min.x, this.xScale, this.cellsX), o = _T(e1.y - this.min.y, this.yScale, this.cellsY), s = _T(t.y - this.min.y, this.yScale, this.cellsY);
                for(let e1 = o; e1 <= s; e1++)for(let t = r; t <= n; t++){
                    const r = this.cells[e1 * this.cellsX + t];
                    if (r) for(let e1 = 0; e1 < r.len; e1++){
                        const t = this.payload[r.start + e1], n = Math.floor(t / 8), o = 1 << t % 8;
                        if (!(this.lookup[n] & o) && (this.lookup[n] |= o, i.push(t), i.length === this.triangleCount)) return;
                    }
                }
            }
        }
        function _T(e1, t, i) {
            return Math.max(0, Math.min(i - 1, Math.floor(e1 * t)));
        }
        function gT(e1, t) {
            const i = e1.json.bufferViews[t.bufferView];
            return new tT[t.componentType](e1.buffers[i.buffer], (t.byteOffset || 0) + (i.byteOffset || 0), t.count * rT[t.type]);
        }
        function yT(e1, t, i) {
            const r = e1.indices, n = e1.attributes, o = {};
            o.indexArray = new Wa;
            const s = t.json.accessors[r], a = s.count / 3;
            o.indexArray.reserve(a);
            const l = gT(t, s);
            for(let e1 = 0; e1 < a; e1++)o.indexArray.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
            o.indexArray._trim(), o.vertexArray = new tl;
            const c = t.json.accessors[n.POSITION];
            o.vertexArray.reserve(c.count);
            const h = gT(t, c);
            for(let e1 = 0; e1 < c.count; e1++)o.vertexArray.emplaceBack(h[3 * e1], h[3 * e1 + 1], h[3 * e1 + 2]);
            if (o.vertexArray._trim(), o.aabb = new ed(c.min, c.max), o.centroid = function(e1, t) {
                const i = [
                    0,
                    0,
                    0
                ], r = e1.length;
                if (r > 0) {
                    for(let n = 0; n < r; n++){
                        const r = 3 * e1[n];
                        i[0] += t[r], i[1] += t[r + 1], i[2] += t[r + 2];
                    }
                    i[0] /= r, i[1] /= r, i[2] /= r;
                }
                return i;
            }(l, h), void 0 !== n.COLOR_0) {
                const e1 = t.json.accessors[n.COLOR_0], i = rT[e1.type];
                if (e1.componentType === eT) {
                    o.colorArray = 3 === i ? new tl : new ka, o.colorArray.reserve(e1.count);
                    const r = gT(t, e1);
                    if (3 === i) for(let t = 0; t < e1.count; t++)o.colorArray.emplaceBack(r[3 * t], r[3 * t + 1], r[3 * t + 2]);
                    else for(let t = 0; t < e1.count; t++)o.colorArray.emplaceBack(r[4 * t], r[4 * t + 1], r[4 * t + 2], r[4 * t + 3]);
                    o.colorArray._trim();
                } else if (e1.componentType === Qw && 4 === i) {
                    o.colorArray = new ka, o.colorArray.resize(e1.count);
                    const i = gT(t, e1), r = 1 / 65535, n = o.colorArray.float32;
                    for(let e1 = 0; e1 < 4 * i.length; ++e1)n[e1] = i[e1] * r;
                } else H(`glTF color buffer parsing for accessor ${JSON.stringify(e1)} is not supported`);
            }
            if (void 0 !== n.NORMAL) {
                o.normalArray = new tl;
                const e1 = t.json.accessors[n.NORMAL];
                o.normalArray.reserve(e1.count);
                const i = gT(t, e1);
                for(let t = 0; t < e1.count; t++)o.normalArray.emplaceBack(i[3 * t], i[3 * t + 1], i[3 * t + 2]);
                o.normalArray._trim();
            }
            if (void 0 !== n.TEXCOORD_0 && i.length > 0) {
                o.texcoordArray = new il;
                const e1 = t.json.accessors[n.TEXCOORD_0];
                o.texcoordArray.reserve(e1.count);
                const i = gT(t, e1);
                for(let t = 0; t < e1.count; t++)o.texcoordArray.emplaceBack(i[2 * t], i[2 * t + 1]);
                o.texcoordArray._trim();
            }
            const u = e1.material;
            return o.material = function(e1, t) {
                const { emissiveFactor: i = [
                    0,
                    0,
                    0
                ], alphaMode: r = "OPAQUE", alphaCutoff: n = .5, normalTexture: o, occlusionTexture: s, emissiveTexture: a, doubleSided: l } = e1, { baseColorFactor: c = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: h = 1, roughnessFactor: u = 1, baseColorTexture: d, metallicRoughnessTexture: p } = e1.pbrMetallicRoughness || {};
                return {
                    pbrMetallicRoughness: {
                        baseColorFactor: new hi(...c),
                        metallicFactor: h,
                        roughnessFactor: u,
                        baseColorTexture: d ? t[d.index] : void 0,
                        metallicRoughnessTexture: p ? t[p.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: i,
                    alphaMode: r,
                    alphaCutoff: n,
                    normalTexture: o ? t[o.index] : void 0,
                    occlusionTexture: s ? t[s.index] : void 0,
                    emissionTexture: a ? t[a.index] : void 0,
                    defined: void 0 === e1.defined
                };
            }(void 0 !== u ? t.json.materials[u] : {
                defined: !1
            }, i), void 0 !== n._FEATURE_RGBA4444 && (o.featureData = new Uint32Array(gT(t, t.json.accessors[n._FEATURE_RGBA4444]).buffer)), o;
        }
        function xT(e1, t, i) {
            const { matrix: r, rotation: n, translation: o, scale: s, mesh: a, extras: l, children: c } = e1, h = {};
            if (h.matrix = r || Au.fromRotationTranslationScale([], n || [
                0,
                0,
                0,
                1
            ], o || [
                0,
                0,
                0
            ], s || [
                1,
                1,
                1
            ]), void 0 !== a) {
                h.meshes = i[a];
                const e1 = h.anchor = [
                    0,
                    0
                ];
                for (const t of h.meshes){
                    const { min: i, max: r } = t.aabb;
                    e1[0] += i[0] + r[0], e1[1] += i[1] + r[1];
                }
                e1[0] = Math.floor(e1[0] / h.meshes.length / 2), e1[1] = Math.floor(e1[1] / h.meshes.length / 2);
            }
            if (l && (l.id && (h.id = l.id), l.lights && (h.lights = function(e1) {
                if (!e1.length) return [];
                const t = function(e1) {
                    const t = atob(e1), i = new Uint8Array(t.length);
                    for(let e1 = 0; e1 < t.length; e1++)i[e1] = t.codePointAt(e1);
                    return i;
                }(e1), i = [], r = t.length / 24, n = new Uint16Array(t.buffer), o = new Float32Array(t.buffer);
                for(let e1 = 0; e1 < r; e1++){
                    const t = n[2 * e1 * 6] / 30, r = n[2 * e1 * 6 + 1] / 30, s = n[2 * e1 * 6 + 10] / 100, a = o[6 * e1 + 1], l = o[6 * e1 + 2], c = o[6 * e1 + 3], h = o[6 * e1 + 4], u = c - a, d = h - l, p = Math.hypot(u, d);
                    i.push({
                        pos: [
                            a + .5 * u,
                            l + .5 * d,
                            r
                        ],
                        normal: [
                            d / p,
                            -u / p,
                            0
                        ],
                        width: p,
                        height: t,
                        depth: s,
                        points: [
                            a,
                            l,
                            c,
                            h
                        ]
                    });
                }
                return i;
            }(l.lights))), c) {
                const e1 = [];
                for (const r of c)e1.push(xT(t.json.nodes[r], t, i));
                h.children = e1;
            }
            return h;
        }
        function vT(e1) {
            if (0 === e1.vertices.length || 0 === e1.indices.length) return null;
            const [t, i] = [
                e1.vertices[0].clone(),
                e1.vertices[0].clone()
            ];
            for(let r = 1; r < e1.vertices.length; ++r){
                const n = e1.vertices[r];
                t.x = Math.min(t.x, n.x), t.y = Math.min(t.y, n.y), i.x = Math.max(i.x, n.x), i.y = Math.max(i.y, n.y);
            }
            const r = Math.ceil(Math.max(i.x - t.x, i.y - t.y) / 256), n = Math.max(8, r), o = new mT(e1.vertices, e1.indices, n);
            return {
                vertices: e1.vertices,
                indices: e1.indices,
                grid: o,
                min: t,
                max: i
            };
        }
        function bT(e1) {
            if (!e1.extras || !e1.extras.ground) return null;
            const t = e1.extras.ground;
            if (!t || !Array.isArray(t) || 0 === t.length) return null;
            const i = t[0];
            if (!i || !Array.isArray(i) || 0 === i.length) return null;
            const r = [];
            for (const e1 of i){
                if (!Array.isArray(e1) || 2 !== e1.length) continue;
                const t = e1[0], i = e1[1];
                "number" == typeof t && "number" == typeof i && r.push(new y(t, i));
            }
            if (r.length < 3) return null;
            r.length > 1 && r[r.length - 1].equals(r[0]) && r.pop();
            let n = 0;
            for(let e1 = 0; e1 < r.length; e1++){
                const t = r[e1], i = r[(e1 + 1) % r.length], o = r[(e1 + 2) % r.length];
                n += (t.x - i.x) * (o.y - i.y) - (o.x - i.x) * (t.y - i.y);
            }
            n > 0 && r.reverse();
            const o = Bf(r.flatMap((e1)=>[
                    e1.x,
                    e1.y
                ]), []);
            return 0 === o.length ? null : {
                vertices: r,
                indices: o
            };
        }
        function wT(e1) {
            const t = [], i = [];
            let r = 0;
            for (const n of e1){
                r = t.length;
                const e1 = n.vertexArray.float32, o = n.indexArray.uint16;
                for(let i = 0; i < n.vertexArray.length; i++)t.push(new y(e1[3 * i + 0], e1[3 * i + 1]));
                for(let e1 = 0; e1 < 3 * n.indexArray.length; e1++)i.push(o[e1] + r);
            }
            if (i.length % 3 != 0) return null;
            for(let e1 = 0; e1 < i.length; e1 += 3){
                const r = t[i[e1 + 0]], n = t[i[e1 + 1]], o = t[i[e1 + 2]];
                (r.x - n.x) * (o.y - n.y) - (o.x - n.x) * (r.y - n.y) > 0 && ([i[e1 + 1], i[e1 + 2]] = [
                    i[e1 + 2],
                    i[e1 + 1]
                ]);
            }
            return {
                vertices: t,
                indices: i
            };
        }
        function TT(e1) {
            const i = function(e1, i) {
                const r = [], n = t.WebGL2RenderingContext;
                if (e1.json.textures) for (const t of e1.json.textures){
                    const o = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== t.sampler && Object.assign(o, e1.json.samplers[t.sampler]), r.push({
                        image: i[t.source],
                        sampler: o,
                        uploaded: !1
                    });
                }
                return r;
            }(e1, e1.images), r = function(e1, t) {
                const i = [];
                for (const r of e1.json.meshes){
                    const n = [];
                    for (const i of r.primitives)n.push(yT(i, e1, t));
                    i.push(n);
                }
                return i;
            }(e1, i), { scenes: n, scene: o, nodes: s } = e1.json, a = n ? n[o || 0].nodes : s, l = [];
            for (const t of a)l.push(xT(s[t], e1, r));
            return function(e1, t, i) {
                const r = {}, n = new Set;
                for(let o = 0; o < e1.length; o++){
                    const e1 = i[t[o]];
                    if (!e1.extras) continue;
                    const s = e1.extras["mapbox:footprint:version"], a = e1.extras["mapbox:footprint:id"];
                    (s || a) && n.add(o), "1.0.0" === s && a && (r[a] = o);
                }
                for(let o = 0; o < e1.length; o++){
                    if (n.has(o)) continue;
                    const s = e1[o], a = i[t[o]];
                    if (!a.extras) continue;
                    let l = null;
                    s.id in r && (l = wT(e1[r[s.id]].meshes)), l || (l = bT(a)), l && (s.footprint = vT(l));
                }
                if (n.size > 0) {
                    const t = Array.from(n.values()).sort((e1, t)=>e1 - t);
                    for(let i = t.length - 1; i >= 0; i--)e1.splice(t[i], 1);
                }
            }(l, a, e1.json.nodes), l;
        }
        function ET(e1) {
            e1.heightmap = new Float32Array(4096), e1.heightmap.fill(-1);
            const t = e1.vertexArray.float32, i = e1.aabb.min[0] - 1, r = e1.aabb.min[1] - 1, n = Sv / (e1.aabb.max[0] - i + 2), o = Sv / (e1.aabb.max[1] - r + 2);
            for(let s = 0; s < t.length; s += 3){
                const a = t[s + 2], l = (t[s + 0] - i) * n | 0, c = (t[s + 1] - r) * o | 0;
                a > e1.heightmap[c * Sv + l] && (e1.heightmap[c * Sv + l] = a);
            }
        }
        function MT(e1, t) {
            const i = {};
            i.indexArray = new Wa, i.indexArray.reserve(4 * e1.length), i.vertexArray = new tl, i.vertexArray.reserve(10 * e1.length), i.colorArray = new ka, i.vertexArray.reserve(10 * e1.length);
            let r = 0;
            for (const n of e1){
                const e1 = Math.min(10, Math.max(4, 1.3 * n.height)) * t, o = [
                    -n.normal[1],
                    n.normal[0],
                    0
                ], s = Math.min(.29, .1 * n.width / n.depth), a = n.width - 2 * n.depth * t * (s + .01), l = Du.scaleAndAdd([], n.pos, o, a / 2), c = Du.scaleAndAdd([], n.pos, o, -a / 2), h = [
                    l[0],
                    l[1],
                    l[2] + n.height
                ], u = [
                    c[0],
                    c[1],
                    c[2] + n.height
                ], d = Du.scaleAndAdd([], n.normal, o, s);
                Du.scale(d, d, e1);
                const p = Du.scaleAndAdd([], n.normal, o, -s);
                Du.scale(p, p, e1), Du.add(d, l, d), Du.add(p, c, p), l[2] += .1, c[2] += .1, i.vertexArray.emplaceBack(d[0], d[1], d[2]), i.vertexArray.emplaceBack(p[0], p[1], p[2]), i.vertexArray.emplaceBack(l[0], l[1], l[2]), i.vertexArray.emplaceBack(c[0], c[1], c[2]), i.vertexArray.emplaceBack(h[0], h[1], h[2]), i.vertexArray.emplaceBack(u[0], u[1], u[2]), i.vertexArray.emplaceBack(l[0], l[1], l[2]), i.vertexArray.emplaceBack(c[0], c[1], c[2]), i.vertexArray.emplaceBack(d[0], d[1], d[2]), i.vertexArray.emplaceBack(p[0], p[1], p[2]);
                const f = a / e1 / 2;
                i.colorArray.emplaceBack(-f - s, -1, f, .8), i.colorArray.emplaceBack(f + s, -1, f, .8), i.colorArray.emplaceBack(-f, 0, f, 1.3), i.colorArray.emplaceBack(f, 0, f, 1.3), i.colorArray.emplaceBack(f + s, -0.8, f, .7), i.colorArray.emplaceBack(f + s, -0.8, f, .7), i.colorArray.emplaceBack(0, 0, f, 1.3), i.colorArray.emplaceBack(0, 0, f, 1.3), i.colorArray.emplaceBack(f + s, -1.2, f, .8), i.colorArray.emplaceBack(f + s, -1.2, f, .8), i.indexArray.emplaceBack(6 + r, 4 + r, 8 + r), i.indexArray.emplaceBack(7 + r, 9 + r, 5 + r), i.indexArray.emplaceBack(0 + r, 1 + r, 2 + r), i.indexArray.emplaceBack(1 + r, 3 + r, 2 + r), r += 10;
            }
            const n = {
                defined: !0,
                emissiveFactor: [
                    0,
                    0,
                    0
                ]
            }, o = {};
            return o.baseColorFactor = hi.white, n.pbrMetallicRoughness = o, i.material = n, i.aabb = new ed([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), i;
        }
        Rs(mT, "TriangleGridIndex");
        const AT = {
            vector: Vw,
            raster: jw,
            "raster-dem": class extends jw {
                constructor(e1, t, i, r){
                    super(e1, t, i, r), this.type = "raster-dem", this.maxzoom = 22, this._options = k({
                        type: "raster-dem"
                    }, t), this.encoding = t.encoding || "mapbox";
                }
                loadTile(e1, i) {
                    const r = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function n(t, r) {
                        t && (e1.state = "errored", i(t)), r && (e1.dem = r, e1.dem.onDeserialize(), e1.needsHillshadePrepare = !0, e1.needsDEMTextureUpload = !0, e1.state = "loaded", i(null));
                    }
                    e1.request = Ie(this.map._requestManager.transformRequest(r, ye.Tile), (function(r, o, s, a) {
                        if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                        else if (r) e1.state = "errored", i(r);
                        else if (o) {
                            this.map._refreshExpiredTiles && e1.setExpiryData({
                                cacheControl: s,
                                expires: a
                            });
                            const i = t.ImageBitmap && o instanceof t.ImageBitmap && ut(), r = 1 - (o.width - ((l = o.width) <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(l) / Math.LN2)))) / 2;
                            r < 1 || e1.neighboringTiles || (e1.neighboringTiles = this._getNeighboringTiles(e1.tileID));
                            const c = i ? o : dt.getImageData(o, r), h = {
                                uid: e1.uid,
                                coord: e1.tileID,
                                source: this.id,
                                scope: this.scope,
                                rawImageData: c,
                                encoding: this.encoding,
                                padding: r
                            };
                            e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", h, n.bind(this), void 0, !0));
                        }
                        var l;
                    }).bind(this));
                }
                _getNeighboringTiles(e1) {
                    const t = e1.canonical, i = Math.pow(2, t.z), r = (t.x - 1 + i) % i, n = 0 === t.x ? e1.wrap - 1 : e1.wrap, o = (t.x + 1 + i) % i, s = t.x + 1 === i ? e1.wrap + 1 : e1.wrap, a = {};
                    return a[new qu(e1.overscaledZ, n, t.z, r, t.y).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, s, t.z, o, t.y).key] = {
                        backfilled: !1
                    }, t.y > 0 && (a[new qu(e1.overscaledZ, n, t.z, r, t.y - 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, e1.wrap, t.z, t.x, t.y - 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, s, t.z, o, t.y - 1).key] = {
                        backfilled: !1
                    }), t.y + 1 < i && (a[new qu(e1.overscaledZ, n, t.z, r, t.y + 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, e1.wrap, t.z, t.x, t.y + 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, s, t.z, o, t.y + 1).key] = {
                        backfilled: !1
                    }), a;
                }
            },
            geojson: class extends zt {
                constructor(e1, t, i, r){
                    super(), this.id = e1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = i.getActor(), this.setEventedParent(r), this._data = t.data, this._options = k({}, t), this._collectResourceTiming = t.collectResourceTiming, void 0 !== t.maxzoom && (this.maxzoom = t.maxzoom), t.type && (this.type = t.type), t.attribution && (this.attribution = t.attribution), this.promoteId = t.promoteId;
                    const n = cr / this.tileSize;
                    this.workerOptions = k({
                        source: this.id,
                        scope: this.scope,
                        cluster: t.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== t.buffer ? t.buffer : 128) * n,
                            tolerance: (void 0 !== t.tolerance ? t.tolerance : .375) * n,
                            extent: cr,
                            maxZoom: this.maxzoom,
                            lineMetrics: t.lineMetrics || !1,
                            generateId: t.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== t.clusterMaxZoom ? t.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, t.clusterMinPoints || 2),
                            extent: cr,
                            radius: (void 0 !== t.clusterRadius ? t.clusterRadius : 50) * n,
                            log: !1,
                            generateId: t.generateId || !1
                        },
                        clusterProperties: t.clusterProperties,
                        filter: t.filter
                    }, t.workerOptions);
                }
                onAdd(e1) {
                    this.map = e1, this.setData(this._data);
                }
                setData(e1) {
                    return this._data = e1, this._updateWorkerData(), this;
                }
                getClusterExpansionZoom(e1, t) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }, t), this;
                }
                getClusterChildren(e1, t) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }, t), this;
                }
                getClusterLeaves(e1, t, i, r) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e1,
                        limit: t,
                        offset: i
                    }, r), this;
                }
                _updateWorkerData() {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new It("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const e1 = k({}, this.workerOptions);
                    e1.scope = this.scope;
                    const t = this._data;
                    "string" == typeof t ? (e1.request = this.map._requestManager.transformRequest(dt.resolveURL(t), ye.Source), e1.request.collectResourceTiming = this._collectResourceTiming) : e1.data = JSON.stringify(t), this._pendingLoad = this.actor.send(`${this.type}.loadData`, e1, (e1, t)=>{
                        if (this._loaded = !0, this._pendingLoad = null, e1) this.fire(new Ct(e1));
                        else {
                            const e1 = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && t && t.resourceTiming && t.resourceTiming[this.id] && (e1.resourceTiming = t.resourceTiming[this.id]), this.fire(new It("data", e1)), this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(e1, t) {
                    const i = e1.actor ? "reloadTile" : "loadTile";
                    e1.actor = this.actor;
                    const r = {
                        type: this.type,
                        uid: e1.uid,
                        tileID: e1.tileID,
                        tileZoom: e1.tileZoom,
                        zoom: e1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        scope: this.scope,
                        pixelRatio: dt.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0
                    };
                    e1.request = this.actor.send(i, r, (r, n)=>(delete e1.request, e1.destroy(), e1.aborted ? t(null) : r ? t(r) : (e1.loadVectorData(n, this.map.painter, "reloadTile" === i), t(null))), void 0, "loadTile" === i);
                }
                abortTile(e1) {
                    e1.request && (e1.request.cancel(), delete e1.request), e1.aborted = !0;
                }
                unloadTile(e1) {
                    this.actor.send("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e1.destroy();
                }
                onRemove() {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return k({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends Jb {
                constructor(e1, t, i, r){
                    super(e1, t, i, r), this.roundZoom = !0, this.type = "video", this.options = t;
                }
                load() {
                    this._loaded = !1;
                    const e1 = this.options;
                    this.urls = [];
                    for (const t of e1.urls)this.urls.push(this.map._requestManager.transformRequest(t, ye.Source).url);
                    !function(e1, i) {
                        const r = t.document.createElement("video");
                        r.muted = !0, r.onloadstart = function() {
                            i(null, r);
                        };
                        for(let i = 0; i < e1.length; i++){
                            const n = t.document.createElement("source");
                            Ee(e1[i]) || (r.crossOrigin = "Anonymous"), n.src = e1[i], r.appendChild(n);
                        }
                    }(this.urls, (e1, t)=>{
                        this._loaded = !0, e1 ? this.fire(new Ct(e1)) : t && (this.video = t, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(e1) {
                    if (this.video) {
                        const t = this.video.seekable;
                        e1 < t.start(0) || e1 > t.end(0) ? this.fire(new Ct(new Dt(`sources.${this.id}`, null, `Playback for this video can be set only between the ${t.start(0)} and ${t.end(0)}-second mark.`))) : this.video.currentTime = e1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e1) {
                    this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const e1 = this.map.painter.context, t = e1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, t.RGBA, t.UNSIGNED_BYTE, this.video)) : (this.texture = new My(e1, this.video, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(e1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: Jb,
            model: class extends zt {
                constructor(e1, t, i, r){
                    super(), this.id = e1, this.type = "model", this.models = [], this._loaded = !1, this._options = t;
                }
                load() {
                    const e1 = [];
                    for(const t in this._options.models){
                        const i = this._options.models[t], r = fT(this.map._requestManager.transformRequest(i.uri, ye.Model).url).then((e1)=>{
                            if (!e1) return;
                            const r = TT(e1), n = new Cv(t, i.position, i.orientation, r);
                            n.computeBoundsAndApplyParent(), this.models.push(n);
                        }).catch((e1)=>{
                            this.fire(new Ct(new Error(`Could not load model ${t} from ${i.uri}: ${e1.message}`)));
                        });
                        e1.push(r);
                    }
                    return Promise.allSettled(e1).then(()=>{
                        this._loaded = !0, this.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        }));
                    }).catch((e1)=>{
                        this.fire(new Ct(new Error(`Could not load models: ${e1.message}`)));
                    });
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                hasTransition() {
                    return !1;
                }
                loaded() {
                    return this._loaded;
                }
                getModels() {
                    return this.models;
                }
                loadTile(e1, t) {}
                serialize() {
                    return {
                        type: "model"
                    };
                }
            },
            "batched-model": class extends zt {
                constructor(e1, t, i, r){
                    super(), this.type = "batched-model", this.id = e1, this.tileSize = 512, this._options = t, this.tiles = this._options.tiles, this.maxzoom = t.maxzoom || 19, this.minzoom = t.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(r);
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                load(e1) {
                    this._loaded = !1, this.fire(new It("dataloading", {
                        dataType: "source"
                    }));
                    const t = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, i = this.map._worldview;
                    this._tileJSONRequest = Dw(this._options, this.map._requestManager, t, i, (r, n)=>{
                        this._tileJSONRequest = null, this._loaded = !0, r ? (t && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${t}`), i && 2 !== i.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${i}`), this.fire(new Ct(r))) : n && (k(this, n), n.bounds && (this.tileBounds = new Rw(n.bounds, this.minzoom, this.maxzoom)), Ge(n.tiles, this.map._requestManager._customAccessToken), this.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), e1 && e1(r);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e1) {
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(e1, t) {
                    const i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                        request: this.map._requestManager.transformRequest(i, ye.Tile),
                        data: void 0,
                        uid: e1.uid,
                        tileID: e1.tileID,
                        tileZoom: e1.tileZoom,
                        zoom: e1.tileID.overscaledZ,
                        tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        isSymbolTile: e1.isSymbolTile,
                        brightness: this.map.style && this.map.style.getBrightness() || 0
                    };
                    if (e1.actor && "expired" !== e1.state) {
                        if ("loading" === e1.state) e1.reloadCallback = t;
                        else {
                            if (e1.buckets) {
                                const t = Object.values(e1.buckets);
                                for (const e1 of t)e1.dirty = !0;
                                return void (e1.state = "loaded");
                            }
                            e1.request = e1.actor.send("reloadTile", r, n.bind(this));
                        }
                    } else e1.actor = this.dispatcher.getActor(), e1.request = e1.actor.send("loadTile", r, n.bind(this), void 0, !0);
                    function n(i, r) {
                        return e1.aborted ? t(null) : i && 404 !== i.status ? t(i) : (r && (r.resourceTiming && (e1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && e1.setExpiryData(r), e1.buckets = {
                            ...e1.buckets,
                            ...r.buckets
                        }), e1.state = "loaded", void t(null));
                    }
                }
                serialize() {
                    return k({}, this._options);
                }
            },
            canvas: class extends Jb {
                constructor(e1, i, r, n){
                    super(e1, i, r, n), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new Ct(new Dt(`sources.${e1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new Ct(new Dt(`sources.${e1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new Ct(new Dt(`sources.${e1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof t.HTMLCanvasElement || this.fire(new Ct(new Dt(`sources.${e1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new Ct(new Dt(`sources.${e1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof t.HTMLCanvasElement ? this.options.canvas : t.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new Ct(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e1) {
                    this.map = e1, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove() {
                    this.pause();
                }
                prepare() {
                    let e1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const t = this.map.painter.context;
                    this.texture ? !e1 && !this._playing || this.texture instanceof Ay || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new My(t, this.canvas, t.gl.RGBA, {
                        premultiply: !0
                    }), this._prepareData(t);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e1 of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e1) || e1 <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends zt {
                constructor(e1, t, i, r){
                    super(), this.id = e1, this.type = "custom", this._dataType = "raster", this._dispatcher = i, this._implementation = t, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new Ct(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new Ct(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new Rw(this._implementation.bounds, this.minzoom, this.maxzoom)), t.update = this._update.bind(this), t.clearTiles = this._clearTiles.bind(this), t.coveringTiles = this._coveringTiles.bind(this), k(this, O(t, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
                serialize() {
                    return O(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(e1) {
                    this._map = e1, this._loaded = !1, this.fire(new It("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(e1), this.load();
                }
                onRemove(e1) {
                    this._implementation.onRemove && this._implementation.onRemove(e1);
                }
                hasTile(e1) {
                    if (this._implementation.hasTile) {
                        const { x: t, y: i, z: r } = e1.canonical;
                        return this._implementation.hasTile({
                            x: t,
                            y: i,
                            z: r
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loadTile(e1, i) {
                    const { x: r, y: n, z: o } = e1.tileID.canonical, s = new t.AbortController;
                    e1.request = Promise.resolve(this._implementation.loadTile({
                        x: r,
                        y: n,
                        z: o
                    }, {
                        signal: s.signal
                    })).then((function(r) {
                        return delete e1.request, e1.aborted ? (e1.state = "unloaded", i(null)) : void 0 === r ? (e1.state = "errored", i(null)) : null === r ? (this.loadTileData(e1, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e1.state = "loaded", i(null)) : function(e1) {
                            return e1 instanceof t.ImageData || e1 instanceof t.HTMLCanvasElement || e1 instanceof t.ImageBitmap || e1 instanceof t.HTMLImageElement;
                        }(r) ? (this.loadTileData(e1, r), e1.state = "loaded", void i(null)) : (e1.state = "errored", i(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((t)=>{
                        20 !== t.code && (e1.state = "errored", i(t));
                    }), e1.request.cancel = ()=>s.abort();
                }
                loadTileData(e1, t) {
                    e1.setTexture(t, this._map.painter);
                }
                unloadTile(e1, t) {
                    if (e1.texture && e1.texture instanceof My ? (e1.destroy(!0), e1.texture && e1.texture instanceof My && this._map.painter.saveTileTexture(e1.texture)) : e1.destroy(), this._implementation.unloadTile) {
                        const { x: t, y: i, z: r } = e1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: t,
                            y: i,
                            z: r
                        });
                    }
                    t();
                }
                abortTile(e1, t) {
                    e1.request && e1.request.cancel && (e1.request.cancel(), delete e1.request), t();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this._map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e1)=>({
                            x: e1.canonical.x,
                            y: e1.canonical.y,
                            z: e1.canonical.z
                        }));
                }
                _clearTiles() {
                    const e1 = va(this.id, this.scope);
                    this._map.style.clearSource(e1);
                }
                _update() {
                    this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, ST = function(e1, t, i, r) {
            const n = new AT[t.type](e1, t, i, r);
            if (n.id !== e1) throw new Error(`Expected Source id to be ${e1} instead of ${n.id}`);
            return j([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], n), n;
        };
        function IT(e1, t) {
            const i = Au.identity([]);
            return Au.scale(i, i, [
                .5 * e1.width,
                .5 * -e1.height,
                1
            ]), Au.translate(i, i, [
                1,
                -1,
                0
            ]), Au.multiply(i, i, e1.calculateProjMatrix(t.toUnwrapped())), Float32Array.from(i);
        }
        function CT(e1, t, i, r, n, o, s, a = !1) {
            const l = e1.tilesIn(r, s, a);
            l.sort(PT);
            const c = [];
            for (const r of l)c.push({
                wrappedTileID: r.tile.tileID.wrapped().key,
                queryResults: r.tile.queryRenderedFeatures(t, i, e1._state, r, n, o, IT(e1.transform, r.tile.tileID), a)
            });
            const h = function(e1) {
                const t = {}, i = {};
                for (const r of e1){
                    const e1 = r.queryResults, n = r.wrappedTileID, o = i[n] = i[n] || {};
                    for(const i in e1){
                        const r = e1[i], n = o[i] = o[i] || {}, s = t[i] = t[i] || [];
                        for (const e1 of r)n[e1.featureIndex] || (n[e1.featureIndex] = !0, s.push(e1));
                    }
                }
                return t;
            }(c);
            for(const t in h)h[t].forEach((t)=>{
                const i = t.feature, r = i.layer;
                r && "background" !== r.type && "sky" !== r.type && "slot" !== r.type && (i.source = r.source, r["source-layer"] && (i.sourceLayer = r["source-layer"]), i.state = void 0 !== i.id ? e1.getFeatureState(r["source-layer"], i.id) : {});
            });
            return h;
        }
        function zT(e1, t) {
            const i = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), r = [], n = {};
            for(let e1 = 0; e1 < i.length; e1++){
                const o = i[e1], s = o.tileID.canonical.key;
                n[s] || (n[s] = !0, o.querySourceFeatures(r, t));
            }
            return r;
        }
        function PT(e1, t) {
            const i = e1.tileID, r = t.tileID;
            return i.overscaledZ - r.overscaledZ || i.canonical.y - r.canonical.y || i.wrap - r.wrap || i.canonical.x - r.canonical.x;
        }
        class DT {
            constructor(e1){
                this.style = e1;
            }
            processLayersChanged() {
                this.layers = [];
                for(const e1 in this.style._mergedLayers){
                    const t = this.style._mergedLayers[e1];
                    if ("fill-extrusion" === t.type) this.layers.push(t);
                    else if ("model" === t.type) {
                        const e1 = this.style.getLayerSource(t);
                        e1 && "batched-model" === e1.type && this.layers.push(t);
                    }
                }
            }
            updateZOffset(e1, t) {
                this.currentBuildingBuckets = [];
                for(let e1 = 0; e1 < this.layers.length; ++e1){
                    const i = this.layers[e1], r = this.style.getLayerSourceCache(i);
                    let n = 1;
                    "fill-extrusion" === i.type && (n = i.paint.get("fill-extrusion-opacity") > 0 ? i.paint.get("fill-extrusion-vertical-scale") : 0);
                    let o = r ? r.getTile(t) : null;
                    if (!o && r && t.canonical.z > r.getSource().minzoom) {
                        let e1 = t.scaledTo(Math.min(r.getSource().maxzoom, t.overscaledZ - 1));
                        for(; e1.overscaledZ >= r.getSource().minzoom && (o = r.getTile(e1), !o && 0 !== e1.overscaledZ);)e1 = e1.scaledTo(e1.overscaledZ - 1);
                    }
                    this.currentBuildingBuckets.push({
                        bucket: o ? o.getBucket(i) : null,
                        tileID: o ? o.tileID : t,
                        verticalScale: n
                    });
                }
                e1.hasAnyZOffset = !1;
                let i = !1;
                for(let r = 0; r < e1.symbolInstances.length; r++){
                    const n = e1.symbolInstances.get(r), o = n.zOffset, s = this._getHeightAtTileOffset(t, n.tileAnchorX, n.tileAnchorY);
                    n.zOffset = -1 !== s ? s : o, i || o === n.zOffset || (i = !0), e1.hasAnyZOffset || 0 === n.zOffset || (e1.hasAnyZOffset = !0);
                }
                i && (e1.zOffsetBuffersNeedUpload = !0, e1.zOffsetSortDirty = !0);
            }
            _mapCoordToOverlappingTile(e1, t, i, r) {
                let n = t, o = i;
                if (e1.canonical.z !== r.canonical.z) {
                    const s = r.canonical, a = 1 / (1 << e1.canonical.z - s.z);
                    n = (t + e1.canonical.x * cr) * a - s.x * cr | 0, o = (i + e1.canonical.y * cr) * a - s.y * cr | 0;
                }
                return {
                    tileX: n,
                    tileY: o
                };
            }
            _getHeightAtTileOffset(e1, t, i) {
                let r;
                for(let n = 0; n < this.layers.length; ++n){
                    if ("fill-extrusion" !== this.layers[n].type) continue;
                    const { bucket: o, tileID: s, verticalScale: a } = this.currentBuildingBuckets[n];
                    if (!o) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e1, t, i, s), h = o.getHeightAtTileCoord(l, c);
                    if (h && void 0 !== h.height) {
                        if (!h.hidden) return h.height * a;
                        r = h.height;
                    }
                }
                for(let n = 0; n < this.layers.length; ++n){
                    if ("model" !== this.layers[n].type) continue;
                    const { bucket: o, tileID: s } = this.currentBuildingBuckets[n];
                    if (!o) continue;
                    const { tileX: a, tileY: l } = this._mapCoordToOverlappingTile(e1, t, i, s), c = o.getHeightAtTileCoord(a, l);
                    if (c && !c.hidden) return void 0 === c.height && void 0 !== r ? Math.min(c.maxHeight, r) * c.verticalScale : (c.height || 0) * c.verticalScale;
                }
                return -1;
            }
        }
        var RT = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function LT(e1, t) {
            const i = {};
            for(const t in e1)"ref" !== t && (i[t] = e1[t]);
            return RT.forEach((e1)=>{
                e1 in t && (i[e1] = t[e1]);
            }), i;
        }
        function kT(e1) {
            e1 = e1.slice();
            const t = Object.create(null);
            for(let i = 0; i < e1.length; i++)t[e1[i].id] = e1[i];
            for(let i = 0; i < e1.length; i++)"ref" in e1[i] && (e1[i] = LT(e1[i], t[e1[i].ref]));
            return e1;
        }
        const OT = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setSlot: "setSlot",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setCamera: "setCamera",
            setLights: "setLights",
            setProjection: "setProjection",
            addImport: "addImport",
            removeImport: "removeImport",
            setImportUrl: "setImportUrl",
            setImportData: "setImportData",
            setImportConfig: "setImportConfig"
        };
        function BT(e1, t, i) {
            i.push({
                command: OT.addSource,
                args: [
                    e1,
                    t[e1]
                ]
            });
        }
        function FT(e1, t, i) {
            t.push({
                command: OT.removeSource,
                args: [
                    e1
                ]
            }), i[e1] = !0;
        }
        function NT(e1, t, i, r) {
            FT(e1, i, r), BT(e1, t, i);
        }
        function UT(e1, t, i) {
            let r;
            for(r in e1[i])if (e1[i].hasOwnProperty(r) && "data" !== r && !x(e1[i][r], t[i][r])) return !1;
            for(r in t[i])if (t[i].hasOwnProperty(r) && "data" !== r && !x(e1[i][r], t[i][r])) return !1;
            return !0;
        }
        function VT(e1, t, i, r, n, o) {
            let s;
            for(s in t = t || {}, e1 = e1 || {})e1.hasOwnProperty(s) && (x(e1[s], t[s]) || i.push({
                command: o,
                args: [
                    r,
                    s,
                    t[s],
                    n
                ]
            }));
            for(s in t)t.hasOwnProperty(s) && !e1.hasOwnProperty(s) && (x(e1[s], t[s]) || i.push({
                command: o,
                args: [
                    r,
                    s,
                    t[s],
                    n
                ]
            }));
        }
        function jT(e1) {
            return e1.id;
        }
        function GT(e1, t) {
            return e1[t.id] = t, e1;
        }
        class qT {
            constructor(e1, t){
                this.reset(e1, t);
            }
            reset(e1, t) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e1) {
                if (1 === this.points.length) return this.points[0];
                e1 = z(e1, 0, 1);
                let t = 1, i = this._distances[t];
                const r = e1 * this.paddedLength + this.padding;
                for(; i < r && t < this._distances.length;)i = this._distances[++t];
                const n = t - 1, o = this._distances[n], s = i - o, a = s > 0 ? (r - o) / s : 0;
                return this.points[n].mult(1 - a).add(this.points[t].mult(a));
            }
        }
        class ZT {
            constructor(e1, t, i){
                const r = this.boxCells = [], n = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t / i);
                for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)r.push([]), n.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e1, t, i, r, n) {
                this._forEachCell(t, i, r, n, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(r), this.bboxes.push(n);
            }
            insertCircle(e1, t, i, r) {
                this._forEachCell(t - r, i - r, t + r, i + r, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(i), this.circles.push(r);
            }
            _insertBoxCell(e1, t, i, r, n, o) {
                this.boxCells[n].push(o);
            }
            _insertCircleCell(e1, t, i, r, n, o) {
                this.circleCells[n].push(o);
            }
            _query(e1, t, i, r, n, o) {
                if (i < 0 || e1 > this.width || r < 0 || t > this.height) return !n && [];
                const s = [];
                if (e1 <= 0 && t <= 0 && this.width <= i && this.height <= r) {
                    if (n) return !0;
                    for(let e1 = 0; e1 < this.boxKeys.length; e1++)s.push({
                        key: this.boxKeys[e1],
                        x1: this.bboxes[4 * e1],
                        y1: this.bboxes[4 * e1 + 1],
                        x2: this.bboxes[4 * e1 + 2],
                        y2: this.bboxes[4 * e1 + 3]
                    });
                    for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                        const t = this.circles[3 * e1], i = this.circles[3 * e1 + 1], r = this.circles[3 * e1 + 2];
                        s.push({
                            key: this.circleKeys[e1],
                            x1: t - r,
                            y1: i - r,
                            x2: t + r,
                            y2: i + r
                        });
                    }
                    return o ? s.filter(o) : s;
                }
                return this._forEachCell(e1, t, i, r, this._queryCell, s, {
                    hitTest: n,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, o), n ? s.length > 0 : s;
            }
            _queryCircle(e1, t, i, r, n) {
                const o = e1 - i, s = e1 + i, a = t - i, l = t + i;
                if (s < 0 || o > this.width || l < 0 || a > this.height) return !r && [];
                const c = [];
                return this._forEachCell(o, a, s, l, this._queryCellCircle, c, {
                    hitTest: r,
                    circle: {
                        x: e1,
                        y: t,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, n), r ? c.length > 0 : c;
            }
            query(e1, t, i, r, n) {
                return this._query(e1, t, i, r, !1, n);
            }
            hitTest(e1, t, i, r, n) {
                return this._query(e1, t, i, r, !0, n);
            }
            hitTestCircle(e1, t, i, r) {
                return this._queryCircle(e1, t, i, !0, r);
            }
            _queryCell(e1, t, i, r, n, o, s, a) {
                const l = s.seenUids, c = this.boxCells[n];
                if (null !== c) {
                    const n = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e1 <= n[c + 2] && t <= n[c + 3] && i >= n[c + 0] && r >= n[c + 1] && (!a || a(this.boxKeys[h]))) {
                            if (s.hitTest) return o.push(!0), !0;
                            o.push({
                                key: this.boxKeys[h],
                                x1: n[c],
                                y1: n[c + 1],
                                x2: n[c + 2],
                                y2: n[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[n];
                if (null !== h) {
                    const n = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(n[h], n[h + 1], n[h + 2], e1, t, i, r) && (!a || a(this.circleKeys[c]))) {
                            if (s.hitTest) return o.push(!0), !0;
                            {
                                const e1 = n[h], t = n[h + 1], i = n[h + 2];
                                o.push({
                                    key: this.circleKeys[c],
                                    x1: e1 - i,
                                    y1: t - i,
                                    x2: e1 + i,
                                    y2: t + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e1, t, i, r, n, o, s, a) {
                const l = s.circle, c = s.seenUids, h = this.boxCells[n];
                if (null !== h) {
                    const e1 = this.bboxes;
                    for (const t of h)if (!c.box[t]) {
                        c.box[t] = !0;
                        const i = 4 * t;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!a || a(this.boxKeys[t]))) return o.push(!0), !0;
                    }
                }
                const u = this.circleCells[n];
                if (null !== u) {
                    const e1 = this.circles;
                    for (const t of u)if (!c.circle[t]) {
                        c.circle[t] = !0;
                        const i = 3 * t;
                        if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!a || a(this.circleKeys[t]))) return o.push(!0), !0;
                    }
                }
            }
            _forEachCell(e1, t, i, r, n, o, s, a) {
                const l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(r);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (n.call(this, e1, t, i, r, this.xCellCount * l + d, o, s, a)) return;
            }
            _convertToXCellCoord(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _convertToYCellCoord(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _circlesCollide(e1, t, i, r, n, o) {
                const s = r - e1, a = n - t, l = i + o;
                return l * l > s * s + a * a;
            }
            _circleAndRectCollide(e1, t, i, r, n, o, s) {
                const a = (o - r) / 2, l = Math.abs(e1 - (r + a));
                if (l > a + i) return !1;
                const c = (s - n) / 2, h = Math.abs(t - (n + c));
                if (h > c + i) return !1;
                if (l <= a || h <= c) return !0;
                const u = l - a, d = h - c;
                return u * u + d * d <= i * i;
            }
        }
        const $T = 100;
        class WT {
            constructor(e1, t, i = new ZT(e1.width + 200, e1.height + 200, 25), r = new ZT(e1.width + 200, e1.height + 200, 25)){
                this.transform = e1, this.grid = i, this.ignoredGrid = r, this.pitchfactor = Math.cos(e1._pitch) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + $T, this.screenBottomBoundary = e1.height + $T, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.fogState = t;
            }
            placeCollisionBox(e1, t, i, r, n, o, s, a) {
                let l = i.projectedAnchorX, c = i.projectedAnchorY, h = i.projectedAnchorZ;
                const u = i.elevation, d = i.tileID, p = e1.getProjection();
                if (u && d) {
                    const [e1, t, r] = p.upVector(d.canonical, i.tileAnchorX, i.tileAnchorY), n = p.upVectorScale(d.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    l += e1 * u * n, c += t * u * n, h += r * u * n;
                }
                const f = this.projectAndGetPerspectiveRatio(s, l, c, h, i.tileID, "globe" === p.name || !!u || this.transform.pitch > 0, p), m = o * f.perspectiveRatio, _ = (i.x1 * t + r.x - i.padding) * m + f.point.x, g = (i.y1 * t + r.y - i.padding) * m + f.point.y, y = (i.x2 * t + r.x + i.padding) * m + f.point.x, x = (i.y2 * t + r.y + i.padding) * m + f.point.y, v = f.perspectiveRatio <= .55 || f.occluded;
                return !this.isInsideGrid(_, g, y, x) || !n && this.grid.hitTest(_, g, y, x, a) || v ? {
                    box: [],
                    offscreen: !1,
                    occluded: f.occluded
                } : {
                    box: [
                        _,
                        g,
                        y,
                        x
                    ],
                    offscreen: this.isOffscreen(_, g, y, x),
                    occluded: !1
                };
            }
            placeCollisionCircles(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f) {
                const m = [], _ = this.transform.elevation, g = e1.getProjection(), x = _ ? _.getAtTileOffsetFunc(f, this.transform.center.lat, this.transform.worldSize, g) : null, v = new y(i.tileAnchorX, i.tileAnchorY);
                let { x: b, y: w, z: T } = g.projectTilePoint(v.x, v.y, f.canonical);
                if (x) {
                    const [e1, t, i] = x(v);
                    b += e1, w += t, T += i;
                }
                const E = "globe" === g.name, M = this.projectAndGetPerspectiveRatio(s, b, w, T, f, E || !!_ || this.transform.pitch > 0, g), { perspectiveRatio: A } = M, S = (h ? o / A : o * A) / u_, I = cv(b, w, T, a), C = M.signedDistanceFromCamera > 0 ? pv(S, n, i.lineOffsetX * S, i.lineOffsetY * S, !1, I, v, i, r, a, {}, _ && !h ? x : null, h && !!_, g, f, h) : null;
                let z = !1, P = !1, D = !0;
                if (C && !M.occluded) {
                    const e1 = .5 * d * A + p, i = new y(-100, -100), r = new y(this.screenRightBoundary, this.screenBottomBoundary), n = new qT, { first: o, last: s } = C, a = o.path.length;
                    let h = [];
                    for(let e1 = a - 1; e1 >= 1; e1--)h.push(o.path[e1]);
                    for(let e1 = 1; e1 < s.path.length; e1++)h.push(s.path[e1]);
                    const f = 2.5 * e1;
                    l && (h = h.map(([e1, t, i], r)=>(x && !E && (i = x(r < a - 1 ? o.tilePath[a - 1 - r] : s.tilePath[r - a + 2])[2]), cv(e1, t, i, l))), h.some((e1)=>e1[3] <= 0) && (h = []));
                    let _ = [];
                    if (h.length > 0) {
                        let e1 = 1 / 0, t = -1 / 0, n = 1 / 0, o = -1 / 0;
                        for (const i of h)e1 = Math.min(e1, i[0]), n = Math.min(n, i[1]), t = Math.max(t, i[0]), o = Math.max(o, i[1]);
                        t >= i.x && e1 <= r.x && o >= i.y && n <= r.y && (_ = [
                            h.map((e1)=>new y(e1[0], e1[1]))
                        ], (e1 < i.x || t > r.x || n < i.y || o > r.y) && (_ = Y_(_, i.x, i.y, r.x, r.y)));
                    }
                    for (const i of _){
                        n.reset(i, .25 * e1);
                        let r = 0;
                        r = n.length <= .5 * e1 ? 1 : Math.ceil(n.paddedLength / f) + 1;
                        for(let i = 0; i < r; i++){
                            const o = i / Math.max(r - 1, 1), s = n.lerp(o), a = s.x + $T, l = s.y + $T;
                            m.push(a, l, e1, 0);
                            const h = a - e1, d = l - e1, p = a + e1, f = l + e1;
                            if (D = D && this.isOffscreen(h, d, p, f), P = P || this.isInsideGrid(h, d, p, f), !t && this.grid.hitTestCircle(a, l, e1, u) && (z = !0, !c)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: z,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !c && z || !P ? [] : m,
                    offscreen: D,
                    collisionDetected: z,
                    occluded: M.occluded
                };
            }
            queryRenderedSymbols(e1) {
                if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const t = [];
                let i = 1 / 0, r = 1 / 0, n = -1 / 0, o = -1 / 0;
                for (const s of e1){
                    const e1 = new y(s.x + $T, s.y + $T);
                    i = Math.min(i, e1.x), r = Math.min(r, e1.y), n = Math.max(n, e1.x), o = Math.max(o, e1.y), t.push(e1);
                }
                const s = this.grid.query(i, r, n, o).concat(this.ignoredGrid.query(i, r, n, o)), a = {}, l = {};
                for (const e1 of s){
                    const i = e1.key;
                    void 0 === a[i.bucketInstanceId] && (a[i.bucketInstanceId] = {}), a[i.bucketInstanceId][i.featureIndex] || bp(t, [
                        new y(e1.x1, e1.y1),
                        new y(e1.x2, e1.y1),
                        new y(e1.x2, e1.y2),
                        new y(e1.x1, e1.y2)
                    ]) && (a[i.bucketInstanceId][i.featureIndex] = !0, void 0 === l[i.bucketInstanceId] && (l[i.bucketInstanceId] = []), l[i.bucketInstanceId].push(i.featureIndex));
                }
                return l;
            }
            insertCollisionBox(e1, t, i, r, n) {
                (t ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: r,
                    collisionGroupID: n
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t, i, r, n) {
                const o = t ? this.ignoredGrid : this.grid, s = {
                    bucketInstanceId: i,
                    featureIndex: r,
                    collisionGroupID: n
                };
                for(let t = 0; t < e1.length; t += 4)o.insertCircle(s, e1[t], e1[t + 1], e1[t + 2]);
            }
            projectAndGetPerspectiveRatio(e1, t, i, r, n, o, s) {
                const a = [
                    t,
                    i,
                    r,
                    1
                ];
                let l = !1;
                if (r || this.transform.pitch > 0) {
                    if (yu.transformMat4(a, a, e1), this.fogState && n && "globe" !== s.name) {
                        const e1 = function(e1, t, i, r, n, o) {
                            const s = o.calculateFogTileMatrix(n), a = [
                                t,
                                i,
                                r
                            ];
                            return Du.transformMat4(a, a, s), mw(e1, Du.length(a), o.pitch, o._fov);
                        }(this.fogState, t, i, r, n.toUnwrapped(), this.transform);
                        l = e1 > .9;
                    }
                } else vv(a, a, e1);
                const c = a[3];
                return {
                    point: new y((a[0] / c + 1) / 2 * this.transform.width + $T, (-a[1] / c + 1) / 2 * this.transform.height + $T),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(s) / c * .5, 1.5),
                    signedDistanceFromCamera: c,
                    occluded: o && a[2] > c || l
                };
            }
            isOffscreen(e1, t, i, r) {
                return i < $T || e1 >= this.screenRightBoundary || r < $T || t > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t, i, r) {
                return i >= 0 && e1 < this.gridRightBoundary && r >= 0 && t < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e1 = Au.identity([]);
                return Au.translate(e1, e1, [
                    -100,
                    -100,
                    0
                ]), e1;
            }
        }
        function HT(e1, t, i) {
            const r = t.createTileMatrix(e1, e1.worldSize, i.toUnwrapped());
            return Au.multiply(new Float32Array(16), e1.projMatrix, r);
        }
        function XT(e1, t, i) {
            if (t.projection.name === i.projection.name) return e1.projMatrix;
            const r = i.clone();
            return r.setProjection(t.projection), HT(r, t.getProjection(), e1);
        }
        function YT(e1, t, i) {
            return t.name === i.projection.name ? e1.projMatrix : HT(i, t, e1);
        }
        class KT {
            constructor(e1, t, i, r){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : r && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class JT {
            constructor(e1, t, i, r, n, o = !1){
                this.text = new KT(e1 ? e1.text : null, t, i, n), this.icon = new KT(e1 ? e1.icon : null, t, r, n), this.clipped = o;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class QT {
            constructor(e1, t, i, r = !1){
                this.text = e1, this.icon = t, this.skipFade = i, this.clipped = r;
            }
        }
        class eE {
            constructor(){
                this.invProjMatrix = Au.create(), this.viewportMatrix = Au.create(), this.circles = [];
            }
        }
        class tE {
            constructor(e1, t, i, r, n){
                this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = r, this.tileID = n;
            }
        }
        class iE {
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t,
                        predicate: (e1)=>e1.collisionGroupID === t
                    };
                }
                return this.collisionGroups[e1];
            }
        }
        function rE(e1, t, i, r, n) {
            const { horizontalAlign: o, verticalAlign: s } = F_(e1), a = -(o - .5) * t, l = -(s - .5) * i, c = xg(e1, r);
            return new y(a + c[0] * n, l + c[1] * n);
        }
        function nE(e1, t, i, r, n) {
            const o = new y(e1, t);
            return i && o._rotate(r ? n : -n), o;
        }
        class oE {
            constructor(e1, t, i, r, n, o){
                this.transform = e1.clone(), this.projection = e1.projection.name, this.collisionIndex = new WT(this.transform, n), this.buildingIndex = o, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t, this.retainedQueryData = {}, this.collisionGroups = new iE(i), this.collisionCircleArrays = {}, this.prevPlacement = r, r && (r.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(e1, t, i, r) {
                const n = i.getBucket(t), o = i.latestFeatureIndex;
                if (!n || !o || t.fqid !== n.layerIds[0]) return;
                const s = n.layers[0].layout, a = i.collisionBoxArray, l = Math.pow(2, this.transform.zoom - i.tileID.overscaledZ), c = i.tileSize / cr, h = i.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const u = (d = i.tileID, p = n.getProjection(), f = this.transform, p.name === this.projection ? f.calculateProjMatrix(d.toUnwrapped()) : HT(f, p, d));
                var d, p, f;
                const m = "map" === s.get("text-pitch-alignment"), _ = "map" === s.get("text-rotation-alignment");
                t.compileFilter();
                const g = t.dynamicFilter(), y = t.dynamicFilterNeedsFeature(), x = this.transform.calculatePixelsToTileUnitsMatrix(i), v = av(u, i.tileID.canonical, m, _, this.transform, n.getProjection(), x);
                let b = null;
                if (m) {
                    const e1 = lv(u, i.tileID.canonical, m, _, this.transform, n.getProjection(), x);
                    b = Au.multiply([], this.transform.labelPlaneMatrix, e1);
                }
                let w = null;
                g && i.latestFeatureIndex && (w = {
                    unwrappedTileID: h,
                    dynamicFilter: g,
                    dynamicFilterNeedsFeature: y,
                    featureIndex: i.latestFeatureIndex
                }), this.retainedQueryData[n.bucketInstanceId] = new tE(n.bucketInstanceId, o, n.sourceLayerIndex, n.index, i.tileID);
                const T = {
                    bucket: n,
                    layout: s,
                    posMatrix: u,
                    textLabelPlaneMatrix: v,
                    labelToScreenMatrix: b,
                    clippingData: w,
                    scale: l,
                    textPixelRatio: c,
                    holdingForFade: i.holdingForFade(),
                    collisionBoxArray: a,
                    partiallyEvaluatedTextSize: m_(n.textSizeData, this.transform.zoom),
                    partiallyEvaluatedIconSize: m_(n.iconSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(n.sourceID)
                };
                if (r) for (const t of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: r, symbolInstanceEnd: n } = t;
                    e1.push({
                        sortKey: i,
                        symbolInstanceStart: r,
                        symbolInstanceEnd: n,
                        parameters: T
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: T
                });
            }
            attemptAnchorPlacement(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g) {
                const { textOffset0: y, textOffset1: x, crossTileID: v } = u, b = [
                    y,
                    x
                ], w = rE(e1, i, r, b, n), T = this.collisionIndex.placeCollisionBox(p, n, t, nE(w.x, w.y, o, s, this.transform.angle), h, a, l, c.predicate);
                if (m) {
                    const e1 = p.getSymbolInstanceIconSize(g, this.transform.zoom, u.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(p, e1, m, nE(w.x, w.y, o, s, this.transform.angle), h, a, l, c.predicate).box.length) return;
                }
                if (T.box.length > 0) {
                    let t;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[v] && this.prevPlacement.placements[v] && this.prevPlacement.placements[v].text && (t = this.prevPlacement.variableOffsets[v].anchor), this.variableOffsets[v] = {
                        textOffset: b,
                        width: i,
                        height: r,
                        anchor: e1,
                        textScale: n,
                        prevAnchor: t
                    }, this.markUsedJustification(p, e1, u, f), p.allowVerticalPlacement && (this.markUsedOrientation(p, f, u), this.placedOrientations[v] = f), {
                        shift: w,
                        placedGlyphBoxes: T
                    };
                }
            }
            placeLayerBucketPart(e1, t, i, r) {
                const { bucket: n, layout: o, posMatrix: s, textLabelPlaneMatrix: a, labelToScreenMatrix: l, clippingData: c, textPixelRatio: h, holdingForFade: u, collisionBoxArray: d, partiallyEvaluatedTextSize: p, partiallyEvaluatedIconSize: f, collisionGroup: m } = e1.parameters, _ = o.get("text-optional"), g = o.get("icon-optional"), x = o.get("text-allow-overlap"), v = o.get("icon-allow-overlap"), b = "map" === o.get("text-rotation-alignment"), w = "map" === o.get("text-pitch-alignment"), T = "viewport-y" === o.get("symbol-z-order"), E = o.get("symbol-z-elevate");
                this.transform.setProjection(n.projection);
                let M = x && (v || !n.hasIconData() || g), A = v && (x || !n.hasTextData() || _);
                !n.collisionArrays && d && n.deserializeCollisionBoxes(d), i && r && n.updateCollisionDebugBuffers(this.transform.zoom, d);
                const S = (e1, r, d)=>{
                    const { crossTileID: T, numVerticalGlyphVertices: E } = e1;
                    if (c) {
                        const i = {
                            zoom: this.transform.zoom,
                            pitch: this.transform.pitch
                        };
                        let r = null;
                        if (c.dynamicFilterNeedsFeature) {
                            const t = this.retainedQueryData[n.bucketInstanceId];
                            r = c.featureIndex.loadFeature({
                                featureIndex: e1.featureIndex,
                                bucketIndex: t.bucketIndex,
                                sourceLayerIndex: t.sourceLayerIndex,
                                layoutVertexArrayOffset: 0
                            });
                        }
                        if (!(0, c.dynamicFilter)(i, r, this.retainedQueryData[n.bucketInstanceId].tileID.canonical, new y(e1.tileAnchorX, e1.tileAnchorY), this.transform.calculateDistanceTileData(c.unwrappedTileID))) return this.placements[T] = new QT(!1, !1, !1, !0), void t.add(T);
                    }
                    if (t.has(T)) return;
                    if (u) return void (this.placements[T] = new QT(!1, !1, !1));
                    let S = !1, I = !1, C = !0, z = !1, P = !1, D = null, R = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, L = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, k = null, O = null, B = null, F = 0, N = 0, U = 0;
                    d.textFeatureIndex ? F = d.textFeatureIndex : e1.useRuntimeCollisionCircles && (F = e1.featureIndex), d.verticalTextFeatureIndex && (N = d.verticalTextFeatureIndex);
                    const V = (t)=>{
                        t.tileID = this.retainedQueryData[n.bucketInstanceId].tileID;
                        const i = this.transform.elevation;
                        t.elevation = e1.zOffset + (i ? i.getAtTileOffset(t.tileID, t.tileAnchorX, t.tileAnchorY) : 0);
                    }, j = d.textBox;
                    if (j) {
                        V(j);
                        const t = (t)=>{
                            let i = A_.horizontal;
                            if (n.allowVerticalPlacement && !t && this.prevPlacement) {
                                const t = this.prevPlacement.placedOrientations[T];
                                t && (this.placedOrientations[T] = t, i = t, this.markUsedOrientation(n, i, e1));
                            }
                            return i;
                        }, i = (e1, t)=>{
                            if (n.allowVerticalPlacement && E > 0 && d.verticalTextBox) {
                                for (const i of n.writingModes)if (i === A_.vertical ? (R = t(), L = R) : R = e1(), R && R.box && R.box.length) break;
                            } else R = e1();
                        };
                        if (o.get("text-variable-anchor")) {
                            let a = o.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[T]) {
                                const e1 = this.prevPlacement.variableOffsets[T];
                                a.indexOf(e1.anchor) > 0 && (a = a.filter((t)=>t !== e1.anchor), a.unshift(e1.anchor));
                            }
                            const l = (t, i, o)=>{
                                const l = n.getSymbolInstanceTextSize(p, e1, this.transform.zoom, r), c = (t.x2 - t.x1) * l + 2 * t.padding, u = (t.y2 - t.y1) * l + 2 * t.padding, d = e1.hasIconTextFit && !v ? i : null;
                                d && V(d);
                                let _ = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const g = x ? 2 * a.length : a.length;
                                for(let i = 0; i < g; ++i){
                                    const g = this.attemptAnchorPlacement(a[i % a.length], t, c, u, l, b, w, h, s, m, i >= a.length, e1, r, n, o, d, p, f);
                                    if (g && (_ = g.placedGlyphBoxes, _ && _.box && _.box.length)) {
                                        S = !0, D = g.shift;
                                        break;
                                    }
                                }
                                return _;
                            };
                            i(()=>l(j, d.iconBox, A_.horizontal), ()=>{
                                const e1 = d.verticalTextBox;
                                return e1 && V(e1), n.allowVerticalPlacement && !(R && R.box && R.box.length) && E > 0 && e1 ? l(e1, d.verticalIconBox, A_.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), R && (S = R.box, C = R.offscreen, z = R.occluded);
                            const c = t(!(!R || !R.box));
                            if (!S && this.prevPlacement) {
                                const t = this.prevPlacement.variableOffsets[T];
                                t && (this.variableOffsets[T] = t, this.markUsedJustification(n, t.anchor, e1, c));
                            }
                        } else {
                            const o = (t, i)=>{
                                const o = n.getSymbolInstanceTextSize(p, e1, this.transform.zoom, r), a = this.collisionIndex.placeCollisionBox(n, o, t, new y(0, 0), x, h, s, m.predicate);
                                return a && a.box && a.box.length && (this.markUsedOrientation(n, i, e1), this.placedOrientations[T] = i), a;
                            };
                            i(()=>o(j, A_.horizontal), ()=>{
                                const e1 = d.verticalTextBox;
                                return n.allowVerticalPlacement && E > 0 && e1 ? (V(e1), o(e1, A_.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), t(!!(R && R.box && R.box.length));
                        }
                    }
                    if (k = R, S = k && k.box && k.box.length > 0, C = k && k.offscreen, z = k && k.occluded, e1.useRuntimeCollisionCircles) {
                        const t = n.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex >= 0 ? e1.centerJustifiedTextSymbolIndex : e1.verticalPlacedTextSymbolIndex), r = f_(n.textSizeData, p, t), c = o.get("text-padding");
                        O = this.collisionIndex.placeCollisionCircles(n, x, t, n.lineVertexArray, n.glyphOffsetArray, r, s, a, l, i, w, m.predicate, e1.collisionCircleDiameter * r / u_, c, this.retainedQueryData[n.bucketInstanceId].tileID), S = x || O.circles.length > 0 && !O.collisionDetected, C = C && O.offscreen, z = O.occluded;
                    }
                    if (d.iconFeatureIndex && (U = d.iconFeatureIndex), d.iconBox) {
                        const t = (t)=>{
                            V(t);
                            const i = e1.hasIconTextFit && D ? nE(D.x, D.y, b, w, this.transform.angle) : new y(0, 0), r = n.getSymbolInstanceIconSize(f, this.transform.zoom, e1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(n, r, t, i, v, h, s, m.predicate);
                        };
                        L && L.box && L.box.length && d.verticalIconBox ? (B = t(d.verticalIconBox), I = B.box.length > 0) : (B = t(d.iconBox), I = B.box.length > 0), C = C && B.offscreen, P = B.occluded;
                    }
                    const G = _ || 0 === e1.numHorizontalGlyphVertices && 0 === E, q = g || 0 === e1.numIconVertices;
                    if (G || q ? q ? G || (I = I && S) : S = I && S : I = S = I && S, S && k && k.box && this.collisionIndex.insertCollisionBox(k.box, o.get("text-ignore-placement"), n.bucketInstanceId, L && L.box && N ? N : F, m.ID), I && B && this.collisionIndex.insertCollisionBox(B.box, o.get("icon-ignore-placement"), n.bucketInstanceId, U, m.ID), O && (S && this.collisionIndex.insertCollisionCircles(O.circles, o.get("text-ignore-placement"), n.bucketInstanceId, F, m.ID), i)) {
                        const e1 = n.bucketInstanceId;
                        let t = this.collisionCircleArrays[e1];
                        void 0 === t && (t = this.collisionCircleArrays[e1] = new eE);
                        for(let e1 = 0; e1 < O.circles.length; e1 += 4)t.circles.push(O.circles[e1 + 0]), t.circles.push(O.circles[e1 + 1]), t.circles.push(O.circles[e1 + 2]), t.circles.push(O.collisionDetected ? 1 : 0);
                    }
                    const Z = "globe" !== n.projection.name;
                    M = M && (Z || !z), A = A && (Z || !P), this.placements[T] = new QT(S || M, I || A, C || n.justReloaded), t.add(T);
                };
                if (E && this.buildingIndex && (this.buildingIndex.updateZOffset(n, this.retainedQueryData[n.bucketInstanceId].tileID), n.updateZOffset()), T) {
                    const e1 = n.getSortedSymbolIndexes(this.transform.angle);
                    for(let t = e1.length - 1; t >= 0; --t){
                        const i = e1[t];
                        S(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                    n.hasAnyZOffset && H(`${n.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (n.hasAnyZOffset) {
                    const e1 = n.getSortedIndexesByZOffset();
                    for(let t = 0; t < e1.length; ++t){
                        const i = e1[t];
                        S(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)S(n.symbolInstances.get(t), t, n.collisionArrays[t]);
                if (i && n.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[n.bucketInstanceId];
                    Au.invert(e1.invProjMatrix, s), e1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                n.justReloaded = !1;
            }
            markUsedJustification(e1, t, i, r) {
                const { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: o, rightJustifiedTextSymbolIndex: s, verticalPlacedTextSymbolIndex: a, crossTileID: l } = i, c = bg(t), h = r === A_.vertical ? a : "left" === c ? n : "center" === c ? o : "right" === c ? s : -1;
                n >= 0 && (e1.text.placedSymbolArray.get(n).crossTileID = h >= 0 && n !== h ? 0 : l), o >= 0 && (e1.text.placedSymbolArray.get(o).crossTileID = h >= 0 && o !== h ? 0 : l), s >= 0 && (e1.text.placedSymbolArray.get(s).crossTileID = h >= 0 && s !== h ? 0 : l), a >= 0 && (e1.text.placedSymbolArray.get(a).crossTileID = h >= 0 && a !== h ? 0 : l);
            }
            markUsedOrientation(e1, t, i) {
                const r = t === A_.horizontal || t === A_.horizontalOnly ? t : 0, n = t === A_.vertical ? t : 0, { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: s, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l } = i, c = e1.text.placedSymbolArray;
                o >= 0 && (c.get(o).placedOrientation = r), s >= 0 && (c.get(s).placedOrientation = r), a >= 0 && (c.get(a).placedOrientation = r), l >= 0 && (c.get(l).placedOrientation = n);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
                const r = t ? t.symbolFadeChange(e1) : 1, n = t ? t.opacities : {}, o = t ? t.variableOffsets : {}, s = t ? t.placedOrientations : {};
                for(const e1 in this.placements){
                    const t = this.placements[e1], o = n[e1];
                    o ? (this.opacities[e1] = new JT(o, r, t.text, t.icon, null, t.clipped), i = i || t.text !== o.text.placed || t.icon !== o.icon.placed) : (this.opacities[e1] = new JT(null, r, t.text, t.icon, t.skipFade, t.clipped), i = i || t.text || t.icon);
                }
                for(const e1 in n){
                    const t = n[e1];
                    if (!this.opacities[e1]) {
                        const n = new JT(t, r, !1, !1);
                        n.isHidden() || (this.opacities[e1] = n, i = i || t.text.placed || t.icon.placed);
                    }
                }
                for(const e1 in o)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = o[e1]);
                for(const e1 in s)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = s[e1]);
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(e1, t) {
                const i = new Set;
                for (const r of t){
                    const t = r.getBucket(e1);
                    t && r.latestFeatureIndex && e1.fqid === t.layerIds[0] && (this.updateBucketOpacities(t, i, r.collisionBoxArray), t.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(t, r.tileID), t.updateZOffset()));
                }
            }
            updateBucketOpacities(e1, t, i) {
                e1.hasTextData() && e1.text.opacityVertexArray.clear(), e1.hasIconData() && e1.icon.opacityVertexArray.clear(), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                const r = e1.layers[0].layout, n = !!e1.layers[0].dynamicFilter(), o = new JT(null, 0, !1, !1, !0), s = r.get("text-allow-overlap"), a = r.get("icon-allow-overlap"), l = r.get("text-variable-anchor"), c = "map" === r.get("text-rotation-alignment"), h = "map" === r.get("text-pitch-alignment"), u = new JT(null, 0, s && (a || !e1.hasIconData() || r.get("icon-optional")), a && (s || !e1.hasTextData() || r.get("text-optional")), !0);
                !e1.collisionArrays && i && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(i);
                const d = (e1, t, i)=>{
                    for(let r = 0; r < t / 4; r++)e1.opacityVertexArray.emplaceBack(i);
                };
                let p = 0;
                for(let i = 0; i < e1.symbolInstances.length; i++){
                    const r = e1.symbolInstances.get(i), { numHorizontalGlyphVertices: s, numVerticalGlyphVertices: a, crossTileID: f, numIconVertices: m } = r, _ = t.has(f);
                    let g = this.opacities[f];
                    _ ? g = o : g || (g = u, this.opacities[f] = g), t.add(f);
                    const x = s > 0 || a > 0, v = m > 0, b = this.placedOrientations[f], w = b === A_.vertical, T = b === A_.horizontal || b === A_.horizontalOnly;
                    if (!x && !v || g.isHidden() || p++, x) {
                        const t = fE(g.text);
                        d(e1.text, s, w ? mE : t), d(e1.text, a, T ? mE : t);
                        const i = g.text.isHidden(), { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: o, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = r, h = e1.text.placedSymbolArray, u = i || w ? 1 : 0;
                        n >= 0 && (h.get(n).hidden = u), o >= 0 && (h.get(o).hidden = u), l >= 0 && (h.get(l).hidden = u), c >= 0 && (h.get(c).hidden = i || T ? 1 : 0);
                        const p = this.variableOffsets[f];
                        p && this.markUsedJustification(e1, p.anchor, r, b);
                        const m = this.placedOrientations[f];
                        m && (this.markUsedJustification(e1, "left", r, m), this.markUsedOrientation(e1, m, r));
                    }
                    if (v) {
                        const t = fE(g.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: n } = r, o = e1.icon.placedSymbolArray, s = g.icon.isHidden() ? 1 : 0;
                        i >= 0 && (d(e1.icon, m, w ? mE : t), o.get(i).hidden = s), n >= 0 && (d(e1.icon, r.numVerticalIconVertices, T ? mE : t), o.get(n).hidden = s);
                    }
                    if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                        const t = e1.collisionArrays[i];
                        if (t) {
                            let i = new y(0, 0), o = !0;
                            if (t.textBox || t.verticalTextBox) {
                                if (l) {
                                    const e1 = this.variableOffsets[f];
                                    e1 ? (i = rE(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textScale), c && i._rotate(h ? this.transform.angle : -this.transform.angle)) : o = !1;
                                }
                                n && (o = !g.clipped), t.textBox && sE(e1.textCollisionBox.collisionVertexArray, g.text.placed, !o || w, i.x, i.y), t.verticalTextBox && sE(e1.textCollisionBox.collisionVertexArray, g.text.placed, !o || T, i.x, i.y);
                            }
                            const s = o && Boolean(!T && t.verticalIconBox);
                            t.iconBox && sE(e1.iconCollisionBox.collisionVertexArray, g.icon.placed, s, r.hasIconTextFit ? i.x : 0, r.hasIconTextFit ? i.y : 0), t.verticalIconBox && sE(e1.iconCollisionBox.collisionVertexArray, g.icon.placed, !s, r.hasIconTextFit ? i.x : 0, r.hasIconTextFit ? i.y : 0);
                        }
                    }
                }
                if (e1.fullyClipped = 0 === p, e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.bucketInstanceId in this.collisionCircleArrays) {
                    const t = this.collisionCircleArrays[e1.bucketInstanceId];
                    e1.placementInvProjMatrix = t.invProjMatrix, e1.placementViewportMatrix = t.viewportMatrix, e1.collisionCircleArray = t.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
                }
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t) {
                const i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
                return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e1;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function sE(e1, t, i, r, n) {
            e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0);
        }
        const aE = Math.pow(2, 25), lE = Math.pow(2, 24), cE = Math.pow(2, 17), hE = Math.pow(2, 16), uE = Math.pow(2, 9), dE = Math.pow(2, 8), pE = Math.pow(2, 1);
        function fE(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * aE + t * lE + i * cE + t * hE + i * uE + t * dE + i * pE + t;
        }
        const mE = 0;
        class _E {
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && void 0 !== e1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
            continuePlacement(e1, t, i, r, n) {
                const o = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t.getBucketParts(o, r, e1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, n()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < o.length;){
                    const e1 = o[this._currentPartIndex];
                    if (t.placeLayerBucketPart(e1, this._seenCrossTileIDs, i, 0 === e1.symbolInstanceStart), this._currentPartIndex++, n()) return !0;
                }
                return !1;
            }
        }
        class gE {
            constructor(e1, t, i, r, n, o, s, a, l){
                this.placement = new oE(e1, n, o, s, a, l), this._currentPlacementIndex = t.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = r, this._done = !1;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(e1, t, i, r) {
                const n = dt.now(), o = ()=>{
                    const e1 = dt.now() - n;
                    return !this._forceFullPlacement && e1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const n = t[e1[this._currentPlacementIndex]], s = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === n.type && (!n.minzoom || n.minzoom <= s) && (!n.maxzoom || n.maxzoom > s)) {
                        const e1 = n, t = e1.layout.get("symbol-z-elevate"), s = this._inProgressLayer = this._inProgressLayer || new _E(e1), a = va(n.source, n.scope);
                        if (s.continuePlacement(t ? r[a] : i[a], this.placement, this._showCollisionBoxes, n, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e1) {
                return this.placement.commit(e1), this.placement;
            }
        }
        const yE = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class xE {
            static from(e1) {
                if (!(e1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [t, i] = new Uint8Array(e1, 0, 2);
                if (219 !== t) throw new Error("Data does not appear to be in a KDBush format.");
                const r = i >> 4;
                if (1 !== r) throw new Error(`Got v${r} data when expected v1.`);
                const n = yE[15 & i];
                if (!n) throw new Error("Unrecognized array type.");
                const [o] = new Uint16Array(e1, 2, 1), [s] = new Uint32Array(e1, 4, 1);
                return new xE(s, o, n, e1);
            }
            constructor(e1, t = 64, i = Float64Array, r){
                if (isNaN(e1) || e1 < 0) throw new Error(`Unpexpected numItems value: ${e1}.`);
                this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = i, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
                const n = yE.indexOf(this.ArrayType), o = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, s = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, a = (8 - s % 8) % 8;
                if (n < 0) throw new Error(`Unexpected typed array class: ${i}.`);
                r && r instanceof ArrayBuffer ? (this.data = r, this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + s + a, 2 * e1), this._pos = 2 * e1, this._finished = !0) : (this.data = new ArrayBuffer(8 + o + s + a), this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + s + a, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + n
                ]), new Uint16Array(this.data, 2, 1)[0] = t, new Uint32Array(this.data, 4, 1)[0] = e1);
            }
            add(e1, t) {
                const i = this._pos >> 1;
                return this.ids[i] = i, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, i;
            }
            finish() {
                const e1 = this._pos >> 1;
                if (e1 !== this.numItems) throw new Error(`Added ${e1} items when expected ${this.numItems}.`);
                return vE(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(e1, t, i, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: o, nodeSize: s } = this, a = [
                    0,
                    n.length - 1,
                    0
                ], l = [];
                for(; a.length;){
                    const c = a.pop() || 0, h = a.pop() || 0, u = a.pop() || 0;
                    if (h - u <= s) {
                        for(let s = u; s <= h; s++){
                            const a = o[2 * s], c = o[2 * s + 1];
                            a >= e1 && a <= i && c >= t && c <= r && l.push(n[s]);
                        }
                        continue;
                    }
                    const d = u + h >> 1, p = o[2 * d], f = o[2 * d + 1];
                    p >= e1 && p <= i && f >= t && f <= r && l.push(n[d]), (0 === c ? e1 <= p : t <= f) && (a.push(u), a.push(d - 1), a.push(1 - c)), (0 === c ? i >= p : r >= f) && (a.push(d + 1), a.push(h), a.push(1 - c));
                }
                return l;
            }
            within(e1, t, i) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: r, coords: n, nodeSize: o } = this, s = [
                    0,
                    r.length - 1,
                    0
                ], a = [], l = i * i;
                for(; s.length;){
                    const c = s.pop() || 0, h = s.pop() || 0, u = s.pop() || 0;
                    if (h - u <= o) {
                        for(let i = u; i <= h; i++)EE(n[2 * i], n[2 * i + 1], e1, t) <= l && a.push(r[i]);
                        continue;
                    }
                    const d = u + h >> 1, p = n[2 * d], f = n[2 * d + 1];
                    EE(p, f, e1, t) <= l && a.push(r[d]), (0 === c ? e1 - i <= p : t - i <= f) && (s.push(u), s.push(d - 1), s.push(1 - c)), (0 === c ? e1 + i >= p : t + i >= f) && (s.push(d + 1), s.push(h), s.push(1 - c));
                }
                return a;
            }
        }
        function vE(e1, t, i, r, n, o) {
            if (n - r <= i) return;
            const s = r + n >> 1;
            bE(e1, t, s, r, n, o), vE(e1, t, i, r, s - 1, 1 - o), vE(e1, t, i, s + 1, n, 1 - o);
        }
        function bE(e1, t, i, r, n, o) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, a = i - r + 1, l = Math.log(s), c = .5 * Math.exp(2 * l / 3), h = .5 * Math.sqrt(l * c * (s - c) / s) * (a - s / 2 < 0 ? -1 : 1);
                    bE(e1, t, i, Math.max(r, Math.floor(i - a * c / s + h)), Math.min(n, Math.floor(i + (s - a) * c / s + h)), o);
                }
                const s = t[2 * i + o];
                let a = r, l = n;
                for(wE(e1, t, r, i), t[2 * n + o] > s && wE(e1, t, r, n); a < l;){
                    for(wE(e1, t, a, l), a++, l--; t[2 * a + o] < s;)a++;
                    for(; t[2 * l + o] > s;)l--;
                }
                t[2 * r + o] === s ? wE(e1, t, r, l) : (l++, wE(e1, t, l, n)), l <= i && (r = l + 1), i <= l && (n = l - 1);
            }
        }
        function wE(e1, t, i, r) {
            TE(e1, i, r), TE(t, 2 * i, 2 * r), TE(t, 2 * i + 1, 2 * r + 1);
        }
        function TE(e1, t, i) {
            const r = e1[t];
            e1[t] = e1[i], e1[i] = r;
        }
        function EE(e1, t, i, r) {
            const n = e1 - i, o = t - r;
            return n * n + o * o;
        }
        const ME = 512 / cr / 2;
        class AE {
            constructor(e1, t, i){
                this.tileID = e1, this.bucketInstanceId = i, this.index = new xE(t.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const r = e1.canonical.x * cr, n = e1.canonical.y * cr;
                for(let e1 = 0; e1 < t.length; e1++){
                    const { key: i, crossTileID: o, tileAnchorX: s, tileAnchorY: a } = t.get(e1), l = Math.floor((r + s) * ME), c = Math.floor((n + a) * ME);
                    this.index.add(l, c), this.keys.push(i), this.crossTileIDs.push(o);
                }
                this.index.finish();
            }
            findMatches(e1, t, i) {
                const r = this.tileID.canonical.z < t.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t.canonical.z), n = ME / Math.pow(2, t.canonical.z - this.tileID.canonical.z), o = t.canonical.x * cr, s = t.canonical.y * cr;
                for(let t = 0; t < e1.length; t++){
                    const a = e1.get(t);
                    if (a.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = a, u = Math.floor((o + c) * n), d = Math.floor((s + h) * n), p = this.index.range(u - r, d - r, u + r, d + r);
                    for (const e1 of p){
                        const t = this.crossTileIDs[e1];
                        if (this.keys[e1] === l && !i.has(t)) {
                            i.add(t), a.crossTileID = t;
                            break;
                        }
                    }
                }
            }
        }
        class SE {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class IE {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e1) {
                const t = Math.round((e1 - this.lng) / 360);
                if (0 !== t) for(const e1 in this.indexes){
                    const i = this.indexes[e1], r = {};
                    for(const e1 in i){
                        const n = i[e1];
                        n.tileID = n.tileID.unwrapTo(n.tileID.wrap + t), r[n.tileID.key] = n;
                    }
                    this.indexes[e1] = r;
                }
                this.lng = e1;
            }
            addBucket(e1, t, i) {
                if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++)t.symbolInstances.get(e1).crossTileID = 0;
                this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = new Set);
                const r = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const n = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in n){
                        const o = n[i];
                        o.tileID.isChildOf(e1) && o.findMatches(t.symbolInstances, e1, r);
                    }
                    else {
                        const o = n[e1.scaledTo(Number(i)).key];
                        o && o.findMatches(t.symbolInstances, e1, r);
                    }
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
                    const n = t.symbolInstances.get(e1);
                    n.crossTileID || (n.crossTileID = i.generate(), r.add(n.crossTileID));
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new AE(e1, t.symbolInstances, t.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t) {
                for (const i of t.crossTileIDs)this.usedCrossTileIDs[e1].delete(i);
            }
            removeStaleBuckets(e1) {
                let t = !1;
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    for(const n in r)e1[r[n].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, r[n]), delete r[n], t = !0);
                }
                return t;
            }
        }
        class CE {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new SE, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e1, t, i, r) {
                let n = this.layerIndexes[e1.fqid];
                void 0 === n && (n = this.layerIndexes[e1.fqid] = new IE);
                let o = !1;
                const s = {};
                "globe" !== r.name && n.handleWrapJump(i);
                for (const i of t){
                    const t = i.getBucket(e1);
                    t && e1.fqid === t.layerIds[0] && (t.bucketInstanceId || (t.bucketInstanceId = ++this.maxBucketInstanceId), n.addBucket(i.tileID, t, this.crossTileIDs) && (o = !0), s[t.bucketInstanceId] = !0);
                }
                return n.removeStaleBuckets(s) && (o = !0), o;
            }
            pruneUnusedLayers(e1) {
                const t = {};
                e1.forEach((e1)=>{
                    t[e1] = !0;
                });
                for(const e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
            }
        }
        var zE = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w-0.0001;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", PE = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", DE = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;uniform sampler2D u_depth;uniform vec2 u_depth_size_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;float depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5));return coord.z > depth+0.0005;}float occlusionFade(vec4 frag) {vec3 coord=frag.xyz/frag.w;vec3 df=vec3(5.0*u_depth_size_inv,0.0);vec2 uv=0.5*coord.xy+0.5;vec4 depth=vec4(\nunpack_depth(texture(u_depth,uv-df.xz)),unpack_depth(texture(u_depth,uv+df.xz)),unpack_depth(texture(u_depth,uv-df.zy)),unpack_depth(texture(u_depth,uv+df.zy))\n);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z-0.001)-depth),0.0,1.0));}vec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }bool isOccluded(vec4 frag) { return false; }float occlusionFade(vec4 frag) { return 1.0; }\n#endif", RE = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", LE = "highp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}\n#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {\n#ifdef FOG_DITHERING\nvec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);\n#else\nreturn color;\n#endif\n}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", kE = "#ifdef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);vec4 _raTexLinearCoord(vec2 texCoord,vec2 texResolution,out vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return (texCoord.xxyy+vec2(1.5,0.5).xyxy)/texResolution.xxyy;}vec2 _raTexLinearMix(vec2 fxy,vec4 colorMix,float colorOffset,vec4 t00,vec4 t10,vec4 t01,vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec2 fxy;vec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texture(u_image0,c.yz),texture(u_image0,c.xz),texture(u_image0,c.yw),texture(u_image0,c.xw)\n);}vec2 raTexture2D_image1_linear(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec2 fxy;vec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texture(u_image1,c.yz),texture(u_image1,c.xz),texture(u_image1,c.yw),texture(u_image1,c.xw)\n);}vec2 raTexture2D_image0_nearest(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec4 t=texture(u_image0,texCoord);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec4 t=texture(u_image1,texCoord);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", OE = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", BE = "#ifdef RENDER_SHADOWS\n#ifdef DEPTH_TEXTURE\nuniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;\n#else\nuniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;\n#endif\nuniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_1,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_0,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;\n#ifdef NATIVE\nhighp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));\n#else\nhighp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(\nshadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)\n);\n#endif\nvec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {\n#ifdef SHADOWS_SINGLE_CASCADE\nlight_view_pos0.xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);\n#else\nlight_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const FE = [];
        qE(zE, FE);
        const NE = {
            "_prelude_fog.vertex.glsl": RE,
            "_prelude_terrain.vertex.glsl": DE,
            "_prelude_shadow.vertex.glsl": OE,
            "_prelude_fog.fragment.glsl": LE,
            "_prelude_shadow.fragment.glsl": BE,
            "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE",
            "_prelude_raster_array.glsl": kE
        }, UE = {};
        ZE("", DE), ZE(LE, RE), ZE(BE, OE), ZE(kE, "");
        const VE = ZE("\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec2 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color) {\n#ifdef INDICATOR_CUTOUT\nfloat holeMinOpacity=u_indicator_cutout_params.x;float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif", "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}"), jE = zE;
        var GE = {
            background: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            backgroundPattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in vec2 v_pos;void main() {vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            circle: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: ZE("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: ZE('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: ZE("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: ZE("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in float a_size_scale;in vec2 a_padding;in float a_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(a_z_offset+elevation(a_anchor_pos)),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'),
            collisionCircle: ZE("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: ZE("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'),
            fill: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutline: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;out vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutlinePattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;in vec2 v_pos;in vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;out vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillPattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;in vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillExtrusion: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nuniform float u_emissive_strength;in float v_height;void main() {\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,v_depth);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);color.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,u_emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef RENDER_CUTOFF\ncolor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#ifdef RENDER_CUTOFF\ninvariant gl_Position;\n#endif\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele;vec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);v_flat=vec4(linearProduct(color.rgb,vec3(calculate_NdotL(normal))),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            fillExtrusionDepth: ZE("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_vertical_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;float ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;float h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base);pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'),
            fillExtrusionPattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nout vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            groundShadow: ZE('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;in float v_depth;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,v_depth));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0)).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);v_depth=gl_Position.w;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
            fillExtrusionGroundEffect: ZE("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;HANDLE_WIREFRAME_DEBUG;\n#endif\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;\n#ifdef FORCE_ABS_FL_GROUND_RADIUS\nfl_ground_radius=abs(flood_light_ground_radius);\n#endif\nfloat flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(1.0,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            hillshadePrepare: ZE("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            line: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).a;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trimmed=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {out_color=vec4(0,0,0,0);trimmed=0.0;}}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {    \nfloat Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color.rgb=mix(border_color.rgb*border_color.a*trimmed,out_color.rgb,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            linePattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_tile_units_to_pixels;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;vec2 pattern_size=vec2(display_size.x/u_tile_units_to_pixels,display_size.y);float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x=mod(v_linesofar/pattern_size.x*aspect,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));vec4 color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_ground(color);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_linesofar;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            raster: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform vec4 u_tl_br;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#elif defined(PROJECTION_GLOBE_VIEW)\nin vec2 a_pos;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;void main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec2 globe_tl=vec2(u_tl_br.x,u_tl_br.y);vec2 globe_br=vec2(u_tl_br.z,u_tl_br.w);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=1.0-((mercatorY-globe_br.y)/(globe_tl.y-globe_br.y));float mercatorX=mercatorXfromLng(latLng[1]);float uvX=(mercatorX-globe_br.x)/(globe_tl.x-globe_br.x);vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);uv=vec2(uvX,uvY);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\nuv=a_texture_pos/8192.0;\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            symbolIcon: ZE('#include "_prelude_lighting.glsl"\nuniform sampler2D u_texture;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\nin float v_fade_opacity;in vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nuniform mediump float u_icon_saturation;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nlowp float alpha=opacity*v_fade_opacity;vec4 out_color;\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b)*alpha;\n#else\nout_color=texture(u_texture,v_tex_a)*alpha;\n#endif\n#ifdef SATURATION\nvec3 luma=vec3(dot(out_color.rgb,vec3(0.2126,0.7152,0.0722)));out_color.rgb=mix(luma,out_color.rgb,u_icon_saturation);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nv_tex_a=a_tex/u_texsize;\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\nv_fade_opacity=out_fade_opacity;}'),
            symbolSDF: ZE('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\nuniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;in float v_draw_halo;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,out_fade_opacity);}'),
            symbolTextAndIcon: ZE('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_halo;in float v_draw_halo;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nfloat out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,out_fade_opacity,is_sdf);}'),
            terrainRaster: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;in float v_depth;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,v_depth,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);v_depth=gl_Position.w;\n#endif\n}'),
            terrainDepth: ZE("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: ZE('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', PE),
            skyboxGradient: ZE('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', PE),
            skyboxCapture: ZE("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(raster.rgb*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: ZE('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;\n#ifndef NATIVE\nc=dither(c,gl_FragCoord.xy+u_temporal_offset);\n#endif\nglFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            model: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform sampler2D u_depthTexture;uniform vec2 u_inv_depth_size;bool isOccluded() {vec2 coord=gl_FragCoord.xy*u_inv_depth_size;highp float depth=unpack_depth(texture(u_depthTexture,coord));return v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\ntexColor.rgb=sRGBToLinear(texColor.rgb);if(u_baseTextureIsAlpha) {if (texColor.w < 0.5) {discard;}albedo*=mix(vec4(texColor.rgb,texColor.a),vec4(texColor.a),float(u_baseTextureIsAlpha));} else {albedo*=texColor;}\n#endif\nreturn vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 diffuse=getDiffuseShadedColor(getBaseColor().rgb,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(diffuse,1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nao=(texture(u_occlusionTexture,uv_2f).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);color=mix(color,v_color_mix.rgb,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=u_matrix*pos;pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=local_pos;\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normalize(normal_3f));shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1);v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: ZE("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=u_matrix*pos;\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"),
            stars: ZE("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}")
        };
        function qE(e1, t) {
            const i = e1.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e1 of i)if (e1 = e1.trim(), "#" === e1[0] && e1.includes("if") && !e1.includes("endif")) {
                e1 = e1.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
                const i = e1.split(" ");
                for (const e1 of i)t.includes(e1) || t.push(e1);
            }
        }
        function ZE(e1, t) {
            const i = /#include\s+"([^"]+)"/g, r = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
            let n = t.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
            n && (n = n.map((e1)=>{
                const t = e1.split(" ");
                return t[t.length - 1];
            }), n = [
                ...new Set(n)
            ]);
            const o = {}, s = [], a = [];
            e1 = e1.replace(i, (e1, t)=>(a.push(t), "")), t = t.replace(i, (e1, t)=>(s.push(t), ""));
            let l = [
                ...FE
            ];
            qE(e1, l), qE(t, l);
            for (const e1 of [
                ...s,
                ...a
            ])NE[e1] || console.error(`Undefined include: ${e1}`), UE[e1] || (UE[e1] = [], qE(NE[e1], UE[e1])), l = [
                ...l,
                ...UE[e1]
            ];
            return {
                fragmentSource: e1 = e1.replace(r, (e1, t, i, r, n)=>(o[n] = !0, "define" === t ? `\n#ifndef HAS_UNIFORM_u_${n}\nin ${i} ${r} ${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "initialize" === t ? `\n#ifdef HAS_UNIFORM_u_${n}\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : "define-attribute" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    in ${i} ${r} ${n};\n#endif\n` : "initialize-attribute" === t ? "" : void 0)),
                vertexSource: t = t.replace(r, (e1, t, i, r, n)=>{
                    const s = "float" === r ? "vec2" : r, a = n.match(/color/) ? "color" : s;
                    return "define-attribute-vertex-shader-only" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\nin ${i} ${r} a_${n};\n#endif\n` : o[n] ? "define" === t ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nin ${i} ${s} a_${n};\nout ${i} ${r} ${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "initialize" === t ? "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = a_${n};\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : "define-attribute" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    in ${i} ${r} a_${n};\n    out ${i} ${r} ${n};\n#endif\n` : "initialize-attribute" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    ${n} = a_${n};\n#endif\n` : void 0 : "define" === t ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nin ${i} ${s} a_${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "define-instanced" === t ? "mat4" === a ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${n}0;\nin vec4 a_${n}1;\nin vec4 a_${n}2;\nin vec4 a_${n}3;\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${i} ${s} a_${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "initialize-attribute-custom" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    ${i} ${r} ${n} = a_${n};\n#endif\n` : "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${r} ${n} = a_${n};\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${r} ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n`;
                }),
                staticAttributes: n,
                usedDefines: l,
                vertexIncludes: s,
                fragmentIncludes: a
            };
        }
        class $E {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e1, t, i, r, n, o, s, a) {
                this.context = e1;
                let l = this.boundPaintVertexBuffers.length !== r.length;
                for(let e1 = 0; !l && e1 < r.length; e1++)this.boundPaintVertexBuffers[e1] !== r[e1] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== s.length;
                for(let e1 = 0; !c && e1 < s.length; e1++)this.boundDynamicVertexBuffers[e1] !== s[e1] && (c = !0);
                if (!this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== n || this.boundVertexOffset !== o) this.freshBind(t, i, r, n, o, s, a);
                else {
                    e1.bindVertexArrayOES.set(this.vao);
                    for (const i of s)i && (i.bind(), a && i.instanceCount && i.setVertexAttribDivisor(e1.gl, t, a));
                    n && n.dynamicDraw && n.bind();
                }
            }
            freshBind(e1, t, i, r, n, o, s) {
                const a = e1.numAttributes, l = this.context, c = l.gl;
                this.vao && this.destroy(), this.vao = l.gl.createVertexArray(), l.bindVertexArrayOES.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = r, this.boundVertexOffset = n, this.boundDynamicVertexBuffers = o, t.enableAttributes(c, e1), t.bind(), t.setVertexAttribPointers(c, e1, n);
                for (const t of i)t.enableAttributes(c, e1), t.bind(), t.setVertexAttribPointers(c, e1, n);
                for (const t of o)t && (t.enableAttributes(c, e1), t.bind(), t.setVertexAttribPointers(c, e1, n), s && t.instanceCount && t.setVertexAttribDivisor(c, e1, s));
                r && r.bind(), l.currentNumAttributes = a;
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function WE(e1, t) {
            const i = Math.pow(2, t.canonical.z), r = t.canonical.y;
            return [
                new lp(0, r / i).toLngLat().lat,
                new lp(0, (r + 1) / i).toLngLat().lat
            ];
        }
        function HE(e1, t, i, r, n, o, s) {
            const a = e1.context, l = a.gl, c = i.hillshadeFBO;
            if (!c) return;
            e1.prepareDrawTile();
            const h = e1.isTileAffectedByFog(t), u = e1.getOrCreateProgram("hillshade", {
                overrideFog: h
            });
            a.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, c.colorAttachment.get());
            const d = ((e1, t, i, r)=>{
                const n = i.paint.get("hillshade-shadow-color"), o = i.paint.get("hillshade-highlight-color"), s = i.paint.get("hillshade-accent-color"), a = i.paint.get("hillshade-emissive-strength");
                let l = w(i.paint.get("hillshade-illumination-direction"));
                if ("viewport" === i.paint.get("hillshade-illumination-anchor")) l -= e1.transform.angle;
                else if (e1.style && e1.style.enable3dLights() && e1.style.directionalLight) {
                    const t = e1.style.directionalLight.properties.get("direction");
                    l = w(J(t.x, t.y, t.z)[1]);
                }
                const c = !e1.options.moving;
                return {
                    u_matrix: r || e1.transform.calculateProjMatrix(t.tileID.toUnwrapped(), c),
                    u_image: 0,
                    u_latrange: WE(0, t.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        l
                    ],
                    u_shadow: n,
                    u_highlight: o,
                    u_emissive_strength: a,
                    u_accent: s
                };
            })(e1, i, r, e1.terrain ? t.projMatrix : null);
            e1.uploadCommonUniforms(a, u, t.toUnwrapped());
            const { tileBoundsBuffer: p, tileBoundsIndexBuffer: f, tileBoundsSegments: m } = e1.getTileBoundsBuffers(i);
            u.draw(e1, l.TRIANGLES, n, o, s, Dx.disabled, d, r.id, p, f, m);
        }
        function XE(e1, t, i) {
            if (!t.needsDEMTextureUpload) return;
            const r = e1.context, n = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), t.demTexture = t.demTexture || e1.getTileTexture(i.stride);
            const o = i.getPixels();
            t.demTexture ? t.demTexture.update(o, {
                premultiply: !1
            }) : t.demTexture = new My(r, o, n.R32F, {
                premultiply: !1
            }), t.needsDEMTextureUpload = !1;
        }
        function YE(e1, t, i) {
            const r = e1.context, n = r.gl;
            if (!t.dem) return;
            const o = t.dem;
            if (r.activeTexture.set(n.TEXTURE1), XE(e1, t, o), !t.demTexture) return;
            t.demTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE);
            const s = o.dim;
            r.activeTexture.set(n.TEXTURE0);
            let a = t.hillshadeFBO;
            if (!a) {
                const e1 = new My(r, {
                    width: s,
                    height: s,
                    data: null
                }, n.RGBA);
                e1.bind(n.LINEAR, n.CLAMP_TO_EDGE), a = t.hillshadeFBO = r.createFramebuffer(s, s, !0, "renderbuffer"), a.colorAttachment.set(e1.texture);
            }
            r.bindFramebuffer.set(a.framebuffer), r.viewport.set([
                0,
                0,
                s,
                s
            ]);
            const { tileBoundsBuffer: l, tileBoundsIndexBuffer: c, tileBoundsSegments: h } = e1.getMercatorTileBoundsBuffers(), u = [];
            e1.linearFloatFilteringSupported() && u.push("TERRAIN_DEM_FLOAT_FORMAT"), e1.getOrCreateProgram("hillshadePrepare", {
                defines: u
            }).draw(e1, n.TRIANGLES, Mx.disabled, Sx.disabled, Cx.unblended, Dx.disabled, ((e1, t)=>{
                const i = t.stride, r = Au.create();
                return Au.ortho(r, 0, cr, -cr, 0, 0, 1), Au.translate(r, r, [
                    0,
                    -cr,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        i,
                        i
                    ],
                    u_zoom: e1.overscaledZ
                };
            })(t.tileID, o), i.id, l, c, h), t.needsHillshadePrepare = !1;
        }
        const KE = (e1)=>({
                u_matrix: new jl(e1),
                u_image0: new kl(e1),
                u_skirt_height: new Ol(e1),
                u_ground_shadow_factor: new Fl(e1)
            }), JE = (e1, t, i)=>({
                u_matrix: e1,
                u_image0: 0,
                u_skirt_height: t,
                u_ground_shadow_factor: i
            }), QE = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f)=>({
                u_proj_matrix: Float32Array.from(e1),
                u_globe_matrix: t,
                u_normalize_matrix: Float32Array.from(r),
                u_merc_matrix: i,
                u_zoom_transition: n,
                u_merc_center: o,
                u_image0: 0,
                u_frustum_tl: s,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: u,
                u_viewport: d,
                u_grid_matrix: f ? Float32Array.from(f) : new Float32Array(9),
                u_skirt_height: p
            }), eM = (e1, t)=>{
            if (t > 0 && e1.terrain && H("Cutoff is currently disabled on terrain"), t <= 0 || e1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        0
                    ]
                }
            };
            const i = e1.transform, r = Math.max(Math.abs(i._zoom - (e1.minCutoffZoom - 1)), 1), n = i.isLODDisabled(!1) ? P(60, 45, i.pitch) : P(30, 15, i.pitch), o = i._farZ - i._nearZ, s = t * i.height, a = ((1 - (l = n)) * (.75 * i.cameraToCenterDistance) + l * (i._farZ + s)) * r;
            var l;
            return {
                shouldRenderCutoff: n < 1,
                uniformValues: {
                    u_cutoff_params: [
                        i._nearZ,
                        i._farZ,
                        (a - i._nearZ) / o,
                        (a - s - i._nearZ) / o
                    ]
                }
            };
        };
        function tM(e1, t) {
            return null != e1 && null != t && !(!e1.hasData() || !t.hasData()) && null != e1.demTexture && null != t.demTexture && e1.tileID.key !== t.tileID.key;
        }
        const iM = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e1, t, i, r, n) {
                if (e1 in this.operations) {
                    const t = this.operations[e1];
                    t.to.tileID.key !== i.tileID.key && (t.queued = i);
                } else this.operations[e1] = {
                    startTime: r,
                    phase: 0,
                    duration: n,
                    from: t,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e1) {
                if (!(e1 in this.operations)) return null;
                const t = this.operations[e1];
                return {
                    from: t.from,
                    to: t.to,
                    phase: t.phase
                };
            }
            update(e1) {
                for(const t in this.operations){
                    const i = this.operations[t];
                    for(i.phase = (e1 - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e1)) {
                        delete this.operations[t];
                        break;
                    }
                }
            }
            _nextOp(e1, t) {
                return !!e1.queued && (e1.from = e1.to, e1.to = e1.queued, e1.queued = null, e1.phase = 0, e1.startTime = t, !0);
            }
            _validOp(e1) {
                return e1.from.hasData() && e1.to.hasData();
            }
        }, rM = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING"
        };
        function nM(e1, t, i) {
            if (0 === t) return 0;
            const r = t < 1 && 514 === i ? .25 / t : 1;
            return 6 * Math.pow(1.5, 22 - e1) * Math.max(t, 1) * r;
        }
        function oM(e1, t) {
            const i = 1 << e1.z;
            return !t && (0 === e1.x || e1.x === i - 1) || 0 === e1.y || e1.y === i - 1;
        }
        const sM = (e1)=>({
                u_matrix: e1
            });
        function aM(e1, t, i, r, n) {
            if (n > 0) {
                const o = dt.now(), s = (o - e1.timeAdded) / n, a = t ? (o - t.timeAdded) / n : -1, l = i.getSource(), c = r.coveringZoomLevel({
                    tileSize: l.tileSize,
                    roundZoom: l.roundZoom
                }), h = !t || Math.abs(t.tileID.overscaledZ - c) > Math.abs(e1.tileID.overscaledZ - c), u = h && e1.refreshedUponExpiration ? 1 : z(h ? s : 1 - a, 0, 1);
                return e1.refreshedUponExpiration && s >= 1 && (e1.refreshedUponExpiration = !1), t ? {
                    opacity: 1,
                    mix: 1 - u
                } : {
                    opacity: u,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        class lM extends Lx {
            constructor(e1){
                const t = {
                    type: "raster-dem",
                    maxzoom: e1.transform.maxZoom
                }, i = new Ew(Ww(), null), r = ST("mock-dem", t, i, e1.style);
                super("mock-dem", r, !1), r.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e1, t) {
                e1.state = "loaded", t(null);
            }
        }
        class cM extends Lx {
            constructor(e1){
                const t = ST("proxy", {
                    type: "geojson",
                    maxzoom: e1.transform.maxZoom
                }, new Ew(Ww(), null), e1.style);
                super("proxy", t, !1), t.setEventedParent(this), this.map = this.getSource().map = e1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(e1, t, i) {
                if (e1.freezeTileCoverage) return;
                this.transform = e1;
                const r = e1.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((t, i)=>{
                    if (t[i.key] = "", !this._tiles[i.key]) {
                        const t = new Oy(i, this._source.tileSize * i.overscaleFactor(), e1.tileZoom);
                        t.state = "loaded", this._tiles[i.key] = t;
                    }
                    return t;
                }, {});
                for(const e1 in this._tiles)e1 in r || (this.freeFBO(e1), this._tiles[e1].unloadVectorData(), delete this._tiles[e1]);
            }
            freeFBO(e1) {
                const t = this.proxyCachedFBO[e1];
                if (void 0 !== t) {
                    const i = Object.values(t);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e1];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e1)=>e1.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class hM extends qu {
            constructor(e1, t, i){
                super(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y), this.proxyTileKey = t, this.projMatrix = i;
            }
        }
        class uM extends Km {
            constructor(e1, t){
                super(), this.painter = e1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [i, r, n] = function(e1) {
                    const t = new za, i = new Wa, r = 131;
                    t.reserve(17161), i.reserve(33800);
                    const n = cr / 128, o = cr + n / 2, s = o + n;
                    for(let e1 = -n; e1 < s; e1 += n)for(let i = -n; i < s; i += n){
                        const r = i < 0 || i > o || e1 < 0 || e1 > o ? 24575 : 0, n = z(Math.round(i), 0, cr), s = z(Math.round(e1), 0, cr);
                        t.emplaceBack(n + r, s);
                    }
                    const a = (e1, t)=>{
                        const n = t * r + e1;
                        i.emplaceBack(n + 1, n, n + r), i.emplaceBack(n + r, n + r + 1, n + 1);
                    };
                    for(let e1 = 1; e1 < 129; e1++)for(let t = 1; t < 129; t++)a(t, e1);
                    return [
                        0,
                        129
                    ].forEach((e1)=>{
                        for(let t = 0; t < 130; t++)a(t, e1), a(e1, t);
                    }), [
                        t,
                        i,
                        32768
                    ];
                }(), o = e1.context;
                this.gridBuffer = o.createVertexBuffer(i, Nu.members), this.gridIndexBuffer = o.createIndexBuffer(r), this.gridSegments = xl.simpleSegment(0, 0, i.length, r.length), this.gridNoSkirtSegments = xl.simpleSegment(0, 0, i.length, n), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new cM(t.map), this.orthoMatrix = Au.create(), Au.ortho(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, cr, 0, cr, 0, 1);
                const s = o.gl;
                this._overlapStencilMode = new Sx({
                    func: s.GEQUAL,
                    mask: 255
                }, 0, 255, s.KEEP, s.KEEP, s.REPLACE), this._previousZoom = e1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = t, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new lM(t.map), this._pendingGroundEffectLayers = [];
            }
            set style(e1) {
                e1.on("data", this._onStyleDataEvent.bind(this)), this._style = e1, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(e1, t, i) {
                if (e1 && e1.terrain) {
                    this._style !== e1 && (this.style = e1, this._evaluationZoom = void 0);
                    const r = e1.terrain.properties, n = 0 === e1.terrain.drapeRenderMode, o = e1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = dt.now();
                    const s = e1.terrain && e1.terrain.scope, a = r.get("source"), l = n ? this._mockSourceCache : e1.getSourceCache(a, s);
                    if (!l) return void H(`Couldn't find terrain source "${a}".`);
                    if (this.sourceCache = l, this._exaggeration = o ? this.calculateExaggeration(t) : r.get("exaggeration"), !t.projection.requiresDraping && o && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const c = ()=>{
                        this.sourceCache.used && H(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const e1 = this.getScaledDemTileSize();
                        this.sourceCache.update(t, e1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, c(), this._initializing = !0), c(), t.updateElevation(!0, i), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(t), this._emptyDEMTextureDirty = !0, this._previousZoom = t.zoom;
                } else this._disable();
            }
            calculateExaggeration(e1) {
                const t = this._previousCameraAltitude, i = e1.getFreeCameraOptions().position.z / e1.pixelsPerMeter * e1.worldSize;
                this._previousCameraAltitude = i;
                const r = null != t ? i - t : Number.MAX_VALUE;
                if (Math.abs(r) < 2) return this._exaggeration;
                const n = e1.zoom, o = this._style.terrain;
                if (!this._previousUpdateTimestamp) return o.getExaggeration(n);
                let s = n - this._previousZoom;
                const a = this._previousUpdateTimestamp;
                let l = n;
                null != this._evaluationZoom && (l = this._evaluationZoom, Math.abs(n - l) > .5 && (s = .5 * (n - l + s)), s * r < 0 && (l += s)), this._evaluationZoom = l;
                const c = o.getExaggeration(l), h = c === o.getExaggeration(Math.max(0, l - .1));
                if (h && Math.abs(c - this._exaggeration) < .01) return c;
                let u = Math.min(.1, .00375 * (this._updateTimestamp - a));
                return (h || c < .1 || Math.abs(s) < 1e-4) && (u = Math.min(.2, 4 * u)), Kr(this._exaggeration, c, u);
            }
            resetTileLookupCache(e1) {
                this._findCoveringTileCache[e1] = {};
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e1) {
                e1.coord && "source" === e1.dataType ? this._clearRenderCacheForTile(e1.sourceCacheId, e1.coord) : "style" === e1.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e1 in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e1].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this._emptyDepthBufferTexture && this._emptyDepthBufferTexture.destroy(), this.pool.forEach((e1)=>e1.fb.destroy()), this.pool = [], this._depthFBO && (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0), this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this._exaggeration;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e1 = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e1,
                    e1
                ];
            }
            set useVertexMorphing(e1) {
                this._useVertexMorphing = e1;
            }
            updateTileBinding(e1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const t = this.proxySourceCache, i = this.painter.transform;
                this._initializing && (this._initializing = 0 === i._centerAltitude && -1 === this.getAtPointOrZero(lp.fromLngLat(i.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = t.getIds().map((e1)=>{
                    const r = t.getTileByID(e1).tileID;
                    return r.projMatrix = i.calculateProjMatrix(r.toUnwrapped()), r;
                });
                !function(e1, t) {
                    const i = t.transform.pointCoordinate(t.transform.getCameraPoint()), r = new y(i.x, i.y);
                    e1.sort((e1, t)=>{
                        if (t.overscaledZ - e1.overscaledZ) return t.overscaledZ - e1.overscaledZ;
                        const i = new y(e1.canonical.x + (1 << e1.canonical.z) * e1.wrap, e1.canonical.y), n = new y(t.canonical.x + (1 << t.canonical.z) * t.wrap, t.canonical.y), o = r.mult(1 << e1.canonical.z);
                        return o.x -= .5, o.y -= .5, o.distSqr(i) - o.distSqr(n);
                    });
                }(r, this.painter);
                const n = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e1)=>{
                    this.proxyToSource[e1.key] = {};
                }), this.terrainTileForTile = {};
                const o = this._style._mergedSourceCaches;
                for(const t in o){
                    const i = o[t];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, e1[t], n), i.usedForTerrain) continue;
                    const r = e1[t];
                    i.getSource().reparseOverscaled && this._assignTerrainTiles(r);
                }
                this.proxiedCoords[t.id] = r.map((e1)=>new hM(e1, e1.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(n), this.renderingToTexture = !1;
                const s = {};
                this._visibleDemTiles = [];
                for (const e1 of this.proxyCoords){
                    const t = this.terrainTileForTile[e1.key];
                    if (!t) continue;
                    const i = t.tileID.key;
                    i in s || (this._visibleDemTiles.push(t), s[i] = i);
                }
            }
            _assignTerrainTiles(e1) {
                this._initializing || e1.forEach((e1)=>{
                    if (this.terrainTileForTile[e1.key]) return;
                    const t = this._findTileCoveringTileID(e1, this.sourceCache);
                    t && (this.terrainTileForTile[e1.key] = t);
                });
            }
            _prepareDEMTextures() {
                const e1 = this.painter.context, t = e1.gl;
                for(const i in this.terrainTileForTile){
                    const r = this.terrainTileForTile[i], n = r.dem;
                    !n || r.demTexture && !r.needsDEMTextureUpload || (e1.activeTexture.set(t.TEXTURE1), XE(this.painter, r, n));
                }
            }
            _prepareDemTileUniforms(e1, t, i, r) {
                if (!t || null == t.demTexture) return !1;
                const n = e1.tileID.canonical, o = Math.pow(2, t.tileID.canonical.z - n.z), s = r || "";
                return i[`u_dem_tl${s}`] = [
                    n.x * o % 1,
                    n.y * o % 1
                ], i[`u_dem_scale${s}`] = o, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            get emptyDepthBufferTexture() {
                const e1 = this.painter.context, t = e1.gl;
                if (!this._emptyDepthBufferTexture) {
                    const i = new ef({
                        width: 1,
                        height: 1
                    }, Uint8Array.of(255, 255, 255, 255));
                    this._emptyDepthBufferTexture = new My(e1, i, t.RGBA, {
                        premultiply: !1
                    });
                }
                return this._emptyDepthBufferTexture;
            }
            _getLoadedAreaMinimum() {
                let e1 = 0;
                const t = this._visibleDemTiles.reduce((t, i)=>{
                    if (!i.dem) return t;
                    const r = i.dem.tree.minimums[0];
                    return r > 0 && e1++, t + r;
                }, 0);
                return e1 ? t / e1 : 0;
            }
            _updateEmptyDEMTexture() {
                const e1 = this.painter.context, t = e1.gl;
                e1.activeTexture.set(t.TEXTURE2);
                const i = this._getLoadedAreaMinimum(), [r, n] = (()=>{
                    const e1 = new tf({
                        width: 1,
                        height: 1
                    }, new Float32Array([
                        i
                    ]));
                    return [
                        t.R32F,
                        e1
                    ];
                })();
                this._emptyDEMTextureDirty = !1;
                let o = this._emptyDEMTexture;
                return o ? o.update(n, {
                    premultiply: !1
                }) : o = this._emptyDEMTexture = new My(e1, n, r, {
                    premultiply: !1
                }), o;
            }
            setupElevationDraw(e1, t, i) {
                const r = this.painter.context, n = r.gl, o = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_exaggeration: 0
                };
                o.u_exaggeration = this.exaggeration();
                let s = null, a = null, l = 1;
                if (i && i.morphing && this._useVertexMorphing) {
                    const t = i.morphing.srcDemTile, r = i.morphing.dstDemTile;
                    l = i.morphing.phase, t && r && (this._prepareDemTileUniforms(e1, t, o, "_prev") && (a = t), this._prepareDemTileUniforms(e1, r, o) && (s = r));
                }
                const c = (e1)=>e1 && e1.demTexture && this.painter.linearFloatFilteringSupported() ? n.LINEAR : n.NEAREST, h = (e1)=>{
                    o.u_dem_size = 1 === e1.size[0] ? 1 : e1.size[0] - 2;
                };
                if (a && s) r.activeTexture.set(n.TEXTURE2), s.demTexture.bind(c(s), n.CLAMP_TO_EDGE), r.activeTexture.set(n.TEXTURE4), a.demTexture.bind(c(a), n.CLAMP_TO_EDGE), s.demTexture && h(s.demTexture), o.u_dem_lerp = l;
                else {
                    s = this.terrainTileForTile[e1.tileID.key], r.activeTexture.set(n.TEXTURE2);
                    const t = this._prepareDemTileUniforms(e1, s, o) ? s.demTexture : this.emptyDEMTexture;
                    t.bind(c(s), n.CLAMP_TO_EDGE), h(t);
                }
                if (r.activeTexture.set(n.TEXTURE3), i && i.useDepthForOcclusion ? (this._depthTexture && this._depthTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), this._depthFBO && (o.u_depth_size_inv = [
                    1 / this._depthFBO.width,
                    1 / this._depthFBO.height
                ])) : (this.emptyDepthBufferTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), o.u_depth_size_inv = [
                    1,
                    1
                ]), i && i.useMeterToDem && s) {
                    const e1 = (1 << s.tileID.canonical.z) * Qd(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    o.u_meter_to_dem = e1;
                }
                if (i && i.labelPlaneMatrixInv && (o.u_label_plane_matrix_inv = i.labelPlaneMatrixInv), t.setTerrainUniformValues(r, o), "globe" === this.painter.transform.projection.name) {
                    const n = this.globeUniformValues(this.painter.transform, e1.tileID.canonical, i && i.useDenormalizedUpVectorScale);
                    t.setGlobeUniformValues(r, n);
                }
            }
            globeUniformValues(e1, t, i) {
                const r = e1.projection;
                return {
                    u_tile_tl_up: r.upVector(t, 0, 0),
                    u_tile_tr_up: r.upVector(t, cr, 0),
                    u_tile_br_up: r.upVector(t, cr, cr),
                    u_tile_bl_up: r.upVector(t, 0, cr),
                    u_tile_up_scale: i ? hd(1) : r.upVectorScale(t, e1.center.lat, e1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(e1) {
                const t = this.painter, i = this.painter.context;
                0 !== e1.length && (i.bindFramebuffer.set(null), i.viewport.set([
                    0,
                    0,
                    t.width,
                    t.height
                ]), t.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(e1, t, i, r, n) {
                    if ("globe" === e1.transform.projection.name) !function(e1, t, i, r, n) {
                        const o = e1.context, s = o.gl;
                        let a, l;
                        const c = e1.transform, h = Ld(e1, o, c), u = (t, i)=>{
                            if (l === i) return;
                            const r = [
                                rM[i],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            h && r.push("CUSTOM_ANTIALIASING");
                            const n = e1.isTileAffectedByFog(t);
                            a = e1.getOrCreateProgram("globeRaster", {
                                defines: r,
                                overrideFog: n
                            }), l = i;
                        }, d = e1.colorModeForRenderPass(), p = new Mx(s.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D);
                        iM.update(n);
                        const f = Pd(c), m = [
                            Kd(c.center.lng),
                            Jd(c.center.lat)
                        ], _ = e1.globeSharedBuffers, g = [
                            c.width * dt.devicePixelRatio,
                            c.height * dt.devicePixelRatio
                        ], y = Float32Array.from(c.globeMatrix), x = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const c = e1.transform, h = nM(c.zoom, t.exaggeration(), t.sourceCache._source.tileSize);
                            l = -1;
                            const v = s.TRIANGLES;
                            for (const l of r){
                                const r = i.getTile(l), b = Sx.disabled, w = t.prevTerrainTileForTile[l.key], T = t.terrainTileForTile[l.key];
                                tM(w, T) && iM.newMorphing(l.key, w, T, n, 250), o.activeTexture.set(s.TEXTURE0), r.texture && r.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                const E = iM.getMorphValuesForProxy(l.key), A = E ? 1 : 0;
                                E && Lt(x, {
                                    morphing: {
                                        srcDemTile: E.from,
                                        dstDemTile: E.to,
                                        phase: M(E.phase)
                                    }
                                });
                                const S = xd(l.canonical), I = Od(S.getCenter().lat), C = kd(l.canonical, S, I, c.worldSize / c._pixelsPerMercatorPixel), z = Ad(fd(l.canonical)), P = QE(c.expandedFarZProjMatrix, y, f, z, Dd(c.zoom), m, c.frustumCorners.TL, c.frustumCorners.TR, c.frustumCorners.BR, c.frustumCorners.BL, c.globeCenterInViewSpace, c.globeRadius, g, h, C);
                                if (u(l, A), a && (t.setupElevationDraw(r, a, x), e1.uploadCommonUniforms(o, a, l.toUnwrapped()), _)) {
                                    const [t, i, r] = _.getGridBuffers(I, 0 !== h);
                                    a.draw(e1, v, p, b, d, Dx.backCCW, P, "globe_raster", t, i, r);
                                }
                            }
                        }
                        if (_ && (e1.renderDefaultNorthPole || e1.renderDefaultSouthPole)) {
                            const n = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            h && n.push("CUSTOM_ANTIALIASING"), a = e1.getOrCreateProgram("globeRaster", {
                                defines: n
                            });
                            for (const n of r){
                                const { x: r, y: l, z: h } = n.canonical, u = 0 === l, f = l === (1 << h) - 1, [y, v, b, w] = _.getPoleBuffers(h, !1);
                                if (w && (u || f)) {
                                    const l = i.getTile(n);
                                    o.activeTexture.set(s.TEXTURE0), l.texture && l.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                    let _ = Rd(h, r, c);
                                    const T = Ad(fd(n.canonical)), E = (t, i)=>t.draw(e1, s.TRIANGLES, p, Sx.disabled, d, Dx.disabled, QE(c.expandedFarZProjMatrix, _, _, T, 0, m, c.frustumCorners.TL, c.frustumCorners.TR, c.frustumCorners.BR, c.frustumCorners.BL, c.globeCenterInViewSpace, c.globeRadius, g, 0), "globe_pole_raster", i, b, w);
                                    t.setupElevationDraw(l, a, x), e1.uploadCommonUniforms(o, a, n.toUnwrapped()), u && e1.renderDefaultNorthPole && E(a, y), f && e1.renderDefaultSouthPole && (_ = Au.scale(Au.create(), _, [
                                        1,
                                        -1,
                                        1
                                    ]), E(a, v));
                                }
                            }
                        }
                    }(e1, t, i, r, n);
                    else {
                        const o = e1.context, s = o.gl;
                        let a, l;
                        const c = e1.shadowRenderer, h = eM(e1, e1.longestCutoffRange), u = (t)=>{
                            if (l === t) return;
                            const i = [];
                            i.push(rM[t]), h.shouldRenderCutoff && i.push("RENDER_CUTOFF"), a = e1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), l = t;
                        }, d = e1.colorModeForRenderPass(), p = new Mx(s.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D);
                        iM.update(n);
                        const f = e1.transform, m = nM(f.zoom, t.exaggeration(), t.sourceCache._source.tileSize);
                        let _ = [
                            0,
                            0,
                            0
                        ];
                        if (c) {
                            const t = e1.style.directionalLight, i = e1.style.ambientLight;
                            t && i && (_ = WA(t, i));
                        }
                        {
                            l = -1;
                            const g = s.TRIANGLES, [y, x] = [
                                t.gridIndexBuffer,
                                t.gridSegments
                            ];
                            for (const l of r){
                                const r = i.getTile(l), v = Sx.disabled, b = t.prevTerrainTileForTile[l.key], w = t.terrainTileForTile[l.key];
                                tM(b, w) && iM.newMorphing(l.key, b, w, n, 250), o.activeTexture.set(s.TEXTURE0), r.texture && r.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                const T = iM.getMorphValuesForProxy(l.key), E = T ? 1 : 0;
                                let A;
                                T && (A = {
                                    morphing: {
                                        srcDemTile: T.from,
                                        dstDemTile: T.to,
                                        phase: M(T.phase)
                                    }
                                });
                                const S = JE(l.projMatrix, oM(l.canonical, f.renderWorldCopies) ? m / 10 : m, _);
                                if (u(E), !a) continue;
                                t.setupElevationDraw(r, a, A);
                                const I = l.toUnwrapped();
                                c && c.setupShadows(I, a), e1.uploadCommonUniforms(o, a, I, null, h), a.draw(e1, g, p, v, d, Dx.backCCW, S, "terrain_raster", t.gridBuffer, y, x);
                            }
                        }
                    }
                }(t, this, this.proxySourceCache, e1, this._updateTimestamp), this.renderingToTexture = !0, t.gpuTimingDeferredRenderEnd(), e1.splice(0, e1.length));
            }
            renderBatch(e1) {
                if (0 === this._drapedRenderBatches.length) return e1 + 1;
                this.renderingToTexture = !0;
                const t = this.painter, i = this.painter.context, r = this.proxySourceCache, n = this.proxiedCoords[r.id], o = this._drapedRenderBatches.shift(), s = t.style.order, a = [];
                let l = 0;
                for (const c of n){
                    const n = r.getTileByID(c.proxyTileKey), h = r.proxyCachedFBO[c.key] ? r.proxyCachedFBO[c.key][e1] : void 0, u = void 0 !== h ? r.renderCache[h] : this.pool[l++], d = void 0 !== h;
                    if (n.texture = u.tex, d && !u.dirty) {
                        a.push(n.tileID);
                        continue;
                    }
                    let p;
                    i.bindFramebuffer.set(u.fb.framebuffer), this.renderedToTile = !1, u.dirty && (i.clear({
                        color: hi.transparent,
                        stencil: 0
                    }), u.dirty = !1);
                    for(let e1 = o.start; e1 <= o.end; ++e1){
                        const r = t.style._mergedLayers[s[e1]];
                        if (r.isHidden(t.transform.zoom)) continue;
                        const n = t.style.getLayerSourceCache(r), o = n ? this.proxyToSource[c.key][n.id] : [
                            c
                        ];
                        if (!o) continue;
                        const a = o;
                        i.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), p !== (n ? n.id : null) && (this._setupStencil(u, o, r, n), p = n ? n.id : null), t.renderLayer(t, n, r, a);
                    }
                    if (0 === this._drapedRenderBatches.length) for (const e1 of this._pendingGroundEffectLayers){
                        const r = t.style._mergedLayers[s[e1]];
                        if (r.isHidden(t.transform.zoom)) continue;
                        const n = t.style.getLayerSourceCache(r), o = n ? this.proxyToSource[c.key][n.id] : [
                            c
                        ];
                        if (!o) continue;
                        const a = o;
                        i.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), p !== (n ? n.id : null) && (this._setupStencil(u, o, r, n), p = n ? n.id : null), t.renderLayer(t, n, r, a);
                    }
                    this.renderedToTile ? (u.dirty = !0, a.push(n.tileID)) : d || --l, 5 === l && (l = 0, this.renderToBackBuffer(a));
                }
                return this.renderToBackBuffer(a), this.renderingToTexture = !1, i.bindFramebuffer.set(null), i.viewport.set([
                    0,
                    0,
                    t.width,
                    t.height
                ]), o.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e1) {
                const t = e1.order.length;
                let i = -1, r = t;
                for(let n = 0; n < t; ++n)this._style.isLayerDraped(e1._mergedLayers[e1.order[n]]) ? i = Math.max(i, n) : r = Math.min(r, n);
                return r > i;
            }
            getMinElevationBelowMSL() {
                let e1 = 0;
                return this._visibleDemTiles.filter((e1)=>e1.dem).forEach((t)=>{
                    e1 = Math.min(e1, t.dem.tree.minimums[0]);
                }), 0 === e1 ? e1 : (e1 - 30) * this._exaggeration;
            }
            raycast(e1, t, i) {
                if (!this._visibleDemTiles) return null;
                const r = this._visibleDemTiles.filter((e1)=>e1.dem).map((r)=>{
                    const n = r.tileID, o = 1 << n.overscaledZ, { x: s, y: a } = n.canonical, l = s / o, c = (s + 1) / o, h = a / o, u = (a + 1) / o;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: u,
                        t: r.dem.tree.raycastRoot(l, h, c, u, e1, t, i),
                        tile: r
                    };
                });
                r.sort((e1, t)=>(null !== e1.t ? e1.t : Number.MAX_VALUE) - (null !== t.t ? t.t : Number.MAX_VALUE));
                for (const n of r){
                    if (null == n.t) return null;
                    const r = n.tile.dem.tree.raycast(n.minx, n.miny, n.maxx, n.maxy, e1, t, i);
                    if (null != r) return r;
                }
                return null;
            }
            _createFBO() {
                const e1 = this.painter.context, t = e1.gl, i = this.drapeBufferSize;
                e1.activeTexture.set(t.TEXTURE0);
                const r = new My(e1, {
                    width: i[0],
                    height: i[1],
                    data: null
                }, t.RGBA);
                r.bind(t.LINEAR, t.CLAMP_TO_EDGE);
                const n = e1.createFramebuffer(i[0], i[1], !0, null);
                return n.colorAttachment.set(r.texture), n.depthAttachment = new Tx(e1, n.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = e1.createRenderbuffer(e1.gl.DEPTH_STENCIL, i[0], i[1]), this._stencilRef = 0, n.depthAttachment.set(this._sharedDepthStencil), e1.clear({
                    stencil: 0
                })) : n.depthAttachment.set(this._sharedDepthStencil), e1.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, e1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, e1.extTextureFilterAnisotropicMax), {
                    fb: n,
                    tex: r,
                    dirty: !1
                };
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._style.hasLightTransitions()) return !0;
                for(const e1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e1].hasTransition()) return !0;
                return this._style.order.some((e1)=>{
                    const t = this._style._mergedLayers[e1], i = t.isHidden(this.painter.transform.zoom);
                    return "custom" === t.type ? !i && t.shouldRedrape() : !i && t.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let e1 = !1;
                for (const t of this._style.getSources())if (t instanceof Vw) {
                    e1 = !0;
                    break;
                }
                if (!e1) return;
                const t = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._mergedLayers[this._style.order[e1]], r = this._style.getLayerSourceCache(i);
                    if (r && !t[r.id] && !i.isHidden(this.painter.transform.zoom) && "line" === i.type && i.widthExpression() instanceof Ao) {
                        t[r.id] = !0;
                        for (const e1 of this.proxyCoords){
                            const t = this.proxyToSource[e1.key][r.id];
                            if (t) for (const e1 of t)this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e1 = !1;
                for(const t in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t]._source instanceof jw) {
                    e1 = !0;
                    break;
                }
                if (!e1) return;
                const t = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._mergedLayers[this._style.order[e1]], r = this._style.getLayerSourceCache(i);
                    if (!r || t[r.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const n = i.paint.get("raster-fade-duration");
                    for (const e1 of this.proxyCoords){
                        const t = this.proxyToSource[e1.key][r.id];
                        if (t) for (const e1 of t){
                            const t = aM(r.getTile(e1), r.findLoadedParent(e1, 0), r, this.painter.transform, n);
                            (1 !== t.opacity || 0 !== t.mix) && this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                const e1 = this._style.order, t = e1.length;
                if (0 === t) return;
                const i = [];
                this._pendingGroundEffectLayers = [];
                let r, n = 0, o = this._style._mergedLayers[e1[n]];
                for(; !this._style.isLayerDraped(o) && o.isHidden(this.painter.transform.zoom) && ++n < t;)o = this._style._mergedLayers[e1[n]];
                for(; n < t; ++n){
                    const t = this._style._mergedLayers[e1[n]];
                    t.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(t) ? void 0 === r && (r = n) : ("fill-extrusion" === t.type && this._pendingGroundEffectLayers.push(n), void 0 !== r && (i.push({
                        start: r,
                        end: n - 1
                    }), r = void 0)));
                }
                if (void 0 !== r && i.push({
                    start: r,
                    end: n - 1
                }), 0 !== i.length) {
                    const e1 = i[i.length - 1], t = this._pendingGroundEffectLayers.every((t)=>t > e1.end);
                    t || H("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = i;
            }
            _setupRenderCache(e1) {
                const t = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t.renderCache.length > t.renderCachePool.length) {
                        const e1 = Object.values(t.proxyCachedFBO);
                        t.proxyCachedFBO = {};
                        for(let i = 0; i < e1.length; ++i){
                            const r = Object.values(e1[i]);
                            t.renderCachePool.push(...r);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, r = this._tilesDirty;
                for(let n = i.length - 1; n >= 0; n--){
                    const o = i[n];
                    if (t.getTileByID(o.key), void 0 !== t.proxyCachedFBO[o.key]) {
                        const i = e1[o.key], n = this.proxyToSource[o.key];
                        let s = 0;
                        for(const e1 in n){
                            const t = n[e1], o = i[e1];
                            if (!o || o.length !== t.length || t.some((t, i)=>t !== o[i] || r[e1] && r[e1].hasOwnProperty(t.key))) {
                                s = -1;
                                break;
                            }
                            ++s;
                        }
                        for(const e1 in t.proxyCachedFBO[o.key])t.renderCache[t.proxyCachedFBO[o.key][e1]].dirty = s < 0 || s !== Object.values(i).length;
                    }
                }
                const n = [
                    ...this._drapedRenderBatches
                ];
                n.sort((e1, t)=>t.end - t.start - (e1.end - e1.start));
                for (const e1 of n)for (const r of i){
                    if (t.proxyCachedFBO[r.key]) continue;
                    let i = t.renderCachePool.pop();
                    void 0 === i && t.renderCache.length < 50 && (i = t.renderCache.length, t.renderCache.push(this._createFBO())), void 0 !== i && (t.proxyCachedFBO[r.key] = {}, t.proxyCachedFBO[r.key][e1.start] = i, t.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e1, t, i, r) {
                if (!r || !this._sourceTilesOverlap[r.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const n = this.painter.context, o = n.gl;
                if (t.length <= 1) return void (this._overlapStencilType = !1);
                let s;
                if (i.isTileClipped()) s = t.length, this._overlapStencilMode.test = {
                    func: o.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t[0].overscaledZ > t[t.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    s = 1, this._overlapStencilMode.test = {
                        func: o.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + s > 255 && (n.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += s, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e1) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e1.key]), this._overlapStencilMode) : Sx.disabled;
            }
            _renderTileClippingMasks(e1, t) {
                const i = this.painter, r = this.painter.context, n = r.gl;
                i._tileClippingMaskIDs = {}, r.setColorMode(Cx.disabled), r.setDepthMode(Mx.disabled);
                const o = i.getOrCreateProgram("clippingMask");
                for (const r of e1){
                    const e1 = i._tileClippingMaskIDs[r.key] = --t;
                    o.draw(i, n.TRIANGLES, Mx.disabled, new Sx({
                        func: n.ALWAYS,
                        mask: 0
                    }, e1, 255, n.KEEP, n.KEEP, n.REPLACE), Cx.disabled, Dx.disabled, sM(r.projMatrix), "$clipping", i.tileExtentBuffer, i.quadTriangleIndexBuffer, i.tileExtentSegments);
                }
            }
            pointCoordinate(e1) {
                const t = this.painter.transform;
                if (e1.x < 0 || e1.x > t.width || e1.y < 0 || e1.y > t.height) return null;
                const i = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                yu.transformMat4(i, i, t.pixelMatrixInverse), yu.scale(i, i, 1 / i[3]), i[0] /= t.worldSize, i[1] /= t.worldSize;
                const r = t._camera.position, n = Qd(1, t.center.lat), o = [
                    r[0],
                    r[1],
                    r[2] / n,
                    0
                ], s = Du.subtract([], i.slice(0, 3), o);
                Du.normalize(s, s);
                const a = this.raycast(o, s, this._exaggeration);
                return null !== a && a ? (Du.scaleAndAdd(o, o, s, a), o[3] = o[2], o[2] *= n, o) : null;
            }
            drawDepth() {
                const e1 = this.painter, t = e1.context, i = this.proxySourceCache, r = Math.ceil(e1.width), n = Math.ceil(e1.height);
                if (!this._depthFBO || this._depthFBO.width === r && this._depthFBO.height === n || (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0), !this._depthFBO) {
                    const e1 = t.gl, i = t.createFramebuffer(r, n, !0, "renderbuffer");
                    t.activeTexture.set(e1.TEXTURE0);
                    const o = new My(t, {
                        width: r,
                        height: n,
                        data: null
                    }, e1.RGBA);
                    o.bind(e1.NEAREST, e1.CLAMP_TO_EDGE), i.colorAttachment.set(o.texture);
                    const s = t.createRenderbuffer(t.gl.DEPTH_COMPONENT16, r, n);
                    i.depthAttachment.set(s), this._depthFBO = i, this._depthTexture = o;
                }
                t.bindFramebuffer.set(this._depthFBO.framebuffer), t.viewport.set([
                    0,
                    0,
                    r,
                    n
                ]), function(e1, t, i, r) {
                    if ("globe" === e1.transform.projection.name) return;
                    const n = e1.context, o = n.gl;
                    n.clear({
                        depth: 1
                    });
                    const s = e1.getOrCreateProgram("terrainDepth"), a = new Mx(o.LESS, Mx.ReadWrite, e1.depthRangeFor3D);
                    for (const n of r){
                        const r = i.getTile(n), l = JE(n.projMatrix, 0, [
                            0,
                            0,
                            0
                        ]);
                        t.setupElevationDraw(r, s), s.draw(e1, o.TRIANGLES, a, Sx.disabled, Cx.unblended, Dx.backCCW, l, "terrain_depth", t.gridBuffer, t.gridIndexBuffer, t.gridNoSkirtSegments);
                    }
                }(e1, this, i, this.proxyCoords);
            }
            _setupProxiedCoordsForOrtho(e1, t, i) {
                if (e1.getSource() instanceof Jb) return this._setupProxiedCoordsForImageSource(e1, t, i);
                this._findCoveringTileCache[e1.id] = this._findCoveringTileCache[e1.id] || {};
                const r = this.proxiedCoords[e1.id] = [], n = this.proxyCoords;
                for(let t = 0; t < n.length; t++){
                    const o = n[t], s = this._findTileCoveringTileID(o, e1);
                    if (s) {
                        const t = this._createProxiedId(o, s, i[o.key] && i[o.key][e1.id]);
                        r.push(t), this.proxyToSource[o.key][e1.id] = [
                            t
                        ];
                    }
                }
                let o = !1;
                for(let n = 0; n < t.length; n++){
                    const s = e1.getTile(t[n]);
                    if (!s || !s.hasData()) continue;
                    const a = this._findTileCoveringTileID(s.tileID, this.proxySourceCache);
                    if (a && a.tileID.canonical.z !== s.tileID.canonical.z) {
                        const t = this.proxyToSource[a.tileID.key][e1.id], n = this._createProxiedId(a.tileID, s, i[a.tileID.key] && i[a.tileID.key][e1.id]);
                        t ? t.splice(t.length - 1, 0, n) : this.proxyToSource[a.tileID.key][e1.id] = [
                            n
                        ], r.push(n), o = !0;
                    }
                }
                this._sourceTilesOverlap[e1.id] = o;
            }
            _setupProxiedCoordsForImageSource(e1, t, i) {
                if (!e1.getSource().loaded()) return;
                const r = this.proxiedCoords[e1.id] = [], n = this.proxyCoords, o = e1.getSource(), s = o.tileID;
                if (!s) return;
                const a = new y(s.x, s.y)._div(1 << s.z), l = o.coordinates.map(lp.fromLngLat).reduce((e1, t)=>(e1.min.x = Math.min(e1.min.x, t.x - a.x), e1.min.y = Math.min(e1.min.y, t.y - a.y), e1.max.x = Math.max(e1.max.x, t.x - a.x), e1.max.y = Math.max(e1.max.y, t.y - a.y), e1), {
                    min: new y(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new y(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), c = (e1, t)=>{
                    const i = e1.wrap + e1.canonical.x / (1 << e1.canonical.z), r = e1.canonical.y / (1 << e1.canonical.z), n = cr / (1 << e1.canonical.z), o = t.wrap + t.canonical.x / (1 << t.canonical.z), s = t.canonical.y / (1 << t.canonical.z);
                    return i + n < o + l.min.x || i > o + l.max.x || r + n < s + l.min.y || r > s + l.max.y;
                };
                for(let o = 0; o < n.length; o++){
                    const s = n[o];
                    for(let n = 0; n < t.length; n++){
                        const o = e1.getTile(t[n]);
                        if (!o || !o.hasData()) continue;
                        if (c(s, o.tileID)) continue;
                        const a = this._createProxiedId(s, o, i[s.key] && i[s.key][e1.id]), l = this.proxyToSource[s.key][e1.id];
                        l ? l.push(a) : this.proxyToSource[s.key][e1.id] = [
                            a
                        ], r.push(a);
                    }
                }
            }
            _createProxiedId(e1, t, i) {
                let r = this.orthoMatrix;
                if (i) {
                    const e1 = i.find((e1)=>e1.key === t.tileID.key);
                    if (e1) return e1;
                }
                if (t.tileID.key !== e1.key) {
                    const i = e1.canonical.z - t.tileID.canonical.z;
                    let n, o, s;
                    r = Au.create();
                    const a = t.tileID.wrap - e1.wrap << e1.overscaledZ;
                    i > 0 ? (n = cr >> i, o = n * ((t.tileID.canonical.x << i) - e1.canonical.x + a), s = n * ((t.tileID.canonical.y << i) - e1.canonical.y)) : (n = cr << -i, o = cr * (t.tileID.canonical.x - (e1.canonical.x + a << -i)), s = cr * (t.tileID.canonical.y - (e1.canonical.y << -i))), Au.ortho(r, 0, n, 0, n, 0, 1), Au.translate(r, r, [
                        o,
                        s,
                        0
                    ]);
                }
                return new hM(t.tileID, e1.key, r);
            }
            _findTileCoveringTileID(e1, t) {
                let i = t.getTile(e1);
                if (i && i.hasData()) return i;
                const r = this._findCoveringTileCache[t.id], n = r[e1.key];
                if (i = n ? t.getTileByID(n) : null, i && i.hasData() || null === n) return i;
                let o = i ? i.tileID : e1, s = o.overscaledZ;
                const a = t.getSource().minzoom, l = [];
                if (!n) {
                    const r = t.getSource().maxzoom;
                    if (e1.canonical.z >= r) {
                        const i = e1.canonical.z - r;
                        t.getSource().reparseOverscaled ? (s = Math.max(e1.canonical.z + 2, t.transform.tileZoom), o = new qu(s, e1.wrap, r, e1.canonical.x >> i, e1.canonical.y >> i)) : 0 !== i && (s = r, o = new qu(s, e1.wrap, r, e1.canonical.x >> i, e1.canonical.y >> i));
                    }
                    o.key !== e1.key && (l.push(o.key), i = t.getTile(o));
                }
                const c = (e1)=>{
                    l.forEach((t)=>{
                        r[t] = e1;
                    }), l.length = 0;
                };
                for(s -= 1; s >= a && (!i || !i.hasData()); s--){
                    i && c(i.tileID.key);
                    const e1 = o.calculateScaledKey(s);
                    if (i = t.getTileByID(e1), i && i.hasData()) break;
                    const n = r[e1];
                    if (null === n) break;
                    void 0 === n ? l.push(e1) : i = t.getTileByID(n);
                }
                return c(i ? i.tileID.key : null), i && i.hasData() ? i : null;
            }
            findDEMTileFor(e1) {
                return this.enabled ? this._findTileCoveringTileID(e1, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e1, t) {
                let i = this._tilesDirty[e1];
                i || (i = this._tilesDirty[e1] = {}), i[t.key] = !0;
            }
        }
        function dM(e1, t, i) {
            const r = function(e1, t, i) {
                const r = Du.dot(t, e1), n = Du.dot(i, [
                    .2126,
                    .7152,
                    .0722
                ]), o = (e1, t, i)=>(1 - i) * e1 + i * t, s = o(1 - .3 * Math.min(n, 1), 1, Math.min(r + 1, 1));
                return o(.92, 1, Math.asin(z(t[2], -1, 1)) / Math.PI + .5) * s;
            }(e1, [
                0,
                0,
                1
            ], t), n = [
                0,
                0,
                0
            ];
            Du.scale(n, i.slice(0, 3), r);
            const o = [
                0,
                0,
                0
            ];
            Du.scale(o, t.slice(0, 3), e1[2]);
            const s = [
                0,
                0,
                0
            ];
            return Du.add(s, n, o), ae(s);
        }
        const pM = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], fM = [
            "stars",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "model",
            "symbolSDF",
            "symbolIcon",
            "symbolTextAndIcon"
        ];
        class mM {
            static cacheKey(e1, t, i, r) {
                let n = `${t}${r ? r.cacheKey : ""}`;
                for (const t of i)e1.usedDefines.includes(t) && (n += `/${t}`);
                return n;
            }
            constructor(e1, t, i, r, n, o){
                const s = e1.gl;
                this.program = s.createProgram(), this.configuration = r, this.name = t, this.fixedDefines = [
                    ...o
                ];
                const a = r ? r.getBinderAttributes() : [], l = (i.staticAttributes || []).concat(a);
                let c = r ? r.defines() : [];
                c = c.concat(o.map((e1)=>`#define ${e1}`));
                const h = "#version 300 es\n";
                let u = h + c.concat("precision mediump float;", jE, VE.fragmentSource).join("\n");
                for (const e1 of i.fragmentIncludes)u += `\n${NE[e1]}`;
                u += `\n${i.fragmentSource}`;
                let d = h + c.concat("precision highp float;", jE, VE.vertexSource).join("\n");
                for (const e1 of i.vertexIncludes)d += `\n${NE[e1]}`;
                d += `\n${i.vertexSource}`;
                const p = s.createShader(s.FRAGMENT_SHADER);
                if (s.isContextLost()) return void (this.failedToCreate = !0);
                s.shaderSource(p, u), s.compileShader(p), s.attachShader(this.program, p);
                const f = s.createShader(s.VERTEX_SHADER);
                if (s.isContextLost()) this.failedToCreate = !0;
                else {
                    s.shaderSource(f, d), s.compileShader(f), s.attachShader(this.program, f), this.attributes = {}, this.numAttributes = l.length;
                    for(let e1 = 0; e1 < this.numAttributes; e1++)if (l[e1]) {
                        const t = l[e1].startsWith("a_") ? l[e1] : `a_${l[e1]}`;
                        s.bindAttribLocation(this.program, e1, t), this.attributes[t] = e1;
                    }
                    s.linkProgram(this.program), s.deleteShader(f), s.deleteShader(p), this.fixedUniforms = n(e1), this.binderUniforms = r ? r.getUniforms(e1) : [], o.includes("TERRAIN") && (this.terrainUniforms = ((e1)=>({
                            u_dem: new kl(e1),
                            u_dem_prev: new kl(e1),
                            u_dem_tl: new Bl(e1),
                            u_dem_scale: new Ol(e1),
                            u_dem_tl_prev: new Bl(e1),
                            u_dem_scale_prev: new Ol(e1),
                            u_dem_size: new Ol(e1),
                            u_dem_lerp: new Ol(e1),
                            u_exaggeration: new Ol(e1),
                            u_depth: new kl(e1),
                            u_depth_size_inv: new Bl(e1),
                            u_meter_to_dem: new Ol(e1),
                            u_label_plane_matrix_inv: new jl(e1)
                        }))(e1)), o.includes("GLOBE") && (this.globeUniforms = ((e1)=>({
                            u_tile_tl_up: new Fl(e1),
                            u_tile_tr_up: new Fl(e1),
                            u_tile_br_up: new Fl(e1),
                            u_tile_bl_up: new Fl(e1),
                            u_tile_up_scale: new Ol(e1)
                        }))(e1)), o.includes("FOG") && (this.fogUniforms = ((e1)=>({
                            u_fog_matrix: new jl(e1),
                            u_fog_range: new Bl(e1),
                            u_fog_color: new Nl(e1),
                            u_fog_horizon_blend: new Ol(e1),
                            u_fog_vertical_limit: new Bl(e1),
                            u_fog_temporal_offset: new Ol(e1),
                            u_frustum_tl: new Fl(e1),
                            u_frustum_tr: new Fl(e1),
                            u_frustum_br: new Fl(e1),
                            u_frustum_bl: new Fl(e1),
                            u_globe_pos: new Fl(e1),
                            u_globe_radius: new Ol(e1),
                            u_globe_transition: new Ol(e1),
                            u_is_globe: new kl(e1),
                            u_viewport: new Bl(e1)
                        }))(e1)), o.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((e1)=>({
                            u_cutoff_params: new Nl(e1)
                        }))(e1)), o.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((e1)=>({
                            u_lighting_ambient_color: new Fl(e1),
                            u_lighting_directional_dir: new Fl(e1),
                            u_lighting_directional_color: new Fl(e1),
                            u_ground_radiance: new Fl(e1)
                        }))(e1)), o.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((e1)=>({
                            u_light_matrix_0: new jl(e1),
                            u_light_matrix_1: new jl(e1),
                            u_fade_range: new Bl(e1),
                            u_shadow_normal_offset: new Fl(e1),
                            u_shadow_intensity: new Ol(e1),
                            u_shadow_texel_size: new Ol(e1),
                            u_shadow_map_resolution: new Ol(e1),
                            u_shadow_direction: new Fl(e1),
                            u_shadow_bias: new Fl(e1),
                            u_shadowmap_0: new kl(e1),
                            u_shadowmap_1: new kl(e1)
                        }))(e1));
                }
            }
            setTerrainUniformValues(e1, t) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1] && i[e1].set(this.program, e1, t[e1]);
                }
            }
            setGlobeUniformValues(e1, t) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1] && i[e1].set(this.program, e1, t[e1]);
                }
            }
            setFogUniformValues(e1, t) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
                }
            }
            setCutoffUniformValues(e1, t) {
                if (!this.cutoffUniforms) return;
                const i = this.cutoffUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
                }
            }
            setLightsUniformValues(e1, t) {
                if (!this.lightsUniforms) return;
                const i = this.lightsUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
                }
            }
            setShadowUniformValues(e1, t) {
                if (this.failedToCreate || !this.shadowUniforms) return;
                const i = this.shadowUniforms;
                e1.program.set(this.program);
                for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
            }
            _drawDebugWireframe(e1, t, i, r, n, o, s, a, l, c) {
                const h = e1.options.wireframe;
                if (!1 === h.terrain && !1 === h.layers2D && !1 === h.layers3D) return;
                const u = e1.context;
                if (!(()=>!(!h.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!h.layers2D || e1._terrain && e1._terrain.renderingToTexture || !pM.includes(this.name)) || !(!h.layers3D || !fM.includes(this.name)))()) return;
                const d = u.gl, p = e1.wireframeDebugCache.getLinesFromTrianglesBuffer(e1.frameCounter, n, u);
                if (!p) return;
                const f = [
                    ...this.fixedDefines
                ];
                f.push("DEBUG_WIREFRAME");
                const m = e1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: f
                });
                u.program.set(m.program);
                const _ = (e1, t, i)=>{
                    if (t[e1] && i[e1]) for(const r in t[e1])i[e1][r] && i[e1][r].set(i.program, r, t[e1][r].current);
                };
                l && l.setUniforms(m.program, u, m.binderUniforms, s, {
                    zoom: a
                }), _("fixedUniforms", this, m), _("terrainUniforms", this, m), _("globeUniforms", this, m), _("fogUniforms", this, m), _("lightsUniforms", this, m), _("shadowUniforms", this, m), p.bind(), u.setColorMode(new Cx([
                    d.ONE,
                    d.ONE_MINUS_SRC_ALPHA,
                    d.ZERO,
                    d.ONE
                ], hi.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), u.setDepthMode(new Mx(t.func === d.LESS ? d.LEQUAL : t.func, Mx.ReadOnly, t.range)), u.setStencilMode(Sx.disabled);
                const g = 3 * o.primitiveLength * 2, y = 3 * o.primitiveOffset * 4;
                c && c > 1 ? d.drawElementsInstanced(d.LINES, g, d.UNSIGNED_SHORT, y, c) : d.drawElements(d.LINES, g, d.UNSIGNED_SHORT, y), n.bind(), u.program.set(this.program), u.setDepthMode(t), u.setStencilMode(i), u.setColorMode(r);
            }
            draw(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
                const _ = e1.context, g = _.gl;
                if (this.failedToCreate) return;
                _.program.set(this.program), _.setDepthMode(i), _.setStencilMode(r), _.setColorMode(n), _.setCullFace(o);
                for (const e1 of Object.keys(this.fixedUniforms))this.fixedUniforms[e1].set(this.program, e1, s[e1]);
                p && p.setUniforms(this.program, _, this.binderUniforms, u, {
                    zoom: d
                });
                const y = {
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t], x = m && m > 0 ? 1 : void 0;
                for (const o of h.get()){
                    const s = o.vaos || (o.vaos = {});
                    (s[a] || (s[a] = new $E)).bind(_, this, l, p ? p.getPaintVertexBuffers() : [], c, o.vertexOffset, f || [], x), m && m > 1 ? g.drawElementsInstanced(t, o.primitiveLength * y, g.UNSIGNED_SHORT, o.primitiveOffset * y * 2, m) : g.drawElements(t, o.primitiveLength * y, g.UNSIGNED_SHORT, o.primitiveOffset * y * 2), t === g.TRIANGLES && this._drawDebugWireframe(e1, i, r, n, c, o, u, d, p, m);
                }
            }
        }
        function _M(e1, t) {
            const i = Math.pow(2, t.tileID.overscaledZ), r = t.tileSize * Math.pow(2, e1.transform.tileZoom) / i, n = r * (t.tileID.canonical.x + t.tileID.wrap * i), o = r * t.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: t.imageAtlasTexture ? t.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / rv(t, 1, e1.transform.tileZoom),
                u_pixel_coord_upper: [
                    n >> 16,
                    o >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & o
                ]
            };
        }
        const gM = Au.create(), yM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m)=>{
            const _ = t.style.light, g = _.properties.get("position"), y = [
                g.x,
                g.y,
                g.z
            ], x = Eu.create();
            "viewport" === _.properties.get("anchor") && (Eu.fromRotation(x, -t.transform.angle), Du.transformMat3(y, y, x));
            const v = _.properties.get("color"), b = t.transform, w = {
                u_matrix: e1,
                u_lightpos: y,
                u_lightintensity: _.properties.get("intensity"),
                u_lightcolor: [
                    v.r,
                    v.g,
                    v.b
                ],
                u_vertical_gradient: +i,
                u_opacity: r,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: gM,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_ao: n,
                u_edge_radius: o,
                u_flood_light_color: u,
                u_vertical_scale: d,
                u_flood_light_intensity: p,
                u_ground_shadow_factor: f,
                u_emissive_strength: m
            };
            return "globe" === b.projection.name && (w.u_tile_id = [
                s.canonical.x,
                s.canonical.y,
                1 << s.canonical.z
            ], w.u_zoom_transition = l, w.u_inv_rot_matrix = h, w.u_merc_center = c, w.u_up_dir = b.projection.upVector(new ju(0, 0, 0), c[0] * cr, c[1] * cr), w.u_height_lift = a), w;
        }, xM = (e1, t, i)=>({
                u_matrix: e1,
                u_edge_radius: t,
                u_vertical_scale: i
            }), vM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p)=>{
            const f = yM(e1, t, i, r, n, o, s, l, c, h, u, d, p, 1, [
                0,
                0,
                0
            ], 0), m = {
                u_height_factor: -Math.pow(2, s.overscaledZ) / a.tileSize / 8
            };
            return k(f, _M(t, a), m);
        }, bM = (e1, t)=>({
                u_matrix: e1,
                u_emissive_strength: t
            }), wM = (e1, t, i, r)=>k(bM(e1, t), _M(i, r)), TM = (e1, t, i)=>({
                u_matrix: e1,
                u_world: i,
                u_emissive_strength: t
            }), EM = (e1, t, i, r, n)=>k(wM(e1, t, i, r), {
                u_world: n
            }), MM = (e1, t, i, r)=>{
            const n = cr / i.tileSize;
            return {
                u_matrix: e1,
                u_camera_to_center_distance: t.getCameraToCenterDistance(r),
                u_extrude_scale: [
                    t.pixelsToGLUnits[0] / n,
                    t.pixelsToGLUnits[1] / n
                ]
            };
        }, AM = (e1, t, i = 1)=>({
                u_matrix: e1,
                u_color: t,
                u_overlay: 0,
                u_overlay_scale: i
            }), SM = Au.create(), IM = (e1, t, i, r, n, o, s)=>{
            const a = e1.transform, l = "globe" === a.projection.name, c = l ? Cd(a.zoom, t.canonical) * a._pixelsPerMercatorPixel : rv(i, 1, o), h = {
                u_matrix: t.projMatrix,
                u_extrude_scale: c,
                u_intensity: s,
                u_inv_rot_matrix: SM,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (l) {
                h.u_inv_rot_matrix = r, h.u_merc_center = n, h.u_tile_id = [
                    t.canonical.x,
                    t.canonical.y,
                    1 << t.canonical.z
                ], h.u_zoom_transition = Dd(a.zoom);
                const e1 = n[0] * cr, i = n[1] * cr;
                h.u_up_dir = a.projection.upVector(new ju(0, 0, 0), e1, i);
            }
            return h;
        }, CM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b)=>{
            var w, T;
            return {
                u_matrix: e1,
                u_normalize_matrix: t,
                u_globe_matrix: i,
                u_merc_matrix: r,
                u_grid_matrix: n,
                u_tl_parent: o,
                u_scale_parent: h,
                u_fade_t: u.mix,
                u_opacity: u.opacity * d.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: d.paint.get("raster-brightness-min"),
                u_brightness_high: d.paint.get("raster-brightness-max"),
                u_saturation_factor: (T = d.paint.get("raster-saturation"), T > 0 ? 1 - 1 / (1.001 - T) : -T),
                u_contrast_factor: (w = d.paint.get("raster-contrast"), w > 0 ? 1 / (1 - w) : 1 + w),
                u_spin_weights: zM(d.paint.get("raster-hue-rotate")),
                u_perspective_transform: p,
                u_raster_elevation: f,
                u_tl_br: s,
                u_zoom_transition: a,
                u_merc_center: l,
                u_cutoff_params: c,
                u_colorization_mix: PM(_, y),
                u_colorization_offset: DM(g, y),
                u_color_ramp: m,
                u_texture_offset: [
                    v / (x + 2 * v),
                    x / (x + 2 * v)
                ],
                u_texture_res: [
                    x + 2 * v,
                    x + 2 * v
                ],
                u_emissive_strength: b
            };
        };
        function zM(e1) {
            e1 *= Math.PI / 180;
            const t = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t - i + 1) / 3,
                (Math.sqrt(3) * t - i + 1) / 3
            ];
        }
        function PM([e1, t, i, r], [n, o]) {
            if (n === o) return [
                0,
                0,
                0,
                0
            ];
            const s = 259 / 257 / (o - n);
            return [
                e1 * s,
                t * s,
                i * s,
                r * s
            ];
        }
        function DM(e1, [t, i]) {
            return t === i ? 0 : ((e1 - t) / (i - t) * 259 - 1) / 257;
        }
        const RM = Au.create(), LM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g)=>{
            const y = n.transform, x = {
                u_is_size_zoom_constant: +("constant" === e1 || "source" === e1),
                u_is_size_feature_constant: +("constant" === e1 || "camera" === e1),
                u_size_t: t ? t.uSizeT : 0,
                u_size: t ? t.uSize : 0,
                u_camera_to_center_distance: y.getCameraToCenterDistance(m),
                u_rotate_symbol: +i,
                u_aspect_ratio: y.width / y.height,
                u_fade_change: n.options.fadeDuration ? n.symbolFadeChange : 1,
                u_matrix: o,
                u_label_plane_matrix: s,
                u_coord_matrix: a,
                u_is_text: +l,
                u_pitch_with_map: +r,
                u_texsize: c,
                u_texture: 0,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: RM,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: RM,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_icon_transition: g || 0,
                u_icon_saturation: _
            };
            return "globe" === m.name && (x.u_tile_id = [
                h.canonical.x,
                h.canonical.y,
                1 << h.canonical.z
            ], x.u_zoom_transition = u, x.u_inv_rot_matrix = p, x.u_merc_center = d, x.u_camera_forward = y._camera.forward(), x.u_ecef_origin = function(e1, t) {
                const i = [
                    0,
                    0,
                    0
                ], r = Ad(fd(t.canonical));
                return Du.transformMat4(i, i, r), Du.transformMat4(i, i, e1), i;
            }(y.globeMatrix, h.toUnwrapped()), x.u_tile_matrix = Float32Array.from(y.globeMatrix), x.u_up_vector = f), x;
        }, kM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _)=>k(LM(e1, t, i, r, n, o, s, a, l, c, u, d, p, f, m, _, 1), {
                u_gamma_scale: r ? n.transform.getCameraToCenterDistance(_) * Math.cos(n.terrain ? 0 : n.transform._pitch) : 1,
                u_device_pixel_ratio: dt.devicePixelRatio,
                u_is_halo: +h,
                undefined: void 0
            }), OM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m)=>k(kM(e1, t, i, r, n, o, s, a, !0, l, !0, h, u, d, p, f, m), {
                u_texsize_icon: c,
                u_texture_icon: 1
            }), BM = (e1, t, i, r)=>({
                u_matrix: e1,
                u_emissive_strength: t,
                u_opacity: i,
                u_color: r
            }), FM = (e1, t, i, r, n, o, s)=>k(function(e1, t, i, r) {
                const n = i.imageManager.getPattern(e1.toString(), t), { width: o, height: s } = i.imageManager.getPixelSize(t), a = Math.pow(2, r.tileID.overscaledZ), l = r.tileSize * Math.pow(2, i.transform.tileZoom) / a, c = l * (r.tileID.canonical.x + r.tileID.wrap * a), h = l * r.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: n.tl,
                    u_pattern_br: n.br,
                    u_texsize: [
                        o,
                        s
                    ],
                    u_pattern_size: n.displaySize,
                    u_tile_units_to_pixels: 1 / rv(r, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        c >> 16,
                        h >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & c,
                        65535 & h
                    ]
                };
            }(n, o, r, s), {
                u_matrix: e1,
                u_emissive_strength: t,
                u_opacity: i
            }), NM = {
            BaseColor: 5,
            MetallicRoughness: 6,
            Normal: 7,
            Occlusion: 8,
            Emission: 9,
            ShadowMap0: 10
        }, UM = (e1, t, i, r, n, o, s, a, l, c, h, u, d = [
            0,
            0,
            0
        ])=>{
            const p = r.style.light, f = p.properties.get("position"), m = [
                -f.x,
                -f.y,
                f.z
            ], _ = Eu.create();
            "viewport" === p.properties.get("anchor") && (Eu.fromRotation(_, -r.transform.angle), Du.transformMat3(m, m, _));
            const g = "MASK" === c.alphaMode, y = p.properties.get("color"), x = u.paint.get("model-ambient-occlusion-intensity"), v = u.paint.get("model-color").constantOr(hi.white), b = u.paint.get("model-color-mix-intensity").constantOr(0);
            return {
                u_matrix: e1,
                u_lighting_matrix: t,
                u_normal_matrix: i,
                u_lightpos: m,
                u_lightintensity: p.properties.get("intensity"),
                u_lightcolor: [
                    y.r,
                    y.g,
                    y.b
                ],
                u_camera_pos: d,
                u_opacity: n,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +g,
                u_alphaCutoff: c.alphaCutoff,
                u_baseColorFactor: [
                    o.r,
                    o.g,
                    o.b,
                    o.a
                ],
                u_emissiveFactor: [
                    s[0],
                    s[1],
                    s[2],
                    1
                ],
                u_metallicFactor: a,
                u_roughnessFactor: l,
                u_baseColorTexture: NM.BaseColor,
                u_metallicRoughnessTexture: NM.MetallicRoughness,
                u_normalTexture: NM.Normal,
                u_occlusionTexture: NM.Occlusion,
                u_emissionTexture: NM.Emission,
                u_color_mix: [
                    v.r,
                    v.g,
                    v.b,
                    b
                ],
                u_aoIntensity: x,
                u_emissive_strength: h
            };
        }, VM = new Float32Array(16), jM = (e1, t = VM, i = VM)=>({
                u_matrix: e1,
                u_instance: t,
                u_node_matrix: i
            }), GM = {
            fillExtrusion: (e1)=>({
                    u_matrix: new jl(e1),
                    u_lightpos: new Fl(e1),
                    u_lightintensity: new Ol(e1),
                    u_lightcolor: new Fl(e1),
                    u_vertical_gradient: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_edge_radius: new Ol(e1),
                    u_ao: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_up_dir: new Fl(e1),
                    u_height_lift: new Ol(e1),
                    u_flood_light_color: new Fl(e1),
                    u_vertical_scale: new Ol(e1),
                    u_flood_light_intensity: new Ol(e1),
                    u_ground_shadow_factor: new Fl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            fillExtrusionDepth: (e1)=>({
                    u_matrix: new jl(e1),
                    u_edge_radius: new Ol(e1),
                    u_vertical_scale: new Ol(e1)
                }),
            fillExtrusionPattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_lightpos: new Fl(e1),
                    u_lightintensity: new Ol(e1),
                    u_lightcolor: new Fl(e1),
                    u_vertical_gradient: new Ol(e1),
                    u_height_factor: new Ol(e1),
                    u_edge_radius: new Ol(e1),
                    u_ao: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_up_dir: new Fl(e1),
                    u_height_lift: new Ol(e1),
                    u_image: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1),
                    u_opacity: new Ol(e1)
                }),
            fillExtrusionGroundEffect: (e1)=>({
                    u_matrix: new jl(e1),
                    u_opacity: new Ol(e1),
                    u_ao_pass: new Ol(e1),
                    u_meter_to_tile: new Ol(e1),
                    u_ao: new Bl(e1),
                    u_flood_light_intensity: new Ol(e1),
                    u_flood_light_color: new Fl(e1),
                    u_attenuation: new Ol(e1),
                    u_edge_radius: new Ol(e1),
                    u_fb: new kl(e1),
                    u_fb_size: new Ol(e1)
                }),
            fill: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            fillPattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_image: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1)
                }),
            fillOutline: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_world: new Bl(e1)
                }),
            fillOutlinePattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_world: new Bl(e1),
                    u_image: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1)
                }),
            circle: (e1)=>({
                    u_camera_to_center_distance: new Ol(e1),
                    u_extrude_scale: new $l(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_up_dir: new Fl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            collisionBox: (e1)=>({
                    u_matrix: new jl(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_extrude_scale: new Bl(e1)
                }),
            collisionCircle: (e1)=>({
                    u_matrix: new jl(e1),
                    u_inv_matrix: new jl(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_viewport_size: new Bl(e1)
                }),
            debug: (e1)=>({
                    u_color: new Ul(e1),
                    u_matrix: new jl(e1),
                    u_overlay: new kl(e1),
                    u_overlay_scale: new Ol(e1)
                }),
            clippingMask: (e1)=>({
                    u_matrix: new jl(e1)
                }),
            heatmap: (e1)=>({
                    u_extrude_scale: new Ol(e1),
                    u_intensity: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_up_dir: new Fl(e1)
                }),
            heatmapTexture: (e1)=>({
                    u_image: new kl(e1),
                    u_color_ramp: new kl(e1),
                    u_opacity: new Ol(e1)
                }),
            hillshade: (e1)=>({
                    u_matrix: new jl(e1),
                    u_image: new kl(e1),
                    u_latrange: new Bl(e1),
                    u_light: new Bl(e1),
                    u_shadow: new Ul(e1),
                    u_highlight: new Ul(e1),
                    u_emissive_strength: new Ol(e1),
                    u_accent: new Ul(e1)
                }),
            hillshadePrepare: (e1)=>({
                    u_matrix: new jl(e1),
                    u_image: new kl(e1),
                    u_dimension: new Bl(e1),
                    u_zoom: new Ol(e1)
                }),
            line: (e1)=>({
                    u_matrix: new jl(e1),
                    u_pixels_to_tile_units: new $l(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_units_to_pixels: new Bl(e1),
                    u_dash_image: new kl(e1),
                    u_gradient_image: new kl(e1),
                    u_image_height: new Ol(e1),
                    u_texsize: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1),
                    u_alpha_discard_threshold: new Ol(e1),
                    u_trim_offset: new Bl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            linePattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_texsize: new Bl(e1),
                    u_pixels_to_tile_units: new $l(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_image: new kl(e1),
                    u_units_to_pixels: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1),
                    u_alpha_discard_threshold: new Ol(e1)
                }),
            raster: (e1)=>({
                    u_matrix: new jl(e1),
                    u_normalize_matrix: new jl(e1),
                    u_globe_matrix: new jl(e1),
                    u_merc_matrix: new jl(e1),
                    u_grid_matrix: new ql(e1),
                    u_tl_parent: new Bl(e1),
                    u_scale_parent: new Ol(e1),
                    u_fade_t: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_image0: new kl(e1),
                    u_image1: new kl(e1),
                    u_brightness_low: new Ol(e1),
                    u_brightness_high: new Ol(e1),
                    u_saturation_factor: new Ol(e1),
                    u_contrast_factor: new Ol(e1),
                    u_spin_weights: new Fl(e1),
                    u_perspective_transform: new Bl(e1),
                    u_raster_elevation: new Ol(e1),
                    u_tl_br: new Nl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_merc_center: new Bl(e1),
                    u_cutoff_params: new Nl(e1),
                    u_colorization_mix: new Nl(e1),
                    u_colorization_offset: new Ol(e1),
                    u_color_ramp: new kl(e1),
                    u_texture_offset: new Bl(e1),
                    u_texture_res: new Bl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            symbolIcon: (e1)=>({
                    u_is_size_zoom_constant: new kl(e1),
                    u_is_size_feature_constant: new kl(e1),
                    u_size_t: new Ol(e1),
                    u_size: new Ol(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_rotate_symbol: new kl(e1),
                    u_aspect_ratio: new Ol(e1),
                    u_fade_change: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_label_plane_matrix: new jl(e1),
                    u_coord_matrix: new jl(e1),
                    u_is_text: new kl(e1),
                    u_pitch_with_map: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_camera_forward: new Fl(e1),
                    u_tile_matrix: new jl(e1),
                    u_up_vector: new Fl(e1),
                    u_ecef_origin: new Fl(e1),
                    u_texture: new kl(e1),
                    u_icon_transition: new Ol(e1),
                    u_icon_saturation: new Ol(e1)
                }),
            symbolSDF: (e1)=>({
                    u_is_size_zoom_constant: new kl(e1),
                    u_is_size_feature_constant: new kl(e1),
                    u_size_t: new Ol(e1),
                    u_size: new Ol(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_rotate_symbol: new kl(e1),
                    u_aspect_ratio: new Ol(e1),
                    u_fade_change: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_label_plane_matrix: new jl(e1),
                    u_coord_matrix: new jl(e1),
                    u_is_text: new kl(e1),
                    u_pitch_with_map: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_texture: new kl(e1),
                    u_gamma_scale: new Ol(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_camera_forward: new Fl(e1),
                    u_tile_matrix: new jl(e1),
                    u_up_vector: new Fl(e1),
                    u_ecef_origin: new Fl(e1),
                    u_is_halo: new kl(e1)
                }),
            symbolTextAndIcon: (e1)=>({
                    u_is_size_zoom_constant: new kl(e1),
                    u_is_size_feature_constant: new kl(e1),
                    u_size_t: new Ol(e1),
                    u_size: new Ol(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_rotate_symbol: new kl(e1),
                    u_aspect_ratio: new Ol(e1),
                    u_fade_change: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_label_plane_matrix: new jl(e1),
                    u_coord_matrix: new jl(e1),
                    u_is_text: new kl(e1),
                    u_pitch_with_map: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_texsize_icon: new Bl(e1),
                    u_texture: new kl(e1),
                    u_texture_icon: new kl(e1),
                    u_gamma_scale: new Ol(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_is_halo: new kl(e1)
                }),
            background: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_color: new Ul(e1)
                }),
            backgroundPattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_image: new kl(e1),
                    u_pattern_tl: new Bl(e1),
                    u_pattern_br: new Bl(e1),
                    u_texsize: new Bl(e1),
                    u_pattern_size: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1)
                }),
            terrainRaster: KE,
            terrainDepth: KE,
            skybox: (e1)=>({
                    u_matrix: new jl(e1),
                    u_sun_direction: new Fl(e1),
                    u_cubemap: new kl(e1),
                    u_opacity: new Ol(e1),
                    u_temporal_offset: new Ol(e1)
                }),
            skyboxGradient: (e1)=>({
                    u_matrix: new jl(e1),
                    u_color_ramp: new kl(e1),
                    u_center_direction: new Fl(e1),
                    u_radius: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_temporal_offset: new Ol(e1)
                }),
            skyboxCapture: (e1)=>({
                    u_matrix_3f: new ql(e1),
                    u_sun_direction: new Fl(e1),
                    u_sun_intensity: new Ol(e1),
                    u_color_tint_r: new Nl(e1),
                    u_color_tint_m: new Nl(e1),
                    u_luminance: new Ol(e1)
                }),
            globeRaster: (e1)=>({
                    u_proj_matrix: new jl(e1),
                    u_globe_matrix: new jl(e1),
                    u_normalize_matrix: new jl(e1),
                    u_merc_matrix: new jl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_merc_center: new Bl(e1),
                    u_image0: new kl(e1),
                    u_grid_matrix: new ql(e1),
                    u_skirt_height: new Ol(e1),
                    u_frustum_tl: new Fl(e1),
                    u_frustum_tr: new Fl(e1),
                    u_frustum_br: new Fl(e1),
                    u_frustum_bl: new Fl(e1),
                    u_globe_pos: new Fl(e1),
                    u_globe_radius: new Ol(e1),
                    u_viewport: new Bl(e1)
                }),
            globeAtmosphere: (e1)=>({
                    u_frustum_tl: new Fl(e1),
                    u_frustum_tr: new Fl(e1),
                    u_frustum_br: new Fl(e1),
                    u_frustum_bl: new Fl(e1),
                    u_horizon: new Ol(e1),
                    u_transition: new Ol(e1),
                    u_fadeout_range: new Ol(e1),
                    u_color: new Nl(e1),
                    u_high_color: new Nl(e1),
                    u_space_color: new Nl(e1),
                    u_temporal_offset: new Ol(e1),
                    u_horizon_angle: new Ol(e1)
                }),
            model: (e1)=>({
                    u_matrix: new jl(e1),
                    u_lighting_matrix: new jl(e1),
                    u_normal_matrix: new jl(e1),
                    u_lightpos: new Fl(e1),
                    u_lightintensity: new Ol(e1),
                    u_lightcolor: new Fl(e1),
                    u_camera_pos: new Fl(e1),
                    u_opacity: new Ol(e1),
                    u_baseColorFactor: new Nl(e1),
                    u_emissiveFactor: new Nl(e1),
                    u_metallicFactor: new Ol(e1),
                    u_roughnessFactor: new Ol(e1),
                    u_baseTextureIsAlpha: new kl(e1),
                    u_alphaMask: new kl(e1),
                    u_alphaCutoff: new Ol(e1),
                    u_baseColorTexture: new kl(e1),
                    u_metallicRoughnessTexture: new kl(e1),
                    u_normalTexture: new kl(e1),
                    u_occlusionTexture: new kl(e1),
                    u_emissionTexture: new kl(e1),
                    u_color_mix: new Nl(e1),
                    u_aoIntensity: new Ol(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            modelDepth: (e1)=>({
                    u_matrix: new jl(e1),
                    u_instance: new jl(e1),
                    u_node_matrix: new jl(e1)
                }),
            groundShadow: (e1)=>({
                    u_matrix: new jl(e1),
                    u_ground_shadow_factor: new Fl(e1)
                }),
            stars: (e1)=>({
                    u_matrix: new jl(e1),
                    u_up: new Fl(e1),
                    u_right: new Fl(e1),
                    u_intensity_multiplier: new Ol(e1)
                })
        };
        let qM;
        function ZM(e1, t, i, r, n, o, s) {
            const a = e1.context, l = a.gl, c = e1.transform, h = e1.getOrCreateProgram("collisionBox"), u = [];
            let d = 0, p = 0;
            for(let a = 0; a < r.length; a++){
                const f = r[a], m = t.getTile(f), _ = m.getBucket(i);
                if (!_) continue;
                const g = XT(f, _, c);
                let y = g;
                0 === n[0] && 0 === n[1] || (y = e1.translatePosMatrix(g, m, n, o));
                const x = s ? _.textCollisionBox : _.iconCollisionBox, v = _.collisionCircleArray;
                if (v.length > 0) {
                    const e1 = Au.create(), t = y;
                    Au.mul(e1, _.placementInvProjMatrix, c.glCoordMatrix), Au.mul(e1, e1, _.placementViewportMatrix), u.push({
                        circleArray: v,
                        circleOffset: p,
                        transform: t,
                        invTransform: e1,
                        projection: _.getProjection()
                    }), d += v.length / 4, p = d;
                }
                x && (e1.terrain && e1.terrain.setupElevationDraw(m, h), h.draw(e1, l.LINES, Mx.disabled, Sx.disabled, e1.colorModeForRenderPass(), Dx.disabled, MM(y, c, m, _.getProjection()), i.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, c.zoom, null, [
                    x.collisionVertexBuffer,
                    x.collisionVertexBufferExt
                ]));
            }
            if (!s || !u.length) return;
            const f = e1.getOrCreateProgram("collisionCircle"), m = new Za;
            m.resize(4 * d), m._trim();
            let _ = 0;
            for (const e1 of u)for(let t = 0; t < e1.circleArray.length / 4; t++){
                const i = 4 * t, r = e1.circleArray[i + 0], n = e1.circleArray[i + 1], o = e1.circleArray[i + 2], s = e1.circleArray[i + 3];
                m.emplace(_++, r, n, o, s, 0), m.emplace(_++, r, n, o, s, 1), m.emplace(_++, r, n, o, s, 2), m.emplace(_++, r, n, o, s, 3);
            }
            (!qM || qM.length < 2 * d) && (qM = function(e1) {
                const t = 2 * e1, i = new Wa;
                i.resize(t), i._trim();
                for(let e1 = 0; e1 < t; e1++){
                    const t = 6 * e1;
                    i.uint16[t + 0] = 4 * e1 + 0, i.uint16[t + 1] = 4 * e1 + 1, i.uint16[t + 2] = 4 * e1 + 2, i.uint16[t + 3] = 4 * e1 + 2, i.uint16[t + 4] = 4 * e1 + 3, i.uint16[t + 5] = 4 * e1 + 0;
                }
                return i;
            }(d));
            const g = a.createIndexBuffer(qM, !0), y = a.createVertexBuffer(m, h_.members, !0);
            for (const t of u){
                const r = {
                    u_matrix: t.transform,
                    u_inv_matrix: t.invTransform,
                    u_camera_to_center_distance: (x = c).getCameraToCenterDistance(t.projection),
                    u_viewport_size: [
                        x.width,
                        x.height
                    ]
                };
                f.draw(e1, l.TRIANGLES, Mx.disabled, Sx.disabled, e1.colorModeForRenderPass(), Dx.disabled, r, i.id, y, g, xl.simpleSegment(0, 2 * t.circleOffset, t.circleArray.length, t.circleArray.length / 2), null, c.zoom);
            }
            var x;
            y.destroy(), g.destroy();
        }
        const $M = Au.create();
        function WM({ width: e1, height: t, anchor: i, textOffset: r, textScale: n }, o) {
            const { horizontalAlign: s, verticalAlign: a } = F_(i), l = -(s - .5) * e1, c = -(a - .5) * t, h = xg(i, r);
            return new y((l / n + h[0]) * o, (c / n + h[1]) * o);
        }
        function HM(e1, t, i, r, n, o, s, a, l, c, h) {
            const u = e1.text.placedSymbolArray, d = e1.text.dynamicLayoutVertexArray, p = e1.icon.dynamicLayoutVertexArray, f = {}, m = e1.getProjection(), _ = YT(a, m, o), g = o.elevation, y = m.upVectorScale(a.canonical, o.center.lat, o.worldSize).metersToTile;
            d.clear();
            for(let p = 0; p < u.length; p++){
                const x = u.get(p), { tileAnchorX: v, tileAnchorY: b, numGlyphs: w } = x, T = x.hidden || !x.crossTileID || e1.allowVerticalPlacement && !x.placedOrientation ? null : r[x.crossTileID];
                if (T) {
                    let r = 0, u = 0, p = 0;
                    if (g) {
                        const e1 = g ? g.getAtTileOffset(a, v, b) : 0, [t, i, n] = m.upVector(a.canonical, v, b);
                        r = e1 * t * y, u = e1 * i * y, p = e1 * n * y;
                    }
                    let [E, M, A, S] = cv(x.projectedAnchorX + r, x.projectedAnchorY + u, x.projectedAnchorZ + p, i ? _ : s);
                    const I = hv(o.getCameraToCenterDistance(m), S);
                    let C = n.evaluateSizeForFeature(e1.textSizeData, c, x) * I / u_;
                    i && (C *= e1.tilePixelRatio / l);
                    const z = WM(T, C);
                    i ? ({ x: E, y: M, z: A } = m.projectTilePoint(v + z.x, b + z.y, a.canonical), [E, M, A] = cv(E + r, M + u, A + p, s)) : (t && z._rotate(-o.angle), E += z.x, M += z.y, A = 0);
                    const P = e1.allowVerticalPlacement && x.placedOrientation === A_.vertical ? Math.PI / 2 : 0;
                    for(let e1 = 0; e1 < w; e1++)dy(d, E, M, A, P);
                    h && x.associatedIconIndex >= 0 && (f[x.associatedIconIndex] = {
                        x: E,
                        y: M,
                        z: A,
                        angle: P
                    });
                } else xv(w, d);
            }
            if (h) {
                p.clear();
                const t = e1.icon.placedSymbolArray;
                for(let e1 = 0; e1 < t.length; e1++){
                    const i = t.get(e1), { numGlyphs: r } = i, n = f[e1];
                    if (i.hidden || !n) xv(r, p);
                    else {
                        const { x: e1, y: t, z: i, angle: o } = n;
                        for(let n = 0; n < r; n++)dy(p, e1, t, i, o);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(d);
        }
        function XM(e1, t, i) {
            return i.iconsInText && t ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
        }
        function YM(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
            const p = e1.context, f = p.gl, m = e1.transform, _ = "map" === a, g = "map" === l, y = _ && "point" !== i.layout.get("symbol-placement"), x = _ && !g && !y, v = void 0 !== i.layout.get("symbol-sort-key").constantOr(1);
            let b = !1;
            const w = e1.depthModeForSublayer(0, Mx.ReadOnly), T = [
                Kd(m.center.lng),
                Jd(m.center.lat)
            ], E = i.layout.get("text-variable-anchor"), M = "globe" === m.projection.name, A = [], S = [
                0,
                -1,
                0
            ];
            let I = S;
            !M && !m.mercatorFromTransition || _ || (I = function(e1) {
                const t = e1._camera.getWorldToCamera(e1.worldSize, 1), i = Au.multiply([], t, e1.globeMatrix);
                Au.invert(i, i);
                const r = [
                    0,
                    0,
                    0
                ], n = [
                    0,
                    1,
                    0,
                    0
                ];
                return yu.transformMat4(n, n, i), r[0] = n[0], r[1] = n[1], r[2] = n[2], Du.normalize(r, r), r;
            }(m));
            for (const a of r){
                const r = t.getTile(a), l = r.getBucket(i);
                if (!l) continue;
                if ("mercator" === l.projection.name && M) continue;
                const u = n ? l.text : l.icon;
                if (!u || l.fullyClipped || !u.segments.get().length) continue;
                const d = u.programConfigurations.get(i.id), p = n || l.sdfIcons, w = n ? l.textSizeData : l.iconSizeData, C = g || 0 !== m.pitch, z = m_(w, m.zoom);
                let P, D, R, L, k = [
                    0,
                    0
                ], O = null;
                if (n) D = r.glyphAtlasTexture ? r.glyphAtlasTexture : null, R = f.LINEAR, P = r.glyphAtlasTexture ? r.glyphAtlasTexture.size : [
                    0,
                    0
                ], l.iconsInText && (k = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                    0,
                    0
                ], O = r.imageAtlasTexture ? r.imageAtlasTexture : null, L = C || e1.options.rotating || e1.options.zooming || "composite" === w.kind || "camera" === w.kind ? f.LINEAR : f.NEAREST);
                else {
                    const t = 1 !== i.layout.get("icon-size").constantOr(0) || l.iconsNeedLinear;
                    D = r.imageAtlasTexture ? r.imageAtlasTexture : null, R = p || e1.options.rotating || e1.options.zooming || t || C ? f.LINEAR : f.NEAREST, P = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ];
                }
                const B = "globe" === l.projection.name, F = B ? I : S, N = B ? Dd(m.zoom) : 0, U = YT(a, l.getProjection(), m), V = m.calculatePixelsToTileUnitsMatrix(r), j = sv(U, r.tileID.canonical, g, _, m, l.getProjection(), V), G = e1.terrain && g && y ? Au.invert(Au.create(), j) : $M, q = lv(U, r.tileID.canonical, g, _, m, l.getProjection(), V), Z = E && l.hasTextData(), $ = l.hasIconTextFit() && Z && l.hasIconData();
                if (y) {
                    const t = m.elevation, i = t ? t.getAtTileOffsetFunc(a, m.center.lat, m.worldSize, l.getProjection()) : null, o = av(U, r.tileID.canonical, g, _, m, l.getProjection(), V);
                    dv(l, U, e1, n, o, q, g, c, i, a);
                }
                const W = y || n && E || $, H = e1.translatePosMatrix(U, r, o, s), X = W ? $M : j, Y = e1.translatePosMatrix(q, r, o, s, !0), K = l.getProjection().createInversionMatrix(m, a.canonical), J = i.paint.get("icon-image-cross-fade").constantOr(0), Q = [];
                e1.terrainRenderModeElevated() && g && Q.push("PITCH_WITH_MAP_TERRAIN"), B && (Q.push("PROJECTION_GLOBE_VIEW"), W && Q.push("PROJECTED_POS_ON_VIEWPORT")), J > 0 && Q.push("ICON_TRANSITION"), u.zOffsetVertexBuffer && Q.push("Z_OFFSET");
                const ee = p && 0 !== i.paint.get(n ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let te;
                p ? te = l.iconsInText ? OM(w.kind, z, x, g, e1, H, X, Y, P, k, a, N, T, K, F, l.getProjection()) : kM(w.kind, z, x, g, e1, H, X, Y, n, P, !0, a, N, T, K, F, l.getProjection()) : (h < 1 && Q.push("SATURATION"), te = LM(w.kind, z, x, g, e1, H, X, Y, n, P, a, N, T, K, F, l.getProjection(), h, J));
                const ie = {
                    program: e1.getOrCreateProgram(XM(p, n, l), {
                        config: d,
                        defines: Q
                    }),
                    buffers: u,
                    uniformValues: te,
                    atlasTexture: D,
                    atlasTextureIcon: O,
                    atlasInterpolation: R,
                    atlasInterpolationIcon: L,
                    isSDF: p,
                    hasHalo: ee,
                    tile: r,
                    labelPlaneMatrixInv: G
                };
                if (v && l.canOverlap) {
                    b = !0;
                    const e1 = u.segments.get();
                    for (const t of e1)A.push({
                        segments: new xl([
                            t
                        ]),
                        sortKey: t.sortKey,
                        state: ie
                    });
                } else A.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: ie
                });
            }
            b && A.sort((e1, t)=>e1.sortKey - t.sortKey);
            for (const t of A){
                const r = t.state;
                if (e1.terrain && e1.terrain.setupElevationDraw(r.tile, r.program, {
                    useDepthForOcclusion: m.depthOcclusionForSymbolsAndCircles,
                    labelPlaneMatrixInv: r.labelPlaneMatrixInv
                }), p.activeTexture.set(f.TEXTURE0), r.atlasTexture && r.atlasTexture.bind(r.atlasInterpolation, f.CLAMP_TO_EDGE), r.atlasTextureIcon && (p.activeTexture.set(f.TEXTURE1), r.atlasTextureIcon && r.atlasTextureIcon.bind(r.atlasInterpolationIcon, f.CLAMP_TO_EDGE)), e1.uploadCommonLightUniforms(e1.context, r.program), r.hasHalo) {
                    const n = r.uniformValues;
                    n.u_is_halo = 1, KM(r.buffers, t.segments, i, e1, r.program, w, u, d, n, 2), n.u_is_halo = 0;
                } else {
                    if (r.isSDF) {
                        const n = r.uniformValues;
                        r.hasHalo && (n.u_is_halo = 1, KM(r.buffers, t.segments, i, e1, r.program, w, u, d, n, 1)), n.u_is_halo = 0;
                    }
                    KM(r.buffers, t.segments, i, e1, r.program, w, u, d, r.uniformValues, 1);
                }
            }
        }
        function KM(e1, t, i, r, n, o, s, a, l, c) {
            const h = [
                e1.dynamicLayoutVertexBuffer,
                e1.opacityVertexBuffer,
                e1.iconTransitioningVertexBuffer,
                e1.globeExtVertexBuffer,
                e1.zOffsetVertexBuffer
            ];
            n.draw(r, r.context.gl.TRIANGLES, o, s, a, Dx.disabled, l, i.id, e1.layoutVertexBuffer, e1.indexBuffer, t, i.paint, r.transform.zoom, e1.programConfigurations.get(i.id), h, c);
        }
        function JM(e1, t, i, r, n, o, s) {
            const a = e1.context.gl, l = i.paint.get("fill-pattern"), c = l && l.constantOr(1);
            let h, u, d, p, f;
            s ? (u = c && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", h = a.LINES) : (u = c ? "fillPattern" : "fill", h = a.TRIANGLES);
            for (const m of r){
                const r = t.getTile(m);
                if (c && !r.patternsLoaded()) continue;
                const _ = r.getBucket(i);
                if (!_) continue;
                e1.prepareDrawTile();
                const g = _.programConfigurations.get(i.id), y = e1.isTileAffectedByFog(m), x = e1.getOrCreateProgram(u, {
                    config: g,
                    overrideFog: y
                });
                c && (e1.context.activeTexture.set(a.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), g.updatePaintBuffers());
                const v = l.constantOr(null);
                if (v && r.imageAtlas) {
                    const e1 = r.imageAtlas.patternPositions[v.toString()];
                    e1 && g.setConstantPatternPositions(e1);
                }
                const b = e1.translatePosMatrix(m.projMatrix, r, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor")), w = i.paint.get("fill-emissive-strength");
                if (s) {
                    p = _.indexBuffer2, f = _.segments2;
                    const t = e1.terrain && e1.terrain.renderingToTexture ? e1.terrain.drapeBufferSize : [
                        a.drawingBufferWidth,
                        a.drawingBufferHeight
                    ];
                    d = "fillOutlinePattern" === u && c ? EM(b, w, e1, r, t) : TM(b, w, t);
                } else p = _.indexBuffer, f = _.segments, d = c ? wM(b, w, e1, r) : bM(b, w);
                e1.uploadCommonUniforms(e1.context, x, m.toUnwrapped()), x.draw(e1, h, n, e1.stencilModeForClipping(m), o, Dx.disabled, d, i.id, _.layoutVertexBuffer, p, f, i.paint, e1.transform.zoom, g, void 0);
            }
        }
        function QM(e1, t, i, r, n, o, s, a) {
            i.resetLayerRenderingStats();
            const l = e1.context, c = l.gl, h = e1.transform, u = i.paint.get("fill-extrusion-pattern"), d = u.constantOr(1), p = i.paint.get("fill-extrusion-opacity"), f = e1.style.enable3dLights(), m = i.paint.get(f && !d ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), _ = [
                i.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                m
            ], g = i.layout.get("fill-extrusion-edge-radius"), y = g > 0 && !i.paint.get("fill-extrusion-rounded-roof"), x = y ? 0 : g, v = "globe" === h.projection.name ? Ib() : 0, b = "globe" === h.projection.name, w = b ? Dd(h.zoom) : 0, T = [
                Kd(h.center.lng),
                Jd(h.center.lat)
            ], E = i.paint.get("fill-extrusion-flood-light-color").toArray01().slice(0, 3), M = i.paint.get("fill-extrusion-flood-light-intensity"), A = i.paint.get("fill-extrusion-vertical-scale"), S = eM(e1, i.paint.get("fill-extrusion-cutoff-fade-range")), I = i.paint.get("fill-extrusion-emissive-strength"), C = [];
            let z;
            b && C.push("PROJECTION_GLOBE_VIEW"), _[0] > 0 && C.push("FAUX_AO"), y && C.push("ZERO_ROOF_RADIUS"), a && C.push("HAS_CENTROID"), M > 0 && C.push("FLOOD_LIGHT"), S.shouldRenderCutoff && C.push("RENDER_CUTOFF");
            const P = "shadow" === e1.renderPass, D = e1.shadowRenderer, R = P && !!D;
            e1.shadowRenderer && (e1.shadowRenderer.useNormalOffset = !0);
            let L = [
                0,
                0,
                0
            ];
            if (D) {
                const t = e1.style.directionalLight, i = e1.style.ambientLight;
                t && i && (L = WA(t, i)), z = C.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const k = R ? "fillExtrusionDepth" : d ? "fillExtrusionPattern" : "fillExtrusion", O = i.getLayerRenderingStats();
            for (const f of r){
                const r = t.getTile(f), m = r.getBucket(i);
                if (!m || m.projection.name !== h.projection.name) continue;
                let g = !1;
                D && (g = 0 === D.getMaxCascadeForTile(f.toUnwrapped()));
                const y = e1.isTileAffectedByFog(f), R = m.programConfigurations.get(i.id), B = e1.getOrCreateProgram(k, {
                    config: R,
                    defines: g ? z : C,
                    overrideFog: y
                });
                if (e1.terrain && e1.terrain.setupElevationDraw(r, B, {
                    useMeterToDem: !0
                }), !m.centroidVertexBuffer) {
                    const e1 = B.attributes.a_centroid_pos;
                    void 0 !== e1 && c.vertexAttrib2f(e1, 0, 0);
                }
                !P && D && D.setupShadows(r.tileID.toUnwrapped(), B, "vector-tile", r.tileID.overscaledZ), d && (e1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), R.updatePaintBuffers());
                const F = u.constantOr(null);
                if (F && r.imageAtlas) {
                    const e1 = r.imageAtlas.patternPositions[F.toString()];
                    e1 && R.setConstantPatternPositions(e1);
                }
                const N = i.paint.get("fill-extrusion-vertical-gradient");
                let U;
                if (P && D) {
                    if (oA(r.tileID, m, e1)) continue;
                    const t = D.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                    U = xM(t, x, A);
                } else {
                    const t = e1.translatePosMatrix(f.expandedProjMatrix, r, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), n = h.projection.createInversionMatrix(h, f.canonical);
                    U = d ? vM(t, e1, N, p, _, x, f, r, v, w, T, n, E, A) : yM(t, e1, N, p, _, x, f, v, w, T, n, E, A, M, L, I);
                }
                e1.uploadCommonUniforms(l, B, f.toUnwrapped(), null, S);
                let V = m.segments;
                if ("mercator" === h.projection.name && !P && (V = m.getVisibleSegments(r.tileID, e1.terrain, e1.transform.getFrustum(0)), !V.get().length)) continue;
                if (O) {
                    if (P) for (const e1 of V.get())O.numRenderedVerticesInShadowPass += e1.primitiveLength;
                    else for (const e1 of V.get())O.numRenderedVerticesInTransparentPass += e1.primitiveLength;
                }
                const j = [];
                (e1.terrain || a) && j.push(m.centroidVertexBuffer), b && j.push(m.layoutVertexExtBuffer), B.draw(e1, l.gl.TRIANGLES, n, o, s, Dx.backCCW, U, i.id, m.layoutVertexBuffer, m.indexBuffer, V, i.paint, e1.transform.zoom, R, j);
            }
            e1.shadowRenderer && (e1.shadowRenderer.useNormalOffset = !1);
        }
        function eA(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y) {
            const x = e1.context, v = x.gl, b = e1.transform, w = e1.transform.zoom, T = [], E = eM(e1, i.paint.get("fill-extrusion-cutoff-fade-range"));
            "clear" === c ? (T.push("CLEAR_SUBPASS"), y && (T.push("CLEAR_FROM_TEXTURE"), x.activeTexture.set(v.TEXTURE0), y.bind(v.LINEAR, v.CLAMP_TO_EDGE))) : "sdf" === c && T.push("SDF_SUBPASS"), _ && T.push("HAS_CENTROID"), E.shouldRenderCutoff && T.push("RENDER_CUTOFF");
            const M = i.layout.get("fill-extrusion-edge-radius"), A = (t, r, c, g, v)=>{
                const b = r.programConfigurations.get(i.id), A = e1.isTileAffectedByFog(t), S = e1.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: T,
                    overrideFog: A
                }), I = ((e1, t, i, r, n, o, s, a, l, c, h)=>({
                        u_matrix: t,
                        u_opacity: i,
                        u_ao_pass: r ? 1 : 0,
                        u_meter_to_tile: n,
                        u_ao: o,
                        u_flood_light_intensity: s,
                        u_flood_light_color: a,
                        u_attenuation: l,
                        u_edge_radius: c,
                        u_fb: 0,
                        u_fb_size: h
                    }))(0, g, h, l, v, [
                    u,
                    d * v
                ], p, f, m, w >= 17 ? 0 : M * v, y ? y.size[0] : 0), C = [];
                _ && C.push(r.hiddenByLandmarkVertexBuffer), e1.uploadCommonUniforms(x, S, t.toUnwrapped(), null, E), S.draw(e1, x.gl.TRIANGLES, n, o, s, a, I, i.id, r.vertexBuffer, r.indexBuffer, c, i.paint, w, b, C);
            };
            for (const n of r){
                const r = t.getTile(n), o = r.getBucket(i);
                if (!o || o.projection.name !== b.projection.name || !o.groundEffect || o.groundEffect && !o.groundEffect.hasData()) continue;
                const s = o.groundEffect, a = 1 / o.tileToMeter;
                {
                    const t = e1.translatePosMatrix(n.projMatrix, r, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), o = s.getDefaultSegment();
                    A(n, s, o, t, a);
                }
                if (g) for(let o = 0; o < 4; o++){
                    const s = $u[o](n), l = t.getTile(s);
                    if (!l) continue;
                    const c = l.getBucket(i);
                    if (!c || c.projection.name !== b.projection.name || !c.groundEffect || c.groundEffect && !c.groundEffect.hasData()) continue;
                    const h = c.groundEffect;
                    let u, d;
                    0 === o ? (u = [
                        -cr,
                        0,
                        0
                    ], d = 1) : 1 === o ? (u = [
                        cr,
                        0,
                        0
                    ], d = 0) : 2 === o ? (u = [
                        0,
                        -cr,
                        0
                    ], d = 3) : (u = [
                        0,
                        cr,
                        0
                    ], d = 2);
                    const p = h.regionSegments[d];
                    if (!p) continue;
                    const f = new Float32Array(16);
                    Au.translate(f, n.projMatrix, u), A(n, h, p, e1.translatePosMatrix(f, r, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), a);
                }
            }
        }
        function tA(e1, t, i, r, n, o, s) {
            0 === r.centroidVertexArray.length && r.createCentroidsBuffer();
            const a = o ? o.findDEMTileFor(i) : null;
            if (!(a && a.dem || s)) return;
            const l = (e1)=>{
                const i = t.getSource().minzoom, r = (e1)=>{
                    const i = t.getTileByID(e1);
                    if (i && i.hasData()) return i.getBucket(n);
                }, o = [
                    0,
                    -1,
                    1
                ];
                for (const t of o){
                    if (e1.overscaledZ + t < i) continue;
                    const n = r(e1.calculateScaledKey(e1.overscaledZ + t));
                    if (n) return n;
                }
            }, c = [
                0,
                0,
                0
            ], h = (e1, t)=>(c[0] = Math.min(e1.min.y, t.min.y), c[1] = Math.max(e1.max.y, t.max.y), c[2] = cr - t.min.x > e1.max.x ? t.min.x - cr : e1.max.x, c), u = (e1, t)=>(c[0] = Math.min(e1.min.x, t.min.x), c[1] = Math.max(e1.max.x, t.max.x), c[2] = cr - t.min.y > e1.max.y ? t.min.y - cr : e1.max.y, c), d = [
                (e1, t)=>h(e1, t),
                (e1, t)=>h(t, e1),
                (e1, t)=>u(e1, t),
                (e1, t)=>u(t, e1)
            ], p = (e1, t, r, n, s, l, c)=>{
                if (!o) return 0;
                const h = [
                    [
                        l ? r : e1,
                        l ? e1 : r,
                        0
                    ],
                    [
                        l ? r : t,
                        l ? t : r,
                        0
                    ]
                ], u = c < 0 ? cr + c : c, d = [
                    l ? u : (e1 + t) / 2,
                    l ? (e1 + t) / 2 : u,
                    0
                ];
                return 0 === r && c < 0 || 0 !== r && c > 0 ? o.getForTilePoints(s, [
                    d
                ], !0, n) : h.push(d), o.getForTilePoints(i, h, !0, a), Math.max(h[0][2], h[1][2], d[2]) / o.exaggeration();
            };
            for(let e1 = 0; e1 < 4; e1++){
                const t = r.borderFeatureIndices[e1];
                if (0 === t.length) continue;
                const n = $u[e1](i), a = l(n);
                if (!(a && a instanceof vb)) continue;
                if (r.borderDoneWithNeighborZ[e1] === a.canonical.z) continue;
                0 === a.centroidVertexArray.length && a.createCentroidsBuffer();
                const c = o ? o.findDEMTileFor(n) : null;
                if (!(c && c.dem || s)) continue;
                const h = (e1 < 2 ? 1 : 5) - e1, u = a.borderDoneWithNeighborZ[h] !== r.canonical.z, g = a.borderFeatureIndices[h];
                let x = 0;
                if (r.canonical.z !== a.canonical.z) {
                    for (const e1 of t)r.showCentroid(r.featuresOnBorder[e1]);
                    if (u) for (const e1 of g)a.showCentroid(a.featuresOnBorder[e1]);
                    r.borderDoneWithNeighborZ[e1] = a.canonical.z, a.borderDoneWithNeighborZ[h] = r.canonical.z;
                }
                for (const i of t){
                    const t = r.featuresOnBorder[i], o = r.centroidData[t.centroidDataIndex], l = t.borders[e1];
                    let u;
                    for(; x < g.length;){
                        u = a.featuresOnBorder[g[x]];
                        const e1 = u.borders[h];
                        if (e1[1] > l[0] + 3 || e1[0] > l[0] - 3) break;
                        a.showCentroid(u), x++;
                    }
                    if (u && x < g.length) {
                        const i = x;
                        let v = 0;
                        for(; !(u.borders[h][0] > l[1] - 3) && (v++, ++x !== g.length);)u = a.featuresOnBorder[g[x]];
                        if (u = a.featuresOnBorder[g[i]], v > 1) {
                            const e1 = u.borders[h];
                            Math.abs(l[0] - e1[0]) < 3 && Math.abs(l[1] - e1[1]) < 3 && (v = 1, x = i + 1);
                        } else if (0 === v) {
                            r.showCentroid(t);
                            continue;
                        }
                        const b = a.centroidData[u.centroidDataIndex];
                        s && 1 === v && (((m = o).flags | (_ = b).flags) & cb ? (m.flags |= cb, _.flags |= cb) : (m.flags &= 2147483647, _.flags &= 2147483647));
                        let w = new y(0, 0);
                        if (v > 1) x = i;
                        else if (c && c.dem && !(t.intersectsCount() > 1 || u.intersectsCount() > 1)) {
                            const t = d[e1](o, b), i = e1 % 2 ? cr - 1 : 0;
                            f = p(t[0], Math.min(cr - 1, t[1]), i, c, n, e1 < 2, t[2]), w = new y(Math.ceil(7 * (f + 450)), 0);
                        }
                        o.centroidXY = b.centroidXY = w, r.writeCentroidToBuffer(o), a.writeCentroidToBuffer(b);
                    } else r.showCentroid(t);
                }
                r.borderDoneWithNeighborZ[e1] = a.canonical.z, a.borderDoneWithNeighborZ[h] = r.canonical.z;
            }
            var f, m, _;
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(e1);
        }
        const iA = [
            1,
            0,
            0
        ], rA = [
            0,
            1,
            0
        ], nA = [
            0,
            0,
            1
        ];
        function oA(e1, t, i) {
            const r = i.transform, n = i.shadowRenderer;
            if (!n) return !0;
            const o = e1.toUnwrapped(), s = r.tileSize * n._cascades[i.currentShadowCascade].scale;
            let a = t.maxHeight;
            if (r.elevation) {
                const t = r.elevation.getMinMaxForTile(e1);
                t && (a += t.max);
            }
            const l = [
                ...n.shadowDirection
            ];
            l[2] = -l[2];
            const c = n.computeSimplifiedTileShadowVolume(o, a, s, l);
            if (!c) return !1;
            const h = [
                iA,
                rA,
                nA,
                l,
                [
                    l[0],
                    0,
                    l[2]
                ],
                [
                    0,
                    l[1],
                    l[2]
                ]
            ], u = "globe" === r.projection.name, d = r.scaleZoom(s), p = Qu.fromInvProjectionMatrix(r.invProjMatrix, r.worldSize, d, !u), f = n.getCurrentCascadeFrustum();
            return 0 === p.intersectsPrecise(c.vertices, c.planes, h) || 0 === f.intersectsPrecise(c.vertices, c.planes, h);
        }
        function sA(e1) {
            const t = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), r = i - t, n = .2 * e1.height, o = t + n;
            return [
                t,
                i,
                (o - n - t) / r,
                (o - t) / r
            ];
        }
        const aA = new hi(1, 0, 0, 1), lA = new hi(0, 1, 0, 1), cA = new hi(0, 0, 1, 1), hA = new hi(1, 0, 1, 1), uA = new hi(0, 1, 1, 1);
        function dA(e1, t, i) {
            const r = e1.context, n = e1.transform, o = r.gl, s = "globe" === n.projection.name, a = s ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let l = i.projMatrix;
            if (s && Dd(n.zoom) > 0) {
                const e1 = Sd(_d(i.canonical, n));
                l = Au.multiply(new Float32Array(16), n.globeMatrix, e1), Au.multiply(l, n.projMatrix, l);
            }
            const c = e1.getOrCreateProgram("debug", {
                defines: a
            }), h = t.getTileByID(i.key);
            e1.terrain && e1.terrain.setupElevationDraw(h, c);
            const u = Mx.disabled, d = Sx.disabled, p = e1.colorModeForRenderPass(), f = "$debug";
            r.activeTexture.set(o.TEXTURE0), e1.emptyTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE), s ? h._makeGlobeTileDebugBuffers(e1.context, n) : h._makeDebugTileBoundsBuffers(e1.context, n.projection);
            const m = h._tileDebugBuffer || e1.debugBuffer, _ = h._tileDebugIndexBuffer || e1.debugIndexBuffer, g = h._tileDebugSegments || e1.debugSegments;
            c.draw(e1, o.LINE_STRIP, u, d, p, Dx.disabled, AM(l, hi.red), f, m, _, g, null, null, null, [
                h._globeTileDebugBorderBuffer
            ]);
            const y = h.latestRawTileData, x = Math.floor((y && y.byteLength || 0) / 1024), v = t.getTile(i).tileSize, b = 512 / Math.min(v, 512) * (i.overscaledZ / n.zoom) * .5;
            let w = i.canonical.toString();
            i.overscaledZ !== i.canonical.z && (w += ` => ${i.overscaledZ}`), w += ` ${x}kb`, function(e1, t) {
                e1.initDebugOverlayCanvas();
                const i = e1.debugOverlayCanvas, r = e1.context.gl, n = e1.debugOverlayCanvas.getContext("2d");
                n.clearRect(0, 0, i.width, i.height), n.shadowColor = "white", n.shadowBlur = 2, n.lineWidth = 1.5, n.strokeStyle = "white", n.textBaseline = "top", n.font = "bold 36px Open Sans, sans-serif", n.fillText(t, 5, 5), n.strokeText(t, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
            }(e1, w);
            const T = h._tileDebugTextBuffer || e1.debugBuffer, E = h._tileDebugTextIndexBuffer || e1.quadTriangleIndexBuffer, M = h._tileDebugTextSegments || e1.debugSegments;
            c.draw(e1, o.TRIANGLES, u, d, Cx.alphaBlended, Dx.disabled, AM(l, hi.transparent, b), f, T, E, M, null, null, null, [
                h._globeTileDebugTextBuffer
            ]);
        }
        function pA(e1, t, i, r) {
            mA(e1, 0, t + i / 2, e1.transform.width, i, r);
        }
        function fA(e1, t, i, r) {
            mA(e1, t - i / 2, 0, i, e1.transform.height, r);
        }
        function mA(e1, t, i, r, n, o) {
            const s = e1.context, a = s.gl;
            a.enable(a.SCISSOR_TEST), a.scissor(t * dt.devicePixelRatio, i * dt.devicePixelRatio, r * dt.devicePixelRatio, n * dt.devicePixelRatio), s.clear({
                color: o
            }), a.disable(a.SCISSOR_TEST);
        }
        const _A = Ia([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: gA } = _A;
        function yA(e1, t, i, r) {
            e1.emplaceBack(t, i, r);
        }
        class xA {
            constructor(e1){
                this.vertexArray = new tl, this.indices = new Wa, yA(this.vertexArray, -1, -1, 1), yA(this.vertexArray, 1, -1, 1), yA(this.vertexArray, -1, 1, 1), yA(this.vertexArray, 1, 1, 1), yA(this.vertexArray, -1, -1, -1), yA(this.vertexArray, 1, -1, -1), yA(this.vertexArray, -1, 1, -1), yA(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = e1.createVertexBuffer(this.vertexArray, gA), this.indexBuffer = e1.createIndexBuffer(this.indices), this.segment = xl.simpleSegment(0, 0, 36, 12);
            }
        }
        function vA(e1, t, i, r, n, o) {
            const s = e1.context.gl, a = t.paint.get("sky-atmosphere-color"), l = t.paint.get("sky-atmosphere-halo-color"), c = t.paint.get("sky-atmosphere-sun-intensity"), h = ((e1, t, i, r, n)=>({
                    u_matrix_3f: e1,
                    u_sun_direction: t,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_color_tint_m: [
                        n.r,
                        n.g,
                        n.b,
                        n.a
                    ],
                    u_luminance: 5e-5
                }))(Eu.fromMat4(Eu.create(), r), n, c, a, l);
            s.framebufferTexture2D(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + o, t.skyboxTexture, 0), i.draw(e1, s.TRIANGLES, Mx.disabled, Sx.disabled, Cx.unblended, Dx.frontCW, h, "skyboxCapture", t.skyboxGeometry.vertexBuffer, t.skyboxGeometry.indexBuffer, t.skyboxGeometry.segment);
        }
        const bA = Ia([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class wA {
            constructor(e1){
                const t = new Ka;
                t.emplaceBack(-1, 1, 1, 0, 0), t.emplaceBack(1, 1, 1, 1, 0), t.emplaceBack(1, -1, 1, 1, 1), t.emplaceBack(-1, -1, 1, 0, 1);
                const i = new Wa;
                i.emplaceBack(0, 1, 2), i.emplaceBack(2, 3, 0), this.vertexBuffer = e1.createVertexBuffer(t, bA.members), this.indexBuffer = e1.createIndexBuffer(i), this.segments = xl.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const TA = Ia([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_fade_opacity",
                components: 1
            }
        ]);
        class EA {
            constructor(){
                this.colorModeAlphaBlendedWriteRGB = new Cx([
                    1,
                    Ix,
                    1,
                    Ix
                ], hi.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new Cx([
                    1,
                    0,
                    1,
                    0
                ], hi.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]);
            }
            update(e1) {
                const t = e1.context;
                if (!this.atmosphereBuffer) {
                    this.atmosphereBuffer = new wA(t);
                    const e1 = 100, i = 200, r = function(e1) {
                        const t = Xn(30), i = [];
                        for(let e1 = 0; e1 < 16e3; ++e1){
                            const e1 = 2 * Math.PI * t(), r = Math.acos(1 - 2 * t()) - .5 * Math.PI;
                            i.push(Du.fromValues(Math.cos(r) * Math.cos(e1), Math.cos(r) * Math.sin(e1), Math.sin(r)));
                        }
                        return i;
                    }(), n = Xn(300), o = new Ja, s = new Wa;
                    let a = 0;
                    for(let t = 0; t < r.length; ++t){
                        const l = Du.scale([], r[t], 200), c = Math.max(0, 1 + .01 * e1 * (1 * n() - .5)), h = Math.max(0, 1 + .01 * i * (1 * n() - .5));
                        o.emplaceBack(l[0], l[1], l[2], -1, -1, c, h), o.emplaceBack(l[0], l[1], l[2], 1, -1, c, h), o.emplaceBack(l[0], l[1], l[2], 1, 1, c, h), o.emplaceBack(l[0], l[1], l[2], -1, 1, c, h), s.emplaceBack(a + 0, a + 1, a + 2), s.emplaceBack(a + 0, a + 2, a + 3), a += 4;
                    }
                    this.starsVx = t.createVertexBuffer(o, TA.members), this.starsIdx = t.createIndexBuffer(s), this.starsSegments = xl.simpleSegment(0, 0, o.length, s.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(e1, t) {
                const i = e1.context, r = i.gl, n = e1.transform, o = new Mx(r.LEQUAL, Mx.ReadOnly, [
                    0,
                    1
                ]), s = Dd(n.zoom), a = t.properties.get("color").toArray01(), l = t.properties.get("high-color").toArray01(), c = t.properties.get("space-color").toArray01PremultipliedAlpha(), h = 5e-4, u = z((t.properties.get("horizon-blend") - 0) / 1 * .2495 + h, 5e-4, .25), d = Ld(e1, i, n) && u === h ? n.worldSize / (2 * Math.PI * 1.025) - 1 : n.globeRadius, p = e1.frameCounter / 1e3 % 1, f = Du.length(n.globeCenterInViewSpace), m = Math.sqrt(Math.pow(f, 2) - Math.pow(d, 2)), _ = Math.acos(m / f), g = (t)=>{
                    const h = "globe" === n.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    t && h.push("ALPHA_PASS");
                    const d = e1.getOrCreateProgram("globeAtmosphere", {
                        defines: h
                    }), f = ((e1, t, i, r, n, o, s, a, l, c, h, u)=>({
                            u_frustum_tl: e1,
                            u_frustum_tr: t,
                            u_frustum_br: i,
                            u_frustum_bl: r,
                            u_horizon: n,
                            u_transition: o,
                            u_fadeout_range: s,
                            u_color: a,
                            u_high_color: l,
                            u_space_color: c,
                            u_temporal_offset: h,
                            u_horizon_angle: u
                        }))(n.frustumCorners.TL, n.frustumCorners.TR, n.frustumCorners.BR, n.frustumCorners.BL, n.frustumCorners.horizon, s, u, a, l, c, p, _);
                    e1.uploadCommonUniforms(i, d);
                    const m = this.atmosphereBuffer;
                    m && d.draw(e1, r.TRIANGLES, o, Sx.disabled, t ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Dx.backCW, f, t ? "atmosphere_glow_alpha" : "atmosphere_glow", m.vertexBuffer, m.indexBuffer, m.segments);
                };
                g(!1), g(!0);
            }
            drawStars(e1, t) {
                const i = z(t.properties.get("star-intensity"), 0, 1);
                if (0 === i) return;
                const r = e1.context, n = r.gl, o = e1.transform, s = e1.getOrCreateProgram("stars"), a = Iu.identity([]);
                Iu.rotateX(a, a, -o._pitch), Iu.rotateZ(a, a, -o.angle), Iu.rotateX(a, a, w(o._center.lat)), Iu.rotateY(a, a, -w(o._center.lng));
                const l = Au.fromQuat(new Float32Array(16), a), c = Au.multiply([], o.starsProjMatrix, l), h = Eu.fromMat4([], l), u = Eu.invert([], h), d = [
                    0,
                    1,
                    0
                ];
                Du.transformMat3(d, d, u), Du.scale(d, d, .15);
                const p = [
                    1,
                    0,
                    0
                ];
                Du.transformMat3(p, p, u), Du.scale(p, p, .15);
                const f = ((e1, t, i, r)=>({
                        u_matrix: Float32Array.from(e1),
                        u_up: t,
                        u_right: i,
                        u_intensity_multiplier: r
                    }))(c, d, p, i);
                e1.uploadCommonUniforms(r, s), this.starsVx && this.starsIdx && s.draw(e1, n.TRIANGLES, Mx.disabled, Sx.disabled, this.colorModeAlphaBlendedWriteRGB, Dx.disabled, f, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
        }
        function MA(e1, t) {
            const i = [
                ...e1
            ], r = t.cameraWorldSizeForFog / t.worldSize, n = Au.identity([]);
            return Au.scale(n, n, [
                r,
                r,
                1
            ]), Au.multiply(i, n, i), Au.multiply(i, t.worldToFogMatrix, i), i;
        }
        function AA(e1, t, i, r) {
            const n = i.material, o = r.context, { baseColorTexture: s, metallicRoughnessTexture: a } = n.pbrMetallicRoughness, { normalTexture: l, occlusionTexture: c, emissionTexture: h } = n;
            function u(t, i, r) {
                if (t && (e1.push(i), o.activeTexture.set(o.gl.TEXTURE0 + r), t.gfxTexture)) {
                    const { minFilter: e1, magFilter: i, wrapS: r, wrapT: n } = t.sampler;
                    t.gfxTexture.bindExtraParam(e1, i, r, n);
                }
            }
            u(s, "HAS_TEXTURE_u_baseColorTexture", NM.BaseColor), u(a, "HAS_TEXTURE_u_metallicRoughnessTexture", NM.MetallicRoughness), u(l, "HAS_TEXTURE_u_normalTexture", NM.Normal), u(c, "HAS_TEXTURE_u_occlusionTexture", NM.Occlusion), u(h, "HAS_TEXTURE_u_emissionTexture", NM.Emission), i.texcoordBuffer && (e1.push("HAS_ATTRIBUTE_a_uv_2f"), t.push(i.texcoordBuffer)), i.colorBuffer && (e1.push(12 === i.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), t.push(i.colorBuffer)), i.normalBuffer && (e1.push("HAS_ATTRIBUTE_a_normal_3f"), t.push(i.normalBuffer)), i.pbrBuffer && (e1.push("HAS_ATTRIBUTE_a_pbr"), e1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), t.push(i.pbrBuffer)), "OPAQUE" !== n.alphaMode && "MASK" !== n.alphaMode || e1.push("UNPREMULT_TEXTURE_IN_SHADER"), n.defined || e1.push("DIFFUSE_SHADED"), e1.push("USE_STANDARD_DERIVATIVES");
        }
        function SA(e1, t, i, r, n, o) {
            const s = i.paint.get("model-opacity"), a = t.context, l = new Mx(t.context.gl.LEQUAL, Mx.ReadWrite, t.depthRangeFor3D), c = t.transform, h = e1.mesh, u = h.material, d = u.pbrMetallicRoughness, p = t.style.fog;
            let f;
            f = "pixels" === t.transform.projection.zAxisUnit ? [
                ...e1.nodeModelMatrix
            ] : Au.multiply([], r.zScaleMatrix, e1.nodeModelMatrix), Au.multiply(f, r.negCameraPosMatrix, f);
            const m = Au.invert([], f);
            Au.transpose(m, m);
            const _ = i.paint.get("model-emissive-strength").constantOr(0), g = UM(new Float32Array(e1.worldViewProjection), new Float32Array(f), new Float32Array(m), t, s, d.baseColorFactor, u.emissiveFactor, d.metallicFactor, d.roughnessFactor, u, _, i), y = {
                defines: []
            }, x = [];
            AA(y.defines, x, h, t);
            const v = t.shadowRenderer;
            v && (v.useNormalOffset = !1);
            let b = null;
            if (p) {
                const i = MA(e1.nodeModelMatrix, t.transform);
                if (b = new Float32Array(i), "globe" !== c.projection.name) {
                    const e1 = h.aabb.min, t = h.aabb.max, [r, n] = p.getOpacityForBounds(i, e1[0], e1[1], t[0], t[1]);
                    y.overrideFog = r >= fw || n >= fw;
                }
            }
            const w = eM(t, i.paint.get("model-cutoff-fade-range"));
            w.shouldRenderCutoff && y.defines.push("RENDER_CUTOFF");
            const T = t.getOrCreateProgram("model", y);
            t.uploadCommonUniforms(a, T, null, b, w), "shadow" !== t.renderPass && v && v.setupShadowsFromMatrix(e1.nodeModelMatrix, T), T.draw(t, a.gl.TRIANGLES, l, n, o, h.material.doubleSided ? Dx.disabled : Dx.backCCW, g, i.id, h.vertexBuffer, h.indexBuffer, h.segments, i.paint, t.transform.zoom, void 0, x);
        }
        function IA(e1, t, i, r, n, o, s) {
            let a;
            a = "globe" === e1.projection.name ? Av(i, e1) : [
                ...i
            ], Au.multiply(a, a, t.matrix);
            const l = Au.multiply([], r, a);
            if (t.meshes) for (const e1 of t.meshes){
                if ("BLEND" !== e1.material.alphaMode) {
                    s.push({
                        mesh: e1,
                        depth: 0,
                        modelIndex: n,
                        worldViewProjection: l,
                        nodeModelMatrix: a
                    });
                    continue;
                }
                const t = Du.transformMat4([], e1.centroid, l);
                t[2] > 0 && o.push({
                    mesh: e1,
                    depth: t[2],
                    modelIndex: n,
                    worldViewProjection: l,
                    nodeModelMatrix: a
                });
            }
            if (t.children) for (const a of t.children)IA(e1, a, i, r, n, o, s);
        }
        function CA(e1, t, i, r) {
            const n = i.shadowRenderer;
            if (!n) return;
            const o = n.getShadowPassDepthMode(), s = n.getShadowPassColorMode(), a = n.calculateShadowPassMatrixFromMatrix(t), l = jM(a);
            i.getOrCreateProgram("modelDepth", {
                defines: [
                    "DEPTH_TEXTURE"
                ]
            }).draw(i, i.context.gl.TRIANGLES, o, Sx.disabled, s, Dx.backCCW, l, r.id, e1.vertexBuffer, e1.indexBuffer, e1.segments, r.paint, i.transform.zoom, void 0, void 0);
        }
        function zA(e1, t, i) {
            const r = t.updateZoomBasedPaintProperties(), n = function(e1, t, i) {
                let r, n, o, s = e1.terrain ? e1.terrain.exaggeration() : 0;
                if (e1.terrain && s > 0) {
                    const t = e1.terrain, n = t.findDEMTileFor(i);
                    n && n.dem ? r = Jm.create(t, i, n) : s = 0;
                }
                if (0 === s && (t.terrainElevationMin = 0, t.terrainElevationMax = 0), s === t.validForExaggeration && (0 === s || r && r._demTile && r._demTile.tileID === t.validForDEMTile.id && r._dem._timestamp === t.validForDEMTile.timestamp)) return !1;
                for(const e1 in t.instancesPerModel){
                    const i = t.instancesPerModel[e1];
                    for(let e1 = 0; e1 < i.instancedDataArray.length; ++e1){
                        const a = (r ? s * r.getElevationAt(0 | i.instancedDataArray.float32[16 * e1], 0 | i.instancedDataArray.float32[16 * e1 + 1], !0, !0) : 0) + i.instancesEvaluatedElevation[e1];
                        i.instancedDataArray.float32[16 * e1 + 6] = a, n = n ? Math.min(t.terrainElevationMin, a) : a, o = o ? Math.max(t.terrainElevationMax, a) : a;
                    }
                }
                return t.terrainElevationMin = n || 0, t.terrainElevationMax = o || 0, t.validForExaggeration = s, t.validForDEMTile = r && r._demTile ? {
                    id: r._demTile.tileID,
                    timestamp: r._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(e1, t, i);
            (r || n) && (t.uploaded = !1, t.upload(e1.context));
        }
        const PA = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new ed([
                0,
                0,
                0
            ], [
                cr,
                cr,
                0
            ])
        };
        function DA(e1, t) {
            const i = 1 << e1.canonical.z, r = t.getFreeCameraOptions().position, n = t.elevation, o = e1.canonical.x / i, s = (e1.canonical.x + 1) / i, a = e1.canonical.y / i, l = (e1.canonical.y + 1) / i;
            let c = t._centerAltitude;
            if (n) {
                const t = n.getMinMaxForTile(e1);
                t && t.max > c && (c = t.max);
            }
            const h = z(r.x, o, s) - r.x, u = z(r.y, a, l) - r.y, d = Qd(c, t.center.lat) - r.z;
            return t._zoomFromMercatorZ(Math.sqrt(h * h + u * u + d * d));
        }
        function RA(e1, t, i, r, n, o, s) {
            const a = e1.context, l = "shadow" === e1.renderPass, c = e1.shadowRenderer, h = l && c ? c.getShadowPassDepthMode() : new Mx(a.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), u = e1.isTileAffectedByFog(o);
            if (i.meshes) for (const d of i.meshes){
                const p = [
                    "MODEL_POSITION_ON_GPU"
                ], f = [];
                let m, _, g;
                r.instancedDataArray.length > 20 && p.push("INSTANCED_ARRAYS");
                const y = eM(e1, t.paint.get("model-cutoff-fade-range"));
                if (y.shouldRenderCutoff && p.push("RENDER_CUTOFF"), l && c) m = e1.getOrCreateProgram("modelDepth", {
                    defines: p
                }), _ = jM(s.shadowTileMatrix, s.shadowTileMatrix, Float32Array.from(i.matrix)), g = c.getShadowPassColorMode();
                else {
                    AA(p, f, d, e1), m = e1.getOrCreateProgram("model", {
                        defines: p,
                        overrideFog: u
                    });
                    const r = d.material, l = r.pbrMetallicRoughness, h = t.paint.get("model-opacity"), x = t.paint.get("model-emissive-strength").constantOr(0);
                    _ = UM(o.expandedProjMatrix, Float32Array.from(i.matrix), new Float32Array(16), e1, h, l.baseColorFactor, r.emissiveFactor, l.metallicFactor, l.roughnessFactor, r, x, t, n), c && (s.shadowUniformsInitialized ? m.setShadowUniformValues(a, c.getShadowUniformValues()) : (c.setupShadows(o.toUnwrapped(), m, "model-tile", o.overscaledZ), s.shadowUniformsInitialized = !0)), g = y.shouldRenderCutoff || h < 1 || "OPAQUE" !== r.alphaMode ? Cx.alphaBlended : Cx.unblended;
                }
                e1.uploadCommonUniforms(a, m, o.toUnwrapped(), null, y);
                const x = d.material.doubleSided ? Dx.disabled : Dx.backCCW;
                if (r.instancedDataArray.length > 20) f.push(r.instancedDataBuffer), m.draw(e1, a.gl.TRIANGLES, h, Sx.disabled, g, x, _, t.id, d.vertexBuffer, d.indexBuffer, d.segments, t.paint, e1.transform.zoom, void 0, f, r.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let n = 0; n < r.instancedDataArray.length; ++n)_[i] = new Float32Array(r.instancedDataArray.arrayBuffer, 64 * n, 16), m.draw(e1, a.gl.TRIANGLES, h, Sx.disabled, g, x, _, t.id, d.vertexBuffer, d.indexBuffer, d.segments, t.paint, e1.transform.zoom, void 0, f);
                }
            }
            if (i.children) for (const a of i.children)RA(e1, t, a, r, n, o, s);
        }
        const LA = [
            1,
            -1,
            1
        ];
        function kA(e1, t, i, r) {
            if (!i.modelManager) return !0;
            const n = i.modelManager;
            if (!i.shadowRenderer) return !0;
            const o = i.shadowRenderer, s = t.aabb;
            let a = !0, l = e1.maxHeight;
            if (0 === l) {
                let t = 0;
                for(const i in e1.instancesPerModel){
                    const e1 = n.getModel(i, r);
                    e1 ? t = Math.max(t, Math.max(Math.max(e1.aabb.max[0], e1.aabb.max[1]), e1.aabb.max[2])) : a = !1;
                }
                l = e1.maxScale * t * 1.41 + e1.maxVerticalOffset, a && (e1.maxHeight = l);
            }
            s.max[2] = l, s.min[2] += e1.terrainElevationMin, s.max[2] += e1.terrainElevationMax, Du.transformMat4(s.min, s.min, t.tileMatrix), Du.transformMat4(s.max, s.max, t.tileMatrix);
            const c = s.intersects(o.getCurrentCascadeFrustum());
            return 0 === i.currentShadowCascade && (e1.isInsideFirstShadowMapFrustum = 2 === c), 0 === c;
        }
        class OA {
        }
        class BA {
            constructor(){
                this._storage = new Map;
            }
            getLinesFromTrianglesBuffer(e1, t, i) {
                {
                    const i = this._storage.get(t.id);
                    if (i) return i.lastUsedFrameIdx = e1, i.buf;
                }
                const r = i.gl, n = r.getBufferParameter(r.ELEMENT_ARRAY_BUFFER, r.BUFFER_SIZE), o = new ArrayBuffer(n), s = new Int16Array(o);
                r.getBufferSubData(r.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(o));
                const a = new ja;
                for(let e1 = 0; e1 < n / 2; e1 += 3){
                    const t = s[e1], i = s[e1 + 1], r = s[e1 + 2];
                    a.emplaceBack(t, i), a.emplaceBack(i, r), a.emplaceBack(r, t);
                }
                const l = i.bindVertexArrayOES.current, c = new OA;
                return c.buf = new Fy(i, a), c.lastUsedFrameIdx = e1, this._storage.set(t.id, c), i.bindVertexArrayOES.set(l), c.buf;
            }
            update(e1) {
                for (const [t, i] of this._storage)e1 - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t));
            }
            destroy() {
                for (const [e1, t] of this._storage)t.buf.destroy(), this._storage.delete(e1);
            }
        }
        const FA = {
            symbol: function(e1, t, i, r, n) {
                if ("translucent" !== e1.renderPass) return;
                const o = Sx.disabled, s = e1.colorModeForRenderPass();
                i.layout.get("text-variable-anchor") && function(e1, t, i, r, n, o, s) {
                    const a = t.transform, l = "map" === n, c = "map" === o;
                    for (const t of e1){
                        const e1 = r.getTile(t), n = e1.getBucket(i);
                        if (!n || !n.text || !n.text.segments.get().length) continue;
                        const o = m_(n.textSizeData, a.zoom), h = YT(t, n.getProjection(), a), u = a.calculatePixelsToTileUnitsMatrix(e1), d = sv(h, e1.tileID.canonical, c, l, a, n.getProjection(), u), p = n.hasIconTextFit() && n.hasIconData();
                        if (o) {
                            const i = Math.pow(2, a.zoom - e1.tileID.overscaledZ);
                            HM(n, l, c, s, __, a, d, t, i, o, p);
                        }
                    }
                }(r, e1, i, t, i.layout.get("text-rotation-alignment"), i.layout.get("text-pitch-alignment"), n), 0 !== i.paint.get("icon-opacity").constantOr(1) && YM(e1, t, i, r, !1, i.paint.get("icon-translate"), i.paint.get("icon-translate-anchor"), i.layout.get("icon-rotation-alignment"), i.layout.get("icon-pitch-alignment"), i.layout.get("icon-keep-upright"), i.paint.get("icon-color-saturation"), o, s), 0 !== i.paint.get("text-opacity").constantOr(1) && YM(e1, t, i, r, !0, i.paint.get("text-translate"), i.paint.get("text-translate-anchor"), i.layout.get("text-rotation-alignment"), i.layout.get("text-pitch-alignment"), i.layout.get("text-keep-upright"), i.paint.get("icon-color-saturation"), o, s), t.map.showCollisionBoxes && (ZM(e1, t, i, r, i.paint.get("text-translate"), i.paint.get("text-translate-anchor"), !0), ZM(e1, t, i, r, i.paint.get("icon-translate"), i.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(e1, t, i, r) {
                if ("translucent" !== e1.renderPass) return;
                const n = i.paint.get("circle-opacity"), o = i.paint.get("circle-stroke-width"), s = i.paint.get("circle-stroke-opacity"), a = void 0 !== i.layout.get("circle-sort-key").constantOr(1), l = i.paint.get("circle-emissive-strength");
                if (0 === n.constantOr(1) && (0 === o.constantOr(1) || 0 === s.constantOr(1))) return;
                const c = e1.context, h = c.gl, u = e1.transform, d = e1.depthModeForSublayer(0, Mx.ReadOnly), p = Sx.disabled, f = e1.colorModeForDrapableLayerRenderPass(l), m = "globe" === u.projection.name, _ = [
                    Kd(u.center.lng),
                    Jd(u.center.lat)
                ], g = [];
                for(let n = 0; n < r.length; n++){
                    const o = r[n], s = t.getTile(o), l = s.getBucket(i);
                    if (!l || l.projection.name !== u.projection.name) continue;
                    const c = l.programConfigurations.get(i.id), h = Gp(i), d = e1.isTileAffectedByFog(o);
                    m && h.push("PROJECTION_GLOBE_VIEW");
                    const p = e1.getOrCreateProgram("circle", {
                        config: c,
                        defines: h,
                        overrideFog: d
                    }), f = l.layoutVertexBuffer, y = l.globeExtVertexBuffer, x = l.indexBuffer, v = u.projection.createInversionMatrix(u, o.canonical), b = {
                        programConfiguration: c,
                        program: p,
                        layoutVertexBuffer: f,
                        globeExtVertexBuffer: y,
                        indexBuffer: x,
                        uniformValues: jp(e1, o, s, v, _, i),
                        tile: s
                    };
                    if (a) {
                        const e1 = l.segments.get();
                        for (const t of e1)g.push({
                            segments: new xl([
                                t
                            ]),
                            sortKey: t.sortKey,
                            state: b
                        });
                    } else g.push({
                        segments: l.segments,
                        sortKey: 0,
                        state: b
                    });
                }
                a && g.sort((e1, t)=>e1.sortKey - t.sortKey);
                const y = {
                    useDepthForOcclusion: u.depthOcclusionForSymbolsAndCircles
                };
                for (const t of g){
                    const { programConfiguration: r, program: n, layoutVertexBuffer: o, globeExtVertexBuffer: s, indexBuffer: a, uniformValues: l, tile: m } = t.state, _ = t.segments;
                    e1.terrain && e1.terrain.setupElevationDraw(m, n, y), e1.uploadCommonUniforms(c, n, m.tileID.toUnwrapped()), n.draw(e1, h.TRIANGLES, d, p, f, Dx.disabled, l, i.id, o, a, _, i.paint, u.zoom, r, [
                        s
                    ]);
                }
            },
            heatmap: function(e1, t, i, r) {
                if (0 !== i.paint.get("heatmap-opacity")) {
                    if ("offscreen" === e1.renderPass) {
                        const n = e1.context, o = n.gl, s = Sx.disabled, a = new Cx([
                            o.ONE,
                            o.ONE,
                            o.ONE,
                            o.ONE
                        ], hi.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e1, t, i, r) {
                            const n = e1.gl, o = t.width * r, s = t.height * r;
                            e1.activeTexture.set(n.TEXTURE1), e1.viewport.set([
                                0,
                                0,
                                o,
                                s
                            ]);
                            let a = i.heatmapFbo;
                            if (!a || a && (a.width !== o || a.height !== s)) {
                                a && a.destroy();
                                const t = n.createTexture();
                                n.bindTexture(n.TEXTURE_2D, t), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), a = i.heatmapFbo = e1.createFramebuffer(o, s, !0, null), function(e1, t, i, r, n, o) {
                                    const s = e1.gl;
                                    s.texImage2D(s.TEXTURE_2D, 0, e1.extRenderToTextureHalfFloat ? s.RGBA16F : s.RGBA, n, o, 0, s.RGBA, e1.extRenderToTextureHalfFloat ? s.HALF_FLOAT : s.UNSIGNED_BYTE, null), r.colorAttachment.set(i);
                                }(e1, 0, t, a, o, s);
                            } else n.bindTexture(n.TEXTURE_2D, a.colorAttachment.get()), e1.bindFramebuffer.set(a.framebuffer);
                        }(n, e1, i, "globe" === e1.transform.projection.name ? .5 : .25), n.clear({
                            color: hi.transparent
                        });
                        const l = e1.transform, c = "globe" === l.projection.name, h = c ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], u = c ? Dx.frontCCW : Dx.disabled, d = [
                            Kd(l.center.lng),
                            Jd(l.center.lat)
                        ];
                        for(let p = 0; p < r.length; p++){
                            const f = r[p];
                            if (t.hasRenderableParent(f)) continue;
                            const m = t.getTile(f), _ = m.getBucket(i);
                            if (!_ || _.projection.name !== l.projection.name) continue;
                            const g = e1.isTileAffectedByFog(f), y = _.programConfigurations.get(i.id), x = e1.getOrCreateProgram("heatmap", {
                                config: y,
                                defines: h,
                                overrideFog: g
                            }), { zoom: v } = e1.transform;
                            e1.terrain && e1.terrain.setupElevationDraw(m, x), e1.uploadCommonUniforms(n, x, f.toUnwrapped());
                            const b = l.projection.createInversionMatrix(l, f.canonical);
                            x.draw(e1, o.TRIANGLES, Mx.disabled, s, a, u, IM(e1, f, m, b, d, v, i.paint.get("heatmap-intensity")), i.id, _.layoutVertexBuffer, _.indexBuffer, _.segments, i.paint, e1.transform.zoom, y, c ? [
                                _.globeExtVertexBuffer
                            ] : null);
                        }
                        n.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, t) {
                        const i = e1.context, r = i.gl, n = t.heatmapFbo;
                        if (!n) return;
                        i.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, n.colorAttachment.get()), i.activeTexture.set(r.TEXTURE1);
                        let o = t.colorRampTexture;
                        o || (o = t.colorRampTexture = new My(i, t.colorRamp, r.RGBA)), o.bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.getOrCreateProgram("heatmapTexture").draw(e1, r.TRIANGLES, Mx.disabled, Sx.disabled, e1.colorModeForRenderPass(), Dx.disabled, ((e1, t, i, r)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t.paint.get("heatmap-opacity")
                            }))(0, t), t.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, t.paint, e1.transform.zoom);
                    }(e1, i));
                }
            },
            line: function(e1, t, i, r) {
                if ("translucent" !== e1.renderPass) return;
                const n = i.paint.get("line-opacity"), o = i.paint.get("line-width");
                if (0 === n.constantOr(1) || 0 === o.constantOr(1)) return;
                const s = i.paint.get("line-emissive-strength"), a = e1.depthModeForSublayer(0, Mx.ReadOnly), l = e1.colorModeForDrapableLayerRenderPass(s), c = e1.terrain && e1.terrain.renderingToTexture ? 1 : dt.devicePixelRatio, h = i.paint.get("line-dasharray"), u = h.constantOr(1), d = i.layout.get("line-cap"), p = i.paint.get("line-pattern"), f = p.constantOr(1), m = i.paint.get("line-pattern").constantOr(1), _ = 1 !== i.paint.get("line-opacity").constantOr(1);
                let g = !m && _;
                const y = i.paint.get("line-gradient"), x = f ? "linePattern" : "line", v = e1.context, b = v.gl, w = Gb(i);
                e1.terrain && e1.terrain.clipOrMaskOverlapStencilType() && (g = !1);
                for (const n of r){
                    const r = t.getTile(n);
                    if (f && !r.patternsLoaded()) continue;
                    const o = r.getBucket(i);
                    if (!o) continue;
                    e1.prepareDrawTile();
                    const s = o.programConfigurations.get(i.id), m = e1.isTileAffectedByFog(n), _ = e1.getOrCreateProgram(x, {
                        config: s,
                        defines: w,
                        overrideFog: m
                    }), T = p.constantOr(null);
                    if (T && r.imageAtlas) {
                        const e1 = r.imageAtlas.patternPositions[T.toString()];
                        e1 && s.setConstantPatternPositions(e1);
                    }
                    const E = h.constantOr(null), M = d.constantOr(null);
                    if (!f && E && M && r.lineAtlas) {
                        const e1 = r.lineAtlas.getDash(E, M);
                        e1 && s.setConstantPatternPositions(e1);
                    }
                    let [A, S] = i.paint.get("line-trim-offset");
                    if ("round" === M || "square" === M) {
                        const e1 = 1;
                        A !== S && (0 === A && (A -= e1), 1 === S && (S += e1));
                    }
                    const I = e1.terrain ? n.projMatrix : null, C = f ? Ub(e1, r, i, I, c) : Nb(e1, r, i, I, o.lineClipsArray.length, c, [
                        A,
                        S
                    ]);
                    if (y) {
                        const r = o.gradients[i.id];
                        let s = r.texture;
                        if (i.gradientVersion !== r.version) {
                            let a = 256;
                            if (i.stepInterpolant) {
                                const i = t.getSource().maxzoom, r = n.canonical.z === i ? Math.ceil(1 << e1.transform.maxZoom - n.canonical.z) : 1;
                                a = z(U(o.maxLineLength / cr * 1024 * r), 256, v.maxTextureSize);
                            }
                            r.gradient = of({
                                expression: i.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: a,
                                image: r.gradient || void 0,
                                clips: o.lineClipsArray
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new My(v, r.gradient, b.RGBA), r.version = i.gradientVersion, s = r.texture;
                        }
                        v.activeTexture.set(b.TEXTURE1), s.bind(i.stepInterpolant ? b.NEAREST : b.LINEAR, b.CLAMP_TO_EDGE);
                    }
                    u && (v.activeTexture.set(b.TEXTURE0), r.lineAtlasTexture && r.lineAtlasTexture.bind(b.LINEAR, b.REPEAT), s.updatePaintBuffers()), f && (v.activeTexture.set(b.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(b.LINEAR, b.CLAMP_TO_EDGE), s.updatePaintBuffers()), e1.uploadCommonUniforms(v, _, n.toUnwrapped());
                    const P = (t)=>{
                        _.draw(e1, b.TRIANGLES, a, t, l, Dx.disabled, C, i.id, o.layoutVertexBuffer, o.indexBuffer, o.segments, i.paint, e1.transform.zoom, s, [
                            o.layoutVertexBuffer2
                        ]);
                    };
                    if (g) {
                        const t = e1.stencilModeForClipping(n).ref;
                        0 === t && e1.terrain && v.clear({
                            stencil: 0
                        });
                        const i = {
                            func: b.EQUAL,
                            mask: 255
                        };
                        C.u_alpha_discard_threshold = .8, P(new Sx(i, t, 255, b.KEEP, b.KEEP, b.INVERT)), C.u_alpha_discard_threshold = 0, P(new Sx(i, t, 255, b.KEEP, b.KEEP, b.KEEP));
                    } else P(e1.stencilModeForClipping(n));
                }
                g && (e1.resetStencilClippingMasks(), e1.terrain && v.clear({
                    stencil: 0
                }));
            },
            fill: function(e1, t, i, r) {
                const n = i.paint.get("fill-color"), o = i.paint.get("fill-opacity");
                if (0 === o.constantOr(1)) return;
                const s = i.paint.get("fill-emissive-strength"), a = e1.colorModeForDrapableLayerRenderPass(s), l = i.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === n.constantOr(hi.transparent).a && 1 === o.constantOr(0) ? "opaque" : "translucent";
                if (e1.renderPass === c) {
                    const n = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? Mx.ReadWrite : Mx.ReadOnly);
                    JM(e1, t, i, r, n, a, !1);
                }
                if ("translucent" === e1.renderPass && i.paint.get("fill-antialias")) {
                    const n = e1.depthModeForSublayer(i.getPaintProperty("fill-outline-color") ? 2 : 0, Mx.ReadOnly);
                    JM(e1, t, i, r, n, a, !0);
                }
            },
            "fill-extrusion": function(e1, t, i, r) {
                const n = i.paint.get("fill-extrusion-opacity"), o = e1.context, s = o.gl, a = e1.terrain, l = a && a.renderingToTexture, c = i.paint.get("fill-extrusion-cutoff-fade-range");
                if (0 === n) return;
                const h = e1.conflationActive && e1.layerUsedInConflation(i, t.getSource());
                if (h && function(e1, t, i, r) {
                    for (const n of r){
                        const r = t.getTile(n).getBucket(i);
                        r && (r.updateReplacement(n, e1.replacementSource), r.uploadCentroid(e1.context));
                    }
                }(e1, t, i, r), a || h) for (const n of r){
                    const r = t.getTile(n).getBucket(i);
                    r && tA(e1.context, t, n, r, i, a, h);
                }
                if ("shadow" === e1.renderPass && e1.shadowRenderer) {
                    const o = e1.shadowRenderer;
                    if (a && n < .65 && i._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof Ao) return;
                    const s = o.getShadowPassDepthMode(), l = o.getShadowPassColorMode();
                    QM(e1, t, i, r, s, Sx.disabled, l, h);
                } else if ("translucent" === e1.renderPass) {
                    const u = !i.paint.get("fill-extrusion-pattern").constantOr(1);
                    if (!l) {
                        const o = new Mx(e1.context.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D);
                        0 === c && 1 === n && u ? QM(e1, t, i, r, o, Sx.disabled, Cx.unblended, h) : (QM(e1, t, i, r, o, Sx.disabled, Cx.disabled, h), QM(e1, t, i, r, o, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), h), e1.resetStencilClippingMasks());
                    }
                    if (e1.style.enable3dLights() && u && (!a && "globe" !== e1.transform.projection.name || l)) {
                        const n = i.paint.get("fill-extrusion-opacity"), c = i.paint.get("fill-extrusion-ambient-occlusion-intensity"), u = i.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), d = i.paint.get("fill-extrusion-flood-light-intensity"), p = i.paint.get("fill-extrusion-flood-light-color").toArray01().slice(0, 3), f = c > 0 && u > 0, m = d > 0, _ = (e1, t, i)=>(1 - i) * e1 + i * t, g = (o)=>{
                            const a = e1.depthModeForSublayer(1, Mx.ReadOnly, s.LEQUAL, !0), l = i.paint.get(o ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), f = _(.1, 3, l), m = e1._showOverdrawInspector;
                            if (!m) {
                                const l = new Sx({
                                    func: s.ALWAYS,
                                    mask: 255
                                }, 255, 255, s.KEEP, s.KEEP, s.REPLACE), m = new Cx([
                                    s.ONE,
                                    s.ONE,
                                    s.ONE,
                                    s.ONE
                                ], hi.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], s.MIN);
                                eA(e1, t, i, r, a, l, m, Dx.disabled, o, "sdf", n, c, u, d, p, f, h, !1);
                            }
                            {
                                const l = m ? Sx.disabled : new Sx({
                                    func: s.EQUAL,
                                    mask: 255
                                }, 255, 255, s.KEEP, s.DECR, s.DECR), _ = m ? e1.colorModeForRenderPass() : new Cx([
                                    s.ONE_MINUS_DST_ALPHA,
                                    s.DST_ALPHA,
                                    s.ONE,
                                    s.ONE
                                ], hi.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                eA(e1, t, i, r, a, l, _, Dx.disabled, o, "color", n, c, u, d, p, f, h, !1);
                            }
                        };
                        if (l) {
                            const l = (o, a, l)=>{
                                const f = e1.depthModeForSublayer(1, Mx.ReadOnly, s.LEQUAL, !1), m = i.paint.get(o ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), g = _(.1, 3, m);
                                {
                                    const l = new Cx([
                                        s.ONE,
                                        s.ONE,
                                        s.ONE,
                                        s.ONE
                                    ], hi.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    eA(e1, t, i, r, f, Sx.disabled, l, Dx.disabled, o, "clear", n, c, u, d, p, g, h, a);
                                }
                                {
                                    const l = new Sx({
                                        func: s.ALWAYS,
                                        mask: 255
                                    }, 255, 255, s.KEEP, s.KEEP, s.REPLACE), m = new Cx([
                                        s.ONE,
                                        s.ONE,
                                        s.ONE,
                                        s.ONE
                                    ], hi.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], s.MIN);
                                    eA(e1, t, i, r, f, l, m, Dx.disabled, o, "sdf", n, c, u, d, p, g, h, a);
                                }
                                {
                                    const l = o ? s.ZERO : s.ONE_MINUS_DST_ALPHA, m = new Sx({
                                        func: s.EQUAL,
                                        mask: 255
                                    }, 255, 255, s.KEEP, s.DECR, s.DECR), _ = new Cx([
                                        l,
                                        s.DST_ALPHA,
                                        s.ONE_MINUS_DST_ALPHA,
                                        s.ZERO
                                    ], hi.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    eA(e1, t, i, r, f, m, _, Dx.disabled, o, "color", n, c, u, d, p, g, h, a);
                                }
                                {
                                    const m = new Cx([
                                        s.ONE,
                                        s.ONE,
                                        s.ONE,
                                        o ? s.ZERO : s.ONE
                                    ], hi.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], o ? s.FUNC_ADD : s.MAX);
                                    eA(e1, t, i, r, f, Sx.disabled, m, Dx.disabled, o, "clear", n, c, u, d, p, g, h, a, l);
                                }
                            };
                            if (f || m) {
                                let t;
                                if (e1.prepareDrawTile(), a) {
                                    const e1 = a.drapeBufferSize[0], i = a.drapeBufferSize[1];
                                    t = a.framebufferCopyTexture, t && (!t || t.size[0] === e1 && t.size[1] === i) || (t && t.destroy(), t = a.framebufferCopyTexture = new My(o, new ef({
                                        width: e1,
                                        height: i
                                    }), s.RGBA)), t.bind(s.LINEAR, s.CLAMP_TO_EDGE), s.copyTexImage2D(s.TEXTURE_2D, 0, s.RGBA, 0, 0, e1, i, 0);
                                }
                                f && l(!0, !1, t), m && l(!1, !0, t);
                            }
                        } else f && g(!0), m && g(!1);
                    }
                }
            },
            hillshade: function(e1, t, i, r) {
                if ("offscreen" !== e1.renderPass && "translucent" !== e1.renderPass) return;
                if (e1.style.disableElevatedTerrain) return;
                const n = e1.context, o = e1.terrain && e1.terrain.renderingToTexture, [s, a] = "translucent" !== e1.renderPass || o ? [
                    {},
                    r
                ] : e1.stencilConfigForOverlap(r);
                for (const r of a){
                    const n = t.getTile(r);
                    if (n.needsHillshadePrepare && "offscreen" === e1.renderPass) YE(e1, n, i);
                    else if ("translucent" === e1.renderPass) {
                        const t = e1.depthModeForSublayer(0, Mx.ReadOnly), a = i.paint.get("hillshade-emissive-strength"), l = e1.colorModeForDrapableLayerRenderPass(a), c = o && e1.terrain ? e1.terrain.stencilModeForRTTOverlap(r) : s[r.overscaledZ];
                        HE(e1, r, n, i, t, c, l);
                    }
                }
                n.viewport.set([
                    0,
                    0,
                    e1.width,
                    e1.height
                ]), e1.resetStencilClippingMasks();
            },
            raster: function(e1, t, i, r, n, o) {
                if ("translucent" !== e1.renderPass) return;
                if (0 === i.paint.get("raster-opacity")) return;
                const s = e1.context, a = s.gl, l = t.getSource(), c = function(e1, t, i) {
                    const r = e1.paint.get("raster-color"), n = [], o = e1.paint.get("raster-resampling"), s = e1.paint.get("raster-color-mix"), a = e1.paint.get("raster-color-range"), l = [
                        s[0],
                        s[1],
                        s[2],
                        0
                    ], c = s[3], h = "nearest" === o ? i.NEAREST : i.LINEAR;
                    if (r && n.push("RASTER_COLOR"), r) {
                        t.activeTexture.set(i.TEXTURE2);
                        let r = e1.colorRampTexture;
                        r || (r = e1.colorRampTexture = new My(t, e1.colorRamp, i.RGBA)), r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                    }
                    return {
                        mix: l,
                        range: a,
                        offset: c,
                        defines: n,
                        resampling: h
                    };
                }(i, s, a), h = c.defines, u = "globe" === e1.transform.projection.name;
                let d = !1;
                if (l instanceof Jb && !r.length) {
                    if (!u) return;
                    if (l.onNorthPole) d = !0, h.push("GLOBE_POLES");
                    else {
                        if (!l.onSouthPole) return;
                        d = !0, h.push("GLOBE_POLES");
                    }
                }
                const p = i.paint.get("raster-emissive-strength"), f = e1.colorModeForDrapableLayerRenderPass(p), m = e1.terrain && e1.terrain.renderingToTexture, _ = l instanceof Jb && 0 !== i.paint.get("raster-elevation"), g = !e1.options.moving, y = "nearest" === i.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;
                if (d) {
                    const r = t.getSource();
                    if (!(r instanceof Jb)) return;
                    const n = r.texture;
                    if (!n) return;
                    const o = e1.globeSharedBuffers;
                    if (!o) return;
                    const l = new Mx(a.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), h = Float32Array.from(e1.transform.expandedFarZProjMatrix);
                    let u = Rd(0, 0, e1.transform);
                    const d = Float32Array.from(Ad(fd(new ju(0, 0, 0)))), m = {
                        opacity: 1,
                        mix: 0
                    };
                    e1.terrain && e1.terrain.prepareDrawTile(), s.activeTexture.set(a.TEXTURE0), n.bind(y, a.CLAMP_TO_EDGE), s.activeTexture.set(a.TEXTURE1), n.bind(y, a.CLAMP_TO_EDGE), n.useMipmap && s.extTextureFilterAnisotropic && e1.transform.pitch > 20 && a.texParameterf(a.TEXTURE_2D, s.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, s.extTextureFilterAnisotropicMax);
                    const [_, g, x, v] = o.getPoleBuffers(0, !0);
                    let b;
                    r.onNorthPole ? (b = _, e1.renderDefaultNorthPole = !1) : (u = Au.scale(Au.create(), u, [
                        1,
                        -1,
                        1
                    ]), b = g, e1.renderDefaultSouthPole = !1);
                    const w = ((e1, t, i, r, n, o, s, a, l, c, h, u)=>CM(e1, t, i, new Float32Array(16), new Float32Array(9), [
                            0,
                            0
                        ], [
                            0,
                            0,
                            0,
                            0
                        ], 0, [
                            0,
                            0
                        ], [
                            0,
                            0,
                            0,
                            0
                        ], 1, r, n, o || [
                            0,
                            0
                        ], s, 2, l, c, h, 1, 0, u))(h, d, u, m, i, r.perspectiveTransform || [
                        0,
                        0
                    ], i.paint.get("raster-elevation"), 0, c.mix, c.offset, c.range, p), T = e1.getOrCreateProgram("raster", {
                        defines: c.defines
                    });
                    return e1.uploadCommonUniforms(s, T, null), void T.draw(e1, a.TRIANGLES, l, Sx.disabled, f, Dx.disabled, w, i.id, b, x, v);
                }
                if (!r.length) return;
                const [x, v] = l instanceof Jb || m ? [
                    {},
                    r
                ] : e1.stencilConfigForOverlap(r), b = v[v.length - 1].overscaledZ, w = _ && u;
                w && c.defines.push("PROJECTION_GLOBE_VIEW"), _ && c.defines.push("RENDER_CUTOFF");
                for (const r of v){
                    const n = r.toUnwrapped(), h = t.getTile(r);
                    if (m && (!h || !h.hasData())) continue;
                    if (!h.texture) continue;
                    let d, v;
                    m ? (d = Mx.disabled, v = r.projMatrix) : _ ? (d = new Mx(a.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), v = u ? Float32Array.from(e1.transform.expandedFarZProjMatrix) : e1.transform.calculateProjMatrix(n, g)) : (d = e1.depthModeForSublayer(r.overscaledZ - b, 1 === i.paint.get("raster-opacity") ? Mx.ReadWrite : Mx.ReadOnly, a.LESS), v = e1.transform.calculateProjMatrix(n, g));
                    const T = e1.terrain && m ? e1.terrain.stencilModeForRTTOverlap(r) : x[r.overscaledZ], E = o ? 0 : i.paint.get("raster-fade-duration");
                    h.registerFadeDuration(E);
                    const M = t.findLoadedParent(r, 0), A = aM(h, M, t, e1.transform, E);
                    let S, I;
                    e1.terrain && e1.terrain.prepareDrawTile(), s.activeTexture.set(a.TEXTURE0), h.texture && h.texture.bind(y, a.CLAMP_TO_EDGE), s.activeTexture.set(a.TEXTURE1), M ? (M.texture && M.texture.bind(y, a.CLAMP_TO_EDGE), S = Math.pow(2, M.tileID.overscaledZ - h.tileID.overscaledZ), I = [
                        h.tileID.canonical.x * S % 1,
                        h.tileID.canonical.y * S % 1
                    ]) : h.texture && h.texture.bind(y, a.CLAMP_TO_EDGE), h.texture && h.texture.useMipmap && s.extTextureFilterAnisotropic && e1.transform.pitch > 20 && a.texParameterf(a.TEXTURE_2D, s.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, s.extTextureFilterAnisotropicMax);
                    const C = e1.transform, z = l instanceof Jb ? l.perspectiveTransform : [
                        0,
                        0
                    ], P = _ ? sA(C) : [
                        0,
                        0,
                        0,
                        0
                    ];
                    let D, R, L, k, O, B;
                    if (w && l instanceof Jb && l.coordinates.length > 3) {
                        D = Float32Array.from(Ad(fd(new ju(0, 0, 0)))), R = Float32Array.from(C.globeMatrix), L = Float32Array.from(Pd(C)), k = [
                            Kd(C.center.lng),
                            Jd(C.center.lat)
                        ], B = [
                            Kd(l.coordinates[1][0]),
                            Jd(l.coordinates[1][1]),
                            Kd(l.coordinates[3][0]),
                            Jd(l.coordinates[3][1])
                        ];
                        const t = new sc(l.coordinates[1], l.coordinates[3]);
                        O = Float32Array.from(kd(new ju(0, 0, 0), t, 0, C.worldSize / e1.transform._pixelsPerMercatorPixel));
                    } else D = new Float32Array(16), R = new Float32Array(9), L = new Float32Array(16), k = [
                        0,
                        0
                    ], O = new Float32Array(16), B = [
                        0,
                        0,
                        0,
                        0
                    ];
                    const F = CM(v, D, R, L, O, I || [
                        0,
                        0
                    ], B, Dd(e1.transform.zoom), k, P, S || 1, A, i, z, _ ? i.paint.get("raster-elevation") : 0, 2, c.mix, c.offset, c.range, 1, 0, p), N = e1.isTileAffectedByFog(r), U = e1.getOrCreateProgram("raster", {
                        defines: c.defines,
                        overrideFog: N
                    });
                    if (e1.uploadCommonUniforms(s, U, n), l instanceof Jb) {
                        if (m || !u) l.boundsBuffer && l.boundsSegments && U.draw(e1, a.TRIANGLES, d, Sx.disabled, f, Dx.disabled, F, i.id, l.boundsBuffer, e1.quadTriangleIndexBuffer, l.boundsSegments);
                        else if (e1.globeSharedBuffers) {
                            const [t, r, n] = e1.globeSharedBuffers.getGridBuffers(0, !1);
                            U.draw(e1, a.TRIANGLES, d, Sx.disabled, f, Dx.frontCCW, F, i.id, t, r, n), U.draw(e1, a.TRIANGLES, d, Sx.disabled, f, Dx.backCCW, F, i.id, t, r, n);
                        }
                    } else {
                        const { tileBoundsBuffer: t, tileBoundsIndexBuffer: r, tileBoundsSegments: n } = e1.getTileBoundsBuffers(h);
                        U.draw(e1, a.TRIANGLES, d, T, f, Dx.disabled, F, i.id, t, r, n);
                    }
                }
                e1.resetStencilClippingMasks();
            },
            background: function(e1, t, i, r) {
                const n = i.paint.get("background-color"), o = i.paint.get("background-opacity"), s = i.paint.get("background-emissive-strength");
                if (0 === o) return;
                const a = e1.context, l = a.gl, c = e1.transform, h = c.tileSize, u = i.paint.get("background-pattern");
                if (e1.isPatternMissing(u, i.scope)) return;
                const d = !u && 1 === n.a && 1 === o && e1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (e1.renderPass !== d) return;
                const p = Sx.disabled, f = e1.depthModeForSublayer(0, "opaque" === d ? Mx.ReadWrite : Mx.ReadOnly), m = e1.colorModeForDrapableLayerRenderPass(s), _ = u ? "backgroundPattern" : "background";
                let g, y = r;
                y || (g = e1.getBackgroundTiles(), y = Object.values(g).map((e1)=>e1.tileID)), u && (a.activeTexture.set(l.TEXTURE0), e1.imageManager.bind(e1.context, i.scope));
                for (const d of y){
                    const y = e1.isTileAffectedByFog(d), x = e1.getOrCreateProgram(_, {
                        overrideFog: y
                    }), v = d.toUnwrapped(), b = r ? d.projMatrix : e1.transform.calculateProjMatrix(v);
                    e1.prepareDrawTile();
                    const w = t ? t.getTile(d) : g ? g[d.key] : new Oy(d, h, c.zoom, e1), T = u ? FM(b, s, o, e1, u, i.scope, {
                        tileID: d,
                        tileSize: h
                    }) : BM(b, s, o, n);
                    e1.uploadCommonUniforms(a, x, v);
                    const { tileBoundsBuffer: E, tileBoundsIndexBuffer: M, tileBoundsSegments: A } = e1.getTileBoundsBuffers(w);
                    x.draw(e1, l.TRIANGLES, f, p, m, Dx.disabled, T, i.id, E, M, A);
                }
            },
            sky: function(e1, t, i) {
                const r = e1._atmosphere ? Dd(e1.transform.zoom) : 1, n = i.paint.get("sky-opacity") * r;
                if (0 === n) return;
                const o = e1.context, s = i.paint.get("sky-type"), a = new Mx(o.gl.LEQUAL, Mx.ReadOnly, [
                    0,
                    1
                ]), l = e1.frameCounter / 1e3 % 1;
                "atmosphere" === s ? "offscreen" === e1.renderPass ? i.needsSkyboxCapture(e1) && (function(e1, t, i, r) {
                    const n = e1.context, o = n.gl;
                    let s = t.skyboxFbo;
                    if (!s) {
                        s = t.skyboxFbo = n.createFramebuffer(32, 32, !0, null), t.skyboxGeometry = new xA(n), t.skyboxTexture = n.gl.createTexture(), o.bindTexture(o.TEXTURE_CUBE_MAP, t.skyboxTexture), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_MAG_FILTER, o.LINEAR);
                        for(let e1 = 0; e1 < 6; ++e1)o.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e1, 0, o.RGBA, 32, 32, 0, o.RGBA, o.UNSIGNED_BYTE, null);
                    }
                    n.bindFramebuffer.set(s.framebuffer), n.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const a = t.getCenter(e1, !0), l = e1.getOrCreateProgram("skyboxCapture"), c = new Float64Array(16);
                    Au.identity(c), Au.rotateY(c, c, .5 * -Math.PI), vA(e1, t, l, c, a, 0), Au.identity(c), Au.rotateY(c, c, .5 * Math.PI), vA(e1, t, l, c, a, 1), Au.identity(c), Au.rotateX(c, c, .5 * -Math.PI), vA(e1, t, l, c, a, 2), Au.identity(c), Au.rotateX(c, c, .5 * Math.PI), vA(e1, t, l, c, a, 3), Au.identity(c), vA(e1, t, l, c, a, 4), Au.identity(c), Au.rotateY(c, c, Math.PI), vA(e1, t, l, c, a, 5), n.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                }(e1, i), i.markSkyboxValid(e1)) : "sky" === e1.renderPass && function(e1, t, i, r, n) {
                    const o = e1.context, s = o.gl, a = e1.transform, l = e1.getOrCreateProgram("skybox");
                    o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_CUBE_MAP, t.skyboxTexture);
                    const c = ((e1, t, i, r, n)=>({
                            u_matrix: e1,
                            u_sun_direction: t,
                            u_cubemap: 0,
                            u_opacity: r,
                            u_temporal_offset: n
                        }))(a.skyboxMatrix, t.getCenter(e1, !1), 0, r, n);
                    e1.uploadCommonUniforms(o, l), l.draw(e1, s.TRIANGLES, i, Sx.disabled, e1.colorModeForRenderPass(), Dx.backCW, c, "skybox", t.skyboxGeometry.vertexBuffer, t.skyboxGeometry.indexBuffer, t.skyboxGeometry.segment);
                }(e1, i, a, n, l) : "gradient" === s && "sky" === e1.renderPass && function(e1, t, i, r, n) {
                    const o = e1.context, s = o.gl, a = e1.transform, l = e1.getOrCreateProgram("skyboxGradient");
                    t.skyboxGeometry || (t.skyboxGeometry = new xA(o)), o.activeTexture.set(s.TEXTURE0);
                    let c = t.colorRampTexture;
                    c || (c = t.colorRampTexture = new My(o, t.colorRamp, s.RGBA)), c.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                    const h = ((e1, t, i, r, n)=>({
                            u_matrix: e1,
                            u_color_ramp: 0,
                            u_center_direction: t,
                            u_radius: w(i),
                            u_opacity: r,
                            u_temporal_offset: n
                        }))(a.skyboxMatrix, t.getCenter(e1, !1), t.paint.get("sky-gradient-radius"), r, n);
                    e1.uploadCommonUniforms(o, l), l.draw(e1, s.TRIANGLES, i, Sx.disabled, e1.colorModeForRenderPass(), Dx.backCW, h, "skyboxGradient", t.skyboxGeometry.vertexBuffer, t.skyboxGeometry.indexBuffer, t.skyboxGeometry.segment);
                }(e1, i, a, n, l);
            },
            debug: function(e1, t, i) {
                for(let r = 0; r < i.length; r++)dA(e1, t, i[r]);
            },
            custom: function(e1, t, i, r) {
                const n = e1.context, o = i.implementation;
                if (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes("custom") || e1.terrain && (e1.terrain.renderingToTexture || "offscreen" === e1.renderPass) && i.isLayerDraped(t)) {
                    if ("offscreen" === e1.renderPass) {
                        const t = o.prerender;
                        if (t) {
                            if (e1.setCustomLayerDefaults(), n.setColorMode(e1.colorModeForRenderPass()), "globe" === e1.transform.projection.name) {
                                const i = e1.transform.pointMerc;
                                t.call(o, n.gl, e1.transform.customLayerMatrix(), e1.transform.getProjection(), e1.transform.globeToMercatorMatrix(), Dd(e1.transform.zoom), [
                                    i.x,
                                    i.y
                                ], e1.transform.pixelsPerMeterRatio);
                            } else t.call(o, n.gl, e1.transform.customLayerMatrix());
                            n.setDirty(), e1.setBaseState();
                        }
                    } else if ("translucent" === e1.renderPass) {
                        if (e1.terrain && e1.terrain.renderingToTexture) {
                            const t = o.renderToTile;
                            if (t) {
                                const i = r[0].canonical, s = new lp(i.x + r[0].wrap * (1 << i.z), i.y, i.z);
                                n.setDepthMode(Mx.disabled), n.setStencilMode(Sx.disabled), n.setColorMode(e1.colorModeForRenderPass()), e1.setCustomLayerDefaults(), t.call(o, n.gl, s), n.setDirty(), e1.setBaseState();
                            }
                            return;
                        }
                        e1.setCustomLayerDefaults(), n.setColorMode(e1.colorModeForRenderPass()), n.setStencilMode(Sx.disabled);
                        const t = "3d" === o.renderingMode ? new Mx(e1.context.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D) : e1.depthModeForSublayer(0, Mx.ReadOnly);
                        if (n.setDepthMode(t), "globe" === e1.transform.projection.name) {
                            const t = e1.transform.pointMerc;
                            o.render(n.gl, e1.transform.customLayerMatrix(), e1.transform.getProjection(), e1.transform.globeToMercatorMatrix(), Dd(e1.transform.zoom), [
                                t.x,
                                t.y
                            ], e1.transform.pixelsPerMeterRatio);
                        } else o.render(n.gl, e1.transform.customLayerMatrix());
                        n.setDirty(), e1.setBaseState(), n.bindFramebuffer.set(null);
                    }
                } else H("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            },
            model: function(e1, t, i, r) {
                if ("opaque" === e1.renderPass) return;
                const n = i.paint.get("model-opacity");
                if (0 === n) return;
                const o = i.paint.get("model-cast-shadows");
                if ("shadow" === e1.renderPass) {
                    if (!o) return;
                    if (e1.terrain && n < .65 && i._transitionablePaint._values["model-opacity"].value.expression instanceof Ao) return;
                }
                const s = e1.shadowRenderer, a = i.paint.get("model-receive-shadows");
                s && (s.useNormalOffset = !0, a || (s.enabled = !1));
                const l = ()=>{
                    s && (s.useNormalOffset = !0, a || (s.enabled = !0));
                }, c = t.getSource();
                if ("light-beam" === e1.renderPass && "batched-model" !== c.type) return;
                if ("vector" === c.type || "geojson" === c.type) return function(e1, t, i, r) {
                    const n = e1.transform;
                    if ("mercator" !== n.projection.name) return void H(`Drawing 3D models for ${n.projection.name} projection is not yet implemented`);
                    const o = n.getFreeCameraOptions().position;
                    if (!e1.modelManager) return;
                    const s = e1.modelManager, a = e1.shadowRenderer;
                    if (!i._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
                    const l = i._unevaluatedLayout._values["model-id"], c = {
                        ...i.layout.get("model-id").parameters
                    };
                    for (const h of r){
                        const r = t.getTile(h).getBucket(i);
                        if (!r || r.projection.name !== n.projection.name) continue;
                        const u = DA(h, n);
                        c.zoom = u;
                        const d = l.possiblyEvaluate(c);
                        if (zA(e1, r, h), PA.shadowUniformsInitialized = !1, PA.useSingleShadowCascade = !!a && 0 === a.getMaxCascadeForTile(h.toUnwrapped()), "shadow" === e1.renderPass && a) {
                            if (1 === e1.currentShadowCascade && r.isInsideFirstShadowMapFrustum) continue;
                            const t = n.calculatePosMatrix(h.toUnwrapped(), n.worldSize);
                            if (PA.tileMatrix.set(t), PA.shadowTileMatrix = Float32Array.from(a.calculateShadowPassMatrixFromMatrix(t)), PA.aabb.min.fill(0), PA.aabb.max[0] = PA.aabb.max[1] = cr, PA.aabb.max[2] = 0, kA(r, PA, e1, i.scope)) continue;
                        }
                        const p = 1 << h.canonical.z, f = [
                            ((o.x - h.wrap) * p - h.canonical.x) * cr,
                            (o.y * p - h.canonical.y) * cr,
                            o.z * p * cr
                        ];
                        for(let t in r.instancesPerModel){
                            const n = r.instancesPerModel[t];
                            n.features.length > 0 && (t = d.evaluate(n.features[0].feature, {}));
                            const o = s.getModel(t, i.scope);
                            if (o && o.uploaded) for (const t of o.nodes)RA(e1, i, t, n, f, h, PA);
                        }
                    }
                }(e1, t, i, r), void l();
                if (!c.loaded()) return;
                if ("batched-model" === c.type) return function(e1, t, i, r) {
                    const n = e1.context, o = e1.transform, s = e1.style.fog, a = e1.shadowRenderer;
                    if ("mercator" !== o.projection.name) return void H(`Drawing 3D landmark models for ${o.projection.name} projection is not yet implemented`);
                    const l = e1.transform.getFreeCameraOptions().position, c = Du.scale([], [
                        l.x,
                        l.y,
                        l.z
                    ], e1.transform.worldSize);
                    Du.negate(c, c);
                    const h = Au.identity([]), u = op(o.center.lat, o.zoom), d = Au.fromScaling([], [
                        1,
                        1,
                        1 / u
                    ]);
                    Au.translate(h, h, c);
                    const p = i.paint.get("model-opacity"), f = new Mx(n.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), m = new Mx(n.gl.LEQUAL, Mx.ReadOnly, e1.depthRangeFor3D), _ = function(l, c) {
                        for (const u of r){
                            const r = t.getTile(u).getBucket(i);
                            if (!r || !r.uploaded) continue;
                            let _ = !1;
                            a && (_ = 0 === a.getMaxCascadeForTile(u.toUnwrapped()));
                            const g = o.calculatePosMatrix(u.toUnwrapped(), o.worldSize), y = r.modelTraits;
                            for (const t of r.getNodesInfo()){
                                if (t.hiddenByReplacement) continue;
                                if (!t.node.meshes) continue;
                                const r = t.node, x = "light-beam" === e1.renderPass, v = [
                                    ...g
                                ], b = t.evaluatedScale;
                                let w = 0;
                                e1.terrain && r.elevation && (w = r.elevation * e1.terrain.exaggeration()), Au.translate(v, v, [
                                    (r.anchor ? r.anchor[0] : 0) * (b[0] - 1),
                                    (r.anchor ? r.anchor[1] : 0) * (b[1] - 1),
                                    w
                                ]), b !== Iv && Au.scale(v, v, b), Au.multiply(v, v, r.matrix);
                                const T = Au.multiply([], d, v);
                                Au.multiply(T, h, T);
                                const E = Au.invert([], T);
                                Au.transpose(E, E), Au.scale(E, E, LA);
                                const M = Au.multiply([], o.expandedFarZProjMatrix, v);
                                for(let h = 0; h < r.meshes.length; ++h){
                                    const d = r.meshes[h], g = h === r.lightMeshIndex;
                                    if (g) {
                                        if (!x && !e1.terrain && e1.shadowRenderer) {
                                            e1.currentLayer < e1.firstLightBeamLayer && (e1.firstLightBeamLayer = e1.currentLayer);
                                            continue;
                                        }
                                    } else if (x) continue;
                                    const b = {
                                        defines: []
                                    }, w = [];
                                    AA(b.defines, w, d, e1), 4 & y || b.defines.push("DIFFUSE_SHADED"), _ && b.defines.push("SHADOWS_SINGLE_CASCADE");
                                    const A = "shadow" === e1.renderPass;
                                    if (A) {
                                        CA(d, v, e1, i);
                                        continue;
                                    }
                                    let S = null;
                                    if (s) {
                                        const t = MA(v, e1.transform);
                                        if (S = new Float32Array(t), "globe" !== o.projection.name) {
                                            const e1 = d.aabb.min, i = d.aabb.max, [r, n] = s.getOpacityForBounds(t, e1[0], e1[1], i[0], i[1]);
                                            b.overrideFog = r >= fw || n >= fw;
                                        }
                                    }
                                    const I = e1.getOrCreateProgram("model", b);
                                    !A && a && (a.useNormalOffset = !!d.normalBuffer, a.setupShadowsFromMatrix(v, I, a.useNormalOffset)), e1.uploadCommonUniforms(n, I, u.toUnwrapped(), S);
                                    const C = d.material, z = C.pbrMetallicRoughness;
                                    z.metallicFactor = .9, z.roughnessFactor = .5;
                                    const P = 0, D = UM(new Float32Array(M), new Float32Array(T), new Float32Array(E), e1, p, z.baseColorFactor, C.emissiveFactor, z.metallicFactor, z.roughnessFactor, C, P, i);
                                    I.draw(e1, n.gl.TRIANGLES, c && !g ? f : m, Sx.disabled, l ? g || p < 1 || t.hasTranslucentParts ? Cx.alphaBlended : Cx.unblended : Cx.disabled, Dx.backCCW, D, i.id, d.vertexBuffer, d.indexBuffer, d.segments, i.paint, e1.transform.zoom, void 0, w);
                                }
                            }
                        }
                    };
                    (function(e1, t, i, r) {
                        const n = e1.terrain ? e1.terrain.exaggeration() : 0, o = e1.transform.zoom;
                        for (const s of r){
                            const r = t.getTile(s).getBucket(i);
                            r && (e1.conflationActive && r.updateReplacement(s, e1.replacementSource), r.evaluateScale(e1, i), e1.terrain && n > 0 && r.elevationUpdate(e1.terrain, n, s, i.source), r.needsReEvaluation(e1, o, i) && r.evaluate(i));
                        }
                    })(e1, t, i, r), 1 === p ? _(!0, !0) : (_(!1, !0), _(!0, !1));
                }(e1, t, i, r), void l();
                const h = c.getModels(), u = [], d = e1.transform.getFreeCameraOptions().position, p = Du.scale([], [
                    d.x,
                    d.y,
                    d.z
                ], e1.transform.worldSize);
                Du.negate(p, p);
                const f = [], m = [];
                let _ = 0;
                for (const t of h){
                    const r = i.paint.get("model-rotation").constantOr(null), n = i.paint.get("model-scale").constantOr(null), o = i.paint.get("model-translation").constantOr(null);
                    t.computeModelMatrix(e1, r, n, o, !0, !0, !1);
                    const s = Au.identity([]), a = op(t.position.lat, e1.transform.zoom), l = Au.fromScaling([], [
                        1,
                        1,
                        1 / a
                    ]);
                    Au.translate(s, s, p), u.push({
                        zScaleMatrix: l,
                        negCameraPosMatrix: s
                    });
                    for (const i of t.nodes)IA(e1.transform, i, t.matrix, e1.transform.expandedFarZProjMatrix, _, f, m);
                    _++;
                }
                if (f.sort((e1, t)=>t.depth - e1.depth), "shadow" !== e1.renderPass) {
                    if (1 === n) for (const t of m)SA(t, e1, i, u[t.modelIndex], Sx.disabled, e1.colorModeForRenderPass());
                    else {
                        for (const t of m)SA(t, e1, i, u[t.modelIndex], Sx.disabled, Cx.disabled);
                        for (const t of m)SA(t, e1, i, u[t.modelIndex], e1.stencilModeFor3D(), e1.colorModeForRenderPass());
                        e1.resetStencilClippingMasks();
                    }
                    for (const t of f)SA(t, e1, i, u[t.modelIndex], Sx.disabled, e1.colorModeForRenderPass());
                    l();
                } else {
                    for (const t of m)CA(t.mesh, t.nodeModelMatrix, e1, i);
                    for (const t of f)CA(t.mesh, t.nodeModelMatrix, e1, i);
                    l();
                }
            }
        }, NA = {
            modelUpload: function(e1, t, i) {
                const r = t.getSource();
                if (!r.loaded()) return;
                if ("vector" === r.type || "geojson" === r.type) return void (e1.modelManager && e1.modelManager.upload(e1, i));
                if ("batched-model" === r.type) return;
                const n = r.getModels();
                for (const t of n)t.upload(e1.context);
            }
        };
        class UA {
            constructor(e1, t, i){
                this.context = new Rx(e1, t), this.transform = i, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.setup(), this.numSublayers = Lx.maxUnderzooming + Lx.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new Xv, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new qA(this), this._wireframeDebugCache = new BA, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0;
            }
            updateTerrain(e1, t) {
                const i = !!e1 && !!e1.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new uM(this, e1));
                const r = this._terrain;
                this.transform.elevation = i ? r : null, r.update(e1, this.transform, t), this.transform.elevation && !r.enabled && (this.transform.elevation = null);
            }
            _updateFog(e1) {
                const t = e1.fog;
                if (!t || "globe" === this.transform.projection.name || t.getOpacity(this.transform.pitch) < 1 || t.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, r] = t.getFovAdjustedRange(this.transform._fov);
                if (i > r) return void (this.transform.fogCullDistSq = null);
                const n = i + .78 * (r - i);
                this.transform.fogCullDistSq = n * n;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled ? this._terrain : null;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(e1, t) {
                if (this.width = e1 * dt.devicePixelRatio, this.height = t * dt.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style.order)this.style._mergedLayers[e1].resize();
            }
            setup() {
                const e1 = this.context, i = new za;
                i.emplaceBack(0, 0), i.emplaceBack(cr, 0), i.emplaceBack(0, cr), i.emplaceBack(cr, cr), this.tileExtentBuffer = e1.createVertexBuffer(i, Nu.members), this.tileExtentSegments = xl.simpleSegment(0, 0, 4, 2);
                const r = new za;
                r.emplaceBack(0, 0), r.emplaceBack(cr, 0), r.emplaceBack(0, cr), r.emplaceBack(cr, cr), this.debugBuffer = e1.createVertexBuffer(r, Nu.members), this.debugSegments = xl.simpleSegment(0, 0, 4, 5);
                const n = new za;
                n.emplaceBack(-1, -1), n.emplaceBack(1, -1), n.emplaceBack(-1, 1), n.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(n, Nu.members), this.viewportSegments = xl.simpleSegment(0, 0, 4, 2);
                const o = new Da;
                o.emplaceBack(0, 0, 0, 0), o.emplaceBack(cr, 0, cr, 0), o.emplaceBack(0, cr, 0, cr), o.emplaceBack(cr, cr, cr, cr), this.mercatorBoundsBuffer = e1.createVertexBuffer(o, Ly.members), this.mercatorBoundsSegments = xl.simpleSegment(0, 0, 4, 2);
                const s = new Wa;
                s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s);
                const a = new el;
                for (const e1 of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e1);
                this.debugIndexBuffer = e1.createIndexBuffer(a), this.emptyTexture = new My(e1, new ef({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), e1.gl.RGBA), this.identityMat = Au.create();
                const l = this.context.gl;
                this.stencilClearMode = new Sx({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(t.performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e1) {
                return e1._makeTileBoundsBuffers(this.context, this.transform.projection), e1._tileBoundsBuffer ? {
                    tileBoundsBuffer: e1._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e1._tileBoundsIndexBuffer,
                    tileBoundsSegments: e1._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const e1 = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e1.TRIANGLES, Mx.disabled, this.stencilClearMode, Cx.disabled, Dx.disabled, sM(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e1, t, i) {
                if (!t || this.currentStencilSource === t.id || !e1.isTileClipped() || !i || 0 === i.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e1 = !1;
                    for (const t of i)if (void 0 === this._tileClippingMaskIDs[t.key]) {
                        e1 = !0;
                        break;
                    }
                    if (!e1) return;
                }
                this.currentStencilSource = t.id;
                const r = this.context, n = r.gl;
                this.nextStencilID + i.length > 256 && this.clearStencil(), r.setColorMode(Cx.disabled), r.setDepthMode(Mx.disabled);
                const o = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const e1 of i){
                    const i = t.getTile(e1), r = this._tileClippingMaskIDs[e1.key] = this.nextStencilID++, { tileBoundsBuffer: s, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = this.getTileBoundsBuffers(i);
                    o.draw(this, n.TRIANGLES, Mx.disabled, new Sx({
                        func: n.ALWAYS,
                        mask: 0
                    }, r, 255, n.KEEP, n.KEEP, n.REPLACE), Cx.disabled, Dx.disabled, sM(e1.projMatrix), "$clipping", s, a, l);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e1 = this.nextStencilID++, t = this.context.gl;
                return new Sx({
                    func: t.NOTEQUAL,
                    mask: 255
                }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
            }
            stencilModeForClipping(e1) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e1);
                const t = this.context.gl;
                return new Sx({
                    func: t.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
            }
            stencilConfigForOverlap(e1) {
                const t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = i[i.length - 1].overscaledZ, n = i[0].overscaledZ - r + 1;
                if (n > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + n > 256 && this.clearStencil();
                    const e1 = {};
                    for(let i = 0; i < n; i++)e1[i + r] = new Sx({
                        func: t.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID += n, [
                        e1,
                        i
                    ];
                }
                return [
                    {
                        [r]: Sx.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const t = 1 / 8;
                    return new Cx([
                        e1.CONSTANT_COLOR,
                        e1.ONE,
                        e1.CONSTANT_COLOR,
                        e1.ONE
                    ], new hi(t, t, t, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Cx.unblended : Cx.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(e1) {
                const t = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new Cx([
                    t.ONE,
                    t.ONE_MINUS_SRC_ALPHA,
                    t.CONSTANT_ALPHA,
                    t.ONE_MINUS_SRC_ALPHA
                ], new hi(0, 0, 0, void 0 === e1 ? 0 : e1), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e1, t, i, r = !1) {
                if (!this.opaquePassEnabledForLayer() && !r) return Mx.disabled;
                const n = 1 - ((1 + this.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
                return new Mx(i || this.context.gl.LEQUAL, t, [
                    n,
                    n
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e1, i) {
                this._wireframeDebugCache.update(this.frameCounter), this.style = e1, this.options = i;
                const r = this.style._mergedLayers, n = this.style.order, o = n.map((e1)=>r[e1]), s = this.style._mergedSourceCaches;
                this.imageManager = e1.imageManager, this.modelManager = e1.modelManager, this.symbolFadeChange = e1.placement.symbolFadeChange(dt.now()), this.imageManager.beginFrame();
                let a = 0, l = !1;
                for(const e1 in s){
                    const t = s[e1];
                    t.used && (t.prepare(this.context), t.getSource().usedInConflation && ++a);
                }
                const c = {}, h = {}, u = {}, d = {}, p = {};
                for(const e1 in s){
                    const t = s[e1];
                    c[e1] = t.getVisibleCoordinates(), h[e1] = c[e1].slice().reverse(), u[e1] = t.getVisibleCoordinates(!0).reverse(), d[e1] = t.getShadowCasterCoordinates(), p[e1] = t.sortCoordinatesByDistance(c[e1]);
                }
                const f = (e1)=>{
                    const t = this.style.getLayerSourceCache(e1);
                    return t && t.used ? t.getSource() : null;
                };
                if (a) {
                    const e1 = [];
                    for (const t of o)this.layerUsedInConflation(t, f(t)) && e1.push(t);
                    if (e1 && e1.length > 1) {
                        const t = [];
                        for (const i of e1){
                            const e1 = this.style.getLayerSourceCache(i);
                            e1 && e1.used && e1.getSource().usedInConflation && t.push({
                                layer: i.fqid,
                                cache: e1
                            });
                        }
                        this.replacementSource.setSources(t), l = !0;
                    }
                }
                l || this.replacementSource.clear(), this.conflationActive = l, this.minCutoffZoom = 0, this.longestCutoffRange = 0;
                for (const e1 of o){
                    const t = e1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(t, this.longestCutoffRange), t > 0) {
                        const t = f(e1);
                        t && (this.minCutoffZoom = Math.max(t.minzoom, this.minCutoffZoom)), e1.minzoom && (this.minCutoffZoom = Math.max(e1.minzoom, this.minCutoffZoom));
                    }
                }
                this.opaquePassCutoff = 1 / 0;
                for(let e1 = 0; e1 < o.length; e1++)if (o[e1].is3D()) {
                    this.opaquePassCutoff = e1;
                    break;
                }
                const m = this.style && this.style.fog;
                m ? (this._fogVisible = 0 !== m.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = m.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(u), this.opaquePassCutoff = 0);
                const _ = this._shadowRenderer;
                if (_) {
                    _.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e1 in s)for (const t of c[e1]){
                        let e1 = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e1 = this.terrain.getMinMaxForTile(t) || e1), _.addShadowReceiver(t.toUnwrapped(), e1.min, e1.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new Gd(this.context));
                for (const t of o){
                    if (t.isHidden(this.transform.zoom)) continue;
                    const i = e1.getLayerSourceCache(t);
                    this.uploadLayer(this, t, i);
                }
                if (this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new EA), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), !Ye.has(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const t of o){
                    const i = e1.getLayerSourceCache(t);
                    if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
                    const r = i ? h[i.id] : void 0;
                    ("custom" === t.type || "raster" === t.type || t.isSky() || r && r.length) && this.renderLayer(this, i, t, r);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (o.length + 2) * this.numSublayers * this.depthEpsilon
                ];
                const g = this.terrain;
                g && (this.style.hasSymbolLayers() || this.style.hasCircleLayers()) && !this.transform.isOrthographic && g.drawDepth(), this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, d)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const y = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), x = (()=>{
                    if (i.showOverdrawInspector) return hi.black;
                    if (this.style.fog && this.transform.projection.supportsFog && !y) {
                        const e1 = this.style.fog.properties.get("color").toArray01();
                        return new hi(...e1);
                    }
                    if (this.style.fog && this.transform.projection.supportsFog && y) {
                        const e1 = this.style.fog.properties.get("space-color").toArray01();
                        return new hi(...e1);
                    }
                    return hi.transparent;
                })();
                if (this.context.clear({
                    color: x,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && y && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = n.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const t = o[this.currentLayer], i = e1.getLayerSourceCache(t);
                    if (t.isSky()) continue;
                    const r = i ? (t.is3D() ? p : h)[i.id] : void 0;
                    this._renderTileClippingMasks(t, i, r), this.renderLayer(this, i, t, r);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && y && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || Dd(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < n.length; this.currentLayer++){
                    const t = o[this.currentLayer], i = e1.getLayerSourceCache(t);
                    t.isSky() && this.renderLayer(this, i, t, i ? h[i.id] : void 0);
                }
                this.renderPass = "translucent", this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                let v = 0;
                for(_ && (v = _.getShadowCastingLayerCount()); this.currentLayer < n.length;){
                    const t = o[this.currentLayer], i = e1.getLayerSourceCache(t);
                    if (t.isSky()) {
                        ++this.currentLayer;
                        continue;
                    }
                    if (g && this.style.isLayerDraped(t)) {
                        if (t.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = g.renderBatch(this.currentLayer);
                        continue;
                    }
                    let r;
                    if (i && (r = ("symbol" === t.type ? u : t.is3D() ? p : h)[i.id]), this._renderTileClippingMasks(t, i, i ? c[i.id] : void 0), this.renderLayer(this, i, t, r), !g && _ && v > 0 && t.hasShadowPass() && 0 == --v && (_.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                        const t = this.currentLayer;
                        for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= t; this.currentLayer++){
                            const t = o[this.currentLayer];
                            if (!t.hasLightBeamPass()) continue;
                            const i = e1.getLayerSourceCache(t);
                            this.renderLayer(this, i, t, i ? h[i.id] : void 0);
                        }
                        this.currentLayer = t, this.renderPass = "translucent";
                    }
                    ++this.currentLayer;
                }
                if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let t = null;
                    o.forEach((i)=>{
                        const r = e1.getLayerSourceCache(i);
                        r && !i.isHidden(this.transform.zoom) && r.getVisibleCoordinates().length && (!t || t.getSource().maxzoom < r.getSource().maxzoom) && (t = r);
                    }), t && this.options.showTileBoundaries && FA.debug(this, t, t.getVisibleCoordinates());
                }
                this.options.showPadding && function(e1) {
                    const t = e1.transform.padding;
                    pA(e1, e1.transform.height - (t.top || 0), 3, aA), pA(e1, t.bottom || 0, 3, lA), fA(e1, t.left || 0, 3, cA), fA(e1, e1.transform.width - (t.right || 0), 3, hA);
                    const i = e1.transform.centerPoint;
                    !function(e1, t, i, r) {
                        mA(e1, t - 1, i - 10, 2, 20, r), mA(e1, t - 10, i - 1, 20, 2, r);
                    }(e1, i.x, e1.transform.height - i.y, uA);
                }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(t.performance.now()), this.saveCanvasCopy()), l || (this.conflationActive = !1);
            }
            uploadLayer(e1, t, i) {
                this.gpuTimingStart(t), (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes(t.type) || e1.terrain && "custom" === t.type) && NA[`${t.type}Upload`] && NA[`${t.type}Upload`](e1, i, t.scope), this.gpuTimingEnd();
            }
            renderLayer(e1, t, i, r) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || r && r.length) && (this.id = i.id, this.gpuTimingStart(i), (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes(i.type) || e1.terrain && "custom" === i.type) && FA[i.type](e1, t, i, r, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e1) {
                if (!this.options.gpuTiming) return;
                const t = this.context.extTimerQuery, i = this.context.gl;
                let r = this.gpuTimers[e1.id];
                r || (r = this.gpuTimers[e1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), r.calls++, i.beginQuery(t.TIME_ELAPSED_EXT, r.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e1 = this.context.extTimerQuery, t = this.context.gl, i = t.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t.beginQuery(e1.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e1 = this.gpuTimers;
                return this.gpuTimers = {}, e1;
            }
            collectDeferredRenderGpuQueries() {
                const e1 = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e1;
            }
            queryGpuTimers(e1) {
                const t = {};
                for(const i in e1){
                    const r = e1[i], n = this.context.extTimerQuery, o = n.getQueryParameter(r.query, this.context.gl.QUERY_RESULT) / 1e6;
                    n.deleteQueryEXT(r.query), t[i] = o;
                }
                return t;
            }
            queryGpuTimeDeferredRender(e1) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t = this.context.extTimerQuery, i = this.context.gl;
                let r = 0;
                for (const n of e1)r += t.getQueryParameter(n, i.QUERY_RESULT) / 1e6, t.deleteQueryEXT(n);
                return r;
            }
            translatePosMatrix(e1, t, i, r, n) {
                if (!i[0] && !i[1]) return e1;
                const o = n ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (o) {
                    const e1 = Math.sin(o), t = Math.cos(o);
                    i = [
                        i[0] * t - i[1] * e1,
                        i[0] * e1 + i[1] * t
                    ];
                }
                const s = [
                    n ? i[0] : rv(t, i[0], this.transform.zoom),
                    n ? i[1] : rv(t, i[1], this.transform.zoom),
                    0
                ], a = new Float32Array(16);
                return Au.translate(a, e1, s), a;
            }
            saveTileTexture(e1) {
                const t = e1.size[0], i = this._tileTextures[t];
                i ? i.push(e1) : this._tileTextures[t] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t = this._tileTextures[e1];
                return t && t.length > 0 ? t.pop() : null;
            }
            isPatternMissing(e1, t) {
                return null === e1 || void 0 !== e1 && !this.imageManager.getPattern(e1.toString(), t);
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e1, t, i) {
                const r = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, n = this.terrain && 0 === this.terrain.exaggeration(), o = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e1 || "terrainRaster" === e1 ? (o.push("LIGHTING_3D_MODE"), o.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : r || o.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass ? this._shadowMapDebug || o.push("DEPTH_TEXTURE") : this.shadowRenderer && (this.shadowRenderer.useNormalOffset ? o.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET") : o.push("RENDER_SHADOWS", "DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (o.push("TERRAIN"), this.linearFloatFilteringSupported() && o.push("TERRAIN_DEM_FLOAT_FORMAT"), n && o.push("ZERO_EXAGGERATION")), "globe" === this.transform.projection.name && o.push("GLOBE"), !this._fogVisible || r || void 0 !== t && !t || o.push("FOG", "FOG_DITHERING"), r && o.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && o.push("OVERDRAW_INSPECTOR"), o;
            }
            getOrCreateProgram(e1, t) {
                this.cache = this.cache || {};
                const i = t && t.defines || [], r = t && t.config, n = this.currentGlobalDefines(e1, t && t.overrideFog, t && t.overrideRtt).concat(i), o = mM.cacheKey(GE[e1], e1, n, r);
                return this.cache[o] || (this.cache[o] = new mM(this.context, e1, GE[e1], r, GM[e1], n)), this.cache[o];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = t.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new My(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(e1, t) {
                if (this.style.enable3dLights()) {
                    const i = this.style.directionalLight, r = this.style.ambientLight;
                    if (i && r) {
                        const n = ((e1, t)=>{
                            const i = e1.properties.get("direction"), r = e1.properties.get("color").toArray01(), n = e1.properties.get("intensity"), o = t.properties.get("color").toArray01(), s = t.properties.get("intensity"), a = [
                                i.x,
                                i.y,
                                i.z
                            ], l = se(o, s), c = se(r, n);
                            return {
                                u_lighting_ambient_color: l,
                                u_lighting_directional_dir: a,
                                u_lighting_directional_color: c,
                                u_ground_radiance: dM(a, c, l)
                            };
                        })(i, r);
                        t.setLightsUniformValues(e1, n);
                    }
                }
            }
            uploadCommonUniforms(e1, t, i, r, n) {
                if (this.uploadCommonLightUniforms(e1, t), this.terrain && this.terrain.renderingToTexture) return;
                const o = this.style.fog;
                if (o) {
                    const n = o.getOpacity(this.transform.pitch), s = ((e1, t, i, r, n, o, s, a, l, c, h, u)=>{
                        const d = e1.transform, p = t.properties.get("color").toArray01();
                        p[3] = r;
                        const f = e1.frameCounter / 1e3 % 1, [m, _] = t.properties.get("vertical-range");
                        return {
                            u_fog_matrix: i ? d.calculateFogTileMatrix(i) : u || e1.identityMat,
                            u_fog_range: t.getFovAdjustedRange(d._fov),
                            u_fog_color: p,
                            u_fog_horizon_blend: t.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(m, _),
                                _
                            ],
                            u_fog_temporal_offset: f,
                            u_frustum_tl: n,
                            u_frustum_tr: o,
                            u_frustum_br: s,
                            u_frustum_bl: a,
                            u_globe_pos: l,
                            u_globe_radius: c,
                            u_viewport: h,
                            u_globe_transition: Dd(d.zoom),
                            u_is_globe: +("globe" === d.projection.name)
                        };
                    })(this, o, i, n, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * dt.devicePixelRatio,
                        this.transform.height * dt.devicePixelRatio
                    ], r);
                    t.setFogUniformValues(e1, s);
                }
                n && t.setCutoffUniformValues(e1, n.uniformValues);
            }
            setTileLoadedFlag(e1) {
                this.tileLoaded = e1;
            }
            saveCanvasCopy() {
                const e1 = this.canvasCopy();
                e1 && (this.frameCopies.push(e1), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e1 = this.context.gl, t = e1.createTexture();
                return e1.bindTexture(e1.TEXTURE_2D, t), e1.copyTexImage2D(e1.TEXTURE_2D, 0, e1.RGBA, 0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight, 0), t;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e1 = this.style && this.style.fog;
                return !!e1 && 0 !== e1.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e1 = this._backgroundTiles, t = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const r of i)t[r.key] = e1[r.key] || new Oy(r, 512, this.transform.tileZoom, this);
                return t;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            layerUsedInConflation(e1, t) {
                return !(!e1.is3D() || e1.minzoom && e1.minzoom > this.transform.zoom || "building" !== e1.sourceLayer && (!t || "batched-model" !== t.type));
            }
            isTileAffectedByFog(e1) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let t = this._cachedTileFogOpacities[e1.key];
                return t || (this._cachedTileFogOpacities[e1.key] = t = this.style.fog.getOpacityForTile(e1)), t[0] >= fw || t[1] >= fw;
            }
        }
        const VA = 2048;
        class jA {
            constructor(e1, t){
                this.aabb = e1, this.lastCascade = t;
            }
        }
        class GA {
            add(e1, t) {
                const i = this.receivers[e1.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t.max[2])) : this.receivers[e1.key] = new jA(t, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e1) {
                return this.receivers[e1.key];
            }
            computeRequiredCascades(e1, t, i) {
                const r = ed.fromPoints(e1.points);
                let n = 0;
                for(const e1 in this.receivers){
                    const o = this.receivers[e1];
                    if (!o) continue;
                    if (!r.intersectsAabb(o.aabb)) continue;
                    o.aabb.min = r.closestPoint(o.aabb.min), o.aabb.max = r.closestPoint(o.aabb.max);
                    const s = o.aabb.getCorners();
                    for(let e1 = 0; e1 < i.length; e1++){
                        let r = !0;
                        for (const n of s){
                            const o = [
                                n[0] * t,
                                n[1] * t,
                                n[2]
                            ];
                            if (Du.transformMat4(o, o, i[e1].matrix), o[0] < -1 || o[0] > 1 || o[1] < -1 || o[1] > 1) {
                                r = !1;
                                break;
                            }
                        }
                        if (o.lastCascade = e1, n = Math.max(n, e1), r) break;
                    }
                }
                return n + 1;
            }
        }
        class qA {
            constructor(e1){
                this.painter = e1, this._enabled = !1, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new GA, this._depthMode = new Mx(e1.context.gl.LEQUAL, Mx.ReadWrite, [
                    0,
                    1
                ]), this._uniformValues = {
                    u_light_matrix_0: new Float32Array(16),
                    u_light_matrix_1: new Float32Array(16),
                    u_shadow_intensity: 0,
                    u_fade_range: [
                        0,
                        0
                    ],
                    u_shadow_normal_offset: [
                        1,
                        1,
                        1
                    ],
                    u_shadow_texel_size: 1,
                    u_shadow_map_resolution: 1,
                    u_shadow_direction: [
                        0,
                        0,
                        1
                    ],
                    u_shadow_bias: [
                        36e-5,
                        .0012,
                        .012
                    ],
                    u_shadowmap_0: 0,
                    u_shadowmap_1: 0
                }, this.useNormalOffset = !1;
            }
            destroy() {
                for (const e1 of this._cascades)e1.texture.destroy(), e1.framebuffer.destroy();
                this._cascades = [];
            }
            updateShadowParameters(e1, t) {
                const i = this.painter;
                if (this._enabled = !1, this._shadowLayerCount = 0, this._receivers.clear(), !t || !t.properties) return;
                const r = t.properties.get("shadow-intensity");
                if (!t.shadowsEnabled() || r <= 0) return;
                if (this._shadowLayerCount = i.style.order.reduce((t, r)=>{
                    const n = i.style._mergedLayers[r];
                    return t + (n.hasShadowPass() && !n.isHidden(e1.zoom) ? 1 : 0);
                }, 0), this._enabled = this._shadowLayerCount > 0, !this._enabled) return;
                const n = i.context, o = VA, s = VA;
                if (0 === this._cascades.length) for(let e1 = 0; e1 < 2; ++e1){
                    const e1 = i._shadowMapDebug, t = n.gl, r = n.createFramebuffer(o, s, e1, "texture"), a = new My(n, {
                        width: o,
                        height: s,
                        data: null
                    }, t.DEPTH_COMPONENT);
                    if (r.depthAttachment.set(a.texture), e1) {
                        const e1 = new My(n, {
                            width: o,
                            height: s,
                            data: null
                        }, t.RGBA);
                        r.colorAttachment.set(e1.texture);
                    }
                    this._cascades.push({
                        framebuffer: r,
                        texture: a,
                        matrix: [],
                        far: 0,
                        boundingSphereRadius: 0,
                        frustum: new Qu,
                        scale: 0
                    });
                }
                this.shadowDirection = $A(t);
                let a = 0;
                if (e1.elevation) {
                    const t = e1.elevation, i = [
                        1e4,
                        -10000
                    ];
                    t.visibleDemTiles.filter((e1)=>e1.dem).forEach((e1)=>{
                        const t = e1.dem.tree;
                        i[0] = Math.min(i[0], t.minimums[0]), i[1] = Math.max(i[1], t.maximums[0]);
                    }), 1e4 !== i[0] && (a = (i[1] - i[0]) * t.exaggeration());
                }
                const l = 1.5 * e1.cameraToCenterDistance, c = 3 * l, h = new Float64Array(16);
                for(let t = 0; t < 2; ++t){
                    const i = this._cascades[t];
                    let r = e1.height / 50, n = 1;
                    0 === t ? n = l : (r = l, n = c);
                    const [o, s] = HA(e1, this.shadowDirection, r, n, VA, a);
                    i.scale = e1.scale, i.matrix = o, i.boundingSphereRadius = s, Au.invert(h, i.matrix), i.frustum = Qu.fromInvProjectionMatrix(h, 1, 0, !0), i.far = n;
                }
                this._uniformValues.u_fade_range = [
                    .75 * this._cascades[1].far,
                    this._cascades[1].far
                ], this._uniformValues.u_shadow_intensity = r, this._uniformValues.u_shadow_direction = [
                    this.shadowDirection[0],
                    this.shadowDirection[1],
                    this.shadowDirection[2]
                ], this._uniformValues.u_shadow_texel_size = .00048828125, this._uniformValues.u_shadow_map_resolution = VA, this._uniformValues.u_shadowmap_0 = NM.ShadowMap0, this._uniformValues.u_shadowmap_1 = NM.ShadowMap0 + 1, this._groundShadowTiles = i.transform.coveringTiles({
                    tileSize: 512,
                    renderWorldCopies: !0
                });
                const u = i.transform.elevation;
                for (const e1 of this._groundShadowTiles){
                    let t = {
                        min: 0,
                        max: 0
                    };
                    if (u) {
                        const i = u.getMinMaxForTile(e1);
                        i && (t = i);
                    }
                    this.addShadowReceiver(e1.toUnwrapped(), t.min, t.max);
                }
            }
            get enabled() {
                return this._enabled;
            }
            set enabled(e1) {
                this._enabled = e1;
            }
            drawShadowPass(e1, t) {
                if (!this._enabled) return;
                const i = this.painter, r = i.context;
                this._numCascadesToRender = this._receivers.computeRequiredCascades(i.transform.getFrustum(0), i.transform.worldSize, this._cascades), r.viewport.set([
                    0,
                    0,
                    VA,
                    VA
                ]);
                for(let n = 0; n < this._numCascadesToRender; ++n){
                    i.currentShadowCascade = n, r.bindFramebuffer.set(this._cascades[n].framebuffer.framebuffer), r.clear({
                        color: hi.white,
                        depth: 1
                    });
                    for (const r of e1.order){
                        const n = e1._mergedLayers[r];
                        if (!n.hasShadowPass() || n.isHidden(i.transform.zoom)) continue;
                        const o = e1.getLayerSourceCache(n), s = o ? t[o.id] : void 0;
                        ("model" === n.type || s && s.length) && i.renderLayer(i, o, n, s);
                    }
                }
                i.currentShadowCascade = 0;
            }
            drawGroundShadows() {
                if (!this._enabled) return;
                const e1 = this.painter, t = e1.style, i = e1.context, r = t.directionalLight, n = t.ambientLight;
                if (!r || !n) return;
                const o = [], s = eM(e1, e1.longestCutoffRange);
                s.shouldRenderCutoff && o.push("RENDER_CUTOFF");
                const a = WA(r, n), l = new Mx(i.gl.LEQUAL, Mx.ReadOnly, e1.depthRangeFor3D);
                for (const t of this._groundShadowTiles){
                    const r = t.toUnwrapped(), n = e1.isTileAffectedByFog(t), c = e1.getOrCreateProgram("groundShadow", {
                        defines: o,
                        overrideFog: n
                    });
                    this.setupShadows(r, c), e1.uploadCommonUniforms(i, c, r, null, s);
                    const h = {
                        u_matrix: e1.transform.calculateProjMatrix(r),
                        u_ground_shadow_factor: a
                    };
                    c.draw(e1, i.gl.TRIANGLES, l, Sx.disabled, Cx.multiply, Dx.disabled, h, "ground_shadow", e1.tileExtentBuffer, e1.quadTriangleIndexBuffer, e1.tileExtentSegments, {}, e1.transform.zoom, null, null);
                }
            }
            getShadowPassColorMode() {
                return this.painter._shadowMapDebug ? Cx.unblended : Cx.disabled;
            }
            getShadowPassDepthMode() {
                return this._depthMode;
            }
            getShadowCastingLayerCount() {
                return this._shadowLayerCount;
            }
            calculateShadowPassMatrixFromTile(e1) {
                const t = this.painter.transform, i = t.calculatePosMatrix(e1, t.worldSize);
                return Au.multiply(i, this._cascades[this.painter.currentShadowCascade].matrix, i), Float32Array.from(i);
            }
            calculateShadowPassMatrixFromMatrix(e1) {
                return Au.multiply(e1, this._cascades[this.painter.currentShadowCascade].matrix, e1), Float32Array.from(e1);
            }
            setupShadows(e1, t, i, r = 0) {
                if (!this._enabled) return;
                const n = this.painter.transform, o = this.painter.context, s = o.gl, a = this._uniformValues, l = new Float64Array(16), c = n.calculatePosMatrix(e1, n.worldSize);
                for(let e1 = 0; e1 < 2; e1++)Au.multiply(l, this._cascades[e1].matrix, c), a[0 === e1 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(l), o.activeTexture.set(s.TEXTURE0 + NM.ShadowMap0 + e1), this._cascades[e1].texture.bind(s.NEAREST, s.CLAMP_TO_EDGE);
                if (this.useNormalOffset = !!i, this.useNormalOffset) {
                    const t = ap(e1.canonical), o = 2 / n.tileSize * cr / VA, s = o * this._cascades[0].boundingSphereRadius, l = o * this._cascades[1].boundingSphereRadius, c = ("vector-tile" === i ? 1 : 3) / Math.pow(2, r - e1.canonical.z - (1 - n.zoom + Math.floor(n.zoom)));
                    a.u_shadow_normal_offset = [
                        t,
                        s * c,
                        l * c
                    ], a.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else a.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                t.setShadowUniformValues(o, a);
            }
            setupShadowsFromMatrix(e1, t, i = !1) {
                if (!this._enabled) return;
                const r = this.painter.context, n = r.gl, o = this._uniformValues, s = new Float64Array(16);
                for(let t = 0; t < 2; t++)Au.multiply(s, this._cascades[t].matrix, e1), o[0 === t ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(s), r.activeTexture.set(n.TEXTURE0 + NM.ShadowMap0 + t), this._cascades[t].texture.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                if (this.useNormalOffset = i, i) {
                    const e1 = 5;
                    o.u_shadow_normal_offset = [
                        1,
                        e1,
                        e1
                    ], o.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else o.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                t.setShadowUniformValues(r, o);
            }
            getShadowUniformValues() {
                return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
                return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(e1, t, i, r) {
                if (r[2] >= 0) return {};
                const n = (function(e1, t, i) {
                    const r = i / (1 << e1.canonical.z);
                    return new ed([
                        e1.canonical.x * r + e1.wrap * i,
                        e1.canonical.y * r + e1.wrap * i,
                        0
                    ], [
                        (e1.canonical.x + 1) * r + e1.wrap * i,
                        (e1.canonical.y + 1) * r + e1.wrap * i,
                        t
                    ]);
                })(e1, t, i).getCorners(), o = t / -r[2];
                r[0] < 0 ? (Du.add(n[0], n[0], [
                    r[0] * o,
                    0,
                    0
                ]), Du.add(n[3], n[3], [
                    r[0] * o,
                    0,
                    0
                ])) : r[0] > 0 && (Du.add(n[1], n[1], [
                    r[0] * o,
                    0,
                    0
                ]), Du.add(n[2], n[2], [
                    r[0] * o,
                    0,
                    0
                ])), r[1] < 0 ? (Du.add(n[0], n[0], [
                    0,
                    r[1] * o,
                    0
                ]), Du.add(n[1], n[1], [
                    0,
                    r[1] * o,
                    0
                ])) : r[1] > 0 && (Du.add(n[2], n[2], [
                    0,
                    r[1] * o,
                    0
                ]), Du.add(n[3], n[3], [
                    0,
                    r[1] * o,
                    0
                ]));
                const s = {};
                return s.vertices = n, s.planes = [
                    ZA(n[1], n[0], n[4]),
                    ZA(n[2], n[1], n[5]),
                    ZA(n[3], n[2], n[6]),
                    ZA(n[0], n[3], n[7])
                ], s;
            }
            addShadowReceiver(e1, t, i) {
                this._receivers.add(e1, ed.fromTileIdAndHeight(e1, t, i));
            }
            getMaxCascadeForTile(e1) {
                const t = this._receivers.get(e1);
                return t && t.lastCascade ? t.lastCascade : 0;
            }
        }
        function ZA(e1, t, i) {
            const r = Du.sub([], i, t), n = Du.sub([], e1, t), o = Du.cross([], r, n), s = Du.length(o);
            return 0 === s ? [
                0,
                0,
                1,
                0
            ] : (Du.scale(o, o, 1 / s), [
                o[0],
                o[1],
                o[2],
                -Du.dot(o, t)
            ]);
        }
        function $A(e1) {
            const t = e1.properties.get("direction"), i = J(t.x, t.y, t.z);
            i[2] = z(i[2], 0, 75);
            const r = K([
                i[0],
                i[1],
                i[2]
            ]);
            return Du.fromValues(r.x, r.y, r.z);
        }
        function WA(e1, t) {
            const i = e1.properties.get("color"), r = e1.properties.get("intensity"), n = e1.properties.get("direction"), o = [
                n.x,
                n.y,
                n.z
            ], s = t.properties.get("color"), a = t.properties.get("intensity"), l = Math.max(Du.dot([
                0,
                0,
                1
            ], o), 0), c = [
                0,
                0,
                0
            ];
            Du.scale(c, s.toArray01Linear().slice(0, 3), a);
            const h = [
                0,
                0,
                0
            ];
            return Du.scale(h, i.toArray01Linear().slice(0, 3), l * r), ae([
                c[0] > 0 ? c[0] / (c[0] + h[0]) : 0,
                c[1] > 0 ? c[1] / (c[1] + h[1]) : 0,
                c[2] > 0 ? c[2] / (c[2] + h[2]) : 0
            ]);
        }
        function HA(e1, t, i, r, n, o) {
            const s = e1.zoom, a = e1.scale, l = e1.worldSize, c = 1 / l, h = e1.aspect, u = Math.sqrt(1 + h * h) * Math.tan(.5 * e1.fovX), d = u * u, p = r - i, f = r + i;
            let m, _;
            d > p / f ? (m = r, _ = r * u) : (m = .5 * f * (1 + d), _ = .5 * Math.sqrt(p * p + 2 * (r * r + i * i) * d + f * f * d * d));
            const g = e1.projection.pixelsPerMeter(e1.center.lat, l), y = e1._camera.getCameraToWorldMercator(), x = [
                0,
                0,
                -m * c
            ];
            Du.transformMat4(x, x, y);
            let v = _ * c;
            const b = e1._edgeInsets;
            if (!(0 === b.left && 0 === b.top && 0 === b.right && 0 === b.bottom || b.left === b.right && b.top === b.bottom)) {
                const t = e1._camera.getWorldToCamera(e1.worldSize, "meters" === e1.projection.zAxisUnit ? g : 1), n = e1._camera.getCameraToClipPerspective(e1._fov, e1.width / e1.height, i, r);
                n[8] = 2 * -e1.centerOffset.x / e1.width, n[9] = 2 * e1.centerOffset.y / e1.height;
                const o = new Float64Array(16);
                Au.mul(o, n, t);
                const c = new Float64Array(16);
                Au.invert(c, o);
                const h = Qu.fromInvProjectionMatrix(c, l, s, !0);
                for (const t of h.points){
                    const i = ((w = t)[0] /= a, w[1] /= a, w[2] = Qd(w[2], e1._center.lat), w);
                    v = Math.max(v, Du.len(Du.subtract([], x, i)));
                }
            }
            var w;
            v *= n / (n - 1);
            const T = Math.acos(t[2]), E = Math.atan2(-t[0], -t[1]), M = new Yx;
            M.position = x, M.setPitchBearing(T, E);
            const A = M.getWorldToCamera(l, g), S = v * l, I = Math.min(e1._mercatorZfromZoom(17) * l * -2, -2 * S), C = M.getCameraToClipOrthographic(-S, S, -S, S, I, (S + o * g) / t[2]), z = new Float64Array(16);
            Au.multiply(z, C, A);
            const P = Du.fromValues(Math.floor(1e6 * x[0]) / 1e6 * l, Math.floor(1e6 * x[1]) / 1e6 * l, 0), D = .5 * n, R = [
                0,
                0,
                0
            ];
            Du.transformMat4(R, P, z), Du.scale(R, R, D);
            const L = [
                Math.floor(R[0]),
                Math.floor(R[1]),
                Math.floor(R[2])
            ], k = [
                0,
                0,
                0
            ];
            Du.sub(k, R, L), Du.scale(k, k, -1 / D);
            const O = new Float64Array(16);
            return Au.identity(O), Au.translate(O, O, k), Au.multiply(z, O, z), [
                z,
                S
            ];
        }
        class XA extends zt {
            constructor(e1){
                super(), this.requestManager = e1, this.models = {
                    "": {}
                }, this.numModelsLoading = {};
            }
            loadModel(e1, t) {
                return fT(this.requestManager.transformRequest(t, ye.Model).url).then((t)=>{
                    if (!t) return;
                    const i = TT(t), r = new Cv(e1, void 0, void 0, i);
                    return r.computeBoundsAndApplyParent(), r;
                }).catch((i)=>{
                    this.fire(new Ct(new Error(`Could not load model ${e1} from ${t}: ${i.message}`)));
                });
            }
            load(e1, t) {
                this.models[t] || (this.models[t] = {});
                const i = Object.keys(e1);
                this.numModelsLoading[t] = (this.numModelsLoading[t] || 0) + i.length;
                const r = [];
                for (const t of i)r.push(this.loadModel(t, e1[t]));
                Promise.allSettled(r).then((e1)=>{
                    for(let r = 0; r < e1.length; r++){
                        const { status: n, value: o } = e1[r];
                        "fulfilled" === n && o && (this.models[t][i[r]] = o);
                    }
                    this.numModelsLoading[t] -= i.length, this.fire(new It("data", {
                        dataType: "style"
                    }));
                }).catch((e1)=>{
                    this.fire(new Ct(new Error(`Could not load models: ${e1.message}`)));
                });
            }
            isLoaded() {
                for(const e1 in this.numModelsLoading)if (this.numModelsLoading[e1] > 0) return !1;
                return !0;
            }
            hasModel(e1, t) {
                return !!this.getModel(e1, t);
            }
            getModel(e1, t) {
                return this.models[t] || (this.models[t] = {}), this.models[t][e1];
            }
            addModel(e1, t, i) {
                this.models[i] || (this.models[i] = {}), this.hasModel(e1, i) && this.removeModel(e1, i), this.load({
                    [e1]: this.requestManager.normalizeModelURL(t)
                }, i);
            }
            addModels(e1, t) {
                const i = {};
                for(const t in e1)i[t] = this.requestManager.normalizeModelURL(e1[t]);
                this.load(i, t);
            }
            removeModel(e1, t) {
                this.models[t] || (this.models[t] = {});
                const i = this.models[t][e1];
                delete this.models[t][e1], i.destroy();
            }
            listModels(e1) {
                return this.models[e1] || (this.models[e1] = {}), Object.keys(this.models[e1]);
            }
            upload(e1, t) {
                this.models[t] || (this.models[t] = {});
                for(const i in this.models[t])this.models[t][i].upload(e1.context);
            }
        }
        const YA = (e1, t)=>Ss(e1, t && t.filter((e1)=>"source.canvas" !== e1.identifier)), KA = O(OT, [
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "setImportUrl",
            "setImportData",
            "setImportConfig"
        ]), JA = O(OT, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), QA = {
            version: 8,
            layers: [],
            sources: {}
        }, eS = {
            duration: 300,
            delay: 0
        }, tS = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class iS extends zt {
            constructor(e1, t = {}){
                super(), this.map = e1, this.scope = t.scope || "", this.fragments = [], this.importDepth = t.importDepth || 0, this.importsCache = t.importsCache || new Map, this.resolvedImports = t.resolvedImports || new Set, this.transition = k({}, eS), this._buildingIndex = new DT(this), this.crossTileSymbolIndex = new CE, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._changes = t.styleChanges || new Ea, this.dispatcher = t.dispatcher ? t.dispatcher : new Ew(Ww(), this), t.imageManager ? this.imageManager = t.imageManager : (this.imageManager = new aw, this.imageManager.setEventedParent(this)), this.imageManager.createScope(this.scope), this.glyphManager = t.glyphManager ? t.glyphManager : new og(e1._requestManager, t.localFontFamily ? 2 : t.localIdeographFontFamily ? 1 : 0, t.localFontFamily || t.localIdeographFontFamily), t.modelManager ? this.modelManager = t.modelManager : (this.modelManager = new XA(e1._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._serializedLayers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._order = [], this._markersNeedUpdate = !1, this.options = new Map, this._configDependentLayers = new Set, this._config = t.config, this.dispatcher.broadcast("setReferrer", ve());
                const i = this;
                this._rtlTextPluginCallback = iS.registerForPluginStateChange((e1)=>{
                    i.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e1.pluginStatus,
                        pluginURL: e1.pluginURL
                    }, (e1, t)=>{
                        if (Qs(e1), t && t.every((e1)=>e1)) for(const e1 in i._sourceCaches){
                            const t = i._sourceCaches[e1], r = t.getSource().type;
                            "vector" !== r && "geojson" !== r || t.reload();
                        }
                    });
                }), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t = this.getOwnSource(e1.sourceId);
                    if (t && t.vectorLayerIds) for(const e1 in this._layers){
                        const i = this._layers[e1];
                        i.source === t.id && this._validateLayer(i);
                    }
                });
            }
            loadURL(e1, t = {}) {
                this.fire(new It("dataloading", {
                    dataType: "style"
                }));
                const i = "boolean" == typeof t.validate ? t.validate : !Pe(e1);
                e1 = this.map._requestManager.normalizeStyleURL(e1, t.accessToken), this.resolvedImports.add(e1);
                const r = this.importsCache.get(e1);
                if (r) return this._load(r, i);
                const n = this.map._requestManager.transformRequest(e1, ye.Style);
                this._request = we(n, (t, r)=>{
                    if (this._request = null, t) this.fire(new Ct(t));
                    else if (r) return this.importsCache.set(e1, r), this._load(r, i);
                });
            }
            loadJSON(e1, t = {}) {
                this.fire(new It("dataloading", {
                    dataType: "style"
                })), this._request = dt.frame(()=>{
                    this._request = null, this._load(e1, !1 !== t.validate);
                });
            }
            loadEmpty() {
                this.fire(new It("dataloading", {
                    dataType: "style"
                })), this._load(QA, !1);
            }
            _loadImports(e1, t) {
                if (this.importDepth >= 4) return H("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const i = [];
                for (const r of e1){
                    const e1 = this._createFragmentStyle(r), n = new Promise((t)=>{
                        e1.once("style.import.load", t), e1.once("error", t);
                    }).then(()=>this.mergeAll());
                    if (i.push(n), this.resolvedImports.has(r.url)) {
                        e1.loadEmpty();
                        continue;
                    }
                    const o = r.data || this.importsCache.get(r.url);
                    o ? e1.loadJSON(o, {
                        validate: t
                    }) : r.url ? e1.loadURL(r.url, {
                        validate: t
                    }) : e1.loadEmpty(), this.fragments.push({
                        style: e1,
                        id: r.id,
                        config: r.config
                    });
                }
                return Promise.allSettled(i);
            }
            _createFragmentStyle(e1) {
                const t = this.scope ? va(e1.id, this.scope) : e1.id, i = new iS(this.map, {
                    scope: t,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: e1.config
                });
                return i.setEventedParent(this.map, {
                    style: i
                }), i;
            }
            _reloadImports() {
                this.mergeAll(), this._updateMapProjection(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                });
                const e1 = this.isRootStyle();
                this._shouldPrecompile = e1, this.fire(new It(e1 ? "style.load" : "style.import.load"));
            }
            _load(e1, t) {
                const i = e1.schema;
                if (this.isRootStyle() && (e1.fragment || i && !1 !== e1.fragment)) {
                    const i = k({}, QA, {
                        imports: [
                            {
                                id: "basemap",
                                data: e1,
                                url: ""
                            }
                        ]
                    });
                    return void this._load(i, t);
                }
                if (this.setConfig(this._config, i), t && YA(this, ms(e1))) return;
                this._loaded = !0, this.stylesheet = $(e1);
                for(const t in e1.sources)this.addSource(t, e1.sources[t], {
                    validate: !1,
                    isInitialLoad: !0
                });
                e1.sprite ? this._loadSprite(e1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                    scope: this.scope,
                    isLoaded: !0
                })), this.glyphManager.setURL(e1.glyphs, this.scope);
                const r = kT(this.stylesheet.layers);
                if (this._order = r.map((e1)=>e1.id), this.stylesheet.light && H("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                    if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                        const e1 = this.stylesheet.lights[0];
                        this.light = new cw(e1.properties, e1.id);
                    } else this.setLights(this.stylesheet.lights);
                }
                this.light || (this.light = new cw(this.stylesheet.light)), this._layers = {}, this._serializedLayers = {};
                for (const e1 of r){
                    const t = ow(e1, this.options);
                    t.setScope(this.scope), t.isConfigDependent && this._configDependentLayers.add(t.fqid), t.setEventedParent(this, {
                        layer: {
                            id: t.id
                        }
                    }), this._layers[t.id] = t, this._serializedLayers[t.id] = t.serialize();
                    const i = this.getOwnLayerSourceCache(t), r = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                    i && t.canCastShadows() && r && (i.castsShadows = !0);
                }
                this.stylesheet.models && this.modelManager.addModels(this.stylesheet.models, this.scope);
                const n = this.stylesheet.terrain;
                n && (void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = dt.hasCanvasFingerprintNoise()), this.disableElevatedTerrain ? H("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode).") : this.terrainSetForDrapingOnly() || this._createTerrain(n, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new It("data", {
                    dataType: "style"
                })), e1.imports ? this._loadImports(e1.imports, t).then(()=>this._reloadImports()) : this._reloadImports();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            mergeAll() {
                let e1, t, i, r, n, o, s, a;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((l)=>{
                    if (l.stylesheet) {
                        if (null != l.light && (e1 = l.light), l.stylesheet.lights) for (const e1 of l.stylesheet.lights)"ambient" === e1.type && null != l.ambientLight && (t = l.ambientLight), "directional" === e1.type && null != l.directionalLight && (i = l.directionalLight);
                        r = this._prioritizeTerrain(r, l.terrain, l.stylesheet.terrain), l.stylesheet.fog && null != l.fog && (n = l.fog), null != l.stylesheet.camera && (a = l.stylesheet.camera), null != l.stylesheet.projection && (o = l.stylesheet.projection), null != l.stylesheet.transition && (s = l.stylesheet.transition);
                    }
                }), this.light = e1, this.ambientLight = t, this.directionalLight = i, this.fog = n, null === r ? delete this.terrain : this.terrain = r, this.camera = a || {
                    "camera-projection": "perspective"
                }, this.projection = o || {
                    name: "mercator"
                }, this.transition = k({}, eS, s), this.mergeSources(), this.mergeLayers();
            }
            forEachFragmentStyle(e1) {
                const t = (i)=>{
                    for (const e1 of i.fragments)t(e1.style);
                    e1(i);
                };
                t(this);
            }
            _prioritizeTerrain(e1, t, i) {
                const r = e1 && 0 === e1.drapeRenderMode;
                return null === i ? t && 0 === t.drapeRenderMode ? t : r ? e1 : null : null != t && (!e1 || r || t && 1 === t.drapeRenderMode) ? t : e1;
            }
            mergeTerrain() {
                let e1;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t)=>{
                    e1 = this._prioritizeTerrain(e1, t.terrain, t.stylesheet.terrain);
                }), null === e1 ? delete this.terrain : this.terrain = e1;
            }
            mergeProjection() {
                let e1;
                this.forEachFragmentStyle((t)=>{
                    null != t.stylesheet.projection && (e1 = t.stylesheet.projection);
                }), this.projection = e1 || {
                    name: "mercator"
                };
            }
            mergeSources() {
                const e1 = {}, t = {}, i = {};
                this.forEachFragmentStyle((r)=>{
                    for(const t in r._sourceCaches){
                        const i = va(t, r.scope);
                        e1[i] = r._sourceCaches[t];
                    }
                    for(const e1 in r._otherSourceCaches){
                        const i = va(e1, r.scope);
                        t[i] = r._otherSourceCaches[e1];
                    }
                    for(const e1 in r._symbolSourceCaches){
                        const t = va(e1, r.scope);
                        i[t] = r._symbolSourceCaches[e1];
                    }
                }), this._mergedSourceCaches = e1, this._mergedOtherSourceCaches = t, this._mergedSymbolSourceCaches = i;
            }
            mergeLayers() {
                const e1 = {}, t = [], i = {};
                this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((i)=>{
                    for (const r of i._order){
                        const n = i._layers[r];
                        if ("slot" === n.type) {
                            const t = ba(r);
                            if (e1[t]) continue;
                            e1[t] = [];
                        }
                        n.slot && e1[n.slot] ? e1[n.slot].push(n) : t.push(n);
                    }
                }), this._mergedOrder = [];
                const r = (t = [])=>{
                    for (const n of t)if ("slot" === n.type) {
                        const t = ba(n.id);
                        e1[t] && r(e1[t]);
                    } else {
                        const e1 = va(n.id, n.scope);
                        this._mergedOrder.push(e1), i[e1] = n, n.is3D() && (this._has3DLayers = !0), "circle" === n.type && (this._hasCircleLayers = !0), "symbol" === n.type && (this._hasSymbolLayers = !0);
                    }
                };
                r(t), this._mergedLayers = i, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(e1) {
                return this.stylesheet.camera = k({}, this.stylesheet.camera, e1), this.camera = this.stylesheet.camera, this;
            }
            setProjection(e1) {
                e1 ? this.stylesheet.projection = e1 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? this.getTerrain() || this.stylesheet.terrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(e1) {
                this._spriteRequest = function(e1, t, i) {
                    let r, n, o;
                    const s = dt.devicePixelRatio > 1 ? "@2x" : "";
                    let a = we(t.transformRequest(t.normalizeSpriteURL(e1, s, ".json"), ye.SpriteJSON), (e1, t)=>{
                        a = null, o || (o = e1, r = t, c());
                    }), l = Ie(t.transformRequest(t.normalizeSpriteURL(e1, s, ".png"), ye.SpriteImage), (e1, t)=>{
                        l = null, o || (o = e1, n = t, c());
                    });
                    function c() {
                        if (o) i(o);
                        else if (r && n) {
                            const e1 = dt.getImageData(n), t = {};
                            for(const i in r){
                                const { width: n, height: o, x: s, y: a, sdf: l, pixelRatio: c, stretchX: h, stretchY: u, content: d } = r[i], p = new ef({
                                    width: n,
                                    height: o
                                });
                                ef.copy(e1, p, {
                                    x: s,
                                    y: a
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: n,
                                    height: o
                                }), t[i] = {
                                    data: p,
                                    pixelRatio: c,
                                    sdf: l,
                                    stretchX: h,
                                    stretchY: u,
                                    content: d
                                };
                            }
                            i(null, t);
                        }
                    }
                    return {
                        cancel () {
                            a && (a.cancel(), a = null), l && (l.cancel(), l = null);
                        }
                    };
                }(e1, this.map._requestManager, (e1, t)=>{
                    if (this._spriteRequest = null, e1) this.fire(new Ct(e1));
                    else if (t) for(const e1 in t)this.imageManager.addImage(e1, this.scope, t[e1]);
                    this.imageManager.setLoaded(!0, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                        scope: this.scope,
                        images: this._availableImages
                    }), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new It("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(e1) {
                const t = this.getOwnSource(e1.source);
                if (!t) return;
                const i = e1.sourceLayer;
                i && ("geojson" === t.type || t.vectorLayerIds && -1 === t.vectorLayerIds.indexOf(i)) && this.fire(new Ct(new Error(`Source layer "${i}" does not exist on source "${t.id}" as specified by style layer "${e1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e1 in this._sourceCaches)if (!this._sourceCaches[e1].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                for (const { style: e1 } of this.fragments)if (!e1.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e1, t)=>{
                    const i = this.fragments[t];
                    return i && i.style && (e1.data = i.style.serialize()), e1;
                });
            }
            _serializeSources() {
                const e1 = {};
                for(const t in this._sourceCaches){
                    const i = this._sourceCaches[t].getSource();
                    e1[i.id] || (e1[i.id] = i.serialize());
                }
                return e1;
            }
            _serializeLayers(e1) {
                const t = [];
                for (const i of e1){
                    const e1 = this._layers[i];
                    e1 && "custom" !== e1.type && t.push(e1.serialize());
                }
                return t;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                for(const e1 in this._sourceCaches)if (this._sourceCaches[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            isLayerDraped(e1) {
                return !!this.terrain && ("function" == typeof e1.isLayerDraped ? e1.isLayerDraped(this.getLayerSourceCache(e1)) : tS.has(e1.type));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(e1) {
                const t = this.getOwnLayer(e1);
                if (t) return t;
                this.fire(new Ct(new Error(`The layer '${e1}' does not exist in the map's style.`)));
            }
            _checkSource(e1) {
                const t = this.getOwnSource(e1);
                if (t) return t;
                this.fire(new Ct(new Error(`The source '${e1}' does not exist in the map's style.`)));
            }
            update(e1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(e1), this.directionalLight && this.directionalLight.recalculate(e1);
                const t = this.calculateLightsBrightness();
                e1.brightness = t || 0, t !== this._brightness && (this._brightness = t, this.dispatcher.broadcast("setBrightness", t));
                const i = this._changes.isDirty();
                if (this._changes.isDirty()) {
                    const t = this._changes.getLayerUpdatesByScope();
                    for(const e1 in t){
                        const { updatedIds: i, removedIds: r } = t[e1];
                        (i || r) && this._updateWorkerLayers(e1, i, r);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(e1), this.light && this.light.updateTransitions(e1), this.ambientLight && this.ambientLight.updateTransitions(e1), this.directionalLight && this.directionalLight.updateTransitions(e1), this.fog && this.fog.updateTransitions(e1), this._changes.reset();
                }
                const r = {};
                for(const e1 in this._mergedSourceCaches){
                    const t = this._mergedSourceCaches[e1];
                    r[e1] = t.used, t.used = !1;
                }
                for (const t of this._mergedOrder){
                    const i = this._mergedLayers[t];
                    if (i.recalculate(e1, this._availableImages), !i.isHidden(e1.zoom)) {
                        const e1 = this.getLayerSourceCache(i);
                        e1 && (e1.used = !0);
                    }
                    if (!this._precompileDone && this._shouldPrecompile) for(let t = i.minzoom || 0; t < (i.maxzoom || 25.5); t++){
                        const t = this.map.painter;
                        if (t) {
                            const r = i.getProgramIds();
                            if (!r) continue;
                            for (const n of r){
                                const r = i.getDefaultProgramParams(n, e1.zoom);
                                r && (t.style = this, this.fog && (t._fogVisible = !0, r.overrideFog = !0, t.getOrCreateProgram(n, r)), t._fogVisible = !1, r.overrideFog = !1, t.getOrCreateProgram(n, r), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (r.overrideRtt = !0, t.getOrCreateProgram(n, r)));
                            }
                        }
                    }
                }
                this._shouldPrecompile && (this._precompileDone = !0);
                for(const e1 in r){
                    const t = this._mergedSourceCaches[e1];
                    r[e1] !== t.used && t.getSource().fire(new It("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: t.getSource().id
                    }));
                }
                this.light && this.light.recalculate(e1), this.terrain && this.terrain.recalculate(e1), this.fog && this.fog.recalculate(e1), this.z = e1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), i && this.fire(new It("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e1 = this._changes.getUpdatedImages();
                if (e1.length) {
                    for(const t in this._sourceCaches)this._sourceCaches[t].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1);
                    this._changes.resetUpdatedImages();
                }
            }
            _updateWorkerLayers(e1, t, i) {
                const r = this.getFragmentStyle(e1);
                r && this.dispatcher.broadcast("updateLayers", {
                    layers: t ? r._serializeLayers(t) : [],
                    scope: e1,
                    removedIds: i || [],
                    options: r.options
                });
            }
            setState(e1) {
                if (this._checkLoaded(), YA(this, ms(e1))) return !1;
                (e1 = $(e1)).layers = kT(e1.layers);
                const t = (function(e1, t) {
                    if (!e1) return [
                        {
                            command: OT.setStyle,
                            args: [
                                t
                            ]
                        }
                    ];
                    let i = [];
                    try {
                        if (!x(e1.version, t.version)) return [
                            {
                                command: OT.setStyle,
                                args: [
                                    t
                                ]
                            }
                        ];
                        x(e1.center, t.center) || i.push({
                            command: OT.setCenter,
                            args: [
                                t.center
                            ]
                        }), x(e1.zoom, t.zoom) || i.push({
                            command: OT.setZoom,
                            args: [
                                t.zoom
                            ]
                        }), x(e1.bearing, t.bearing) || i.push({
                            command: OT.setBearing,
                            args: [
                                t.bearing
                            ]
                        }), x(e1.pitch, t.pitch) || i.push({
                            command: OT.setPitch,
                            args: [
                                t.pitch
                            ]
                        }), x(e1.sprite, t.sprite) || i.push({
                            command: OT.setSprite,
                            args: [
                                t.sprite
                            ]
                        }), x(e1.glyphs, t.glyphs) || i.push({
                            command: OT.setGlyphs,
                            args: [
                                t.glyphs
                            ]
                        }), x(e1.imports, t.imports) || function(e1 = [], t = [], i) {
                            t = t || [];
                            const r = (e1 = e1 || []).map(jT), n = t.map(jT), o = e1.reduce(GT, {}), s = t.reduce(GT, {}), a = r.slice();
                            let l, c, h, u;
                            for(l = 0, c = 0; l < r.length; l++)h = r[l], s.hasOwnProperty(h) ? c++ : (i.push({
                                command: OT.removeImport,
                                args: [
                                    h
                                ]
                            }), a.splice(a.indexOf(h, c), 1));
                            for(l = 0, c = 0; l < n.length; l++)h = n[n.length - 1 - l], a[a.length - 1 - l] !== h && (o.hasOwnProperty(h) ? (i.push({
                                command: OT.removeImport,
                                args: [
                                    h
                                ]
                            }), a.splice(a.lastIndexOf(h, a.length - c), 1)) : c++, u = a[a.length - l], i.push({
                                command: OT.addImport,
                                args: [
                                    s[h],
                                    u
                                ]
                            }), a.splice(a.length - l, 0, h));
                            for (const e1 of t){
                                const t = o[e1.id];
                                if (!t || x(t, e1)) continue;
                                x(t.config, e1.config) || i.push({
                                    command: OT.setImportConfig,
                                    args: [
                                        e1.id,
                                        e1.config
                                    ]
                                }), x(t.url, e1.url) || i.push({
                                    command: OT.setImportUrl,
                                    args: [
                                        e1.id,
                                        e1.url
                                    ]
                                });
                                const r = e1.data;
                                x(t && t.data, r) || i.push({
                                    command: OT.setImportData,
                                    args: [
                                        e1.id,
                                        r
                                    ]
                                });
                            }
                        }(e1.imports, t.imports, i), x(e1.transition, t.transition) || i.push({
                            command: OT.setTransition,
                            args: [
                                t.transition
                            ]
                        }), x(e1.light, t.light) || i.push({
                            command: OT.setLight,
                            args: [
                                t.light
                            ]
                        }), x(e1.fog, t.fog) || i.push({
                            command: OT.setFog,
                            args: [
                                t.fog
                            ]
                        }), x(e1.projection, t.projection) || i.push({
                            command: OT.setProjection,
                            args: [
                                t.projection
                            ]
                        }), x(e1.lights, t.lights) || i.push({
                            command: OT.setLights,
                            args: [
                                t.lights
                            ]
                        }), x(e1.camera, t.camera) || i.push({
                            command: OT.setCamera,
                            args: [
                                t.camera
                            ]
                        });
                        const r = {}, n = [];
                        !function(e1, t, i, r) {
                            let n;
                            for(n in t = t || {}, e1 = e1 || {})e1.hasOwnProperty(n) && (t.hasOwnProperty(n) || FT(n, i, r));
                            for(n in t){
                                if (!t.hasOwnProperty(n)) continue;
                                const o = t[n];
                                e1.hasOwnProperty(n) ? x(e1[n], o) || ("geojson" === e1[n].type && "geojson" === o.type && UT(e1, t, n) ? i.push({
                                    command: OT.setGeoJSONSourceData,
                                    args: [
                                        n,
                                        o.data
                                    ]
                                }) : NT(n, t, i, r)) : BT(n, t, i);
                            }
                        }(e1.sources, t.sources, n, r);
                        const o = [];
                        e1.layers && e1.layers.forEach((e1)=>{
                            e1.source && r[e1.source] ? i.push({
                                command: OT.removeLayer,
                                args: [
                                    e1.id
                                ]
                            }) : o.push(e1);
                        });
                        let s = e1.terrain;
                        s && r[s.source] && (i.push({
                            command: OT.setTerrain,
                            args: [
                                void 0
                            ]
                        }), s = void 0), i = i.concat(n), x(s, t.terrain) || i.push({
                            command: OT.setTerrain,
                            args: [
                                t.terrain
                            ]
                        }), function(e1, t, i) {
                            t = t || [];
                            const r = (e1 = e1 || []).map(jT), n = t.map(jT), o = e1.reduce(GT, {}), s = t.reduce(GT, {}), a = r.slice(), l = Object.create(null);
                            let c, h, u, d, p, f, m;
                            for(c = 0, h = 0; c < r.length; c++)u = r[c], s.hasOwnProperty(u) ? h++ : (i.push({
                                command: OT.removeLayer,
                                args: [
                                    u
                                ]
                            }), a.splice(a.indexOf(u, h), 1));
                            for(c = 0, h = 0; c < n.length; c++)u = n[n.length - 1 - c], a[a.length - 1 - c] !== u && (o.hasOwnProperty(u) ? (i.push({
                                command: OT.removeLayer,
                                args: [
                                    u
                                ]
                            }), a.splice(a.lastIndexOf(u, a.length - h), 1)) : h++, f = a[a.length - c], i.push({
                                command: OT.addLayer,
                                args: [
                                    s[u],
                                    f
                                ]
                            }), a.splice(a.length - c, 0, u), l[u] = !0);
                            for(c = 0; c < n.length; c++)if (u = n[c], d = o[u], p = s[u], !l[u] && !x(d, p)) {
                                if (x(d.source, p.source) && x(d["source-layer"], p["source-layer"]) && x(d.type, p.type)) {
                                    for(m in VT(d.layout, p.layout, i, u, null, OT.setLayoutProperty), VT(d.paint, p.paint, i, u, null, OT.setPaintProperty), x(d.slot, p.slot) || i.push({
                                        command: OT.setSlot,
                                        args: [
                                            u,
                                            p.slot
                                        ]
                                    }), x(d.filter, p.filter) || i.push({
                                        command: OT.setFilter,
                                        args: [
                                            u,
                                            p.filter
                                        ]
                                    }), x(d.minzoom, p.minzoom) && x(d.maxzoom, p.maxzoom) || i.push({
                                        command: OT.setLayerZoomRange,
                                        args: [
                                            u,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), d)d.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? VT(d[m], p[m], i, u, m.slice(6), OT.setPaintProperty) : x(d[m], p[m]) || i.push({
                                        command: OT.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                    for(m in p)p.hasOwnProperty(m) && !d.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? VT(d[m], p[m], i, u, m.slice(6), OT.setPaintProperty) : x(d[m], p[m]) || i.push({
                                        command: OT.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                } else i.push({
                                    command: OT.removeLayer,
                                    args: [
                                        u
                                    ]
                                }), f = a[a.lastIndexOf(u) + 1], i.push({
                                    command: OT.addLayer,
                                    args: [
                                        p,
                                        f
                                    ]
                                });
                            }
                        }(o, t.layers, i);
                    } catch (e1) {
                        console.warn("Unable to compute style diff:", e1), i = [
                            {
                                command: OT.setStyle,
                                args: [
                                    t
                                ]
                            }
                        ];
                    }
                    return i;
                })(this.serialize(), e1).filter((e1)=>!(e1.command in JA));
                if (0 === t.length) return !1;
                const i = t.filter((e1)=>!(e1.command in KA));
                if (i.length > 0) throw new Error(`Unimplemented: ${i.map((e1)=>e1.command).join(", ")}.`);
                return t.forEach((e1)=>{
                    this[e1.command].apply(this, e1.args);
                }), this.stylesheet = e1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            addImage(e1, t) {
                return this.getImage(e1) ? this.fire(new Ct(new Error("An image with this name already exists."))) : (this.imageManager.addImage(e1, this.scope, t), this._afterImageUpdated(e1), this);
            }
            updateImage(e1, t) {
                this.imageManager.updateImage(e1, this.scope, t);
            }
            getImage(e1) {
                return this.imageManager.getImage(e1, this.scope);
            }
            removeImage(e1) {
                return this.getImage(e1) ? (this.imageManager.removeImage(e1, this.scope), this._afterImageUpdated(e1), this) : this.fire(new Ct(new Error("No image with this name exists.")));
            }
            _afterImageUpdated(e1) {
                this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(e1), this.dispatcher.broadcast("setImages", {
                    scope: this.scope,
                    images: this._availableImages
                }), this.fire(new It("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            addModel(e1, t, i = {}) {
                return this._checkLoaded(), this._validate(Ms, `models.${e1}`, t, null, i) || (this.modelManager.addModel(e1, t, this.scope), this._changes.setDirty()), this;
            }
            hasModel(e1) {
                return this.modelManager.hasModel(e1, this.scope);
            }
            removeModel(e1) {
                return this.hasModel(e1) ? (this.modelManager.removeModel(e1, this.scope), this) : this.fire(new Ct(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.scope);
            }
            addSource(e1, t, i = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(e1)) throw new Error(`There is already a source with ID "${e1}".`);
                if (!t.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(t).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(t.type) >= 0 && this._validate(_s, `sources.${e1}`, t, null, i)) return;
                this.map && this.map._collectResourceTiming && (t.collectResourceTiming = !0);
                const r = ST(e1, t, this.dispatcher, this);
                r.scope = this.scope, r.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(r.id),
                        source: r.serialize(),
                        sourceId: r.id
                    }));
                const n = (e1)=>{
                    const t = (e1 ? "symbol:" : "other:") + r.id, i = va(t, this.scope), n = this._sourceCaches[t] = new Lx(i, r, e1);
                    (e1 ? this._symbolSourceCaches : this._otherSourceCaches)[r.id] = n, n.onAdd(this.map);
                };
                n(!1), "vector" !== t.type && "geojson" !== t.type || n(!0), r.onAdd && r.onAdd(this.map), i.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(e1) {
                this._checkLoaded();
                const t = this.getOwnSource(e1);
                if (!t) throw new Error("There is no source with this ID");
                for(const t in this._layers)if (this._layers[t].source === e1) return this.fire(new Ct(new Error(`Source "${e1}" cannot be removed while layer "${t}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === e1) return this.fire(new Ct(new Error(`Source "${e1}" cannot be removed while terrain is using it.`)));
                const i = this.getOwnSourceCaches(e1);
                for (const e1 of i){
                    const t = ba(e1.id);
                    delete this._sourceCaches[t], this._changes.discardSourceCacheUpdate(e1.id), e1.fire(new It("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: e1.getSource().id
                    })), e1.setEventedParent(null), e1.clearTiles();
                }
                return delete this._otherSourceCaches[e1], delete this._symbolSourceCaches[e1], this.mergeSources(), t.setEventedParent(null), t.onRemove && t.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e1, t) {
                this._checkLoaded(), this.getOwnSource(e1).setData(t), this._changes.setDirty();
            }
            getOwnSource(e1) {
                const t = this.getOwnSourceCache(e1);
                return t && t.getSource();
            }
            getOwnSources() {
                const e1 = [];
                for(const t in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t);
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            setLights(e1) {
                if (this._checkLoaded(), !e1) return delete this.ambientLight, void delete this.directionalLight;
                const t = this._getTransitionParameters();
                for (const i of e1){
                    if (this._validate(ys, "lights", i)) return;
                    switch(i.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const e1 = this.ambientLight;
                                e1.set(i), e1.updateTransitions(t);
                            } else this.ambientLight = new Mw(i, Aw, this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const e1 = this.directionalLight;
                                e1.set(i), e1.updateTransitions(t);
                            } else this.directionalLight = new Mw(i, Sw, this.scope, this.options);
                    }
                }
                const i = new oa(this.z || 0, t);
                this.ambientLight && this.ambientLight.recalculate(i), this.directionalLight && this.directionalLight.recalculate(i), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
                const e1 = this.directionalLight, t = this.ambientLight;
                if (!e1 || !t) return;
                const i = (e1)=>.2126 * (e1[0] <= .03928 ? e1[0] / 12.92 : Math.pow((e1[0] + .055) / 1.055, 2.4)) + .7152 * (e1[1] <= .03928 ? e1[1] / 12.92 : Math.pow((e1[1] + .055) / 1.055, 2.4)) + .0722 * (e1[2] <= .03928 ? e1[2] / 12.92 : Math.pow((e1[2] + .055) / 1.055, 2.4)), r = e1.properties.get("color").toArray01(), n = e1.properties.get("intensity"), o = e1.properties.get("direction"), s = 1 - J(o.x, o.y, o.z)[2] / 90, a = i(r) * n * s, l = t.properties.get("color").toArray01(), c = t.properties.get("intensity");
                return (a + i(l) * c) / 2;
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e1 = [];
                return this.directionalLight && e1.push(this.directionalLight.get()), this.ambientLight && e1.push(this.ambientLight.get()), e1;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(e1) {
                if (!e1) return this;
                if (xa(e1)) {
                    const t = function(e1) {
                        const t = e1.indexOf(ya);
                        return t >= 0 ? e1.slice(t + 1) : "";
                    }(e1), i = this.fragments.find(({ id: e1 })=>e1 === t);
                    if (!i) throw new Error(`Style import not found: ${e1}`);
                    const r = ba(e1);
                    return i.style.getFragmentStyle(r);
                }
                {
                    const t = this.fragments.find(({ id: t })=>t === e1);
                    if (!t) throw new Error(`Style import not found: ${e1}`);
                    return t.style;
                }
            }
            getConfigProperty(e1, t) {
                const i = this.getFragmentStyle(e1);
                if (!i) return null;
                const r = i.options.get(t), n = r ? r.value || r.default : null;
                return n ? n.serialize() : null;
            }
            setConfigProperty(e1, t, i) {
                const r = Eo(i);
                if ("success" !== r.result) return void YA(this, r.value);
                const n = r.value.expression, o = this.getFragmentStyle(e1);
                if (!o) return;
                const s = o.options.get(t);
                s && (o.options.set(t, {
                    ...s,
                    value: n
                }), o.updateConfigDependencies());
            }
            setConfig(e1, t) {
                if (this._config = e1, e1 || t) {
                    if (t) {
                        this.options.clear();
                        for(const i in t){
                            let r, n;
                            const o = Eo(t[i].default);
                            if ("success" === o.result && (r = o.value.expression), e1 && void 0 !== e1[i]) {
                                const t = Eo(e1[i]);
                                "success" === t.result && (n = t.value.expression);
                            }
                            const { minValue: s, maxValue: a, stepValue: l, type: c, values: h } = t[i];
                            r ? this.options.set(i, {
                                default: r,
                                value: n,
                                minValue: s,
                                maxValue: a,
                                stepValue: l,
                                type: c,
                                values: h
                            }) : this.fire(new Ct(new Error(`No schema defined for config option "${i}".`)));
                        }
                    } else this.fire(new Ct(new Error("Attempting to set config for a style without schema.")));
                }
            }
            updateConfigDependencies() {
                for (const e1 of this._configDependentLayers){
                    const t = this.getLayer(e1);
                    t && (t.possiblyEvaluateVisibility(), this._updateLayer(t));
                }
                this.ambientLight && this.ambientLight.scope === this.scope && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.scope === this.scope && this.directionalLight.updateConfig(this.options), this._changes.setDirty();
            }
            addLayer(e1, t, i = {}) {
                this._checkLoaded();
                const r = e1.id;
                if (this._layers[r]) return void this.fire(new Ct(new Error(`Layer with id "${r}" already exists on this map`)));
                let n;
                if ("custom" === e1.type) {
                    if (YA(this, function(e1) {
                        const t = [], i = e1.id;
                        return void 0 === i && t.push({
                            message: `layers.${i}: missing required property "id"`
                        }), void 0 === e1.render && t.push({
                            message: `layers.${i}: missing required method "render"`
                        }), e1.renderingMode && "2d" !== e1.renderingMode && "3d" !== e1.renderingMode && t.push({
                            message: `layers.${i}: property "renderingMode" must be either "2d" or "3d"`
                        }), t;
                    }(e1))) return;
                    n = ow(e1, this.options);
                } else {
                    if ("object" == typeof e1.source && (this.addSource(r, e1.source), e1 = k(e1 = $(e1), {
                        source: r
                    })), this._validate(bs, `layers.${r}`, e1, {
                        arrayIndex: -1
                    }, i)) return;
                    n = ow(e1, this.options), this._validateLayer(n), n.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    }), this._serializedLayers[n.id] = n.serialize();
                }
                n.isConfigDependent && this._configDependentLayers.add(n.fqid), n.setScope(this.scope);
                let o = this._order.length;
                if (t) {
                    const e1 = this._order.indexOf(t);
                    if (-1 === e1) return void this.fire(new Ct(new Error(`Layer with id "${t}" does not exist on this map.`)));
                    n.slot === this._layers[t].slot ? o = e1 : H(`Layer with id "${t}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(o, 0, r), this._layerOrderChanged = !0, this._layers[r] = n;
                const s = this.getOwnLayerSourceCache(n), a = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                s && n.canCastShadows() && a && (s.castsShadows = !0);
                const l = this._changes.getRemovedLayer(n);
                if (l && n.source && s && "custom" !== n.type) {
                    this._changes.discardLayerRemoval(n);
                    const e1 = va(n.source, n.scope);
                    l.type !== n.type ? this._changes.updateSourceCache(e1, "clear") : (this._changes.updateSourceCache(e1, "reload"), s.pause());
                }
                this._updateLayer(n), n.onAdd && n.onAdd(this.map), n.scope = this.scope, this.mergeLayers();
            }
            moveLayer(e1, t) {
                this._checkLoaded();
                const i = this._checkLayer(e1);
                if (!i) return;
                if (e1 === t) return;
                const r = this._order.indexOf(e1);
                this._order.splice(r, 1);
                let n = this._order.length;
                if (t) {
                    const e1 = this._order.indexOf(t);
                    if (-1 === e1) return void this.fire(new Ct(new Error(`Layer with id "${t}" does not exist on this map.`)));
                    i.slot === this._layers[t].slot ? n = e1 : H(`Layer with id "${t}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(n, 0, e1), this._changes.setDirty(), this._layerOrderChanged = !0, this.mergeLayers();
            }
            removeLayer(e1) {
                this._checkLoaded();
                const t = this._checkLayer(e1);
                if (!t) return;
                t.setEventedParent(null);
                const i = this._order.indexOf(e1);
                this._order.splice(i, 1), delete this._layers[e1], delete this._serializedLayers[e1], this._changes.setDirty(), this._layerOrderChanged = !0, this._configDependentLayers.delete(t.fqid), this._changes.removeLayer(t);
                const r = this.getOwnLayerSourceCache(t);
                if (r && r.castsShadows) {
                    let e1 = !1;
                    for(const i in this._layers)if (this._layers[i].source === t.source && this._layers[i].canCastShadows()) {
                        e1 = !0;
                        break;
                    }
                    r.castsShadows = e1;
                }
                t.onRemove && t.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e1) {
                return this._layers[e1];
            }
            hasLayer(e1) {
                return e1 in this._mergedLayers;
            }
            hasLayerType(e1) {
                for(const t in this._layers)if (this._layers[t].type === e1) return !0;
                return !1;
            }
            setLayerZoomRange(e1, t, i) {
                this._checkLoaded();
                const r = this._checkLayer(e1);
                r && (r.minzoom === t && r.maxzoom === i || (null != t && (r.minzoom = t), null != i && (r.maxzoom = i), this._updateLayer(r)));
            }
            setSlot(e1, t) {
                this._checkLoaded();
                const i = this._checkLayer(e1);
                i && i.slot !== t && (i.slot = t, this._updateLayer(i));
            }
            setFilter(e1, t, i = {}) {
                this._checkLoaded();
                const r = this._checkLayer(e1);
                if (r && !x(r.filter, t)) return null == t ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(ws, `layers.${r.id}.filter`, t, {
                    layerType: r.type
                }, i) || (r.filter = $(t), this._updateLayer(r)));
            }
            getFilter(e1) {
                const t = this._checkLayer(e1);
                if (t) return $(t.filter);
            }
            setLayoutProperty(e1, t, i, r = {}) {
                this._checkLoaded();
                const n = this._checkLayer(e1);
                n && (x(n.getLayoutProperty(t), i) || (n.setLayoutProperty(t, i, r), n.isConfigDependent && this._configDependentLayers.add(n.fqid), this._updateLayer(n)));
            }
            getLayoutProperty(e1, t) {
                const i = this._checkLayer(e1);
                if (i) return i.getLayoutProperty(t);
            }
            setPaintProperty(e1, t, i, r = {}) {
                this._checkLoaded();
                const n = this._checkLayer(e1);
                if (!n) return;
                if (x(n.getPaintProperty(t), i)) return;
                const o = n.setPaintProperty(t, i, r);
                n.isConfigDependent && this._configDependentLayers.add(n.fqid), o && this._updateLayer(n), this._changes.updatePaintProperties(n);
            }
            getPaintProperty(e1, t) {
                const i = this._checkLayer(e1);
                if (i) return i.getPaintProperty(t);
            }
            setFeatureState(e1, t) {
                this._checkLoaded();
                const i = e1.source, r = e1.sourceLayer, n = this._checkSource(i);
                if (!n) return;
                const o = n.type;
                if ("geojson" === o && r) return void this.fire(new Ct(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === o && !r) return void this.fire(new Ct(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === e1.id && this.fire(new Ct(new Error("The feature id parameter must be provided.")));
                const s = this.getOwnSourceCaches(i);
                for (const i of s)i.setFeatureState(r, e1.id, t);
            }
            removeFeatureState(e1, t) {
                this._checkLoaded();
                const i = e1.source, r = this._checkSource(i);
                if (!r) return;
                const n = r.type, o = "vector" === n ? e1.sourceLayer : void 0;
                if ("vector" === n && !o) return void this.fire(new Ct(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (t && "string" != typeof e1.id && "number" != typeof e1.id) return void this.fire(new Ct(new Error("A feature id is required to remove its specific state property.")));
                const s = this.getOwnSourceCaches(i);
                for (const i of s)i.removeFeatureState(o, e1.id, t);
            }
            getFeatureState(e1) {
                this._checkLoaded();
                const t = e1.source, i = e1.sourceLayer, r = this._checkSource(t);
                if (r) {
                    if ("vector" !== r.type || i) return void 0 === e1.id && this.fire(new Ct(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(t)[0].getFeatureState(i, e1.id);
                    this.fire(new Ct(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            setTransition(e1) {
                return this.stylesheet.transition = k({}, this.stylesheet.transition, e1), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return k({}, this.stylesheet.transition);
            }
            serialize() {
                this._checkLoaded();
                const e1 = this.getTerrain(), t = e1 && this.terrain && this.terrain.scope === this.scope ? e1 : this.stylesheet.terrain;
                return Z({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: t,
                    fog: this.stylesheet.fog,
                    center: this.stylesheet.center,
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e1)=>void 0 !== e1);
            }
            _updateLayer(e1) {
                this._changes.updateLayer(e1);
                const t = this.getLayerSourceCache(e1), i = va(e1.source, e1.scope), r = this._changes.getUpdatedSourceCaches();
                e1.source && !r[i] && t && "raster" !== t.getSource().type && (this._changes.updateSourceCache(i, "reload"), t.pause()), e1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t = (e1)=>"fill-extrusion" === this._mergedLayers[e1].type, i = this.order, r = {}, n = [];
                for(let o = i.length - 1; o >= 0; o--){
                    const s = i[o];
                    if (t(s)) {
                        r[s] = o;
                        for (const t of e1){
                            const e1 = t[s];
                            if (e1) for (const t of e1)n.push(t);
                        }
                    }
                }
                n.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
                const o = [];
                for(let s = i.length - 1; s >= 0; s--){
                    const a = i[s];
                    if (t(a)) for(let e1 = n.length - 1; e1 >= 0; e1--){
                        const t = n[e1].feature;
                        if (r[t.layer.id] < s) break;
                        o.push(t), n.pop();
                    }
                    else for (const t of e1){
                        const e1 = t[a];
                        if (e1) for (const t of e1)o.push(t.feature);
                    }
                }
                return o;
            }
            queryRenderedFeatures(e1, t, i) {
                t && t.filter && this._validate(ws, "queryRenderedFeatures.filter", t.filter, null, t), t.scope = this.scope, t.availableImages = this._availableImages, t.serializedLayers = this._serializedLayers;
                const r = {};
                if (t && t.layers) {
                    if (!Array.isArray(t.layers)) return this.fire(new Ct(new Error("parameters.layers must be an Array."))), [];
                    for (const e1 of t.layers){
                        const t = this._mergedLayers[e1];
                        if (!t) return this.fire(new Ct(new Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        r[t.source] = !0;
                    }
                }
                const n = [], o = t.serializedLayers || {}, s = t && t.layers ? t.layers.some((e1)=>{
                    const t = this.getLayer(e1);
                    return t && t.is3D();
                }) : this.has3DLayers(), a = Iw.createFromScreenPoints(e1, i);
                for(const e1 in this._mergedSourceCaches){
                    const l = this._mergedSourceCaches[e1].getSource();
                    if (!l || l.scope !== t.scope) continue;
                    const c = this._mergedSourceCaches[e1].getSource().id;
                    t.layers && !r[c] || n.push(CT(this._mergedSourceCaches[e1], this._mergedLayers, o, a, t, i, s, !!this.map._showQueryGeometry));
                }
                return this.placement && n.push(function(e1, t, i, r, n, o, s) {
                    const a = {}, l = o.queryRenderedSymbols(r), c = [];
                    for (const e1 of Object.keys(l).map(Number))c.push(s[e1]);
                    c.sort(PT);
                    for (const i of c){
                        const r = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t, i.bucketIndex, i.sourceLayerIndex, n.filter, n.layers, n.availableImages, e1);
                        for(const e1 in r){
                            const t = a[e1] = a[e1] || [], n = r[e1];
                            n.sort((e1, t)=>{
                                const r = i.featureSortOrder;
                                if (r) {
                                    const i = r.indexOf(e1.featureIndex);
                                    return r.indexOf(t.featureIndex) - i;
                                }
                                return t.featureIndex - e1.featureIndex;
                            });
                            for (const e1 of n)t.push(e1);
                        }
                    }
                    for(const t in a)a[t].forEach((r)=>{
                        const n = r.feature, o = i(e1[t]);
                        if (!o) return;
                        const s = o.getFeatureState(n.layer["source-layer"], n.id);
                        n.source = n.layer.source, n.layer["source-layer"] && (n.sourceLayer = n.layer["source-layer"]), n.state = s;
                    });
                    return a;
                }(this._mergedLayers, o, this.getLayerSourceCache.bind(this), a.screenGeometry, t, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(n);
            }
            querySourceFeatures(e1, t) {
                t && t.filter && this._validate(ws, "querySourceFeatures.filter", t.filter, null, t);
                const i = this.getOwnSourceCaches(e1);
                let r = [];
                for (const e1 of i)r = r.concat(zT(e1, t));
                return r;
            }
            addSourceType(e1, t, i) {
                return iS.getSourceType(e1) ? i(new Error(`A source type called "${e1}" already exists.`)) : (iS.setSourceType(e1, t), t.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e1,
                    url: t.workerSourceURL
                }, i) : i(null, null));
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(e1, t, i = {}) {
                this._checkLoaded();
                const r = this.light.getLight();
                let n = !1;
                for(const t in e1)if (!x(e1[t], r[t])) {
                    n = !0;
                    break;
                }
                if (!n) return;
                const o = this._getTransitionParameters();
                this.light.setLight(e1, t, i), this.light.updateTransitions(o);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            setTerrain(e1, t = 1) {
                if (this._checkLoaded(), !e1) return delete this.terrain, null === e1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                let i = e1;
                const r = null == e1.source;
                if (1 === t) {
                    if ("object" == typeof i.source) {
                        const e1 = "terrain-dem-src";
                        this.addSource(e1, i.source), i = $(i), i = k(i, {
                            source: e1
                        });
                    }
                    const e1 = k({}, i), t = {};
                    if (this.terrain && r) {
                        e1.source = this.terrain.get().source;
                        const i = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        i && (t.style = i.serialize());
                    }
                    if (this._validate(xs, "terrain", e1, t)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !r || this.terrain && t !== this.terrain.drapeRenderMode) {
                    if (!i) return;
                    this._createTerrain(i, t), this.fire(new It("data", {
                        dataType: "style"
                    }));
                } else {
                    const t = this.terrain, r = t.get();
                    for (const e1 of Object.keys(Pt.terrain))!i.hasOwnProperty(e1) && Pt.terrain[e1].default && (i[e1] = Pt.terrain[e1].default);
                    for(const i in e1)if (!x(e1[i], r[i])) {
                        t.set(e1, this.options), this.stylesheet.terrain = e1;
                        const i = this._getTransitionParameters({
                            duration: 0
                        });
                        t.updateTransitions(i), this.fire(new It("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e1) {
                const t = this.fog = new vw(e1, this.map.transform);
                this.stylesheet.fog = t.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e1 of this.map._markers)e1._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(e1) {
                if (this._checkLoaded(), !e1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const t = this.fog;
                    if (!x(t.get(), e1)) {
                        t.set(e1), this.stylesheet.fog = t.get();
                        const i = this._getTransitionParameters({
                            duration: 0
                        });
                        t.updateTransitions(i);
                    }
                } else this._createFog(e1);
                this._markersNeedUpdate = !0;
            }
            _getTransitionParameters(e1) {
                return {
                    now: dt.now(),
                    transition: k(this.transition, e1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e1 = [], t = [];
                for(const i in this._mergedLayers)this.isLayerDraped(this._mergedLayers[i]) ? e1.push(i) : t.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e1), this._drapedFirstOrder.push(...t);
            }
            _createTerrain(e1, t) {
                const i = this.terrain = new uw(e1, t, this.scope, this.options);
                1 === t && (this.stylesheet.terrain = e1), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const r = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(r);
            }
            _force3DLayerUpdate() {
                for(const e1 in this._layers){
                    const t = this._layers[e1];
                    "fill-extrusion" === t.type && this._updateLayer(t);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e1 in this._layers){
                    const t = this._layers[e1];
                    "symbol" === t.type && this._updateLayer(t);
                }
            }
            _validate(e1, t, i, r, n = {}) {
                if (n && !1 === n.validate) return !1;
                const o = k({}, this.serialize());
                return YA(this, e1.call(ms, k({
                    key: t,
                    style: o,
                    value: i,
                    styleSpec: Pt
                }, r)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), ta.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e1 in this._mergedLayers)this._mergedLayers[e1].setEventedParent(null);
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles(), this._mergedSourceCaches[e1].setEventedParent(null);
                this.setEventedParent(null), delete this.fog, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
            }
            clearSource(e1) {
                const t = this.getSourceCaches(e1);
                for (const e1 of t)e1.clearTiles();
            }
            clearSources() {
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles();
            }
            reloadSource(e1) {
                const t = this.getSourceCaches(e1);
                for (const e1 of t)e1.resume(), e1.reload();
            }
            reloadSources() {
                for (const e1 of this.getSources())e1.reload && e1.reload();
            }
            updateSources(e1) {
                let t;
                this.directionalLight && (t = $A(this.directionalLight));
                for(const i in this._mergedSourceCaches)this._mergedSourceCaches[i].update(e1, void 0, void 0, t);
            }
            _generateCollisionBoxes() {
                for(const e1 in this._sourceCaches){
                    const t = this._sourceCaches[e1];
                    t.resume(), t.reload();
                }
            }
            _updatePlacement(e1, t, i, r, n = !1) {
                let o = !1, s = !1;
                const a = {}, l = {};
                for (const t of this._mergedOrder){
                    const i = this._mergedLayers[t];
                    if ("symbol" !== i.type) continue;
                    const r = va(i.source, i.scope);
                    let n = a[r];
                    if (!n) {
                        const e1 = this.getLayerSourceCache(i);
                        if (!e1) continue;
                        const t = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t));
                        l[r] = t.slice(), n = a[r] = t.sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
                    }
                    const s = this.crossTileSymbolIndex.addLayer(i, n, e1.center.lng, e1.projection);
                    o = o || s;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), n = n || this._layerOrderChanged || 0 === i, this._layerOrderChanged && this.fire(new It("neworder")), (n || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(dt.now(), e1.zoom)) && (this.pauseablePlacement = new gE(e1, this._mergedOrder, n, t, i, r, this.placement, this.fog && e1.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, a, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(dt.now()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) for (const e1 of this._mergedOrder){
                    const t = this._mergedLayers[e1];
                    "symbol" === t.type && this.placement.updateLayerOpacities(t, a[va(t.source, t.scope)]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(dt.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].releaseSymbolFadeTiles();
            }
            addImport(e1) {
                this._checkLoaded();
                const t = this.stylesheet.imports = this.stylesheet.imports || [], i = t.findIndex(({ id: t })=>t === e1.id);
                return -1 !== i ? this.fire(new Ct(new Error(`Import with id '${e1.id}' already exists in the map's style.`))) : (t.push(e1), this._loadImports([
                    e1
                ], !0), this);
            }
            setImportUrl(e1, t) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], r = this.getImportIndex(e1);
                if (-1 === r) return this;
                i[r].url = t;
                const n = this.fragments[r];
                return n.style = this._createFragmentStyle(i[r]), n.style.on("style.import.load", ()=>this.mergeAll()), n.style.loadURL(t), this;
            }
            setImportData(e1, t) {
                this._checkLoaded();
                const i = this.getImportIndex(e1), r = this.stylesheet.imports || [];
                return -1 === i ? this : t ? (this.fragments[i].style.setState(t), this._reloadImports(), this) : (delete r[i].data, this.setImportUrl(e1, r[i].url));
            }
            setImportConfig(e1, t) {
                this._checkLoaded();
                const i = this.getImportIndex(e1), r = this.stylesheet.imports || [];
                if (-1 === i) return this;
                t ? r[i].config = t : delete r[i].config;
                const n = this.fragments[i], o = n.style.stylesheet && n.style.stylesheet.schema;
                return n.config = t, n.style.setConfig(t, o), n.style.updateConfigDependencies(), this;
            }
            removeImport(e1) {
                this._checkLoaded();
                const t = this.stylesheet.imports || [], i = this.getImportIndex(e1);
                return -1 === i || (t.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports()), this;
            }
            getImportIndex(e1) {
                const t = (this.stylesheet.imports || []).findIndex((t)=>t.id === e1);
                return -1 === t && this.fire(new Ct(new Error(`Import '${e1}' does not exist in the map's style and cannot be updated.`))), t;
            }
            getLayer(e1) {
                return this._mergedLayers[e1];
            }
            getSources() {
                const e1 = [];
                for(const t in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t];
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            getSource(e1, t) {
                const i = this.getSourceCache(e1, t);
                return i && i.getSource();
            }
            getLayerSource(e1) {
                const t = this.getLayerSourceCache(e1);
                return t && t.getSource();
            }
            getSourceCache(e1, t) {
                const i = va(e1, t);
                return this._mergedOtherSourceCaches[i];
            }
            getLayerSourceCache(e1) {
                const t = va(e1.source, e1.scope);
                return "symbol" === e1.type ? this._mergedSymbolSourceCaches[t] : this._mergedOtherSourceCaches[t];
            }
            getSourceCaches(e1) {
                const t = [];
                return this._mergedOtherSourceCaches[e1] && t.push(this._mergedOtherSourceCaches[e1]), this._mergedSymbolSourceCaches[e1] && t.push(this._mergedSymbolSourceCaches[e1]), t;
            }
            updateSourceCaches() {
                const e1 = this._changes.getUpdatedSourceCaches();
                for(const t in e1){
                    const i = e1[t];
                    "reload" === i ? this.reloadSource(t) : "clear" === i && this.clearSource(t);
                }
            }
            updateLayers(e1) {
                const t = this._changes.getUpdatedPaintProperties();
                for (const i of t){
                    const t = this.getLayer(i);
                    t && t.updateTransitions(e1);
                }
            }
            getImages(e1, t, i) {
                this.imageManager.getImages(t.icons, t.scope, i), this._updateTilesForChangedImages();
                const r = (e1)=>{
                    e1 && e1.setDependencies(t.tileID.key, t.type, t.icons);
                };
                r(this._otherSourceCaches[t.source]), r(this._symbolSourceCaches[t.source]);
            }
            getGlyphs(e1, t, i) {
                this.glyphManager.getGlyphs(t.stacks, t.scope, i);
            }
            getResource(e1, t, i) {
                return be(t, i);
            }
            getOwnSourceCache(e1) {
                return this._otherSourceCaches[e1];
            }
            getOwnLayerSourceCache(e1) {
                return "symbol" === e1.type ? this._symbolSourceCaches[e1.source] : this._otherSourceCaches[e1.source];
            }
            getOwnSourceCaches(e1) {
                const t = [];
                return this._otherSourceCaches[e1] && t.push(this._otherSourceCaches[e1]), this._symbolSourceCaches[e1] && t.push(this._symbolSourceCaches[e1]), t;
            }
            _isSourceCacheLoaded(e1) {
                const t = this.getOwnSourceCaches(e1);
                return 0 === t.length ? (this.fire(new Ct(new Error(`There is no source with ID '${e1}'`))), !1) : t.every((e1)=>e1.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
                this._clearWorkerCaches(), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
        }
        function rS(e1, t) {
            let i = !1, r = null;
            const n = ()=>{
                r = null, i && (e1(), r = setTimeout(n, t), i = !1);
            };
            return ()=>(i = !0, r || n(), r);
        }
        iS.getSourceType = function(e1) {
            return AT[e1];
        }, iS.setSourceType = function(e1, t) {
            AT[e1] = t;
        }, iS.registerForPluginStateChange = function(e1) {
            return e1({
                pluginStatus: Ks,
                pluginURL: Js
            }), ta.on("pluginStateChange", e1), e1;
        };
        class nS {
            constructor(e1){
                this._hashName = e1 && encodeURIComponent(e1), j([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = rS(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e1) {
                return this._map = e1, t.addEventListener("hashchange", this._onHashChange, !1), e1.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), t.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e1 = this._map;
                if (!e1) return "";
                const i = oS(e1);
                if (this._hashName) {
                    const e1 = this._hashName;
                    let r = !1;
                    const n = t.location.hash.slice(1).split("&").map((t)=>{
                        const n = t.split("=")[0];
                        return n === e1 ? (r = !0, `${n}=${i}`) : t;
                    }).filter((e1)=>e1);
                    return r || n.push(`${e1}=${i}`), `#${n.join("&")}`;
                }
                return `#${i}`;
            }
            _getCurrentHash() {
                const e1 = t.location.hash.replace("#", "");
                if (this._hashName) {
                    let t;
                    return e1.split("&").map((e1)=>e1.split("=")).forEach((e1)=>{
                        e1[0] === this._hashName && (t = e1);
                    }), (t && t[1] || "").split("/");
                }
                return e1.split("/");
            }
            _onHashChange() {
                const e1 = this._map;
                if (!e1) return !1;
                const t = this._getCurrentHash();
                if (t.length >= 3 && !t.some((e1)=>isNaN(e1))) {
                    const i = e1.dragRotate.isEnabled() && e1.touchZoomRotate.isEnabled() ? +(t[3] || 0) : e1.getBearing();
                    return e1.jumpTo({
                        center: [
                            +t[2],
                            +t[1]
                        ],
                        zoom: +t[0],
                        bearing: i,
                        pitch: +(t[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                const e1 = t.location.href.replace(/(#.+)?$/, this.getHashString());
                t.history.replaceState(t.history.state, null, e1);
            }
        }
        function oS(e1, t) {
            const i = e1.getCenter(), r = Math.round(100 * e1.getZoom()) / 100, n = Math.ceil((r * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), o = Math.pow(10, n), s = Math.round(i.lng * o) / o, a = Math.round(i.lat * o) / o, l = e1.getBearing(), c = e1.getPitch();
            let h = t ? `/${s}/${a}/${r}` : `${r}/${a}/${s}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const sS = {
            linearity: .3,
            easing: I(0, 0, .3, 1)
        }, aS = k({
            deceleration: 2500,
            maxSpeed: 1400
        }, sS), lS = k({
            deceleration: 20,
            maxSpeed: 1400
        }, sS), cS = k({
            deceleration: 1e3,
            maxSpeed: 360
        }, sS), hS = k({
            deceleration: 1e3,
            maxSpeed: 90
        }, sS);
        class uS {
            constructor(e1){
                this._map = e1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(e1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: dt.now(),
                    settings: e1
                });
            }
            _drainInertiaBuffer() {
                const e1 = this._inertiaBuffer, t = dt.now();
                for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
            }
            _onMoveEnd(e1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const t = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new y(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)t.zoom += e1.zoomDelta || 0, t.bearing += e1.bearingDelta || 0, t.pitch += e1.pitchDelta || 0, e1.panDelta && t.pan._add(e1.panDelta), e1.around && (t.around = e1.around), e1.pinchAround && (t.pinchAround = e1.pinchAround);
                const i = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                if (t.pan.mag()) {
                    const n = pS(t.pan.mag(), i, k({}, aS, e1 || {}));
                    r.offset = t.pan.mult(n.amount / t.pan.mag()), r.center = this._map.transform.center, dS(r, n);
                }
                if (t.zoom) {
                    const e1 = pS(t.zoom, i, lS);
                    r.zoom = this._map.transform.zoom + e1.amount, dS(r, e1);
                }
                if (t.bearing) {
                    const e1 = pS(t.bearing, i, cS);
                    r.bearing = this._map.transform.bearing + z(e1.amount, -179, 179), dS(r, e1);
                }
                if (t.pitch) {
                    const e1 = pS(t.pitch, i, hS);
                    r.pitch = this._map.transform.pitch + e1.amount, dS(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === t.pinchAround ? t.around : t.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
        }
        function dS(e1, t) {
            (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
        }
        function pS(e1, t, i) {
            const { maxSpeed: r, linearity: n, deceleration: o } = i, s = z(e1 * n / (t / 1e3), -r, r), a = Math.abs(s) / (o * n);
            return {
                easing: i.easing,
                duration: 1e3 * a,
                amount: s * (a / 2)
            };
        }
        class fS extends It {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i, r = {}){
                const n = wt(t.getCanvasContainer(), i);
                super(e1, k({
                    point: n,
                    lngLat: t.unproject(n),
                    originalEvent: i
                }, r)), this._defaultPrevented = !1, this.target = t;
            }
        }
        class mS extends It {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i){
                const r = "touchend" === e1 ? i.changedTouches : i.touches, n = Tt(t.getCanvasContainer(), r), o = n.map((e1)=>t.unproject(e1)), s = n.reduce((e1, t, i, r)=>e1.add(t.div(r.length)), new y(0, 0));
                super(e1, {
                    points: n,
                    point: s,
                    lngLats: o,
                    lngLat: t.unproject(s),
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class _S extends It {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i){
                super(e1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class gS {
            constructor(e1, t){
                this._map = e1, this._clickTolerance = t.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e1) {
                return this._firePreventable(new _S(e1.type, this._map, e1));
            }
            mousedown(e1, t) {
                return this._mousedownPos = t, this._firePreventable(new fS(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            preclick(e1) {
                const t = k({}, e1);
                t.type = "preclick", this._map.fire(new fS(t.type, this._map, t));
            }
            click(e1, t) {
                this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || (this.preclick(e1), this._map.fire(new fS(e1.type, this._map, e1)));
            }
            dblclick(e1) {
                return this._firePreventable(new fS(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new mS(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new mS(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new mS(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new mS(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class yS {
            constructor(e1){
                this._map = e1;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new fS("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._map.fire(new fS(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class xS {
            constructor(e1, t){
                this._map = e1, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (yt(), this._startPos = this._lastPos = t, this._active = !0);
            }
            mousemoveWindow(e1, t) {
                if (!this._active) return;
                const i = t, r = this._startPos, n = this._lastPos;
                if (!r || !n || n.equals(i) || !this._box && i.dist(r) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = pt("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const o = Math.min(r.x, i.x), s = Math.max(r.x, i.x), a = Math.min(r.y, i.y), l = Math.max(r.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${o}px,${a}px)`, this._box.style.width = s - o + "px", this._box.style.height = l - a + "px");
                });
            }
            mouseupWindow(e1, t) {
                if (!this._active) return;
                const i = this._startPos, r = t;
                if (i && 0 === e1.button) {
                    if (this.reset(), bt(), i.x !== r.x || i.y !== r.y) return this._map.fire(new It("boxzoomend", {
                        originalEvent: e1
                    })), {
                        cameraAnimation: (e1)=>e1.fitScreenCoordinates(i, r, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", e1);
                }
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), xt(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e1, t) {
                return this._map.fire(new It(e1, {
                    originalEvent: t
                }));
            }
        }
        function vS(e1, t) {
            const i = {};
            for(let r = 0; r < e1.length; r++)i[e1[r].identifier] = t[r];
            return i;
        }
        class bS {
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(e1, t, i) {
                (this.centroid || i.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = e1.timeStamp), i.length === this.numTouches && (this.centroid = function(e1) {
                    const t = new y(0, 0);
                    for (const i of e1)t._add(i);
                    return t.div(e1.length);
                }(t), this.touches = vS(i, t)));
            }
            touchmove(e1, t, i) {
                if (this.aborted || !this.centroid) return;
                const r = vS(i, t);
                for(const e1 in this.touches){
                    const t = r[e1];
                    (!t || t.dist(this.touches[e1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
        }
        class wS {
            constructor(e1){
                this.singleTap = new bS(e1), this.numTaps = e1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t, i) {
                this.singleTap.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this.singleTap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                const r = this.singleTap.touchend(e1, t, i);
                if (r) {
                    const t = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(r) < 30;
                    if (t && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = r, this.count === this.numTaps) return this.reset(), r;
                }
            }
        }
        class TS {
            constructor(){
                this._zoomIn = new wS({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new wS({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t, i) {
                this._zoomIn.touchstart(e1, t, i), this._zoomOut.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this._zoomIn.touchmove(e1, t, i), this._zoomOut.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                const r = this._zoomIn.touchend(e1, t, i), n = this._zoomOut.touchend(e1, t, i);
                return r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: t.getZoom() + 1,
                            around: t.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : n ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: t.getZoom() - 1,
                            around: t.unproject(n)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const ES = {
            0: 1,
            2: 2
        };
        class MS {
            constructor(e1){
                this.reset(), this._clickTolerance = e1.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e1, t) {
                return !1;
            }
            _move(e1, t) {
                return {};
            }
            mousedown(e1, t) {
                if (this._lastPoint) return;
                const i = Et(e1);
                this._correctButton(e1, i) && (this._lastPoint = t, this._eventButton = i);
            }
            mousemoveWindow(e1, t) {
                const i = this._lastPoint;
                if (i) {
                    if (e1.preventDefault(), null != this._eventButton && function(e1, t) {
                        const i = ES[t];
                        return void 0 === e1.buttons || (e1.buttons & i) !== i;
                    }(e1, this._eventButton)) this.reset();
                    else if (this._moved || !(t.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t, this._move(i, t);
                }
            }
            mouseupWindow(e1) {
                this._lastPoint && Et(e1) === this._eventButton && (this._moved && bt(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class AS extends MS {
            mousedown(e1, t) {
                super.mousedown(e1, t), this._lastPoint && (this._active = !0);
            }
            _correctButton(e1, t) {
                return 0 === t && !e1.ctrlKey;
            }
            _move(e1, t) {
                return {
                    around: t,
                    panDelta: t.sub(e1)
                };
            }
        }
        class SS extends MS {
            _correctButton(e1, t) {
                return 0 === t && e1.ctrlKey || 2 === t;
            }
            _move(e1, t) {
                const i = .8 * (t.x - e1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class IS extends MS {
            _correctButton(e1, t) {
                return 0 === t && e1.ctrlKey || 2 === t;
            }
            _move(e1, t) {
                const i = -0.5 * (t.y - e1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class CS {
            constructor(e1, t){
                this._map = e1, this._el = e1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = t.clickTolerance || 1, this.reset(), j([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new y(0, 0);
            }
            touchstart(e1, t, i) {
                return this._calculateTransform(e1, t, i);
            }
            touchmove(e1, t, i) {
                if (this._active && !(i.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === i.length && !ie()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return e1.cancelable && e1.preventDefault(), this._calculateTransform(e1, t, i);
                }
            }
            touchend(e1, t, i) {
                this._calculateTransform(e1, t, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e1, t, i) {
                i.length > 0 && (this._active = !0);
                const r = vS(i, t), n = new y(0, 0), o = new y(0, 0);
                let s = 0;
                for(const e1 in r){
                    const t = r[e1], i = this._touches[e1];
                    i && (n._add(t), o._add(t.sub(i)), s++, r[e1] = t);
                }
                if (this._touches = r, s < this._minTouches || !o.mag()) return;
                const a = o.div(s);
                return this._sum._add(a), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: n.div(s),
                    panDelta: a
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = pt("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 500);
            }
        }
        class zS {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e1) {}
            _move(e1, t, i) {
                return {};
            }
            touchstart(e1, t, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t[0],
                    t[1]
                ]));
            }
            touchmove(e1, t, i) {
                const r = this._firstTwoTouches;
                if (!r) return;
                e1.preventDefault();
                const [n, o] = r, s = PS(i, t, n), a = PS(i, t, o);
                if (!s || !a) return;
                const l = this._aroundCenter ? null : s.add(a).div(2);
                return this._move([
                    s,
                    a
                ], l, e1);
            }
            touchend(e1, t, i) {
                if (!this._firstTwoTouches) return;
                const [r, n] = this._firstTwoTouches, o = PS(i, t, r), s = PS(i, t, n);
                o && s || (this._active && bt(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function PS(e1, t, i) {
            for(let r = 0; r < e1.length; r++)if (e1[r].identifier === i) return t[r];
        }
        function DS(e1, t) {
            return Math.log(e1 / t) / Math.LN2;
        }
        class RS extends zS {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(DS(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: DS(this._distance, i),
                    pinchAround: t
                };
            }
        }
        function LS(e1, t) {
            return 180 * e1.angleWith(t) / Math.PI;
        }
        class kS extends zS {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t) {
                const i = this._vector;
                if (this._vector = e1[0].sub(e1[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: LS(this._vector, i),
                    pinchAround: t
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const r = LS(e1, i);
                return Math.abs(r) < t;
            }
        }
        function OS(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class BS extends zS {
            constructor(e1){
                super(), this._map = e1;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e1) {
                this._lastPoints = e1, OS(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(e1, t, i) {
                const r = this._lastPoints;
                if (!r) return;
                const n = e1[0].sub(r[0]), o = e1[1].sub(r[1]);
                return this._map._cooperativeGestures && !ie() && i.touches.length < 3 || (this._valid = this.gestureBeginsVertically(n, o, i.timeStamp), !this._valid) ? void 0 : (this._lastPoints = e1, this._active = !0, {
                    pitchDelta: (n.y + o.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e1, t, i) {
                if (void 0 !== this._valid) return this._valid;
                const r = e1.mag() >= 2, n = t.mag() >= 2;
                if (!r && !n) return;
                if (!r || !n) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const o = e1.y > 0 == t.y > 0;
                return OS(e1) && OS(t) && o;
            }
        }
        const FS = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class NS {
            constructor(){
                const e1 = FS;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let t = 0, i = 0, r = 0, n = 0, o = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), n = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), n = 1);
                        break;
                    case 38:
                        e1.shiftKey ? r = 1 : (e1.preventDefault(), o = -1);
                        break;
                    case 40:
                        e1.shiftKey ? r = -1 : (e1.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, r = 0), {
                    cameraAnimation: (s)=>{
                        const a = s.getZoom();
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: US,
                            zoom: t ? Math.round(a) + t * (e1.shiftKey ? 2 : 1) : a,
                            bearing: s.getBearing() + i * this._bearingStep,
                            pitch: s.getPitch() + r * this._pitchStep,
                            offset: [
                                -n * this._panStep,
                                -o * this._panStep
                            ],
                            center: s.getCenter()
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function US(e1) {
            return e1 * (2 - e1);
        }
        const VS = 4.000244140625;
        class jS {
            constructor(e1, t){
                this._map = e1, this._el = e1.getCanvasContainer(), this._handler = t, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222, j([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(e1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(e1.ctrlKey || e1.metaKey || this.isZooming() || ie())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = e1.deltaMode === t.WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY;
                const r = dt.now(), n = r - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = r, 0 !== i && i % VS == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : n > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(n * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= i, this._active || this._start(e1)), e1.preventDefault();
            }
            _onTimeout(e1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t = wt(this._el, e1);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e1 = this._map.transform;
                "wheel" === this._type && e1.projection.wrap && (e1._center.lng >= 180 || e1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const t = ()=>e1._terrainEnabled() && this._aroundCoord ? e1.computeZoomRelativeTo(this._aroundCoord) : e1.zoom;
                if (0 !== this._delta) {
                    const i = "wheel" === this._type && Math.abs(this._delta) > VS ? this._wheelZoomRate : this._defaultZoomRate;
                    let r = 2 / (1 + Math.exp(-Math.abs(this._delta * i)));
                    this._delta < 0 && 0 !== r && (r = 1 / r);
                    const n = t(), o = Math.pow(2, n), s = "number" == typeof this._targetZoom ? e1.zoomScale(this._targetZoom) : o;
                    this._targetZoom = Math.min(e1.maxZoom, Math.max(e1.minZoom, e1.scaleZoom(s * r))), "wheel" === this._type && (this._startZoom = n, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const i = "number" == typeof this._targetZoom ? this._targetZoom : t(), r = this._startZoom, n = this._easing;
                let o, s = !1;
                if ("wheel" === this._type && r && n) {
                    const e1 = Math.min((dt.now() - this._lastWheelEventTime) / 200, 1);
                    o = Kr(r, i, n(e1)), e1 < 1 ? this._frameId || (this._frameId = !0) : s = !0;
                } else o = i, s = !0;
                this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let a = o - t();
                return a * this._lastDelta < 0 && (a = 0), {
                    noInertia: !0,
                    needsRenderFrame: !s,
                    zoomDelta: a,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e1) {
                let t = C;
                if (this._prevEase) {
                    const e1 = this._prevEase, i = (dt.now() - e1.start) / e1.duration, r = e1.easing(i + .01) - e1.easing(i), n = .27 / Math.sqrt(r * r + 1e-4) * .01;
                    t = I(n, Math.sqrt(.0729 - n * n), .25, 1);
                }
                return this._prevEase = {
                    start: dt.now(),
                    duration: e1,
                    easing: t
                }, t;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = pt("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(t.navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 200);
            }
        }
        class GS {
            constructor(e1, t){
                this._clickZoom = e1, this._tapZoom = t;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class qS {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e1, t) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e1.shiftKey ? -1 : 1),
                            around: i.unproject(t)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class ZS {
            constructor(){
                this._tap = new wS({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e1, t, i) {
                this._swipePoint || (this._tapTime && e1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e1, t, i));
            }
            touchmove(e1, t, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const r = t[0], n = r.y - this._swipePoint.y;
                        return this._swipePoint = r, e1.preventDefault(), this._active = !0, {
                            zoomDelta: n / 128
                        };
                    }
                } else this._tap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e1, t, i) && (this._tapTime = e1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class $S {
            constructor(e1, t, i){
                this._el = e1, this._mousePan = t, this._touchPan = i;
            }
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class WS {
            constructor(e1, t, i){
                this._pitchWithRotate = e1.pitchWithRotate, this._mouseRotate = t, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class HS {
            constructor(e1, t, i, r){
                this._el = e1, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = r, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const XS = (e1)=>e1.zoom || e1.drag || e1.pitch || e1.rotate;
        class YS extends It {
        }
        class KS {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(e1, t) {
                const i = Du.sub([], t, e1);
                this.radius = Du.length(i[2] < 0 ? Du.div([], i, this.constants) : [
                    i[0],
                    i[1],
                    0
                ]);
            }
            projectRay(e1) {
                Du.div(e1, e1, this.constants), Du.normalize(e1, e1), Du.mul(e1, e1, this.constants);
                const t = Du.scale([], e1, this.radius);
                if (t[2] > 0) {
                    const e1 = Du.scale([], [
                        0,
                        0,
                        1
                    ], Du.dot(t, [
                        0,
                        0,
                        1
                    ])), i = Du.scale([], Du.normalize([], [
                        t[0],
                        t[1],
                        0
                    ]), this.radius), r = Du.add([], t, Du.scale([], Du.sub([], Du.add([], i, e1), t), 2));
                    t[0] = r[0], t[1] = r[1];
                }
                return t;
            }
        }
        function JS(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta;
        }
        class QS {
            constructor(e1, i){
                this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new uS(e1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new KS, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), j([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const r = this._el;
                this._listeners = [
                    [
                        r,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        r,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        r,
                        "touchend",
                        void 0
                    ],
                    [
                        r,
                        "touchcancel",
                        void 0
                    ],
                    [
                        r,
                        "mousedown",
                        void 0
                    ],
                    [
                        r,
                        "mousemove",
                        void 0
                    ],
                    [
                        r,
                        "mouseup",
                        void 0
                    ],
                    [
                        t.document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        t.document,
                        "mouseup",
                        void 0
                    ],
                    [
                        r,
                        "mouseover",
                        void 0
                    ],
                    [
                        r,
                        "mouseout",
                        void 0
                    ],
                    [
                        r,
                        "dblclick",
                        void 0
                    ],
                    [
                        r,
                        "click",
                        void 0
                    ],
                    [
                        r,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        r,
                        "keyup",
                        void 0
                    ],
                    [
                        r,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        r,
                        "contextmenu",
                        void 0
                    ],
                    [
                        t,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e1, i, r] of this._listeners)e1.addEventListener(i, e1 === t.document ? this.handleWindowEvent : this.handleEvent, r);
            }
            destroy() {
                for (const [e1, i, r] of this._listeners)e1.removeEventListener(i, e1 === t.document ? this.handleWindowEvent : this.handleEvent, r);
            }
            _addDefaultHandlers(e1) {
                const t = this._map, i = t.getCanvasContainer();
                this._add("mapEvent", new gS(t, e1));
                const r = t.boxZoom = new xS(t, e1);
                this._add("boxZoom", r);
                const n = new TS, o = new qS;
                t.doubleClickZoom = new GS(o, n), this._add("tapZoom", n), this._add("clickZoom", o);
                const s = new ZS;
                this._add("tapDragZoom", s);
                const a = t.touchPitch = new BS(t);
                this._add("touchPitch", a);
                const l = new SS(e1), c = new IS(e1);
                t.dragRotate = new WS(e1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new AS(e1), u = new CS(t, e1);
                t.dragPan = new $S(i, h, u), this._add("mousePan", h), this._add("touchPan", u, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const d = new kS, p = new RS;
                t.touchZoomRotate = new HS(i, p, d, s), this._add("touchRotate", d, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", p, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new yS(t));
                const f = t.scrollZoom = new jS(t, this);
                this._add("scrollZoom", f, [
                    "mousePan"
                ]);
                const m = t.keyboard = new NS;
                this._add("keyboard", m);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e1.interactive && e1[i] && t[i].enable(e1[i]);
            }
            _add(e1, t, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t,
                    allowed: i
                }), this._handlersById[e1] = t;
            }
            stop(e1) {
                if (!this._updatingCamera) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!XS(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e1, t, i) {
                for(const r in e1)if (r !== i && (!t || t.indexOf(r) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e1) {
                this.handleEvent(e1, `${e1.type}Window`);
            }
            _getMapTouches(e1) {
                const t = [];
                for (const i of e1)this._el.contains(i.target) && t.push(i);
                return t;
            }
            handleEvent(e1, t) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e1.type, r = i ? void 0 : e1, n = {
                    needsRenderFrame: !1
                }, o = {}, s = {}, a = e1.touches ? this._getMapTouches(e1.touches) : void 0, l = a ? Tt(this._el, a) : i ? void 0 : wt(this._el, e1);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let u;
                    this._blockedByActive(s, h, i) ? c.reset() : c[t || e1.type] && (u = c[t || e1.type](e1, l, a), this.mergeHandlerResult(n, o, u, i, r), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || c.isActive()) && (s[i] = c);
                }
                const c = {};
                for(const e1 in this._previousActiveHandlers)s[e1] || (c[e1] = r);
                this._previousActiveHandlers = s, (Object.keys(c).length || JS(n)) && (this._changes.push([
                    n,
                    o,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(s).length || JS(n)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = n;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(e1, t, i, r, n) {
                if (!i) return;
                k(e1, i);
                const o = {
                    handlerName: r,
                    originalEvent: i.originalEvent || n
                };
                void 0 !== i.zoomDelta && (t.zoom = o), void 0 !== i.panDelta && (t.drag = o), void 0 !== i.pitchDelta && (t.pitch = o), void 0 !== i.bearingDelta && (t.rotate = o);
            }
            _applyChanges() {
                const e1 = {}, t = {}, i = {};
                for (const [r, n, o] of this._changes)r.panDelta && (e1.panDelta = (e1.panDelta || new y(0, 0))._add(r.panDelta)), r.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (e1.around = r.around), void 0 !== r.aroundCoord && (e1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (e1.pinchAround = r.pinchAround), r.noInertia && (e1.noInertia = r.noInertia), k(t, n), k(i, o);
                this._updateMapTransform(e1, t, i), this._changes = [];
            }
            _updateMapTransform(e1, t, i) {
                const r = this._map, n = r.transform, o = (e1)=>[
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                if (((e1)=>{
                    const t = this._eventsInProgress.drag;
                    return t && !this._handlersById[t.handlerName].isActive();
                })() && !JS(e1)) {
                    const e1 = n.zoom;
                    n.cameraElevationReference = "sea", null != this._originalZoom && n._orthographicProjectionAtLowPitch && "globe" !== n.projection.name && 0 === n.pitch ? (n.cameraElevationReference = "ground", n.zoom = this._originalZoom) : (n.recenterOnTerrain(), n.cameraElevationReference = "ground"), e1 !== n.zoom && this._map._update(!0);
                }
                if (n._isCameraConstrained && r._stop(!0), !JS(e1)) return void this._fireEvents(t, i, !0);
                let { panDelta: s, zoomDelta: a, bearingDelta: l, pitchDelta: c, around: h, aroundCoord: u, pinchAround: d } = e1;
                n._isCameraConstrained && (a > 0 && (a = 0), n._isCameraConstrained = !1), void 0 !== d && (h = d), (a || ((e1)=>t[e1] && !this._eventsInProgress[e1])("drag")) && h && (this._dragOrigin = o(n.pointCoordinate3D(h)), this._originalZoom = n.zoom, this._trackingEllipsoid.setup(n._camera.position, this._dragOrigin)), n.cameraElevationReference = "sea", r._stop(!0), h = h || r.transform.centerPoint, l && (n.bearing += l), c && (n.pitch += c), n._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (s) {
                    if ("mercator" === n.projection.name) {
                        const e1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(h).dir), t = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(h.sub(s)).dir);
                        p[0] = t[0] - e1[0], p[1] = t[1] - e1[1];
                    } else {
                        const e1 = n.pointCoordinate(h);
                        if ("globe" === n.projection.name) {
                            s = s.rotate(-n.angle);
                            const t = n._pixelsPerMercatorPixel / n.worldSize;
                            p[0] = -s.x * sp(tp(e1.y)) * t, p[1] = -s.y * sp(n.center.lat) * t;
                        } else {
                            const t = n.pointCoordinate(h.sub(s));
                            e1 && t && (p[0] = t.x - e1.x, p[1] = t.y - e1.y);
                        }
                    }
                }
                const f = n.zoom, m = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    const e1 = o(u || n.pointCoordinate3D(h)), t = {
                        dir: Du.normalize([], Du.sub([], e1, n._camera.position))
                    };
                    if (t.dir[2] < 0) {
                        const i = n.zoomDeltaToMovement(e1, a);
                        Du.scale(m, t.dir, i);
                    }
                }
                const _ = Du.add(p, p, m);
                n._translateCameraConstrained(_), a && Math.abs(n.zoom - f) > 1e-4 && n.recenterOnTerrain(), n.cameraElevationReference = "ground", this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, i, !0);
            }
            _fireEvents(e1, t, i) {
                const r = XS(this._eventsInProgress), n = XS(e1), o = {};
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._eventsInProgress[t] || (o[`${t}start`] = i), this._eventsInProgress[t] = e1[t];
                }
                !r && n && this._fireEvent("movestart", n.originalEvent);
                for(const e1 in o)this._fireEvent(e1, o[e1]);
                n && this._fireEvent("move", n.originalEvent);
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._fireEvent(t, i);
                }
                const s = {};
                let a;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: i, originalEvent: r } = this._eventsInProgress[e1];
                    this._handlersById[i].isActive() || (delete this._eventsInProgress[e1], a = t[i] || r, s[`${e1}end`] = a);
                }
                for(const e1 in s)this._fireEvent(e1, s[e1]);
                const l = XS(this._eventsInProgress);
                if (i && (r || n) && !l) {
                    this._updatingCamera = !0;
                    const e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), t = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    e1 ? (t(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), this._map.easeTo(e1, {
                        originalEvent: a
                    })) : (this._map.fire(new It("moveend", {
                        originalEvent: a
                    })), t(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(e1, t) {
                this._map.fire(new It(e1, t ? {
                    originalEvent: t
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    this._frameId = void 0, this.handleEvent(new YS("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const eI = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class tI extends zt {
            constructor(e1, t){
                super(), this._moving = !1, this._zooming = !1, this.transform = e1, this._bearingSnap = t.bearingSnap, this._respectPrefersReducedMotion = !1 !== t.respectPrefersReducedMotion, j([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new Wd(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t) {
                return this.jumpTo({
                    center: e1
                }, t);
            }
            panBy(e1, t, i) {
                return e1 = y.convert(e1).mult(-1), this.panTo(this.transform.center, k({
                    offset: e1
                }, t), i);
            }
            panTo(e1, t, i) {
                return this.easeTo(k({
                    center: e1
                }, t), i);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t) {
                return this.jumpTo({
                    zoom: e1
                }, t), this;
            }
            zoomTo(e1, t, i) {
                return this.easeTo(k({
                    zoom: e1
                }, t), i);
            }
            zoomIn(e1, t) {
                return this.zoomTo(this.getZoom() + 1, e1, t), this;
            }
            zoomOut(e1, t) {
                return this.zoomTo(this.getZoom() - 1, e1, t), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t) {
                return this.jumpTo({
                    bearing: e1
                }, t), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t) {
                return this.jumpTo({
                    padding: e1
                }, t), this;
            }
            rotateTo(e1, t, i) {
                return this.easeTo(k({
                    bearing: e1
                }, t), i);
            }
            resetNorth(e1, t) {
                return this.rotateTo(0, k({
                    duration: 1e3
                }, e1), t), this;
            }
            resetNorthPitch(e1, t) {
                return this.easeTo(k({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e1), t), this;
            }
            snapToNorth(e1, t) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t) {
                return this.jumpTo({
                    pitch: e1
                }, t), this;
            }
            cameraForBounds(e1, t) {
                e1 = sc.convert(e1);
                const i = t && t.bearing || 0, r = t && t.pitch || 0, n = e1.getNorthWest(), o = e1.getSouthEast();
                return this._cameraForBounds(this.transform, n, o, i, r, t);
            }
            _extendCameraOptions(e1) {
                const t = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (e1 = k({
                    padding: t,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, e1)).padding) {
                    const t = e1.padding;
                    e1.padding = {
                        top: t,
                        bottom: t,
                        right: t,
                        left: t
                    };
                }
                return e1.padding = k(t, e1.padding), e1;
            }
            _minimumAABBFrustumDistance(e1, t) {
                const i = t.max[0] - t.min[0], r = t.max[1] - t.min[1];
                return i / r > e1.aspect ? i / (2 * Math.tan(.5 * e1.fovX) * e1.aspect) : r / (2 * Math.tan(.5 * e1.fovY) * e1.aspect);
            }
            _cameraForBoundsOnGlobe(e1, t, i, r, n, o) {
                const s = e1.clone(), a = this._extendCameraOptions(o);
                s.bearing = r, s.pitch = n;
                const l = Wd.convert(t), c = Wd.convert(i), h = .5 * (l.lat + c.lat), u = .5 * (l.lng + c.lng), d = wd(h, u), p = Du.normalize([], d), f = Du.normalize([], Du.cross([], p, [
                    0,
                    1,
                    0
                ])), m = Du.cross([], f, p), _ = [
                    f[0],
                    f[1],
                    f[2],
                    0,
                    m[0],
                    m[1],
                    m[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], g = [
                    d,
                    wd(l.lat, l.lng),
                    wd(c.lat, l.lng),
                    wd(c.lat, c.lng),
                    wd(l.lat, c.lng),
                    wd(h, l.lng),
                    wd(h, c.lng),
                    wd(l.lat, u),
                    wd(c.lat, u)
                ];
                let y = ed.fromPoints(g.map((e1)=>[
                        Du.dot(f, e1),
                        Du.dot(m, e1),
                        Du.dot(p, e1)
                    ]));
                const x = Du.transformMat4([], y.center, _);
                0 === Du.squaredLength(x) && Du.set(x, 0, 0, 1), Du.normalize(x, x), Du.scale(x, x, rd), s.center = function([e1, t, i]) {
                    const r = Math.hypot(e1, t, i), n = Math.atan2(e1, i), o = .5 * Math.PI - Math.acos(-t / r);
                    return new Wd(T(n), T(o));
                }(x);
                const v = s.getWorldToCameraMatrix(), b = Au.invert(new Float64Array(16), v);
                y = ed.applyTransform(y, Au.multiply([], v, _)), Du.transformMat4(x, x, v);
                const w = .5 * (y.max[2] - y.min[2]), E = this._minimumAABBFrustumDistance(s, y), M = Du.scale([], [
                    0,
                    0,
                    1
                ], w), A = Du.add(M, x, M), S = E + (0 === s.pitch ? 0 : Du.distance(x, A)), I = s.globeCenterInViewSpace, C = Du.sub([], x, [
                    I[0],
                    I[1],
                    I[2]
                ]);
                Du.normalize(C, C), Du.scale(C, C, S);
                const z = Du.add([], x, C);
                Du.transformMat4(z, z, b);
                const P = qd / rd, D = Du.length(z), R = Qd(Math.max(D * P - qd, Number.EPSILON), 0), L = Math.min(s.zoomFromMercatorZAdjusted(R), a.maxZoom);
                return L > .5 * (td + id) ? (s.setProjection({
                    name: "mercator"
                }), s.zoom = L, this._cameraForBounds(s, t, i, r, n, o)) : {
                    center: s.center,
                    zoom: L,
                    bearing: r,
                    pitch: n
                };
            }
            queryTerrainElevation(e1, t) {
                const i = this.transform.elevation;
                return i ? (t = k({}, {
                    exaggerated: !0
                }, t), i.getAtPoint(lp.fromLngLat(e1), null, t.exaggerated)) : null;
            }
            _cameraForBounds(e1, t, i, r, n, o) {
                if ("globe" === e1.projection.name) return this._cameraForBoundsOnGlobe(e1, t, i, r, n, o);
                const s = e1.clone(), a = this._extendCameraOptions(o), l = s.padding;
                s.bearing = r, s.pitch = n;
                const c = Wd.convert(t), h = Wd.convert(i), u = new Wd(c.lng, h.lat), d = new Wd(h.lng, c.lat), p = s.project(c), f = s.project(h), m = this.queryTerrainElevation(c), _ = this.queryTerrainElevation(h), g = this.queryTerrainElevation(u), x = this.queryTerrainElevation(d), v = [
                    [
                        p.x,
                        p.y,
                        Math.min(m || 0, _ || 0, g || 0, x || 0)
                    ],
                    [
                        f.x,
                        f.y,
                        Math.max(m || 0, _ || 0, g || 0, x || 0)
                    ]
                ];
                let b = ed.fromPoints(v);
                const T = s.getWorldToCameraMatrix(), E = Au.invert(new Float64Array(16), T);
                b = ed.applyTransform(b, T);
                const M = Du.sub([], b.max, b.min), A = l.left || 0, S = l.right || 0, I = l.bottom || 0, C = l.top || 0, { left: z, right: P, top: D, bottom: R } = a.padding, L = .5 * (A + S), k = .5 * (C + I), O = Math.min(s.scaleZoom(s.scale * Math.min((s.width - (A + S + z + P)) / M[0], (s.height - (I + C + R + D)) / M[1])), a.maxZoom), B = s.scale / s.zoomScale(O);
                b = new ed([
                    b.min[0] - (z + L) * B,
                    b.min[1] - (R + k) * B,
                    b.min[2]
                ], [
                    b.max[0] + (P + L) * B,
                    b.max[1] + (D + k) * B,
                    b.max[2]
                ]);
                const F = .5 * M[2], N = this._minimumAABBFrustumDistance(s, b), U = [
                    0,
                    0,
                    1,
                    0
                ];
                yu.transformMat4(U, U, T), yu.normalize(U, U);
                const V = Du.scale([], U, N + F), j = Du.add([], b.center, V), G = ("number" == typeof a.offset.x && "number" == typeof a.offset.y ? new y(a.offset.x, a.offset.y) : y.convert(a.offset)).rotate(-w(r));
                b.center[0] -= G.x * B, b.center[1] += G.y * B, Du.transformMat4(b.center, b.center, E), Du.transformMat4(j, j, E);
                const q = [
                    b.center[0],
                    b.center[1],
                    j[2] * s.pixelsPerMeter
                ];
                Du.scale(q, q, 1 / s.worldSize);
                const Z = ep(q[0]), $ = tp(q[1]), W = Math.min(s._zoomFromMercatorZ(q[2]), a.maxZoom), H = new Wd(Z, $);
                return s.mercatorFromTransition && W < .5 * (td + id) ? (s.setProjection({
                    name: "globe"
                }), s.zoom = W, this._cameraForBounds(s, t, i, r, n, o)) : {
                    center: H,
                    zoom: W,
                    bearing: r,
                    pitch: n
                };
            }
            fitBounds(e1, t, i) {
                const r = this.cameraForBounds(e1, t);
                return this._fitInternal(r, t, i);
            }
            fitScreenCoordinates(e1, t, i, r, n) {
                const o = y.convert(e1), s = y.convert(t), a = new y(Math.min(o.x, s.x), Math.min(o.y, s.y)), l = new y(Math.max(o.x, s.x), Math.max(o.y, s.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(o, s)) return this;
                const c = this.transform.pointLocation3D(a), h = this.transform.pointLocation3D(l), u = this.transform.pointLocation3D(new y(a.x, l.y)), d = this.transform.pointLocation3D(new y(l.x, a.y)), p = [
                    Math.min(c.lng, h.lng, u.lng, d.lng),
                    Math.min(c.lat, h.lat, u.lat, d.lat)
                ], f = [
                    Math.max(c.lng, h.lng, u.lng, d.lng),
                    Math.max(c.lat, h.lat, u.lat, d.lat)
                ], m = r && r.pitch ? r.pitch : this.getPitch(), _ = this._cameraForBounds(this.transform, p, f, i, m, r);
                return this._fitInternal(_, r, n);
            }
            _fitInternal(e1, t, i) {
                return e1 ? (delete (t = k(e1, t)).padding, t.linear ? this.easeTo(t, i) : this.flyTo(t, i)) : this;
            }
            jumpTo(e1, t) {
                this.stop();
                const i = e1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, n = !1, o = !1;
                return "zoom" in e1 && i.zoom !== +e1.zoom && (r = !0, i.zoom = +e1.zoom), void 0 !== e1.center && (i.center = Wd.convert(e1.center)), "bearing" in e1 && i.bearing !== +e1.bearing && (n = !0, i.bearing = +e1.bearing), "pitch" in e1 && i.pitch !== +e1.pitch && (o = !0, i.pitch = +e1.pitch), null == e1.padding || i.isPaddingEqual(e1.padding) || (i.padding = e1.padding), e1.preloadOnly ? (this._preloadTiles(i), this) : (this.fire(new It("movestart", t)).fire(new It("move", t)), r && this.fire(new It("zoomstart", t)).fire(new It("zoom", t)).fire(new It("zoomend", t)), n && this.fire(new It("rotatestart", t)).fire(new It("rotate", t)).fire(new It("rotateend", t)), o && this.fire(new It("pitchstart", t)).fire(new It("pitch", t)).fire(new It("pitchend", t)), this.fire(new It("moveend", t)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || H(eI), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(e1, t) {
                const i = this.transform;
                if (!i.projection.supportsFreeCamera) return H(eI), this;
                this.stop();
                const r = i.zoom, n = i.pitch, o = i.bearing;
                i.setFreeCameraOptions(e1);
                const s = r !== i.zoom, a = n !== i.pitch, l = o !== i.bearing;
                return this.fire(new It("movestart", t)).fire(new It("move", t)), s && this.fire(new It("zoomstart", t)).fire(new It("zoom", t)).fire(new It("zoomend", t)), l && this.fire(new It("rotatestart", t)).fire(new It("rotate", t)).fire(new It("rotateend", t)), a && this.fire(new It("pitchstart", t)).fire(new It("pitch", t)).fire(new It("pitchend", t)), this.fire(new It("moveend", t)), this;
            }
            easeTo(e1, t) {
                this._stop(!1, e1.easeId), (!1 === (e1 = k({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: C
                }, e1)).animate || this._prefersReducedMotion(e1)) && (e1.duration = 0);
                const i = this.transform, r = this.getZoom(), n = this.getBearing(), o = this.getPitch(), s = this.getPadding(), a = "zoom" in e1 ? +e1.zoom : r, l = "bearing" in e1 ? this._normalizeBearing(e1.bearing, n) : n, c = "pitch" in e1 ? +e1.pitch : o, h = "padding" in e1 ? e1.padding : i.padding, u = y.convert(e1.offset);
                let d, p, f;
                if ("globe" === i.projection.name) {
                    const t = lp.fromLngLat(i.center), r = u.rotate(-i.angle);
                    t.x += r.x / i.worldSize, t.y += r.y / i.worldSize;
                    const n = t.toLngLat(), o = Wd.convert(e1.center || n);
                    this._normalizeCenter(o), d = i.centerPoint.add(r), p = new y(t.x, t.y).mult(i.worldSize), f = new y(Kd(o.lng), Jd(o.lat)).mult(i.worldSize).sub(p);
                } else {
                    d = i.centerPoint.add(u);
                    const t = i.pointLocation(d), r = Wd.convert(e1.center || t);
                    this._normalizeCenter(r), p = i.project(t), f = i.project(r).sub(p);
                }
                const m = i.zoomScale(a - r);
                let _, g;
                e1.around && (_ = Wd.convert(e1.around), g = i.locationPoint(_));
                const x = this._zooming || a !== r, v = this._rotating || n !== l, b = this._pitching || c !== o, w = !i.isPaddingEqual(h), T = (i)=>(y)=>{
                        if (x && (i.zoom = Kr(r, a, y)), v && (i.bearing = Kr(n, l, y)), b && (i.pitch = Kr(o, c, y)), w && (i.interpolatePadding(s, h, y), d = i.centerPoint.add(u)), _) i.setLocationAtPoint(_, g);
                        else {
                            const e1 = i.zoomScale(i.zoom - r), t = a > r ? Math.min(2, m) : Math.max(.5, m), n = Math.pow(t, 1 - y), o = i.unproject(p.add(f.mult(y * n)).mult(e1));
                            i.setLocationAtPoint(i.renderWorldCopies ? o.wrap() : o, d);
                        }
                        return e1.preloadOnly || this._fireMoveEvents(t), i;
                    };
                if (e1.preloadOnly) {
                    const t = this._emulate(T, e1.duration, i);
                    return this._preloadTiles(t), this;
                }
                const E = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = x, this._rotating = v, this._pitching = b, this._padding = w, this._easeId = e1.easeId, this._prepareEase(t, e1.noMoveStart, E), this._ease(T(i), (e1)=>{
                    "sea" === i.cameraElevationReference && i.recenterOnTerrain(), this._afterEase(t, e1);
                }, e1), this;
            }
            _prepareEase(e1, t, i = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), t || i.moving || this.fire(new It("movestart", e1)), this._zooming && !i.zooming && this.fire(new It("zoomstart", e1)), this._rotating && !i.rotating && this.fire(new It("rotatestart", e1)), this._pitching && !i.pitching && this.fire(new It("pitchstart", e1));
            }
            _fireMoveEvents(e1) {
                this.fire(new It("move", e1)), this._zooming && this.fire(new It("zoom", e1)), this._rotating && this.fire(new It("rotate", e1)), this._pitching && this.fire(new It("pitch", e1));
            }
            _afterEase(e1, t) {
                if (this._easeId && t && this._easeId === t) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const i = this._zooming, r = this._rotating, n = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, i && this.fire(new It("zoomend", e1)), r && this.fire(new It("rotateend", e1)), n && this.fire(new It("pitchend", e1)), this.fire(new It("moveend", e1));
            }
            flyTo(e1, t) {
                if (this._prefersReducedMotion(e1)) {
                    const i = O(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(i, t);
                }
                this.stop(), e1 = k({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: C
                }, e1);
                const i = this.transform, r = this.getZoom(), n = this.getBearing(), o = this.getPitch(), s = this.getPadding(), a = "zoom" in e1 ? z(+e1.zoom, i.minZoom, i.maxZoom) : r, l = "bearing" in e1 ? this._normalizeBearing(e1.bearing, n) : n, c = "pitch" in e1 ? +e1.pitch : o, h = "padding" in e1 ? e1.padding : i.padding, u = i.zoomScale(a - r), d = y.convert(e1.offset);
                let p = i.centerPoint.add(d);
                const f = i.pointLocation(p), m = Wd.convert(e1.center || f);
                this._normalizeCenter(m);
                const _ = i.project(f), g = i.project(m).sub(_);
                let x = e1.curve;
                const v = Math.max(i.width, i.height), b = v / u, w = g.mag();
                if ("minZoom" in e1) {
                    const t = z(Math.min(e1.minZoom, r, a), i.minZoom, i.maxZoom), n = v / i.zoomScale(t - r);
                    x = Math.sqrt(n / w * 2);
                }
                const T = x * x;
                function E(e1) {
                    const t = (b * b - v * v + (e1 ? -1 : 1) * T * T * w * w) / (2 * (e1 ? b : v) * T * w);
                    return Math.log(Math.sqrt(t * t + 1) - t);
                }
                function M(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function A(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const S = E(0);
                let I = function(e1) {
                    return A(S) / A(S + x * e1);
                }, P = function(e1) {
                    var t;
                    return v * ((A(S) * (M(t = S + x * e1) / A(t)) - M(S)) / T) / w;
                }, D = (E(1) - S) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(D)) {
                    if (Math.abs(v - b) < 1e-6) return this.easeTo(e1, t);
                    const i = b < v ? -1 : 1;
                    D = Math.abs(Math.log(b / v)) / x, P = function() {
                        return 0;
                    }, I = function(e1) {
                        return Math.exp(i * x * e1);
                    };
                }
                e1.duration = "duration" in e1 ? +e1.duration : 1e3 * D / ("screenSpeed" in e1 ? +e1.screenSpeed / x : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0);
                const R = n !== l, L = c !== o, B = !i.isPaddingEqual(h), F = (i)=>(u)=>{
                        const f = u * D, y = 1 / I(f);
                        i.zoom = 1 === u ? a : r + i.scaleZoom(y), R && (i.bearing = Kr(n, l, u)), L && (i.pitch = Kr(o, c, u)), B && (i.interpolatePadding(s, h, u), p = i.centerPoint.add(d));
                        const x = 1 === u ? m : i.unproject(_.add(g.mult(P(f))).mult(y));
                        return i.setLocationAtPoint(i.renderWorldCopies ? x.wrap() : x, p), i._updateCameraOnTerrain(), e1.preloadOnly || this._fireMoveEvents(t), i;
                    };
                if (e1.preloadOnly) {
                    const t = this._emulate(F, e1.duration, i);
                    return this._preloadTiles(t), this;
                }
                return this._zooming = !0, this._rotating = R, this._pitching = L, this._padding = B, this._prepareEase(t, !1), this._ease(F(i), ()=>this._afterEase(t), e1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(e1, t) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e1 = this._onEaseEnd;
                    this._onEaseEnd = void 0, e1.call(this, t);
                }
                if (!e1) {
                    const e1 = this.handlers;
                    e1 && e1.stop(!1);
                }
                return this;
            }
            _ease(e1, t, i) {
                !1 === i.animate || 0 === i.duration ? (e1(1), t()) : (this._easeStart = dt.now(), this._easeOptions = i, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const e1 = Math.min((dt.now() - this._easeStart) / this._easeOptions.duration, 1), t = this._onEaseFrame;
                t && t(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(e1, t) {
                e1 = D(e1, -180, 180);
                const i = Math.abs(e1 - t);
                return Math.abs(e1 - 360 - t) < i && (e1 -= 360), Math.abs(e1 + 360 - t) < i && (e1 += 360), e1;
            }
            _normalizeCenter(e1) {
                const t = this.transform;
                if (t.maxBounds) return;
                if ("globe" !== t.projection.name && !t.renderWorldCopies) return;
                const i = e1.lng - t.center.lng;
                e1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(e1) {
                return this._respectPrefersReducedMotion && dt.prefersReducedMotion && !(e1 && e1.essential);
            }
            _emulate(e1, t, i) {
                const r = Math.ceil(15 * t / 1e3), n = [], o = e1(i.clone());
                for(let e1 = 0; e1 <= r; e1++){
                    const t = o(e1 / r);
                    n.push(t.clone());
                }
                return n;
            }
        }
        class iI {
            constructor(e1 = {}){
                this.options = e1, j([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                const t = this.options && this.options.compact;
                return this._map = e1, this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = pt("button", "mapboxgl-ctrl-attrib-button", this._container), pt("span", "mapboxgl-ctrl-icon", this._compactButton).setAttribute("aria-hidden", "true"), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = pt("div", "mapboxgl-ctrl-attrib-inner", this._container), t && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(e1, t) {
                const i = this._map._getUIString(`AttributionControl.${t}`);
                e1.removeAttribute("title"), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let e1 = this._editLink;
                e1 || (e1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const t = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || n.ACCESS_TOKEN
                    }
                ];
                if (e1) {
                    const i = t.reduce((e1, i, r)=>(i.value && (e1 += `${i.key}=${i.value}${r < t.length - 1 ? "&" : ""}`), e1), "?");
                    e1.href = `${n.FEEDBACK_URL}/${i}#${oS(this._map, !0)}`, e1.rel = "noopener nofollow", this._setElementTitle(e1, "MapFeedback");
                }
            }
            _updateData(e1) {
                !e1 || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType && "style" !== e1.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t = this._map.style._mergedSourceCaches;
                for(const i in t){
                    const r = t[i];
                    if (r.used) {
                        const t = r.getSource();
                        t.attribution && e1.indexOf(t.attribution) < 0 && e1.push(t.attribution);
                    }
                }
                e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, i)=>{
                    for(let r = i + 1; r < e1.length; r++)if (e1[r].indexOf(t) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = [
                    ...this.options.customAttribution,
                    ...e1
                ] : e1.unshift(this.options.customAttribution));
                const i = e1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class rI {
            constructor(){
                j([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e1) {
                this._map = e1, this._container = pt("div", "mapboxgl-ctrl");
                const t = pt("a", "mapboxgl-ctrl-logo");
                return t.target = "_blank", t.rel = "noopener nofollow", t.href = "https://www.mapbox.com/", t.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e1) {
                e1 && "metadata" !== e1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e1 = this._map.style._sourceCaches;
                if (0 === Object.entries(e1).length) return !0;
                for(const t in e1){
                    const i = e1[t].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e1 = this._container.children;
                if (e1.length) {
                    const t = e1[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t.classList.add("mapboxgl-compact") : t.classList.remove("mapboxgl-compact");
                }
            }
        }
        class nI {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e1) {
                const t = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t,
                    cancelled: !1
                }), t;
            }
            remove(e1) {
                const t = this._currentlyRunning, i = t ? this._queue.concat(t) : this._queue;
                for (const t of i)if (t.id === e1) return void (t.cancelled = !0);
            }
            run(e1 = 0) {
                const t = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        function oI(e1, t, i) {
            if (e1 = new Wd(e1.lng, e1.lat), t) {
                const r = new Wd(e1.lng - 360, e1.lat), n = new Wd(e1.lng + 360, e1.lat), o = 360 * Math.ceil(Math.abs(e1.lng - i.center.lng) / 360), s = i.locationPoint(e1).distSqr(t), a = t.x < 0 || t.y < 0 || t.x > i.width || t.y > i.height;
                i.locationPoint(r).distSqr(t) < s && (a || Math.abs(r.lng - i.center.lng) < o) ? e1 = r : i.locationPoint(n).distSqr(t) < s && (a || Math.abs(n.lng - i.center.lng) < o) && (e1 = n);
            }
            for(; Math.abs(e1.lng - i.center.lng) > 180;){
                const t = i.locationPoint(e1);
                if (t.x >= 0 && t.y >= 0 && t.x <= i.width && t.y <= i.height) break;
                e1.lng > i.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1;
        }
        const sI = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        class aI extends zt {
            constructor(e1, i){
                if (super(), (e1 instanceof t.HTMLElement || i) && (e1 = k({
                    element: e1
                }, i)), j([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this), this._anchor = e1 && e1.anchor || "center", this._color = e1 && e1.color || "#3FB1CE", this._scale = e1 && e1.scale || 1, this._draggable = e1 && e1.draggable || !1, this._clickTolerance = e1 && e1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = e1 && e1.rotation || 0, this._rotationAlignment = e1 && e1.rotationAlignment || "auto", this._pitchAlignment = e1 && e1.pitchAlignment && e1.pitchAlignment || "auto", this._updateMoving = ()=>this._update(!0), this._occludedOpacity = e1 && e1.occludedOpacity || .2, e1 && e1.element) this._element = e1.element, this._offset = y.convert(e1 && e1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = pt("div");
                    const t = 41, i = 27, r = ft("svg", {
                        display: "block",
                        height: t * this._scale + "px",
                        width: i * this._scale + "px",
                        viewBox: `0 0 ${i} ${t}`
                    }, this._element), n = ft("radialGradient", {
                        id: "shadowGradient"
                    }, ft("defs", {}, r));
                    ft("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, n), ft("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, n), ft("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, r), ft("path", {
                        fill: this._color,
                        d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                    }, r), ft("path", {
                        opacity: .25,
                        d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                    }, r), ft("circle", {
                        fill: "white",
                        cx: 13.5,
                        cy: 13.5,
                        r: 5.5
                    }, r), this._offset = y.convert(e1 && e1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                });
                const r = this._element.classList;
                for(const e1 in sI)r.remove(`mapboxgl-marker-anchor-${e1}`);
                r.add(`mapboxgl-marker-anchor-${this._anchor}`);
                const n = e1 && e1.className ? e1.className.trim().split(/\s+/) : [];
                r.add(...n), this._popup = null;
            }
            addTo(e1) {
                return e1 === this._map || (this.remove(), this._map = e1, e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._updateMoving), e1.on("moveend", this._update), e1.on("remove", this._clearFadeTimer), e1._addMarker(this), this.setDraggable(this._draggable), this._update(), e1.on("click", this._onMapClick)), this;
            }
            remove() {
                const e1 = this._map;
                return e1 && (e1.off("click", this._onMapClick), e1.off("move", this._updateMoving), e1.off("moveend", this._update), e1.off("mousedown", this._addDragHandler), e1.off("touchstart", this._addDragHandler), e1.off("mouseup", this._onUp), e1.off("touchend", this._onUp), e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove), e1.off("remove", this._clearFadeTimer), e1._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = Wd.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t = 38.1, i = 13.5, r = Math.sqrt(Math.pow(i, 2) / 2);
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t
                            ],
                            "bottom-left": [
                                r,
                                -1 * (t - i + r)
                            ],
                            "bottom-right": [
                                -r,
                                -1 * (t - i + r)
                            ],
                            left: [
                                i,
                                -1 * (t - i)
                            ],
                            right: [
                                -i,
                                -1 * (t - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, e1._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e1) {
                const t = e1.code, i = e1.charCode || e1.keyCode;
                "Space" !== t && "Enter" !== t && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e1) {
                const t = e1.originalEvent.target, i = this._element;
                this._popup && (t === i || i.contains(t)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return e1 ? (e1.isOpen() ? (e1.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e1.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e1 = this._map, t = this._pos;
                if (!e1 || !t) return !1;
                const i = e1.unproject(t), r = e1.getFreeCameraOptions();
                if (!r.position) return !1;
                const n = r.position.toLngLat();
                return n.distanceTo(i) < .9 * n.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const e1 = this._map;
                if (!e1) return;
                const t = this._pos;
                if (!t || t.x < 0 || t.x > e1.transform.width || t.y < 0 || t.y > e1.transform.height) return void this._clearFadeTimer();
                const i = e1.unproject(t);
                let r;
                e1._showingGlobe() && Nd(e1.transform, this._lngLat) ? r = 0 : (r = 1 - e1._queryFogOpacity(i), e1.transform._terrainEnabled() && e1.getTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = `${r}`, this._element.style.pointerEvents = r > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e1 = this._pos;
                if (!e1 || !this._map) return;
                const t = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e1.x}px,${e1.y}px)\n            ${sI[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t.x}px,${t.y}px)\n        `;
            }
            _calculateXYTransform() {
                const e1 = this._pos, t = this._map, i = this.getPitchAlignment();
                if (!t || !e1 || "map" !== i) return "";
                if (!t._showingGlobe()) {
                    const e1 = t.getPitch();
                    return e1 ? `rotateX(${e1}deg)` : "";
                }
                const r = T(Fd(t.transform, this._lngLat)), n = e1.sub(Bd(t.transform)), o = Math.abs(n.x) + Math.abs(n.y);
                if (0 === o) return "";
                const s = r / o;
                return `rotateX(${-n.y * s}deg) rotateY(${n.x * s}deg)`;
            }
            _calculateZTransform() {
                const e1 = this._pos, t = this._map;
                if (!t || !e1) return "";
                let i = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (t._showingGlobe()) {
                        const e1 = t.project(new Wd(this._lngLat.lng, this._lngLat.lat + .001)), r = t.project(new Wd(this._lngLat.lng, this._lngLat.lat - .001)).sub(e1);
                        i = T(Math.atan2(r.y, r.x)) - 90;
                    } else i = -t.getBearing();
                } else if ("horizon" === r) {
                    const r = P(4, 6, t.getZoom()), n = Bd(t.transform);
                    n.y += r * t.transform.height;
                    const o = e1.sub(n), s = T(Math.atan2(o.y, o.x));
                    i = (s > 90 ? s - 270 : s + 90) * (1 - r);
                }
                return i += this._rotation, i ? `rotateZ(${i}deg)` : "";
            }
            _update(e1) {
                t.cancelAnimationFrame(this._updateFrameId);
                const i = this._map;
                i && (i.transform.renderWorldCopies && (this._lngLat = oI(this._lngLat, this._pos, i.transform)), this._pos = i.project(this._lngLat), !0 === e1 ? this._updateFrameId = t.requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), i._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (i._showingGlobe() || i.getTerrain() || i.getFog()) && !this._fadeTimer && (this._fadeTimer = setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e1) {
                return this._offset = y.convert(e1), this._update(), this;
            }
            addClassName(e1) {
                return this._element.classList.add(e1), this;
            }
            removeClassName(e1) {
                return this._element.classList.remove(e1), this;
            }
            toggleClassName(e1) {
                return this._element.classList.toggle(e1);
            }
            _onMove(e1) {
                const t = this._map;
                if (!t) return;
                const i = this._pointerdownPos, r = this._positionDelta;
                if (i && r) {
                    if (!this._isDragging) {
                        const r = this._clickTolerance || t._clickTolerance;
                        if (e1.point.dist(i) < r) return;
                        this._isDragging = !0;
                    }
                    this._pos = e1.point.sub(r), this._lngLat = t.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new It("dragstart"))), this.fire(new It("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const e1 = this._map;
                e1 && (e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new It("dragend")), this._state = "inactive";
            }
            _addDragHandler(e1) {
                const t = this._map, i = this._pos;
                t && i && this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(i), this._pointerdownPos = e1.point, this._state = "pending", t.on("mousemove", this._onMove), t.on("touchmove", this._onMove), t.once("mouseup", this._onUp), t.once("touchend", this._onUp));
            }
            setDraggable(e1) {
                this._draggable = !!e1;
                const t = this._map;
                return t && (e1 ? (t.on("mousedown", this._addDragHandler), t.on("touchstart", this._addDragHandler)) : (t.off("mousedown", this._addDragHandler), t.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 || "auto", this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e1) {
                return this._occludedOpacity = e1 || .2, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const lI = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, cI = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function hI(e1 = new y(0, 0), t = "bottom") {
            if ("number" == typeof e1) {
                const i = Math.round(Math.sqrt(.5 * Math.pow(e1, 2)));
                switch(t){
                    case "top":
                        return new y(0, e1);
                    case "top-left":
                        return new y(i, i);
                    case "top-right":
                        return new y(-i, i);
                    case "bottom":
                        return new y(0, -e1);
                    case "bottom-left":
                        return new y(i, -i);
                    case "bottom-right":
                        return new y(-i, -i);
                    case "left":
                        return new y(e1, 0);
                    case "right":
                        return new y(-e1, 0);
                }
                return new y(0, 0);
            }
            return e1 instanceof y || Array.isArray(e1) ? y.convert(e1) : y.convert(e1[t] || [
                0,
                0
            ]);
        }
        class uI {
            constructor(e1){
                this.jumpTo(e1);
            }
            getValue(e1) {
                if (e1 <= this._startTime) return this._start;
                if (e1 >= this._endTime) return this._end;
                const t = M((e1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - t) + this._end * t;
            }
            isEasing(e1) {
                return e1 >= this._startTime && e1 <= this._endTime;
            }
            jumpTo(e1) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e1, this._end = e1;
            }
            easeTo(e1, t, i) {
                this._start = this.getValue(t), this._end = e1, this._startTime = t, this._endTime = t + i;
            }
        }
        const dI = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        }, pI = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1
        }, fI = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class mI {
            constructor(e1, t, i = !1){
                this._clickTolerance = 10, this.element = t, this.mouseRotate = new SS({
                    clickTolerance: e1.dragRotate._mouseRotate._clickTolerance
                }), this.map = e1, i && (this.mousePitch = new IS({
                    clickTolerance: e1.dragRotate._mousePitch._clickTolerance
                })), j([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), t.addEventListener("mousedown", this.mousedown), t.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), t.addEventListener("touchmove", this.touchmove), t.addEventListener("touchend", this.touchend), t.addEventListener("touchcancel", this.reset);
            }
            down(e1, t) {
                this.mouseRotate.mousedown(e1, t), this.mousePitch && this.mousePitch.mousedown(e1, t), yt();
            }
            move(e1, t) {
                const i = this.map, r = this.mouseRotate.mousemoveWindow(e1, t), n = r && r.bearingDelta;
                if (n && i.setBearing(i.getBearing() + n), this.mousePitch) {
                    const r = this.mousePitch.mousemoveWindow(e1, t), n = r && r.pitchDelta;
                    n && i.setPitch(i.getPitch() + n);
                }
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), e1.removeEventListener("touchmove", this.touchmove), e1.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                xt(), t.removeEventListener("mousemove", this.mousemove), t.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(e1) {
                this.down(k({}, e1, {
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }), wt(this.element, e1)), t.addEventListener("mousemove", this.mousemove), t.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e1) {
                this.move(e1, wt(this.element, e1));
            }
            mouseup(e1) {
                this.mouseRotate.mouseupWindow(e1), this.mousePitch && this.mousePitch.mouseupWindow(e1), this.offTemp();
            }
            touchstart(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = Tt(this.element, e1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, this._startPos));
            }
            touchmove(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = Tt(this.element, e1.targetTouches)[0], this.move({
                    preventDefault: ()=>e1.preventDefault()
                }, this._lastPos));
            }
            touchend(e1) {
                0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        const _I = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1
        }, gI = {
            maxWidth: 100,
            unit: "metric"
        }, yI = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, xI = {
            version: i,
            supported: rt,
            setRTLTextPlugin: function(e1, t, i = !1) {
                if (Ks === Ws || Ks === Hs || Ks === Xs) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                Js = dt.resolveURL(e1), Ks = Ws, Ys = t, ea(), i || ra();
            },
            getRTLTextPluginStatus: ia,
            Map: class extends tI {
                constructor(e1){
                    Qe.mark(Je.create);
                    const i = e1;
                    if (null != (e1 = k({}, pI, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != e1.maxPitch && e1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (e1.antialias && function(e1) {
                        const t = e1.navigator ? e1.navigator.userAgent : null;
                        return !!function(e1) {
                            if (null == te) {
                                const t = e1.navigator ? e1.navigator.userAgent : null;
                                te = !!e1.safari || !(!t || !(/\b(iPad|iPhone|iPod)\b/.test(t) || t.match("Safari") && !t.match("Chrome")));
                            }
                            return te;
                        }(e1) && t && (t.match("Version/15.4") || t.match("Version/15.5") || t.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
                    }(t) && (e1.antialias = !1, H("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Tv(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies), e1), this._interactive = e1.interactive, this._minTileCacheSize = e1.minTileCacheSize, this._maxTileCacheSize = e1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = e1.crossSourceCollisions, this._collectResourceTiming = e1.collectResourceTiming, this._language = this._parseLanguage(e1.language), this._worldview = e1.worldview, this._renderTaskQueue = new nI, this._domRenderTaskQueue = new nI, this._controls = [], this._markers = [], this._popups = [], this._mapId = F(), this._locale = k({}, dI, e1.locale), this._clickTolerance = e1.clickTolerance, this._cooperativeGestures = e1.cooperativeGestures, this._performanceMetricsCollection = e1.performanceMetricsCollection, this._containerWidth = 0, this._containerHeight = 0, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new uI(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._requestManager = new ze(e1.transformRequest, e1.accessToken, e1.testMode), this._silenceAuthErrors = !!e1.testMode, this._contextCreateOptions = e1.contextCreateOptions ? {
                        ...e1.contextCreateOptions
                    } : {}, "string" == typeof e1.container) {
                        if (this._container = t.document.getElementById(e1.container), !this._container) throw new Error(`Container '${e1.container.toString()}' not found.`);
                    } else {
                        if (!(e1.container instanceof t.HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = e1.container;
                    }
                    if (this._container.childNodes.length > 0 && H("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), e1.maxBounds && this.setMaxBounds(e1.maxBounds), j([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), void 0 !== t && (this._fullscreenchangeEvent = "onfullscreenchange" in t.document ? "fullscreenchange" : "webkitfullscreenchange", t.addEventListener("online", this._onWindowOnline, !1), t.addEventListener("resize", this._onWindowResize, !1), t.addEventListener("orientationchange", this._onWindowResize, !1), t.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), t.addEventListener("visibilitychange", this._onVisibilityChange, !1)), this.handlers = new QS(this, e1), this._localFontFamily = e1.localFontFamily, this._localIdeographFontFamily = e1.localIdeographFontFamily, (e1.style || !e1.testMode) && this.setStyle(e1.style || n.DEFAULT_STYLE, {
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), e1.projection && this.setProjection(e1.projection), e1.hash && (this._hash = new nS("string" == typeof e1.hash && e1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == i.center && null == i.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: e1.center,
                            zoom: e1.zoom,
                            bearing: e1.bearing,
                            pitch: e1.pitch
                        });
                        const t = e1.bounds;
                        t && (this.resize(), this.fitBounds(t, k({}, e1.fitBoundsOptions, {
                            duration: 0
                        })));
                    }
                    this.resize(), e1.attributionControl && this.addControl(new iI({
                        customAttribution: e1.customAttribution
                    })), this._logoControl = new rI, this.addControl(this._logoControl, e1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                    }), this.on("data", (e1)=>{
                        this._update("style" === e1.dataType), this.fire(new It(`${e1.dataType}data`, e1));
                    }), this.on("dataloading", (e1)=>{
                        this.fire(new It(`${e1.dataType}dataloading`, e1));
                    });
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(e1, t) {
                    if (void 0 === t && (t = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new Ct(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = e1.onAdd(this);
                    this._controls.push(e1);
                    const r = this._controlPositions[t];
                    return -1 !== t.indexOf("bottom") ? r.insertBefore(i, r.firstChild) : r.appendChild(i), this;
                }
                removeControl(e1) {
                    if (!e1 || !e1.onRemove) return this.fire(new Ct(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const t = this._controls.indexOf(e1);
                    return t > -1 && this._controls.splice(t, 1), e1.onRemove(this), this;
                }
                hasControl(e1) {
                    return this._controls.indexOf(e1) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(e1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const t = !this._moving;
                    return t && this.fire(new It("movestart", e1)).fire(new It("move", e1)), this.fire(new It("resize", e1)), t && this.fire(new It("moveend", e1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(e1) {
                    return this.transform.setMaxBounds(sc.convert(e1)), this._update();
                }
                setMinZoom(e1) {
                    if ((e1 = null == e1 ? -2 : e1) >= -2 && e1 <= this.transform.maxZoom) return this.transform.minZoom = e1, this._update(), this.getZoom() < e1 ? this.setZoom(e1) : this.fire(new It("zoomstart")).fire(new It("zoom")).fire(new It("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(e1) {
                    if ((e1 = null == e1 ? 22 : e1) >= this.transform.minZoom) return this.transform.maxZoom = e1, this._update(), this.getZoom() > e1 ? this.setZoom(e1) : this.fire(new It("zoomstart")).fire(new It("zoom")).fire(new It("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(e1) {
                    if ((e1 = null == e1 ? 0 : e1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (e1 >= 0 && e1 <= this.transform.maxPitch) return this.transform.minPitch = e1, this._update(), this.getPitch() < e1 ? this.setPitch(e1) : this.fire(new It("pitchstart")).fire(new It("pitch")).fire(new It("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(e1) {
                    if ((e1 = null == e1 ? 85 : e1) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (e1 >= this.transform.minPitch) return this.transform.maxPitch = e1, this._update(), this.getPitch() > e1 ? this.setPitch(e1) : this.fire(new It("pitchstart")).fire(new It("pitch")).fire(new It("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e1) {
                    return this.transform.renderWorldCopies = e1, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e1) {
                    return "auto" === e1 ? t.navigator.language : Array.isArray(e1) ? 0 === e1.length ? void 0 : e1.map((e1)=>"auto" === e1 ? t.navigator.language : e1) : e1;
                }
                setLanguage(e1) {
                    const t = this._parseLanguage(e1);
                    if (!this.style || t === this._language) return this;
                    this._language = t, this.style.reloadSources();
                    for (const e1 of this._controls)e1._setLanguage && e1._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e1) {
                    return this.style && e1 !== this._worldview ? (this._worldview = e1, this.style.reloadSources(), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e1) {
                    return this._lazyInitEmptyStyle(), e1 ? "string" == typeof e1 && (e1 = {
                        name: e1
                    }) : e1 = null, this._useExplicitProjection = !!e1, this._prioritizeAndUpdateProjection(e1, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const e1 = this.transform, t = e1.projection.name;
                    let i;
                    "globe" === t && e1.zoom >= id ? (e1.setMercatorFromTransition(), i = !0) : "mercator" === t && e1.zoom < id && (e1.setProjection({
                        name: "globe"
                    }), i = !0), i && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
                }
                _prioritizeAndUpdateProjection(e1, t) {
                    return this._updateProjection(e1 || t || {
                        name: "mercator"
                    });
                }
                _updateProjection(e1) {
                    let t;
                    return t = "globe" === e1.name && this.transform.zoom >= id ? this.transform.setMercatorFromTransition() : this.transform.setProjection(e1), this.style.applyProjectionUpdate(), t && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(e1) {
                    return this.transform.locationPoint3D(Wd.convert(e1));
                }
                unproject(e1) {
                    return this.transform.pointLocation3D(y.convert(e1));
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e1, t, i) {
                    if ("mouseenter" === e1 || "mouseover" === e1) {
                        let r = !1;
                        const n = (n)=>{
                            const o = t.filter((e1)=>this.getLayer(e1)), s = o.length ? this.queryRenderedFeatures(n.point, {
                                layers: o
                            }) : [];
                            s.length ? r || (r = !0, i.call(this, new fS(e1, this, n.originalEvent, {
                                features: s
                            }))) : r = !1;
                        }, o = ()=>{
                            r = !1;
                        };
                        return {
                            layers: new Set(t),
                            listener: i,
                            delegates: {
                                mousemove: n,
                                mouseout: o
                            }
                        };
                    }
                    if ("mouseleave" === e1 || "mouseout" === e1) {
                        let r = !1;
                        const n = (n)=>{
                            const o = t.filter((e1)=>this.getLayer(e1));
                            (o.length ? this.queryRenderedFeatures(n.point, {
                                layers: o
                            }) : []).length ? r = !0 : r && (r = !1, i.call(this, new fS(e1, this, n.originalEvent)));
                        }, o = (t)=>{
                            r && (r = !1, i.call(this, new fS(e1, this, t.originalEvent)));
                        };
                        return {
                            layers: new Set(t),
                            listener: i,
                            delegates: {
                                mousemove: n,
                                mouseout: o
                            }
                        };
                    }
                    {
                        const r = (e1)=>{
                            const r = t.filter((e1)=>this.getLayer(e1)), n = r.length ? this.queryRenderedFeatures(e1.point, {
                                layers: r
                            }) : [];
                            n.length && (e1.features = n, i.call(this, e1), delete e1.features);
                        };
                        return {
                            layers: new Set(t),
                            listener: i,
                            delegates: {
                                [e1]: r
                            }
                        };
                    }
                }
                on(e1, t, i) {
                    if (void 0 === i) return super.on(e1, t);
                    if (Array.isArray(t) || (t = [
                        t
                    ]), t) {
                        for (const e1 of t)if (!this._isValidId(e1)) return this;
                    }
                    const r = this._createDelegatedListener(e1, t, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(r);
                    for(const e1 in r.delegates)this.on(e1, r.delegates[e1]);
                    return this;
                }
                once(e1, t, i) {
                    if (void 0 === i) return super.once(e1, t);
                    if (Array.isArray(t) || (t = [
                        t
                    ]), t) {
                        for (const e1 of t)if (!this._isValidId(e1)) return this;
                    }
                    const r = this._createDelegatedListener(e1, t, i);
                    for(const e1 in r.delegates)this.once(e1, r.delegates[e1]);
                    return this;
                }
                off(e1, t, i) {
                    if (void 0 === i) return super.off(e1, t);
                    t = new Set(Array.isArray(t) ? t : [
                        t
                    ]);
                    for (const e1 of t)if (!this._isValidId(e1)) return this;
                    const r = (e1, t)=>{
                        if (e1.size !== t.size) return !1;
                        for (const i of e1)if (!t.has(i)) return !1;
                        return !0;
                    }, n = this._delegatedListeners ? this._delegatedListeners[e1] : void 0;
                    return n && ((e1)=>{
                        for(let n = 0; n < e1.length; n++){
                            const o = e1[n];
                            if (o.listener === i && r(o.layers, t)) {
                                for(const e1 in o.delegates)this.off(e1, o.delegates[e1]);
                                return e1.splice(n, 1), this;
                            }
                        }
                    })(n), this;
                }
                queryRenderedFeatures(e1, t) {
                    if (!this.style) return [];
                    if (void 0 !== t || void 0 === e1 || e1 instanceof y || Array.isArray(e1) || (t = e1, e1 = void 0), e1 = e1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], (t = t || {}).layers && Array.isArray(t.layers)) {
                        for (const e1 of t.layers)if (!this._isValidId(e1)) return [];
                    }
                    return this.style.queryRenderedFeatures(e1, t, this.transform);
                }
                querySourceFeatures(e1, t) {
                    return this._isValidId(e1) ? this.style.querySourceFeatures(e1, t) : [];
                }
                isPointOnSurface(e1) {
                    const { name: t } = this.transform.projection;
                    return "globe" !== t && "mercator" !== t && H(`${t} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(y.convert(e1));
                }
                setStyle(e1, t) {
                    return !1 !== (t = k({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, t)).diff && t.localIdeographFontFamily === this._localIdeographFontFamily && t.localFontFamily === this._localFontFamily && this.style && e1 ? (this._diffStyle(e1, t), this) : (this._localIdeographFontFamily = t.localIdeographFontFamily, this._localFontFamily = t.localFontFamily, this._updateStyle(e1, t));
                }
                _getUIString(e1) {
                    const t = this._locale[e1];
                    if (null == t) throw new Error(`Missing UI string '${e1}'`);
                    return t;
                }
                _updateStyle(e1, t) {
                    return this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e1 && (this.style = new iS(this, t || {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), "string" == typeof e1 ? this.style.loadURL(e1) : this.style.loadJSON(e1)), this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new iS(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                _diffStyle(e1, t) {
                    if ("string" == typeof e1) {
                        const i = this._requestManager.normalizeStyleURL(e1), r = this._requestManager.transformRequest(i, ye.Style);
                        we(r, (e1, i)=>{
                            e1 ? this.fire(new Ct(e1)) : i && this._updateDiff(i, t);
                        });
                    } else "object" == typeof e1 && this._updateDiff(e1, t);
                }
                _updateDiff(e1, t) {
                    try {
                        this.style.setState(e1) && this._update(!0);
                    } catch (i) {
                        H(`Unable to perform style diff: ${i.message || i.error || i}.  Rebuilding the style from scratch.`), this._updateStyle(e1, t);
                    }
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (H("There is no style added to the map."), !1);
                }
                _isValidId(e1) {
                    return null == e1 ? (this.fire(new Ct(new Error("IDs can't be empty."))), !1) : !xa(e1) || (this.fire(new Ct(new Error(`IDs can't contain special symbols: "${e1}".`))), !1);
                }
                addSource(e1, t) {
                    return this._isValidId(e1) ? (this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0)) : this;
                }
                isSourceLoaded(e1) {
                    return !!this._isValidId(e1) && !!this.style && this.style._isSourceCacheLoaded(e1);
                }
                areTilesLoaded() {
                    const e1 = this.style && this.style._sourceCaches;
                    for(const t in e1){
                        const i = e1[t]._tiles;
                        for(const e1 in i){
                            const t = i[e1];
                            if ("loaded" !== t.state && "errored" !== t.state) return !1;
                        }
                    }
                    return !0;
                }
                addSourceType(e1, t, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e1, t, i);
                }
                removeSource(e1) {
                    return this._isValidId(e1) ? (this.style.removeSource(e1), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e1) {
                    return this._isValidId(e1) ? this.style.getOwnSource(e1) : null;
                }
                addImage(e1, i, { pixelRatio: r = 1, sdf: n = !1, stretchX: o, stretchY: s, content: a } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof t.HTMLImageElement || t.ImageBitmap && i instanceof t.ImageBitmap) {
                        const { width: t, height: l, data: c } = dt.getImageData(i);
                        this.style.addImage(e1, {
                            data: new ef({
                                width: t,
                                height: l
                            }, c),
                            pixelRatio: r,
                            stretchX: o,
                            stretchY: s,
                            content: a,
                            sdf: n,
                            version: 0
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new Ct(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: t, height: l } = i, c = i;
                        this.style.addImage(e1, {
                            data: new ef({
                                width: t,
                                height: l
                            }, new Uint8Array(c.data)),
                            pixelRatio: r,
                            stretchX: o,
                            stretchY: s,
                            content: a,
                            sdf: n,
                            version: 0,
                            userImage: c
                        }), c.onAdd && c.onAdd(this, e1);
                    }
                }
                updateImage(e1, i) {
                    this._lazyInitEmptyStyle();
                    const r = this.style.getImage(e1);
                    if (!r) return void this.fire(new Ct(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const n = i instanceof t.HTMLImageElement || t.ImageBitmap && i instanceof t.ImageBitmap ? dt.getImageData(i) : i, { width: o, height: s } = n;
                    void 0 !== o && void 0 !== s ? o === r.data.width && s === r.data.height ? (r.data.replace(n.data, !(i instanceof t.HTMLImageElement || t.ImageBitmap && i instanceof t.ImageBitmap)), this.style.updateImage(e1, r)) : this.fire(new Ct(new Error(`The width and height of the updated image (${o}, ${s})\n                must be that same as the previous version of the image\n                (${r.data.width}, ${r.data.height})`))) : this.fire(new Ct(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                }
                hasImage(e1) {
                    return e1 ? !!this.style && !!this.style.getImage(e1) : (this.fire(new Ct(new Error("Missing required image id"))), !1);
                }
                removeImage(e1) {
                    this.style.removeImage(e1);
                }
                loadImage(e1, i) {
                    Ie(this._requestManager.transformRequest(e1, ye.Image), (e1, r)=>{
                        i(e1, r instanceof t.HTMLImageElement ? dt.getImageData(r) : r);
                    });
                }
                listImages() {
                    return this.style.listImages();
                }
                addModel(e1, t) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e1, t);
                }
                hasModel(e1) {
                    return e1 ? this.style.hasModel(e1) : (this.fire(new Ct(new Error("Missing required model id"))), !1);
                }
                removeModel(e1) {
                    this.style.removeModel(e1);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e1, t) {
                    return this._isValidId(e1.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0)) : this;
                }
                moveLayer(e1, t) {
                    return this._isValidId(e1) ? (this.style.moveLayer(e1, t), this._update(!0)) : this;
                }
                removeLayer(e1) {
                    return this._isValidId(e1) ? (this.style.removeLayer(e1), this._update(!0)) : this;
                }
                getLayer(e1) {
                    return this._isValidId(e1) ? this.style.getOwnLayer(e1) : null;
                }
                setLayerZoomRange(e1, t, i) {
                    return this._isValidId(e1) ? (this.style.setLayerZoomRange(e1, t, i), this._update(!0)) : this;
                }
                setFilter(e1, t, i = {}) {
                    return this._isValidId(e1) ? (this.style.setFilter(e1, t, i), this._update(!0)) : this;
                }
                getFilter(e1) {
                    return this._isValidId(e1) ? this.style.getFilter(e1) : null;
                }
                setPaintProperty(e1, t, i, r = {}) {
                    return this._isValidId(e1) ? (this.style.setPaintProperty(e1, t, i, r), this._update(!0)) : this;
                }
                getPaintProperty(e1, t) {
                    return this._isValidId(e1) ? this.style.getPaintProperty(e1, t) : null;
                }
                setLayoutProperty(e1, t, i, r = {}) {
                    return this._isValidId(e1) ? (this.style.setLayoutProperty(e1, t, i, r), this._update(!0)) : this;
                }
                getLayoutProperty(e1, t) {
                    return this._isValidId(e1) ? this.style.getLayoutProperty(e1, t) : null;
                }
                getConfigProperty(e1, t) {
                    return this.style.getConfigProperty(e1, t);
                }
                setConfigProperty(e1, t, i) {
                    return this.style.setConfigProperty(e1, t, i), this._update(!0);
                }
                setLights(e1) {
                    if (this._lazyInitEmptyStyle(), e1 && 1 === e1.length && "flat" === e1[0].type) {
                        const t = e1[0];
                        t.properties ? this.style.setFlatLight(t.properties, t.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e1), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e1 = this.style.getLights() || [];
                    return 0 === e1.length && e1.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e1;
                }
                setLight(e1, t = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e1
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e1) {
                    return this._lazyInitEmptyStyle(), !e1 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e1), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e1), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setCamera(e1) {
                    return this.style.setCamera(e1), this._triggerCameraUpdate(e1);
                }
                _triggerCameraUpdate(e1) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e1["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(e1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(Wd.convert(e1), this.transform) : 0;
                }
                setFeatureState(e1, t) {
                    return this._isValidId(e1.source) ? (this.style.setFeatureState(e1, t), this._update()) : this;
                }
                removeFeatureState(e1, t) {
                    return this._isValidId(e1.source) ? (this.style.removeFeatureState(e1, t), this._update()) : this;
                }
                getFeatureState(e1) {
                    return this._isValidId(e1.source) ? this.style.getFeatureState(e1) : null;
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e1 = this._container.getBoundingClientRect().width || 400, i = this._container.getBoundingClientRect().height || 300;
                    let r, n, o, s = this._container;
                    for(; s && (!n || !o);){
                        const e1 = t.getComputedStyle(s).transform;
                        e1 && "none" !== e1 && (r = e1.match(/matrix.*\((.+)\)/)[1].split(", "), r[0] && "0" !== r[0] && "1" !== r[0] && (n = r[0]), r[3] && "0" !== r[3] && "1" !== r[3] && (o = r[3])), s = s.parentElement;
                    }
                    this._containerWidth = n ? Math.abs(e1 / n) : e1, this._containerHeight = o ? Math.abs(i / o) : i;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== t.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && H("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e1 = this._container;
                    e1.classList.add("mapboxgl-map"), (this._missingCSSCanary = pt("div", "mapboxgl-canary", e1)).style.visibility = "hidden", this._detectMissingCSS();
                    const t = this._canvasContainer = pt("div", "mapboxgl-canvas-container", e1);
                    this._canvas = pt("canvas", "mapboxgl-canvas", t), this._interactive && (t.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = pt("div", "mapboxgl-control-container", e1), r = this._controlPositions = {};
                    [
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ].forEach((e1)=>{
                        r[e1] = pt("div", `mapboxgl-ctrl-${e1}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(e1, t) {
                    const i = dt.devicePixelRatio || 1;
                    this._canvas.width = i * Math.ceil(e1), this._canvas.height = i * Math.ceil(t), this._canvas.style.width = `${e1}px`, this._canvas.style.height = `${t}px`;
                }
                _addMarker(e1) {
                    this._markers.push(e1);
                }
                _removeMarker(e1) {
                    const t = this._markers.indexOf(e1);
                    -1 !== t && this._markers.splice(t, 1);
                }
                _addPopup(e1) {
                    this._popups.push(e1);
                }
                _removePopup(e1) {
                    const t = this._popups.indexOf(e1);
                    -1 !== t && this._popups.splice(t, 1);
                }
                _setupPainter() {
                    const e1 = k({}, rt.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), t = this._canvas.getContext("webgl2", e1);
                    t ? (Ke(t, !0), this.painter = new UA(t, this._contextCreateOptions, this.transform), this.on("data", (e1)=>{
                        "source" === e1.dataType && this.painter.setTileLoadedFlag(!0);
                    }), o.testSupport(t)) : this.fire(new Ct(new Error("Failed to initialize WebGL")));
                }
                _contextLost(e1) {
                    e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new It("webglcontextlost", {
                        originalEvent: e1
                    }));
                }
                _contextRestored(e1) {
                    this._setupPainter(), this.resize(), this._update(), this.fire(new It("webglcontextrestored", {
                        originalEvent: e1
                    }));
                }
                _onMapScroll(e1) {
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                _update(e1) {
                    return this.style ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e1) {
                    return this._update(), this._renderTaskQueue.add(e1);
                }
                _cancelRenderFrame(e1) {
                    this._renderTaskQueue.remove(e1);
                }
                _requestDomTask(e1) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e1() : this._domRenderTaskQueue.add(e1);
                }
                _render(e1) {
                    let i;
                    this.fire(new It("renderstart"));
                    const r = this.painter.context.extTimerQuery, n = dt.now(), o = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (i = o.createQuery(), o.beginQuery(r.TIME_ELAPSED_EXT, i)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], t.performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], t.performance.now())), this._renderTaskQueue.run(e1), this._domRenderTaskQueue.run(e1), this._removed) return;
                    this._updateProjectionTransition();
                    const s = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const e1 = this.transform.zoom, t = this.transform.pitch, i = dt.now(), r = new oa(e1, {
                            now: i,
                            fadeDuration: s,
                            pitch: t,
                            transition: this.style.transition
                        });
                        this.style.update(r);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let a = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), a = this._updateAverageElevation(n), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : a = this._updateAverageElevation(n), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, s, this._crossSourceCollisions), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: s,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new It("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new It("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i) {
                        const e1 = dt.now() - n;
                        o.endQuery(r.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const r = o.getQueryParameter(i, o.QUERY_RESULT) / 1e6;
                            o.deleteQuery(i), this.fire(new It("gpu-timing-frame", {
                                cpuTime: e1,
                                gpuTime: r
                            })), t.performance.mark("frame-gpu", {
                                startTime: n,
                                detail: {
                                    gpuTime: r
                                }
                            });
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const e1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const t = this.painter.queryGpuTimers(e1);
                            this.fire(new It("gpu-timing-layer", {
                                layerTimes: t
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const e1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const t = this.painter.queryGpuTimeDeferredRender(e1);
                            this.fire(new It("gpu-timing-deferred-render", {
                                gpuTime: t
                            }));
                        }, 50);
                    }
                    const l = this._sourcesDirty || this._styleDirty || this._placementDirty || a;
                    if (l || this._repaint) this.triggerRepaint();
                    else {
                        const e1 = !this.isMoving() && this.loaded();
                        if (e1 && (a = this._updateAverageElevation(n, !0)), a) this.triggerRepaint();
                        else if (this._triggerFrame(!1), e1 && (this.fire(new It("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const e1 = this._calculateSpeedIndex();
                            this.fire(new It("speedindexcompleted", {
                                speedIndex: e1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || l || (this._fullyLoaded = !0, Qe.mark(Je.fullLoad), this._performanceMetricsCollection && We(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e1) {
                    for (const t of this._markers)e1 && !this.getRenderWorldCopies() && (t._lngLat = t._lngLat.wrap()), t._update();
                    for (const t of this._popups)!e1 || this.getRenderWorldCopies() || t._trackPointer || (t._lngLat = t._lngLat.wrap()), t._update();
                }
                _updateAverageElevation(e1, t = !1) {
                    const i = (e1)=>(this.transform.averageElevation = e1, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const r = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (r || (t || e1 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e1)) {
                        const t = this.transform.averageElevation;
                        let n = this.transform.sampleAverageElevation();
                        this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(n) ? n = 0 : this._averageElevationLastSampledAt = e1;
                        const o = Math.abs(t - n);
                        if (o > 1) {
                            if (this._isInitialLoad || r) return this._averageElevation.jumpTo(n), i(n);
                            this._averageElevation.easeTo(n, e1, 300);
                        } else if (o > 1e-4) return this._averageElevation.jumpTo(n), i(n);
                    }
                    return !!this._averageElevation.isEasing(e1) && i(this._averageElevation.getValue(e1));
                }
                _authenticate() {
                    Xe(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (e1)=>{
                        if (e1 && (e1.message === Ce || 401 === e1.status)) {
                            const e1 = this.painter.context.gl;
                            Ke(e1, !1), this._logoControl instanceof rI && this._logoControl._updateLogo(), e1 && e1.clear(e1.DEPTH_BUFFER_BIT | e1.COLOR_BUFFER_BIT | e1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new Ct(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), Ze(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _updateTerrain() {
                    const e1 = this._isDragging();
                    this.painter.updateTerrain(this.style, e1);
                }
                _calculateSpeedIndex() {
                    const e1 = this.painter.canvasCopy(), t = this.painter.getCanvasCopiesAndTimestamps();
                    t.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, r = i.createFramebuffer();
                    function n(e1) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e1, 0);
                        const t = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t), t;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, r), this._canvasPixelComparison(n(e1), t.canvasCopies.map(n), t.timeStamps);
                }
                _canvasPixelComparison(e1, t, i) {
                    let r = i[1] - i[0];
                    const n = e1.length / 4;
                    for(let o = 0; o < t.length; o++){
                        const s = t[o];
                        let a = 0;
                        for(let t = 0; t < s.length; t += 4)s[t] === e1[t] && s[t + 1] === e1[t + 1] && s[t + 2] === e1[t + 2] && s[t + 3] === e1[t + 3] && (a += 1);
                        r += (i[o + 2] - i[o + 1]) * (1 - a / n);
                    }
                    return r;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e1 of this._controls)e1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), void 0 !== t && (t.removeEventListener("resize", this._onWindowResize, !1), t.removeEventListener("orientationchange", this._onWindowResize, !1), t.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), t.removeEventListener("online", this._onWindowOnline, !1), t.removeEventListener("visibilitychange", this._onVisibilityChange, !1));
                    const e1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    e1 && e1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), Ye.delete(this.painter.context.gl), this._removed = !0, this.fire(new It("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(e1) {
                    this._renderNextFrame = this._renderNextFrame || e1, this.style && !this._frame && (this._frame = dt.frame((e1)=>{
                        const t = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t && this._render(e1);
                    }));
                }
                _preloadTiles(e1) {
                    return R(this.style ? Object.values(this.style._sourceCaches) : [], (t, i)=>t._preloadTiles(e1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e1) {
                    this._trackResize && this.resize({
                        originalEvent: e1
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === t.document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e1) {
                    this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e1) {
                    this._showTerrainWireframe !== e1 && (this._showTerrainWireframe = e1, this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e1) {
                    this._showLayers2DWireframe !== e1 && (this._showLayers2DWireframe = e1, this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e1) {
                    this._showLayers3DWireframe !== e1 && (this._showLayers3DWireframe = e1, this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e1) {
                    this._speedIndexTiming !== e1 && (this._speedIndexTiming = e1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e1) {
                    this._showPadding !== e1 && (this._showPadding = e1, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e1) {
                    this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e1) {
                    this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e1) {
                    this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e1) {
                    this._vertices = e1, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e1) {
                    this._showTileAABBs !== e1 && (this._showTileAABBs = e1, e1 && this._update());
                }
                _setCacheLimits(e1, t) {
                    !function(e1, t) {
                        ce = e1, he = t;
                    }(e1, t);
                }
                get version() {
                    return i;
                }
            },
            NavigationControl: class {
                constructor(e1){
                    this.options = k({}, fI, e1), this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (j([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e1)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e1
                        });
                    }), pt("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e1)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e1
                        });
                    }), pt("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (j([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e1)=>{
                        const t = this._map;
                        t && (this.options.visualizePitch ? t.resetNorthPitch({}, {
                            originalEvent: e1
                        }) : t.resetNorth({}, {
                            originalEvent: e1
                        }));
                    }), this._compassIcon = pt("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t = e1.getZoom(), i = t === e1.getMaxZoom(), r = t === e1.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = r, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", r.toString());
                }
                _rotateCompassArrow() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e1.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e1.transform.pitch}deg) rotateZ(${e1.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e1.transform.angle * (180 / Math.PI)}deg)`;
                    e1._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t);
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e1.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e1.on("pitch", this._rotateCompassArrow), e1.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new mI(e1, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e1 = this._map;
                    e1 && (this._container.remove(), this.options.showZoom && e1.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e1.off("pitch", this._rotateCompassArrow), e1.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e1, t) {
                    const i = pt("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t), i;
                }
                _setButtonTitle(e1, t) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t}`);
                    e1.setAttribute("aria-label", i), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends zt {
                constructor(e1){
                    super(), this.options = k({
                        geolocation: t.navigator.geolocation
                    }, _I, e1), j([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = rS(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e1) {
                    const i = (t = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t, e1(t);
                    };
                    void 0 !== this._supportsGeolocation ? e1(this._supportsGeolocation) : void 0 !== t.navigator.permissions ? t.navigator.permissions.query({
                        name: "geolocation"
                    }).then((e1)=>i("denied" !== e1.state)).catch(()=>i()) : i();
                }
                _isOutOfMapMaxBounds(e1) {
                    const t = this._map.getMaxBounds(), i = e1.coords;
                    return !!t && (i.longitude < t.getWest() || i.longitude > t.getEast() || i.latitude < t.getSouth() || i.latitude > t.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(e1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new It("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new It("geolocate", e1)), this._finish();
                    }
                }
                _updateCamera(e1) {
                    const t = new Wd(e1.coords.longitude, e1.coords.latitude), i = e1.coords.accuracy, r = k({
                        bearing: this._map.getBearing()
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(t.toBounds(i), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(e1) {
                    if (e1) {
                        const t = new Wd(e1.coords.longitude, e1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(t).addTo(this._map), this._userLocationDotMarker.setLngLat(t).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const e1 = this._map.transform, t = Qd(1, e1._center.lat) * e1.worldSize, i = Math.ceil(2 * this._accuracy * t);
                    this._circleElement.style.width = `${i}px`, this._circleElement.style.height = `${i}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(e1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === e1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === e1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new It("error", e1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(e1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = pt("button", "mapboxgl-ctrl-geolocate", this._container), pt("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === e1) {
                            H("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1);
                        } else {
                            const e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = pt("div", "mapboxgl-user-location"), this._dotElement.appendChild(pt("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(pt("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new aI({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = pt("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new aI({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e1)=>{
                            e1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || e1.originalEvent && "resize" === e1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new It("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e1) {
                    this._userLocationDotMarker && (e1.webkitCompassHeading ? this._heading = e1.webkitCompassHeading : !0 === e1.absolute && (this._heading = -1 * e1.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return H("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new It("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new It("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new It("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e1;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e1 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e1), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                    return !0;
                }
                _addDeviceOrientationListener() {
                    const e1 = ()=>{
                        t.addEventListener("ondeviceorientationabsolute" in t ? "deviceorientationabsolute" : "deviceorientation", this._onDeviceOrientation);
                    };
                    void 0 !== t.DeviceMotionEvent && "function" == typeof t.DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t)=>{
                        "granted" === t && e1();
                    }).catch(console.error) : e1();
                }
                _clearWatch() {
                    this.options.geolocation.clearWatch(this._geolocationWatchID), t.removeEventListener("deviceorientation", this._onDeviceOrientation), t.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: iI,
            ScaleControl: class {
                constructor(e1){
                    this.options = k({}, gI, e1), this._isNumberFormatSupported = function() {
                        try {
                            return new Intl.NumberFormat("en", {
                                style: "unit",
                                unitDisplay: "short",
                                unit: "meter"
                            }), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), j([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e1 = this.options.maxWidth || 100, t = this._map, i = t._containerHeight / 2, r = t._containerWidth / 2 - e1 / 2, n = t.unproject([
                        r,
                        i
                    ]), o = t.unproject([
                        r + e1,
                        i
                    ]), s = n.distanceTo(o);
                    if ("imperial" === this.options.unit) {
                        const t = 3.2808 * s;
                        t > 5280 ? this._setScale(e1, t / 5280, "mile") : this._setScale(e1, t, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e1, s / 1852, "nautical-mile") : s >= 1e3 ? this._setScale(e1, s / 1e3, "kilometer") : this._setScale(e1, s, "meter");
                }
                _setScale(e1, t, i) {
                    this._map._requestDomTask(()=>{
                        const r = function(e1) {
                            const t = Math.pow(10, `${Math.floor(e1)}`.length - 1);
                            let i = e1 / t;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                                const t = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                                return Math.round(e1 * t) / t;
                            }(i), t * i;
                        }(t), n = r / t;
                        this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(r) : `${r}&nbsp;${yI[i]}`, this._container.style.width = e1 * n + "px";
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this._language = e1.getLanguage(), this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e1.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e1) {
                    this._language = e1, this._update();
                }
                setUnit(e1) {
                    this.options.unit = e1, this._update();
                }
            },
            FullscreenControl: class {
                constructor(e1){
                    this._fullscreen = !1, e1 && e1.container && (e1.container instanceof t.HTMLElement ? this._container = e1.container : H("Full screen control 'container' must be a DOM element.")), j([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in t.document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in t.document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(e1) {
                    return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", H("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, t.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!t.document.fullscreenEnabled && !t.document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e1 = this._fullscreenButton = pt("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    pt("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), t.document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e1);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (t.document.fullscreenElement || t.document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? t.document.exitFullscreen ? t.document.exitFullscreen() : t.document.webkitCancelFullScreen && t.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            Popup: class extends zt {
                constructor(e1){
                    super(), this.options = k(Object.create(lI), e1), j([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(e1 && e1.className ? e1.className.trim().split(/\s+/) : []);
                }
                addTo(e1) {
                    return this._map && this.remove(), this._map = e1, this.options.closeOnClick && e1.on("preclick", this._onClose), this.options.closeOnMove && e1.on("move", this._onClose), e1.on("remove", this.remove), this._update(), e1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (e1.on("mousemove", this._onMouseEvent), e1.on("mouseup", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")) : e1.on("move", this._update), this.fire(new It("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.off("move", this._onClose), e1.off("preclick", this._onClose), e1.off("click", this._onClose), e1.off("remove", this.remove), e1.off("mousemove", this._onMouseEvent), e1.off("mouseup", this._onMouseEvent), e1.off("drag", this._onMouseEvent), e1._canvasContainer && e1._canvasContainer.classList.remove("mapboxgl-track-pointer"), e1._removePopup(this), this._map = void 0), this.fire(new It("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(e1) {
                    this._lngLat = Wd.convert(e1), this._pos = null, this._trackPointer = !1, this._update();
                    const t = this._map;
                    return t && (t.on("move", this._update), t.off("mousemove", this._onMouseEvent), t._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.on("mousemove", this._onMouseEvent), e1.on("drag", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e1) {
                    return this.setDOMContent(t.document.createTextNode(e1));
                }
                setHTML(e1) {
                    const i = t.document.createDocumentFragment(), r = t.document.createElement("body");
                    let n;
                    for(r.innerHTML = e1; n = r.firstChild, n;)i.appendChild(n);
                    return this.setDOMContent(i);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e1) {
                    return this.options.maxWidth = e1, this._update(), this;
                }
                setDOMContent(e1) {
                    let t = this._content;
                    if (t) for(; t.hasChildNodes();)t.firstChild && t.removeChild(t.firstChild);
                    else t = this._content = pt("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t.appendChild(e1), this.options.closeButton) {
                        const e1 = this._closeButton = pt("button", "mapboxgl-popup-close-button", t);
                        e1.type = "button", e1.setAttribute("aria-label", "Close popup"), e1.setAttribute("aria-hidden", "true"), e1.innerHTML = "&#215;", e1.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e1) {
                    return this._classList.add(e1), this._updateClassList(), this;
                }
                removeClassName(e1) {
                    return this._classList.delete(e1), this._updateClassList(), this;
                }
                setOffset(e1) {
                    return this.options.offset = e1, this._update(), this;
                }
                toggleClassName(e1) {
                    let t;
                    return this._classList.delete(e1) ? t = !1 : (this._classList.add(e1), t = !0), this._updateClassList(), t;
                }
                _onMouseEvent(e1) {
                    this._update(e1.point);
                }
                _getAnchor(e1) {
                    if (this.options.anchor) return this.options.anchor;
                    const t = this._map, i = this._container, r = this._pos;
                    if (!t || !i || !r) return "bottom";
                    const n = i.offsetWidth, o = i.offsetHeight, s = r.x < n / 2, a = r.x > t.transform.width - n / 2;
                    if (r.y + e1 < o) return s ? "top-left" : a ? "top-right" : "top";
                    if (r.y > t.transform.height - o) {
                        if (s) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return s ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e1 = this._container;
                    if (!e1) return;
                    const t = [
                        ...this._classList
                    ];
                    t.push("mapboxgl-popup"), this._anchor && t.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t.push("mapboxgl-popup-track-pointer"), e1.className = t.join(" ");
                }
                _update(e1) {
                    const t = this._map, i = this._content;
                    if (!t || !this._lngLat && !this._trackPointer || !i) return;
                    let r = this._container;
                    if (r || (r = this._container = pt("div", "mapboxgl-popup", t.getContainer()), this._tip = pt("div", "mapboxgl-popup-tip", r), r.appendChild(i)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), t.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = oI(this._lngLat, this._pos, t.transform)), !this._trackPointer || e1) {
                        const i = this._pos = this._trackPointer && e1 ? e1 : t.project(this._lngLat), r = hI(this.options.offset), n = this._anchor = this._getAnchor(r.y), o = hI(this.options.offset, n), s = i.add(o).round();
                        t._requestDomTask(()=>{
                            this._container && n && (this._container.style.transform = `${sI[n]} translate(${s.x}px,${s.y}px)`);
                        });
                    }
                    if (!this._marker && t._showingGlobe()) {
                        const e1 = Nd(t.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(e1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e1 = this._container.querySelector(cI);
                    e1 && e1.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e1) {
                    this._container && (this._container.style.opacity = `${e1}`), this._content && (this._content.style.pointerEvents = e1 ? "auto" : "none");
                }
            },
            Marker: aI,
            Style: iS,
            LngLat: Wd,
            LngLatBounds: sc,
            Point: y,
            MercatorCoordinate: lp,
            FreeCameraOptions: Xx,
            Evented: zt,
            config: n,
            prewarm: function() {
                Ww().acquire(qw);
            },
            clearPrewarmedResources: function() {
                const e1 = $w;
                e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(qw), $w = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return n.ACCESS_TOKEN;
            },
            set accessToken (e){
                n.ACCESS_TOKEN = e;
            },
            get baseApiUrl () {
                return n.API_URL;
            },
            set baseApiUrl (e){
                n.API_URL = e;
            },
            get workerCount () {
                return Zw.workerCount;
            },
            set workerCount (e){
                Zw.workerCount = e;
            },
            get maxParallelImageRequests () {
                return n.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (e){
                n.MAX_PARALLEL_IMAGE_REQUESTS = e;
            },
            clearStorage (e1) {
                !function(e1) {
                    if (!pe()) return;
                    const i = t.caches.delete(le);
                    e1 && i.catch(e1).then(()=>e1());
                }(e1);
            },
            workerUrl: "",
            workerClass: null,
            get dracoUrl () {
                return Jw();
            },
            set dracoUrl (e){
                !function(e1) {
                    Xw = dt.resolveURL(e1), Kw || (Kw = new Ew(Ww(), new zt)), Kw.broadcast("setDracoUrl", Xw);
                }(e);
            },
            setNow: dt.setNow,
            restoreNow: dt.restoreNow
        };
        e1.A = Tw, e1.D = Ym, e1.E = cr, e1.F = Qm, e1.K = xE, e1.O = qu, e1.P = y, e1.T = Zv, e1.V = hm, e1.a = Kf, e1.b = fm, e1.c = ow, e1.d = class extends zt {
            constructor(e1, t, i, r, n, o){
                super(), this.actor = e1, this.layerIndex = t, this.availableImages = i, this.loadVectorData = n || Uw, this.loading = {}, this.loaded = {}, this.deduped = new Nw(e1.scheduler), this.isSpriteLoaded = r, this.scheduler = e1.scheduler, this.brightness = o;
            }
            loadTile(e1, t) {
                const i = e1.uid, r = e1 && e1.request, n = r && r.collectResourceTiming, o = this.loading[i] = new Bw(e1);
                o.abort = this.loadVectorData(e1, (s, a)=>{
                    const l = !this.loading[i];
                    if (delete this.loading[i], l || s || !a) return o.status = "done", l || (this.loaded[i] = o), t(s);
                    const c = a.rawData, h = {};
                    a.expires && (h.expires = a.expires), a.cacheControl && (h.cacheControl = a.cacheControl), o.vectorTile = a.vectorTile || new cm(new km(c));
                    const u = ()=>{
                        o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, (e1, i)=>{
                            if (e1 || !i) return t(e1);
                            const o = {};
                            if (n) {
                                const e1 = it(r);
                                e1.length > 0 && (o.resourceTiming = JSON.parse(JSON.stringify(e1)));
                            }
                            t(null, k({
                                rawTileData: c.slice(0)
                            }, i, h, o));
                        });
                    };
                    this.isSpriteLoaded ? u() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(u, {
                            type: "parseTile",
                            isSymbolTile: e1.isSymbolTile,
                            zoom: e1.tileZoom
                        }) : u();
                    }), this.loaded = this.loaded || {}, this.loaded[i] = o;
                });
            }
            reloadTile(e1, t) {
                const i = this.loaded, r = e1.uid, n = this;
                if (i && i[r]) {
                    const o = i[r];
                    o.showCollisionBoxes = e1.showCollisionBoxes, o.projection = e1.projection, o.brightness = e1.brightness, o.tileTransform = Pg(e1.tileID.canonical, e1.projection), o.extraShadowCaster = e1.extraShadowCaster;
                    const s = (e1, i)=>{
                        const r = o.reloadCallback;
                        r && (delete o.reloadCallback, o.parse(o.vectorTile, n.layerIndex, this.availableImages, n.actor, r)), t(e1, i);
                    };
                    "parsing" === o.status ? o.reloadCallback = s : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
                } else t(null, void 0);
            }
            abortTile(e1, t) {
                const i = e1.uid, r = this.loading[i];
                r && (r.abort && r.abort(), delete this.loading[i]), t();
            }
            removeTile(e1, t) {
                const i = this.loaded, r = e1.uid;
                i && i[r] && delete i[r], t();
            }
        }, e1.e = Eo, e1.f = it, e1.g = d, e1.h = we, e1.i = Te, e1.j = function(e1, t) {
            const i = TT(e1);
            for (const e1 of i){
                for (const t of e1.meshes)ET(t);
                e1.lights && (e1.lightMeshIndex = e1.meshes.length, e1.meshes.push(MT(e1.lights, t)));
            }
            return i;
        }, e1.k = oa, e1.l = function(e1) {
            let t = 0;
            if (new Uint32Array(e1, 0, 1)[0] !== aT) {
                const i = new Uint32Array(e1, 0, 7), [, , r, n, o, s] = i;
                t = i.byteLength + n + o + s + o, (r !== e1.byteLength || t >= e1.byteLength) && H("Invalid b3dm header information.");
            }
            return pT(e1, t);
        }, e1.m = ty, e1.n = na, e1.o = It, e1.p = _, e1.q = function(e1) {
            fe(), ue && ue.then((t)=>{
                t.keys().then((i)=>{
                    for(let r = 0; r < i.length - e1; r++)t.delete(i[r]);
                });
            });
        }, e1.r = RT, e1.s = xI, e1.t = ap, e1.v = L, e1.w = t;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t(e1) {
            if ("number" == typeof e1 || "boolean" == typeof e1 || "string" == typeof e1 || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let r = "[";
                for (const o of e1)r += `${t(o)},`;
                return `${r}]`;
            }
            let r = "{";
            for (const o of Object.keys(e1).sort())r += `${o}:${t(e1[o])},`;
            return `${r}}`;
        }
        function r(r) {
            let o = "";
            for (const i of e1.r)o += `/${t(r[i])}`;
            return o;
        }
        class o {
            constructor(e1){
                this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e1 && this.replace(e1);
            }
            replace(e1, t) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, [], t);
            }
            update(t, o, i) {
                this._options = i;
                for (const r of t){
                    this._layerConfigs[r.id] = r;
                    const t = this._layers[r.id] = e1.c(r, this._options);
                    t.setScope(this.scope), t.compileFilter(), this.keyCache[r.id] && delete this.keyCache[r.id];
                }
                for (const e1 of o)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const s = function(e1, t) {
                    const o = {};
                    for(let i = 0; i < e1.length; i++){
                        const s = t && t[e1[i].id] || r(e1[i]);
                        t && (t[e1[i].id] = s);
                        let n = o[s];
                        n || (n = o[s] = []), n.push(e1[i]);
                    }
                    const i = [];
                    for(const e1 in o)i.push(o[e1]);
                    return i;
                }(e1.v(this._layerConfigs), this.keyCache);
                for (const e1 of s){
                    const t = e1.map((e1)=>this._layers[e1.id]), r = t[0];
                    if ("none" === r.visibility) continue;
                    const o = r.source || "";
                    let i = this.familiesBySource[o];
                    i || (i = this.familiesBySource[o] = {});
                    const s = r.sourceLayer || "_geojsonTileLayer";
                    let n = i[s];
                    n || (n = i[s] = []), n.push(t);
                }
            }
        }
        class i {
            loadTile(t, r) {
                const { uid: o, encoding: i, rawImageData: s, padding: n } = t, a = e1.w.ImageBitmap && s instanceof e1.w.ImageBitmap ? this.getImageData(s, n) : s;
                r(null, new e1.D(o, a, i, n < 1));
            }
            getImageData(e1, t) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                const r = this.offscreenCanvasContext.getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), r;
            }
        }
        function s(e1, t) {
            if (0 !== e1.length) {
                n(e1[0], t);
                for(var r = 1; r < e1.length; r++)n(e1[r], !t);
            }
        }
        function n(e1, t) {
            for(var r = 0, o = 0, i = 0, s = e1.length, n = s - 1; i < s; n = i++){
                var a = (e1[i][0] - e1[n][0]) * (e1[n][1] + e1[i][1]), l = r + a;
                o += Math.abs(r) >= Math.abs(a) ? r - l + a : a - l + r, r = l;
            }
            r + o >= 0 != !!t && e1.reverse();
        }
        var a = e1.g(function e1(t, r) {
            var o, i = t && t.type;
            if ("FeatureCollection" === i) for(o = 0; o < t.features.length; o++)e1(t.features[o], r);
            else if ("GeometryCollection" === i) for(o = 0; o < t.geometries.length; o++)e1(t.geometries[o], r);
            else if ("Feature" === i) e1(t.geometry, r);
            else if ("Polygon" === i) s(t.coordinates, r);
            else if ("MultiPolygon" === i) for(o = 0; o < t.coordinates.length; o++)s(t.coordinates[o], r);
            return t;
        });
        const l = e1.V.prototype.toGeoJSON;
        var h = {
            exports: {}
        }, u = e1.p, c = e1.a.VectorTileFeature, f = d;
        function d(e1, t) {
            this.options = t || {}, this.features = e1, this.length = e1.length;
        }
        function p(e1, t) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t || 4096;
        }
        d.prototype.feature = function(e1) {
            return new p(this.features[e1], this.options.extent);
        }, p.prototype.loadGeometry = function() {
            var e1 = this.rawGeometry;
            this.geometry = [];
            for(var t = 0; t < e1.length; t++){
                for(var r = e1[t], o = [], i = 0; i < r.length; i++)o.push(new u(r[i][0], r[i][1]));
                this.geometry.push(o);
            }
            return this.geometry;
        }, p.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t = 1 / 0, r = -1 / 0, o = 1 / 0, i = -1 / 0, s = 0; s < e1.length; s++)for(var n = e1[s], a = 0; a < n.length; a++){
                var l = n[a];
                t = Math.min(t, l.x), r = Math.max(r, l.x), o = Math.min(o, l.y), i = Math.max(i, l.y);
            }
            return [
                t,
                o,
                r,
                i
            ];
        }, p.prototype.toGeoJSON = c.prototype.toGeoJSON;
        var g = e1.b, m = f;
        function y(e1) {
            var t = new g;
            return function(e1, t) {
                for(var r in e1.layers)t.writeMessage(3, v, e1.layers[r]);
            }(e1, t), t.finish();
        }
        function v(e1, t) {
            var r;
            t.writeVarintField(15, e1.version || 1), t.writeStringField(1, e1.name || ""), t.writeVarintField(5, e1.extent || 4096);
            var o = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(r = 0; r < e1.length; r++)o.feature = e1.feature(r), t.writeMessage(2, w, o);
            var i = o.keys;
            for(r = 0; r < i.length; r++)t.writeStringField(3, i[r]);
            var s = o.values;
            for(r = 0; r < s.length; r++)t.writeMessage(4, I, s[r]);
        }
        function w(e1, t) {
            var r = e1.feature;
            void 0 !== r.id && t.writeVarintField(1, r.id), t.writeMessage(2, x, e1), t.writeVarintField(3, r.type), t.writeMessage(4, b, r);
        }
        function x(e1, t) {
            var r = e1.feature, o = e1.keys, i = e1.values, s = e1.keycache, n = e1.valuecache;
            for(var a in r.properties){
                var l = r.properties[a], h = s[a];
                if (null !== l) {
                    void 0 === h && (o.push(a), s[a] = h = o.length - 1), t.writeVarint(h);
                    var u = typeof l;
                    "string" !== u && "boolean" !== u && "number" !== u && (l = JSON.stringify(l));
                    var c = u + ":" + l, f = n[c];
                    void 0 === f && (i.push(l), n[c] = f = i.length - 1), t.writeVarint(f);
                }
            }
        }
        function S(e1, t) {
            return (t << 3) + (7 & e1);
        }
        function M(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function b(e1, t) {
            for(var r = e1.loadGeometry(), o = e1.type, i = 0, s = 0, n = r.length, a = 0; a < n; a++){
                var l = r[a], h = 1;
                1 === o && (h = l.length), t.writeVarint(S(1, h));
                for(var u = 3 === o ? l.length - 1 : l.length, c = 0; c < u; c++){
                    1 === c && 1 !== o && t.writeVarint(S(2, u - 1));
                    var f = l[c].x - i, d = l[c].y - s;
                    t.writeVarint(M(f)), t.writeVarint(M(d)), i += f, s += d;
                }
                3 === o && t.writeVarint(S(7, 1));
            }
        }
        function I(e1, t) {
            var r = typeof e1;
            "string" === r ? t.writeStringField(1, e1) : "boolean" === r ? t.writeBooleanField(7, e1) : "number" === r && (e1 % 1 != 0 ? t.writeDoubleField(3, e1) : e1 < 0 ? t.writeSVarintField(6, e1) : t.writeVarintField(5, e1));
        }
        h.exports = y, h.exports.fromVectorTileJs = y, h.exports.fromGeojsonVt = function(e1, t) {
            t = t || {};
            var r = {};
            for(var o in e1)r[o] = new m(e1[o].features, t), r[o].name = o, r[o].version = t.version, r[o].extent = t.extent;
            return y({
                layers: r
            });
        }, h.exports.GeoJSONWrapper = m;
        var k = e1.g(h.exports);
        const P = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, _ = Math.fround || (L = new Float32Array(1), (e1)=>(L[0] = +e1, L[0]));
        var L;
        const T = 3, C = 5, O = 6;
        class j {
            constructor(e1){
                this.options = Object.assign(Object.create(P), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e1) {
                const { log: t, minZoom: r, maxZoom: o } = this.options;
                t && console.time("total time");
                const i = `prepare ${e1.length} points`;
                t && console.time(i), this.points = e1;
                const s = [];
                for(let t = 0; t < e1.length; t++){
                    const r = e1[t];
                    if (!r.geometry) continue;
                    const [o, i] = r.geometry.coordinates, n = _(z(o)), a = _(D(i));
                    s.push(n, a, 1 / 0, t, -1, 1), this.options.reduce && s.push(0);
                }
                let n = this.trees[o + 1] = this._createTree(s);
                t && console.timeEnd(i);
                for(let e1 = o; e1 >= r; e1--){
                    const r = +Date.now();
                    n = this.trees[e1] = this._createTree(this._cluster(n, e1)), t && console.log("z%d: %d clusters in %dms", e1, n.numItems, +Date.now() - r);
                }
                return t && console.timeEnd("total time"), this;
            }
            getClusters(e1, t) {
                let r = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const o = Math.max(-90, Math.min(90, e1[1]));
                let i = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) r = -180, i = 180;
                else if (r > i) {
                    const e1 = this.getClusters([
                        r,
                        o,
                        180,
                        s
                    ], t), n = this.getClusters([
                        -180,
                        o,
                        i,
                        s
                    ], t);
                    return e1.concat(n);
                }
                const n = this.trees[this._limitZoom(t)], a = n.range(z(r), D(s), z(i), D(o)), l = n.data, h = [];
                for (const e1 of a){
                    const t = this.stride * e1;
                    h.push(l[t + C] > 1 ? F(l, t, this.clusterProps) : this.points[l[t + T]]);
                }
                return h;
            }
            getChildren(e1) {
                const t = this._getOriginId(e1), r = this._getOriginZoom(e1), o = "No cluster with the specified id.", i = this.trees[r];
                if (!i) throw new Error(o);
                const s = i.data;
                if (t * this.stride >= s.length) throw new Error(o);
                const n = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), a = i.within(s[t * this.stride], s[t * this.stride + 1], n), l = [];
                for (const t of a){
                    const r = t * this.stride;
                    s[r + 4] === e1 && l.push(s[r + C] > 1 ? F(s, r, this.clusterProps) : this.points[s[r + T]]);
                }
                if (0 === l.length) throw new Error(o);
                return l;
            }
            getLeaves(e1, t, r) {
                const o = [];
                return this._appendLeaves(o, e1, t = t || 10, r = r || 0, 0), o;
            }
            getTile(e1, t, r) {
                const o = this.trees[this._limitZoom(e1)], i = Math.pow(2, e1), { extent: s, radius: n } = this.options, a = n / s, l = (r - a) / i, h = (r + 1 + a) / i, u = {
                    features: []
                };
                return this._addTileFeatures(o.range((t - a) / i, l, (t + 1 + a) / i, h), o.data, t, r, i, u), 0 === t && this._addTileFeatures(o.range(1 - a / i, l, 1, h), o.data, i, r, i, u), t === i - 1 && this._addTileFeatures(o.range(0, l, a / i, h), o.data, -1, r, i, u), u.features.length ? u : null;
            }
            getClusterExpansionZoom(e1) {
                let t = this._getOriginZoom(e1) - 1;
                for(; t <= this.options.maxZoom;){
                    const r = this.getChildren(e1);
                    if (t++, 1 !== r.length) break;
                    e1 = r[0].properties.cluster_id;
                }
                return t;
            }
            _appendLeaves(e1, t, r, o, i) {
                const s = this.getChildren(t);
                for (const t of s){
                    const s = t.properties;
                    if (s && s.cluster ? i + s.point_count <= o ? i += s.point_count : i = this._appendLeaves(e1, s.cluster_id, r, o, i) : i < o ? i++ : e1.push(t), e1.length === r) break;
                }
                return i;
            }
            _createTree(t) {
                const r = new e1.K(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e1 = 0; e1 < t.length; e1 += this.stride)r.add(t[e1], t[e1 + 1]);
                return r.finish(), r.data = t, r;
            }
            _addTileFeatures(e1, t, r, o, i, s) {
                for (const n of e1){
                    const e1 = n * this.stride, a = t[e1 + C] > 1;
                    let l, h, u;
                    if (a) l = Z(t, e1, this.clusterProps), h = t[e1], u = t[e1 + 1];
                    else {
                        const r = this.points[t[e1 + T]];
                        l = r.properties;
                        const [o, i] = r.geometry.coordinates;
                        h = z(o), u = D(i);
                    }
                    const c = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (h * i - r)),
                                Math.round(this.options.extent * (u * i - o))
                            ]
                        ],
                        tags: l
                    };
                    let f;
                    f = a || this.options.generateId ? t[e1 + T] : this.points[t[e1 + T]].id, void 0 !== f && (c.id = f), s.features.push(c);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t) {
                const { radius: r, extent: o, reduce: i, minPoints: s } = this.options, n = r / (o * Math.pow(2, t)), a = e1.data, l = [], h = this.stride;
                for(let r = 0; r < a.length; r += h){
                    if (a[r + 2] <= t) continue;
                    a[r + 2] = t;
                    const o = a[r], u = a[r + 1], c = e1.within(a[r], a[r + 1], n), f = a[r + C];
                    let d = f;
                    for (const e1 of c){
                        const r = e1 * h;
                        a[r + 2] > t && (d += a[r + C]);
                    }
                    if (d > f && d >= s) {
                        let e1, s = o * f, n = u * f, p = -1;
                        const g = ((r / h | 0) << 5) + (t + 1) + this.points.length;
                        for (const o of c){
                            const l = o * h;
                            if (a[l + 2] <= t) continue;
                            a[l + 2] = t;
                            const u = a[l + C];
                            s += a[l] * u, n += a[l + 1] * u, a[l + 4] = g, i && (e1 || (e1 = this._map(a, r, !0), p = this.clusterProps.length, this.clusterProps.push(e1)), i(e1, this._map(a, l)));
                        }
                        a[r + 4] = g, l.push(s / d, n / d, 1 / 0, g, -1, d), i && l.push(p);
                    } else {
                        for(let e1 = 0; e1 < h; e1++)l.push(a[r + e1]);
                        if (d > 1) for (const e1 of c){
                            const r = e1 * h;
                            if (!(a[r + 2] <= t)) {
                                a[r + 2] = t;
                                for(let e1 = 0; e1 < h; e1++)l.push(a[r + e1]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t, r) {
                if (e1[t + C] > 1) {
                    const o = this.clusterProps[e1[t + O]];
                    return r ? Object.assign({}, o) : o;
                }
                const o = this.points[e1[t + T]].properties, i = this.options.map(o);
                return r && i === o ? Object.assign({}, i) : i;
            }
        }
        function F(e1, t, r) {
            var o;
            return {
                type: "Feature",
                id: e1[t + T],
                properties: Z(e1, t, r),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (o = e1[t], 360 * (o - .5)),
                        E(e1[t + 1])
                    ]
                }
            };
        }
        function Z(e1, t, r) {
            const o = e1[t + C], i = o >= 1e4 ? `${Math.round(o / 1e3)}k` : o >= 1e3 ? Math.round(o / 100) / 10 + "k" : o, s = e1[t + O], n = -1 === s ? {} : Object.assign({}, r[s]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e1[t + T],
                point_count: o,
                point_count_abbreviated: i
            });
        }
        function z(e1) {
            return e1 / 360 + .5;
        }
        function D(e1) {
            const t = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function E(e1) {
            const t = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        var N = {
            exports: {}
        };
        N.exports = function() {
            function e1(r, o, i, s) {
                for(var n, a = s, l = i - o >> 1, h = i - o, u = r[o], c = r[o + 1], f = r[i], d = r[i + 1], p = o + 3; p < i; p += 3){
                    var g = t(r[p], r[p + 1], u, c, f, d);
                    if (g > a) n = p, a = g;
                    else if (g === a) {
                        var m = Math.abs(p - l);
                        m < h && (n = p, h = m);
                    }
                }
                a > s && (n - o > 3 && e1(r, o, n, s), r[n + 2] = a, i - n > 3 && e1(r, n, i, s));
            }
            function t(e1, t, r, o, i, s) {
                var n = i - r, a = s - o;
                if (0 !== n || 0 !== a) {
                    var l = ((e1 - r) * n + (t - o) * a) / (n * n + a * a);
                    l > 1 ? (r = i, o = s) : l > 0 && (r += n * l, o += a * l);
                }
                return (n = e1 - r) * n + (a = t - o) * a;
            }
            function r(e1, t, r, i) {
                var s = {
                    id: void 0 === e1 ? null : e1,
                    type: t,
                    geometry: r,
                    tags: i,
                    minX: 1 / 0,
                    minY: 1 / 0,
                    maxX: -1 / 0,
                    maxY: -1 / 0
                };
                return function(e1) {
                    var t = e1.geometry, r = e1.type;
                    if ("Point" === r || "MultiPoint" === r || "LineString" === r) o(e1, t);
                    else if ("Polygon" === r || "MultiLineString" === r) for(var i = 0; i < t.length; i++)o(e1, t[i]);
                    else if ("MultiPolygon" === r) for(i = 0; i < t.length; i++)for(var s = 0; s < t[i].length; s++)o(e1, t[i][s]);
                }(s), s;
            }
            function o(e1, t) {
                for(var r = 0; r < t.length; r += 3)e1.minX = Math.min(e1.minX, t[r]), e1.minY = Math.min(e1.minY, t[r + 1]), e1.maxX = Math.max(e1.maxX, t[r]), e1.maxY = Math.max(e1.maxY, t[r + 1]);
            }
            function i(e1, t, o, l) {
                if (t.geometry) {
                    var h = t.geometry.coordinates, u = t.geometry.type, c = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2), f = [], d = t.id;
                    if (o.promoteId ? d = t.properties[o.promoteId] : o.generateId && (d = l || 0), "Point" === u) s(h, f);
                    else if ("MultiPoint" === u) for(var p = 0; p < h.length; p++)s(h[p], f);
                    else if ("LineString" === u) n(h, f, c, !1);
                    else if ("MultiLineString" === u) {
                        if (o.lineMetrics) {
                            for(p = 0; p < h.length; p++)n(h[p], f = [], c, !1), e1.push(r(d, "LineString", f, t.properties));
                            return;
                        }
                        a(h, f, c, !1);
                    } else if ("Polygon" === u) a(h, f, c, !0);
                    else {
                        if ("MultiPolygon" !== u) {
                            if ("GeometryCollection" === u) {
                                for(p = 0; p < t.geometry.geometries.length; p++)i(e1, {
                                    id: d,
                                    geometry: t.geometry.geometries[p],
                                    properties: t.properties
                                }, o, l);
                                return;
                            }
                            throw new Error("Input data is not a valid GeoJSON object.");
                        }
                        for(p = 0; p < h.length; p++){
                            var g = [];
                            a(h[p], g, c, !0), f.push(g);
                        }
                    }
                    e1.push(r(d, u, f, t.properties));
                }
            }
            function s(e1, t) {
                t.push(l(e1[0])), t.push(h(e1[1])), t.push(0);
            }
            function n(t, r, o, i) {
                for(var s, n, a = 0, u = 0; u < t.length; u++){
                    var c = l(t[u][0]), f = h(t[u][1]);
                    r.push(c), r.push(f), r.push(0), u > 0 && (a += i ? (s * f - c * n) / 2 : Math.sqrt(Math.pow(c - s, 2) + Math.pow(f - n, 2))), s = c, n = f;
                }
                var d = r.length - 3;
                r[2] = 1, e1(r, 0, d, o), r[d + 2] = 1, r.size = Math.abs(a), r.start = 0, r.end = r.size;
            }
            function a(e1, t, r, o) {
                for(var i = 0; i < e1.length; i++){
                    var s = [];
                    n(e1[i], s, r, o), t.push(s);
                }
            }
            function l(e1) {
                return e1 / 360 + .5;
            }
            function h(e1) {
                var t = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
                return r < 0 ? 0 : r > 1 ? 1 : r;
            }
            function u(e1, t, o, i, s, n, a, l) {
                if (i /= t, n >= (o /= t) && a < i) return e1;
                if (a < o || n >= i) return null;
                for(var h = [], u = 0; u < e1.length; u++){
                    var d = e1[u], g = d.geometry, m = d.type, y = 0 === s ? d.minX : d.minY, v = 0 === s ? d.maxX : d.maxY;
                    if (y >= o && v < i) h.push(d);
                    else if (!(v < o || y >= i)) {
                        var w = [];
                        if ("Point" === m || "MultiPoint" === m) c(g, w, o, i, s);
                        else if ("LineString" === m) f(g, w, o, i, s, !1, l.lineMetrics);
                        else if ("MultiLineString" === m) p(g, w, o, i, s, !1);
                        else if ("Polygon" === m) p(g, w, o, i, s, !0);
                        else if ("MultiPolygon" === m) for(var x = 0; x < g.length; x++){
                            var S = [];
                            p(g[x], S, o, i, s, !0), S.length && w.push(S);
                        }
                        if (w.length) {
                            if (l.lineMetrics && "LineString" === m) {
                                for(x = 0; x < w.length; x++)h.push(r(d.id, m, w[x], d.tags));
                                continue;
                            }
                            "LineString" !== m && "MultiLineString" !== m || (1 === w.length ? (m = "LineString", w = w[0]) : m = "MultiLineString"), "Point" !== m && "MultiPoint" !== m || (m = 3 === w.length ? "Point" : "MultiPoint"), h.push(r(d.id, m, w, d.tags));
                        }
                    }
                }
                return h.length ? h : null;
            }
            function c(e1, t, r, o, i) {
                for(var s = 0; s < e1.length; s += 3){
                    var n = e1[s + i];
                    n >= r && n <= o && (t.push(e1[s]), t.push(e1[s + 1]), t.push(e1[s + 2]));
                }
            }
            function f(e1, t, r, o, i, s, n) {
                for(var a, l, h = d(e1), u = 0 === i ? m : y, c = e1.start, f = 0; f < e1.length - 3; f += 3){
                    var p = e1[f], v = e1[f + 1], w = e1[f + 2], x = e1[f + 3], S = e1[f + 4], M = 0 === i ? p : v, b = 0 === i ? x : S, I = !1;
                    n && (a = Math.sqrt(Math.pow(p - x, 2) + Math.pow(v - S, 2))), M < r ? b > r && (l = u(h, p, v, x, S, r), n && (h.start = c + a * l)) : M > o ? b < o && (l = u(h, p, v, x, S, o), n && (h.start = c + a * l)) : g(h, p, v, w), b < r && M >= r && (l = u(h, p, v, x, S, r), I = !0), b > o && M <= o && (l = u(h, p, v, x, S, o), I = !0), !s && I && (n && (h.end = c + a * l), t.push(h), h = d(e1)), n && (c += a);
                }
                var k = e1.length - 3;
                p = e1[k], v = e1[k + 1], w = e1[k + 2], (M = 0 === i ? p : v) >= r && M <= o && g(h, p, v, w), k = h.length - 3, s && k >= 3 && (h[k] !== h[0] || h[k + 1] !== h[1]) && g(h, h[0], h[1], h[2]), h.length && t.push(h);
            }
            function d(e1) {
                var t = [];
                return t.size = e1.size, t.start = e1.start, t.end = e1.end, t;
            }
            function p(e1, t, r, o, i, s) {
                for(var n = 0; n < e1.length; n++)f(e1[n], t, r, o, i, s, !1);
            }
            function g(e1, t, r, o) {
                e1.push(t), e1.push(r), e1.push(o);
            }
            function m(e1, t, r, o, i, s) {
                var n = (s - t) / (o - t);
                return e1.push(s), e1.push(r + (i - r) * n), e1.push(1), n;
            }
            function y(e1, t, r, o, i, s) {
                var n = (s - r) / (i - r);
                return e1.push(t + (o - t) * n), e1.push(s), e1.push(1), n;
            }
            function v(e1, t) {
                for(var o = [], i = 0; i < e1.length; i++){
                    var s, n = e1[i], a = n.type;
                    if ("Point" === a || "MultiPoint" === a || "LineString" === a) s = w(n.geometry, t);
                    else if ("MultiLineString" === a || "Polygon" === a) {
                        s = [];
                        for(var l = 0; l < n.geometry.length; l++)s.push(w(n.geometry[l], t));
                    } else if ("MultiPolygon" === a) for(s = [], l = 0; l < n.geometry.length; l++){
                        for(var h = [], u = 0; u < n.geometry[l].length; u++)h.push(w(n.geometry[l][u], t));
                        s.push(h);
                    }
                    o.push(r(n.id, a, s, n.tags));
                }
                return o;
            }
            function w(e1, t) {
                var r = [];
                r.size = e1.size, void 0 !== e1.start && (r.start = e1.start, r.end = e1.end);
                for(var o = 0; o < e1.length; o += 3)r.push(e1[o] + t, e1[o + 1], e1[o + 2]);
                return r;
            }
            function x(e1, t) {
                if (e1.transformed) return e1;
                var r, o, i, s = 1 << e1.z, n = e1.x, a = e1.y;
                for(r = 0; r < e1.features.length; r++){
                    var l = e1.features[r], h = l.geometry, u = l.type;
                    if (l.geometry = [], 1 === u) for(o = 0; o < h.length; o += 2)l.geometry.push(S(h[o], h[o + 1], t, s, n, a));
                    else for(o = 0; o < h.length; o++){
                        var c = [];
                        for(i = 0; i < h[o].length; i += 2)c.push(S(h[o][i], h[o][i + 1], t, s, n, a));
                        l.geometry.push(c);
                    }
                }
                return e1.transformed = !0, e1;
            }
            function S(e1, t, r, o, i, s) {
                return [
                    Math.round(r * (e1 * o - i)),
                    Math.round(r * (t * o - s))
                ];
            }
            function M(e1, t, r, o, i) {
                for(var s = t === i.maxZoom ? 0 : i.tolerance / ((1 << t) * i.extent), n = {
                    features: [],
                    numPoints: 0,
                    numSimplified: 0,
                    numFeatures: 0,
                    source: null,
                    x: r,
                    y: o,
                    z: t,
                    transformed: !1,
                    minX: 2,
                    minY: 1,
                    maxX: -1,
                    maxY: 0
                }, a = 0; a < e1.length; a++){
                    n.numFeatures++, b(n, e1[a], s, i);
                    var l = e1[a].minX, h = e1[a].minY, u = e1[a].maxX, c = e1[a].maxY;
                    l < n.minX && (n.minX = l), h < n.minY && (n.minY = h), u > n.maxX && (n.maxX = u), c > n.maxY && (n.maxY = c);
                }
                return n;
            }
            function b(e1, t, r, o) {
                var i = t.geometry, s = t.type, n = [];
                if ("Point" === s || "MultiPoint" === s) for(var a = 0; a < i.length; a += 3)n.push(i[a]), n.push(i[a + 1]), e1.numPoints++, e1.numSimplified++;
                else if ("LineString" === s) I(n, i, e1, r, !1, !1);
                else if ("MultiLineString" === s || "Polygon" === s) for(a = 0; a < i.length; a++)I(n, i[a], e1, r, "Polygon" === s, 0 === a);
                else if ("MultiPolygon" === s) for(var l = 0; l < i.length; l++){
                    var h = i[l];
                    for(a = 0; a < h.length; a++)I(n, h[a], e1, r, !0, 0 === a);
                }
                if (n.length) {
                    var u = t.tags || null;
                    if ("LineString" === s && o.lineMetrics) {
                        for(var c in u = {}, t.tags)u[c] = t.tags[c];
                        u.mapbox_clip_start = i.start / i.size, u.mapbox_clip_end = i.end / i.size;
                    }
                    var f = {
                        geometry: n,
                        type: "Polygon" === s || "MultiPolygon" === s ? 3 : "LineString" === s || "MultiLineString" === s ? 2 : 1,
                        tags: u
                    };
                    null !== t.id && (f.id = t.id), e1.features.push(f);
                }
            }
            function I(e1, t, r, o, i, s) {
                var n = o * o;
                if (o > 0 && t.size < (i ? n : o)) r.numPoints += t.length / 3;
                else {
                    for(var a = [], l = 0; l < t.length; l += 3)(0 === o || t[l + 2] > n) && (r.numSimplified++, a.push(t[l]), a.push(t[l + 1])), r.numPoints++;
                    i && function(e1, t) {
                        for(var r = 0, o = 0, i = e1.length, s = i - 2; o < i; s = o, o += 2)r += (e1[o] - e1[s]) * (e1[o + 1] + e1[s + 1]);
                        if (r > 0 === t) for(o = 0, i = e1.length; o < i / 2; o += 2){
                            var n = e1[o], a = e1[o + 1];
                            e1[o] = e1[i - 2 - o], e1[o + 1] = e1[i - 1 - o], e1[i - 2 - o] = n, e1[i - 1 - o] = a;
                        }
                    }(a, s), e1.push(a);
                }
            }
            function k(e1, t) {
                var r = (t = this.options = function(e1, t) {
                    for(var r in t)e1[r] = t[r];
                    return e1;
                }(Object.create(this.options), t)).debug;
                if (r && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
                var o = function(e1, t) {
                    var r = [];
                    if ("FeatureCollection" === e1.type) for(var o = 0; o < e1.features.length; o++)i(r, e1.features[o], t, o);
                    else i(r, "Feature" === e1.type ? e1 : {
                        geometry: e1
                    }, t);
                    return r;
                }(e1, t);
                this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (o = function(e1, t) {
                    var r = t.buffer / t.extent, o = e1, i = u(e1, 1, -1 - r, r, 0, -1, 2, t), s = u(e1, 1, 1 - r, 2 + r, 0, -1, 2, t);
                    return (i || s) && (o = u(e1, 1, -r, 1 + r, 0, -1, 2, t) || [], i && (o = v(i, 1).concat(o)), s && (o = o.concat(v(s, -1)))), o;
                }(o, t)).length && this.splitTile(o, 0, 0, 0), r && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            function P(e1, t, r) {
                return 32 * ((1 << e1) * r + t) + e1;
            }
            return k.prototype.options = {
                maxZoom: 14,
                indexMaxZoom: 5,
                indexMaxPoints: 1e5,
                tolerance: 3,
                extent: 4096,
                buffer: 64,
                lineMetrics: !1,
                promoteId: null,
                generateId: !1,
                debug: 0
            }, k.prototype.splitTile = function(e1, t, r, o, i, s, n) {
                for(var a = [
                    e1,
                    t,
                    r,
                    o
                ], l = this.options, h = l.debug; a.length;){
                    o = a.pop(), r = a.pop(), t = a.pop(), e1 = a.pop();
                    var c = 1 << t, f = P(t, r, o), d = this.tiles[f];
                    if (!d && (h > 1 && console.time("creation"), d = this.tiles[f] = M(e1, t, r, o, l), this.tileCoords.push({
                        z: t,
                        x: r,
                        y: o
                    }), h)) {
                        h > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, r, o, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        var p = "z" + t;
                        this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                    }
                    if (d.source = e1, i) {
                        if (t === l.maxZoom || t === i) continue;
                        var g = 1 << i - t;
                        if (r !== Math.floor(s / g) || o !== Math.floor(n / g)) continue;
                    } else if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    if (d.source = null, 0 !== e1.length) {
                        h > 1 && console.time("clipping");
                        var m, y, v, w, x, S, b = .5 * l.buffer / l.extent, I = .5 - b, k = .5 + b, _ = 1 + b;
                        m = y = v = w = null, x = u(e1, c, r - b, r + k, 0, d.minX, d.maxX, l), S = u(e1, c, r + I, r + _, 0, d.minX, d.maxX, l), e1 = null, x && (m = u(x, c, o - b, o + k, 1, d.minY, d.maxY, l), y = u(x, c, o + I, o + _, 1, d.minY, d.maxY, l), x = null), S && (v = u(S, c, o - b, o + k, 1, d.minY, d.maxY, l), w = u(S, c, o + I, o + _, 1, d.minY, d.maxY, l), S = null), h > 1 && console.timeEnd("clipping"), a.push(m || [], t + 1, 2 * r, 2 * o), a.push(y || [], t + 1, 2 * r, 2 * o + 1), a.push(v || [], t + 1, 2 * r + 1, 2 * o), a.push(w || [], t + 1, 2 * r + 1, 2 * o + 1);
                    }
                }
            }, k.prototype.getTile = function(e1, t, r) {
                var o = this.options, i = o.extent, s = o.debug;
                if (e1 < 0 || e1 > 24) return null;
                var n = 1 << e1, a = P(e1, t = (t % n + n) % n, r);
                if (this.tiles[a]) return x(this.tiles[a], i);
                s > 1 && console.log("drilling down to z%d-%d-%d", e1, t, r);
                for(var l, h = e1, u = t, c = r; !l && h > 0;)h--, u = Math.floor(u / 2), c = Math.floor(c / 2), l = this.tiles[P(h, u, c)];
                return l && l.source ? (s > 1 && console.log("found parent tile z%d-%d-%d", h, u, c), s > 1 && console.time("drilling down"), this.splitTile(l.source, h, u, c, e1, t, r), s > 1 && console.timeEnd("drilling down"), this.tiles[a] ? x(this.tiles[a], i) : null) : null;
            }, function(e1, t) {
                return new k(e1, t);
            };
        }();
        var J = e1.g(N.exports);
        function Y(t, r) {
            const o = t.tileID.canonical;
            if (!this._geoJSONIndex) return r(null, null);
            const i = this._geoJSONIndex.getTile(o.z, o.x, o.y);
            if (!i) return r(null, null);
            const s = new class {
                constructor(t){
                    this.layers = {
                        _geojsonTileLayer: this
                    }, this.name = "_geojsonTileLayer", this.extent = e1.E, this.length = t.length, this._features = t;
                }
                feature(t) {
                    return new class {
                        constructor(t){
                            this._feature = t, this.extent = e1.E, this.type = t.type, this.properties = t.tags, "id" in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10));
                        }
                        loadGeometry() {
                            if (1 === this._feature.type) {
                                const t = [];
                                for (const r of this._feature.geometry)t.push([
                                    new e1.P(r[0], r[1])
                                ]);
                                return t;
                            }
                            {
                                const t = [];
                                for (const r of this._feature.geometry){
                                    const o = [];
                                    for (const t of r)o.push(new e1.P(t[0], t[1]));
                                    t.push(o);
                                }
                                return t;
                            }
                        }
                        toGeoJSON(e1, t, r) {
                            return l.call(this, e1, t, r);
                        }
                    }(this._features[t]);
                }
            }(i.features);
            let n = k(s);
            0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), r(null, {
                vectorTile: s,
                rawData: n.buffer
            });
        }
        class G extends e1.d {
            constructor(e1, t, r, o, i, s){
                super(e1, t, r, o, Y, s), i && (this.loadGeoJSON = i);
            }
            loadData(t, r) {
                const o = t && t.request, i = o && o.collectResourceTiming;
                this.loadGeoJSON(t, (s, n)=>{
                    if (s || !n) return r(s);
                    if ("object" != typeof n) return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    {
                        a(n, !0);
                        try {
                            if (t.filter) {
                                const r = e1.e(t.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === r.result) throw new Error(r.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                                const o = n.features.filter((e1)=>r.value.evaluate({
                                        zoom: 0
                                    }, e1));
                                n = {
                                    type: "FeatureCollection",
                                    features: o
                                };
                            }
                            this._geoJSONIndex = t.cluster ? new j(function({ superclusterOptions: t, clusterProperties: r }) {
                                if (!r || !t) return t;
                                const o = {}, i = {}, s = {
                                    accumulated: null,
                                    zoom: 0
                                }, n = {
                                    properties: null
                                }, a = Object.keys(r);
                                for (const t of a){
                                    const [s, n] = r[t], a = e1.e(n), l = e1.e("string" == typeof s ? [
                                        s,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t
                                        ]
                                    ] : s);
                                    o[t] = a.value, i[t] = l.value;
                                }
                                return t.map = (e1)=>{
                                    n.properties = e1;
                                    const t = {};
                                    for (const e1 of a)t[e1] = o[e1].evaluate(s, n);
                                    return t;
                                }, t.reduce = (e1, t)=>{
                                    n.properties = t;
                                    for (const t of a)s.accumulated = e1[t], e1[t] = i[t].evaluate(s, n);
                                }, t;
                            }(t)).load(n.features) : J(n, t.geojsonVtOptions);
                        } catch (s) {
                            return r(s);
                        }
                        this.loaded = {};
                        const l = {};
                        if (i) {
                            const r = e1.f(o);
                            r && (l.resourceTiming = {}, l.resourceTiming[t.source] = JSON.parse(JSON.stringify(r)));
                        }
                        r(null, l);
                    }
                });
            }
            reloadTile(e1, t) {
                const r = this.loaded;
                return r && r[e1.uid] ? super.reloadTile(e1, t) : this.loadTile(e1, t);
            }
            loadGeoJSON(t, r) {
                if (t.request) e1.h(t.request, r);
                else {
                    if ("string" != typeof t.data) return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    try {
                        return r(null, JSON.parse(t.data));
                    } catch (e1) {
                        return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    }
                }
            }
            getClusterExpansionZoom(e1, t) {
                try {
                    t(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t(e1);
                }
            }
            getClusterChildren(e1, t) {
                try {
                    t(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t(e1);
                }
            }
            getClusterLeaves(e1, t) {
                try {
                    t(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t(e1);
                }
            }
        }
        class W {
            constructor(t, r){
                this.tileID = new e1.O(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.tileZoom = t.tileZoom, this.uid = t.uid, this.zoom = t.zoom, this.canonical = t.tileID.canonical, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t.projection, this.brightness = r;
            }
            parse(t, r, o, i) {
                this.status = "parsing";
                const s = new e1.O(o.tileID.overscaledZ, o.tileID.wrap, o.tileID.canonical.z, o.tileID.canonical.x, o.tileID.canonical.y), n = {}, a = r.familiesBySource[o.source], l = new e1.F(s, o.promoteId);
                return l.bucketLayerIDs = [], e1.l(t).then((t)=>{
                    if (!t) return i(new Error("Could not parse tile"));
                    const r = e1.j(t, 1 / e1.t(o.tileID.canonical)), h = t.json.extensionsUsed && t.json.extensionsUsed.includes("MAPBOX_mesh_features"), u = new e1.k(this.zoom, {
                        brightness: this.brightness
                    });
                    for(const o in a)for (const i of a[o]){
                        const o = i[0], a = t.json.extensionsUsed;
                        o.recalculate(u, []);
                        const l = new e1.T(r, s, a && a.includes("MAPBOX_mesh_features"), this.brightness);
                        h || (l.needsUpload = !0), n[o.fqid] = l, l.evaluate(o);
                    }
                    this.status = "done", i(null, {
                        buckets: n,
                        featureIndex: l
                    });
                }).catch((e1)=>i(new Error(e1.message)));
            }
        }
        class X {
            constructor(e1, t, r, o, i, s){
                this.actor = e1, this.layerIndex = t, this.brightness = s, this.loading = {}, this.loaded = {};
            }
            loadTile(t, r) {
                const o = t.uid, i = this.loading[o] = new W(t, this.brightness);
                e1.i(t.request, (e1, s)=>{
                    const n = !this.loading[o];
                    return delete this.loading[o], n || e1 ? (i.status = "done", n || (this.loaded[o] = i), r(e1)) : s && 0 !== s.byteLength ? void i.parse(s, this.layerIndex, t, (e1, t)=>{
                        i.status = "done", this.loaded = this.loaded || {}, this.loaded[o] = i, e1 || !t ? r(e1) : r(null, t);
                    }) : (i.status = "done", this.loaded[o] = i, r());
                });
            }
            reloadTile(e1, t) {
                const r = this.loaded, o = e1.uid;
                if (r && r[o]) {
                    const i = r[o];
                    i.projection = e1.projection, i.brightness = e1.brightness;
                    const s = (r, o)=>{
                        i.reloadCallback && (delete i.reloadCallback, this.loadTile(e1, t)), t(r, o);
                    };
                    "parsing" === i.status ? i.reloadCallback = s : "done" === i.status && this.loadTile(e1, t);
                }
            }
            abortTile(e1, t) {
                const r = e1.uid;
                this.loading[r] && delete this.loading[r], t();
            }
            removeTile(e1, t) {
                const r = this.loaded, o = e1.uid;
                r && r[o] && delete r[o], t();
            }
        }
        class V {
            constructor(t){
                this.self = t, this.actor = new e1.A(t, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e1.m({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: e1.d,
                    geojson: G,
                    "batched-model": X
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e1, t)=>{
                    if (this.workerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.workerSourceTypes[e1] = t;
                }, this.self.registerRTLTextPlugin = (t)=>{
                    if (e1.n.isParsed()) throw new Error("RTL text plugin already registered.");
                    e1.n.applyArabicShaping = t.applyArabicShaping, e1.n.processBidirectionalText = t.processBidirectionalText, e1.n.processStyledBidirectionalText = t.processStyledBidirectionalText;
                };
            }
            clearCaches(e1, t, r) {
                delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.workerSources[e1], delete this.demWorkerSources[e1], r();
            }
            checkIfReady(e1, t, r) {
                r();
            }
            setReferrer(e1, t) {
                this.referrer = t;
            }
            spriteLoaded(t, { scope: r, isLoaded: o }) {
                if (this.isSpriteLoaded[t] || (this.isSpriteLoaded[t] = {}), this.isSpriteLoaded[t][r] = o, this.workerSources[t] && this.workerSources[t][r]) for(const i in this.workerSources[t][r]){
                    const s = this.workerSources[t][r][i];
                    for(const t in s)s[t] instanceof e1.d && (s[t].isSpriteLoaded = o, s[t].fire(new e1.o("isSpriteLoaded")));
                }
            }
            setImages(e1, { scope: t, images: r }, o) {
                if (this.availableImages[e1] || (this.availableImages[e1] = {}), this.availableImages[e1][t] = r, this.workerSources[e1] && this.workerSources[e1][t]) {
                    for(const o in this.workerSources[e1][t]){
                        const i = this.workerSources[e1][t][o];
                        for(const e1 in i)i[e1].availableImages = r;
                    }
                    o();
                } else o();
            }
            setProjection(t, r) {
                this.projections[t] = e1.m(r);
            }
            setBrightness(e1, t, r) {
                this.brightness = t, r();
            }
            setLayers(e1, t, r) {
                this.getLayerIndex(e1, t.scope).replace(t.layers, t.options), r();
            }
            updateLayers(e1, t, r) {
                this.getLayerIndex(e1, t.scope).update(t.layers, t.removedIds, t.options), r();
            }
            loadTile(e1, t, r) {
                t.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t.type, t.source, t.scope).loadTile(t, r);
            }
            loadDEMTile(e1, t, r) {
                this.getDEMWorkerSource(e1, t.source, t.scope).loadTile(t, r);
            }
            reloadTile(e1, t, r) {
                t.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t.type, t.source, t.scope).reloadTile(t, r);
            }
            abortTile(e1, t, r) {
                this.getWorkerSource(e1, t.type, t.source, t.scope).abortTile(t, r);
            }
            removeTile(e1, t, r) {
                this.getWorkerSource(e1, t.type, t.source, t.scope).removeTile(t, r);
            }
            removeSource(e1, t, r) {
                if (!(this.workerSources[e1] && this.workerSources[e1][t.scope] && this.workerSources[e1][t.scope][t.type] && this.workerSources[e1][t.scope][t.type][t.source])) return;
                const o = this.workerSources[e1][t.scope][t.type][t.source];
                delete this.workerSources[e1][t.scope][t.type][t.source], void 0 !== o.removeSource ? o.removeSource(t, r) : r();
            }
            loadWorkerSource(e1, t, r) {
                try {
                    this.self.importScripts(t.url), r();
                } catch (e1) {
                    r(e1.toString());
                }
            }
            syncRTLPluginState(t, r, o) {
                try {
                    e1.n.setState(r);
                    const t = e1.n.getPluginURL();
                    if (e1.n.isLoaded() && !e1.n.isParsed() && null != t) {
                        this.self.importScripts(t);
                        const r = e1.n.isParsed();
                        o(r ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t}`), r);
                    }
                } catch (e1) {
                    o(e1.toString());
                }
            }
            setDracoUrl(e1, t) {
                this.dracoUrl = t;
            }
            getAvailableImages(e1, t) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                let r = this.availableImages[e1][t];
                return r || (r = []), r;
            }
            getLayerIndex(e1, t) {
                this.layerIndexes[e1] || (this.layerIndexes[e1] = {});
                let r = this.layerIndexes[e1][t];
                return r || (r = this.layerIndexes[e1][t] = new o, r.scope = t), r;
            }
            getWorkerSource(e1, t, r, o) {
                if (this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][o] || (this.workerSources[e1][o] = {}), this.workerSources[e1][o][t] || (this.workerSources[e1][o][t] = {}), this.isSpriteLoaded[e1] || (this.isSpriteLoaded[e1] = {}), !this.workerSources[e1][o][t][r]) {
                    const i = {
                        send: (t, r, o, i, s, n)=>{
                            this.actor.send(t, r, o, e1, s, n);
                        },
                        scheduler: this.actor.scheduler
                    };
                    this.workerSources[e1][o][t][r] = new this.workerSourceTypes[t](i, this.getLayerIndex(e1, o), this.getAvailableImages(e1, o), this.isSpriteLoaded[e1][o], void 0, this.brightness);
                }
                return this.workerSources[e1][o][t][r];
            }
            getDEMWorkerSource(e1, t, r) {
                return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][r] || (this.demWorkerSources[e1][r] = {}), this.demWorkerSources[e1][r][t] || (this.demWorkerSources[e1][r][t] = new i), this.demWorkerSources[e1][r][t];
            }
            enforceCacheSizeLimit(t, r) {
                e1.q(r);
            }
            getWorkerPerformanceMetrics(e1, t, r) {
                r(void 0, void 0);
            }
        }
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new V(self)), V;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        return e1.s;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'mapboxgl'
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});



var $8tsvq = parcelRequire("8tsvq");
(0, (/*@__PURE__*/$parcel$interopDefault($ccea77f5aa9cfa56$exports))).accessToken = "pk.eyJ1IjoibGluZGJsYWQtZXhwZWRpdGlvbnMiLCJhIjoiY2wxMXk2ZmNmMDF4bzNqczAxYXRzY3hhcyJ9.5vsFOrH2usOumgT-JUH28A";
const $42e2c2e54ddb26ec$var$InteractiveMap = ({ lng: lng, lat: lat, address: address })=>{
    const mapContainer = (0, $8tsvq.useRef)(null);
    const map = (0, $8tsvq.useRef)(null);
    const [isVisible, setIsVisible] = (0, $8tsvq.useState)(false);
    const [wasVisible, setWasVisible] = (0, $8tsvq.useState)(false);
    (0, $8tsvq.useEffect)(()=>{
        const onScroll = ()=>{
            const rect = mapContainer.current?.getBoundingClientRect();
            const isInview = rect && rect.top >= 0 && rect.bottom <= window.innerHeight;
            if (!wasVisible) {
                setIsVisible(isInview);
                if (isInview) setWasVisible(true);
            }
        };
        window.addEventListener("scroll", onScroll);
        return ()=>window.removeEventListener("scroll", onScroll);
    }, []);
    (0, $8tsvq.useEffect)(()=>{
        if (!isVisible) return;
        if (map.current) return; // initialize map only once
        map.current = new (0, (/*@__PURE__*/$parcel$interopDefault($ccea77f5aa9cfa56$exports))).Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [
                lng,
                lat
            ],
            zoom: 14
        });
        const marker = new (0, (/*@__PURE__*/$parcel$interopDefault($ccea77f5aa9cfa56$exports))).Marker({
            color: '#006CB5'
        }).setLngLat([
            lng,
            lat
        ]).addTo(map.current);
        if (address) {
            const popup = new (0, (/*@__PURE__*/$parcel$interopDefault($ccea77f5aa9cfa56$exports))).Popup({
                offset: 35
            }).setText(address).addTo(map.current);
            marker.setPopup(popup);
        }
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        ref: mapContainer,
        style: {
            height: 300
        }
    });
};
var $42e2c2e54ddb26ec$export$2e2bcd8739ae039 = $42e2c2e54ddb26ec$var$InteractiveMap;



const $f7dc38b5b672fa20$var$Location = ({ data: data, hideTitle: hideTitle })=>{
    const { internalName: internalName, locationType2: locationType2, location: location, addressText: addressText, phoneNumber: phoneNumber, website: website, timeDistanceToAirport: timeDistanceToAirport, timeDistanceToDock: timeDistanceToDock, timeDistanceToHotel: timeDistanceToHotel, timeDistanceToHospitalityRoom: timeDistanceToHospitalityRoom } = data.fields;
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        style: {
            marginTop: 20
        },
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    !hideTitle && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        className: "content_h4",
                        style: {
                            marginBottom: 10
                        },
                        children: internalName
                    }),
                    !hideTitle && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            locationType2 && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginBottom: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Features"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                        className: "list-style",
                        style: {
                            marginTop: 10
                        },
                        children: locationType2.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: v
                            }, v))
                    })
                ]
            }),
            addressText && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 15
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Address:"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: addressText
                    })
                ]
            }),
            location && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $42e2c2e54ddb26ec$export$2e2bcd8739ae039), {
                address: addressText,
                lng: location.lon,
                lat: location.lat
            }),
            phoneNumber && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Phone Number:"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                        href: `tel:${phoneNumber}`,
                        children: phoneNumber
                    })
                ]
            }),
            website && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "d-flex-align-center",
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Website:"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                        className: "link-wrap",
                        href: website,
                        target: "_blank",
                        children: website
                    })
                ]
            }),
            timeDistanceToAirport && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Airport"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToAirport
                    })
                ]
            }),
            timeDistanceToDock && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Dock"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToDock
                    })
                ]
            }),
            timeDistanceToHotel && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Hotel"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToHotel
                    })
                ]
            }),
            timeDistanceToHospitalityRoom && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Hospitality Room"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToHospitalityRoom
                    })
                ]
            })
        ]
    });
};
var $f7dc38b5b672fa20$export$2e2bcd8739ae039 = $f7dc38b5b672fa20$var$Location;


const $d76881503fb34ae5$var$AirportDetailed = ({ data: data })=>{
    const { airportName: airportName, location: location, airportCode: airportCode, airportWebsite: airportWebsite, timeDistanceToDock: timeDistanceToDock, timeDistanceToHotel: timeDistanceToHotel, timeDistanceToHospitalityRoom: timeDistanceToHospitalityRoom, additionalInfo: additionalInfo } = data.fields;
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        style: {
            marginBottom: 20
        },
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("b", {
                        className: "content_h4",
                        children: [
                            airportName,
                            " ",
                            airportCode && `(${airportCode})`
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            location && location.map((loc, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7dc38b5b672fa20$export$2e2bcd8739ae039), {
                    hideTitle: true,
                    data: loc
                }, i)),
            timeDistanceToDock && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Dock"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToDock
                    })
                ]
            }),
            timeDistanceToHotel && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Hotel"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToHotel
                    })
                ]
            }),
            timeDistanceToHospitalityRoom && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Hospitality Room"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToHospitalityRoom
                    })
                ]
            }),
            additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                data: additionalInfo,
                slug: "additionalInfo"
            })
        ]
    });
};
var $d76881503fb34ae5$export$2e2bcd8739ae039 = $d76881503fb34ae5$var$AirportDetailed;







const $5ca7d94104fc61e4$var$HotelSimple = ({ data: data })=>{
    const { internalNameEntryTitle: internalNameEntryTitle, hotelAddress: hotelAddress, hotelLocation: hotelLocation, additionalInfo: additionalInfo } = data.fields;
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        className: "content_h4",
                        style: {
                            marginBottom: 15
                        },
                        children: internalNameEntryTitle
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            hotelAddress && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 15
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Hotel Address:"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: hotelAddress
                    })
                ]
            }),
            hotelLocation && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $42e2c2e54ddb26ec$export$2e2bcd8739ae039), {
                address: hotelAddress,
                lng: hotelLocation.lon,
                lat: hotelLocation.lat
            }),
            additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                data: additionalInfo,
                slug: "additionalInfo"
            })
        ]
    });
};
var $5ca7d94104fc61e4$export$2e2bcd8739ae039 = $5ca7d94104fc61e4$var$HotelSimple;







const $b3c83cae613fa638$var$DockInformation = ({ data: data })=>{
    const { portDock: portDock, Dock: Dock, dockAddress: dockAddress, timeDistanceToAirport: timeDistanceToAirport, timeDistanceToHotel: timeDistanceToHotel, timeDistanceToHospitalityRoom: timeDistanceToHospitalityRoom, additionalInfo: additionalInfo } = data.fields;
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        className: "content_h4",
                        style: {
                            marginBottom: 15
                        },
                        children: portDock
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            dockAddress && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 15
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Dock Address:"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: dockAddress
                    })
                ]
            }),
            Dock && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $42e2c2e54ddb26ec$export$2e2bcd8739ae039), {
                address: dockAddress,
                lng: Dock.lon,
                lat: Dock.lat
            }),
            timeDistanceToAirport && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Airport"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToAirport
                    })
                ]
            }),
            timeDistanceToHotel && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Hotel"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToHotel
                    })
                ]
            }),
            timeDistanceToHospitalityRoom && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Time & Distance to Hospitality Room"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: timeDistanceToHospitalityRoom
                    })
                ]
            }),
            additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                data: additionalInfo,
                slug: "additionalInfo"
            })
        ]
    });
};
var $b3c83cae613fa638$export$2e2bcd8739ae039 = $b3c83cae613fa638$var$DockInformation;








const $be30f9f83269c2ed$var$AirportSimple = ({ data: data })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    const { airportName: airportName, airportCode: airportCode, locations: locations, airportAddress: airportAddress, additionalInfo: additionalInfo } = data.fields;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                style: {
                    marginBottom: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("b", {
                        className: "content_h4",
                        children: [
                            airportName,
                            " ",
                            airportCode && `(${airportCode})`
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            airportAddress && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 15
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Airport Address:"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: airportAddress
                    })
                ]
            }),
            locations && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $42e2c2e54ddb26ec$export$2e2bcd8739ae039), {
                address: airportAddress,
                lng: locations.lon,
                lat: locations.lat
            }),
            additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                data: additionalInfo,
                slug: "additionalInfo"
            })
        ]
    });
};
var $be30f9f83269c2ed$export$2e2bcd8739ae039 = $be30f9f83269c2ed$var$AirportSimple;









const $14ab153572ad8686$var$Hotel = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((el, i)=>{
                if (!el || !el.fields) return;
                const { name: name, hotelType: hotelType, hotelLocation: hotelLocation, hotelImages: hotelImages, hotelRoomFeatures: hotelRoomFeatures, link: link, phone: phone, shuttleOffered: shuttleOffered, shuttleArrangement: shuttleArrangement, additionalInfo: additionalInfo } = el.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    style: {
                        marginTop: 20
                    },
                    children: [
                        name && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            className: "content_h3",
                            children: name
                        }),
                        hotelType && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Hotel Type"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: hotelType.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        hotelLocation && hotelLocation.map((loc, i)=>{
                            const type = loc.sys.contentType.sys.id;
                            return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "block-style",
                                style: {
                                    marginTop: 20
                                },
                                children: [
                                    type === 'hotelSimple' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5ca7d94104fc61e4$export$2e2bcd8739ae039), {
                                        data: loc
                                    }),
                                    type === 'location' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7dc38b5b672fa20$export$2e2bcd8739ae039), {
                                        data: loc
                                    })
                                ]
                            }, i);
                        }),
                        hotelImages && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $316027d593e708f6$export$2e2bcd8739ae039), {
                            data: hotelImages
                        }),
                        hotelRoomFeatures && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Hotel Room Features"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: hotelRoomFeatures.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        link && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "d-flex-align-center",
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Website Link:"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "link-wrap",
                                    href: link,
                                    target: "_blank",
                                    children: link
                                })
                            ]
                        }),
                        phone && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Phone:"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    href: `tel:${phone}`,
                                    children: phone
                                })
                            ]
                        }),
                        shuttleOffered !== undefined && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Does the Hotel Have Its Own Shuttle?"
                                }),
                                shuttleOffered ? ' Yes' : ' No'
                            ]
                        }),
                        shuttleArrangement && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "How Does a Guest Arrange the Shuttle?"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: shuttleArrangement
                                })
                            ]
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $14ab153572ad8686$export$2e2bcd8739ae039 = $14ab153572ad8686$var$Hotel;


const $48fca6b33f67dc42$var$MeetingPoints = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        className: "content_h3",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((point, i)=>{
                if (!point || !point.fields) return;
                const type = point.sys.contentType.sys.id;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        type === 'hotel' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $14ab153572ad8686$export$2e2bcd8739ae039), {
                            data: [
                                point
                            ],
                            slug: "hotels"
                        }),
                        type === 'testAirportSimple' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $be30f9f83269c2ed$export$2e2bcd8739ae039), {
                            data: point
                        }),
                        type === 'airport' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d76881503fb34ae5$export$2e2bcd8739ae039), {
                            data: point
                        }),
                        type === 'hotelSimple' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5ca7d94104fc61e4$export$2e2bcd8739ae039), {
                            data: point
                        }),
                        type === 'dockInformation' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $b3c83cae613fa638$export$2e2bcd8739ae039), {
                            data: point
                        }),
                        type === 'location' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7dc38b5b672fa20$export$2e2bcd8739ae039), {
                            data: point
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $48fca6b33f67dc42$export$2e2bcd8739ae039 = $48fca6b33f67dc42$var$MeetingPoints;







const $58ca2a055b7e2a42$var$PublicTransportation = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                className: "content_h3",
                children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                date: date
            }),
            data.map((transport, i)=>{
                if (!transport || !transport.fields) return;
                const { entryTitle: entryTitle, publicTransportation: publicTransportation, publicTransportationLink: publicTransportationLink, additionalInfo: additionalInfo } = transport.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        entryTitle && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h4", {
                            className: "content_h4",
                            children: entryTitle
                        }),
                        publicTransportation && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Public Transportation:"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                    className: "list-style",
                                    dangerouslySetInnerHTML: {
                                        __html: (0, $e2ae5481ea3ab6f0$export$7baf571c7f59ce7c)(publicTransportation)
                                    }
                                })
                            ]
                        }),
                        publicTransportationLink && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "d-flex-align-center",
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Public Transportation Link:"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "link-wrap",
                                    href: publicTransportationLink,
                                    target: "_blank",
                                    children: publicTransportationLink
                                })
                            ]
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $58ca2a055b7e2a42$export$2e2bcd8739ae039 = $58ca2a055b7e2a42$var$PublicTransportation;


const $b752c4f2f516e8be$var$Arrivals = ({ data: data, slug: slug, isDeparture: isDeparture })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                date: date
            }),
            data.map((info, i)=>{
                if (!info || !info.fields) return;
                const { internalName: internalName, transferType: transferType, arrivalParameters: arrivalParameters, meetingPoints: meetingPoints, transferWindow: transferWindow, publicTransportation: publicTransportation, additionalInfo: additionalInfo } = info.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        internalName && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                            className: "content_h2",
                            style: {
                                marginBottom: 30
                            },
                            children: internalName
                        }),
                        transferType && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginBottom: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Transfer Type"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: transferType.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        arrivalParameters && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("b", {
                                    children: [
                                        isDeparture ? 'Departure' : 'Arrival',
                                        " Parameters"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: arrivalParameters
                                })
                            ]
                        }),
                        transferWindow && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Transfer Window"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: transferWindow
                                })
                            ]
                        }),
                        meetingPoints && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $48fca6b33f67dc42$export$2e2bcd8739ae039), {
                            data: meetingPoints,
                            slug: isDeparture ? 'transferPoints' : 'meetingPoints'
                        }),
                        publicTransportation && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $58ca2a055b7e2a42$export$2e2bcd8739ae039), {
                            data: publicTransportation,
                            slug: "publicTransportation"
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $b752c4f2f516e8be$export$2e2bcd8739ae039 = $b752c4f2f516e8be$var$Arrivals;










const $82400203e8339977$var$Excursions = ({ data: data, slug: slug })=>{
    const { name: name, description: description, duration: duration, includedItems: includedItems, additionalInfo: additionalInfo } = data.fields;
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "block-style",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        className: "content_h3",
                        children: slug ? (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug) : name
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Excursion Description:"
                    }),
                    description ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0, $e2ae5481ea3ab6f0$export$7baf571c7f59ce7c)(description)
                        }
                    }) : null
                ]
            }),
            duration && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Duration (in hours)"
                    }),
                    ": ",
                    duration
                ]
            }),
            includedItems && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                        children: "Included Items"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                        className: "list-style",
                        style: {
                            marginTop: 10
                        },
                        children: includedItems.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: v
                            }, v))
                    })
                ]
            }),
            additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                data: additionalInfo,
                slug: "additionalInfo"
            })
        ]
    });
};
var $82400203e8339977$export$2e2bcd8739ae039 = $82400203e8339977$var$Excursions;






const $9c0be078b04fc7b7$var$Meals = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    const { internalname: internalname, type: type, beverage: beverage, specialDietAccommodations: specialDietAccommodations, additionalInfo: additionalInfo } = data.fields;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        className: "block-style",
        id: slug,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "flex-between-centered",
                    children: [
                        internalname && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                            style: {
                                marginTop: 10,
                                marginBottom: 20
                            },
                            className: "content_h3",
                            children: internalname
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                            date: date
                        })
                    ]
                }),
                type && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            children: "Food"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "list-style",
                            style: {
                                marginTop: 10
                            },
                            children: type.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: v
                                }, v))
                        })
                    ]
                }),
                beverage && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    style: {
                        marginTop: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            children: "Beverage"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "list-style",
                            style: {
                                marginTop: 10
                            },
                            children: beverage.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: v
                                }, v))
                        })
                    ]
                }),
                specialDietAccommodations && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    style: {
                        marginTop: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            children: "Special Diet Accommodations"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "list-style",
                            style: {
                                marginTop: 10
                            },
                            children: specialDietAccommodations.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: v
                                }, v))
                        })
                    ]
                }),
                additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                    data: additionalInfo,
                    slug: "additionalInfo"
                })
            ]
        })
    });
};
var $9c0be078b04fc7b7$export$2e2bcd8739ae039 = $9c0be078b04fc7b7$var$Meals;









const $91af4ed0e5f342fc$var$InclusionsModule = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "block-style",
        children: [
            slug && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                className: "content_h3",
                children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                date: date
            }),
            data.map((info, i)=>{
                if (!info || !info.fields) return;
                const { internalName: internalName, includedArrangements: includedArrangements, hospitality: hospitality, tour: tour, meals: meals, additionalInfo: additionalInfo } = info.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            className: "content_h3",
                            style: {
                                marginBottom: 15
                            },
                            children: internalName
                        }),
                        includedArrangements && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "list-style",
                            style: {
                                marginTop: 10,
                                marginBottom: 15
                            },
                            children: includedArrangements.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: v
                                }, v))
                        }),
                        hospitality && hospitality.map((item, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7dc38b5b672fa20$export$2e2bcd8739ae039), {
                                data: item
                            }, i)),
                        tour && tour.map((item, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $82400203e8339977$export$2e2bcd8739ae039), {
                                data: item
                            }, i)),
                        meals && meals.map((item, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9c0be078b04fc7b7$export$2e2bcd8739ae039), {
                                data: item,
                                slug: "meals"
                            }, i)),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $91af4ed0e5f342fc$export$2e2bcd8739ae039 = $91af4ed0e5f342fc$var$InclusionsModule;













const $62b70645b3962193$var$ExpeditionGear = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        className: "content_h2",
                        style: {
                            marginTop: 0
                        },
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((el, i)=>{
                if (!el || !el.fields) return;
                const { internalTitle: internalTitle, gearHowtoGet: gearHowtoGet, gearRequired: gearRequired, name: name, brand: brand, link: link, additionalInfo: additionalInfo, images: images } = el.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            className: "content_h3",
                            style: {
                                marginBottom: 20
                            },
                            children: internalTitle
                        }),
                        images && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            style: {
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginBottom: '20px'
                            },
                            children: images.map((img, i)=>{
                                if (!img.fields) return null;
                                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                    style: {
                                        width: '48%'
                                    },
                                    src: img.fields.file.url,
                                    alt: img.fields.title
                                }, i);
                            })
                        }),
                        gearHowtoGet && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Gear How to Get"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: gearHowtoGet.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        gearRequired && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Gear Required"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: gearRequired.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        name && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: name
                                })
                            ]
                        }),
                        brand && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Brand"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: brand
                                })
                            ]
                        }),
                        link && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "d-flex-align-center",
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Link:"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "link-wrap",
                                    href: link,
                                    target: "_blank",
                                    children: link
                                })
                            ]
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $62b70645b3962193$export$2e2bcd8739ae039 = $62b70645b3962193$var$ExpeditionGear;




const $3cda978dc5aae4de$var$ActivityOpportunity = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((info, i)=>{
                if (!info || !info.fields) return;
                const { internalName: internalName, ActivityOverview: ActivityOverview, divingProvider: divingProvider, providedGear: providedGear, levelOfExperience: levelOfExperience, inclusions: inclusions, files: files, additionalInfo: additionalInfo } = info.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            className: "content_h3",
                            style: {
                                marginBottom: 15
                            },
                            children: internalName
                        }),
                        ActivityOverview && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Activity Overview / Parameters"
                                }),
                                ActivityOverview ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: (0, $e2ae5481ea3ab6f0$export$7baf571c7f59ce7c)(ActivityOverview)
                                    }
                                }) : null
                            ]
                        }),
                        divingProvider && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Activity Provider:"
                                }),
                                " ",
                                divingProvider
                            ]
                        }),
                        providedGear && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $62b70645b3962193$export$2e2bcd8739ae039), {
                            data: providedGear,
                            slug: "providedGear"
                        }),
                        levelOfExperience && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Required Level of Experience"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    children: levelOfExperience
                                })
                            ]
                        }),
                        inclusions && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $91af4ed0e5f342fc$export$2e2bcd8739ae039), {
                            data: inclusions,
                            slug: "inclusions"
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $3cda978dc5aae4de$export$2e2bcd8739ae039 = $3cda978dc5aae4de$var$ActivityOpportunity;


const $9622d6b59167dfff$var$Inclusions = ({ data: data, slug: slug })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                className: "content_h3",
                children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
            }),
            data.map((inc, i)=>{
                if (!inc || !inc.fields) return;
                const type = inc.sys.contentType.sys.id;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    children: [
                        type === 'hotel' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $14ab153572ad8686$export$2e2bcd8739ae039), {
                            data: [
                                inc
                            ],
                            slug: "hotels"
                        }),
                        type === 'tours' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $82400203e8339977$export$2e2bcd8739ae039), {
                            data: inc,
                            slug: "excursions"
                        }),
                        type === 'meals' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9c0be078b04fc7b7$export$2e2bcd8739ae039), {
                            data: inc,
                            slug: "meals"
                        }),
                        type === 'inclusions' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $91af4ed0e5f342fc$export$2e2bcd8739ae039), {
                            data: [
                                inc
                            ]
                        }),
                        type === 'testFreeText' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: [
                                inc
                            ],
                            slug: "additionalInfo"
                        }),
                        type === 'airport' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d76881503fb34ae5$export$2e2bcd8739ae039), {
                            data: inc
                        }),
                        type === 'scubaDivingOpportunity' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $3cda978dc5aae4de$export$2e2bcd8739ae039), {
                            data: [
                                inc
                            ],
                            slug: "activityOpportunity"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $9622d6b59167dfff$export$2e2bcd8739ae039 = $9622d6b59167dfff$var$Inclusions;


const $bc20aa9f415779ff$var$ArrivalInformation = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    const isDeparture = slug.startsWith('departure');
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((info, i)=>{
                if (!info || !info.fields) return;
                const { arrivalInformation: arrivalInformation, arrivals: arrivals, inclusions: inclusions, additionalInfo: additionalInfo } = info.fields;
                const id = (0, $d75ce639c2332d78$export$c383cdd2a518017a)(arrivalInformation);
                const elId = /^[A-Za-z]/.test(id) ? id : 'x' + id;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    id: elId,
                    className: "block-style",
                    children: [
                        arrivalInformation && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                            className: "content_h3",
                            children: arrivalInformation
                        }),
                        arrivals && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $b752c4f2f516e8be$export$2e2bcd8739ae039), {
                            data: arrivals,
                            slug: isDeparture ? 'departures' : 'arrivals',
                            isDeparture: isDeparture
                        }),
                        inclusions && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9622d6b59167dfff$export$2e2bcd8739ae039), {
                            data: inclusions,
                            slug: "inclusions"
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $bc20aa9f415779ff$export$2e2bcd8739ae039 = $bc20aa9f415779ff$var$ArrivalInformation;







const $72f8e0932a4c07e9$var$Flights = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((el, i)=>{
                if (!el || !el.fields) return;
                const { flightType: flightType, additionalInfo: additionalInfo } = el.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    children: [
                        flightType && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            style: {
                                marginTop: 20,
                                marginBottom: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Flight Type"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                    className: "list-style",
                                    style: {
                                        marginTop: 10
                                    },
                                    children: flightType.map((v)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                            children: v
                                        }, v))
                                })
                            ]
                        }),
                        additionalInfo && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                            data: additionalInfo,
                            slug: "additionalInfo"
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $72f8e0932a4c07e9$export$2e2bcd8739ae039 = $72f8e0932a4c07e9$var$Flights;







const $8174d72046965c9f$var$ExpeditionGuide = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((item, i)=>{
                if (!item || !item.fields) return;
                const { internalName: internalName, link: link } = item.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            className: "content_h3",
                            children: internalName
                        }),
                        link && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "d-flex-align-center",
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Link:"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "link-wrap",
                                    href: link,
                                    target: "_blank",
                                    children: link
                                })
                            ]
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $8174d72046965c9f$export$2e2bcd8739ae039 = $8174d72046965c9f$var$ExpeditionGuide;





const $6cc41ee50489846d$var$Marketing = ({ data: data, slug: slug })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, data);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: "Sales & Marketing"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            data.map((item, i)=>{
                if (!item || !item.fields) return;
                const { salesMarketing: salesMarketing, brochures: brochures, spreadsheetLink: spreadsheetLink } = item.fields;
                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "block-style",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                            className: "content_h3",
                            children: salesMarketing
                        }),
                        brochures && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "d-flex-align-center",
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("b", {
                                    children: "Brochure(s):"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "link-wrap",
                                    href: brochures,
                                    target: "_blank",
                                    children: brochures
                                })
                            ]
                        }),
                        spreadsheetLink && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "d-flex-align-center",
                            style: {
                                marginTop: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("b", {
                                    children: [
                                        salesMarketing,
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "link-wrap",
                                    href: spreadsheetLink,
                                    target: "_blank",
                                    children: spreadsheetLink
                                })
                            ]
                        })
                    ]
                }, i);
            })
        ]
    });
};
var $6cc41ee50489846d$export$2e2bcd8739ae039 = $6cc41ee50489846d$var$Marketing;






const $357a48c4c4e1ca31$var$Embed = ({ data: data })=>{
    const text = (0, $e2137a36f845690e$export$16c55c8c145e9dad)(data);
    if (!text) return;
    const iframe = text.replace(/<iframe/gi, '<iframe loading="lazy"');
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        style: {
            margin: '20px 0 40px'
        },
        dangerouslySetInnerHTML: {
            __html: iframe
        }
    });
};
var $357a48c4c4e1ca31$export$2e2bcd8739ae039 = $357a48c4c4e1ca31$var$Embed;




const $49978b174b254240$var$ExtensionOperatingDates = ({ embed: embed, text: text, slug: slug })=>{
    const chartEmbedCode = embed && embed.fields && embed.fields.chartEmbed ? (0, $e2137a36f845690e$export$16c55c8c145e9dad)(embed.fields.chartEmbed) : null;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: "extensionOperatingDates",
        style: {
            marginTop: 40
        },
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                className: "content_h2",
                children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
            }),
            embed && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        className: "d-flex-align-center",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("b", {
                                children: [
                                    "View ",
                                    (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                className: "link-wrap",
                                href: (0, $d75ce639c2332d78$export$280746aa23b168d4)(chartEmbedCode),
                                target: "_blank",
                                children: (0, $d75ce639c2332d78$export$280746aa23b168d4)(chartEmbedCode)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $357a48c4c4e1ca31$export$2e2bcd8739ae039), {
                        data: embed.fields.chartEmbed
                    })
                ]
            }),
            text && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: (0, $e2ae5481ea3ab6f0$export$7baf571c7f59ce7c)(text)
                }
            })
        ]
    });
};
var $49978b174b254240$export$2e2bcd8739ae039 = $49978b174b254240$var$ExtensionOperatingDates;




var $8tsvq = parcelRequire("8tsvq");



const $44bd448832ff8697$var$Itinerary = ({ data: data, freeText: freeText, slug: slug })=>{
    const [itinerary, setItinerary] = (0, $8tsvq.useState)();
    const updatedAt = (0, $8tsvq.useMemo)(()=>{
        if (itinerary) return (0, $d75ce639c2332d78$export$820fb7fb68841687)(itinerary.items);
    }, [
        itinerary
    ]);
    const fetcher = async ()=>{
        const itemUrl = data.split('/');
        const itin = await (0, $d75ce639c2332d78$export$bda897526085869f)(itemUrl[itemUrl.length - 1], 'pageExpedition');
        const image = itin.includes.Entry.find((el)=>el.sys.contentType.sys.id === 'photo');
        setItinerary({
            title: itin.items[0].fields.title,
            image: image,
            items: itin.items[0],
            slug: itin.items[0].fields.slug
        });
    };
    (0, $8tsvq.useEffect)(()=>{
        fetcher();
    }, []);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                className: "content_h2",
                children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                date: updatedAt
            }),
            itinerary && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                        href: `https://www.expeditions.com/expeditions/${itinerary.slug}`,
                        className: "block-style highlights__item",
                        target: "_blank",
                        style: {
                            display: 'block'
                        },
                        children: [
                            itinerary.image && itinerary.image.fields && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                className: "highlights__item--img",
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                    src: itinerary.image.fields.asset[0].src,
                                    alt: itinerary.image.fields.asset[0].name
                                })
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h4", {
                                className: "content_h4",
                                style: {
                                    marginTop: 20,
                                    marginBottom: 0
                                },
                                children: itinerary.title
                            })
                        ]
                    }),
                    freeText && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $f7747c0090244a4f$export$2e2bcd8739ae039), {
                        data: [
                            freeText
                        ],
                        slug: "additionalInfo"
                    })
                ]
            })
        ]
    });
};
var $44bd448832ff8697$export$2e2bcd8739ae039 = $44bd448832ff8697$var$Itinerary;




var $8tsvq = parcelRequire("8tsvq");


const $c03235f22eef73d1$var$ExtensionDetails = ({ data: data, slug: slug })=>{
    const [extensions, setExtensions] = (0, $8tsvq.useState)([]);
    const updatedAt = (0, $8tsvq.useMemo)(()=>{
        if (extensions && extensions.length) return (0, $d75ce639c2332d78$export$820fb7fb68841687)(null, extensions);
    }, [
        extensions
    ]);
    const fetcher = async ()=>{
        const dataToFetch = data.map((item)=>{
            const itemUrl = item.sys.urn.split('/');
            return (0, $d75ce639c2332d78$export$bda897526085869f)(itemUrl[itemUrl.length - 1], 'extension');
        });
        const results = await Promise.all(dataToFetch);
        const extensionsMapped = results.map((result)=>({
                title: result.items[0].fields.title,
                image: {
                    fields: result.items[0].fields
                },
                sys: result.items[0].sys,
                slug: result.items[0].fields.slug
            }));
        setExtensions(extensionsMapped);
    };
    (0, $8tsvq.useEffect)(()=>{
        fetcher();
    }, []);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                className: "content_h2",
                children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug)
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                date: updatedAt
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                className: "extensions",
                children: extensions.map((extension, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                        className: "block-style highlights__item",
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                            href: `https://www.expeditions.com/extensions/${extension.slug}`,
                            target: "_blank",
                            children: [
                                extension.image && extension.image.fields && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                    className: "highlights__item--img",
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                        src: extension.image.fields.asset[0].src,
                                        alt: extension.image.fields.asset[0].name
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h4", {
                                    className: "content_h4",
                                    style: {
                                        marginTop: 20,
                                        marginBottom: 0
                                    },
                                    children: extension.title
                                })
                            ]
                        })
                    }, i))
            })
        ]
    });
};
var $c03235f22eef73d1$export$2e2bcd8739ae039 = $c03235f22eef73d1$var$ExtensionDetails;







const $717d61c9b7da29ca$var$ChartEmbed = ({ data: data, slug: slug, title: title })=>{
    const date = (0, $d75ce639c2332d78$export$820fb7fb68841687)(data);
    const chartEmbedCode = data && data.fields && data.fields.chartEmbed ? (0, $e2137a36f845690e$export$16c55c8c145e9dad)(data.fields.chartEmbed) : null;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        id: slug,
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "flex-between-centered",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        children: (0, $d75ce639c2332d78$export$3b34af866c706a7c)(slug.replace(/Embed$/, ''))
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: date
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                style: {
                    marginTop: 40
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        className: "d-flex-align-center",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("b", {
                                children: [
                                    title,
                                    " Chart Link:"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                className: "link-wrap",
                                href: (0, $d75ce639c2332d78$export$280746aa23b168d4)(chartEmbedCode),
                                target: "_blank",
                                children: (0, $d75ce639c2332d78$export$280746aa23b168d4)(chartEmbedCode)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("b", {
                            children: [
                                title,
                                " Chart:"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $357a48c4c4e1ca31$export$2e2bcd8739ae039), {
                        data: data.fields.chartEmbed
                    })
                ]
            })
        ]
    });
};
var $717d61c9b7da29ca$export$2e2bcd8739ae039 = $717d61c9b7da29ca$var$ChartEmbed;




const $4b4bad15c616e058$var$replacements = {
    'Hotel': 'hotels',
    '/Disembark': 'Information',
    '/Embark': 'Information'
};
const $4b4bad15c616e058$var$Deviations = ({ data: data })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "deviation-block",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("svg", {
                role: "presentation",
                "aria-hidden": "true",
                width: "40",
                height: "40",
                viewBox: "0 0 32 32",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                style: {
                    verticalAlign: "middle"
                },
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM18.2898 8.31392C18.2898 9.54411 17.2644 10.5414 15.9996 10.5414C14.7347 10.5414 13.7094 9.54411 13.7094 8.31392C13.7094 7.08374 14.7347 6.08647 15.9996 6.08647C17.2644 6.08647 18.2898 7.08374 18.2898 8.31392ZM13.9917 12.2044H18.0073V24.4397H13.9917V12.2044Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                children: [
                    "Please note that there are one or more departures with a DEVIATION. ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                    "Deviations will be identified in the subject matter headers or titles with the applicable VOYAGE ID.",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                        className: "list-style",
                        style: {
                            marginTop: 10,
                            fontWeight: 700
                        },
                        children: data.map((v)=>{
                            const link = (0, $d75ce639c2332d78$export$161d051f5dd25de7)(v.replace(/\/Disembark|\/Embark|\bHotel\b/g, (match)=>$4b4bad15c616e058$var$replacements[match]));
                            return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    "DEVIATION OR CHANGE: ",
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                        title: "Click to scroll to the section",
                                        style: {
                                            color: 'inherit',
                                            textDecoration: 'underline'
                                        },
                                        href: `#${link}`,
                                        children: v
                                    })
                                ]
                            }, v);
                        })
                    })
                ]
            })
        ]
    });
};
var $4b4bad15c616e058$export$2e2bcd8739ae039 = $4b4bad15c616e058$var$Deviations;




var $8tsvq = parcelRequire("8tsvq");
class $7496436b70fef144$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            style: {
                padding: '20px',
                margin: '20px',
                border: '2px solid #ff6b6b',
                borderRadius: '8px',
                backgroundColor: '#fff5f5',
                height: 'fit-content'
            },
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                    style: {
                        color: '#c92a2a',
                        marginTop: 0
                    },
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                    style: {
                        color: '#666'
                    },
                    children: this.props.fallbackMessage || 'An error occurred while loading this section. Please try refreshing the page.'
                }),
                false
            ]
        });
        return this.props.children;
    }
}
var $7496436b70fef144$export$2e2bcd8739ae039 = $7496436b70fef144$var$ErrorBoundary;


const $968a5e4f5bfad90a$var$Content = ()=>{
    const { id: id, extensionId: extensionId } = (0, $5bc57f835864eb51$export$99eaa27ddbbb95ef)();
    const [anchorData, setAnchorData] = (0, $8tsvq.useState)([]);
    const [error, setError] = (0, $8tsvq.useState)(false);
    const fetcher = async ()=>{
        setError(false);
        try {
            const entryItems = await (0, $c3c8ef5796d3b74c$export$388e0302ca0d9a41).getEntries({
                content_type: id ? 'testProduct' : 'extension',
                'fields.slug[in]': id || extensionId,
                include: 10
            });
            const item = entryItems.items[0];
            if (!item) {
                setError(true);
                return;
            }
            const { items: items } = await (0, $c3c8ef5796d3b74c$export$388e0302ca0d9a41).getEntries({
                links_to_entry: item.sys.id,
                include: 3
            });
            const { productOwners: productOwners, entryRequirements: entryRequirements, expeditionGear: expeditionGear, FAQS: FAQS, expeditionGuide: expeditionGuide, salesMarketing: salesMarketing } = items && items.length && items[0].fields;
            const { name: name, deviations: deviations, ship: ship, activityOpportunity: activityOpportunity, arrivalInformation: arrivalInformation, hotels: hotels, hotelsChartEmbed: hotelsChartEmbed, flights: flights, flightsChartEmbed: flightsChartEmbed, departureInformation: departureInformation, extensions: extensions, itinerary: itinerary, itineraryFreeText: itineraryFreeText } = item.fields;
            const fieldsObj = {
                name: name,
                ...productOwners && {
                    productOwners: productOwners
                },
                ...itinerary && {
                    itinerary: itinerary
                },
                ...itinerary && itineraryFreeText && {
                    itineraryFreeText: itineraryFreeText
                },
                ...deviations && {
                    deviations: deviations
                },
                ...activityOpportunity && {
                    activityOpportunity: activityOpportunity
                },
                ...ship && {
                    ship: ship
                },
                ...entryRequirements && {
                    entryRequirements: entryRequirements
                },
                ...arrivalInformation && {
                    arrivalInformation: arrivalInformation
                },
                ...hotels && {
                    hotels: hotels
                },
                ...hotelsChartEmbed && {
                    hotelsChartEmbed: hotelsChartEmbed
                },
                ...flights && {
                    flights: flights
                },
                ...flightsChartEmbed && {
                    flightsChartEmbed: flightsChartEmbed
                },
                ...departureInformation && {
                    departureInformation: departureInformation
                },
                ...expeditionGear && {
                    expeditionGear: expeditionGear
                },
                ...extensions && {
                    extensions: extensions
                },
                ...FAQS && {
                    FAQS: FAQS
                },
                ...expeditionGuide && {
                    expeditionGuide: expeditionGuide
                },
                ...salesMarketing && {
                    salesMarketing: salesMarketing
                }
            };
            const fields = item.sys.contentType.sys.id === 'extension' ? {
                ...item.fields.productOwners && {
                    productOwners: item.fields.productOwners
                },
                ...item.fields
            } : fieldsObj;
            const modules = {
                content: []
            };
            for (let [key, value] of Object.entries(fields)){
                const subSectionList = [
                    'entryRequirements',
                    'arrivalInformation',
                    'departureInformation'
                ];
                const subSectionExclusions = [
                    'internalName',
                    'additionalInfo',
                    'arrivals',
                    'inclusions'
                ];
                const subSections = [];
                if (subSectionList.includes(key)) value && value.forEach((item)=>{
                    if (item.fields) Object.keys(item.fields).forEach((subKey, i)=>{
                        if (!subSectionExclusions.includes(subKey)) {
                            if (subKey === 'arrivalInformation') {
                                const name = Object.values(item.fields)[i];
                                const id = (0, $d75ce639c2332d78$export$c383cdd2a518017a)(name);
                                subSections.push({
                                    name: name,
                                    id: /^[A-Za-z]/.test(id) ? id : 'x' + id
                                });
                            } else subSections.push({
                                name: (0, $d75ce639c2332d78$export$aebd617640818cda)(subKey) ? subKey : subKey.replace(/([A-Z])/g, ' $1').replace(/^./, (str)=>str.toUpperCase()),
                                id: subKey === 'additionalInfo' ? key + subKey : subKey
                            });
                        }
                    });
                });
                modules.content.push({
                    name: (0, $d75ce639c2332d78$export$aebd617640818cda)(key) ? key : key.replace(/([A-Z])/g, ' $1').replace(/^./, (str)=>str.toUpperCase()),
                    id: key,
                    subSections: subSections
                });
            }
            setData(fields);
            setAnchorData(modules.content);
        } catch (err) {
            console.log(err);
            setError(true);
        }
    };
    const [data, setData] = (0, $8tsvq.useState)();
    (0, $8tsvq.useEffect)(()=>{
        fetcher();
        setActiveAnchor('productOwners');
    }, [
        id,
        extensionId
    ]);
    (0, $8tsvq.useEffect)(()=>{
        if (data) {
            window.scrollTo({
                top: 0
            });
            document.title = data.name;
            const hash = window.location.hash;
            const anchorEl = hash && document.querySelector(hash);
            if (anchorEl) setTimeout(()=>{
                anchorEl.scrollIntoView();
            }, 200);
        }
    }, [
        data
    ]);
    const [activeAnchor, setActiveAnchor] = (0, $8tsvq.useState)('productOwners');
    (0, $8tsvq.useEffect)(()=>{
        if (data) {
            const observerOptions = {
                rootMargin: '50px 0px 50px 0px',
                threshold: [
                    0.1
                ]
            };
            const observer = new IntersectionObserver(observerCallback, observerOptions);
            function observerCallback(entries) {
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) //console.log(entry.target.id, entry, window.scrollY)
                    {
                        if (window.scrollY !== 0) setActiveAnchor(entry.target.id);
                    }
                });
            }
            setTimeout(()=>{
                const collection = document.querySelectorAll('#moduleSection > article');
                collection.forEach((i)=>{
                    if (i) observer.observe(i);
                });
            }, 1000);
        }
    }, [
        data
    ]);
    if (error) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
        style: {
            margin: 'auto'
        },
        children: "404 Not Found"
    });
    if (!data) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $6e6b089c3d63766c$export$7f7cbe89f1eacd2), {
        size: "large"
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("section", {
                id: "moduleSection",
                className: "module-section",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        style: {
                            marginBottom: 40
                        },
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
                            className: "content_h1",
                            style: {
                                marginBottom: 15
                            },
                            children: data.name
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Deviations section",
                        children: data.deviations && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $4b4bad15c616e058$export$2e2bcd8739ae039), {
                            data: data.deviations
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Product Owners section",
                        children: data.productOwners && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $b404e00b0f12a8df$export$2e2bcd8739ae039), {
                            data: data.productOwners,
                            slug: "productOwners"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Itinerary section",
                        children: data.itinerary && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $44bd448832ff8697$export$2e2bcd8739ae039), {
                            data: data.itinerary.sys.urn,
                            freeText: data.itineraryFreeText,
                            slug: "itinerary"
                        }, data.itinerary.sys.urn)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Extension Itinerary section",
                        children: data.extensionDetails && data.extensionDetails.length && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $c03235f22eef73d1$export$2e2bcd8739ae039), {
                            data: data.extensionDetails,
                            slug: "extensionItinerary"
                        }, data.name)
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Extension Operating Dates section",
                        children: (data.extensionOperatingDates || data.extensionOperatingDatesText) && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $49978b174b254240$export$2e2bcd8739ae039), {
                            embed: data.extensionOperatingDates,
                            text: data.extensionOperatingDatesText,
                            slug: "extensionOperatingDates"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Activity Opportunity section",
                        children: data.activityOpportunity && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $3cda978dc5aae4de$export$2e2bcd8739ae039), {
                            data: data.activityOpportunity,
                            slug: "activityOpportunity"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Ship section",
                        children: data.ship && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8b892f412b4b5fd2$export$2e2bcd8739ae039), {
                            data: data.ship,
                            slug: "ship"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Entry Requirements section",
                        children: data.entryRequirements && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $fc1b7e1c69c74761$export$2e2bcd8739ae039), {
                            data: data.entryRequirements,
                            slug: "entryRequirements"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Arrival Information section",
                        children: data.arrivalInformation && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $bc20aa9f415779ff$export$2e2bcd8739ae039), {
                            data: data.arrivalInformation,
                            slug: "arrivalInformation"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Hotels section",
                        children: data.hotels && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $14ab153572ad8686$export$2e2bcd8739ae039), {
                            data: data.hotels,
                            slug: "hotels"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Hotels Chart section",
                        children: data.hotelsChartEmbed && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $717d61c9b7da29ca$export$2e2bcd8739ae039), {
                            data: data.hotelsChartEmbed,
                            slug: "hotelsChartEmbed",
                            title: "Hotel"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Flights section",
                        children: data.flights && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $72f8e0932a4c07e9$export$2e2bcd8739ae039), {
                            data: data.flights,
                            slug: "flights"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Flights Chart section",
                        children: data.flightsChartEmbed && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $717d61c9b7da29ca$export$2e2bcd8739ae039), {
                            data: data.flightsChartEmbed,
                            slug: "flightsChartEmbed",
                            title: "Flights"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Departure Information section",
                        children: data.departureInformation && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $bc20aa9f415779ff$export$2e2bcd8739ae039), {
                            data: data.departureInformation,
                            slug: "departureInformation"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Expedition Gear section",
                        children: data.expeditionGear && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $62b70645b3962193$export$2e2bcd8739ae039), {
                            data: data.expeditionGear,
                            slug: "expeditionGear"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Extensions section",
                        children: data.extensions && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                            id: "extensions",
                            children: data.extensions.map((ext, i)=>{
                                if (!ext.fields) return;
                                const { extension: extension, disclaimer: disclaimer, extensions: extensions, additionalInfo: additionalInfo } = ext.fields;
                                return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                                    fallbackMessage: "Unable to load the extension",
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        style: {
                                            marginTop: 60
                                        },
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5fb78378baf79c9f$export$2e2bcd8739ae039), {
                                            data: extension,
                                            disclaimer: disclaimer,
                                            slug: extensions,
                                            freeText: additionalInfo
                                        })
                                    })
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load FAQs section",
                        children: data.FAQS && data.FAQS.map((faq, i)=>{
                            if (!faq.fields) return;
                            // TOASK faq.fields.FAQs
                            return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                                fallbackMessage: "Unable to load this FAQ",
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $32fd15a4dc46ab2b$export$2e2bcd8739ae039), {
                                    data: faq.fields.questionanswer,
                                    slug: "FAQS"
                                })
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Expedition Guide section",
                        children: data.expeditionGuide && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8174d72046965c9f$export$2e2bcd8739ae039), {
                            data: data.expeditionGuide,
                            slug: "expeditionGuide"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                        fallbackMessage: "Unable to load Sales & Marketing section",
                        children: data.salesMarketing && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $6cc41ee50489846d$export$2e2bcd8739ae039), {
                            data: data.salesMarketing,
                            slug: "salesMarketing"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                fallbackMessage: "Unable to load navigation menu",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $37b4dc016acd2660$export$2e2bcd8739ae039), {
                    data: anchorData,
                    activeAnchor: activeAnchor,
                    setActiveAnchor: setActiveAnchor
                })
            })
        ]
    });
};
var $968a5e4f5bfad90a$export$2e2bcd8739ae039 = $968a5e4f5bfad90a$var$Content;



var $8tsvq = parcelRequire("8tsvq");


const $b8bd2c9bcd2d1081$var$LoginButton = (props)=>{
    const { loginWithRedirect: loginWithRedirect } = (0, $a60a332f9bf049ee$export$f2b63d3ca66bb884)();
    const handleLogin = ()=>{
        localStorage.setItem('pre_auth_path', window.location.pathname);
        loginWithRedirect();
    };
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
        ...props,
        onClick: handleLogin,
        children: "LogIn"
    });
};
var $b8bd2c9bcd2d1081$export$2e2bcd8739ae039 = $b8bd2c9bcd2d1081$var$LoginButton;





var $8tsvq = parcelRequire("8tsvq");

const $e3a182d6791d5fe4$var$Logo = ({ id: id = '' })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("svg", {
        width: "174",
        height: "40",
        viewBox: "0 0 174 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("g", {
                clipPath: 'url(#clip0_59_913)' + id,
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M60.9772 1.19666H64.1649V13.7396H70.3634V16.687H60.9772V1.19666ZM72.3779 4.81993H75.4993V16.687H72.3779V4.81993ZM72.3115 0.698046H75.5546V3.55677H72.3115V0.698046ZM78.4768 4.81993H81.5871V6.40442C82.2733 5.45151 83.1256 4.59832 84.6088 4.59832C86.8115 4.59832 88.0844 6.13849 88.0844 8.59832V16.6759H84.963V9.52907C84.963 8.13295 84.3543 7.42381 83.3027 7.42381C82.2733 7.42381 81.5871 8.13295 81.5871 9.52907V16.6759H78.4768V4.81993ZM89.8333 10.9252V10.5706C89.8333 6.5263 91.9585 4.59832 94.305 4.59832C95.8878 4.59832 96.8065 5.46259 97.4928 6.34902V0.698046H100.603V16.6759H97.4928V15.0471C96.8065 16.0332 95.8657 16.8975 94.305 16.8975C91.9806 16.8975 89.8333 14.9806 89.8333 10.9252ZM97.526 10.8587V10.6371C97.526 8.63156 96.5188 7.34625 95.2237 7.34625C93.9398 7.34625 92.9436 8.63156 92.9436 10.6371V10.8587C92.9436 12.8753 93.9398 14.1607 95.2237 14.1607C96.5188 14.1607 97.526 12.8753 97.526 10.8587ZM106.436 15.1579V16.687H103.326V0.698046H106.436V6.45982C107.123 5.46259 108.063 4.59832 109.624 4.59832C111.949 4.59832 114.096 6.5263 114.096 10.5706V10.9252C114.096 14.9806 111.971 16.8975 109.624 16.8975C108.041 16.8975 107.1 16.0332 106.436 15.1579ZM110.986 10.8587V10.6371C110.986 8.63156 109.989 7.34625 108.694 7.34625C107.41 7.34625 106.403 8.63156 106.403 10.6371V10.8587C106.403 12.8753 107.41 14.1607 108.694 14.1607C109.989 14.1607 110.986 12.8753 110.986 10.8587ZM116.044 0.709127H119.154V16.687H116.044V0.709127ZM121.678 13.2964V13.1634C121.678 10.5485 123.371 9.38503 125.773 9.38503C125.987 9.37764 126.198 9.38503 126.404 9.40719C126.618 9.42935 126.829 9.4589 127.035 9.49583C127.242 9.54015 127.445 9.59186 127.644 9.65095C127.843 9.71005 128.039 9.78022 128.231 9.86148V9.50691C128.231 8.13295 127.423 7.43489 126.017 7.43489C124.921 7.43489 124.047 7.78946 123.316 8.09971L122.464 5.63987C122.774 5.47736 123.091 5.33701 123.416 5.21882C123.74 5.09324 124.072 4.98983 124.412 4.90857C124.751 4.82732 125.094 4.76822 125.441 4.73129C125.788 4.69435 126.135 4.67958 126.482 4.68697C128.076 4.68697 129.282 5.13018 130.057 5.9058C130.865 6.72575 131.263 7.96674 131.263 9.48475V16.687H128.208V15.4016C127.511 16.3213 126.548 16.8975 125.165 16.8975C123.239 16.8975 121.678 15.6011 121.678 13.2964ZM128.275 12.7867V11.7895C128.142 11.7304 128.006 11.675 127.865 11.6233C127.725 11.5789 127.581 11.542 127.434 11.5125C127.286 11.4755 127.138 11.4497 126.991 11.4349C126.843 11.4201 126.696 11.4127 126.548 11.4127C125.408 11.4127 124.678 11.9889 124.678 13.0748V13.1191C124.678 14.0942 125.297 14.5817 126.194 14.6039C127.4 14.626 128.275 13.8726 128.275 12.7867ZM133.4 10.9252V10.5706C133.4 6.5263 135.525 4.59832 137.871 4.59832C139.454 4.59832 140.373 5.46259 141.048 6.34902V0.698046H144.17V16.6759H141.048V15.036C140.373 16.0332 139.432 16.8975 137.871 16.8975C135.547 16.8975 133.4 14.9806 133.4 10.9252ZM141.092 10.8587V10.6371C141.092 8.63156 140.085 7.34625 138.79 7.34625C137.495 7.34625 136.51 8.62048 136.51 10.6371V10.8587C136.51 12.8753 137.495 14.1607 138.79 14.1607C140.085 14.1607 141.092 12.8753 141.092 10.8587ZM60.9772 21.0748H70.8726V23.9778H64.1428V27.3241H70.0646V30.2161H64.1428V33.6731H70.9611V36.5651H60.9772V21.0748ZM77.5802 28.1773L79.4398 24.7091H82.6607L79.2626 30.482L82.7936 36.5651H79.484L77.5359 32.8753L75.5546 36.5651H72.3115L75.8203 30.5263L72.4443 24.7091H75.7317L77.5802 28.1773ZM84.7527 24.698H87.863V26.3379C88.5382 25.3407 89.4901 24.4764 91.0398 24.4764C93.3642 24.4764 95.5115 26.4044 95.5115 30.4598V30.8144C95.5115 34.8587 93.3863 36.7867 91.0398 36.7867C89.468 36.7867 88.5161 35.9224 87.863 35.036V39.9003H84.7527V24.698ZM92.4012 30.7479V30.5263C92.4012 28.5097 91.4161 27.2244 90.1211 27.2244C88.826 27.2244 87.8188 28.5097 87.8188 30.5263V30.7479C87.8188 32.7534 88.826 34.0388 90.1211 34.0388C91.4161 34.0388 92.4012 32.7534 92.4012 30.7479ZM96.8619 30.7701V30.5706C96.8619 27.0471 99.0424 24.4875 101.998 24.4875C105.352 24.4875 107.001 27.2465 107.001 30.7922C107.001 30.9695 107.001 31.3462 106.979 31.8005H99.9611C100.227 33.3739 101.19 34.1939 102.496 34.1939C103.47 34.1939 104.212 33.7507 104.953 33.0194L106.558 34.9252C105.484 36.1219 104.123 36.831 102.374 36.831C99.2527 36.831 96.8619 34.4598 96.8619 30.7701ZM103.99 29.7285C103.857 28.0886 103.16 27.0692 101.998 27.0692C100.858 27.0692 100.116 28.0443 99.939 29.7285H103.99ZM108.34 30.8144V30.4598C108.34 26.4044 110.476 24.4875 112.823 24.4875C114.395 24.4875 115.313 25.3407 116 26.2271V20.5872H119.11V36.5651H116V34.9252C115.313 35.9224 114.373 36.7867 112.823 36.7867C110.499 36.7867 108.34 34.8587 108.34 30.8144ZM116.044 30.7479V30.5263C116.044 28.5097 115.037 27.2244 113.742 27.2244C112.447 27.2244 111.462 28.5097 111.462 30.5263V30.7479C111.462 32.7534 112.447 34.0388 113.742 34.0388C115.037 34.0388 116.044 32.7534 116.044 30.7479ZM121.899 24.698H125.021V36.5651H121.899V24.698ZM121.833 20.5762H125.087V23.4349H121.833V20.5762ZM128.22 33.5956V27.3462H127.024V24.698H128.22V21.662H131.33V24.698H133.654V27.3462H131.33V32.9529C131.33 33.6399 131.64 33.9612 132.293 33.9612C132.78 33.9612 133.234 33.8282 133.632 33.6399V36.1329C133.455 36.2364 133.274 36.3287 133.09 36.41C132.905 36.4838 132.717 36.5466 132.525 36.5983C132.326 36.65 132.127 36.6907 131.928 36.7202C131.728 36.7424 131.529 36.7534 131.33 36.7534C129.526 36.7534 128.22 36.0443 128.22 33.5956ZM136.078 24.698H139.189V36.554H136.078V24.698ZM136.012 20.5872H139.255V23.4349H136.012V20.5872ZM141.203 30.7922V30.5485C141.203 27.036 143.572 24.4875 146.749 24.4875C149.925 24.4875 152.25 26.9917 152.25 30.5263V30.7701C152.25 34.2936 149.903 36.831 146.726 36.831C143.55 36.831 141.203 34.3379 141.203 30.7922ZM149.184 30.7479V30.5928C149.184 28.6648 148.221 27.2133 146.726 27.2133C145.166 27.2133 144.269 28.6426 144.269 30.5706V30.7257C144.269 32.6316 145.254 34.1163 146.749 34.1163C148.287 34.1163 149.184 32.6759 149.184 30.7479ZM153.81 24.7091H156.932V26.3047C157.607 25.3518 158.459 24.4875 159.953 24.4875C162.145 24.4875 163.418 26.0388 163.418 28.4875V36.5651H160.308V29.4183C160.308 28.0332 159.688 27.3241 158.636 27.3241C157.607 27.3241 156.921 28.0332 156.921 29.4183V36.5651H153.81V24.7091ZM165.366 35.1579L166.716 32.9418C167.779 33.7618 168.897 34.2715 169.86 34.2715C170.734 34.2715 171.111 33.8504 171.111 33.3629V33.3185C171.111 32.6316 170.236 32.3435 168.963 31.7895C167.292 31.0582 165.864 30.2161 165.864 28.2105V28.1662C165.864 25.8836 167.624 24.5318 169.904 24.5318C171.177 24.5318 172.605 24.9751 173.789 25.8172L172.539 28.0775C171.653 27.5014 170.69 27.0582 169.86 27.0582C169.118 27.0582 168.72 27.4349 168.72 27.9003V27.9446C168.72 28.554 169.594 28.9086 170.845 29.4847C172.561 30.3047 173.955 31.169 173.955 33.0526V33.0969C173.955 35.5457 172.162 36.7867 169.816 36.7867C169.41 36.7867 169.008 36.7498 168.609 36.6759C168.211 36.602 167.823 36.4949 167.447 36.3546C167.071 36.2142 166.705 36.0443 166.351 35.8449C166.004 35.6454 165.676 35.4164 165.366 35.1579ZM53.871 20.3767C50.6501 29.7618 41.131 39.0803 26.9409 39.0803C12.7508 39.0803 3.16532 29.7618 0.0107422 20.3767C2.74471 10.7811 12.618 0.0664673 28.2802 0.0664673C41.784 0.0664673 51.6241 7.06924 51.6241 7.06924C51.6241 7.06924 51.6573 9.70636 50.805 12.5872C44.1417 7.39057 35.6188 4.96397 28.2691 4.96397C17.4218 4.96397 8.44509 11.5124 5.12448 20.3767C9.31952 29.0305 17.1562 34.1828 26.9741 34.1828C36.792 34.1828 44.5291 29.0526 47.905 21.2521C46.6985 20 41.5959 15.8781 36.4489 14.3601C36.7072 14.7959 36.9359 15.2428 37.1352 15.7008C37.327 16.1662 37.4894 16.6426 37.6222 17.1302C37.755 17.6177 37.8583 18.1126 37.9321 18.6149C37.9985 19.1099 38.0317 19.6122 38.0317 20.1219C38.0317 26.3047 33.0619 31.313 26.9298 31.313C20.8088 31.313 15.839 26.3047 15.839 20.1219C15.839 15.1468 19.4695 8.6648 28.2691 8.6648C38.3195 8.6648 47.7611 13.5401 53.871 20.3767ZM33.1726 20.1219C33.1726 16.6426 30.3833 13.8282 26.9298 13.8282C23.4875 13.8282 20.6981 16.6426 20.6981 20.1219C20.6981 23.6011 23.4875 26.4155 26.9298 26.4155C30.3833 26.4155 33.1726 23.6011 33.1726 20.1219Z",
                    fill: "#006CB5"
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("clipPath", {
                    id: 'clip0_59_913' + id,
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("rect", {
                        width: "174",
                        height: "40",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $e3a182d6791d5fe4$export$2e2bcd8739ae039 = $e3a182d6791d5fe4$var$Logo;



function $5bb1d9f4f24fe8bb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5bb1d9f4f24fe8bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5bb1d9f4f24fe8bb$var$_typeof(obj);
}
function $5bb1d9f4f24fe8bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5bb1d9f4f24fe8bb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5bb1d9f4f24fe8bb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5bb1d9f4f24fe8bb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5bb1d9f4f24fe8bb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5bb1d9f4f24fe8bb$var$_defineProperty(obj, key, value) {
    key = $5bb1d9f4f24fe8bb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5bb1d9f4f24fe8bb$var$_toPropertyKey(arg) {
    var key = $5bb1d9f4f24fe8bb$var$_toPrimitive(arg, "string");
    return $5bb1d9f4f24fe8bb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5bb1d9f4f24fe8bb$var$_toPrimitive(input, hint) {
    if ($5bb1d9f4f24fe8bb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5bb1d9f4f24fe8bb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5bb1d9f4f24fe8bb$export$8d54726fdbf08e0a(fetcher, requesterId) {
    function execute(fetcherParams) {
        return fetcher({
            searchClient: fetcherParams.searchClient,
            queries: fetcherParams.requests.map(function(x) {
                return x.query;
            })
        }).then(function(responses) {
            return responses.map(function(response, index) {
                var _fetcherParams$reques = fetcherParams.requests[index], sourceId = _fetcherParams$reques.sourceId, transformResponse = _fetcherParams$reques.transformResponse;
                return {
                    items: response,
                    sourceId: sourceId,
                    transformResponse: transformResponse
                };
            });
        });
    }
    return function createSpecifiedRequester(requesterParams) {
        return function requester(requestParams) {
            return $5bb1d9f4f24fe8bb$var$_objectSpread($5bb1d9f4f24fe8bb$var$_objectSpread({
                requesterId: requesterId,
                execute: execute
            }, requesterParams), requestParams);
        };
    };
}

/**
 * Throws an error if the condition is not met in development mode.
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $c0d61b83e196c4c1$export$f5708dca728d7177(condition, message) {
    return;
}

var $a92f5d5da59449a5$export$83d89fbfd8236492 = '1.17.0';


var $134f5434c802b205$export$9536ea83a4cbd560 = [
    {
        segment: 'autocomplete-core',
        version: (0, $a92f5d5da59449a5$export$83d89fbfd8236492)
    }
];


var $9ad720f7ffcd5ffd$export$2df5424f792538bd = '__aa-highlight__';
var $9ad720f7ffcd5ffd$export$2681d4c6a4ae86 = '__/aa-highlight__';


function $0c4ba3a53ddcd5cd$export$58f35ab8a1251bc0(searchClient) {
    var _ref = searchClient.transporter || {}, _ref$headers = _ref.headers, headers = _ref$headers === void 0 ? {} : _ref$headers, _ref$queryParameters = _ref.queryParameters, queryParameters = _ref$queryParameters === void 0 ? {} : _ref$queryParameters;
    var APP_ID = 'x-algolia-application-id';
    var API_KEY = 'x-algolia-api-key';
    var appId = headers[APP_ID] || queryParameters[APP_ID];
    var apiKey = headers[API_KEY] || queryParameters[API_KEY];
    return {
        appId: appId,
        apiKey: apiKey
    };
}


function $f8b8caf43db6a066$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f8b8caf43db6a066$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f8b8caf43db6a066$var$_typeof(obj);
}
var $f8b8caf43db6a066$var$_excluded = [
    "params"
];
function $f8b8caf43db6a066$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f8b8caf43db6a066$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f8b8caf43db6a066$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f8b8caf43db6a066$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f8b8caf43db6a066$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f8b8caf43db6a066$var$_defineProperty(obj, key, value) {
    key = $f8b8caf43db6a066$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f8b8caf43db6a066$var$_toPropertyKey(arg) {
    var key = $f8b8caf43db6a066$var$_toPrimitive(arg, "string");
    return $f8b8caf43db6a066$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f8b8caf43db6a066$var$_toPrimitive(input, hint) {
    if ($f8b8caf43db6a066$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f8b8caf43db6a066$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f8b8caf43db6a066$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f8b8caf43db6a066$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f8b8caf43db6a066$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f8b8caf43db6a066$var$_toConsumableArray(arr) {
    return $f8b8caf43db6a066$var$_arrayWithoutHoles(arr) || $f8b8caf43db6a066$var$_iterableToArray(arr) || $f8b8caf43db6a066$var$_unsupportedIterableToArray(arr) || $f8b8caf43db6a066$var$_nonIterableSpread();
}
function $f8b8caf43db6a066$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f8b8caf43db6a066$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f8b8caf43db6a066$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f8b8caf43db6a066$var$_arrayLikeToArray(o, minLen);
}
function $f8b8caf43db6a066$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f8b8caf43db6a066$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f8b8caf43db6a066$var$_arrayLikeToArray(arr);
}
function $f8b8caf43db6a066$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f8b8caf43db6a066$export$9e16a9ccc61ab625(_ref) {
    var searchClient = _ref.searchClient, queries = _ref.queries, _ref$userAgents = _ref.userAgents, userAgents = _ref$userAgents === void 0 ? [] : _ref$userAgents;
    if (typeof searchClient.addAlgoliaAgent === 'function') {
        var algoliaAgents = [].concat($f8b8caf43db6a066$var$_toConsumableArray((0, $134f5434c802b205$export$9536ea83a4cbd560)), $f8b8caf43db6a066$var$_toConsumableArray(userAgents));
        algoliaAgents.forEach(function(_ref2) {
            var segment = _ref2.segment, version = _ref2.version;
            searchClient.addAlgoliaAgent(segment, version);
        });
    }
    var _getAppIdAndApiKey = (0, $0c4ba3a53ddcd5cd$export$58f35ab8a1251bc0)(searchClient), appId = _getAppIdAndApiKey.appId, apiKey = _getAppIdAndApiKey.apiKey;
    (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(Boolean(appId), 'The Algolia `appId` was not accessible from the searchClient passed.');
    (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(Boolean(apiKey), 'The Algolia `apiKey` was not accessible from the searchClient passed.');
    return searchClient.search(queries.map(function(searchParameters) {
        var params = searchParameters.params, headers = $f8b8caf43db6a066$var$_objectWithoutProperties(searchParameters, $f8b8caf43db6a066$var$_excluded);
        return $f8b8caf43db6a066$var$_objectSpread($f8b8caf43db6a066$var$_objectSpread({}, headers), {}, {
            params: $f8b8caf43db6a066$var$_objectSpread({
                hitsPerPage: 5,
                highlightPreTag: (0, $9ad720f7ffcd5ffd$export$2df5424f792538bd),
                highlightPostTag: (0, $9ad720f7ffcd5ffd$export$2681d4c6a4ae86)
            }, params)
        });
    })).then(function(response) {
        return response.results.map(function(result, resultIndex) {
            var _result$hits;
            return $f8b8caf43db6a066$var$_objectSpread($f8b8caf43db6a066$var$_objectSpread({}, result), {}, {
                hits: (_result$hits = result.hits) === null || _result$hits === void 0 ? void 0 : _result$hits.map(function(hit) {
                    return $f8b8caf43db6a066$var$_objectSpread($f8b8caf43db6a066$var$_objectSpread({}, hit), {}, {
                        // Bring support for the Insights plugin.
                        __autocomplete_indexName: result.index || queries[resultIndex].indexName,
                        __autocomplete_queryID: result.queryID,
                        __autocomplete_algoliaCredentials: {
                            appId: appId,
                            apiKey: apiKey
                        }
                    });
                })
            });
        });
    });
}



var $02ba42a6613d600b$export$9536ea83a4cbd560 = [
    {
        segment: 'autocomplete-js',
        version: (0, $a92f5d5da59449a5$export$83d89fbfd8236492)
    }
];


function $5ae90152f9658fa8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5ae90152f9658fa8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5ae90152f9658fa8$var$_typeof(obj);
}
function $5ae90152f9658fa8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5ae90152f9658fa8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5ae90152f9658fa8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5ae90152f9658fa8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5ae90152f9658fa8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5ae90152f9658fa8$var$_defineProperty(obj, key, value) {
    key = $5ae90152f9658fa8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5ae90152f9658fa8$var$_toPropertyKey(arg) {
    var key = $5ae90152f9658fa8$var$_toPrimitive(arg, "string");
    return $5ae90152f9658fa8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5ae90152f9658fa8$var$_toPrimitive(input, hint) {
    if ($5ae90152f9658fa8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5ae90152f9658fa8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $5ae90152f9658fa8$export$9f082baead25d83b = (0, $5bb1d9f4f24fe8bb$export$8d54726fdbf08e0a)(function(params) {
    return (0, $f8b8caf43db6a066$export$9e16a9ccc61ab625)($5ae90152f9658fa8$var$_objectSpread($5ae90152f9658fa8$var$_objectSpread({}, params), {}, {
        userAgents: (0, $02ba42a6613d600b$export$9536ea83a4cbd560)
    }));
}, 'algolia');


var $7130cceb9be2fc23$export$d82b34328f310205 = (0, $5ae90152f9658fa8$export$9f082baead25d83b)({
    transformResponse: function transformResponse(response) {
        return response.hits;
    }
});


var $9c645d8fd2e53e04$exports = {};
/*! algoliasearch-lite.umd.js | 4.22.1 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ !function(e, t) {
    $9c645d8fd2e53e04$exports = t();
}($9c645d8fd2e53e04$exports, function() {
    "use strict";
    function e(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function t(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function r(r) {
        for(var n = 1; n < arguments.length; n++){
            var o = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t(Object(o), !0).forEach(function(t) {
                e(r, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function(e) {
                Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
            });
        }
        return r;
    }
    function n(e, t) {
        if (null == e) return {};
        var r, n, o = function(e, t) {
            if (null == e) return {};
            var r, n, o = {}, a = Object.keys(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
            return o;
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
        return o;
    }
    function o(e, t) {
        return function(e) {
            if (Array.isArray(e)) return e;
        }(e) || function(e, t) {
            if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
            var r = [], n = !0, o = !1, a = void 0;
            try {
                for(var u, i = e[Symbol.iterator](); !(n = (u = i.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0);
            } catch (e) {
                o = !0, a = e;
            } finally{
                try {
                    n || null == i.return || i.return();
                } finally{
                    if (o) throw a;
                }
            }
            return r;
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
    }
    function a(e) {
        return function(e) {
            if (Array.isArray(e)) {
                for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                return r;
            }
        }(e) || function(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
    }
    function u(e) {
        var t, r = "algoliasearch-client-js-".concat(e.key), n = function() {
            return void 0 === t && (t = e.localStorage || window.localStorage), t;
        }, a = function() {
            return JSON.parse(n().getItem(r) || "{}");
        }, u = function(e) {
            n().setItem(r, JSON.stringify(e));
        }, i = function() {
            var t = e.timeToLive ? 1e3 * e.timeToLive : null, r = a(), n = Object.fromEntries(Object.entries(r).filter(function(e) {
                return void 0 !== o(e, 2)[1].timestamp;
            }));
            if (u(n), t) {
                var i = Object.fromEntries(Object.entries(n).filter(function(e) {
                    var r = o(e, 2)[1], n = (new Date).getTime();
                    return !(r.timestamp + t < n);
                }));
                u(i);
            }
        };
        return {
            get: function(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return Promise.resolve().then(function() {
                    i();
                    var t = JSON.stringify(e);
                    return a()[t];
                }).then(function(e) {
                    return Promise.all([
                        e ? e.value : t(),
                        void 0 !== e
                    ]);
                }).then(function(e) {
                    var t = o(e, 2), n = t[0], a = t[1];
                    return Promise.all([
                        n,
                        a || r.miss(n)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function(e, t) {
                return Promise.resolve().then(function() {
                    var o = a();
                    return o[JSON.stringify(e)] = {
                        timestamp: (new Date).getTime(),
                        value: t
                    }, n().setItem(r, JSON.stringify(o)), t;
                });
            },
            delete: function(e) {
                return Promise.resolve().then(function() {
                    var t = a();
                    delete t[JSON.stringify(e)], n().setItem(r, JSON.stringify(t));
                });
            },
            clear: function() {
                return Promise.resolve().then(function() {
                    n().removeItem(r);
                });
            }
        };
    }
    function i(e) {
        var t = a(e.caches), r = t.shift();
        return void 0 === r ? {
            get: function(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, n = t();
                return n.then(function(e) {
                    return Promise.all([
                        e,
                        r.miss(e)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function(e, t) {
                return Promise.resolve(t);
            },
            delete: function(e) {
                return Promise.resolve();
            },
            clear: function() {
                return Promise.resolve();
            }
        } : {
            get: function(e, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return r.get(e, n, o).catch(function() {
                    return i({
                        caches: t
                    }).get(e, n, o);
                });
            },
            set: function(e, n) {
                return r.set(e, n).catch(function() {
                    return i({
                        caches: t
                    }).set(e, n);
                });
            },
            delete: function(e) {
                return r.delete(e).catch(function() {
                    return i({
                        caches: t
                    }).delete(e);
                });
            },
            clear: function() {
                return r.clear().catch(function() {
                    return i({
                        caches: t
                    }).clear();
                });
            }
        };
    }
    function s() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            serializable: !0
        }, t = {};
        return {
            get: function(r, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, a = JSON.stringify(r);
                if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
                var u = n(), i = o && o.miss || function() {
                    return Promise.resolve();
                };
                return u.then(function(e) {
                    return i(e);
                }).then(function() {
                    return u;
                });
            },
            set: function(r, n) {
                return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
            },
            delete: function(e) {
                return delete t[JSON.stringify(e)], Promise.resolve();
            },
            clear: function() {
                return t = {}, Promise.resolve();
            }
        };
    }
    function c(e) {
        for(var t = e.length - 1; t > 0; t--){
            var r = Math.floor(Math.random() * (t + 1)), n = e[t];
            e[t] = e[r], e[r] = n;
        }
        return e;
    }
    function l(e, t) {
        return t ? (Object.keys(t).forEach(function(r) {
            e[r] = t[r](e);
        }), e) : e;
    }
    function f(e) {
        for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
        var o = 0;
        return e.replace(/%s/g, function() {
            return encodeURIComponent(r[o++]);
        });
    }
    var m = {
        WithinQueryParameters: 0,
        WithinHeaders: 1
    };
    function h(e, t) {
        var r = e || {}, n = r.data || {};
        return Object.keys(r).forEach(function(e) {
            -1 === [
                "timeout",
                "headers",
                "queryParameters",
                "data",
                "cacheable"
            ].indexOf(e) && (n[e] = r[e]);
        }), {
            data: Object.entries(n).length > 0 ? n : void 0,
            timeout: r.timeout || t,
            headers: r.headers || {},
            queryParameters: r.queryParameters || {},
            cacheable: r.cacheable
        };
    }
    var d = {
        Read: 1,
        Write: 2,
        Any: 3
    }, p = 1, v = 2, g = 3;
    function y(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
        return r(r({}, e), {}, {
            status: t,
            lastUpdate: Date.now()
        });
    }
    function b(e) {
        return "string" == typeof e ? {
            protocol: "https",
            url: e,
            accept: d.Any
        } : {
            protocol: e.protocol || "https",
            url: e.url,
            accept: e.accept || d.Any
        };
    }
    var O = "GET", P = "POST";
    function q(e, t) {
        return Promise.all(t.map(function(t) {
            return e.get(t, function() {
                return Promise.resolve(y(t));
            });
        })).then(function(e) {
            var r = e.filter(function(e) {
                return function(e) {
                    return e.status === p || Date.now() - e.lastUpdate > 12e4;
                }(e);
            }), n = e.filter(function(e) {
                return function(e) {
                    return e.status === g && Date.now() - e.lastUpdate <= 12e4;
                }(e);
            }), o = [].concat(a(r), a(n));
            return {
                getTimeout: function(e, t) {
                    return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t;
                },
                statelessHosts: o.length > 0 ? o.map(function(e) {
                    return b(e);
                }) : t
            };
        });
    }
    function j(e, t, n, o) {
        var u = [], i = function(e, t) {
            if (e.method === O || void 0 === e.data && void 0 === t.data) return;
            var n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
            return JSON.stringify(n);
        }(n, o), s = function(e, t) {
            var n = r(r({}, e.headers), t.headers), o = {};
            return Object.keys(n).forEach(function(e) {
                var t = n[e];
                o[e.toLowerCase()] = t;
            }), o;
        }(e, o), c = n.method, l = n.method !== O ? {} : r(r({}, n.data), o.data), f = r(r(r({
            "x-algolia-agent": e.userAgent.value
        }, e.queryParameters), l), o.queryParameters), m = 0, h = function t(r, a) {
            var l = r.pop();
            if (void 0 === l) throw {
                name: "RetryError",
                message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
                transporterStackTrace: A(u)
            };
            var h = {
                data: i,
                headers: s,
                method: c,
                url: S(l, n.path, f),
                connectTimeout: a(m, e.timeouts.connect),
                responseTimeout: a(m, o.timeout)
            }, d = function(e) {
                var t = {
                    request: h,
                    response: e,
                    host: l,
                    triesLeft: r.length
                };
                return u.push(t), t;
            }, p = {
                onSuccess: function(e) {
                    return function(e) {
                        try {
                            return JSON.parse(e.content);
                        } catch (t) {
                            throw function(e, t) {
                                return {
                                    name: "DeserializationError",
                                    message: e,
                                    response: t
                                };
                            }(t.message, e);
                        }
                    }(e);
                },
                onRetry: function(n) {
                    var o = d(n);
                    return n.isTimedOut && m++, Promise.all([
                        e.logger.info("Retryable failure", N(o)),
                        e.hostsCache.set(l, y(l, n.isTimedOut ? g : v))
                    ]).then(function() {
                        return t(r, a);
                    });
                },
                onFail: function(e) {
                    throw d(e), function(e, t) {
                        var r = e.content, n = e.status, o = r;
                        try {
                            o = JSON.parse(r).message;
                        } catch (e) {}
                        return function(e, t, r) {
                            return {
                                name: "ApiError",
                                message: e,
                                status: t,
                                transporterStackTrace: r
                            };
                        }(o, n, t);
                    }(e, A(u));
                }
            };
            return e.requester.send(h).then(function(e) {
                return function(e, t) {
                    return function(e) {
                        var t = e.status;
                        return e.isTimedOut || function(e) {
                            var t = e.isTimedOut, r = e.status;
                            return !t && 0 == ~~r;
                        }(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100);
                    }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e);
                }(e, p);
            });
        };
        return q(e.hostsCache, t).then(function(e) {
            return h(a(e.statelessHosts).reverse(), e.getTimeout);
        });
    }
    function w(e) {
        var t = {
            value: "Algolia for JavaScript (".concat(e, ")"),
            add: function(e) {
                var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
                return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t;
            }
        };
        return t;
    }
    function S(e, t, r) {
        var n = T(r), o = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
        return n.length && (o += "?".concat(n)), o;
    }
    function T(e) {
        return Object.keys(e).map(function(t) {
            var r;
            return f("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
        }).join("&");
    }
    function A(e) {
        return e.map(function(e) {
            return N(e);
        });
    }
    function N(e) {
        var t = e.request.headers["x-algolia-api-key"] ? {
            "x-algolia-api-key": "*****"
        } : {};
        return r(r({}, e), {}, {
            request: r(r({}, e.request), {}, {
                headers: r(r({}, e.request.headers), t)
            })
        });
    }
    var x = function(e) {
        var t = e.appId, n = function(e, t, r) {
            var n = {
                "x-algolia-api-key": r,
                "x-algolia-application-id": t
            };
            return {
                headers: function() {
                    return e === m.WithinHeaders ? n : {};
                },
                queryParameters: function() {
                    return e === m.WithinQueryParameters ? n : {};
                }
            };
        }(void 0 !== e.authMode ? e.authMode : m.WithinHeaders, t, e.apiKey), a = function(e) {
            var t = e.hostsCache, r = e.logger, n = e.requester, a = e.requestsCache, u = e.responsesCache, i = e.timeouts, s = e.userAgent, c = e.hosts, l = e.queryParameters, f = {
                hostsCache: t,
                logger: r,
                requester: n,
                requestsCache: a,
                responsesCache: u,
                timeouts: i,
                userAgent: s,
                headers: e.headers,
                queryParameters: l,
                hosts: c.map(function(e) {
                    return b(e);
                }),
                read: function(e, t) {
                    var r = h(t, f.timeouts.read), n = function() {
                        return j(f, f.hosts.filter(function(e) {
                            return 0 != (e.accept & d.Read);
                        }), e, r);
                    };
                    if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable)) return n();
                    var a = {
                        request: e,
                        mappedRequestOptions: r,
                        transporter: {
                            queryParameters: f.queryParameters,
                            headers: f.headers
                        }
                    };
                    return f.responsesCache.get(a, function() {
                        return f.requestsCache.get(a, function() {
                            return f.requestsCache.set(a, n()).then(function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    e
                                ]);
                            }, function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    Promise.reject(e)
                                ]);
                            }).then(function(e) {
                                var t = o(e, 2);
                                t[0];
                                return t[1];
                            });
                        });
                    }, {
                        miss: function(e) {
                            return f.responsesCache.set(a, e);
                        }
                    });
                },
                write: function(e, t) {
                    return j(f, f.hosts.filter(function(e) {
                        return 0 != (e.accept & d.Write);
                    }), e, h(t, f.timeouts.write));
                }
            };
            return f;
        }(r(r({
            hosts: [
                {
                    url: "".concat(t, "-dsn.algolia.net"),
                    accept: d.Read
                },
                {
                    url: "".concat(t, ".algolia.net"),
                    accept: d.Write
                }
            ].concat(c([
                {
                    url: "".concat(t, "-1.algolianet.com")
                },
                {
                    url: "".concat(t, "-2.algolianet.com")
                },
                {
                    url: "".concat(t, "-3.algolianet.com")
                }
            ]))
        }, e), {}, {
            headers: r(r(r({}, n.headers()), {
                "content-type": "application/x-www-form-urlencoded"
            }), e.headers),
            queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
        }));
        return l({
            transporter: a,
            appId: t,
            addAlgoliaAgent: function(e, t) {
                a.userAgent.add({
                    segment: e,
                    version: t
                });
            },
            clearCache: function() {
                return Promise.all([
                    a.requestsCache.clear(),
                    a.responsesCache.clear()
                ]).then(function() {});
            }
        }, e.methods);
    }, C = function(e) {
        return function(t, r) {
            return t.method === O ? e.transporter.read(t, r) : e.transporter.write(t, r);
        };
    }, E = function(e) {
        return function(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {
                transporter: e.transporter,
                appId: e.appId,
                indexName: t
            };
            return l(n, r.methods);
        };
    }, J = function(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    params: T(e.params || {})
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/queries",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    }, k = function(e) {
        return function(t, o) {
            return Promise.all(t.map(function(t) {
                var a = t.params, u = a.facetName, i = a.facetQuery, s = n(a, [
                    "facetName",
                    "facetQuery"
                ]);
                return E(e)(t.indexName, {
                    methods: {
                        searchForFacetValues: R
                    }
                }).searchForFacetValues(u, i, r(r({}, o), s));
            }));
        };
    }, I = function(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/answers/%s/prediction", e.indexName),
                data: {
                    query: t,
                    queryLanguages: r
                },
                cacheable: !0
            }, n);
        };
    }, F = function(e) {
        return function(t, r) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/query", e.indexName),
                data: {
                    query: t
                },
                cacheable: !0
            }, r);
        };
    }, R = function(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
                data: {
                    facetQuery: r
                },
                cacheable: !0
            }, n);
        };
    }, D = 1, W = 2, H = 3;
    function Q(e, t, n) {
        var o, a = {
            appId: e,
            apiKey: t,
            timeouts: {
                connect: 1,
                read: 2,
                write: 30
            },
            requester: {
                send: function(e) {
                    return new Promise(function(t) {
                        var r = new XMLHttpRequest;
                        r.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function(t) {
                            return r.setRequestHeader(t, e.headers[t]);
                        });
                        var n, o = function(e, n) {
                            return setTimeout(function() {
                                r.abort(), t({
                                    status: 0,
                                    content: n,
                                    isTimedOut: !0
                                });
                            }, 1e3 * e);
                        }, a = o(e.connectTimeout, "Connection timeout");
                        r.onreadystatechange = function() {
                            r.readyState > r.OPENED && void 0 === n && (clearTimeout(a), n = o(e.responseTimeout, "Socket timeout"));
                        }, r.onerror = function() {
                            0 === r.status && (clearTimeout(a), clearTimeout(n), t({
                                content: r.responseText || "Network request failed",
                                status: r.status,
                                isTimedOut: !1
                            }));
                        }, r.onload = function() {
                            clearTimeout(a), clearTimeout(n), t({
                                content: r.responseText,
                                status: r.status,
                                isTimedOut: !1
                            });
                        }, r.send(e.data);
                    });
                }
            },
            logger: (o = H, {
                debug: function(e, t) {
                    return D >= o && console.debug(e, t), Promise.resolve();
                },
                info: function(e, t) {
                    return W >= o && console.info(e, t), Promise.resolve();
                },
                error: function(e, t) {
                    return console.error(e, t), Promise.resolve();
                }
            }),
            responsesCache: s(),
            requestsCache: s({
                serializable: !1
            }),
            hostsCache: i({
                caches: [
                    u({
                        key: "".concat("4.22.1", "-").concat(e)
                    }),
                    s()
                ]
            }),
            userAgent: w("4.22.1").add({
                segment: "Browser",
                version: "lite"
            }),
            authMode: m.WithinQueryParameters
        };
        return x(r(r(r({}, a), n), {}, {
            methods: {
                search: J,
                searchForFacetValues: k,
                multipleQueries: J,
                multipleSearchForFacetValues: k,
                customRequest: C,
                initIndex: function(e) {
                    return function(t) {
                        return E(e)(t, {
                            methods: {
                                search: F,
                                searchForFacetValues: R,
                                findAnswers: I
                            }
                        });
                    };
                }
            }
        }));
    }
    return Q.version = "4.22.1", Q;
});




function $01c9e23a5dd7f92b$export$7d1e3a5e95ceca43(initialValue) {
    return {
        current: initialValue
    };
}

function $1a895ed241f1e396$export$61fc7d43ac8f84b0(fn, time) {
    var timerId = undefined;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(function() {
            return fn.apply(void 0, args);
        }, time);
    };
}

function $ef52e92c81aace68$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $ef52e92c81aace68$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($ef52e92c81aace68$var$isPrimitive(first) || $ef52e92c81aace68$var$isPrimitive(second) || typeof first === 'function' || typeof second === 'function') return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$ef52e92c81aace68$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

var $ca0064faea230143$export$8793edee2d425525 = function noop() {};

/**
 * Safely runs code meant for browser environments only.
 */ function $c6c518ced8df3043$export$39f19eed34acd2f1(callback) {
    if (typeof window !== 'undefined') return callback({
        window: window
    });
    return undefined;
}


function $69bf233cc850bb6f$export$285269928260a84d(_ref) {
    var item = _ref.item, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items;
    return {
        index: item.__autocomplete_indexName,
        items: [
            item
        ],
        positions: [
            1 + items.findIndex(function(x) {
                return x.objectID === item.objectID;
            })
        ],
        queryID: item.__autocomplete_queryID,
        algoliaSource: [
            'autocomplete'
        ]
    };
}


function $a1a42126c90ce84f$var$_slicedToArray(arr, i) {
    return $a1a42126c90ce84f$var$_arrayWithHoles(arr) || $a1a42126c90ce84f$var$_iterableToArrayLimit(arr, i) || $a1a42126c90ce84f$var$_unsupportedIterableToArray(arr, i) || $a1a42126c90ce84f$var$_nonIterableRest();
}
function $a1a42126c90ce84f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a1a42126c90ce84f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a1a42126c90ce84f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a1a42126c90ce84f$var$_arrayLikeToArray(o, minLen);
}
function $a1a42126c90ce84f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a1a42126c90ce84f$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $a1a42126c90ce84f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a1a42126c90ce84f$export$5c9cfc0c9d3b5e01(client) {
    var _split$map = (client.version || '').split('.').map(Number), _split$map2 = $a1a42126c90ce84f$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/camelcase */ var v3 = major >= 3;
    var v2_4 = major === 2 && minor >= 4;
    var v1_10 = major === 1 && minor >= 10;
    return v3 || v2_4 || v1_10;
/* eslint-enable @typescript-eslint/camelcase */ }


var $870e3dfe753cd7eb$var$_excluded = [
    "items"
], $870e3dfe753cd7eb$var$_excluded2 = [
    "items"
];
function $870e3dfe753cd7eb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $870e3dfe753cd7eb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $870e3dfe753cd7eb$var$_typeof(obj);
}
function $870e3dfe753cd7eb$var$_toConsumableArray(arr) {
    return $870e3dfe753cd7eb$var$_arrayWithoutHoles(arr) || $870e3dfe753cd7eb$var$_iterableToArray(arr) || $870e3dfe753cd7eb$var$_unsupportedIterableToArray(arr) || $870e3dfe753cd7eb$var$_nonIterableSpread();
}
function $870e3dfe753cd7eb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $870e3dfe753cd7eb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $870e3dfe753cd7eb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $870e3dfe753cd7eb$var$_arrayLikeToArray(o, minLen);
}
function $870e3dfe753cd7eb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $870e3dfe753cd7eb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $870e3dfe753cd7eb$var$_arrayLikeToArray(arr);
}
function $870e3dfe753cd7eb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $870e3dfe753cd7eb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $870e3dfe753cd7eb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $870e3dfe753cd7eb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $870e3dfe753cd7eb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $870e3dfe753cd7eb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $870e3dfe753cd7eb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $870e3dfe753cd7eb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $870e3dfe753cd7eb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $870e3dfe753cd7eb$var$_defineProperty(obj, key, value) {
    key = $870e3dfe753cd7eb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $870e3dfe753cd7eb$var$_toPropertyKey(arg) {
    var key = $870e3dfe753cd7eb$var$_toPrimitive(arg, "string");
    return $870e3dfe753cd7eb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $870e3dfe753cd7eb$var$_toPrimitive(input, hint) {
    if ($870e3dfe753cd7eb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($870e3dfe753cd7eb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $870e3dfe753cd7eb$var$chunk(item) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < item.objectIDs.length; i += chunkSize)chunks.push($870e3dfe753cd7eb$var$_objectSpread($870e3dfe753cd7eb$var$_objectSpread({}, item), {}, {
        objectIDs: item.objectIDs.slice(i, i + chunkSize)
    }));
    return chunks;
}
function $870e3dfe753cd7eb$var$mapToInsightsParamsApi(params) {
    return params.map(function(_ref) {
        var items = _ref.items, param = $870e3dfe753cd7eb$var$_objectWithoutProperties(_ref, $870e3dfe753cd7eb$var$_excluded);
        return $870e3dfe753cd7eb$var$_objectSpread($870e3dfe753cd7eb$var$_objectSpread({}, param), {}, {
            objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref2) {
                var objectID = _ref2.objectID;
                return objectID;
            })) || param.objectIDs
        });
    });
}
function $870e3dfe753cd7eb$export$96bc93a891c6f784(searchInsights) {
    var canSendHeaders = (0, $a1a42126c90ce84f$export$5c9cfc0c9d3b5e01)(searchInsights);
    function sendToInsights(method, payloads, items) {
        if (canSendHeaders && typeof items !== 'undefined') {
            var _items$0$__autocomple = items[0].__autocomplete_algoliaCredentials, appId = _items$0$__autocomple.appId, apiKey = _items$0$__autocomple.apiKey;
            var headers = {
                'X-Algolia-Application-Id': appId,
                'X-Algolia-API-Key': apiKey
            };
            searchInsights.apply(void 0, [
                method
            ].concat($870e3dfe753cd7eb$var$_toConsumableArray(payloads), [
                {
                    headers: headers
                }
            ]));
        } else searchInsights.apply(void 0, [
            method
        ].concat($870e3dfe753cd7eb$var$_toConsumableArray(payloads)));
    }
    return {
        /**
     * Initializes Insights with Algolia credentials.
     */ init: function init(appId, apiKey) {
            searchInsights('init', {
                appId: appId,
                apiKey: apiKey
            });
        },
        /**
     * Sets the authenticated user token to attach to events.
     * Unsets the authenticated token by passing `undefined`.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/set-authenticated-user-token/
     */ setAuthenticatedUserToken: function setAuthenticatedUserToken(authenticatedUserToken) {
            searchInsights('setAuthenticatedUserToken', authenticatedUserToken);
        },
        /**
     * Sets the user token to attach to events.
     */ setUserToken: function setUserToken(userToken) {
            searchInsights('setUserToken', userToken);
        },
        /**
     * Sends click events to capture a query and its clicked items and positions.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids-after-search/
     */ clickedObjectIDsAfterSearch: function clickedObjectIDsAfterSearch() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++)params[_key] = arguments[_key];
            if (params.length > 0) sendToInsights('clickedObjectIDsAfterSearch', $870e3dfe753cd7eb$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids/
     */ clickedObjectIDs: function clickedObjectIDs() {
            for(var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)params[_key2] = arguments[_key2];
            if (params.length > 0) sendToInsights('clickedObjectIDs', $870e3dfe753cd7eb$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture the filters a user clicks on.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-filters/
     */ clickedFilters: function clickedFilters() {
            for(var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)params[_key3] = arguments[_key3];
            if (params.length > 0) searchInsights.apply(void 0, [
                'clickedFilters'
            ].concat(params));
        },
        /**
     * Sends conversion events to capture a query and its clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids-after-search/
     */ convertedObjectIDsAfterSearch: function convertedObjectIDsAfterSearch() {
            for(var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)params[_key4] = arguments[_key4];
            if (params.length > 0) sendToInsights('convertedObjectIDsAfterSearch', $870e3dfe753cd7eb$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids/
     */ convertedObjectIDs: function convertedObjectIDs() {
            for(var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)params[_key5] = arguments[_key5];
            if (params.length > 0) sendToInsights('convertedObjectIDs', $870e3dfe753cd7eb$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture the filters a user uses when converting.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-filters/
     */ convertedFilters: function convertedFilters() {
            for(var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)params[_key6] = arguments[_key6];
            if (params.length > 0) searchInsights.apply(void 0, [
                'convertedFilters'
            ].concat(params));
        },
        /**
     * Sends view events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-object-ids/
     */ viewedObjectIDs: function viewedObjectIDs() {
            for(var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)params[_key7] = arguments[_key7];
            if (params.length > 0) params.reduce(function(acc, _ref3) {
                var items = _ref3.items, param = $870e3dfe753cd7eb$var$_objectWithoutProperties(_ref3, $870e3dfe753cd7eb$var$_excluded2);
                return [].concat($870e3dfe753cd7eb$var$_toConsumableArray(acc), $870e3dfe753cd7eb$var$_toConsumableArray($870e3dfe753cd7eb$var$chunk($870e3dfe753cd7eb$var$_objectSpread($870e3dfe753cd7eb$var$_objectSpread({}, param), {}, {
                    objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref4) {
                        var objectID = _ref4.objectID;
                        return objectID;
                    })) || param.objectIDs
                })).map(function(payload) {
                    return {
                        items: items,
                        payload: payload
                    };
                })));
            }, []).forEach(function(_ref5) {
                var items = _ref5.items, payload = _ref5.payload;
                return sendToInsights('viewedObjectIDs', [
                    payload
                ], items);
            });
        },
        /**
     * Sends view events to capture the filters a user uses when viewing.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-filters/
     */ viewedFilters: function viewedFilters() {
            for(var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)params[_key8] = arguments[_key8];
            if (params.length > 0) searchInsights.apply(void 0, [
                'viewedFilters'
            ].concat(params));
        }
    };
}


function $186a72f70b4d2dd1$export$8bae0094a47f6972(_ref) {
    var items = _ref.items;
    var itemsByIndexName = items.reduce(function(acc, current) {
        var _acc$current$__autoco;
        acc[current.__autocomplete_indexName] = ((_acc$current$__autoco = acc[current.__autocomplete_indexName]) !== null && _acc$current$__autoco !== void 0 ? _acc$current$__autoco : []).concat(current);
        return acc;
    }, {});
    return Object.keys(itemsByIndexName).map(function(indexName) {
        var items = itemsByIndexName[indexName];
        return {
            index: indexName,
            items: items,
            algoliaSource: [
                'autocomplete'
            ]
        };
    });
}


function $ac866eea07542dd0$export$977f4849b4f88a72(hit) {
    return hit.objectID && hit.__autocomplete_indexName && hit.__autocomplete_queryID;
}


function $a82c53bae852b484$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a82c53bae852b484$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a82c53bae852b484$var$_typeof(obj);
}
function $a82c53bae852b484$var$_toConsumableArray(arr) {
    return $a82c53bae852b484$var$_arrayWithoutHoles(arr) || $a82c53bae852b484$var$_iterableToArray(arr) || $a82c53bae852b484$var$_unsupportedIterableToArray(arr) || $a82c53bae852b484$var$_nonIterableSpread();
}
function $a82c53bae852b484$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a82c53bae852b484$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a82c53bae852b484$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a82c53bae852b484$var$_arrayLikeToArray(o, minLen);
}
function $a82c53bae852b484$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a82c53bae852b484$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a82c53bae852b484$var$_arrayLikeToArray(arr);
}
function $a82c53bae852b484$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a82c53bae852b484$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a82c53bae852b484$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a82c53bae852b484$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a82c53bae852b484$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a82c53bae852b484$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a82c53bae852b484$var$_defineProperty(obj, key, value) {
    key = $a82c53bae852b484$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a82c53bae852b484$var$_toPropertyKey(arg) {
    var key = $a82c53bae852b484$var$_toPrimitive(arg, "string");
    return $a82c53bae852b484$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a82c53bae852b484$var$_toPrimitive(input, hint) {
    if ($a82c53bae852b484$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a82c53bae852b484$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a82c53bae852b484$var$VIEW_EVENT_DELAY = 400;
var $a82c53bae852b484$var$ALGOLIA_INSIGHTS_VERSION = '2.13.0';
var $a82c53bae852b484$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($a82c53bae852b484$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
var $a82c53bae852b484$var$sendViewedObjectIDs = (0, $1a895ed241f1e396$export$61fc7d43ac8f84b0)(function(_ref) {
    var onItemsChange = _ref.onItemsChange, items = _ref.items, insights = _ref.insights, state = _ref.state;
    onItemsChange({
        insights: insights,
        insightsEvents: (0, $186a72f70b4d2dd1$export$8bae0094a47f6972)({
            items: items
        }).map(function(event) {
            return $a82c53bae852b484$var$_objectSpread({
                eventName: 'Items Viewed'
            }, event);
        }),
        state: state
    });
}, $a82c53bae852b484$var$VIEW_EVENT_DELAY);
function $a82c53bae852b484$export$89ab4208990a3782(options) {
    var _getOptions = $a82c53bae852b484$var$getOptions(options), providedInsightsClient = _getOptions.insightsClient, insightsInitParams = _getOptions.insightsInitParams, onItemsChange = _getOptions.onItemsChange, onSelectEvent = _getOptions.onSelect, onActiveEvent = _getOptions.onActive, __autocomplete_clickAnalytics = _getOptions.__autocomplete_clickAnalytics;
    var insightsClient = providedInsightsClient;
    if (!providedInsightsClient) (0, $c6c518ced8df3043$export$39f19eed34acd2f1)(function(_ref2) {
        var window = _ref2.window;
        var pointer = window.AlgoliaAnalyticsObject || 'aa';
        if (typeof pointer === 'string') insightsClient = window[pointer];
        if (!insightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) window[pointer] = function() {
                if (!window[pointer].queue) window[pointer].queue = [];
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                window[pointer].queue.push(args);
            };
            window[pointer].version = $a82c53bae852b484$var$ALGOLIA_INSIGHTS_VERSION;
            insightsClient = window[pointer];
            $a82c53bae852b484$var$loadInsights(window);
        }
    });
    // We return an empty plugin if `insightsClient` is still undefined at
    // this stage, which can happen in server environments.
    if (!insightsClient) return {};
    if (insightsInitParams) insightsClient('init', $a82c53bae852b484$var$_objectSpread({
        partial: true
    }, insightsInitParams));
    var insights = (0, $870e3dfe753cd7eb$export$96bc93a891c6f784)(insightsClient);
    var previousItems = (0, $01c9e23a5dd7f92b$export$7d1e3a5e95ceca43)([]);
    var debouncedOnStateChange = (0, $1a895ed241f1e396$export$61fc7d43ac8f84b0)(function(_ref3) {
        var state = _ref3.state;
        if (!state.isOpen) return;
        var items = state.collections.reduce(function(acc, current) {
            return [].concat($a82c53bae852b484$var$_toConsumableArray(acc), $a82c53bae852b484$var$_toConsumableArray(current.items));
        }, []).filter((0, $ac866eea07542dd0$export$977f4849b4f88a72));
        if (!(0, $ef52e92c81aace68$export$248d38f6296296c5)(previousItems.current.map(function(x) {
            return x.objectID;
        }), items.map(function(x) {
            return x.objectID;
        }))) {
            previousItems.current = items;
            if (items.length > 0) $a82c53bae852b484$var$sendViewedObjectIDs({
                onItemsChange: onItemsChange,
                items: items,
                insights: insights,
                state: state
            });
        }
    }, 0);
    return {
        name: 'aa.algoliaInsightsPlugin',
        subscribe: function subscribe(_ref4) {
            var setContext = _ref4.setContext, onSelect = _ref4.onSelect, onActive = _ref4.onActive;
            var isAuthenticatedToken = false;
            function setInsightsContext(userToken) {
                setContext({
                    algoliaInsightsPlugin: {
                        __algoliaSearchParameters: $a82c53bae852b484$var$_objectSpread($a82c53bae852b484$var$_objectSpread({}, __autocomplete_clickAnalytics ? {
                            clickAnalytics: true
                        } : {}), userToken ? {
                            userToken: $a82c53bae852b484$var$normalizeUserToken(userToken)
                        } : {}),
                        insights: insights
                    }
                });
            }
            insightsClient('addAlgoliaAgent', 'insights-plugin');
            setInsightsContext();
            // Handles user token changes
            insightsClient('onUserTokenChange', function(userToken) {
                if (!isAuthenticatedToken) setInsightsContext(userToken);
            });
            insightsClient('getUserToken', null, function(_error, userToken) {
                if (!isAuthenticatedToken) setInsightsContext(userToken);
            });
            // Handles authenticated user token changes
            insightsClient('onAuthenticatedUserTokenChange', function(authenticatedUserToken) {
                if (authenticatedUserToken) {
                    isAuthenticatedToken = true;
                    setInsightsContext(authenticatedUserToken);
                } else {
                    isAuthenticatedToken = false;
                    insightsClient('getUserToken', null, function(_error, userToken) {
                        return setInsightsContext(userToken);
                    });
                }
            });
            insightsClient('getAuthenticatedUserToken', null, function(_error, authenticatedUserToken) {
                if (authenticatedUserToken) {
                    isAuthenticatedToken = true;
                    setInsightsContext(authenticatedUserToken);
                }
            });
            onSelect(function(_ref5) {
                var item = _ref5.item, state = _ref5.state, event = _ref5.event, source = _ref5.source;
                if (!(0, $ac866eea07542dd0$export$977f4849b4f88a72)(item)) return;
                onSelectEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $a82c53bae852b484$var$_objectSpread({
                            eventName: 'Item Selected'
                        }, (0, $69bf233cc850bb6f$export$285269928260a84d)({
                            item: item,
                            items: source.getItems().filter((0, $ac866eea07542dd0$export$977f4849b4f88a72))
                        }))
                    ]
                });
            });
            onActive(function(_ref6) {
                var item = _ref6.item, source = _ref6.source, state = _ref6.state, event = _ref6.event;
                if (!(0, $ac866eea07542dd0$export$977f4849b4f88a72)(item)) return;
                onActiveEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $a82c53bae852b484$var$_objectSpread({
                            eventName: 'Item Active'
                        }, (0, $69bf233cc850bb6f$export$285269928260a84d)({
                            item: item,
                            items: source.getItems().filter((0, $ac866eea07542dd0$export$977f4849b4f88a72))
                        }))
                    ]
                });
            });
        },
        onStateChange: function onStateChange(_ref7) {
            var state = _ref7.state;
            debouncedOnStateChange({
                state: state
            });
        },
        __autocomplete_pluginOptions: options
    };
}
function $a82c53bae852b484$var$getAlgoliaSources() {
    var _context$algoliaInsig;
    var algoliaSourceBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var context = arguments.length > 1 ? arguments[1] : undefined;
    return [].concat($a82c53bae852b484$var$_toConsumableArray(algoliaSourceBase), [
        'autocomplete-internal'
    ], $a82c53bae852b484$var$_toConsumableArray((_context$algoliaInsig = context.algoliaInsightsPlugin) !== null && _context$algoliaInsig !== void 0 && _context$algoliaInsig.__automaticInsights ? [
        'autocomplete-automatic'
    ] : []));
}
function $a82c53bae852b484$var$getOptions(options) {
    return $a82c53bae852b484$var$_objectSpread({
        onItemsChange: function onItemsChange(_ref8) {
            var insights = _ref8.insights, insightsEvents = _ref8.insightsEvents, state = _ref8.state;
            insights.viewedObjectIDs.apply(insights, $a82c53bae852b484$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $a82c53bae852b484$var$_objectSpread($a82c53bae852b484$var$_objectSpread({}, event), {}, {
                    algoliaSource: $a82c53bae852b484$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onSelect: function onSelect(_ref9) {
            var insights = _ref9.insights, insightsEvents = _ref9.insightsEvents, state = _ref9.state;
            insights.clickedObjectIDsAfterSearch.apply(insights, $a82c53bae852b484$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $a82c53bae852b484$var$_objectSpread($a82c53bae852b484$var$_objectSpread({}, event), {}, {
                    algoliaSource: $a82c53bae852b484$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onActive: (0, $ca0064faea230143$export$8793edee2d425525),
        __autocomplete_clickAnalytics: true
    }, options);
}
function $a82c53bae852b484$var$loadInsights(environment) {
    var errorMessage = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
    try {
        var script = environment.document.createElement('script');
        script.async = true;
        script.src = $a82c53bae852b484$var$ALGOLIA_INSIGHTS_SRC;
        script.onerror = function() {
            // eslint-disable-next-line no-console
            console.error(errorMessage);
        };
        document.body.appendChild(script);
    } catch (cause) {
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $a82c53bae852b484$var$normalizeUserToken(userToken) {
    return typeof userToken === 'number' ? userToken.toString() : userToken;
}



function $56f6d8950b292669$export$6fe837ce0e0e0cdf(options) {}


function $9cad636c0390c956$export$9661f890aacb4415() {
    var list = [];
    return {
        add: function add(cancelablePromise) {
            list.push(cancelablePromise);
            return cancelablePromise.finally(function() {
                list = list.filter(function(item) {
                    return item !== cancelablePromise;
                });
            });
        },
        cancelAll: function cancelAll() {
            list.forEach(function(promise) {
                return promise.cancel();
            });
        },
        isEmpty: function isEmpty() {
            return list.length === 0;
        }
    };
}


function $e93801cf8d0b838b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e93801cf8d0b838b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e93801cf8d0b838b$var$_typeof(obj);
}
function $e93801cf8d0b838b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e93801cf8d0b838b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e93801cf8d0b838b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e93801cf8d0b838b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e93801cf8d0b838b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e93801cf8d0b838b$var$_defineProperty(obj, key, value) {
    key = $e93801cf8d0b838b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e93801cf8d0b838b$var$_toPropertyKey(arg) {
    var key = $e93801cf8d0b838b$var$_toPrimitive(arg, "string");
    return $e93801cf8d0b838b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e93801cf8d0b838b$var$_toPrimitive(input, hint) {
    if ($e93801cf8d0b838b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e93801cf8d0b838b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e93801cf8d0b838b$export$f51a9068ac82ea43(reducer, props, onStoreStateChange) {
    var state = props.initialState;
    return {
        getState: function getState() {
            return state;
        },
        dispatch: function dispatch(action, payload) {
            var prevState = $e93801cf8d0b838b$var$_objectSpread({}, state);
            state = reducer(state, {
                type: action,
                props: props,
                payload: payload
            });
            onStoreStateChange({
                state: state,
                prevState: prevState
            });
        },
        pendingRequests: (0, $9cad636c0390c956$export$9661f890aacb4415)()
    };
}


function $18ef26517fb42da2$export$bffa455ba8c619a6(values) {
    return values.reduce(function(a, b) {
        return a.concat(b);
    }, []);
}


function $5fa042d311d2d767$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5fa042d311d2d767$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5fa042d311d2d767$var$_typeof(obj);
}
function $5fa042d311d2d767$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5fa042d311d2d767$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5fa042d311d2d767$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5fa042d311d2d767$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5fa042d311d2d767$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5fa042d311d2d767$var$_defineProperty(obj, key, value) {
    key = $5fa042d311d2d767$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5fa042d311d2d767$var$_toPropertyKey(arg) {
    var key = $5fa042d311d2d767$var$_toPrimitive(arg, "string");
    return $5fa042d311d2d767$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5fa042d311d2d767$var$_toPrimitive(input, hint) {
    if ($5fa042d311d2d767$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5fa042d311d2d767$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5fa042d311d2d767$export$5085b122b817cee(_ref) {
    var store = _ref.store;
    var setActiveItemId = function setActiveItemId(value) {
        store.dispatch('setActiveItemId', value);
    };
    var setQuery = function setQuery(value) {
        store.dispatch('setQuery', value);
    };
    var setCollections = function setCollections(rawValue) {
        var baseItemId = 0;
        var value = rawValue.map(function(collection) {
            return $5fa042d311d2d767$var$_objectSpread($5fa042d311d2d767$var$_objectSpread({}, collection), {}, {
                // We flatten the stored items to support calling `getAlgoliaResults`
                // from the source itself.
                items: (0, $18ef26517fb42da2$export$bffa455ba8c619a6)(collection.items).map(function(item) {
                    return $5fa042d311d2d767$var$_objectSpread($5fa042d311d2d767$var$_objectSpread({}, item), {}, {
                        __autocomplete_id: baseItemId++
                    });
                })
            });
        });
        store.dispatch('setCollections', value);
    };
    var setIsOpen = function setIsOpen(value) {
        store.dispatch('setIsOpen', value);
    };
    var setStatus = function setStatus(value) {
        store.dispatch('setStatus', value);
    };
    var setContext = function setContext(value) {
        store.dispatch('setContext', value);
    };
    return {
        setActiveItemId: setActiveItemId,
        setQuery: setQuery,
        setCollections: setCollections,
        setIsOpen: setIsOpen,
        setStatus: setStatus,
        setContext: setContext
    };
}


var $dd58adffabb2430e$var$autocompleteId = 0;
function $dd58adffabb2430e$export$46ae397d8484b6c2() {
    return "autocomplete-".concat($dd58adffabb2430e$var$autocompleteId++);
}

function $009101fa2649e815$export$dd01a43948d7de86(state) {
    if (state.collections.length === 0) return 0;
    return state.collections.reduce(function(sum, collection) {
        return sum + collection.items.length;
    }, 0);
}


function $57bfcc81421994ca$var$_slicedToArray(arr, i) {
    return $57bfcc81421994ca$var$_arrayWithHoles(arr) || $57bfcc81421994ca$var$_iterableToArrayLimit(arr, i) || $57bfcc81421994ca$var$_unsupportedIterableToArray(arr, i) || $57bfcc81421994ca$var$_nonIterableRest();
}
function $57bfcc81421994ca$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $57bfcc81421994ca$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $57bfcc81421994ca$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $57bfcc81421994ca$var$_arrayLikeToArray(o, minLen);
}
function $57bfcc81421994ca$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $57bfcc81421994ca$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $57bfcc81421994ca$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $57bfcc81421994ca$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $57bfcc81421994ca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $57bfcc81421994ca$var$_typeof(obj);
}
function $57bfcc81421994ca$export$ed3e2bdb532b061f(obj) {
    var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    var newSeen;
    return obj;
}


function $4d97cbcbbbc79166$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4d97cbcbbbc79166$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4d97cbcbbbc79166$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4d97cbcbbbc79166$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4d97cbcbbbc79166$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4d97cbcbbbc79166$var$_defineProperty(obj, key, value) {
    key = $4d97cbcbbbc79166$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4d97cbcbbbc79166$var$_toPropertyKey(arg) {
    var key = $4d97cbcbbbc79166$var$_toPrimitive(arg, "string");
    return $4d97cbcbbbc79166$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4d97cbcbbbc79166$var$_toPrimitive(input, hint) {
    if ($4d97cbcbbbc79166$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4d97cbcbbbc79166$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4d97cbcbbbc79166$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4d97cbcbbbc79166$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4d97cbcbbbc79166$var$_typeof(obj);
}
function $4d97cbcbbbc79166$export$c7afda361f77b571(getSources, params) {
    var seenSourceIds = [];
    return Promise.resolve(getSources(params)).then(function(sources) {
        (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(Array.isArray(sources), function() {
            return "The `getSources` function must return an array of sources but returned type ".concat(JSON.stringify($4d97cbcbbbc79166$var$_typeof(sources)), ":\n\n").concat(JSON.stringify((0, $57bfcc81421994ca$export$ed3e2bdb532b061f)(sources), null, 2));
        });
        return Promise.all(sources// We allow `undefined` and `false` sources to allow users to use
        // `Boolean(query) && source` (=> `false`).
        // We need to remove these values at this point.
        .filter(function(maybeSource) {
            return Boolean(maybeSource);
        }).map(function(source) {
            (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(typeof source.sourceId === 'string', 'A source must provide a `sourceId` string.');
            if (seenSourceIds.includes(source.sourceId)) throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(source.sourceId), " is not unique."));
            seenSourceIds.push(source.sourceId);
            var defaultSource = {
                getItemInputValue: function getItemInputValue(_ref) {
                    var state = _ref.state;
                    return state.query;
                },
                getItemUrl: function getItemUrl() {
                    return undefined;
                },
                onSelect: function onSelect(_ref2) {
                    var setIsOpen = _ref2.setIsOpen;
                    setIsOpen(false);
                },
                onActive: (0, $ca0064faea230143$export$8793edee2d425525),
                onResolve: (0, $ca0064faea230143$export$8793edee2d425525)
            };
            Object.keys(defaultSource).forEach(function(key) {
                defaultSource[key].__default = true;
            });
            var normalizedSource = $4d97cbcbbbc79166$var$_objectSpread($4d97cbcbbbc79166$var$_objectSpread({}, defaultSource), source);
            return Promise.resolve(normalizedSource);
        }));
    });
}


function $ef1762a627541762$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ef1762a627541762$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ef1762a627541762$var$_typeof(obj);
}
function $ef1762a627541762$var$_toConsumableArray(arr) {
    return $ef1762a627541762$var$_arrayWithoutHoles(arr) || $ef1762a627541762$var$_iterableToArray(arr) || $ef1762a627541762$var$_unsupportedIterableToArray(arr) || $ef1762a627541762$var$_nonIterableSpread();
}
function $ef1762a627541762$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ef1762a627541762$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ef1762a627541762$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ef1762a627541762$var$_arrayLikeToArray(o, minLen);
}
function $ef1762a627541762$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ef1762a627541762$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ef1762a627541762$var$_arrayLikeToArray(arr);
}
function $ef1762a627541762$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ef1762a627541762$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ef1762a627541762$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ef1762a627541762$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ef1762a627541762$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ef1762a627541762$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ef1762a627541762$var$_defineProperty(obj, key, value) {
    key = $ef1762a627541762$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef1762a627541762$var$_toPropertyKey(arg) {
    var key = $ef1762a627541762$var$_toPrimitive(arg, "string");
    return $ef1762a627541762$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ef1762a627541762$var$_toPrimitive(input, hint) {
    if ($ef1762a627541762$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ef1762a627541762$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ef1762a627541762$export$61b94149aeb1f59(props, pluginSubscribers) {
    var _props$id;
    /* eslint-disable no-restricted-globals */ var environment = typeof window !== 'undefined' ? window : {};
    /* eslint-enable no-restricted-globals */ var plugins = props.plugins || [];
    return $ef1762a627541762$var$_objectSpread($ef1762a627541762$var$_objectSpread({
        debug: false,
        openOnFocus: false,
        enterKeyHint: undefined,
        ignoreCompositionEvents: false,
        placeholder: '',
        autoFocus: false,
        defaultActiveItemId: null,
        stallThreshold: 300,
        insights: undefined,
        environment: environment,
        shouldPanelOpen: function shouldPanelOpen(_ref) {
            var state = _ref.state;
            return (0, $009101fa2649e815$export$dd01a43948d7de86)(state) > 0;
        },
        reshape: function reshape(_ref2) {
            var sources = _ref2.sources;
            return sources;
        }
    }, props), {}, {
        // Since `generateAutocompleteId` triggers a side effect (it increments
        // an internal counter), we don't want to execute it if unnecessary.
        id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : (0, $dd58adffabb2430e$export$46ae397d8484b6c2)(),
        plugins: plugins,
        // The following props need to be deeply defaulted.
        initialState: $ef1762a627541762$var$_objectSpread({
            activeItemId: null,
            query: '',
            completion: null,
            collections: [],
            isOpen: false,
            status: 'idle',
            context: {}
        }, props.initialState),
        onStateChange: function onStateChange(params) {
            var _props$onStateChange;
            (_props$onStateChange = props.onStateChange) === null || _props$onStateChange === void 0 || _props$onStateChange.call(props, params);
            plugins.forEach(function(x) {
                var _x$onStateChange;
                return (_x$onStateChange = x.onStateChange) === null || _x$onStateChange === void 0 ? void 0 : _x$onStateChange.call(x, params);
            });
        },
        onSubmit: function onSubmit(params) {
            var _props$onSubmit;
            (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 || _props$onSubmit.call(props, params);
            plugins.forEach(function(x) {
                var _x$onSubmit;
                return (_x$onSubmit = x.onSubmit) === null || _x$onSubmit === void 0 ? void 0 : _x$onSubmit.call(x, params);
            });
        },
        onReset: function onReset(params) {
            var _props$onReset;
            (_props$onReset = props.onReset) === null || _props$onReset === void 0 || _props$onReset.call(props, params);
            plugins.forEach(function(x) {
                var _x$onReset;
                return (_x$onReset = x.onReset) === null || _x$onReset === void 0 ? void 0 : _x$onReset.call(x, params);
            });
        },
        getSources: function getSources(params) {
            return Promise.all([].concat($ef1762a627541762$var$_toConsumableArray(plugins.map(function(plugin) {
                return plugin.getSources;
            })), [
                props.getSources
            ]).filter(Boolean).map(function(getSources) {
                return (0, $4d97cbcbbbc79166$export$c7afda361f77b571)(getSources, params);
            })).then(function(nested) {
                return (0, $18ef26517fb42da2$export$bffa455ba8c619a6)(nested);
            }).then(function(sources) {
                return sources.map(function(source) {
                    return $ef1762a627541762$var$_objectSpread($ef1762a627541762$var$_objectSpread({}, source), {}, {
                        onSelect: function onSelect(params) {
                            source.onSelect(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onSelect;
                                return (_x$onSelect = x.onSelect) === null || _x$onSelect === void 0 ? void 0 : _x$onSelect.call(x, params);
                            });
                        },
                        onActive: function onActive(params) {
                            source.onActive(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onActive;
                                return (_x$onActive = x.onActive) === null || _x$onActive === void 0 ? void 0 : _x$onActive.call(x, params);
                            });
                        },
                        onResolve: function onResolve(params) {
                            source.onResolve(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onResolve;
                                return (_x$onResolve = x.onResolve) === null || _x$onResolve === void 0 ? void 0 : _x$onResolve.call(x, params);
                            });
                        }
                    });
                });
            });
        },
        navigator: $ef1762a627541762$var$_objectSpread({
            navigate: function navigate(_ref3) {
                var itemUrl = _ref3.itemUrl;
                environment.location.assign(itemUrl);
            },
            navigateNewTab: function navigateNewTab(_ref4) {
                var itemUrl = _ref4.itemUrl;
                var windowReference = environment.open(itemUrl, '_blank', 'noopener');
                windowReference === null || windowReference === void 0 || windowReference.focus();
            },
            navigateNewWindow: function navigateNewWindow(_ref5) {
                var itemUrl = _ref5.itemUrl;
                environment.open(itemUrl, '_blank', 'noopener');
            }
        }, props.navigator)
    });
}




function $9ad23a01a7c32e90$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9ad23a01a7c32e90$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9ad23a01a7c32e90$var$_typeof(obj);
}
function $9ad23a01a7c32e90$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9ad23a01a7c32e90$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9ad23a01a7c32e90$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9ad23a01a7c32e90$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9ad23a01a7c32e90$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9ad23a01a7c32e90$var$_defineProperty(obj, key, value) {
    key = $9ad23a01a7c32e90$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ad23a01a7c32e90$var$_toPropertyKey(arg) {
    var key = $9ad23a01a7c32e90$var$_toPrimitive(arg, "string");
    return $9ad23a01a7c32e90$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9ad23a01a7c32e90$var$_toPrimitive(input, hint) {
    if ($9ad23a01a7c32e90$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9ad23a01a7c32e90$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9ad23a01a7c32e90$export$9eaad88cf88cee2b(_ref) {
    var collections = _ref.collections, props = _ref.props, state = _ref.state;
    // Sources are grouped by `sourceId` to conveniently pick them via destructuring.
    // Example: `const { recentSearchesPlugin } = sourcesBySourceId`
    var originalSourcesBySourceId = collections.reduce(function(acc, collection) {
        return $9ad23a01a7c32e90$var$_objectSpread($9ad23a01a7c32e90$var$_objectSpread({}, acc), {}, $9ad23a01a7c32e90$var$_defineProperty({}, collection.source.sourceId, $9ad23a01a7c32e90$var$_objectSpread($9ad23a01a7c32e90$var$_objectSpread({}, collection.source), {}, {
            getItems: function getItems() {
                // We provide the resolved items from the collection to the `reshape` prop.
                return (0, $18ef26517fb42da2$export$bffa455ba8c619a6)(collection.items);
            }
        })));
    }, {});
    var _props$plugins$reduce = props.plugins.reduce(function(acc, plugin) {
        if (plugin.reshape) return plugin.reshape(acc);
        return acc;
    }, {
        sourcesBySourceId: originalSourcesBySourceId,
        state: state
    }), sourcesBySourceId = _props$plugins$reduce.sourcesBySourceId;
    var reshapeSources = props.reshape({
        sourcesBySourceId: sourcesBySourceId,
        sources: Object.values(sourcesBySourceId),
        state: state
    });
    // We reconstruct the collections with the items modified by the `reshape` prop.
    return (0, $18ef26517fb42da2$export$bffa455ba8c619a6)(reshapeSources).filter(Boolean).map(function(source) {
        return {
            source: source,
            items: source.getItems()
        };
    });
}



function $f48aafe56891e3b1$export$23042d7bd0b8d14b(rawResults) {
    return {
        results: rawResults,
        hits: rawResults.map(function(result) {
            return result.hits;
        }).filter(Boolean),
        facetHits: rawResults.map(function(result) {
            var _facetHits;
            return (_facetHits = result.facetHits) === null || _facetHits === void 0 ? void 0 : _facetHits.map(function(facetHit) {
                // Bring support for the highlighting components.
                return {
                    label: facetHit.value,
                    count: facetHit.count,
                    _highlightResult: {
                        label: {
                            value: facetHit.highlighted
                        }
                    }
                };
            });
        }).filter(Boolean)
    };
}


function $060299908584e406$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $060299908584e406$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $060299908584e406$var$_typeof(obj);
}
function $060299908584e406$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $060299908584e406$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $060299908584e406$var$ownKeys(Object(source), !0).forEach(function(key) {
            $060299908584e406$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $060299908584e406$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $060299908584e406$var$_defineProperty(obj, key, value) {
    key = $060299908584e406$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $060299908584e406$var$_toPropertyKey(arg) {
    var key = $060299908584e406$var$_toPrimitive(arg, "string");
    return $060299908584e406$var$_typeof(key) === "symbol" ? key : String(key);
}
function $060299908584e406$var$_toPrimitive(input, hint) {
    if ($060299908584e406$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($060299908584e406$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $060299908584e406$var$_toConsumableArray(arr) {
    return $060299908584e406$var$_arrayWithoutHoles(arr) || $060299908584e406$var$_iterableToArray(arr) || $060299908584e406$var$_unsupportedIterableToArray(arr) || $060299908584e406$var$_nonIterableSpread();
}
function $060299908584e406$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $060299908584e406$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $060299908584e406$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $060299908584e406$var$_arrayLikeToArray(o, minLen);
}
function $060299908584e406$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $060299908584e406$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $060299908584e406$var$_arrayLikeToArray(arr);
}
function $060299908584e406$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $060299908584e406$var$isDescription(item) {
    return Boolean(item.execute);
}
function $060299908584e406$var$isRequesterDescription(description) {
    return Boolean(description === null || description === void 0 ? void 0 : description.execute);
}
function $060299908584e406$export$ae3cd3529c74e69e(itemsOrDescription, sourceId, state) {
    if ($060299908584e406$var$isRequesterDescription(itemsOrDescription)) {
        var contextParameters = itemsOrDescription.requesterId === 'algolia' ? Object.assign.apply(Object, [
            {}
        ].concat($060299908584e406$var$_toConsumableArray(Object.keys(state.context).map(function(key) {
            var _state$context$key;
            return (_state$context$key = state.context[key]) === null || _state$context$key === void 0 ? void 0 : _state$context$key.__algoliaSearchParameters;
        })))) : {};
        return $060299908584e406$var$_objectSpread($060299908584e406$var$_objectSpread({}, itemsOrDescription), {}, {
            requests: itemsOrDescription.queries.map(function(query) {
                return {
                    query: itemsOrDescription.requesterId === 'algolia' ? $060299908584e406$var$_objectSpread($060299908584e406$var$_objectSpread({}, query), {}, {
                        params: $060299908584e406$var$_objectSpread($060299908584e406$var$_objectSpread({}, contextParameters), query.params)
                    }) : query,
                    sourceId: sourceId,
                    transformResponse: itemsOrDescription.transformResponse
                };
            })
        });
    }
    return {
        items: itemsOrDescription,
        sourceId: sourceId
    };
}
function $060299908584e406$export$f7ad0328861e2f03(items) {
    var packed = items.reduce(function(acc, current) {
        if (!$060299908584e406$var$isDescription(current)) {
            acc.push(current);
            return acc;
        }
        var searchClient = current.searchClient, execute = current.execute, requesterId = current.requesterId, requests = current.requests;
        var container = acc.find(function(item) {
            return $060299908584e406$var$isDescription(current) && $060299908584e406$var$isDescription(item) && item.searchClient === searchClient && Boolean(requesterId) && item.requesterId === requesterId;
        });
        if (container) {
            var _container$items;
            (_container$items = container.items).push.apply(_container$items, $060299908584e406$var$_toConsumableArray(requests));
        } else {
            var request = {
                execute: execute,
                requesterId: requesterId,
                items: requests,
                searchClient: searchClient
            };
            acc.push(request);
        }
        return acc;
    }, []);
    var values = packed.map(function(maybeDescription) {
        if (!$060299908584e406$var$isDescription(maybeDescription)) return Promise.resolve(maybeDescription);
        var _ref = maybeDescription, execute = _ref.execute, items = _ref.items, searchClient = _ref.searchClient;
        return execute({
            searchClient: searchClient,
            requests: items
        });
    });
    return Promise.all(values).then(function(responses) {
        return (0, $18ef26517fb42da2$export$bffa455ba8c619a6)(responses);
    });
}
function $060299908584e406$export$c1b3edf5a28f586(responses, sources, store) {
    return sources.map(function(source) {
        var matches = responses.filter(function(response) {
            return response.sourceId === source.sourceId;
        });
        var results = matches.map(function(_ref2) {
            var items = _ref2.items;
            return items;
        });
        var transform = matches[0].transformResponse;
        var items = transform ? transform((0, $f48aafe56891e3b1$export$23042d7bd0b8d14b)(results)) : results;
        source.onResolve({
            source: source,
            results: results,
            items: items,
            state: store.getState()
        });
        (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(Array.isArray(items), function() {
            return "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned type ").concat(JSON.stringify($060299908584e406$var$_typeof(items)), ":\n\n").concat(JSON.stringify((0, $57bfcc81421994ca$export$ed3e2bdb532b061f)(items), null, 2), ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems");
        });
        (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(items.every(Boolean), "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned ").concat(JSON.stringify(undefined), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"));
        return {
            source: source,
            items: items
        };
    });
}


function $bf293a90b45e1fb5$var$createInternalCancelablePromise(promise, initialState) {
    var state = initialState;
    return {
        then: function then(onfulfilled, onrejected) {
            return $bf293a90b45e1fb5$var$createInternalCancelablePromise(promise.then($bf293a90b45e1fb5$var$createCallback(onfulfilled, state, promise), $bf293a90b45e1fb5$var$createCallback(onrejected, state, promise)), state);
        },
        catch: function _catch(onrejected) {
            return $bf293a90b45e1fb5$var$createInternalCancelablePromise(promise.catch($bf293a90b45e1fb5$var$createCallback(onrejected, state, promise)), state);
        },
        finally: function _finally(onfinally) {
            if (onfinally) state.onCancelList.push(onfinally);
            return $bf293a90b45e1fb5$var$createInternalCancelablePromise(promise.finally($bf293a90b45e1fb5$var$createCallback(onfinally && function() {
                state.onCancelList = [];
                return onfinally();
            }, state, promise)), state);
        },
        cancel: function cancel() {
            state.isCanceled = true;
            var callbacks = state.onCancelList;
            state.onCancelList = [];
            callbacks.forEach(function(callback) {
                callback();
            });
        },
        isCanceled: function isCanceled() {
            return state.isCanceled === true;
        }
    };
}
function $bf293a90b45e1fb5$export$72af18a8b033265c(executor) {
    return $bf293a90b45e1fb5$var$createInternalCancelablePromise(new Promise(function(resolve, reject) {
        return executor(resolve, reject);
    }), {
        isCanceled: false,
        onCancelList: []
    });
}
$bf293a90b45e1fb5$export$72af18a8b033265c.resolve = function(value) {
    return $bf293a90b45e1fb5$export$95ff25b64c2b7c9d(Promise.resolve(value));
};
$bf293a90b45e1fb5$export$72af18a8b033265c.reject = function(reason) {
    return $bf293a90b45e1fb5$export$95ff25b64c2b7c9d(Promise.reject(reason));
};
function $bf293a90b45e1fb5$export$95ff25b64c2b7c9d(promise) {
    return $bf293a90b45e1fb5$var$createInternalCancelablePromise(promise, {
        isCanceled: false,
        onCancelList: []
    });
}
function $bf293a90b45e1fb5$var$createCallback(onResult, state, fallback) {
    if (!onResult) return fallback;
    return function callback(arg) {
        if (state.isCanceled) return arg;
        return onResult(arg);
    };
}

/**
 * Creates a runner that executes promises in a concurrent-safe way.
 *
 * This is useful to prevent older promises to resolve after a newer promise,
 * otherwise resulting in stale resolved values.
 */ function $cd39474f4488c30e$export$8829b68d73f73d13() {
    var basePromiseId = -1;
    var latestResolvedId = -1;
    var latestResolvedValue = undefined;
    return function runConcurrentSafePromise(promise) {
        basePromiseId++;
        var currentPromiseId = basePromiseId;
        return Promise.resolve(promise).then(function(x) {
            // The promise might take too long to resolve and get outdated. This would
            // result in resolving stale values.
            // When this happens, we ignore the promise value and return the one
            // coming from the latest resolved value.
            //
            // +----------------------------------+
            // |        100ms                     |
            // | run(1) +--->  R1                 |
            // |        300ms                     |
            // | run(2) +-------------> R2 (SKIP) |
            // |        200ms                     |
            // | run(3) +--------> R3             |
            // +----------------------------------+
            if (latestResolvedValue && currentPromiseId < latestResolvedId) return latestResolvedValue;
            latestResolvedId = currentPromiseId;
            latestResolvedValue = x;
            return x;
        });
    };
}

// We don't have access to the autocomplete source when we call `onKeyDown`
// or `onClick` because those are native browser events.
// However, we can get the source from the suggestion index.
function $18e55a71c33afde1$var$getCollectionFromActiveItemId(state) {
    // Given 3 sources with respectively 1, 2 and 3 suggestions: [1, 2, 3]
    // We want to get the accumulated counts:
    // [1, 1 + 2, 1 + 2 + 3] = [1, 3, 3 + 3] = [1, 3, 6]
    var accumulatedCollectionsCount = state.collections.map(function(collections) {
        return collections.items.length;
    }).reduce(function(acc, collectionsCount, index) {
        var previousValue = acc[index - 1] || 0;
        var nextValue = previousValue + collectionsCount;
        acc.push(nextValue);
        return acc;
    }, []);
    // Based on the accumulated counts, we can infer the index of the suggestion.
    var collectionIndex = accumulatedCollectionsCount.reduce(function(acc, current) {
        if (current <= state.activeItemId) return acc + 1;
        return acc;
    }, 0);
    return state.collections[collectionIndex];
}
/**
 * Gets the highlighted index relative to a suggestion object (not the absolute
 * highlighted index).
 *
 * Example:
 *  [['a', 'b'], ['c', 'd', 'e'], ['f']]
 *                      ↑
 *         (absolute: 3, relative: 1)
 */ function $18e55a71c33afde1$var$getRelativeActiveItemId(_ref) {
    var state = _ref.state, collection = _ref.collection;
    var isOffsetFound = false;
    var counter = 0;
    var previousItemsOffset = 0;
    while(isOffsetFound === false){
        var currentCollection = state.collections[counter];
        if (currentCollection === collection) {
            isOffsetFound = true;
            break;
        }
        previousItemsOffset += currentCollection.items.length;
        counter++;
    }
    return state.activeItemId - previousItemsOffset;
}
function $18e55a71c33afde1$export$f0f14253205ef68f(state) {
    var collection = $18e55a71c33afde1$var$getCollectionFromActiveItemId(state);
    if (!collection) return null;
    var item = collection.items[$18e55a71c33afde1$var$getRelativeActiveItemId({
        state: state,
        collection: collection
    })];
    var source = collection.source;
    var itemInputValue = source.getItemInputValue({
        item: item,
        state: state
    });
    var itemUrl = source.getItemUrl({
        item: item,
        state: state
    });
    return {
        item: item,
        itemInputValue: itemInputValue,
        itemUrl: itemUrl,
        source: source
    };
}


function $2593a8ab0007b319$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2593a8ab0007b319$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2593a8ab0007b319$var$_typeof(obj);
}
var $2593a8ab0007b319$var$_excluded = [
    "event",
    "nextState",
    "props",
    "query",
    "refresh",
    "store"
];
function $2593a8ab0007b319$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2593a8ab0007b319$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2593a8ab0007b319$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2593a8ab0007b319$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2593a8ab0007b319$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2593a8ab0007b319$var$_defineProperty(obj, key, value) {
    key = $2593a8ab0007b319$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2593a8ab0007b319$var$_toPropertyKey(arg) {
    var key = $2593a8ab0007b319$var$_toPrimitive(arg, "string");
    return $2593a8ab0007b319$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2593a8ab0007b319$var$_toPrimitive(input, hint) {
    if ($2593a8ab0007b319$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2593a8ab0007b319$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2593a8ab0007b319$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2593a8ab0007b319$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2593a8ab0007b319$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2593a8ab0007b319$var$lastStalledId = null;
var $2593a8ab0007b319$var$runConcurrentSafePromise = (0, $cd39474f4488c30e$export$8829b68d73f73d13)();
function $2593a8ab0007b319$export$7fbc06d7c1beb512(_ref) {
    var event = _ref.event, _ref$nextState = _ref.nextState, nextState = _ref$nextState === void 0 ? {} : _ref$nextState, props = _ref.props, query = _ref.query, refresh = _ref.refresh, store = _ref.store, setters = $2593a8ab0007b319$var$_objectWithoutProperties(_ref, $2593a8ab0007b319$var$_excluded);
    if ($2593a8ab0007b319$var$lastStalledId) props.environment.clearTimeout($2593a8ab0007b319$var$lastStalledId);
    var setCollections = setters.setCollections, setIsOpen = setters.setIsOpen, setQuery = setters.setQuery, setActiveItemId = setters.setActiveItemId, setStatus = setters.setStatus, setContext = setters.setContext;
    setQuery(query);
    setActiveItemId(props.defaultActiveItemId);
    if (!query && props.openOnFocus === false) {
        var _nextState$isOpen;
        var collections = store.getState().collections.map(function(collection) {
            return $2593a8ab0007b319$var$_objectSpread($2593a8ab0007b319$var$_objectSpread({}, collection), {}, {
                items: []
            });
        });
        setStatus('idle');
        setCollections(collections);
        setIsOpen((_nextState$isOpen = nextState.isOpen) !== null && _nextState$isOpen !== void 0 ? _nextState$isOpen : props.shouldPanelOpen({
            state: store.getState()
        }));
        // We make sure to update the latest resolved value of the tracked
        // promises to keep late resolving promises from "cancelling" the state
        // updates performed in this code path.
        // We chain with a void promise to respect `onInput`'s expected return type.
        var _request = (0, $bf293a90b45e1fb5$export$95ff25b64c2b7c9d)($2593a8ab0007b319$var$runConcurrentSafePromise(collections).then(function() {
            return Promise.resolve();
        }));
        return store.pendingRequests.add(_request);
    }
    setStatus('loading');
    $2593a8ab0007b319$var$lastStalledId = props.environment.setTimeout(function() {
        setStatus('stalled');
    }, props.stallThreshold);
    // We track the entire promise chain triggered by `onInput` before mutating
    // the Autocomplete state to make sure that any state manipulation is based on
    // fresh data regardless of when promises individually resolve.
    // We don't track nested promises and only rely on the full chain resolution,
    // meaning we should only ever manipulate the state once this concurrent-safe
    // promise is resolved.
    var request = (0, $bf293a90b45e1fb5$export$95ff25b64c2b7c9d)($2593a8ab0007b319$var$runConcurrentSafePromise(props.getSources($2593a8ab0007b319$var$_objectSpread({
        query: query,
        refresh: refresh,
        state: store.getState()
    }, setters)).then(function(sources) {
        return Promise.all(sources.map(function(source) {
            return Promise.resolve(source.getItems($2593a8ab0007b319$var$_objectSpread({
                query: query,
                refresh: refresh,
                state: store.getState()
            }, setters))).then(function(itemsOrDescription) {
                return (0, $060299908584e406$export$ae3cd3529c74e69e)(itemsOrDescription, source.sourceId, store.getState());
            });
        })).then((0, $060299908584e406$export$f7ad0328861e2f03)).then(function(responses) {
            var __automaticInsights = responses.some(function(_ref2) {
                var items = _ref2.items;
                return $2593a8ab0007b319$var$isSearchResponseWithAutomaticInsightsFlag(items);
            });
            // No need to pollute the context if `__automaticInsights=false`
            if (__automaticInsights) {
                var _store$getState$conte;
                setContext({
                    algoliaInsightsPlugin: $2593a8ab0007b319$var$_objectSpread($2593a8ab0007b319$var$_objectSpread({}, ((_store$getState$conte = store.getState().context) === null || _store$getState$conte === void 0 ? void 0 : _store$getState$conte.algoliaInsightsPlugin) || {}), {}, {
                        __automaticInsights: __automaticInsights
                    })
                });
            }
            return (0, $060299908584e406$export$c1b3edf5a28f586)(responses, sources, store);
        }).then(function(collections) {
            return (0, $9ad23a01a7c32e90$export$9eaad88cf88cee2b)({
                collections: collections,
                props: props,
                state: store.getState()
            });
        });
    }))).then(function(collections) {
        var _nextState$isOpen2;
        // Parameters passed to `onInput` could be stale when the following code
        // executes, because `onInput` calls may not resolve in order.
        // If it becomes a problem we'll need to save the last passed parameters.
        // See: https://codesandbox.io/s/agitated-cookies-y290z
        setStatus('idle');
        setCollections(collections);
        var isPanelOpen = props.shouldPanelOpen({
            state: store.getState()
        });
        setIsOpen((_nextState$isOpen2 = nextState.isOpen) !== null && _nextState$isOpen2 !== void 0 ? _nextState$isOpen2 : props.openOnFocus && !query && isPanelOpen || isPanelOpen);
        var highlightedItem = (0, $18e55a71c33afde1$export$f0f14253205ef68f)(store.getState());
        if (store.getState().activeItemId !== null && highlightedItem) {
            var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
            source.onActive($2593a8ab0007b319$var$_objectSpread({
                event: event,
                item: item,
                itemInputValue: itemInputValue,
                itemUrl: itemUrl,
                refresh: refresh,
                source: source,
                state: store.getState()
            }, setters));
        }
    }).finally(function() {
        setStatus('idle');
        if ($2593a8ab0007b319$var$lastStalledId) props.environment.clearTimeout($2593a8ab0007b319$var$lastStalledId);
    });
    return store.pendingRequests.add(request);
}
function $2593a8ab0007b319$var$isSearchResponseWithAutomaticInsightsFlag(items) {
    return !Array.isArray(items) && Boolean(items === null || items === void 0 ? void 0 : items._automaticInsights);
}



/**
 * Returns a full element id for an autocomplete element.
 *
 * @param autocompleteInstanceId The id of the autocomplete instance
 * @param elementId The specific element id
 * @param source The source of the element, when it needs to be scoped
 */ function $d6e862e27b6c64cd$export$17f5bb35a44b3f03(autocompleteInstanceId, elementId, source) {
    return [
        autocompleteInstanceId,
        source === null || source === void 0 ? void 0 : source.sourceId,
        elementId
    ].filter(Boolean).join('-').replace(/\s/g, '');
}


function $5b4f37b81e147a80$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5b4f37b81e147a80$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5b4f37b81e147a80$var$_typeof(obj);
}
var $5b4f37b81e147a80$var$_excluded = [
    "event",
    "props",
    "refresh",
    "store"
];
function $5b4f37b81e147a80$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5b4f37b81e147a80$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5b4f37b81e147a80$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5b4f37b81e147a80$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5b4f37b81e147a80$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5b4f37b81e147a80$var$_defineProperty(obj, key, value) {
    key = $5b4f37b81e147a80$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5b4f37b81e147a80$var$_toPropertyKey(arg) {
    var key = $5b4f37b81e147a80$var$_toPrimitive(arg, "string");
    return $5b4f37b81e147a80$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5b4f37b81e147a80$var$_toPrimitive(input, hint) {
    if ($5b4f37b81e147a80$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5b4f37b81e147a80$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5b4f37b81e147a80$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5b4f37b81e147a80$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5b4f37b81e147a80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5b4f37b81e147a80$export$de8e1b1372cdb41b(_ref) {
    var event = _ref.event, props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $5b4f37b81e147a80$var$_objectWithoutProperties(_ref, $5b4f37b81e147a80$var$_excluded);
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        // eslint-disable-next-line no-inner-declarations
        var triggerScrollIntoView = function triggerScrollIntoView() {
            var highlightedItem = (0, $18e55a71c33afde1$export$f0f14253205ef68f)(store.getState());
            var nodeItem = props.environment.document.getElementById((0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, "item-".concat(store.getState().activeItemId), highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.source));
            if (nodeItem) {
                if (nodeItem.scrollIntoViewIfNeeded) nodeItem.scrollIntoViewIfNeeded(false);
                else nodeItem.scrollIntoView(false);
            }
        }; // eslint-disable-next-line no-inner-declarations
        var triggerOnActive = function triggerOnActive() {
            var highlightedItem = (0, $18e55a71c33afde1$export$f0f14253205ef68f)(store.getState());
            if (store.getState().activeItemId !== null && highlightedItem) {
                var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
                source.onActive($5b4f37b81e147a80$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            }
        }; // Default browser behavior changes the caret placement on ArrowUp and
        // ArrowDown.
        event.preventDefault();
        // When re-opening the panel, we need to split the logic to keep the actions
        // synchronized as `onInput` returns a promise.
        if (store.getState().isOpen === false && (props.openOnFocus || Boolean(store.getState().query))) (0, $2593a8ab0007b319$export$7fbc06d7c1beb512)($5b4f37b81e147a80$var$_objectSpread({
            event: event,
            props: props,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters)).then(function() {
            store.dispatch(event.key, {
                nextActiveItemId: props.defaultActiveItemId
            });
            triggerOnActive();
            // Since we rely on the DOM, we need to wait for all the micro tasks to
            // finish (which include re-opening the panel) to make sure all the
            // elements are available.
            setTimeout(triggerScrollIntoView, 0);
        });
        else {
            store.dispatch(event.key, {});
            triggerOnActive();
            triggerScrollIntoView();
        }
    } else if (event.key === 'Escape') {
        // This prevents the default browser behavior on `input[type="search"]`
        // from removing the query right away because we first want to close the
        // panel.
        event.preventDefault();
        store.dispatch(event.key, null);
        // Hitting the `Escape` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Tab') {
        store.dispatch('blur', null);
        // Hitting the `Tab` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Enter') {
        // No active item, so we let the browser handle the native `onSubmit` form
        // event.
        if (store.getState().activeItemId === null || store.getState().collections.every(function(collection) {
            return collection.items.length === 0;
        })) {
            // If requests are still pending when the panel closes, they could reopen
            // the panel once they resolve.
            // We want to prevent any subsequent query from reopening the panel
            // because it would result in an unsolicited UI behavior.
            if (!props.debug) store.pendingRequests.cancelAll();
            return;
        }
        // This prevents the `onSubmit` event to be sent because an item is
        // highlighted.
        event.preventDefault();
        var _ref2 = (0, $18e55a71c33afde1$export$f0f14253205ef68f)(store.getState()), item = _ref2.item, itemInputValue = _ref2.itemInputValue, itemUrl = _ref2.itemUrl, source = _ref2.source;
        if (event.metaKey || event.ctrlKey) {
            if (itemUrl !== undefined) {
                source.onSelect($5b4f37b81e147a80$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewTab({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.shiftKey) {
            if (itemUrl !== undefined) {
                source.onSelect($5b4f37b81e147a80$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewWindow({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.altKey) ;
        else {
            if (itemUrl !== undefined) {
                source.onSelect($5b4f37b81e147a80$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigate({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
                return;
            }
            (0, $2593a8ab0007b319$export$7fbc06d7c1beb512)($5b4f37b81e147a80$var$_objectSpread({
                event: event,
                nextState: {
                    isOpen: false
                },
                props: props,
                query: itemInputValue,
                refresh: refresh,
                store: store
            }, setters)).then(function() {
                source.onSelect($5b4f37b81e147a80$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            });
        }
    }
}


function $15b81ce0a582710c$export$4abe0e945399ac1d(event) {
    return event.nativeEvent || event;
}

function $37ff965e9f843711$export$428954767edfafa7(parent, child) {
    return parent === child || parent.contains(child);
}

var $e8f5f12d435ef32e$var$regex = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
function $e8f5f12d435ef32e$export$838732a363f40fc6(userAgent) {
    return Boolean(userAgent && userAgent.match($e8f5f12d435ef32e$var$regex));
}


function $d37f6853ef770244$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d37f6853ef770244$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d37f6853ef770244$var$_typeof(obj);
}
var $d37f6853ef770244$var$_excluded = [
    "props",
    "refresh",
    "store"
], $d37f6853ef770244$var$_excluded2 = [
    "inputElement",
    "formElement",
    "panelElement"
], $d37f6853ef770244$var$_excluded3 = [
    "inputElement"
], $d37f6853ef770244$var$_excluded4 = [
    "inputElement",
    "maxLength"
], $d37f6853ef770244$var$_excluded5 = [
    "source"
], $d37f6853ef770244$var$_excluded6 = [
    "item",
    "source"
];
function $d37f6853ef770244$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d37f6853ef770244$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d37f6853ef770244$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d37f6853ef770244$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d37f6853ef770244$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d37f6853ef770244$var$_defineProperty(obj, key, value) {
    key = $d37f6853ef770244$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d37f6853ef770244$var$_toPropertyKey(arg) {
    var key = $d37f6853ef770244$var$_toPrimitive(arg, "string");
    return $d37f6853ef770244$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d37f6853ef770244$var$_toPrimitive(input, hint) {
    if ($d37f6853ef770244$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d37f6853ef770244$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d37f6853ef770244$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d37f6853ef770244$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d37f6853ef770244$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d37f6853ef770244$export$a4b47c9a40a3a795(_ref) {
    var props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $d37f6853ef770244$var$_objectWithoutProperties(_ref, $d37f6853ef770244$var$_excluded);
    var getEnvironmentProps = function getEnvironmentProps(providedProps) {
        var inputElement = providedProps.inputElement, formElement = providedProps.formElement, panelElement = providedProps.panelElement, rest = $d37f6853ef770244$var$_objectWithoutProperties(providedProps, $d37f6853ef770244$var$_excluded2);
        function onMouseDownOrTouchStart(event) {
            // The `onTouchStart`/`onMouseDown` events shouldn't trigger the `blur`
            // handler when it's not an interaction with Autocomplete.
            // We detect it with the following heuristics:
            // - the panel is closed AND there are no pending requests
            //   (no interaction with the autocomplete, no future state updates)
            // - OR the touched target is the input element (should open the panel)
            var isAutocompleteInteraction = store.getState().isOpen || !store.pendingRequests.isEmpty();
            if (!isAutocompleteInteraction || event.target === inputElement) return;
            // @TODO: support cases where there are multiple Autocomplete instances.
            // Right now, a second instance makes this computation return false.
            var isTargetWithinAutocomplete = [
                formElement,
                panelElement
            ].some(function(contextNode) {
                return (0, $37ff965e9f843711$export$428954767edfafa7)(contextNode, event.target);
            });
            if (isTargetWithinAutocomplete === false) {
                store.dispatch('blur', null);
                // If requests are still pending when the user closes the panel, they
                // could reopen the panel once they resolve.
                // We want to prevent any subsequent query from reopening the panel
                // because it would result in an unsolicited UI behavior.
                if (!props.debug) store.pendingRequests.cancelAll();
            }
        }
        return $d37f6853ef770244$var$_objectSpread({
            // We do not rely on the native `blur` event of the input to close the
            // panel, but rather on a custom `touchstart`/`mousedown` event outside
            // of the autocomplete elements.
            // This ensures we don't mistakenly interpret interactions within the
            // autocomplete (but outside of the input) as a signal to close the panel.
            // For example, clicking reset button causes an input blur, but if
            // `openOnFocus=true`, it shouldn't close the panel.
            // On touch devices, scrolling results (`touchmove`) causes an input blur
            // but shouldn't close the panel.
            onTouchStart: onMouseDownOrTouchStart,
            onMouseDown: onMouseDownOrTouchStart,
            // When scrolling on touch devices (mobiles, tablets, etc.), we want to
            // mimic the native platform behavior where the input is blurred to
            // hide the virtual keyboard. This gives more vertical space to
            // discover all the suggestions showing up in the panel.
            onTouchMove: function onTouchMove(event) {
                if (store.getState().isOpen === false || inputElement !== props.environment.document.activeElement || event.target === inputElement) return;
                inputElement.blur();
            }
        }, rest);
    };
    var getRootProps = function getRootProps(rest) {
        return $d37f6853ef770244$var$_objectSpread({
            role: 'combobox',
            'aria-expanded': store.getState().isOpen,
            'aria-haspopup': 'listbox',
            'aria-owns': store.getState().isOpen ? store.getState().collections.map(function(_ref2) {
                var source = _ref2.source;
                return (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'label')
        }, rest);
    };
    var getFormProps = function getFormProps(providedProps) {
        var inputElement = providedProps.inputElement, rest = $d37f6853ef770244$var$_objectWithoutProperties(providedProps, $d37f6853ef770244$var$_excluded3);
        return $d37f6853ef770244$var$_objectSpread({
            action: '',
            noValidate: true,
            role: 'search',
            onSubmit: function onSubmit(event) {
                var _providedProps$inputE;
                event.preventDefault();
                props.onSubmit($d37f6853ef770244$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch('submit', null);
                (_providedProps$inputE = providedProps.inputElement) === null || _providedProps$inputE === void 0 || _providedProps$inputE.blur();
            },
            onReset: function onReset(event) {
                var _providedProps$inputE2;
                event.preventDefault();
                props.onReset($d37f6853ef770244$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch('reset', null);
                (_providedProps$inputE2 = providedProps.inputElement) === null || _providedProps$inputE2 === void 0 || _providedProps$inputE2.focus();
            }
        }, rest);
    };
    var getInputProps = function getInputProps(providedProps) {
        var _props$environment$na;
        function onFocus(event) {
            // We want to trigger a query when `openOnFocus` is true
            // because the panel should open with the current query.
            if (props.openOnFocus || Boolean(store.getState().query)) (0, $2593a8ab0007b319$export$7fbc06d7c1beb512)($d37f6853ef770244$var$_objectSpread({
                event: event,
                props: props,
                query: store.getState().completion || store.getState().query,
                refresh: refresh,
                store: store
            }, setters));
            store.dispatch('focus', null);
        }
        var _ref3 = providedProps || {}, inputElement = _ref3.inputElement, _ref3$maxLength = _ref3.maxLength, maxLength = _ref3$maxLength === void 0 ? 512 : _ref3$maxLength, rest = $d37f6853ef770244$var$_objectWithoutProperties(_ref3, $d37f6853ef770244$var$_excluded4);
        var activeItem = (0, $18e55a71c33afde1$export$f0f14253205ef68f)(store.getState());
        var userAgent = ((_props$environment$na = props.environment.navigator) === null || _props$environment$na === void 0 ? void 0 : _props$environment$na.userAgent) || '';
        var shouldFallbackKeyHint = (0, $e8f5f12d435ef32e$export$838732a363f40fc6)(userAgent);
        var enterKeyHint = props.enterKeyHint || (activeItem !== null && activeItem !== void 0 && activeItem.itemUrl && !shouldFallbackKeyHint ? 'go' : 'search');
        return $d37f6853ef770244$var$_objectSpread({
            'aria-autocomplete': 'both',
            'aria-activedescendant': store.getState().isOpen && store.getState().activeItemId !== null ? (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, "item-".concat(store.getState().activeItemId), activeItem === null || activeItem === void 0 ? void 0 : activeItem.source) : undefined,
            'aria-controls': store.getState().isOpen ? store.getState().collections.map(function(_ref4) {
                var source = _ref4.source;
                return (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'label'),
            value: store.getState().completion || store.getState().query,
            id: (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'input'),
            autoComplete: 'off',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            enterKeyHint: enterKeyHint,
            spellCheck: 'false',
            autoFocus: props.autoFocus,
            placeholder: props.placeholder,
            maxLength: maxLength,
            type: 'search',
            onChange: function onChange(event) {
                var value = event.currentTarget.value;
                if (props.ignoreCompositionEvents && (0, $15b81ce0a582710c$export$4abe0e945399ac1d)(event).isComposing) {
                    setters.setQuery(value);
                    return;
                }
                (0, $2593a8ab0007b319$export$7fbc06d7c1beb512)($d37f6853ef770244$var$_objectSpread({
                    event: event,
                    props: props,
                    query: value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onCompositionEnd: function onCompositionEnd(event) {
                (0, $2593a8ab0007b319$export$7fbc06d7c1beb512)($d37f6853ef770244$var$_objectSpread({
                    event: event,
                    props: props,
                    query: event.currentTarget.value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onKeyDown: function onKeyDown(event) {
                if ((0, $15b81ce0a582710c$export$4abe0e945399ac1d)(event).isComposing) return;
                (0, $5b4f37b81e147a80$export$de8e1b1372cdb41b)($d37f6853ef770244$var$_objectSpread({
                    event: event,
                    props: props,
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onFocus: onFocus,
            // We don't rely on the `blur` event.
            // See explanation in `onTouchStart`/`onMouseDown`.
            // @MAJOR See if we need to keep this handler.
            onBlur: (0, $ca0064faea230143$export$8793edee2d425525),
            onClick: function onClick(event) {
                // When the panel is closed and you click on the input while
                // the input is focused, the `onFocus` event is not triggered
                // (default browser behavior).
                // In an autocomplete context, it makes sense to open the panel in this
                // case.
                // We mimic this event by catching the `onClick` event which
                // triggers the `onFocus` for the panel to open.
                if (providedProps.inputElement === props.environment.document.activeElement && !store.getState().isOpen) onFocus(event);
            }
        }, rest);
    };
    var getLabelProps = function getLabelProps(rest) {
        return $d37f6853ef770244$var$_objectSpread({
            htmlFor: (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'input'),
            id: (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'label')
        }, rest);
    };
    var getListProps = function getListProps(providedProps) {
        var _ref5 = providedProps || {}, source = _ref5.source, rest = $d37f6853ef770244$var$_objectWithoutProperties(_ref5, $d37f6853ef770244$var$_excluded5);
        return $d37f6853ef770244$var$_objectSpread({
            role: 'listbox',
            'aria-labelledby': (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'label'),
            id: (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, 'list', source)
        }, rest);
    };
    var getPanelProps = function getPanelProps(rest) {
        return $d37f6853ef770244$var$_objectSpread({
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the panel so
                // that the blur event is not triggered, otherwise it closes the
                // panel.
                event.preventDefault();
            },
            onMouseLeave: function onMouseLeave() {
                store.dispatch('mouseleave', null);
            }
        }, rest);
    };
    var getItemProps = function getItemProps(providedProps) {
        var item = providedProps.item, source = providedProps.source, rest = $d37f6853ef770244$var$_objectWithoutProperties(providedProps, $d37f6853ef770244$var$_excluded6);
        return $d37f6853ef770244$var$_objectSpread({
            id: (0, $d6e862e27b6c64cd$export$17f5bb35a44b3f03)(props.id, "item-".concat(item.__autocomplete_id), source),
            role: 'option',
            'aria-selected': store.getState().activeItemId === item.__autocomplete_id,
            onMouseMove: function onMouseMove(event) {
                if (item.__autocomplete_id === store.getState().activeItemId) return;
                store.dispatch('mousemove', item.__autocomplete_id);
                var activeItem = (0, $18e55a71c33afde1$export$f0f14253205ef68f)(store.getState());
                if (store.getState().activeItemId !== null && activeItem) {
                    var _item = activeItem.item, itemInputValue = activeItem.itemInputValue, itemUrl = activeItem.itemUrl, _source = activeItem.source;
                    _source.onActive($d37f6853ef770244$var$_objectSpread({
                        event: event,
                        item: _item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: _source,
                        state: store.getState()
                    }, setters));
                }
            },
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the item so it
                // can remain with the current `activeElement`.
                event.preventDefault();
            },
            onClick: function onClick(event) {
                var itemInputValue = source.getItemInputValue({
                    item: item,
                    state: store.getState()
                });
                var itemUrl = source.getItemUrl({
                    item: item,
                    state: store.getState()
                });
                // If `getItemUrl` is provided, it means that the suggestion
                // is a link, not plain text that aims at updating the query.
                // We can therefore skip the state change because it will update
                // the `activeItemId`, resulting in a UI flash, especially
                // noticeable on mobile.
                var runPreCommand = itemUrl ? Promise.resolve() : (0, $2593a8ab0007b319$export$7fbc06d7c1beb512)($d37f6853ef770244$var$_objectSpread({
                    event: event,
                    nextState: {
                        isOpen: false
                    },
                    props: props,
                    query: itemInputValue,
                    refresh: refresh,
                    store: store
                }, setters));
                runPreCommand.then(function() {
                    source.onSelect($d37f6853ef770244$var$_objectSpread({
                        event: event,
                        item: item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: source,
                        state: store.getState()
                    }, setters));
                });
            }
        }, rest);
    };
    return {
        getEnvironmentProps: getEnvironmentProps,
        getRootProps: getRootProps,
        getFormProps: getFormProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getPanelProps: getPanelProps,
        getListProps: getListProps,
        getItemProps: getItemProps
    };
}



function $1c7cc64215edfe43$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1c7cc64215edfe43$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1c7cc64215edfe43$var$_typeof(obj);
}
function $1c7cc64215edfe43$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c7cc64215edfe43$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1c7cc64215edfe43$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1c7cc64215edfe43$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1c7cc64215edfe43$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c7cc64215edfe43$var$_defineProperty(obj, key, value) {
    key = $1c7cc64215edfe43$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1c7cc64215edfe43$var$_toPropertyKey(arg) {
    var key = $1c7cc64215edfe43$var$_toPrimitive(arg, "string");
    return $1c7cc64215edfe43$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1c7cc64215edfe43$var$_toPrimitive(input, hint) {
    if ($1c7cc64215edfe43$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1c7cc64215edfe43$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1c7cc64215edfe43$export$8548546c0aa631e6(_ref) {
    var _, _options$__autocomple, _options$__autocomple2, _options$__autocomple3;
    var plugins = _ref.plugins, options = _ref.options;
    var optionsKey = (_ = (((_options$__autocomple = options.__autocomplete_metadata) === null || _options$__autocomple === void 0 ? void 0 : _options$__autocomple.userAgents) || [])[0]) === null || _ === void 0 ? void 0 : _.segment;
    var extraOptions = optionsKey ? $1c7cc64215edfe43$var$_defineProperty({}, optionsKey, Object.keys(((_options$__autocomple2 = options.__autocomplete_metadata) === null || _options$__autocomple2 === void 0 ? void 0 : _options$__autocomple2.options) || {})) : {};
    return {
        plugins: plugins.map(function(plugin) {
            return {
                name: plugin.name,
                options: Object.keys(plugin.__autocomplete_pluginOptions || [])
            };
        }),
        options: $1c7cc64215edfe43$var$_objectSpread({
            'autocomplete-core': Object.keys(options)
        }, extraOptions),
        ua: (0, $134f5434c802b205$export$9536ea83a4cbd560).concat(((_options$__autocomple3 = options.__autocomplete_metadata) === null || _options$__autocomple3 === void 0 ? void 0 : _options$__autocomple3.userAgents) || [])
    };
}
function $1c7cc64215edfe43$export$404feeb97c870f44(_ref3) {
    var _environment$navigato, _environment$navigato2;
    var metadata = _ref3.metadata, environment = _ref3.environment;
    var isMetadataEnabled = (_environment$navigato = environment.navigator) === null || _environment$navigato === void 0 ? void 0 : (_environment$navigato2 = _environment$navigato.userAgent) === null || _environment$navigato2 === void 0 ? void 0 : _environment$navigato2.includes('Algolia Crawler');
    if (isMetadataEnabled) {
        var metadataContainer = environment.document.createElement('meta');
        var headRef = environment.document.querySelector('head');
        metadataContainer.name = 'algolia:metadata';
        setTimeout(function() {
            metadataContainer.content = JSON.stringify(metadata);
            headRef.appendChild(metadataContainer);
        }, 0);
    }
}





function $c91a7127beed112e$export$6c69e642446172b6(_ref) {
    var _getActiveItem;
    var state = _ref.state;
    if (state.isOpen === false || state.activeItemId === null) return null;
    return ((_getActiveItem = (0, $18e55a71c33afde1$export$f0f14253205ef68f)(state)) === null || _getActiveItem === void 0 ? void 0 : _getActiveItem.itemInputValue) || null;
}


/**
 * Returns the next active item ID from the current state.
 *
 * We allow circular keyboard navigation from the base index.
 * The base index can either be `null` (nothing is highlighted) or `0`
 * (the first item is highlighted).
 * The base index is allowed to get assigned `null` only if
 * `props.defaultActiveItemId` is `null`. This pattern allows to "stop"
 * by the actual query before navigating to other suggestions as seen on
 * Google or Amazon.
 *
 * @param moveAmount The offset to increment (or decrement) the last index
 * @param baseIndex The current index to compute the next index from
 * @param itemCount The number of items
 * @param defaultActiveItemId The default active index to fallback to
 */ function $28588457a0b345af$export$9e353209669d8620(moveAmount, baseIndex, itemCount, defaultActiveItemId) {
    if (!itemCount) return null;
    if (moveAmount < 0 && (baseIndex === null || defaultActiveItemId !== null && baseIndex === 0)) return itemCount + moveAmount;
    var numericIndex = (baseIndex === null ? -1 : baseIndex) + moveAmount;
    if (numericIndex <= -1 || numericIndex >= itemCount) return defaultActiveItemId === null ? null : 0;
    return numericIndex;
}


function $066c4202c1e33b80$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $066c4202c1e33b80$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $066c4202c1e33b80$var$_typeof(obj);
}
function $066c4202c1e33b80$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $066c4202c1e33b80$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $066c4202c1e33b80$var$ownKeys(Object(source), !0).forEach(function(key) {
            $066c4202c1e33b80$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $066c4202c1e33b80$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $066c4202c1e33b80$var$_defineProperty(obj, key, value) {
    key = $066c4202c1e33b80$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $066c4202c1e33b80$var$_toPropertyKey(arg) {
    var key = $066c4202c1e33b80$var$_toPrimitive(arg, "string");
    return $066c4202c1e33b80$var$_typeof(key) === "symbol" ? key : String(key);
}
function $066c4202c1e33b80$var$_toPrimitive(input, hint) {
    if ($066c4202c1e33b80$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($066c4202c1e33b80$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $066c4202c1e33b80$export$ca8ebd435faad836 = function stateReducer(state, action) {
    switch(action.type){
        case 'setActiveItemId':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'setQuery':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                query: action.payload,
                completion: null
            });
        case 'setCollections':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                collections: action.payload
            });
        case 'setIsOpen':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                isOpen: action.payload
            });
        case 'setStatus':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                status: action.payload
            });
        case 'setContext':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                context: $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state.context), action.payload)
            });
        case 'ArrowDown':
            var nextState = $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload.hasOwnProperty('nextActiveItemId') ? action.payload.nextActiveItemId : (0, $28588457a0b345af$export$9e353209669d8620)(1, state.activeItemId, (0, $009101fa2649e815$export$dd01a43948d7de86)(state), action.props.defaultActiveItemId)
            });
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, nextState), {}, {
                completion: (0, $c91a7127beed112e$export$6c69e642446172b6)({
                    state: nextState
                })
            });
        case 'ArrowUp':
            var _nextState = $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: (0, $28588457a0b345af$export$9e353209669d8620)(-1, state.activeItemId, (0, $009101fa2649e815$export$dd01a43948d7de86)(state), action.props.defaultActiveItemId)
            });
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, _nextState), {}, {
                completion: (0, $c91a7127beed112e$export$6c69e642446172b6)({
                    state: _nextState
                })
            });
        case 'Escape':
            if (state.isOpen) return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                completion: null
            });
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                query: '',
                status: 'idle',
                collections: []
            });
        case 'submit':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                status: 'idle'
            });
        case 'reset':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: // Since we open the panel on reset when openOnFocus=true
                // we need to restore the highlighted index to the defaultActiveItemId. (DocSearch use-case)
                // Since we close the panel when openOnFocus=false
                // we lose track of the highlighted index. (Query-suggestions use-case)
                action.props.openOnFocus === true ? action.props.defaultActiveItemId : null,
                status: 'idle',
                completion: null,
                query: ''
            });
        case 'focus':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId,
                isOpen: (action.props.openOnFocus || Boolean(state.query)) && action.props.shouldPanelOpen({
                    state: state
                })
            });
        case 'blur':
            if (action.props.debug) return state;
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                isOpen: false,
                activeItemId: null
            });
        case 'mousemove':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'mouseleave':
            return $066c4202c1e33b80$var$_objectSpread($066c4202c1e33b80$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId
            });
        default:
            (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(false, "The reducer action ".concat(JSON.stringify(action.type), " is not supported."));
            return state;
    }
};


function $51dbda34caf22fe0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $51dbda34caf22fe0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $51dbda34caf22fe0$var$_typeof(obj);
}
function $51dbda34caf22fe0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $51dbda34caf22fe0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $51dbda34caf22fe0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $51dbda34caf22fe0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $51dbda34caf22fe0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $51dbda34caf22fe0$var$_defineProperty(obj, key, value) {
    key = $51dbda34caf22fe0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $51dbda34caf22fe0$var$_toPropertyKey(arg) {
    var key = $51dbda34caf22fe0$var$_toPrimitive(arg, "string");
    return $51dbda34caf22fe0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $51dbda34caf22fe0$var$_toPrimitive(input, hint) {
    if ($51dbda34caf22fe0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($51dbda34caf22fe0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $51dbda34caf22fe0$export$b00b86c416695282(options) {
    (0, $56f6d8950b292669$export$6fe837ce0e0e0cdf)(options);
    var subscribers = [];
    var props = (0, $ef1762a627541762$export$61b94149aeb1f59)(options, subscribers);
    var store = (0, $e93801cf8d0b838b$export$f51a9068ac82ea43)((0, $066c4202c1e33b80$export$ca8ebd435faad836), props, onStoreStateChange);
    var setters = (0, $5fa042d311d2d767$export$5085b122b817cee)({
        store: store
    });
    var propGetters = (0, $d37f6853ef770244$export$a4b47c9a40a3a795)($51dbda34caf22fe0$var$_objectSpread({
        props: props,
        refresh: refresh,
        store: store,
        navigator: props.navigator
    }, setters));
    function onStoreStateChange(_ref) {
        var _state$context, _state$context$algoli;
        var prevState = _ref.prevState, state = _ref.state;
        props.onStateChange($51dbda34caf22fe0$var$_objectSpread({
            prevState: prevState,
            state: state,
            refresh: refresh,
            navigator: props.navigator
        }, setters));
        if (!isAlgoliaInsightsPluginEnabled() && (_state$context = state.context) !== null && _state$context !== void 0 && (_state$context$algoli = _state$context.algoliaInsightsPlugin) !== null && _state$context$algoli !== void 0 && _state$context$algoli.__automaticInsights && props.insights !== false) {
            var plugin = (0, $a82c53bae852b484$export$89ab4208990a3782)({
                __autocomplete_clickAnalytics: false
            });
            props.plugins.push(plugin);
            subscribePlugins([
                plugin
            ]);
        }
    }
    function refresh() {
        return (0, $2593a8ab0007b319$export$7fbc06d7c1beb512)($51dbda34caf22fe0$var$_objectSpread({
            event: new Event('input'),
            nextState: {
                isOpen: store.getState().isOpen
            },
            props: props,
            navigator: props.navigator,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters));
    }
    function subscribePlugins(plugins) {
        plugins.forEach(function(plugin) {
            var _plugin$subscribe;
            return (_plugin$subscribe = plugin.subscribe) === null || _plugin$subscribe === void 0 ? void 0 : _plugin$subscribe.call(plugin, $51dbda34caf22fe0$var$_objectSpread($51dbda34caf22fe0$var$_objectSpread({}, setters), {}, {
                navigator: props.navigator,
                refresh: refresh,
                onSelect: function onSelect(fn) {
                    subscribers.push({
                        onSelect: fn
                    });
                },
                onActive: function onActive(fn) {
                    subscribers.push({
                        onActive: fn
                    });
                },
                onResolve: function onResolve(fn) {
                    subscribers.push({
                        onResolve: fn
                    });
                }
            }));
        });
    }
    function isAlgoliaInsightsPluginEnabled() {
        return props.plugins.some(function(plugin) {
            return plugin.name === 'aa.algoliaInsightsPlugin';
        });
    }
    if (props.insights && !isAlgoliaInsightsPluginEnabled()) {
        var insightsParams = typeof props.insights === 'boolean' ? {} : props.insights;
        props.plugins.push((0, $a82c53bae852b484$export$89ab4208990a3782)(insightsParams));
    }
    subscribePlugins(props.plugins);
    (0, $1c7cc64215edfe43$export$404feeb97c870f44)({
        metadata: (0, $1c7cc64215edfe43$export$8548546c0aa631e6)({
            plugins: props.plugins,
            options: options
        }),
        environment: props.environment
    });
    return $51dbda34caf22fe0$var$_objectSpread($51dbda34caf22fe0$var$_objectSpread({
        refresh: refresh,
        navigator: props.navigator
    }, propGetters), setters);
}



var $5ece538e27521dca$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $5ece538e27521dca$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $5ece538e27521dca$var$t = new Map;
function $5ece538e27521dca$export$2e2bcd8739ae039(s) {
    var r = $5ece538e27521dca$var$t.get(this);
    return r || (r = new Map, $5ece538e27521dca$var$t.set(this, r)), (r = $5ece538e27521dca$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}


var $7c88c0b72f6979c7$export$cefbac224a47f32 = function ClearIcon(_ref) {
    var environment = _ref.environment;
    var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    element.setAttribute('class', 'aa-ClearIcon');
    element.setAttribute('viewBox', '0 0 24 24');
    element.setAttribute('width', '18');
    element.setAttribute('height', '18');
    element.setAttribute('fill', 'currentColor');
    var path = environment.document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z');
    element.appendChild(path);
    return element;
};

/* eslint-disable */ /**
 * Touch-specific event aliases
 *
 * See https://w3c.github.io/touch-events/#extensions-to-the-globaleventhandlers-mixin
 */ var $8dbb11db5a0b36c0$var$TOUCH_EVENTS_ALIASES = [
    'ontouchstart',
    'ontouchend',
    'ontouchmove',
    'ontouchcancel'
];
/*
 * Taken from Preact
 *
 * See https://github.com/preactjs/preact/blob/6ab49d9020740127577bf4af66bf63f4af7f9fee/src/diff/props.js#L58-L151
 */ function $8dbb11db5a0b36c0$var$setStyle(style, key, value) {
    if (value === null) style[key] = '';
    else if (typeof value !== 'number') style[key] = value;
    else style[key] = value + 'px';
}
/**
 * Proxy an event to hooked event handlers
 */ function $8dbb11db5a0b36c0$var$eventProxy(event) {
    this._listeners[event.type](event);
}
function $8dbb11db5a0b36c0$export$a41c68a4eb5ff164(dom, name, value) {
    var useCapture;
    var nameLower;
    var oldValue = dom[name];
    if (name === 'style') {
        if (typeof value == 'string') dom.style = value;
        else if (value === null) dom.style = '';
        else {
            for(name in value)if (!oldValue || value[name] !== oldValue[name]) $8dbb11db5a0b36c0$var$setStyle(dom.style, name, value[name]);
        }
    } else if (name[0] === 'o' && name[1] === 'n') {
        useCapture = name !== (name = name.replace(/Capture$/, ''));
        nameLower = name.toLowerCase();
        if (nameLower in dom || $8dbb11db5a0b36c0$var$TOUCH_EVENTS_ALIASES.includes(nameLower)) name = nameLower;
        name = name.slice(2);
        if (!dom._listeners) dom._listeners = {};
        dom._listeners[name] = value;
        if (value) {
            if (!oldValue) dom.addEventListener(name, $8dbb11db5a0b36c0$var$eventProxy, useCapture);
        } else dom.removeEventListener(name, $8dbb11db5a0b36c0$var$eventProxy, useCapture);
    } else if (name !== 'list' && name !== 'tagName' && // HTMLButtonElement.form and HTMLInputElement.form are read-only but can be set using
    // setAttribute
    name !== 'form' && name !== 'type' && name !== 'size' && name !== 'download' && name !== 'href' && name in dom) dom[name] = value == null ? '' : value;
    else if (typeof value != 'function' && name !== 'dangerouslySetInnerHTML') {
        if (value == null || value === false && // ARIA-attributes have a different notion of boolean values.
        // The value `false` is different from the attribute not
        // existing on the DOM, so we can't remove it. For non-boolean
        // ARIA-attributes we could treat false as a removal, but the
        // amount of exceptions would cost us too many bytes. On top of
        // that other VDOM frameworks also always stringify `false`.
        !/^ar/.test(name)) dom.removeAttribute(name);
        else dom.setAttribute(name, value);
    }
}
function $8dbb11db5a0b36c0$var$getNormalizedName(name) {
    switch(name){
        case 'onChange':
            return 'onInput';
        // see: https://github.com/preactjs/preact/issues/1978
        case 'onCompositionEnd':
            return 'oncompositionend';
        default:
            return name;
    }
}
function $8dbb11db5a0b36c0$export$80f053e5e39de51d(dom, props) {
    for(var name in props)$8dbb11db5a0b36c0$export$a41c68a4eb5ff164(dom, $8dbb11db5a0b36c0$var$getNormalizedName(name), props[name]);
}
function $8dbb11db5a0b36c0$export$514d50f66c38c2be(dom, props) {
    for(var name in props)if (!(name[0] === 'o' && name[1] === 'n')) $8dbb11db5a0b36c0$export$a41c68a4eb5ff164(dom, $8dbb11db5a0b36c0$var$getNormalizedName(name), props[name]);
}


var $904a86b65e4a3d08$var$_excluded = [
    "children"
];
function $904a86b65e4a3d08$var$_toConsumableArray(arr) {
    return $904a86b65e4a3d08$var$_arrayWithoutHoles(arr) || $904a86b65e4a3d08$var$_iterableToArray(arr) || $904a86b65e4a3d08$var$_unsupportedIterableToArray(arr) || $904a86b65e4a3d08$var$_nonIterableSpread();
}
function $904a86b65e4a3d08$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $904a86b65e4a3d08$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $904a86b65e4a3d08$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $904a86b65e4a3d08$var$_arrayLikeToArray(o, minLen);
}
function $904a86b65e4a3d08$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $904a86b65e4a3d08$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $904a86b65e4a3d08$var$_arrayLikeToArray(arr);
}
function $904a86b65e4a3d08$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $904a86b65e4a3d08$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $904a86b65e4a3d08$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $904a86b65e4a3d08$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $904a86b65e4a3d08$export$c7f8c472ad836e1a(environment) {
    return function createDomElement(tagName, _ref) {
        var _ref$children = _ref.children, children = _ref$children === void 0 ? [] : _ref$children, props = $904a86b65e4a3d08$var$_objectWithoutProperties(_ref, $904a86b65e4a3d08$var$_excluded);
        var element = environment.document.createElement(tagName);
        (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(element, props);
        element.append.apply(element, $904a86b65e4a3d08$var$_toConsumableArray(children));
        return element;
    };
}



function $965011531709a211$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $965011531709a211$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $965011531709a211$var$_typeof(obj);
}
var $965011531709a211$var$_excluded = [
    "autocompleteScopeApi",
    "environment",
    "classNames",
    "getInputProps",
    "getInputPropsCore",
    "isDetached",
    "state"
];
function $965011531709a211$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $965011531709a211$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $965011531709a211$var$ownKeys(Object(source), !0).forEach(function(key) {
            $965011531709a211$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $965011531709a211$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $965011531709a211$var$_defineProperty(obj, key, value) {
    key = $965011531709a211$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $965011531709a211$var$_toPropertyKey(arg) {
    var key = $965011531709a211$var$_toPrimitive(arg, "string");
    return $965011531709a211$var$_typeof(key) === "symbol" ? key : String(key);
}
function $965011531709a211$var$_toPrimitive(input, hint) {
    if ($965011531709a211$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($965011531709a211$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $965011531709a211$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $965011531709a211$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $965011531709a211$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $965011531709a211$export$f5b8910cec6cf069 = function Input(_ref) {
    var autocompleteScopeApi = _ref.autocompleteScopeApi, environment = _ref.environment, classNames = _ref.classNames, getInputProps = _ref.getInputProps, getInputPropsCore = _ref.getInputPropsCore, isDetached = _ref.isDetached, state = _ref.state, props = $965011531709a211$var$_objectWithoutProperties(_ref, $965011531709a211$var$_excluded);
    var createDomElement = (0, $904a86b65e4a3d08$export$c7f8c472ad836e1a)(environment);
    var element = createDomElement('input', props);
    var inputProps = getInputProps($965011531709a211$var$_objectSpread({
        state: state,
        props: getInputPropsCore({
            inputElement: element
        }),
        inputElement: element
    }, autocompleteScopeApi));
    (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(element, $965011531709a211$var$_objectSpread($965011531709a211$var$_objectSpread({}, inputProps), {}, {
        onKeyDown: function onKeyDown(event) {
            // In detached mode we don't want to close the panel when hitting `Tab`.
            if (isDetached && event.key === 'Tab') return;
            inputProps.onKeyDown(event);
        }
    }));
    return element;
};

var $eccd762bc037bfbb$export$b936c55164dcf1db = function LoadingIcon(_ref) {
    var environment = _ref.environment;
    var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    element.setAttribute('class', 'aa-LoadingIcon');
    element.setAttribute('viewBox', '0 0 100 100');
    element.setAttribute('width', '20');
    element.setAttribute('height', '20');
    element.innerHTML = "<circle\n  cx=\"50\"\n  cy=\"50\"\n  fill=\"none\"\n  r=\"35\"\n  stroke=\"currentColor\"\n  stroke-dasharray=\"164.93361431346415 56.97787143782138\"\n  stroke-width=\"6\"\n>\n  <animateTransform\n    attributeName=\"transform\"\n    type=\"rotate\"\n    repeatCount=\"indefinite\"\n    dur=\"1s\"\n    values=\"0 50 50;90 50 50;180 50 50;360 50 50\"\n    keyTimes=\"0;0.40;0.65;1\"\n  />\n</circle>";
    return element;
};

var $f637f3cb4299fed7$export$82eafebb825fc23f = function SearchIcon(_ref) {
    var environment = _ref.environment;
    var element = environment.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    element.setAttribute('class', 'aa-SubmitIcon');
    element.setAttribute('viewBox', '0 0 24 24');
    element.setAttribute('width', '20');
    element.setAttribute('height', '20');
    element.setAttribute('fill', 'currentColor');
    var path = environment.document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z');
    element.appendChild(path);
    return element;
};




function $12f9efeb53a76ffe$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $12f9efeb53a76ffe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $12f9efeb53a76ffe$var$_typeof(obj);
}
function $12f9efeb53a76ffe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $12f9efeb53a76ffe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $12f9efeb53a76ffe$var$ownKeys(Object(source), !0).forEach(function(key) {
            $12f9efeb53a76ffe$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $12f9efeb53a76ffe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $12f9efeb53a76ffe$var$_defineProperty(obj, key, value) {
    key = $12f9efeb53a76ffe$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $12f9efeb53a76ffe$var$_toPropertyKey(arg) {
    var key = $12f9efeb53a76ffe$var$_toPrimitive(arg, "string");
    return $12f9efeb53a76ffe$var$_typeof(key) === "symbol" ? key : String(key);
}
function $12f9efeb53a76ffe$var$_toPrimitive(input, hint) {
    if ($12f9efeb53a76ffe$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($12f9efeb53a76ffe$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $12f9efeb53a76ffe$export$55e5ca2210a4e3c2(_ref) {
    var autocomplete = _ref.autocomplete, autocompleteScopeApi = _ref.autocompleteScopeApi, classNames = _ref.classNames, environment = _ref.environment, isDetached = _ref.isDetached, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? 'Search' : _ref$placeholder, propGetters = _ref.propGetters, setIsModalOpen = _ref.setIsModalOpen, state = _ref.state, translations = _ref.translations;
    var createDomElement = (0, $904a86b65e4a3d08$export$c7f8c472ad836e1a)(environment);
    var rootProps = propGetters.getRootProps($12f9efeb53a76ffe$var$_objectSpread({
        state: state,
        props: autocomplete.getRootProps({})
    }, autocompleteScopeApi));
    var root = createDomElement('div', $12f9efeb53a76ffe$var$_objectSpread({
        class: classNames.root
    }, rootProps));
    var detachedContainer = createDomElement('div', {
        class: classNames.detachedContainer,
        onMouseDown: function onMouseDown(event) {
            event.stopPropagation();
        }
    });
    var detachedOverlay = createDomElement('div', {
        class: classNames.detachedOverlay,
        children: [
            detachedContainer
        ],
        onMouseDown: function onMouseDown() {
            setIsModalOpen(false);
            autocomplete.setIsOpen(false);
        }
    });
    var labelProps = propGetters.getLabelProps($12f9efeb53a76ffe$var$_objectSpread({
        state: state,
        props: autocomplete.getLabelProps({})
    }, autocompleteScopeApi));
    var submitButton = createDomElement('button', {
        class: classNames.submitButton,
        type: 'submit',
        title: translations.submitButtonTitle,
        children: [
            (0, $f637f3cb4299fed7$export$82eafebb825fc23f)({
                environment: environment
            })
        ]
    });
    var label = createDomElement('label', $12f9efeb53a76ffe$var$_objectSpread({
        class: classNames.label,
        children: [
            submitButton
        ]
    }, labelProps));
    var clearButton = createDomElement('button', {
        class: classNames.clearButton,
        type: 'reset',
        title: translations.clearButtonTitle,
        children: [
            (0, $7c88c0b72f6979c7$export$cefbac224a47f32)({
                environment: environment
            })
        ]
    });
    var loadingIndicator = createDomElement('div', {
        class: classNames.loadingIndicator,
        children: [
            (0, $eccd762bc037bfbb$export$b936c55164dcf1db)({
                environment: environment
            })
        ]
    });
    var input = (0, $965011531709a211$export$f5b8910cec6cf069)({
        class: classNames.input,
        environment: environment,
        state: state,
        getInputProps: propGetters.getInputProps,
        getInputPropsCore: autocomplete.getInputProps,
        autocompleteScopeApi: autocompleteScopeApi,
        isDetached: isDetached
    });
    var inputWrapperPrefix = createDomElement('div', {
        class: classNames.inputWrapperPrefix,
        children: [
            label,
            loadingIndicator
        ]
    });
    var inputWrapperSuffix = createDomElement('div', {
        class: classNames.inputWrapperSuffix,
        children: [
            clearButton
        ]
    });
    var inputWrapper = createDomElement('div', {
        class: classNames.inputWrapper,
        children: [
            input
        ]
    });
    var formProps = propGetters.getFormProps($12f9efeb53a76ffe$var$_objectSpread({
        state: state,
        props: autocomplete.getFormProps({
            inputElement: input
        })
    }, autocompleteScopeApi));
    var form = createDomElement('form', $12f9efeb53a76ffe$var$_objectSpread({
        class: classNames.form,
        children: [
            inputWrapperPrefix,
            inputWrapper,
            inputWrapperSuffix
        ]
    }, formProps));
    var panelProps = propGetters.getPanelProps($12f9efeb53a76ffe$var$_objectSpread({
        state: state,
        props: autocomplete.getPanelProps({})
    }, autocompleteScopeApi));
    var panel = createDomElement('div', $12f9efeb53a76ffe$var$_objectSpread({
        class: classNames.panel
    }, panelProps));
    var detachedSearchButtonQuery = createDomElement('div', {
        class: classNames.detachedSearchButtonQuery,
        textContent: state.query
    });
    var detachedSearchButtonPlaceholder = createDomElement('div', {
        class: classNames.detachedSearchButtonPlaceholder,
        hidden: Boolean(state.query),
        textContent: placeholder
    });
    if (isDetached) {
        var detachedSearchButtonIcon = createDomElement('div', {
            class: classNames.detachedSearchButtonIcon,
            children: [
                (0, $f637f3cb4299fed7$export$82eafebb825fc23f)({
                    environment: environment
                })
            ]
        });
        var detachedSearchButton = createDomElement('button', {
            type: 'button',
            class: classNames.detachedSearchButton,
            title: translations.detachedSearchButtonTitle,
            id: labelProps.id,
            onClick: function onClick() {
                setIsModalOpen(true);
            },
            children: [
                detachedSearchButtonIcon,
                detachedSearchButtonPlaceholder,
                detachedSearchButtonQuery
            ]
        });
        var detachedCancelButton = createDomElement('button', {
            type: 'button',
            class: classNames.detachedCancelButton,
            textContent: translations.detachedCancelButtonText,
            // Prevent `onTouchStart` from closing the panel
            // since it should be initiated by `onClick` only
            onTouchStart: function onTouchStart(event) {
                event.stopPropagation();
            },
            onClick: function onClick() {
                autocomplete.setIsOpen(false);
                setIsModalOpen(false);
            }
        });
        var detachedFormContainer = createDomElement('div', {
            class: classNames.detachedFormContainer,
            children: [
                form,
                detachedCancelButton
            ]
        });
        detachedContainer.appendChild(detachedFormContainer);
        root.appendChild(detachedSearchButton);
    } else root.appendChild(form);
    return {
        detachedContainer: detachedContainer,
        detachedOverlay: detachedOverlay,
        detachedSearchButtonQuery: detachedSearchButtonQuery,
        detachedSearchButtonPlaceholder: detachedSearchButtonPlaceholder,
        inputWrapper: inputWrapper,
        input: input,
        root: root,
        form: form,
        label: label,
        submitButton: submitButton,
        clearButton: clearButton,
        loadingIndicator: loadingIndicator,
        panel: panel
    };
}


function $049a3f99a929515d$export$10c722448c02c6b9() {
    var effects = [];
    var cleanups = [];
    function runEffect(fn) {
        effects.push(fn);
        var effectCleanup = fn();
        cleanups.push(effectCleanup);
    }
    return {
        runEffect: runEffect,
        cleanupEffects: function cleanupEffects() {
            var currentCleanups = cleanups;
            cleanups = [];
            currentCleanups.forEach(function(cleanup) {
                cleanup();
            });
        },
        runEffects: function runEffects() {
            var currentEffects = effects;
            effects = [];
            currentEffects.forEach(function(effect) {
                runEffect(effect);
            });
        }
    };
}


function $54fbff6da3d12a96$export$d1aaf184999dfd1f() {
    var reactives = [];
    return {
        reactive: function reactive(value1) {
            var current = value1();
            var reactive = {
                _fn: value1,
                _ref: {
                    current: current
                },
                get value () {
                    return this._ref.current;
                },
                set value (value){
                    this._ref.current = value;
                }
            };
            reactives.push(reactive);
            return reactive;
        },
        runReactives: function runReactives() {
            reactives.forEach(function(value1) {
                value1._ref.current = value1._fn();
            });
        }
    };
}



var $4d4f9a4167bc8de2$var$n, $4d4f9a4167bc8de2$export$41c562ebe57d11e2, $4d4f9a4167bc8de2$var$u, $4d4f9a4167bc8de2$export$a8257692ac88316c, $4d4f9a4167bc8de2$var$i, $4d4f9a4167bc8de2$var$o, $4d4f9a4167bc8de2$var$r, $4d4f9a4167bc8de2$var$f, $4d4f9a4167bc8de2$var$e, $4d4f9a4167bc8de2$var$c = {}, $4d4f9a4167bc8de2$var$s = [], $4d4f9a4167bc8de2$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $4d4f9a4167bc8de2$var$h = Array.isArray;
function $4d4f9a4167bc8de2$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $4d4f9a4167bc8de2$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $4d4f9a4167bc8de2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $4d4f9a4167bc8de2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $4d4f9a4167bc8de2$var$d(l, f, i, o, null);
}
function $4d4f9a4167bc8de2$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$4d4f9a4167bc8de2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $4d4f9a4167bc8de2$export$41c562ebe57d11e2.vnode && $4d4f9a4167bc8de2$export$41c562ebe57d11e2.vnode(f), f;
}
function $4d4f9a4167bc8de2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $4d4f9a4167bc8de2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $4d4f9a4167bc8de2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $4d4f9a4167bc8de2$var$m(n, l) {
    if (null == l) return n.__ ? $4d4f9a4167bc8de2$var$m(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $4d4f9a4167bc8de2$var$m(n) : null;
}
function $4d4f9a4167bc8de2$var$w(n, u, t) {
    var i, o = n.__v, r = o.__e, f = n.__P;
    if (f) return (i = $4d4f9a4167bc8de2$var$v({}, o)).__v = o.__v + 1, $4d4f9a4167bc8de2$export$41c562ebe57d11e2.vnode && $4d4f9a4167bc8de2$export$41c562ebe57d11e2.vnode(i), $4d4f9a4167bc8de2$var$M(f, i, o, n.__n, void 0 !== f.ownerSVGElement, 32 & o.__u ? [
        r
    ] : null, u, null == r ? $4d4f9a4167bc8de2$var$m(o) : r, !!(32 & o.__u), t), i.__v = o.__v, i.__.__k[i.__i] = i, i.__d = void 0, i.__e != r && $4d4f9a4167bc8de2$var$k(i), i;
}
function $4d4f9a4167bc8de2$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $4d4f9a4167bc8de2$var$k(n);
    }
}
function $4d4f9a4167bc8de2$var$x(n) {
    (!n.__d && (n.__d = !0) && $4d4f9a4167bc8de2$var$i.push(n) && !$4d4f9a4167bc8de2$var$C.__r++ || $4d4f9a4167bc8de2$var$o !== $4d4f9a4167bc8de2$export$41c562ebe57d11e2.debounceRendering) && (($4d4f9a4167bc8de2$var$o = $4d4f9a4167bc8de2$export$41c562ebe57d11e2.debounceRendering) || $4d4f9a4167bc8de2$var$r)($4d4f9a4167bc8de2$var$C);
}
function $4d4f9a4167bc8de2$var$C() {
    var n, u, t, o = [], r = [];
    for($4d4f9a4167bc8de2$var$i.sort($4d4f9a4167bc8de2$var$f); n = $4d4f9a4167bc8de2$var$i.shift();)n.__d && (t = $4d4f9a4167bc8de2$var$i.length, u = $4d4f9a4167bc8de2$var$w(n, o, r) || u, 0 === t || $4d4f9a4167bc8de2$var$i.length > t ? ($4d4f9a4167bc8de2$var$j(o, u, r), r.length = o.length = 0, u = void 0, $4d4f9a4167bc8de2$var$i.sort($4d4f9a4167bc8de2$var$f)) : u && $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__c && $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__c(u, $4d4f9a4167bc8de2$var$s));
    u && $4d4f9a4167bc8de2$var$j(o, u, r), $4d4f9a4167bc8de2$var$C.__r = 0;
}
function $4d4f9a4167bc8de2$var$P(n, l, u, t, i, o, r, f, e, a, h) {
    var v, p, y, d, _, g = t && t.__k || $4d4f9a4167bc8de2$var$s, b = l.length;
    for(u.__d = e, $4d4f9a4167bc8de2$var$S(u, l, g), e = u.__d, v = 0; v < b; v++)null != (y = u.__k[v]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $4d4f9a4167bc8de2$var$c : g[y.__i] || $4d4f9a4167bc8de2$var$c, y.__i = v, $4d4f9a4167bc8de2$var$M(n, y, p, i, o, r, f, e, a, h), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $4d4f9a4167bc8de2$var$N(p.ref, null, y), h.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? e = $4d4f9a4167bc8de2$var$$(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $4d4f9a4167bc8de2$var$S(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $4d4f9a4167bc8de2$var$d(null, i, null, null, null) : $4d4f9a4167bc8de2$var$h(i) ? $4d4f9a4167bc8de2$var$d($4d4f9a4167bc8de2$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $4d4f9a4167bc8de2$var$d(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $4d4f9a4167bc8de2$var$I(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r ? f == r - 1 && (a = f - r) : a = 0, f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d4f9a4167bc8de2$var$m(o)), $4d4f9a4167bc8de2$var$O(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d4f9a4167bc8de2$var$m(o)), $4d4f9a4167bc8de2$var$O(o, o));
}
function $4d4f9a4167bc8de2$var$$(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $4d4f9a4167bc8de2$var$$(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $4d4f9a4167bc8de2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($4d4f9a4167bc8de2$var$h(n) ? n.some(function(n) {
        $4d4f9a4167bc8de2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $4d4f9a4167bc8de2$var$I(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $4d4f9a4167bc8de2$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $4d4f9a4167bc8de2$var$a.test(l) ? u : u + "px";
}
function $4d4f9a4167bc8de2$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $4d4f9a4167bc8de2$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $4d4f9a4167bc8de2$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $4d4f9a4167bc8de2$var$L : $4d4f9a4167bc8de2$var$D, o)) : n.removeEventListener(l, o ? $4d4f9a4167bc8de2$var$L : $4d4f9a4167bc8de2$var$D, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $4d4f9a4167bc8de2$var$D(n) {
    if (this.l) {
        var u = this.l[n.type + !1];
        if (n.t) {
            if (n.t <= u.u) return;
        } else n.t = Date.now();
        return u($4d4f9a4167bc8de2$export$41c562ebe57d11e2.event ? $4d4f9a4167bc8de2$export$41c562ebe57d11e2.event(n) : n);
    }
}
function $4d4f9a4167bc8de2$var$L(n) {
    if (this.l) return this.l[n.type + !0]($4d4f9a4167bc8de2$export$41c562ebe57d11e2.event ? $4d4f9a4167bc8de2$export$41c562ebe57d11e2.event(n) : n);
}
function $4d4f9a4167bc8de2$var$M(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, m, w, k, x, C, S, $, H, I, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (k = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? w = (p = u.__c = t.__c).__ = p.__E : ("prototype" in A && A.prototype.render ? u.__c = p = new A(k, C) : (u.__c = p = new $4d4f9a4167bc8de2$export$16fa2f45be04daa8(k, C), p.constructor = A, p.render = $4d4f9a4167bc8de2$var$q), x && x.sub(p), p.props = k, p.state || (p.state = {}), p.context = C, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != A.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $4d4f9a4167bc8de2$var$v({}, p.__s)), $4d4f9a4167bc8de2$var$v(p.__s, A.getDerivedStateFromProps(k, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == A.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && k !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(k, C), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(k, p.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = k, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), S = 0; S < p._sb.length; S++)p.__h.push(p._sb[S]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(k, p.__s, C), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, m);
            });
        }
        if (p.context = C, p.props = k, p.__P = n, p.__e = !1, $ = $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__r, H = 0, "prototype" in A && A.prototype.render) {
            for(p.state = p.__s, p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), I = 0; I < p._sb.length; I++)p.__h.push(p._sb[I]);
            p._sb = [];
        } else do p.__d = !1, $ && $(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++H < 25);
        p.state = p.__s, null != p.getChildContext && (i = $4d4f9a4167bc8de2$var$v($4d4f9a4167bc8de2$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (m = p.getSnapshotBeforeUpdate(d, _)), $4d4f9a4167bc8de2$var$P(n, $4d4f9a4167bc8de2$var$h(T = null != a && a.type === $4d4f9a4167bc8de2$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__u &= -161, p.__h.length && f.push(p), w && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $4d4f9a4167bc8de2$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $4d4f9a4167bc8de2$export$41c562ebe57d11e2.diffed) && a(u);
}
function $4d4f9a4167bc8de2$var$j(n, u, t) {
    for(var i = 0; i < t.length; i++)$4d4f9a4167bc8de2$var$N(t[i], t[++i], t[++i]);
    $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__c && $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $4d4f9a4167bc8de2$var$z(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d, _, g, b, w = t.props, k = u.props, x = u.type;
    if ("svg" === x && (o = !0), null != r) {
        for(a = 0; a < r.length; a++)if ((_ = r[a]) && "setAttribute" in _ == !!x && (x ? _.localName === x : 3 === _.nodeType)) {
            l = _, r[a] = null;
            break;
        }
    }
    if (null == l) {
        if (null === x) return document.createTextNode(k);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, k.is && k), r = null, e = !1;
    }
    if (null === x) w === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $4d4f9a4167bc8de2$var$n.call(l.childNodes), w = t.props || $4d4f9a4167bc8de2$var$c, !e && null != r) for(w = {}, a = 0; a < l.attributes.length; a++)w[(_ = l.attributes[a]).name] = _.value;
        for(a in w)_ = w[a], "children" == a || ("dangerouslySetInnerHTML" == a ? y = _ : "key" === a || a in k || $4d4f9a4167bc8de2$var$A(l, a, null, _, o));
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? b = _ : "key" === a || e && "function" != typeof _ || w[a] === _ || $4d4f9a4167bc8de2$var$A(l, a, _, w[a], o);
        if (v) e || y && (v.__html === y.__html || v.__html === l.innerHTML) || (l.innerHTML = v.__html), u.__k = [];
        else if (y && (l.innerHTML = ""), $4d4f9a4167bc8de2$var$P(l, $4d4f9a4167bc8de2$var$h(d) ? d : [
            d
        ], u, t, i, o && "foreignObject" !== x, r, f, r ? r[0] : t.__k && $4d4f9a4167bc8de2$var$m(t, 0), e, s), null != r) for(a = r.length; a--;)null != r[a] && $4d4f9a4167bc8de2$var$p(r[a]);
        e || (a = "value", void 0 !== g && (g !== l[a] || "progress" === x && !g || "option" === x && g !== w[a]) && $4d4f9a4167bc8de2$var$A(l, a, g, w[a], !1), a = "checked", void 0 !== b && b !== l[a] && $4d4f9a4167bc8de2$var$A(l, a, b, w[a], !1));
    }
    return l;
}
function $4d4f9a4167bc8de2$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $4d4f9a4167bc8de2$var$O(n, u, t) {
    var i, o;
    if ($4d4f9a4167bc8de2$export$41c562ebe57d11e2.unmount && $4d4f9a4167bc8de2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $4d4f9a4167bc8de2$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $4d4f9a4167bc8de2$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $4d4f9a4167bc8de2$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $4d4f9a4167bc8de2$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $4d4f9a4167bc8de2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__ && $4d4f9a4167bc8de2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $4d4f9a4167bc8de2$var$M(t, u = (!o && i || t).__k = $4d4f9a4167bc8de2$export$c8a8987d4410bf2d($4d4f9a4167bc8de2$export$ffb0004e005737fa, null, [
        u
    ]), r || $4d4f9a4167bc8de2$var$c, $4d4f9a4167bc8de2$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $4d4f9a4167bc8de2$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), u.__d = void 0, $4d4f9a4167bc8de2$var$j(f, u, e);
}
function $4d4f9a4167bc8de2$export$fa8d919ba61d84db(n, l) {
    $4d4f9a4167bc8de2$export$b3890eb0ae9dca99(n, l, $4d4f9a4167bc8de2$export$fa8d919ba61d84db);
}
function $4d4f9a4167bc8de2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $4d4f9a4167bc8de2$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $4d4f9a4167bc8de2$var$n.call(arguments, 2) : t), $4d4f9a4167bc8de2$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $4d4f9a4167bc8de2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $4d4f9a4167bc8de2$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $4d4f9a4167bc8de2$var$x(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$4d4f9a4167bc8de2$var$n = $4d4f9a4167bc8de2$var$s.slice, $4d4f9a4167bc8de2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $4d4f9a4167bc8de2$var$u = 0, $4d4f9a4167bc8de2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $4d4f9a4167bc8de2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $4d4f9a4167bc8de2$var$v({}, this.state), "function" == typeof n && (n = n($4d4f9a4167bc8de2$var$v({}, u), this.props)), n && $4d4f9a4167bc8de2$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $4d4f9a4167bc8de2$var$x(this));
}, $4d4f9a4167bc8de2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $4d4f9a4167bc8de2$var$x(this));
}, $4d4f9a4167bc8de2$export$16fa2f45be04daa8.prototype.render = $4d4f9a4167bc8de2$export$ffb0004e005737fa, $4d4f9a4167bc8de2$var$i = [], $4d4f9a4167bc8de2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $4d4f9a4167bc8de2$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $4d4f9a4167bc8de2$var$C.__r = 0, $4d4f9a4167bc8de2$var$e = 0;


function $82808133d5803385$export$3219add52b18c0d7(record, path) {
    return path.reduce(function(current, key) {
        return current && current[key];
    }, record);
}



/**
 * Creates a data structure that allows to concatenate similar highlighting
 * parts in a single value.
 */ function $21f6be031cd863a9$var$createAttributeSet() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var value = initialValue;
    return {
        get: function get() {
            return value;
        },
        add: function add(part) {
            var lastPart = value[value.length - 1];
            if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.isHighlighted) === part.isHighlighted) value[value.length - 1] = {
                value: lastPart.value + part.value,
                isHighlighted: lastPart.isHighlighted
            };
            else value.push(part);
        }
    };
}
function $21f6be031cd863a9$export$dd369bc78e81a241(_ref) {
    var highlightedValue = _ref.highlightedValue;
    var preTagParts = highlightedValue.split((0, $9ad720f7ffcd5ffd$export$2df5424f792538bd));
    var firstValue = preTagParts.shift();
    var parts = $21f6be031cd863a9$var$createAttributeSet(firstValue ? [
        {
            value: firstValue,
            isHighlighted: false
        }
    ] : []);
    preTagParts.forEach(function(part) {
        var postTagParts = part.split((0, $9ad720f7ffcd5ffd$export$2681d4c6a4ae86));
        parts.add({
            value: postTagParts[0],
            isHighlighted: true
        });
        if (postTagParts[1] !== '') parts.add({
            value: postTagParts[1],
            isHighlighted: false
        });
    });
    return parts.get();
}


function $8c6d8eda8d3b9aab$var$_toConsumableArray(arr) {
    return $8c6d8eda8d3b9aab$var$_arrayWithoutHoles(arr) || $8c6d8eda8d3b9aab$var$_iterableToArray(arr) || $8c6d8eda8d3b9aab$var$_unsupportedIterableToArray(arr) || $8c6d8eda8d3b9aab$var$_nonIterableSpread();
}
function $8c6d8eda8d3b9aab$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8c6d8eda8d3b9aab$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8c6d8eda8d3b9aab$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8c6d8eda8d3b9aab$var$_arrayLikeToArray(o, minLen);
}
function $8c6d8eda8d3b9aab$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8c6d8eda8d3b9aab$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8c6d8eda8d3b9aab$var$_arrayLikeToArray(arr);
}
function $8c6d8eda8d3b9aab$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8c6d8eda8d3b9aab$export$8d253e1eb996c525(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute;
    var path = Array.isArray(attribute) ? attribute : [
        attribute
    ];
    var highlightedValue = (0, $82808133d5803385$export$3219add52b18c0d7)(hit, [
        '_highlightResult'
    ].concat($8c6d8eda8d3b9aab$var$_toConsumableArray(path), [
        'value'
    ]));
    if (typeof highlightedValue !== 'string') highlightedValue = (0, $82808133d5803385$export$3219add52b18c0d7)(hit, path) || '';
    return (0, $21f6be031cd863a9$export$dd369bc78e81a241)({
        highlightedValue: highlightedValue
    });
}


function $9fd89664d3b92a98$export$c8682df1c852a966(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function Highlight(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $8c6d8eda8d3b9aab$export$8d253e1eb996c525)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    Highlight.__autocomplete_componentName = 'Highlight';
    return Highlight;
}


var $5586edc14427cb70$var$htmlEscapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
var $5586edc14427cb70$var$hasAlphanumeric = new RegExp(/\w/i);
var $5586edc14427cb70$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $5586edc14427cb70$var$regexHasEscapedHtml = RegExp($5586edc14427cb70$var$regexEscapedHtml.source);
function $5586edc14427cb70$var$unescape(value) {
    return value && $5586edc14427cb70$var$regexHasEscapedHtml.test(value) ? value.replace($5586edc14427cb70$var$regexEscapedHtml, function(character) {
        return $5586edc14427cb70$var$htmlEscapes[character];
    }) : value;
}
function $5586edc14427cb70$export$72c2046b3b0a911c(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$5586edc14427cb70$var$hasAlphanumeric.test($5586edc14427cb70$var$unescape(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $59a97f5a72784dd9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $59a97f5a72784dd9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $59a97f5a72784dd9$var$_typeof(obj);
}
function $59a97f5a72784dd9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $59a97f5a72784dd9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $59a97f5a72784dd9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $59a97f5a72784dd9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $59a97f5a72784dd9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $59a97f5a72784dd9$var$_defineProperty(obj, key, value) {
    key = $59a97f5a72784dd9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $59a97f5a72784dd9$var$_toPropertyKey(arg) {
    var key = $59a97f5a72784dd9$var$_toPrimitive(arg, "string");
    return $59a97f5a72784dd9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $59a97f5a72784dd9$var$_toPrimitive(input, hint) {
    if ($59a97f5a72784dd9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($59a97f5a72784dd9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $59a97f5a72784dd9$export$8d1202a2cf66e93(parts) {
    // We don't want to highlight the whole word when no parts match.
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $59a97f5a72784dd9$var$_objectSpread($59a97f5a72784dd9$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $59a97f5a72784dd9$var$_objectSpread($59a97f5a72784dd9$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $5586edc14427cb70$export$72c2046b3b0a911c)(parts, i)
        });
    });
}


function $6e68b6543de62098$export$4923484c50253a9b(props) {
    return (0, $59a97f5a72784dd9$export$8d1202a2cf66e93)((0, $8c6d8eda8d3b9aab$export$8d253e1eb996c525)(props));
}


function $a65991b233222e03$export$6497355a57b2273f(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function ReverseHighlight(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $6e68b6543de62098$export$4923484c50253a9b)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    ReverseHighlight.__autocomplete_componentName = 'ReverseHighlight';
    return ReverseHighlight;
}



function $4e5b20967ae7f1fb$var$_toConsumableArray(arr) {
    return $4e5b20967ae7f1fb$var$_arrayWithoutHoles(arr) || $4e5b20967ae7f1fb$var$_iterableToArray(arr) || $4e5b20967ae7f1fb$var$_unsupportedIterableToArray(arr) || $4e5b20967ae7f1fb$var$_nonIterableSpread();
}
function $4e5b20967ae7f1fb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4e5b20967ae7f1fb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4e5b20967ae7f1fb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4e5b20967ae7f1fb$var$_arrayLikeToArray(o, minLen);
}
function $4e5b20967ae7f1fb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $4e5b20967ae7f1fb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4e5b20967ae7f1fb$var$_arrayLikeToArray(arr);
}
function $4e5b20967ae7f1fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4e5b20967ae7f1fb$export$8d43cf2bcfea1837(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute;
    var path = Array.isArray(attribute) ? attribute : [
        attribute
    ];
    var highlightedValue = (0, $82808133d5803385$export$3219add52b18c0d7)(hit, [
        '_snippetResult'
    ].concat($4e5b20967ae7f1fb$var$_toConsumableArray(path), [
        'value'
    ]));
    if (typeof highlightedValue !== 'string') highlightedValue = (0, $82808133d5803385$export$3219add52b18c0d7)(hit, path) || '';
    return (0, $21f6be031cd863a9$export$dd369bc78e81a241)({
        highlightedValue: highlightedValue
    });
}



function $8d049e842985aaef$export$28f36526e7a141af(props) {
    return (0, $59a97f5a72784dd9$export$8d1202a2cf66e93)((0, $4e5b20967ae7f1fb$export$8d43cf2bcfea1837)(props));
}


function $bcb536ffa3c9e387$export$8af413b0fd5d7b30(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function ReverseSnippet(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $8d049e842985aaef$export$28f36526e7a141af)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    ReverseSnippet.__autocomplete_componentName = 'ReverseSnippet';
    return ReverseSnippet;
}


function $913c286ea639da0a$export$563bb1b0fb5a610d(_ref) {
    var createElement = _ref.createElement, Fragment = _ref.Fragment;
    function Snippet(_ref2) {
        var hit = _ref2.hit, attribute = _ref2.attribute, _ref2$tagName = _ref2.tagName, tagName = _ref2$tagName === void 0 ? 'mark' : _ref2$tagName;
        return createElement(Fragment, {}, (0, $4e5b20967ae7f1fb$export$8d43cf2bcfea1837)({
            hit: hit,
            attribute: attribute
        }).map(function(x, index) {
            return x.isHighlighted ? createElement(tagName, {
                key: index
            }, x.value) : x.value;
        }));
    }
    Snippet.__autocomplete_componentName = 'Snippet';
    return Snippet;
}



function $f189a21d18b6e612$export$bad8ef72755038c6(environment, value) {
    if (typeof value === 'string') {
        var element = environment.document.querySelector(value);
        (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(element !== null, "The element ".concat(JSON.stringify(value), " is not in the document."));
        return element;
    }
    return value;
}

function $8a0503cdebe89cad$export$8bf64cd1c29a1310() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return values.reduce(function(acc, current) {
        Object.keys(current).forEach(function(key) {
            var accValue = acc[key];
            var currentValue = current[key];
            if (accValue !== currentValue) acc[key] = [
                accValue,
                currentValue
            ].filter(Boolean).join(' ');
        });
        return acc;
    }, {});
}


function $1bf8c17cdf5ddfde$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1bf8c17cdf5ddfde$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1bf8c17cdf5ddfde$var$_typeof(obj);
}
var $1bf8c17cdf5ddfde$var$_excluded = [
    "classNames",
    "container",
    "getEnvironmentProps",
    "getFormProps",
    "getInputProps",
    "getItemProps",
    "getLabelProps",
    "getListProps",
    "getPanelProps",
    "getRootProps",
    "panelContainer",
    "panelPlacement",
    "render",
    "renderNoResults",
    "renderer",
    "detachedMediaQuery",
    "components",
    "translations"
];
function $1bf8c17cdf5ddfde$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1bf8c17cdf5ddfde$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1bf8c17cdf5ddfde$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1bf8c17cdf5ddfde$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1bf8c17cdf5ddfde$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1bf8c17cdf5ddfde$var$_defineProperty(obj, key, value) {
    key = $1bf8c17cdf5ddfde$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1bf8c17cdf5ddfde$var$_toPropertyKey(arg) {
    var key = $1bf8c17cdf5ddfde$var$_toPrimitive(arg, "string");
    return $1bf8c17cdf5ddfde$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1bf8c17cdf5ddfde$var$_toPrimitive(input, hint) {
    if ($1bf8c17cdf5ddfde$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1bf8c17cdf5ddfde$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1bf8c17cdf5ddfde$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1bf8c17cdf5ddfde$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1bf8c17cdf5ddfde$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1bf8c17cdf5ddfde$var$defaultClassNames = {
    clearButton: 'aa-ClearButton',
    detachedCancelButton: 'aa-DetachedCancelButton',
    detachedContainer: 'aa-DetachedContainer',
    detachedFormContainer: 'aa-DetachedFormContainer',
    detachedOverlay: 'aa-DetachedOverlay',
    detachedSearchButton: 'aa-DetachedSearchButton',
    detachedSearchButtonIcon: 'aa-DetachedSearchButtonIcon',
    detachedSearchButtonPlaceholder: 'aa-DetachedSearchButtonPlaceholder',
    detachedSearchButtonQuery: 'aa-DetachedSearchButtonQuery',
    form: 'aa-Form',
    input: 'aa-Input',
    inputWrapper: 'aa-InputWrapper',
    inputWrapperPrefix: 'aa-InputWrapperPrefix',
    inputWrapperSuffix: 'aa-InputWrapperSuffix',
    item: 'aa-Item',
    label: 'aa-Label',
    list: 'aa-List',
    loadingIndicator: 'aa-LoadingIndicator',
    panel: 'aa-Panel',
    panelLayout: 'aa-PanelLayout aa-Panel--scrollable',
    root: 'aa-Autocomplete',
    source: 'aa-Source',
    sourceFooter: 'aa-SourceFooter',
    sourceHeader: 'aa-SourceHeader',
    sourceNoResults: 'aa-SourceNoResults',
    submitButton: 'aa-SubmitButton'
};
var $1bf8c17cdf5ddfde$var$defaultRender = function defaultRender(_ref, root) {
    var children = _ref.children, render = _ref.render;
    render(children, root);
};
var $1bf8c17cdf5ddfde$var$defaultRenderer = {
    createElement: (0, $4d4f9a4167bc8de2$export$c8a8987d4410bf2d),
    Fragment: (0, $4d4f9a4167bc8de2$export$ffb0004e005737fa),
    render: (0, $4d4f9a4167bc8de2$export$b3890eb0ae9dca99)
};
function $1bf8c17cdf5ddfde$export$430a3269e24b912e(options) {
    var _core$id;
    var classNames = options.classNames, container = options.container, getEnvironmentProps = options.getEnvironmentProps, getFormProps = options.getFormProps, getInputProps = options.getInputProps, getItemProps = options.getItemProps, getLabelProps = options.getLabelProps, getListProps = options.getListProps, getPanelProps = options.getPanelProps, getRootProps = options.getRootProps, panelContainer = options.panelContainer, panelPlacement = options.panelPlacement, render = options.render, renderNoResults = options.renderNoResults, renderer = options.renderer, detachedMediaQuery = options.detachedMediaQuery, components = options.components, translations = options.translations, core = $1bf8c17cdf5ddfde$var$_objectWithoutProperties(options, $1bf8c17cdf5ddfde$var$_excluded);
    /* eslint-disable no-restricted-globals */ var environment = typeof window !== 'undefined' ? window : {};
    /* eslint-enable no-restricted-globals */ var containerElement = (0, $f189a21d18b6e612$export$bad8ef72755038c6)(environment, container);
    (0, $c0d61b83e196c4c1$export$f5708dca728d7177)(containerElement.tagName !== 'INPUT', 'The `container` option does not support `input` elements. You need to change the container to a `div`.');
    var defaultedRenderer = $1bf8c17cdf5ddfde$var$_objectSpread($1bf8c17cdf5ddfde$var$_objectSpread({}, $1bf8c17cdf5ddfde$var$defaultRenderer), renderer);
    var defaultComponents = {
        Highlight: (0, $9fd89664d3b92a98$export$c8682df1c852a966)(defaultedRenderer),
        ReverseHighlight: (0, $a65991b233222e03$export$6497355a57b2273f)(defaultedRenderer),
        ReverseSnippet: (0, $bcb536ffa3c9e387$export$8af413b0fd5d7b30)(defaultedRenderer),
        Snippet: (0, $913c286ea639da0a$export$563bb1b0fb5a610d)(defaultedRenderer)
    };
    var defaultTranslations = {
        clearButtonTitle: 'Clear',
        detachedCancelButtonText: 'Cancel',
        detachedSearchButtonTitle: 'Search',
        submitButtonTitle: 'Submit'
    };
    return {
        renderer: {
            classNames: (0, $8a0503cdebe89cad$export$8bf64cd1c29a1310)($1bf8c17cdf5ddfde$var$defaultClassNames, classNames !== null && classNames !== void 0 ? classNames : {}),
            container: containerElement,
            getEnvironmentProps: getEnvironmentProps !== null && getEnvironmentProps !== void 0 ? getEnvironmentProps : function(_ref2) {
                var props = _ref2.props;
                return props;
            },
            getFormProps: getFormProps !== null && getFormProps !== void 0 ? getFormProps : function(_ref3) {
                var props = _ref3.props;
                return props;
            },
            getInputProps: getInputProps !== null && getInputProps !== void 0 ? getInputProps : function(_ref4) {
                var props = _ref4.props;
                return props;
            },
            getItemProps: getItemProps !== null && getItemProps !== void 0 ? getItemProps : function(_ref5) {
                var props = _ref5.props;
                return props;
            },
            getLabelProps: getLabelProps !== null && getLabelProps !== void 0 ? getLabelProps : function(_ref6) {
                var props = _ref6.props;
                return props;
            },
            getListProps: getListProps !== null && getListProps !== void 0 ? getListProps : function(_ref7) {
                var props = _ref7.props;
                return props;
            },
            getPanelProps: getPanelProps !== null && getPanelProps !== void 0 ? getPanelProps : function(_ref8) {
                var props = _ref8.props;
                return props;
            },
            getRootProps: getRootProps !== null && getRootProps !== void 0 ? getRootProps : function(_ref9) {
                var props = _ref9.props;
                return props;
            },
            panelContainer: panelContainer ? (0, $f189a21d18b6e612$export$bad8ef72755038c6)(environment, panelContainer) : environment.document.body,
            panelPlacement: panelPlacement !== null && panelPlacement !== void 0 ? panelPlacement : 'input-wrapper-width',
            render: render !== null && render !== void 0 ? render : $1bf8c17cdf5ddfde$var$defaultRender,
            renderNoResults: renderNoResults,
            renderer: defaultedRenderer,
            detachedMediaQuery: detachedMediaQuery !== null && detachedMediaQuery !== void 0 ? detachedMediaQuery : getComputedStyle(environment.document.documentElement).getPropertyValue('--aa-detached-media-query'),
            components: $1bf8c17cdf5ddfde$var$_objectSpread($1bf8c17cdf5ddfde$var$_objectSpread({}, defaultComponents), components),
            translations: $1bf8c17cdf5ddfde$var$_objectSpread($1bf8c17cdf5ddfde$var$_objectSpread({}, defaultTranslations), translations)
        },
        core: $1bf8c17cdf5ddfde$var$_objectSpread($1bf8c17cdf5ddfde$var$_objectSpread({}, core), {}, {
            id: (_core$id = core.id) !== null && _core$id !== void 0 ? _core$id : (0, $dd58adffabb2430e$export$46ae397d8484b6c2)(),
            environment: environment
        })
    };
}


function $90838c7d2be148a9$export$1d22b12817313d05(_ref) {
    var panelPlacement = _ref.panelPlacement, container = _ref.container, form = _ref.form, environment = _ref.environment;
    var containerRect = container.getBoundingClientRect();
    // Some browsers have specificities to retrieve the document scroll position.
    // See https://stackoverflow.com/a/28633515/9940315
    var scrollTop = environment.pageYOffset || environment.document.documentElement.scrollTop || environment.document.body.scrollTop || 0;
    var top = scrollTop + containerRect.top + containerRect.height;
    switch(panelPlacement){
        case 'start':
            return {
                top: top,
                left: containerRect.left
            };
        case 'end':
            return {
                top: top,
                right: environment.document.documentElement.clientWidth - (containerRect.left + containerRect.width)
            };
        case 'full-width':
            return {
                top: top,
                left: 0,
                right: 0,
                width: 'unset',
                maxWidth: 'unset'
            };
        case 'input-wrapper-width':
            var formRect = form.getBoundingClientRect();
            return {
                top: top,
                left: formRect.left,
                right: environment.document.documentElement.clientWidth - (formRect.left + formRect.width),
                width: 'unset',
                maxWidth: 'unset'
            };
        default:
            throw new Error("[Autocomplete] The `panelPlacement` value ".concat(JSON.stringify(panelPlacement), " is not valid."));
    }
}



function $71a5f84a14483f22$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $71a5f84a14483f22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $71a5f84a14483f22$var$_typeof(obj);
}
function $71a5f84a14483f22$var$_extends() {
    $71a5f84a14483f22$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71a5f84a14483f22$var$_extends.apply(this, arguments);
}
function $71a5f84a14483f22$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $71a5f84a14483f22$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $71a5f84a14483f22$var$ownKeys(Object(source), !0).forEach(function(key) {
            $71a5f84a14483f22$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $71a5f84a14483f22$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $71a5f84a14483f22$var$_defineProperty(obj, key, value) {
    key = $71a5f84a14483f22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71a5f84a14483f22$var$_toPropertyKey(arg) {
    var key = $71a5f84a14483f22$var$_toPrimitive(arg, "string");
    return $71a5f84a14483f22$var$_typeof(key) === "symbol" ? key : String(key);
}
function $71a5f84a14483f22$var$_toPrimitive(input, hint) {
    if ($71a5f84a14483f22$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($71a5f84a14483f22$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $71a5f84a14483f22$export$348e1e27f1e916dd(_ref) {
    var autocomplete = _ref.autocomplete, autocompleteScopeApi = _ref.autocompleteScopeApi, dom = _ref.dom, propGetters = _ref.propGetters, state = _ref.state;
    (0, $8dbb11db5a0b36c0$export$514d50f66c38c2be)(dom.root, propGetters.getRootProps($71a5f84a14483f22$var$_objectSpread({
        state: state,
        props: autocomplete.getRootProps({})
    }, autocompleteScopeApi)));
    (0, $8dbb11db5a0b36c0$export$514d50f66c38c2be)(dom.input, propGetters.getInputProps($71a5f84a14483f22$var$_objectSpread({
        state: state,
        props: autocomplete.getInputProps({
            inputElement: dom.input
        }),
        inputElement: dom.input
    }, autocompleteScopeApi)));
    (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(dom.label, {
        hidden: state.status === 'stalled'
    });
    (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(dom.loadingIndicator, {
        hidden: state.status !== 'stalled'
    });
    (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(dom.clearButton, {
        hidden: !state.query
    });
    (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(dom.detachedSearchButtonQuery, {
        textContent: state.query
    });
    (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(dom.detachedSearchButtonPlaceholder, {
        hidden: Boolean(state.query)
    });
}
function $71a5f84a14483f22$export$67d17c7da9b4cdd6(render, _ref2) {
    var autocomplete = _ref2.autocomplete, autocompleteScopeApi = _ref2.autocompleteScopeApi, classNames = _ref2.classNames, html = _ref2.html, dom = _ref2.dom, panelContainer = _ref2.panelContainer, propGetters = _ref2.propGetters, state = _ref2.state, components = _ref2.components, renderer = _ref2.renderer;
    if (!state.isOpen) {
        if (panelContainer.contains(dom.panel)) panelContainer.removeChild(dom.panel);
        return;
    }
    // We add the panel element to the DOM when it's not yet appended and that the
    // items are fetched.
    if (!panelContainer.contains(dom.panel) && state.status !== 'loading') panelContainer.appendChild(dom.panel);
    dom.panel.classList.toggle('aa-Panel--stalled', state.status === 'stalled');
    var sections = state.collections.filter(function(_ref3) {
        var source = _ref3.source, items = _ref3.items;
        return source.templates.noResults || items.length > 0;
    }).map(function(_ref4, sourceIndex) {
        var source = _ref4.source, items = _ref4.items;
        return renderer.createElement("section", {
            key: sourceIndex,
            className: classNames.source,
            "data-autocomplete-source-id": source.sourceId
        }, source.templates.header && renderer.createElement("div", {
            className: classNames.sourceHeader
        }, source.templates.header({
            components: components,
            createElement: renderer.createElement,
            Fragment: renderer.Fragment,
            items: items,
            source: source,
            state: state,
            html: html
        })), source.templates.noResults && items.length === 0 ? renderer.createElement("div", {
            className: classNames.sourceNoResults
        }, source.templates.noResults({
            components: components,
            createElement: renderer.createElement,
            Fragment: renderer.Fragment,
            source: source,
            state: state,
            html: html
        })) : renderer.createElement("ul", $71a5f84a14483f22$var$_extends({
            className: classNames.list
        }, propGetters.getListProps($71a5f84a14483f22$var$_objectSpread({
            state: state,
            props: autocomplete.getListProps({
                source: source
            })
        }, autocompleteScopeApi))), items.map(function(item) {
            var itemProps = autocomplete.getItemProps({
                item: item,
                source: source
            });
            return renderer.createElement("li", $71a5f84a14483f22$var$_extends({
                key: itemProps.id,
                className: classNames.item
            }, propGetters.getItemProps($71a5f84a14483f22$var$_objectSpread({
                state: state,
                props: itemProps
            }, autocompleteScopeApi))), source.templates.item({
                components: components,
                createElement: renderer.createElement,
                Fragment: renderer.Fragment,
                item: item,
                state: state,
                html: html
            }));
        })), source.templates.footer && renderer.createElement("div", {
            className: classNames.sourceFooter
        }, source.templates.footer({
            components: components,
            createElement: renderer.createElement,
            Fragment: renderer.Fragment,
            items: items,
            source: source,
            state: state,
            html: html
        })));
    });
    var children = renderer.createElement(renderer.Fragment, null, renderer.createElement("div", {
        className: classNames.panelLayout
    }, sections), renderer.createElement("div", {
        className: "aa-GradientBottom"
    }));
    var elements = sections.reduce(function(acc, current) {
        acc[current.props['data-autocomplete-source-id']] = current;
        return acc;
    }, {});
    render($71a5f84a14483f22$var$_objectSpread($71a5f84a14483f22$var$_objectSpread({
        children: children,
        state: state,
        sections: sections,
        elements: elements
    }, renderer), {}, {
        components: components,
        html: html
    }, autocompleteScopeApi), dom.panel);
}



function $5d3b845ebb0da544$var$_toConsumableArray(arr) {
    return $5d3b845ebb0da544$var$_arrayWithoutHoles(arr) || $5d3b845ebb0da544$var$_iterableToArray(arr) || $5d3b845ebb0da544$var$_unsupportedIterableToArray(arr) || $5d3b845ebb0da544$var$_nonIterableSpread();
}
function $5d3b845ebb0da544$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d3b845ebb0da544$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5d3b845ebb0da544$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5d3b845ebb0da544$var$_arrayLikeToArray(o, minLen);
}
function $5d3b845ebb0da544$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5d3b845ebb0da544$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5d3b845ebb0da544$var$_arrayLikeToArray(arr);
}
function $5d3b845ebb0da544$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5d3b845ebb0da544$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5d3b845ebb0da544$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5d3b845ebb0da544$var$_typeof(obj);
}
var $5d3b845ebb0da544$var$isPlainObject = function isPlainObject(value) {
    return value && $5d3b845ebb0da544$var$_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Object]';
};
function $5d3b845ebb0da544$export$dd702b3c8240390c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return values.reduce(function(acc, current) {
        Object.keys(current).forEach(function(key) {
            var accValue = acc[key];
            var currentValue = current[key];
            if (Array.isArray(accValue) && Array.isArray(currentValue)) acc[key] = accValue.concat.apply(accValue, $5d3b845ebb0da544$var$_toConsumableArray(currentValue));
            else if ($5d3b845ebb0da544$var$isPlainObject(accValue) && $5d3b845ebb0da544$var$isPlainObject(currentValue)) acc[key] = $5d3b845ebb0da544$export$dd702b3c8240390c(accValue, currentValue);
            else acc[key] = currentValue;
        });
        return acc;
    }, {});
}

function $cb06d79e6789d781$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cb06d79e6789d781$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cb06d79e6789d781$var$_typeof(obj);
}
function $cb06d79e6789d781$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cb06d79e6789d781$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cb06d79e6789d781$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cb06d79e6789d781$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cb06d79e6789d781$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cb06d79e6789d781$var$_defineProperty(obj, key, value) {
    key = $cb06d79e6789d781$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cb06d79e6789d781$var$_toPropertyKey(arg) {
    var key = $cb06d79e6789d781$var$_toPrimitive(arg, "string");
    return $cb06d79e6789d781$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cb06d79e6789d781$var$_toPrimitive(input, hint) {
    if ($cb06d79e6789d781$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cb06d79e6789d781$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cb06d79e6789d781$var$_slicedToArray(arr, i) {
    return $cb06d79e6789d781$var$_arrayWithHoles(arr) || $cb06d79e6789d781$var$_iterableToArrayLimit(arr, i) || $cb06d79e6789d781$var$_unsupportedIterableToArray(arr, i) || $cb06d79e6789d781$var$_nonIterableRest();
}
function $cb06d79e6789d781$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cb06d79e6789d781$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cb06d79e6789d781$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cb06d79e6789d781$var$_arrayLikeToArray(o, minLen);
}
function $cb06d79e6789d781$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cb06d79e6789d781$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $cb06d79e6789d781$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cb06d79e6789d781$export$b460b275d6c6aa0(obj, predicate) {
    return Object.entries(obj).reduce(function(acc, _ref) {
        var _ref2 = $cb06d79e6789d781$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (predicate({
            key: key,
            value: value
        })) return $cb06d79e6789d781$var$_objectSpread($cb06d79e6789d781$var$_objectSpread({}, acc), {}, $cb06d79e6789d781$var$_defineProperty({}, key, value));
        return acc;
    }, {});
}


var $bf5435a78004acf5$var$_excluded = [
    "components"
];
function $bf5435a78004acf5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bf5435a78004acf5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bf5435a78004acf5$var$_typeof(obj);
}
function $bf5435a78004acf5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bf5435a78004acf5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bf5435a78004acf5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bf5435a78004acf5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bf5435a78004acf5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bf5435a78004acf5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bf5435a78004acf5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bf5435a78004acf5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bf5435a78004acf5$var$_defineProperty(obj, key, value) {
    key = $bf5435a78004acf5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf5435a78004acf5$var$_toPropertyKey(arg) {
    var key = $bf5435a78004acf5$var$_toPrimitive(arg, "string");
    return $bf5435a78004acf5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bf5435a78004acf5$var$_toPrimitive(input, hint) {
    if ($bf5435a78004acf5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bf5435a78004acf5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $bf5435a78004acf5$var$instancesCount = 0;
function $bf5435a78004acf5$export$485ded5f26ebe08d(options) {
    var _createEffectWrapper = (0, $049a3f99a929515d$export$10c722448c02c6b9)(), runEffect = _createEffectWrapper.runEffect, cleanupEffects = _createEffectWrapper.cleanupEffects, runEffects = _createEffectWrapper.runEffects;
    var _createReactiveWrappe = (0, $54fbff6da3d12a96$export$d1aaf184999dfd1f)(), reactive = _createReactiveWrappe.reactive, runReactives = _createReactiveWrappe.runReactives;
    var hasNoResultsSourceTemplateRef = (0, $01c9e23a5dd7f92b$export$7d1e3a5e95ceca43)(false);
    var optionsRef = (0, $01c9e23a5dd7f92b$export$7d1e3a5e95ceca43)(options);
    var onStateChangeRef = (0, $01c9e23a5dd7f92b$export$7d1e3a5e95ceca43)(undefined);
    var props = reactive(function() {
        return (0, $1bf8c17cdf5ddfde$export$430a3269e24b912e)(optionsRef.current);
    });
    var isDetached = reactive(function() {
        return props.value.core.environment.matchMedia(props.value.renderer.detachedMediaQuery).matches;
    });
    var autocomplete = reactive(function() {
        return (0, $51dbda34caf22fe0$export$b00b86c416695282)($bf5435a78004acf5$var$_objectSpread($bf5435a78004acf5$var$_objectSpread({}, props.value.core), {}, {
            onStateChange: function onStateChange(params) {
                var _onStateChangeRef$cur, _props$value$core$onS, _props$value$core;
                hasNoResultsSourceTemplateRef.current = params.state.collections.some(function(collection) {
                    return collection.source.templates.noResults;
                });
                (_onStateChangeRef$cur = onStateChangeRef.current) === null || _onStateChangeRef$cur === void 0 || _onStateChangeRef$cur.call(onStateChangeRef, params);
                (_props$value$core$onS = (_props$value$core = props.value.core).onStateChange) === null || _props$value$core$onS === void 0 || _props$value$core$onS.call(_props$value$core, params);
            },
            shouldPanelOpen: optionsRef.current.shouldPanelOpen || function(_ref) {
                var state = _ref.state;
                if (isDetached.value) return true;
                var hasItems = (0, $009101fa2649e815$export$dd01a43948d7de86)(state) > 0;
                if (!props.value.core.openOnFocus && !state.query) return hasItems;
                var hasNoResultsTemplate = Boolean(hasNoResultsSourceTemplateRef.current || props.value.renderer.renderNoResults);
                return !hasItems && hasNoResultsTemplate || hasItems;
            },
            __autocomplete_metadata: {
                userAgents: (0, $02ba42a6613d600b$export$9536ea83a4cbd560),
                options: options
            }
        }));
    });
    var lastStateRef = (0, $01c9e23a5dd7f92b$export$7d1e3a5e95ceca43)($bf5435a78004acf5$var$_objectSpread({
        collections: [],
        completion: null,
        context: {},
        isOpen: false,
        query: '',
        activeItemId: null,
        status: 'idle'
    }, props.value.core.initialState));
    var propGetters = {
        getEnvironmentProps: props.value.renderer.getEnvironmentProps,
        getFormProps: props.value.renderer.getFormProps,
        getInputProps: props.value.renderer.getInputProps,
        getItemProps: props.value.renderer.getItemProps,
        getLabelProps: props.value.renderer.getLabelProps,
        getListProps: props.value.renderer.getListProps,
        getPanelProps: props.value.renderer.getPanelProps,
        getRootProps: props.value.renderer.getRootProps
    };
    var autocompleteScopeApi = {
        setActiveItemId: autocomplete.value.setActiveItemId,
        setQuery: autocomplete.value.setQuery,
        setCollections: autocomplete.value.setCollections,
        setIsOpen: autocomplete.value.setIsOpen,
        setStatus: autocomplete.value.setStatus,
        setContext: autocomplete.value.setContext,
        refresh: autocomplete.value.refresh,
        navigator: autocomplete.value.navigator
    };
    var html = reactive(function() {
        return (0, $5ece538e27521dca$export$2e2bcd8739ae039).bind(props.value.renderer.renderer.createElement);
    });
    var dom = reactive(function() {
        return (0, $12f9efeb53a76ffe$export$55e5ca2210a4e3c2)({
            autocomplete: autocomplete.value,
            autocompleteScopeApi: autocompleteScopeApi,
            classNames: props.value.renderer.classNames,
            environment: props.value.core.environment,
            isDetached: isDetached.value,
            placeholder: props.value.core.placeholder,
            propGetters: propGetters,
            setIsModalOpen: setIsModalOpen,
            state: lastStateRef.current,
            translations: props.value.renderer.translations
        });
    });
    function setPanelPosition() {
        (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(dom.value.panel, {
            style: isDetached.value ? {} : (0, $90838c7d2be148a9$export$1d22b12817313d05)({
                panelPlacement: props.value.renderer.panelPlacement,
                container: dom.value.root,
                form: dom.value.form,
                environment: props.value.core.environment
            })
        });
    }
    function scheduleRender(state) {
        lastStateRef.current = state;
        var renderProps = {
            autocomplete: autocomplete.value,
            autocompleteScopeApi: autocompleteScopeApi,
            classNames: props.value.renderer.classNames,
            components: props.value.renderer.components,
            container: props.value.renderer.container,
            html: html.value,
            dom: dom.value,
            panelContainer: isDetached.value ? dom.value.detachedContainer : props.value.renderer.panelContainer,
            propGetters: propGetters,
            state: lastStateRef.current,
            renderer: props.value.renderer.renderer
        };
        var render = !(0, $009101fa2649e815$export$dd01a43948d7de86)(state) && !hasNoResultsSourceTemplateRef.current && props.value.renderer.renderNoResults || props.value.renderer.render;
        (0, $71a5f84a14483f22$export$348e1e27f1e916dd)(renderProps);
        (0, $71a5f84a14483f22$export$67d17c7da9b4cdd6)(render, renderProps);
    }
    runEffect(function() {
        var environmentProps = autocomplete.value.getEnvironmentProps({
            formElement: dom.value.form,
            panelElement: dom.value.panel,
            inputElement: dom.value.input
        });
        (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(props.value.core.environment, environmentProps);
        return function() {
            (0, $8dbb11db5a0b36c0$export$80f053e5e39de51d)(props.value.core.environment, Object.keys(environmentProps).reduce(function(acc, key) {
                return $bf5435a78004acf5$var$_objectSpread($bf5435a78004acf5$var$_objectSpread({}, acc), {}, $bf5435a78004acf5$var$_defineProperty({}, key, undefined));
            }, {}));
        };
    });
    runEffect(function() {
        var panelContainerElement = isDetached.value ? props.value.core.environment.document.body : props.value.renderer.panelContainer;
        var panelElement = isDetached.value ? dom.value.detachedOverlay : dom.value.panel;
        if (isDetached.value && lastStateRef.current.isOpen) setIsModalOpen(true);
        scheduleRender(lastStateRef.current);
        return function() {
            if (panelContainerElement.contains(panelElement)) panelContainerElement.removeChild(panelElement);
        };
    });
    runEffect(function() {
        var containerElement = props.value.renderer.container;
        containerElement.appendChild(dom.value.root);
        return function() {
            containerElement.removeChild(dom.value.root);
        };
    });
    runEffect(function() {
        var debouncedRender = (0, $1a895ed241f1e396$export$61fc7d43ac8f84b0)(function(_ref2) {
            var state = _ref2.state;
            scheduleRender(state);
        }, 0);
        onStateChangeRef.current = function(_ref3) {
            var state = _ref3.state, prevState = _ref3.prevState;
            if (isDetached.value && prevState.isOpen !== state.isOpen) setIsModalOpen(state.isOpen);
            // The outer DOM might have changed since the last time the panel was
            // positioned. The layout might have shifted vertically for instance.
            // It's therefore safer to re-calculate the panel position before opening
            // it again.
            if (!isDetached.value && state.isOpen && !prevState.isOpen) setPanelPosition();
            // We scroll to the top of the panel whenever the query changes (i.e. new
            // results come in) so that users don't have to.
            if (state.query !== prevState.query) {
                var scrollablePanels = props.value.core.environment.document.querySelectorAll('.aa-Panel--scrollable');
                scrollablePanels.forEach(function(scrollablePanel) {
                    if (scrollablePanel.scrollTop !== 0) scrollablePanel.scrollTop = 0;
                });
            }
            debouncedRender({
                state: state
            });
        };
        return function() {
            onStateChangeRef.current = undefined;
        };
    });
    runEffect(function() {
        var onResize = (0, $1a895ed241f1e396$export$61fc7d43ac8f84b0)(function() {
            var previousIsDetached = isDetached.value;
            isDetached.value = props.value.core.environment.matchMedia(props.value.renderer.detachedMediaQuery).matches;
            if (previousIsDetached !== isDetached.value) update({});
            else requestAnimationFrame(setPanelPosition);
        }, 20);
        props.value.core.environment.addEventListener('resize', onResize);
        return function() {
            props.value.core.environment.removeEventListener('resize', onResize);
        };
    });
    runEffect(function() {
        if (!isDetached.value) return function() {};
        function toggleModalClassname(isActive) {
            dom.value.detachedContainer.classList.toggle('aa-DetachedContainer--modal', isActive);
        }
        function onChange(event) {
            toggleModalClassname(event.matches);
        }
        var isModalDetachedMql = props.value.core.environment.matchMedia(getComputedStyle(props.value.core.environment.document.documentElement).getPropertyValue('--aa-detached-modal-media-query'));
        toggleModalClassname(isModalDetachedMql.matches);
        // Prior to Safari 14, `MediaQueryList` isn't based on `EventTarget`,
        // so we must use `addListener` and `removeListener` to observe media query lists.
        // See https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener
        var hasModernEventListener = Boolean(isModalDetachedMql.addEventListener);
        hasModernEventListener ? isModalDetachedMql.addEventListener('change', onChange) : isModalDetachedMql.addListener(onChange);
        return function() {
            hasModernEventListener ? isModalDetachedMql.removeEventListener('change', onChange) : isModalDetachedMql.removeListener(onChange);
        };
    });
    runEffect(function() {
        requestAnimationFrame(setPanelPosition);
        return function() {};
    });
    function destroy() {
        $bf5435a78004acf5$var$instancesCount--;
        cleanupEffects();
    }
    function update() {
        var updatedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        cleanupEffects();
        var _props$value$renderer = props.value.renderer, components = _props$value$renderer.components, rendererProps = $bf5435a78004acf5$var$_objectWithoutProperties(_props$value$renderer, $bf5435a78004acf5$var$_excluded);
        optionsRef.current = (0, $5d3b845ebb0da544$export$dd702b3c8240390c)(rendererProps, props.value.core, {
            // We need to filter out default components so they can be replaced with
            // a new `renderer`, without getting rid of user components.
            // @MAJOR Deal with registering components with the same name as the
            // default ones. If we disallow overriding default components, we'd just
            // need to pass all `components` here.
            components: (0, $cb06d79e6789d781$export$b460b275d6c6aa0)(components, function(_ref4) {
                var value = _ref4.value;
                return !value.hasOwnProperty('__autocomplete_componentName');
            }),
            initialState: lastStateRef.current
        }, updatedOptions);
        runReactives();
        runEffects();
        autocomplete.value.refresh().then(function() {
            scheduleRender(lastStateRef.current);
        });
    }
    function setIsModalOpen(value) {
        var prevValue = props.value.core.environment.document.body.contains(dom.value.detachedOverlay);
        if (value === prevValue) return;
        if (value) {
            props.value.core.environment.document.body.appendChild(dom.value.detachedOverlay);
            props.value.core.environment.document.body.classList.add('aa-Detached');
            dom.value.input.focus();
        } else {
            props.value.core.environment.document.body.removeChild(dom.value.detachedOverlay);
            props.value.core.environment.document.body.classList.remove('aa-Detached');
        }
    }
    $bf5435a78004acf5$var$instancesCount++;
    return $bf5435a78004acf5$var$_objectSpread($bf5435a78004acf5$var$_objectSpread({}, autocompleteScopeApi), {}, {
        update: update,
        destroy: destroy
    });
}



var $8tsvq = parcelRequire("8tsvq");



function $e0c13e6ef92c5ffe$export$2f2b9559550c7bbc(props) {
    const containerRef = (0, $8tsvq.useRef)(null);
    const panelRootRef = (0, $8tsvq.useRef)(null);
    const rootRef = (0, $8tsvq.useRef)(null);
    (0, $8tsvq.useEffect)(()=>{
        if (!containerRef.current) return undefined;
        const search = (0, $bf5435a78004acf5$export$485ded5f26ebe08d)({
            container: containerRef.current,
            insights: true,
            renderer: {
                createElement: $8tsvq.createElement,
                Fragment: $8tsvq.Fragment,
                render: ()=>{}
            },
            render ({ children: children, state: state, Fragment: Fragment, components: components, render: render }, root) {
                if (!panelRootRef.current || rootRef.current !== root) {
                    rootRef.current = root;
                    panelRootRef.current?.unmount();
                    panelRootRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($416246511aeb39de$exports))).createRoot(root);
                }
                //panelRootRef.current.render(children);
                const { preview: preview, item: item } = state.context;
                const anchorList = [];
                if (item) {
                    const folder = item.contentType === 'extension' ? '/extensions' : '';
                    for (let [key] of Object.entries(item.fields))anchorList.push({
                        name: (0, $d75ce639c2332d78$export$aebd617640818cda)(key) ? key : key.replace(/([A-Z])/g, ' $1').replace(/^./, (str)=>str.toUpperCase()),
                        slug: `${folder}/${item.fields.slug}`,
                        id: key
                    });
                }
                panelRootRef.current.render(/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)(Fragment, {
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        className: "aa-Grid",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                className: "aa-Results aa-Column",
                                children: children
                            }),
                            preview && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "aa-Preview aa-Column aa-Panel--scrollable",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                                        className: "aa-PreviewTags text-center",
                                        children: preview.tags && preview.tags.map((tag, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                                className: "aa-PreviewTags__item",
                                                children: tag.name.value
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        className: "aa-PreviewTitle text-center",
                                        children: preview.breadcrumbs && preview.breadcrumbs[0]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "aa-PreviewDescription",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "aa-PreviewDescription__content",
                                                children: preview.anchor && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)(components.Highlight, {
                                                    hit: preview,
                                                    attribute: "name"
                                                })
                                            }),
                                            anchorList.length && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $37b4dc016acd2660$export$2e2bcd8739ae039), {
                                                data: anchorList
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }));
            },
            ...props
        });
        return ()=>{
            search.destroy();
        };
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        ref: containerRef
    });
}



const $0a3e4bcbebcd04fe$var$searchClient = (0, (/*@__PURE__*/$parcel$interopDefault($9c645d8fd2e53e04$exports)))("BH8WB0BG5F", "56b11de3c2cabb17aace7ee6207e4e3e");
const $0a3e4bcbebcd04fe$var$Search = ({ notModal: notModal })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $e0c13e6ef92c5ffe$export$2f2b9559550c7bbc), {
        openOnFocus: true,
        detachedMediaQuery: notModal ? undefined : '',
        insights: true,
        getSources: ()=>[
                {
                    sourceId: 'hits',
                    getItems ({ query: query }) {
                        if (query && query.length > 1) return (0, $7130cceb9be2fc23$export$d82b34328f310205)({
                            searchClient: $0a3e4bcbebcd04fe$var$searchClient,
                            queries: [
                                {
                                    indexName: "products",
                                    query: query,
                                    params: {
                                        hitsPerPage: 1000
                                    }
                                }
                            ]
                        });
                        else return [];
                    },
                    onActive ({ item: item, setContext: setContext }) {
                        const matchContainer = document.querySelector('.aa-PreviewDescription__content');
                        const matchContainerClone = document.querySelector('.PreviewDescription__content--Clone');
                        if (matchContainer) {
                            if (matchContainerClone) matchContainerClone.remove();
                            matchContainer.style.display = '-webkit-box';
                        }
                        const hits = (0, $d75ce639c2332d78$export$eac196a2107442)(item);
                        setContext({
                            preview: hits[0],
                            item: item
                        });
                    },
                    getItemInputValue ({ state: state }) {
                        if (state.query.length < 2 && state.activeItemId === null) state.context.preview = undefined;
                    // TODO doesn't work when search on product
                    },
                    templates: {
                        item ({ item: item, components: components }) {
                            const hits = (0, $d75ce639c2332d78$export$eac196a2107442)(item);
                            const onExtraHitOver = (hit)=>{
                                const matchContainer = document.querySelector('.aa-PreviewDescription__content');
                                if (matchContainer) {
                                    const matchContainerParent = matchContainer.parentNode;
                                    const cloneEl = matchContainerParent.querySelector('.PreviewDescription__content--Clone');
                                    if (cloneEl) cloneEl.innerHTML = hit.name.value.replace(/__aa-highlight__/g, '<mark>').replace(/__\/aa-highlight__/g, '</mark>');
                                    else {
                                        const matchContainerClone = matchContainer.cloneNode(true);
                                        matchContainerClone.className = 'PreviewDescription__content--Clone';
                                        matchContainerClone.innerHTML = hit.name.value.replace(/__aa-highlight__/g, '<mark>').replace(/__\/aa-highlight__/g, '</mark>');
                                        matchContainer.style.display = 'none';
                                        matchContainerParent.insertBefore(matchContainerClone, matchContainerParent.firstChild);
                                    }
                                }
                            };
                            hits.sort((a, b)=>{
                                const firstMatch = a.name.matchLevel === 'full' ? 0 : 1;
                                const secondMatch = b.name.matchLevel === 'full' ? 0 : 1;
                                if (firstMatch < secondMatch) return -1;
                                if (firstMatch > secondMatch) return 1;
                                return 0;
                            });
                            // maybe sort tags to be on top or make them stand out
                            const folder = item.contentType === 'extension' ? '/extensions/' : '/';
                            return hits.map((hit, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                    className: "aa-ItemLink",
                                    href: folder + item.fields.slug + (hit.anchor ? `#${hit.anchor}` : ''),
                                    onMouseEnter: hits.length > 1 ? ()=>onExtraHitOver(hit) : undefined,
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        className: "aa-ItemContent",
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                            className: "aa-ItemContentBody",
                                            children: [
                                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                    className: "aa-ItemContentTitle",
                                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)(components.Highlight, {
                                                        hit: hit,
                                                        attribute: "name"
                                                    })
                                                }),
                                                hit.breadcrumbs && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                    className: "breadcrumbs",
                                                    children: hit.breadcrumbs.join(' > ')
                                                })
                                            ]
                                        })
                                    })
                                }, hit._highlightResult.name.value + i));
                        }
                    }
                }
            ]
    });
};
var $0a3e4bcbebcd04fe$export$2e2bcd8739ae039 = $0a3e4bcbebcd04fe$var$Search;





var $8tsvq = parcelRequire("8tsvq");





const $cff44cc77ed43474$var$renderOptions = {
    renderNode: {
        [(0, $dad3209a3a2cdfa7$export$4473561af957c5c7).EMBEDDED_ASSET]: (node)=>{
            const fields = node.data.target.fields;
            if (!fields) return null;
            const { url: url, title: title, description: description } = fields.file;
            return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "embedded-asset",
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                        src: url,
                        alt: description || title
                    }),
                    description && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: description
                    })
                ]
            });
        }
    }
};
const $cff44cc77ed43474$var$News = ({ data: data })=>{
    if (!data) return;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        id: (0, $d75ce639c2332d78$export$161d051f5dd25de7)(data.title),
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h4", {
                className: "content_h4",
                children: data.title
            }),
            data.content ? (0, $96d12809385be3c5$export$4a295a2b4ab66da6)(data.content, $cff44cc77ed43474$var$renderOptions) : null
        ]
    });
};
var $cff44cc77ed43474$export$2e2bcd8739ae039 = $cff44cc77ed43474$var$News;



const $d7a785ed407be6de$var$NewsItem = ({ item: item, activeAnchor: activeAnchor })=>{
    const [isOpen, setOpen] = (0, $8tsvq.useState)(false);
    const headerRef = (0, $8tsvq.useRef)(null);
    const onHeaderClick = ()=>{
        if (headerRef && !isOpen) setTimeout(()=>{
            headerRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }, 80);
        setOpen(!isOpen);
    };
    (0, $8tsvq.useEffect)(()=>{
        if (item.fields.contentBlock) {
            const dict = [];
            item.fields.contentBlock.forEach((block)=>{
                dict.push((0, $d75ce639c2332d78$export$161d051f5dd25de7)(block.fields.title));
                setNestedItems(dict);
            });
        }
    }, []);
    const [nestedItems, setNestedItems] = (0, $8tsvq.useState)([]);
    (0, $8tsvq.useEffect)(()=>{
        if (activeAnchor === (0, $d75ce639c2332d78$export$161d051f5dd25de7)(item.fields.title)) setOpen(true);
        if (nestedItems.includes(activeAnchor)) setOpen(true);
    }, [
        activeAnchor
    ]);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
        className: "news-item block-style",
        id: (0, $d75ce639c2332d78$export$161d051f5dd25de7)(item.fields.title),
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("button", {
                className: "news-item__header",
                ref: headerRef,
                onClick: onHeaderClick,
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                        className: "news-item__icon",
                        children: isOpen ? '-' : '+'
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        className: "content_h3",
                        style: {
                            marginTop: 0
                        },
                        children: item.fields.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: `news-item__content ${isOpen ? 'open' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $2bb2818d562d5134$export$2e2bcd8739ae039), {
                        date: (0, $d75ce639c2332d78$export$b5336631ae1d96d0)(item.sys.updatedAt)
                    }),
                    item.fields.contentBlock && item.fields.contentBlock.map((block, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $cff44cc77ed43474$export$2e2bcd8739ae039), {
                            data: block.fields
                        }, i))
                ]
            })
        ]
    });
};
var $d7a785ed407be6de$export$2e2bcd8739ae039 = $d7a785ed407be6de$var$NewsItem;




const $dabf7dcafd6394ea$var$Homepage = ()=>{
    const [data, setData] = (0, $8tsvq.useState)();
    const [anchorData, setAnchorData] = (0, $8tsvq.useState)([]);
    const [activeAnchor, setActiveAnchor] = (0, $8tsvq.useState)('');
    const fetcher = async ()=>{
        try {
            const entryItems = await (0, $c3c8ef5796d3b74c$export$388e0302ca0d9a41).getEntries({
                content_type: 'news',
                include: 1,
                limit: 20
            });
            const modules = {
                content: []
            };
            entryItems.items.forEach((item)=>{
                const name = item.fields.title;
                const subSections = [];
                item.fields.contentBlock.forEach((subItem)=>{
                    if (subItem.fields) subSections.push({
                        name: subItem.fields.title,
                        id: (0, $d75ce639c2332d78$export$161d051f5dd25de7)(subItem.fields.title)
                    });
                });
                modules.content.push({
                    name: name,
                    id: (0, $d75ce639c2332d78$export$161d051f5dd25de7)(name),
                    subSections: subSections
                });
            });
            setAnchorData(modules.content);
            setData(entryItems.items);
        } catch (err) {
            console.log(err);
        }
    };
    (0, $8tsvq.useEffect)(()=>{
        fetcher();
    }, []);
    (0, $8tsvq.useEffect)(()=>{
        if (data) {
            const observerOptions = {
                rootMargin: '50px 0px 50px 0px',
                threshold: [
                    0.7
                ]
            };
            const observer = new IntersectionObserver(observerCallback, observerOptions);
            function observerCallback(entries) {
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) {
                        if (window.scrollY !== 0) setActiveAnchor(entry.target.id);
                    }
                });
            }
            setTimeout(()=>{
                const collection = document.querySelectorAll('article');
                collection.forEach((i)=>{
                    if (i) observer.observe(i);
                });
            }, 1000);
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "homepage",
        style: {
            width: '70%'
        },
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $e3a182d6791d5fe4$export$2e2bcd8739ae039), {
                id: "2"
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                id: "search-widget",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $0a3e4bcbebcd04fe$export$2e2bcd8739ae039), {
                    notModal: true
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "homepage-content",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                                className: "content_h2",
                                children: "News"
                            }),
                            data && data.map((item, i)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d7a785ed407be6de$export$2e2bcd8739ae039), {
                                    activeAnchor: activeAnchor,
                                    item: item
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $37b4dc016acd2660$export$2e2bcd8739ae039), {
                        data: anchorData,
                        activeAnchor: activeAnchor,
                        setActiveAnchor: setActiveAnchor
                    })
                ]
            })
        ]
    });
};
var $dabf7dcafd6394ea$export$2e2bcd8739ae039 = $dabf7dcafd6394ea$var$Homepage;







parcelRequire("8tsvq");

const $54d97af44a291029$var$LogoutButton = (props)=>{
    const { logout: logout } = (0, $a60a332f9bf049ee$export$f2b63d3ca66bb884)();
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
        ...props,
        onClick: ()=>logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            }),
        children: "Log Out"
    });
};
var $54d97af44a291029$export$2e2bcd8739ae039 = $54d97af44a291029$var$LogoutButton;


const $9fea6016d1af3f92$var$getMainMenu = ()=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                className: "header_link",
                to: "/",
                children: "Home"
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                className: "header_link",
                to: "/recent-activity",
                children: "Recent Activity"
            })
        ]
    });
};
const $9fea6016d1af3f92$var$BaseLayout = ({ children: children, hasHeader: hasHeader = true })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "main-content",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("header", {
                className: "header",
                children: [
                    hasHeader ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        className: "header_content",
                        children: [
                            $9fea6016d1af3f92$var$getMainMenu(),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                className: "header_search_wrap",
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $0a3e4bcbebcd04fe$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "header_content",
                        children: $9fea6016d1af3f92$var$getMainMenu()
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $54d97af44a291029$export$2e2bcd8739ae039), {
                        className: "header_link header_link_last"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("main", {
                className: "main",
                children: children
            })
        ]
    });
};
var $9fea6016d1af3f92$export$2e2bcd8739ae039 = $9fea6016d1af3f92$var$BaseLayout;





var $8tsvq = parcelRequire("8tsvq");


const $b893d6518915e0ec$var$SPACE_ID = "9nha52v3tfhf";
// Strip leading "Test " prefix from content type names
const $b893d6518915e0ec$var$formatContentTypeName = (name)=>name.replace(/^Test\s+/, '');
const $b893d6518915e0ec$var$formatRelativeTime = (timestamp)=>{
    const now = new Date();
    const updatedDate = new Date(timestamp);
    const diffMs = now - updatedDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    return updatedDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: now.getFullYear() !== updatedDate.getFullYear() ? 'numeric' : undefined
    });
};
// Try a range of common name fields; return trimmed string or null
const $b893d6518915e0ec$var$getEntryName = (fields)=>{
    if (!fields) return null;
    const raw = fields.name || fields.internalName || fields.title || fields.headline || fields.label || null;
    if (!raw) return null;
    const str = typeof raw === 'object' ? Object.values(raw)[0] : String(raw);
    return str.trim() || null;
};
const $b893d6518915e0ec$var$RecentActivityPage = ()=>{
    const [entries, setEntries] = (0, $8tsvq.useState)([]);
    const [loading, setLoading] = (0, $8tsvq.useState)(true);
    const [error, setError] = (0, $8tsvq.useState)(null);
    // Content type filter
    const [contentTypes, setContentTypes] = (0, $8tsvq.useState)([]);
    const [ctMap, setCtMap] = (0, $8tsvq.useState)({}) // { id -> raw name }
    ;
    const [ctDisplayField, setCtDisplayField] = (0, $8tsvq.useState)({}) // { id -> displayField }
    ;
    const [selectedContentType, setSelectedContentType] = (0, $8tsvq.useState)('all');
    const [searchTerm, setSearchTerm] = (0, $8tsvq.useState)('');
    const [dropdownOpen, setDropdownOpen] = (0, $8tsvq.useState)(false);
    // Date range filter
    const [startDate, setStartDate] = (0, $8tsvq.useState)('');
    const [endDate, setEndDate] = (0, $8tsvq.useState)('');
    // Pagination
    const [total, setTotal] = (0, $8tsvq.useState)(0);
    const [loadingMore, setLoadingMore] = (0, $8tsvq.useState)(false);
    (0, $8tsvq.useEffect)(()=>{
        const loadContentTypes = async ()=>{
            try {
                const result = await (0, $c3c8ef5796d3b74c$export$388e0302ca0d9a41).getContentTypes({
                    limit: 100,
                    order: 'name'
                });
                const map = {};
                const dfMap = {};
                const types = result.items.map((ct)=>{
                    map[ct.sys.id] = ct.name;
                    dfMap[ct.sys.id] = ct.displayField;
                    return {
                        id: ct.sys.id,
                        displayName: $b893d6518915e0ec$var$formatContentTypeName(ct.name)
                    };
                });
                setCtMap(map);
                setCtDisplayField(dfMap);
                setContentTypes([
                    {
                        id: 'all',
                        displayName: 'All Content Types'
                    },
                    ...types
                ]);
            } catch (err) {
                console.error('Error loading content types:', err);
            }
        };
        loadContentTypes();
    }, []);
    const fetchEntries = (0, $8tsvq.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const params = {
                order: '-sys.updatedAt',
                limit: 40
            };
            if (selectedContentType !== 'all') params.content_type = selectedContentType;
            if (startDate) params['sys.updatedAt[gte]'] = startDate + 'T00:00:00.000Z';
            if (endDate) params['sys.updatedAt[lte]'] = endDate + 'T23:59:59.999Z';
            const result = await (0, $c3c8ef5796d3b74c$export$388e0302ca0d9a41).getEntries(params);
            setTotal(result.total);
            const mapped = result.items.filter((entry)=>{
                const ctId = entry.sys.contentType.sys.id;
                const df = ctDisplayField[ctId];
                const name = df && entry.fields[df] ? String(entry.fields[df]).trim() : $b893d6518915e0ec$var$getEntryName(entry.fields);
                return name !== null && name !== '';
            }).map((entry)=>{
                const ctId = entry.sys.contentType.sys.id;
                const df = ctDisplayField[ctId];
                const name = df && entry.fields[df] ? String(entry.fields[df]).trim() : $b893d6518915e0ec$var$getEntryName(entry.fields);
                return {
                    id: entry.sys.id,
                    name: name,
                    contentTypeId: ctId,
                    updatedAt: entry.sys.updatedAt,
                    comparisonUrl: `https://app.contentful.com/spaces/${$b893d6518915e0ec$var$SPACE_ID}/entries/${entry.sys.id}/compare/`
                };
            });
            setEntries(mapped);
        } catch (err) {
            console.error('Error fetching entries:', err);
            setError(err.message);
        } finally{
            setLoading(false);
        }
    }, [
        selectedContentType,
        startDate,
        endDate,
        ctDisplayField
    ]);
    const loadMore = (0, $8tsvq.useCallback)(async ()=>{
        setLoadingMore(true);
        try {
            const params = {
                order: '-sys.updatedAt',
                limit: 40,
                skip: entries.length
            };
            if (selectedContentType !== 'all') params.content_type = selectedContentType;
            if (startDate) params['sys.updatedAt[gte]'] = startDate + 'T00:00:00.000Z';
            if (endDate) params['sys.updatedAt[lte]'] = endDate + 'T23:59:59.999Z';
            const result = await (0, $c3c8ef5796d3b74c$export$388e0302ca0d9a41).getEntries(params);
            setTotal(result.total);
            const mapped = result.items.filter((entry)=>{
                const ctId = entry.sys.contentType.sys.id;
                const df = ctDisplayField[ctId];
                const name = df && entry.fields[df] ? String(entry.fields[df]).trim() : $b893d6518915e0ec$var$getEntryName(entry.fields);
                return name !== null && name !== '';
            }).map((entry)=>{
                const ctId = entry.sys.contentType.sys.id;
                const df = ctDisplayField[ctId];
                const name = df && entry.fields[df] ? String(entry.fields[df]).trim() : $b893d6518915e0ec$var$getEntryName(entry.fields);
                return {
                    id: entry.sys.id,
                    name: name,
                    contentTypeId: ctId,
                    updatedAt: entry.sys.updatedAt,
                    comparisonUrl: `https://app.contentful.com/spaces/${$b893d6518915e0ec$var$SPACE_ID}/entries/${entry.sys.id}/compare/`
                };
            });
            setEntries((prev)=>[
                    ...prev,
                    ...mapped
                ]);
        } catch (err) {
            console.error('Error loading more entries:', err);
        } finally{
            setLoadingMore(false);
        }
    }, [
        selectedContentType,
        startDate,
        endDate,
        ctDisplayField,
        entries.length
    ]);
    (0, $8tsvq.useEffect)(()=>{
        fetchEntries();
        const interval = setInterval(fetchEntries, 300000);
        return ()=>clearInterval(interval);
    }, [
        fetchEntries
    ]);
    // Close dropdown on outside click
    (0, $8tsvq.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            if (dropdownOpen && !e.target.closest('.custom-select')) {
                setDropdownOpen(false);
                setSearchTerm('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, [
        dropdownOpen
    ]);
    const filteredContentTypes = contentTypes.filter((ct)=>ct.displayName.toLowerCase().includes(searchTerm.toLowerCase()));
    const handleContentTypeSelect = (typeId)=>{
        setSelectedContentType(typeId);
        setDropdownOpen(false);
        setSearchTerm('');
    };
    const clearDateFilter = ()=>{
        setStartDate('');
        setEndDate('');
    };
    const hasDateFilter = startDate || endDate;
    const today = new Date().toISOString().split('T')[0];
    const selectedTypeName = contentTypes.find((ct)=>ct.id === selectedContentType)?.displayName || 'All Content Types';
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("section", {
        className: "ra-page",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "ra-header",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        className: "content_h2",
                        style: {
                            margin: 0
                        },
                        children: "Recent Activity"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                        onClick: fetchEntries,
                        className: "ra-refresh",
                        title: "Refresh",
                        disabled: loading,
                        children: "\u21BB"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "ra-filters",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        className: "ra-filter-group",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("label", {
                                className: "ra-filter-label",
                                children: "Content Type"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "date-input-group",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("label", {
                                        className: "date-sub-label",
                                        children: "Select"
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "custom-select",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                                className: "select-trigger",
                                                onClick: ()=>setDropdownOpen(!dropdownOpen),
                                                role: "button",
                                                tabIndex: 0,
                                                children: [
                                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                        children: selectedTypeName
                                                    }),
                                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                        className: "select-arrow",
                                                        children: dropdownOpen ? "\u25B2" : "\u25BC"
                                                    })
                                                ]
                                            }),
                                            dropdownOpen && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                                className: "select-dropdown",
                                                children: [
                                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("input", {
                                                        type: "text",
                                                        className: "search-input",
                                                        placeholder: "Search\u2026",
                                                        value: searchTerm,
                                                        onChange: (e)=>setSearchTerm(e.target.value),
                                                        autoFocus: true
                                                    }),
                                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                        className: "options-list",
                                                        children: filteredContentTypes.length === 0 ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                            className: "no-results",
                                                            children: "No content types found"
                                                        }) : filteredContentTypes.map((ct)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                                                className: `option-item ${ct.id === selectedContentType ? 'selected' : ''}`,
                                                                onClick: ()=>handleContentTypeSelect(ct.id),
                                                                children: [
                                                                    ct.displayName,
                                                                    ct.id === selectedContentType && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                                        className: "checkmark",
                                                                        children: "\u2713"
                                                                    })
                                                                ]
                                                            }, ct.id))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        className: "ra-filter-group",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("label", {
                                className: "ra-filter-label",
                                children: "Date Range"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "date-range",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "date-input-group",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("label", {
                                                className: "date-sub-label",
                                                children: "From"
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("input", {
                                                type: "date",
                                                className: "date-input",
                                                value: startDate,
                                                onChange: (e)=>setStartDate(e.target.value),
                                                onClick: (e)=>e.target.showPicker?.(),
                                                max: endDate ? Math.min(endDate, today) : today
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "date-input-group",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("label", {
                                                className: "date-sub-label",
                                                children: "To"
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("input", {
                                                type: "date",
                                                className: "date-input",
                                                value: endDate,
                                                onChange: (e)=>setEndDate(e.target.value),
                                                onClick: (e)=>e.target.showPicker?.(),
                                                min: startDate || undefined,
                                                max: today
                                            })
                                        ]
                                    }),
                                    hasDateFilter && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                                        className: "clear-date",
                                        onClick: clearDateFilter,
                                        title: "Clear date filter",
                                        children: "\u2715"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            loading && entries.length === 0 ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "ra-loading",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $6e6b089c3d63766c$export$7f7cbe89f1eacd2), {
                    size: "medium"
                })
            }) : error ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                className: "ra-error",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "Unable to load recent activity"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                        onClick: fetchEntries,
                        className: "ra-retry",
                        children: "Retry"
                    })
                ]
            }) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "entries-list",
                        children: entries.length === 0 ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            className: "no-entries",
                            children: "No recent activity"
                        }) : entries.map((entry)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                                title: "Click to view changes in Contentful",
                                href: entry.comparisonUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "entry-item",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "entry-content",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "entry-type-badge",
                                                children: $b893d6518915e0ec$var$formatContentTypeName(ctMap[entry.contentTypeId] || entry.contentTypeId)
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "entry-name",
                                                title: entry.name,
                                                children: entry.name
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "entry-time",
                                                children: $b893d6518915e0ec$var$formatRelativeTime(entry.updatedAt)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        className: "entry-arrow",
                                        children: "\u2192"
                                    })
                                ]
                            }, entry.id))
                    }),
                    entries.length < total && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                        className: "load-more",
                        onClick: loadMore,
                        disabled: loadingMore,
                        children: loadingMore ? "Loading\u2026" : "\u21BB Load more"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("style", {
                children: `
        .ra-page {
            flex-grow: 1;
        }
        .ra-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
        }

        .ra-title {
          margin: 0;
          font-size: 22px;
          font-weight: 700;
          color: #1f2937;
        }

        .ra-refresh {
          background: none;
          border: 1px solid #d1d5db;
          font-size: 20px;
          cursor: pointer;
          color: #6b7280;
          padding: 4px 10px;
          border-radius: 6px;
          transition: all 0.2s;
        }

        .ra-refresh:hover:not(:disabled) {
          background: #f3f4f6;
          color: #1f2937;
          border-color: #9ca3af;
        }

        .ra-refresh:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .ra-filters {
          display: flex;
          align-items: center;
          gap: 24px;
          flex-wrap: wrap;
          margin-bottom: 24px;
          padding: 16px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
        }

        .ra-filter-group {
          flex: 1;
          min-width: 200px;
        }

        .ra-filter-label {
          display: block;
          font-size: 12px;
          font-weight: 600;
          color: #6b7280;
          margin-bottom: 6px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* \u{2500}\u{2500} Dropdown \u{2500}\u{2500} */
        .custom-select {
          position: relative;
        }

        .select-trigger {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 12px;
          background: white;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          color: #1f2937;
          transition: all 0.2s;
          user-select: none;
        }

        .select-trigger:hover {
          border-color: #3b82f6;
        }

        .select-arrow {
          font-size: 10px;
          color: #6b7280;
          margin-left: 8px;
          flex-shrink: 0;
        }

        .select-dropdown {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          right: 0;
          background: white;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          z-index: 100;
          max-height: 300px;
          display: flex;
          flex-direction: column;
        }

        .search-input {
          padding: 10px 12px;
          border: none;
          border-bottom: 1px solid #e5e7eb;
          font-size: 14px;
          outline: none;
          border-radius: 6px 6px 0 0;
        }

        .options-list {
          overflow-y: auto;
          max-height: 240px;
        }

        .options-list::-webkit-scrollbar { width: 6px; }
        .options-list::-webkit-scrollbar-track { background: transparent; }
        .options-list::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }

        .option-item {
          padding: 10px 12px;
          cursor: pointer;
          font-size: 14px;
          color: #1f2937;
          transition: background 0.15s;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .option-item:hover { background: #f3f4f6; }
        .option-item.selected { background: #eff6ff; color: #3b82f6; font-weight: 500; }
        .checkmark { color: #3b82f6; font-weight: bold; }

        .no-results {
          padding: 16px 12px;
          text-align: center;
          color: #6b7280;
          font-size: 14px;
        }

        /* \u{2500}\u{2500} Date range \u{2500}\u{2500} */
        .date-range {
          display: flex;
          gap: 8px;
          align-items: flex-end;
        }

        .date-input-group {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .date-sub-label {
          font-size: 11px;
          font-weight: 500;
          color: #6b7280;
        }

        .date-input {
          padding: 10px 10px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 14px;
          color: #1f2937;
          transition: all 0.2s;
          font-family: inherit;
          background: white;
        }

        .date-input:hover { border-color: #3b82f6; }
        .date-input:focus { outline: none; border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }

        .clear-date {
          background: #ef4444;
          color: white;
          border: none;
          padding: 0 12px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          height: 40px;
          transition: background 0.2s;
        }

        .clear-date:hover { background: #dc2626; }

        /* \u{2500}\u{2500} States \u{2500}\u{2500} */
        .ra-loading,
        .ra-error {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px 16px;
          color: #6b7280;
        }

        .ra-error p { margin: 0 0 12px; font-size: 14px; }

        .ra-retry {
          background: #3b82f6;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 14px;
        }

        .ra-retry:hover { background: #2563eb; }

        /* \u{2500}\u{2500} Load more \u{2500}\u{2500} */
        .load-more {
          display: block;
          padding: 10px 16px;
          background: white;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          color: #3b82f6;
          cursor: pointer;
          transition: all 0.2s;
          font-size: 16px;
          margin: 0 auto 24px;
          text-transform: uppercase;
          font-weight: 700;
          border-color: currentColor;
        }

        .load-more:hover:not(:disabled) {
          background: #eff6ff;
          border-color: #3b82f6;
        }

        .load-more:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* \u{2500}\u{2500} Entries \u{2500}\u{2500} */
        .entries-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-bottom: 24px;
        }

        .entries-list::-webkit-scrollbar { width: 6px; }
        .entries-list::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }

        .no-entries {
          text-align: center;
          color: #6b7280;
          padding: 48px 16px;
          margin: 0;
          font-size: 14px;
        }

        .entry-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 16px;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          text-decoration: none;
          color: inherit;
          transition: all 0.2s;
        }

        .entry-item:hover {
          background: #f9fafb;
          border-color: #3b82f6;
          transform: translateX(2px);
          box-shadow: 0 2px 8px rgba(59,130,246,.08);
        }

        .entry-content { flex: 1; min-width: 0; }

        .entry-type-badge {
          display: inline-block;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          color: #3b82f6;
          background: #eff6ff;
          padding: 2px 8px;
          border-radius: 4px;
          margin-bottom: 4px;
          letter-spacing: 0.5px;
        }

        .entry-name {
          font-size: 14px;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .entry-time { font-size: 12px; color: #6b7280; }

        .entry-arrow {
          font-size: 18px;
          color: #9ca3af;
          margin-left: 12px;
          transition: transform 0.2s;
        }

        .entry-item:hover .entry-arrow {
          transform: translateX(4px);
          color: #3b82f6;
        }
      `
            })
        ]
    });
};
var $b893d6518915e0ec$export$2e2bcd8739ae039 = $b893d6518915e0ec$var$RecentActivityPage;


const $c3c8ef5796d3b74c$export$388e0302ca0d9a41 = (0, $27e65424bfb9f508$export$5d730b7aed1a3eb0)({
    space: "9nha52v3tfhf",
    accessToken: "dEiapauyqtxK03doPj3sxuaQgX1cuGfU3-ZFuZ2P6Qo",
    environment: document.location.hostname.startsWith('dev') ? 'development' : 'master'
});
const $c3c8ef5796d3b74c$var$AccordionModule = ({ data: data, open: open })=>{
    return data.map((el, i1)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $98476e90da6dd9c8$export$2e2bcd8739ae039), {
            name: el.name,
            open: open,
            children: el.content && el.content.map((el, i2)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $98476e90da6dd9c8$export$2e2bcd8739ae039), {
                    name: el.name,
                    slug: el.slug
                }, i1 + i2))
        }, i1));
};
const $c3c8ef5796d3b74c$var$AuthRedirectHandler = ()=>{
    const navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    const { isAuthenticated: isAuthenticated, isLoading: isLoading } = (0, $a60a332f9bf049ee$export$f2b63d3ca66bb884)();
    (0, $8tsvq.useEffect)(()=>{
        if (isAuthenticated && !isLoading) {
            const preAuthPath = localStorage.getItem('pre_auth_path');
            if (preAuthPath && preAuthPath !== '/') {
                localStorage.removeItem('pre_auth_path');
                navigate(preAuthPath);
            }
        }
    }, [
        isAuthenticated,
        isLoading,
        navigate
    ]);
    return null;
};
function $c3c8ef5796d3b74c$var$App() {
    const [data, setData] = (0, $8tsvq.useState)();
    const { isAuthenticated: isAuthenticated, isLoading: isLoading } = (0, $a60a332f9bf049ee$export$f2b63d3ca66bb884)();
    const fetcher = async ()=>{
        let data = [];
        try {
            const codeItems = await $c3c8ef5796d3b74c$export$388e0302ca0d9a41.getEntries({
                content_type: 'productCode',
                order: 'fields.code',
                limit: 250
            });
            for (const code of codeItems.items)if (code.fields) {
                data.push({
                    name: code.fields.code,
                    content: []
                });
                for (const product of code.fields.product)if (product.fields) {
                    const dataItem = data.find((d)=>d.name === code.fields.code);
                    dataItem.content.push(product.fields);
                }
            }
        } catch (err) {
            console.log(err);
        }
        setData(data);
    };
    (0, $8tsvq.useEffect)(()=>{
        if (isAuthenticated) fetcher();
    }, [
        isAuthenticated
    ]);
    const [allOpen, selAllOpen] = (0, $8tsvq.useState)(false);
    const [sidebarOpen, selSidebarOpen] = (0, $8tsvq.useState)(true);
    if (isLoading) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        className: "loading",
        children: "Loading ..."
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $63c245eaedba316b$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($c3c8ef5796d3b74c$var$AuthRedirectHandler, {}),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: isAuthenticated ? 'main-block' : '',
                children: isAuthenticated ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("aside", {
                            className: `sidebar ${sidebarOpen ? 'open' : ''}`,
                            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "sidebar_content",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $e3a182d6791d5fe4$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "accordion-module",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("button", {
                                                className: "accordion-expand",
                                                onClick: ()=>selAllOpen(!allOpen),
                                                children: [
                                                    !allOpen ? 'Expand' : 'Close',
                                                    " all"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
                                                fallbackMessage: "Unable to load navigation menu.",
                                                children: data ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($c3c8ef5796d3b74c$var$AccordionModule, {
                                                    open: allOpen,
                                                    data: data
                                                }, allOpen) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $6e6b089c3d63766c$export$7f7cbe89f1eacd2), {
                                                    size: "large"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                                        className: "sidebar_control",
                                        onClick: ()=>selSidebarOpen(!sidebarOpen),
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("svg", {
                                            width: "24",
                                            height: "16",
                                            viewBox: "0 0 24 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                                    d: "M16.6308 0L14.7884 1.99654L20.3156 7.98615L14.7884 13.9758L16.6308 15.9723L24.0004 7.98615L16.6308 0Z",
                                                    fill: "white"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                                    d: "M0 0H12.182V2.82353H0V0Z",
                                                    fill: "white"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                                    d: "M0 6.58824H15.0748V9.41176H0V6.58824Z",
                                                    fill: "white"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                                    d: "M0 13.1765H12.182V16H0V13.1765Z",
                                                    fill: "white"
                                                }),
                                                " "
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $5bc57f835864eb51$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                    path: "/",
                                    element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9fea6016d1af3f92$export$2e2bcd8739ae039), {
                                        hasHeader: false,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $dabf7dcafd6394ea$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                    path: "/:id",
                                    element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9fea6016d1af3f92$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $968a5e4f5bfad90a$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                    path: "/extensions",
                                    element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$444b3ab0cb9aec40), {
                                        to: "/"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                    path: "/extensions/:extensionId",
                                    element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9fea6016d1af3f92$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $968a5e4f5bfad90a$export$2e2bcd8739ae039), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                    path: "/recent-activity",
                                    element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $9fea6016d1af3f92$export$2e2bcd8739ae039), {
                                        hasHeader: false,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $b893d6518915e0ec$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: "login-wrapper",
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                        className: "login-block",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                className: "login-header text-center",
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("svg", {
                                    className: "logo",
                                    role: "img",
                                    "aria-label": "Lindblad Expeditions logo with Eye symbol and National Geographic logo with Yellow Border symbol",
                                    viewBox: "0 0 1826 307",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("title", {
                                            children: "Lindblad"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M912.988 306.997H1826V0.00317383H912.988V306.997Z",
                                            fill: "#0A0B09"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1048.85 218.837H1133.32V81.7547H1048.85V218.837ZM1031.73 236.112H1150.5V64.47H1031.73V236.112Z",
                                            fill: "#F9C822"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1229.39 141.469H1222.03C1212.38 127.731 1202.82 114.076 1193.26 98.6174H1193.17V141.469H1185.06V81.7228H1192.42C1202.06 95.3779 1211.62 108.947 1221.1 124.313H1221.27V81.7228H1229.39V141.469Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1252.58 81.7228L1232.1 141.469H1240.9L1246.06 125.173H1263.92L1268.57 141.469H1279.91L1261.03 81.7228H1252.58ZM1248.68 117.827C1251.05 109.976 1253.42 102.717 1255.54 93.4975H1255.71C1258.08 102.717 1260.19 109.976 1262.39 117.827H1248.68Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1289.46 141.469V89.7464H1273.9V81.7228H1315.19V89.7464H1299.61V141.469H1289.46Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1318.49 141.469H1328.56V81.7228H1318.49V141.469Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1359.87 142.496C1375.35 142.496 1385 128.585 1385 110.744C1385 94.0123 1374.33 80.6962 1359.87 80.6962C1345.39 80.6962 1334.73 94.0123 1334.73 110.744C1334.73 128.585 1344.38 142.496 1359.87 142.496ZM1359.87 133.957C1349.29 133.957 1345.56 122.18 1345.56 110.744C1345.56 99.7334 1349.79 89.2314 1359.87 89.2314C1369.93 89.2314 1374.16 99.7334 1374.16 110.744C1374.16 122.18 1370.44 133.957 1359.87 133.957Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1435.51 141.469H1428.15C1418.5 127.731 1408.94 114.076 1399.38 98.6174H1399.29V141.469H1391.17V81.7228H1398.53C1408.17 95.3779 1417.73 108.947 1427.22 124.313H1427.38V81.7228H1435.51V141.469Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1458.7 81.7228L1438.21 141.469H1447.02L1452.17 125.173H1470.02L1474.69 141.469H1486.02L1467.15 81.7228H1458.7ZM1454.8 117.827C1457.17 109.976 1459.54 102.717 1461.65 93.4975H1461.81C1464.19 102.717 1466.31 109.976 1468.51 117.827H1454.8Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1488.98 81.7228H1499.05V133.449H1519.1V141.469H1488.98V81.7228Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1223.14 191.456V216.122C1217.72 218.255 1212.06 219.793 1206.3 219.793C1188.87 219.793 1177.88 206.141 1177.88 188.552C1177.88 172.246 1188.87 158 1206.64 158C1212.14 158 1217.64 160.046 1221.02 162.605L1217.72 169.691C1215.02 167.98 1210.79 166.528 1206.9 166.528C1196.07 166.528 1188.7 175.153 1188.7 188.725C1188.7 202.892 1197.17 211.261 1205.88 211.261C1208.59 211.261 1210.88 210.919 1212.99 209.806V191.456H1223.14Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1259.44 167.043H1242.52V183.429H1259.1V191.456H1242.52V210.746H1262.49V218.769H1232.36V159.02H1259.44V167.043Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1290.75 219.793C1306.23 219.793 1315.88 205.879 1315.88 188.044C1315.88 171.312 1305.22 158 1290.75 158C1276.28 158 1265.62 171.312 1265.62 188.044C1265.62 205.879 1275.27 219.793 1290.75 219.793ZM1290.75 211.261C1280.17 211.261 1276.45 199.473 1276.45 188.044C1276.45 177.033 1280.68 166.528 1290.75 166.528C1300.82 166.528 1305.05 177.033 1305.05 188.044C1305.05 199.473 1301.33 211.261 1290.75 211.261Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1364.62 191.456V216.122C1359.2 218.255 1353.53 219.793 1347.78 219.793C1330.35 219.793 1319.35 206.141 1319.35 188.552C1319.35 172.246 1330.35 158 1348.11 158C1353.62 158 1359.12 160.046 1362.5 162.605L1359.2 169.691C1356.49 167.98 1352.26 166.528 1348.37 166.528C1337.54 166.528 1330.18 175.153 1330.18 188.725C1330.18 202.892 1338.64 211.261 1347.35 211.261C1350.06 211.261 1352.35 210.919 1354.46 209.806V191.456H1364.62Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1409.8 218.769L1397.87 194.018C1404.39 190.525 1408.1 183.429 1408.1 176.259C1408.1 164.654 1401.08 159.02 1389.75 159.02H1373.92V218.769H1384.08V196.234H1388.65L1398.21 218.769H1409.8ZM1384.08 167.043H1388.56C1394.57 167.043 1397.95 170.542 1397.95 176.694C1397.95 184.712 1393.13 188.296 1388.31 188.552C1387.29 188.635 1384.92 188.725 1384.08 188.811V167.043Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1430.44 159.02L1409.97 218.769H1418.77L1423.93 202.463H1441.79L1446.43 218.769H1457.78L1438.9 159.02H1430.44ZM1426.55 195.13C1428.92 187.28 1431.29 180.011 1433.4 170.801H1433.58C1435.94 180.011 1438.06 187.28 1440.26 195.13H1426.55Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1475.37 188.552C1474.36 188.629 1471.91 188.712 1471.14 188.789V167.043H1475.71C1481.64 167.043 1485.01 170.542 1485.01 176.694C1485.01 184.712 1480.19 188.296 1475.37 188.552ZM1476.81 159.02H1460.99V218.769H1471.14V196.234H1475.71C1487.81 196.234 1495.17 186.333 1495.17 176.259C1495.17 164.654 1488.15 159.02 1476.81 159.02Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1542.22 218.769H1532.07V190.004H1511V218.769H1500.93V159.02H1511V181.984H1532.07V159.189H1542.22V218.769Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1551.95 218.769H1562.02V159.02H1551.95V218.769Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M1607.71 169.861C1605.26 168.322 1601.19 166.528 1597.31 166.528C1586.97 166.528 1579.45 175.153 1579.45 188.725C1579.45 202.892 1587.75 211.261 1597.56 211.261C1601.45 211.261 1605.09 209.978 1607.71 208.274L1610.5 215.7C1607.45 217.833 1602.04 219.793 1597.14 219.793C1579.7 219.793 1568.71 206.141 1568.71 188.552C1568.71 172.246 1579.62 158 1597.31 158C1602.56 158 1607.45 160.219 1610.93 162.605L1607.71 169.861Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M0.0032959 306.997H913.01V0.0159912H0.0032959V306.997Z",
                                            fill: "#006CB5"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M317.062 76.1775H329.888V126.772H354.92V138.639H317.062V76.1775Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M363.039 138.639H375.599V90.8112H363.039V138.639ZM362.769 85.7265H375.862V74.2172H362.769V85.7265Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M387.619 90.8112H400.179V97.2358C402.921 93.3983 406.37 89.9189 412.384 89.9189C421.229 89.9189 426.361 96.1645 426.361 106.068V138.639H413.801V109.82C413.801 104.194 411.325 101.339 407.077 101.339C402.921 101.339 400.179 104.194 400.179 109.82V138.639H387.619V90.8112Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M464.482 115.173V114.277C464.482 106.158 460.415 100.984 455.194 100.984C449.976 100.984 445.994 106.158 445.994 114.277V115.173C445.994 123.292 449.976 128.467 455.194 128.467C460.415 128.467 464.482 123.292 464.482 115.173ZM433.434 115.438V114.009C433.434 97.6835 442.016 89.9189 451.479 89.9189C457.85 89.9189 461.566 93.3983 464.305 96.9671V74.2172H476.865V138.639H464.305V132.035C461.566 136.049 457.762 139.531 451.479 139.531C442.104 139.531 433.434 131.767 433.434 115.438Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M518.726 115.173V114.277C518.726 106.158 514.745 100.984 509.527 100.984C504.309 100.984 500.241 106.158 500.241 114.277V115.173C500.241 123.292 504.309 128.467 509.527 128.467C514.745 128.467 518.726 123.292 518.726 115.173ZM500.416 132.483V138.639H487.856V74.2172H500.416V97.4149C503.159 93.3983 506.963 89.9189 513.243 89.9189C522.617 89.9189 531.287 97.6835 531.287 114.009V115.438C531.287 131.767 522.709 139.531 513.243 139.531C506.877 139.531 503.073 136.049 500.416 132.483Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M539.14 138.639H551.7V74.2172H539.14V138.639Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M588.495 122.934V118.921C586.637 118.025 584.072 117.402 581.505 117.402C576.908 117.402 573.985 119.724 573.985 124.095V124.271C573.985 128.198 576.464 130.162 580.091 130.248C584.954 130.341 588.495 127.306 588.495 122.934ZM561.869 124.987V124.45C561.869 113.923 568.682 109.196 578.411 109.196C582.393 109.196 585.398 109.995 588.318 111.156V109.73C588.318 104.194 585.046 101.339 579.384 101.339C574.962 101.339 571.421 102.768 568.504 104.015L565.055 94.1146C569.655 91.7929 574.432 90.2739 581.242 90.2739C587.699 90.2739 592.562 92.0616 595.66 95.1859C598.934 98.4862 600.526 103.481 600.526 109.637V138.639H588.229V133.462C585.398 137.21 581.505 139.531 575.935 139.531C568.152 139.531 561.869 134.264 561.869 124.987Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M640.19 115.173V114.277C640.19 106.158 636.123 100.984 630.902 100.984C625.684 100.984 621.702 106.158 621.702 114.277V115.173C621.702 123.292 625.684 128.467 630.902 128.467C636.123 128.467 640.19 123.292 640.19 115.173ZM609.139 115.438V114.009C609.139 97.6835 617.72 89.9189 627.186 89.9189C633.555 89.9189 637.271 93.3983 640.013 96.9671V74.2172H652.573V138.639H640.013V132.035C637.271 136.049 633.467 139.531 627.186 139.531C617.809 139.531 609.139 131.767 609.139 115.438Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M317.062 156.375H356.955V168.063H329.799V181.539H353.68V193.224H329.799V207.145H357.307V218.837H317.062V156.375Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M383.997 185.015L391.519 171.009H404.52L390.812 194.299L405.05 218.837H391.697L383.822 203.934L375.859 218.837H362.769L376.924 194.475L363.299 171.009H376.569L383.997 185.015Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M443.771 195.367V194.475C443.771 186.355 439.786 181.178 434.568 181.178C429.353 181.178 425.283 186.355 425.283 194.475V195.367C425.283 203.487 429.353 208.661 434.568 208.661C439.786 208.661 443.771 203.487 443.771 195.367ZM412.897 171.009H425.458V177.612C428.2 173.596 432.004 170.116 438.284 170.116C447.661 170.116 456.332 177.878 456.332 194.206V195.636C456.332 211.961 447.75 219.726 438.284 219.726C431.915 219.726 428.114 216.246 425.458 212.677V232.309H412.897V171.009Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M490.516 191.264C489.984 184.66 487.153 180.554 482.467 180.554C477.867 180.554 474.862 184.481 474.152 191.264H490.516ZM461.769 195.457V194.654C461.769 180.468 470.525 170.116 482.466 170.116C496 170.116 502.635 181.271 502.635 195.546C502.635 196.259 502.635 197.778 502.543 199.652H474.24C475.302 205.984 479.195 209.284 484.502 209.284C488.395 209.284 491.4 207.503 494.405 204.558L500.866 212.23C496.532 217.049 491.045 219.905 483.972 219.905C471.412 219.905 461.769 210.356 461.769 195.457Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M539.121 195.367V194.475C539.121 186.355 535.05 181.178 529.832 181.178C524.614 181.178 520.629 186.355 520.629 194.475V195.367C520.629 203.487 524.614 208.661 529.832 208.661C535.05 208.661 539.121 203.487 539.121 195.367ZM508.069 195.636V194.206C508.069 177.878 516.651 170.116 526.117 170.116C532.486 170.116 536.201 173.596 538.943 177.165V154.411H551.503V218.837H538.943V212.23C536.201 216.246 532.397 219.726 526.117 219.726C516.74 219.726 508.069 211.961 508.069 195.636Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M562.759 218.837H575.319V171.009H562.759V218.837ZM562.49 165.924H575.583V154.411H562.49V165.924Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M588.213 206.876V181.715H583.436V171.009H588.213V158.783H600.773V171.009H610.148V181.715H600.773V204.293C600.773 207.056 602.01 208.395 604.663 208.395C606.61 208.395 608.467 207.858 610.059 207.056V217.139C607.583 218.568 604.578 219.639 600.773 219.639C593.52 219.639 588.213 216.78 588.213 206.876Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M619.917 218.837H632.477V171.009H619.917V218.837ZM619.651 165.924H632.744V154.411H619.651V165.924Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M672.789 195.367V194.74C672.789 186.982 668.9 181.092 662.883 181.092C656.603 181.092 652.979 186.889 652.979 194.654V195.278C652.979 202.953 656.958 208.929 662.975 208.929C669.163 208.929 672.789 203.132 672.789 195.367ZM640.594 195.546V194.564C640.594 180.375 650.146 170.116 662.975 170.116C675.798 170.116 685.176 180.199 685.176 194.475V195.457C685.176 209.646 675.71 219.905 662.883 219.905C650.06 219.905 640.594 209.822 640.594 195.546Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M691.455 171.009H704.015V177.43C706.757 173.596 710.206 170.116 716.22 170.116C725.068 170.116 730.197 176.362 730.197 186.266V218.837H717.637V190.014C717.637 184.392 715.161 181.539 710.913 181.539C706.757 181.539 704.015 184.392 704.015 190.014V218.837H691.455V171.009Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M738.046 213.125L743.534 204.2C747.782 207.503 752.29 209.553 756.183 209.553C759.721 209.553 761.223 207.858 761.223 205.898V205.719C761.223 202.953 757.685 201.792 752.556 199.56C745.832 196.614 740.082 193.224 740.082 185.108V184.929C740.082 175.738 747.16 170.295 756.36 170.295C761.49 170.295 767.24 172.08 772.014 175.47L766.974 184.571C763.436 182.249 759.543 180.468 756.183 180.468C753.174 180.468 751.58 181.981 751.58 183.858V184.037C751.58 186.534 755.121 187.961 760.161 190.282C767.063 193.583 772.721 197.062 772.721 204.644V204.827C772.721 214.727 765.468 219.726 756.005 219.726C750.432 219.726 743.797 217.852 738.046 213.125Z",
                                            fill: "#FFFFFE"
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M179.706 177.881C165.811 177.881 154.544 166.519 154.544 152.502C154.544 138.486 165.811 127.12 179.706 127.12C193.6 127.12 204.864 138.486 204.864 152.502C204.864 166.519 193.6 177.881 179.706 177.881ZM185.095 106.302C149.595 106.302 134.962 132.451 134.962 152.502C134.962 177.427 154.994 197.638 179.705 197.638C204.417 197.638 224.449 177.427 224.449 152.502C224.449 144.002 222.116 136.059 218.07 129.273C238.844 135.397 259.403 152.029 264.288 157.078C250.679 188.514 219.478 209.22 179.861 209.22C140.247 209.22 108.682 188.412 91.7246 153.526C105.144 117.776 141.334 91.4028 185.095 91.4028C214.729 91.4028 249.125 101.176 275.995 122.112C279.4 110.504 279.289 99.8901 279.289 99.8901C279.289 99.8901 239.586 71.6333 185.117 71.6333C121.949 71.6333 82.1317 114.863 71.1218 153.526C83.8309 191.373 122.491 228.948 179.721 228.948C236.955 228.948 275.371 191.373 288.346 153.526C263.717 125.969 225.615 106.302 185.095 106.302Z",
                                            fill: "#FFFFFE"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
                                        className: "login-h1",
                                        children: "Login"
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                                        className: "login-h2",
                                        children: "Please login to view LEX Knowledgebase"
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $b8bd2c9bcd2d1081$export$2e2bcd8739ae039), {
                                        className: "primary-button"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $c3c8ef5796d3b74c$export$2e2bcd8739ae039 = $c3c8ef5796d3b74c$var$App;



const $22cce652dfc8bdb5$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($416246511aeb39de$exports))).createRoot(document.getElementById('root'));
$22cce652dfc8bdb5$var$root.render(/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $7496436b70fef144$export$2e2bcd8739ae039), {
    fallbackMessage: "A critical error occurred. Please refresh the page to continue.",
    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $a60a332f9bf049ee$export$6aefaad9cc4faf3c), {
        domain: "account-staging.expeditions.com",
        clientId: "MEO8BLFSznD2NK6OSQDmkm0tHZalzGPJ",
        authorizationParams: {
            redirect_uri: window.location.origin
        },
        cacheLocation: "localstorage",
        useRefreshTokens: true,
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).StrictMode, {
            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $c3c8ef5796d3b74c$export$2e2bcd8739ae039), {})
        })
    })
}));


//# sourceMappingURL=public.42c55e24.js.map
